(function (root, factory) {
  if (typeof define === 'function' && define.amd)
    define(['exports', 'react', 'styled-components', 'react', 'react-dom', 'styled-components', 'react-router-dom'], factory);
  else if (typeof exports === 'object')
    factory(module.exports, require('react'), require('styled-components'), require('react'), require('react-dom'), require('styled-components'), require('react-router-dom'));
  else {
    if (typeof ReactModule === 'undefined') {
      throw new Error("Error loading module 'matrix-anteroom-check-in-frontend'. Its dependency 'react' was not found. Please, check whether 'react' is loaded prior to 'matrix-anteroom-check-in-frontend'.");
    }if (typeof StyledComponents === 'undefined') {
      throw new Error("Error loading module 'matrix-anteroom-check-in-frontend'. Its dependency 'styled-components' was not found. Please, check whether 'styled-components' is loaded prior to 'matrix-anteroom-check-in-frontend'.");
    }if (typeof react === 'undefined') {
      throw new Error("Error loading module 'matrix-anteroom-check-in-frontend'. Its dependency 'react' was not found. Please, check whether 'react' is loaded prior to 'matrix-anteroom-check-in-frontend'.");
    }if (typeof this['react-dom'] === 'undefined') {
      throw new Error("Error loading module 'matrix-anteroom-check-in-frontend'. Its dependency 'react-dom' was not found. Please, check whether 'react-dom' is loaded prior to 'matrix-anteroom-check-in-frontend'.");
    }if (typeof this['styled-components'] === 'undefined') {
      throw new Error("Error loading module 'matrix-anteroom-check-in-frontend'. Its dependency 'styled-components' was not found. Please, check whether 'styled-components' is loaded prior to 'matrix-anteroom-check-in-frontend'.");
    }if (typeof this['react-router-dom'] === 'undefined') {
      throw new Error("Error loading module 'matrix-anteroom-check-in-frontend'. Its dependency 'react-router-dom' was not found. Please, check whether 'react-router-dom' is loaded prior to 'matrix-anteroom-check-in-frontend'.");
    }root['matrix-anteroom-check-in-frontend'] = factory(typeof this['matrix-anteroom-check-in-frontend'] === 'undefined' ? {} : this['matrix-anteroom-check-in-frontend'], ReactModule, StyledComponents, react, this['react-dom'], this['styled-components'], this['react-router-dom']);
  }
}(this, function (_, ReactModule, StyledComponents, $module$react, $module$react_dom, $module$styled_components, $module$react_router_dom) {
  var createContext = $module$react.createContext;
  var useContext = $module$react.useContext;
  var useRef = $module$react.useRef;
  var createElement = $module$react.createElement;
  var Component = $module$react.Component;
  var Children = $module$react.Children;
  var cloneElement = $module$react.cloneElement;
  var Fragment = $module$react.Fragment;
  var useState = $module$react.useState;
  var useEffect = $module$react.useEffect;
  var render = $module$react_dom.render;
  var keyframes = $module$styled_components.keyframes;
  var css = $module$styled_components.css;
  var createGlobalStyle = $module$styled_components.createGlobalStyle;
  var useHistory = $module$react_router_dom.useHistory;
  var useLocation = $module$react_router_dom.useLocation;
  var HashRouter = $module$react_router_dom.HashRouter;
  var Switch = $module$react_router_dom.Switch;
  var Route = $module$react_router_dom.Route;
  var Redirect = $module$react_router_dom.Redirect;
  'use strict';
  AbstractSet.prototype = Object.create(AbstractCollection.prototype);
  AbstractSet.prototype.constructor = AbstractSet;
  _no_name_provided__5.prototype = Object.create(AbstractSet.prototype);
  _no_name_provided__5.prototype.constructor = _no_name_provided__5;
  _no_name_provided__7.prototype = Object.create(AbstractCollection.prototype);
  _no_name_provided__7.prototype.constructor = _no_name_provided__7;
  CoroutineSingletons.prototype = Object.create(Enum.prototype);
  CoroutineSingletons.prototype.constructor = CoroutineSingletons;
  Default.prototype = Object.create(Random.prototype);
  Default.prototype.constructor = Default;
  XorWowRandom.prototype = Object.create(Random.prototype);
  XorWowRandom.prototype.constructor = XorWowRandom;
  KVariance.prototype = Object.create(Enum.prototype);
  KVariance.prototype.constructor = KVariance;
  _no_name_provided__18.prototype = Object.create(CharIterator.prototype);
  _no_name_provided__18.prototype.constructor = _no_name_provided__18;
  LazyThreadSafetyMode.prototype = Object.create(Enum.prototype);
  LazyThreadSafetyMode.prototype.constructor = LazyThreadSafetyMode;
  IntProgressionIterator.prototype = Object.create(IntIterator.prototype);
  IntProgressionIterator.prototype.constructor = IntProgressionIterator;
  CharProgressionIterator.prototype = Object.create(CharIterator.prototype);
  CharProgressionIterator.prototype.constructor = CharProgressionIterator;
  IntRange.prototype = Object.create(IntProgression.prototype);
  IntRange.prototype.constructor = IntRange;
  CharRange.prototype = Object.create(CharProgression.prototype);
  CharRange.prototype.constructor = CharRange;
  AbstractMutableCollection.prototype = Object.create(AbstractCollection.prototype);
  AbstractMutableCollection.prototype.constructor = AbstractMutableCollection;
  ListIteratorImpl.prototype = Object.create(IteratorImpl.prototype);
  ListIteratorImpl.prototype.constructor = ListIteratorImpl;
  AbstractMutableList.prototype = Object.create(AbstractMutableCollection.prototype);
  AbstractMutableList.prototype.constructor = AbstractMutableList;
  AbstractMutableSet.prototype = Object.create(AbstractMutableCollection.prototype);
  AbstractMutableSet.prototype.constructor = AbstractMutableSet;
  AbstractEntrySet.prototype = Object.create(AbstractMutableSet.prototype);
  AbstractEntrySet.prototype.constructor = AbstractEntrySet;
  _no_name_provided__22.prototype = Object.create(AbstractMutableSet.prototype);
  _no_name_provided__22.prototype.constructor = _no_name_provided__22;
  _no_name_provided__23.prototype = Object.create(AbstractMutableCollection.prototype);
  _no_name_provided__23.prototype.constructor = _no_name_provided__23;
  AbstractMutableMap.prototype = Object.create(AbstractMap.prototype);
  AbstractMutableMap.prototype.constructor = AbstractMutableMap;
  ArrayList.prototype = Object.create(AbstractMutableList.prototype);
  ArrayList.prototype.constructor = ArrayList;
  EntrySet.prototype = Object.create(AbstractEntrySet.prototype);
  EntrySet.prototype.constructor = EntrySet;
  HashMap.prototype = Object.create(AbstractMutableMap.prototype);
  HashMap.prototype.constructor = HashMap;
  HashSet.prototype = Object.create(AbstractMutableSet.prototype);
  HashSet.prototype.constructor = HashSet;
  ChainEntry.prototype = Object.create(SimpleEntry.prototype);
  ChainEntry.prototype.constructor = ChainEntry;
  EntrySet_0.prototype = Object.create(AbstractEntrySet.prototype);
  EntrySet_0.prototype.constructor = EntrySet_0;
  LinkedHashMap.prototype = Object.create(HashMap.prototype);
  LinkedHashMap.prototype.constructor = LinkedHashMap;
  LinkedHashSet.prototype = Object.create(HashSet.prototype);
  LinkedHashSet.prototype.constructor = LinkedHashSet;
  PrimitiveKClassImpl.prototype = Object.create(KClassImpl.prototype);
  PrimitiveKClassImpl.prototype.constructor = PrimitiveKClassImpl;
  NothingKClassImpl.prototype = Object.create(KClassImpl.prototype);
  NothingKClassImpl.prototype.constructor = NothingKClassImpl;
  SimpleKClassImpl.prototype = Object.create(KClassImpl.prototype);
  SimpleKClassImpl.prototype.constructor = SimpleKClassImpl;
  RegexOption.prototype = Object.create(Enum.prototype);
  RegexOption.prototype.constructor = RegexOption;
  _no_name_provided__51.prototype = Object.create(AbstractCollection.prototype);
  _no_name_provided__51.prototype.constructor = _no_name_provided__51;
  Long.prototype = Object.create(Number_0.prototype);
  Long.prototype.constructor = Long;
  _no_name_provided__1_0.prototype = Object.create(CoroutineImpl_0.prototype);
  _no_name_provided__1_0.prototype.constructor = _no_name_provided__1_0;
  Exception.prototype = Object.create(Error.prototype);
  Exception.prototype.constructor = Exception;
  Error_0.prototype = Object.create(Error.prototype);
  Error_0.prototype.constructor = Error_0;
  RuntimeException.prototype = Object.create(Exception.prototype);
  RuntimeException.prototype.constructor = RuntimeException;
  IllegalArgumentException.prototype = Object.create(RuntimeException.prototype);
  IllegalArgumentException.prototype.constructor = IllegalArgumentException;
  NoSuchElementException.prototype = Object.create(RuntimeException.prototype);
  NoSuchElementException.prototype.constructor = NoSuchElementException;
  IllegalStateException.prototype = Object.create(RuntimeException.prototype);
  IllegalStateException.prototype.constructor = IllegalStateException;
  IndexOutOfBoundsException.prototype = Object.create(RuntimeException.prototype);
  IndexOutOfBoundsException.prototype.constructor = IndexOutOfBoundsException;
  UnsupportedOperationException.prototype = Object.create(RuntimeException.prototype);
  UnsupportedOperationException.prototype.constructor = UnsupportedOperationException;
  ArithmeticException.prototype = Object.create(RuntimeException.prototype);
  ArithmeticException.prototype.constructor = ArithmeticException;
  NumberFormatException.prototype = Object.create(IllegalArgumentException.prototype);
  NumberFormatException.prototype.constructor = NumberFormatException;
  NullPointerException.prototype = Object.create(RuntimeException.prototype);
  NullPointerException.prototype.constructor = NullPointerException;
  NoWhenBranchMatchedException.prototype = Object.create(RuntimeException.prototype);
  NoWhenBranchMatchedException.prototype.constructor = NoWhenBranchMatchedException;
  ClassCastException.prototype = Object.create(RuntimeException.prototype);
  ClassCastException.prototype.constructor = ClassCastException;
  UninitializedPropertyAccessException.prototype = Object.create(RuntimeException.prototype);
  UninitializedPropertyAccessException.prototype.constructor = UninitializedPropertyAccessException;
  SealedClassSerializer.prototype = Object.create(AbstractPolymorphicSerializer.prototype);
  SealedClassSerializer.prototype.constructor = SealedClassSerializer;
  SerializationException.prototype = Object.create(IllegalArgumentException.prototype);
  SerializationException.prototype.constructor = SerializationException;
  UnknownFieldException.prototype = Object.create(SerializationException.prototype);
  UnknownFieldException.prototype.constructor = UnknownFieldException;
  MissingFieldException.prototype = Object.create(SerializationException.prototype);
  MissingFieldException.prototype.constructor = MissingFieldException;
  ENUM.prototype = Object.create(SerialKind.prototype);
  ENUM.prototype.constructor = ENUM;
  CONTEXTUAL.prototype = Object.create(SerialKind.prototype);
  CONTEXTUAL.prototype.constructor = CONTEXTUAL;
  PrimitiveKind.prototype = Object.create(SerialKind.prototype);
  PrimitiveKind.prototype.constructor = PrimitiveKind;
  BOOLEAN.prototype = Object.create(PrimitiveKind.prototype);
  BOOLEAN.prototype.constructor = BOOLEAN;
  BYTE.prototype = Object.create(PrimitiveKind.prototype);
  BYTE.prototype.constructor = BYTE;
  CHAR.prototype = Object.create(PrimitiveKind.prototype);
  CHAR.prototype.constructor = CHAR;
  SHORT.prototype = Object.create(PrimitiveKind.prototype);
  SHORT.prototype.constructor = SHORT;
  INT.prototype = Object.create(PrimitiveKind.prototype);
  INT.prototype.constructor = INT;
  LONG.prototype = Object.create(PrimitiveKind.prototype);
  LONG.prototype.constructor = LONG;
  FLOAT.prototype = Object.create(PrimitiveKind.prototype);
  FLOAT.prototype.constructor = FLOAT;
  DOUBLE.prototype = Object.create(PrimitiveKind.prototype);
  DOUBLE.prototype.constructor = DOUBLE;
  STRING.prototype = Object.create(PrimitiveKind.prototype);
  STRING.prototype.constructor = STRING;
  StructureKind.prototype = Object.create(SerialKind.prototype);
  StructureKind.prototype.constructor = StructureKind;
  CLASS.prototype = Object.create(StructureKind.prototype);
  CLASS.prototype.constructor = CLASS;
  LIST.prototype = Object.create(StructureKind.prototype);
  LIST.prototype.constructor = LIST;
  MAP.prototype = Object.create(StructureKind.prototype);
  MAP.prototype.constructor = MAP;
  OBJECT.prototype = Object.create(StructureKind.prototype);
  OBJECT.prototype.constructor = OBJECT;
  PolymorphicKind.prototype = Object.create(SerialKind.prototype);
  PolymorphicKind.prototype.constructor = PolymorphicKind;
  SEALED.prototype = Object.create(PolymorphicKind.prototype);
  SEALED.prototype.constructor = SEALED;
  PrimitiveArrayDescriptor.prototype = Object.create(ListLikeDescriptor.prototype);
  PrimitiveArrayDescriptor.prototype.constructor = PrimitiveArrayDescriptor;
  ArrayListClassDesc.prototype = Object.create(ListLikeDescriptor.prototype);
  ArrayListClassDesc.prototype.constructor = ArrayListClassDesc;
  LinkedHashSetClassDesc.prototype = Object.create(ListLikeDescriptor.prototype);
  LinkedHashSetClassDesc.prototype.constructor = LinkedHashSetClassDesc;
  LinkedHashMapClassDesc.prototype = Object.create(MapLikeDescriptor.prototype);
  LinkedHashMapClassDesc.prototype.constructor = LinkedHashMapClassDesc;
  HashSetClassDesc.prototype = Object.create(ListLikeDescriptor.prototype);
  HashSetClassDesc.prototype.constructor = HashSetClassDesc;
  HashMapClassDesc.prototype = Object.create(MapLikeDescriptor.prototype);
  HashMapClassDesc.prototype.constructor = HashMapClassDesc;
  ArrayClassDesc.prototype = Object.create(ListLikeDescriptor.prototype);
  ArrayClassDesc.prototype.constructor = ArrayClassDesc;
  ListLikeSerializer.prototype = Object.create(AbstractCollectionSerializer.prototype);
  ListLikeSerializer.prototype.constructor = ListLikeSerializer;
  PrimitiveArraySerializer.prototype = Object.create(ListLikeSerializer.prototype);
  PrimitiveArraySerializer.prototype.constructor = PrimitiveArraySerializer;
  ArrayListSerializer.prototype = Object.create(ListLikeSerializer.prototype);
  ArrayListSerializer.prototype.constructor = ArrayListSerializer;
  LinkedHashSetSerializer.prototype = Object.create(ListLikeSerializer.prototype);
  LinkedHashSetSerializer.prototype.constructor = LinkedHashSetSerializer;
  MapLikeSerializer.prototype = Object.create(AbstractCollectionSerializer.prototype);
  MapLikeSerializer.prototype.constructor = MapLikeSerializer;
  LinkedHashMapSerializer.prototype = Object.create(MapLikeSerializer.prototype);
  LinkedHashMapSerializer.prototype.constructor = LinkedHashMapSerializer;
  HashSetSerializer.prototype = Object.create(ListLikeSerializer.prototype);
  HashSetSerializer.prototype.constructor = HashSetSerializer;
  HashMapSerializer.prototype = Object.create(MapLikeSerializer.prototype);
  HashMapSerializer.prototype.constructor = HashMapSerializer;
  ReferenceArraySerializer.prototype = Object.create(ListLikeSerializer.prototype);
  ReferenceArraySerializer.prototype.constructor = ReferenceArraySerializer;
  InlineClassDescriptor.prototype = Object.create(PluginGeneratedSerialDescriptor.prototype);
  InlineClassDescriptor.prototype.constructor = InlineClassDescriptor;
  CharArraySerializer_0.prototype = Object.create(PrimitiveArraySerializer.prototype);
  CharArraySerializer_0.prototype.constructor = CharArraySerializer_0;
  DoubleArraySerializer_0.prototype = Object.create(PrimitiveArraySerializer.prototype);
  DoubleArraySerializer_0.prototype.constructor = DoubleArraySerializer_0;
  FloatArraySerializer_0.prototype = Object.create(PrimitiveArraySerializer.prototype);
  FloatArraySerializer_0.prototype.constructor = FloatArraySerializer_0;
  LongArraySerializer_0.prototype = Object.create(PrimitiveArraySerializer.prototype);
  LongArraySerializer_0.prototype.constructor = LongArraySerializer_0;
  IntArraySerializer_0.prototype = Object.create(PrimitiveArraySerializer.prototype);
  IntArraySerializer_0.prototype.constructor = IntArraySerializer_0;
  ShortArraySerializer_0.prototype = Object.create(PrimitiveArraySerializer.prototype);
  ShortArraySerializer_0.prototype.constructor = ShortArraySerializer_0;
  ByteArraySerializer_0.prototype = Object.create(PrimitiveArraySerializer.prototype);
  ByteArraySerializer_0.prototype.constructor = ByteArraySerializer_0;
  BooleanArraySerializer_0.prototype = Object.create(PrimitiveArraySerializer.prototype);
  BooleanArraySerializer_0.prototype.constructor = BooleanArraySerializer_0;
  CharArrayBuilder.prototype = Object.create(PrimitiveArrayBuilder.prototype);
  CharArrayBuilder.prototype.constructor = CharArrayBuilder;
  DoubleArrayBuilder.prototype = Object.create(PrimitiveArrayBuilder.prototype);
  DoubleArrayBuilder.prototype.constructor = DoubleArrayBuilder;
  FloatArrayBuilder.prototype = Object.create(PrimitiveArrayBuilder.prototype);
  FloatArrayBuilder.prototype.constructor = FloatArrayBuilder;
  LongArrayBuilder.prototype = Object.create(PrimitiveArrayBuilder.prototype);
  LongArrayBuilder.prototype.constructor = LongArrayBuilder;
  IntArrayBuilder.prototype = Object.create(PrimitiveArrayBuilder.prototype);
  IntArrayBuilder.prototype.constructor = IntArrayBuilder;
  ShortArrayBuilder.prototype = Object.create(PrimitiveArrayBuilder.prototype);
  ShortArrayBuilder.prototype.constructor = ShortArrayBuilder;
  ByteArrayBuilder.prototype = Object.create(PrimitiveArrayBuilder.prototype);
  ByteArrayBuilder.prototype.constructor = ByteArrayBuilder;
  BooleanArrayBuilder.prototype = Object.create(PrimitiveArrayBuilder.prototype);
  BooleanArrayBuilder.prototype.constructor = BooleanArrayBuilder;
  NamedValueDecoder.prototype = Object.create(TaggedDecoder.prototype);
  NamedValueDecoder.prototype.constructor = NamedValueDecoder;
  MapEntrySerializer_0.prototype = Object.create(KeyValueSerializer.prototype);
  MapEntrySerializer_0.prototype.constructor = MapEntrySerializer_0;
  PairSerializer_0.prototype = Object.create(KeyValueSerializer.prototype);
  PairSerializer_0.prototype.constructor = PairSerializer_0;
  SerialModuleImpl.prototype = Object.create(SerializersModule.prototype);
  SerialModuleImpl.prototype.constructor = SerialModuleImpl;
  Default_0.prototype = Object.create(Json_0.prototype);
  Default_0.prototype.constructor = Default_0;
  JsonImpl.prototype = Object.create(Json_0.prototype);
  JsonImpl.prototype.constructor = JsonImpl;
  JsonObject.prototype = Object.create(JsonElement.prototype);
  JsonObject.prototype.constructor = JsonObject;
  JsonPrimitive.prototype = Object.create(JsonElement.prototype);
  JsonPrimitive.prototype.constructor = JsonPrimitive;
  JsonNull.prototype = Object.create(JsonPrimitive.prototype);
  JsonNull.prototype.constructor = JsonNull;
  JsonLiteral.prototype = Object.create(JsonPrimitive.prototype);
  JsonLiteral.prototype.constructor = JsonLiteral;
  JsonArray.prototype = Object.create(JsonElement.prototype);
  JsonArray.prototype.constructor = JsonArray;
  JsonException.prototype = Object.create(SerializationException.prototype);
  JsonException.prototype.constructor = JsonException;
  JsonEncodingException.prototype = Object.create(JsonException.prototype);
  JsonEncodingException.prototype.constructor = JsonEncodingException;
  JsonDecodingException.prototype = Object.create(JsonException.prototype);
  JsonDecodingException.prototype.constructor = JsonDecodingException;
  StreamingJsonDecoder.prototype = Object.create(AbstractDecoder.prototype);
  StreamingJsonDecoder.prototype.constructor = StreamingJsonDecoder;
  JsonDecoderForUnsignedTypes.prototype = Object.create(AbstractDecoder.prototype);
  JsonDecoderForUnsignedTypes.prototype.constructor = JsonDecoderForUnsignedTypes;
  ComposerForUnsignedNumbers.prototype = Object.create(Composer.prototype);
  ComposerForUnsignedNumbers.prototype.constructor = ComposerForUnsignedNumbers;
  StreamingJsonEncoder.prototype = Object.create(AbstractEncoder.prototype);
  StreamingJsonEncoder.prototype.constructor = StreamingJsonEncoder;
  AbstractJsonTreeDecoder.prototype = Object.create(NamedValueDecoder.prototype);
  AbstractJsonTreeDecoder.prototype.constructor = AbstractJsonTreeDecoder;
  JsonTreeDecoder.prototype = Object.create(AbstractJsonTreeDecoder.prototype);
  JsonTreeDecoder.prototype.constructor = JsonTreeDecoder;
  JsonTreeListDecoder.prototype = Object.create(AbstractJsonTreeDecoder.prototype);
  JsonTreeListDecoder.prototype.constructor = JsonTreeListDecoder;
  JsonTreeMapDecoder.prototype = Object.create(JsonTreeDecoder.prototype);
  JsonTreeMapDecoder.prototype.constructor = JsonTreeMapDecoder;
  WriteMode.prototype = Object.create(Enum.prototype);
  WriteMode.prototype.constructor = WriteMode;
  AbstractCoroutine.prototype = Object.create(JobSupport.prototype);
  AbstractCoroutine.prototype.constructor = AbstractCoroutine;
  StandaloneCoroutine.prototype = Object.create(AbstractCoroutine.prototype);
  StandaloneCoroutine.prototype.constructor = StandaloneCoroutine;
  LazyStandaloneCoroutine.prototype = Object.create(StandaloneCoroutine.prototype);
  LazyStandaloneCoroutine.prototype.constructor = LazyStandaloneCoroutine;
  $awaitCOROUTINE$0.prototype = Object.create(CoroutineImpl_0.prototype);
  $awaitCOROUTINE$0.prototype.constructor = $awaitCOROUTINE$0;
  DeferredCoroutine.prototype = Object.create(AbstractCoroutine.prototype);
  DeferredCoroutine.prototype.constructor = DeferredCoroutine;
  LazyDeferredCoroutine.prototype = Object.create(DeferredCoroutine.prototype);
  LazyDeferredCoroutine.prototype.constructor = LazyDeferredCoroutine;
  CancelHandler.prototype = Object.create(CancelHandlerBase.prototype);
  CancelHandler.prototype.constructor = CancelHandler;
  DisposeOnCancel.prototype = Object.create(CancelHandler.prototype);
  DisposeOnCancel.prototype.constructor = DisposeOnCancel;
  BeforeResumeCancelHandler.prototype = Object.create(CancelHandler.prototype);
  BeforeResumeCancelHandler.prototype.constructor = BeforeResumeCancelHandler;
  RemoveOnCancel.prototype = Object.create(BeforeResumeCancelHandler.prototype);
  RemoveOnCancel.prototype.constructor = RemoveOnCancel;
  DispatchedTask.prototype = Object.create(SchedulerTask.prototype);
  DispatchedTask.prototype.constructor = DispatchedTask;
  CancellableContinuationImpl.prototype = Object.create(DispatchedTask.prototype);
  CancellableContinuationImpl.prototype.constructor = CancellableContinuationImpl;
  InvokeOnCancel.prototype = Object.create(CancelHandler.prototype);
  InvokeOnCancel.prototype.constructor = InvokeOnCancel;
  $awaitCOROUTINE$1.prototype = Object.create(CoroutineImpl_0.prototype);
  $awaitCOROUTINE$1.prototype.constructor = $awaitCOROUTINE$1;
  CompletableDeferredImpl.prototype = Object.create(JobSupport.prototype);
  CompletableDeferredImpl.prototype.constructor = CompletableDeferredImpl;
  CancelledContinuation.prototype = Object.create(CompletedExceptionally.prototype);
  CancelledContinuation.prototype.constructor = CancelledContinuation;
  Key_1.prototype = Object.create(AbstractCoroutineContextKey.prototype);
  Key_1.prototype.constructor = Key_1;
  CoroutineDispatcher.prototype = Object.create(AbstractCoroutineContextElement.prototype);
  CoroutineDispatcher.prototype.constructor = CoroutineDispatcher;
  CoroutineName.prototype = Object.create(AbstractCoroutineContextElement.prototype);
  CoroutineName.prototype.constructor = CoroutineName;
  CoroutineStart.prototype = Object.create(Enum.prototype);
  CoroutineStart.prototype.constructor = CoroutineStart;
  EventLoop.prototype = Object.create(CoroutineDispatcher.prototype);
  EventLoop.prototype.constructor = EventLoop;
  CompletionHandlerException.prototype = Object.create(RuntimeException.prototype);
  CompletionHandlerException.prototype.constructor = CompletionHandlerException;
  CoroutinesInternalError.prototype = Object.create(Error_0.prototype);
  CoroutinesInternalError.prototype.constructor = CoroutinesInternalError;
  LinkedListHead.prototype = Object.create(LinkedListNode.prototype);
  LinkedListHead.prototype.constructor = LinkedListHead;
  NodeList_0.prototype = Object.create(LinkedListHead.prototype);
  NodeList_0.prototype.constructor = NodeList_0;
  CompletionHandlerBase.prototype = Object.create(LinkedListNode.prototype);
  CompletionHandlerBase.prototype.constructor = CompletionHandlerBase;
  JobNode.prototype = Object.create(CompletionHandlerBase.prototype);
  JobNode.prototype.constructor = JobNode;
  ChildCompletion.prototype = Object.create(JobNode.prototype);
  ChildCompletion.prototype.constructor = ChildCompletion;
  AwaitContinuation.prototype = Object.create(CancellableContinuationImpl.prototype);
  AwaitContinuation.prototype.constructor = AwaitContinuation;
  JobCancellingNode.prototype = Object.create(JobNode.prototype);
  JobCancellingNode.prototype.constructor = JobCancellingNode;
  ChildHandleNode.prototype = Object.create(JobCancellingNode.prototype);
  ChildHandleNode.prototype.constructor = ChildHandleNode;
  InvokeOnCancelling.prototype = Object.create(JobCancellingNode.prototype);
  InvokeOnCancelling.prototype.constructor = InvokeOnCancelling;
  InvokeOnCompletion.prototype = Object.create(JobNode.prototype);
  InvokeOnCompletion.prototype.constructor = InvokeOnCompletion;
  ResumeOnCompletion.prototype = Object.create(JobNode.prototype);
  ResumeOnCompletion.prototype.constructor = ResumeOnCompletion;
  ResumeAwaitOnCompletion.prototype = Object.create(JobNode.prototype);
  ResumeAwaitOnCompletion.prototype.constructor = ResumeAwaitOnCompletion;
  ChildContinuation.prototype = Object.create(JobCancellingNode.prototype);
  ChildContinuation.prototype.constructor = ChildContinuation;
  JobImpl.prototype = Object.create(JobSupport.prototype);
  JobImpl.prototype.constructor = JobImpl;
  MainCoroutineDispatcher.prototype = Object.create(CoroutineDispatcher.prototype);
  MainCoroutineDispatcher.prototype.constructor = MainCoroutineDispatcher;
  SupervisorJobImpl.prototype = Object.create(JobImpl.prototype);
  SupervisorJobImpl.prototype.constructor = SupervisorJobImpl;
  CancellationException.prototype = Object.create(IllegalStateException.prototype);
  CancellationException.prototype.constructor = CancellationException;
  TimeoutCancellationException.prototype = Object.create(CancellationException.prototype);
  TimeoutCancellationException.prototype.constructor = TimeoutCancellationException;
  Unconfined.prototype = Object.create(CoroutineDispatcher.prototype);
  Unconfined.prototype.constructor = Unconfined;
  RemoveReceiveOnCancel.prototype = Object.create(BeforeResumeCancelHandler.prototype);
  RemoveReceiveOnCancel.prototype.constructor = RemoveReceiveOnCancel;
  Receive.prototype = Object.create(LinkedListNode.prototype);
  Receive.prototype.constructor = Receive;
  ReceiveHasNext.prototype = Object.create(Receive.prototype);
  ReceiveHasNext.prototype.constructor = ReceiveHasNext;
  AbstractChannel.prototype = Object.create(AbstractSendChannel.prototype);
  AbstractChannel.prototype.constructor = AbstractChannel;
  Send.prototype = Object.create(LinkedListNode.prototype);
  Send.prototype.constructor = Send;
  SendBuffered.prototype = Object.create(Send.prototype);
  SendBuffered.prototype.constructor = SendBuffered;
  Closed.prototype = Object.create(Send.prototype);
  Closed.prototype.constructor = Closed;
  SendElement.prototype = Object.create(Send.prototype);
  SendElement.prototype.constructor = SendElement;
  SendElementWithUndeliveredHandler.prototype = Object.create(SendElement.prototype);
  SendElementWithUndeliveredHandler.prototype.constructor = SendElementWithUndeliveredHandler;
  ArrayChannel.prototype = Object.create(AbstractChannel.prototype);
  ArrayChannel.prototype.constructor = ArrayChannel;
  BufferOverflow.prototype = Object.create(Enum.prototype);
  BufferOverflow.prototype.constructor = BufferOverflow;
  ClosedReceiveChannelException.prototype = Object.create(NoSuchElementException.prototype);
  ClosedReceiveChannelException.prototype.constructor = ClosedReceiveChannelException;
  ClosedSendChannelException.prototype = Object.create(IllegalStateException.prototype);
  ClosedSendChannelException.prototype.constructor = ClosedSendChannelException;
  ConflatedChannel.prototype = Object.create(AbstractChannel.prototype);
  ConflatedChannel.prototype.constructor = ConflatedChannel;
  LinkedListChannel.prototype = Object.create(AbstractChannel.prototype);
  LinkedListChannel.prototype.constructor = LinkedListChannel;
  RendezvousChannel.prototype = Object.create(AbstractChannel.prototype);
  RendezvousChannel.prototype.constructor = RendezvousChannel;
  DispatchedContinuation.prototype = Object.create(DispatchedTask.prototype);
  DispatchedContinuation.prototype.constructor = DispatchedContinuation;
  UndeliveredElementException.prototype = Object.create(RuntimeException.prototype);
  UndeliveredElementException.prototype.constructor = UndeliveredElementException;
  JsMainDispatcher.prototype = Object.create(MainCoroutineDispatcher.prototype);
  JsMainDispatcher.prototype.constructor = JsMainDispatcher;
  UnconfinedEventLoop.prototype = Object.create(EventLoop.prototype);
  UnconfinedEventLoop.prototype.constructor = UnconfinedEventLoop;
  JobCancellationException.prototype = Object.create(CancellationException.prototype);
  JobCancellationException.prototype.constructor = JobCancellationException;
  SetTimeoutBasedDispatcher.prototype = Object.create(CoroutineDispatcher.prototype);
  SetTimeoutBasedDispatcher.prototype.constructor = SetTimeoutBasedDispatcher;
  NodeDispatcher.prototype = Object.create(SetTimeoutBasedDispatcher.prototype);
  NodeDispatcher.prototype.constructor = NodeDispatcher;
  SetTimeoutDispatcher.prototype = Object.create(SetTimeoutBasedDispatcher.prototype);
  SetTimeoutDispatcher.prototype.constructor = SetTimeoutDispatcher;
  MessageQueue.prototype = Object.create(ArrayQueue.prototype);
  MessageQueue.prototype.constructor = MessageQueue;
  ScheduledMessageQueue.prototype = Object.create(MessageQueue.prototype);
  ScheduledMessageQueue.prototype.constructor = ScheduledMessageQueue;
  ClearTimeout.prototype = Object.create(CancelHandler.prototype);
  ClearTimeout.prototype.constructor = ClearTimeout;
  WindowDispatcher.prototype = Object.create(CoroutineDispatcher.prototype);
  WindowDispatcher.prototype.constructor = WindowDispatcher;
  WindowMessageQueue.prototype = Object.create(MessageQueue.prototype);
  WindowMessageQueue.prototype.constructor = WindowMessageQueue;
  RElementBuilder.prototype = Object.create(RBuilder.prototype);
  RElementBuilder.prototype.constructor = RElementBuilder;
  StringAttribute.prototype = Object.create(Attribute.prototype);
  StringAttribute.prototype.constructor = StringAttribute;
  TickerAttribute.prototype = Object.create(Attribute.prototype);
  TickerAttribute.prototype.constructor = TickerAttribute;
  EnumAttribute.prototype = Object.create(Attribute.prototype);
  EnumAttribute.prototype.constructor = EnumAttribute;
  InputType.prototype = Object.create(Enum.prototype);
  InputType.prototype.constructor = InputType;
  BUTTON.prototype = Object.create(HTMLTag.prototype);
  BUTTON.prototype.constructor = BUTTON;
  BR.prototype = Object.create(HTMLTag.prototype);
  BR.prototype.constructor = BR;
  B.prototype = Object.create(HTMLTag.prototype);
  B.prototype.constructor = B;
  DIV.prototype = Object.create(HTMLTag.prototype);
  DIV.prototype.constructor = DIV;
  FORM.prototype = Object.create(HTMLTag.prototype);
  FORM.prototype.constructor = FORM;
  INPUT.prototype = Object.create(HTMLTag.prototype);
  INPUT.prototype.constructor = INPUT;
  P.prototype = Object.create(HTMLTag.prototype);
  P.prototype.constructor = P;
  RDOMBuilder.prototype = Object.create(RBuilder.prototype);
  RDOMBuilder.prototype.constructor = RDOMBuilder;
  CSSBuilder.prototype = Object.create(StyledElement.prototype);
  CSSBuilder.prototype.constructor = CSSBuilder;
  LinearDimension.prototype = Object.create(CssValue.prototype);
  LinearDimension.prototype.constructor = LinearDimension;
  Align.prototype = Object.create(Enum.prototype);
  Align.prototype.constructor = Align;
  Color.prototype = Object.create(CssValue.prototype);
  Color.prototype.constructor = Color;
  QuotedString.prototype = Object.create(CssValue.prototype);
  QuotedString.prototype.constructor = QuotedString;
  Display.prototype = Object.create(Enum.prototype);
  Display.prototype.constructor = Display;
  FlexDirection.prototype = Object.create(Enum.prototype);
  FlexDirection.prototype.constructor = FlexDirection;
  FlexWrap.prototype = Object.create(Enum.prototype);
  FlexWrap.prototype.constructor = FlexWrap;
  FontWeight.prototype = Object.create(CssValue.prototype);
  FontWeight.prototype.constructor = FontWeight;
  GridColumn.prototype = Object.create(CssValue.prototype);
  GridColumn.prototype.constructor = GridColumn;
  GridRow.prototype = Object.create(CssValue.prototype);
  GridRow.prototype.constructor = GridRow;
  JustifyContent.prototype = Object.create(Enum.prototype);
  JustifyContent.prototype.constructor = JustifyContent;
  Position.prototype = Object.create(Enum.prototype);
  Position.prototype.constructor = Position;
  TextAlign.prototype = Object.create(Enum.prototype);
  TextAlign.prototype.constructor = TextAlign;
  Animations.prototype = Object.create(StyleList.prototype);
  Animations.prototype.constructor = Animations;
  IterationCount.prototype = Object.create(CssValue.prototype);
  IterationCount.prototype.constructor = IterationCount;
  AnimationDirection.prototype = Object.create(Enum.prototype);
  AnimationDirection.prototype.constructor = AnimationDirection;
  FillMode.prototype = Object.create(Enum.prototype);
  FillMode.prototype.constructor = FillMode;
  PlayState.prototype = Object.create(Enum.prototype);
  PlayState.prototype.constructor = PlayState;
  Time.prototype = Object.create(CssValue.prototype);
  Time.prototype.constructor = Time;
  Timing.prototype = Object.create(CssValue.prototype);
  Timing.prototype.constructor = Timing;
  Transforms.prototype = Object.create(StyleList.prototype);
  Transforms.prototype.constructor = Transforms;
  Angle.prototype = Object.create(CssValue.prototype);
  Angle.prototype.constructor = Angle;
  Transitions.prototype = Object.create(StyleList.prototype);
  Transitions.prototype.constructor = Transitions;
  StyledDOMBuilder.prototype = Object.create(RDOMBuilder.prototype);
  StyledDOMBuilder.prototype.constructor = StyledDOMBuilder;
  HashType.prototype = Object.create(Enum.prototype);
  HashType.prototype.constructor = HashType;
  $awaitAtLeastNBytesAvailableForWriteCOROUTINE$0.prototype = Object.create(CoroutineImpl_0.prototype);
  $awaitAtLeastNBytesAvailableForWriteCOROUTINE$0.prototype.constructor = $awaitAtLeastNBytesAvailableForWriteCOROUTINE$0;
  $awaitAtLeastNBytesAvailableForReadCOROUTINE$1.prototype = Object.create(CoroutineImpl_0.prototype);
  $awaitAtLeastNBytesAvailableForReadCOROUTINE$1.prototype.constructor = $awaitAtLeastNBytesAvailableForReadCOROUTINE$1;
  $writeFullyCOROUTINE$9.prototype = Object.create(CoroutineImpl_0.prototype);
  $writeFullyCOROUTINE$9.prototype.constructor = $writeFullyCOROUTINE$9;
  $writeFullyCOROUTINE$10.prototype = Object.create(CoroutineImpl_0.prototype);
  $writeFullyCOROUTINE$10.prototype.constructor = $writeFullyCOROUTINE$10;
  $readRemainingCOROUTINE$26.prototype = Object.create(CoroutineImpl_0.prototype);
  $readRemainingCOROUTINE$26.prototype.constructor = $readRemainingCOROUTINE$26;
  $readRemainingSuspendCOROUTINE$27.prototype = Object.create(CoroutineImpl_0.prototype);
  $readRemainingSuspendCOROUTINE$27.prototype.constructor = $readRemainingSuspendCOROUTINE$27;
  $readAvailableCOROUTINE$30.prototype = Object.create(CoroutineImpl_0.prototype);
  $readAvailableCOROUTINE$30.prototype.constructor = $readAvailableCOROUTINE$30;
  $readAvailableSuspendCOROUTINE$31.prototype = Object.create(CoroutineImpl_0.prototype);
  $readAvailableSuspendCOROUTINE$31.prototype.constructor = $readAvailableSuspendCOROUTINE$31;
  $awaitInternalAtLeast1COROUTINE$40.prototype = Object.create(CoroutineImpl_0.prototype);
  $awaitInternalAtLeast1COROUTINE$40.prototype.constructor = $awaitInternalAtLeast1COROUTINE$40;
  $awaitSuspendCOROUTINE$41.prototype = Object.create(CoroutineImpl_0.prototype);
  $awaitSuspendCOROUTINE$41.prototype.constructor = $awaitSuspendCOROUTINE$41;
  ClosedWriteChannelException.prototype = Object.create(CancellationException.prototype);
  ClosedWriteChannelException.prototype.constructor = ClosedWriteChannelException;
  _no_name_provided__116.prototype = Object.create(CoroutineImpl_0.prototype);
  _no_name_provided__116.prototype.constructor = _no_name_provided__116;
  _no_name_provided__3_0.prototype = Object.create(RequireFailureCapture.prototype);
  _no_name_provided__3_0.prototype.constructor = _no_name_provided__3_0;
  _no_name_provided__3_1.prototype = Object.create(RequireFailureCapture.prototype);
  _no_name_provided__3_1.prototype.constructor = _no_name_provided__3_1;
  _no_name_provided__3_2.prototype = Object.create(RequireFailureCapture.prototype);
  _no_name_provided__3_2.prototype.constructor = _no_name_provided__3_2;
  _no_name_provided__3_3.prototype = Object.create(RequireFailureCapture.prototype);
  _no_name_provided__3_3.prototype.constructor = _no_name_provided__3_3;
  _no_name_provided__3_4.prototype = Object.create(RequireFailureCapture.prototype);
  _no_name_provided__3_4.prototype.constructor = _no_name_provided__3_4;
  _no_name_provided__3_5.prototype = Object.create(RequireFailureCapture.prototype);
  _no_name_provided__3_5.prototype.constructor = _no_name_provided__3_5;
  _no_name_provided__3_6.prototype = Object.create(RequireFailureCapture.prototype);
  _no_name_provided__3_6.prototype.constructor = _no_name_provided__3_6;
  InsufficientSpaceException.prototype = Object.create(Exception.prototype);
  InsufficientSpaceException.prototype.constructor = InsufficientSpaceException;
  DefaultBufferPool.prototype = Object.create(DefaultPool.prototype);
  DefaultBufferPool.prototype.constructor = DefaultBufferPool;
  _no_name_provided__3_5_0.prototype = Object.create(RequireFailureCapture.prototype);
  _no_name_provided__3_5_0.prototype.constructor = _no_name_provided__3_5_0;
  _no_name_provided__3_5_1.prototype = Object.create(RequireFailureCapture.prototype);
  _no_name_provided__3_5_1.prototype.constructor = _no_name_provided__3_5_1;
  _no_name_provided__3_5_2.prototype = Object.create(RequireFailureCapture.prototype);
  _no_name_provided__3_5_2.prototype.constructor = _no_name_provided__3_5_2;
  _no_name_provided__3_7.prototype = Object.create(RequireFailureCapture.prototype);
  _no_name_provided__3_7.prototype.constructor = _no_name_provided__3_7;
  _no_name_provided__3_8.prototype = Object.create(RequireFailureCapture.prototype);
  _no_name_provided__3_8.prototype.constructor = _no_name_provided__3_8;
  _no_name_provided__3_9.prototype = Object.create(RequireFailureCapture.prototype);
  _no_name_provided__3_9.prototype.constructor = _no_name_provided__3_9;
  EmptyBufferPoolImpl.prototype = Object.create(NoPoolImpl.prototype);
  EmptyBufferPoolImpl.prototype.constructor = EmptyBufferPoolImpl;
  BufferLimitExceededException.prototype = Object.create(Exception.prototype);
  BufferLimitExceededException.prototype.constructor = BufferLimitExceededException;
  BytePacketBuilderBase.prototype = Object.create(AbstractOutput.prototype);
  BytePacketBuilderBase.prototype.constructor = BytePacketBuilderBase;
  BytePacketBuilderPlatformBase.prototype = Object.create(BytePacketBuilderBase.prototype);
  BytePacketBuilderPlatformBase.prototype.constructor = BytePacketBuilderPlatformBase;
  _no_name_provided__3_10.prototype = Object.create(RequireFailureCapture.prototype);
  _no_name_provided__3_10.prototype.constructor = _no_name_provided__3_10;
  BytePacketBuilder.prototype = Object.create(BytePacketBuilderPlatformBase.prototype);
  BytePacketBuilder.prototype.constructor = BytePacketBuilder;
  ByteReadPacketBase.prototype = Object.create(AbstractInput.prototype);
  ByteReadPacketBase.prototype.constructor = ByteReadPacketBase;
  ByteReadPacketPlatformBase.prototype = Object.create(ByteReadPacketBase.prototype);
  ByteReadPacketPlatformBase.prototype.constructor = ByteReadPacketPlatformBase;
  ByteReadPacket.prototype = Object.create(ByteReadPacketPlatformBase.prototype);
  ByteReadPacket.prototype.constructor = ByteReadPacket;
  _no_name_provided__3_11.prototype = Object.create(RequireFailureCapture.prototype);
  _no_name_provided__3_11.prototype.constructor = _no_name_provided__3_11;
  _no_name_provided__120.prototype = Object.create(NoPoolImpl.prototype);
  _no_name_provided__120.prototype.constructor = _no_name_provided__120;
  _no_name_provided__121.prototype = Object.create(NoPoolImpl.prototype);
  _no_name_provided__121.prototype.constructor = _no_name_provided__121;
  _no_name_provided__3_12.prototype = Object.create(RequireFailureCapture.prototype);
  _no_name_provided__3_12.prototype.constructor = _no_name_provided__3_12;
  _no_name_provided__3_13.prototype = Object.create(RequireFailureCapture.prototype);
  _no_name_provided__3_13.prototype.constructor = _no_name_provided__3_13;
  ChunkBuffer.prototype = Object.create(Buffer.prototype);
  ChunkBuffer.prototype.constructor = ChunkBuffer;
  MalformedUTF8InputException.prototype = Object.create(Exception.prototype);
  MalformedUTF8InputException.prototype.constructor = MalformedUTF8InputException;
  _no_name_provided__2_0.prototype = Object.create(RequireFailureCapture.prototype);
  _no_name_provided__2_0.prototype.constructor = _no_name_provided__2_0;
  _no_name_provided__2_1.prototype = Object.create(RequireFailureCapture.prototype);
  _no_name_provided__2_1.prototype.constructor = _no_name_provided__2_1;
  _no_name_provided__2_2.prototype = Object.create(RequireFailureCapture.prototype);
  _no_name_provided__2_2.prototype.constructor = _no_name_provided__2_2;
  _no_name_provided__2_3.prototype = Object.create(RequireFailureCapture.prototype);
  _no_name_provided__2_3.prototype.constructor = _no_name_provided__2_3;
  $sleepCOROUTINE$54.prototype = Object.create(CoroutineImpl_0.prototype);
  $sleepCOROUTINE$54.prototype.constructor = $sleepCOROUTINE$54;
  $trySuspendCOROUTINE$55.prototype = Object.create(CoroutineImpl_0.prototype);
  $trySuspendCOROUTINE$55.prototype.constructor = $trySuspendCOROUTINE$55;
  $copyToSequentialImplCOROUTINE$56.prototype = Object.create(CoroutineImpl_0.prototype);
  $copyToSequentialImplCOROUTINE$56.prototype.constructor = $copyToSequentialImplCOROUTINE$56;
  $copyToTailCOROUTINE$57.prototype = Object.create(CoroutineImpl_0.prototype);
  $copyToTailCOROUTINE$57.prototype.constructor = $copyToTailCOROUTINE$57;
  ByteChannelJS.prototype = Object.create(ByteChannelSequentialBase.prototype);
  ByteChannelJS.prototype.constructor = ByteChannelJS;
  CharsetImpl.prototype = Object.create(Charset.prototype);
  CharsetImpl.prototype.constructor = CharsetImpl;
  CharsetEncoderImpl.prototype = Object.create(CharsetEncoder.prototype);
  CharsetEncoderImpl.prototype.constructor = CharsetEncoderImpl;
  CharsetDecoderImpl.prototype = Object.create(CharsetDecoder.prototype);
  CharsetDecoderImpl.prototype.constructor = CharsetDecoderImpl;
  MalformedInputException.prototype = Object.create(Error.prototype);
  MalformedInputException.prototype.constructor = MalformedInputException;
  ByteOrder.prototype = Object.create(Enum.prototype);
  ByteOrder.prototype.constructor = ByteOrder;
  _no_name_provided__2_4.prototype = Object.create(RequireFailureCapture.prototype);
  _no_name_provided__2_4.prototype.constructor = _no_name_provided__2_4;
  _no_name_provided__2_5.prototype = Object.create(RequireFailureCapture.prototype);
  _no_name_provided__2_5.prototype.constructor = _no_name_provided__2_5;
  _no_name_provided__126.prototype = Object.create(DefaultPool.prototype);
  _no_name_provided__126.prototype.constructor = _no_name_provided__126;
  _no_name_provided__127.prototype = Object.create(NoPoolImpl.prototype);
  _no_name_provided__127.prototype.constructor = _no_name_provided__127;
  IoBuffer.prototype = Object.create(ChunkBuffer.prototype);
  IoBuffer.prototype.constructor = IoBuffer;
  IOException.prototype = Object.create(Exception.prototype);
  IOException.prototype.constructor = IOException;
  EOFException.prototype = Object.create(IOException.prototype);
  EOFException.prototype.constructor = EOFException;
  $toByteArrayCOROUTINE$0.prototype = Object.create(CoroutineImpl_0.prototype);
  $toByteArrayCOROUTINE$0.prototype.constructor = $toByteArrayCOROUTINE$0;
  _no_name_provided__1_2.prototype = Object.create(AbstractCoroutineContextElement.prototype);
  _no_name_provided__1_2.prototype.constructor = _no_name_provided__1_2;
  WeekDay.prototype = Object.create(Enum.prototype);
  WeekDay.prototype.constructor = WeekDay;
  Month.prototype = Object.create(Enum.prototype);
  Month.prototype.constructor = Month;
  $proceedLoopCOROUTINE$1.prototype = Object.create(CoroutineImpl_0.prototype);
  $proceedLoopCOROUTINE$1.prototype.constructor = $proceedLoopCOROUTINE$1;
  InvalidPhaseException.prototype = Object.create(Error.prototype);
  InvalidPhaseException.prototype.constructor = InvalidPhaseException;
  Before.prototype = Object.create(PipelinePhaseRelation.prototype);
  Before.prototype.constructor = Before;
  Last.prototype = Object.create(PipelinePhaseRelation.prototype);
  Last.prototype.constructor = Last;
  _no_name_provided__150.prototype = Object.create(CoroutineImpl_0.prototype);
  _no_name_provided__150.prototype.constructor = _no_name_provided__150;
  InvalidTimestampException.prototype = Object.create(IllegalStateException.prototype);
  InvalidTimestampException.prototype.constructor = InvalidTimestampException;
  URLDecodeException.prototype = Object.create(Exception.prototype);
  URLDecodeException.prototype.constructor = URLDecodeException;
  ContentType.prototype = Object.create(HeaderValueWithParameters.prototype);
  ContentType.prototype.constructor = ContentType;
  BadContentTypeFormatException.prototype = Object.create(Exception.prototype);
  BadContentTypeFormatException.prototype.constructor = BadContentTypeFormatException;
  HeadersBuilder.prototype = Object.create(StringValuesBuilder.prototype);
  HeadersBuilder.prototype.constructor = HeadersBuilder;
  HeadersImpl.prototype = Object.create(StringValuesImpl.prototype);
  HeadersImpl.prototype.constructor = HeadersImpl;
  UnsafeHeaderException.prototype = Object.create(IllegalArgumentException.prototype);
  UnsafeHeaderException.prototype.constructor = UnsafeHeaderException;
  IllegalHeaderNameException.prototype = Object.create(IllegalArgumentException.prototype);
  IllegalHeaderNameException.prototype.constructor = IllegalHeaderNameException;
  IllegalHeaderValueException.prototype = Object.create(IllegalArgumentException.prototype);
  IllegalHeaderValueException.prototype.constructor = IllegalHeaderValueException;
  ParametersBuilder.prototype = Object.create(StringValuesBuilder.prototype);
  ParametersBuilder.prototype.constructor = ParametersBuilder;
  ParametersImpl.prototype = Object.create(StringValuesImpl.prototype);
  ParametersImpl.prototype.constructor = ParametersImpl;
  URLParserException.prototype = Object.create(IllegalStateException.prototype);
  URLParserException.prototype.constructor = URLParserException;
  HeaderValueEncoding.prototype = Object.create(Enum.prototype);
  HeaderValueEncoding.prototype.constructor = HeaderValueEncoding;
  Single.prototype = Object.create(HttpAuthHeader.prototype);
  Single.prototype.constructor = Single;
  Parameterized.prototype = Object.create(HttpAuthHeader.prototype);
  Parameterized.prototype.constructor = Parameterized;
  NoContent.prototype = Object.create(OutgoingContent.prototype);
  NoContent.prototype.constructor = NoContent;
  ReadChannelContent.prototype = Object.create(OutgoingContent.prototype);
  ReadChannelContent.prototype.constructor = ReadChannelContent;
  WriteChannelContent.prototype = Object.create(OutgoingContent.prototype);
  WriteChannelContent.prototype.constructor = WriteChannelContent;
  ByteArrayContent.prototype = Object.create(OutgoingContent.prototype);
  ByteArrayContent.prototype.constructor = ByteArrayContent;
  TextContent.prototype = Object.create(ByteArrayContent.prototype);
  TextContent.prototype.constructor = TextContent;
  ParseException.prototype = Object.create(IllegalArgumentException.prototype);
  ParseException.prototype.constructor = ParseException;
  SequenceGrammar.prototype = Object.create(Grammar.prototype);
  SequenceGrammar.prototype.constructor = SequenceGrammar;
  StringGrammar.prototype = Object.create(Grammar.prototype);
  StringGrammar.prototype.constructor = StringGrammar;
  AtLeastOne.prototype = Object.create(Grammar.prototype);
  AtLeastOne.prototype.constructor = AtLeastOne;
  OrGrammar.prototype = Object.create(Grammar.prototype);
  OrGrammar.prototype.constructor = OrGrammar;
  RawGrammar.prototype = Object.create(Grammar.prototype);
  RawGrammar.prototype.constructor = RawGrammar;
  NamedGrammar.prototype = Object.create(Grammar.prototype);
  NamedGrammar.prototype.constructor = NamedGrammar;
  MaybeGrammar.prototype = Object.create(Grammar.prototype);
  MaybeGrammar.prototype.constructor = MaybeGrammar;
  ManyGrammar.prototype = Object.create(Grammar.prototype);
  ManyGrammar.prototype.constructor = ManyGrammar;
  AnyOfGrammar.prototype = Object.create(Grammar.prototype);
  AnyOfGrammar.prototype.constructor = AnyOfGrammar;
  RangeGrammar.prototype = Object.create(Grammar.prototype);
  RangeGrammar.prototype.constructor = RangeGrammar;
  _no_name_provided__166.prototype = Object.create(DefaultPool.prototype);
  _no_name_provided__166.prototype.constructor = _no_name_provided__166;
  _no_name_provided__167.prototype = Object.create(DefaultPool.prototype);
  _no_name_provided__167.prototype.constructor = _no_name_provided__167;
  _no_name_provided__170.prototype = Object.create(DefaultPool.prototype);
  _no_name_provided__170.prototype.constructor = _no_name_provided__170;
  Codes.prototype = Object.create(Enum.prototype);
  Codes.prototype.constructor = Codes;
  FrameType.prototype = Object.create(Enum.prototype);
  FrameType.prototype.constructor = FrameType;
  Binary.prototype = Object.create(Frame.prototype);
  Binary.prototype.constructor = Binary;
  Text_1.prototype = Object.create(Frame.prototype);
  Text_1.prototype.constructor = Text_1;
  Close.prototype = Object.create(Frame.prototype);
  Close.prototype.constructor = Close;
  _no_name_provided__174.prototype = Object.create(CoroutineImpl_0.prototype);
  _no_name_provided__174.prototype.constructor = _no_name_provided__174;
  $executeCOROUTINE$0.prototype = Object.create(CoroutineImpl_0.prototype);
  $executeCOROUTINE$0.prototype.constructor = $executeCOROUTINE$0;
  $receiveCOROUTINE$1.prototype = Object.create(CoroutineImpl_0.prototype);
  $receiveCOROUTINE$1.prototype.constructor = $receiveCOROUTINE$1;
  DoubleReceiveException.prototype = Object.create(IllegalStateException.prototype);
  DoubleReceiveException.prototype.constructor = DoubleReceiveException;
  NoTransformationFoundException.prototype = Object.create(UnsupportedOperationException.prototype);
  NoTransformationFoundException.prototype.constructor = NoTransformationFoundException;
  $getResponseContentCOROUTINE$4.prototype = Object.create(CoroutineImpl_0.prototype);
  $getResponseContentCOROUTINE$4.prototype.constructor = $getResponseContentCOROUTINE$4;
  SavedHttpCall.prototype = Object.create(HttpClientCall.prototype);
  SavedHttpCall.prototype.constructor = SavedHttpCall;
  SavedHttpResponse.prototype = Object.create(HttpResponse.prototype);
  SavedHttpResponse.prototype.constructor = SavedHttpResponse;
  $saveCOROUTINE$3.prototype = Object.create(CoroutineImpl_0.prototype);
  $saveCOROUTINE$3.prototype.constructor = $saveCOROUTINE$3;
  _no_name_provided__183.prototype = Object.create(CoroutineImpl_0.prototype);
  _no_name_provided__183.prototype.constructor = _no_name_provided__183;
  _no_name_provided__184.prototype = Object.create(CoroutineImpl_0.prototype);
  _no_name_provided__184.prototype.constructor = _no_name_provided__184;
  $executeWithinCallContextCOROUTINE$5.prototype = Object.create(CoroutineImpl_0.prototype);
  $executeWithinCallContextCOROUTINE$5.prototype.constructor = $executeWithinCallContextCOROUTINE$5;
  ClientEngineClosedException.prototype = Object.create(IllegalStateException.prototype);
  ClientEngineClosedException.prototype.constructor = ClientEngineClosedException;
  _no_name_provided__189.prototype = Object.create(CoroutineImpl_0.prototype);
  _no_name_provided__189.prototype.constructor = _no_name_provided__189;
  ResponseException.prototype = Object.create(IllegalStateException.prototype);
  ResponseException.prototype.constructor = ResponseException;
  RedirectResponseException.prototype = Object.create(ResponseException.prototype);
  RedirectResponseException.prototype.constructor = RedirectResponseException;
  ClientRequestException.prototype = Object.create(ResponseException.prototype);
  ClientRequestException.prototype.constructor = ClientRequestException;
  ServerResponseException.prototype = Object.create(ResponseException.prototype);
  ServerResponseException.prototype.constructor = ServerResponseException;
  _no_name_provided__191.prototype = Object.create(CoroutineImpl_0.prototype);
  _no_name_provided__191.prototype.constructor = _no_name_provided__191;
  _no_name_provided__193.prototype = Object.create(ByteArrayContent.prototype);
  _no_name_provided__193.prototype.constructor = _no_name_provided__193;
  _no_name_provided__194.prototype = Object.create(ReadChannelContent.prototype);
  _no_name_provided__194.prototype.constructor = _no_name_provided__194;
  _no_name_provided__195.prototype = Object.create(CoroutineImpl_0.prototype);
  _no_name_provided__195.prototype.constructor = _no_name_provided__195;
  _no_name_provided__196.prototype = Object.create(CoroutineImpl_0.prototype);
  _no_name_provided__196.prototype.constructor = _no_name_provided__196;
  _no_name_provided__198.prototype = Object.create(CoroutineImpl_0.prototype);
  _no_name_provided__198.prototype.constructor = _no_name_provided__198;
  _no_name_provided__199.prototype = Object.create(CoroutineImpl_0.prototype);
  _no_name_provided__199.prototype.constructor = _no_name_provided__199;
  _no_name_provided__200.prototype = Object.create(CoroutineImpl_0.prototype);
  _no_name_provided__200.prototype.constructor = _no_name_provided__200;
  _no_name_provided__201.prototype = Object.create(CoroutineImpl_0.prototype);
  _no_name_provided__201.prototype.constructor = _no_name_provided__201;
  $validateResponseCOROUTINE$6.prototype = Object.create(CoroutineImpl_0.prototype);
  $validateResponseCOROUTINE$6.prototype.constructor = $validateResponseCOROUTINE$6;
  $processExceptionCOROUTINE$7.prototype = Object.create(CoroutineImpl_0.prototype);
  $processExceptionCOROUTINE$7.prototype.constructor = $processExceptionCOROUTINE$7;
  _no_name_provided__202.prototype = Object.create(CoroutineImpl_0.prototype);
  _no_name_provided__202.prototype.constructor = _no_name_provided__202;
  _no_name_provided__203.prototype = Object.create(CoroutineImpl_0.prototype);
  _no_name_provided__203.prototype.constructor = _no_name_provided__203;
  _no_name_provided__206.prototype = Object.create(CoroutineImpl_0.prototype);
  _no_name_provided__206.prototype.constructor = _no_name_provided__206;
  $handleCallCOROUTINE$8.prototype = Object.create(CoroutineImpl_0.prototype);
  $handleCallCOROUTINE$8.prototype.constructor = $handleCallCOROUTINE$8;
  _no_name_provided__207.prototype = Object.create(CoroutineImpl_0.prototype);
  _no_name_provided__207.prototype.constructor = _no_name_provided__207;
  _no_name_provided__210.prototype = Object.create(CoroutineImpl_0.prototype);
  _no_name_provided__210.prototype.constructor = _no_name_provided__210;
  $executeCOROUTINE$9.prototype = Object.create(CoroutineImpl_0.prototype);
  $executeCOROUTINE$9.prototype.constructor = $executeCOROUTINE$9;
  SendCountExceedException.prototype = Object.create(IllegalStateException.prototype);
  SendCountExceedException.prototype.constructor = SendCountExceedException;
  _no_name_provided__211.prototype = Object.create(CoroutineImpl_0.prototype);
  _no_name_provided__211.prototype.constructor = _no_name_provided__211;
  _no_name_provided__213.prototype = Object.create(CoroutineImpl_0.prototype);
  _no_name_provided__213.prototype.constructor = _no_name_provided__213;
  HttpRequestTimeoutException.prototype = Object.create(CancellationException.prototype);
  HttpRequestTimeoutException.prototype.constructor = HttpRequestTimeoutException;
  WebSocketException.prototype = Object.create(IllegalStateException.prototype);
  WebSocketException.prototype.constructor = WebSocketException;
  ClientUpgradeContent.prototype = Object.create(NoContent.prototype);
  ClientUpgradeContent.prototype.constructor = ClientUpgradeContent;
  HttpRequestPipeline.prototype = Object.create(Pipeline.prototype);
  HttpRequestPipeline.prototype.constructor = HttpRequestPipeline;
  HttpSendPipeline.prototype = Object.create(Pipeline.prototype);
  HttpSendPipeline.prototype.constructor = HttpSendPipeline;
  DefaultHttpResponse.prototype = Object.create(HttpResponse.prototype);
  DefaultHttpResponse.prototype.constructor = DefaultHttpResponse;
  HttpResponsePipeline.prototype = Object.create(Pipeline.prototype);
  HttpResponsePipeline.prototype.constructor = HttpResponsePipeline;
  HttpReceivePipeline.prototype = Object.create(Pipeline.prototype);
  HttpReceivePipeline.prototype.constructor = HttpReceivePipeline;
  _no_name_provided__216.prototype = Object.create(CoroutineImpl_0.prototype);
  _no_name_provided__216.prototype.constructor = _no_name_provided__216;
  $executeCOROUTINE$18.prototype = Object.create(CoroutineImpl_0.prototype);
  $executeCOROUTINE$18.prototype.constructor = $executeCOROUTINE$18;
  $executeUnsafeCOROUTINE$21.prototype = Object.create(CoroutineImpl_0.prototype);
  $executeUnsafeCOROUTINE$21.prototype.constructor = $executeUnsafeCOROUTINE$21;
  $cleanupCOROUTINE$22.prototype = Object.create(CoroutineImpl_0.prototype);
  $cleanupCOROUTINE$22.prototype.constructor = $cleanupCOROUTINE$22;
  $readTextCOROUTINE$17.prototype = Object.create(CoroutineImpl_0.prototype);
  $readTextCOROUTINE$17.prototype.constructor = $readTextCOROUTINE$17;
  EmptyContent.prototype = Object.create(NoContent.prototype);
  EmptyContent.prototype.constructor = EmptyContent;
  $executeCOROUTINE$23.prototype = Object.create(CoroutineImpl_0.prototype);
  $executeCOROUTINE$23.prototype.constructor = $executeCOROUTINE$23;
  $executeWebSocketRequestCOROUTINE$24.prototype = Object.create(CoroutineImpl_0.prototype);
  $executeWebSocketRequestCOROUTINE$24.prototype.constructor = $executeWebSocketRequestCOROUTINE$24;
  JsClientEngine.prototype = Object.create(HttpClientEngineBase.prototype);
  JsClientEngine.prototype.constructor = JsClientEngine;
  JsError.prototype = Object.create(Error.prototype);
  JsError.prototype.constructor = JsError;
  _no_name_provided__224.prototype = Object.create(CoroutineImpl_0.prototype);
  _no_name_provided__224.prototype.constructor = _no_name_provided__224;
  $toRawCOROUTINE$25.prototype = Object.create(CoroutineImpl_0.prototype);
  $toRawCOROUTINE$25.prototype.constructor = $toRawCOROUTINE$25;
  _no_name_provided__228.prototype = Object.create(CoroutineImpl_0.prototype);
  _no_name_provided__228.prototype.constructor = _no_name_provided__228;
  _no_name_provided__235.prototype = Object.create(CoroutineImpl_0.prototype);
  _no_name_provided__235.prototype.constructor = _no_name_provided__235;
  _no_name_provided__236.prototype = Object.create(CoroutineImpl_0.prototype);
  _no_name_provided__236.prototype.constructor = _no_name_provided__236;
  _no_name_provided__237.prototype = Object.create(CoroutineImpl_0.prototype);
  _no_name_provided__237.prototype.constructor = _no_name_provided__237;
  _no_name_provided__241.prototype = Object.create(CoroutineImpl_0.prototype);
  _no_name_provided__241.prototype.constructor = _no_name_provided__241;
  _no_name_provided__243.prototype = Object.create(CoroutineImpl_0.prototype);
  _no_name_provided__243.prototype.constructor = _no_name_provided__243;
  _no_name_provided__244.prototype = Object.create(CoroutineImpl_0.prototype);
  _no_name_provided__244.prototype.constructor = _no_name_provided__244;
  _no_name_provided__246.prototype = Object.create(CoroutineImpl_0.prototype);
  _no_name_provided__246.prototype.constructor = _no_name_provided__246;
  _no_name_provided__247.prototype = Object.create(CoroutineImpl_0.prototype);
  _no_name_provided__247.prototype.constructor = _no_name_provided__247;
  $postTokenCOROUTINE$0.prototype = Object.create(CoroutineImpl_0.prototype);
  $postTokenCOROUTINE$0.prototype.constructor = $postTokenCOROUTINE$0;
  $getLocationsCOROUTINE$1.prototype = Object.create(CoroutineImpl_0.prototype);
  $getLocationsCOROUTINE$1.prototype.constructor = $getLocationsCOROUTINE$1;
  _no_name_provided__266.prototype = Object.create(CoroutineImpl_0.prototype);
  _no_name_provided__266.prototype.constructor = _no_name_provided__266;
  _no_name_provided__286.prototype = Object.create(CoroutineImpl_0.prototype);
  _no_name_provided__286.prototype.constructor = _no_name_provided__286;
  _no_name_provided__302.prototype = Object.create(CoroutineImpl_0.prototype);
  _no_name_provided__302.prototype.constructor = _no_name_provided__302;
  $textGeneratorCOROUTINE$2.prototype = Object.create(CoroutineImpl_0.prototype);
  $textGeneratorCOROUTINE$2.prototype.constructor = $textGeneratorCOROUTINE$2;
  function toList(_this_) {
    var tmp0_subject = _this_.length;
    switch (tmp0_subject) {
      case 0:
        return emptyList();
      case 1:
        return listOf_0(_this_[0]);
      default:return toMutableList(_this_);
    }
  }
  function withIndex(_this_) {
    return new IndexingIterable(_no_name_provided_$factory(_this_));
  }
  function _get_indices_(_this_) {
    return new IntRange(0, _get_lastIndex_(_this_));
  }
  function joinToString(_this_, separator, prefix, postfix, limit, truncated, transform_0) {
    return joinTo(_this_, StringBuilder_init_$Create$_0(), separator, prefix, postfix, limit, truncated, transform_0).toString();
  }
  function joinToString$default(_this_, separator, prefix, postfix, limit, truncated, transform_0, $mask0, $handler) {
    if (!(($mask0 & 1) === 0))
      separator = ', ';
    if (!(($mask0 & 2) === 0))
      prefix = '';
    if (!(($mask0 & 4) === 0))
      postfix = '';
    if (!(($mask0 & 8) === 0))
      limit = -1;
    if (!(($mask0 & 16) === 0))
      truncated = '...';
    if (!(($mask0 & 32) === 0))
      transform_0 = null;
    return joinToString(_this_, separator, prefix, postfix, limit, truncated, transform_0);
  }
  function firstOrNull(_this_) {
    var tmp;
    if (_this_.length === 0) {
      tmp = null;
    } else {
      {
        tmp = _this_[0];
      }
    }
    return tmp;
  }
  function single(_this_) {
    var tmp0_subject = _this_.length;
    var tmp;
    switch (tmp0_subject) {
      case 0:
        throw NoSuchElementException_init_$Create$_0('Array is empty.');
      case 1:
        tmp = _this_[0];
        break;
      default:throw IllegalArgumentException_init_$Create$_0('Array has more than one element.');
    }
    return tmp;
  }
  function toMutableList(_this_) {
    return ArrayList_init_$Create$_1(asCollection(_this_));
  }
  function _get_lastIndex_(_this_) {
    return _this_.length - 1 | 0;
  }
  function joinTo(_this_, buffer, separator, prefix, postfix, limit, truncated, transform_0) {
    buffer.append_31(prefix);
    Unit_getInstance();
    var count_0 = 0;
    var indexedObject = _this_;
    var inductionVariable = 0;
    var last_1 = indexedObject.length;
    $l$break: while (inductionVariable < last_1) {
      var element = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      count_0 = count_0 + 1 | 0;
      if (count_0 > 1) {
        buffer.append_31(separator);
        Unit_getInstance();
      } else {
      }
      if (limit < 0 ? true : count_0 <= limit) {
        appendElement(buffer, element, transform_0);
      } else
        break $l$break;
    }
    if (limit >= 0 ? count_0 > limit : false) {
      buffer.append_31(truncated);
      Unit_getInstance();
    }buffer.append_31(postfix);
    Unit_getInstance();
    return buffer;
  }
  function indexOf(_this_, element) {
    if (element == null) {
      var inductionVariable = 0;
      var last_1 = _this_.length - 1 | 0;
      if (inductionVariable <= last_1)
        do {
          var index = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          if (_this_[index] == null) {
            return index;
          }}
         while (inductionVariable <= last_1);
    } else {
      var inductionVariable_0 = 0;
      var last_2 = _this_.length - 1 | 0;
      if (inductionVariable_0 <= last_2)
        do {
          var index_0 = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          if (equals_1(element, _this_[index_0])) {
            return index_0;
          }}
         while (inductionVariable_0 <= last_2);
    }
    return -1;
  }
  function toSet(_this_) {
    var tmp0_subject = _this_.length;
    switch (tmp0_subject) {
      case 0:
        return emptySet();
      case 1:
        return setOf_0(_this_[0]);
      default:return toCollection(_this_, LinkedHashSet_init_$Create$_1(mapCapacity(_this_.length)));
    }
  }
  function toCollection(_this_, destination) {
    var indexedObject = _this_;
    var inductionVariable = 0;
    var last_1 = indexedObject.length;
    while (inductionVariable < last_1) {
      var item = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      destination.add_33(item);
      Unit_getInstance();
    }
    return destination;
  }
  function contains(_this_, element) {
    return indexOf(_this_, element) >= 0;
  }
  function _no_name_provided_($this_withIndex) {
    this._$this_withIndex = $this_withIndex;
  }
  _no_name_provided_.prototype.invoke_540 = function () {
    return arrayIterator(this._$this_withIndex);
  };
  _no_name_provided_.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided_$factory($this_withIndex) {
    var i = new _no_name_provided_($this_withIndex);
    return function () {
      return i.invoke_540();
    };
  }
  function toHashSet(_this_) {
    return toCollection_0(_this_, HashSet_init_$Create$_1(mapCapacity(collectionSizeOrDefault(_this_, 12))));
  }
  function toBooleanArray(_this_) {
    var result = booleanArray(_this_._get_size__45());
    var index = 0;
    var tmp0_iterator = _this_.iterator_64();
    while (tmp0_iterator.hasNext_31()) {
      var element = tmp0_iterator.next_35();
      var tmp1 = index;
      index = tmp1 + 1 | 0;
      result[tmp1] = element;
    }
    return result;
  }
  function joinToString_0(_this_, separator, prefix, postfix, limit, truncated, transform_0) {
    return joinTo_0(_this_, StringBuilder_init_$Create$_0(), separator, prefix, postfix, limit, truncated, transform_0).toString();
  }
  function joinToString$default_0(_this_, separator, prefix, postfix, limit, truncated, transform_0, $mask0, $handler) {
    if (!(($mask0 & 1) === 0))
      separator = ', ';
    if (!(($mask0 & 2) === 0))
      prefix = '';
    if (!(($mask0 & 4) === 0))
      postfix = '';
    if (!(($mask0 & 8) === 0))
      limit = -1;
    if (!(($mask0 & 16) === 0))
      truncated = '...';
    if (!(($mask0 & 32) === 0))
      transform_0 = null;
    return joinToString_0(_this_, separator, prefix, postfix, limit, truncated, transform_0);
  }
  function toSet_0(_this_) {
    if (isInterface(_this_, Collection)) {
      var tmp0_subject = _this_._get_size__45();
      var tmp;
      switch (tmp0_subject) {
        case 0:
          tmp = emptySet();
          break;
        case 1:
          var tmp_0;
          if (isInterface(_this_, List)) {
            tmp_0 = _this_.get_80(0);
          } else {
            {
              tmp_0 = _this_.iterator_64().next_35();
            }
          }

          tmp = setOf_0(tmp_0);
          break;
        default:tmp = toCollection_0(_this_, LinkedHashSet_init_$Create$_1(mapCapacity(_this_._get_size__45())));
          break;
      }
      return tmp;
    } else {
    }
    return optimizeReadOnlySet(toCollection_0(_this_, LinkedHashSet_init_$Create$()));
  }
  function plus(_this_, elements) {
    if (isInterface(elements, Collection)) {
      var result = ArrayList_init_$Create$_0(_this_._get_size__45() + elements._get_size__45() | 0);
      result.addAll_23(_this_);
      Unit_getInstance();
      result.addAll_23(elements);
      Unit_getInstance();
      return result;
    } else {
      {
        var result_0 = ArrayList_init_$Create$_1(_this_);
        addAll(result_0, elements);
        Unit_getInstance();
        return result_0;
      }
    }
  }
  function plus_0(_this_, elements) {
    if (isInterface(_this_, Collection))
      return plus(_this_, elements);
    else {
    }
    var result = ArrayList_init_$Create$();
    addAll(result, _this_);
    Unit_getInstance();
    addAll(result, elements);
    Unit_getInstance();
    return result;
  }
  function asSequence(_this_) {
    return new _no_name_provided__1(_this_);
  }
  function firstOrNull_0(_this_) {
    return _this_.isEmpty_53() ? null : _this_.get_80(0);
  }
  function plus_1(_this_, element) {
    var result = ArrayList_init_$Create$_0(_this_._get_size__45() + 1 | 0);
    result.addAll_23(_this_);
    Unit_getInstance();
    result.add_33(element);
    Unit_getInstance();
    return result;
  }
  function single_0(_this_) {
    var tmp0_subject = _this_._get_size__45();
    var tmp;
    switch (tmp0_subject) {
      case 0:
        throw NoSuchElementException_init_$Create$_0('List is empty.');
      case 1:
        tmp = _this_.get_80(0);
        break;
      default:throw IllegalArgumentException_init_$Create$_0('List has more than one element.');
    }
    return tmp;
  }
  function toLongArray(_this_) {
    var result = longArray(_this_._get_size__45());
    var index = 0;
    var tmp0_iterator = _this_.iterator_64();
    while (tmp0_iterator.hasNext_31()) {
      var element = tmp0_iterator.next_35();
      var tmp1 = index;
      index = tmp1 + 1 | 0;
      result[tmp1] = element;
    }
    return result;
  }
  function toByteArray(_this_) {
    var result = new Int8Array(_this_._get_size__45());
    var index = 0;
    var tmp0_iterator = _this_.iterator_64();
    while (tmp0_iterator.hasNext_31()) {
      var element = tmp0_iterator.next_35();
      var tmp1 = index;
      index = tmp1 + 1 | 0;
      result[tmp1] = element;
    }
    return result;
  }
  function reversed(_this_) {
    var tmp;
    if (isInterface(_this_, Collection)) {
      tmp = _this_._get_size__45() <= 1;
    } else {
      {
        tmp = false;
      }
    }
    if (tmp)
      return toList_0(_this_);
    else {
    }
    var list = toMutableList_0(_this_);
    reverse(list);
    return list;
  }
  function filterNotNull(_this_) {
    return filterNotNullTo(_this_, ArrayList_init_$Create$());
  }
  function singleOrNull(_this_) {
    return _this_._get_size__45() === 1 ? _this_.get_80(0) : null;
  }
  function single_1(_this_) {
    var tmp0_subject = _this_;
    if (isInterface(tmp0_subject, List))
      return single_0(_this_);
    else {
      {
        var iterator_0 = _this_.iterator_64();
        if (!iterator_0.hasNext_31())
          throw NoSuchElementException_init_$Create$_0('Collection is empty.');
        var single_3 = iterator_0.next_35();
        if (iterator_0.hasNext_31())
          throw IllegalArgumentException_init_$Create$_0('Collection has more than one element.');
        return single_3;
      }
    }
  }
  function toCollection_0(_this_, destination) {
    var tmp0_iterator = _this_.iterator_64();
    while (tmp0_iterator.hasNext_31()) {
      var item = tmp0_iterator.next_35();
      destination.add_33(item);
      Unit_getInstance();
    }
    return destination;
  }
  function joinTo_0(_this_, buffer, separator, prefix, postfix, limit, truncated, transform_0) {
    buffer.append_31(prefix);
    Unit_getInstance();
    var count_0 = 0;
    var tmp0_iterator = _this_.iterator_64();
    $l$break: while (tmp0_iterator.hasNext_31()) {
      var element = tmp0_iterator.next_35();
      count_0 = count_0 + 1 | 0;
      if (count_0 > 1) {
        buffer.append_31(separator);
        Unit_getInstance();
      } else {
      }
      if (limit < 0 ? true : count_0 <= limit) {
        appendElement(buffer, element, transform_0);
      } else
        break $l$break;
    }
    if (limit >= 0 ? count_0 > limit : false) {
      buffer.append_31(truncated);
      Unit_getInstance();
    }buffer.append_31(postfix);
    Unit_getInstance();
    return buffer;
  }
  function joinTo$default(_this_, buffer, separator, prefix, postfix, limit, truncated, transform_0, $mask0, $handler) {
    if (!(($mask0 & 2) === 0))
      separator = ', ';
    if (!(($mask0 & 4) === 0))
      prefix = '';
    if (!(($mask0 & 8) === 0))
      postfix = '';
    if (!(($mask0 & 16) === 0))
      limit = -1;
    if (!(($mask0 & 32) === 0))
      truncated = '...';
    if (!(($mask0 & 64) === 0))
      transform_0 = null;
    return joinTo_0(_this_, buffer, separator, prefix, postfix, limit, truncated, transform_0);
  }
  function sortedWith(_this_, comparator) {
    if (isInterface(_this_, Collection)) {
      if (_this_._get_size__45() <= 1)
        return toList_0(_this_);
      var tmp0_toTypedArray_0 = _this_;
      var tmp = copyToArray_0(tmp0_toTypedArray_0);
      var tmp1_apply_0 = isArray(tmp) ? tmp : THROW_CCE();
      sortWith_0(tmp1_apply_0, comparator);
      return asList(tmp1_apply_0);
    } else {
    }
    var tmp2_apply_0 = toMutableList_0(_this_);
    sortWith(tmp2_apply_0, comparator);
    return tmp2_apply_0;
  }
  function toList_0(_this_) {
    if (isInterface(_this_, Collection)) {
      var tmp0_subject = _this_._get_size__45();
      var tmp;
      switch (tmp0_subject) {
        case 0:
          tmp = emptyList();
          break;
        case 1:
          var tmp_0;
          if (isInterface(_this_, List)) {
            tmp_0 = _this_.get_80(0);
          } else {
            {
              tmp_0 = _this_.iterator_64().next_35();
            }
          }

          tmp = listOf_0(tmp_0);
          break;
        default:tmp = toMutableList_1(_this_);
          break;
      }
      return tmp;
    } else {
    }
    return optimizeReadOnlyList(toMutableList_0(_this_));
  }
  function toMutableList_0(_this_) {
    if (isInterface(_this_, Collection))
      return toMutableList_1(_this_);
    else {
    }
    return toCollection_0(_this_, ArrayList_init_$Create$());
  }
  function filterNotNullTo(_this_, destination) {
    var tmp0_iterator = _this_.iterator_64();
    while (tmp0_iterator.hasNext_31()) {
      var element = tmp0_iterator.next_35();
      if (!(element == null)) {
        destination.add_33(element);
        Unit_getInstance();
      }}
    return destination;
  }
  function toMutableList_1(_this_) {
    return ArrayList_init_$Create$_1(_this_);
  }
  function last(_this_) {
    if (_this_.isEmpty_53())
      throw NoSuchElementException_init_$Create$_0('List is empty.');
    return _this_.get_80(_get_lastIndex__0(_this_));
  }
  function first(_this_) {
    if (_this_.isEmpty_53())
      throw NoSuchElementException_init_$Create$_0('List is empty.');
    return _this_.get_80(0);
  }
  function lastOrNull(_this_) {
    return _this_.isEmpty_53() ? null : _this_.get_80(_this_._get_size__45() - 1 | 0);
  }
  function minOrNull(_this_) {
    var iterator_0 = _this_.iterator_64();
    if (!iterator_0.hasNext_31())
      return null;
    var min = iterator_0.next_35();
    while (iterator_0.hasNext_31()) {
      var e = iterator_0.next_35();
      if (compareTo(min, e) > 0)
        min = e;
    }
    return min;
  }
  function _no_name_provided__1($this_asSequence) {
    this._$this_asSequence = $this_asSequence;
  }
  _no_name_provided__1.prototype.iterator_2_0 = function () {
    return this._$this_asSequence.iterator_64();
  };
  _no_name_provided__1.prototype.iterator_64 = function () {
    return this.iterator_2_0();
  };
  _no_name_provided__1.$metadata$ = {
    simpleName: '<no name provided>_1',
    kind: 'class',
    interfaces: [Sequence]
  };
  function toList_1(_this_) {
    if (_this_._get_size__45() === 0)
      return emptyList();
    var iterator_0 = _this_._get_entries__10().iterator_64();
    if (!iterator_0.hasNext_31())
      return emptyList();
    var first_1 = iterator_0.next_35();
    if (!iterator_0.hasNext_31()) {
      return listOf_0(new Pair(first_1._get_key__47(), first_1._get_value__33()));
    }var result = ArrayList_init_$Create$_0(_this_._get_size__45());
    result.add_33(new Pair(first_1._get_key__47(), first_1._get_value__33()));
    Unit_getInstance();
    do {
      var tmp0_toPair_0 = iterator_0.next_35();
      result.add_33(new Pair(tmp0_toPair_0._get_key__47(), tmp0_toPair_0._get_value__33()));
      Unit_getInstance();
    }
     while (iterator_0.hasNext_31());
    return result;
  }
  function until(_this_, to_1) {
    if (to_1 <= IntCompanionObject_getInstance()._MIN_VALUE_5)
      return Companion_getInstance_10()._EMPTY;
    return numberRangeToNumber(_this_, to_1 - 1 | 0);
  }
  function coerceAtLeast(_this_, minimumValue) {
    return _this_ < minimumValue ? minimumValue : _this_;
  }
  function coerceIn(_this_, minimumValue, maximumValue) {
    if (minimumValue > maximumValue)
      throw IllegalArgumentException_init_$Create$_0('' + 'Cannot coerce value to an empty range: maximum ' + maximumValue + ' is less than minimum ' + minimumValue + '.');
    if (_this_ < minimumValue)
      return minimumValue;
    if (_this_ > maximumValue)
      return maximumValue;
    return _this_;
  }
  function coerceIn_0(_this_, minimumValue, maximumValue) {
    if (minimumValue > maximumValue)
      throw IllegalArgumentException_init_$Create$_0('' + 'Cannot coerce value to an empty range: maximum ' + maximumValue + ' is less than minimum ' + minimumValue + '.');
    if (_this_ < minimumValue)
      return minimumValue;
    if (_this_ > maximumValue)
      return maximumValue;
    return _this_;
  }
  function coerceAtMost(_this_, maximumValue) {
    return _this_ > maximumValue ? maximumValue : _this_;
  }
  function step(_this_, step_0) {
    checkStepIsPositive(step_0 > 0, step_0);
    return Companion_getInstance_8().fromClosedRange(_this_._first_1, _this_._last, _this_._step_1 > 0 ? step_0 : -step_0 | 0);
  }
  function downTo(_this_, to_1) {
    return Companion_getInstance_8().fromClosedRange(_this_, to_1, -1);
  }
  function coerceIn_1(_this_, minimumValue, maximumValue) {
    if (minimumValue.compareTo_69(maximumValue) > 0)
      throw IllegalArgumentException_init_$Create$_0('' + 'Cannot coerce value to an empty range: maximum ' + maximumValue + ' is less than minimum ' + minimumValue + '.');
    if (_this_.compareTo_69(minimumValue) < 0)
      return minimumValue;
    if (_this_.compareTo_69(maximumValue) > 0)
      return maximumValue;
    return _this_;
  }
  function coerceAtMost_0(_this_, maximumValue) {
    return _this_.compareTo_69(maximumValue) > 0 ? maximumValue : _this_;
  }
  function map(_this_, transform_0) {
    return new TransformingSequence(_this_, transform_0);
  }
  function toList_2(_this_) {
    return optimizeReadOnlyList(toMutableList_2(_this_));
  }
  function mapNotNull(_this_, transform_0) {
    return filterNotNull_0(new TransformingSequence(_this_, transform_0));
  }
  function toMutableList_2(_this_) {
    return toCollection_1(_this_, ArrayList_init_$Create$());
  }
  function filterNotNull_0(_this_) {
    var tmp = filterNot(_this_, _no_name_provided_$factory_0());
    return isInterface(tmp, Sequence) ? tmp : THROW_CCE();
  }
  function toCollection_1(_this_, destination) {
    var tmp0_iterator = _this_.iterator_64();
    while (tmp0_iterator.hasNext_31()) {
      var item = tmp0_iterator.next_35();
      destination.add_33(item);
      Unit_getInstance();
    }
    return destination;
  }
  function filterNot(_this_, predicate) {
    return new FilteringSequence(_this_, false, predicate);
  }
  function _no_name_provided__0() {
  }
  _no_name_provided__0.prototype.invoke_1 = function (it) {
    return it == null;
  };
  _no_name_provided__0.prototype.invoke_542 = function (p1) {
    return this.invoke_1((p1 == null ? true : isObject(p1)) ? p1 : THROW_CCE());
  };
  _no_name_provided__0.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided_$factory_0() {
    var i = new _no_name_provided__0();
    return function (p1) {
      return i.invoke_1(p1);
    };
  }
  function plus_2(_this_, elements) {
    var tmp0_safe_receiver = collectionSizeOrNull(elements);
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      tmp = _this_._get_size__45() + tmp0_safe_receiver | 0;
    }
    var tmp1_elvis_lhs = tmp;
    var result = LinkedHashSet_init_$Create$_1(mapCapacity(tmp1_elvis_lhs == null ? imul(_this_._get_size__45(), 2) : tmp1_elvis_lhs));
    result.addAll_23(_this_);
    Unit_getInstance();
    addAll(result, elements);
    Unit_getInstance();
    return result;
  }
  function first_0(_this_) {
    if (charSequenceLength(_this_) === 0)
      throw NoSuchElementException_init_$Create$_0('Char sequence is empty.');
    else {
    }
    return charSequenceGet(_this_, 0);
  }
  function last_0(_this_) {
    if (charSequenceLength(_this_) === 0)
      throw NoSuchElementException_init_$Create$_0('Char sequence is empty.');
    else {
    }
    return charSequenceGet(_this_, _get_lastIndex__1(_this_));
  }
  function dropLast(_this_, n) {
    var tmp0_require_0 = n >= 0;
    if (!tmp0_require_0) {
      var message_2 = '' + 'Requested character count ' + n + ' is less than zero.';
      throw IllegalArgumentException_init_$Create$_0(toString_1(message_2));
    }return take(_this_, coerceAtLeast(_this_.length - n | 0, 0));
  }
  function take(_this_, n) {
    var tmp0_require_0 = n >= 0;
    if (!tmp0_require_0) {
      var message_2 = '' + 'Requested character count ' + n + ' is less than zero.';
      throw IllegalArgumentException_init_$Create$_0(toString_1(message_2));
    }var tmp1_substring_0 = 0;
    var tmp2_substring_0 = coerceAtMost(n, _this_.length);
    return _this_.substring(tmp1_substring_0, tmp2_substring_0);
  }
  function single_2(_this_) {
    var tmp0_subject = charSequenceLength(_this_);
    var tmp;
    switch (tmp0_subject) {
      case 0:
        throw NoSuchElementException_init_$Create$_0('Char sequence is empty.');
      case 1:
        tmp = charSequenceGet(_this_, 0);
        break;
      default:throw IllegalArgumentException_init_$Create$_0('Char sequence has more than one element.');
    }
    return tmp;
  }
  function drop(_this_, n) {
    var tmp0_require_0 = n >= 0;
    if (!tmp0_require_0) {
      var message_2 = '' + 'Requested character count ' + n + ' is less than zero.';
      throw IllegalArgumentException_init_$Create$_0(toString_1(message_2));
    }var tmp1_substring_0 = coerceAtMost(n, _this_.length);
    return _this_.substring(tmp1_substring_0);
  }
  function takeLast(_this_, n) {
    var tmp0_require_0 = n >= 0;
    if (!tmp0_require_0) {
      var message_2 = '' + 'Requested character count ' + n + ' is less than zero.';
      throw IllegalArgumentException_init_$Create$_0(toString_1(message_2));
    }var length = _this_.length;
    var tmp1_substring_0 = length - coerceAtMost(n, length) | 0;
    return _this_.substring(tmp1_substring_0);
  }
  function _no_name_provided__2(this$0) {
    this._this$0 = this$0;
  }
  _no_name_provided__2.prototype.invoke_19 = function (it) {
    return it === this._this$0 ? '(this Collection)' : toString_0(it);
  };
  _no_name_provided__2.prototype.invoke_542 = function (p1) {
    return this.invoke_19((p1 == null ? true : isObject(p1)) ? p1 : THROW_CCE());
  };
  _no_name_provided__2.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function AbstractCollection() {
  }
  AbstractCollection.prototype.contains_51 = function (element) {
    var tmp$ret$0;
    l$ret$1: do {
      var tmp;
      if (isInterface(this, Collection)) {
        tmp = this.isEmpty_53();
      } else {
        {
          tmp = false;
        }
      }
      if (tmp) {
        tmp$ret$0 = false;
        break l$ret$1;
      } else {
      }
      var tmp0_iterator_1 = this.iterator_64();
      while (tmp0_iterator_1.hasNext_31()) {
        var element_2 = tmp0_iterator_1.next_35();
        if (equals_1(element_2, element)) {
          tmp$ret$0 = true;
          break l$ret$1;
        } else {
        }
      }
      tmp$ret$0 = false;
    }
     while (false);
    return tmp$ret$0;
  };
  AbstractCollection.prototype.containsAll_38 = function (elements) {
    var tmp$ret$0;
    l$ret$1: do {
      var tmp;
      if (isInterface(elements, Collection)) {
        tmp = elements.isEmpty_53();
      } else {
        {
          tmp = false;
        }
      }
      if (tmp) {
        tmp$ret$0 = true;
        break l$ret$1;
      } else {
      }
      var tmp0_iterator_1 = elements.iterator_64();
      while (tmp0_iterator_1.hasNext_31()) {
        var element_2 = tmp0_iterator_1.next_35();
        if (!this.contains_51(element_2)) {
          tmp$ret$0 = false;
          break l$ret$1;
        } else {
        }
      }
      tmp$ret$0 = true;
    }
     while (false);
    return tmp$ret$0;
  };
  AbstractCollection.prototype.isEmpty_53 = function () {
    return this._get_size__45() === 0;
  };
  AbstractCollection.prototype.toString = function () {
    return joinToString$default_0(this, ', ', '[', ']', 0, null, _no_name_provided_$factory_1(this), 24, null);
  };
  AbstractCollection.prototype.toArray = function () {
    return copyToArrayImpl_0(this);
  };
  AbstractCollection.$metadata$ = {
    simpleName: 'AbstractCollection',
    kind: 'class',
    interfaces: [Collection]
  };
  function _no_name_provided_$factory_1(this$0) {
    var i = new _no_name_provided__2(this$0);
    return function (p1) {
      return i.invoke_19(p1);
    };
  }
  function Companion_0() {
    Companion_instance = this;
  }
  Companion_0.prototype.checkElementIndex = function (index, size_0) {
    if (index < 0 ? true : index >= size_0) {
      throw IndexOutOfBoundsException_init_$Create$_0('' + 'index: ' + index + ', size: ' + size_0);
    }};
  Companion_0.prototype.checkPositionIndex = function (index, size_0) {
    if (index < 0 ? true : index > size_0) {
      throw IndexOutOfBoundsException_init_$Create$_0('' + 'index: ' + index + ', size: ' + size_0);
    }};
  Companion_0.prototype.checkRangeIndexes = function (fromIndex, toIndex, size_0) {
    if (fromIndex < 0 ? true : toIndex > size_0) {
      throw IndexOutOfBoundsException_init_$Create$_0('' + 'fromIndex: ' + fromIndex + ', toIndex: ' + toIndex + ', size: ' + size_0);
    }if (fromIndex > toIndex) {
      throw IllegalArgumentException_init_$Create$_0('' + 'fromIndex: ' + fromIndex + ' > toIndex: ' + toIndex);
    }};
  Companion_0.prototype.checkBoundsIndexes = function (startIndex, endIndex, size_0) {
    if (startIndex < 0 ? true : endIndex > size_0) {
      throw IndexOutOfBoundsException_init_$Create$_0('' + 'startIndex: ' + startIndex + ', endIndex: ' + endIndex + ', size: ' + size_0);
    }if (startIndex > endIndex) {
      throw IllegalArgumentException_init_$Create$_0('' + 'startIndex: ' + startIndex + ' > endIndex: ' + endIndex);
    }};
  Companion_0.prototype.orderedHashCode = function (c) {
    var hashCode_1 = 1;
    var tmp0_iterator = c.iterator_64();
    while (tmp0_iterator.hasNext_31()) {
      var e = tmp0_iterator.next_35();
      var tmp = imul(31, hashCode_1);
      var tmp1_safe_receiver = e;
      var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : hashCode(tmp1_safe_receiver);
      hashCode_1 = tmp + (tmp2_elvis_lhs == null ? 0 : tmp2_elvis_lhs) | 0;
    }
    return hashCode_1;
  };
  Companion_0.prototype.orderedEquals = function (c, other) {
    if (!(c._get_size__45() === other._get_size__45()))
      return false;
    var otherIterator = other.iterator_64();
    var tmp0_iterator = c.iterator_64();
    while (tmp0_iterator.hasNext_31()) {
      var elem = tmp0_iterator.next_35();
      var elemOther = otherIterator.next_35();
      if (!equals_1(elem, elemOther)) {
        return false;
      }}
    return true;
  };
  Companion_0.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance;
  function Companion_getInstance() {
    if (Companion_instance == null)
      new Companion_0();
    return Companion_instance;
  }
  function _no_name_provided__3($entryIterator) {
    this._$entryIterator = $entryIterator;
  }
  _no_name_provided__3.prototype.hasNext_31 = function () {
    return this._$entryIterator.hasNext_31();
  };
  _no_name_provided__3.prototype.next_35 = function () {
    return this._$entryIterator.next_35()._get_key__47();
  };
  _no_name_provided__3.$metadata$ = {
    kind: 'class',
    interfaces: [Iterator]
  };
  function _no_name_provided__4($entryIterator) {
    this._$entryIterator_0 = $entryIterator;
  }
  _no_name_provided__4.prototype.hasNext_31 = function () {
    return this._$entryIterator_0.hasNext_31();
  };
  _no_name_provided__4.prototype.next_35 = function () {
    return this._$entryIterator_0.next_35()._get_value__33();
  };
  _no_name_provided__4.$metadata$ = {
    kind: 'class',
    interfaces: [Iterator]
  };
  function toString($this, o) {
    return o === $this ? '(this Map)' : toString_0(o);
  }
  function implFindEntry($this, key) {
    var tmp$ret$0;
    l$ret$1: do {
      var tmp0_firstOrNull_0 = $this._get_entries__10();
      var tmp0_iterator_1 = tmp0_firstOrNull_0.iterator_64();
      while (tmp0_iterator_1.hasNext_31()) {
        var element_2 = tmp0_iterator_1.next_35();
        if (equals_1(element_2._get_key__47(), key)) {
          tmp$ret$0 = element_2;
          break l$ret$1;
        } else {
        }
      }
      tmp$ret$0 = null;
    }
     while (false);
    return tmp$ret$0;
  }
  function Companion_1() {
    Companion_instance_0 = this;
  }
  Companion_1.prototype.entryHashCode = function (e) {
    var tmp2_safe_receiver_4 = e._get_key__47();
    var tmp3_elvis_lhs_3 = tmp2_safe_receiver_4 == null ? null : hashCode(tmp2_safe_receiver_4);
    var tmp = tmp3_elvis_lhs_3 == null ? 0 : tmp3_elvis_lhs_3;
    var tmp0_safe_receiver_6 = e._get_value__33();
    var tmp1_elvis_lhs_5 = tmp0_safe_receiver_6 == null ? null : hashCode(tmp0_safe_receiver_6);
    return tmp ^ (tmp1_elvis_lhs_5 == null ? 0 : tmp1_elvis_lhs_5);
  };
  Companion_1.prototype.entryToString = function (e) {
    return '' + e._get_key__47() + '=' + e._get_value__33();
  };
  Companion_1.prototype.entryEquals = function (e, other) {
    if (!(!(other == null) ? isInterface(other, Entry) : false))
      return false;
    else {
    }
    return equals_1(e._get_key__47(), other._get_key__47()) ? equals_1(e._get_value__33(), other._get_value__33()) : false;
  };
  Companion_1.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_0;
  function Companion_getInstance_0() {
    if (Companion_instance_0 == null)
      new Companion_1();
    return Companion_instance_0;
  }
  function _no_name_provided__5(this$0) {
    this._this$0_0 = this$0;
    AbstractSet.call(this);
  }
  _no_name_provided__5.prototype.contains_27 = function (element) {
    return this._this$0_0.containsKey_16(element);
  };
  _no_name_provided__5.prototype.contains_51 = function (element) {
    if (!(element == null ? true : isObject(element)))
      return false;
    else {
    }
    return this.contains_27((element == null ? true : isObject(element)) ? element : THROW_CCE());
  };
  _no_name_provided__5.prototype.iterator_64 = function () {
    var entryIterator = this._this$0_0._get_entries__10().iterator_64();
    return new _no_name_provided__3(entryIterator);
  };
  _no_name_provided__5.prototype._get_size__45 = function () {
    return this._this$0_0._get_size__45();
  };
  _no_name_provided__5.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__6(this$0) {
    this._this$0_1 = this$0;
  }
  _no_name_provided__6.prototype.invoke_5 = function (it) {
    return this._this$0_1.toString_0(it);
  };
  _no_name_provided__6.prototype.invoke_542 = function (p1) {
    return this.invoke_5((!(p1 == null) ? isInterface(p1, Entry) : false) ? p1 : THROW_CCE());
  };
  _no_name_provided__6.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__7(this$0) {
    this._this$0_2 = this$0;
    AbstractCollection.call(this);
  }
  _no_name_provided__7.prototype.contains_20 = function (element) {
    return this._this$0_2.containsValue_2(element);
  };
  _no_name_provided__7.prototype.contains_51 = function (element) {
    if (!(element == null ? true : isObject(element)))
      return false;
    else {
    }
    return this.contains_20((element == null ? true : isObject(element)) ? element : THROW_CCE());
  };
  _no_name_provided__7.prototype.iterator_64 = function () {
    var entryIterator = this._this$0_2._get_entries__10().iterator_64();
    return new _no_name_provided__4(entryIterator);
  };
  _no_name_provided__7.prototype._get_size__45 = function () {
    return this._this$0_2._get_size__45();
  };
  _no_name_provided__7.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function AbstractMap() {
    Companion_getInstance_0();
    this.__keys = null;
    this.__values = null;
  }
  AbstractMap.prototype.containsKey_16 = function (key) {
    return !(implFindEntry(this, key) == null);
  };
  AbstractMap.prototype.containsValue_2 = function (value) {
    var tmp$ret$0;
    l$ret$1: do {
      var tmp0_any_0 = this._get_entries__10();
      var tmp;
      if (isInterface(tmp0_any_0, Collection)) {
        tmp = tmp0_any_0.isEmpty_53();
      } else {
        {
          tmp = false;
        }
      }
      if (tmp) {
        tmp$ret$0 = false;
        break l$ret$1;
      } else {
      }
      var tmp0_iterator_1 = tmp0_any_0.iterator_64();
      while (tmp0_iterator_1.hasNext_31()) {
        var element_2 = tmp0_iterator_1.next_35();
        if (equals_1(element_2._get_value__33(), value)) {
          tmp$ret$0 = true;
          break l$ret$1;
        } else {
        }
      }
      tmp$ret$0 = false;
    }
     while (false);
    return tmp$ret$0;
  };
  AbstractMap.prototype.containsEntry_5 = function (entry) {
    if (!(!(entry == null) ? isInterface(entry, Entry) : false))
      return false;
    else {
    }
    var key = entry._get_key__47();
    var value = entry._get_value__33();
    var ourValue = (isInterface(this, Map_0) ? this : THROW_CCE()).get_63(key);
    if (!equals_1(value, ourValue)) {
      return false;
    }var tmp;
    if (ourValue == null) {
      tmp = !(isInterface(this, Map_0) ? this : THROW_CCE()).containsKey_16(key);
    } else {
      tmp = false;
    }
    if (tmp) {
      return false;
    } else {
    }
    return true;
  };
  AbstractMap.prototype.equals = function (other) {
    if (other === this)
      return true;
    if (!(!(other == null) ? isInterface(other, Map_0) : false))
      return false;
    else {
    }
    if (!(this._get_size__45() === other._get_size__45()))
      return false;
    var tmp$ret$0;
    l$ret$1: do {
      var tmp0_all_0 = other._get_entries__10();
      var tmp;
      if (isInterface(tmp0_all_0, Collection)) {
        tmp = tmp0_all_0.isEmpty_53();
      } else {
        {
          tmp = false;
        }
      }
      if (tmp) {
        tmp$ret$0 = true;
        break l$ret$1;
      } else {
      }
      var tmp0_iterator_1 = tmp0_all_0.iterator_64();
      while (tmp0_iterator_1.hasNext_31()) {
        var element_2 = tmp0_iterator_1.next_35();
        if (!this.containsEntry_5(element_2)) {
          tmp$ret$0 = false;
          break l$ret$1;
        } else {
        }
      }
      tmp$ret$0 = true;
    }
     while (false);
    return tmp$ret$0;
  };
  AbstractMap.prototype.get_63 = function (key) {
    var tmp0_safe_receiver = implFindEntry(this, key);
    return tmp0_safe_receiver == null ? null : tmp0_safe_receiver._get_value__33();
  };
  AbstractMap.prototype.hashCode = function () {
    return hashCode(this._get_entries__10());
  };
  AbstractMap.prototype.isEmpty_53 = function () {
    return this._get_size__45() === 0;
  };
  AbstractMap.prototype._get_size__45 = function () {
    return this._get_entries__10()._get_size__45();
  };
  AbstractMap.prototype._get_keys__10 = function () {
    if (this.__keys == null) {
      var tmp = this;
      tmp.__keys = new _no_name_provided__5(this);
    }return ensureNotNull(this.__keys);
  };
  AbstractMap.prototype.toString = function () {
    var tmp = this._get_entries__10();
    return joinToString$default_0(tmp, ', ', '{', '}', 0, null, _no_name_provided_$factory_2(this), 24, null);
  };
  AbstractMap.prototype.toString_0 = function (entry) {
    return toString(this, entry._get_key__47()) + '=' + toString(this, entry._get_value__33());
  };
  AbstractMap.prototype._get_values__16 = function () {
    if (this.__values == null) {
      var tmp = this;
      tmp.__values = new _no_name_provided__7(this);
    }return ensureNotNull(this.__values);
  };
  AbstractMap.$metadata$ = {
    simpleName: 'AbstractMap',
    kind: 'class',
    interfaces: [Map_0]
  };
  function _no_name_provided_$factory_2(this$0) {
    var i = new _no_name_provided__6(this$0);
    return function (p1) {
      return i.invoke_5(p1);
    };
  }
  function Companion_2() {
    Companion_instance_1 = this;
  }
  Companion_2.prototype.unorderedHashCode = function (c) {
    var hashCode_1 = 0;
    var tmp0_iterator = c.iterator_64();
    while (tmp0_iterator.hasNext_31()) {
      var element = tmp0_iterator.next_35();
      var tmp = hashCode_1;
      var tmp1_safe_receiver = element;
      var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : hashCode(tmp1_safe_receiver);
      hashCode_1 = tmp + (tmp2_elvis_lhs == null ? 0 : tmp2_elvis_lhs) | 0;
    }
    return hashCode_1;
  };
  Companion_2.prototype.setEquals = function (c, other) {
    if (!(c._get_size__45() === other._get_size__45()))
      return false;
    return c.containsAll_38(other);
  };
  Companion_2.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_1;
  function Companion_getInstance_1() {
    if (Companion_instance_1 == null)
      new Companion_2();
    return Companion_instance_1;
  }
  function AbstractSet() {
    Companion_getInstance_1();
    AbstractCollection.call(this);
  }
  AbstractSet.prototype.equals = function (other) {
    if (other === this)
      return true;
    if (!(!(other == null) ? isInterface(other, Set) : false))
      return false;
    else {
    }
    return Companion_getInstance_1().setEquals(this, other);
  };
  AbstractSet.prototype.hashCode = function () {
    return Companion_getInstance_1().unorderedHashCode(this);
  };
  AbstractSet.$metadata$ = {
    simpleName: 'AbstractSet',
    kind: 'class',
    interfaces: [Set]
  };
  function emptyList() {
    return EmptyList_getInstance();
  }
  function listOf(elements) {
    return elements.length > 0 ? asList(elements) : emptyList();
  }
  function EmptyList() {
    EmptyList_instance = this;
    this._serialVersionUID = new Long(-1478467534, -1720727600);
  }
  EmptyList.prototype.equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, List) : false) {
      tmp = other.isEmpty_53();
    } else {
      {
        tmp = false;
      }
    }
    return tmp;
  };
  EmptyList.prototype.hashCode = function () {
    return 1;
  };
  EmptyList.prototype.toString = function () {
    return '[]';
  };
  EmptyList.prototype._get_size__45 = function () {
    return 0;
  };
  EmptyList.prototype.isEmpty_53 = function () {
    return true;
  };
  EmptyList.prototype.contains_10 = function (element) {
    return false;
  };
  EmptyList.prototype.contains_51 = function (element) {
    if (!false)
      return false;
    else {
    }
    var tmp;
    if (false) {
      tmp = element;
    } else {
      {
        tmp = THROW_CCE();
      }
    }
    return this.contains_10(tmp);
  };
  EmptyList.prototype.containsAll_7 = function (elements) {
    return elements.isEmpty_53();
  };
  EmptyList.prototype.containsAll_38 = function (elements) {
    return this.containsAll_7(elements);
  };
  EmptyList.prototype.get_80 = function (index) {
    throw IndexOutOfBoundsException_init_$Create$_0('' + "Empty list doesn't contain element at index " + index + '.');
  };
  EmptyList.prototype.iterator_64 = function () {
    return EmptyIterator_getInstance();
  };
  EmptyList.$metadata$ = {
    simpleName: 'EmptyList',
    kind: 'object',
    interfaces: [List, Serializable, RandomAccess]
  };
  var EmptyList_instance;
  function EmptyList_getInstance() {
    if (EmptyList_instance == null)
      new EmptyList();
    return EmptyList_instance;
  }
  function EmptyIterator() {
    EmptyIterator_instance = this;
  }
  EmptyIterator.prototype.hasNext_31 = function () {
    return false;
  };
  EmptyIterator.prototype.next_35 = function () {
    throw NoSuchElementException_init_$Create$();
  };
  EmptyIterator.$metadata$ = {
    simpleName: 'EmptyIterator',
    kind: 'object',
    interfaces: [ListIterator]
  };
  var EmptyIterator_instance;
  function EmptyIterator_getInstance() {
    if (EmptyIterator_instance == null)
      new EmptyIterator();
    return EmptyIterator_instance;
  }
  function asCollection(_this_) {
    return new ArrayAsCollection(_this_, false);
  }
  function _get_lastIndex__0(_this_) {
    return _this_._get_size__45() - 1 | 0;
  }
  function optimizeReadOnlyList(_this_) {
    var tmp0_subject = _this_._get_size__45();
    switch (tmp0_subject) {
      case 0:
        return emptyList();
      case 1:
        return listOf_0(_this_.get_80(0));
      default:return _this_;
    }
  }
  function arrayListOf(elements) {
    return elements.length === 0 ? ArrayList_init_$Create$() : ArrayList_init_$Create$_1(new ArrayAsCollection(elements, true));
  }
  function throwIndexOverflow() {
    throw ArithmeticException_init_$Create$('Index overflow has happened.');
  }
  function _get_indices__0(_this_) {
    return numberRangeToNumber(0, _this_._get_size__45() - 1 | 0);
  }
  function ArrayAsCollection(values_5, isVarargs) {
    this._values = values_5;
    this._isVarargs = isVarargs;
  }
  ArrayAsCollection.prototype._get_size__45 = function () {
    return this._values.length;
  };
  ArrayAsCollection.prototype.isEmpty_53 = function () {
    var tmp0_isEmpty_0 = this._values;
    return tmp0_isEmpty_0.length === 0;
  };
  ArrayAsCollection.prototype.contains_42 = function (element) {
    return contains(this._values, element);
  };
  ArrayAsCollection.prototype.contains_51 = function (element) {
    if (!(element == null ? true : isObject(element)))
      return false;
    else {
    }
    return this.contains_42((element == null ? true : isObject(element)) ? element : THROW_CCE());
  };
  ArrayAsCollection.prototype.containsAll_29 = function (elements) {
    var tmp$ret$0;
    l$ret$1: do {
      var tmp;
      if (isInterface(elements, Collection)) {
        tmp = elements.isEmpty_53();
      } else {
        {
          tmp = false;
        }
      }
      if (tmp) {
        tmp$ret$0 = true;
        break l$ret$1;
      } else {
      }
      var tmp0_iterator_1 = elements.iterator_64();
      while (tmp0_iterator_1.hasNext_31()) {
        var element_2 = tmp0_iterator_1.next_35();
        if (!this.contains_42(element_2)) {
          tmp$ret$0 = false;
          break l$ret$1;
        } else {
        }
      }
      tmp$ret$0 = true;
    }
     while (false);
    return tmp$ret$0;
  };
  ArrayAsCollection.prototype.containsAll_38 = function (elements) {
    return this.containsAll_29(elements);
  };
  ArrayAsCollection.prototype.iterator_64 = function () {
    return arrayIterator(this._values);
  };
  ArrayAsCollection.$metadata$ = {
    simpleName: 'ArrayAsCollection',
    kind: 'class',
    interfaces: [Collection]
  };
  function mutableListOf(elements) {
    return elements.length === 0 ? ArrayList_init_$Create$() : ArrayList_init_$Create$_1(new ArrayAsCollection(elements, true));
  }
  function IndexedValue(index, value) {
    this._index = index;
    this._value = value;
  }
  IndexedValue.prototype.toString = function () {
    return '' + 'IndexedValue(index=' + this._index + ', value=' + this._value + ')';
  };
  IndexedValue.prototype.hashCode = function () {
    var result = this._index;
    result = imul(result, 31) + (this._value == null ? 0 : hashCode(this._value)) | 0;
    return result;
  };
  IndexedValue.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof IndexedValue))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof IndexedValue ? other : THROW_CCE();
    if (!(this._index === tmp0_other_with_cast._index))
      return false;
    if (!equals_1(this._value, tmp0_other_with_cast._value))
      return false;
    return true;
  };
  IndexedValue.$metadata$ = {
    simpleName: 'IndexedValue',
    kind: 'class',
    interfaces: []
  };
  function IndexingIterable(iteratorFactory) {
    this._iteratorFactory = iteratorFactory;
  }
  IndexingIterable.prototype.iterator_64 = function () {
    return new IndexingIterator(this._iteratorFactory());
  };
  IndexingIterable.$metadata$ = {
    simpleName: 'IndexingIterable',
    kind: 'class',
    interfaces: [Iterable]
  };
  function collectionSizeOrDefault(_this_, default_0) {
    var tmp;
    if (isInterface(_this_, Collection)) {
      tmp = _this_._get_size__45();
    } else {
      {
        tmp = default_0;
      }
    }
    return tmp;
  }
  function collectionSizeOrNull(_this_) {
    var tmp;
    if (isInterface(_this_, Collection)) {
      tmp = _this_._get_size__45();
    } else {
      {
        tmp = null;
      }
    }
    return tmp;
  }
  function IndexingIterator(iterator_0) {
    this._iterator = iterator_0;
    this._index_0 = 0;
  }
  IndexingIterator.prototype.hasNext_31 = function () {
    return this._iterator.hasNext_31();
  };
  IndexingIterator.prototype.next_35 = function () {
    var tmp0_this = this;
    var tmp1 = tmp0_this._index_0;
    tmp0_this._index_0 = tmp1 + 1 | 0;
    return new IndexedValue(checkIndexOverflow(tmp1), this._iterator.next_35());
  };
  IndexingIterator.$metadata$ = {
    simpleName: 'IndexingIterator',
    kind: 'class',
    interfaces: [Iterator]
  };
  function getOrImplicitDefault(_this_, key) {
    if (isInterface(_this_, MapWithDefault))
      return _this_.getOrImplicitDefault(key);
    else {
    }
    var tmp$ret$0;
    l$ret$1: do {
      var value_1 = _this_.get_63(key);
      if (value_1 == null ? !_this_.containsKey_16(key) : false) {
        throw NoSuchElementException_init_$Create$_0('' + 'Key ' + key + ' is missing in the map.');
      } else {
        tmp$ret$0 = (value_1 == null ? true : isObject(value_1)) ? value_1 : THROW_CCE();
        break l$ret$1;
      }
    }
     while (false);
    return tmp$ret$0;
  }
  function MapWithDefault() {
  }
  MapWithDefault.$metadata$ = {
    simpleName: 'MapWithDefault',
    kind: 'interface',
    interfaces: [Map_0]
  };
  function mapOf(pairs) {
    return pairs.length > 0 ? toMap_0(pairs, LinkedHashMap_init_$Create$_1(mapCapacity(pairs.length))) : emptyMap();
  }
  function emptyMap() {
    var tmp = EmptyMap_getInstance();
    return isInterface(tmp, Map_0) ? tmp : THROW_CCE();
  }
  function toMap(_this_) {
    if (isInterface(_this_, Collection)) {
      var tmp0_subject = _this_._get_size__45();
      var tmp;
      switch (tmp0_subject) {
        case 0:
          tmp = emptyMap();
          break;
        case 1:
          var tmp_0;
          if (isInterface(_this_, List)) {
            tmp_0 = _this_.get_80(0);
          } else {
            {
              tmp_0 = _this_.iterator_64().next_35();
            }
          }

          tmp = mapOf_0(tmp_0);
          break;
        default:tmp = toMap_1(_this_, LinkedHashMap_init_$Create$_1(mapCapacity(_this_._get_size__45())));
          break;
      }
      return tmp;
    } else {
    }
    return optimizeReadOnlyMap(toMap_1(_this_, LinkedHashMap_init_$Create$()));
  }
  function toMutableMap(_this_) {
    return LinkedHashMap_init_$Create$_2(_this_);
  }
  function toMap_0(_this_, destination) {
    putAll(destination, _this_);
    return destination;
  }
  function EmptyMap() {
    EmptyMap_instance = this;
    this._serialVersionUID_0 = new Long(-888910638, 1920087921);
  }
  EmptyMap.prototype.equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, Map_0) : false) {
      tmp = other.isEmpty_53();
    } else {
      {
        tmp = false;
      }
    }
    return tmp;
  };
  EmptyMap.prototype.hashCode = function () {
    return 0;
  };
  EmptyMap.prototype.toString = function () {
    return '{}';
  };
  EmptyMap.prototype._get_size__45 = function () {
    return 0;
  };
  EmptyMap.prototype.isEmpty_53 = function () {
    return true;
  };
  EmptyMap.prototype.containsKey_0 = function (key) {
    return false;
  };
  EmptyMap.prototype.containsKey_16 = function (key) {
    if (!(key == null ? true : isObject(key)))
      return false;
    else {
    }
    return this.containsKey_0((key == null ? true : isObject(key)) ? key : THROW_CCE());
  };
  EmptyMap.prototype.get_2 = function (key) {
    return null;
  };
  EmptyMap.prototype.get_63 = function (key) {
    if (!(key == null ? true : isObject(key)))
      return null;
    else {
    }
    return this.get_2((key == null ? true : isObject(key)) ? key : THROW_CCE());
  };
  EmptyMap.prototype._get_entries__10 = function () {
    return EmptySet_getInstance();
  };
  EmptyMap.prototype._get_keys__10 = function () {
    return EmptySet_getInstance();
  };
  EmptyMap.prototype._get_values__16 = function () {
    return EmptyList_getInstance();
  };
  EmptyMap.$metadata$ = {
    simpleName: 'EmptyMap',
    kind: 'object',
    interfaces: [Map_0, Serializable]
  };
  var EmptyMap_instance;
  function EmptyMap_getInstance() {
    if (EmptyMap_instance == null)
      new EmptyMap();
    return EmptyMap_instance;
  }
  function toMap_1(_this_, destination) {
    putAll_0(destination, _this_);
    return destination;
  }
  function optimizeReadOnlyMap(_this_) {
    var tmp0_subject = _this_._get_size__45();
    var tmp;
    switch (tmp0_subject) {
      case 0:
        tmp = emptyMap();
        break;
      case 1:
        tmp = _this_;
        break;
      default:tmp = _this_;
        break;
    }
    return tmp;
  }
  function putAll(_this_, pairs) {
    var indexedObject = pairs;
    var inductionVariable = 0;
    var last_1 = indexedObject.length;
    while (inductionVariable < last_1) {
      var tmp1_loop_parameter = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      var key = tmp1_loop_parameter.component1_4();
      var value = tmp1_loop_parameter.component2_4();
      _this_.put_12(key, value);
      Unit_getInstance();
    }
  }
  function putAll_0(_this_, pairs) {
    var tmp0_iterator = pairs.iterator_64();
    while (tmp0_iterator.hasNext_31()) {
      var tmp1_loop_parameter = tmp0_iterator.next_35();
      var key = tmp1_loop_parameter.component1_4();
      var value = tmp1_loop_parameter.component2_4();
      _this_.put_12(key, value);
      Unit_getInstance();
    }
  }
  function hashMapOf(pairs) {
    var tmp0_apply_0 = HashMap_init_$Create$_1(mapCapacity(pairs.length));
    putAll(tmp0_apply_0, pairs);
    return tmp0_apply_0;
  }
  function getValue(_this_, key) {
    return getOrImplicitDefault(_this_, key);
  }
  function toMap_2(_this_) {
    var tmp0_subject = _this_._get_size__45();
    var tmp;
    switch (tmp0_subject) {
      case 0:
        tmp = emptyMap();
        break;
      case 1:
        tmp = toMutableMap(_this_);
        break;
      default:tmp = toMutableMap(_this_);
        break;
    }
    return tmp;
  }
  function addAll(_this_, elements) {
    var tmp0_subject = elements;
    if (isInterface(tmp0_subject, Collection))
      return _this_.addAll_23(elements);
    else {
      {
        var result = false;
        var tmp1_iterator = elements.iterator_64();
        while (tmp1_iterator.hasNext_31()) {
          var item = tmp1_iterator.next_35();
          if (_this_.add_33(item))
            result = true;
        }
        return result;
      }
    }
  }
  function filterInPlace(_this_, predicate, predicateResultToRemove) {
    var result = false;
    var tmp0_with_0 = _this_.iterator_64();
    while (tmp0_with_0.hasNext_31())
      if (predicate(tmp0_with_0.next_35()) === predicateResultToRemove) {
        tmp0_with_0.remove_51();
        result = true;
      }return result;
  }
  function removeAll(_this_, predicate) {
    return filterInPlace(_this_, predicate, true);
  }
  function addAll_0(_this_, elements) {
    return _this_.addAll_23(asList(elements));
  }
  function Sequence() {
  }
  Sequence.$metadata$ = {
    simpleName: 'Sequence',
    kind: 'interface',
    interfaces: []
  };
  function generateSequence(seedFunction, nextFunction) {
    return new GeneratorSequence(seedFunction, nextFunction);
  }
  function _no_name_provided__8(this$0) {
    this._this$0_3 = this$0;
    this._iterator_0 = this._this$0_3._sequence.iterator_64();
  }
  _no_name_provided__8.prototype.next_35 = function () {
    return this._this$0_3._transformer(this._iterator_0.next_35());
  };
  _no_name_provided__8.prototype.hasNext_31 = function () {
    return this._iterator_0.hasNext_31();
  };
  _no_name_provided__8.$metadata$ = {
    kind: 'class',
    interfaces: [Iterator]
  };
  function TransformingSequence(sequence, transformer) {
    this._sequence = sequence;
    this._transformer = transformer;
  }
  TransformingSequence.prototype.iterator_64 = function () {
    return new _no_name_provided__8(this);
  };
  TransformingSequence.$metadata$ = {
    simpleName: 'TransformingSequence',
    kind: 'class',
    interfaces: [Sequence]
  };
  function calcNext($this) {
    while ($this._iterator_1.hasNext_31()) {
      var item = $this._iterator_1.next_35();
      if ($this._this$0_4._predicate(item) === $this._this$0_4._sendWhen) {
        $this._nextItem = item;
        $this._nextState = 1;
        return Unit_getInstance();
      }}
    $this._nextState = 0;
  }
  function _no_name_provided__9(this$0) {
    this._this$0_4 = this$0;
    this._iterator_1 = this._this$0_4._sequence_0.iterator_64();
    this._nextState = -1;
    this._nextItem = null;
  }
  _no_name_provided__9.prototype.next_35 = function () {
    if (this._nextState === -1)
      calcNext(this);
    if (this._nextState === 0)
      throw NoSuchElementException_init_$Create$();
    var result = this._nextItem;
    this._nextItem = null;
    this._nextState = -1;
    return (result == null ? true : isObject(result)) ? result : THROW_CCE();
  };
  _no_name_provided__9.prototype.hasNext_31 = function () {
    if (this._nextState === -1)
      calcNext(this);
    return this._nextState === 1;
  };
  _no_name_provided__9.$metadata$ = {
    kind: 'class',
    interfaces: [Iterator]
  };
  function FilteringSequence(sequence, sendWhen, predicate) {
    this._sequence_0 = sequence;
    this._sendWhen = sendWhen;
    this._predicate = predicate;
  }
  FilteringSequence.prototype.iterator_64 = function () {
    return new _no_name_provided__9(this);
  };
  FilteringSequence.$metadata$ = {
    simpleName: 'FilteringSequence',
    kind: 'class',
    interfaces: [Sequence]
  };
  function calcNext_0($this) {
    $this._nextItem_0 = $this._nextState_0 === -2 ? $this._this$0_5._getInitialValue() : $this._this$0_5._getNextValue(ensureNotNull($this._nextItem_0));
    $this._nextState_0 = $this._nextItem_0 == null ? 0 : 1;
  }
  function _no_name_provided__10(this$0) {
    this._this$0_5 = this$0;
    this._nextItem_0 = null;
    this._nextState_0 = -2;
  }
  _no_name_provided__10.prototype.next_35 = function () {
    if (this._nextState_0 < 0)
      calcNext_0(this);
    if (this._nextState_0 === 0)
      throw NoSuchElementException_init_$Create$();
    var tmp = this._nextItem_0;
    var result = isObject(tmp) ? tmp : THROW_CCE();
    this._nextState_0 = -1;
    return result;
  };
  _no_name_provided__10.prototype.hasNext_31 = function () {
    if (this._nextState_0 < 0)
      calcNext_0(this);
    return this._nextState_0 === 1;
  };
  _no_name_provided__10.$metadata$ = {
    kind: 'class',
    interfaces: [Iterator]
  };
  function GeneratorSequence(getInitialValue, getNextValue) {
    this._getInitialValue = getInitialValue;
    this._getNextValue = getNextValue;
  }
  GeneratorSequence.prototype.iterator_64 = function () {
    return new _no_name_provided__10(this);
  };
  GeneratorSequence.$metadata$ = {
    simpleName: 'GeneratorSequence',
    kind: 'class',
    interfaces: [Sequence]
  };
  function setOf(elements) {
    return elements.length > 0 ? toSet(elements) : emptySet();
  }
  function emptySet() {
    return EmptySet_getInstance();
  }
  function EmptySet() {
    EmptySet_instance = this;
    this._serialVersionUID_1 = new Long(1993859828, 793161749);
  }
  EmptySet.prototype.equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, Set) : false) {
      tmp = other.isEmpty_53();
    } else {
      {
        tmp = false;
      }
    }
    return tmp;
  };
  EmptySet.prototype.hashCode = function () {
    return 0;
  };
  EmptySet.prototype.toString = function () {
    return '[]';
  };
  EmptySet.prototype._get_size__45 = function () {
    return 0;
  };
  EmptySet.prototype.isEmpty_53 = function () {
    return true;
  };
  EmptySet.prototype.contains_10 = function (element) {
    return false;
  };
  EmptySet.prototype.contains_51 = function (element) {
    if (!false)
      return false;
    else {
    }
    var tmp;
    if (false) {
      tmp = element;
    } else {
      {
        tmp = THROW_CCE();
      }
    }
    return this.contains_10(tmp);
  };
  EmptySet.prototype.containsAll_7 = function (elements) {
    return elements.isEmpty_53();
  };
  EmptySet.prototype.containsAll_38 = function (elements) {
    return this.containsAll_7(elements);
  };
  EmptySet.prototype.iterator_64 = function () {
    return EmptyIterator_getInstance();
  };
  EmptySet.$metadata$ = {
    simpleName: 'EmptySet',
    kind: 'object',
    interfaces: [Set, Serializable]
  };
  var EmptySet_instance;
  function EmptySet_getInstance() {
    if (EmptySet_instance == null)
      new EmptySet();
    return EmptySet_instance;
  }
  function optimizeReadOnlySet(_this_) {
    var tmp0_subject = _this_._get_size__45();
    switch (tmp0_subject) {
      case 0:
        return emptySet();
      case 1:
        return setOf_0(_this_.iterator_64().next_35());
      default:return _this_;
    }
  }
  function hashSetOf(elements) {
    return toCollection(elements, HashSet_init_$Create$_1(mapCapacity(elements.length)));
  }
  function compareValues(a, b) {
    if (a === b)
      return 0;
    if (a == null)
      return -1;
    if (b == null)
      return 1;
    return compareTo((!(a == null) ? isComparable(a) : false) ? a : THROW_CCE(), b);
  }
  function Continuation() {
  }
  Continuation.$metadata$ = {
    simpleName: 'Continuation',
    kind: 'interface',
    interfaces: []
  };
  function startCoroutine(_this_, receiver, completion) {
    var tmp0_resume_0 = intercepted(createCoroutineUnintercepted(_this_, receiver, completion));
    var tmp1_resume_0 = Unit_getInstance();
    var tmp0_success_0_1 = Companion_getInstance_3();
    tmp0_resume_0.resumeWith_34(_Result___init__impl_(Unit_getInstance()));
  }
  function Key() {
    Key_instance = this;
  }
  Key.$metadata$ = {
    simpleName: 'Key',
    kind: 'object',
    interfaces: [Key_0]
  };
  var Key_instance;
  function Key_getInstance() {
    if (Key_instance == null)
      new Key();
    return Key_instance;
  }
  function ContinuationInterceptor() {
  }
  ContinuationInterceptor.prototype.releaseInterceptedContinuation_9 = function (continuation) {
  };
  ContinuationInterceptor.prototype.get_70 = function (key) {
    if (key instanceof AbstractCoroutineContextKey) {
      var tmp;
      if (key.isSubKey_0(this._get_key__47())) {
        var tmp_0 = key.tryCast_0(this);
        tmp = (!(tmp_0 == null) ? isInterface(tmp_0, Element_0) : false) ? tmp_0 : null;
      } else {
        tmp = null;
      }
      return tmp;
    } else {
    }
    var tmp_1;
    if (Key_getInstance() === key) {
      tmp_1 = isInterface(this, Element_0) ? this : THROW_CCE();
    } else {
      tmp_1 = null;
    }
    return tmp_1;
  };
  ContinuationInterceptor.prototype.minusKey_27 = function (key) {
    if (key instanceof AbstractCoroutineContextKey) {
      return (key.isSubKey_0(this._get_key__47()) ? !(key.tryCast_0(this) == null) : false) ? EmptyCoroutineContext_getInstance() : this;
    } else {
    }
    return Key_getInstance() === key ? EmptyCoroutineContext_getInstance() : this;
  };
  ContinuationInterceptor.$metadata$ = {
    simpleName: 'ContinuationInterceptor',
    kind: 'interface',
    interfaces: [Element_0]
  };
  function Key_0() {
  }
  Key_0.$metadata$ = {
    simpleName: 'Key',
    kind: 'interface',
    interfaces: []
  };
  function Element_0() {
  }
  Element_0.prototype.get_70 = function (key) {
    var tmp;
    if (equals_1(this._get_key__47(), key)) {
      tmp = isInterface(this, Element_0) ? this : THROW_CCE();
    } else {
      tmp = null;
    }
    return tmp;
  };
  Element_0.prototype.fold_26 = function (initial, operation) {
    return operation(initial, this);
  };
  Element_0.prototype.minusKey_27 = function (key) {
    return equals_1(this._get_key__47(), key) ? EmptyCoroutineContext_getInstance() : this;
  };
  Element_0.$metadata$ = {
    simpleName: 'Element',
    kind: 'interface',
    interfaces: [CoroutineContext]
  };
  function _no_name_provided__11() {
  }
  _no_name_provided__11.prototype.invoke_7 = function (acc, element) {
    var removed = acc.minusKey_27(element._get_key__47());
    var tmp;
    if (removed === EmptyCoroutineContext_getInstance()) {
      tmp = element;
    } else {
      var interceptor = removed.get_70(Key_getInstance());
      var tmp_0;
      if (interceptor == null) {
        tmp_0 = new CombinedContext(removed, element);
      } else {
        var left = removed.minusKey_27(Key_getInstance());
        tmp_0 = left === EmptyCoroutineContext_getInstance() ? new CombinedContext(element, interceptor) : new CombinedContext(new CombinedContext(left, element), interceptor);
      }
      tmp = tmp_0;
    }
    return tmp;
  };
  _no_name_provided__11.prototype.invoke_537 = function (p1, p2) {
    var tmp = (!(p1 == null) ? isInterface(p1, CoroutineContext) : false) ? p1 : THROW_CCE();
    return this.invoke_7(tmp, (!(p2 == null) ? isInterface(p2, Element_0) : false) ? p2 : THROW_CCE());
  };
  _no_name_provided__11.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function CoroutineContext() {
  }
  CoroutineContext.prototype.plus_28 = function (context) {
    var tmp;
    if (context === EmptyCoroutineContext_getInstance()) {
      tmp = this;
    } else {
      tmp = context.fold_26(this, _no_name_provided_$factory_3());
    }
    return tmp;
  };
  CoroutineContext.$metadata$ = {
    simpleName: 'CoroutineContext',
    kind: 'interface',
    interfaces: []
  };
  function _no_name_provided_$factory_3() {
    var i = new _no_name_provided__11();
    return function (p1, p2) {
      return i.invoke_7(p1, p2);
    };
  }
  function EmptyCoroutineContext() {
    EmptyCoroutineContext_instance = this;
    this._serialVersionUID_2 = new Long(0, 0);
  }
  EmptyCoroutineContext.prototype.get_70 = function (key) {
    return null;
  };
  EmptyCoroutineContext.prototype.fold_26 = function (initial, operation) {
    return initial;
  };
  EmptyCoroutineContext.prototype.plus_28 = function (context) {
    return context;
  };
  EmptyCoroutineContext.prototype.minusKey_27 = function (key) {
    return this;
  };
  EmptyCoroutineContext.prototype.hashCode = function () {
    return 0;
  };
  EmptyCoroutineContext.prototype.toString = function () {
    return 'EmptyCoroutineContext';
  };
  EmptyCoroutineContext.$metadata$ = {
    simpleName: 'EmptyCoroutineContext',
    kind: 'object',
    interfaces: [CoroutineContext, Serializable]
  };
  var EmptyCoroutineContext_instance;
  function EmptyCoroutineContext_getInstance() {
    if (EmptyCoroutineContext_instance == null)
      new EmptyCoroutineContext();
    return EmptyCoroutineContext_instance;
  }
  function size($this) {
    var cur = $this;
    var size_0 = 2;
    while (true) {
      var tmp = cur._left;
      var tmp0_elvis_lhs = tmp instanceof CombinedContext ? tmp : null;
      var tmp_0;
      if (tmp0_elvis_lhs == null) {
        return size_0;
      } else {
        tmp_0 = tmp0_elvis_lhs;
      }
      cur = tmp_0;
      var tmp1 = size_0;
      size_0 = tmp1 + 1 | 0;
      Unit_getInstance();
    }
  }
  function contains_0($this, element) {
    return equals_1($this.get_70(element._get_key__47()), element);
  }
  function containsAll($this, context) {
    var cur = context;
    while (true) {
      if (!contains_0($this, cur._element))
        return false;
      var next = cur._left;
      if (next instanceof CombinedContext) {
        cur = next;
      } else {
        {
          return contains_0($this, isInterface(next, Element_0) ? next : THROW_CCE());
        }
      }
    }
  }
  function _no_name_provided__12() {
  }
  _no_name_provided__12.prototype.invoke_9 = function (acc, element) {
    var tmp;
    if (charSequenceLength(acc) === 0) {
      tmp = toString_1(element);
    } else {
      {
        tmp = '' + acc + ', ' + element;
      }
    }
    return tmp;
  };
  _no_name_provided__12.prototype.invoke_537 = function (p1, p2) {
    var tmp = (!(p1 == null) ? typeof p1 === 'string' : false) ? p1 : THROW_CCE();
    return this.invoke_9(tmp, (!(p2 == null) ? isInterface(p2, Element_0) : false) ? p2 : THROW_CCE());
  };
  _no_name_provided__12.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function CombinedContext(left, element) {
    this._left = left;
    this._element = element;
  }
  CombinedContext.prototype.get_70 = function (key) {
    var cur = this;
    while (true) {
      var tmp0_safe_receiver = cur._element.get_70(key);
      if (tmp0_safe_receiver == null)
        null;
      else {
        return tmp0_safe_receiver;
      }
      Unit_getInstance();
      var next = cur._left;
      if (next instanceof CombinedContext) {
        cur = next;
      } else {
        {
          return next.get_70(key);
        }
      }
    }
  };
  CombinedContext.prototype.fold_26 = function (initial, operation) {
    return operation(this._left.fold_26(initial, operation), this._element);
  };
  CombinedContext.prototype.minusKey_27 = function (key) {
    var tmp0_safe_receiver = this._element.get_70(key);
    if (tmp0_safe_receiver == null)
      null;
    else {
      return this._left;
    }
    Unit_getInstance();
    var newLeft = this._left.minusKey_27(key);
    return newLeft === this._left ? this : newLeft === EmptyCoroutineContext_getInstance() ? this._element : new CombinedContext(newLeft, this._element);
  };
  CombinedContext.prototype.equals = function (other) {
    var tmp;
    if (this === other) {
      tmp = true;
    } else {
      var tmp_0;
      var tmp_1;
      if (other instanceof CombinedContext) {
        tmp_1 = size(other) === size(this);
      } else {
        {
          tmp_1 = false;
        }
      }
      if (tmp_1) {
        tmp_0 = containsAll(other, this);
      } else {
        {
          tmp_0 = false;
        }
      }
      tmp = tmp_0;
    }
    return tmp;
  };
  CombinedContext.prototype.hashCode = function () {
    return hashCode(this._left) + hashCode(this._element) | 0;
  };
  CombinedContext.prototype.toString = function () {
    return '[' + this.fold_26('', _no_name_provided_$factory_4()) + ']';
  };
  CombinedContext.$metadata$ = {
    simpleName: 'CombinedContext',
    kind: 'class',
    interfaces: [CoroutineContext, Serializable]
  };
  function AbstractCoroutineContextKey(baseKey, safeCast) {
    this._safeCast = safeCast;
    var tmp = this;
    var tmp_0;
    if (baseKey instanceof AbstractCoroutineContextKey) {
      tmp_0 = baseKey._topmostKey;
    } else {
      {
        tmp_0 = baseKey;
      }
    }
    tmp._topmostKey = tmp_0;
  }
  AbstractCoroutineContextKey.prototype.tryCast_0 = function (element) {
    return this._safeCast(element);
  };
  AbstractCoroutineContextKey.prototype.isSubKey_0 = function (key) {
    return key === this ? true : this._topmostKey === key;
  };
  AbstractCoroutineContextKey.$metadata$ = {
    simpleName: 'AbstractCoroutineContextKey',
    kind: 'class',
    interfaces: [Key_0]
  };
  function AbstractCoroutineContextElement(key) {
    this._key = key;
  }
  AbstractCoroutineContextElement.prototype._get_key__47 = function () {
    return this._key;
  };
  AbstractCoroutineContextElement.$metadata$ = {
    simpleName: 'AbstractCoroutineContextElement',
    kind: 'class',
    interfaces: [Element_0]
  };
  function _no_name_provided_$factory_4() {
    var i = new _no_name_provided__12();
    return function (p1, p2) {
      return i.invoke_9(p1, p2);
    };
  }
  function _get_COROUTINE_SUSPENDED_() {
    return CoroutineSingletons_COROUTINE_SUSPENDED_getInstance();
  }
  var CoroutineSingletons_COROUTINE_SUSPENDED_instance;
  var CoroutineSingletons_UNDECIDED_instance;
  var CoroutineSingletons_RESUMED_instance;
  var CoroutineSingletons_entriesInitialized;
  function CoroutineSingletons_initEntries() {
    if (CoroutineSingletons_entriesInitialized)
      return Unit_getInstance();
    CoroutineSingletons_entriesInitialized = true;
    CoroutineSingletons_COROUTINE_SUSPENDED_instance = new CoroutineSingletons('COROUTINE_SUSPENDED', 0);
    CoroutineSingletons_UNDECIDED_instance = new CoroutineSingletons('UNDECIDED', 1);
    CoroutineSingletons_RESUMED_instance = new CoroutineSingletons('RESUMED', 2);
  }
  function CoroutineSingletons(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  CoroutineSingletons.$metadata$ = {
    simpleName: 'CoroutineSingletons',
    kind: 'class',
    interfaces: []
  };
  function CoroutineSingletons_COROUTINE_SUSPENDED_getInstance() {
    CoroutineSingletons_initEntries();
    return CoroutineSingletons_COROUTINE_SUSPENDED_instance;
  }
  function ReadWriteProperty() {
  }
  ReadWriteProperty.$metadata$ = {
    simpleName: 'ReadWriteProperty',
    kind: 'interface',
    interfaces: [ReadOnlyProperty]
  };
  function ReadOnlyProperty() {
  }
  ReadOnlyProperty.$metadata$ = {
    simpleName: 'ReadOnlyProperty',
    kind: 'interface',
    interfaces: []
  };
  function Default() {
    Default_instance = this;
    Random.call(this);
    this._defaultRandom = defaultPlatformRandom();
  }
  Default.prototype.nextBits_1 = function (bitCount) {
    return this._defaultRandom.nextBits_1(bitCount);
  };
  Default.prototype.nextInt_3 = function () {
    return this._defaultRandom.nextInt_3();
  };
  Default.prototype.nextLong_3 = function () {
    return this._defaultRandom.nextLong_3();
  };
  Default.prototype.nextLong_4 = function (from, until_0) {
    return this._defaultRandom.nextLong_4(from, until_0);
  };
  Default.$metadata$ = {
    simpleName: 'Default',
    kind: 'object',
    interfaces: []
  };
  var Default_instance;
  function Default_getInstance() {
    if (Default_instance == null)
      new Default();
    return Default_instance;
  }
  function Random() {
    Default_getInstance();
  }
  Random.prototype.nextInt_3 = function () {
    return this.nextBits_1(32);
  };
  Random.prototype.nextLong_3 = function () {
    var tmp0_plus_0 = toLong_0(this.nextInt_3()).shl_0(32);
    var tmp1_plus_0 = this.nextInt_3();
    return tmp0_plus_0.plus_56(toLong_0(tmp1_plus_0));
  };
  Random.prototype.nextLong_4 = function (from, until_0) {
    checkRangeBounds(from, until_0);
    var n = until_0.minus_29(from);
    if (n.compareTo_69(new Long(0, 0)) > 0) {
      var rnd;
      if (n.and(n.unaryMinus_4()).equals(n)) {
        var nLow = n.toInt_5();
        var nHigh = n.ushr_0(32).toInt_5();
        var tmp;
        if (!(nLow === 0)) {
          var bitCount = fastLog2(nLow);
          tmp = toLong_0(this.nextBits_1(bitCount)).and(new Long(-1, 0));
        } else if (nHigh === 1) {
          tmp = toLong_0(this.nextInt_3()).and(new Long(-1, 0));
        } else {
          var bitCount_0 = fastLog2(nHigh);
          var tmp0_plus_0 = toLong_0(this.nextBits_1(bitCount_0)).shl_0(32);
          var tmp1_plus_0 = this.nextInt_3();
          tmp = tmp0_plus_0.plus_56(toLong_0(tmp1_plus_0));
        }
        rnd = tmp;
      } else {
        var v;
        $l$1: do {
          $l$0: do {
            var bits = this.nextLong_3().ushr_0(1);
            v = bits.rem_27(n);
          }
           while (false);
          var tmp_0 = bits.minus_29(v);
          var tmp2_minus_0 = 1;
        }
         while (tmp_0.plus_56(n.minus_29(toLong_0(tmp2_minus_0))).compareTo_69(new Long(0, 0)) < 0);
        rnd = v;
      }
      return from.plus_56(rnd);
    } else {
      while (true) {
        var rnd_0 = this.nextLong_3();
        if (from.compareTo_69(rnd_0) <= 0 ? rnd_0.compareTo_69(until_0) < 0 : false)
          return rnd_0;
      }
    }
  };
  Random.$metadata$ = {
    simpleName: 'Random',
    kind: 'class',
    interfaces: []
  };
  function fastLog2(value) {
    return 31 - Math.clz32(value) | 0;
  }
  function checkRangeBounds(from, until_0) {
    var tmp0_require_0 = until_0.compareTo_69(from) > 0;
    var tmp;
    if (!tmp0_require_0) {
      var message_2 = boundsErrorMessage(from, until_0);
      throw IllegalArgumentException_init_$Create$_0(toString_1(message_2));
    }return tmp;
  }
  function boundsErrorMessage(from, until_0) {
    return '' + 'Random range is empty: [' + from + ', ' + until_0 + ').';
  }
  function Random_0(seed) {
    return XorWowRandom_init_$Create$(seed, seed >> 31);
  }
  function takeUpperBits(_this_, bitCount) {
    return _this_ >>> (32 - bitCount | 0) & (-bitCount | 0) >> 31;
  }
  function XorWowRandom_init_$Init$(seed1, seed2, $this) {
    XorWowRandom.call($this, seed1, seed2, 0, 0, ~seed1, seed1 << 10 ^ seed2 >>> 4);
    return $this;
  }
  function XorWowRandom_init_$Create$(seed1, seed2) {
    return XorWowRandom_init_$Init$(seed1, seed2, Object.create(XorWowRandom.prototype));
  }
  function XorWowRandom(x, y, z, w, v, addend) {
    Random.call(this);
    this._x = x;
    this._y = y;
    this._z = z;
    this._w = w;
    this._v = v;
    this._addend = addend;
    var tmp0_require_0 = !((this._x | this._y | this._z | this._w | this._v) === 0);
    if (!tmp0_require_0) {
      var message_2 = 'Initial state must have at least one non-zero element.';
      throw IllegalArgumentException_init_$Create$_0(toString_1(message_2));
    }var tmp1_repeat_0 = 64;
    var inductionVariable = 0;
    if (inductionVariable < tmp1_repeat_0)
      do {
        var index_3 = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        this.nextInt_3();
        Unit_getInstance();
      }
       while (inductionVariable < tmp1_repeat_0);
  }
  XorWowRandom.prototype.nextInt_3 = function () {
    var t = this._x;
    t = t ^ t >>> 2;
    this._x = this._y;
    this._y = this._z;
    this._z = this._w;
    var v0 = this._v;
    this._w = v0;
    t = t ^ t << 1 ^ v0 ^ v0 << 4;
    this._v = t;
    var tmp0_this = this;
    tmp0_this._addend = tmp0_this._addend + 362437 | 0;
    return t + this._addend | 0;
  };
  XorWowRandom.prototype.nextBits_1 = function (bitCount) {
    return takeUpperBits(this.nextInt_3(), bitCount);
  };
  XorWowRandom.$metadata$ = {
    simpleName: 'XorWowRandom',
    kind: 'class',
    interfaces: []
  };
  function ClosedFloatingPointRange() {
  }
  ClosedFloatingPointRange.prototype.contains_42 = function (value) {
    return this.lessThanOrEquals_1(this._get_start__1(), value) ? this.lessThanOrEquals_1(value, this._get_endInclusive__1()) : false;
  };
  ClosedFloatingPointRange.$metadata$ = {
    simpleName: 'ClosedFloatingPointRange',
    kind: 'interface',
    interfaces: [ClosedRange]
  };
  function rangeTo(_this_, that) {
    return new ClosedDoubleRange(_this_, that);
  }
  function checkStepIsPositive(isPositive, step_0) {
    if (!isPositive)
      throw IllegalArgumentException_init_$Create$_0('' + 'Step must be positive, was: ' + step_0 + '.');
  }
  function ClosedDoubleRange(start, endInclusive) {
    this.__start = start;
    this.__endInclusive = endInclusive;
  }
  ClosedDoubleRange.prototype._get_start__1 = function () {
    return this.__start;
  };
  ClosedDoubleRange.prototype._get_endInclusive__1 = function () {
    return this.__endInclusive;
  };
  ClosedDoubleRange.prototype.lessThanOrEquals_0 = function (a, b) {
    return a <= b;
  };
  ClosedDoubleRange.prototype.lessThanOrEquals_1 = function (a, b) {
    var tmp = typeof a === 'number' ? a : THROW_CCE();
    return this.lessThanOrEquals_0(tmp, typeof b === 'number' ? b : THROW_CCE());
  };
  ClosedDoubleRange.prototype.contains_13 = function (value) {
    return value >= this.__start ? value <= this.__endInclusive : false;
  };
  ClosedDoubleRange.prototype.contains_42 = function (value) {
    return this.contains_13(typeof value === 'number' ? value : THROW_CCE());
  };
  ClosedDoubleRange.prototype.isEmpty_53 = function () {
    return !(this.__start <= this.__endInclusive);
  };
  ClosedDoubleRange.prototype.equals = function (other) {
    var tmp;
    if (other instanceof ClosedDoubleRange) {
      tmp = (this.isEmpty_53() ? other.isEmpty_53() : false) ? true : this.__start === other.__start ? this.__endInclusive === other.__endInclusive : false;
    } else {
      {
        tmp = false;
      }
    }
    return tmp;
  };
  ClosedDoubleRange.prototype.hashCode = function () {
    return this.isEmpty_53() ? -1 : imul(31, getNumberHashCode(this.__start)) + getNumberHashCode(this.__endInclusive) | 0;
  };
  ClosedDoubleRange.prototype.toString = function () {
    return '' + this.__start + '..' + this.__endInclusive;
  };
  ClosedDoubleRange.$metadata$ = {
    simpleName: 'ClosedDoubleRange',
    kind: 'class',
    interfaces: [ClosedFloatingPointRange]
  };
  function KClassifier() {
  }
  KClassifier.$metadata$ = {
    simpleName: 'KClassifier',
    kind: 'interface',
    interfaces: []
  };
  function Companion_3() {
    Companion_instance_2 = this;
    this._star = new KTypeProjection(null, null);
  }
  Companion_3.prototype.invariant = function (type) {
    return new KTypeProjection(KVariance_INVARIANT_getInstance(), type);
  };
  Companion_3.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_2;
  function Companion_getInstance_2() {
    if (Companion_instance_2 == null)
      new Companion_3();
    return Companion_instance_2;
  }
  function KTypeProjection(variance, type) {
    Companion_getInstance_2();
    this._variance = variance;
    this._type = type;
    var tmp0_require_0 = this._variance == null === (this._type == null);
    if (!tmp0_require_0) {
      var message_2 = this._variance == null ? 'Star projection must have no type specified.' : '' + 'The projection variance ' + this._variance + ' requires type to be specified.';
      throw IllegalArgumentException_init_$Create$_0(toString_1(message_2));
    }}
  KTypeProjection.prototype.toString = function () {
    var tmp0_subject = this._variance;
    var tmp;
    if (tmp0_subject == null) {
      tmp = '*';
    } else if (equals_1(tmp0_subject, KVariance_INVARIANT_getInstance())) {
      tmp = toString_0(this._type);
    } else if (equals_1(tmp0_subject, KVariance_IN_getInstance())) {
      tmp = '' + 'in ' + this._type;
    } else if (equals_1(tmp0_subject, KVariance_OUT_getInstance())) {
      tmp = '' + 'out ' + this._type;
    } else {
      noWhenBranchMatchedException();
    }
    return tmp;
  };
  KTypeProjection.prototype.hashCode = function () {
    var result = this._variance == null ? 0 : this._variance.hashCode();
    result = imul(result, 31) + (this._type == null ? 0 : hashCode(this._type)) | 0;
    return result;
  };
  KTypeProjection.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof KTypeProjection))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof KTypeProjection ? other : THROW_CCE();
    if (!equals_1(this._variance, tmp0_other_with_cast._variance))
      return false;
    if (!equals_1(this._type, tmp0_other_with_cast._type))
      return false;
    return true;
  };
  KTypeProjection.$metadata$ = {
    simpleName: 'KTypeProjection',
    kind: 'class',
    interfaces: []
  };
  var KVariance_INVARIANT_instance;
  var KVariance_IN_instance;
  var KVariance_OUT_instance;
  var KVariance_entriesInitialized;
  function KVariance_initEntries() {
    if (KVariance_entriesInitialized)
      return Unit_getInstance();
    KVariance_entriesInitialized = true;
    KVariance_INVARIANT_instance = new KVariance('INVARIANT', 0);
    KVariance_IN_instance = new KVariance('IN', 1);
    KVariance_OUT_instance = new KVariance('OUT', 2);
  }
  function KVariance(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  KVariance.$metadata$ = {
    simpleName: 'KVariance',
    kind: 'class',
    interfaces: []
  };
  function KVariance_INVARIANT_getInstance() {
    KVariance_initEntries();
    return KVariance_INVARIANT_instance;
  }
  function KVariance_IN_getInstance() {
    KVariance_initEntries();
    return KVariance_IN_instance;
  }
  function KVariance_OUT_getInstance() {
    KVariance_initEntries();
    return KVariance_OUT_instance;
  }
  function appendElement(_this_, element, transform_0) {
    if (!(transform_0 == null)) {
      _this_.append_31(transform_0(element));
      Unit_getInstance();
    } else {
      if (element == null ? true : isCharSequence(element)) {
        _this_.append_31(element);
        Unit_getInstance();
      } else {
        if (element instanceof Char) {
          _this_.append_32(element);
          Unit_getInstance();
        } else {
          {
            _this_.append_31(toString_0(element));
            Unit_getInstance();
          }
        }
      }
    }
  }
  function equals(_this_, other, ignoreCase) {
    if (_this_.equals(other))
      return true;
    if (!ignoreCase)
      return false;
    if (uppercaseChar(_this_).equals(uppercaseChar(other)))
      return true;
    var tmp0_asDynamic_0 = _this_.toString();
    var tmp1_unsafeCast_0 = tmp0_asDynamic_0.toLowerCase().charCodeAt(0);
    var tmp = numberToChar(tmp1_unsafeCast_0);
    var tmp2_asDynamic_0 = other.toString();
    var tmp3_unsafeCast_0 = tmp2_asDynamic_0.toLowerCase().charCodeAt(0);
    if (tmp.equals(numberToChar(tmp3_unsafeCast_0)))
      return true;
    else {
    }
    return false;
  }
  function isSurrogate(_this_) {
    var containsLower = new Char(55296);
    return _this_ <= new Char(57343) ? containsLower <= _this_ : false;
  }
  function trimMargin(_this_, marginPrefix) {
    return replaceIndentByMargin(_this_, '', marginPrefix);
  }
  function trimMargin$default(_this_, marginPrefix, $mask0, $handler) {
    if (!(($mask0 & 1) === 0))
      marginPrefix = '|';
    return trimMargin(_this_, marginPrefix);
  }
  function replaceIndentByMargin(_this_, newIndent, marginPrefix) {
    var tmp0_require_0 = !isBlank(marginPrefix);
    if (!tmp0_require_0) {
      var message_2 = 'marginPrefix must be non-blank string.';
      throw IllegalArgumentException_init_$Create$_0(toString_1(message_2));
    }var lines_0 = lines(_this_);
    var tmp1_reindent_0 = _this_.length + imul(newIndent.length, lines_0._get_size__45()) | 0;
    var tmp2_reindent_0 = getIndentFunction(newIndent);
    var lastIndex_1 = _get_lastIndex__0(lines_0);
    var tmp1_mapIndexedNotNullTo_0_1 = ArrayList_init_$Create$();
    var index_1_2 = 0;
    var tmp0_iterator_2_3 = lines_0.iterator_64();
    while (tmp0_iterator_2_3.hasNext_31()) {
      var item_3_4 = tmp0_iterator_2_3.next_35();
      var tmp1_4_6 = index_1_2;
      index_1_2 = tmp1_4_6 + 1 | 0;
      var tmp0__anonymous__1_5_5 = checkIndexOverflow(tmp1_4_6);
      var tmp;
      if ((tmp0__anonymous__1_5_5 === 0 ? true : tmp0__anonymous__1_5_5 === lastIndex_1) ? isBlank(item_3_4) : false) {
        tmp = null;
      } else {
        var tmp$ret$0;
        l$ret$1: do {
          var inductionVariable = 0;
          var last_1 = charSequenceLength(item_3_4) - 1 | 0;
          if (inductionVariable <= last_1)
            do {
              var index_2_8 = inductionVariable;
              inductionVariable = inductionVariable + 1 | 0;
              var tmp0__anonymous__3_9 = charSequenceGet(item_3_4, index_2_8);
              if (!isWhitespace(tmp0__anonymous__3_9)) {
                tmp$ret$0 = index_2_8;
                break l$ret$1;
              } else {
              }
            }
             while (inductionVariable <= last_1);
          tmp$ret$0 = -1;
        }
         while (false);
        var firstNonWhitespaceIndex_6 = tmp$ret$0;
        var tmp_0;
        if (firstNonWhitespaceIndex_6 === -1) {
          tmp_0 = null;
        } else {
          if (startsWith$default_2(item_3_4, marginPrefix, firstNonWhitespaceIndex_6, false, 4, null)) {
            var tmp1_substring_0_10 = firstNonWhitespaceIndex_6 + marginPrefix.length | 0;
            tmp_0 = item_3_4.substring(tmp1_substring_0_10);
          } else {
            {
              tmp_0 = null;
            }
          }
        }
        var tmp0_safe_receiver_4_10 = tmp_0;
        var tmp_1;
        if (tmp0_safe_receiver_4_10 == null) {
          tmp_1 = null;
        } else {
          tmp_1 = tmp2_reindent_0(tmp0_safe_receiver_4_10);
        }
        var tmp1_elvis_lhs_3_9 = tmp_1;
        tmp = tmp1_elvis_lhs_3_9 == null ? item_3_4 : tmp1_elvis_lhs_3_9;
      }
      var tmp0_safe_receiver_2_6_7 = tmp;
      if (tmp0_safe_receiver_2_6_7 == null)
        null;
      else {
        tmp1_mapIndexedNotNullTo_0_1.add_33(tmp0_safe_receiver_2_6_7);
        Unit_getInstance();
      }
      Unit_getInstance();
    }
    var tmp_2 = StringBuilder_init_$Create$(tmp1_reindent_0);
    return joinTo$default(tmp1_mapIndexedNotNullTo_0_1, tmp_2, '\n', null, null, 0, null, null, 124, null).toString();
  }
  function getIndentFunction(indent) {
    var tmp;
    if (charSequenceLength(indent) === 0) {
      tmp = _no_name_provided_$factory_5();
    } else {
      {
        tmp = _no_name_provided_$factory_6(indent);
      }
    }
    return tmp;
  }
  function trimIndent(_this_) {
    return replaceIndent(_this_, '');
  }
  function replaceIndent(_this_, newIndent) {
    var lines_0 = lines(_this_);
    var tmp0_filterTo_0_1 = ArrayList_init_$Create$();
    var tmp0_iterator_1_2 = lines_0.iterator_64();
    while (tmp0_iterator_1_2.hasNext_31()) {
      var element_2_3 = tmp0_iterator_1_2.next_35();
      if (isNotBlank(element_2_3)) {
        tmp0_filterTo_0_1.add_33(element_2_3);
        Unit_getInstance();
      }}
    var tmp0_map_0 = tmp0_filterTo_0_1;
    var tmp0_mapTo_0_1 = ArrayList_init_$Create$_0(collectionSizeOrDefault(tmp0_map_0, 10));
    var tmp0_iterator_1_2_0 = tmp0_map_0.iterator_64();
    while (tmp0_iterator_1_2_0.hasNext_31()) {
      var item_2_3 = tmp0_iterator_1_2_0.next_35();
      tmp0_mapTo_0_1.add_33(indentWidth(item_2_3));
      Unit_getInstance();
    }
    var tmp0_elvis_lhs = minOrNull(tmp0_mapTo_0_1);
    var minCommonIndent = tmp0_elvis_lhs == null ? 0 : tmp0_elvis_lhs;
    var tmp1_reindent_0 = _this_.length + imul(newIndent.length, lines_0._get_size__45()) | 0;
    var tmp2_reindent_0 = getIndentFunction(newIndent);
    var lastIndex_1 = _get_lastIndex__0(lines_0);
    var tmp1_mapIndexedNotNullTo_0_1_2 = ArrayList_init_$Create$();
    var index_1_2_3 = 0;
    var tmp0_iterator_2_3_4 = lines_0.iterator_64();
    while (tmp0_iterator_2_3_4.hasNext_31()) {
      var item_3_4_5 = tmp0_iterator_2_3_4.next_35();
      var tmp1_4_6_7 = index_1_2_3;
      index_1_2_3 = tmp1_4_6_7 + 1 | 0;
      var tmp0__anonymous__1_5_5_6 = checkIndexOverflow(tmp1_4_6_7);
      var tmp;
      if ((tmp0__anonymous__1_5_5_6 === 0 ? true : tmp0__anonymous__1_5_5_6 === lastIndex_1) ? isBlank(item_3_4_5) : false) {
        tmp = null;
      } else {
        var tmp0_safe_receiver_10_10 = drop(item_3_4_5, minCommonIndent);
        var tmp_0;
        if (tmp0_safe_receiver_10_10 == null) {
          tmp_0 = null;
        } else {
          tmp_0 = tmp2_reindent_0(tmp0_safe_receiver_10_10);
        }
        var tmp1_elvis_lhs_9_9 = tmp_0;
        tmp = tmp1_elvis_lhs_9_9 == null ? item_3_4_5 : tmp1_elvis_lhs_9_9;
      }
      var tmp0_safe_receiver_2_6_7_8 = tmp;
      if (tmp0_safe_receiver_2_6_7_8 == null)
        null;
      else {
        tmp1_mapIndexedNotNullTo_0_1_2.add_33(tmp0_safe_receiver_2_6_7_8);
        Unit_getInstance();
      }
      Unit_getInstance();
    }
    var tmp_1 = StringBuilder_init_$Create$(tmp1_reindent_0);
    return joinTo$default(tmp1_mapIndexedNotNullTo_0_1_2, tmp_1, '\n', null, null, 0, null, null, 124, null).toString();
  }
  function indentWidth(_this_) {
    var tmp$ret$0;
    l$ret$1: do {
      var inductionVariable = 0;
      var last_1 = charSequenceLength(_this_) - 1 | 0;
      if (inductionVariable <= last_1)
        do {
          var index_2 = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var tmp0__anonymous__3 = charSequenceGet(_this_, index_2);
          if (!isWhitespace(tmp0__anonymous__3)) {
            tmp$ret$0 = index_2;
            break l$ret$1;
          } else {
          }
        }
         while (inductionVariable <= last_1);
      tmp$ret$0 = -1;
    }
     while (false);
    var tmp1_let_0 = tmp$ret$0;
    return tmp1_let_0 === -1 ? _this_.length : tmp1_let_0;
  }
  function _no_name_provided__13() {
  }
  _no_name_provided__13.prototype.invoke_229 = function (line) {
    return line;
  };
  _no_name_provided__13.prototype.invoke_542 = function (p1) {
    return this.invoke_229((!(p1 == null) ? typeof p1 === 'string' : false) ? p1 : THROW_CCE());
  };
  _no_name_provided__13.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__14($indent) {
    this._$indent = $indent;
  }
  _no_name_provided__14.prototype.invoke_229 = function (line) {
    return this._$indent + line;
  };
  _no_name_provided__14.prototype.invoke_542 = function (p1) {
    return this.invoke_229((!(p1 == null) ? typeof p1 === 'string' : false) ? p1 : THROW_CCE());
  };
  _no_name_provided__14.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided_$factory_5() {
    var i = new _no_name_provided__13();
    return function (p1) {
      return i.invoke_229(p1);
    };
  }
  function _no_name_provided_$factory_6($indent) {
    var i = new _no_name_provided__14($indent);
    return function (p1) {
      return i.invoke_229(p1);
    };
  }
  function toIntOrNull(_this_) {
    return toIntOrNull_0(_this_, 10);
  }
  function toLongOrNull(_this_) {
    return toLongOrNull_0(_this_, 10);
  }
  function toIntOrNull_0(_this_, radix) {
    checkRadix(radix);
    Unit_getInstance();
    var length = _this_.length;
    if (length === 0)
      return null;
    var start;
    var isNegative_0;
    var limit;
    var firstChar = charSequenceGet(_this_, 0);
    if (firstChar.compareTo_12(new Char(48)) < 0) {
      if (length === 1)
        return null;
      start = 1;
      if (firstChar.equals(new Char(45))) {
        isNegative_0 = true;
        limit = IntCompanionObject_getInstance()._MIN_VALUE_5;
      } else if (firstChar.equals(new Char(43))) {
        isNegative_0 = false;
        limit = -IntCompanionObject_getInstance()._MAX_VALUE_5 | 0;
      } else
        return null;
    } else {
      start = 0;
      isNegative_0 = false;
      limit = -IntCompanionObject_getInstance()._MAX_VALUE_5 | 0;
    }
    var limitForMaxRadix = (-IntCompanionObject_getInstance()._MAX_VALUE_5 | 0) / 36 | 0;
    var limitBeforeMul = limitForMaxRadix;
    var result = 0;
    var inductionVariable = start;
    if (inductionVariable < length)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var digit = digitOf(charSequenceGet(_this_, i), radix);
        if (digit < 0)
          return null;
        if (result < limitBeforeMul) {
          if (limitBeforeMul === limitForMaxRadix) {
            limitBeforeMul = limit / radix | 0;
            if (result < limitBeforeMul) {
              return null;
            }} else {
            return null;
          }
        }result = imul(result, radix);
        if (result < (limit + digit | 0))
          return null;
        result = result - digit | 0;
      }
       while (inductionVariable < length);
    return isNegative_0 ? result : -result | 0;
  }
  function toLongOrNull_0(_this_, radix) {
    checkRadix(radix);
    Unit_getInstance();
    var length = _this_.length;
    if (length === 0)
      return null;
    var start;
    var isNegative_0;
    var limit;
    var firstChar = charSequenceGet(_this_, 0);
    if (firstChar.compareTo_12(new Char(48)) < 0) {
      if (length === 1)
        return null;
      start = 1;
      if (firstChar.equals(new Char(45))) {
        isNegative_0 = true;
        limit = new Long(0, -2147483648);
      } else if (firstChar.equals(new Char(43))) {
        isNegative_0 = false;
        limit = new Long(1, -2147483648);
      } else
        return null;
    } else {
      start = 0;
      isNegative_0 = false;
      limit = new Long(1, -2147483648);
    }
    var tmp0_div_0 = new Long(1, -2147483648);
    var tmp1_div_0 = 36;
    var limitForMaxRadix = tmp0_div_0.div_27(toLong_0(tmp1_div_0));
    var limitBeforeMul = limitForMaxRadix;
    var result = new Long(0, 0);
    var inductionVariable = start;
    if (inductionVariable < length)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var digit = digitOf(charSequenceGet(_this_, i), radix);
        if (digit < 0)
          return null;
        if (result.compareTo_69(limitBeforeMul) < 0) {
          if (limitBeforeMul.equals(limitForMaxRadix)) {
            limitBeforeMul = limit.div_27(toLong_0(radix));
            if (result.compareTo_69(limitBeforeMul) < 0) {
              return null;
            }} else {
            return null;
          }
        }var tmp2_times_0 = result;
        result = tmp2_times_0.times_27(toLong_0(radix));
        var tmp = result;
        if (tmp.compareTo_69(limit.plus_56(toLong_0(digit))) < 0)
          return null;
        else {
        }
        var tmp3_minus_0 = result;
        result = tmp3_minus_0.minus_29(toLong_0(digit));
      }
       while (inductionVariable < length);
    return isNegative_0 ? result : result.unaryMinus_4();
  }
  function numberFormatError(input) {
    throw NumberFormatException_init_$Create$('' + "Invalid number format: '" + input + "'");
  }
  function toByteOrNull(_this_) {
    return toByteOrNull_0(_this_, 10);
  }
  function toShortOrNull(_this_) {
    return toShortOrNull_0(_this_, 10);
  }
  function toByteOrNull_0(_this_, radix) {
    var tmp0_elvis_lhs = toIntOrNull_0(_this_, radix);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return null;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var int = tmp;
    if (int < ByteCompanionObject_getInstance()._MIN_VALUE_3 ? true : int > ByteCompanionObject_getInstance()._MAX_VALUE_3)
      return null;
    return toByte_0(int);
  }
  function toShortOrNull_0(_this_, radix) {
    var tmp0_elvis_lhs = toIntOrNull_0(_this_, radix);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return null;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var int = tmp;
    if (int < ShortCompanionObject_getInstance()._MIN_VALUE_4 ? true : int > ShortCompanionObject_getInstance()._MAX_VALUE_4)
      return null;
    return toShort_0(int);
  }
  function isNotBlank(_this_) {
    return !isBlank(_this_);
  }
  function substringBefore(_this_, delimiter, missingDelimiterValue) {
    var index = indexOf$default_0(_this_, delimiter, 0, false, 6, null);
    var tmp;
    if (index === -1) {
      tmp = missingDelimiterValue;
    } else {
      var tmp0_substring_0 = 0;
      tmp = _this_.substring(tmp0_substring_0, index);
    }
    return tmp;
  }
  function substringBefore$default(_this_, delimiter, missingDelimiterValue, $mask0, $handler) {
    if (!(($mask0 & 2) === 0))
      missingDelimiterValue = _this_;
    return substringBefore(_this_, delimiter, missingDelimiterValue);
  }
  function endsWith(_this_, char, ignoreCase) {
    return charSequenceLength(_this_) > 0 ? equals(charSequenceGet(_this_, _get_lastIndex__1(_this_)), char, ignoreCase) : false;
  }
  function endsWith$default(_this_, char, ignoreCase, $mask0, $handler) {
    if (!(($mask0 & 2) === 0))
      ignoreCase = false;
    return endsWith(_this_, char, ignoreCase);
  }
  function substringBefore_0(_this_, delimiter, missingDelimiterValue) {
    var index = indexOf$default(_this_, delimiter, 0, false, 6, null);
    var tmp;
    if (index === -1) {
      tmp = missingDelimiterValue;
    } else {
      var tmp0_substring_0 = 0;
      tmp = _this_.substring(tmp0_substring_0, index);
    }
    return tmp;
  }
  function substringBefore$default_0(_this_, delimiter, missingDelimiterValue, $mask0, $handler) {
    if (!(($mask0 & 2) === 0))
      missingDelimiterValue = _this_;
    return substringBefore_0(_this_, delimiter, missingDelimiterValue);
  }
  function substring(_this_, range) {
    var tmp0_substring_0 = range._get_start__1();
    var tmp1_substring_0 = range._get_endInclusive__1() + 1 | 0;
    return _this_.substring(tmp0_substring_0, tmp1_substring_0);
  }
  function contains_1(_this_, other, ignoreCase) {
    var tmp;
    if (typeof other === 'string') {
      var tmp_0 = other;
      tmp = indexOf$default_0(_this_, tmp_0, 0, ignoreCase, 2, null) >= 0;
    } else {
      {
        var tmp_1 = charSequenceLength(_this_);
        tmp = indexOf$default_1(_this_, other, 0, tmp_1, ignoreCase, false, 16, null) >= 0;
      }
    }
    return tmp;
  }
  function contains$default(_this_, other, ignoreCase, $mask0, $handler) {
    if (!(($mask0 & 2) === 0))
      ignoreCase = false;
    return contains_1(_this_, other, ignoreCase);
  }
  function startsWith(_this_, char, ignoreCase) {
    return charSequenceLength(_this_) > 0 ? equals(charSequenceGet(_this_, 0), char, ignoreCase) : false;
  }
  function startsWith$default(_this_, char, ignoreCase, $mask0, $handler) {
    if (!(($mask0 & 2) === 0))
      ignoreCase = false;
    return startsWith(_this_, char, ignoreCase);
  }
  function indexOf_0(_this_, char, startIndex, ignoreCase) {
    var tmp;
    var tmp_0;
    if (ignoreCase) {
      tmp_0 = true;
    } else {
      tmp_0 = !(typeof _this_ === 'string');
    }
    if (tmp_0) {
      var tmp0_charArrayOf_0 = charArrayOf([char]);
      tmp = indexOfAny(_this_, tmp0_charArrayOf_0, startIndex, ignoreCase);
    } else {
      {
        var tmp2_nativeIndexOf_0 = _this_;
        var tmp1_nativeIndexOf_0 = char.toString();
        tmp = tmp2_nativeIndexOf_0.indexOf(tmp1_nativeIndexOf_0, startIndex);
      }
    }
    return tmp;
  }
  function indexOf$default(_this_, char, startIndex, ignoreCase, $mask0, $handler) {
    if (!(($mask0 & 2) === 0))
      startIndex = 0;
    if (!(($mask0 & 4) === 0))
      ignoreCase = false;
    return indexOf_0(_this_, char, startIndex, ignoreCase);
  }
  function removePrefix(_this_, prefix) {
    if (startsWith$default_0(_this_, prefix, false, 2, null)) {
      var tmp0_substring_0 = charSequenceLength(prefix);
      return _this_.substring(tmp0_substring_0);
    } else {
    }
    return _this_;
  }
  function lineSequence(_this_) {
    var tmp = ['\r\n', '\n', '\r'];
    return splitToSequence$default(_this_, tmp, false, 0, 6, null);
  }
  function contains_2(_this_, char, ignoreCase) {
    return indexOf$default(_this_, char, 0, ignoreCase, 2, null) >= 0;
  }
  function contains$default_0(_this_, char, ignoreCase, $mask0, $handler) {
    if (!(($mask0 & 2) === 0))
      ignoreCase = false;
    return contains_2(_this_, char, ignoreCase);
  }
  function _get_lastIndex__1(_this_) {
    return charSequenceLength(_this_) - 1 | 0;
  }
  function indexOf_1(_this_, string, startIndex, ignoreCase) {
    var tmp;
    var tmp_0;
    if (ignoreCase) {
      tmp_0 = true;
    } else {
      tmp_0 = !(typeof _this_ === 'string');
    }
    if (tmp_0) {
      var tmp_1 = charSequenceLength(_this_);
      tmp = indexOf$default_1(_this_, string, startIndex, tmp_1, ignoreCase, false, 16, null);
    } else {
      {
        var tmp0_nativeIndexOf_0 = _this_;
        tmp = tmp0_nativeIndexOf_0.indexOf(string, startIndex);
      }
    }
    return tmp;
  }
  function indexOf$default_0(_this_, string, startIndex, ignoreCase, $mask0, $handler) {
    if (!(($mask0 & 2) === 0))
      startIndex = 0;
    if (!(($mask0 & 4) === 0))
      ignoreCase = false;
    return indexOf_1(_this_, string, startIndex, ignoreCase);
  }
  function indexOf_2(_this_, other, startIndex, endIndex, ignoreCase, last_1) {
    var indices = !last_1 ? numberRangeToNumber(coerceAtLeast(startIndex, 0), coerceAtMost(endIndex, charSequenceLength(_this_))) : downTo(coerceAtMost(startIndex, _get_lastIndex__1(_this_)), coerceAtLeast(endIndex, 0));
    var tmp;
    if (typeof _this_ === 'string') {
      tmp = typeof other === 'string';
    } else {
      {
        tmp = false;
      }
    }
    if (tmp) {
      var inductionVariable = indices._first_1;
      var last_2 = indices._last;
      var step_0 = indices._step_1;
      if ((step_0 > 0 ? inductionVariable <= last_2 : false) ? true : step_0 < 0 ? last_2 <= inductionVariable : false)
        do {
          var index = inductionVariable;
          inductionVariable = inductionVariable + step_0 | 0;
          if (regionMatches(other, 0, _this_, index, charSequenceLength(other), ignoreCase))
            return index;
        }
         while (!(index === last_2));
    } else {
      {
        var inductionVariable_0 = indices._first_1;
        var last_3 = indices._last;
        var step_1 = indices._step_1;
        if ((step_1 > 0 ? inductionVariable_0 <= last_3 : false) ? true : step_1 < 0 ? last_3 <= inductionVariable_0 : false)
          do {
            var index_0 = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + step_1 | 0;
            if (regionMatchesImpl(other, 0, _this_, index_0, charSequenceLength(other), ignoreCase))
              return index_0;
          }
           while (!(index_0 === last_3));
      }
    }
    return -1;
  }
  function indexOf$default_1(_this_, other, startIndex, endIndex, ignoreCase, last_1, $mask0, $handler) {
    if (!(($mask0 & 16) === 0))
      last_1 = false;
    return indexOf_2(_this_, other, startIndex, endIndex, ignoreCase, last_1);
  }
  function indexOfAny(_this_, chars, startIndex, ignoreCase) {
    var tmp;
    if (!ignoreCase ? chars.length === 1 : false) {
      tmp = typeof _this_ === 'string';
    } else {
      tmp = false;
    }
    if (tmp) {
      var char = single(chars);
      var tmp1_nativeIndexOf_0 = _this_;
      var tmp0_nativeIndexOf_0 = char.toString();
      return tmp1_nativeIndexOf_0.indexOf(tmp0_nativeIndexOf_0, startIndex);
    } else {
    }
    var inductionVariable = coerceAtLeast(startIndex, 0);
    var last_1 = _get_lastIndex__1(_this_);
    if (inductionVariable <= last_1)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var charAtIndex = charSequenceGet(_this_, index);
        var tmp$ret$0;
        l$ret$1: do {
          var indexedObject = chars;
          var inductionVariable_0 = 0;
          var last_2 = indexedObject.length;
          while (inductionVariable_0 < last_2) {
            var element_2 = indexedObject[inductionVariable_0];
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            if (equals(element_2, charAtIndex, ignoreCase)) {
              tmp$ret$0 = true;
              break l$ret$1;
            } else {
            }
          }
          tmp$ret$0 = false;
        }
         while (false);
        if (tmp$ret$0)
          return index;
        else {
        }
      }
       while (!(index === last_1));
    return -1;
  }
  function indexOfAny$default(_this_, chars, startIndex, ignoreCase, $mask0, $handler) {
    if (!(($mask0 & 2) === 0))
      startIndex = 0;
    if (!(($mask0 & 4) === 0))
      ignoreCase = false;
    return indexOfAny(_this_, chars, startIndex, ignoreCase);
  }
  function trim(_this_) {
    var startIndex_1 = 0;
    var endIndex_2 = charSequenceLength(_this_) - 1 | 0;
    var startFound_3 = false;
    $l$break: while (startIndex_1 <= endIndex_2) {
      var index_4 = !startFound_3 ? startIndex_1 : endIndex_2;
      var match_5 = isWhitespace(charSequenceGet(_this_, index_4));
      if (!startFound_3) {
        if (!match_5)
          startFound_3 = true;
        else
          startIndex_1 = startIndex_1 + 1 | 0;
      } else {
        if (!match_5)
          break $l$break;
        else
          endIndex_2 = endIndex_2 - 1 | 0;
      }
    }
    return charSequenceSubSequence(_this_, startIndex_1, endIndex_2 + 1 | 0);
  }
  function startsWith_0(_this_, prefix, ignoreCase) {
    var tmp;
    var tmp_0;
    if (!ignoreCase) {
      tmp_0 = typeof _this_ === 'string';
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = typeof prefix === 'string';
    } else {
      {
        tmp = false;
      }
    }
    if (tmp) {
      var tmp_1 = _this_;
      var tmp_2 = prefix;
      return startsWith$default_1(tmp_1, tmp_2, false, 2, null);
    } else {
      return regionMatchesImpl(_this_, 0, prefix, 0, charSequenceLength(prefix), ignoreCase);
    }
  }
  function startsWith$default_0(_this_, prefix, ignoreCase, $mask0, $handler) {
    if (!(($mask0 & 2) === 0))
      ignoreCase = false;
    return startsWith_0(_this_, prefix, ignoreCase);
  }
  function splitToSequence(_this_, delimiters, ignoreCase, limit) {
    var tmp = rangesDelimitedBy$default(_this_, delimiters, 0, ignoreCase, limit, 2, null);
    return map(tmp, _no_name_provided_$factory_7(_this_));
  }
  function splitToSequence$default(_this_, delimiters, ignoreCase, limit, $mask0, $handler) {
    if (!(($mask0 & 2) === 0))
      ignoreCase = false;
    if (!(($mask0 & 4) === 0))
      limit = 0;
    return splitToSequence(_this_, delimiters, ignoreCase, limit);
  }
  function regionMatchesImpl(_this_, thisOffset, other, otherOffset, length, ignoreCase) {
    if (((otherOffset < 0 ? true : thisOffset < 0) ? true : thisOffset > (charSequenceLength(_this_) - length | 0)) ? true : otherOffset > (charSequenceLength(other) - length | 0)) {
      return false;
    }var inductionVariable = 0;
    if (inductionVariable < length)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (!equals(charSequenceGet(_this_, thisOffset + index | 0), charSequenceGet(other, otherOffset + index | 0), ignoreCase))
          return false;
      }
       while (inductionVariable < length);
    return true;
  }
  function substring_0(_this_, range) {
    return toString_1(charSequenceSubSequence(_this_, range._get_start__1(), range._get_endInclusive__1() + 1 | 0));
  }
  function rangesDelimitedBy(_this_, delimiters, startIndex, ignoreCase, limit) {
    var tmp0_require_0 = limit >= 0;
    if (!tmp0_require_0) {
      var message_2 = '' + 'Limit must be non-negative, but was ' + limit + '.';
      throw IllegalArgumentException_init_$Create$_0(toString_1(message_2));
    }var delimitersList = asList(delimiters);
    return new DelimitedRangesSequence(_this_, startIndex, limit, _no_name_provided_$factory_8(delimitersList, ignoreCase));
  }
  function rangesDelimitedBy$default(_this_, delimiters, startIndex, ignoreCase, limit, $mask0, $handler) {
    if (!(($mask0 & 2) === 0))
      startIndex = 0;
    if (!(($mask0 & 4) === 0))
      ignoreCase = false;
    if (!(($mask0 & 8) === 0))
      limit = 0;
    return rangesDelimitedBy(_this_, delimiters, startIndex, ignoreCase, limit);
  }
  function calcNext_1($this) {
    if ($this._nextSearchIndex < 0) {
      $this._nextState_1 = 0;
      $this._nextItem_1 = null;
    } else {
      var tmp;
      var tmp_0;
      if ($this._this$0_6._limit > 0) {
        var tmp0_this = $this;
        tmp0_this._counter = tmp0_this._counter + 1 | 0;
        tmp_0 = tmp0_this._counter >= $this._this$0_6._limit;
      } else {
        tmp_0 = false;
      }
      if (tmp_0) {
        tmp = true;
      } else {
        {
          tmp = $this._nextSearchIndex > charSequenceLength($this._this$0_6._input);
        }
      }
      if (tmp) {
        $this._nextItem_1 = numberRangeToNumber($this._currentStartIndex, _get_lastIndex__1($this._this$0_6._input));
        $this._nextSearchIndex = -1;
      } else {
        {
          var match = $this._this$0_6._getNextMatch($this._this$0_6._input, $this._nextSearchIndex);
          if (match == null) {
            $this._nextItem_1 = numberRangeToNumber($this._currentStartIndex, _get_lastIndex__1($this._this$0_6._input));
            $this._nextSearchIndex = -1;
          } else {
            var tmp1_container = match;
            var index = tmp1_container.component1_4();
            var length = tmp1_container.component2_4();
            $this._nextItem_1 = until($this._currentStartIndex, index);
            $this._currentStartIndex = index + length | 0;
            $this._nextSearchIndex = $this._currentStartIndex + (length === 0 ? 1 : 0) | 0;
          }
        }
      }
      $this._nextState_1 = 1;
    }
  }
  function _no_name_provided__15(this$0) {
    this._this$0_6 = this$0;
    this._nextState_1 = -1;
    this._currentStartIndex = coerceIn_0(this._this$0_6._startIndex, 0, charSequenceLength(this._this$0_6._input));
    this._nextSearchIndex = this._currentStartIndex;
    this._nextItem_1 = null;
    this._counter = 0;
  }
  _no_name_provided__15.prototype.next_35 = function () {
    if (this._nextState_1 === -1)
      calcNext_1(this);
    if (this._nextState_1 === 0)
      throw NoSuchElementException_init_$Create$();
    var tmp = this._nextItem_1;
    var result = tmp instanceof IntRange ? tmp : THROW_CCE();
    this._nextItem_1 = null;
    this._nextState_1 = -1;
    return result;
  };
  _no_name_provided__15.prototype.hasNext_31 = function () {
    if (this._nextState_1 === -1)
      calcNext_1(this);
    return this._nextState_1 === 1;
  };
  _no_name_provided__15.$metadata$ = {
    kind: 'class',
    interfaces: [Iterator]
  };
  function DelimitedRangesSequence(input, startIndex, limit, getNextMatch) {
    this._input = input;
    this._startIndex = startIndex;
    this._limit = limit;
    this._getNextMatch = getNextMatch;
  }
  DelimitedRangesSequence.prototype.iterator_64 = function () {
    return new _no_name_provided__15(this);
  };
  DelimitedRangesSequence.$metadata$ = {
    simpleName: 'DelimitedRangesSequence',
    kind: 'class',
    interfaces: [Sequence]
  };
  function findAnyOf(_this_, strings, startIndex, ignoreCase, last_1) {
    if (!ignoreCase ? strings._get_size__45() === 1 : false) {
      var string = single_1(strings);
      var tmp;
      if (!last_1) {
        tmp = indexOf$default_0(_this_, string, startIndex, false, 4, null);
      } else {
        tmp = lastIndexOf$default(_this_, string, startIndex, false, 4, null);
      }
      var index = tmp;
      return index < 0 ? null : to(index, string);
    }var indices = !last_1 ? numberRangeToNumber(coerceAtLeast(startIndex, 0), charSequenceLength(_this_)) : downTo(coerceAtMost(startIndex, _get_lastIndex__1(_this_)), 0);
    if (typeof _this_ === 'string') {
      var inductionVariable = indices._first_1;
      var last_2 = indices._last;
      var step_0 = indices._step_1;
      if ((step_0 > 0 ? inductionVariable <= last_2 : false) ? true : step_0 < 0 ? last_2 <= inductionVariable : false)
        do {
          var index_0 = inductionVariable;
          inductionVariable = inductionVariable + step_0 | 0;
          var tmp$ret$0;
          l$ret$1: do {
            var tmp0_iterator_1 = strings.iterator_64();
            while (tmp0_iterator_1.hasNext_31()) {
              var element_2 = tmp0_iterator_1.next_35();
              if (regionMatches(element_2, 0, _this_, index_0, element_2.length, ignoreCase)) {
                tmp$ret$0 = element_2;
                break l$ret$1;
              } else {
              }
            }
            tmp$ret$0 = null;
          }
           while (false);
          var matchingString = tmp$ret$0;
          if (!(matchingString == null))
            return to(index_0, matchingString);
        }
         while (!(index_0 === last_2));
    } else {
      {
        var inductionVariable_0 = indices._first_1;
        var last_3 = indices._last;
        var step_1 = indices._step_1;
        if ((step_1 > 0 ? inductionVariable_0 <= last_3 : false) ? true : step_1 < 0 ? last_3 <= inductionVariable_0 : false)
          do {
            var index_1 = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + step_1 | 0;
            var tmp$ret$2;
            l$ret$3: do {
              var tmp0_iterator_1_0 = strings.iterator_64();
              while (tmp0_iterator_1_0.hasNext_31()) {
                var element_2_0 = tmp0_iterator_1_0.next_35();
                if (regionMatchesImpl(element_2_0, 0, _this_, index_1, element_2_0.length, ignoreCase)) {
                  tmp$ret$2 = element_2_0;
                  break l$ret$3;
                } else {
                }
              }
              tmp$ret$2 = null;
            }
             while (false);
            var matchingString_0 = tmp$ret$2;
            if (!(matchingString_0 == null))
              return to(index_1, matchingString_0);
          }
           while (!(index_1 === last_3));
      }
    }
    return null;
  }
  function lastIndexOf(_this_, string, startIndex, ignoreCase) {
    var tmp;
    var tmp_0;
    if (ignoreCase) {
      tmp_0 = true;
    } else {
      tmp_0 = !(typeof _this_ === 'string');
    }
    if (tmp_0) {
      tmp = indexOf_2(_this_, string, startIndex, 0, ignoreCase, true);
    } else {
      {
        var tmp0_nativeLastIndexOf_0 = _this_;
        tmp = tmp0_nativeLastIndexOf_0.lastIndexOf(string, startIndex);
      }
    }
    return tmp;
  }
  function lastIndexOf$default(_this_, string, startIndex, ignoreCase, $mask0, $handler) {
    if (!(($mask0 & 2) === 0))
      startIndex = _get_lastIndex__1(_this_);
    if (!(($mask0 & 4) === 0))
      ignoreCase = false;
    return lastIndexOf(_this_, string, startIndex, ignoreCase);
  }
  function iterator(_this_) {
    return new _no_name_provided__18(_this_);
  }
  function lines(_this_) {
    return toList_2(lineSequence(_this_));
  }
  function lastIndexOf_0(_this_, char, startIndex, ignoreCase) {
    var tmp;
    var tmp_0;
    if (ignoreCase) {
      tmp_0 = true;
    } else {
      tmp_0 = !(typeof _this_ === 'string');
    }
    if (tmp_0) {
      var tmp0_charArrayOf_0 = charArrayOf([char]);
      tmp = lastIndexOfAny(_this_, tmp0_charArrayOf_0, startIndex, ignoreCase);
    } else {
      {
        var tmp2_nativeLastIndexOf_0 = _this_;
        var tmp1_nativeLastIndexOf_0 = char.toString();
        tmp = tmp2_nativeLastIndexOf_0.lastIndexOf(tmp1_nativeLastIndexOf_0, startIndex);
      }
    }
    return tmp;
  }
  function lastIndexOf$default_0(_this_, char, startIndex, ignoreCase, $mask0, $handler) {
    if (!(($mask0 & 2) === 0))
      startIndex = _get_lastIndex__1(_this_);
    if (!(($mask0 & 4) === 0))
      ignoreCase = false;
    return lastIndexOf_0(_this_, char, startIndex, ignoreCase);
  }
  function lastIndexOfAny(_this_, chars, startIndex, ignoreCase) {
    var tmp;
    if (!ignoreCase ? chars.length === 1 : false) {
      tmp = typeof _this_ === 'string';
    } else {
      tmp = false;
    }
    if (tmp) {
      var char = single(chars);
      var tmp1_nativeLastIndexOf_0 = _this_;
      var tmp0_nativeLastIndexOf_0 = char.toString();
      return tmp1_nativeLastIndexOf_0.lastIndexOf(tmp0_nativeLastIndexOf_0, startIndex);
    } else {
    }
    var inductionVariable = coerceAtMost(startIndex, _get_lastIndex__1(_this_));
    if (0 <= inductionVariable)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + -1 | 0;
        var charAtIndex = charSequenceGet(_this_, index);
        var tmp$ret$0;
        l$ret$1: do {
          var indexedObject = chars;
          var inductionVariable_0 = 0;
          var last_1 = indexedObject.length;
          while (inductionVariable_0 < last_1) {
            var element_2 = indexedObject[inductionVariable_0];
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            if (equals(element_2, charAtIndex, ignoreCase)) {
              tmp$ret$0 = true;
              break l$ret$1;
            } else {
            }
          }
          tmp$ret$0 = false;
        }
         while (false);
        if (tmp$ret$0)
          return index;
        else {
        }
      }
       while (0 <= inductionVariable);
    return -1;
  }
  function removeSurrounding(_this_, delimiter) {
    return removeSurrounding_0(_this_, delimiter, delimiter);
  }
  function trimStart(_this_) {
    var tmp$ret$0;
    l$ret$1: do {
      var inductionVariable = 0;
      var last_1 = charSequenceLength(_this_) - 1 | 0;
      if (inductionVariable <= last_1)
        do {
          var index_2 = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          if (!isWhitespace(charSequenceGet(_this_, index_2))) {
            tmp$ret$0 = charSequenceSubSequence(_this_, index_2, charSequenceLength(_this_));
            break l$ret$1;
          }}
         while (inductionVariable <= last_1);
      tmp$ret$0 = '';
    }
     while (false);
    return tmp$ret$0;
  }
  function removeSurrounding_0(_this_, prefix, suffix) {
    var tmp;
    var tmp_0;
    if (_this_.length >= (charSequenceLength(prefix) + charSequenceLength(suffix) | 0)) {
      tmp_0 = startsWith$default_0(_this_, prefix, false, 2, null);
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = endsWith$default_0(_this_, suffix, false, 2, null);
    } else {
      {
        tmp = false;
      }
    }
    if (tmp) {
      var tmp0_substring_0 = charSequenceLength(prefix);
      var tmp1_substring_0 = _this_.length - charSequenceLength(suffix) | 0;
      return _this_.substring(tmp0_substring_0, tmp1_substring_0);
    } else {
    }
    return _this_;
  }
  function endsWith_0(_this_, suffix, ignoreCase) {
    var tmp;
    var tmp_0;
    if (!ignoreCase) {
      tmp_0 = typeof _this_ === 'string';
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = typeof suffix === 'string';
    } else {
      {
        tmp = false;
      }
    }
    if (tmp) {
      var tmp_1 = _this_;
      var tmp_2 = suffix;
      return endsWith$default_1(tmp_1, tmp_2, false, 2, null);
    } else {
      return regionMatchesImpl(_this_, charSequenceLength(_this_) - charSequenceLength(suffix) | 0, suffix, 0, charSequenceLength(suffix), ignoreCase);
    }
  }
  function endsWith$default_0(_this_, suffix, ignoreCase, $mask0, $handler) {
    if (!(($mask0 & 2) === 0))
      ignoreCase = false;
    return endsWith_0(_this_, suffix, ignoreCase);
  }
  function _no_name_provided__16($this_splitToSequence) {
    this._$this_splitToSequence = $this_splitToSequence;
  }
  _no_name_provided__16.prototype.invoke_15 = function (it) {
    return substring_0(this._$this_splitToSequence, it);
  };
  _no_name_provided__16.prototype.invoke_542 = function (p1) {
    return this.invoke_15(p1 instanceof IntRange ? p1 : THROW_CCE());
  };
  _no_name_provided__16.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__17($delimitersList, $ignoreCase) {
    this._$delimitersList = $delimitersList;
    this._$ignoreCase = $ignoreCase;
  }
  _no_name_provided__17.prototype.invoke_17 = function (_this__0, currentIndex) {
    var tmp0_safe_receiver = findAnyOf(_this__0, this._$delimitersList, currentIndex, this._$ignoreCase, false);
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      tmp = to(tmp0_safe_receiver._first, tmp0_safe_receiver._second.length);
    }
    return tmp;
  };
  _no_name_provided__17.prototype.invoke_537 = function (p1, p2) {
    var tmp = (!(p1 == null) ? isCharSequence(p1) : false) ? p1 : THROW_CCE();
    return this.invoke_17(tmp, (!(p2 == null) ? typeof p2 === 'number' : false) ? p2 : THROW_CCE());
  };
  _no_name_provided__17.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__18($this_iterator) {
    this._$this_iterator = $this_iterator;
    CharIterator.call(this);
    this._index_1 = 0;
  }
  _no_name_provided__18.prototype.nextChar_1 = function () {
    var tmp0_this = this;
    var tmp1 = tmp0_this._index_1;
    tmp0_this._index_1 = tmp1 + 1 | 0;
    return charSequenceGet(this._$this_iterator, tmp1);
  };
  _no_name_provided__18.prototype.hasNext_31 = function () {
    return this._index_1 < charSequenceLength(this._$this_iterator);
  };
  _no_name_provided__18.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided_$factory_7($this_splitToSequence) {
    var i = new _no_name_provided__16($this_splitToSequence);
    return function (p1) {
      return i.invoke_15(p1);
    };
  }
  function _no_name_provided_$factory_8($delimitersList, $ignoreCase) {
    var i = new _no_name_provided__17($delimitersList, $ignoreCase);
    return function (p1, p2) {
      return i.invoke_17(p1, p2);
    };
  }
  function MatchResult() {
  }
  MatchResult.$metadata$ = {
    simpleName: 'MatchResult',
    kind: 'interface',
    interfaces: []
  };
  function MatchGroupCollection() {
  }
  MatchGroupCollection.$metadata$ = {
    simpleName: 'MatchGroupCollection',
    kind: 'interface',
    interfaces: [Collection]
  };
  function Lazy() {
  }
  Lazy.$metadata$ = {
    simpleName: 'Lazy',
    kind: 'interface',
    interfaces: []
  };
  var LazyThreadSafetyMode_SYNCHRONIZED_instance;
  var LazyThreadSafetyMode_PUBLICATION_instance;
  var LazyThreadSafetyMode_NONE_instance;
  var LazyThreadSafetyMode_entriesInitialized;
  function LazyThreadSafetyMode_initEntries() {
    if (LazyThreadSafetyMode_entriesInitialized)
      return Unit_getInstance();
    LazyThreadSafetyMode_entriesInitialized = true;
    LazyThreadSafetyMode_SYNCHRONIZED_instance = new LazyThreadSafetyMode('SYNCHRONIZED', 0);
    LazyThreadSafetyMode_PUBLICATION_instance = new LazyThreadSafetyMode('PUBLICATION', 1);
    LazyThreadSafetyMode_NONE_instance = new LazyThreadSafetyMode('NONE', 2);
  }
  function LazyThreadSafetyMode(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  LazyThreadSafetyMode.$metadata$ = {
    simpleName: 'LazyThreadSafetyMode',
    kind: 'class',
    interfaces: []
  };
  function UnsafeLazyImpl(initializer_0) {
    this._initializer = initializer_0;
    this.__value = UNINITIALIZED_VALUE_getInstance();
  }
  UnsafeLazyImpl.prototype._get_value__33 = function () {
    if (this.__value === UNINITIALIZED_VALUE_getInstance()) {
      this.__value = ensureNotNull(this._initializer)();
      this._initializer = null;
    }var tmp = this.__value;
    return (tmp == null ? true : isObject(tmp)) ? tmp : THROW_CCE();
  };
  UnsafeLazyImpl.prototype.isInitialized_0 = function () {
    return !(this.__value === UNINITIALIZED_VALUE_getInstance());
  };
  UnsafeLazyImpl.prototype.toString = function () {
    return this.isInitialized_0() ? toString_0(this._get_value__33()) : 'Lazy value not initialized yet.';
  };
  UnsafeLazyImpl.$metadata$ = {
    simpleName: 'UnsafeLazyImpl',
    kind: 'class',
    interfaces: [Lazy, Serializable]
  };
  function UNINITIALIZED_VALUE() {
    UNINITIALIZED_VALUE_instance = this;
  }
  UNINITIALIZED_VALUE.$metadata$ = {
    simpleName: 'UNINITIALIZED_VALUE',
    kind: 'object',
    interfaces: []
  };
  var UNINITIALIZED_VALUE_instance;
  function UNINITIALIZED_VALUE_getInstance() {
    if (UNINITIALIZED_VALUE_instance == null)
      new UNINITIALIZED_VALUE();
    return UNINITIALIZED_VALUE_instance;
  }
  function LazyThreadSafetyMode_NONE_getInstance() {
    LazyThreadSafetyMode_initEntries();
    return LazyThreadSafetyMode_NONE_instance;
  }
  function _Result___init__impl_(value) {
    return value;
  }
  function _Result___get_value__impl_(this_0) {
    return this_0;
  }
  function _Result___get_isFailure__impl_(this_0) {
    var tmp = _Result___get_value__impl_(this_0);
    return tmp instanceof Failure;
  }
  function Result__exceptionOrNull_impl(this_0) {
    var tmp0_subject = _Result___get_value__impl_(this_0);
    var tmp;
    if (tmp0_subject instanceof Failure) {
      tmp = _Result___get_value__impl_(this_0)._exception;
    } else {
      {
        tmp = null;
      }
    }
    return tmp;
  }
  function Companion_4() {
    Companion_instance_3 = this;
  }
  Companion_4.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_3;
  function Companion_getInstance_3() {
    if (Companion_instance_3 == null)
      new Companion_4();
    return Companion_instance_3;
  }
  function Failure(exception) {
    this._exception = exception;
  }
  Failure.prototype.equals = function (other) {
    var tmp;
    if (other instanceof Failure) {
      tmp = equals_1(this._exception, other._exception);
    } else {
      {
        tmp = false;
      }
    }
    return tmp;
  };
  Failure.prototype.hashCode = function () {
    return hashCode(this._exception);
  };
  Failure.prototype.toString = function () {
    return '' + 'Failure(' + this._exception + ')';
  };
  Failure.$metadata$ = {
    simpleName: 'Failure',
    kind: 'class',
    interfaces: [Serializable]
  };
  function createFailure(exception) {
    return new Failure(exception);
  }
  function Pair(first_1, second) {
    this._first = first_1;
    this._second = second;
  }
  Pair.prototype.toString = function () {
    return '' + '(' + this._first + ', ' + this._second + ')';
  };
  Pair.prototype.component1_4 = function () {
    return this._first;
  };
  Pair.prototype.component2_4 = function () {
    return this._second;
  };
  Pair.prototype.hashCode = function () {
    var result = this._first == null ? 0 : hashCode(this._first);
    result = imul(result, 31) + (this._second == null ? 0 : hashCode(this._second)) | 0;
    return result;
  };
  Pair.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Pair))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof Pair ? other : THROW_CCE();
    if (!equals_1(this._first, tmp0_other_with_cast._first))
      return false;
    if (!equals_1(this._second, tmp0_other_with_cast._second))
      return false;
    return true;
  };
  Pair.$metadata$ = {
    simpleName: 'Pair',
    kind: 'class',
    interfaces: [Serializable]
  };
  function to(_this_, that) {
    return new Pair(_this_, that);
  }
  function Triple(first_1, second, third) {
    this._first_0 = first_1;
    this._second_0 = second;
    this._third = third;
  }
  Triple.prototype.toString = function () {
    return '' + '(' + this._first_0 + ', ' + this._second_0 + ', ' + this._third + ')';
  };
  Triple.prototype.hashCode = function () {
    var result = this._first_0 == null ? 0 : hashCode(this._first_0);
    result = imul(result, 31) + (this._second_0 == null ? 0 : hashCode(this._second_0)) | 0;
    result = imul(result, 31) + (this._third == null ? 0 : hashCode(this._third)) | 0;
    return result;
  };
  Triple.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Triple))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof Triple ? other : THROW_CCE();
    if (!equals_1(this._first_0, tmp0_other_with_cast._first_0))
      return false;
    if (!equals_1(this._second_0, tmp0_other_with_cast._second_0))
      return false;
    if (!equals_1(this._third, tmp0_other_with_cast._third))
      return false;
    return true;
  };
  Triple.$metadata$ = {
    simpleName: 'Triple',
    kind: 'class',
    interfaces: [Serializable]
  };
  function _UByte___init__impl_(data) {
    return data;
  }
  function _UByte___get_data__impl_(this_0) {
    return this_0;
  }
  function Companion_5() {
    Companion_instance_4 = this;
    this._MIN_VALUE = _UByte___init__impl_(0);
    this._MAX_VALUE = _UByte___init__impl_(-1);
    this._SIZE_BYTES = 1;
    this._SIZE_BITS = 8;
  }
  Companion_5.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_4;
  function Companion_getInstance_4() {
    if (Companion_instance_4 == null)
      new Companion_5();
    return Companion_instance_4;
  }
  function UByte__compareTo_impl(this_0, other) {
    var tmp = _UByte___get_data__impl_(this_0) & 255;
    return compareTo(tmp, _UByte___get_data__impl_(other) & 255);
  }
  function UByte__compareTo_impl_0(this_0, other) {
    var tmp = this_0._data;
    return UByte__compareTo_impl(tmp, other instanceof UByte ? other._data : THROW_CCE());
  }
  function UByte__toString_impl(this_0) {
    return (_UByte___get_data__impl_(this_0) & 255).toString();
  }
  function UByte__hashCode_impl(this_0) {
    return this_0;
  }
  function UByte__equals_impl(this_0, other) {
    if (!(other instanceof UByte))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof UByte ? other._data : THROW_CCE();
    if (!(this_0 === tmp0_other_with_cast))
      return false;
    return true;
  }
  function UByte(data) {
    Companion_getInstance_4();
    this._data = data;
  }
  UByte.prototype.compareTo_2 = function (other) {
    return UByte__compareTo_impl(this._data, other);
  };
  UByte.prototype.compareTo_35 = function (other) {
    return UByte__compareTo_impl_0(this, other);
  };
  UByte.prototype.toString = function () {
    return UByte__toString_impl(this._data);
  };
  UByte.prototype.hashCode = function () {
    return UByte__hashCode_impl(this._data);
  };
  UByte.prototype.equals = function (other) {
    return UByte__equals_impl(this._data, other);
  };
  UByte.$metadata$ = {
    simpleName: 'UByte',
    kind: 'class',
    interfaces: [Comparable]
  };
  function _UInt___init__impl_(data) {
    return data;
  }
  function _UInt___get_data__impl_(this_0) {
    return this_0;
  }
  function Companion_6() {
    Companion_instance_5 = this;
    this._MIN_VALUE_0 = _UInt___init__impl_(0);
    this._MAX_VALUE_0 = _UInt___init__impl_(-1);
    this._SIZE_BYTES_0 = 4;
    this._SIZE_BITS_0 = 32;
  }
  Companion_6.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_5;
  function Companion_getInstance_5() {
    if (Companion_instance_5 == null)
      new Companion_6();
    return Companion_instance_5;
  }
  function UInt__compareTo_impl(this_0, other) {
    return uintCompare(_UInt___get_data__impl_(this_0), _UInt___get_data__impl_(other));
  }
  function UInt__compareTo_impl_0(this_0, other) {
    var tmp = this_0._data_0;
    return UInt__compareTo_impl(tmp, other instanceof UInt ? other._data_0 : THROW_CCE());
  }
  function UInt__toString_impl(this_0) {
    return toLong_0(_UInt___get_data__impl_(this_0)).and(new Long(-1, 0)).toString();
  }
  function UInt__hashCode_impl(this_0) {
    return this_0;
  }
  function UInt__equals_impl(this_0, other) {
    if (!(other instanceof UInt))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof UInt ? other._data_0 : THROW_CCE();
    if (!(this_0 === tmp0_other_with_cast))
      return false;
    return true;
  }
  function UInt(data) {
    Companion_getInstance_5();
    this._data_0 = data;
  }
  UInt.prototype.compareTo_4 = function (other) {
    return UInt__compareTo_impl(this._data_0, other);
  };
  UInt.prototype.compareTo_35 = function (other) {
    return UInt__compareTo_impl_0(this, other);
  };
  UInt.prototype.toString = function () {
    return UInt__toString_impl(this._data_0);
  };
  UInt.prototype.hashCode = function () {
    return UInt__hashCode_impl(this._data_0);
  };
  UInt.prototype.equals = function (other) {
    return UInt__equals_impl(this._data_0, other);
  };
  UInt.$metadata$ = {
    simpleName: 'UInt',
    kind: 'class',
    interfaces: [Comparable]
  };
  function _ULong___init__impl_(data) {
    return data;
  }
  function _ULong___get_data__impl_(this_0) {
    return this_0;
  }
  function Companion_7() {
    Companion_instance_6 = this;
    this._MIN_VALUE_1 = _ULong___init__impl_(new Long(0, 0));
    this._MAX_VALUE_1 = _ULong___init__impl_(new Long(-1, -1));
    this._SIZE_BYTES_1 = 8;
    this._SIZE_BITS_1 = 64;
  }
  Companion_7.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_6;
  function Companion_getInstance_6() {
    if (Companion_instance_6 == null)
      new Companion_7();
    return Companion_instance_6;
  }
  function ULong__compareTo_impl(this_0, other) {
    return ulongCompare(_ULong___get_data__impl_(this_0), _ULong___get_data__impl_(other));
  }
  function ULong__compareTo_impl_0(this_0, other) {
    var tmp = this_0._data_1;
    return ULong__compareTo_impl(tmp, other instanceof ULong ? other._data_1 : THROW_CCE());
  }
  function ULong__toString_impl(this_0) {
    return ulongToString(_ULong___get_data__impl_(this_0));
  }
  function ULong__hashCode_impl(this_0) {
    return this_0.hashCode();
  }
  function ULong__equals_impl(this_0, other) {
    if (!(other instanceof ULong))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof ULong ? other._data_1 : THROW_CCE();
    if (!this_0.equals(tmp0_other_with_cast))
      return false;
    return true;
  }
  function ULong(data) {
    Companion_getInstance_6();
    this._data_1 = data;
  }
  ULong.prototype.compareTo_6 = function (other) {
    return ULong__compareTo_impl(this._data_1, other);
  };
  ULong.prototype.compareTo_35 = function (other) {
    return ULong__compareTo_impl_0(this, other);
  };
  ULong.prototype.toString = function () {
    return ULong__toString_impl(this._data_1);
  };
  ULong.prototype.hashCode = function () {
    return ULong__hashCode_impl(this._data_1);
  };
  ULong.prototype.equals = function (other) {
    return ULong__equals_impl(this._data_1, other);
  };
  ULong.$metadata$ = {
    simpleName: 'ULong',
    kind: 'class',
    interfaces: [Comparable]
  };
  function _UShort___init__impl_(data) {
    return data;
  }
  function _UShort___get_data__impl_(this_0) {
    return this_0;
  }
  function Companion_8() {
    Companion_instance_7 = this;
    this._MIN_VALUE_2 = _UShort___init__impl_(0);
    this._MAX_VALUE_2 = _UShort___init__impl_(-1);
    this._SIZE_BYTES_2 = 2;
    this._SIZE_BITS_2 = 16;
  }
  Companion_8.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_7;
  function Companion_getInstance_7() {
    if (Companion_instance_7 == null)
      new Companion_8();
    return Companion_instance_7;
  }
  function UShort__compareTo_impl(this_0, other) {
    var tmp = _UShort___get_data__impl_(this_0) & 65535;
    return compareTo(tmp, _UShort___get_data__impl_(other) & 65535);
  }
  function UShort__compareTo_impl_0(this_0, other) {
    var tmp = this_0._data_2;
    return UShort__compareTo_impl(tmp, other instanceof UShort ? other._data_2 : THROW_CCE());
  }
  function UShort__toString_impl(this_0) {
    return (_UShort___get_data__impl_(this_0) & 65535).toString();
  }
  function UShort__hashCode_impl(this_0) {
    return this_0;
  }
  function UShort__equals_impl(this_0, other) {
    if (!(other instanceof UShort))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof UShort ? other._data_2 : THROW_CCE();
    if (!(this_0 === tmp0_other_with_cast))
      return false;
    return true;
  }
  function UShort(data) {
    Companion_getInstance_7();
    this._data_2 = data;
  }
  UShort.prototype.compareTo_8 = function (other) {
    return UShort__compareTo_impl(this._data_2, other);
  };
  UShort.prototype.compareTo_35 = function (other) {
    return UShort__compareTo_impl_0(this, other);
  };
  UShort.prototype.toString = function () {
    return UShort__toString_impl(this._data_2);
  };
  UShort.prototype.hashCode = function () {
    return UShort__hashCode_impl(this._data_2);
  };
  UShort.prototype.equals = function (other) {
    return UShort__equals_impl(this._data_2, other);
  };
  UShort.$metadata$ = {
    simpleName: 'UShort',
    kind: 'class',
    interfaces: [Comparable]
  };
  function toUInt(_this_) {
    var tmp0_elvis_lhs = toUIntOrNull(_this_);
    var tmp;
    var tmp_0 = tmp0_elvis_lhs;
    if ((tmp_0 == null ? null : new UInt(tmp_0)) == null) {
      numberFormatError(_this_);
    } else {
      {
        tmp = tmp0_elvis_lhs;
      }
    }
    return tmp;
  }
  function toULong(_this_) {
    var tmp0_elvis_lhs = toULongOrNull(_this_);
    var tmp;
    var tmp_0 = tmp0_elvis_lhs;
    if ((tmp_0 == null ? null : new ULong(tmp_0)) == null) {
      numberFormatError(_this_);
    } else {
      {
        tmp = tmp0_elvis_lhs;
      }
    }
    return tmp;
  }
  function toUByte(_this_) {
    var tmp0_elvis_lhs = toUByteOrNull(_this_);
    var tmp;
    var tmp_0 = tmp0_elvis_lhs;
    if ((tmp_0 == null ? null : new UByte(tmp_0)) == null) {
      numberFormatError(_this_);
    } else {
      {
        tmp = tmp0_elvis_lhs;
      }
    }
    return tmp;
  }
  function toUShort(_this_) {
    var tmp0_elvis_lhs = toUShortOrNull(_this_);
    var tmp;
    var tmp_0 = tmp0_elvis_lhs;
    if ((tmp_0 == null ? null : new UShort(tmp_0)) == null) {
      numberFormatError(_this_);
    } else {
      {
        tmp = tmp0_elvis_lhs;
      }
    }
    return tmp;
  }
  function toULongOrNull(_this_) {
    return toULongOrNull_0(_this_, 10);
  }
  function toUIntOrNull(_this_) {
    return toUIntOrNull_0(_this_, 10);
  }
  function toUByteOrNull(_this_) {
    return toUByteOrNull_0(_this_, 10);
  }
  function toUShortOrNull(_this_) {
    return toUShortOrNull_0(_this_, 10);
  }
  function toULongOrNull_0(_this_, radix) {
    checkRadix(radix);
    Unit_getInstance();
    var length = _this_.length;
    if (length === 0)
      return null;
    var limit = _ULong___init__impl_(new Long(-1, -1));
    var start;
    var firstChar = charSequenceGet(_this_, 0);
    if (firstChar.compareTo_12(new Char(48)) < 0) {
      if (length === 1 ? true : !firstChar.equals(new Char(43)))
        return null;
      start = 1;
    } else {
      start = 0;
    }
    var limitForMaxRadix = _ULong___init__impl_(new Long(477218588, 119304647));
    var limitBeforeMul = limitForMaxRadix;
    var uradix = _ULong___init__impl_(toLong_0(radix));
    var result = _ULong___init__impl_(new Long(0, 0));
    var inductionVariable = start;
    if (inductionVariable < length)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var digit = digitOf(charSequenceGet(_this_, i), radix);
        if (digit < 0)
          return null;
        var tmp0_compareTo_0 = result;
        var tmp1_compareTo_0 = limitBeforeMul;
        if (ulongCompare(_ULong___get_data__impl_(tmp0_compareTo_0), _ULong___get_data__impl_(tmp1_compareTo_0)) > 0) {
          if (equals_1(new ULong(limitBeforeMul), new ULong(limitForMaxRadix))) {
            limitBeforeMul = ulongDivide(limit, uradix);
            var tmp2_compareTo_0 = result;
            var tmp3_compareTo_0 = limitBeforeMul;
            if (ulongCompare(_ULong___get_data__impl_(tmp2_compareTo_0), _ULong___get_data__impl_(tmp3_compareTo_0)) > 0) {
              return null;
            } else {
            }
          } else {
            return null;
          }
        } else {
        }
        var tmp4_times_0 = result;
        result = _ULong___init__impl_(_ULong___get_data__impl_(tmp4_times_0).times_27(_ULong___get_data__impl_(uradix)));
        var beforeAdding = result;
        var tmp5_plus_0 = result;
        var tmp6_plus_0 = _UInt___init__impl_(digit);
        var tmp0_plus_0_1 = _ULong___init__impl_(toLong_0(_UInt___get_data__impl_(tmp6_plus_0)).and(new Long(-1, 0)));
        result = _ULong___init__impl_(_ULong___get_data__impl_(tmp5_plus_0).plus_56(_ULong___get_data__impl_(tmp0_plus_0_1)));
        var tmp7_compareTo_0 = result;
        if (ulongCompare(_ULong___get_data__impl_(tmp7_compareTo_0), _ULong___get_data__impl_(beforeAdding)) < 0)
          return null;
        else {
        }
      }
       while (inductionVariable < length);
    return result;
  }
  function toUIntOrNull_0(_this_, radix) {
    checkRadix(radix);
    Unit_getInstance();
    var length = _this_.length;
    if (length === 0)
      return null;
    var limit = _UInt___init__impl_(-1);
    var start;
    var firstChar = charSequenceGet(_this_, 0);
    if (firstChar.compareTo_12(new Char(48)) < 0) {
      if (length === 1 ? true : !firstChar.equals(new Char(43)))
        return null;
      start = 1;
    } else {
      start = 0;
    }
    var limitForMaxRadix = _UInt___init__impl_(119304647);
    var limitBeforeMul = limitForMaxRadix;
    var uradix = _UInt___init__impl_(radix);
    var result = _UInt___init__impl_(0);
    var inductionVariable = start;
    if (inductionVariable < length)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var digit = digitOf(charSequenceGet(_this_, i), radix);
        if (digit < 0)
          return null;
        var tmp0_compareTo_0 = result;
        var tmp1_compareTo_0 = limitBeforeMul;
        if (uintCompare(_UInt___get_data__impl_(tmp0_compareTo_0), _UInt___get_data__impl_(tmp1_compareTo_0)) > 0) {
          if (equals_1(new UInt(limitBeforeMul), new UInt(limitForMaxRadix))) {
            limitBeforeMul = uintDivide(limit, uradix);
            var tmp2_compareTo_0 = result;
            var tmp3_compareTo_0 = limitBeforeMul;
            if (uintCompare(_UInt___get_data__impl_(tmp2_compareTo_0), _UInt___get_data__impl_(tmp3_compareTo_0)) > 0) {
              return null;
            } else {
            }
          } else {
            return null;
          }
        } else {
        }
        var tmp4_times_0 = result;
        result = _UInt___init__impl_(imul(_UInt___get_data__impl_(tmp4_times_0), _UInt___get_data__impl_(uradix)));
        var beforeAdding = result;
        var tmp5_plus_0 = result;
        var tmp6_plus_0 = _UInt___init__impl_(digit);
        result = _UInt___init__impl_(_UInt___get_data__impl_(tmp5_plus_0) + _UInt___get_data__impl_(tmp6_plus_0) | 0);
        var tmp7_compareTo_0 = result;
        if (uintCompare(_UInt___get_data__impl_(tmp7_compareTo_0), _UInt___get_data__impl_(beforeAdding)) < 0)
          return null;
        else {
        }
      }
       while (inductionVariable < length);
    return result;
  }
  function toUByteOrNull_0(_this_, radix) {
    var tmp0_elvis_lhs = toUIntOrNull_0(_this_, radix);
    var tmp;
    var tmp_0 = tmp0_elvis_lhs;
    if ((tmp_0 == null ? null : new UInt(tmp_0)) == null) {
      return null;
    } else {
      {
        tmp = tmp0_elvis_lhs;
      }
    }
    var int = tmp;
    var tmp0_compareTo_0 = _UByte___init__impl_(-1);
    var tmp0_compareTo_0_1 = _UInt___init__impl_(_UByte___get_data__impl_(tmp0_compareTo_0) & 255);
    if (uintCompare(_UInt___get_data__impl_(int), _UInt___get_data__impl_(tmp0_compareTo_0_1)) > 0)
      return null;
    else {
    }
    var tmp0_toUByte_0_1 = _UInt___get_data__impl_(int);
    return _UByte___init__impl_(toByte_0(tmp0_toUByte_0_1));
  }
  function toUShortOrNull_0(_this_, radix) {
    var tmp0_elvis_lhs = toUIntOrNull_0(_this_, radix);
    var tmp;
    var tmp_0 = tmp0_elvis_lhs;
    if ((tmp_0 == null ? null : new UInt(tmp_0)) == null) {
      return null;
    } else {
      {
        tmp = tmp0_elvis_lhs;
      }
    }
    var int = tmp;
    var tmp0_compareTo_0 = _UShort___init__impl_(-1);
    var tmp0_compareTo_0_1 = _UInt___init__impl_(_UShort___get_data__impl_(tmp0_compareTo_0) & 65535);
    if (uintCompare(_UInt___get_data__impl_(int), _UInt___get_data__impl_(tmp0_compareTo_0_1)) > 0)
      return null;
    else {
    }
    var tmp0_toUShort_0_1 = _UInt___get_data__impl_(int);
    return _UShort___init__impl_(toShort_0(tmp0_toUShort_0_1));
  }
  function uintCompare(v1, v2) {
    return compareTo(v1 ^ IntCompanionObject_getInstance()._MIN_VALUE_5, v2 ^ IntCompanionObject_getInstance()._MIN_VALUE_5);
  }
  function uintDivide(v1, v2) {
    var tmp = toLong_0(_UInt___get_data__impl_(v1)).and(new Long(-1, 0));
    var tmp0_toUInt_0 = tmp.div_27(toLong_0(_UInt___get_data__impl_(v2)).and(new Long(-1, 0)));
    return _UInt___init__impl_(tmp0_toUInt_0.toInt_5());
  }
  function ulongCompare(v1, v2) {
    return v1.xor(new Long(0, -2147483648)).compareTo_69(v2.xor(new Long(0, -2147483648)));
  }
  function ulongDivide(v1, v2) {
    var dividend = _ULong___get_data__impl_(v1);
    var divisor = _ULong___get_data__impl_(v2);
    if (divisor.compareTo_69(new Long(0, 0)) < 0) {
      var tmp;
      if (ulongCompare(_ULong___get_data__impl_(v1), _ULong___get_data__impl_(v2)) < 0) {
        tmp = _ULong___init__impl_(new Long(0, 0));
      } else {
        {
          tmp = _ULong___init__impl_(new Long(1, 0));
        }
      }
      return tmp;
    }if (dividend.compareTo_69(new Long(0, 0)) >= 0) {
      return _ULong___init__impl_(dividend.div_27(divisor));
    }var quotient = dividend.ushr_0(1).div_27(divisor).shl_0(1);
    var rem = dividend.minus_29(quotient.times_27(divisor));
    var tmp_0;
    var tmp0_compareTo_0 = _ULong___init__impl_(rem);
    var tmp1_compareTo_0 = _ULong___init__impl_(divisor);
    if (ulongCompare(_ULong___get_data__impl_(tmp0_compareTo_0), _ULong___get_data__impl_(tmp1_compareTo_0)) >= 0) {
      tmp_0 = 1;
    } else {
      {
        tmp_0 = 0;
      }
    }
    var tmp2_plus_0 = tmp_0;
    return _ULong___init__impl_(quotient.plus_56(toLong_0(tmp2_plus_0)));
  }
  function ulongToString(v) {
    return ulongToString_0(v, 10);
  }
  function ulongToString_0(v, base) {
    if (v.compareTo_69(new Long(0, 0)) >= 0)
      return toString_2(v, base);
    var tmp0_div_0 = v.ushr_0(1);
    var quotient = tmp0_div_0.div_27(toLong_0(base)).shl_0(1);
    var tmp1_times_0 = quotient;
    var rem = v.minus_29(tmp1_times_0.times_27(toLong_0(base)));
    if (rem.compareTo_69(toLong_0(base)) >= 0) {
      var tmp2_minus_0 = rem;
      rem = tmp2_minus_0.minus_29(toLong_0(base));
      var tmp3_plus_0 = quotient;
      var tmp4_plus_0 = 1;
      quotient = tmp3_plus_0.plus_56(toLong_0(tmp4_plus_0));
    }return toString_2(quotient, base) + toString_2(rem, base);
  }
  function Annotation() {
  }
  Annotation.$metadata$ = {
    simpleName: 'Annotation',
    kind: 'interface',
    interfaces: []
  };
  function CharSequence() {
  }
  CharSequence.$metadata$ = {
    simpleName: 'CharSequence',
    kind: 'interface',
    interfaces: []
  };
  function Comparable() {
  }
  Comparable.$metadata$ = {
    simpleName: 'Comparable',
    kind: 'interface',
    interfaces: []
  };
  function Iterator() {
  }
  Iterator.$metadata$ = {
    simpleName: 'Iterator',
    kind: 'interface',
    interfaces: []
  };
  function MutableIterator() {
  }
  MutableIterator.$metadata$ = {
    simpleName: 'MutableIterator',
    kind: 'interface',
    interfaces: [Iterator]
  };
  function ListIterator() {
  }
  ListIterator.$metadata$ = {
    simpleName: 'ListIterator',
    kind: 'interface',
    interfaces: [Iterator]
  };
  function MutableListIterator() {
  }
  MutableListIterator.$metadata$ = {
    simpleName: 'MutableListIterator',
    kind: 'interface',
    interfaces: [ListIterator, MutableIterator]
  };
  function Number_0() {
  }
  Number_0.$metadata$ = {
    simpleName: 'Number',
    kind: 'class',
    interfaces: []
  };
  function IntIterator() {
  }
  IntIterator.prototype.next_35 = function () {
    return this.nextInt_3();
  };
  IntIterator.$metadata$ = {
    simpleName: 'IntIterator',
    kind: 'class',
    interfaces: [Iterator]
  };
  function CharIterator() {
  }
  CharIterator.prototype.next_35 = function () {
    return this.nextChar_1();
  };
  CharIterator.$metadata$ = {
    simpleName: 'CharIterator',
    kind: 'class',
    interfaces: [Iterator]
  };
  function IntProgressionIterator(first_1, last_1, step_0) {
    IntIterator.call(this);
    this._step = step_0;
    this._finalElement = last_1;
    this._hasNext = this._step > 0 ? first_1 <= last_1 : first_1 >= last_1;
    this._next_0 = this._hasNext ? first_1 : this._finalElement;
  }
  IntProgressionIterator.prototype.hasNext_31 = function () {
    return this._hasNext;
  };
  IntProgressionIterator.prototype.nextInt_3 = function () {
    var value = this._next_0;
    if (value === this._finalElement) {
      if (!this._hasNext)
        throw NoSuchElementException_init_$Create$();
      this._hasNext = false;
    } else {
      var tmp0_this = this;
      tmp0_this._next_0 = tmp0_this._next_0 + this._step | 0;
    }
    return value;
  };
  IntProgressionIterator.$metadata$ = {
    simpleName: 'IntProgressionIterator',
    kind: 'class',
    interfaces: []
  };
  function CharProgressionIterator(first_1, last_1, step_0) {
    CharIterator.call(this);
    this._step_0 = step_0;
    this._finalElement_0 = last_1.toInt_5();
    this._hasNext_0 = this._step_0 > 0 ? first_1.compareTo_12(last_1) <= 0 : first_1.compareTo_12(last_1) >= 0;
    this._next_1 = this._hasNext_0 ? first_1.toInt_5() : this._finalElement_0;
  }
  CharProgressionIterator.prototype.hasNext_31 = function () {
    return this._hasNext_0;
  };
  CharProgressionIterator.prototype.nextChar_1 = function () {
    var value = this._next_1;
    if (value === this._finalElement_0) {
      if (!this._hasNext_0)
        throw NoSuchElementException_init_$Create$();
      this._hasNext_0 = false;
    } else {
      var tmp0_this = this;
      tmp0_this._next_1 = tmp0_this._next_1 + this._step_0 | 0;
    }
    return numberToChar(value);
  };
  CharProgressionIterator.$metadata$ = {
    simpleName: 'CharProgressionIterator',
    kind: 'class',
    interfaces: []
  };
  function Companion_9() {
    Companion_instance_8 = this;
  }
  Companion_9.prototype.fromClosedRange = function (rangeStart, rangeEnd, step_0) {
    return new IntProgression(rangeStart, rangeEnd, step_0);
  };
  Companion_9.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_8;
  function Companion_getInstance_8() {
    if (Companion_instance_8 == null)
      new Companion_9();
    return Companion_instance_8;
  }
  function IntProgression(start, endInclusive, step_0) {
    Companion_getInstance_8();
    if (step_0 === 0)
      throw IllegalArgumentException_init_$Create$_0('Step must be non-zero.');
    if (step_0 === IntCompanionObject_getInstance()._MIN_VALUE_5)
      throw IllegalArgumentException_init_$Create$_0('Step must be greater than Int.MIN_VALUE to avoid overflow on negation.');
    this._first_1 = start;
    this._last = getProgressionLastElement(start, endInclusive, step_0);
    this._step_1 = step_0;
  }
  IntProgression.prototype._get_first__2 = function () {
    return this._first_1;
  };
  IntProgression.prototype._get_last__2 = function () {
    return this._last;
  };
  IntProgression.prototype.iterator_64 = function () {
    return new IntProgressionIterator(this._first_1, this._last, this._step_1);
  };
  IntProgression.prototype.isEmpty_53 = function () {
    return this._step_1 > 0 ? this._first_1 > this._last : this._first_1 < this._last;
  };
  IntProgression.prototype.equals = function (other) {
    var tmp;
    if (other instanceof IntProgression) {
      tmp = (this.isEmpty_53() ? other.isEmpty_53() : false) ? true : (this._first_1 === other._first_1 ? this._last === other._last : false) ? this._step_1 === other._step_1 : false;
    } else {
      {
        tmp = false;
      }
    }
    return tmp;
  };
  IntProgression.prototype.hashCode = function () {
    return this.isEmpty_53() ? -1 : imul(31, imul(31, this._first_1) + this._last | 0) + this._step_1 | 0;
  };
  IntProgression.prototype.toString = function () {
    return this._step_1 > 0 ? '' + this._first_1 + '..' + this._last + ' step ' + this._step_1 : '' + this._first_1 + ' downTo ' + this._last + ' step ' + (-this._step_1 | 0);
  };
  IntProgression.$metadata$ = {
    simpleName: 'IntProgression',
    kind: 'class',
    interfaces: [Iterable]
  };
  function Companion_10() {
    Companion_instance_9 = this;
  }
  Companion_10.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_9;
  function Companion_getInstance_9() {
    if (Companion_instance_9 == null)
      new Companion_10();
    return Companion_instance_9;
  }
  function CharProgression(start, endInclusive, step_0) {
    Companion_getInstance_9();
    if (step_0 === 0)
      throw IllegalArgumentException_init_$Create$_0('Step must be non-zero.');
    if (step_0 === IntCompanionObject_getInstance()._MIN_VALUE_5)
      throw IllegalArgumentException_init_$Create$_0('Step must be greater than Int.MIN_VALUE to avoid overflow on negation.');
    this._first_2 = start;
    this._last_0 = numberToChar(getProgressionLastElement(start.toInt_5(), endInclusive.toInt_5(), step_0));
    this._step_2 = step_0;
  }
  CharProgression.prototype._get_first__2 = function () {
    return this._first_2;
  };
  CharProgression.prototype._get_last__2 = function () {
    return this._last_0;
  };
  CharProgression.prototype.iterator_64 = function () {
    return new CharProgressionIterator(this._first_2, this._last_0, this._step_2);
  };
  CharProgression.prototype.isEmpty_53 = function () {
    return this._step_2 > 0 ? this._first_2.compareTo_12(this._last_0) > 0 : this._first_2.compareTo_12(this._last_0) < 0;
  };
  CharProgression.prototype.equals = function (other) {
    var tmp;
    if (other instanceof CharProgression) {
      tmp = (this.isEmpty_53() ? other.isEmpty_53() : false) ? true : (this._first_2.equals(other._first_2) ? this._last_0.equals(other._last_0) : false) ? this._step_2 === other._step_2 : false;
    } else {
      {
        tmp = false;
      }
    }
    return tmp;
  };
  CharProgression.prototype.hashCode = function () {
    return this.isEmpty_53() ? -1 : imul(31, imul(31, this._first_2.toInt_5()) + this._last_0.toInt_5() | 0) + this._step_2 | 0;
  };
  CharProgression.prototype.toString = function () {
    return this._step_2 > 0 ? '' + this._first_2 + '..' + this._last_0 + ' step ' + this._step_2 : '' + this._first_2 + ' downTo ' + this._last_0 + ' step ' + (-this._step_2 | 0);
  };
  CharProgression.$metadata$ = {
    simpleName: 'CharProgression',
    kind: 'class',
    interfaces: [Iterable]
  };
  function ClosedRange() {
  }
  ClosedRange.$metadata$ = {
    simpleName: 'ClosedRange',
    kind: 'interface',
    interfaces: []
  };
  function Companion_11() {
    Companion_instance_10 = this;
    this._EMPTY = new IntRange(1, 0);
  }
  Companion_11.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_10;
  function Companion_getInstance_10() {
    if (Companion_instance_10 == null)
      new Companion_11();
    return Companion_instance_10;
  }
  function IntRange(start, endInclusive) {
    Companion_getInstance_10();
    IntProgression.call(this, start, endInclusive, 1);
  }
  IntRange.prototype._get_start__1 = function () {
    return this._get_first__2();
  };
  IntRange.prototype._get_endInclusive__1 = function () {
    return this._get_last__2();
  };
  IntRange.prototype.isEmpty_53 = function () {
    return this._get_first__2() > this._get_last__2();
  };
  IntRange.prototype.equals = function (other) {
    var tmp;
    if (other instanceof IntRange) {
      tmp = (this.isEmpty_53() ? other.isEmpty_53() : false) ? true : this._get_first__2() === other._get_first__2() ? this._get_last__2() === other._get_last__2() : false;
    } else {
      {
        tmp = false;
      }
    }
    return tmp;
  };
  IntRange.prototype.hashCode = function () {
    return this.isEmpty_53() ? -1 : imul(31, this._get_first__2()) + this._get_last__2() | 0;
  };
  IntRange.prototype.toString = function () {
    return '' + this._get_first__2() + '..' + this._get_last__2();
  };
  IntRange.$metadata$ = {
    simpleName: 'IntRange',
    kind: 'class',
    interfaces: [ClosedRange]
  };
  function Companion_12() {
    Companion_instance_11 = this;
    this._EMPTY_0 = new CharRange(new Char(1), new Char(0));
  }
  Companion_12.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_11;
  function Companion_getInstance_11() {
    if (Companion_instance_11 == null)
      new Companion_12();
    return Companion_instance_11;
  }
  function CharRange(start, endInclusive) {
    Companion_getInstance_11();
    CharProgression.call(this, start, endInclusive, 1);
  }
  CharRange.prototype.isEmpty_53 = function () {
    return this._get_first__2().compareTo_12(this._get_last__2()) > 0;
  };
  CharRange.prototype.equals = function (other) {
    var tmp;
    if (other instanceof CharRange) {
      tmp = (this.isEmpty_53() ? other.isEmpty_53() : false) ? true : this._get_first__2().equals(other._get_first__2()) ? this._get_last__2().equals(other._get_last__2()) : false;
    } else {
      {
        tmp = false;
      }
    }
    return tmp;
  };
  CharRange.prototype.hashCode = function () {
    return this.isEmpty_53() ? -1 : imul(31, this._get_first__2().toInt_5()) + this._get_last__2().toInt_5() | 0;
  };
  CharRange.prototype.toString = function () {
    return '' + this._get_first__2() + '..' + this._get_last__2();
  };
  CharRange.$metadata$ = {
    simpleName: 'CharRange',
    kind: 'class',
    interfaces: [ClosedRange]
  };
  function Unit() {
    Unit_instance = this;
  }
  Unit.prototype.toString = function () {
    return 'kotlin.Unit';
  };
  Unit.$metadata$ = {
    simpleName: 'Unit',
    kind: 'object',
    interfaces: []
  };
  var Unit_instance;
  function Unit_getInstance() {
    if (Unit_instance == null)
      new Unit();
    return Unit_instance;
  }
  function getProgressionLastElement(start, end, step_0) {
    var tmp;
    if (step_0 > 0) {
      tmp = start >= end ? end : end - differenceModulo(end, start, step_0) | 0;
    } else if (step_0 < 0) {
      tmp = start <= end ? end : end + differenceModulo(start, end, -step_0 | 0) | 0;
    } else {
      throw IllegalArgumentException_init_$Create$_0('Step is zero.');
    }
    return tmp;
  }
  function differenceModulo(a, b, c) {
    return mod(mod(a, c) - mod(b, c) | 0, c);
  }
  function mod(a, b) {
    var mod_0 = a % b;
    return mod_0 >= 0 ? mod_0 : mod_0 + b | 0;
  }
  function ByteCompanionObject_0() {
    ByteCompanionObject_instance = this;
    this._MIN_VALUE_3 = -128;
    this._MAX_VALUE_3 = 127;
    this._SIZE_BYTES_3 = 1;
    this._SIZE_BITS_3 = 8;
  }
  ByteCompanionObject_0.prototype._get_MIN_VALUE__3 = function () {
    return this._MIN_VALUE_3;
  };
  ByteCompanionObject_0.prototype._get_MAX_VALUE__3 = function () {
    return this._MAX_VALUE_3;
  };
  ByteCompanionObject_0.prototype._get_SIZE_BYTES__3 = function () {
    return this._SIZE_BYTES_3;
  };
  ByteCompanionObject_0.prototype._get_SIZE_BITS__3 = function () {
    return this._SIZE_BITS_3;
  };
  ByteCompanionObject_0.$metadata$ = {
    simpleName: 'ByteCompanionObject',
    kind: 'object',
    interfaces: []
  };
  Object.defineProperty(ByteCompanionObject_0.prototype, 'MIN_VALUE', {
    configurable: true,
    get: ByteCompanionObject_0.prototype._get_MIN_VALUE__3
  });
  Object.defineProperty(ByteCompanionObject_0.prototype, 'MAX_VALUE', {
    configurable: true,
    get: ByteCompanionObject_0.prototype._get_MAX_VALUE__3
  });
  Object.defineProperty(ByteCompanionObject_0.prototype, 'SIZE_BYTES', {
    configurable: true,
    get: ByteCompanionObject_0.prototype._get_SIZE_BYTES__3
  });
  Object.defineProperty(ByteCompanionObject_0.prototype, 'SIZE_BITS', {
    configurable: true,
    get: ByteCompanionObject_0.prototype._get_SIZE_BITS__3
  });
  var ByteCompanionObject_instance;
  function ByteCompanionObject_getInstance() {
    if (ByteCompanionObject_instance == null)
      new ByteCompanionObject_0();
    return ByteCompanionObject_instance;
  }
  function ShortCompanionObject_0() {
    ShortCompanionObject_instance = this;
    this._MIN_VALUE_4 = -32768;
    this._MAX_VALUE_4 = 32767;
    this._SIZE_BYTES_4 = 2;
    this._SIZE_BITS_4 = 16;
  }
  ShortCompanionObject_0.prototype._get_MIN_VALUE__3 = function () {
    return this._MIN_VALUE_4;
  };
  ShortCompanionObject_0.prototype._get_MAX_VALUE__3 = function () {
    return this._MAX_VALUE_4;
  };
  ShortCompanionObject_0.prototype._get_SIZE_BYTES__3 = function () {
    return this._SIZE_BYTES_4;
  };
  ShortCompanionObject_0.prototype._get_SIZE_BITS__3 = function () {
    return this._SIZE_BITS_4;
  };
  ShortCompanionObject_0.$metadata$ = {
    simpleName: 'ShortCompanionObject',
    kind: 'object',
    interfaces: []
  };
  Object.defineProperty(ShortCompanionObject_0.prototype, 'MIN_VALUE', {
    configurable: true,
    get: ShortCompanionObject_0.prototype._get_MIN_VALUE__3
  });
  Object.defineProperty(ShortCompanionObject_0.prototype, 'MAX_VALUE', {
    configurable: true,
    get: ShortCompanionObject_0.prototype._get_MAX_VALUE__3
  });
  Object.defineProperty(ShortCompanionObject_0.prototype, 'SIZE_BYTES', {
    configurable: true,
    get: ShortCompanionObject_0.prototype._get_SIZE_BYTES__3
  });
  Object.defineProperty(ShortCompanionObject_0.prototype, 'SIZE_BITS', {
    configurable: true,
    get: ShortCompanionObject_0.prototype._get_SIZE_BITS__3
  });
  var ShortCompanionObject_instance;
  function ShortCompanionObject_getInstance() {
    if (ShortCompanionObject_instance == null)
      new ShortCompanionObject_0();
    return ShortCompanionObject_instance;
  }
  function IntCompanionObject_0() {
    IntCompanionObject_instance = this;
    this._MIN_VALUE_5 = -2147483648;
    this._MAX_VALUE_5 = 2147483647;
    this._SIZE_BYTES_5 = 4;
    this._SIZE_BITS_5 = 32;
  }
  IntCompanionObject_0.prototype._get_MIN_VALUE__3 = function () {
    return this._MIN_VALUE_5;
  };
  IntCompanionObject_0.prototype._get_MAX_VALUE__3 = function () {
    return this._MAX_VALUE_5;
  };
  IntCompanionObject_0.prototype._get_SIZE_BYTES__3 = function () {
    return this._SIZE_BYTES_5;
  };
  IntCompanionObject_0.prototype._get_SIZE_BITS__3 = function () {
    return this._SIZE_BITS_5;
  };
  IntCompanionObject_0.$metadata$ = {
    simpleName: 'IntCompanionObject',
    kind: 'object',
    interfaces: []
  };
  Object.defineProperty(IntCompanionObject_0.prototype, 'MIN_VALUE', {
    configurable: true,
    get: IntCompanionObject_0.prototype._get_MIN_VALUE__3
  });
  Object.defineProperty(IntCompanionObject_0.prototype, 'MAX_VALUE', {
    configurable: true,
    get: IntCompanionObject_0.prototype._get_MAX_VALUE__3
  });
  Object.defineProperty(IntCompanionObject_0.prototype, 'SIZE_BYTES', {
    configurable: true,
    get: IntCompanionObject_0.prototype._get_SIZE_BYTES__3
  });
  Object.defineProperty(IntCompanionObject_0.prototype, 'SIZE_BITS', {
    configurable: true,
    get: IntCompanionObject_0.prototype._get_SIZE_BITS__3
  });
  var IntCompanionObject_instance;
  function IntCompanionObject_getInstance() {
    if (IntCompanionObject_instance == null)
      new IntCompanionObject_0();
    return IntCompanionObject_instance;
  }
  function FloatCompanionObject_0() {
    FloatCompanionObject_instance = this;
    this._MIN_VALUE_6 = 1.4E-45;
    this._MAX_VALUE_6 = 3.4028235E38;
    this._POSITIVE_INFINITY = Infinity;
    this._NEGATIVE_INFINITY = -Infinity;
    this._NaN = NaN;
    this._SIZE_BYTES_6 = 4;
    this._SIZE_BITS_6 = 32;
  }
  FloatCompanionObject_0.prototype._get_MIN_VALUE__3 = function () {
    return this._MIN_VALUE_6;
  };
  FloatCompanionObject_0.prototype._get_MAX_VALUE__3 = function () {
    return this._MAX_VALUE_6;
  };
  FloatCompanionObject_0.prototype._get_POSITIVE_INFINITY__0 = function () {
    return this._POSITIVE_INFINITY;
  };
  FloatCompanionObject_0.prototype._get_NEGATIVE_INFINITY__0 = function () {
    return this._NEGATIVE_INFINITY;
  };
  FloatCompanionObject_0.prototype._get_NaN__0 = function () {
    return this._NaN;
  };
  FloatCompanionObject_0.prototype._get_SIZE_BYTES__3 = function () {
    return this._SIZE_BYTES_6;
  };
  FloatCompanionObject_0.prototype._get_SIZE_BITS__3 = function () {
    return this._SIZE_BITS_6;
  };
  FloatCompanionObject_0.$metadata$ = {
    simpleName: 'FloatCompanionObject',
    kind: 'object',
    interfaces: []
  };
  Object.defineProperty(FloatCompanionObject_0.prototype, 'MIN_VALUE', {
    configurable: true,
    get: FloatCompanionObject_0.prototype._get_MIN_VALUE__3
  });
  Object.defineProperty(FloatCompanionObject_0.prototype, 'MAX_VALUE', {
    configurable: true,
    get: FloatCompanionObject_0.prototype._get_MAX_VALUE__3
  });
  Object.defineProperty(FloatCompanionObject_0.prototype, 'POSITIVE_INFINITY', {
    configurable: true,
    get: FloatCompanionObject_0.prototype._get_POSITIVE_INFINITY__0
  });
  Object.defineProperty(FloatCompanionObject_0.prototype, 'NEGATIVE_INFINITY', {
    configurable: true,
    get: FloatCompanionObject_0.prototype._get_NEGATIVE_INFINITY__0
  });
  Object.defineProperty(FloatCompanionObject_0.prototype, 'NaN', {
    configurable: true,
    get: FloatCompanionObject_0.prototype._get_NaN__0
  });
  Object.defineProperty(FloatCompanionObject_0.prototype, 'SIZE_BYTES', {
    configurable: true,
    get: FloatCompanionObject_0.prototype._get_SIZE_BYTES__3
  });
  Object.defineProperty(FloatCompanionObject_0.prototype, 'SIZE_BITS', {
    configurable: true,
    get: FloatCompanionObject_0.prototype._get_SIZE_BITS__3
  });
  var FloatCompanionObject_instance;
  function FloatCompanionObject_getInstance() {
    if (FloatCompanionObject_instance == null)
      new FloatCompanionObject_0();
    return FloatCompanionObject_instance;
  }
  function DoubleCompanionObject_0() {
    DoubleCompanionObject_instance = this;
    this._MIN_VALUE_7 = 4.9E-324;
    this._MAX_VALUE_7 = 1.7976931348623157E308;
    this._POSITIVE_INFINITY_0 = Infinity;
    this._NEGATIVE_INFINITY_0 = -Infinity;
    this._NaN_0 = NaN;
    this._SIZE_BYTES_7 = 8;
    this._SIZE_BITS_7 = 64;
  }
  DoubleCompanionObject_0.prototype._get_MIN_VALUE__3 = function () {
    return this._MIN_VALUE_7;
  };
  DoubleCompanionObject_0.prototype._get_MAX_VALUE__3 = function () {
    return this._MAX_VALUE_7;
  };
  DoubleCompanionObject_0.prototype._get_POSITIVE_INFINITY__0 = function () {
    return this._POSITIVE_INFINITY_0;
  };
  DoubleCompanionObject_0.prototype._get_NEGATIVE_INFINITY__0 = function () {
    return this._NEGATIVE_INFINITY_0;
  };
  DoubleCompanionObject_0.prototype._get_NaN__0 = function () {
    return this._NaN_0;
  };
  DoubleCompanionObject_0.prototype._get_SIZE_BYTES__3 = function () {
    return this._SIZE_BYTES_7;
  };
  DoubleCompanionObject_0.prototype._get_SIZE_BITS__3 = function () {
    return this._SIZE_BITS_7;
  };
  DoubleCompanionObject_0.$metadata$ = {
    simpleName: 'DoubleCompanionObject',
    kind: 'object',
    interfaces: []
  };
  Object.defineProperty(DoubleCompanionObject_0.prototype, 'MIN_VALUE', {
    configurable: true,
    get: DoubleCompanionObject_0.prototype._get_MIN_VALUE__3
  });
  Object.defineProperty(DoubleCompanionObject_0.prototype, 'MAX_VALUE', {
    configurable: true,
    get: DoubleCompanionObject_0.prototype._get_MAX_VALUE__3
  });
  Object.defineProperty(DoubleCompanionObject_0.prototype, 'POSITIVE_INFINITY', {
    configurable: true,
    get: DoubleCompanionObject_0.prototype._get_POSITIVE_INFINITY__0
  });
  Object.defineProperty(DoubleCompanionObject_0.prototype, 'NEGATIVE_INFINITY', {
    configurable: true,
    get: DoubleCompanionObject_0.prototype._get_NEGATIVE_INFINITY__0
  });
  Object.defineProperty(DoubleCompanionObject_0.prototype, 'NaN', {
    configurable: true,
    get: DoubleCompanionObject_0.prototype._get_NaN__0
  });
  Object.defineProperty(DoubleCompanionObject_0.prototype, 'SIZE_BYTES', {
    configurable: true,
    get: DoubleCompanionObject_0.prototype._get_SIZE_BYTES__3
  });
  Object.defineProperty(DoubleCompanionObject_0.prototype, 'SIZE_BITS', {
    configurable: true,
    get: DoubleCompanionObject_0.prototype._get_SIZE_BITS__3
  });
  var DoubleCompanionObject_instance;
  function DoubleCompanionObject_getInstance() {
    if (DoubleCompanionObject_instance == null)
      new DoubleCompanionObject_0();
    return DoubleCompanionObject_instance;
  }
  function StringCompanionObject() {
    StringCompanionObject_instance = this;
  }
  StringCompanionObject.$metadata$ = {
    simpleName: 'StringCompanionObject',
    kind: 'object',
    interfaces: []
  };
  var StringCompanionObject_instance;
  function StringCompanionObject_getInstance() {
    if (StringCompanionObject_instance == null)
      new StringCompanionObject();
    return StringCompanionObject_instance;
  }
  function BooleanCompanionObject() {
    BooleanCompanionObject_instance = this;
  }
  BooleanCompanionObject.$metadata$ = {
    simpleName: 'BooleanCompanionObject',
    kind: 'object',
    interfaces: []
  };
  var BooleanCompanionObject_instance;
  function BooleanCompanionObject_getInstance() {
    if (BooleanCompanionObject_instance == null)
      new BooleanCompanionObject();
    return BooleanCompanionObject_instance;
  }
  function Comparator() {
  }
  Comparator.$metadata$ = {
    simpleName: 'Comparator',
    kind: 'interface',
    interfaces: []
  };
  function setOf_0(element) {
    return hashSetOf([element]);
  }
  function mapCapacity(expectedSize) {
    return expectedSize;
  }
  function mapOf_0(pair) {
    return hashMapOf([pair]);
  }
  function listOf_0(element) {
    return arrayListOf([element]);
  }
  function arrayCopy_0(source, destination, destinationOffset, startIndex, endIndex) {
    Companion_getInstance().checkRangeIndexes(startIndex, endIndex, source.length);
    var rangeSize = endIndex - startIndex | 0;
    Companion_getInstance().checkRangeIndexes(destinationOffset, destinationOffset + rangeSize | 0, destination.length);
    if (ArrayBuffer.isView(destination) && ArrayBuffer.isView(source)) {
      var subrange = source.subarray(startIndex, endIndex);
      destination.set(subrange, destinationOffset);
    } else {
      if (!(source === destination) ? true : destinationOffset <= startIndex) {
        var inductionVariable = 0;
        if (inductionVariable < rangeSize)
          do {
            var index = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            destination[destinationOffset + index | 0] = source[startIndex + index | 0];
          }
           while (inductionVariable < rangeSize);
      } else {
        var inductionVariable_0 = rangeSize - 1 | 0;
        if (0 <= inductionVariable_0)
          do {
            var index_0 = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + -1 | 0;
            destination[destinationOffset + index_0 | 0] = source[startIndex + index_0 | 0];
          }
           while (0 <= inductionVariable_0);
      }
    }
  }
  function checkIndexOverflow(index) {
    if (index < 0) {
      throwIndexOverflow();
    }return index;
  }
  function sortWith(_this_, comparator) {
    collectionsSort(_this_, comparator);
  }
  function copyToArray_0(collection) {
    var tmp;
    if (collection.toArray !== undefined) {
      var tmp0_unsafeCast_0 = collection.toArray();
      tmp = tmp0_unsafeCast_0;
    } else {
      {
        var tmp1_unsafeCast_0 = copyToArrayImpl_0(collection);
        tmp = tmp1_unsafeCast_0;
      }
    }
    return tmp;
  }
  function collectionsSort(list, comparator) {
    if (list._get_size__45() <= 1)
      return Unit_getInstance();
    var array = copyToArray_0(list);
    sortArrayWith(array, comparator);
    var inductionVariable = 0;
    var last_1 = array.length;
    if (inductionVariable < last_1)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        list.set_11(i, array[i]);
        Unit_getInstance();
      }
       while (inductionVariable < last_1);
  }
  function copyToArrayImpl_0(collection) {
    var array = [];
    var iterator_0 = collection.iterator_64();
    while (iterator_0.hasNext_31()) {
      array.push(iterator_0.next_35());
    }
    return array;
  }
  function _no_name_provided__19($elements) {
    this._$elements = $elements;
  }
  _no_name_provided__19.prototype.invoke_19 = function (it) {
    return this._$elements.contains_51(it);
  };
  _no_name_provided__19.prototype.invoke_542 = function (p1) {
    return this.invoke_19((p1 == null ? true : isObject(p1)) ? p1 : THROW_CCE());
  };
  _no_name_provided__19.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function AbstractMutableCollection() {
    AbstractCollection.call(this);
  }
  AbstractMutableCollection.prototype.addAll_23 = function (elements) {
    this.checkIsMutable_12();
    var modified = false;
    var tmp0_iterator = elements.iterator_64();
    while (tmp0_iterator.hasNext_31()) {
      var element = tmp0_iterator.next_35();
      if (this.add_33(element))
        modified = true;
    }
    return modified;
  };
  AbstractMutableCollection.prototype.removeAll_1 = function (elements) {
    this.checkIsMutable_12();
    var tmp = isInterface(this, MutableIterable) ? this : THROW_CCE();
    return removeAll(tmp, _no_name_provided_$factory_9(elements));
  };
  AbstractMutableCollection.prototype.clear_27 = function () {
    this.checkIsMutable_12();
    var iterator_0 = this.iterator_64();
    while (iterator_0.hasNext_31()) {
      iterator_0.next_35();
      Unit_getInstance();
      iterator_0.remove_51();
    }
  };
  AbstractMutableCollection.prototype.toJSON = function () {
    return this.toArray();
  };
  AbstractMutableCollection.prototype.checkIsMutable_12 = function () {
  };
  AbstractMutableCollection.$metadata$ = {
    simpleName: 'AbstractMutableCollection',
    kind: 'class',
    interfaces: [MutableCollection]
  };
  function _no_name_provided_$factory_9($elements) {
    var i = new _no_name_provided__19($elements);
    return function (p1) {
      return i.invoke_19(p1);
    };
  }
  function IteratorImpl($outer) {
    this._$this = $outer;
    this._index_2 = 0;
    this._last_1 = -1;
  }
  IteratorImpl.prototype._set_index__0 = function (_set___) {
    this._index_2 = _set___;
  };
  IteratorImpl.prototype.hasNext_31 = function () {
    return this._index_2 < this._$this._get_size__45();
  };
  IteratorImpl.prototype.next_35 = function () {
    if (!this.hasNext_31())
      throw NoSuchElementException_init_$Create$();
    var tmp = this;
    var tmp0_this = this;
    var tmp1 = tmp0_this._index_2;
    tmp0_this._index_2 = tmp1 + 1 | 0;
    tmp._last_1 = tmp1;
    return this._$this.get_80(this._last_1);
  };
  IteratorImpl.prototype.remove_51 = function () {
    var tmp0_check_0 = !(this._last_1 === -1);
    if (!tmp0_check_0) {
      var message_1 = 'Call next() or previous() before removing element from the iterator.';
      throw IllegalStateException_init_$Create$(toString_1(message_1));
    }this._$this.removeAt_2(this._last_1);
    Unit_getInstance();
    this._index_2 = this._last_1;
    this._last_1 = -1;
  };
  IteratorImpl.$metadata$ = {
    simpleName: 'IteratorImpl',
    kind: 'class',
    interfaces: [MutableIterator]
  };
  function ListIteratorImpl($outer, index) {
    this._$this_0 = $outer;
    IteratorImpl.call(this, $outer);
    Companion_getInstance().checkPositionIndex(index, this._$this_0._get_size__45());
    this._set_index__0(index);
  }
  ListIteratorImpl.$metadata$ = {
    simpleName: 'ListIteratorImpl',
    kind: 'class',
    interfaces: [MutableListIterator]
  };
  function AbstractMutableList() {
    AbstractMutableCollection.call(this);
    this._modCount = 0;
  }
  AbstractMutableList.prototype._set_modCount__0 = function (_set___) {
    this._modCount = _set___;
  };
  AbstractMutableList.prototype._get_modCount__0 = function () {
    return this._modCount;
  };
  AbstractMutableList.prototype.add_33 = function (element) {
    this.checkIsMutable_12();
    this.add_27(this._get_size__45(), element);
    return true;
  };
  AbstractMutableList.prototype.clear_27 = function () {
    this.checkIsMutable_12();
    this.removeRange_0(0, this._get_size__45());
  };
  AbstractMutableList.prototype.iterator_64 = function () {
    return new IteratorImpl(this);
  };
  AbstractMutableList.prototype.contains_51 = function (element) {
    return this.indexOf_1(element) >= 0;
  };
  AbstractMutableList.prototype.indexOf_1 = function (element) {
    var inductionVariable = 0;
    var last_1 = _get_lastIndex__0(this);
    if (inductionVariable <= last_1)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (equals_1(this.get_80(index), element)) {
          return index;
        }}
       while (!(index === last_1));
    return -1;
  };
  AbstractMutableList.prototype.listIterator_3 = function (index) {
    return new ListIteratorImpl(this, index);
  };
  AbstractMutableList.prototype.removeRange_0 = function (fromIndex, toIndex) {
    var iterator_0 = this.listIterator_3(fromIndex);
    var tmp0_repeat_0 = toIndex - fromIndex | 0;
    var inductionVariable = 0;
    if (inductionVariable < tmp0_repeat_0)
      do {
        var index_2 = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        iterator_0.next_35();
        Unit_getInstance();
        iterator_0.remove_51();
      }
       while (inductionVariable < tmp0_repeat_0);
  };
  AbstractMutableList.prototype.equals = function (other) {
    if (other === this)
      return true;
    if (!(!(other == null) ? isInterface(other, List) : false))
      return false;
    else {
    }
    return Companion_getInstance().orderedEquals(this, other);
  };
  AbstractMutableList.prototype.hashCode = function () {
    return Companion_getInstance().orderedHashCode(this);
  };
  AbstractMutableList.$metadata$ = {
    simpleName: 'AbstractMutableList',
    kind: 'class',
    interfaces: [MutableList]
  };
  function _no_name_provided__20($entryIterator) {
    this._$entryIterator_1 = $entryIterator;
  }
  _no_name_provided__20.prototype.hasNext_31 = function () {
    return this._$entryIterator_1.hasNext_31();
  };
  _no_name_provided__20.prototype.next_35 = function () {
    return this._$entryIterator_1.next_35()._get_key__47();
  };
  _no_name_provided__20.prototype.remove_51 = function () {
    return this._$entryIterator_1.remove_51();
  };
  _no_name_provided__20.$metadata$ = {
    kind: 'class',
    interfaces: [MutableIterator]
  };
  function _no_name_provided__21($entryIterator) {
    this._$entryIterator_2 = $entryIterator;
  }
  _no_name_provided__21.prototype.hasNext_31 = function () {
    return this._$entryIterator_2.hasNext_31();
  };
  _no_name_provided__21.prototype.next_35 = function () {
    return this._$entryIterator_2.next_35()._get_value__33();
  };
  _no_name_provided__21.prototype.remove_51 = function () {
    return this._$entryIterator_2.remove_51();
  };
  _no_name_provided__21.$metadata$ = {
    kind: 'class',
    interfaces: [MutableIterator]
  };
  function SimpleEntry(key, value) {
    this._key_0 = key;
    this.__value_0 = value;
  }
  SimpleEntry.prototype._get_key__47 = function () {
    return this._key_0;
  };
  SimpleEntry.prototype._get_value__33 = function () {
    return this.__value_0;
  };
  SimpleEntry.prototype.setValue_11 = function (newValue) {
    var oldValue = this.__value_0;
    this.__value_0 = newValue;
    return oldValue;
  };
  SimpleEntry.prototype.hashCode = function () {
    return Companion_getInstance_0().entryHashCode(this);
  };
  SimpleEntry.prototype.toString = function () {
    return Companion_getInstance_0().entryToString(this);
  };
  SimpleEntry.prototype.equals = function (other) {
    return Companion_getInstance_0().entryEquals(this, other);
  };
  SimpleEntry.$metadata$ = {
    simpleName: 'SimpleEntry',
    kind: 'class',
    interfaces: [MutableEntry]
  };
  function AbstractEntrySet() {
    AbstractMutableSet.call(this);
  }
  AbstractEntrySet.prototype.contains_51 = function (element) {
    return this.containsEntry_4(element);
  };
  AbstractEntrySet.$metadata$ = {
    simpleName: 'AbstractEntrySet',
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__22(this$0) {
    this._this$0_7 = this$0;
    AbstractMutableSet.call(this);
  }
  _no_name_provided__22.prototype.add_4 = function (element) {
    throw UnsupportedOperationException_init_$Create$_0('Add is not supported on keys');
  };
  _no_name_provided__22.prototype.add_33 = function (element) {
    return this.add_4((element == null ? true : isObject(element)) ? element : THROW_CCE());
  };
  _no_name_provided__22.prototype.clear_27 = function () {
    this._this$0_7.clear_27();
  };
  _no_name_provided__22.prototype.contains_27 = function (element) {
    return this._this$0_7.containsKey_16(element);
  };
  _no_name_provided__22.prototype.contains_51 = function (element) {
    if (!(element == null ? true : isObject(element)))
      return false;
    else {
    }
    return this.contains_27((element == null ? true : isObject(element)) ? element : THROW_CCE());
  };
  _no_name_provided__22.prototype.iterator_64 = function () {
    var entryIterator = this._this$0_7._get_entries__10().iterator_64();
    return new _no_name_provided__20(entryIterator);
  };
  _no_name_provided__22.prototype._get_size__45 = function () {
    return this._this$0_7._get_size__45();
  };
  _no_name_provided__22.prototype.checkIsMutable_12 = function () {
    return this._this$0_7.checkIsMutable_12();
  };
  _no_name_provided__22.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__23(this$0) {
    this._this$0_8 = this$0;
    AbstractMutableCollection.call(this);
  }
  _no_name_provided__23.prototype.add_6 = function (element) {
    throw UnsupportedOperationException_init_$Create$_0('Add is not supported on values');
  };
  _no_name_provided__23.prototype.add_33 = function (element) {
    return this.add_6((element == null ? true : isObject(element)) ? element : THROW_CCE());
  };
  _no_name_provided__23.prototype.contains_20 = function (element) {
    return this._this$0_8.containsValue_2(element);
  };
  _no_name_provided__23.prototype.contains_51 = function (element) {
    if (!(element == null ? true : isObject(element)))
      return false;
    else {
    }
    return this.contains_20((element == null ? true : isObject(element)) ? element : THROW_CCE());
  };
  _no_name_provided__23.prototype.iterator_64 = function () {
    var entryIterator = this._this$0_8._get_entries__10().iterator_64();
    return new _no_name_provided__21(entryIterator);
  };
  _no_name_provided__23.prototype._get_size__45 = function () {
    return this._this$0_8._get_size__45();
  };
  _no_name_provided__23.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(!(other == null) ? isInterface(other, Collection) : false))
      return false;
    else {
    }
    return Companion_getInstance().orderedEquals(this, other);
  };
  _no_name_provided__23.prototype.hashCode = function () {
    return Companion_getInstance().orderedHashCode(this);
  };
  _no_name_provided__23.prototype.checkIsMutable_12 = function () {
    return this._this$0_8.checkIsMutable_12();
  };
  _no_name_provided__23.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function AbstractMutableMap() {
    AbstractMap.call(this);
    this.__keys_0 = null;
    this.__values_0 = null;
  }
  AbstractMutableMap.prototype.clear_27 = function () {
    this._get_entries__10().clear_27();
  };
  AbstractMutableMap.prototype._get_keys__10 = function () {
    if (this.__keys_0 == null) {
      var tmp = this;
      tmp.__keys_0 = new _no_name_provided__22(this);
    }return ensureNotNull(this.__keys_0);
  };
  AbstractMutableMap.prototype.putAll_8 = function (from) {
    this.checkIsMutable_12();
    var tmp0_iterator = from._get_entries__10().iterator_64();
    while (tmp0_iterator.hasNext_31()) {
      var tmp1_loop_parameter = tmp0_iterator.next_35();
      var key = tmp1_loop_parameter._get_key__47();
      var value = tmp1_loop_parameter._get_value__33();
      this.put_12(key, value);
      Unit_getInstance();
    }
  };
  AbstractMutableMap.prototype._get_values__16 = function () {
    if (this.__values_0 == null) {
      var tmp = this;
      tmp.__values_0 = new _no_name_provided__23(this);
    }return ensureNotNull(this.__values_0);
  };
  AbstractMutableMap.prototype.remove_45 = function (key) {
    this.checkIsMutable_12();
    var iter = this._get_entries__10().iterator_64();
    while (iter.hasNext_31()) {
      var entry = iter.next_35();
      var k = entry._get_key__47();
      if (equals_1(key, k)) {
        var value = entry._get_value__33();
        iter.remove_51();
        return value;
      }}
    return null;
  };
  AbstractMutableMap.prototype.checkIsMutable_12 = function () {
  };
  AbstractMutableMap.$metadata$ = {
    simpleName: 'AbstractMutableMap',
    kind: 'class',
    interfaces: [MutableMap]
  };
  function AbstractMutableSet() {
    AbstractMutableCollection.call(this);
  }
  AbstractMutableSet.prototype.equals = function (other) {
    if (other === this)
      return true;
    if (!(!(other == null) ? isInterface(other, Set) : false))
      return false;
    else {
    }
    return Companion_getInstance_1().setEquals(this, other);
  };
  AbstractMutableSet.prototype.hashCode = function () {
    return Companion_getInstance_1().unorderedHashCode(this);
  };
  AbstractMutableSet.$metadata$ = {
    simpleName: 'AbstractMutableSet',
    kind: 'class',
    interfaces: [MutableSet]
  };
  function ArrayList_init_$Init$($this) {
    ArrayList.call($this, []);
    return $this;
  }
  function ArrayList_init_$Create$() {
    return ArrayList_init_$Init$(Object.create(ArrayList.prototype));
  }
  function ArrayList_init_$Init$_0(initialCapacity, $this) {
    ArrayList.call($this, []);
    return $this;
  }
  function ArrayList_init_$Create$_0(initialCapacity) {
    return ArrayList_init_$Init$_0(initialCapacity, Object.create(ArrayList.prototype));
  }
  function ArrayList_init_$Init$_1(elements, $this) {
    ArrayList.call($this, copyToArray_0(elements));
    return $this;
  }
  function ArrayList_init_$Create$_1(elements) {
    return ArrayList_init_$Init$_1(elements, Object.create(ArrayList.prototype));
  }
  function rangeCheck($this, index) {
    Companion_getInstance().checkElementIndex(index, $this._get_size__45());
    return index;
  }
  function insertionRangeCheck($this, index) {
    Companion_getInstance().checkPositionIndex(index, $this._get_size__45());
    return index;
  }
  function ArrayList(array) {
    AbstractMutableList.call(this);
    this._array = array;
    this._isReadOnly = false;
  }
  ArrayList.prototype.trimToSize = function () {
  };
  ArrayList.prototype.ensureCapacity_8 = function (minCapacity) {
  };
  ArrayList.prototype._get_size__45 = function () {
    return this._array.length;
  };
  ArrayList.prototype.get_80 = function (index) {
    var tmp = this._array[rangeCheck(this, index)];
    return (tmp == null ? true : isObject(tmp)) ? tmp : THROW_CCE();
  };
  ArrayList.prototype.set_11 = function (index, element) {
    this.checkIsMutable_12();
    rangeCheck(this, index);
    Unit_getInstance();
    var tmp0_apply_0 = this._array[index];
    this._array[index] = element;
    var tmp = tmp0_apply_0;
    return (tmp == null ? true : isObject(tmp)) ? tmp : THROW_CCE();
  };
  ArrayList.prototype.add_33 = function (element) {
    this.checkIsMutable_12();
    var tmp0_asDynamic_0 = this._array;
    tmp0_asDynamic_0.push(element);
    var tmp0_this = this;
    var tmp1 = tmp0_this._get_modCount__0();
    tmp0_this._set_modCount__0(tmp1 + 1 | 0);
    Unit_getInstance();
    return true;
  };
  ArrayList.prototype.add_27 = function (index, element) {
    this.checkIsMutable_12();
    var tmp0_asDynamic_0 = this._array;
    tmp0_asDynamic_0.splice(insertionRangeCheck(this, index), 0, element);
    var tmp0_this = this;
    var tmp1 = tmp0_this._get_modCount__0();
    tmp0_this._set_modCount__0(tmp1 + 1 | 0);
    Unit_getInstance();
  };
  ArrayList.prototype.addAll_23 = function (elements) {
    this.checkIsMutable_12();
    if (elements.isEmpty_53())
      return false;
    var tmp0_this = this;
    var tmp = tmp0_this;
    var tmp0_plus_0 = tmp0_this._array;
    var tmp1_plus_0 = copyToArray_0(elements);
    tmp._array = tmp0_plus_0.concat(tmp1_plus_0);
    var tmp1_this = this;
    var tmp2 = tmp1_this._get_modCount__0();
    tmp1_this._set_modCount__0(tmp2 + 1 | 0);
    Unit_getInstance();
    return true;
  };
  ArrayList.prototype.removeAt_2 = function (index) {
    this.checkIsMutable_12();
    rangeCheck(this, index);
    Unit_getInstance();
    var tmp0_this = this;
    var tmp1 = tmp0_this._get_modCount__0();
    tmp0_this._set_modCount__0(tmp1 + 1 | 0);
    Unit_getInstance();
    var tmp;
    if (index === _get_lastIndex__0(this)) {
      var tmp0_asDynamic_0 = this._array;
      tmp = tmp0_asDynamic_0.pop();
    } else {
      var tmp1_asDynamic_0 = this._array;
      tmp = tmp1_asDynamic_0.splice(index, 1)[0];
    }
    return tmp;
  };
  ArrayList.prototype.removeRange_0 = function (fromIndex, toIndex) {
    this.checkIsMutable_12();
    var tmp0_this = this;
    var tmp1 = tmp0_this._get_modCount__0();
    tmp0_this._set_modCount__0(tmp1 + 1 | 0);
    Unit_getInstance();
    var tmp0_asDynamic_0 = this._array;
    tmp0_asDynamic_0.splice(fromIndex, toIndex - fromIndex | 0);
  };
  ArrayList.prototype.clear_27 = function () {
    this.checkIsMutable_12();
    var tmp = this;
    tmp._array = [];
    var tmp0_this = this;
    var tmp1 = tmp0_this._get_modCount__0();
    tmp0_this._set_modCount__0(tmp1 + 1 | 0);
    Unit_getInstance();
  };
  ArrayList.prototype.indexOf_1 = function (element) {
    return indexOf(this._array, element);
  };
  ArrayList.prototype.toString = function () {
    return arrayToString(this._array);
  };
  ArrayList.prototype.toArray_0 = function () {
    return [].slice.call(this._array);
  };
  ArrayList.prototype.toArray = function () {
    return this.toArray_0();
  };
  ArrayList.prototype.checkIsMutable_12 = function () {
    if (this._isReadOnly)
      throw UnsupportedOperationException_init_$Create$();
  };
  ArrayList.$metadata$ = {
    simpleName: 'ArrayList',
    kind: 'class',
    interfaces: [MutableList, RandomAccess]
  };
  var _stableSortingIsSupported;
  function sortArrayWith(array, comparator) {
    if (getStableSortingIsSupported()) {
      var comparison = _no_name_provided_$factory_10(comparator);
      array.sort(comparison);
    } else {
      mergeSort(array, 0, _get_lastIndex_(array), comparator);
    }
  }
  function getStableSortingIsSupported() {
    var tmp0_safe_receiver = _stableSortingIsSupported;
    if (tmp0_safe_receiver == null)
      null;
    else {
      return tmp0_safe_receiver;
    }
    Unit_getInstance();
    _stableSortingIsSupported = false;
    var tmp0_unsafeCast_0 = [];
    var array = tmp0_unsafeCast_0;
    var inductionVariable = 0;
    if (inductionVariable < 600)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        array.push(index);
      }
       while (inductionVariable < 600);
    var comparison = _no_name_provided_$factory_11();
    array.sort(comparison);
    var inductionVariable_0 = 1;
    var last_1 = array.length;
    if (inductionVariable_0 < last_1)
      do {
        var index_0 = inductionVariable_0;
        inductionVariable_0 = inductionVariable_0 + 1 | 0;
        var a = array[index_0 - 1 | 0];
        var b = array[index_0];
        if ((a & 3) === (b & 3) ? a >= b : false)
          return false;
      }
       while (inductionVariable_0 < last_1);
    _stableSortingIsSupported = true;
    return true;
  }
  function mergeSort(array, start, endInclusive, comparator) {
    var tmp0_arrayOfNulls_0 = array.length;
    var tmp1_unsafeCast_0 = fillArrayVal(Array(tmp0_arrayOfNulls_0), null);
    var buffer = tmp1_unsafeCast_0;
    var result = mergeSort_0(array, buffer, start, endInclusive, comparator);
    if (!(result === array)) {
      var inductionVariable = start;
      if (inductionVariable <= endInclusive)
        do {
          var i = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          array[i] = result[i];
        }
         while (!(i === endInclusive));
    }}
  function mergeSort_0(array, buffer, start, end, comparator) {
    if (start === end) {
      return array;
    }var median = (start + end | 0) / 2 | 0;
    var left = mergeSort_0(array, buffer, start, median, comparator);
    var right = mergeSort_0(array, buffer, median + 1 | 0, end, comparator);
    var target = left === buffer ? array : buffer;
    var leftIndex = start;
    var rightIndex = median + 1 | 0;
    var inductionVariable = start;
    if (inductionVariable <= end)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (leftIndex <= median ? rightIndex <= end : false) {
          var leftValue = left[leftIndex];
          var rightValue = right[rightIndex];
          if (comparator.compare(leftValue, rightValue) <= 0) {
            target[i] = leftValue;
            var tmp1 = leftIndex;
            leftIndex = tmp1 + 1 | 0;
            Unit_getInstance();
          } else {
            target[i] = rightValue;
            var tmp2 = rightIndex;
            rightIndex = tmp2 + 1 | 0;
            Unit_getInstance();
          }
        } else if (leftIndex <= median) {
          target[i] = left[leftIndex];
          var tmp3 = leftIndex;
          leftIndex = tmp3 + 1 | 0;
          Unit_getInstance();
        } else {
          target[i] = right[rightIndex];
          var tmp4 = rightIndex;
          rightIndex = tmp4 + 1 | 0;
          Unit_getInstance();
          Unit_getInstance();
        }
      }
       while (!(i === end));
    return target;
  }
  function _no_name_provided__24($comparator) {
    this._$comparator = $comparator;
  }
  _no_name_provided__24.prototype.invoke_21 = function (a, b) {
    return this._$comparator.compare(a, b);
  };
  _no_name_provided__24.prototype.invoke_537 = function (p1, p2) {
    var tmp = (p1 == null ? true : isObject(p1)) ? p1 : THROW_CCE();
    return this.invoke_21(tmp, (p2 == null ? true : isObject(p2)) ? p2 : THROW_CCE());
  };
  _no_name_provided__24.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__25() {
  }
  _no_name_provided__25.prototype.invoke_23 = function (a, b) {
    return (a & 3) - (b & 3) | 0;
  };
  _no_name_provided__25.prototype.invoke_537 = function (p1, p2) {
    var tmp = (!(p1 == null) ? typeof p1 === 'number' : false) ? p1 : THROW_CCE();
    return this.invoke_23(tmp, (!(p2 == null) ? typeof p2 === 'number' : false) ? p2 : THROW_CCE());
  };
  _no_name_provided__25.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided_$factory_10($comparator) {
    var i = new _no_name_provided__24($comparator);
    return function (p1, p2) {
      return i.invoke_21(p1, p2);
    };
  }
  function _no_name_provided_$factory_11() {
    var i = new _no_name_provided__25();
    return function (p1, p2) {
      return i.invoke_23(p1, p2);
    };
  }
  function HashCode() {
    HashCode_instance = this;
  }
  HashCode.prototype.equals_1 = function (value1, value2) {
    return equals_1(value1, value2);
  };
  HashCode.prototype.getHashCode_0 = function (value) {
    var tmp0_safe_receiver = value;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : hashCode(tmp0_safe_receiver);
    return tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs;
  };
  HashCode.$metadata$ = {
    simpleName: 'HashCode',
    kind: 'object',
    interfaces: [EqualityComparator]
  };
  var HashCode_instance;
  function HashCode_getInstance() {
    if (HashCode_instance == null)
      new HashCode();
    return HashCode_instance;
  }
  function EqualityComparator() {
  }
  EqualityComparator.$metadata$ = {
    simpleName: 'EqualityComparator',
    kind: 'interface',
    interfaces: []
  };
  function EntrySet($outer) {
    this._$this_1 = $outer;
    AbstractEntrySet.call(this);
  }
  EntrySet.prototype.add_14 = function (element) {
    throw UnsupportedOperationException_init_$Create$_0('Add is not supported on entries');
  };
  EntrySet.prototype.add_33 = function (element) {
    return this.add_14((!(element == null) ? isInterface(element, MutableEntry) : false) ? element : THROW_CCE());
  };
  EntrySet.prototype.clear_27 = function () {
    this._$this_1.clear_27();
  };
  EntrySet.prototype.containsEntry_4 = function (element) {
    return this._$this_1.containsEntry_5(element);
  };
  EntrySet.prototype.iterator_64 = function () {
    return this._$this_1._internalMap.iterator_64();
  };
  EntrySet.prototype._get_size__45 = function () {
    return this._$this_1._get_size__45();
  };
  EntrySet.$metadata$ = {
    simpleName: 'EntrySet',
    kind: 'class',
    interfaces: []
  };
  function HashMap_init_$Init$(internalMap, $this) {
    AbstractMutableMap.call($this);
    HashMap.call($this);
    $this._internalMap = internalMap;
    $this._equality = internalMap._get_equality__0();
    return $this;
  }
  function HashMap_init_$Init$_0($this) {
    HashMap_init_$Init$(new InternalHashCodeMap(HashCode_getInstance()), $this);
    return $this;
  }
  function HashMap_init_$Create$() {
    return HashMap_init_$Init$_0(Object.create(HashMap.prototype));
  }
  function HashMap_init_$Init$_1(initialCapacity, loadFactor, $this) {
    HashMap_init_$Init$_0($this);
    var tmp0_require_0 = initialCapacity >= 0;
    if (!tmp0_require_0) {
      var message_1 = '' + 'Negative initial capacity: ' + initialCapacity;
      throw IllegalArgumentException_init_$Create$_0(toString_1(message_1));
    }var tmp1_require_0 = loadFactor >= 0;
    if (!tmp1_require_0) {
      var message_1_0 = '' + 'Non-positive load factor: ' + loadFactor;
      throw IllegalArgumentException_init_$Create$_0(toString_1(message_1_0));
    }return $this;
  }
  function HashMap_init_$Create$_0(initialCapacity, loadFactor) {
    return HashMap_init_$Init$_1(initialCapacity, loadFactor, Object.create(HashMap.prototype));
  }
  function HashMap_init_$Init$_2(initialCapacity, $this) {
    HashMap_init_$Init$_1(initialCapacity, 0.0, $this);
    return $this;
  }
  function HashMap_init_$Create$_1(initialCapacity) {
    return HashMap_init_$Init$_2(initialCapacity, Object.create(HashMap.prototype));
  }
  function HashMap_init_$Init$_3(original, $this) {
    HashMap_init_$Init$_0($this);
    $this.putAll_8(original);
    return $this;
  }
  function HashMap_init_$Create$_2(original) {
    return HashMap_init_$Init$_3(original, Object.create(HashMap.prototype));
  }
  HashMap.prototype.clear_27 = function () {
    this._internalMap.clear_27();
  };
  HashMap.prototype.containsKey_16 = function (key) {
    return this._internalMap.contains_27(key);
  };
  HashMap.prototype.containsValue_2 = function (value) {
    var tmp$ret$0;
    l$ret$1: do {
      var tmp0_any_0 = this._internalMap;
      var tmp;
      if (isInterface(tmp0_any_0, Collection)) {
        tmp = tmp0_any_0.isEmpty_53();
      } else {
        {
          tmp = false;
        }
      }
      if (tmp) {
        tmp$ret$0 = false;
        break l$ret$1;
      } else {
      }
      var tmp0_iterator_1 = tmp0_any_0.iterator_64();
      while (tmp0_iterator_1.hasNext_31()) {
        var element_2 = tmp0_iterator_1.next_35();
        if (this._equality.equals_1(element_2._get_value__33(), value)) {
          tmp$ret$0 = true;
          break l$ret$1;
        } else {
        }
      }
      tmp$ret$0 = false;
    }
     while (false);
    return tmp$ret$0;
  };
  HashMap.prototype._get_entries__10 = function () {
    if (this.__entries == null) {
      this.__entries = this.createEntrySet_0();
    }return ensureNotNull(this.__entries);
  };
  HashMap.prototype.createEntrySet_0 = function () {
    return new EntrySet(this);
  };
  HashMap.prototype.get_63 = function (key) {
    return this._internalMap.get_63(key);
  };
  HashMap.prototype.put_12 = function (key, value) {
    return this._internalMap.put_12(key, value);
  };
  HashMap.prototype.remove_45 = function (key) {
    return this._internalMap.remove_45(key);
  };
  HashMap.prototype._get_size__45 = function () {
    return this._internalMap._get_size__45();
  };
  function HashMap() {
    this.__entries = null;
  }
  HashMap.$metadata$ = {
    simpleName: 'HashMap',
    kind: 'class',
    interfaces: [MutableMap]
  };
  function HashSet_init_$Init$($this) {
    AbstractMutableSet.call($this);
    HashSet.call($this);
    $this._map = HashMap_init_$Create$();
    return $this;
  }
  function HashSet_init_$Create$() {
    return HashSet_init_$Init$(Object.create(HashSet.prototype));
  }
  function HashSet_init_$Init$_0(elements, $this) {
    AbstractMutableSet.call($this);
    HashSet.call($this);
    $this._map = HashMap_init_$Create$_1(elements._get_size__45());
    $this.addAll_23(elements);
    Unit_getInstance();
    return $this;
  }
  function HashSet_init_$Create$_0(elements) {
    return HashSet_init_$Init$_0(elements, Object.create(HashSet.prototype));
  }
  function HashSet_init_$Init$_1(initialCapacity, loadFactor, $this) {
    AbstractMutableSet.call($this);
    HashSet.call($this);
    $this._map = HashMap_init_$Create$_0(initialCapacity, loadFactor);
    return $this;
  }
  function HashSet_init_$Init$_2(initialCapacity, $this) {
    HashSet_init_$Init$_1(initialCapacity, 0.0, $this);
    return $this;
  }
  function HashSet_init_$Create$_1(initialCapacity) {
    return HashSet_init_$Init$_2(initialCapacity, Object.create(HashSet.prototype));
  }
  function HashSet_init_$Init$_3(map_0, $this) {
    AbstractMutableSet.call($this);
    HashSet.call($this);
    $this._map = map_0;
    return $this;
  }
  HashSet.prototype._get_map__0 = function () {
    return this._map;
  };
  HashSet.prototype.add_33 = function (element) {
    var old = this._map.put_12(element, this);
    return old == null;
  };
  HashSet.prototype.clear_27 = function () {
    this._map.clear_27();
  };
  HashSet.prototype.contains_51 = function (element) {
    return this._map.containsKey_16(element);
  };
  HashSet.prototype.isEmpty_53 = function () {
    return this._map.isEmpty_53();
  };
  HashSet.prototype.iterator_64 = function () {
    return this._map._get_keys__10().iterator_64();
  };
  HashSet.prototype.remove_14 = function (element) {
    return !(this._map.remove_45(element) == null);
  };
  HashSet.prototype._get_size__45 = function () {
    return this._map._get_size__45();
  };
  function HashSet() {
  }
  HashSet.$metadata$ = {
    simpleName: 'HashSet',
    kind: 'class',
    interfaces: [MutableSet]
  };
  function computeNext($this) {
    if ($this._chainOrEntry != null ? $this._isChain : false) {
      var tmp0_unsafeCast_0 = $this._chainOrEntry;
      var chainSize = tmp0_unsafeCast_0.length;
      var tmp0_this = $this;
      tmp0_this._itemIndex = tmp0_this._itemIndex + 1 | 0;
      if (tmp0_this._itemIndex < chainSize)
        return 0;
      else {
      }
    }var tmp1_this = $this;
    tmp1_this._keyIndex = tmp1_this._keyIndex + 1 | 0;
    if (tmp1_this._keyIndex < $this._keys.length) {
      $this._chainOrEntry = $this._this$0_9._backingMap[$this._keys[$this._keyIndex]];
      var tmp = $this;
      var tmp_0 = $this._chainOrEntry;
      tmp._isChain = !(tmp_0 == null) ? isArray(tmp_0) : false;
      $this._itemIndex = 0;
      return 0;
    } else {
      {
        $this._chainOrEntry = null;
        return 1;
      }
    }
  }
  function getEntry($this, key) {
    var tmp0_elvis_lhs = getChainOrEntryOrNull($this, $this._equality_0.getHashCode_0(key));
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return null;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var chainOrEntry = tmp;
    if (!(!(chainOrEntry == null) ? isArray(chainOrEntry) : false)) {
      var entry = chainOrEntry;
      if ($this._equality_0.equals_1(entry._get_key__47(), key)) {
        return entry;
      } else {
        return null;
      }
    } else {
      {
        var chain = chainOrEntry;
        return findEntryInChain(chain, $this, key);
      }
    }
  }
  function findEntryInChain(_this_, $this, key) {
    var tmp$ret$0;
    l$ret$1: do {
      var indexedObject = _this_;
      var inductionVariable = 0;
      var last_1 = indexedObject.length;
      while (inductionVariable < last_1) {
        var element_2 = indexedObject[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        if ($this._equality_0.equals_1(element_2._get_key__47(), key)) {
          tmp$ret$0 = element_2;
          break l$ret$1;
        } else {
        }
      }
      tmp$ret$0 = null;
    }
     while (false);
    return tmp$ret$0;
  }
  function getChainOrEntryOrNull($this, hashCode_1) {
    var chainOrEntry = $this._backingMap[hashCode_1];
    return chainOrEntry === undefined ? null : chainOrEntry;
  }
  function _no_name_provided__26(this$0) {
    this._this$0_9 = this$0;
    this._state = -1;
    this._keys = Object.keys(this._this$0_9._backingMap);
    this._keyIndex = -1;
    this._chainOrEntry = null;
    this._isChain = false;
    this._itemIndex = -1;
    this._lastEntry = null;
  }
  _no_name_provided__26.prototype.hasNext_31 = function () {
    if (this._state === -1)
      this._state = computeNext(this);
    return this._state === 0;
  };
  _no_name_provided__26.prototype.next_35 = function () {
    if (!this.hasNext_31())
      throw NoSuchElementException_init_$Create$();
    var tmp;
    if (this._isChain) {
      var tmp0_unsafeCast_0 = this._chainOrEntry;
      tmp = tmp0_unsafeCast_0[this._itemIndex];
    } else {
      var tmp1_unsafeCast_0 = this._chainOrEntry;
      tmp = tmp1_unsafeCast_0;
    }
    var lastEntry = tmp;
    this._lastEntry = lastEntry;
    this._state = -1;
    return lastEntry;
  };
  _no_name_provided__26.prototype.remove_51 = function () {
    var tmp0_checkNotNull_0 = this._lastEntry;
    var tmp$ret$0;
    l$ret$1: do {
      if (tmp0_checkNotNull_0 == null) {
        var message_2_1 = 'Required value was null.';
        throw IllegalStateException_init_$Create$(toString_1(message_2_1));
      } else {
        tmp$ret$0 = tmp0_checkNotNull_0;
        break l$ret$1;
      }
    }
     while (false);
    Unit_getInstance();
    this._this$0_9.remove_45(ensureNotNull(this._lastEntry)._get_key__47());
    Unit_getInstance();
    this._lastEntry = null;
    var tmp0_this = this;
    var tmp1 = tmp0_this._itemIndex;
    tmp0_this._itemIndex = tmp1 - 1 | 0;
    Unit_getInstance();
  };
  _no_name_provided__26.$metadata$ = {
    kind: 'class',
    interfaces: [MutableIterator]
  };
  function InternalHashCodeMap(equality) {
    this._equality_0 = equality;
    this._backingMap = this.createJsMap_0();
    this._size_0 = 0;
  }
  InternalHashCodeMap.prototype._get_equality__0 = function () {
    return this._equality_0;
  };
  InternalHashCodeMap.prototype._get_size__45 = function () {
    return this._size_0;
  };
  InternalHashCodeMap.prototype.put_12 = function (key, value) {
    var hashCode_1 = this._equality_0.getHashCode_0(key);
    var chainOrEntry = getChainOrEntryOrNull(this, hashCode_1);
    if (chainOrEntry == null) {
      this._backingMap[hashCode_1] = new SimpleEntry(key, value);
    } else {
      if (!(!(chainOrEntry == null) ? isArray(chainOrEntry) : false)) {
        var entry = chainOrEntry;
        if (this._equality_0.equals_1(entry._get_key__47(), key)) {
          return entry.setValue_11(value);
        } else {
          var tmp0_arrayOf_0 = [entry, new SimpleEntry(key, value)];
          this._backingMap[hashCode_1] = tmp0_arrayOf_0;
          var tmp0_this = this;
          var tmp1 = tmp0_this._size_0;
          tmp0_this._size_0 = tmp1 + 1 | 0;
          Unit_getInstance();
          return null;
        }
      } else {
        {
          var chain = chainOrEntry;
          var entry_0 = findEntryInChain(chain, this, key);
          if (!(entry_0 == null)) {
            return entry_0.setValue_11(value);
          }chain.push(new SimpleEntry(key, value));
        }
      }
    }
    var tmp2_this = this;
    var tmp3 = tmp2_this._size_0;
    tmp2_this._size_0 = tmp3 + 1 | 0;
    Unit_getInstance();
    return null;
  };
  InternalHashCodeMap.prototype.remove_45 = function (key) {
    var hashCode_1 = this._equality_0.getHashCode_0(key);
    var tmp0_elvis_lhs = getChainOrEntryOrNull(this, hashCode_1);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return null;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var chainOrEntry = tmp;
    if (!(!(chainOrEntry == null) ? isArray(chainOrEntry) : false)) {
      var entry = chainOrEntry;
      if (this._equality_0.equals_1(entry._get_key__47(), key)) {
        jsDeleteProperty(this._backingMap, hashCode_1);
        var tmp1_this = this;
        var tmp2 = tmp1_this._size_0;
        tmp1_this._size_0 = tmp2 - 1 | 0;
        Unit_getInstance();
        return entry._get_value__33();
      } else {
        return null;
      }
    } else {
      {
        var chain = chainOrEntry;
        var inductionVariable = 0;
        var last_1 = chain.length - 1 | 0;
        if (inductionVariable <= last_1)
          do {
            var index = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            var entry_0 = chain[index];
            if (this._equality_0.equals_1(key, entry_0._get_key__47())) {
              if (chain.length === 1) {
                chain.length = 0;
                jsDeleteProperty(this._backingMap, hashCode_1);
              } else {
                chain.splice(index, 1);
              }
              var tmp4_this = this;
              var tmp5 = tmp4_this._size_0;
              tmp4_this._size_0 = tmp5 - 1 | 0;
              Unit_getInstance();
              return entry_0._get_value__33();
            }}
           while (inductionVariable <= last_1);
      }
    }
    return null;
  };
  InternalHashCodeMap.prototype.clear_27 = function () {
    this._backingMap = this.createJsMap_0();
    this._size_0 = 0;
  };
  InternalHashCodeMap.prototype.contains_27 = function (key) {
    return !(getEntry(this, key) == null);
  };
  InternalHashCodeMap.prototype.get_63 = function (key) {
    var tmp0_safe_receiver = getEntry(this, key);
    return tmp0_safe_receiver == null ? null : tmp0_safe_receiver._get_value__33();
  };
  InternalHashCodeMap.prototype.iterator_64 = function () {
    return new _no_name_provided__26(this);
  };
  InternalHashCodeMap.$metadata$ = {
    simpleName: 'InternalHashCodeMap',
    kind: 'class',
    interfaces: [InternalMap]
  };
  function InternalMap() {
  }
  InternalMap.prototype.createJsMap_0 = function () {
    var result = Object.create(null);
    result['foo'] = 1;
    jsDeleteProperty(result, 'foo');
    return result;
  };
  InternalMap.$metadata$ = {
    simpleName: 'InternalMap',
    kind: 'interface',
    interfaces: [MutableIterable]
  };
  function EntryIterator($outer) {
    this._$this_2 = $outer;
    this._last_2 = null;
    this._next_2 = null;
    this._next_2 = this._$this_2._$this_4._head;
  }
  EntryIterator.prototype.hasNext_31 = function () {
    return !(this._next_2 === null);
  };
  EntryIterator.prototype.next_35 = function () {
    if (!this.hasNext_31())
      throw NoSuchElementException_init_$Create$();
    var current = ensureNotNull(this._next_2);
    this._last_2 = current;
    var tmp = this;
    var tmp0_takeIf_0 = current._next_3;
    var tmp_0;
    if (!(tmp0_takeIf_0 === this._$this_2._$this_4._head)) {
      tmp_0 = tmp0_takeIf_0;
    } else {
      {
        tmp_0 = null;
      }
    }
    tmp._next_2 = tmp_0;
    return current;
  };
  EntryIterator.prototype.remove_51 = function () {
    var tmp0_check_0 = !(this._last_2 == null);
    if (!tmp0_check_0) {
      var message_2_1 = 'Check failed.';
      throw IllegalStateException_init_$Create$(toString_1(message_2_1));
    }this._$this_2.checkIsMutable_12();
    remove(ensureNotNull(this._last_2), this._$this_2._$this_4);
    this._$this_2._$this_4._map_0.remove_45(ensureNotNull(this._last_2)._get_key__47());
    Unit_getInstance();
    this._last_2 = null;
  };
  EntryIterator.$metadata$ = {
    simpleName: 'EntryIterator',
    kind: 'class',
    interfaces: [MutableIterator]
  };
  function ChainEntry($outer, key, value) {
    this._$this_3 = $outer;
    SimpleEntry.call(this, key, value);
    this._next_3 = null;
    this._prev = null;
  }
  ChainEntry.prototype.setValue_11 = function (newValue) {
    this._$this_3.checkIsMutable_12();
    return SimpleEntry.prototype.setValue_11.call(this, newValue);
  };
  ChainEntry.$metadata$ = {
    simpleName: 'ChainEntry',
    kind: 'class',
    interfaces: []
  };
  function EntrySet_0($outer) {
    this._$this_4 = $outer;
    AbstractEntrySet.call(this);
  }
  EntrySet_0.prototype.add_14 = function (element) {
    throw UnsupportedOperationException_init_$Create$_0('Add is not supported on entries');
  };
  EntrySet_0.prototype.add_33 = function (element) {
    return this.add_14((!(element == null) ? isInterface(element, MutableEntry) : false) ? element : THROW_CCE());
  };
  EntrySet_0.prototype.clear_27 = function () {
    this._$this_4.clear_27();
  };
  EntrySet_0.prototype.containsEntry_4 = function (element) {
    return this._$this_4.containsEntry_5(element);
  };
  EntrySet_0.prototype.iterator_64 = function () {
    return new EntryIterator(this);
  };
  EntrySet_0.prototype._get_size__45 = function () {
    return this._$this_4._get_size__45();
  };
  EntrySet_0.prototype.checkIsMutable_12 = function () {
    return this._$this_4.checkIsMutable_12();
  };
  EntrySet_0.$metadata$ = {
    simpleName: 'EntrySet',
    kind: 'class',
    interfaces: []
  };
  function addToEnd(_this_, $this) {
    var tmp0_check_0 = _this_._next_3 == null ? _this_._prev == null : false;
    if (!tmp0_check_0) {
      var message_2_1 = 'Check failed.';
      throw IllegalStateException_init_$Create$(toString_1(message_2_1));
    }var _head = $this._head;
    if (_head == null) {
      $this._head = _this_;
      _this_._next_3 = _this_;
      _this_._prev = _this_;
    } else {
      var tmp1_checkNotNull_0 = _head._prev;
      var tmp$ret$0;
      l$ret$1: do {
        if (tmp1_checkNotNull_0 == null) {
          var message_2_1_0 = 'Required value was null.';
          throw IllegalStateException_init_$Create$(toString_1(message_2_1_0));
        } else {
          tmp$ret$0 = tmp1_checkNotNull_0;
          break l$ret$1;
        }
      }
       while (false);
      var _tail = tmp$ret$0;
      _this_._prev = _tail;
      _this_._next_3 = _head;
      _head._prev = _this_;
      _tail._next_3 = _this_;
    }
  }
  function remove(_this_, $this) {
    if (_this_._next_3 === _this_) {
      $this._head = null;
    } else {
      if ($this._head === _this_) {
        $this._head = _this_._next_3;
      }ensureNotNull(_this_._next_3)._prev = _this_._prev;
      ensureNotNull(_this_._prev)._next_3 = _this_._next_3;
    }
    _this_._next_3 = null;
    _this_._prev = null;
  }
  function LinkedHashMap_init_$Init$($this) {
    HashMap_init_$Init$_0($this);
    LinkedHashMap.call($this);
    $this._map_0 = HashMap_init_$Create$();
    return $this;
  }
  function LinkedHashMap_init_$Create$() {
    return LinkedHashMap_init_$Init$(Object.create(LinkedHashMap.prototype));
  }
  function LinkedHashMap_init_$Init$_0(initialCapacity, loadFactor, $this) {
    HashMap_init_$Init$_1(initialCapacity, loadFactor, $this);
    LinkedHashMap.call($this);
    $this._map_0 = HashMap_init_$Create$();
    return $this;
  }
  function LinkedHashMap_init_$Create$_0(initialCapacity, loadFactor) {
    return LinkedHashMap_init_$Init$_0(initialCapacity, loadFactor, Object.create(LinkedHashMap.prototype));
  }
  function LinkedHashMap_init_$Init$_1(initialCapacity, $this) {
    LinkedHashMap_init_$Init$_0(initialCapacity, 0.0, $this);
    return $this;
  }
  function LinkedHashMap_init_$Create$_1(initialCapacity) {
    return LinkedHashMap_init_$Init$_1(initialCapacity, Object.create(LinkedHashMap.prototype));
  }
  function LinkedHashMap_init_$Init$_2(original, $this) {
    HashMap_init_$Init$_0($this);
    LinkedHashMap.call($this);
    $this._map_0 = HashMap_init_$Create$();
    $this.putAll_8(original);
    return $this;
  }
  function LinkedHashMap_init_$Create$_2(original) {
    return LinkedHashMap_init_$Init$_2(original, Object.create(LinkedHashMap.prototype));
  }
  LinkedHashMap.prototype.clear_27 = function () {
    this.checkIsMutable_12();
    this._map_0.clear_27();
    this._head = null;
  };
  LinkedHashMap.prototype.containsKey_16 = function (key) {
    return this._map_0.containsKey_16(key);
  };
  LinkedHashMap.prototype.containsValue_2 = function (value) {
    var tmp0_elvis_lhs = this._head;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return false;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var node = tmp;
    do {
      if (equals_1(node._get_value__33(), value)) {
        return true;
      }node = ensureNotNull(node._next_3);
    }
     while (!(node === this._head));
    return false;
  };
  LinkedHashMap.prototype.createEntrySet_0 = function () {
    return new EntrySet_0(this);
  };
  LinkedHashMap.prototype.get_63 = function (key) {
    var tmp0_safe_receiver = this._map_0.get_63(key);
    return tmp0_safe_receiver == null ? null : tmp0_safe_receiver._get_value__33();
  };
  LinkedHashMap.prototype.put_12 = function (key, value) {
    this.checkIsMutable_12();
    var old = this._map_0.get_63(key);
    if (old == null) {
      var newEntry = new ChainEntry(this, key, value);
      this._map_0.put_12(key, newEntry);
      Unit_getInstance();
      addToEnd(newEntry, this);
      return null;
    } else {
      return old.setValue_11(value);
    }
  };
  LinkedHashMap.prototype.remove_45 = function (key) {
    this.checkIsMutable_12();
    var entry = this._map_0.remove_45(key);
    if (!(entry == null)) {
      remove(entry, this);
      return entry._get_value__33();
    }return null;
  };
  LinkedHashMap.prototype._get_size__45 = function () {
    return this._map_0._get_size__45();
  };
  LinkedHashMap.prototype.checkIsMutable_12 = function () {
    if (this._isReadOnly_0)
      throw UnsupportedOperationException_init_$Create$();
  };
  function LinkedHashMap() {
    this._head = null;
    this._isReadOnly_0 = false;
  }
  LinkedHashMap.$metadata$ = {
    simpleName: 'LinkedHashMap',
    kind: 'class',
    interfaces: [MutableMap]
  };
  function LinkedHashSet_init_$Init$($this) {
    HashSet_init_$Init$_3(LinkedHashMap_init_$Create$(), $this);
    LinkedHashSet.call($this);
    return $this;
  }
  function LinkedHashSet_init_$Create$() {
    return LinkedHashSet_init_$Init$(Object.create(LinkedHashSet.prototype));
  }
  function LinkedHashSet_init_$Init$_0(elements, $this) {
    HashSet_init_$Init$_3(LinkedHashMap_init_$Create$(), $this);
    LinkedHashSet.call($this);
    $this.addAll_23(elements);
    Unit_getInstance();
    return $this;
  }
  function LinkedHashSet_init_$Create$_0(elements) {
    return LinkedHashSet_init_$Init$_0(elements, Object.create(LinkedHashSet.prototype));
  }
  function LinkedHashSet_init_$Init$_1(initialCapacity, loadFactor, $this) {
    HashSet_init_$Init$_3(LinkedHashMap_init_$Create$_0(initialCapacity, loadFactor), $this);
    LinkedHashSet.call($this);
    return $this;
  }
  function LinkedHashSet_init_$Init$_2(initialCapacity, $this) {
    LinkedHashSet_init_$Init$_1(initialCapacity, 0.0, $this);
    return $this;
  }
  function LinkedHashSet_init_$Create$_1(initialCapacity) {
    return LinkedHashSet_init_$Init$_2(initialCapacity, Object.create(LinkedHashSet.prototype));
  }
  LinkedHashSet.prototype.checkIsMutable_12 = function () {
    return this._get_map__0().checkIsMutable_12();
  };
  function LinkedHashSet() {
  }
  LinkedHashSet.$metadata$ = {
    simpleName: 'LinkedHashSet',
    kind: 'class',
    interfaces: [MutableSet]
  };
  function RandomAccess() {
  }
  RandomAccess.$metadata$ = {
    simpleName: 'RandomAccess',
    kind: 'interface',
    interfaces: []
  };
  function Serializable() {
  }
  Serializable.$metadata$ = {
    simpleName: 'Serializable',
    kind: 'interface',
    interfaces: []
  };
  function roundToInt(_this_) {
    var tmp;
    if (isNaN_0(_this_)) {
      throw IllegalArgumentException_init_$Create$_0('Cannot round NaN value.');
    } else if (_this_ > IntCompanionObject_getInstance()._MAX_VALUE_5) {
      tmp = IntCompanionObject_getInstance()._MAX_VALUE_5;
    } else if (_this_ < IntCompanionObject_getInstance()._MIN_VALUE_5) {
      tmp = IntCompanionObject_getInstance()._MIN_VALUE_5;
    } else {
      var tmp0_unsafeCast_0 = Math.round(_this_);
      tmp = numberToInt(tmp0_unsafeCast_0);
    }
    return tmp;
  }
  function isNaN_0(_this_) {
    return !(_this_ === _this_);
  }
  function isInfinite(_this_) {
    return _this_ === Infinity ? true : _this_ === -Infinity;
  }
  function isFinite(_this_) {
    return !isInfinite(_this_) ? !isNaN_0(_this_) : false;
  }
  function isFinite_0(_this_) {
    return !isInfinite_0(_this_) ? !isNaN_1(_this_) : false;
  }
  function isInfinite_0(_this_) {
    return _this_ === Infinity ? true : _this_ === -Infinity;
  }
  function isNaN_1(_this_) {
    return !(_this_ === _this_);
  }
  function defaultPlatformRandom() {
    var tmp0_unsafeCast_0 = Math.random() * Math.pow(2, 32) | 0;
    return Random_0(tmp0_unsafeCast_0);
  }
  function _get_js_(_this_) {
    return (_this_ instanceof KClassImpl ? _this_ : THROW_CCE())._get_jClass__2();
  }
  function KCallable() {
  }
  KCallable.$metadata$ = {
    simpleName: 'KCallable',
    kind: 'interface',
    interfaces: []
  };
  function KClass() {
  }
  KClass.$metadata$ = {
    simpleName: 'KClass',
    kind: 'interface',
    interfaces: [KClassifier]
  };
  function KClassImpl(jClass) {
    this._jClass = jClass;
  }
  KClassImpl.prototype._get_jClass__2 = function () {
    return this._jClass;
  };
  KClassImpl.prototype.equals = function (other) {
    var tmp;
    if (other instanceof KClassImpl) {
      tmp = equals_1(this._get_jClass__2(), other._get_jClass__2());
    } else {
      {
        tmp = false;
      }
    }
    return tmp;
  };
  KClassImpl.prototype.hashCode = function () {
    var tmp0_safe_receiver = this._get_simpleName__4();
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : getStringHashCode(tmp0_safe_receiver);
    return tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs;
  };
  KClassImpl.prototype.toString = function () {
    return '' + 'class ' + this._get_simpleName__4();
  };
  KClassImpl.$metadata$ = {
    simpleName: 'KClassImpl',
    kind: 'class',
    interfaces: [KClass]
  };
  function PrimitiveKClassImpl(jClass, givenSimpleName, isInstanceFunction) {
    KClassImpl.call(this, jClass);
    this._givenSimpleName = givenSimpleName;
    this._isInstanceFunction = isInstanceFunction;
  }
  PrimitiveKClassImpl.prototype.equals = function (other) {
    if (!(other instanceof PrimitiveKClassImpl))
      return false;
    else {
    }
    return KClassImpl.prototype.equals.call(this, other) ? this._givenSimpleName === other._givenSimpleName : false;
  };
  PrimitiveKClassImpl.prototype._get_simpleName__4 = function () {
    return this._givenSimpleName;
  };
  PrimitiveKClassImpl.prototype.isInstance_4 = function (value) {
    return this._isInstanceFunction(value);
  };
  PrimitiveKClassImpl.$metadata$ = {
    simpleName: 'PrimitiveKClassImpl',
    kind: 'class',
    interfaces: []
  };
  function NothingKClassImpl() {
    NothingKClassImpl_instance = this;
    KClassImpl.call(this, Object);
    this._simpleName = 'Nothing';
  }
  NothingKClassImpl.prototype._get_simpleName__4 = function () {
    return this._simpleName;
  };
  NothingKClassImpl.prototype.isInstance_4 = function (value) {
    return false;
  };
  NothingKClassImpl.prototype._get_jClass__2 = function () {
    throw UnsupportedOperationException_init_$Create$_0("There's no native JS class for Nothing type");
  };
  NothingKClassImpl.prototype.equals = function (other) {
    return other === this;
  };
  NothingKClassImpl.prototype.hashCode = function () {
    return 0;
  };
  NothingKClassImpl.$metadata$ = {
    simpleName: 'NothingKClassImpl',
    kind: 'object',
    interfaces: []
  };
  var NothingKClassImpl_instance;
  function NothingKClassImpl_getInstance() {
    if (NothingKClassImpl_instance == null)
      new NothingKClassImpl();
    return NothingKClassImpl_instance;
  }
  function ErrorKClass() {
  }
  ErrorKClass.prototype._get_simpleName__4 = function () {
    var tmp0_error_0 = 'Unknown simpleName for ErrorKClass';
    throw IllegalStateException_init_$Create$(toString_1(tmp0_error_0));
  };
  ErrorKClass.prototype.isInstance_4 = function (value) {
    var tmp0_error_0 = "Can's check isInstance on ErrorKClass";
    throw IllegalStateException_init_$Create$(toString_1(tmp0_error_0));
  };
  ErrorKClass.prototype.equals = function (other) {
    return other === this;
  };
  ErrorKClass.prototype.hashCode = function () {
    return 0;
  };
  ErrorKClass.$metadata$ = {
    simpleName: 'ErrorKClass',
    kind: 'class',
    interfaces: [KClass]
  };
  function SimpleKClassImpl(jClass) {
    KClassImpl.call(this, jClass);
    var tmp = this;
    var tmp0_safe_receiver = jClass.$metadata$;
    var tmp0_unsafeCast_0 = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.simpleName;
    tmp._simpleName_0 = tmp0_unsafeCast_0;
  }
  SimpleKClassImpl.prototype._get_simpleName__4 = function () {
    return this._simpleName_0;
  };
  SimpleKClassImpl.prototype.isInstance_4 = function (value) {
    return jsIsType(value, this._get_jClass__2());
  };
  SimpleKClassImpl.$metadata$ = {
    simpleName: 'SimpleKClassImpl',
    kind: 'class',
    interfaces: []
  };
  function KProperty1() {
  }
  KProperty1.$metadata$ = {
    simpleName: 'KProperty1',
    kind: 'interface',
    interfaces: [KProperty]
  };
  function KMutableProperty1() {
  }
  KMutableProperty1.$metadata$ = {
    simpleName: 'KMutableProperty1',
    kind: 'interface',
    interfaces: [KProperty1, KMutableProperty]
  };
  function KProperty() {
  }
  KProperty.$metadata$ = {
    simpleName: 'KProperty',
    kind: 'interface',
    interfaces: [KCallable]
  };
  function KProperty0() {
  }
  KProperty0.$metadata$ = {
    simpleName: 'KProperty0',
    kind: 'interface',
    interfaces: [KProperty]
  };
  function KMutableProperty() {
  }
  KMutableProperty.$metadata$ = {
    simpleName: 'KMutableProperty',
    kind: 'interface',
    interfaces: [KProperty]
  };
  function KType() {
  }
  KType.$metadata$ = {
    simpleName: 'KType',
    kind: 'interface',
    interfaces: []
  };
  function createKType_0(classifier, arguments_0, isMarkedNullable) {
    return new KTypeImpl(classifier, asList(arguments_0), isMarkedNullable);
  }
  function createInvariantKTypeProjection_0(type) {
    return Companion_getInstance_2().invariant(type);
  }
  function asString(_this_, $this) {
    if (_this_._variance == null)
      return '*';
    return prefixString(_this_._variance) + toString_0(_this_._type);
  }
  function _no_name_provided__27(this$0) {
    this._this$0_10 = this$0;
  }
  _no_name_provided__27.prototype.invoke_25 = function (it) {
    return asString(it, this._this$0_10);
  };
  _no_name_provided__27.prototype.invoke_542 = function (p1) {
    return this.invoke_25(p1 instanceof KTypeProjection ? p1 : THROW_CCE());
  };
  _no_name_provided__27.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function KTypeImpl(classifier, arguments_0, isMarkedNullable) {
    this._classifier = classifier;
    this._arguments = arguments_0;
    this._isMarkedNullable = isMarkedNullable;
  }
  KTypeImpl.prototype._get_classifier__0 = function () {
    return this._classifier;
  };
  KTypeImpl.prototype._get_arguments__0 = function () {
    return this._arguments;
  };
  KTypeImpl.prototype._get_isMarkedNullable__0 = function () {
    return this._isMarkedNullable;
  };
  KTypeImpl.prototype.equals = function (other) {
    var tmp;
    var tmp_0;
    var tmp_1;
    if (other instanceof KTypeImpl) {
      tmp_1 = equals_1(this._classifier, other._classifier);
    } else {
      {
        tmp_1 = false;
      }
    }
    if (tmp_1) {
      tmp_0 = equals_1(this._arguments, other._arguments);
    } else {
      {
        tmp_0 = false;
      }
    }
    if (tmp_0) {
      tmp = this._isMarkedNullable === other._isMarkedNullable;
    } else {
      {
        tmp = false;
      }
    }
    return tmp;
  };
  KTypeImpl.prototype.hashCode = function () {
    return imul(imul(hashCode(this._classifier), 31) + hashCode(this._arguments) | 0, 31) + (this._isMarkedNullable | 0) | 0;
  };
  KTypeImpl.prototype.toString = function () {
    var tmp = this._classifier;
    var kClass = isInterface(tmp, KClass) ? tmp : null;
    var classifierName = kClass == null ? toString_1(this._classifier) : !(kClass._get_simpleName__4() == null) ? kClass._get_simpleName__4() : '(non-denotable type)';
    var tmp_0;
    if (this._arguments.isEmpty_53()) {
      tmp_0 = '';
    } else {
      tmp_0 = joinToString$default_0(this._arguments, ', ', '<', '>', 0, null, _no_name_provided_$factory_12(this), 24, null);
    }
    var args = tmp_0;
    var nullable_0 = this._isMarkedNullable ? '?' : '';
    return plus_3(classifierName, args) + nullable_0;
  };
  KTypeImpl.$metadata$ = {
    simpleName: 'KTypeImpl',
    kind: 'class',
    interfaces: [KType]
  };
  function prefixString(_this_) {
    var tmp0_subject = _this_;
    var tmp;
    if (tmp0_subject.equals(KVariance_INVARIANT_getInstance())) {
      tmp = '';
    } else if (tmp0_subject.equals(KVariance_IN_getInstance())) {
      tmp = 'in ';
    } else if (tmp0_subject.equals(KVariance_OUT_getInstance())) {
      tmp = 'out ';
    } else {
      noWhenBranchMatchedException();
    }
    return tmp;
  }
  function _no_name_provided_$factory_12(this$0) {
    var i = new _no_name_provided__27(this$0);
    return function (p1) {
      return i.invoke_25(p1);
    };
  }
  var functionClasses;
  function _no_name_provided__28() {
  }
  _no_name_provided__28.prototype.invoke_72 = function (it) {
    return isObject(it);
  };
  _no_name_provided__28.prototype.invoke_542 = function (p1) {
    return this.invoke_72((p1 == null ? true : isObject(p1)) ? p1 : THROW_CCE());
  };
  _no_name_provided__28.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__29() {
  }
  _no_name_provided__29.prototype.invoke_72 = function (it) {
    return isNumber(it);
  };
  _no_name_provided__29.prototype.invoke_542 = function (p1) {
    return this.invoke_72((p1 == null ? true : isObject(p1)) ? p1 : THROW_CCE());
  };
  _no_name_provided__29.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__30() {
  }
  _no_name_provided__30.prototype.invoke_72 = function (it) {
    return !(it == null) ? typeof it === 'boolean' : false;
  };
  _no_name_provided__30.prototype.invoke_542 = function (p1) {
    return this.invoke_72((p1 == null ? true : isObject(p1)) ? p1 : THROW_CCE());
  };
  _no_name_provided__30.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__31() {
  }
  _no_name_provided__31.prototype.invoke_72 = function (it) {
    return !(it == null) ? typeof it === 'number' : false;
  };
  _no_name_provided__31.prototype.invoke_542 = function (p1) {
    return this.invoke_72((p1 == null ? true : isObject(p1)) ? p1 : THROW_CCE());
  };
  _no_name_provided__31.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__32() {
  }
  _no_name_provided__32.prototype.invoke_72 = function (it) {
    return !(it == null) ? typeof it === 'number' : false;
  };
  _no_name_provided__32.prototype.invoke_542 = function (p1) {
    return this.invoke_72((p1 == null ? true : isObject(p1)) ? p1 : THROW_CCE());
  };
  _no_name_provided__32.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__33() {
  }
  _no_name_provided__33.prototype.invoke_72 = function (it) {
    return !(it == null) ? typeof it === 'number' : false;
  };
  _no_name_provided__33.prototype.invoke_542 = function (p1) {
    return this.invoke_72((p1 == null ? true : isObject(p1)) ? p1 : THROW_CCE());
  };
  _no_name_provided__33.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__34() {
  }
  _no_name_provided__34.prototype.invoke_72 = function (it) {
    return !(it == null) ? typeof it === 'number' : false;
  };
  _no_name_provided__34.prototype.invoke_542 = function (p1) {
    return this.invoke_72((p1 == null ? true : isObject(p1)) ? p1 : THROW_CCE());
  };
  _no_name_provided__34.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__35() {
  }
  _no_name_provided__35.prototype.invoke_72 = function (it) {
    return !(it == null) ? typeof it === 'number' : false;
  };
  _no_name_provided__35.prototype.invoke_542 = function (p1) {
    return this.invoke_72((p1 == null ? true : isObject(p1)) ? p1 : THROW_CCE());
  };
  _no_name_provided__35.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__36() {
  }
  _no_name_provided__36.prototype.invoke_72 = function (it) {
    return !(it == null) ? isArray(it) : false;
  };
  _no_name_provided__36.prototype.invoke_542 = function (p1) {
    return this.invoke_72((p1 == null ? true : isObject(p1)) ? p1 : THROW_CCE());
  };
  _no_name_provided__36.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__37() {
  }
  _no_name_provided__37.prototype.invoke_72 = function (it) {
    return !(it == null) ? typeof it === 'string' : false;
  };
  _no_name_provided__37.prototype.invoke_542 = function (p1) {
    return this.invoke_72((p1 == null ? true : isObject(p1)) ? p1 : THROW_CCE());
  };
  _no_name_provided__37.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__38() {
  }
  _no_name_provided__38.prototype.invoke_72 = function (it) {
    return it instanceof Error;
  };
  _no_name_provided__38.prototype.invoke_542 = function (p1) {
    return this.invoke_72((p1 == null ? true : isObject(p1)) ? p1 : THROW_CCE());
  };
  _no_name_provided__38.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__39() {
  }
  _no_name_provided__39.prototype.invoke_72 = function (it) {
    return !(it == null) ? isBooleanArray(it) : false;
  };
  _no_name_provided__39.prototype.invoke_542 = function (p1) {
    return this.invoke_72((p1 == null ? true : isObject(p1)) ? p1 : THROW_CCE());
  };
  _no_name_provided__39.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__40() {
  }
  _no_name_provided__40.prototype.invoke_72 = function (it) {
    return !(it == null) ? isCharArray(it) : false;
  };
  _no_name_provided__40.prototype.invoke_542 = function (p1) {
    return this.invoke_72((p1 == null ? true : isObject(p1)) ? p1 : THROW_CCE());
  };
  _no_name_provided__40.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__41() {
  }
  _no_name_provided__41.prototype.invoke_72 = function (it) {
    return !(it == null) ? isByteArray(it) : false;
  };
  _no_name_provided__41.prototype.invoke_542 = function (p1) {
    return this.invoke_72((p1 == null ? true : isObject(p1)) ? p1 : THROW_CCE());
  };
  _no_name_provided__41.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__42() {
  }
  _no_name_provided__42.prototype.invoke_72 = function (it) {
    return !(it == null) ? isShortArray(it) : false;
  };
  _no_name_provided__42.prototype.invoke_542 = function (p1) {
    return this.invoke_72((p1 == null ? true : isObject(p1)) ? p1 : THROW_CCE());
  };
  _no_name_provided__42.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__43() {
  }
  _no_name_provided__43.prototype.invoke_72 = function (it) {
    return !(it == null) ? isIntArray(it) : false;
  };
  _no_name_provided__43.prototype.invoke_542 = function (p1) {
    return this.invoke_72((p1 == null ? true : isObject(p1)) ? p1 : THROW_CCE());
  };
  _no_name_provided__43.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__44() {
  }
  _no_name_provided__44.prototype.invoke_72 = function (it) {
    return !(it == null) ? isLongArray(it) : false;
  };
  _no_name_provided__44.prototype.invoke_542 = function (p1) {
    return this.invoke_72((p1 == null ? true : isObject(p1)) ? p1 : THROW_CCE());
  };
  _no_name_provided__44.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__45() {
  }
  _no_name_provided__45.prototype.invoke_72 = function (it) {
    return !(it == null) ? isFloatArray(it) : false;
  };
  _no_name_provided__45.prototype.invoke_542 = function (p1) {
    return this.invoke_72((p1 == null ? true : isObject(p1)) ? p1 : THROW_CCE());
  };
  _no_name_provided__45.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__46() {
  }
  _no_name_provided__46.prototype.invoke_72 = function (it) {
    return !(it == null) ? isDoubleArray(it) : false;
  };
  _no_name_provided__46.prototype.invoke_542 = function (p1) {
    return this.invoke_72((p1 == null ? true : isObject(p1)) ? p1 : THROW_CCE());
  };
  _no_name_provided__46.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__47($arity) {
    this._$arity = $arity;
  }
  _no_name_provided__47.prototype.invoke_72 = function (it) {
    var tmp;
    if (typeof it === 'function') {
      tmp = it.length === this._$arity;
    } else {
      tmp = false;
    }
    return tmp;
  };
  _no_name_provided__47.prototype.invoke_542 = function (p1) {
    return this.invoke_72((p1 == null ? true : isObject(p1)) ? p1 : THROW_CCE());
  };
  _no_name_provided__47.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function PrimitiveClasses_0() {
    PrimitiveClasses_instance = this;
    var tmp = this;
    var tmp0_unsafeCast_0 = Object;
    var tmp_0 = tmp0_unsafeCast_0;
    tmp._anyClass = new PrimitiveKClassImpl(tmp_0, 'Any', _no_name_provided_$factory_13());
    var tmp_1 = this;
    var tmp0_unsafeCast_0_0 = Number;
    var tmp_2 = tmp0_unsafeCast_0_0;
    tmp_1._numberClass = new PrimitiveKClassImpl(tmp_2, 'Number', _no_name_provided_$factory_14());
    this._nothingClass = NothingKClassImpl_getInstance();
    var tmp_3 = this;
    var tmp0_unsafeCast_0_1 = Boolean;
    var tmp_4 = tmp0_unsafeCast_0_1;
    tmp_3._booleanClass = new PrimitiveKClassImpl(tmp_4, 'Boolean', _no_name_provided_$factory_15());
    var tmp_5 = this;
    var tmp0_unsafeCast_0_2 = Number;
    var tmp_6 = tmp0_unsafeCast_0_2;
    tmp_5._byteClass = new PrimitiveKClassImpl(tmp_6, 'Byte', _no_name_provided_$factory_16());
    var tmp_7 = this;
    var tmp0_unsafeCast_0_3 = Number;
    var tmp_8 = tmp0_unsafeCast_0_3;
    tmp_7._shortClass = new PrimitiveKClassImpl(tmp_8, 'Short', _no_name_provided_$factory_17());
    var tmp_9 = this;
    var tmp0_unsafeCast_0_4 = Number;
    var tmp_10 = tmp0_unsafeCast_0_4;
    tmp_9._intClass = new PrimitiveKClassImpl(tmp_10, 'Int', _no_name_provided_$factory_18());
    var tmp_11 = this;
    var tmp0_unsafeCast_0_5 = Number;
    var tmp_12 = tmp0_unsafeCast_0_5;
    tmp_11._floatClass = new PrimitiveKClassImpl(tmp_12, 'Float', _no_name_provided_$factory_19());
    var tmp_13 = this;
    var tmp0_unsafeCast_0_6 = Number;
    var tmp_14 = tmp0_unsafeCast_0_6;
    tmp_13._doubleClass = new PrimitiveKClassImpl(tmp_14, 'Double', _no_name_provided_$factory_20());
    var tmp_15 = this;
    var tmp0_unsafeCast_0_7 = Array;
    var tmp_16 = tmp0_unsafeCast_0_7;
    tmp_15._arrayClass = new PrimitiveKClassImpl(tmp_16, 'Array', _no_name_provided_$factory_21());
    var tmp_17 = this;
    var tmp0_unsafeCast_0_8 = String;
    var tmp_18 = tmp0_unsafeCast_0_8;
    tmp_17._stringClass = new PrimitiveKClassImpl(tmp_18, 'String', _no_name_provided_$factory_22());
    var tmp_19 = this;
    var tmp0_unsafeCast_0_9 = Error;
    var tmp_20 = tmp0_unsafeCast_0_9;
    tmp_19._throwableClass = new PrimitiveKClassImpl(tmp_20, 'Throwable', _no_name_provided_$factory_23());
    var tmp_21 = this;
    var tmp0_unsafeCast_0_10 = Array;
    var tmp_22 = tmp0_unsafeCast_0_10;
    tmp_21._booleanArrayClass = new PrimitiveKClassImpl(tmp_22, 'BooleanArray', _no_name_provided_$factory_24());
    var tmp_23 = this;
    var tmp0_unsafeCast_0_11 = Uint16Array;
    var tmp_24 = tmp0_unsafeCast_0_11;
    tmp_23._charArrayClass = new PrimitiveKClassImpl(tmp_24, 'CharArray', _no_name_provided_$factory_25());
    var tmp_25 = this;
    var tmp0_unsafeCast_0_12 = Int8Array;
    var tmp_26 = tmp0_unsafeCast_0_12;
    tmp_25._byteArrayClass = new PrimitiveKClassImpl(tmp_26, 'ByteArray', _no_name_provided_$factory_26());
    var tmp_27 = this;
    var tmp0_unsafeCast_0_13 = Int16Array;
    var tmp_28 = tmp0_unsafeCast_0_13;
    tmp_27._shortArrayClass = new PrimitiveKClassImpl(tmp_28, 'ShortArray', _no_name_provided_$factory_27());
    var tmp_29 = this;
    var tmp0_unsafeCast_0_14 = Int32Array;
    var tmp_30 = tmp0_unsafeCast_0_14;
    tmp_29._intArrayClass = new PrimitiveKClassImpl(tmp_30, 'IntArray', _no_name_provided_$factory_28());
    var tmp_31 = this;
    var tmp0_unsafeCast_0_15 = Array;
    var tmp_32 = tmp0_unsafeCast_0_15;
    tmp_31._longArrayClass = new PrimitiveKClassImpl(tmp_32, 'LongArray', _no_name_provided_$factory_29());
    var tmp_33 = this;
    var tmp0_unsafeCast_0_16 = Float32Array;
    var tmp_34 = tmp0_unsafeCast_0_16;
    tmp_33._floatArrayClass = new PrimitiveKClassImpl(tmp_34, 'FloatArray', _no_name_provided_$factory_30());
    var tmp_35 = this;
    var tmp0_unsafeCast_0_17 = Float64Array;
    var tmp_36 = tmp0_unsafeCast_0_17;
    tmp_35._doubleArrayClass = new PrimitiveKClassImpl(tmp_36, 'DoubleArray', _no_name_provided_$factory_31());
  }
  PrimitiveClasses_0.prototype._get_anyClass_ = function () {
    return this._anyClass;
  };
  PrimitiveClasses_0.prototype._get_numberClass_ = function () {
    return this._numberClass;
  };
  PrimitiveClasses_0.prototype._get_nothingClass_ = function () {
    return this._nothingClass;
  };
  PrimitiveClasses_0.prototype._get_booleanClass_ = function () {
    return this._booleanClass;
  };
  PrimitiveClasses_0.prototype._get_byteClass_ = function () {
    return this._byteClass;
  };
  PrimitiveClasses_0.prototype._get_shortClass_ = function () {
    return this._shortClass;
  };
  PrimitiveClasses_0.prototype._get_intClass_ = function () {
    return this._intClass;
  };
  PrimitiveClasses_0.prototype._get_floatClass_ = function () {
    return this._floatClass;
  };
  PrimitiveClasses_0.prototype._get_doubleClass_ = function () {
    return this._doubleClass;
  };
  PrimitiveClasses_0.prototype._get_arrayClass_ = function () {
    return this._arrayClass;
  };
  PrimitiveClasses_0.prototype._get_stringClass_ = function () {
    return this._stringClass;
  };
  PrimitiveClasses_0.prototype._get_throwableClass_ = function () {
    return this._throwableClass;
  };
  PrimitiveClasses_0.prototype._get_booleanArrayClass_ = function () {
    return this._booleanArrayClass;
  };
  PrimitiveClasses_0.prototype._get_charArrayClass_ = function () {
    return this._charArrayClass;
  };
  PrimitiveClasses_0.prototype._get_byteArrayClass_ = function () {
    return this._byteArrayClass;
  };
  PrimitiveClasses_0.prototype._get_shortArrayClass_ = function () {
    return this._shortArrayClass;
  };
  PrimitiveClasses_0.prototype._get_intArrayClass_ = function () {
    return this._intArrayClass;
  };
  PrimitiveClasses_0.prototype._get_longArrayClass_ = function () {
    return this._longArrayClass;
  };
  PrimitiveClasses_0.prototype._get_floatArrayClass_ = function () {
    return this._floatArrayClass;
  };
  PrimitiveClasses_0.prototype._get_doubleArrayClass_ = function () {
    return this._doubleArrayClass;
  };
  PrimitiveClasses_0.prototype.functionClass = function (arity) {
    var tmp0_elvis_lhs = functionClasses[arity];
    var tmp;
    if (tmp0_elvis_lhs == null) {
      var tmp0_unsafeCast_0_3 = Function;
      var tmp_0 = tmp0_unsafeCast_0_3;
      var tmp_1 = '' + 'Function' + arity;
      var result_2 = new PrimitiveKClassImpl(tmp_0, tmp_1, _no_name_provided_$factory_32(arity));
      var tmp1_asDynamic_0_5 = functionClasses;
      tmp1_asDynamic_0_5[arity] = result_2;
      tmp = result_2;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  };
  PrimitiveClasses_0.$metadata$ = {
    simpleName: 'PrimitiveClasses',
    kind: 'object',
    interfaces: []
  };
  Object.defineProperty(PrimitiveClasses_0.prototype, 'anyClass', {
    configurable: true,
    get: PrimitiveClasses_0.prototype._get_anyClass_
  });
  Object.defineProperty(PrimitiveClasses_0.prototype, 'numberClass', {
    configurable: true,
    get: PrimitiveClasses_0.prototype._get_numberClass_
  });
  Object.defineProperty(PrimitiveClasses_0.prototype, 'nothingClass', {
    configurable: true,
    get: PrimitiveClasses_0.prototype._get_nothingClass_
  });
  Object.defineProperty(PrimitiveClasses_0.prototype, 'booleanClass', {
    configurable: true,
    get: PrimitiveClasses_0.prototype._get_booleanClass_
  });
  Object.defineProperty(PrimitiveClasses_0.prototype, 'byteClass', {
    configurable: true,
    get: PrimitiveClasses_0.prototype._get_byteClass_
  });
  Object.defineProperty(PrimitiveClasses_0.prototype, 'shortClass', {
    configurable: true,
    get: PrimitiveClasses_0.prototype._get_shortClass_
  });
  Object.defineProperty(PrimitiveClasses_0.prototype, 'intClass', {
    configurable: true,
    get: PrimitiveClasses_0.prototype._get_intClass_
  });
  Object.defineProperty(PrimitiveClasses_0.prototype, 'floatClass', {
    configurable: true,
    get: PrimitiveClasses_0.prototype._get_floatClass_
  });
  Object.defineProperty(PrimitiveClasses_0.prototype, 'doubleClass', {
    configurable: true,
    get: PrimitiveClasses_0.prototype._get_doubleClass_
  });
  Object.defineProperty(PrimitiveClasses_0.prototype, 'arrayClass', {
    configurable: true,
    get: PrimitiveClasses_0.prototype._get_arrayClass_
  });
  Object.defineProperty(PrimitiveClasses_0.prototype, 'stringClass', {
    configurable: true,
    get: PrimitiveClasses_0.prototype._get_stringClass_
  });
  Object.defineProperty(PrimitiveClasses_0.prototype, 'throwableClass', {
    configurable: true,
    get: PrimitiveClasses_0.prototype._get_throwableClass_
  });
  Object.defineProperty(PrimitiveClasses_0.prototype, 'booleanArrayClass', {
    configurable: true,
    get: PrimitiveClasses_0.prototype._get_booleanArrayClass_
  });
  Object.defineProperty(PrimitiveClasses_0.prototype, 'charArrayClass', {
    configurable: true,
    get: PrimitiveClasses_0.prototype._get_charArrayClass_
  });
  Object.defineProperty(PrimitiveClasses_0.prototype, 'byteArrayClass', {
    configurable: true,
    get: PrimitiveClasses_0.prototype._get_byteArrayClass_
  });
  Object.defineProperty(PrimitiveClasses_0.prototype, 'shortArrayClass', {
    configurable: true,
    get: PrimitiveClasses_0.prototype._get_shortArrayClass_
  });
  Object.defineProperty(PrimitiveClasses_0.prototype, 'intArrayClass', {
    configurable: true,
    get: PrimitiveClasses_0.prototype._get_intArrayClass_
  });
  Object.defineProperty(PrimitiveClasses_0.prototype, 'longArrayClass', {
    configurable: true,
    get: PrimitiveClasses_0.prototype._get_longArrayClass_
  });
  Object.defineProperty(PrimitiveClasses_0.prototype, 'floatArrayClass', {
    configurable: true,
    get: PrimitiveClasses_0.prototype._get_floatArrayClass_
  });
  Object.defineProperty(PrimitiveClasses_0.prototype, 'doubleArrayClass', {
    configurable: true,
    get: PrimitiveClasses_0.prototype._get_doubleArrayClass_
  });
  var PrimitiveClasses_instance;
  function PrimitiveClasses_getInstance() {
    if (PrimitiveClasses_instance == null)
      new PrimitiveClasses_0();
    return PrimitiveClasses_instance;
  }
  function _no_name_provided_$factory_13() {
    var i = new _no_name_provided__28();
    return function (p1) {
      return i.invoke_72(p1);
    };
  }
  function _no_name_provided_$factory_14() {
    var i = new _no_name_provided__29();
    return function (p1) {
      return i.invoke_72(p1);
    };
  }
  function _no_name_provided_$factory_15() {
    var i = new _no_name_provided__30();
    return function (p1) {
      return i.invoke_72(p1);
    };
  }
  function _no_name_provided_$factory_16() {
    var i = new _no_name_provided__31();
    return function (p1) {
      return i.invoke_72(p1);
    };
  }
  function _no_name_provided_$factory_17() {
    var i = new _no_name_provided__32();
    return function (p1) {
      return i.invoke_72(p1);
    };
  }
  function _no_name_provided_$factory_18() {
    var i = new _no_name_provided__33();
    return function (p1) {
      return i.invoke_72(p1);
    };
  }
  function _no_name_provided_$factory_19() {
    var i = new _no_name_provided__34();
    return function (p1) {
      return i.invoke_72(p1);
    };
  }
  function _no_name_provided_$factory_20() {
    var i = new _no_name_provided__35();
    return function (p1) {
      return i.invoke_72(p1);
    };
  }
  function _no_name_provided_$factory_21() {
    var i = new _no_name_provided__36();
    return function (p1) {
      return i.invoke_72(p1);
    };
  }
  function _no_name_provided_$factory_22() {
    var i = new _no_name_provided__37();
    return function (p1) {
      return i.invoke_72(p1);
    };
  }
  function _no_name_provided_$factory_23() {
    var i = new _no_name_provided__38();
    return function (p1) {
      return i.invoke_72(p1);
    };
  }
  function _no_name_provided_$factory_24() {
    var i = new _no_name_provided__39();
    return function (p1) {
      return i.invoke_72(p1);
    };
  }
  function _no_name_provided_$factory_25() {
    var i = new _no_name_provided__40();
    return function (p1) {
      return i.invoke_72(p1);
    };
  }
  function _no_name_provided_$factory_26() {
    var i = new _no_name_provided__41();
    return function (p1) {
      return i.invoke_72(p1);
    };
  }
  function _no_name_provided_$factory_27() {
    var i = new _no_name_provided__42();
    return function (p1) {
      return i.invoke_72(p1);
    };
  }
  function _no_name_provided_$factory_28() {
    var i = new _no_name_provided__43();
    return function (p1) {
      return i.invoke_72(p1);
    };
  }
  function _no_name_provided_$factory_29() {
    var i = new _no_name_provided__44();
    return function (p1) {
      return i.invoke_72(p1);
    };
  }
  function _no_name_provided_$factory_30() {
    var i = new _no_name_provided__45();
    return function (p1) {
      return i.invoke_72(p1);
    };
  }
  function _no_name_provided_$factory_31() {
    var i = new _no_name_provided__46();
    return function (p1) {
      return i.invoke_72(p1);
    };
  }
  function _no_name_provided_$factory_32($arity) {
    var i = new _no_name_provided__47($arity);
    return function (p1) {
      return i.invoke_72(p1);
    };
  }
  function functionClasses$init$() {
    var tmp0_arrayOfNulls_0 = 0;
    return fillArrayVal(Array(tmp0_arrayOfNulls_0), null);
  }
  function getKClass_0(jClass) {
    var tmp;
    if (Array.isArray(jClass)) {
      tmp = getKClassM_0(jClass);
    } else {
      tmp = getKClass1_0(jClass);
    }
    return tmp;
  }
  function getKClassM_0(jClasses) {
    var tmp0_subject = jClasses.length;
    var tmp;
    switch (tmp0_subject) {
      case 1:
        tmp = getKClass1_0(jClasses[0]);
        break;
      case 0:
        var tmp0_unsafeCast_0 = NothingKClassImpl_getInstance();
        tmp = tmp0_unsafeCast_0;
        break;
      default:var tmp1_unsafeCast_0 = new ErrorKClass();
        tmp = tmp1_unsafeCast_0;
        break;
    }
    return tmp;
  }
  function getKClass1_0(jClass) {
    if (jClass === String) {
      var tmp0_unsafeCast_0 = PrimitiveClasses_getInstance()._stringClass;
      return tmp0_unsafeCast_0;
    }var metadata = jClass.$metadata$;
    var tmp;
    if (metadata != null) {
      var tmp_0;
      if (metadata.$kClass$ == null) {
        var kClass = new SimpleKClassImpl(jClass);
        metadata.$kClass$ = kClass;
        tmp_0 = kClass;
      } else {
        tmp_0 = metadata.$kClass$;
      }
      tmp = tmp_0;
    } else {
      tmp = new SimpleKClassImpl(jClass);
    }
    return tmp;
  }
  function getKClassFromExpression_0(e) {
    var tmp0_subject = typeof e;
    var tmp;
    switch (tmp0_subject) {
      case 'string':
        tmp = PrimitiveClasses_getInstance()._stringClass;
        break;
      case 'number':
        var tmp_0;
        var tmp0_asDynamic_0 = jsBitwiseOr(e, 0);
        if (tmp0_asDynamic_0 === e) {
          tmp_0 = PrimitiveClasses_getInstance()._intClass;
        } else {
          {
            tmp_0 = PrimitiveClasses_getInstance()._doubleClass;
          }
        }

        tmp = tmp_0;
        break;
      case 'boolean':
        tmp = PrimitiveClasses_getInstance()._booleanClass;
        break;
      case 'function':
        var tmp_1 = PrimitiveClasses_getInstance();
        tmp = tmp_1.functionClass(e.length);
        break;
      default:var tmp_2;
        if (isBooleanArray(e)) {
          tmp_2 = PrimitiveClasses_getInstance()._booleanArrayClass;
        } else {
          if (isCharArray(e)) {
            tmp_2 = PrimitiveClasses_getInstance()._charArrayClass;
          } else {
            if (isByteArray(e)) {
              tmp_2 = PrimitiveClasses_getInstance()._byteArrayClass;
            } else {
              if (isShortArray(e)) {
                tmp_2 = PrimitiveClasses_getInstance()._shortArrayClass;
              } else {
                if (isIntArray(e)) {
                  tmp_2 = PrimitiveClasses_getInstance()._intArrayClass;
                } else {
                  if (isLongArray(e)) {
                    tmp_2 = PrimitiveClasses_getInstance()._longArrayClass;
                  } else {
                    if (isFloatArray(e)) {
                      tmp_2 = PrimitiveClasses_getInstance()._floatArrayClass;
                    } else {
                      if (isDoubleArray(e)) {
                        tmp_2 = PrimitiveClasses_getInstance()._doubleArrayClass;
                      } else {
                        if (isInterface(e, KClass)) {
                          tmp_2 = getKClass_0(KClass);
                        } else {
                          if (isArray(e)) {
                            tmp_2 = PrimitiveClasses_getInstance()._arrayClass;
                          } else {
                            {
                              var constructor = Object.getPrototypeOf(e).constructor;
                              var tmp_3;
                              if (constructor === Object) {
                                tmp_3 = PrimitiveClasses_getInstance()._anyClass;
                              } else if (constructor === Error) {
                                tmp_3 = PrimitiveClasses_getInstance()._throwableClass;
                              } else {
                                var jsClass_0 = constructor;
                                tmp_3 = getKClass1_0(jsClass_0);
                              }
                              tmp_2 = tmp_3;
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }

        tmp = tmp_2;
        break;
    }
    var tmp1_unsafeCast_0 = tmp;
    return tmp1_unsafeCast_0;
  }
  function reset(_this_) {
    _this_.lastIndex = 0;
  }
  function Appendable() {
  }
  Appendable.$metadata$ = {
    simpleName: 'Appendable',
    kind: 'interface',
    interfaces: []
  };
  function StringBuilder_init_$Init$(capacity, $this) {
    StringBuilder_init_$Init$_0($this);
    return $this;
  }
  function StringBuilder_init_$Create$(capacity) {
    return StringBuilder_init_$Init$(capacity, Object.create(StringBuilder.prototype));
  }
  function StringBuilder_init_$Init$_0($this) {
    StringBuilder.call($this, '');
    return $this;
  }
  function StringBuilder_init_$Create$_0() {
    return StringBuilder_init_$Init$_0(Object.create(StringBuilder.prototype));
  }
  function StringBuilder(content) {
    this._string = !(content === undefined) ? content : '';
  }
  StringBuilder.prototype._get_length__0 = function () {
    var tmp0_asDynamic_0 = this._string;
    return tmp0_asDynamic_0.length;
  };
  StringBuilder.prototype.get_80 = function (index) {
    var tmp0_getOrElse_0 = this._string;
    var tmp;
    if (index >= 0 ? index <= _get_lastIndex__1(tmp0_getOrElse_0) : false) {
      tmp = charSequenceGet(tmp0_getOrElse_0, index);
    } else {
      throw IndexOutOfBoundsException_init_$Create$_0('' + 'index: ' + index + ', length: ' + this._get_length__0() + '}');
    }
    return tmp;
  };
  StringBuilder.prototype.subSequence_1 = function (startIndex, endIndex) {
    var tmp0_substring_0 = this._string;
    return tmp0_substring_0.substring(startIndex, endIndex);
  };
  StringBuilder.prototype.append_32 = function (value) {
    var tmp0_this = this;
    tmp0_this._string = tmp0_this._string + value;
    return this;
  };
  StringBuilder.prototype.append_31 = function (value) {
    var tmp0_this = this;
    tmp0_this._string = tmp0_this._string + toString_0(value);
    return this;
  };
  StringBuilder.prototype.append_30 = function (value, startIndex, endIndex) {
    var tmp0_elvis_lhs = value;
    return this.appendRange(tmp0_elvis_lhs == null ? 'null' : tmp0_elvis_lhs, startIndex, endIndex);
  };
  StringBuilder.prototype.append_5 = function (value) {
    var tmp0_this = this;
    tmp0_this._string = tmp0_this._string + toString_0(value);
    return this;
  };
  StringBuilder.prototype.append_6 = function (value) {
    var tmp0_this = this;
    tmp0_this._string = tmp0_this._string + value;
    return this;
  };
  StringBuilder.prototype.append_7 = function (value) {
    var tmp0_this = this;
    var tmp = tmp0_this;
    var tmp_0 = tmp0_this._string;
    var tmp1_elvis_lhs = value;
    tmp._string = tmp_0 + (tmp1_elvis_lhs == null ? 'null' : tmp1_elvis_lhs);
    return this;
  };
  StringBuilder.prototype.toString = function () {
    return this._string;
  };
  StringBuilder.prototype.clear_15 = function () {
    this._string = '';
    return this;
  };
  StringBuilder.prototype.appendRange = function (value, startIndex, endIndex) {
    var stringCsq = toString_1(value);
    Companion_getInstance().checkBoundsIndexes(startIndex, endIndex, stringCsq.length);
    var tmp0_this = this;
    var tmp = tmp0_this;
    var tmp_0 = tmp0_this._string;
    tmp._string = tmp_0 + stringCsq.substring(startIndex, endIndex);
    return this;
  };
  StringBuilder.$metadata$ = {
    simpleName: 'StringBuilder',
    kind: 'class',
    interfaces: [Appendable, CharSequence]
  };
  function isHighSurrogate(_this_) {
    var containsLower = new Char(55296);
    return _this_ <= new Char(56319) ? containsLower <= _this_ : false;
  }
  function isLowSurrogate(_this_) {
    var containsLower = new Char(56320);
    return _this_ <= new Char(57343) ? containsLower <= _this_ : false;
  }
  function isWhitespace(_this_) {
    return matches(_this_.toString(), '[\\s\\xA0]');
  }
  function uppercaseChar(_this_) {
    var tmp0_asDynamic_0 = _this_.toString();
    var tmp = tmp0_asDynamic_0.toUpperCase();
    var uppercase = (!(tmp == null) ? typeof tmp === 'string' : false) ? tmp : THROW_CCE();
    return uppercase.length > 1 ? _this_ : charSequenceGet(uppercase, 0);
  }
  function checkRadix(radix) {
    if (!(2 <= radix ? radix <= 36 : false)) {
      throw IllegalArgumentException_init_$Create$_0('' + 'radix ' + radix + ' was not in valid range 2..36');
    }return radix;
  }
  function toDouble(_this_) {
    var tmp0_unsafeCast_0 = +_this_;
    var tmp1_also_0 = tmp0_unsafeCast_0;
    if ((isNaN_0(tmp1_also_0) ? !isNaN_2(_this_) : false) ? true : tmp1_also_0 === 0.0 ? isBlank(_this_) : false) {
      numberFormatError(_this_);
    }return tmp1_also_0;
  }
  function toInt(_this_) {
    var tmp0_elvis_lhs = toIntOrNull(_this_);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      numberFormatError(_this_);
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  }
  function toInt_0(_this_, radix) {
    var tmp0_elvis_lhs = toIntOrNull_0(_this_, radix);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      numberFormatError(_this_);
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  }
  function toDoubleOrNull(_this_) {
    var tmp0_unsafeCast_0 = +_this_;
    var tmp1_takeIf_0 = tmp0_unsafeCast_0;
    var tmp;
    if (!((isNaN_0(tmp1_takeIf_0) ? !isNaN_2(_this_) : false) ? true : tmp1_takeIf_0 === 0.0 ? isBlank(_this_) : false)) {
      tmp = tmp1_takeIf_0;
    } else {
      {
        tmp = null;
      }
    }
    return tmp;
  }
  function toLong(_this_) {
    var tmp0_elvis_lhs = toLongOrNull(_this_);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      numberFormatError(_this_);
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  }
  function digitOf(char, radix) {
    var tmp0_let_0 = (char.compareTo_12(new Char(48)) >= 0 ? char.compareTo_12(new Char(57)) <= 0 : false) ? char.minus(new Char(48)) : (char.compareTo_12(new Char(65)) >= 0 ? char.compareTo_12(new Char(90)) <= 0 : false) ? char.minus(new Char(65)) + 10 | 0 : (char.compareTo_12(new Char(97)) >= 0 ? char.compareTo_12(new Char(122)) <= 0 : false) ? char.minus(new Char(97)) + 10 | 0 : -1;
    return tmp0_let_0 >= radix ? -1 : tmp0_let_0;
  }
  function isNaN_2(_this_) {
    var tmp0_subject = _this_.toLowerCase();
    switch (tmp0_subject) {
      case 'nan':
      case '+nan':
      case '-nan':
        return true;
      default:return false;
    }
  }
  function toByte(_this_) {
    var tmp0_elvis_lhs = toByteOrNull(_this_);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      numberFormatError(_this_);
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  }
  function toShort(_this_) {
    var tmp0_elvis_lhs = toShortOrNull(_this_);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      numberFormatError(_this_);
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  }
  function Regex_init_$Init$(pattern, option, $this) {
    Regex.call($this, pattern, setOf_0(option));
    return $this;
  }
  function Regex_init_$Create$(pattern, option) {
    return Regex_init_$Init$(pattern, option, Object.create(Regex.prototype));
  }
  function Regex_init_$Init$_0(pattern, $this) {
    Regex.call($this, pattern, emptySet());
    return $this;
  }
  function Regex_init_$Create$_0(pattern) {
    return Regex_init_$Init$_0(pattern, Object.create(Regex.prototype));
  }
  function Companion_13() {
    Companion_instance_12 = this;
    this._patternEscape = new RegExp('[-\\\\^$*+?.()|[\\]{}]', 'g');
    this._replacementEscape = new RegExp('\\$', 'g');
  }
  Companion_13.prototype.escape = function (literal) {
    var tmp0_nativeReplace_0 = this._patternEscape;
    var tmp1_nativeReplace_0 = '\\$&';
    return literal.replace(tmp0_nativeReplace_0, tmp1_nativeReplace_0);
  };
  Companion_13.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_12;
  function Companion_getInstance_12() {
    if (Companion_instance_12 == null)
      new Companion_13();
    return Companion_instance_12;
  }
  function _no_name_provided__48(this$0, $input, $startIndex) {
    this._this$0_11 = this$0;
    this._$input = $input;
    this._$startIndex = $startIndex;
  }
  _no_name_provided__48.prototype.invoke_540 = function () {
    return this._this$0_11.find_0(this._$input, this._$startIndex);
  };
  _no_name_provided__48.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__49() {
  }
  _no_name_provided__49.prototype.invoke_235 = function (match) {
    return match.next_35();
  };
  _no_name_provided__49.prototype.invoke_542 = function (p1) {
    return this.invoke_235((!(p1 == null) ? isInterface(p1, MatchResult) : false) ? p1 : THROW_CCE());
  };
  _no_name_provided__49.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function Regex(pattern, options) {
    Companion_getInstance_12();
    this._pattern = pattern;
    this._options = toSet_0(options);
    var tmp = this;
    var tmp0_mapTo_0_1 = ArrayList_init_$Create$_0(collectionSizeOrDefault(options, 10));
    var tmp0_iterator_1_2 = options.iterator_64();
    while (tmp0_iterator_1_2.hasNext_31()) {
      var item_2_3 = tmp0_iterator_1_2.next_35();
      tmp0_mapTo_0_1.add_33(item_2_3._value_0);
      Unit_getInstance();
    }
    tmp._nativePattern = new RegExp(pattern, joinToString$default_0(tmp0_mapTo_0_1, '', null, null, 0, null, null, 62, null) + 'g');
  }
  Regex.prototype.matches_0 = function (input) {
    reset(this._nativePattern);
    var match = this._nativePattern.exec(toString_1(input));
    return (!(match == null) ? match.index === 0 : false) ? this._nativePattern.lastIndex === charSequenceLength(input) : false;
  };
  Regex.prototype.find_0 = function (input, startIndex) {
    if (startIndex < 0 ? true : startIndex > charSequenceLength(input)) {
      throw IndexOutOfBoundsException_init_$Create$_0('' + 'Start index out of bounds: ' + startIndex + ', input length: ' + charSequenceLength(input));
    }return findNext(this._nativePattern, toString_1(input), startIndex);
  };
  Regex.prototype.find$default = function (input, startIndex, $mask0, $handler) {
    if (!(($mask0 & 2) === 0))
      startIndex = 0;
    return this.find_0(input, startIndex);
  };
  Regex.prototype.findAll = function (input, startIndex) {
    if (startIndex < 0 ? true : startIndex > charSequenceLength(input)) {
      throw IndexOutOfBoundsException_init_$Create$_0('' + 'Start index out of bounds: ' + startIndex + ', input length: ' + charSequenceLength(input));
    }var tmp = _no_name_provided_$factory_33(this, input, startIndex);
    return generateSequence(tmp, _no_name_provided_$factory_34());
  };
  Regex.prototype.findAll$default = function (input, startIndex, $mask0, $handler) {
    if (!(($mask0 & 2) === 0))
      startIndex = 0;
    return this.findAll(input, startIndex);
  };
  Regex.prototype.toString = function () {
    return this._nativePattern.toString();
  };
  Regex.$metadata$ = {
    simpleName: 'Regex',
    kind: 'class',
    interfaces: []
  };
  var RegexOption_IGNORE_CASE_instance;
  var RegexOption_MULTILINE_instance;
  var RegexOption_entriesInitialized;
  function RegexOption_initEntries() {
    if (RegexOption_entriesInitialized)
      return Unit_getInstance();
    RegexOption_entriesInitialized = true;
    RegexOption_IGNORE_CASE_instance = new RegexOption('IGNORE_CASE', 0, 'i');
    RegexOption_MULTILINE_instance = new RegexOption('MULTILINE', 1, 'm');
  }
  function RegexOption(name, ordinal, value) {
    Enum.call(this, name, ordinal);
    this._value_0 = value;
  }
  RegexOption.$metadata$ = {
    simpleName: 'RegexOption',
    kind: 'class',
    interfaces: []
  };
  function MatchGroup(value) {
    this._value_1 = value;
  }
  MatchGroup.prototype.toString = function () {
    return '' + 'MatchGroup(value=' + this._value_1 + ')';
  };
  MatchGroup.prototype.hashCode = function () {
    return getStringHashCode(this._value_1);
  };
  MatchGroup.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof MatchGroup))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof MatchGroup ? other : THROW_CCE();
    if (!(this._value_1 === tmp0_other_with_cast._value_1))
      return false;
    return true;
  };
  MatchGroup.$metadata$ = {
    simpleName: 'MatchGroup',
    kind: 'class',
    interfaces: []
  };
  function findNext(_this_, input, from) {
    _this_.lastIndex = from;
    var match = _this_.exec(input);
    if (match == null)
      return null;
    var range = numberRangeToNumber(match.index, _this_.lastIndex - 1 | 0);
    return new _no_name_provided__52(range, match, _this_, input);
  }
  function _no_name_provided__50(this$0) {
    this._this$0_12 = this$0;
  }
  _no_name_provided__50.prototype.invoke_75 = function (it) {
    return this._this$0_12.get_80(it);
  };
  _no_name_provided__50.prototype.invoke_542 = function (p1) {
    return this.invoke_75((!(p1 == null) ? typeof p1 === 'number' : false) ? p1 : THROW_CCE());
  };
  _no_name_provided__50.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__51($match) {
    this._$match = $match;
    AbstractCollection.call(this);
  }
  _no_name_provided__51.prototype._get_size__45 = function () {
    return this._$match.length;
  };
  _no_name_provided__51.prototype.iterator_64 = function () {
    var tmp = asSequence(_get_indices__0(this));
    return map(tmp, _no_name_provided_$factory_35(this)).iterator_64();
  };
  _no_name_provided__51.prototype.get_80 = function (index) {
    var tmp0_safe_receiver = this._$match[index];
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      tmp = new MatchGroup(tmp0_safe_receiver);
    }
    return tmp;
  };
  _no_name_provided__51.$metadata$ = {
    kind: 'class',
    interfaces: [MatchGroupCollection]
  };
  function _no_name_provided__52($range, $match, $this_findNext, $input) {
    this._$range = $range;
    this._$match_0 = $match;
    this._$this_findNext = $this_findNext;
    this._$input_0 = $input;
    this._range = this._$range;
    var tmp = this;
    tmp._groups = new _no_name_provided__51(this._$match_0);
    this._groupValues_ = null;
  }
  _no_name_provided__52.prototype._get_range__0 = function () {
    return this._range;
  };
  _no_name_provided__52.prototype._get_value__33 = function () {
    var tmp0_get_0 = 0;
    return ensureNotNull(this._$match_0[tmp0_get_0]);
  };
  _no_name_provided__52.prototype._get_groups__0 = function () {
    return this._groups;
  };
  _no_name_provided__52.prototype.next_35 = function () {
    return findNext(this._$this_findNext, this._$input_0, this._$range.isEmpty_53() ? this._$range._get_start__1() + 1 | 0 : this._$range._get_endInclusive__1() + 1 | 0);
  };
  _no_name_provided__52.$metadata$ = {
    kind: 'class',
    interfaces: [MatchResult]
  };
  function RegexOption_IGNORE_CASE_getInstance() {
    RegexOption_initEntries();
    return RegexOption_IGNORE_CASE_instance;
  }
  function _no_name_provided_$factory_33(this$0, $input, $startIndex) {
    var i = new _no_name_provided__48(this$0, $input, $startIndex);
    return function () {
      return i.invoke_540();
    };
  }
  function _no_name_provided_$factory_34() {
    var i = new _no_name_provided__49();
    return function (p1) {
      return i.invoke_235(p1);
    };
  }
  function _no_name_provided_$factory_35(this$0) {
    var i = new _no_name_provided__50(this$0);
    return function (p1) {
      return i.invoke_75(p1);
    };
  }
  function concatToString(_this_, startIndex, endIndex) {
    Companion_getInstance().checkBoundsIndexes(startIndex, endIndex, _this_.length);
    var result = '';
    var inductionVariable = startIndex;
    if (inductionVariable < endIndex)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        result = result + _this_[index];
      }
       while (inductionVariable < endIndex);
    return result;
  }
  function startsWith_1(_this_, prefix, ignoreCase) {
    if (!ignoreCase) {
      var tmp0_nativeStartsWith_0 = 0;
      return _this_.startsWith(prefix, tmp0_nativeStartsWith_0);
    } else
      return regionMatches(_this_, 0, prefix, 0, prefix.length, ignoreCase);
  }
  function startsWith$default_1(_this_, prefix, ignoreCase, $mask0, $handler) {
    if (!(($mask0 & 2) === 0))
      ignoreCase = false;
    return startsWith_1(_this_, prefix, ignoreCase);
  }
  function endsWith_1(_this_, suffix, ignoreCase) {
    if (!ignoreCase) {
      return _this_.endsWith(suffix);
    } else
      return regionMatches(_this_, _this_.length - suffix.length | 0, suffix, 0, suffix.length, ignoreCase);
  }
  function endsWith$default_1(_this_, suffix, ignoreCase, $mask0, $handler) {
    if (!(($mask0 & 2) === 0))
      ignoreCase = false;
    return endsWith_1(_this_, suffix, ignoreCase);
  }
  function repeat(_this_, n) {
    var tmp0_require_0 = n >= 0;
    if (!tmp0_require_0) {
      var message_1 = '' + "Count 'n' must be non-negative, but was " + n + '.';
      throw IllegalArgumentException_init_$Create$_0(toString_1(message_1));
    }var tmp0_subject = n;
    var tmp;
    switch (tmp0_subject) {
      case 0:
        tmp = '';
        break;
      case 1:
        tmp = toString_1(_this_);
        break;
      default:var result = '';
        if (!(charSequenceLength(_this_) === 0)) {
          var s = toString_1(_this_);
          var count_0 = n;
          $l$break: while (true) {
            if ((count_0 & 1) === 1) {
              result = result + s;
            }count_0 = count_0 >>> 1;
            if (count_0 === 0) {
              break $l$break;
            }s = s + s;
          }
        } else {
        }

        return result;
    }
    return tmp;
  }
  function replace(_this_, oldChar, newChar, ignoreCase) {
    var tmp0_nativeReplace_0 = new RegExp(Companion_getInstance_12().escape(oldChar.toString()), ignoreCase ? 'gi' : 'g');
    var tmp1_nativeReplace_0 = newChar.toString();
    return _this_.replace(tmp0_nativeReplace_0, tmp1_nativeReplace_0);
  }
  function replace$default(_this_, oldChar, newChar, ignoreCase, $mask0, $handler) {
    if (!(($mask0 & 4) === 0))
      ignoreCase = false;
    return replace(_this_, oldChar, newChar, ignoreCase);
  }
  function equals_0(_this_, other, ignoreCase) {
    var tmp;
    if (_this_ == null) {
      tmp = other == null;
    } else if (!ignoreCase) {
      tmp = _this_ == other;
    } else {
      var tmp_0;
      if (!(other == null)) {
        var tmp_1 = _this_.toLowerCase();
        tmp_0 = tmp_1 === other.toLowerCase();
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    }
    return tmp;
  }
  function isBlank(_this_) {
    var tmp;
    if (charSequenceLength(_this_) === 0) {
      tmp = true;
    } else {
      var tmp_0;
      if (typeof _this_ === 'string') {
        tmp_0 = _this_;
      } else {
        {
          tmp_0 = toString_1(_this_);
        }
      }
      tmp = matches(tmp_0, '^[\\s\\xA0]+$');
    }
    return tmp;
  }
  function regionMatches(_this_, thisOffset, other, otherOffset, length, ignoreCase) {
    return regionMatchesImpl(_this_, thisOffset, other, otherOffset, length, ignoreCase);
  }
  function matches(_this_, regex) {
    var result = _this_.match(regex);
    return !(result == null) ? !(result.length === 0) : false;
  }
  function startsWith_2(_this_, prefix, startIndex, ignoreCase) {
    if (!ignoreCase) {
      return _this_.startsWith(prefix, startIndex);
    } else
      return regionMatches(_this_, startIndex, prefix, 0, prefix.length, ignoreCase);
  }
  function startsWith$default_2(_this_, prefix, startIndex, ignoreCase, $mask0, $handler) {
    if (!(($mask0 & 4) === 0))
      ignoreCase = false;
    return startsWith_2(_this_, prefix, startIndex, ignoreCase);
  }
  function capitalize(_this_) {
    var tmp;
    if (charSequenceLength(_this_) > 0) {
      var tmp0_substring_0 = 0;
      var tmp1_substring_0 = 1;
      var tmp2_toUpperCase_0 = _this_.substring(tmp0_substring_0, tmp1_substring_0);
      var tmp_0 = tmp2_toUpperCase_0.toUpperCase();
      var tmp3_substring_0 = 1;
      tmp = tmp_0 + _this_.substring(tmp3_substring_0);
    } else {
      {
        tmp = _this_;
      }
    }
    return tmp;
  }
  function addSuppressed(_this_, exception) {
    if (!(_this_ === exception)) {
      var tmp0_unsafeCast_0 = _this_._suppressed;
      var suppressed = tmp0_unsafeCast_0;
      if (suppressed == null) {
        _this_._suppressed = mutableListOf([exception]);
      } else {
        suppressed.add_33(exception);
        Unit_getInstance();
      }
    }}
  function Companion_14() {
    Companion_instance_13 = this;
    this._MIN_VALUE_8 = new Char(0);
    this._MAX_VALUE_8 = new Char(65535);
    this._MIN_HIGH_SURROGATE = new Char(55296);
    this._MAX_HIGH_SURROGATE = new Char(56319);
    this._MIN_LOW_SURROGATE = new Char(56320);
    this._MAX_LOW_SURROGATE = new Char(57343);
    this._MIN_SURROGATE = new Char(55296);
    this._MAX_SURROGATE = new Char(57343);
    this._SIZE_BYTES_8 = 2;
    this._SIZE_BITS_8 = 16;
  }
  Companion_14.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_13;
  function Companion_getInstance_13() {
    if (Companion_instance_13 == null)
      new Companion_14();
    return Companion_instance_13;
  }
  function Char(code) {
    Companion_getInstance_13();
    var tmp = this;
    tmp._value_2 = _UShort___get_data__impl_(code) & 65535;
  }
  Char.prototype.compareTo_12 = function (other) {
    return this._value_2 - other._value_2 | 0;
  };
  Char.prototype.compareTo_35 = function (other) {
    return this.compareTo_12(other instanceof Char ? other : THROW_CCE());
  };
  Char.prototype.plus_55 = function (other) {
    return numberToChar(this._value_2 + other | 0);
  };
  Char.prototype.minus = function (other) {
    return this._value_2 - other._value_2 | 0;
  };
  Char.prototype.minus_28 = function (other) {
    return numberToChar(this._value_2 - other | 0);
  };
  Char.prototype.rangeTo = function (other) {
    return new CharRange(this, other);
  };
  Char.prototype.toByte_4 = function () {
    return toByte_0(this._value_2);
  };
  Char.prototype.toInt_5 = function () {
    return this._value_2;
  };
  Char.prototype.equals = function (other) {
    if (other === this)
      return true;
    if (!(other instanceof Char))
      return false;
    else {
    }
    return this._value_2 === other._value_2;
  };
  Char.prototype.hashCode = function () {
    return this._value_2;
  };
  Char.prototype.toString = function () {
    var tmp0_unsafeCast_0 = String.fromCharCode(this._value_2);
    return tmp0_unsafeCast_0;
  };
  Char.$metadata$ = {
    simpleName: 'Char',
    kind: 'class',
    interfaces: [Comparable]
  };
  function Iterable() {
  }
  Iterable.$metadata$ = {
    simpleName: 'Iterable',
    kind: 'interface',
    interfaces: []
  };
  function Entry() {
  }
  Entry.$metadata$ = {
    simpleName: 'Entry',
    kind: 'interface',
    interfaces: []
  };
  function Map_0() {
  }
  Map_0.$metadata$ = {
    simpleName: 'Map',
    kind: 'interface',
    interfaces: []
  };
  function List() {
  }
  List.$metadata$ = {
    simpleName: 'List',
    kind: 'interface',
    interfaces: [Collection]
  };
  function MutableList() {
  }
  MutableList.$metadata$ = {
    simpleName: 'MutableList',
    kind: 'interface',
    interfaces: [List, MutableCollection]
  };
  function MutableSet() {
  }
  MutableSet.$metadata$ = {
    simpleName: 'MutableSet',
    kind: 'interface',
    interfaces: [Set, MutableCollection]
  };
  function Set() {
  }
  Set.$metadata$ = {
    simpleName: 'Set',
    kind: 'interface',
    interfaces: [Collection]
  };
  function MutableEntry() {
  }
  MutableEntry.$metadata$ = {
    simpleName: 'MutableEntry',
    kind: 'interface',
    interfaces: [Entry]
  };
  function MutableMap() {
  }
  MutableMap.$metadata$ = {
    simpleName: 'MutableMap',
    kind: 'interface',
    interfaces: [Map_0]
  };
  function Collection() {
  }
  Collection.$metadata$ = {
    simpleName: 'Collection',
    kind: 'interface',
    interfaces: [Iterable]
  };
  function MutableCollection() {
  }
  MutableCollection.$metadata$ = {
    simpleName: 'MutableCollection',
    kind: 'interface',
    interfaces: [Collection, MutableIterable]
  };
  function MutableIterable() {
  }
  MutableIterable.$metadata$ = {
    simpleName: 'MutableIterable',
    kind: 'interface',
    interfaces: [Iterable]
  };
  function Companion_15() {
    Companion_instance_14 = this;
  }
  Companion_15.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_14;
  function Companion_getInstance_14() {
    if (Companion_instance_14 == null)
      new Companion_15();
    return Companion_instance_14;
  }
  function Enum(name, ordinal) {
    Companion_getInstance_14();
    this._name = name;
    this._ordinal = ordinal;
  }
  Enum.prototype._get_name__10 = function () {
    return this._name;
  };
  Enum.prototype._get_ordinal__0 = function () {
    return this._ordinal;
  };
  Enum.prototype.compareTo_14 = function (other) {
    return compareTo(this._ordinal, other._ordinal);
  };
  Enum.prototype.compareTo_35 = function (other) {
    return this.compareTo_14(other instanceof Enum ? other : THROW_CCE());
  };
  Enum.prototype.equals = function (other) {
    return this === other;
  };
  Enum.prototype.hashCode = function () {
    return identityHashCode(this);
  };
  Enum.prototype.toString = function () {
    return this._name;
  };
  Enum.$metadata$ = {
    simpleName: 'Enum',
    kind: 'class',
    interfaces: [Comparable]
  };
  function toString_0(_this_) {
    var tmp0_safe_receiver = _this_;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : toString_1(tmp0_safe_receiver);
    return tmp1_elvis_lhs == null ? 'null' : tmp1_elvis_lhs;
  }
  function plus_3(_this_, other) {
    var tmp2_safe_receiver = _this_;
    var tmp3_elvis_lhs = tmp2_safe_receiver == null ? null : toString_1(tmp2_safe_receiver);
    var tmp = tmp3_elvis_lhs == null ? 'null' : tmp3_elvis_lhs;
    var tmp0_safe_receiver = other;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : toString_1(tmp0_safe_receiver);
    return tmp + (tmp1_elvis_lhs == null ? 'null' : tmp1_elvis_lhs);
  }
  function fillArrayVal(array, initValue) {
    var inductionVariable = 0;
    var last_1 = array.length - 1 | 0;
    if (inductionVariable <= last_1)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        array[i] = initValue;
      }
       while (!(i === last_1));
    return array;
  }
  function arrayIterator(array) {
    return new _no_name_provided__53(array);
  }
  function booleanArray(size_0) {
    var tmp0_withType_0 = 'BooleanArray';
    var tmp1_withType_0 = fillArrayVal(Array(size_0), false);
    tmp1_withType_0.$type$ = tmp0_withType_0;
    var tmp2_unsafeCast_0 = tmp1_withType_0;
    return tmp2_unsafeCast_0;
  }
  function charArray(size_0) {
    var tmp1_withType_0 = 'CharArray';
    var tmp = Array(size_0);
    var tmp0_Char_0 = 0;
    var tmp_0;
    var tmp0__get_code__0_1 = new Char(0);
    if (tmp0_Char_0 < tmp0__get_code__0_1.toInt_5()) {
      tmp_0 = true;
    } else {
      {
        var tmp1__get_code__0_2 = new Char(65535);
        tmp_0 = tmp0_Char_0 > tmp1__get_code__0_2.toInt_5();
      }
    }
    if (tmp_0) {
      throw IllegalArgumentException_init_$Create$_0('' + 'Invalid Char code: ' + tmp0_Char_0);
    } else {
    }
    var tmp2_withType_0 = fillArrayVal(tmp, new Char(_UShort___init__impl_(toShort_0(tmp0_Char_0))));
    tmp2_withType_0.$type$ = tmp1_withType_0;
    var tmp3_unsafeCast_0 = tmp2_withType_0;
    return tmp3_unsafeCast_0;
  }
  function longArray(size_0) {
    var tmp0_withType_0 = 'LongArray';
    var tmp1_withType_0 = fillArrayVal(Array(size_0), new Long(0, 0));
    tmp1_withType_0.$type$ = tmp0_withType_0;
    var tmp2_unsafeCast_0 = tmp1_withType_0;
    return tmp2_unsafeCast_0;
  }
  function charArrayOf(arr) {
    var tmp0_withType_0 = 'CharArray';
    var tmp1_withType_0 = arr.slice();
    tmp1_withType_0.$type$ = tmp0_withType_0;
    var tmp2_unsafeCast_0 = tmp1_withType_0;
    return tmp2_unsafeCast_0;
  }
  function _no_name_provided__53($array) {
    this._$array = $array;
    this._index_3 = 0;
  }
  _no_name_provided__53.prototype.hasNext_31 = function () {
    return !(this._index_3 === this._$array.length);
  };
  _no_name_provided__53.prototype.next_35 = function () {
    var tmp;
    if (!(this._index_3 === this._$array.length)) {
      var tmp0_this = this;
      var tmp1 = tmp0_this._index_3;
      tmp0_this._index_3 = tmp1 + 1 | 0;
      tmp = this._$array[tmp1];
    } else {
      throw NoSuchElementException_init_$Create$_0('' + this._index_3);
    }
    return tmp;
  };
  _no_name_provided__53.$metadata$ = {
    kind: 'class',
    interfaces: [Iterator]
  };
  var buf;
  var bufFloat64;
  var bufInt32;
  var lowIndex;
  var highIndex;
  function getNumberHashCode(obj) {
    var tmp0_unsafeCast_0 = jsBitwiseOr(obj, 0);
    if (tmp0_unsafeCast_0 === obj) {
      return numberToInt(obj);
    } else {
    }
    bufFloat64[0] = obj;
    return imul(bufInt32[highIndex], 31) + bufInt32[lowIndex] | 0;
  }
  function bufFloat64$init$() {
    var tmp0_unsafeCast_0 = new Float64Array(buf);
    return tmp0_unsafeCast_0;
  }
  function bufInt32$init$() {
    var tmp0_unsafeCast_0 = new Int32Array(buf);
    return tmp0_unsafeCast_0;
  }
  function lowIndex$init$() {
    bufFloat64[0] = -1.0;
    return !(bufInt32[0] === 0) ? 1 : 0;
  }
  function charSequenceGet(a, index) {
    var tmp;
    if (isString(a)) {
      var tmp0_unsafeCast_0 = a.charCodeAt(index);
      var tmp1_Char_0 = tmp0_unsafeCast_0;
      var tmp_0;
      var tmp0__get_code__0_1 = new Char(0);
      if (tmp1_Char_0 < tmp0__get_code__0_1.toInt_5()) {
        tmp_0 = true;
      } else {
        {
          var tmp1__get_code__0_2 = new Char(65535);
          tmp_0 = tmp1_Char_0 > tmp1__get_code__0_2.toInt_5();
        }
      }
      if (tmp_0) {
        throw IllegalArgumentException_init_$Create$_0('' + 'Invalid Char code: ' + tmp1_Char_0);
      } else {
      }
      tmp = new Char(_UShort___init__impl_(toShort_0(tmp1_Char_0)));
    } else {
      tmp = a.get_80(index);
    }
    return tmp;
  }
  function isString(a) {
    return typeof a === 'string';
  }
  function charSequenceLength(a) {
    var tmp;
    if (isString(a)) {
      var tmp0_unsafeCast_0 = a.length;
      tmp = tmp0_unsafeCast_0;
    } else {
      tmp = a._get_length__0();
    }
    return tmp;
  }
  function charSequenceSubSequence(a, startIndex, endIndex) {
    var tmp;
    if (isString(a)) {
      var tmp0_unsafeCast_0 = a.substring(startIndex, endIndex);
      tmp = tmp0_unsafeCast_0;
    } else {
      tmp = a.subSequence_1(startIndex, endIndex);
    }
    return tmp;
  }
  function contentEqualsInternal(_this_, other) {
    var a = _this_;
    var b = other;
    if (a === b)
      return true;
    if (((a == null ? true : b == null) ? true : !isArrayish(b)) ? true : a.length != b.length)
      return false;
    var inductionVariable = 0;
    var last_1 = a.length;
    if (inductionVariable < last_1)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (!equals_1(a[i], b[i])) {
          return false;
        }}
       while (inductionVariable < last_1);
    return true;
  }
  function contentHashCodeInternal(_this_) {
    var a = _this_;
    if (a == null)
      return 0;
    var result = 1;
    var inductionVariable = 0;
    var last_1 = a.length;
    if (inductionVariable < last_1)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        result = imul(result, 31) + hashCode(a[i]) | 0;
      }
       while (inductionVariable < last_1);
    return result;
  }
  function arrayToString(array) {
    return joinToString$default(array, ', ', '[', ']', 0, null, _no_name_provided_$factory_36(), 24, null);
  }
  function _no_name_provided__54() {
  }
  _no_name_provided__54.prototype.invoke_72 = function (it) {
    return toString_1(it);
  };
  _no_name_provided__54.prototype.invoke_542 = function (p1) {
    return this.invoke_72((p1 == null ? true : isObject(p1)) ? p1 : THROW_CCE());
  };
  _no_name_provided__54.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided_$factory_36() {
    var i = new _no_name_provided__54();
    return function (p1) {
      return i.invoke_72(p1);
    };
  }
  function compareTo(a, b) {
    var tmp0_subject = typeof a;
    var tmp;
    switch (tmp0_subject) {
      case 'number':
        var tmp_0;
        if (typeof b === 'number') {
          tmp_0 = doubleCompareTo(a, b);
        } else {
          if (b instanceof Long) {
            tmp_0 = doubleCompareTo(a, b.toDouble_4());
          } else {
            {
              tmp_0 = primitiveCompareTo(a, b);
            }
          }
        }

        tmp = tmp_0;
        break;
      case 'string':
      case 'boolean':
        tmp = primitiveCompareTo(a, b);
        break;
      default:tmp = compareToDoNotIntrinsicify(a, b);
        break;
    }
    return tmp;
  }
  function doubleCompareTo(a, b) {
    var tmp;
    if (a < b) {
      tmp = -1;
    } else if (a > b) {
      tmp = 1;
    } else if (a === b) {
      var tmp_0;
      if (a !== 0) {
        tmp_0 = 0;
      } else {
        var tmp0_asDynamic_0 = 1;
        var ia = tmp0_asDynamic_0 / a;
        var tmp_1;
        var tmp1_asDynamic_0 = 1;
        if (ia === tmp1_asDynamic_0 / b) {
          tmp_1 = 0;
        } else {
          if (ia < 0) {
            tmp_1 = -1;
          } else {
            {
              tmp_1 = 1;
            }
          }
        }
        tmp_0 = tmp_1;
      }
      tmp = tmp_0;
    } else if (a !== a) {
      tmp = b !== b ? 0 : 1;
    } else {
      tmp = -1;
    }
    return tmp;
  }
  function primitiveCompareTo(a, b) {
    return a < b ? -1 : a > b ? 1 : 0;
  }
  function compareToDoNotIntrinsicify(a, b) {
    return a.compareTo_35(b);
  }
  function identityHashCode(obj) {
    return getObjectHashCode(obj);
  }
  function getObjectHashCode(obj) {
    if (!jsIn('kotlinHashCodeValue$', obj)) {
      var hash = jsBitwiseOr(Math.random() * 4.294967296E9, 0);
      var descriptor = new Object();
      descriptor.value = hash;
      descriptor.enumerable = false;
      Object.defineProperty(obj, 'kotlinHashCodeValue$', descriptor);
    }var tmp0_unsafeCast_0 = obj['kotlinHashCodeValue$'];
    return tmp0_unsafeCast_0;
  }
  function equals_1(obj1, obj2) {
    if (obj1 == null) {
      return obj2 == null;
    }if (obj2 == null) {
      return false;
    }if (typeof obj1 === 'object' ? typeof obj1.equals === 'function' : false) {
      return obj1.equals(obj2);
    }if (obj1 !== obj1) {
      return obj2 !== obj2;
    }if (typeof obj1 === 'number' ? typeof obj2 === 'number' : false) {
      var tmp;
      if (obj1 === obj2) {
        var tmp_0;
        if (obj1 !== 0) {
          tmp_0 = true;
        } else {
          var tmp0_asDynamic_0 = 1;
          var tmp_1 = tmp0_asDynamic_0 / obj1;
          var tmp1_asDynamic_0 = 1;
          tmp_0 = tmp_1 === tmp1_asDynamic_0 / obj2;
        }
        tmp = tmp_0;
      } else {
        tmp = false;
      }
      return tmp;
    }return obj1 === obj2;
  }
  function hashCode(obj) {
    if (obj == null)
      return 0;
    var tmp0_subject = typeof obj;
    var tmp;
    switch (tmp0_subject) {
      case 'object':
        tmp = 'function' === typeof obj.hashCode ? obj.hashCode() : getObjectHashCode(obj);
        break;
      case 'function':
        tmp = getObjectHashCode(obj);
        break;
      case 'number':
        tmp = getNumberHashCode(obj);
        break;
      case 'boolean':
        var tmp_0;
        if (obj) {
          tmp_0 = 1;
        } else {
          {
            tmp_0 = 0;
          }
        }

        tmp = tmp_0;
        break;
      default:tmp = getStringHashCode(String(obj));
        break;
    }
    return tmp;
  }
  function toString_1(o) {
    var tmp;
    if (o == null) {
      tmp = 'null';
    } else if (isArrayish(o)) {
      tmp = '[...]';
    } else {
      var tmp0_unsafeCast_0 = o.toString();
      tmp = tmp0_unsafeCast_0;
    }
    return tmp;
  }
  function getStringHashCode(str) {
    var hash = 0;
    var length = str.length;
    var inductionVariable = 0;
    var last_1 = length - 1 | 0;
    if (inductionVariable <= last_1)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var code = str.charCodeAt(i);
        hash = imul(hash, 31) + code | 0;
      }
       while (!(i === last_1));
    return hash;
  }
  function anyToString(o) {
    return Object.prototype.toString.call(o);
  }
  function boxIntrinsic(x) {
    var tmp0_error_0 = 'Should be lowered';
    throw IllegalStateException_init_$Create$(toString_1(tmp0_error_0));
  }
  function unboxIntrinsic(x) {
    var tmp0_error_0 = 'Should be lowered';
    throw IllegalStateException_init_$Create$(toString_1(tmp0_error_0));
  }
  function captureStack(instance, constructorFunction) {
    if (Error.captureStackTrace != null) {
      Error.captureStackTrace(instance, constructorFunction);
    } else {
      instance.stack = (new Error()).stack;
    }
  }
  function extendThrowable(this_, message, cause) {
    Error.call(this_);
    setPropertiesToThrowableInstance(this_, message, cause);
  }
  function setPropertiesToThrowableInstance(this_, message, cause) {
    if (!hasOwnPrototypeProperty(this_, 'message')) {
      var tmp;
      if (message == null) {
        var tmp_0;
        if (!(message === null)) {
          var tmp0_safe_receiver = cause;
          var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.toString();
          tmp_0 = tmp1_elvis_lhs == null ? undefined : tmp1_elvis_lhs;
        } else {
          tmp_0 = undefined;
        }
        tmp = tmp_0;
      } else {
        tmp = message;
      }
      this_.message = tmp;
    }if (!hasOwnPrototypeProperty(this_, 'cause')) {
      this_.cause = cause;
    }this_.name = Object.getPrototypeOf(this_).constructor.name;
  }
  function hasOwnPrototypeProperty(o, name) {
    var tmp0_unsafeCast_0 = Object.getPrototypeOf(o).hasOwnProperty(name);
    return tmp0_unsafeCast_0;
  }
  function getContinuation() {
    throw Exception_init_$Create$('Implemented as intrinsic');
  }
  function ensureNotNull(v) {
    var tmp;
    if (v == null) {
      THROW_NPE();
    } else {
      tmp = v;
    }
    return tmp;
  }
  function THROW_NPE() {
    throw NullPointerException_init_$Create$();
  }
  function noWhenBranchMatchedException() {
    throw NoWhenBranchMatchedException_init_$Create$();
  }
  function THROW_CCE() {
    throw ClassCastException_init_$Create$();
  }
  function throwUninitializedPropertyAccessException(name) {
    throw UninitializedPropertyAccessException_init_$Create$('' + 'lateinit property ' + name + ' has not been initialized');
  }
  function lazy(initializer_0) {
    return new UnsafeLazyImpl(initializer_0);
  }
  function lazy_0(mode, initializer_0) {
    return new UnsafeLazyImpl(initializer_0);
  }
  function fillFrom(src, dst) {
    var srcLen = src.length;
    var dstLen = dst.length;
    var index = 0;
    var arr = dst;
    while (index < srcLen ? index < dstLen : false) {
      var tmp = index;
      var tmp0 = index;
      index = tmp0 + 1 | 0;
      arr[tmp] = src[tmp0];
    }
    return dst;
  }
  function arrayCopyResize(source, newSize, defaultValue) {
    var tmp0_unsafeCast_0 = source.slice(0, newSize);
    var result = tmp0_unsafeCast_0;
    if (source.$type$ !== undefined) {
      result.$type$ = source.$type$;
    }var index = source.length;
    if (newSize > index) {
      result.length = newSize;
      while (index < newSize) {
        var tmp0 = index;
        index = tmp0 + 1 | 0;
        result[tmp0] = defaultValue;
      }
    }return result;
  }
  function Companion_16() {
    Companion_instance_15 = this;
    this._MIN_VALUE_9 = new Long(0, -2147483648);
    this._MAX_VALUE_9 = new Long(-1, 2147483647);
    this._SIZE_BYTES_9 = 8;
    this._SIZE_BITS_9 = 64;
  }
  Companion_16.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_15;
  function Companion_getInstance_15() {
    if (Companion_instance_15 == null)
      new Companion_16();
    return Companion_instance_15;
  }
  function Long(low, high) {
    Companion_getInstance_15();
    Number_0.call(this);
    this._low = low;
    this._high = high;
  }
  Long.prototype.compareTo_69 = function (other) {
    return compare(this, other);
  };
  Long.prototype.compareTo_35 = function (other) {
    return this.compareTo_69(other instanceof Long ? other : THROW_CCE());
  };
  Long.prototype.plus_56 = function (other) {
    return add(this, other);
  };
  Long.prototype.minus_29 = function (other) {
    return subtract(this, other);
  };
  Long.prototype.times_27 = function (other) {
    return multiply(this, other);
  };
  Long.prototype.div_27 = function (other) {
    return divide(this, other);
  };
  Long.prototype.rem_27 = function (other) {
    return modulo(this, other);
  };
  Long.prototype.unaryMinus_4 = function () {
    return this.inv_0().plus_56(new Long(1, 0));
  };
  Long.prototype.shl_0 = function (bitCount) {
    return shiftLeft(this, bitCount);
  };
  Long.prototype.ushr_0 = function (bitCount) {
    return shiftRightUnsigned(this, bitCount);
  };
  Long.prototype.and = function (other) {
    return new Long(this._low & other._low, this._high & other._high);
  };
  Long.prototype.xor = function (other) {
    return new Long(this._low ^ other._low, this._high ^ other._high);
  };
  Long.prototype.inv_0 = function () {
    return new Long(~this._low, ~this._high);
  };
  Long.prototype.toInt_5 = function () {
    return this._low;
  };
  Long.prototype.toDouble_4 = function () {
    return toNumber(this);
  };
  Long.prototype.valueOf = function () {
    return this.toDouble_4();
  };
  Long.prototype.equals = function (other) {
    var tmp;
    if (other instanceof Long) {
      tmp = equalsLong(this, other);
    } else {
      {
        tmp = false;
      }
    }
    return tmp;
  };
  Long.prototype.hashCode = function () {
    return hashCode_0(this);
  };
  Long.prototype.toString = function () {
    return toStringImpl(this, 10);
  };
  Long.$metadata$ = {
    simpleName: 'Long',
    kind: 'class',
    interfaces: [Comparable]
  };
  var ZERO;
  var ONE;
  var NEG_ONE;
  var MAX_VALUE;
  var MIN_VALUE;
  var TWO_PWR_24_;
  function compare(_this_, other) {
    if (equalsLong(_this_, other)) {
      return 0;
    }var thisNeg = isNegative(_this_);
    var otherNeg = isNegative(other);
    return (thisNeg ? !otherNeg : false) ? -1 : (!thisNeg ? otherNeg : false) ? 1 : isNegative(subtract(_this_, other)) ? -1 : 1;
  }
  function add(_this_, other) {
    var a48 = _this_._high >>> 16;
    var a32 = _this_._high & 65535;
    var a16 = _this_._low >>> 16;
    var a00 = _this_._low & 65535;
    var b48 = other._high >>> 16;
    var b32 = other._high & 65535;
    var b16 = other._low >>> 16;
    var b00 = other._low & 65535;
    var c48 = 0;
    var c32 = 0;
    var c16 = 0;
    var c00 = 0;
    c00 = c00 + (a00 + b00 | 0) | 0;
    c16 = c16 + (c00 >>> 16) | 0;
    c00 = c00 & 65535;
    c16 = c16 + (a16 + b16 | 0) | 0;
    c32 = c32 + (c16 >>> 16) | 0;
    c16 = c16 & 65535;
    c32 = c32 + (a32 + b32 | 0) | 0;
    c48 = c48 + (c32 >>> 16) | 0;
    c32 = c32 & 65535;
    c48 = c48 + (a48 + b48 | 0) | 0;
    c48 = c48 & 65535;
    return new Long(c16 << 16 | c00, c48 << 16 | c32);
  }
  function subtract(_this_, other) {
    return add(_this_, other.unaryMinus_4());
  }
  function multiply(_this_, other) {
    if (isZero(_this_)) {
      return ZERO;
    } else if (isZero(other)) {
      return ZERO;
    }if (equalsLong(_this_, MIN_VALUE)) {
      return isOdd(other) ? MIN_VALUE : ZERO;
    } else if (equalsLong(other, MIN_VALUE)) {
      return isOdd(_this_) ? MIN_VALUE : ZERO;
    }if (isNegative(_this_)) {
      var tmp;
      if (isNegative(other)) {
        tmp = multiply(negate(_this_), negate(other));
      } else {
        tmp = negate(multiply(negate(_this_), other));
      }
      return tmp;
    } else if (isNegative(other)) {
      return negate(multiply(_this_, negate(other)));
    }if (lessThan(_this_, TWO_PWR_24_) ? lessThan(other, TWO_PWR_24_) : false) {
      return fromNumber(toNumber(_this_) * toNumber(other));
    }var a48 = _this_._high >>> 16;
    var a32 = _this_._high & 65535;
    var a16 = _this_._low >>> 16;
    var a00 = _this_._low & 65535;
    var b48 = other._high >>> 16;
    var b32 = other._high & 65535;
    var b16 = other._low >>> 16;
    var b00 = other._low & 65535;
    var c48 = 0;
    var c32 = 0;
    var c16 = 0;
    var c00 = 0;
    c00 = c00 + imul(a00, b00) | 0;
    c16 = c16 + (c00 >>> 16) | 0;
    c00 = c00 & 65535;
    c16 = c16 + imul(a16, b00) | 0;
    c32 = c32 + (c16 >>> 16) | 0;
    c16 = c16 & 65535;
    c16 = c16 + imul(a00, b16) | 0;
    c32 = c32 + (c16 >>> 16) | 0;
    c16 = c16 & 65535;
    c32 = c32 + imul(a32, b00) | 0;
    c48 = c48 + (c32 >>> 16) | 0;
    c32 = c32 & 65535;
    c32 = c32 + imul(a16, b16) | 0;
    c48 = c48 + (c32 >>> 16) | 0;
    c32 = c32 & 65535;
    c32 = c32 + imul(a00, b32) | 0;
    c48 = c48 + (c32 >>> 16) | 0;
    c32 = c32 & 65535;
    c48 = c48 + (((imul(a48, b00) + imul(a32, b16) | 0) + imul(a16, b32) | 0) + imul(a00, b48) | 0) | 0;
    c48 = c48 & 65535;
    return new Long(c16 << 16 | c00, c48 << 16 | c32);
  }
  function divide(_this_, other) {
    if (isZero(other)) {
      throw Exception_init_$Create$('division by zero');
    } else if (isZero(_this_)) {
      return ZERO;
    }if (equalsLong(_this_, MIN_VALUE)) {
      if (equalsLong(other, ONE) ? true : equalsLong(other, NEG_ONE)) {
        return MIN_VALUE;
      } else if (equalsLong(other, MIN_VALUE)) {
        return ONE;
      } else {
        var halfThis = shiftRight(_this_, 1);
        var approx = shiftLeft(halfThis.div_27(other), 1);
        if (equalsLong(approx, ZERO)) {
          return isNegative(other) ? ONE : NEG_ONE;
        } else {
          var rem = subtract(_this_, multiply(other, approx));
          return add(approx, rem.div_27(other));
        }
      }
    } else if (equalsLong(other, MIN_VALUE)) {
      return ZERO;
    }if (isNegative(_this_)) {
      var tmp;
      if (isNegative(other)) {
        tmp = negate(_this_).div_27(negate(other));
      } else {
        tmp = negate(negate(_this_).div_27(other));
      }
      return tmp;
    } else if (isNegative(other)) {
      return negate(_this_.div_27(negate(other)));
    }var res = ZERO;
    var rem_0 = _this_;
    while (greaterThanOrEqual(rem_0, other)) {
      var approxDouble = toNumber(rem_0) / toNumber(other);
      var approx2 = Math.max(1.0, Math.floor(approxDouble));
      var log2 = Math.ceil(Math.log(approx2) / Math.LN2);
      var delta_0 = log2 <= 48.0 ? 1.0 : Math.pow(2, log2 - 48);
      var approxRes = fromNumber(approx2);
      var approxRem = multiply(approxRes, other);
      while (isNegative(approxRem) ? true : greaterThan(approxRem, rem_0)) {
        approx2 = approx2 - delta_0;
        approxRes = fromNumber(approx2);
        approxRem = multiply(approxRes, other);
      }
      if (isZero(approxRes)) {
        approxRes = ONE;
      }res = add(res, approxRes);
      rem_0 = subtract(rem_0, approxRem);
    }
    return res;
  }
  function modulo(_this_, other) {
    return subtract(_this_, multiply(_this_.div_27(other), other));
  }
  function shiftLeft(_this_, numBits) {
    var numBits_0 = numBits & 63;
    if (numBits_0 === 0) {
      return _this_;
    } else {
      if (numBits_0 < 32) {
        return new Long(_this_._low << numBits_0, _this_._high << numBits_0 | _this_._low >>> (32 - numBits_0 | 0));
      } else {
        return new Long(0, _this_._low << (numBits_0 - 32 | 0));
      }
    }
  }
  function shiftRight(_this_, numBits) {
    var numBits_0 = numBits & 63;
    if (numBits_0 === 0) {
      return _this_;
    } else {
      if (numBits_0 < 32) {
        return new Long(_this_._low >>> numBits_0 | _this_._high << (32 - numBits_0 | 0), _this_._high >> numBits_0);
      } else {
        return new Long(_this_._high >> (numBits_0 - 32 | 0), _this_._high >= 0 ? 0 : -1);
      }
    }
  }
  function shiftRightUnsigned(_this_, numBits) {
    var numBits_0 = numBits & 63;
    if (numBits_0 === 0) {
      return _this_;
    } else {
      if (numBits_0 < 32) {
        return new Long(_this_._low >>> numBits_0 | _this_._high << (32 - numBits_0 | 0), _this_._high >>> numBits_0);
      } else {
        var tmp;
        if (numBits_0 === 32) {
          tmp = new Long(_this_._high, 0);
        } else {
          tmp = new Long(_this_._high >>> (numBits_0 - 32 | 0), 0);
        }
        return tmp;
      }
    }
  }
  function toNumber(_this_) {
    return _this_._high * 4.294967296E9 + getLowBitsUnsigned(_this_);
  }
  function equalsLong(_this_, other) {
    return _this_._high === other._high ? _this_._low === other._low : false;
  }
  function hashCode_0(l) {
    return l._low ^ l._high;
  }
  function toStringImpl(_this_, radix) {
    if (radix < 2 ? true : 36 < radix) {
      throw Exception_init_$Create$('' + 'radix out of range: ' + radix);
    }if (isZero(_this_)) {
      return '0';
    }if (isNegative(_this_)) {
      if (equalsLong(_this_, MIN_VALUE)) {
        var radixLong = fromInt(radix);
        var div = _this_.div_27(radixLong);
        var rem = subtract(multiply(div, radixLong), _this_).toInt_5();
        var tmp = toStringImpl(div, radix);
        var tmp0_unsafeCast_0 = rem.toString(radix);
        return tmp + tmp0_unsafeCast_0;
      } else {
        return '' + '-' + toStringImpl(negate(_this_), radix);
      }
    }var radixToPower = fromNumber(Math.pow(radix, 6.0));
    var rem_0 = _this_;
    var result = '';
    while (true) {
      var remDiv = rem_0.div_27(radixToPower);
      var intval = subtract(rem_0, multiply(remDiv, radixToPower)).toInt_5();
      var tmp1_unsafeCast_0 = intval.toString(radix);
      var digits_0 = tmp1_unsafeCast_0;
      rem_0 = remDiv;
      if (isZero(rem_0)) {
        return digits_0 + result;
      } else {
        while (digits_0.length < 6) {
          digits_0 = '0' + digits_0;
        }
        result = digits_0 + result;
      }
    }
  }
  function fromInt(value) {
    return new Long(value, value < 0 ? -1 : 0);
  }
  function isNegative(_this_) {
    return _this_._high < 0;
  }
  function isZero(_this_) {
    return _this_._high === 0 ? _this_._low === 0 : false;
  }
  function isOdd(_this_) {
    return (_this_._low & 1) === 1;
  }
  function negate(_this_) {
    return _this_.unaryMinus_4();
  }
  function lessThan(_this_, other) {
    return compare(_this_, other) < 0;
  }
  function fromNumber(value) {
    if (isNaN_0(value)) {
      return ZERO;
    } else if (value <= -9.223372036854776E18) {
      return MIN_VALUE;
    } else if (value + 1 >= 9.223372036854776E18) {
      return MAX_VALUE;
    } else if (value < 0.0) {
      return negate(fromNumber(-value));
    } else {
      var twoPwr32 = 4.294967296E9;
      return new Long(jsBitwiseOr(value % twoPwr32, 0), jsBitwiseOr(value / twoPwr32, 0));
    }
  }
  function greaterThan(_this_, other) {
    return compare(_this_, other) > 0;
  }
  function greaterThanOrEqual(_this_, other) {
    return compare(_this_, other) >= 0;
  }
  function getLowBitsUnsigned(_this_) {
    return _this_._low >= 0 ? _this_._low : 4.294967296E9 + _this_._low;
  }
  function imul(a_local, b_local) {
    var lhs = jsBitwiseAnd(a_local, 4.29490176E9) * jsBitwiseAnd(b_local, 65535);
    var rhs = jsBitwiseAnd(a_local, 65535) * b_local;
    return jsBitwiseOr(lhs + rhs, 0);
  }
  function toByte_0(a) {
    var tmp0_unsafeCast_0 = a << 24 >> 24;
    return tmp0_unsafeCast_0;
  }
  function numberToInt(a) {
    var tmp;
    if (a instanceof Long) {
      tmp = a.toInt_5();
    } else {
      {
        tmp = doubleToInt(a);
      }
    }
    return tmp;
  }
  function doubleToInt(a) {
    return a > 2.147483647E9 ? 2147483647 : a < -2.147483648E9 ? -2147483648 : jsBitwiseOr(a, 0);
  }
  function toShort_0(a) {
    var tmp0_unsafeCast_0 = a << 16 >> 16;
    return tmp0_unsafeCast_0;
  }
  function numberToLong(a) {
    var tmp;
    if (a instanceof Long) {
      tmp = a;
    } else {
      {
        tmp = fromNumber(a);
      }
    }
    return tmp;
  }
  function numberToChar(a) {
    var tmp0_Char_0 = numberToInt(a) & 65535;
    var tmp;
    var tmp0__get_code__0_1 = new Char(0);
    if (tmp0_Char_0 < tmp0__get_code__0_1.toInt_5()) {
      tmp = true;
    } else {
      {
        var tmp1__get_code__0_2 = new Char(65535);
        tmp = tmp0_Char_0 > tmp1__get_code__0_2.toInt_5();
      }
    }
    if (tmp) {
      throw IllegalArgumentException_init_$Create$_0('' + 'Invalid Char code: ' + tmp0_Char_0);
    } else {
    }
    return new Char(_UShort___init__impl_(toShort_0(tmp0_Char_0)));
  }
  function toLong_0(a) {
    return fromInt(a);
  }
  function numberRangeToNumber(start, endInclusive) {
    return new IntRange(start, endInclusive);
  }
  var propertyRefClassMetadataCache;
  function getPropertyCallableRef(name, paramCount, type, getter, setter) {
    getter.get = getter;
    getter.set = setter;
    getter.callableName = name;
    var tmp0_unsafeCast_0 = getPropertyRefClass(getter, getKPropMetadata(paramCount, setter, type));
    return tmp0_unsafeCast_0;
  }
  function getPropertyRefClass(obj, metadata) {
    obj.$metadata$ = metadata;
    obj.constructor = obj;
    return obj;
  }
  function getKPropMetadata(paramCount, setter, type) {
    var mdata = propertyRefClassMetadataCache[paramCount][setter == null ? 0 : 1];
    if (mdata.interfaces.length == 0) {
      mdata.interfaces.push(type);
    }return mdata;
  }
  function propertyRefClassMetadataCache$init$() {
    var tmp = {kind: 'class', interfaces: []};
    var tmp0_arrayOf_0 = [tmp, {kind: 'class', interfaces: []}];
    var tmp_0 = tmp0_arrayOf_0;
    var tmp_1 = {kind: 'class', interfaces: []};
    var tmp1_arrayOf_0 = [tmp_1, {kind: 'class', interfaces: []}];
    var tmp_2 = tmp1_arrayOf_0;
    var tmp_3 = {kind: 'class', interfaces: []};
    var tmp2_arrayOf_0 = [tmp_3, {kind: 'class', interfaces: []}];
    var tmp3_arrayOf_0 = [tmp_0, tmp_2, tmp2_arrayOf_0];
    return tmp3_arrayOf_0;
  }
  function isArrayish(o) {
    var tmp;
    if (isJsArray(o)) {
      tmp = true;
    } else {
      var tmp0_unsafeCast_0 = ArrayBuffer.isView(o);
      tmp = tmp0_unsafeCast_0;
    }
    return tmp;
  }
  function isJsArray(obj) {
    var tmp0_unsafeCast_0 = Array.isArray(obj);
    return tmp0_unsafeCast_0;
  }
  function isInterface(obj, iface) {
    var tmp0_elvis_lhs = obj.constructor;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return false;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var ctor = tmp;
    return isInterfaceImpl(ctor, iface);
  }
  function isInterfaceImpl(ctor, iface) {
    if (ctor === iface)
      return true;
    var metadata = ctor.$metadata$;
    if (!(metadata == null)) {
      var interfaces = metadata.interfaces;
      var indexedObject = interfaces;
      var inductionVariable = 0;
      var last_1 = indexedObject.length;
      while (inductionVariable < last_1) {
        var i = indexedObject[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        if (isInterfaceImpl(i, iface)) {
          return true;
        }}
    }var superPrototype = !(ctor.prototype == null) ? Object.getPrototypeOf(ctor.prototype) : null;
    var superConstructor = superPrototype != null ? superPrototype.constructor : null;
    return !(superConstructor == null) ? isInterfaceImpl(superConstructor, iface) : false;
  }
  function isArray(obj) {
    var tmp;
    if (isJsArray(obj)) {
      tmp = !obj.$type$;
    } else {
      tmp = false;
    }
    return tmp;
  }
  function isObject(obj) {
    var objTypeOf = typeof obj;
    var tmp0_subject = objTypeOf;
    switch (tmp0_subject) {
      case 'string':
        return true;
      case 'number':
        return true;
      case 'boolean':
        return true;
      case 'function':
        return true;
      default:return jsInstanceOf(obj, Object);
    }
  }
  function isNumber(a) {
    var tmp;
    if (typeof a === 'number') {
      tmp = true;
    } else {
      tmp = a instanceof Long;
    }
    return tmp;
  }
  function isComparable(value) {
    var type = typeof value;
    return ((type === 'string' ? true : type === 'boolean') ? true : isNumber(value)) ? true : isInterface(value, _get_js_(getKClass_0(Comparable)));
  }
  function isCharSequence(value) {
    return typeof value === 'string' ? true : isInterface(value, _get_js_(getKClass_0(CharSequence)));
  }
  function isBooleanArray(a) {
    return isJsArray(a) ? a.$type$ === 'BooleanArray' : false;
  }
  function isByteArray(a) {
    return jsInstanceOf(a, Int8Array);
  }
  function isShortArray(a) {
    return jsInstanceOf(a, Int16Array);
  }
  function isCharArray(a) {
    return isJsArray(a) ? a.$type$ === 'CharArray' : false;
  }
  function isIntArray(a) {
    return jsInstanceOf(a, Int32Array);
  }
  function isFloatArray(a) {
    return jsInstanceOf(a, Float32Array);
  }
  function isLongArray(a) {
    return isJsArray(a) ? a.$type$ === 'LongArray' : false;
  }
  function isDoubleArray(a) {
    return jsInstanceOf(a, Float64Array);
  }
  function jsIsType(obj, jsClass_0) {
    if (jsClass_0 === Object) {
      return isObject(obj);
    }if ((obj == null ? true : jsClass_0 == null) ? true : !(typeof obj === 'object') ? !(typeof obj === 'function') : false) {
      return false;
    }if (typeof jsClass_0 === 'function' ? jsInstanceOf(obj, jsClass_0) : false) {
      return true;
    }var proto = jsGetPrototypeOf(jsClass_0);
    var tmp0_safe_receiver = proto;
    var constructor = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.constructor;
    if (constructor != null ? jsIn('$metadata$', constructor) : false) {
      var metadata = constructor.$metadata$;
      if (metadata.kind === 'object') {
        return obj === jsClass_0;
      }}var klassMetadata = jsClass_0.$metadata$;
    if (klassMetadata == null) {
      return jsInstanceOf(obj, jsClass_0);
    }if (klassMetadata.kind === 'interface' ? obj.constructor != null : false) {
      return isInterfaceImpl(obj.constructor, jsClass_0);
    }return false;
  }
  function jsGetPrototypeOf(jsClass_0) {
    return Object.getPrototypeOf(jsClass_0);
  }
  function copyOf(_this_, newSize) {
    var tmp0_require_0 = newSize >= 0;
    if (!tmp0_require_0) {
      var message_1 = '' + 'Invalid new array size: ' + newSize + '.';
      throw IllegalArgumentException_init_$Create$_0(toString_1(message_1));
    }var tmp1_withType_0 = 'CharArray';
    var tmp2_withType_0 = fillFrom(_this_, charArray(newSize));
    tmp2_withType_0.$type$ = tmp1_withType_0;
    return tmp2_withType_0;
  }
  function copyOf_0(_this_, newSize) {
    var tmp0_require_0 = newSize >= 0;
    if (!tmp0_require_0) {
      var message_1 = '' + 'Invalid new array size: ' + newSize + '.';
      throw IllegalArgumentException_init_$Create$_0(toString_1(message_1));
    }return fillFrom(_this_, new Float64Array(newSize));
  }
  function copyOf_1(_this_, newSize) {
    var tmp0_require_0 = newSize >= 0;
    if (!tmp0_require_0) {
      var message_1 = '' + 'Invalid new array size: ' + newSize + '.';
      throw IllegalArgumentException_init_$Create$_0(toString_1(message_1));
    }return fillFrom(_this_, new Float32Array(newSize));
  }
  function copyOf_2(_this_, newSize) {
    var tmp0_require_0 = newSize >= 0;
    if (!tmp0_require_0) {
      var message_1 = '' + 'Invalid new array size: ' + newSize + '.';
      throw IllegalArgumentException_init_$Create$_0(toString_1(message_1));
    }var tmp1_withType_0 = 'LongArray';
    var tmp2_withType_0 = arrayCopyResize(_this_, newSize, new Long(0, 0));
    tmp2_withType_0.$type$ = tmp1_withType_0;
    return tmp2_withType_0;
  }
  function copyOf_3(_this_, newSize) {
    var tmp0_require_0 = newSize >= 0;
    if (!tmp0_require_0) {
      var message_1 = '' + 'Invalid new array size: ' + newSize + '.';
      throw IllegalArgumentException_init_$Create$_0(toString_1(message_1));
    }return fillFrom(_this_, new Int32Array(newSize));
  }
  function copyOf_4(_this_, newSize) {
    var tmp0_require_0 = newSize >= 0;
    if (!tmp0_require_0) {
      var message_1 = '' + 'Invalid new array size: ' + newSize + '.';
      throw IllegalArgumentException_init_$Create$_0(toString_1(message_1));
    }return fillFrom(_this_, new Int16Array(newSize));
  }
  function copyOf_5(_this_, newSize) {
    var tmp0_require_0 = newSize >= 0;
    if (!tmp0_require_0) {
      var message_1 = '' + 'Invalid new array size: ' + newSize + '.';
      throw IllegalArgumentException_init_$Create$_0(toString_1(message_1));
    }return fillFrom(_this_, new Int8Array(newSize));
  }
  function copyOf_6(_this_, newSize) {
    var tmp0_require_0 = newSize >= 0;
    if (!tmp0_require_0) {
      var message_1 = '' + 'Invalid new array size: ' + newSize + '.';
      throw IllegalArgumentException_init_$Create$_0(toString_1(message_1));
    }var tmp1_withType_0 = 'BooleanArray';
    var tmp2_withType_0 = arrayCopyResize(_this_, newSize, false);
    tmp2_withType_0.$type$ = tmp1_withType_0;
    return tmp2_withType_0;
  }
  function contentEquals(_this_, other) {
    return contentEqualsInternal(_this_, other);
  }
  function contentHashCode(_this_) {
    return contentHashCodeInternal(_this_);
  }
  function asList(_this_) {
    return new ArrayList(_this_);
  }
  function sortWith_0(_this_, comparator) {
    if (_this_.length > 1)
      sortArrayWith(_this_, comparator);
  }
  function toTypedArray(_this_) {
    return [].slice.call(_this_);
  }
  function fill(_this_, element, fromIndex, toIndex) {
    Companion_getInstance().checkRangeIndexes(fromIndex, toIndex, _this_.length);
    _this_.fill(element, fromIndex, toIndex);
  }
  function fill$default(_this_, element, fromIndex, toIndex, $mask0, $handler) {
    if (!(($mask0 & 2) === 0))
      fromIndex = 0;
    if (!(($mask0 & 4) === 0))
      toIndex = _this_.length;
    return fill(_this_, element, fromIndex, toIndex);
  }
  function reverse(_this_) {
    var midPoint = (_this_._get_size__45() / 2 | 0) - 1 | 0;
    if (midPoint < 0)
      return Unit_getInstance();
    var reverseIndex = _get_lastIndex__0(_this_);
    var inductionVariable = 0;
    if (inductionVariable <= midPoint)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var tmp = _this_.get_80(index);
        _this_.set_11(index, _this_.get_80(reverseIndex));
        Unit_getInstance();
        _this_.set_11(reverseIndex, tmp);
        Unit_getInstance();
        var tmp1 = reverseIndex;
        reverseIndex = tmp1 - 1 | 0;
        Unit_getInstance();
      }
       while (!(index === midPoint));
  }
  function releaseIntercepted($this) {
    var intercepted_0 = $this._intercepted_;
    if (!(intercepted_0 == null) ? !(intercepted_0 === $this) : false) {
      ensureNotNull($this._get_context__86().get_70(Key_getInstance())).releaseInterceptedContinuation_9(intercepted_0);
    }$this._intercepted_ = CompletedContinuation_getInstance();
  }
  function CoroutineImpl_0(resultContinuation) {
    this._resultContinuation = resultContinuation;
    this._state_0 = 0;
    this._exceptionState = 0;
    this._result = null;
    this._exception_0 = null;
    this._finallyPath = null;
    var tmp = this;
    var tmp0_safe_receiver = this._resultContinuation;
    tmp.__context = tmp0_safe_receiver == null ? null : tmp0_safe_receiver._get_context__86();
    this._intercepted_ = null;
  }
  CoroutineImpl_0.prototype._get_exception_ = function () {
    return this._exception_0;
  };
  CoroutineImpl_0.prototype._get_context__86 = function () {
    return ensureNotNull(this.__context);
  };
  CoroutineImpl_0.prototype.intercepted_71 = function () {
    var tmp2_elvis_lhs = this._intercepted_;
    var tmp;
    if (tmp2_elvis_lhs == null) {
      var tmp0_safe_receiver = this._get_context__86().get_70(Key_getInstance());
      var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.interceptContinuation_9(this);
      var tmp0_also_0 = tmp1_elvis_lhs == null ? this : tmp1_elvis_lhs;
      this._intercepted_ = tmp0_also_0;
      tmp = tmp0_also_0;
    } else {
      tmp = tmp2_elvis_lhs;
    }
    return tmp;
  };
  CoroutineImpl_0.prototype.resumeWith_86 = function (result) {
    var current = this;
    var tmp;
    if (_Result___get_isFailure__impl_(result)) {
      tmp = null;
    } else {
      var tmp_0 = _Result___get_value__impl_(result);
      tmp = (tmp_0 == null ? true : isObject(tmp_0)) ? tmp_0 : THROW_CCE();
    }
    var currentResult = tmp;
    var currentException = Result__exceptionOrNull_impl(result);
    while (true) {
      var tmp0_with_0 = current;
      if (currentException == null) {
        tmp0_with_0._result = currentResult;
      } else {
        tmp0_with_0._state_0 = tmp0_with_0._exceptionState;
        tmp0_with_0._exception_0 = currentException;
      }
      try {
        var outcome_2 = tmp0_with_0.doResume_72();
        if (outcome_2 === _get_COROUTINE_SUSPENDED_())
          return Unit_getInstance();
        currentResult = outcome_2;
        currentException = null;
      } catch ($p) {
        currentResult = null;
        currentException = $p;
      }
      releaseIntercepted(tmp0_with_0);
      var completion_4 = ensureNotNull(tmp0_with_0._resultContinuation);
      if (completion_4 instanceof CoroutineImpl_0) {
        current = completion_4;
      } else {
        {
          if (!(currentException == null)) {
            var tmp0_resumeWithException_0_5 = ensureNotNull(currentException);
            var tmp0_failure_0_1_6 = Companion_getInstance_3();
            completion_4.resumeWith_34(_Result___init__impl_(createFailure(tmp0_resumeWithException_0_5)));
          } else {
            var tmp1_resume_0_7 = currentResult;
            var tmp0_success_0_1_8 = Companion_getInstance_3();
            completion_4.resumeWith_34(_Result___init__impl_(tmp1_resume_0_7));
          }
          return Unit_getInstance();
        }
      }
    }
  };
  CoroutineImpl_0.prototype.resumeWith_34 = function (result) {
    return this.resumeWith_86(result);
  };
  CoroutineImpl_0.$metadata$ = {
    simpleName: 'CoroutineImpl',
    kind: 'class',
    interfaces: [Continuation]
  };
  function CompletedContinuation() {
    CompletedContinuation_instance = this;
  }
  CompletedContinuation.prototype._get_context__86 = function () {
    var tmp0_error_0 = 'This continuation is already complete';
    throw IllegalStateException_init_$Create$(toString_1(tmp0_error_0));
  };
  CompletedContinuation.prototype.resumeWith_86 = function (result) {
    var tmp0_error_0 = 'This continuation is already complete';
    throw IllegalStateException_init_$Create$(toString_1(tmp0_error_0));
  };
  CompletedContinuation.prototype.resumeWith_34 = function (result) {
    return this.resumeWith_86(result);
  };
  CompletedContinuation.prototype.toString = function () {
    return 'This continuation is already complete';
  };
  CompletedContinuation.$metadata$ = {
    simpleName: 'CompletedContinuation',
    kind: 'object',
    interfaces: [Continuation]
  };
  var CompletedContinuation_instance;
  function CompletedContinuation_getInstance() {
    if (CompletedContinuation_instance == null)
      new CompletedContinuation();
    return CompletedContinuation_instance;
  }
  function intercepted(_this_) {
    var tmp0_safe_receiver = _this_ instanceof CoroutineImpl_0 ? _this_ : null;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.intercepted_71();
    return tmp1_elvis_lhs == null ? _this_ : tmp1_elvis_lhs;
  }
  function createCoroutineUnintercepted(_this_, receiver, completion) {
    return new _no_name_provided__1_0(_this_, receiver, completion);
  }
  function _no_name_provided__1_0($this_createCoroutineUnintercepted, $receiver, $completion) {
    this._$this_createCoroutineUnintercepted = $this_createCoroutineUnintercepted;
    this._$receiver = $receiver;
    this._$completion = $completion;
    CoroutineImpl_0.call(this, isInterface($completion, Continuation) ? $completion : THROW_CCE());
  }
  _no_name_provided__1_0.prototype.doResume_2 = function () {
    if (this._get_exception_() != null)
      throw this._get_exception_();
    return this._$this_createCoroutineUnintercepted(this._$receiver, this._$completion);
  };
  _no_name_provided__1_0.prototype.doResume_72 = function () {
    return this.doResume_2();
  };
  _no_name_provided__1_0.$metadata$ = {
    simpleName: '<no name provided>_1',
    kind: 'class',
    interfaces: []
  };
  function Exception_init_$Init$($this) {
    extendThrowable($this, void 1, void 1);
    Exception.call($this);
    return $this;
  }
  function Exception_init_$Init$_0(message, $this) {
    extendThrowable($this, message, void 1);
    Exception.call($this);
    return $this;
  }
  function Exception_init_$Create$(message) {
    var tmp = Exception_init_$Init$_0(message, Object.create(Exception.prototype));
    captureStack(tmp, Exception_init_$Create$);
    return tmp;
  }
  function Exception_init_$Init$_1(message, cause, $this) {
    extendThrowable($this, message, cause);
    Exception.call($this);
    return $this;
  }
  function Exception() {
    captureStack(this, Exception);
  }
  Exception.$metadata$ = {
    simpleName: 'Exception',
    kind: 'class',
    interfaces: []
  };
  function Error_init_$Init$(message, $this) {
    extendThrowable($this, message, void 1);
    Error_0.call($this);
    return $this;
  }
  function Error_init_$Create$(message) {
    var tmp = Error_init_$Init$(message, Object.create(Error_0.prototype));
    captureStack(tmp, Error_init_$Create$);
    return tmp;
  }
  function Error_init_$Init$_0(message, cause, $this) {
    extendThrowable($this, message, cause);
    Error_0.call($this);
    return $this;
  }
  function Error_init_$Create$_0(message, cause) {
    var tmp = Error_init_$Init$_0(message, cause, Object.create(Error_0.prototype));
    captureStack(tmp, Error_init_$Create$_0);
    return tmp;
  }
  function Error_0() {
    captureStack(this, Error_0);
  }
  Error_0.$metadata$ = {
    simpleName: 'Error',
    kind: 'class',
    interfaces: []
  };
  function IllegalArgumentException_init_$Init$($this) {
    RuntimeException_init_$Init$($this);
    IllegalArgumentException.call($this);
    return $this;
  }
  function IllegalArgumentException_init_$Create$() {
    var tmp = IllegalArgumentException_init_$Init$(Object.create(IllegalArgumentException.prototype));
    captureStack(tmp, IllegalArgumentException_init_$Create$);
    return tmp;
  }
  function IllegalArgumentException_init_$Init$_0(message, $this) {
    RuntimeException_init_$Init$_0(message, $this);
    IllegalArgumentException.call($this);
    return $this;
  }
  function IllegalArgumentException_init_$Create$_0(message) {
    var tmp = IllegalArgumentException_init_$Init$_0(message, Object.create(IllegalArgumentException.prototype));
    captureStack(tmp, IllegalArgumentException_init_$Create$_0);
    return tmp;
  }
  function IllegalArgumentException_init_$Init$_1(message, cause, $this) {
    RuntimeException_init_$Init$_1(message, cause, $this);
    IllegalArgumentException.call($this);
    return $this;
  }
  function IllegalArgumentException_init_$Create$_1(message, cause) {
    var tmp = IllegalArgumentException_init_$Init$_1(message, cause, Object.create(IllegalArgumentException.prototype));
    captureStack(tmp, IllegalArgumentException_init_$Create$_1);
    return tmp;
  }
  function IllegalArgumentException() {
    captureStack(this, IllegalArgumentException);
  }
  IllegalArgumentException.$metadata$ = {
    simpleName: 'IllegalArgumentException',
    kind: 'class',
    interfaces: []
  };
  function RuntimeException_init_$Init$($this) {
    Exception_init_$Init$($this);
    RuntimeException.call($this);
    return $this;
  }
  function RuntimeException_init_$Init$_0(message, $this) {
    Exception_init_$Init$_0(message, $this);
    RuntimeException.call($this);
    return $this;
  }
  function RuntimeException_init_$Init$_1(message, cause, $this) {
    Exception_init_$Init$_1(message, cause, $this);
    RuntimeException.call($this);
    return $this;
  }
  function RuntimeException_init_$Create$(message, cause) {
    var tmp = RuntimeException_init_$Init$_1(message, cause, Object.create(RuntimeException.prototype));
    captureStack(tmp, RuntimeException_init_$Create$);
    return tmp;
  }
  function RuntimeException() {
    captureStack(this, RuntimeException);
  }
  RuntimeException.$metadata$ = {
    simpleName: 'RuntimeException',
    kind: 'class',
    interfaces: []
  };
  function NoSuchElementException_init_$Init$($this) {
    RuntimeException_init_$Init$($this);
    NoSuchElementException.call($this);
    return $this;
  }
  function NoSuchElementException_init_$Create$() {
    var tmp = NoSuchElementException_init_$Init$(Object.create(NoSuchElementException.prototype));
    captureStack(tmp, NoSuchElementException_init_$Create$);
    return tmp;
  }
  function NoSuchElementException_init_$Init$_0(message, $this) {
    RuntimeException_init_$Init$_0(message, $this);
    NoSuchElementException.call($this);
    return $this;
  }
  function NoSuchElementException_init_$Create$_0(message) {
    var tmp = NoSuchElementException_init_$Init$_0(message, Object.create(NoSuchElementException.prototype));
    captureStack(tmp, NoSuchElementException_init_$Create$_0);
    return tmp;
  }
  function NoSuchElementException() {
    captureStack(this, NoSuchElementException);
  }
  NoSuchElementException.$metadata$ = {
    simpleName: 'NoSuchElementException',
    kind: 'class',
    interfaces: []
  };
  function IllegalStateException_init_$Init$($this) {
    RuntimeException_init_$Init$($this);
    IllegalStateException.call($this);
    return $this;
  }
  function IllegalStateException_init_$Init$_0(message, $this) {
    RuntimeException_init_$Init$_0(message, $this);
    IllegalStateException.call($this);
    return $this;
  }
  function IllegalStateException_init_$Create$(message) {
    var tmp = IllegalStateException_init_$Init$_0(message, Object.create(IllegalStateException.prototype));
    captureStack(tmp, IllegalStateException_init_$Create$);
    return tmp;
  }
  function IllegalStateException_init_$Init$_1(message, cause, $this) {
    RuntimeException_init_$Init$_1(message, cause, $this);
    IllegalStateException.call($this);
    return $this;
  }
  function IllegalStateException_init_$Create$_0(message, cause) {
    var tmp = IllegalStateException_init_$Init$_1(message, cause, Object.create(IllegalStateException.prototype));
    captureStack(tmp, IllegalStateException_init_$Create$_0);
    return tmp;
  }
  function IllegalStateException() {
    captureStack(this, IllegalStateException);
  }
  IllegalStateException.$metadata$ = {
    simpleName: 'IllegalStateException',
    kind: 'class',
    interfaces: []
  };
  function IndexOutOfBoundsException_init_$Init$($this) {
    RuntimeException_init_$Init$($this);
    IndexOutOfBoundsException.call($this);
    return $this;
  }
  function IndexOutOfBoundsException_init_$Create$() {
    var tmp = IndexOutOfBoundsException_init_$Init$(Object.create(IndexOutOfBoundsException.prototype));
    captureStack(tmp, IndexOutOfBoundsException_init_$Create$);
    return tmp;
  }
  function IndexOutOfBoundsException_init_$Init$_0(message, $this) {
    RuntimeException_init_$Init$_0(message, $this);
    IndexOutOfBoundsException.call($this);
    return $this;
  }
  function IndexOutOfBoundsException_init_$Create$_0(message) {
    var tmp = IndexOutOfBoundsException_init_$Init$_0(message, Object.create(IndexOutOfBoundsException.prototype));
    captureStack(tmp, IndexOutOfBoundsException_init_$Create$_0);
    return tmp;
  }
  function IndexOutOfBoundsException() {
    captureStack(this, IndexOutOfBoundsException);
  }
  IndexOutOfBoundsException.$metadata$ = {
    simpleName: 'IndexOutOfBoundsException',
    kind: 'class',
    interfaces: []
  };
  function UnsupportedOperationException_init_$Init$($this) {
    RuntimeException_init_$Init$($this);
    UnsupportedOperationException.call($this);
    return $this;
  }
  function UnsupportedOperationException_init_$Create$() {
    var tmp = UnsupportedOperationException_init_$Init$(Object.create(UnsupportedOperationException.prototype));
    captureStack(tmp, UnsupportedOperationException_init_$Create$);
    return tmp;
  }
  function UnsupportedOperationException_init_$Init$_0(message, $this) {
    RuntimeException_init_$Init$_0(message, $this);
    UnsupportedOperationException.call($this);
    return $this;
  }
  function UnsupportedOperationException_init_$Create$_0(message) {
    var tmp = UnsupportedOperationException_init_$Init$_0(message, Object.create(UnsupportedOperationException.prototype));
    captureStack(tmp, UnsupportedOperationException_init_$Create$_0);
    return tmp;
  }
  function UnsupportedOperationException() {
    captureStack(this, UnsupportedOperationException);
  }
  UnsupportedOperationException.$metadata$ = {
    simpleName: 'UnsupportedOperationException',
    kind: 'class',
    interfaces: []
  };
  function ArithmeticException_init_$Init$(message, $this) {
    RuntimeException_init_$Init$_0(message, $this);
    ArithmeticException.call($this);
    return $this;
  }
  function ArithmeticException_init_$Create$(message) {
    var tmp = ArithmeticException_init_$Init$(message, Object.create(ArithmeticException.prototype));
    captureStack(tmp, ArithmeticException_init_$Create$);
    return tmp;
  }
  function ArithmeticException() {
    captureStack(this, ArithmeticException);
  }
  ArithmeticException.$metadata$ = {
    simpleName: 'ArithmeticException',
    kind: 'class',
    interfaces: []
  };
  function NumberFormatException_init_$Init$(message, $this) {
    IllegalArgumentException_init_$Init$_0(message, $this);
    NumberFormatException.call($this);
    return $this;
  }
  function NumberFormatException_init_$Create$(message) {
    var tmp = NumberFormatException_init_$Init$(message, Object.create(NumberFormatException.prototype));
    captureStack(tmp, NumberFormatException_init_$Create$);
    return tmp;
  }
  function NumberFormatException() {
    captureStack(this, NumberFormatException);
  }
  NumberFormatException.$metadata$ = {
    simpleName: 'NumberFormatException',
    kind: 'class',
    interfaces: []
  };
  function NullPointerException_init_$Init$($this) {
    RuntimeException_init_$Init$($this);
    NullPointerException.call($this);
    return $this;
  }
  function NullPointerException_init_$Create$() {
    var tmp = NullPointerException_init_$Init$(Object.create(NullPointerException.prototype));
    captureStack(tmp, NullPointerException_init_$Create$);
    return tmp;
  }
  function NullPointerException() {
    captureStack(this, NullPointerException);
  }
  NullPointerException.$metadata$ = {
    simpleName: 'NullPointerException',
    kind: 'class',
    interfaces: []
  };
  function NoWhenBranchMatchedException_init_$Init$($this) {
    RuntimeException_init_$Init$($this);
    NoWhenBranchMatchedException.call($this);
    return $this;
  }
  function NoWhenBranchMatchedException_init_$Create$() {
    var tmp = NoWhenBranchMatchedException_init_$Init$(Object.create(NoWhenBranchMatchedException.prototype));
    captureStack(tmp, NoWhenBranchMatchedException_init_$Create$);
    return tmp;
  }
  function NoWhenBranchMatchedException() {
    captureStack(this, NoWhenBranchMatchedException);
  }
  NoWhenBranchMatchedException.$metadata$ = {
    simpleName: 'NoWhenBranchMatchedException',
    kind: 'class',
    interfaces: []
  };
  function ClassCastException_init_$Init$($this) {
    RuntimeException_init_$Init$($this);
    ClassCastException.call($this);
    return $this;
  }
  function ClassCastException_init_$Create$() {
    var tmp = ClassCastException_init_$Init$(Object.create(ClassCastException.prototype));
    captureStack(tmp, ClassCastException_init_$Create$);
    return tmp;
  }
  function ClassCastException() {
    captureStack(this, ClassCastException);
  }
  ClassCastException.$metadata$ = {
    simpleName: 'ClassCastException',
    kind: 'class',
    interfaces: []
  };
  function UninitializedPropertyAccessException_init_$Init$(message, $this) {
    RuntimeException_init_$Init$_0(message, $this);
    UninitializedPropertyAccessException.call($this);
    return $this;
  }
  function UninitializedPropertyAccessException_init_$Create$(message) {
    var tmp = UninitializedPropertyAccessException_init_$Init$(message, Object.create(UninitializedPropertyAccessException.prototype));
    captureStack(tmp, UninitializedPropertyAccessException_init_$Create$);
    return tmp;
  }
  function UninitializedPropertyAccessException() {
    captureStack(this, UninitializedPropertyAccessException);
  }
  UninitializedPropertyAccessException.$metadata$ = {
    simpleName: 'UninitializedPropertyAccessException',
    kind: 'class',
    interfaces: []
  };
  function jsIn(lhs_hack, rhs_hack) {
    var tmp0_unsafeCast_0 = lhs_hack in rhs_hack;
    return tmp0_unsafeCast_0;
  }
  function jsBitwiseOr(lhs_hack, rhs_hack) {
    var tmp0_unsafeCast_0 = lhs_hack | rhs_hack;
    return tmp0_unsafeCast_0;
  }
  function jsTypeOf(value_hack) {
    var tmp0_unsafeCast_0 = typeof value_hack;
    return tmp0_unsafeCast_0;
  }
  function jsDeleteProperty(obj_hack, property_hack) {
    delete obj_hack[property_hack];
  }
  function jsInstanceOf(obj_hack, jsClass_hack) {
    var tmp0_unsafeCast_0 = obj_hack instanceof jsClass_hack;
    return tmp0_unsafeCast_0;
  }
  function jsBitwiseAnd(lhs_hack, rhs_hack) {
    var tmp0_unsafeCast_0 = lhs_hack & rhs_hack;
    return tmp0_unsafeCast_0;
  }
  function findAssociatedObject(_this_, annotationClass) {
    var tmp;
    var tmp_0;
    if (_this_ instanceof KClassImpl) {
      tmp_0 = annotationClass instanceof KClassImpl;
    } else {
      {
        tmp_0 = false;
      }
    }
    if (tmp_0) {
      var tmp0_asDynamic_0 = annotationClass._get_jClass__2();
      var tmp0_safe_receiver = tmp0_asDynamic_0.$metadata$;
      var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.associatedObjectKey;
      var tmp_1;
      if (tmp1_safe_receiver == null) {
        tmp_1 = null;
      } else {
        tmp_1 = tmp1_safe_receiver;
      }
      var tmp2_elvis_lhs = tmp_1;
      var tmp_2;
      if (tmp2_elvis_lhs == null) {
        return null;
      } else {
        tmp_2 = tmp2_elvis_lhs;
      }
      var key = tmp_2;
      var tmp1_asDynamic_0 = _this_._get_jClass__2();
      var tmp3_safe_receiver = tmp1_asDynamic_0.$metadata$;
      var tmp4_elvis_lhs = tmp3_safe_receiver == null ? null : tmp3_safe_receiver.associatedObjects;
      var tmp_3;
      if (tmp4_elvis_lhs == null) {
        return null;
      } else {
        tmp_3 = tmp4_elvis_lhs;
      }
      var map_0 = tmp_3;
      var tmp5_elvis_lhs = map_0[key];
      var tmp_4;
      if (tmp5_elvis_lhs == null) {
        return null;
      } else {
        tmp_4 = tmp5_elvis_lhs;
      }
      var factory = tmp_4;
      return factory();
    } else {
      {
        tmp = null;
      }
    }
    return tmp;
  }
  function toString_2(_this_, radix) {
    return toStringImpl(_this_, checkRadix(radix));
  }
  function KSerializer() {
  }
  KSerializer.$metadata$ = {
    simpleName: 'KSerializer',
    kind: 'interface',
    interfaces: [SerializationStrategy, DeserializationStrategy]
  };
  function DeserializationStrategy() {
  }
  DeserializationStrategy.$metadata$ = {
    simpleName: 'DeserializationStrategy',
    kind: 'interface',
    interfaces: []
  };
  function SerializationStrategy() {
  }
  SerializationStrategy.$metadata$ = {
    simpleName: 'SerializationStrategy',
    kind: 'interface',
    interfaces: []
  };
  function findPolymorphicSerializer(_this_, encoder, value) {
    var tmp0_elvis_lhs = _this_.findPolymorphicSerializerOrNull_0(encoder, value);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      throwSubtypeNotRegistered(getKClassFromExpression_0(value), _this_._get_baseClass_());
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  }
  function SealedClassSerializer() {
  }
  SealedClassSerializer.$metadata$ = {
    simpleName: 'SealedClassSerializer',
    kind: 'class',
    interfaces: []
  };
  function StringFormat() {
  }
  StringFormat.$metadata$ = {
    simpleName: 'StringFormat',
    kind: 'interface',
    interfaces: [SerialFormat]
  };
  function SerialFormat() {
  }
  SerialFormat.$metadata$ = {
    simpleName: 'SerialFormat',
    kind: 'interface',
    interfaces: []
  };
  function SerializationException_init_$Init$(message, $this) {
    IllegalArgumentException_init_$Init$_0(message, $this);
    SerializationException.call($this);
    return $this;
  }
  function SerializationException_init_$Create$(message) {
    var tmp = SerializationException_init_$Init$(message, Object.create(SerializationException.prototype));
    captureStack(tmp, SerializationException_init_$Create$);
    return tmp;
  }
  function SerializationException_init_$Init$_0(message, cause, $this) {
    IllegalArgumentException_init_$Init$_1(message, cause, $this);
    SerializationException.call($this);
    return $this;
  }
  function SerializationException() {
    captureStack(this, SerializationException);
  }
  SerializationException.$metadata$ = {
    simpleName: 'SerializationException',
    kind: 'class',
    interfaces: []
  };
  function UnknownFieldException_init_$Init$(index, $this) {
    UnknownFieldException.call($this, '' + 'An unknown field for index ' + index);
    return $this;
  }
  function UnknownFieldException_init_$Create$(index) {
    var tmp = UnknownFieldException_init_$Init$(index, Object.create(UnknownFieldException.prototype));
    captureStack(tmp, UnknownFieldException_init_$Create$);
    return tmp;
  }
  function UnknownFieldException(message) {
    SerializationException_init_$Init$(message, this);
    captureStack(this, UnknownFieldException);
  }
  UnknownFieldException.$metadata$ = {
    simpleName: 'UnknownFieldException',
    kind: 'class',
    interfaces: []
  };
  function MissingFieldException_init_$Init$(fieldName, $this) {
    MissingFieldException.call($this, '' + "Field '" + fieldName + "' is required, but it was missing", null);
    return $this;
  }
  function MissingFieldException_init_$Create$(fieldName) {
    var tmp = MissingFieldException_init_$Init$(fieldName, Object.create(MissingFieldException.prototype));
    captureStack(tmp, MissingFieldException_init_$Create$);
    return tmp;
  }
  function MissingFieldException(message, cause) {
    SerializationException_init_$Init$_0(message, cause, this);
    captureStack(this, MissingFieldException);
  }
  MissingFieldException.$metadata$ = {
    simpleName: 'MissingFieldException',
    kind: 'class',
    interfaces: []
  };
  function serializer(type) {
    return serializer_1(EmptySerializersModule, type);
  }
  function serializer_0(_this_) {
    var tmp0_elvis_lhs = serializerOrNull(_this_);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      serializerNotRegistered(_this_);
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  }
  function serializer_1(_this_, type) {
    var tmp0_elvis_lhs = serializerByKTypeImpl(_this_, type, true);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      platformSpecificSerializerNotRegistered(kclass(type));
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  }
  function serializerOrNull(_this_) {
    var tmp0_elvis_lhs = compiledSerializerImpl(_this_);
    return tmp0_elvis_lhs == null ? builtinSerializerOrNull(_this_) : tmp0_elvis_lhs;
  }
  function serializerByKTypeImpl(_this_, type, failOnMissingTypeArgSerializer) {
    var rootClass = kclass(type);
    var isNullable = type._get_isMarkedNullable__0();
    var tmp0_map_0 = type._get_arguments__0();
    var tmp0_mapTo_0_1 = ArrayList_init_$Create$_0(collectionSizeOrDefault(tmp0_map_0, 10));
    var tmp0_iterator_1_2 = tmp0_map_0.iterator_64();
    while (tmp0_iterator_1_2.hasNext_31()) {
      var item_2_3 = tmp0_iterator_1_2.next_35();
      var tmp$ret$0;
      l$ret$1: do {
        var tmp0_requireNotNull_0_5 = item_2_3._type;
        if (tmp0_requireNotNull_0_5 == null) {
          var message_1_6 = '' + 'Star projections in type arguments are not allowed, but had ' + type;
          throw IllegalArgumentException_init_$Create$_0(toString_1(message_1_6));
        } else {
          tmp$ret$0 = tmp0_requireNotNull_0_5;
          break l$ret$1;
        }
      }
       while (false);
      tmp0_mapTo_0_1.add_33(tmp$ret$0);
      Unit_getInstance();
    }
    var typeArguments = tmp0_mapTo_0_1;
    var tmp;
    if (typeArguments.isEmpty_53()) {
      var tmp0_elvis_lhs = serializerOrNull(rootClass);
      tmp = tmp0_elvis_lhs == null ? _this_.getContextual_0(rootClass) : tmp0_elvis_lhs;
    } else {
      tmp = builtinSerializer(_this_, typeArguments, rootClass, failOnMissingTypeArgSerializer);
    }
    var tmp1_safe_receiver = tmp;
    var tmp_0;
    if (tmp1_safe_receiver == null) {
      tmp_0 = null;
    } else {
      tmp_0 = (!(tmp1_safe_receiver == null) ? isInterface(tmp1_safe_receiver, KSerializer) : false) ? tmp1_safe_receiver : THROW_CCE();
    }
    var result = tmp_0;
    var tmp2_safe_receiver = result;
    return tmp2_safe_receiver == null ? null : nullable(tmp2_safe_receiver, isNullable);
  }
  function builtinSerializer(_this_, typeArguments, rootClass, failOnMissingTypeArgSerializer) {
    var tmp;
    if (failOnMissingTypeArgSerializer) {
      var tmp0_mapTo_0_1 = ArrayList_init_$Create$_0(collectionSizeOrDefault(typeArguments, 10));
      var tmp0_iterator_1_2 = typeArguments.iterator_64();
      while (tmp0_iterator_1_2.hasNext_31()) {
        var item_2_3 = tmp0_iterator_1_2.next_35();
        tmp0_mapTo_0_1.add_33(serializer_1(_this_, item_2_3));
        Unit_getInstance();
      }
      tmp = tmp0_mapTo_0_1;
    } else {
      var tmp0_mapTo_0_1_0 = ArrayList_init_$Create$_0(collectionSizeOrDefault(typeArguments, 10));
      var tmp0_iterator_1_2_0 = typeArguments.iterator_64();
      while (tmp0_iterator_1_2_0.hasNext_31()) {
        var item_2_3_0 = tmp0_iterator_1_2_0.next_35();
        var tmp0_elvis_lhs_5 = serializerOrNull_0(_this_, item_2_3_0);
        var tmp_0;
        if (tmp0_elvis_lhs_5 == null) {
          return null;
        } else {
          tmp_0 = tmp0_elvis_lhs_5;
        }
        tmp0_mapTo_0_1_0.add_33(tmp_0);
        Unit_getInstance();
      }
      tmp = tmp0_mapTo_0_1_0;
    }
    var serializers = tmp;
    var tmp0_subject = rootClass;
    var tmp_1;
    if (((tmp0_subject.equals(getKClass_0(Collection)) ? true : tmp0_subject.equals(getKClass_0(List))) ? true : tmp0_subject.equals(getKClass_0(MutableList))) ? true : tmp0_subject.equals(getKClass_0(ArrayList))) {
      tmp_1 = new ArrayListSerializer(serializers.get_80(0));
    } else if (tmp0_subject.equals(getKClass_0(HashSet))) {
      tmp_1 = new HashSetSerializer(serializers.get_80(0));
    } else if ((tmp0_subject.equals(getKClass_0(Set)) ? true : tmp0_subject.equals(getKClass_0(MutableSet))) ? true : tmp0_subject.equals(getKClass_0(LinkedHashSet))) {
      tmp_1 = new LinkedHashSetSerializer(serializers.get_80(0));
    } else if (tmp0_subject.equals(getKClass_0(HashMap))) {
      tmp_1 = new HashMapSerializer(serializers.get_80(0), serializers.get_80(1));
    } else if ((tmp0_subject.equals(getKClass_0(Map_0)) ? true : tmp0_subject.equals(getKClass_0(MutableMap))) ? true : tmp0_subject.equals(getKClass_0(LinkedHashMap))) {
      tmp_1 = new LinkedHashMapSerializer(serializers.get_80(0), serializers.get_80(1));
    } else if (tmp0_subject.equals(getKClass_0(Entry))) {
      tmp_1 = MapEntrySerializer(serializers.get_80(0), serializers.get_80(1));
    } else if (tmp0_subject.equals(getKClass_0(Pair))) {
      tmp_1 = PairSerializer(serializers.get_80(0), serializers.get_80(1));
    } else if (tmp0_subject.equals(getKClass_0(Triple))) {
      tmp_1 = TripleSerializer(serializers.get_80(0), serializers.get_80(1), serializers.get_80(2));
    } else {
      if (isReferenceArray(rootClass)) {
        var tmp_2 = typeArguments.get_80(0)._get_classifier__0();
        var tmp0_cast_0 = ArraySerializer((!(tmp_2 == null) ? isInterface(tmp_2, KClass) : false) ? tmp_2 : THROW_CCE(), serializers.get_80(0));
        return isInterface(tmp0_cast_0, KSerializer) ? tmp0_cast_0 : THROW_CCE();
      }tmp_1 = constructSerializerForGivenTypeArgs(rootClass, copyToArray_0(serializers).slice());
    }
    return tmp_1;
  }
  function nullable(_this_, shouldBeNullable) {
    if (shouldBeNullable)
      return _get_nullable_(_this_);
    return isInterface(_this_, KSerializer) ? _this_ : THROW_CCE();
  }
  function serializerOrNull_0(_this_, type) {
    return serializerByKTypeImpl(_this_, type, false);
  }
  function serializer_2(_this_) {
    return StringSerializer_getInstance();
  }
  function serializer_3(_this_) {
    return CharSerializer_getInstance();
  }
  function CharArraySerializer() {
    return CharArraySerializer_getInstance();
  }
  function serializer_4(_this_) {
    return DoubleSerializer_getInstance();
  }
  function DoubleArraySerializer() {
    return DoubleArraySerializer_getInstance();
  }
  function serializer_5(_this_) {
    return FloatSerializer_getInstance();
  }
  function FloatArraySerializer() {
    return FloatArraySerializer_getInstance();
  }
  function serializer_6(_this_) {
    return LongSerializer_getInstance();
  }
  function LongArraySerializer() {
    return LongArraySerializer_getInstance();
  }
  function serializer_7(_this_) {
    return IntSerializer_getInstance();
  }
  function IntArraySerializer() {
    return IntArraySerializer_getInstance();
  }
  function serializer_8(_this_) {
    return ShortSerializer_getInstance();
  }
  function ShortArraySerializer() {
    return ShortArraySerializer_getInstance();
  }
  function serializer_9(_this_) {
    return ByteSerializer_getInstance();
  }
  function ByteArraySerializer() {
    return ByteArraySerializer_getInstance();
  }
  function serializer_10(_this_) {
    return BooleanSerializer_getInstance();
  }
  function BooleanArraySerializer() {
    return BooleanArraySerializer_getInstance();
  }
  function serializer_11(_this_) {
    return UnitSerializer_getInstance();
  }
  function serializer_12(_this_) {
    return UIntSerializer_getInstance();
  }
  function serializer_13(_this_) {
    return ULongSerializer_getInstance();
  }
  function serializer_14(_this_) {
    return UByteSerializer_getInstance();
  }
  function serializer_15(_this_) {
    return UShortSerializer_getInstance();
  }
  function ListSerializer(elementSerializer_0) {
    return new ArrayListSerializer(elementSerializer_0);
  }
  function SetSerializer(elementSerializer_0) {
    return new LinkedHashSetSerializer(elementSerializer_0);
  }
  function MapSerializer(keySerializer, valueSerializer) {
    return new LinkedHashMapSerializer(keySerializer, valueSerializer);
  }
  function _get_nullable_(_this_) {
    var tmp;
    if (_this_._get_descriptor__48()._get_isNullable__16()) {
      tmp = isInterface(_this_, KSerializer) ? _this_ : THROW_CCE();
    } else {
      tmp = new NullableSerializer(_this_);
    }
    return tmp;
  }
  function MapEntrySerializer(keySerializer, valueSerializer) {
    return new MapEntrySerializer_0(keySerializer, valueSerializer);
  }
  function PairSerializer(keySerializer, valueSerializer) {
    return new PairSerializer_0(keySerializer, valueSerializer);
  }
  function TripleSerializer(aSerializer, bSerializer, cSerializer) {
    return new TripleSerializer_0(aSerializer, bSerializer, cSerializer);
  }
  function ArraySerializer(kClass, elementSerializer_0) {
    return new ReferenceArraySerializer(kClass, elementSerializer_0);
  }
  function SerialDescriptor() {
  }
  SerialDescriptor.prototype._get_isNullable__16 = function () {
    return false;
  };
  SerialDescriptor.prototype._get_isInline__16 = function () {
    return false;
  };
  SerialDescriptor.$metadata$ = {
    simpleName: 'SerialDescriptor',
    kind: 'interface',
    interfaces: []
  };
  function _get_elementDescriptors_(_this_) {
    return new _no_name_provided__1_1(_this_);
  }
  function _no_name_provided__55($this_elementDescriptors) {
    this._$this_elementDescriptors = $this_elementDescriptors;
    this._elementsLeft = this._$this_elementDescriptors._get_elementsCount__16();
  }
  _no_name_provided__55.prototype.hasNext_31 = function () {
    return this._elementsLeft > 0;
  };
  _no_name_provided__55.prototype.next_35 = function () {
    var tmp = this._$this_elementDescriptors._get_elementsCount__16();
    var tmp0_this = this;
    var tmp1 = tmp0_this._elementsLeft;
    tmp0_this._elementsLeft = tmp1 - 1 | 0;
    return this._$this_elementDescriptors.getElementDescriptor_16(tmp - tmp1 | 0);
  };
  _no_name_provided__55.$metadata$ = {
    kind: 'class',
    interfaces: [Iterator]
  };
  function _no_name_provided__1_1($this_elementDescriptors) {
    this._$this_elementDescriptors_0 = $this_elementDescriptors;
  }
  _no_name_provided__1_1.prototype.iterator_2_0 = function () {
    return new _no_name_provided__55(this._$this_elementDescriptors_0);
  };
  _no_name_provided__1_1.prototype.iterator_64 = function () {
    return this.iterator_2_0();
  };
  _no_name_provided__1_1.$metadata$ = {
    simpleName: '<no name provided>_1',
    kind: 'class',
    interfaces: [Iterable]
  };
  function buildSerialDescriptor(serialName, kind, typeParameters, builder) {
    var tmp0_require_0 = !isBlank(serialName);
    if (!tmp0_require_0) {
      var message_1 = 'Blank serial names are prohibited';
      throw IllegalArgumentException_init_$Create$_0(toString_1(message_1));
    }var tmp1_require_0 = !equals_1(kind, CLASS_getInstance());
    if (!tmp1_require_0) {
      var message_1_0 = "For StructureKind.CLASS please use 'buildClassSerialDescriptor' instead";
      throw IllegalArgumentException_init_$Create$_0(toString_1(message_1_0));
    }var sdBuilder = new ClassSerialDescriptorBuilder(serialName);
    builder(sdBuilder);
    return new SerialDescriptorImpl(serialName, kind, sdBuilder._elementNames._get_size__45(), toList(typeParameters), sdBuilder);
  }
  function buildSerialDescriptor$default(serialName, kind, typeParameters, builder, $mask0, $handler) {
    if (!(($mask0 & 8) === 0)) {
      builder = _no_name_provided_$factory_37();
    }return buildSerialDescriptor(serialName, kind, typeParameters, builder);
  }
  function ClassSerialDescriptorBuilder(serialName) {
    this._serialName = serialName;
    this._isNullable = false;
    this._annotations = emptyList();
    this._elementNames = ArrayList_init_$Create$();
    this._uniqueNames = HashSet_init_$Create$();
    this._elementDescriptors = ArrayList_init_$Create$();
    this._elementAnnotations = ArrayList_init_$Create$();
    this._elementOptionality = ArrayList_init_$Create$();
  }
  ClassSerialDescriptorBuilder.prototype.element = function (elementName, descriptor, annotations, isOptional) {
    var tmp0_require_0 = this._uniqueNames.add_33(elementName);
    if (!tmp0_require_0) {
      var message_1 = '' + "Element with name '" + elementName + "' is already registered";
      throw IllegalArgumentException_init_$Create$_0(toString_1(message_1));
    }var tmp0_this = this;
    var tmp1_plusAssign_0 = tmp0_this._elementNames;
    tmp1_plusAssign_0.add_33(elementName);
    Unit_getInstance();
    var tmp1_this = this;
    var tmp2_plusAssign_0 = tmp1_this._elementDescriptors;
    tmp2_plusAssign_0.add_33(descriptor);
    Unit_getInstance();
    var tmp2_this = this;
    var tmp3_plusAssign_0 = tmp2_this._elementAnnotations;
    tmp3_plusAssign_0.add_33(annotations);
    Unit_getInstance();
    var tmp3_this = this;
    var tmp4_plusAssign_0 = tmp3_this._elementOptionality;
    tmp4_plusAssign_0.add_33(isOptional);
    Unit_getInstance();
  };
  ClassSerialDescriptorBuilder.prototype.element$default = function (elementName, descriptor, annotations, isOptional, $mask0, $handler) {
    if (!(($mask0 & 4) === 0))
      annotations = emptyList();
    if (!(($mask0 & 8) === 0))
      isOptional = false;
    return this.element(elementName, descriptor, annotations, isOptional);
  };
  ClassSerialDescriptorBuilder.$metadata$ = {
    simpleName: 'ClassSerialDescriptorBuilder',
    kind: 'class',
    interfaces: []
  };
  function _get__hashCode_($this) {
    var tmp0_getValue_0 = $this.__hashCode$delegate;
    var tmp1_getValue_0 = _hashCode$factory();
    return tmp0_getValue_0._get_value__33();
  }
  function _no_name_provided__56(this$0) {
    this._this$0_13 = this$0;
  }
  _no_name_provided__56.prototype.invoke_540 = function () {
    return hashCodeImpl(this._this$0_13, this._this$0_13._typeParametersDescriptors);
  };
  _no_name_provided__56.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__57(this$0) {
    this._this$0_14 = this$0;
  }
  _no_name_provided__57.prototype.invoke_75 = function (it) {
    return this._this$0_14.getElementName_16(it) + ': ' + this._this$0_14.getElementDescriptor_16(it)._get_serialName__16();
  };
  _no_name_provided__57.prototype.invoke_542 = function (p1) {
    return this.invoke_75((!(p1 == null) ? typeof p1 === 'number' : false) ? p1 : THROW_CCE());
  };
  _no_name_provided__57.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function SerialDescriptorImpl(serialName, kind, elementsCount, typeParameters, builder) {
    this._serialName_0 = serialName;
    this._kind = kind;
    this._elementsCount = elementsCount;
    this._annotations_0 = builder._annotations;
    this._serialNames = toHashSet(builder._elementNames);
    var tmp = this;
    var tmp0_toTypedArray_0 = builder._elementNames;
    tmp._elementNames_0 = copyToArray_0(tmp0_toTypedArray_0);
    this._elementDescriptors_0 = compactArray(builder._elementDescriptors);
    var tmp_0 = this;
    var tmp0_toTypedArray_0_0 = builder._elementAnnotations;
    tmp_0._elementAnnotations_0 = copyToArray_0(tmp0_toTypedArray_0_0);
    this._elementOptionality_0 = toBooleanArray(builder._elementOptionality);
    var tmp_1 = this;
    var tmp0_map_0 = withIndex(this._elementNames_0);
    var tmp0_mapTo_0_1 = ArrayList_init_$Create$_0(collectionSizeOrDefault(tmp0_map_0, 10));
    var tmp0_iterator_1_2 = tmp0_map_0.iterator_64();
    while (tmp0_iterator_1_2.hasNext_31()) {
      var item_2_3 = tmp0_iterator_1_2.next_35();
      tmp0_mapTo_0_1.add_33(to(item_2_3._value, item_2_3._index));
      Unit_getInstance();
    }
    tmp_1._name2Index = toMap(tmp0_mapTo_0_1);
    this._typeParametersDescriptors = compactArray(typeParameters);
    var tmp_2 = this;
    tmp_2.__hashCode$delegate = lazy(_no_name_provided_$factory_38(this));
  }
  SerialDescriptorImpl.prototype._get_serialName__16 = function () {
    return this._serialName_0;
  };
  SerialDescriptorImpl.prototype._get_kind__16 = function () {
    return this._kind;
  };
  SerialDescriptorImpl.prototype._get_elementsCount__16 = function () {
    return this._elementsCount;
  };
  SerialDescriptorImpl.prototype._get_serialNames__3 = function () {
    return this._serialNames;
  };
  SerialDescriptorImpl.prototype.getElementName_16 = function (index) {
    return getChecked(this._elementNames_0, index);
  };
  SerialDescriptorImpl.prototype.getElementIndex_16 = function (name) {
    var tmp0_elvis_lhs = this._name2Index.get_63(name);
    return tmp0_elvis_lhs == null ? -3 : tmp0_elvis_lhs;
  };
  SerialDescriptorImpl.prototype.getElementDescriptor_16 = function (index) {
    return getChecked(this._elementDescriptors_0, index);
  };
  SerialDescriptorImpl.prototype.equals = function (other) {
    var tmp$ret$0;
    l$ret$1: do {
      if (this === other) {
        tmp$ret$0 = true;
        break l$ret$1;
      }if (!(other instanceof SerialDescriptorImpl)) {
        tmp$ret$0 = false;
        break l$ret$1;
      } else {
      }
      if (!(this._get_serialName__16() === other._get_serialName__16())) {
        tmp$ret$0 = false;
        break l$ret$1;
      }var tmp0__anonymous__3 = other;
      if (!contentEquals(this._typeParametersDescriptors, tmp0__anonymous__3._typeParametersDescriptors)) {
        tmp$ret$0 = false;
        break l$ret$1;
      } else {
      }
      if (!(this._get_elementsCount__16() === other._get_elementsCount__16())) {
        tmp$ret$0 = false;
        break l$ret$1;
      }var inductionVariable = 0;
      var last_1 = this._get_elementsCount__16();
      if (inductionVariable < last_1)
        do {
          var index_2 = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          if (!(this.getElementDescriptor_16(index_2)._get_serialName__16() === other.getElementDescriptor_16(index_2)._get_serialName__16())) {
            tmp$ret$0 = false;
            break l$ret$1;
          }if (!equals_1(this.getElementDescriptor_16(index_2)._get_kind__16(), other.getElementDescriptor_16(index_2)._get_kind__16())) {
            tmp$ret$0 = false;
            break l$ret$1;
          }}
         while (inductionVariable < last_1);
      tmp$ret$0 = true;
    }
     while (false);
    return tmp$ret$0;
  };
  SerialDescriptorImpl.prototype.hashCode = function () {
    return _get__hashCode_(this);
  };
  SerialDescriptorImpl.prototype.toString = function () {
    var tmp = until(0, this._elementsCount);
    var tmp_0 = '' + this._serialName_0 + '(';
    return joinToString$default_0(tmp, ', ', tmp_0, ')', 0, null, _no_name_provided_$factory_39(this), 24, null);
  };
  SerialDescriptorImpl.$metadata$ = {
    simpleName: 'SerialDescriptorImpl',
    kind: 'class',
    interfaces: [SerialDescriptor, CachedNames]
  };
  function buildClassSerialDescriptor(serialName, typeParameters, builderAction) {
    var tmp0_require_0 = !isBlank(serialName);
    if (!tmp0_require_0) {
      var message_1 = 'Blank serial names are prohibited';
      throw IllegalArgumentException_init_$Create$_0(toString_1(message_1));
    }var sdBuilder = new ClassSerialDescriptorBuilder(serialName);
    builderAction(sdBuilder);
    return new SerialDescriptorImpl(serialName, CLASS_getInstance(), sdBuilder._elementNames._get_size__45(), toList(typeParameters), sdBuilder);
  }
  function buildClassSerialDescriptor$default(serialName, typeParameters, builderAction, $mask0, $handler) {
    if (!(($mask0 & 4) === 0)) {
      builderAction = _no_name_provided_$factory_40();
    }return buildClassSerialDescriptor(serialName, typeParameters, builderAction);
  }
  function PrimitiveSerialDescriptor(serialName, kind) {
    var tmp0_require_0 = !isBlank(serialName);
    if (!tmp0_require_0) {
      var message_1 = 'Blank serial names are prohibited';
      throw IllegalArgumentException_init_$Create$_0(toString_1(message_1));
    }return PrimitiveDescriptorSafe(serialName, kind);
  }
  function _no_name_provided__58() {
  }
  _no_name_provided__58.prototype.invoke_101 = function ($this$null) {
    return Unit_getInstance();
  };
  _no_name_provided__58.prototype.invoke_542 = function (p1) {
    this.invoke_101(p1 instanceof ClassSerialDescriptorBuilder ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__58.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__59() {
  }
  _no_name_provided__59.prototype.invoke_101 = function ($this$null) {
    return Unit_getInstance();
  };
  _no_name_provided__59.prototype.invoke_542 = function (p1) {
    this.invoke_101(p1 instanceof ClassSerialDescriptorBuilder ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__59.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _hashCode$factory() {
    return getPropertyCallableRef('_hashCode', 1, KProperty1, function (receiver) {
      return _get__hashCode_(receiver);
    }, null);
  }
  function _no_name_provided_$factory_37() {
    var i = new _no_name_provided__58();
    return function (p1) {
      i.invoke_101(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_38(this$0) {
    var i = new _no_name_provided__56(this$0);
    return function () {
      return i.invoke_540();
    };
  }
  function _no_name_provided_$factory_39(this$0) {
    var i = new _no_name_provided__57(this$0);
    return function (p1) {
      return i.invoke_75(p1);
    };
  }
  function _no_name_provided_$factory_40() {
    var i = new _no_name_provided__59();
    return function (p1) {
      i.invoke_101(p1);
      return Unit_getInstance();
    };
  }
  function ENUM() {
    ENUM_instance = this;
    SerialKind.call(this);
  }
  ENUM.$metadata$ = {
    simpleName: 'ENUM',
    kind: 'object',
    interfaces: []
  };
  var ENUM_instance;
  function ENUM_getInstance() {
    if (ENUM_instance == null)
      new ENUM();
    return ENUM_instance;
  }
  function CONTEXTUAL() {
    CONTEXTUAL_instance = this;
    SerialKind.call(this);
  }
  CONTEXTUAL.$metadata$ = {
    simpleName: 'CONTEXTUAL',
    kind: 'object',
    interfaces: []
  };
  var CONTEXTUAL_instance;
  function CONTEXTUAL_getInstance() {
    if (CONTEXTUAL_instance == null)
      new CONTEXTUAL();
    return CONTEXTUAL_instance;
  }
  function SerialKind() {
  }
  SerialKind.prototype.toString = function () {
    return ensureNotNull(getKClassFromExpression_0(this)._get_simpleName__4());
  };
  SerialKind.prototype.hashCode = function () {
    return getStringHashCode(this.toString());
  };
  SerialKind.$metadata$ = {
    simpleName: 'SerialKind',
    kind: 'class',
    interfaces: []
  };
  function BOOLEAN() {
    BOOLEAN_instance = this;
    PrimitiveKind.call(this);
  }
  BOOLEAN.$metadata$ = {
    simpleName: 'BOOLEAN',
    kind: 'object',
    interfaces: []
  };
  var BOOLEAN_instance;
  function BOOLEAN_getInstance() {
    if (BOOLEAN_instance == null)
      new BOOLEAN();
    return BOOLEAN_instance;
  }
  function BYTE() {
    BYTE_instance = this;
    PrimitiveKind.call(this);
  }
  BYTE.$metadata$ = {
    simpleName: 'BYTE',
    kind: 'object',
    interfaces: []
  };
  var BYTE_instance;
  function BYTE_getInstance() {
    if (BYTE_instance == null)
      new BYTE();
    return BYTE_instance;
  }
  function CHAR() {
    CHAR_instance = this;
    PrimitiveKind.call(this);
  }
  CHAR.$metadata$ = {
    simpleName: 'CHAR',
    kind: 'object',
    interfaces: []
  };
  var CHAR_instance;
  function CHAR_getInstance() {
    if (CHAR_instance == null)
      new CHAR();
    return CHAR_instance;
  }
  function SHORT() {
    SHORT_instance = this;
    PrimitiveKind.call(this);
  }
  SHORT.$metadata$ = {
    simpleName: 'SHORT',
    kind: 'object',
    interfaces: []
  };
  var SHORT_instance;
  function SHORT_getInstance() {
    if (SHORT_instance == null)
      new SHORT();
    return SHORT_instance;
  }
  function INT() {
    INT_instance = this;
    PrimitiveKind.call(this);
  }
  INT.$metadata$ = {
    simpleName: 'INT',
    kind: 'object',
    interfaces: []
  };
  var INT_instance;
  function INT_getInstance() {
    if (INT_instance == null)
      new INT();
    return INT_instance;
  }
  function LONG() {
    LONG_instance = this;
    PrimitiveKind.call(this);
  }
  LONG.$metadata$ = {
    simpleName: 'LONG',
    kind: 'object',
    interfaces: []
  };
  var LONG_instance;
  function LONG_getInstance() {
    if (LONG_instance == null)
      new LONG();
    return LONG_instance;
  }
  function FLOAT() {
    FLOAT_instance = this;
    PrimitiveKind.call(this);
  }
  FLOAT.$metadata$ = {
    simpleName: 'FLOAT',
    kind: 'object',
    interfaces: []
  };
  var FLOAT_instance;
  function FLOAT_getInstance() {
    if (FLOAT_instance == null)
      new FLOAT();
    return FLOAT_instance;
  }
  function DOUBLE() {
    DOUBLE_instance = this;
    PrimitiveKind.call(this);
  }
  DOUBLE.$metadata$ = {
    simpleName: 'DOUBLE',
    kind: 'object',
    interfaces: []
  };
  var DOUBLE_instance;
  function DOUBLE_getInstance() {
    if (DOUBLE_instance == null)
      new DOUBLE();
    return DOUBLE_instance;
  }
  function STRING() {
    STRING_instance = this;
    PrimitiveKind.call(this);
  }
  STRING.$metadata$ = {
    simpleName: 'STRING',
    kind: 'object',
    interfaces: []
  };
  var STRING_instance;
  function STRING_getInstance() {
    if (STRING_instance == null)
      new STRING();
    return STRING_instance;
  }
  function PrimitiveKind() {
    SerialKind.call(this);
  }
  PrimitiveKind.$metadata$ = {
    simpleName: 'PrimitiveKind',
    kind: 'class',
    interfaces: []
  };
  function CLASS() {
    CLASS_instance = this;
    StructureKind.call(this);
  }
  CLASS.$metadata$ = {
    simpleName: 'CLASS',
    kind: 'object',
    interfaces: []
  };
  var CLASS_instance;
  function CLASS_getInstance() {
    if (CLASS_instance == null)
      new CLASS();
    return CLASS_instance;
  }
  function LIST() {
    LIST_instance = this;
    StructureKind.call(this);
  }
  LIST.$metadata$ = {
    simpleName: 'LIST',
    kind: 'object',
    interfaces: []
  };
  var LIST_instance;
  function LIST_getInstance() {
    if (LIST_instance == null)
      new LIST();
    return LIST_instance;
  }
  function MAP() {
    MAP_instance = this;
    StructureKind.call(this);
  }
  MAP.$metadata$ = {
    simpleName: 'MAP',
    kind: 'object',
    interfaces: []
  };
  var MAP_instance;
  function MAP_getInstance() {
    if (MAP_instance == null)
      new MAP();
    return MAP_instance;
  }
  function OBJECT() {
    OBJECT_instance = this;
    StructureKind.call(this);
  }
  OBJECT.$metadata$ = {
    simpleName: 'OBJECT',
    kind: 'object',
    interfaces: []
  };
  var OBJECT_instance;
  function OBJECT_getInstance() {
    if (OBJECT_instance == null)
      new OBJECT();
    return OBJECT_instance;
  }
  function StructureKind() {
    SerialKind.call(this);
  }
  StructureKind.$metadata$ = {
    simpleName: 'StructureKind',
    kind: 'class',
    interfaces: []
  };
  function SEALED() {
    SEALED_instance = this;
    PolymorphicKind.call(this);
  }
  SEALED.$metadata$ = {
    simpleName: 'SEALED',
    kind: 'object',
    interfaces: []
  };
  var SEALED_instance;
  function SEALED_getInstance() {
    if (SEALED_instance == null)
      new SEALED();
    return SEALED_instance;
  }
  function PolymorphicKind() {
    SerialKind.call(this);
  }
  PolymorphicKind.$metadata$ = {
    simpleName: 'PolymorphicKind',
    kind: 'class',
    interfaces: []
  };
  function AbstractDecoder() {
  }
  AbstractDecoder.prototype.decodeValue_1 = function () {
    throw SerializationException_init_$Create$('' + getKClassFromExpression_0(this) + " can't retrieve untyped values");
  };
  AbstractDecoder.prototype.decodeNotNullMark_8 = function () {
    return true;
  };
  AbstractDecoder.prototype.decodeNull_8 = function () {
    return null;
  };
  AbstractDecoder.prototype.decodeBoolean_8 = function () {
    var tmp = this.decodeValue_1();
    return typeof tmp === 'boolean' ? tmp : THROW_CCE();
  };
  AbstractDecoder.prototype.decodeByte_8 = function () {
    var tmp = this.decodeValue_1();
    return typeof tmp === 'number' ? tmp : THROW_CCE();
  };
  AbstractDecoder.prototype.decodeShort_8 = function () {
    var tmp = this.decodeValue_1();
    return typeof tmp === 'number' ? tmp : THROW_CCE();
  };
  AbstractDecoder.prototype.decodeInt_8 = function () {
    var tmp = this.decodeValue_1();
    return typeof tmp === 'number' ? tmp : THROW_CCE();
  };
  AbstractDecoder.prototype.decodeLong_8 = function () {
    var tmp = this.decodeValue_1();
    return tmp instanceof Long ? tmp : THROW_CCE();
  };
  AbstractDecoder.prototype.decodeFloat_8 = function () {
    var tmp = this.decodeValue_1();
    return typeof tmp === 'number' ? tmp : THROW_CCE();
  };
  AbstractDecoder.prototype.decodeDouble_8 = function () {
    var tmp = this.decodeValue_1();
    return typeof tmp === 'number' ? tmp : THROW_CCE();
  };
  AbstractDecoder.prototype.decodeChar_8 = function () {
    var tmp = this.decodeValue_1();
    return tmp instanceof Char ? tmp : THROW_CCE();
  };
  AbstractDecoder.prototype.decodeString_8 = function () {
    var tmp = this.decodeValue_1();
    return typeof tmp === 'string' ? tmp : THROW_CCE();
  };
  AbstractDecoder.prototype.decodeInline_8 = function (inlineDescriptor) {
    return this;
  };
  AbstractDecoder.prototype.decodeSerializableValue_17 = function (deserializer, previousValue) {
    return this.decodeSerializableValue_16(deserializer);
  };
  AbstractDecoder.prototype.beginStructure_11 = function (descriptor) {
    return this;
  };
  AbstractDecoder.prototype.endStructure_11 = function (descriptor) {
  };
  AbstractDecoder.prototype.decodeBooleanElement_8 = function (descriptor, index) {
    return this.decodeBoolean_8();
  };
  AbstractDecoder.prototype.decodeByteElement_8 = function (descriptor, index) {
    return this.decodeByte_8();
  };
  AbstractDecoder.prototype.decodeShortElement_8 = function (descriptor, index) {
    return this.decodeShort_8();
  };
  AbstractDecoder.prototype.decodeIntElement_8 = function (descriptor, index) {
    return this.decodeInt_8();
  };
  AbstractDecoder.prototype.decodeLongElement_8 = function (descriptor, index) {
    return this.decodeLong_8();
  };
  AbstractDecoder.prototype.decodeFloatElement_8 = function (descriptor, index) {
    return this.decodeFloat_8();
  };
  AbstractDecoder.prototype.decodeDoubleElement_8 = function (descriptor, index) {
    return this.decodeDouble_8();
  };
  AbstractDecoder.prototype.decodeCharElement_8 = function (descriptor, index) {
    return this.decodeChar_8();
  };
  AbstractDecoder.prototype.decodeStringElement_8 = function (descriptor, index) {
    return this.decodeString_8();
  };
  AbstractDecoder.prototype.decodeSerializableElement_8 = function (descriptor, index, deserializer, previousValue) {
    return this.decodeSerializableValue_17(deserializer, previousValue);
  };
  AbstractDecoder.$metadata$ = {
    simpleName: 'AbstractDecoder',
    kind: 'class',
    interfaces: [Decoder, CompositeDecoder]
  };
  function AbstractEncoder() {
  }
  AbstractEncoder.prototype.beginStructure_11 = function (descriptor) {
    return this;
  };
  AbstractEncoder.prototype.endStructure_11 = function (descriptor) {
  };
  AbstractEncoder.prototype.encodeElement_0 = function (descriptor, index) {
    return true;
  };
  AbstractEncoder.prototype.encodeValue_0 = function (value) {
    throw SerializationException_init_$Create$('' + 'Non-serializable ' + getKClassFromExpression_0(value) + ' is not supported by ' + getKClassFromExpression_0(this) + ' encoder');
  };
  AbstractEncoder.prototype.encodeNull_1 = function () {
    throw SerializationException_init_$Create$("'null' is not supported by default");
  };
  AbstractEncoder.prototype.encodeBoolean_1 = function (value) {
    return this.encodeValue_0(value);
  };
  AbstractEncoder.prototype.encodeByte_1 = function (value) {
    return this.encodeValue_0(value);
  };
  AbstractEncoder.prototype.encodeShort_1 = function (value) {
    return this.encodeValue_0(value);
  };
  AbstractEncoder.prototype.encodeInt_1 = function (value) {
    return this.encodeValue_0(value);
  };
  AbstractEncoder.prototype.encodeLong_1 = function (value) {
    return this.encodeValue_0(value);
  };
  AbstractEncoder.prototype.encodeFloat_1 = function (value) {
    return this.encodeValue_0(value);
  };
  AbstractEncoder.prototype.encodeDouble_1 = function (value) {
    return this.encodeValue_0(value);
  };
  AbstractEncoder.prototype.encodeChar_1 = function (value) {
    return this.encodeValue_0(value);
  };
  AbstractEncoder.prototype.encodeString_1 = function (value) {
    return this.encodeValue_0(value);
  };
  AbstractEncoder.prototype.encodeInline_1 = function (inlineDescriptor) {
    return this;
  };
  AbstractEncoder.prototype.encodeBooleanElement_1 = function (descriptor, index, value) {
    if (this.encodeElement_0(descriptor, index))
      this.encodeBoolean_1(value);
  };
  AbstractEncoder.prototype.encodeByteElement_1 = function (descriptor, index, value) {
    if (this.encodeElement_0(descriptor, index))
      this.encodeByte_1(value);
  };
  AbstractEncoder.prototype.encodeShortElement_1 = function (descriptor, index, value) {
    if (this.encodeElement_0(descriptor, index))
      this.encodeShort_1(value);
  };
  AbstractEncoder.prototype.encodeIntElement_1 = function (descriptor, index, value) {
    if (this.encodeElement_0(descriptor, index))
      this.encodeInt_1(value);
  };
  AbstractEncoder.prototype.encodeLongElement_1 = function (descriptor, index, value) {
    if (this.encodeElement_0(descriptor, index))
      this.encodeLong_1(value);
  };
  AbstractEncoder.prototype.encodeFloatElement_1 = function (descriptor, index, value) {
    if (this.encodeElement_0(descriptor, index))
      this.encodeFloat_1(value);
  };
  AbstractEncoder.prototype.encodeDoubleElement_1 = function (descriptor, index, value) {
    if (this.encodeElement_0(descriptor, index))
      this.encodeDouble_1(value);
  };
  AbstractEncoder.prototype.encodeCharElement_1 = function (descriptor, index, value) {
    if (this.encodeElement_0(descriptor, index))
      this.encodeChar_1(value);
  };
  AbstractEncoder.prototype.encodeStringElement_1 = function (descriptor, index, value) {
    if (this.encodeElement_0(descriptor, index))
      this.encodeString_1(value);
  };
  AbstractEncoder.prototype.encodeSerializableElement_1 = function (descriptor, index, serializer_16, value) {
    if (this.encodeElement_0(descriptor, index))
      this.encodeSerializableValue_1(serializer_16, value);
  };
  AbstractEncoder.$metadata$ = {
    simpleName: 'AbstractEncoder',
    kind: 'class',
    interfaces: [Encoder, CompositeEncoder]
  };
  function Decoder() {
  }
  Decoder.prototype.decodeSerializableValue_16 = function (deserializer) {
    return deserializer.deserialize_52(this);
  };
  Decoder.$metadata$ = {
    simpleName: 'Decoder',
    kind: 'interface',
    interfaces: []
  };
  function CompositeDecoder() {
  }
  CompositeDecoder.prototype.decodeSequentially_8 = function () {
    return false;
  };
  CompositeDecoder.prototype.decodeCollectionSize_8 = function (descriptor) {
    return -1;
  };
  CompositeDecoder.prototype.decodeSerializableElement$default_8 = function (descriptor, index, deserializer, previousValue, $mask0, $handler) {
    if (!(($mask0 & 8) === 0))
      previousValue = null;
    return $handler == null ? this.decodeSerializableElement_8(descriptor, index, deserializer, previousValue) : $handler(descriptor, index, deserializer, previousValue);
  };
  CompositeDecoder.$metadata$ = {
    simpleName: 'CompositeDecoder',
    kind: 'interface',
    interfaces: []
  };
  function Encoder() {
  }
  Encoder.prototype.encodeNotNullMark_1 = function () {
  };
  Encoder.prototype.beginCollection_1 = function (descriptor, collectionSize) {
    return this.beginStructure_11(descriptor);
  };
  Encoder.prototype.encodeSerializableValue_1 = function (serializer_16, value) {
    serializer_16.serialize_76(this, value);
  };
  Encoder.$metadata$ = {
    simpleName: 'Encoder',
    kind: 'interface',
    interfaces: []
  };
  function CompositeEncoder() {
  }
  CompositeEncoder.$metadata$ = {
    simpleName: 'CompositeEncoder',
    kind: 'interface',
    interfaces: []
  };
  function AbstractPolymorphicSerializer() {
  }
  AbstractPolymorphicSerializer.prototype.findPolymorphicSerializerOrNull = function (decoder, klassName) {
    return decoder._get_serializersModule__14().getPolymorphic_2(this._get_baseClass_(), klassName);
  };
  AbstractPolymorphicSerializer.prototype.findPolymorphicSerializerOrNull_0 = function (encoder, value) {
    return encoder._get_serializersModule__14().getPolymorphic_1(this._get_baseClass_(), value);
  };
  AbstractPolymorphicSerializer.$metadata$ = {
    simpleName: 'AbstractPolymorphicSerializer',
    kind: 'class',
    interfaces: [KSerializer]
  };
  function throwSubtypeNotRegistered(subClass, baseClass) {
    var tmp0_elvis_lhs = subClass._get_simpleName__4();
    throwSubtypeNotRegistered_0(tmp0_elvis_lhs == null ? '' + subClass : tmp0_elvis_lhs, baseClass);
  }
  function throwSubtypeNotRegistered_0(subClassName, baseClass) {
    var scope_0 = '' + "in the scope of '" + baseClass._get_simpleName__4() + "'";
    throw SerializationException_init_$Create$(subClassName == null ? '' + 'Class discriminator was missing and no default polymorphic serializers were registered ' + scope_0 : '' + "Class '" + subClassName + "' is not registered for polymorphic serialization " + scope_0 + '.\n' + "Mark the base class as 'sealed' or register the serializer explicitly.");
  }
  function CachedNames() {
  }
  CachedNames.$metadata$ = {
    simpleName: 'CachedNames',
    kind: 'interface',
    interfaces: []
  };
  function PrimitiveArrayDescriptor(primitive) {
    ListLikeDescriptor.call(this, primitive);
    this._serialName_1 = '' + primitive._get_serialName__16() + 'Array';
  }
  PrimitiveArrayDescriptor.prototype._get_serialName__16 = function () {
    return this._serialName_1;
  };
  PrimitiveArrayDescriptor.$metadata$ = {
    simpleName: 'PrimitiveArrayDescriptor',
    kind: 'class',
    interfaces: []
  };
  function ListLikeDescriptor(elementDescriptor) {
    this._elementDescriptor = elementDescriptor;
    this._elementsCount_0 = 1;
  }
  ListLikeDescriptor.prototype._get_kind__16 = function () {
    return LIST_getInstance();
  };
  ListLikeDescriptor.prototype._get_elementsCount__16 = function () {
    return this._elementsCount_0;
  };
  ListLikeDescriptor.prototype.getElementName_16 = function (index) {
    return index.toString();
  };
  ListLikeDescriptor.prototype.getElementIndex_16 = function (name) {
    var tmp0_elvis_lhs = toIntOrNull(name);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      throw IllegalArgumentException_init_$Create$_0('' + name + ' is not a valid list index');
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  };
  ListLikeDescriptor.prototype.getElementDescriptor_16 = function (index) {
    var tmp0_require_0 = index >= 0;
    if (!tmp0_require_0) {
      var message_1 = '' + 'Illegal index ' + index + ', ' + this._get_serialName__16() + ' expects only non-negative indices';
      throw IllegalArgumentException_init_$Create$_0(toString_1(message_1));
    }return this._elementDescriptor;
  };
  ListLikeDescriptor.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof ListLikeDescriptor))
      return false;
    else {
    }
    if (equals_1(this._elementDescriptor, other._elementDescriptor) ? this._get_serialName__16() === other._get_serialName__16() : false)
      return true;
    return false;
  };
  ListLikeDescriptor.prototype.hashCode = function () {
    return imul(hashCode(this._elementDescriptor), 31) + getStringHashCode(this._get_serialName__16()) | 0;
  };
  ListLikeDescriptor.prototype.toString = function () {
    return '' + this._get_serialName__16() + '(' + this._elementDescriptor + ')';
  };
  ListLikeDescriptor.$metadata$ = {
    simpleName: 'ListLikeDescriptor',
    kind: 'class',
    interfaces: [SerialDescriptor]
  };
  function ArrayListClassDesc(elementDesc) {
    ListLikeDescriptor.call(this, elementDesc);
  }
  ArrayListClassDesc.prototype._get_serialName__16 = function () {
    return 'kotlin.collections.ArrayList';
  };
  ArrayListClassDesc.$metadata$ = {
    simpleName: 'ArrayListClassDesc',
    kind: 'class',
    interfaces: []
  };
  function LinkedHashSetClassDesc(elementDesc) {
    ListLikeDescriptor.call(this, elementDesc);
  }
  LinkedHashSetClassDesc.prototype._get_serialName__16 = function () {
    return 'kotlin.collections.LinkedHashSet';
  };
  LinkedHashSetClassDesc.$metadata$ = {
    simpleName: 'LinkedHashSetClassDesc',
    kind: 'class',
    interfaces: []
  };
  function LinkedHashMapClassDesc(keyDesc, valueDesc) {
    MapLikeDescriptor.call(this, 'kotlin.collections.LinkedHashMap', keyDesc, valueDesc);
  }
  LinkedHashMapClassDesc.$metadata$ = {
    simpleName: 'LinkedHashMapClassDesc',
    kind: 'class',
    interfaces: []
  };
  function HashSetClassDesc(elementDesc) {
    ListLikeDescriptor.call(this, elementDesc);
  }
  HashSetClassDesc.prototype._get_serialName__16 = function () {
    return 'kotlin.collections.HashSet';
  };
  HashSetClassDesc.$metadata$ = {
    simpleName: 'HashSetClassDesc',
    kind: 'class',
    interfaces: []
  };
  function HashMapClassDesc(keyDesc, valueDesc) {
    MapLikeDescriptor.call(this, 'kotlin.collections.HashMap', keyDesc, valueDesc);
  }
  HashMapClassDesc.$metadata$ = {
    simpleName: 'HashMapClassDesc',
    kind: 'class',
    interfaces: []
  };
  function MapLikeDescriptor(serialName, keyDescriptor, valueDescriptor) {
    this._serialName_2 = serialName;
    this._keyDescriptor = keyDescriptor;
    this._valueDescriptor = valueDescriptor;
    this._elementsCount_1 = 2;
  }
  MapLikeDescriptor.prototype._get_serialName__16 = function () {
    return this._serialName_2;
  };
  MapLikeDescriptor.prototype._get_kind__16 = function () {
    return MAP_getInstance();
  };
  MapLikeDescriptor.prototype._get_elementsCount__16 = function () {
    return this._elementsCount_1;
  };
  MapLikeDescriptor.prototype.getElementName_16 = function (index) {
    return index.toString();
  };
  MapLikeDescriptor.prototype.getElementIndex_16 = function (name) {
    var tmp0_elvis_lhs = toIntOrNull(name);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      throw IllegalArgumentException_init_$Create$_0('' + name + ' is not a valid map index');
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  };
  MapLikeDescriptor.prototype.getElementDescriptor_16 = function (index) {
    var tmp0_require_0 = index >= 0;
    if (!tmp0_require_0) {
      var message_1 = '' + 'Illegal index ' + index + ', ' + this._get_serialName__16() + ' expects only non-negative indices';
      throw IllegalArgumentException_init_$Create$_0(toString_1(message_1));
    }var tmp0_subject = index % 2;
    var tmp;
    switch (tmp0_subject) {
      case 0:
        tmp = this._keyDescriptor;
        break;
      case 1:
        tmp = this._valueDescriptor;
        break;
      default:var tmp1_error_0 = 'Unreached';
        throw IllegalStateException_init_$Create$(toString_1(tmp1_error_0));
    }
    return tmp;
  };
  MapLikeDescriptor.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof MapLikeDescriptor))
      return false;
    else {
    }
    if (!(this._get_serialName__16() === other._get_serialName__16()))
      return false;
    if (!equals_1(this._keyDescriptor, other._keyDescriptor))
      return false;
    if (!equals_1(this._valueDescriptor, other._valueDescriptor))
      return false;
    return true;
  };
  MapLikeDescriptor.prototype.hashCode = function () {
    var result = getStringHashCode(this._get_serialName__16());
    result = imul(31, result) + hashCode(this._keyDescriptor) | 0;
    result = imul(31, result) + hashCode(this._valueDescriptor) | 0;
    return result;
  };
  MapLikeDescriptor.prototype.toString = function () {
    return '' + this._get_serialName__16() + '(' + this._keyDescriptor + ', ' + this._valueDescriptor + ')';
  };
  MapLikeDescriptor.$metadata$ = {
    simpleName: 'MapLikeDescriptor',
    kind: 'class',
    interfaces: [SerialDescriptor]
  };
  function ArrayClassDesc(elementDesc) {
    ListLikeDescriptor.call(this, elementDesc);
  }
  ArrayClassDesc.prototype._get_serialName__16 = function () {
    return 'kotlin.Array';
  };
  ArrayClassDesc.$metadata$ = {
    simpleName: 'ArrayClassDesc',
    kind: 'class',
    interfaces: []
  };
  function PrimitiveArraySerializer(primitiveSerializer) {
    ListLikeSerializer.call(this, primitiveSerializer);
    this._descriptor = new PrimitiveArrayDescriptor(primitiveSerializer._get_descriptor__48());
  }
  PrimitiveArraySerializer.prototype._get_descriptor__48 = function () {
    return this._descriptor;
  };
  PrimitiveArraySerializer.prototype.builderSize_14 = function (_this__0) {
    return _this__0._get_position__7();
  };
  PrimitiveArraySerializer.prototype.toResult_14 = function (_this__0) {
    return _this__0.build_16();
  };
  PrimitiveArraySerializer.prototype.checkCapacity_14 = function (_this__0, size_0) {
    return _this__0.ensureCapacity_8(size_0);
  };
  PrimitiveArraySerializer.prototype.collectionIterator = function (_this__0) {
    var tmp0_error_0 = 'This method lead to boxing and must not be used, use writeContents instead';
    throw IllegalStateException_init_$Create$(toString_1(tmp0_error_0));
  };
  PrimitiveArraySerializer.prototype.collectionIterator_14 = function (_this__0) {
    return this.collectionIterator((_this__0 == null ? true : isObject(_this__0)) ? _this__0 : THROW_CCE());
  };
  PrimitiveArraySerializer.prototype.insert_8 = function (_this__0, index, element) {
    var tmp0_error_0 = 'This method lead to boxing and must not be used, use Builder.append instead';
    throw IllegalStateException_init_$Create$(toString_1(tmp0_error_0));
  };
  PrimitiveArraySerializer.prototype.builder_16 = function () {
    return this.toBuilder_30(this.empty_7());
  };
  PrimitiveArraySerializer.prototype.serialize_1 = function (encoder, value) {
    var size_0 = this.collectionSize_29(value);
    var composite = encoder.beginCollection_1(this._descriptor, size_0);
    this.writeContent_15(composite, value, size_0);
    composite.endStructure_11(this._descriptor);
  };
  PrimitiveArraySerializer.prototype.serialize_76 = function (encoder, value) {
    return this.serialize_1(encoder, (value == null ? true : isObject(value)) ? value : THROW_CCE());
  };
  PrimitiveArraySerializer.prototype.serialize_12 = function (encoder, value) {
    return this.serialize_1(encoder, (value == null ? true : isObject(value)) ? value : THROW_CCE());
  };
  PrimitiveArraySerializer.prototype.deserialize_52 = function (decoder) {
    return this.merge_7(decoder, null);
  };
  PrimitiveArraySerializer.$metadata$ = {
    simpleName: 'PrimitiveArraySerializer',
    kind: 'class',
    interfaces: []
  };
  function PrimitiveArrayBuilder() {
  }
  PrimitiveArrayBuilder.prototype.ensureCapacity$default_7 = function (requiredCapacity, $mask0, $handler) {
    if (!(($mask0 & 1) === 0))
      requiredCapacity = this._get_position__7() + 1 | 0;
    return $handler == null ? this.ensureCapacity_8(requiredCapacity) : $handler(requiredCapacity);
  };
  PrimitiveArrayBuilder.$metadata$ = {
    simpleName: 'PrimitiveArrayBuilder',
    kind: 'class',
    interfaces: []
  };
  function ListLikeSerializer(elementSerializer_0) {
    AbstractCollectionSerializer.call(this);
    this._elementSerializer = elementSerializer_0;
  }
  ListLikeSerializer.prototype.serialize_12 = function (encoder, value) {
    var size_0 = this.collectionSize_29(value);
    var composite = encoder.beginCollection_1(this._get_descriptor__48(), size_0);
    var iterator_0 = this.collectionIterator_14(value);
    var inductionVariable = 0;
    if (inductionVariable < size_0)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        composite.encodeSerializableElement_1(this._get_descriptor__48(), index, this._elementSerializer, iterator_0.next_35());
      }
       while (inductionVariable < size_0);
    composite.endStructure_11(this._get_descriptor__48());
  };
  ListLikeSerializer.prototype.serialize_76 = function (encoder, value) {
    return this.serialize_12(encoder, (value == null ? true : isObject(value)) ? value : THROW_CCE());
  };
  ListLikeSerializer.prototype.readAll_7 = function (decoder, builder, startIndex, size_0) {
    var tmp0_require_0 = size_0 >= 0;
    if (!tmp0_require_0) {
      var message_1 = 'Size must be known in advance when using READ_ALL';
      throw IllegalArgumentException_init_$Create$_0(toString_1(message_1));
    }var inductionVariable = 0;
    if (inductionVariable < size_0)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        this.readElement_24(decoder, startIndex + index | 0, builder, false);
      }
       while (inductionVariable < size_0);
  };
  ListLikeSerializer.prototype.readElement_24 = function (decoder, index, builder, checkIndex_0) {
    var tmp = this._get_descriptor__48();
    this.insert_8(builder, index, decoder.decodeSerializableElement$default_8(tmp, index, this._elementSerializer, null, 8, null));
  };
  ListLikeSerializer.$metadata$ = {
    simpleName: 'ListLikeSerializer',
    kind: 'class',
    interfaces: []
  };
  function readSize($this, decoder, builder) {
    var size_0 = decoder.decodeCollectionSize_8($this._get_descriptor__48());
    $this.checkCapacity_14(builder, size_0);
    return size_0;
  }
  function AbstractCollectionSerializer() {
  }
  AbstractCollectionSerializer.prototype.merge_7 = function (decoder, previous) {
    var tmp0_safe_receiver = previous;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : this.toBuilder_30(tmp0_safe_receiver);
    var builder = tmp1_elvis_lhs == null ? this.builder_16() : tmp1_elvis_lhs;
    var startIndex = this.builderSize_14(builder);
    var compositeDecoder = decoder.beginStructure_11(this._get_descriptor__48());
    if (compositeDecoder.decodeSequentially_8()) {
      this.readAll_7(compositeDecoder, builder, startIndex, readSize(this, compositeDecoder, builder));
    } else {
      $l$break: while (true) {
        var index = compositeDecoder.decodeElementIndex_8(this._get_descriptor__48());
        if (index === -1)
          break $l$break;
        var tmp = startIndex + index | 0;
        this.readElement$default_7(compositeDecoder, tmp, builder, false, 8, null);
      }
    }
    compositeDecoder.endStructure_11(this._get_descriptor__48());
    return this.toResult_14(builder);
  };
  AbstractCollectionSerializer.prototype.deserialize_52 = function (decoder) {
    return this.merge_7(decoder, null);
  };
  AbstractCollectionSerializer.prototype.readElement$default_7 = function (decoder, index, builder, checkIndex_0, $mask0, $handler) {
    if (!(($mask0 & 8) === 0))
      checkIndex_0 = true;
    return $handler == null ? this.readElement_24(decoder, index, builder, checkIndex_0) : $handler(decoder, index, builder, checkIndex_0);
  };
  AbstractCollectionSerializer.$metadata$ = {
    simpleName: 'AbstractCollectionSerializer',
    kind: 'class',
    interfaces: [KSerializer]
  };
  function ArrayListSerializer(element) {
    ListLikeSerializer.call(this, element);
    this._descriptor_0 = new ArrayListClassDesc(element._get_descriptor__48());
  }
  ArrayListSerializer.prototype._get_descriptor__48 = function () {
    return this._descriptor_0;
  };
  ArrayListSerializer.prototype.collectionSize_1 = function (_this__0) {
    return _this__0._get_size__45();
  };
  ArrayListSerializer.prototype.collectionSize_29 = function (_this__0) {
    return this.collectionSize_1((!(_this__0 == null) ? isInterface(_this__0, List) : false) ? _this__0 : THROW_CCE());
  };
  ArrayListSerializer.prototype.collectionIterator_2 = function (_this__0) {
    return _this__0.iterator_64();
  };
  ArrayListSerializer.prototype.collectionIterator_14 = function (_this__0) {
    return this.collectionIterator_2((!(_this__0 == null) ? isInterface(_this__0, List) : false) ? _this__0 : THROW_CCE());
  };
  ArrayListSerializer.prototype.builder_16 = function () {
    return ArrayList_init_$Create$();
  };
  ArrayListSerializer.prototype.builderSize_2 = function (_this__0) {
    return _this__0._get_size__45();
  };
  ArrayListSerializer.prototype.builderSize_14 = function (_this__0) {
    return this.builderSize_2(_this__0 instanceof ArrayList ? _this__0 : THROW_CCE());
  };
  ArrayListSerializer.prototype.toResult_2 = function (_this__0) {
    return _this__0;
  };
  ArrayListSerializer.prototype.toResult_14 = function (_this__0) {
    return this.toResult_2(_this__0 instanceof ArrayList ? _this__0 : THROW_CCE());
  };
  ArrayListSerializer.prototype.toBuilder_2 = function (_this__0) {
    var tmp0_elvis_lhs = _this__0 instanceof ArrayList ? _this__0 : null;
    return tmp0_elvis_lhs == null ? ArrayList_init_$Create$_1(_this__0) : tmp0_elvis_lhs;
  };
  ArrayListSerializer.prototype.toBuilder_30 = function (_this__0) {
    return this.toBuilder_2((!(_this__0 == null) ? isInterface(_this__0, List) : false) ? _this__0 : THROW_CCE());
  };
  ArrayListSerializer.prototype.checkCapacity_2 = function (_this__0, size_0) {
    return _this__0.ensureCapacity_8(size_0);
  };
  ArrayListSerializer.prototype.checkCapacity_14 = function (_this__0, size_0) {
    return this.checkCapacity_2(_this__0 instanceof ArrayList ? _this__0 : THROW_CCE(), size_0);
  };
  ArrayListSerializer.prototype.insert_1 = function (_this__0, index, element) {
    _this__0.add_27(index, element);
  };
  ArrayListSerializer.prototype.insert_8 = function (_this__0, index, element) {
    var tmp = _this__0 instanceof ArrayList ? _this__0 : THROW_CCE();
    return this.insert_1(tmp, index, (element == null ? true : isObject(element)) ? element : THROW_CCE());
  };
  ArrayListSerializer.$metadata$ = {
    simpleName: 'ArrayListSerializer',
    kind: 'class',
    interfaces: []
  };
  function LinkedHashSetSerializer(eSerializer) {
    ListLikeSerializer.call(this, eSerializer);
    this._descriptor_1 = new LinkedHashSetClassDesc(eSerializer._get_descriptor__48());
  }
  LinkedHashSetSerializer.prototype._get_descriptor__48 = function () {
    return this._descriptor_1;
  };
  LinkedHashSetSerializer.prototype.collectionSize_7 = function (_this__0) {
    return _this__0._get_size__45();
  };
  LinkedHashSetSerializer.prototype.collectionSize_29 = function (_this__0) {
    return this.collectionSize_7((!(_this__0 == null) ? isInterface(_this__0, Set) : false) ? _this__0 : THROW_CCE());
  };
  LinkedHashSetSerializer.prototype.collectionIterator_8 = function (_this__0) {
    return _this__0.iterator_64();
  };
  LinkedHashSetSerializer.prototype.collectionIterator_14 = function (_this__0) {
    return this.collectionIterator_8((!(_this__0 == null) ? isInterface(_this__0, Set) : false) ? _this__0 : THROW_CCE());
  };
  LinkedHashSetSerializer.prototype.builder_16 = function () {
    return LinkedHashSet_init_$Create$();
  };
  LinkedHashSetSerializer.prototype.builderSize_4 = function (_this__0) {
    return _this__0._get_size__45();
  };
  LinkedHashSetSerializer.prototype.builderSize_14 = function (_this__0) {
    return this.builderSize_4(_this__0 instanceof LinkedHashSet ? _this__0 : THROW_CCE());
  };
  LinkedHashSetSerializer.prototype.toResult_4 = function (_this__0) {
    return _this__0;
  };
  LinkedHashSetSerializer.prototype.toResult_14 = function (_this__0) {
    return this.toResult_4(_this__0 instanceof LinkedHashSet ? _this__0 : THROW_CCE());
  };
  LinkedHashSetSerializer.prototype.toBuilder_8 = function (_this__0) {
    var tmp0_elvis_lhs = _this__0 instanceof LinkedHashSet ? _this__0 : null;
    return tmp0_elvis_lhs == null ? LinkedHashSet_init_$Create$_0(_this__0) : tmp0_elvis_lhs;
  };
  LinkedHashSetSerializer.prototype.toBuilder_30 = function (_this__0) {
    return this.toBuilder_8((!(_this__0 == null) ? isInterface(_this__0, Set) : false) ? _this__0 : THROW_CCE());
  };
  LinkedHashSetSerializer.prototype.checkCapacity_4 = function (_this__0, size_0) {
  };
  LinkedHashSetSerializer.prototype.checkCapacity_14 = function (_this__0, size_0) {
    return this.checkCapacity_4(_this__0 instanceof LinkedHashSet ? _this__0 : THROW_CCE(), size_0);
  };
  LinkedHashSetSerializer.prototype.insert_3 = function (_this__0, index, element) {
    _this__0.add_33(element);
    Unit_getInstance();
  };
  LinkedHashSetSerializer.prototype.insert_8 = function (_this__0, index, element) {
    var tmp = _this__0 instanceof LinkedHashSet ? _this__0 : THROW_CCE();
    return this.insert_3(tmp, index, (element == null ? true : isObject(element)) ? element : THROW_CCE());
  };
  LinkedHashSetSerializer.$metadata$ = {
    simpleName: 'LinkedHashSetSerializer',
    kind: 'class',
    interfaces: []
  };
  function LinkedHashMapSerializer(kSerializer, vSerializer) {
    MapLikeSerializer.call(this, kSerializer, vSerializer);
    this._descriptor_2 = new LinkedHashMapClassDesc(kSerializer._get_descriptor__48(), vSerializer._get_descriptor__48());
  }
  LinkedHashMapSerializer.prototype._get_descriptor__48 = function () {
    return this._descriptor_2;
  };
  LinkedHashMapSerializer.prototype.collectionSize_9 = function (_this__0) {
    return _this__0._get_size__45();
  };
  LinkedHashMapSerializer.prototype.collectionSize_29 = function (_this__0) {
    return this.collectionSize_9((!(_this__0 == null) ? isInterface(_this__0, Map_0) : false) ? _this__0 : THROW_CCE());
  };
  LinkedHashMapSerializer.prototype.collectionIterator_10 = function (_this__0) {
    return _this__0._get_entries__10().iterator_64();
  };
  LinkedHashMapSerializer.prototype.collectionIterator_14 = function (_this__0) {
    return this.collectionIterator_10((!(_this__0 == null) ? isInterface(_this__0, Map_0) : false) ? _this__0 : THROW_CCE());
  };
  LinkedHashMapSerializer.prototype.builder_16 = function () {
    return LinkedHashMap_init_$Create$();
  };
  LinkedHashMapSerializer.prototype.builderSize_6 = function (_this__0) {
    return _this__0._get_size__45();
  };
  LinkedHashMapSerializer.prototype.builderSize_14 = function (_this__0) {
    return this.builderSize_6(_this__0 instanceof LinkedHashMap ? _this__0 : THROW_CCE());
  };
  LinkedHashMapSerializer.prototype.toResult_6 = function (_this__0) {
    return _this__0;
  };
  LinkedHashMapSerializer.prototype.toResult_14 = function (_this__0) {
    return this.toResult_6(_this__0 instanceof LinkedHashMap ? _this__0 : THROW_CCE());
  };
  LinkedHashMapSerializer.prototype.toBuilder_10 = function (_this__0) {
    var tmp0_elvis_lhs = _this__0 instanceof LinkedHashMap ? _this__0 : null;
    return tmp0_elvis_lhs == null ? LinkedHashMap_init_$Create$_2(_this__0) : tmp0_elvis_lhs;
  };
  LinkedHashMapSerializer.prototype.toBuilder_30 = function (_this__0) {
    return this.toBuilder_10((!(_this__0 == null) ? isInterface(_this__0, Map_0) : false) ? _this__0 : THROW_CCE());
  };
  LinkedHashMapSerializer.prototype.checkCapacity_6 = function (_this__0, size_0) {
  };
  LinkedHashMapSerializer.prototype.checkCapacity_14 = function (_this__0, size_0) {
    return this.checkCapacity_6(_this__0 instanceof LinkedHashMap ? _this__0 : THROW_CCE(), size_0);
  };
  LinkedHashMapSerializer.$metadata$ = {
    simpleName: 'LinkedHashMapSerializer',
    kind: 'class',
    interfaces: []
  };
  function HashSetSerializer(eSerializer) {
    ListLikeSerializer.call(this, eSerializer);
    this._descriptor_3 = new HashSetClassDesc(eSerializer._get_descriptor__48());
  }
  HashSetSerializer.prototype._get_descriptor__48 = function () {
    return this._descriptor_3;
  };
  HashSetSerializer.prototype.collectionSize_7 = function (_this__0) {
    return _this__0._get_size__45();
  };
  HashSetSerializer.prototype.collectionSize_29 = function (_this__0) {
    return this.collectionSize_7((!(_this__0 == null) ? isInterface(_this__0, Set) : false) ? _this__0 : THROW_CCE());
  };
  HashSetSerializer.prototype.collectionIterator_8 = function (_this__0) {
    return _this__0.iterator_64();
  };
  HashSetSerializer.prototype.collectionIterator_14 = function (_this__0) {
    return this.collectionIterator_8((!(_this__0 == null) ? isInterface(_this__0, Set) : false) ? _this__0 : THROW_CCE());
  };
  HashSetSerializer.prototype.builder_16 = function () {
    return HashSet_init_$Create$();
  };
  HashSetSerializer.prototype.builderSize_8 = function (_this__0) {
    return _this__0._get_size__45();
  };
  HashSetSerializer.prototype.builderSize_14 = function (_this__0) {
    return this.builderSize_8(_this__0 instanceof HashSet ? _this__0 : THROW_CCE());
  };
  HashSetSerializer.prototype.toResult_8 = function (_this__0) {
    return _this__0;
  };
  HashSetSerializer.prototype.toResult_14 = function (_this__0) {
    return this.toResult_8(_this__0 instanceof HashSet ? _this__0 : THROW_CCE());
  };
  HashSetSerializer.prototype.toBuilder_8 = function (_this__0) {
    var tmp0_elvis_lhs = _this__0 instanceof HashSet ? _this__0 : null;
    return tmp0_elvis_lhs == null ? HashSet_init_$Create$_0(_this__0) : tmp0_elvis_lhs;
  };
  HashSetSerializer.prototype.toBuilder_30 = function (_this__0) {
    return this.toBuilder_8((!(_this__0 == null) ? isInterface(_this__0, Set) : false) ? _this__0 : THROW_CCE());
  };
  HashSetSerializer.prototype.checkCapacity_8 = function (_this__0, size_0) {
  };
  HashSetSerializer.prototype.checkCapacity_14 = function (_this__0, size_0) {
    return this.checkCapacity_8(_this__0 instanceof HashSet ? _this__0 : THROW_CCE(), size_0);
  };
  HashSetSerializer.prototype.insert_5 = function (_this__0, index, element) {
    _this__0.add_33(element);
    Unit_getInstance();
  };
  HashSetSerializer.prototype.insert_8 = function (_this__0, index, element) {
    var tmp = _this__0 instanceof HashSet ? _this__0 : THROW_CCE();
    return this.insert_5(tmp, index, (element == null ? true : isObject(element)) ? element : THROW_CCE());
  };
  HashSetSerializer.$metadata$ = {
    simpleName: 'HashSetSerializer',
    kind: 'class',
    interfaces: []
  };
  function HashMapSerializer(kSerializer, vSerializer) {
    MapLikeSerializer.call(this, kSerializer, vSerializer);
    this._descriptor_4 = new HashMapClassDesc(kSerializer._get_descriptor__48(), vSerializer._get_descriptor__48());
  }
  HashMapSerializer.prototype._get_descriptor__48 = function () {
    return this._descriptor_4;
  };
  HashMapSerializer.prototype.collectionSize_9 = function (_this__0) {
    return _this__0._get_size__45();
  };
  HashMapSerializer.prototype.collectionSize_29 = function (_this__0) {
    return this.collectionSize_9((!(_this__0 == null) ? isInterface(_this__0, Map_0) : false) ? _this__0 : THROW_CCE());
  };
  HashMapSerializer.prototype.collectionIterator_10 = function (_this__0) {
    return _this__0._get_entries__10().iterator_64();
  };
  HashMapSerializer.prototype.collectionIterator_14 = function (_this__0) {
    return this.collectionIterator_10((!(_this__0 == null) ? isInterface(_this__0, Map_0) : false) ? _this__0 : THROW_CCE());
  };
  HashMapSerializer.prototype.builder_16 = function () {
    return HashMap_init_$Create$();
  };
  HashMapSerializer.prototype.builderSize_10 = function (_this__0) {
    return _this__0._get_size__45();
  };
  HashMapSerializer.prototype.builderSize_14 = function (_this__0) {
    return this.builderSize_10(_this__0 instanceof HashMap ? _this__0 : THROW_CCE());
  };
  HashMapSerializer.prototype.toResult_10 = function (_this__0) {
    return _this__0;
  };
  HashMapSerializer.prototype.toResult_14 = function (_this__0) {
    return this.toResult_10(_this__0 instanceof HashMap ? _this__0 : THROW_CCE());
  };
  HashMapSerializer.prototype.toBuilder_10 = function (_this__0) {
    var tmp0_elvis_lhs = _this__0 instanceof HashMap ? _this__0 : null;
    return tmp0_elvis_lhs == null ? HashMap_init_$Create$_2(_this__0) : tmp0_elvis_lhs;
  };
  HashMapSerializer.prototype.toBuilder_30 = function (_this__0) {
    return this.toBuilder_10((!(_this__0 == null) ? isInterface(_this__0, Map_0) : false) ? _this__0 : THROW_CCE());
  };
  HashMapSerializer.prototype.checkCapacity_10 = function (_this__0, size_0) {
  };
  HashMapSerializer.prototype.checkCapacity_14 = function (_this__0, size_0) {
    return this.checkCapacity_10(_this__0 instanceof HashMap ? _this__0 : THROW_CCE(), size_0);
  };
  HashMapSerializer.$metadata$ = {
    simpleName: 'HashMapSerializer',
    kind: 'class',
    interfaces: []
  };
  function MapLikeSerializer(keySerializer, valueSerializer) {
    AbstractCollectionSerializer.call(this);
    this._keySerializer = keySerializer;
    this._valueSerializer = valueSerializer;
  }
  MapLikeSerializer.prototype.readAll_7 = function (decoder, builder, startIndex, size_0) {
    var tmp0_require_0 = size_0 >= 0;
    if (!tmp0_require_0) {
      var message_1 = 'Size must be known in advance when using READ_ALL';
      throw IllegalArgumentException_init_$Create$_0(toString_1(message_1));
    }var progression = step(until(0, imul(size_0, 2)), 2);
    var inductionVariable = progression._first_1;
    var last_1 = progression._last;
    var step_0 = progression._step_1;
    if ((step_0 > 0 ? inductionVariable <= last_1 : false) ? true : step_0 < 0 ? last_1 <= inductionVariable : false)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + step_0 | 0;
        this.readElement_24(decoder, startIndex + index | 0, builder, false);
      }
       while (!(index === last_1));
  };
  MapLikeSerializer.prototype.readElement_24 = function (decoder, index, builder, checkIndex_0) {
    var tmp = this._get_descriptor__48();
    var key = decoder.decodeSerializableElement$default_8(tmp, index, this._keySerializer, null, 8, null);
    var tmp_0;
    if (checkIndex_0) {
      var tmp0_also_0 = decoder.decodeElementIndex_8(this._get_descriptor__48());
      var tmp0_require_0_2 = tmp0_also_0 === (index + 1 | 0);
      if (!tmp0_require_0_2) {
        var message_1_3 = '' + 'Value must follow key in a map, index for key: ' + index + ', returned index for value: ' + tmp0_also_0;
        throw IllegalArgumentException_init_$Create$_0(toString_1(message_1_3));
      }tmp_0 = tmp0_also_0;
    } else {
      tmp_0 = index + 1 | 0;
    }
    var vIndex = tmp_0;
    var tmp_1;
    var tmp_2;
    if (builder.containsKey_16(key)) {
      var tmp_3 = this._valueSerializer._get_descriptor__48()._get_kind__16();
      tmp_2 = !(tmp_3 instanceof PrimitiveKind);
    } else {
      tmp_2 = false;
    }
    if (tmp_2) {
      tmp_1 = decoder.decodeSerializableElement_8(this._get_descriptor__48(), vIndex, this._valueSerializer, getValue(builder, key));
    } else {
      {
        var tmp_4 = this._get_descriptor__48();
        tmp_1 = decoder.decodeSerializableElement$default_8(tmp_4, vIndex, this._valueSerializer, null, 8, null);
      }
    }
    var value = tmp_1;
    builder.put_12(key, value);
    Unit_getInstance();
  };
  MapLikeSerializer.prototype.serialize_12 = function (encoder, value) {
    var size_0 = this.collectionSize_29(value);
    var composite = encoder.beginCollection_1(this._get_descriptor__48(), size_0);
    var iterator_0 = this.collectionIterator_14(value);
    var index = 0;
    var tmp0_iterator_1 = iterator_0;
    while (tmp0_iterator_1.hasNext_31()) {
      var element_2 = tmp0_iterator_1.next_35();
      var k_4 = element_2._get_key__47();
      var v_5 = element_2._get_value__33();
      var tmp = this._get_descriptor__48();
      var tmp0_6 = index;
      index = tmp0_6 + 1 | 0;
      composite.encodeSerializableElement_1(tmp, tmp0_6, this._keySerializer, k_4);
      var tmp_0 = this._get_descriptor__48();
      var tmp1_7 = index;
      index = tmp1_7 + 1 | 0;
      composite.encodeSerializableElement_1(tmp_0, tmp1_7, this._valueSerializer, v_5);
    }
    composite.endStructure_11(this._get_descriptor__48());
  };
  MapLikeSerializer.prototype.serialize_76 = function (encoder, value) {
    return this.serialize_12(encoder, (value == null ? true : isObject(value)) ? value : THROW_CCE());
  };
  MapLikeSerializer.$metadata$ = {
    simpleName: 'MapLikeSerializer',
    kind: 'class',
    interfaces: []
  };
  function ReferenceArraySerializer(kClass, eSerializer) {
    ListLikeSerializer.call(this, eSerializer);
    this._kClass = kClass;
    this._descriptor_5 = new ArrayClassDesc(eSerializer._get_descriptor__48());
  }
  ReferenceArraySerializer.prototype._get_descriptor__48 = function () {
    return this._descriptor_5;
  };
  ReferenceArraySerializer.prototype.collectionSize_12 = function (_this__0) {
    return _this__0.length;
  };
  ReferenceArraySerializer.prototype.collectionSize_29 = function (_this__0) {
    return this.collectionSize_12((!(_this__0 == null) ? isArray(_this__0) : false) ? _this__0 : THROW_CCE());
  };
  ReferenceArraySerializer.prototype.collectionIterator_13 = function (_this__0) {
    return arrayIterator(_this__0);
  };
  ReferenceArraySerializer.prototype.collectionIterator_14 = function (_this__0) {
    return this.collectionIterator_13((!(_this__0 == null) ? isArray(_this__0) : false) ? _this__0 : THROW_CCE());
  };
  ReferenceArraySerializer.prototype.builder_16 = function () {
    return ArrayList_init_$Create$();
  };
  ReferenceArraySerializer.prototype.builderSize_13 = function (_this__0) {
    return _this__0._get_size__45();
  };
  ReferenceArraySerializer.prototype.builderSize_14 = function (_this__0) {
    return this.builderSize_13(_this__0 instanceof ArrayList ? _this__0 : THROW_CCE());
  };
  ReferenceArraySerializer.prototype.toResult_13 = function (_this__0) {
    return toNativeArrayImpl(_this__0, this._kClass);
  };
  ReferenceArraySerializer.prototype.toResult_14 = function (_this__0) {
    return this.toResult_13(_this__0 instanceof ArrayList ? _this__0 : THROW_CCE());
  };
  ReferenceArraySerializer.prototype.toBuilder_13 = function (_this__0) {
    return ArrayList_init_$Create$_1(asList(_this__0));
  };
  ReferenceArraySerializer.prototype.toBuilder_30 = function (_this__0) {
    return this.toBuilder_13((!(_this__0 == null) ? isArray(_this__0) : false) ? _this__0 : THROW_CCE());
  };
  ReferenceArraySerializer.prototype.checkCapacity_13 = function (_this__0, size_0) {
    return _this__0.ensureCapacity_8(size_0);
  };
  ReferenceArraySerializer.prototype.checkCapacity_14 = function (_this__0, size_0) {
    return this.checkCapacity_13(_this__0 instanceof ArrayList ? _this__0 : THROW_CCE(), size_0);
  };
  ReferenceArraySerializer.prototype.insert_7 = function (_this__0, index, element) {
    _this__0.add_27(index, element);
  };
  ReferenceArraySerializer.prototype.insert_8 = function (_this__0, index, element) {
    var tmp = _this__0 instanceof ArrayList ? _this__0 : THROW_CCE();
    return this.insert_7(tmp, index, (element == null ? true : isObject(element)) ? element : THROW_CCE());
  };
  ReferenceArraySerializer.$metadata$ = {
    simpleName: 'ReferenceArraySerializer',
    kind: 'class',
    interfaces: []
  };
  function InlinePrimitiveDescriptor(name, primitiveSerializer) {
    return new InlineClassDescriptor(name, new _no_name_provided__60(primitiveSerializer));
  }
  function InlineClassDescriptor(name, generatedSerializer) {
    PluginGeneratedSerialDescriptor.call(this, name, generatedSerializer, 1);
    this._isInline = true;
  }
  InlineClassDescriptor.prototype._get_isInline__16 = function () {
    return this._isInline;
  };
  InlineClassDescriptor.prototype.hashCode = function () {
    return imul(PluginGeneratedSerialDescriptor.prototype.hashCode.call(this), 31);
  };
  InlineClassDescriptor.prototype.equals = function (other) {
    var tmp$ret$0;
    l$ret$1: do {
      if (this === other) {
        tmp$ret$0 = true;
        break l$ret$1;
      }if (!(other instanceof InlineClassDescriptor)) {
        tmp$ret$0 = false;
        break l$ret$1;
      } else {
      }
      if (!(this._get_serialName__16() === other._get_serialName__16())) {
        tmp$ret$0 = false;
        break l$ret$1;
      }var tmp0__anonymous__3 = other;
      if (!(tmp0__anonymous__3._isInline ? contentEquals(this._get_typeParameterDescriptors__0(), tmp0__anonymous__3._get_typeParameterDescriptors__0()) : false)) {
        tmp$ret$0 = false;
        break l$ret$1;
      } else {
      }
      if (!(this._get_elementsCount__16() === other._get_elementsCount__16())) {
        tmp$ret$0 = false;
        break l$ret$1;
      }var inductionVariable = 0;
      var last_1 = this._get_elementsCount__16();
      if (inductionVariable < last_1)
        do {
          var index_2 = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          if (!(this.getElementDescriptor_16(index_2)._get_serialName__16() === other.getElementDescriptor_16(index_2)._get_serialName__16())) {
            tmp$ret$0 = false;
            break l$ret$1;
          }if (!equals_1(this.getElementDescriptor_16(index_2)._get_kind__16(), other.getElementDescriptor_16(index_2)._get_kind__16())) {
            tmp$ret$0 = false;
            break l$ret$1;
          }}
         while (inductionVariable < last_1);
      tmp$ret$0 = true;
    }
     while (false);
    return tmp$ret$0;
  };
  InlineClassDescriptor.$metadata$ = {
    simpleName: 'InlineClassDescriptor',
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__60($primitiveSerializer) {
    this._$primitiveSerializer = $primitiveSerializer;
  }
  _no_name_provided__60.prototype.childSerializers_2 = function () {
    var tmp0_arrayOf_0 = [this._$primitiveSerializer];
    return tmp0_arrayOf_0;
  };
  _no_name_provided__60.prototype._get_descriptor__48 = function () {
    var tmp0_error_0 = 'unsupported';
    throw IllegalStateException_init_$Create$(toString_1(tmp0_error_0));
  };
  _no_name_provided__60.prototype.serialize_76 = function (encoder, value) {
    var tmp0_error_0 = 'unsupported';
    throw IllegalStateException_init_$Create$(toString_1(tmp0_error_0));
  };
  _no_name_provided__60.prototype.deserialize_52 = function (decoder) {
    var tmp0_error_0 = 'unsupported';
    throw IllegalStateException_init_$Create$(toString_1(tmp0_error_0));
  };
  _no_name_provided__60.$metadata$ = {
    kind: 'class',
    interfaces: [GeneratedSerializer]
  };
  function UIntSerializer() {
    UIntSerializer_instance = this;
    this._descriptor_6 = InlinePrimitiveDescriptor('kotlin.UInt', serializer_7(IntCompanionObject_getInstance()));
  }
  UIntSerializer.prototype._get_descriptor__48 = function () {
    return this._descriptor_6;
  };
  UIntSerializer.prototype.serialize_16 = function (encoder, value) {
    var tmp0_safe_receiver = encoder.encodeInline_1(this._descriptor_6);
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.encodeInt_1(_UInt___get_data__impl_(value));
      Unit_getInstance();
    }
    Unit_getInstance();
  };
  UIntSerializer.prototype.serialize_76 = function (encoder, value) {
    return this.serialize_16(encoder, value instanceof UInt ? value._data_0 : THROW_CCE());
  };
  UIntSerializer.prototype.deserialize_12 = function (decoder) {
    var tmp0_toUInt_0 = decoder.decodeInline_8(this._descriptor_6).decodeInt_8();
    return _UInt___init__impl_(tmp0_toUInt_0);
  };
  UIntSerializer.prototype.deserialize_52 = function (decoder) {
    return new UInt(this.deserialize_12(decoder));
  };
  UIntSerializer.$metadata$ = {
    simpleName: 'UIntSerializer',
    kind: 'object',
    interfaces: [KSerializer]
  };
  var UIntSerializer_instance;
  function UIntSerializer_getInstance() {
    if (UIntSerializer_instance == null)
      new UIntSerializer();
    return UIntSerializer_instance;
  }
  function ULongSerializer() {
    ULongSerializer_instance = this;
    this._descriptor_7 = InlinePrimitiveDescriptor('kotlin.ULong', serializer_6(Companion_getInstance_15()));
  }
  ULongSerializer.prototype._get_descriptor__48 = function () {
    return this._descriptor_7;
  };
  ULongSerializer.prototype.serialize_18 = function (encoder, value) {
    var tmp0_safe_receiver = encoder.encodeInline_1(this._descriptor_7);
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.encodeLong_1(_ULong___get_data__impl_(value));
      Unit_getInstance();
    }
    Unit_getInstance();
  };
  ULongSerializer.prototype.serialize_76 = function (encoder, value) {
    return this.serialize_18(encoder, value instanceof ULong ? value._data_1 : THROW_CCE());
  };
  ULongSerializer.prototype.deserialize_14 = function (decoder) {
    var tmp0_toULong_0 = decoder.decodeInline_8(this._descriptor_7).decodeLong_8();
    return _ULong___init__impl_(tmp0_toULong_0);
  };
  ULongSerializer.prototype.deserialize_52 = function (decoder) {
    return new ULong(this.deserialize_14(decoder));
  };
  ULongSerializer.$metadata$ = {
    simpleName: 'ULongSerializer',
    kind: 'object',
    interfaces: [KSerializer]
  };
  var ULongSerializer_instance;
  function ULongSerializer_getInstance() {
    if (ULongSerializer_instance == null)
      new ULongSerializer();
    return ULongSerializer_instance;
  }
  function UByteSerializer() {
    UByteSerializer_instance = this;
    this._descriptor_8 = InlinePrimitiveDescriptor('kotlin.UByte', serializer_9(ByteCompanionObject_getInstance()));
  }
  UByteSerializer.prototype._get_descriptor__48 = function () {
    return this._descriptor_8;
  };
  UByteSerializer.prototype.serialize_20 = function (encoder, value) {
    var tmp0_safe_receiver = encoder.encodeInline_1(this._descriptor_8);
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.encodeByte_1(_UByte___get_data__impl_(value));
      Unit_getInstance();
    }
    Unit_getInstance();
  };
  UByteSerializer.prototype.serialize_76 = function (encoder, value) {
    return this.serialize_20(encoder, value instanceof UByte ? value._data : THROW_CCE());
  };
  UByteSerializer.prototype.deserialize_16 = function (decoder) {
    var tmp0_toUByte_0 = decoder.decodeInline_8(this._descriptor_8).decodeByte_8();
    return _UByte___init__impl_(tmp0_toUByte_0);
  };
  UByteSerializer.prototype.deserialize_52 = function (decoder) {
    return new UByte(this.deserialize_16(decoder));
  };
  UByteSerializer.$metadata$ = {
    simpleName: 'UByteSerializer',
    kind: 'object',
    interfaces: [KSerializer]
  };
  var UByteSerializer_instance;
  function UByteSerializer_getInstance() {
    if (UByteSerializer_instance == null)
      new UByteSerializer();
    return UByteSerializer_instance;
  }
  function UShortSerializer() {
    UShortSerializer_instance = this;
    this._descriptor_9 = InlinePrimitiveDescriptor('kotlin.UShort', serializer_8(ShortCompanionObject_getInstance()));
  }
  UShortSerializer.prototype._get_descriptor__48 = function () {
    return this._descriptor_9;
  };
  UShortSerializer.prototype.serialize_22 = function (encoder, value) {
    var tmp0_safe_receiver = encoder.encodeInline_1(this._descriptor_9);
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.encodeShort_1(_UShort___get_data__impl_(value));
      Unit_getInstance();
    }
    Unit_getInstance();
  };
  UShortSerializer.prototype.serialize_76 = function (encoder, value) {
    return this.serialize_22(encoder, value instanceof UShort ? value._data_2 : THROW_CCE());
  };
  UShortSerializer.prototype.deserialize_18 = function (decoder) {
    var tmp0_toUShort_0 = decoder.decodeInline_8(this._descriptor_9).decodeShort_8();
    return _UShort___init__impl_(tmp0_toUShort_0);
  };
  UShortSerializer.prototype.deserialize_52 = function (decoder) {
    return new UShort(this.deserialize_18(decoder));
  };
  UShortSerializer.$metadata$ = {
    simpleName: 'UShortSerializer',
    kind: 'object',
    interfaces: [KSerializer]
  };
  var UShortSerializer_instance;
  function UShortSerializer_getInstance() {
    if (UShortSerializer_instance == null)
      new UShortSerializer();
    return UShortSerializer_instance;
  }
  function jsonCachedSerialNames(_this_) {
    return cachedSerialNames(_this_);
  }
  function NullableSerializer(serializer_16) {
    this._serializer = serializer_16;
    this._descriptor_10 = new SerialDescriptorForNullable(this._serializer._get_descriptor__48());
  }
  NullableSerializer.prototype._get_descriptor__48 = function () {
    return this._descriptor_10;
  };
  NullableSerializer.prototype.serialize_24 = function (encoder, value) {
    if (!(value == null)) {
      encoder.encodeNotNullMark_1();
      encoder.encodeSerializableValue_1(this._serializer, value);
    } else {
      encoder.encodeNull_1();
    }
  };
  NullableSerializer.prototype.serialize_76 = function (encoder, value) {
    return this.serialize_24(encoder, (value == null ? true : isObject(value)) ? value : THROW_CCE());
  };
  NullableSerializer.prototype.deserialize_52 = function (decoder) {
    return decoder.decodeNotNullMark_8() ? decoder.decodeSerializableValue_16(this._serializer) : decoder.decodeNull_8();
  };
  NullableSerializer.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (other == null ? true : !getKClassFromExpression_0(this).equals(getKClassFromExpression_0(other)))
      return false;
    if (other instanceof NullableSerializer)
      other;
    else
      THROW_CCE();
    Unit_getInstance();
    if (!equals_1(this._serializer, other._serializer))
      return false;
    return true;
  };
  NullableSerializer.prototype.hashCode = function () {
    return hashCode(this._serializer);
  };
  NullableSerializer.$metadata$ = {
    simpleName: 'NullableSerializer',
    kind: 'class',
    interfaces: [KSerializer]
  };
  function SerialDescriptorForNullable(original) {
    this._original = original;
    this._serialName_3 = this._original._get_serialName__16() + '?';
    this._serialNames_0 = cachedSerialNames(this._original);
  }
  SerialDescriptorForNullable.prototype.getElementDescriptor_16 = function (index) {
    return this._original.getElementDescriptor_16(index);
  };
  SerialDescriptorForNullable.prototype.getElementIndex_16 = function (name) {
    return this._original.getElementIndex_16(name);
  };
  SerialDescriptorForNullable.prototype.getElementName_16 = function (index) {
    return this._original.getElementName_16(index);
  };
  SerialDescriptorForNullable.prototype._get_elementsCount__16 = function () {
    return this._original._get_elementsCount__16();
  };
  SerialDescriptorForNullable.prototype._get_isInline__16 = function () {
    return this._original._get_isInline__16();
  };
  SerialDescriptorForNullable.prototype._get_kind__16 = function () {
    return this._original._get_kind__16();
  };
  SerialDescriptorForNullable.prototype._get_serialName__16 = function () {
    return this._serialName_3;
  };
  SerialDescriptorForNullable.prototype._get_serialNames__3 = function () {
    return this._serialNames_0;
  };
  SerialDescriptorForNullable.prototype._get_isNullable__16 = function () {
    return true;
  };
  SerialDescriptorForNullable.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof SerialDescriptorForNullable))
      return false;
    else {
    }
    if (!equals_1(this._original, other._original))
      return false;
    return true;
  };
  SerialDescriptorForNullable.prototype.toString = function () {
    return '' + this._original + '?';
  };
  SerialDescriptorForNullable.prototype.hashCode = function () {
    return imul(hashCode(this._original), 31);
  };
  SerialDescriptorForNullable.$metadata$ = {
    simpleName: 'SerialDescriptorForNullable',
    kind: 'class',
    interfaces: [SerialDescriptor, CachedNames]
  };
  function ObjectSerializer(serialName, objectInstance) {
    this._objectInstance = objectInstance;
    var tmp = this;
    var tmp_0 = OBJECT_getInstance();
    var tmp_1 = [];
    tmp._descriptor_11 = buildSerialDescriptor$default(serialName, tmp_0, tmp_1, null, 12, null);
  }
  ObjectSerializer.prototype._get_descriptor__48 = function () {
    return this._descriptor_11;
  };
  ObjectSerializer.prototype.serialize_76 = function (encoder, value) {
    encoder.beginStructure_11(this._descriptor_11).endStructure_11(this._descriptor_11);
  };
  ObjectSerializer.prototype.deserialize_52 = function (decoder) {
    decoder.beginStructure_11(this._descriptor_11).endStructure_11(this._descriptor_11);
    return this._objectInstance;
  };
  ObjectSerializer.$metadata$ = {
    simpleName: 'ObjectSerializer',
    kind: 'class',
    interfaces: [KSerializer]
  };
  var EMPTY_DESCRIPTOR_ARRAY;
  function compactArray(_this_) {
    var tmp;
    if (!(_this_ == null ? true : _this_.isEmpty_53())) {
      tmp = _this_;
    } else {
      {
        tmp = null;
      }
    }
    var tmp0_safe_receiver = tmp;
    var tmp_0;
    if (tmp0_safe_receiver == null) {
      tmp_0 = null;
    } else {
      tmp_0 = copyToArray_0(tmp0_safe_receiver);
    }
    var tmp1_elvis_lhs = tmp_0;
    return tmp1_elvis_lhs == null ? EMPTY_DESCRIPTOR_ARRAY : tmp1_elvis_lhs;
  }
  function serializerNotRegistered(_this_) {
    throw SerializationException_init_$Create$('' + "Serializer for class '" + _this_._get_simpleName__4() + "' is not found.\n" + 'Mark the class as @Serializable or provide the serializer explicitly.');
  }
  function kclass(_this_) {
    var t = _this_._get_classifier__0();
    var tmp;
    if (!(t == null) ? isInterface(t, KClass) : false) {
      tmp = t;
    } else {
      {
        var tmp0_error_0 = '' + 'Only KClass supported as classifier, got ' + t;
        throw IllegalStateException_init_$Create$(toString_1(tmp0_error_0));
      }
    }
    var tmp_0 = tmp;
    return isInterface(tmp_0, KClass) ? tmp_0 : THROW_CCE();
  }
  function cachedSerialNames(_this_) {
    if (isInterface(_this_, CachedNames))
      return _this_._get_serialNames__3();
    else {
    }
    var result = HashSet_init_$Create$_1(_this_._get_elementsCount__16());
    var inductionVariable = 0;
    var last_1 = _this_._get_elementsCount__16();
    if (inductionVariable < last_1)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var tmp0_plusAssign_0 = _this_.getElementName_16(i);
        result.add_33(tmp0_plusAssign_0);
        Unit_getInstance();
      }
       while (inductionVariable < last_1);
    return result;
  }
  function EMPTY_DESCRIPTOR_ARRAY$init$() {
    var tmp0_arrayOf_0 = [];
    return tmp0_arrayOf_0;
  }
  function hashCodeImpl(_this_, typeParams) {
    var result = getStringHashCode(_this_._get_serialName__16());
    result = imul(31, result) + contentHashCode(typeParams) | 0;
    var elementDescriptors = _get_elementDescriptors_(_this_);
    var tmp0_fold_0_1 = 1;
    var accumulator_1_2 = tmp0_fold_0_1;
    var tmp0_iterator_2_3 = elementDescriptors.iterator_64();
    while (tmp0_iterator_2_3.hasNext_31()) {
      var element_3_4 = tmp0_iterator_2_3.next_35();
      var tmp1__anonymous__4_5 = accumulator_1_2;
      var tmp = imul(31, tmp1__anonymous__4_5);
      var tmp0_hashCode_0_5_6 = element_3_4._get_serialName__16();
      var tmp0_safe_receiver_2_7_8 = tmp0_hashCode_0_5_6;
      var tmp1_elvis_lhs_1_6_7 = tmp0_safe_receiver_2_7_8 == null ? null : hashCode(tmp0_safe_receiver_2_7_8);
      accumulator_1_2 = tmp + (tmp1_elvis_lhs_1_6_7 == null ? 0 : tmp1_elvis_lhs_1_6_7) | 0;
    }
    var namesHash = accumulator_1_2;
    var tmp0_fold_0_1_0 = 1;
    var accumulator_1_2_0 = tmp0_fold_0_1_0;
    var tmp0_iterator_2_3_0 = elementDescriptors.iterator_64();
    while (tmp0_iterator_2_3_0.hasNext_31()) {
      var element_3_4_0 = tmp0_iterator_2_3_0.next_35();
      var tmp1__anonymous__4_5_0 = accumulator_1_2_0;
      var tmp_0 = imul(31, tmp1__anonymous__4_5_0);
      var tmp0_hashCode_0_5_6_0 = element_3_4_0._get_kind__16();
      var tmp0_safe_receiver_2_7_8_0 = tmp0_hashCode_0_5_6_0;
      var tmp1_elvis_lhs_1_6_7_0 = tmp0_safe_receiver_2_7_8_0 == null ? null : hashCode(tmp0_safe_receiver_2_7_8_0);
      accumulator_1_2_0 = tmp_0 + (tmp1_elvis_lhs_1_6_7_0 == null ? 0 : tmp1_elvis_lhs_1_6_7_0) | 0;
    }
    var kindHash = accumulator_1_2_0;
    result = imul(31, result) + namesHash | 0;
    result = imul(31, result) + kindHash | 0;
    return result;
  }
  function _get_indices__1($this) {
    var tmp0_getValue_0 = $this._indices$delegate;
    var tmp1_getValue_0 = indices$factory();
    return tmp0_getValue_0._get_value__33();
  }
  function _get_childSerializers_($this) {
    var tmp0_getValue_0 = $this._childSerializers$delegate;
    var tmp1_getValue_0 = childSerializers$factory();
    return tmp0_getValue_0._get_value__33();
  }
  function _get__hashCode__0($this) {
    var tmp0_getValue_0 = $this.__hashCode$delegate_0;
    var tmp1_getValue_0 = _hashCode$factory_0();
    return tmp0_getValue_0._get_value__33();
  }
  function buildIndices($this) {
    var indices = HashMap_init_$Create$();
    var inductionVariable = 0;
    var last_1 = $this._names.length - 1 | 0;
    if (inductionVariable <= last_1)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var tmp0_set_0 = $this._names[i];
        indices.put_12(tmp0_set_0, i);
        Unit_getInstance();
      }
       while (inductionVariable <= last_1);
    return indices;
  }
  function _no_name_provided__61(this$0) {
    this._this$0_15 = this$0;
  }
  _no_name_provided__61.prototype.invoke_540 = function () {
    return buildIndices(this._this$0_15);
  };
  _no_name_provided__61.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__62(this$0) {
    this._this$0_16 = this$0;
  }
  _no_name_provided__62.prototype.invoke_540 = function () {
    var tmp0_safe_receiver = this._this$0_16._generatedSerializer;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.childSerializers_2();
    var tmp;
    if (tmp1_elvis_lhs == null) {
      tmp = [];
    } else {
      tmp = tmp1_elvis_lhs;
    }
    return tmp;
  };
  _no_name_provided__62.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__63(this$0) {
    this._this$0_17 = this$0;
  }
  _no_name_provided__63.prototype.invoke_540 = function () {
    var tmp0_safe_receiver = this._this$0_17._generatedSerializer;
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.typeParametersSerializers_2();
    var tmp;
    if (tmp1_safe_receiver == null) {
      tmp = null;
    } else {
      var tmp0_mapTo_0_1 = ArrayList_init_$Create$_0(tmp1_safe_receiver.length);
      var tmp0_iterator_1_2 = arrayIterator(tmp1_safe_receiver);
      while (tmp0_iterator_1_2.hasNext_31()) {
        var item_2_3 = tmp0_iterator_1_2.next_35();
        tmp0_mapTo_0_1.add_33(item_2_3._get_descriptor__48());
        Unit_getInstance();
      }
      tmp = tmp0_mapTo_0_1;
    }
    return compactArray(tmp);
  };
  _no_name_provided__63.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__64(this$0) {
    this._this$0_18 = this$0;
  }
  _no_name_provided__64.prototype.invoke_540 = function () {
    return hashCodeImpl(this._this$0_18, this._this$0_18._get_typeParameterDescriptors__0());
  };
  _no_name_provided__64.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__65(this$0) {
    this._this$0_19 = this$0;
  }
  _no_name_provided__65.prototype.invoke_85 = function (it) {
    return it._get_key__47() + ': ' + this._this$0_19.getElementDescriptor_16(it._get_value__33())._get_serialName__16();
  };
  _no_name_provided__65.prototype.invoke_542 = function (p1) {
    return this.invoke_85((!(p1 == null) ? isInterface(p1, Entry) : false) ? p1 : THROW_CCE());
  };
  _no_name_provided__65.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function PluginGeneratedSerialDescriptor(serialName, generatedSerializer, elementsCount) {
    this._serialName_4 = serialName;
    this._generatedSerializer = generatedSerializer;
    this._elementsCount_2 = elementsCount;
    this._added = -1;
    var tmp = this;
    var tmp_0 = 0;
    var tmp_1 = this._elementsCount_2;
    var tmp_2 = fillArrayVal(Array(tmp_1), null);
    while (tmp_0 < tmp_1) {
      var tmp_3 = tmp_0;
      tmp_2[tmp_3] = '[UNINITIALIZED]';
      tmp_0 = tmp_0 + 1 | 0;
    }
    tmp._names = tmp_2;
    var tmp_4 = this;
    var tmp0_arrayOfNulls_0 = this._elementsCount_2;
    tmp_4._propertiesAnnotations = fillArrayVal(Array(tmp0_arrayOfNulls_0), null);
    this._classAnnotations = null;
    this._elementsOptionality = booleanArray(this._elementsCount_2);
    var tmp_5 = this;
    tmp_5._indices$delegate = lazy(_no_name_provided_$factory_41(this));
    var tmp_6 = this;
    tmp_6._childSerializers$delegate = lazy(_no_name_provided_$factory_42(this));
    var tmp_7 = this;
    tmp_7._typeParameterDescriptors$delegate = lazy(_no_name_provided_$factory_43(this));
    var tmp_8 = this;
    tmp_8.__hashCode$delegate_0 = lazy(_no_name_provided_$factory_44(this));
  }
  PluginGeneratedSerialDescriptor.prototype._get_serialName__16 = function () {
    return this._serialName_4;
  };
  PluginGeneratedSerialDescriptor.prototype._get_elementsCount__16 = function () {
    return this._elementsCount_2;
  };
  PluginGeneratedSerialDescriptor.prototype._get_kind__16 = function () {
    return CLASS_getInstance();
  };
  PluginGeneratedSerialDescriptor.prototype._get_serialNames__3 = function () {
    return _get_indices__1(this)._get_keys__10();
  };
  PluginGeneratedSerialDescriptor.prototype._get_typeParameterDescriptors__0 = function () {
    var tmp0_getValue_0 = this._typeParameterDescriptors$delegate;
    var tmp1_getValue_0 = typeParameterDescriptors$factory();
    return tmp0_getValue_0._get_value__33();
  };
  PluginGeneratedSerialDescriptor.prototype.addElement_0 = function (name, isOptional) {
    var tmp0_this = this;
    tmp0_this._added = tmp0_this._added + 1 | 0;
    this._names[tmp0_this._added] = name;
    this._elementsOptionality[this._added] = isOptional;
    this._propertiesAnnotations[this._added] = null;
  };
  PluginGeneratedSerialDescriptor.prototype.getElementDescriptor_16 = function (index) {
    return getChecked(_get_childSerializers_(this), index)._get_descriptor__48();
  };
  PluginGeneratedSerialDescriptor.prototype.getElementName_16 = function (index) {
    return getChecked(this._names, index);
  };
  PluginGeneratedSerialDescriptor.prototype.getElementIndex_16 = function (name) {
    var tmp0_elvis_lhs = _get_indices__1(this).get_63(name);
    return tmp0_elvis_lhs == null ? -3 : tmp0_elvis_lhs;
  };
  PluginGeneratedSerialDescriptor.prototype.equals = function (other) {
    var tmp$ret$0;
    l$ret$1: do {
      if (this === other) {
        tmp$ret$0 = true;
        break l$ret$1;
      }if (!(other instanceof PluginGeneratedSerialDescriptor)) {
        tmp$ret$0 = false;
        break l$ret$1;
      } else {
      }
      if (!(this._get_serialName__16() === other._get_serialName__16())) {
        tmp$ret$0 = false;
        break l$ret$1;
      }var tmp0__anonymous__3 = other;
      if (!contentEquals(this._get_typeParameterDescriptors__0(), tmp0__anonymous__3._get_typeParameterDescriptors__0())) {
        tmp$ret$0 = false;
        break l$ret$1;
      } else {
      }
      if (!(this._get_elementsCount__16() === other._get_elementsCount__16())) {
        tmp$ret$0 = false;
        break l$ret$1;
      }var inductionVariable = 0;
      var last_1 = this._get_elementsCount__16();
      if (inductionVariable < last_1)
        do {
          var index_2 = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          if (!(this.getElementDescriptor_16(index_2)._get_serialName__16() === other.getElementDescriptor_16(index_2)._get_serialName__16())) {
            tmp$ret$0 = false;
            break l$ret$1;
          }if (!equals_1(this.getElementDescriptor_16(index_2)._get_kind__16(), other.getElementDescriptor_16(index_2)._get_kind__16())) {
            tmp$ret$0 = false;
            break l$ret$1;
          }}
         while (inductionVariable < last_1);
      tmp$ret$0 = true;
    }
     while (false);
    return tmp$ret$0;
  };
  PluginGeneratedSerialDescriptor.prototype.hashCode = function () {
    return _get__hashCode__0(this);
  };
  PluginGeneratedSerialDescriptor.prototype.toString = function () {
    var tmp = _get_indices__1(this)._get_entries__10();
    var tmp_0 = '' + this._get_serialName__16() + '(';
    return joinToString$default_0(tmp, ', ', tmp_0, ')', 0, null, _no_name_provided_$factory_45(this), 24, null);
  };
  PluginGeneratedSerialDescriptor.$metadata$ = {
    simpleName: 'PluginGeneratedSerialDescriptor',
    kind: 'class',
    interfaces: [SerialDescriptor, CachedNames]
  };
  function indices$factory() {
    return getPropertyCallableRef('indices', 1, KProperty1, function (receiver) {
      return _get_indices__1(receiver);
    }, null);
  }
  function childSerializers$factory() {
    return getPropertyCallableRef('childSerializers', 1, KProperty1, function (receiver) {
      return _get_childSerializers_(receiver);
    }, null);
  }
  function typeParameterDescriptors$factory() {
    return getPropertyCallableRef('typeParameterDescriptors', 1, KProperty1, function (receiver) {
      return receiver._get_typeParameterDescriptors__0();
    }, null);
  }
  function _hashCode$factory_0() {
    return getPropertyCallableRef('_hashCode', 1, KProperty1, function (receiver) {
      return _get__hashCode__0(receiver);
    }, null);
  }
  function _no_name_provided_$factory_41(this$0) {
    var i = new _no_name_provided__61(this$0);
    return function () {
      return i.invoke_540();
    };
  }
  function _no_name_provided_$factory_42(this$0) {
    var i = new _no_name_provided__62(this$0);
    return function () {
      return i.invoke_540();
    };
  }
  function _no_name_provided_$factory_43(this$0) {
    var i = new _no_name_provided__63(this$0);
    return function () {
      return i.invoke_540();
    };
  }
  function _no_name_provided_$factory_44(this$0) {
    var i = new _no_name_provided__64(this$0);
    return function () {
      return i.invoke_540();
    };
  }
  function _no_name_provided_$factory_45(this$0) {
    var i = new _no_name_provided__65(this$0);
    return function (p1) {
      return i.invoke_85(p1);
    };
  }
  var EMPTY_SERIALIZER_ARRAY;
  function SerializerFactory() {
  }
  SerializerFactory.$metadata$ = {
    simpleName: 'SerializerFactory',
    kind: 'interface',
    interfaces: []
  };
  function GeneratedSerializer() {
  }
  GeneratedSerializer.prototype.typeParametersSerializers_2 = function () {
    return EMPTY_SERIALIZER_ARRAY;
  };
  GeneratedSerializer.$metadata$ = {
    simpleName: 'GeneratedSerializer',
    kind: 'interface',
    interfaces: [KSerializer]
  };
  function EMPTY_SERIALIZER_ARRAY$init$() {
    var tmp0_arrayOf_0 = [];
    return tmp0_arrayOf_0;
  }
  function CharArraySerializer_0() {
    CharArraySerializer_instance = this;
    PrimitiveArraySerializer.call(this, serializer_3(Companion_getInstance_13()));
  }
  CharArraySerializer_0.prototype.collectionSize_14 = function (_this__0) {
    return _this__0.length;
  };
  CharArraySerializer_0.prototype.collectionSize_29 = function (_this__0) {
    return this.collectionSize_14((!(_this__0 == null) ? isCharArray(_this__0) : false) ? _this__0 : THROW_CCE());
  };
  CharArraySerializer_0.prototype.toBuilder_15 = function (_this__0) {
    return new CharArrayBuilder(_this__0);
  };
  CharArraySerializer_0.prototype.toBuilder_30 = function (_this__0) {
    return this.toBuilder_15((!(_this__0 == null) ? isCharArray(_this__0) : false) ? _this__0 : THROW_CCE());
  };
  CharArraySerializer_0.prototype.empty_7 = function () {
    return charArray(0);
  };
  CharArraySerializer_0.prototype.readElement_9 = function (decoder, index, builder, checkIndex_0) {
    builder.append_8(decoder.decodeCharElement_8(this._get_descriptor__48(), index));
  };
  CharArraySerializer_0.prototype.readElement_24 = function (decoder, index, builder, checkIndex_0) {
    return this.readElement_9(decoder, index, builder instanceof CharArrayBuilder ? builder : THROW_CCE(), checkIndex_0);
  };
  CharArraySerializer_0.prototype.writeContent_0 = function (encoder, content, size_0) {
    var inductionVariable = 0;
    if (inductionVariable < size_0)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        encoder.encodeCharElement_1(this._get_descriptor__48(), i, content[i]);
      }
       while (inductionVariable < size_0);
  };
  CharArraySerializer_0.prototype.writeContent_15 = function (encoder, content, size_0) {
    return this.writeContent_0(encoder, (!(content == null) ? isCharArray(content) : false) ? content : THROW_CCE(), size_0);
  };
  CharArraySerializer_0.$metadata$ = {
    simpleName: 'CharArraySerializer',
    kind: 'object',
    interfaces: [KSerializer]
  };
  var CharArraySerializer_instance;
  function CharArraySerializer_getInstance() {
    if (CharArraySerializer_instance == null)
      new CharArraySerializer_0();
    return CharArraySerializer_instance;
  }
  function DoubleArraySerializer_0() {
    DoubleArraySerializer_instance = this;
    PrimitiveArraySerializer.call(this, serializer_4(DoubleCompanionObject_getInstance()));
  }
  DoubleArraySerializer_0.prototype.collectionSize_16 = function (_this__0) {
    return _this__0.length;
  };
  DoubleArraySerializer_0.prototype.collectionSize_29 = function (_this__0) {
    return this.collectionSize_16((!(_this__0 == null) ? isDoubleArray(_this__0) : false) ? _this__0 : THROW_CCE());
  };
  DoubleArraySerializer_0.prototype.toBuilder_17 = function (_this__0) {
    return new DoubleArrayBuilder(_this__0);
  };
  DoubleArraySerializer_0.prototype.toBuilder_30 = function (_this__0) {
    return this.toBuilder_17((!(_this__0 == null) ? isDoubleArray(_this__0) : false) ? _this__0 : THROW_CCE());
  };
  DoubleArraySerializer_0.prototype.empty_7 = function () {
    return new Float64Array(0);
  };
  DoubleArraySerializer_0.prototype.readElement_11 = function (decoder, index, builder, checkIndex_0) {
    builder.append_9(decoder.decodeDoubleElement_8(this._get_descriptor__48(), index));
  };
  DoubleArraySerializer_0.prototype.readElement_24 = function (decoder, index, builder, checkIndex_0) {
    return this.readElement_11(decoder, index, builder instanceof DoubleArrayBuilder ? builder : THROW_CCE(), checkIndex_0);
  };
  DoubleArraySerializer_0.prototype.writeContent_2 = function (encoder, content, size_0) {
    var inductionVariable = 0;
    if (inductionVariable < size_0)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        encoder.encodeDoubleElement_1(this._get_descriptor__48(), i, content[i]);
      }
       while (inductionVariable < size_0);
  };
  DoubleArraySerializer_0.prototype.writeContent_15 = function (encoder, content, size_0) {
    return this.writeContent_2(encoder, (!(content == null) ? isDoubleArray(content) : false) ? content : THROW_CCE(), size_0);
  };
  DoubleArraySerializer_0.$metadata$ = {
    simpleName: 'DoubleArraySerializer',
    kind: 'object',
    interfaces: [KSerializer]
  };
  var DoubleArraySerializer_instance;
  function DoubleArraySerializer_getInstance() {
    if (DoubleArraySerializer_instance == null)
      new DoubleArraySerializer_0();
    return DoubleArraySerializer_instance;
  }
  function FloatArraySerializer_0() {
    FloatArraySerializer_instance = this;
    PrimitiveArraySerializer.call(this, serializer_5(FloatCompanionObject_getInstance()));
  }
  FloatArraySerializer_0.prototype.collectionSize_18 = function (_this__0) {
    return _this__0.length;
  };
  FloatArraySerializer_0.prototype.collectionSize_29 = function (_this__0) {
    return this.collectionSize_18((!(_this__0 == null) ? isFloatArray(_this__0) : false) ? _this__0 : THROW_CCE());
  };
  FloatArraySerializer_0.prototype.toBuilder_19 = function (_this__0) {
    return new FloatArrayBuilder(_this__0);
  };
  FloatArraySerializer_0.prototype.toBuilder_30 = function (_this__0) {
    return this.toBuilder_19((!(_this__0 == null) ? isFloatArray(_this__0) : false) ? _this__0 : THROW_CCE());
  };
  FloatArraySerializer_0.prototype.empty_7 = function () {
    return new Float32Array(0);
  };
  FloatArraySerializer_0.prototype.readElement_13 = function (decoder, index, builder, checkIndex_0) {
    builder.append_10(decoder.decodeFloatElement_8(this._get_descriptor__48(), index));
  };
  FloatArraySerializer_0.prototype.readElement_24 = function (decoder, index, builder, checkIndex_0) {
    return this.readElement_13(decoder, index, builder instanceof FloatArrayBuilder ? builder : THROW_CCE(), checkIndex_0);
  };
  FloatArraySerializer_0.prototype.writeContent_4 = function (encoder, content, size_0) {
    var inductionVariable = 0;
    if (inductionVariable < size_0)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        encoder.encodeFloatElement_1(this._get_descriptor__48(), i, content[i]);
      }
       while (inductionVariable < size_0);
  };
  FloatArraySerializer_0.prototype.writeContent_15 = function (encoder, content, size_0) {
    return this.writeContent_4(encoder, (!(content == null) ? isFloatArray(content) : false) ? content : THROW_CCE(), size_0);
  };
  FloatArraySerializer_0.$metadata$ = {
    simpleName: 'FloatArraySerializer',
    kind: 'object',
    interfaces: [KSerializer]
  };
  var FloatArraySerializer_instance;
  function FloatArraySerializer_getInstance() {
    if (FloatArraySerializer_instance == null)
      new FloatArraySerializer_0();
    return FloatArraySerializer_instance;
  }
  function LongArraySerializer_0() {
    LongArraySerializer_instance = this;
    PrimitiveArraySerializer.call(this, serializer_6(Companion_getInstance_15()));
  }
  LongArraySerializer_0.prototype.collectionSize_20 = function (_this__0) {
    return _this__0.length;
  };
  LongArraySerializer_0.prototype.collectionSize_29 = function (_this__0) {
    return this.collectionSize_20((!(_this__0 == null) ? isLongArray(_this__0) : false) ? _this__0 : THROW_CCE());
  };
  LongArraySerializer_0.prototype.toBuilder_21 = function (_this__0) {
    return new LongArrayBuilder(_this__0);
  };
  LongArraySerializer_0.prototype.toBuilder_30 = function (_this__0) {
    return this.toBuilder_21((!(_this__0 == null) ? isLongArray(_this__0) : false) ? _this__0 : THROW_CCE());
  };
  LongArraySerializer_0.prototype.empty_7 = function () {
    return longArray(0);
  };
  LongArraySerializer_0.prototype.readElement_15 = function (decoder, index, builder, checkIndex_0) {
    builder.append_11(decoder.decodeLongElement_8(this._get_descriptor__48(), index));
  };
  LongArraySerializer_0.prototype.readElement_24 = function (decoder, index, builder, checkIndex_0) {
    return this.readElement_15(decoder, index, builder instanceof LongArrayBuilder ? builder : THROW_CCE(), checkIndex_0);
  };
  LongArraySerializer_0.prototype.writeContent_6 = function (encoder, content, size_0) {
    var inductionVariable = 0;
    if (inductionVariable < size_0)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        encoder.encodeLongElement_1(this._get_descriptor__48(), i, content[i]);
      }
       while (inductionVariable < size_0);
  };
  LongArraySerializer_0.prototype.writeContent_15 = function (encoder, content, size_0) {
    return this.writeContent_6(encoder, (!(content == null) ? isLongArray(content) : false) ? content : THROW_CCE(), size_0);
  };
  LongArraySerializer_0.$metadata$ = {
    simpleName: 'LongArraySerializer',
    kind: 'object',
    interfaces: [KSerializer]
  };
  var LongArraySerializer_instance;
  function LongArraySerializer_getInstance() {
    if (LongArraySerializer_instance == null)
      new LongArraySerializer_0();
    return LongArraySerializer_instance;
  }
  function IntArraySerializer_0() {
    IntArraySerializer_instance = this;
    PrimitiveArraySerializer.call(this, serializer_7(IntCompanionObject_getInstance()));
  }
  IntArraySerializer_0.prototype.collectionSize_22 = function (_this__0) {
    return _this__0.length;
  };
  IntArraySerializer_0.prototype.collectionSize_29 = function (_this__0) {
    return this.collectionSize_22((!(_this__0 == null) ? isIntArray(_this__0) : false) ? _this__0 : THROW_CCE());
  };
  IntArraySerializer_0.prototype.toBuilder_23 = function (_this__0) {
    return new IntArrayBuilder(_this__0);
  };
  IntArraySerializer_0.prototype.toBuilder_30 = function (_this__0) {
    return this.toBuilder_23((!(_this__0 == null) ? isIntArray(_this__0) : false) ? _this__0 : THROW_CCE());
  };
  IntArraySerializer_0.prototype.empty_7 = function () {
    return new Int32Array(0);
  };
  IntArraySerializer_0.prototype.readElement_17 = function (decoder, index, builder, checkIndex_0) {
    builder.append_12(decoder.decodeIntElement_8(this._get_descriptor__48(), index));
  };
  IntArraySerializer_0.prototype.readElement_24 = function (decoder, index, builder, checkIndex_0) {
    return this.readElement_17(decoder, index, builder instanceof IntArrayBuilder ? builder : THROW_CCE(), checkIndex_0);
  };
  IntArraySerializer_0.prototype.writeContent_8 = function (encoder, content, size_0) {
    var inductionVariable = 0;
    if (inductionVariable < size_0)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        encoder.encodeIntElement_1(this._get_descriptor__48(), i, content[i]);
      }
       while (inductionVariable < size_0);
  };
  IntArraySerializer_0.prototype.writeContent_15 = function (encoder, content, size_0) {
    return this.writeContent_8(encoder, (!(content == null) ? isIntArray(content) : false) ? content : THROW_CCE(), size_0);
  };
  IntArraySerializer_0.$metadata$ = {
    simpleName: 'IntArraySerializer',
    kind: 'object',
    interfaces: [KSerializer]
  };
  var IntArraySerializer_instance;
  function IntArraySerializer_getInstance() {
    if (IntArraySerializer_instance == null)
      new IntArraySerializer_0();
    return IntArraySerializer_instance;
  }
  function ShortArraySerializer_0() {
    ShortArraySerializer_instance = this;
    PrimitiveArraySerializer.call(this, serializer_8(ShortCompanionObject_getInstance()));
  }
  ShortArraySerializer_0.prototype.collectionSize_24 = function (_this__0) {
    return _this__0.length;
  };
  ShortArraySerializer_0.prototype.collectionSize_29 = function (_this__0) {
    return this.collectionSize_24((!(_this__0 == null) ? isShortArray(_this__0) : false) ? _this__0 : THROW_CCE());
  };
  ShortArraySerializer_0.prototype.toBuilder_25 = function (_this__0) {
    return new ShortArrayBuilder(_this__0);
  };
  ShortArraySerializer_0.prototype.toBuilder_30 = function (_this__0) {
    return this.toBuilder_25((!(_this__0 == null) ? isShortArray(_this__0) : false) ? _this__0 : THROW_CCE());
  };
  ShortArraySerializer_0.prototype.empty_7 = function () {
    return new Int16Array(0);
  };
  ShortArraySerializer_0.prototype.readElement_19 = function (decoder, index, builder, checkIndex_0) {
    builder.append_13(decoder.decodeShortElement_8(this._get_descriptor__48(), index));
  };
  ShortArraySerializer_0.prototype.readElement_24 = function (decoder, index, builder, checkIndex_0) {
    return this.readElement_19(decoder, index, builder instanceof ShortArrayBuilder ? builder : THROW_CCE(), checkIndex_0);
  };
  ShortArraySerializer_0.prototype.writeContent_10 = function (encoder, content, size_0) {
    var inductionVariable = 0;
    if (inductionVariable < size_0)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        encoder.encodeShortElement_1(this._get_descriptor__48(), i, content[i]);
      }
       while (inductionVariable < size_0);
  };
  ShortArraySerializer_0.prototype.writeContent_15 = function (encoder, content, size_0) {
    return this.writeContent_10(encoder, (!(content == null) ? isShortArray(content) : false) ? content : THROW_CCE(), size_0);
  };
  ShortArraySerializer_0.$metadata$ = {
    simpleName: 'ShortArraySerializer',
    kind: 'object',
    interfaces: [KSerializer]
  };
  var ShortArraySerializer_instance;
  function ShortArraySerializer_getInstance() {
    if (ShortArraySerializer_instance == null)
      new ShortArraySerializer_0();
    return ShortArraySerializer_instance;
  }
  function ByteArraySerializer_0() {
    ByteArraySerializer_instance = this;
    PrimitiveArraySerializer.call(this, serializer_9(ByteCompanionObject_getInstance()));
  }
  ByteArraySerializer_0.prototype.collectionSize_26 = function (_this__0) {
    return _this__0.length;
  };
  ByteArraySerializer_0.prototype.collectionSize_29 = function (_this__0) {
    return this.collectionSize_26((!(_this__0 == null) ? isByteArray(_this__0) : false) ? _this__0 : THROW_CCE());
  };
  ByteArraySerializer_0.prototype.toBuilder_27 = function (_this__0) {
    return new ByteArrayBuilder(_this__0);
  };
  ByteArraySerializer_0.prototype.toBuilder_30 = function (_this__0) {
    return this.toBuilder_27((!(_this__0 == null) ? isByteArray(_this__0) : false) ? _this__0 : THROW_CCE());
  };
  ByteArraySerializer_0.prototype.empty_7 = function () {
    return new Int8Array(0);
  };
  ByteArraySerializer_0.prototype.readElement_21 = function (decoder, index, builder, checkIndex_0) {
    builder.append_14(decoder.decodeByteElement_8(this._get_descriptor__48(), index));
  };
  ByteArraySerializer_0.prototype.readElement_24 = function (decoder, index, builder, checkIndex_0) {
    return this.readElement_21(decoder, index, builder instanceof ByteArrayBuilder ? builder : THROW_CCE(), checkIndex_0);
  };
  ByteArraySerializer_0.prototype.writeContent_12 = function (encoder, content, size_0) {
    var inductionVariable = 0;
    if (inductionVariable < size_0)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        encoder.encodeByteElement_1(this._get_descriptor__48(), i, content[i]);
      }
       while (inductionVariable < size_0);
  };
  ByteArraySerializer_0.prototype.writeContent_15 = function (encoder, content, size_0) {
    return this.writeContent_12(encoder, (!(content == null) ? isByteArray(content) : false) ? content : THROW_CCE(), size_0);
  };
  ByteArraySerializer_0.$metadata$ = {
    simpleName: 'ByteArraySerializer',
    kind: 'object',
    interfaces: [KSerializer]
  };
  var ByteArraySerializer_instance;
  function ByteArraySerializer_getInstance() {
    if (ByteArraySerializer_instance == null)
      new ByteArraySerializer_0();
    return ByteArraySerializer_instance;
  }
  function BooleanArraySerializer_0() {
    BooleanArraySerializer_instance = this;
    PrimitiveArraySerializer.call(this, serializer_10(BooleanCompanionObject_getInstance()));
  }
  BooleanArraySerializer_0.prototype.collectionSize_28 = function (_this__0) {
    return _this__0.length;
  };
  BooleanArraySerializer_0.prototype.collectionSize_29 = function (_this__0) {
    return this.collectionSize_28((!(_this__0 == null) ? isBooleanArray(_this__0) : false) ? _this__0 : THROW_CCE());
  };
  BooleanArraySerializer_0.prototype.toBuilder_29 = function (_this__0) {
    return new BooleanArrayBuilder(_this__0);
  };
  BooleanArraySerializer_0.prototype.toBuilder_30 = function (_this__0) {
    return this.toBuilder_29((!(_this__0 == null) ? isBooleanArray(_this__0) : false) ? _this__0 : THROW_CCE());
  };
  BooleanArraySerializer_0.prototype.empty_7 = function () {
    return booleanArray(0);
  };
  BooleanArraySerializer_0.prototype.readElement_23 = function (decoder, index, builder, checkIndex_0) {
    builder.append_15(decoder.decodeBooleanElement_8(this._get_descriptor__48(), index));
  };
  BooleanArraySerializer_0.prototype.readElement_24 = function (decoder, index, builder, checkIndex_0) {
    return this.readElement_23(decoder, index, builder instanceof BooleanArrayBuilder ? builder : THROW_CCE(), checkIndex_0);
  };
  BooleanArraySerializer_0.prototype.writeContent_14 = function (encoder, content, size_0) {
    var inductionVariable = 0;
    if (inductionVariable < size_0)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        encoder.encodeBooleanElement_1(this._get_descriptor__48(), i, content[i]);
      }
       while (inductionVariable < size_0);
  };
  BooleanArraySerializer_0.prototype.writeContent_15 = function (encoder, content, size_0) {
    return this.writeContent_14(encoder, (!(content == null) ? isBooleanArray(content) : false) ? content : THROW_CCE(), size_0);
  };
  BooleanArraySerializer_0.$metadata$ = {
    simpleName: 'BooleanArraySerializer',
    kind: 'object',
    interfaces: [KSerializer]
  };
  var BooleanArraySerializer_instance;
  function BooleanArraySerializer_getInstance() {
    if (BooleanArraySerializer_instance == null)
      new BooleanArraySerializer_0();
    return BooleanArraySerializer_instance;
  }
  function CharArrayBuilder(bufferWithData) {
    PrimitiveArrayBuilder.call(this);
    this._buffer = bufferWithData;
    this._position = bufferWithData.length;
    this.ensureCapacity_8(10);
  }
  CharArrayBuilder.prototype._get_position__7 = function () {
    return this._position;
  };
  CharArrayBuilder.prototype.ensureCapacity_8 = function (requiredCapacity) {
    if (this._buffer.length < requiredCapacity)
      this._buffer = copyOf(this._buffer, coerceAtLeast(requiredCapacity, imul(this._buffer.length, 2)));
  };
  CharArrayBuilder.prototype.append_8 = function (c) {
    this.ensureCapacity$default_7(0, 1, null);
    var tmp = this._buffer;
    var tmp0_this = this;
    var tmp1 = tmp0_this._position;
    tmp0_this._position = tmp1 + 1 | 0;
    tmp[tmp1] = c;
  };
  CharArrayBuilder.prototype.build_16 = function () {
    return copyOf(this._buffer, this._position);
  };
  CharArrayBuilder.$metadata$ = {
    simpleName: 'CharArrayBuilder',
    kind: 'class',
    interfaces: []
  };
  function DoubleArrayBuilder(bufferWithData) {
    PrimitiveArrayBuilder.call(this);
    this._buffer_0 = bufferWithData;
    this._position_0 = bufferWithData.length;
    this.ensureCapacity_8(10);
  }
  DoubleArrayBuilder.prototype._get_position__7 = function () {
    return this._position_0;
  };
  DoubleArrayBuilder.prototype.ensureCapacity_8 = function (requiredCapacity) {
    if (this._buffer_0.length < requiredCapacity)
      this._buffer_0 = copyOf_0(this._buffer_0, coerceAtLeast(requiredCapacity, imul(this._buffer_0.length, 2)));
  };
  DoubleArrayBuilder.prototype.append_9 = function (c) {
    this.ensureCapacity$default_7(0, 1, null);
    var tmp = this._buffer_0;
    var tmp0_this = this;
    var tmp1 = tmp0_this._position_0;
    tmp0_this._position_0 = tmp1 + 1 | 0;
    tmp[tmp1] = c;
  };
  DoubleArrayBuilder.prototype.build_16 = function () {
    return copyOf_0(this._buffer_0, this._position_0);
  };
  DoubleArrayBuilder.$metadata$ = {
    simpleName: 'DoubleArrayBuilder',
    kind: 'class',
    interfaces: []
  };
  function FloatArrayBuilder(bufferWithData) {
    PrimitiveArrayBuilder.call(this);
    this._buffer_1 = bufferWithData;
    this._position_1 = bufferWithData.length;
    this.ensureCapacity_8(10);
  }
  FloatArrayBuilder.prototype._get_position__7 = function () {
    return this._position_1;
  };
  FloatArrayBuilder.prototype.ensureCapacity_8 = function (requiredCapacity) {
    if (this._buffer_1.length < requiredCapacity)
      this._buffer_1 = copyOf_1(this._buffer_1, coerceAtLeast(requiredCapacity, imul(this._buffer_1.length, 2)));
  };
  FloatArrayBuilder.prototype.append_10 = function (c) {
    this.ensureCapacity$default_7(0, 1, null);
    var tmp = this._buffer_1;
    var tmp0_this = this;
    var tmp1 = tmp0_this._position_1;
    tmp0_this._position_1 = tmp1 + 1 | 0;
    tmp[tmp1] = c;
  };
  FloatArrayBuilder.prototype.build_16 = function () {
    return copyOf_1(this._buffer_1, this._position_1);
  };
  FloatArrayBuilder.$metadata$ = {
    simpleName: 'FloatArrayBuilder',
    kind: 'class',
    interfaces: []
  };
  function LongArrayBuilder(bufferWithData) {
    PrimitiveArrayBuilder.call(this);
    this._buffer_2 = bufferWithData;
    this._position_2 = bufferWithData.length;
    this.ensureCapacity_8(10);
  }
  LongArrayBuilder.prototype._get_position__7 = function () {
    return this._position_2;
  };
  LongArrayBuilder.prototype.ensureCapacity_8 = function (requiredCapacity) {
    if (this._buffer_2.length < requiredCapacity)
      this._buffer_2 = copyOf_2(this._buffer_2, coerceAtLeast(requiredCapacity, imul(this._buffer_2.length, 2)));
  };
  LongArrayBuilder.prototype.append_11 = function (c) {
    this.ensureCapacity$default_7(0, 1, null);
    var tmp = this._buffer_2;
    var tmp0_this = this;
    var tmp1 = tmp0_this._position_2;
    tmp0_this._position_2 = tmp1 + 1 | 0;
    tmp[tmp1] = c;
  };
  LongArrayBuilder.prototype.build_16 = function () {
    return copyOf_2(this._buffer_2, this._position_2);
  };
  LongArrayBuilder.$metadata$ = {
    simpleName: 'LongArrayBuilder',
    kind: 'class',
    interfaces: []
  };
  function IntArrayBuilder(bufferWithData) {
    PrimitiveArrayBuilder.call(this);
    this._buffer_3 = bufferWithData;
    this._position_3 = bufferWithData.length;
    this.ensureCapacity_8(10);
  }
  IntArrayBuilder.prototype._get_position__7 = function () {
    return this._position_3;
  };
  IntArrayBuilder.prototype.ensureCapacity_8 = function (requiredCapacity) {
    if (this._buffer_3.length < requiredCapacity)
      this._buffer_3 = copyOf_3(this._buffer_3, coerceAtLeast(requiredCapacity, imul(this._buffer_3.length, 2)));
  };
  IntArrayBuilder.prototype.append_12 = function (c) {
    this.ensureCapacity$default_7(0, 1, null);
    var tmp = this._buffer_3;
    var tmp0_this = this;
    var tmp1 = tmp0_this._position_3;
    tmp0_this._position_3 = tmp1 + 1 | 0;
    tmp[tmp1] = c;
  };
  IntArrayBuilder.prototype.build_16 = function () {
    return copyOf_3(this._buffer_3, this._position_3);
  };
  IntArrayBuilder.$metadata$ = {
    simpleName: 'IntArrayBuilder',
    kind: 'class',
    interfaces: []
  };
  function ShortArrayBuilder(bufferWithData) {
    PrimitiveArrayBuilder.call(this);
    this._buffer_4 = bufferWithData;
    this._position_4 = bufferWithData.length;
    this.ensureCapacity_8(10);
  }
  ShortArrayBuilder.prototype._get_position__7 = function () {
    return this._position_4;
  };
  ShortArrayBuilder.prototype.ensureCapacity_8 = function (requiredCapacity) {
    if (this._buffer_4.length < requiredCapacity)
      this._buffer_4 = copyOf_4(this._buffer_4, coerceAtLeast(requiredCapacity, imul(this._buffer_4.length, 2)));
  };
  ShortArrayBuilder.prototype.append_13 = function (c) {
    this.ensureCapacity$default_7(0, 1, null);
    var tmp = this._buffer_4;
    var tmp0_this = this;
    var tmp1 = tmp0_this._position_4;
    tmp0_this._position_4 = tmp1 + 1 | 0;
    tmp[tmp1] = c;
  };
  ShortArrayBuilder.prototype.build_16 = function () {
    return copyOf_4(this._buffer_4, this._position_4);
  };
  ShortArrayBuilder.$metadata$ = {
    simpleName: 'ShortArrayBuilder',
    kind: 'class',
    interfaces: []
  };
  function ByteArrayBuilder(bufferWithData) {
    PrimitiveArrayBuilder.call(this);
    this._buffer_5 = bufferWithData;
    this._position_5 = bufferWithData.length;
    this.ensureCapacity_8(10);
  }
  ByteArrayBuilder.prototype._get_position__7 = function () {
    return this._position_5;
  };
  ByteArrayBuilder.prototype.ensureCapacity_8 = function (requiredCapacity) {
    if (this._buffer_5.length < requiredCapacity)
      this._buffer_5 = copyOf_5(this._buffer_5, coerceAtLeast(requiredCapacity, imul(this._buffer_5.length, 2)));
  };
  ByteArrayBuilder.prototype.append_14 = function (c) {
    this.ensureCapacity$default_7(0, 1, null);
    var tmp = this._buffer_5;
    var tmp0_this = this;
    var tmp1 = tmp0_this._position_5;
    tmp0_this._position_5 = tmp1 + 1 | 0;
    tmp[tmp1] = c;
  };
  ByteArrayBuilder.prototype.build_16 = function () {
    return copyOf_5(this._buffer_5, this._position_5);
  };
  ByteArrayBuilder.$metadata$ = {
    simpleName: 'ByteArrayBuilder',
    kind: 'class',
    interfaces: []
  };
  function BooleanArrayBuilder(bufferWithData) {
    PrimitiveArrayBuilder.call(this);
    this._buffer_6 = bufferWithData;
    this._position_6 = bufferWithData.length;
    this.ensureCapacity_8(10);
  }
  BooleanArrayBuilder.prototype._get_position__7 = function () {
    return this._position_6;
  };
  BooleanArrayBuilder.prototype.ensureCapacity_8 = function (requiredCapacity) {
    if (this._buffer_6.length < requiredCapacity)
      this._buffer_6 = copyOf_6(this._buffer_6, coerceAtLeast(requiredCapacity, imul(this._buffer_6.length, 2)));
  };
  BooleanArrayBuilder.prototype.append_15 = function (c) {
    this.ensureCapacity$default_7(0, 1, null);
    var tmp = this._buffer_6;
    var tmp0_this = this;
    var tmp1 = tmp0_this._position_6;
    tmp0_this._position_6 = tmp1 + 1 | 0;
    tmp[tmp1] = c;
  };
  BooleanArrayBuilder.prototype.build_16 = function () {
    return copyOf_6(this._buffer_6, this._position_6);
  };
  BooleanArrayBuilder.$metadata$ = {
    simpleName: 'BooleanArrayBuilder',
    kind: 'class',
    interfaces: []
  };
  var BUILTIN_SERIALIZERS;
  function StringSerializer() {
    StringSerializer_instance = this;
    this._descriptor_12 = new PrimitiveSerialDescriptor_0('kotlin.String', STRING_getInstance());
  }
  StringSerializer.prototype._get_descriptor__48 = function () {
    return this._descriptor_12;
  };
  StringSerializer.prototype.serialize_35 = function (encoder, value) {
    return encoder.encodeString_1(value);
  };
  StringSerializer.prototype.serialize_76 = function (encoder, value) {
    return this.serialize_35(encoder, (!(value == null) ? typeof value === 'string' : false) ? value : THROW_CCE());
  };
  StringSerializer.prototype.deserialize_52 = function (decoder) {
    return decoder.decodeString_8();
  };
  StringSerializer.$metadata$ = {
    simpleName: 'StringSerializer',
    kind: 'object',
    interfaces: [KSerializer]
  };
  var StringSerializer_instance;
  function StringSerializer_getInstance() {
    if (StringSerializer_instance == null)
      new StringSerializer();
    return StringSerializer_instance;
  }
  function CharSerializer() {
    CharSerializer_instance = this;
    this._descriptor_13 = new PrimitiveSerialDescriptor_0('kotlin.Char', CHAR_getInstance());
  }
  CharSerializer.prototype._get_descriptor__48 = function () {
    return this._descriptor_13;
  };
  CharSerializer.prototype.serialize_37 = function (encoder, value) {
    return encoder.encodeChar_1(value);
  };
  CharSerializer.prototype.serialize_76 = function (encoder, value) {
    return this.serialize_37(encoder, value instanceof Char ? value : THROW_CCE());
  };
  CharSerializer.prototype.deserialize_52 = function (decoder) {
    return decoder.decodeChar_8();
  };
  CharSerializer.$metadata$ = {
    simpleName: 'CharSerializer',
    kind: 'object',
    interfaces: [KSerializer]
  };
  var CharSerializer_instance;
  function CharSerializer_getInstance() {
    if (CharSerializer_instance == null)
      new CharSerializer();
    return CharSerializer_instance;
  }
  function DoubleSerializer() {
    DoubleSerializer_instance = this;
    this._descriptor_14 = new PrimitiveSerialDescriptor_0('kotlin.Double', DOUBLE_getInstance());
  }
  DoubleSerializer.prototype._get_descriptor__48 = function () {
    return this._descriptor_14;
  };
  DoubleSerializer.prototype.serialize_39 = function (encoder, value) {
    return encoder.encodeDouble_1(value);
  };
  DoubleSerializer.prototype.serialize_76 = function (encoder, value) {
    return this.serialize_39(encoder, (!(value == null) ? typeof value === 'number' : false) ? value : THROW_CCE());
  };
  DoubleSerializer.prototype.deserialize_52 = function (decoder) {
    return decoder.decodeDouble_8();
  };
  DoubleSerializer.$metadata$ = {
    simpleName: 'DoubleSerializer',
    kind: 'object',
    interfaces: [KSerializer]
  };
  var DoubleSerializer_instance;
  function DoubleSerializer_getInstance() {
    if (DoubleSerializer_instance == null)
      new DoubleSerializer();
    return DoubleSerializer_instance;
  }
  function FloatSerializer() {
    FloatSerializer_instance = this;
    this._descriptor_15 = new PrimitiveSerialDescriptor_0('kotlin.Float', FLOAT_getInstance());
  }
  FloatSerializer.prototype._get_descriptor__48 = function () {
    return this._descriptor_15;
  };
  FloatSerializer.prototype.serialize_41 = function (encoder, value) {
    return encoder.encodeFloat_1(value);
  };
  FloatSerializer.prototype.serialize_76 = function (encoder, value) {
    return this.serialize_41(encoder, (!(value == null) ? typeof value === 'number' : false) ? value : THROW_CCE());
  };
  FloatSerializer.prototype.deserialize_52 = function (decoder) {
    return decoder.decodeFloat_8();
  };
  FloatSerializer.$metadata$ = {
    simpleName: 'FloatSerializer',
    kind: 'object',
    interfaces: [KSerializer]
  };
  var FloatSerializer_instance;
  function FloatSerializer_getInstance() {
    if (FloatSerializer_instance == null)
      new FloatSerializer();
    return FloatSerializer_instance;
  }
  function LongSerializer() {
    LongSerializer_instance = this;
    this._descriptor_16 = new PrimitiveSerialDescriptor_0('kotlin.Long', LONG_getInstance());
  }
  LongSerializer.prototype._get_descriptor__48 = function () {
    return this._descriptor_16;
  };
  LongSerializer.prototype.serialize_43 = function (encoder, value) {
    return encoder.encodeLong_1(value);
  };
  LongSerializer.prototype.serialize_76 = function (encoder, value) {
    return this.serialize_43(encoder, value instanceof Long ? value : THROW_CCE());
  };
  LongSerializer.prototype.deserialize_52 = function (decoder) {
    return decoder.decodeLong_8();
  };
  LongSerializer.$metadata$ = {
    simpleName: 'LongSerializer',
    kind: 'object',
    interfaces: [KSerializer]
  };
  var LongSerializer_instance;
  function LongSerializer_getInstance() {
    if (LongSerializer_instance == null)
      new LongSerializer();
    return LongSerializer_instance;
  }
  function IntSerializer() {
    IntSerializer_instance = this;
    this._descriptor_17 = new PrimitiveSerialDescriptor_0('kotlin.Int', INT_getInstance());
  }
  IntSerializer.prototype._get_descriptor__48 = function () {
    return this._descriptor_17;
  };
  IntSerializer.prototype.serialize_45 = function (encoder, value) {
    return encoder.encodeInt_1(value);
  };
  IntSerializer.prototype.serialize_76 = function (encoder, value) {
    return this.serialize_45(encoder, (!(value == null) ? typeof value === 'number' : false) ? value : THROW_CCE());
  };
  IntSerializer.prototype.deserialize_52 = function (decoder) {
    return decoder.decodeInt_8();
  };
  IntSerializer.$metadata$ = {
    simpleName: 'IntSerializer',
    kind: 'object',
    interfaces: [KSerializer]
  };
  var IntSerializer_instance;
  function IntSerializer_getInstance() {
    if (IntSerializer_instance == null)
      new IntSerializer();
    return IntSerializer_instance;
  }
  function ShortSerializer() {
    ShortSerializer_instance = this;
    this._descriptor_18 = new PrimitiveSerialDescriptor_0('kotlin.Short', SHORT_getInstance());
  }
  ShortSerializer.prototype._get_descriptor__48 = function () {
    return this._descriptor_18;
  };
  ShortSerializer.prototype.serialize_47 = function (encoder, value) {
    return encoder.encodeShort_1(value);
  };
  ShortSerializer.prototype.serialize_76 = function (encoder, value) {
    return this.serialize_47(encoder, (!(value == null) ? typeof value === 'number' : false) ? value : THROW_CCE());
  };
  ShortSerializer.prototype.deserialize_52 = function (decoder) {
    return decoder.decodeShort_8();
  };
  ShortSerializer.$metadata$ = {
    simpleName: 'ShortSerializer',
    kind: 'object',
    interfaces: [KSerializer]
  };
  var ShortSerializer_instance;
  function ShortSerializer_getInstance() {
    if (ShortSerializer_instance == null)
      new ShortSerializer();
    return ShortSerializer_instance;
  }
  function ByteSerializer() {
    ByteSerializer_instance = this;
    this._descriptor_19 = new PrimitiveSerialDescriptor_0('kotlin.Byte', BYTE_getInstance());
  }
  ByteSerializer.prototype._get_descriptor__48 = function () {
    return this._descriptor_19;
  };
  ByteSerializer.prototype.serialize_49 = function (encoder, value) {
    return encoder.encodeByte_1(value);
  };
  ByteSerializer.prototype.serialize_76 = function (encoder, value) {
    return this.serialize_49(encoder, (!(value == null) ? typeof value === 'number' : false) ? value : THROW_CCE());
  };
  ByteSerializer.prototype.deserialize_52 = function (decoder) {
    return decoder.decodeByte_8();
  };
  ByteSerializer.$metadata$ = {
    simpleName: 'ByteSerializer',
    kind: 'object',
    interfaces: [KSerializer]
  };
  var ByteSerializer_instance;
  function ByteSerializer_getInstance() {
    if (ByteSerializer_instance == null)
      new ByteSerializer();
    return ByteSerializer_instance;
  }
  function BooleanSerializer() {
    BooleanSerializer_instance = this;
    this._descriptor_20 = new PrimitiveSerialDescriptor_0('kotlin.Boolean', BOOLEAN_getInstance());
  }
  BooleanSerializer.prototype._get_descriptor__48 = function () {
    return this._descriptor_20;
  };
  BooleanSerializer.prototype.serialize_51 = function (encoder, value) {
    return encoder.encodeBoolean_1(value);
  };
  BooleanSerializer.prototype.serialize_76 = function (encoder, value) {
    return this.serialize_51(encoder, (!(value == null) ? typeof value === 'boolean' : false) ? value : THROW_CCE());
  };
  BooleanSerializer.prototype.deserialize_52 = function (decoder) {
    return decoder.decodeBoolean_8();
  };
  BooleanSerializer.$metadata$ = {
    simpleName: 'BooleanSerializer',
    kind: 'object',
    interfaces: [KSerializer]
  };
  var BooleanSerializer_instance;
  function BooleanSerializer_getInstance() {
    if (BooleanSerializer_instance == null)
      new BooleanSerializer();
    return BooleanSerializer_instance;
  }
  function UnitSerializer() {
    UnitSerializer_instance = this;
    this._$$delegate_0 = new ObjectSerializer('kotlin.Unit', Unit_getInstance());
  }
  UnitSerializer.prototype.deserialize_39 = function (decoder) {
    this._$$delegate_0.deserialize_52(decoder);
  };
  UnitSerializer.prototype.deserialize_52 = function (decoder) {
    this.deserialize_39(decoder);
    return Unit_getInstance();
  };
  UnitSerializer.prototype.serialize_53 = function (encoder, value) {
    this._$$delegate_0.serialize_76(encoder, Unit_getInstance());
  };
  UnitSerializer.prototype.serialize_76 = function (encoder, value) {
    return this.serialize_53(encoder, value instanceof Unit ? value : THROW_CCE());
  };
  UnitSerializer.prototype._get_descriptor__48 = function () {
    return this._$$delegate_0._descriptor_11;
  };
  UnitSerializer.$metadata$ = {
    simpleName: 'UnitSerializer',
    kind: 'object',
    interfaces: [KSerializer]
  };
  var UnitSerializer_instance;
  function UnitSerializer_getInstance() {
    if (UnitSerializer_instance == null)
      new UnitSerializer();
    return UnitSerializer_instance;
  }
  function error($this) {
    throw IllegalStateException_init_$Create$('Primitive descriptor does not have elements');
  }
  function PrimitiveSerialDescriptor_0(serialName, kind) {
    this._serialName_5 = serialName;
    this._kind_0 = kind;
  }
  PrimitiveSerialDescriptor_0.prototype._get_serialName__16 = function () {
    return this._serialName_5;
  };
  PrimitiveSerialDescriptor_0.prototype._get_kind__16 = function () {
    return this._kind_0;
  };
  PrimitiveSerialDescriptor_0.prototype._get_elementsCount__16 = function () {
    return 0;
  };
  PrimitiveSerialDescriptor_0.prototype.getElementName_16 = function (index) {
    error(this);
  };
  PrimitiveSerialDescriptor_0.prototype.getElementIndex_16 = function (name) {
    error(this);
  };
  PrimitiveSerialDescriptor_0.prototype.getElementDescriptor_16 = function (index) {
    error(this);
  };
  PrimitiveSerialDescriptor_0.prototype.toString = function () {
    return '' + 'PrimitiveDescriptor(' + this._serialName_5 + ')';
  };
  PrimitiveSerialDescriptor_0.$metadata$ = {
    simpleName: 'PrimitiveSerialDescriptor',
    kind: 'class',
    interfaces: [SerialDescriptor]
  };
  function builtinSerializerOrNull(_this_) {
    var tmp = BUILTIN_SERIALIZERS.get_63(_this_);
    return (tmp == null ? true : isInterface(tmp, KSerializer)) ? tmp : THROW_CCE();
  }
  function PrimitiveDescriptorSafe(serialName, kind) {
    checkName(serialName);
    return new PrimitiveSerialDescriptor_0(serialName, kind);
  }
  function checkName(serialName) {
    var keys = BUILTIN_SERIALIZERS._get_keys__10();
    var tmp0_iterator = keys.iterator_64();
    while (tmp0_iterator.hasNext_31()) {
      var primitive = tmp0_iterator.next_35();
      var simpleName = capitalize(ensureNotNull(primitive._get_simpleName__4()));
      var qualifiedName = '' + 'kotlin.' + simpleName;
      if (equals_0(serialName, qualifiedName, true) ? true : equals_0(serialName, simpleName, true)) {
        throw IllegalArgumentException_init_$Create$_0(trimIndent('' + '\n                The name of serial descriptor should uniquely identify associated serializer.\n                For serial name ' + serialName + ' there already exist ' + capitalize(simpleName) + 'Serializer.\n                Please refer to SerialDescriptor documentation for additional information.\n            '));
      }}
  }
  function NamedValueDecoder() {
    TaggedDecoder.call(this);
  }
  NamedValueDecoder.prototype.getTag_4 = function (_this__0, index) {
    return this.nested_3(this.elementName_3(_this__0, index));
  };
  NamedValueDecoder.prototype.nested_3 = function (nestedName) {
    var tmp0_elvis_lhs = this._get_currentTagOrNull__4();
    return this.composeName_3(tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs, nestedName);
  };
  NamedValueDecoder.prototype.elementName_3 = function (desc, index) {
    return desc.getElementName_16(index);
  };
  NamedValueDecoder.prototype.composeName_3 = function (parentName, childName) {
    var tmp;
    if (charSequenceLength(parentName) === 0) {
      tmp = childName;
    } else {
      {
        tmp = '' + parentName + '.' + childName;
      }
    }
    return tmp;
  };
  NamedValueDecoder.$metadata$ = {
    simpleName: 'NamedValueDecoder',
    kind: 'class',
    interfaces: []
  };
  function tagBlock($this, tag, block) {
    $this.pushTag_0(tag);
    var r = block();
    if (!$this._flag) {
      $this.popTag_4();
      Unit_getInstance();
    }$this._flag = false;
    return r;
  }
  function _no_name_provided__66(this$0, $deserializer, $previousValue) {
    this._this$0_20 = this$0;
    this._$deserializer = $deserializer;
    this._$previousValue = $previousValue;
  }
  _no_name_provided__66.prototype.invoke_540 = function () {
    return this._this$0_20.decodeSerializableValue_17(this._$deserializer, this._$previousValue);
  };
  _no_name_provided__66.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function TaggedDecoder() {
    var tmp = this;
    tmp._tagStack = ArrayList_init_$Create$();
    this._flag = false;
  }
  TaggedDecoder.prototype._get_serializersModule__14 = function () {
    return EmptySerializersModule;
  };
  TaggedDecoder.prototype.decodeTaggedValue_0 = function (tag) {
    throw SerializationException_init_$Create$('' + getKClassFromExpression_0(this) + " can't retrieve untyped values");
  };
  TaggedDecoder.prototype.decodeTaggedNotNullMark_2 = function (tag) {
    return true;
  };
  TaggedDecoder.prototype.decodeTaggedBoolean_2 = function (tag) {
    var tmp = this.decodeTaggedValue_0(tag);
    return typeof tmp === 'boolean' ? tmp : THROW_CCE();
  };
  TaggedDecoder.prototype.decodeTaggedByte_2 = function (tag) {
    var tmp = this.decodeTaggedValue_0(tag);
    return typeof tmp === 'number' ? tmp : THROW_CCE();
  };
  TaggedDecoder.prototype.decodeTaggedShort_2 = function (tag) {
    var tmp = this.decodeTaggedValue_0(tag);
    return typeof tmp === 'number' ? tmp : THROW_CCE();
  };
  TaggedDecoder.prototype.decodeTaggedInt_2 = function (tag) {
    var tmp = this.decodeTaggedValue_0(tag);
    return typeof tmp === 'number' ? tmp : THROW_CCE();
  };
  TaggedDecoder.prototype.decodeTaggedLong_2 = function (tag) {
    var tmp = this.decodeTaggedValue_0(tag);
    return tmp instanceof Long ? tmp : THROW_CCE();
  };
  TaggedDecoder.prototype.decodeTaggedFloat_2 = function (tag) {
    var tmp = this.decodeTaggedValue_0(tag);
    return typeof tmp === 'number' ? tmp : THROW_CCE();
  };
  TaggedDecoder.prototype.decodeTaggedDouble_2 = function (tag) {
    var tmp = this.decodeTaggedValue_0(tag);
    return typeof tmp === 'number' ? tmp : THROW_CCE();
  };
  TaggedDecoder.prototype.decodeTaggedChar_2 = function (tag) {
    var tmp = this.decodeTaggedValue_0(tag);
    return tmp instanceof Char ? tmp : THROW_CCE();
  };
  TaggedDecoder.prototype.decodeTaggedString_2 = function (tag) {
    var tmp = this.decodeTaggedValue_0(tag);
    return typeof tmp === 'string' ? tmp : THROW_CCE();
  };
  TaggedDecoder.prototype.decodeTaggedInline_2 = function (tag, inlineDescriptor) {
    this.pushTag_0(tag);
    return this;
  };
  TaggedDecoder.prototype.decodeSerializableValue_17 = function (deserializer, previousValue) {
    return this.decodeSerializableValue_16(deserializer);
  };
  TaggedDecoder.prototype.decodeInline_8 = function (inlineDescriptor) {
    return this.decodeTaggedInline_2(this.popTag_4(), inlineDescriptor);
  };
  TaggedDecoder.prototype.decodeNotNullMark_8 = function () {
    var tmp0_elvis_lhs = this._get_currentTagOrNull__4();
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return false;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var currentTag = tmp;
    return this.decodeTaggedNotNullMark_2(currentTag);
  };
  TaggedDecoder.prototype.decodeNull_8 = function () {
    return null;
  };
  TaggedDecoder.prototype.decodeBoolean_8 = function () {
    return this.decodeTaggedBoolean_2(this.popTag_4());
  };
  TaggedDecoder.prototype.decodeByte_8 = function () {
    return this.decodeTaggedByte_2(this.popTag_4());
  };
  TaggedDecoder.prototype.decodeShort_8 = function () {
    return this.decodeTaggedShort_2(this.popTag_4());
  };
  TaggedDecoder.prototype.decodeInt_8 = function () {
    return this.decodeTaggedInt_2(this.popTag_4());
  };
  TaggedDecoder.prototype.decodeLong_8 = function () {
    return this.decodeTaggedLong_2(this.popTag_4());
  };
  TaggedDecoder.prototype.decodeFloat_8 = function () {
    return this.decodeTaggedFloat_2(this.popTag_4());
  };
  TaggedDecoder.prototype.decodeDouble_8 = function () {
    return this.decodeTaggedDouble_2(this.popTag_4());
  };
  TaggedDecoder.prototype.decodeChar_8 = function () {
    return this.decodeTaggedChar_2(this.popTag_4());
  };
  TaggedDecoder.prototype.decodeString_8 = function () {
    return this.decodeTaggedString_2(this.popTag_4());
  };
  TaggedDecoder.prototype.beginStructure_11 = function (descriptor) {
    return this;
  };
  TaggedDecoder.prototype.endStructure_11 = function (descriptor) {
  };
  TaggedDecoder.prototype.decodeBooleanElement_8 = function (descriptor, index) {
    return this.decodeTaggedBoolean_2(this.getTag_4(descriptor, index));
  };
  TaggedDecoder.prototype.decodeByteElement_8 = function (descriptor, index) {
    return this.decodeTaggedByte_2(this.getTag_4(descriptor, index));
  };
  TaggedDecoder.prototype.decodeShortElement_8 = function (descriptor, index) {
    return this.decodeTaggedShort_2(this.getTag_4(descriptor, index));
  };
  TaggedDecoder.prototype.decodeIntElement_8 = function (descriptor, index) {
    return this.decodeTaggedInt_2(this.getTag_4(descriptor, index));
  };
  TaggedDecoder.prototype.decodeLongElement_8 = function (descriptor, index) {
    return this.decodeTaggedLong_2(this.getTag_4(descriptor, index));
  };
  TaggedDecoder.prototype.decodeFloatElement_8 = function (descriptor, index) {
    return this.decodeTaggedFloat_2(this.getTag_4(descriptor, index));
  };
  TaggedDecoder.prototype.decodeDoubleElement_8 = function (descriptor, index) {
    return this.decodeTaggedDouble_2(this.getTag_4(descriptor, index));
  };
  TaggedDecoder.prototype.decodeCharElement_8 = function (descriptor, index) {
    return this.decodeTaggedChar_2(this.getTag_4(descriptor, index));
  };
  TaggedDecoder.prototype.decodeStringElement_8 = function (descriptor, index) {
    return this.decodeTaggedString_2(this.getTag_4(descriptor, index));
  };
  TaggedDecoder.prototype.decodeSerializableElement_8 = function (descriptor, index, deserializer, previousValue) {
    var tmp = this.getTag_4(descriptor, index);
    return tagBlock(this, tmp, _no_name_provided_$factory_46(this, deserializer, previousValue));
  };
  TaggedDecoder.prototype._get_currentTagOrNull__4 = function () {
    return lastOrNull(this._tagStack);
  };
  TaggedDecoder.prototype.pushTag_0 = function (name) {
    this._tagStack.add_33(name);
    Unit_getInstance();
  };
  TaggedDecoder.prototype.popTag_4 = function () {
    var r = this._tagStack.removeAt_2(_get_lastIndex__0(this._tagStack));
    this._flag = true;
    return r;
  };
  TaggedDecoder.$metadata$ = {
    simpleName: 'TaggedDecoder',
    kind: 'class',
    interfaces: [Decoder, CompositeDecoder]
  };
  function _no_name_provided_$factory_46(this$0, $deserializer, $previousValue) {
    var i = new _no_name_provided__66(this$0, $deserializer, $previousValue);
    return function () {
      return i.invoke_540();
    };
  }
  var NULL;
  function MapEntry(key, value) {
    this._key_1 = key;
    this._value_3 = value;
  }
  MapEntry.prototype._get_key__47 = function () {
    return this._key_1;
  };
  MapEntry.prototype._get_value__33 = function () {
    return this._value_3;
  };
  MapEntry.prototype.toString = function () {
    return '' + 'MapEntry(key=' + this._key_1 + ', value=' + this._value_3 + ')';
  };
  MapEntry.prototype.hashCode = function () {
    var result = this._key_1 == null ? 0 : hashCode(this._key_1);
    result = imul(result, 31) + (this._value_3 == null ? 0 : hashCode(this._value_3)) | 0;
    return result;
  };
  MapEntry.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof MapEntry))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof MapEntry ? other : THROW_CCE();
    if (!equals_1(this._key_1, tmp0_other_with_cast._key_1))
      return false;
    if (!equals_1(this._value_3, tmp0_other_with_cast._value_3))
      return false;
    return true;
  };
  MapEntry.$metadata$ = {
    simpleName: 'MapEntry',
    kind: 'class',
    interfaces: [Entry]
  };
  function _no_name_provided__67($keySerializer, $valueSerializer) {
    this._$keySerializer = $keySerializer;
    this._$valueSerializer = $valueSerializer;
  }
  _no_name_provided__67.prototype.invoke_101 = function ($this$buildSerialDescriptor) {
    var tmp = this._$keySerializer._get_descriptor__48();
    $this$buildSerialDescriptor.element$default('key', tmp, null, false, 12, null);
    var tmp_0 = this._$valueSerializer._get_descriptor__48();
    $this$buildSerialDescriptor.element$default('value', tmp_0, null, false, 12, null);
  };
  _no_name_provided__67.prototype.invoke_542 = function (p1) {
    this.invoke_101(p1 instanceof ClassSerialDescriptorBuilder ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__67.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function MapEntrySerializer_0(keySerializer, valueSerializer) {
    KeyValueSerializer.call(this, keySerializer, valueSerializer);
    var tmp = this;
    var tmp_0 = MAP_getInstance();
    var tmp_1 = [];
    tmp._descriptor_21 = buildSerialDescriptor$default('kotlin.collections.Map.Entry', tmp_0, tmp_1, _no_name_provided_$factory_47(keySerializer, valueSerializer), 4, null);
  }
  MapEntrySerializer_0.prototype._get_descriptor__48 = function () {
    return this._descriptor_21;
  };
  MapEntrySerializer_0.prototype._get_key__7 = function (_this__0) {
    return _this__0._get_key__47();
  };
  MapEntrySerializer_0.prototype._get_key__11 = function (_this__0) {
    return this._get_key__7((!(_this__0 == null) ? isInterface(_this__0, Entry) : false) ? _this__0 : THROW_CCE());
  };
  MapEntrySerializer_0.prototype._get_value__8 = function (_this__0) {
    return _this__0._get_value__33();
  };
  MapEntrySerializer_0.prototype._get_value__12 = function (_this__0) {
    return this._get_value__8((!(_this__0 == null) ? isInterface(_this__0, Entry) : false) ? _this__0 : THROW_CCE());
  };
  MapEntrySerializer_0.prototype.toResult_25 = function (key, value) {
    return new MapEntry(key, value);
  };
  MapEntrySerializer_0.$metadata$ = {
    simpleName: 'MapEntrySerializer',
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__68($keySerializer, $valueSerializer) {
    this._$keySerializer_0 = $keySerializer;
    this._$valueSerializer_0 = $valueSerializer;
  }
  _no_name_provided__68.prototype.invoke_101 = function ($this$buildClassSerialDescriptor) {
    var tmp = this._$keySerializer_0._get_descriptor__48();
    $this$buildClassSerialDescriptor.element$default('first', tmp, null, false, 12, null);
    var tmp_0 = this._$valueSerializer_0._get_descriptor__48();
    $this$buildClassSerialDescriptor.element$default('second', tmp_0, null, false, 12, null);
  };
  _no_name_provided__68.prototype.invoke_542 = function (p1) {
    this.invoke_101(p1 instanceof ClassSerialDescriptorBuilder ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__68.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function PairSerializer_0(keySerializer, valueSerializer) {
    KeyValueSerializer.call(this, keySerializer, valueSerializer);
    var tmp = this;
    var tmp_0 = [];
    tmp._descriptor_22 = buildClassSerialDescriptor$default('kotlin.Pair', tmp_0, _no_name_provided_$factory_48(keySerializer, valueSerializer), 2, null);
  }
  PairSerializer_0.prototype._get_descriptor__48 = function () {
    return this._descriptor_22;
  };
  PairSerializer_0.prototype._get_key__9 = function (_this__0) {
    return _this__0._first;
  };
  PairSerializer_0.prototype._get_key__11 = function (_this__0) {
    return this._get_key__9(_this__0 instanceof Pair ? _this__0 : THROW_CCE());
  };
  PairSerializer_0.prototype._get_value__10 = function (_this__0) {
    return _this__0._second;
  };
  PairSerializer_0.prototype._get_value__12 = function (_this__0) {
    return this._get_value__10(_this__0 instanceof Pair ? _this__0 : THROW_CCE());
  };
  PairSerializer_0.prototype.toResult_25 = function (key, value) {
    return to(key, value);
  };
  PairSerializer_0.$metadata$ = {
    simpleName: 'PairSerializer',
    kind: 'class',
    interfaces: []
  };
  function decodeSequentially($this, composite) {
    var a = composite.decodeSerializableElement$default_8($this._descriptor_23, 0, $this._aSerializer, null, 8, null);
    var b = composite.decodeSerializableElement$default_8($this._descriptor_23, 1, $this._bSerializer, null, 8, null);
    var c = composite.decodeSerializableElement$default_8($this._descriptor_23, 2, $this._cSerializer, null, 8, null);
    composite.endStructure_11($this._descriptor_23);
    return new Triple(a, b, c);
  }
  function decodeStructure($this, composite) {
    var a = NULL;
    var b = NULL;
    var c = NULL;
    mainLoop: while (true) {
      var index = composite.decodeElementIndex_8($this._descriptor_23);
      switch (index) {
        case -1:
          break mainLoop;
        case 0:
          a = composite.decodeSerializableElement$default_8($this._descriptor_23, 0, $this._aSerializer, null, 8, null);
          break;
        case 1:
          b = composite.decodeSerializableElement$default_8($this._descriptor_23, 1, $this._bSerializer, null, 8, null);
          break;
        case 2:
          c = composite.decodeSerializableElement$default_8($this._descriptor_23, 2, $this._cSerializer, null, 8, null);
          break;
        default:throw SerializationException_init_$Create$('' + 'Unexpected index ' + index);
      }
    }
    composite.endStructure_11($this._descriptor_23);
    if (a === NULL)
      throw SerializationException_init_$Create$("Element 'first' is missing");
    if (b === NULL)
      throw SerializationException_init_$Create$("Element 'second' is missing");
    if (c === NULL)
      throw SerializationException_init_$Create$("Element 'third' is missing");
    var tmp = (a == null ? true : isObject(a)) ? a : THROW_CCE();
    var tmp_0 = (b == null ? true : isObject(b)) ? b : THROW_CCE();
    return new Triple(tmp, tmp_0, (c == null ? true : isObject(c)) ? c : THROW_CCE());
  }
  function _no_name_provided__69(this$0) {
    this._this$0_21 = this$0;
  }
  _no_name_provided__69.prototype.invoke_101 = function ($this$buildClassSerialDescriptor) {
    var tmp = this._this$0_21._aSerializer._get_descriptor__48();
    $this$buildClassSerialDescriptor.element$default('first', tmp, null, false, 12, null);
    var tmp_0 = this._this$0_21._bSerializer._get_descriptor__48();
    $this$buildClassSerialDescriptor.element$default('second', tmp_0, null, false, 12, null);
    var tmp_1 = this._this$0_21._cSerializer._get_descriptor__48();
    $this$buildClassSerialDescriptor.element$default('third', tmp_1, null, false, 12, null);
  };
  _no_name_provided__69.prototype.invoke_542 = function (p1) {
    this.invoke_101(p1 instanceof ClassSerialDescriptorBuilder ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__69.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function TripleSerializer_0(aSerializer, bSerializer, cSerializer) {
    this._aSerializer = aSerializer;
    this._bSerializer = bSerializer;
    this._cSerializer = cSerializer;
    var tmp = this;
    var tmp_0 = [];
    tmp._descriptor_23 = buildClassSerialDescriptor$default('kotlin.Triple', tmp_0, _no_name_provided_$factory_49(this), 2, null);
  }
  TripleSerializer_0.prototype._get_descriptor__48 = function () {
    return this._descriptor_23;
  };
  TripleSerializer_0.prototype.serialize_57 = function (encoder, value) {
    var structuredEncoder = encoder.beginStructure_11(this._descriptor_23);
    structuredEncoder.encodeSerializableElement_1(this._descriptor_23, 0, this._aSerializer, value._first_0);
    structuredEncoder.encodeSerializableElement_1(this._descriptor_23, 1, this._bSerializer, value._second_0);
    structuredEncoder.encodeSerializableElement_1(this._descriptor_23, 2, this._cSerializer, value._third);
    structuredEncoder.endStructure_11(this._descriptor_23);
  };
  TripleSerializer_0.prototype.serialize_76 = function (encoder, value) {
    return this.serialize_57(encoder, value instanceof Triple ? value : THROW_CCE());
  };
  TripleSerializer_0.prototype.deserialize_52 = function (decoder) {
    var composite = decoder.beginStructure_11(this._descriptor_23);
    if (composite.decodeSequentially_8()) {
      return decodeSequentially(this, composite);
    }return decodeStructure(this, composite);
  };
  TripleSerializer_0.$metadata$ = {
    simpleName: 'TripleSerializer',
    kind: 'class',
    interfaces: [KSerializer]
  };
  function KeyValueSerializer(keySerializer, valueSerializer) {
    this._keySerializer_0 = keySerializer;
    this._valueSerializer_0 = valueSerializer;
  }
  KeyValueSerializer.prototype.serialize_59 = function (encoder, value) {
    var structuredEncoder = encoder.beginStructure_11(this._get_descriptor__48());
    structuredEncoder.encodeSerializableElement_1(this._get_descriptor__48(), 0, this._keySerializer_0, this._get_key__11(value));
    structuredEncoder.encodeSerializableElement_1(this._get_descriptor__48(), 1, this._valueSerializer_0, this._get_value__12(value));
    structuredEncoder.endStructure_11(this._get_descriptor__48());
  };
  KeyValueSerializer.prototype.serialize_76 = function (encoder, value) {
    return this.serialize_59(encoder, (value == null ? true : isObject(value)) ? value : THROW_CCE());
  };
  KeyValueSerializer.prototype.deserialize_52 = function (decoder) {
    var composite = decoder.beginStructure_11(this._get_descriptor__48());
    if (composite.decodeSequentially_8()) {
      var tmp = this._get_descriptor__48();
      var key = composite.decodeSerializableElement$default_8(tmp, 0, this._keySerializer_0, null, 8, null);
      var tmp_0 = this._get_descriptor__48();
      var value = composite.decodeSerializableElement$default_8(tmp_0, 1, this._valueSerializer_0, null, 8, null);
      return this.toResult_25(key, value);
    }var key_0 = NULL;
    var value_0 = NULL;
    mainLoop: while (true) {
      var idx = composite.decodeElementIndex_8(this._get_descriptor__48());
      switch (idx) {
        case -1:
          break mainLoop;
        case 0:
          var tmp_1 = this._get_descriptor__48();
          key_0 = composite.decodeSerializableElement$default_8(tmp_1, 0, this._keySerializer_0, null, 8, null);
          break;
        case 1:
          var tmp_2 = this._get_descriptor__48();
          value_0 = composite.decodeSerializableElement$default_8(tmp_2, 1, this._valueSerializer_0, null, 8, null);
          break;
        default:throw SerializationException_init_$Create$('' + 'Invalid index: ' + idx);
      }
    }
    composite.endStructure_11(this._get_descriptor__48());
    if (key_0 === NULL)
      throw SerializationException_init_$Create$("Element 'key' is missing");
    if (value_0 === NULL)
      throw SerializationException_init_$Create$("Element 'value' is missing");
    var tmp_3 = (key_0 == null ? true : isObject(key_0)) ? key_0 : THROW_CCE();
    return this.toResult_25(tmp_3, (value_0 == null ? true : isObject(value_0)) ? value_0 : THROW_CCE());
  };
  KeyValueSerializer.$metadata$ = {
    simpleName: 'KeyValueSerializer',
    kind: 'class',
    interfaces: [KSerializer]
  };
  function _no_name_provided_$factory_47($keySerializer, $valueSerializer) {
    var i = new _no_name_provided__67($keySerializer, $valueSerializer);
    return function (p1) {
      i.invoke_101(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_48($keySerializer, $valueSerializer) {
    var i = new _no_name_provided__68($keySerializer, $valueSerializer);
    return function (p1) {
      i.invoke_101(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_49(this$0) {
    var i = new _no_name_provided__69(this$0);
    return function (p1) {
      i.invoke_101(p1);
      return Unit_getInstance();
    };
  }
  var EmptySerializersModule;
  function SerializersModule() {
  }
  SerializersModule.$metadata$ = {
    simpleName: 'SerializersModule',
    kind: 'class',
    interfaces: []
  };
  function SerialModuleImpl(class2Serializer, polyBase2Serializers, polyBase2NamedSerializers, polyBase2DefaultProvider) {
    SerializersModule.call(this);
    this._class2Serializer = class2Serializer;
    this._polyBase2Serializers = polyBase2Serializers;
    this._polyBase2NamedSerializers = polyBase2NamedSerializers;
    this._polyBase2DefaultProvider = polyBase2DefaultProvider;
  }
  SerialModuleImpl.prototype.getPolymorphic_1 = function (baseClass, value) {
    if (!isInstanceOf(value, baseClass))
      return null;
    var tmp0_safe_receiver = this._polyBase2Serializers.get_63(baseClass);
    var tmp = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.get_63(getKClassFromExpression_0(value));
    return (!(tmp == null) ? isInterface(tmp, SerializationStrategy) : false) ? tmp : null;
  };
  SerialModuleImpl.prototype.getPolymorphic_2 = function (baseClass, serializedClassName) {
    var tmp0_safe_receiver = this._polyBase2NamedSerializers.get_63(baseClass);
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      tmp = ((!(tmp0_safe_receiver == null) ? isInterface(tmp0_safe_receiver, Map_0) : false) ? tmp0_safe_receiver : THROW_CCE()).get_63(serializedClassName);
    }
    var tmp_0 = tmp;
    var registered = (!(tmp_0 == null) ? isInterface(tmp_0, KSerializer) : false) ? tmp_0 : null;
    if (!(registered == null))
      return registered;
    var tmp_1 = this._polyBase2DefaultProvider.get_63(baseClass);
    var tmp1_safe_receiver = (!(tmp_1 == null) ? typeof tmp_1 === 'function' : false) ? tmp_1 : null;
    return tmp1_safe_receiver == null ? null : tmp1_safe_receiver(serializedClassName);
  };
  SerialModuleImpl.prototype.getContextual_0 = function (kclass_0) {
    var tmp = this._class2Serializer.get_63(kclass_0);
    return (!(tmp == null) ? isInterface(tmp, KSerializer) : false) ? tmp : null;
  };
  SerialModuleImpl.prototype.dumpTo_0 = function (collector) {
    var tmp0_forEach_0 = this._class2Serializer;
    var tmp0_iterator_1 = tmp0_forEach_0._get_entries__10().iterator_64();
    while (tmp0_iterator_1.hasNext_31()) {
      var element_2 = tmp0_iterator_1.next_35();
      var kclass_4 = element_2._get_key__47();
      var serial_5 = element_2._get_value__33();
      var tmp = isInterface(kclass_4, KClass) ? kclass_4 : THROW_CCE();
      collector.contextual_0(tmp, isInterface(serial_5, KSerializer) ? serial_5 : THROW_CCE());
    }
    var tmp1_forEach_0 = this._polyBase2Serializers;
    var tmp0_iterator_1_0 = tmp1_forEach_0._get_entries__10().iterator_64();
    while (tmp0_iterator_1_0.hasNext_31()) {
      var element_2_0 = tmp0_iterator_1_0.next_35();
      var baseClass_4 = element_2_0._get_key__47();
      var classMap_5 = element_2_0._get_value__33();
      var tmp0_iterator_1_6 = classMap_5._get_entries__10().iterator_64();
      while (tmp0_iterator_1_6.hasNext_31()) {
        var element_2_7 = tmp0_iterator_1_6.next_35();
        var actualClass_4_8 = element_2_7._get_key__47();
        var serializer_5_9 = element_2_7._get_value__33();
        var tmp_0 = isInterface(baseClass_4, KClass) ? baseClass_4 : THROW_CCE();
        var tmp_1 = isInterface(actualClass_4_8, KClass) ? actualClass_4_8 : THROW_CCE();
        collector.polymorphic_0(tmp_0, tmp_1, isInterface(serializer_5_9, KSerializer) ? serializer_5_9 : THROW_CCE());
      }
    }
    var tmp2_forEach_0 = this._polyBase2DefaultProvider;
    var tmp0_iterator_1_1 = tmp2_forEach_0._get_entries__10().iterator_64();
    while (tmp0_iterator_1_1.hasNext_31()) {
      var element_2_1 = tmp0_iterator_1_1.next_35();
      var baseClass_4_0 = element_2_1._get_key__47();
      var provider_5 = element_2_1._get_value__33();
      var tmp_2 = isInterface(baseClass_4_0, KClass) ? baseClass_4_0 : THROW_CCE();
      collector.polymorphicDefault_0(tmp_2, typeof provider_5 === 'function' ? provider_5 : THROW_CCE());
    }
  };
  SerialModuleImpl.$metadata$ = {
    simpleName: 'SerialModuleImpl',
    kind: 'class',
    interfaces: []
  };
  function SerializersModuleCollector() {
  }
  SerializersModuleCollector.$metadata$ = {
    simpleName: 'SerializersModuleCollector',
    kind: 'interface',
    interfaces: []
  };
  function SerializableWith() {
  }
  SerializableWith.$metadata$ = {
    simpleName: 'SerializableWith',
    kind: 'class',
    interfaces: [Annotation],
    associatedObjectKey: 0
  };
  function isInstanceOf(_this_, kclass_0) {
    return kclass_0.isInstance_4(_this_);
  }
  function getChecked(_this_, index) {
    if (!(0 <= index ? index <= (_this_.length - 1 | 0) : false))
      throw IndexOutOfBoundsException_init_$Create$_0('' + 'Index ' + index + ' out of bounds ' + _get_indices_(_this_));
    return _this_[index];
  }
  function platformSpecificSerializerNotRegistered(_this_) {
    throw SerializationException_init_$Create$('' + "Serializer for class '" + _this_._get_simpleName__4() + "' is not found.\n" + 'Mark the class as @Serializable or provide the serializer explicitly.\n' + 'On Kotlin/JS explicitly declared serializer should be used for interfaces and enums without @Serializable annotation');
  }
  function compiledSerializerImpl(_this_) {
    var tmp1_elvis_lhs = constructSerializerForGivenTypeArgs(_this_, []);
    var tmp;
    if (tmp1_elvis_lhs == null) {
      var tmp0_asDynamic_0 = _get_js_(_this_);
      var tmp0_safe_receiver = tmp0_asDynamic_0.Companion;
      var tmp_0 = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.serializer();
      tmp = (!(tmp_0 == null) ? isInterface(tmp_0, KSerializer) : false) ? tmp_0 : null;
    } else {
      tmp = tmp1_elvis_lhs;
    }
    return tmp;
  }
  function isReferenceArray(rootClass) {
    return rootClass.equals(PrimitiveClasses_getInstance()._get_arrayClass_());
  }
  function constructSerializerForGivenTypeArgs(_this_, args) {
    var tmp;
    try {
      var assocObject = findAssociatedObject(_this_, getKClass_0(SerializableWith));
      var tmp_0;
      if (!(assocObject == null) ? isInterface(assocObject, KSerializer) : false) {
        tmp_0 = (!(assocObject == null) ? isInterface(assocObject, KSerializer) : false) ? assocObject : THROW_CCE();
      } else {
        if (!(assocObject == null) ? isInterface(assocObject, SerializerFactory) : false) {
          var tmp_1 = assocObject.serializer(args.slice());
          tmp_0 = isInterface(tmp_1, KSerializer) ? tmp_1 : THROW_CCE();
        } else {
          {
            tmp_0 = null;
          }
        }
      }
      tmp = tmp_0;
    } catch ($p) {
      var tmp_2;
      {
        tmp_2 = null;
      }
      tmp = tmp_2;
    }
    return tmp;
  }
  function toNativeArrayImpl(_this_, eClass) {
    return copyToArray_0(_this_);
  }
  function Default_0() {
    Default_instance_0 = this;
    Json_0.call(this, JsonConf_init_$Create$(false, false, false, false, false, null, false, false, null, false, null, 2047, null));
  }
  Default_0.$metadata$ = {
    simpleName: 'Default',
    kind: 'object',
    interfaces: []
  };
  var Default_instance_0;
  function Default_getInstance_0() {
    if (Default_instance_0 == null)
      new Default_0();
    return Default_instance_0;
  }
  function Json_0(configuration) {
    Default_getInstance_0();
    this._configuration = configuration;
  }
  Json_0.prototype._get_configuration__3 = function () {
    return this._configuration;
  };
  Json_0.prototype._get_serializersModule__14 = function () {
    return this._configuration._serializersModule_0;
  };
  Json_0.prototype.encodeToString_1 = function (serializer_16, value) {
    var result = StringBuilder_init_$Create$_0();
    var tmp = WriteMode_OBJ_getInstance();
    var tmp0_arrayOfNulls_0 = values().length;
    var encoder = StreamingJsonEncoder_init_$Create$(result, this, tmp, fillArrayVal(Array(tmp0_arrayOfNulls_0), null));
    encoder.encodeSerializableValue_1(serializer_16, value);
    return result.toString();
  };
  Json_0.prototype.decodeFromString_1 = function (deserializer, string) {
    var reader = new JsonReader(string);
    var input = new StreamingJsonDecoder(this, WriteMode_OBJ_getInstance(), reader);
    var result = input.decodeSerializableValue_16(deserializer);
    if (!reader._get_isDone_()) {
      var tmp0_error_0 = '' + 'Reader has not consumed the whole input: ' + reader;
      throw IllegalStateException_init_$Create$(toString_1(tmp0_error_0));
    }return result;
  };
  Json_0.$metadata$ = {
    simpleName: 'Json',
    kind: 'class',
    interfaces: [StringFormat]
  };
  function Json_1(from, builderAction) {
    var builder = new JsonBuilder(from._configuration);
    builderAction(builder);
    var conf = builder.build_16();
    return new JsonImpl(conf);
  }
  function Json$default(from, builderAction, $mask0, $handler) {
    if (!(($mask0 & 1) === 0))
      from = Default_getInstance_0();
    return Json_1(from, builderAction);
  }
  function JsonBuilder(conf) {
    this._encodeDefaults = conf._encodeDefaults_0;
    this._ignoreUnknownKeys = conf._ignoreUnknownKeys_0;
    this._isLenient = conf._isLenient_0;
    this._allowStructuredMapKeys = conf._allowStructuredMapKeys_0;
    this._prettyPrint = conf._prettyPrint_0;
    this._prettyPrintIndent = conf._prettyPrintIndent_0;
    this._coerceInputValues = conf._coerceInputValues_0;
    this._useArrayPolymorphism = conf._useArrayPolymorphism_0;
    this._classDiscriminator = conf._classDiscriminator_0;
    this._allowSpecialFloatingPointValues = conf._allowSpecialFloatingPointValues_0;
    this._serializersModule = conf._serializersModule_0;
  }
  JsonBuilder.prototype.build_16 = function () {
    if (this._useArrayPolymorphism) {
      var tmp0_require_0 = this._classDiscriminator === 'type';
      if (!tmp0_require_0) {
        var message_1 = 'Class discriminator should not be specified when array polymorphism is specified';
        throw IllegalArgumentException_init_$Create$_0(toString_1(message_1));
      }}if (!this._prettyPrint) {
      var tmp1_require_0 = this._prettyPrintIndent === '    ';
      if (!tmp1_require_0) {
        var message_1_0 = 'Indent should not be specified when default printing mode is used';
        throw IllegalArgumentException_init_$Create$_0(toString_1(message_1_0));
      }} else if (!(this._prettyPrintIndent === '    ')) {
      var tmp$ret$0;
      l$ret$1: do {
        var tmp2_all_0 = this._prettyPrintIndent;
        var indexedObject = tmp2_all_0;
        var inductionVariable = 0;
        var last_1 = indexedObject.length;
        while (inductionVariable < last_1) {
          var element_2 = charSequenceGet(indexedObject, inductionVariable);
          inductionVariable = inductionVariable + 1 | 0;
          if (!(((element_2.equals(new Char(32)) ? true : element_2.equals(new Char(9))) ? true : element_2.equals(new Char(13))) ? true : element_2.equals(new Char(10)))) {
            tmp$ret$0 = false;
            break l$ret$1;
          } else {
          }
        }
        tmp$ret$0 = true;
      }
       while (false);
      var allWhitespaces = tmp$ret$0;
      if (!allWhitespaces) {
        var message_1_1 = '' + 'Only whitespace, tab, newline and carriage return are allowed as pretty print symbols. Had ' + this._prettyPrintIndent;
        throw IllegalArgumentException_init_$Create$_0(toString_1(message_1_1));
      }}return new JsonConf(this._encodeDefaults, this._ignoreUnknownKeys, this._isLenient, this._allowStructuredMapKeys, this._prettyPrint, this._prettyPrintIndent, this._coerceInputValues, this._useArrayPolymorphism, this._classDiscriminator, this._allowSpecialFloatingPointValues, this._serializersModule);
  };
  JsonBuilder.$metadata$ = {
    simpleName: 'JsonBuilder',
    kind: 'class',
    interfaces: []
  };
  function validateConfiguration($this) {
    if (equals_1($this._get_serializersModule__14(), EmptySerializersModule))
      return Unit_getInstance();
    var collector = new PolymorphismValidator($this._get_configuration__3()._useArrayPolymorphism_0, $this._get_configuration__3()._classDiscriminator_0);
    $this._get_serializersModule__14().dumpTo_0(collector);
  }
  function JsonImpl(configuration) {
    Json_0.call(this, configuration);
    validateConfiguration(this);
  }
  JsonImpl.$metadata$ = {
    simpleName: 'JsonImpl',
    kind: 'class',
    interfaces: []
  };
  function JsonDecoder() {
  }
  JsonDecoder.$metadata$ = {
    simpleName: 'JsonDecoder',
    kind: 'interface',
    interfaces: [Decoder, CompositeDecoder]
  };
  function Companion_17() {
    Companion_instance_16 = this;
  }
  Companion_17.prototype.serializer_0 = function () {
    return JsonElementSerializer_getInstance();
  };
  Companion_17.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_16;
  function Companion_getInstance_16() {
    if (Companion_instance_16 == null)
      new Companion_17();
    return Companion_instance_16;
  }
  function JsonElement() {
    Companion_getInstance_16();
  }
  JsonElement.$metadata$ = {
    simpleName: 'JsonElement',
    kind: 'class',
    interfaces: [],
    associatedObjects: {0: JsonElementSerializer_getInstance}
  };
  function Companion_18() {
    Companion_instance_17 = this;
  }
  Companion_18.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_17;
  function Companion_getInstance_17() {
    if (Companion_instance_17 == null)
      new Companion_18();
    return Companion_instance_17;
  }
  function _no_name_provided__70() {
  }
  _no_name_provided__70.prototype.invoke_94 = function (_name_for_destructuring_parameter_0_) {
    var k = _name_for_destructuring_parameter_0_._get_key__47();
    var v = _name_for_destructuring_parameter_0_._get_value__33();
    var tmp0_apply_0_1 = StringBuilder_init_$Create$_0();
    printQuoted(tmp0_apply_0_1, k);
    tmp0_apply_0_1.append_32(new Char(58));
    Unit_getInstance();
    tmp0_apply_0_1.append_5(v);
    Unit_getInstance();
    return tmp0_apply_0_1.toString();
  };
  _no_name_provided__70.prototype.invoke_542 = function (p1) {
    return this.invoke_94((!(p1 == null) ? isInterface(p1, Entry) : false) ? p1 : THROW_CCE());
  };
  _no_name_provided__70.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function JsonObject(content) {
    Companion_getInstance_17();
    JsonElement.call(this);
    this._content = content;
  }
  JsonObject.prototype.containsKey_13 = function (key) {
    return this._content.containsKey_16(key);
  };
  JsonObject.prototype.containsKey_16 = function (key) {
    if (!(!(key == null) ? typeof key === 'string' : false))
      return false;
    else {
    }
    return this.containsKey_13((!(key == null) ? typeof key === 'string' : false) ? key : THROW_CCE());
  };
  JsonObject.prototype.get_69 = function (key) {
    return this._content.get_63(key);
  };
  JsonObject.prototype.get_63 = function (key) {
    if (!(!(key == null) ? typeof key === 'string' : false))
      return null;
    else {
    }
    return this.get_69((!(key == null) ? typeof key === 'string' : false) ? key : THROW_CCE());
  };
  JsonObject.prototype.isEmpty_53 = function () {
    return this._content.isEmpty_53();
  };
  JsonObject.prototype._get_entries__10 = function () {
    return this._content._get_entries__10();
  };
  JsonObject.prototype._get_keys__10 = function () {
    return this._content._get_keys__10();
  };
  JsonObject.prototype._get_size__45 = function () {
    return this._content._get_size__45();
  };
  JsonObject.prototype._get_values__16 = function () {
    return this._content._get_values__16();
  };
  JsonObject.prototype.equals = function (other) {
    return equals_1(this._content, other);
  };
  JsonObject.prototype.hashCode = function () {
    return hashCode(this._content);
  };
  JsonObject.prototype.toString = function () {
    var tmp = this._content._get_entries__10();
    return joinToString$default_0(tmp, ',', '{', '}', 0, null, _no_name_provided_$factory_50(), 24, null);
  };
  JsonObject.$metadata$ = {
    simpleName: 'JsonObject',
    kind: 'class',
    interfaces: [Map_0],
    associatedObjects: {0: JsonObjectSerializer_getInstance}
  };
  function JsonNull() {
    JsonNull_instance = this;
    JsonPrimitive.call(this);
    this._content_0 = 'null';
  }
  JsonNull.prototype._get_content__6 = function () {
    return this._content_0;
  };
  JsonNull.$metadata$ = {
    simpleName: 'JsonNull',
    kind: 'object',
    interfaces: []
  };
  var JsonNull_instance;
  function JsonNull_getInstance() {
    if (JsonNull_instance == null)
      new JsonNull();
    return JsonNull_instance;
  }
  function Companion_19() {
    Companion_instance_18 = this;
  }
  Companion_19.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_18;
  function Companion_getInstance_18() {
    if (Companion_instance_18 == null)
      new Companion_19();
    return Companion_instance_18;
  }
  function JsonPrimitive() {
    Companion_getInstance_18();
    JsonElement.call(this);
  }
  JsonPrimitive.prototype.toString = function () {
    return this._get_content__6();
  };
  JsonPrimitive.$metadata$ = {
    simpleName: 'JsonPrimitive',
    kind: 'class',
    interfaces: [],
    associatedObjects: {0: JsonPrimitiveSerializer_getInstance}
  };
  function JsonPrimitive_0(value) {
    if (value == null)
      return JsonNull_getInstance();
    return new JsonLiteral(value, true);
  }
  function JsonLiteral(body, isString_0) {
    JsonPrimitive.call(this);
    this._isString = isString_0;
    this._content_1 = toString_1(body);
  }
  JsonLiteral.prototype._get_content__6 = function () {
    return this._content_1;
  };
  JsonLiteral.prototype.toString = function () {
    var tmp;
    if (this._isString) {
      var tmp0_apply_0_1 = StringBuilder_init_$Create$_0();
      printQuoted(tmp0_apply_0_1, this._content_1);
      tmp = tmp0_apply_0_1.toString();
    } else {
      tmp = this._content_1;
    }
    return tmp;
  };
  JsonLiteral.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (other == null ? true : !getKClassFromExpression_0(this).equals(getKClassFromExpression_0(other)))
      return false;
    if (other instanceof JsonLiteral)
      other;
    else
      THROW_CCE();
    Unit_getInstance();
    if (!(this._isString === other._isString))
      return false;
    if (!(this._content_1 === other._content_1))
      return false;
    return true;
  };
  JsonLiteral.prototype.hashCode = function () {
    var result = this._isString | 0;
    result = imul(31, result) + getStringHashCode(this._content_1) | 0;
    return result;
  };
  JsonLiteral.$metadata$ = {
    simpleName: 'JsonLiteral',
    kind: 'class',
    interfaces: []
  };
  function Companion_20() {
    Companion_instance_19 = this;
  }
  Companion_20.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_19;
  function Companion_getInstance_19() {
    if (Companion_instance_19 == null)
      new Companion_20();
    return Companion_instance_19;
  }
  function JsonArray(content) {
    Companion_getInstance_19();
    JsonElement.call(this);
    this._content_2 = content;
  }
  JsonArray.prototype.contains_35 = function (element) {
    return this._content_2.contains_51(element);
  };
  JsonArray.prototype.contains_51 = function (element) {
    if (!(element instanceof JsonElement))
      return false;
    else {
    }
    return this.contains_35(element instanceof JsonElement ? element : THROW_CCE());
  };
  JsonArray.prototype.containsAll_25 = function (elements) {
    return this._content_2.containsAll_38(elements);
  };
  JsonArray.prototype.containsAll_38 = function (elements) {
    return this.containsAll_25(elements);
  };
  JsonArray.prototype.get_80 = function (index) {
    return this._content_2.get_80(index);
  };
  JsonArray.prototype.isEmpty_53 = function () {
    return this._content_2.isEmpty_53();
  };
  JsonArray.prototype.iterator_64 = function () {
    return this._content_2.iterator_64();
  };
  JsonArray.prototype._get_size__45 = function () {
    return this._content_2._get_size__45();
  };
  JsonArray.prototype.equals = function (other) {
    return equals_1(this._content_2, other);
  };
  JsonArray.prototype.hashCode = function () {
    return hashCode(this._content_2);
  };
  JsonArray.prototype.toString = function () {
    return joinToString$default_0(this._content_2, ',', '[', ']', 0, null, null, 56, null);
  };
  JsonArray.$metadata$ = {
    simpleName: 'JsonArray',
    kind: 'class',
    interfaces: [List],
    associatedObjects: {0: JsonArraySerializer_getInstance}
  };
  function _get_booleanOrNull_(_this_) {
    return toBooleanStrictOrNull(_this_._get_content__6());
  }
  function _get_int_(_this_) {
    return toInt(_this_._get_content__6());
  }
  function _get_long_(_this_) {
    return toLong(_this_._get_content__6());
  }
  function _get_float_(_this_) {
    var tmp0_toFloat_0 = _this_._get_content__6();
    var tmp0_unsafeCast_0_1 = toDouble(tmp0_toFloat_0);
    return tmp0_unsafeCast_0_1;
  }
  function _get_double_(_this_) {
    return toDouble(_this_._get_content__6());
  }
  function _get_contentOrNull_(_this_) {
    var tmp;
    if (_this_ instanceof JsonNull) {
      tmp = null;
    } else {
      {
        tmp = _this_._get_content__6();
      }
    }
    return tmp;
  }
  function _get_longOrNull_(_this_) {
    return toLongOrNull(_this_._get_content__6());
  }
  function _get_doubleOrNull_(_this_) {
    return toDoubleOrNull(_this_._get_content__6());
  }
  function _get_jsonPrimitive_(_this_) {
    var tmp0_elvis_lhs = _this_ instanceof JsonPrimitive ? _this_ : null;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      error_0(_this_, 'JsonPrimitive');
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  }
  function error_0(_this_, element) {
    throw IllegalArgumentException_init_$Create$_0('' + 'Element ' + getKClassFromExpression_0(_this_) + ' is not a ' + element);
  }
  function _no_name_provided_$factory_50() {
    var i = new _no_name_provided__70();
    return function (p1) {
      return i.invoke_94(p1);
    };
  }
  function _no_name_provided__71() {
  }
  _no_name_provided__71.prototype.invoke_540 = function () {
    return JsonPrimitiveSerializer_getInstance()._descriptor_27;
  };
  _no_name_provided__71.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__72() {
  }
  _no_name_provided__72.prototype.invoke_540 = function () {
    return JsonNullSerializer_getInstance()._descriptor_28;
  };
  _no_name_provided__72.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__73() {
  }
  _no_name_provided__73.prototype.invoke_540 = function () {
    return JsonLiteralSerializer_getInstance()._descriptor_29;
  };
  _no_name_provided__73.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__74() {
  }
  _no_name_provided__74.prototype.invoke_540 = function () {
    return JsonObjectSerializer_getInstance()._descriptor_25;
  };
  _no_name_provided__74.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__75() {
  }
  _no_name_provided__75.prototype.invoke_540 = function () {
    return JsonArraySerializer_getInstance()._descriptor_26;
  };
  _no_name_provided__75.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__76() {
  }
  _no_name_provided__76.prototype.invoke_101 = function ($this$buildSerialDescriptor) {
    var tmp = defer(_no_name_provided_$factory_52());
    $this$buildSerialDescriptor.element$default('JsonPrimitive', tmp, null, false, 12, null);
    var tmp_0 = defer(_no_name_provided_$factory_53());
    $this$buildSerialDescriptor.element$default('JsonNull', tmp_0, null, false, 12, null);
    var tmp_1 = defer(_no_name_provided_$factory_54());
    $this$buildSerialDescriptor.element$default('JsonLiteral', tmp_1, null, false, 12, null);
    var tmp_2 = defer(_no_name_provided_$factory_55());
    $this$buildSerialDescriptor.element$default('JsonObject', tmp_2, null, false, 12, null);
    var tmp_3 = defer(_no_name_provided_$factory_56());
    $this$buildSerialDescriptor.element$default('JsonArray', tmp_3, null, false, 12, null);
  };
  _no_name_provided__76.prototype.invoke_542 = function (p1) {
    this.invoke_101(p1 instanceof ClassSerialDescriptorBuilder ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__76.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function JsonElementSerializer() {
    JsonElementSerializer_instance = this;
    var tmp = this;
    var tmp_0 = SEALED_getInstance();
    var tmp_1 = [];
    tmp._descriptor_24 = buildSerialDescriptor$default('kotlinx.serialization.json.JsonElement', tmp_0, tmp_1, _no_name_provided_$factory_51(), 4, null);
  }
  JsonElementSerializer.prototype._get_descriptor__48 = function () {
    return this._descriptor_24;
  };
  JsonElementSerializer.prototype.serialize_61 = function (encoder, value) {
    verify(encoder);
    var tmp0_subject = value;
    if (tmp0_subject instanceof JsonPrimitive)
      encoder.encodeSerializableValue_1(JsonPrimitiveSerializer_getInstance(), value);
    else {
      if (tmp0_subject instanceof JsonObject)
        encoder.encodeSerializableValue_1(JsonObjectSerializer_getInstance(), value);
      else {
        if (tmp0_subject instanceof JsonArray)
          encoder.encodeSerializableValue_1(JsonArraySerializer_getInstance(), value);
        else {
        }
      }
    }
  };
  JsonElementSerializer.prototype.serialize_76 = function (encoder, value) {
    return this.serialize_61(encoder, value instanceof JsonElement ? value : THROW_CCE());
  };
  JsonElementSerializer.prototype.deserialize_52 = function (decoder) {
    var input = asJsonDecoder(decoder);
    return input.decodeJsonElement_4();
  };
  JsonElementSerializer.$metadata$ = {
    simpleName: 'JsonElementSerializer',
    kind: 'object',
    interfaces: [KSerializer]
  };
  var JsonElementSerializer_instance;
  function JsonElementSerializer_getInstance() {
    if (JsonElementSerializer_instance == null)
      new JsonElementSerializer();
    return JsonElementSerializer_instance;
  }
  function JsonObjectDescriptor() {
    JsonObjectDescriptor_instance = this;
    var tmp = this;
    var tmp0_cast_0_1_1 = serializer(createKType_0(getKClass_0(HashMap), [createInvariantKTypeProjection_0(createKType_0(PrimitiveClasses_getInstance()._get_stringClass_(), [], false)), createInvariantKTypeProjection_0(createKType_0(getKClass_0(JsonElement), [], false))], false));
    tmp._$$delegate_0_0 = (isInterface(tmp0_cast_0_1_1, KSerializer) ? tmp0_cast_0_1_1 : THROW_CCE())._get_descriptor__48();
    this._serialName_6 = 'kotlinx.serialization.json.JsonObject';
  }
  JsonObjectDescriptor.prototype.getElementDescriptor_16 = function (index) {
    return this._$$delegate_0_0.getElementDescriptor_16(index);
  };
  JsonObjectDescriptor.prototype.getElementIndex_16 = function (name) {
    return this._$$delegate_0_0.getElementIndex_16(name);
  };
  JsonObjectDescriptor.prototype.getElementName_16 = function (index) {
    return this._$$delegate_0_0.getElementName_16(index);
  };
  JsonObjectDescriptor.prototype._get_elementsCount__16 = function () {
    return this._$$delegate_0_0._get_elementsCount__16();
  };
  JsonObjectDescriptor.prototype._get_isInline__16 = function () {
    return this._$$delegate_0_0._get_isInline__16();
  };
  JsonObjectDescriptor.prototype._get_isNullable__16 = function () {
    return this._$$delegate_0_0._get_isNullable__16();
  };
  JsonObjectDescriptor.prototype._get_kind__16 = function () {
    return this._$$delegate_0_0._get_kind__16();
  };
  JsonObjectDescriptor.prototype._get_serialName__16 = function () {
    return this._serialName_6;
  };
  JsonObjectDescriptor.$metadata$ = {
    simpleName: 'JsonObjectDescriptor',
    kind: 'object',
    interfaces: [SerialDescriptor]
  };
  var JsonObjectDescriptor_instance;
  function JsonObjectDescriptor_getInstance() {
    if (JsonObjectDescriptor_instance == null)
      new JsonObjectDescriptor();
    return JsonObjectDescriptor_instance;
  }
  function JsonObjectSerializer() {
    JsonObjectSerializer_instance = this;
    this._descriptor_25 = JsonObjectDescriptor_getInstance();
  }
  JsonObjectSerializer.prototype._get_descriptor__48 = function () {
    return this._descriptor_25;
  };
  JsonObjectSerializer.prototype.serialize_63 = function (encoder, value) {
    verify(encoder);
    MapSerializer(serializer_2(StringCompanionObject_getInstance()), JsonElementSerializer_getInstance()).serialize_76(encoder, value);
  };
  JsonObjectSerializer.prototype.serialize_76 = function (encoder, value) {
    return this.serialize_63(encoder, value instanceof JsonObject ? value : THROW_CCE());
  };
  JsonObjectSerializer.prototype.deserialize_52 = function (decoder) {
    verify_0(decoder);
    return new JsonObject(MapSerializer(serializer_2(StringCompanionObject_getInstance()), JsonElementSerializer_getInstance()).deserialize_52(decoder));
  };
  JsonObjectSerializer.$metadata$ = {
    simpleName: 'JsonObjectSerializer',
    kind: 'object',
    interfaces: [KSerializer]
  };
  var JsonObjectSerializer_instance;
  function JsonObjectSerializer_getInstance() {
    if (JsonObjectSerializer_instance == null)
      new JsonObjectSerializer();
    return JsonObjectSerializer_instance;
  }
  function JsonArrayDescriptor() {
    JsonArrayDescriptor_instance = this;
    var tmp = this;
    var tmp0_cast_0_1_1 = serializer(createKType_0(getKClass_0(List), [createInvariantKTypeProjection_0(createKType_0(getKClass_0(JsonElement), [], false))], false));
    tmp._$$delegate_0_1 = (isInterface(tmp0_cast_0_1_1, KSerializer) ? tmp0_cast_0_1_1 : THROW_CCE())._get_descriptor__48();
    this._serialName_7 = 'kotlinx.serialization.json.JsonArray';
  }
  JsonArrayDescriptor.prototype.getElementDescriptor_16 = function (index) {
    return this._$$delegate_0_1.getElementDescriptor_16(index);
  };
  JsonArrayDescriptor.prototype.getElementIndex_16 = function (name) {
    return this._$$delegate_0_1.getElementIndex_16(name);
  };
  JsonArrayDescriptor.prototype.getElementName_16 = function (index) {
    return this._$$delegate_0_1.getElementName_16(index);
  };
  JsonArrayDescriptor.prototype._get_elementsCount__16 = function () {
    return this._$$delegate_0_1._get_elementsCount__16();
  };
  JsonArrayDescriptor.prototype._get_isInline__16 = function () {
    return this._$$delegate_0_1._get_isInline__16();
  };
  JsonArrayDescriptor.prototype._get_isNullable__16 = function () {
    return this._$$delegate_0_1._get_isNullable__16();
  };
  JsonArrayDescriptor.prototype._get_kind__16 = function () {
    return this._$$delegate_0_1._get_kind__16();
  };
  JsonArrayDescriptor.prototype._get_serialName__16 = function () {
    return this._serialName_7;
  };
  JsonArrayDescriptor.$metadata$ = {
    simpleName: 'JsonArrayDescriptor',
    kind: 'object',
    interfaces: [SerialDescriptor]
  };
  var JsonArrayDescriptor_instance;
  function JsonArrayDescriptor_getInstance() {
    if (JsonArrayDescriptor_instance == null)
      new JsonArrayDescriptor();
    return JsonArrayDescriptor_instance;
  }
  function JsonArraySerializer() {
    JsonArraySerializer_instance = this;
    this._descriptor_26 = JsonArrayDescriptor_getInstance();
  }
  JsonArraySerializer.prototype._get_descriptor__48 = function () {
    return this._descriptor_26;
  };
  JsonArraySerializer.prototype.serialize_65 = function (encoder, value) {
    verify(encoder);
    ListSerializer(JsonElementSerializer_getInstance()).serialize_76(encoder, value);
  };
  JsonArraySerializer.prototype.serialize_76 = function (encoder, value) {
    return this.serialize_65(encoder, value instanceof JsonArray ? value : THROW_CCE());
  };
  JsonArraySerializer.prototype.deserialize_52 = function (decoder) {
    verify_0(decoder);
    return new JsonArray(ListSerializer(JsonElementSerializer_getInstance()).deserialize_52(decoder));
  };
  JsonArraySerializer.$metadata$ = {
    simpleName: 'JsonArraySerializer',
    kind: 'object',
    interfaces: [KSerializer]
  };
  var JsonArraySerializer_instance;
  function JsonArraySerializer_getInstance() {
    if (JsonArraySerializer_instance == null)
      new JsonArraySerializer();
    return JsonArraySerializer_instance;
  }
  function defer(deferred) {
    return new _no_name_provided__77(deferred);
  }
  function JsonPrimitiveSerializer() {
    JsonPrimitiveSerializer_instance = this;
    var tmp = this;
    var tmp_0 = STRING_getInstance();
    var tmp_1 = [];
    tmp._descriptor_27 = buildSerialDescriptor$default('kotlinx.serialization.json.JsonPrimitive', tmp_0, tmp_1, null, 12, null);
  }
  JsonPrimitiveSerializer.prototype._get_descriptor__48 = function () {
    return this._descriptor_27;
  };
  JsonPrimitiveSerializer.prototype.serialize_67 = function (encoder, value) {
    verify(encoder);
    var tmp;
    if (value instanceof JsonNull) {
      tmp = encoder.encodeSerializableValue_1(JsonNullSerializer_getInstance(), JsonNull_getInstance());
    } else {
      {
        var tmp_0 = JsonLiteralSerializer_getInstance();
        tmp = encoder.encodeSerializableValue_1(tmp_0, value instanceof JsonLiteral ? value : THROW_CCE());
      }
    }
    return tmp;
  };
  JsonPrimitiveSerializer.prototype.serialize_76 = function (encoder, value) {
    return this.serialize_67(encoder, value instanceof JsonPrimitive ? value : THROW_CCE());
  };
  JsonPrimitiveSerializer.prototype.deserialize_52 = function (decoder) {
    var result = asJsonDecoder(decoder).decodeJsonElement_4();
    if (!(result instanceof JsonPrimitive))
      throw JsonDecodingException_0(-1, '' + 'Unexpected JSON element, expected JsonPrimitive, had ' + getKClassFromExpression_0(result), toString_1(result));
    else {
    }
    return result;
  };
  JsonPrimitiveSerializer.$metadata$ = {
    simpleName: 'JsonPrimitiveSerializer',
    kind: 'object',
    interfaces: [KSerializer]
  };
  var JsonPrimitiveSerializer_instance;
  function JsonPrimitiveSerializer_getInstance() {
    if (JsonPrimitiveSerializer_instance == null)
      new JsonPrimitiveSerializer();
    return JsonPrimitiveSerializer_instance;
  }
  function JsonNullSerializer() {
    JsonNullSerializer_instance = this;
    var tmp = this;
    var tmp_0 = ENUM_getInstance();
    var tmp_1 = [];
    tmp._descriptor_28 = buildSerialDescriptor$default('kotlinx.serialization.json.JsonNull', tmp_0, tmp_1, null, 12, null);
  }
  JsonNullSerializer.prototype._get_descriptor__48 = function () {
    return this._descriptor_28;
  };
  JsonNullSerializer.prototype.serialize_69 = function (encoder, value) {
    verify(encoder);
    encoder.encodeNull_1();
  };
  JsonNullSerializer.prototype.serialize_76 = function (encoder, value) {
    return this.serialize_69(encoder, value instanceof JsonNull ? value : THROW_CCE());
  };
  JsonNullSerializer.prototype.deserialize_52 = function (decoder) {
    verify_0(decoder);
    decoder.decodeNull_8();
    Unit_getInstance();
    return JsonNull_getInstance();
  };
  JsonNullSerializer.$metadata$ = {
    simpleName: 'JsonNullSerializer',
    kind: 'object',
    interfaces: [KSerializer]
  };
  var JsonNullSerializer_instance;
  function JsonNullSerializer_getInstance() {
    if (JsonNullSerializer_instance == null)
      new JsonNullSerializer();
    return JsonNullSerializer_instance;
  }
  function JsonLiteralSerializer() {
    JsonLiteralSerializer_instance = this;
    this._descriptor_29 = PrimitiveSerialDescriptor('kotlinx.serialization.json.JsonLiteral', STRING_getInstance());
  }
  JsonLiteralSerializer.prototype._get_descriptor__48 = function () {
    return this._descriptor_29;
  };
  JsonLiteralSerializer.prototype.serialize_71 = function (encoder, value) {
    verify(encoder);
    if (value._isString) {
      return encoder.encodeString_1(value._content_1);
    }var tmp0_safe_receiver = _get_longOrNull_(value);
    if (tmp0_safe_receiver == null)
      null;
    else {
      return encoder.encodeLong_1(tmp0_safe_receiver);
    }
    Unit_getInstance();
    var tmp1_safe_receiver = toULongOrNull(value._content_1);
    var tmp = tmp1_safe_receiver;
    if ((tmp == null ? null : new ULong(tmp)) == null)
      null;
    else {
      {
        var tmp0_safe_receiver_2 = encoder.encodeInline_1(serializer_13(Companion_getInstance_6())._get_descriptor__48());
        if (tmp0_safe_receiver_2 == null)
          null;
        else {
          tmp0_safe_receiver_2.encodeLong_1(_ULong___get_data__impl_(tmp1_safe_receiver));
          Unit_getInstance();
        }
        Unit_getInstance();
        return Unit_getInstance();
      }
    }
    Unit_getInstance();
    var tmp2_safe_receiver = _get_doubleOrNull_(value);
    if (tmp2_safe_receiver == null)
      null;
    else {
      return encoder.encodeDouble_1(tmp2_safe_receiver);
    }
    Unit_getInstance();
    var tmp3_safe_receiver = _get_booleanOrNull_(value);
    if (tmp3_safe_receiver == null)
      null;
    else {
      return encoder.encodeBoolean_1(tmp3_safe_receiver);
    }
    Unit_getInstance();
    encoder.encodeString_1(value._content_1);
  };
  JsonLiteralSerializer.prototype.serialize_76 = function (encoder, value) {
    return this.serialize_71(encoder, value instanceof JsonLiteral ? value : THROW_CCE());
  };
  JsonLiteralSerializer.prototype.deserialize_52 = function (decoder) {
    var result = asJsonDecoder(decoder).decodeJsonElement_4();
    if (!(result instanceof JsonLiteral))
      throw JsonDecodingException_0(-1, '' + 'Unexpected JSON element, expected JsonLiteral, had ' + getKClassFromExpression_0(result), toString_1(result));
    else {
    }
    return result;
  };
  JsonLiteralSerializer.$metadata$ = {
    simpleName: 'JsonLiteralSerializer',
    kind: 'object',
    interfaces: [KSerializer]
  };
  var JsonLiteralSerializer_instance;
  function JsonLiteralSerializer_getInstance() {
    if (JsonLiteralSerializer_instance == null)
      new JsonLiteralSerializer();
    return JsonLiteralSerializer_instance;
  }
  function verify(encoder) {
    asJsonEncoder(encoder);
    Unit_getInstance();
  }
  function asJsonDecoder(_this_) {
    var tmp0_elvis_lhs = isInterface(_this_, JsonDecoder) ? _this_ : null;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      throw IllegalStateException_init_$Create$('This serializer can be used only with Json format.' + ('' + 'Expected Decoder to be JsonDecoder, got ' + getKClassFromExpression_0(_this_)));
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  }
  function verify_0(decoder) {
    asJsonDecoder(decoder);
    Unit_getInstance();
  }
  function asJsonEncoder(_this_) {
    var tmp0_elvis_lhs = isInterface(_this_, JsonEncoder) ? _this_ : null;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      throw IllegalStateException_init_$Create$('This serializer can be used only with Json format.' + ('' + 'Expected Encoder to be JsonEncoder, got ' + getKClassFromExpression_0(_this_)));
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  }
  function _get_original_($this) {
    var tmp0_getValue_0 = $this._original$delegate;
    var tmp1_getValue_0 = original$factory();
    return tmp0_getValue_0._get_value__33();
  }
  function _no_name_provided__77($deferred) {
    this._$deferred = $deferred;
    this._original$delegate = lazy(this._$deferred);
  }
  _no_name_provided__77.prototype._get_serialName__16 = function () {
    return _get_original_(this)._get_serialName__16();
  };
  _no_name_provided__77.prototype._get_kind__16 = function () {
    return _get_original_(this)._get_kind__16();
  };
  _no_name_provided__77.prototype._get_elementsCount__16 = function () {
    return _get_original_(this)._get_elementsCount__16();
  };
  _no_name_provided__77.prototype.getElementName_16 = function (index) {
    return _get_original_(this).getElementName_16(index);
  };
  _no_name_provided__77.prototype.getElementIndex_16 = function (name) {
    return _get_original_(this).getElementIndex_16(name);
  };
  _no_name_provided__77.prototype.getElementDescriptor_16 = function (index) {
    return _get_original_(this).getElementDescriptor_16(index);
  };
  _no_name_provided__77.$metadata$ = {
    kind: 'class',
    interfaces: [SerialDescriptor]
  };
  function original$factory() {
    return getPropertyCallableRef('original', 1, KProperty1, function (receiver) {
      return _get_original_(receiver);
    }, null);
  }
  function _no_name_provided_$factory_51() {
    var i = new _no_name_provided__76();
    return function (p1) {
      i.invoke_101(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_52() {
    var i = new _no_name_provided__71();
    return function () {
      return i.invoke_540();
    };
  }
  function _no_name_provided_$factory_53() {
    var i = new _no_name_provided__72();
    return function () {
      return i.invoke_540();
    };
  }
  function _no_name_provided_$factory_54() {
    var i = new _no_name_provided__73();
    return function () {
      return i.invoke_540();
    };
  }
  function _no_name_provided_$factory_55() {
    var i = new _no_name_provided__74();
    return function () {
      return i.invoke_540();
    };
  }
  function _no_name_provided_$factory_56() {
    var i = new _no_name_provided__75();
    return function () {
      return i.invoke_540();
    };
  }
  function JsonEncoder() {
  }
  JsonEncoder.$metadata$ = {
    simpleName: 'JsonEncoder',
    kind: 'interface',
    interfaces: [Encoder, CompositeEncoder]
  };
  function JsonConf_init_$Init$(encodeDefaults, ignoreUnknownKeys, isLenient, allowStructuredMapKeys, prettyPrint, prettyPrintIndent, coerceInputValues, useArrayPolymorphism, classDiscriminator, allowSpecialFloatingPointValues, serializersModule, $mask0, $marker, $this) {
    if (!(($mask0 & 1) === 0))
      encodeDefaults = false;
    if (!(($mask0 & 2) === 0))
      ignoreUnknownKeys = false;
    if (!(($mask0 & 4) === 0))
      isLenient = false;
    if (!(($mask0 & 8) === 0))
      allowStructuredMapKeys = false;
    if (!(($mask0 & 16) === 0))
      prettyPrint = false;
    if (!(($mask0 & 32) === 0))
      prettyPrintIndent = '    ';
    if (!(($mask0 & 64) === 0))
      coerceInputValues = false;
    if (!(($mask0 & 128) === 0))
      useArrayPolymorphism = false;
    if (!(($mask0 & 256) === 0))
      classDiscriminator = 'type';
    if (!(($mask0 & 512) === 0))
      allowSpecialFloatingPointValues = false;
    if (!(($mask0 & 1024) === 0))
      serializersModule = EmptySerializersModule;
    JsonConf.call($this, encodeDefaults, ignoreUnknownKeys, isLenient, allowStructuredMapKeys, prettyPrint, prettyPrintIndent, coerceInputValues, useArrayPolymorphism, classDiscriminator, allowSpecialFloatingPointValues, serializersModule);
    return $this;
  }
  function JsonConf_init_$Create$(encodeDefaults, ignoreUnknownKeys, isLenient, allowStructuredMapKeys, prettyPrint, prettyPrintIndent, coerceInputValues, useArrayPolymorphism, classDiscriminator, allowSpecialFloatingPointValues, serializersModule, $mask0, $marker) {
    return JsonConf_init_$Init$(encodeDefaults, ignoreUnknownKeys, isLenient, allowStructuredMapKeys, prettyPrint, prettyPrintIndent, coerceInputValues, useArrayPolymorphism, classDiscriminator, allowSpecialFloatingPointValues, serializersModule, $mask0, $marker, Object.create(JsonConf.prototype));
  }
  function JsonConf(encodeDefaults, ignoreUnknownKeys, isLenient, allowStructuredMapKeys, prettyPrint, prettyPrintIndent, coerceInputValues, useArrayPolymorphism, classDiscriminator, allowSpecialFloatingPointValues, serializersModule) {
    this._encodeDefaults_0 = encodeDefaults;
    this._ignoreUnknownKeys_0 = ignoreUnknownKeys;
    this._isLenient_0 = isLenient;
    this._allowStructuredMapKeys_0 = allowStructuredMapKeys;
    this._prettyPrint_0 = prettyPrint;
    this._prettyPrintIndent_0 = prettyPrintIndent;
    this._coerceInputValues_0 = coerceInputValues;
    this._useArrayPolymorphism_0 = useArrayPolymorphism;
    this._classDiscriminator_0 = classDiscriminator;
    this._allowSpecialFloatingPointValues_0 = allowSpecialFloatingPointValues;
    this._serializersModule_0 = serializersModule;
  }
  JsonConf.prototype.toString = function () {
    return '' + 'JsonConf(encodeDefaults=' + this._encodeDefaults_0 + ', ignoreUnknownKeys=' + this._ignoreUnknownKeys_0 + ', isLenient=' + this._isLenient_0 + ', allowStructuredMapKeys=' + this._allowStructuredMapKeys_0 + ', prettyPrint=' + this._prettyPrint_0 + ', prettyPrintIndent=' + this._prettyPrintIndent_0 + ', coerceInputValues=' + this._coerceInputValues_0 + ', useArrayPolymorphism=' + this._useArrayPolymorphism_0 + ', classDiscriminator=' + this._classDiscriminator_0 + ', allowSpecialFloatingPointValues=' + this._allowSpecialFloatingPointValues_0 + ', serializersModule=' + this._serializersModule_0 + ')';
  };
  JsonConf.prototype.hashCode = function () {
    var result = this._encodeDefaults_0 | 0;
    result = imul(result, 31) + (this._ignoreUnknownKeys_0 | 0) | 0;
    result = imul(result, 31) + (this._isLenient_0 | 0) | 0;
    result = imul(result, 31) + (this._allowStructuredMapKeys_0 | 0) | 0;
    result = imul(result, 31) + (this._prettyPrint_0 | 0) | 0;
    result = imul(result, 31) + getStringHashCode(this._prettyPrintIndent_0) | 0;
    result = imul(result, 31) + (this._coerceInputValues_0 | 0) | 0;
    result = imul(result, 31) + (this._useArrayPolymorphism_0 | 0) | 0;
    result = imul(result, 31) + getStringHashCode(this._classDiscriminator_0) | 0;
    result = imul(result, 31) + (this._allowSpecialFloatingPointValues_0 | 0) | 0;
    result = imul(result, 31) + hashCode(this._serializersModule_0) | 0;
    return result;
  };
  JsonConf.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof JsonConf))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof JsonConf ? other : THROW_CCE();
    if (!(this._encodeDefaults_0 === tmp0_other_with_cast._encodeDefaults_0))
      return false;
    if (!(this._ignoreUnknownKeys_0 === tmp0_other_with_cast._ignoreUnknownKeys_0))
      return false;
    if (!(this._isLenient_0 === tmp0_other_with_cast._isLenient_0))
      return false;
    if (!(this._allowStructuredMapKeys_0 === tmp0_other_with_cast._allowStructuredMapKeys_0))
      return false;
    if (!(this._prettyPrint_0 === tmp0_other_with_cast._prettyPrint_0))
      return false;
    if (!(this._prettyPrintIndent_0 === tmp0_other_with_cast._prettyPrintIndent_0))
      return false;
    if (!(this._coerceInputValues_0 === tmp0_other_with_cast._coerceInputValues_0))
      return false;
    if (!(this._useArrayPolymorphism_0 === tmp0_other_with_cast._useArrayPolymorphism_0))
      return false;
    if (!(this._classDiscriminator_0 === tmp0_other_with_cast._classDiscriminator_0))
      return false;
    if (!(this._allowSpecialFloatingPointValues_0 === tmp0_other_with_cast._allowSpecialFloatingPointValues_0))
      return false;
    if (!equals_1(this._serializersModule_0, tmp0_other_with_cast._serializersModule_0))
      return false;
    return true;
  };
  JsonConf.$metadata$ = {
    simpleName: 'JsonConf',
    kind: 'class',
    interfaces: []
  };
  function JsonEncodingException(message) {
    JsonException.call(this, message);
    captureStack(this, JsonEncodingException);
  }
  JsonEncodingException.$metadata$ = {
    simpleName: 'JsonEncodingException',
    kind: 'class',
    interfaces: []
  };
  function InvalidFloatingPointEncoded(value, output) {
    var tmp = '' + 'Unexpected special floating-point value ' + value + '. By default, ' + 'non-finite floating point values are prohibited because they do not conform JSON specification. ' + "It is possible to deserialize them using 'JsonBuilder.allowSpecialFloatingPointValues = true'\n";
    return new JsonEncodingException(tmp + ('' + 'Current output: ' + minify$default(output, 0, 1, null)));
  }
  function InvalidKeyKindException(keyDescriptor) {
    return new JsonEncodingException('' + "Value of type '" + keyDescriptor._get_serialName__16() + "' can't be used in JSON as a key in the map. " + ('' + "It should have either primitive or enum kind, but its kind is '" + keyDescriptor._get_kind__16() + "'.\n") + "Use 'allowStructuredMapKeys = true' in 'Json {}' builder to convert such maps to [key1, value1, key2, value2,...] arrays.");
  }
  function JsonDecodingException(message) {
    JsonException.call(this, message);
    captureStack(this, JsonDecodingException);
  }
  JsonDecodingException.$metadata$ = {
    simpleName: 'JsonDecodingException',
    kind: 'class',
    interfaces: []
  };
  function JsonDecodingException_0(offset, message, input) {
    return JsonDecodingException_1(offset, '' + message + '\nJSON input: ' + minify(input, offset));
  }
  function throwInvalidFloatingPointDecoded(_this_, result) {
    var tmp = '' + 'Unexpected special floating-point value ' + result + '. By default, ' + 'non-finite floating point values are prohibited because they do not conform JSON specification. ' + "It is possible to deserialize them using 'JsonBuilder.allowSpecialFloatingPointValues = true'";
    _this_.fail$default(tmp, 0, 2, null);
  }
  function InvalidFloatingPointDecoded(value, key, output) {
    return JsonDecodingException_1(-1, unexpectedFpErrorMessage(value, key, output));
  }
  function UnknownKeyException(key, input) {
    var tmp = '' + "Encountered unknown key '" + key + "'.\n" + "Use 'ignoreUnknownKeys = true' in 'Json {}' builder to ignore unknown keys.\n";
    return JsonDecodingException_1(-1, tmp + ('' + 'Current input: ' + minify$default(input, 0, 1, null)));
  }
  function JsonException(message) {
    SerializationException_init_$Init$(message, this);
    captureStack(this, JsonException);
  }
  JsonException.$metadata$ = {
    simpleName: 'JsonException',
    kind: 'class',
    interfaces: []
  };
  function minify(_this_, offset) {
    if (_this_.length < 200)
      return _this_;
    if (offset === -1) {
      var start = _this_.length - 60 | 0;
      if (start <= 0)
        return _this_;
      return '.....' + _this_.substring(start);
    }var start_0 = offset - 30 | 0;
    var end = offset + 30 | 0;
    var prefix = start_0 <= 0 ? '' : '.....';
    var suffix = end >= _this_.length ? '' : '.....';
    var tmp0_substring_0 = coerceAtLeast(start_0, 0);
    var tmp1_substring_0 = coerceAtMost(end, _this_.length);
    return prefix + _this_.substring(tmp0_substring_0, tmp1_substring_0) + suffix;
  }
  function minify$default(_this_, offset, $mask0, $handler) {
    if (!(($mask0 & 1) === 0))
      offset = -1;
    return minify(_this_, offset);
  }
  function JsonDecodingException_1(offset, message) {
    return new JsonDecodingException(offset >= 0 ? '' + 'Unexpected JSON token at offset ' + offset + ': ' + message : message);
  }
  function unexpectedFpErrorMessage(value, key, output) {
    var tmp = '' + 'Unexpected special floating-point value ' + value + ' with key ' + key + '. By default, ' + 'non-finite floating point values are prohibited because they do not conform JSON specification. ' + "It is possible to deserialize them using 'JsonBuilder.allowSpecialFloatingPointValues = true'\n";
    return tmp + ('' + 'Current output: ' + minify$default(output, 0, 1, null));
  }
  function readObject($this) {
    var tmp0_requireTokenClass_0 = $this._reader;
    var tmp1_requireTokenClass_0 = 6;
    if (!(tmp0_requireTokenClass_0._tokenClass === tmp1_requireTokenClass_0)) {
      var tmp2__anonymous__1 = numberToChar(tmp0_requireTokenClass_0._tokenClass);
      tmp0_requireTokenClass_0.fail('Expected start of the object', tmp0_requireTokenClass_0._tokenPosition);
    }$this._reader.nextToken();
    var tmp3_require_0 = $this._reader;
    var tmp4_require_0 = !($this._reader._tokenClass === 4);
    var tmp5_require_0 = $this._reader._currentPosition;
    if (!tmp4_require_0) {
      tmp3_require_0.fail('Unexpected leading comma', tmp5_require_0);
    }var result = LinkedHashMap_init_$Create$();
    var valueExpected = false;
    while ($this._reader._get_canBeginValue_()) {
      valueExpected = false;
      var key = $this._isLenient_1 ? $this._reader.takeString() : $this._reader.takeStringQuoted();
      var tmp6_requireTokenClass_0 = $this._reader;
      var tmp7_requireTokenClass_0 = 5;
      if (!(tmp6_requireTokenClass_0._tokenClass === tmp7_requireTokenClass_0)) {
        var tmp8__anonymous__1 = numberToChar(tmp6_requireTokenClass_0._tokenClass);
        tmp6_requireTokenClass_0.fail("Expected ':'", tmp6_requireTokenClass_0._tokenPosition);
      }$this._reader.nextToken();
      var element = $this.read_0();
      result.put_12(key, element);
      Unit_getInstance();
      if (!($this._reader._tokenClass === 4)) {
        var tmp9_requireTokenClass_0 = $this._reader;
        var tmp10_requireTokenClass_0 = 7;
        if (!(tmp9_requireTokenClass_0._tokenClass === tmp10_requireTokenClass_0)) {
          var tmp11__anonymous__1 = numberToChar(tmp9_requireTokenClass_0._tokenClass);
          tmp9_requireTokenClass_0.fail('Expected end of the object or comma', tmp9_requireTokenClass_0._tokenPosition);
        }} else {
        valueExpected = true;
        $this._reader.nextToken();
      }
    }
    var tmp12_require_0 = $this._reader;
    var tmp13_require_0 = !valueExpected ? $this._reader._tokenClass === 7 : false;
    var tmp14_require_0 = $this._reader._currentPosition;
    if (!tmp13_require_0) {
      tmp12_require_0.fail('Expected end of the object', tmp14_require_0);
    }$this._reader.nextToken();
    return new JsonObject(result);
  }
  function readArray($this) {
    var tmp0_requireTokenClass_0 = $this._reader;
    var tmp1_requireTokenClass_0 = 8;
    if (!(tmp0_requireTokenClass_0._tokenClass === tmp1_requireTokenClass_0)) {
      var tmp2__anonymous__1 = numberToChar(tmp0_requireTokenClass_0._tokenClass);
      tmp0_requireTokenClass_0.fail('Expected start of the array', tmp0_requireTokenClass_0._tokenPosition);
    }$this._reader.nextToken();
    var tmp3_require_0 = $this._reader;
    var tmp4_require_0 = !($this._reader._tokenClass === 4);
    var tmp5_require_0 = $this._reader._currentPosition;
    if (!tmp4_require_0) {
      tmp3_require_0.fail('Unexpected leading comma', tmp5_require_0);
    }var result = ArrayList_init_$Create$();
    var valueExpected = false;
    while ($this._reader._get_canBeginValue_()) {
      valueExpected = false;
      var element = $this.read_0();
      result.add_33(element);
      Unit_getInstance();
      if (!($this._reader._tokenClass === 4)) {
        var tmp6_requireTokenClass_0 = $this._reader;
        var tmp7_requireTokenClass_0 = 9;
        if (!(tmp6_requireTokenClass_0._tokenClass === tmp7_requireTokenClass_0)) {
          var tmp8__anonymous__1 = numberToChar(tmp6_requireTokenClass_0._tokenClass);
          tmp6_requireTokenClass_0.fail('Expected end of the array or comma', tmp6_requireTokenClass_0._tokenPosition);
        }} else {
        valueExpected = true;
        $this._reader.nextToken();
      }
    }
    var tmp9_require_0 = $this._reader;
    var tmp10_require_0 = !valueExpected;
    var tmp11_require_0 = $this._reader._currentPosition;
    if (!tmp10_require_0) {
      tmp9_require_0.fail('Unexpected trailing comma', tmp11_require_0);
    }$this._reader.nextToken();
    return new JsonArray(result);
  }
  function readValue($this, isString_0) {
    var tmp;
    if ($this._isLenient_1) {
      tmp = $this._reader.takeString();
    } else {
      tmp = isString_0 ? $this._reader.takeStringQuoted() : $this._reader.takeString();
    }
    var str = tmp;
    return new JsonLiteral(str, isString_0);
  }
  function JsonParser(configuration, reader) {
    this._reader = reader;
    this._isLenient_1 = configuration._isLenient_0;
  }
  JsonParser.prototype.read_0 = function () {
    if (!this._reader._get_canBeginValue_()) {
      this._reader.fail$default("Can't begin reading value from here", 0, 2, null);
    }var tmp0_subject = this._reader._tokenClass;
    var tmp;
    if (tmp0_subject === 10) {
      var tmp0_also_0 = JsonNull_getInstance();
      this._reader.nextToken();
      tmp = tmp0_also_0;
    } else if (tmp0_subject === 1) {
      tmp = readValue(this, true);
    } else if (tmp0_subject === 0) {
      tmp = readValue(this, false);
    } else if (tmp0_subject === 6) {
      tmp = readObject(this);
    } else if (tmp0_subject === 8) {
      tmp = readArray(this);
    } else {
      this._reader.fail$default("Can't begin reading element, unexpected token", 0, 2, null);
    }
    return tmp;
  };
  JsonParser.$metadata$ = {
    simpleName: 'JsonParser',
    kind: 'class',
    interfaces: []
  };
  function takeStringInternal($this, advance) {
    var tmp;
    if ($this._offset < 0) {
      tmp = concatToString($this._buf, 0, 0 + $this._length | 0);
    } else {
      var tmp0_substring_0 = $this._source;
      var tmp1_substring_0 = $this._offset;
      var tmp2_substring_0 = $this._offset + $this._length | 0;
      tmp = tmp0_substring_0.substring(tmp1_substring_0, tmp2_substring_0);
    }
    var prevStr = tmp;
    if (advance)
      $this.nextToken();
    return prevStr;
  }
  function takeStringInternal$default($this, advance, $mask0, $handler) {
    if (!(($mask0 & 2) === 0))
      advance = true;
    return takeStringInternal($this, advance);
  }
  function append($this, ch) {
    if ($this._length >= $this._buf.length)
      $this._buf = copyOf($this._buf, imul(2, $this._buf.length));
    var tmp = $this._buf;
    var tmp0_this = $this;
    var tmp1 = tmp0_this._length;
    tmp0_this._length = tmp1 + 1 | 0;
    tmp[tmp1] = ch;
  }
  function appendRange($this, source, fromIndex, toIndex) {
    var addLen = toIndex - fromIndex | 0;
    var oldLen = $this._length;
    var newLen = oldLen + addLen | 0;
    if (newLen > $this._buf.length)
      $this._buf = copyOf($this._buf, coerceAtLeast(newLen, imul(2, $this._buf.length)));
    var inductionVariable = 0;
    if (inductionVariable < addLen)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        $this._buf[oldLen + i | 0] = charSequenceGet(source, fromIndex + i | 0);
      }
       while (inductionVariable < addLen);
    var tmp1_this = $this;
    tmp1_this._length = tmp1_this._length + addLen | 0;
  }
  function nextLiteral($this, source, startPos) {
    $this._tokenPosition = startPos;
    $this._offset = startPos;
    var currentPosition = startPos;
    while (currentPosition < source.length ? charToTokenClass(charSequenceGet(source, currentPosition)) === 0 : false) {
      var tmp0 = currentPosition;
      currentPosition = tmp0 + 1 | 0;
      Unit_getInstance();
    }
    $this._currentPosition = currentPosition;
    $this._length = currentPosition - $this._offset | 0;
    $this._tokenClass = rangeEquals(source, $this._offset, $this._length, 'null') ? 10 : 0;
  }
  function nextString($this, source, startPosition) {
    $this._tokenPosition = startPosition;
    $this._length = 0;
    var currentPosition = startPosition + 1 | 0;
    if (currentPosition >= source.length) {
      $this.fail('EOF', currentPosition);
    }var lastPosition = currentPosition;
    while (!charSequenceGet(source, currentPosition).equals(new Char(34))) {
      if (charSequenceGet(source, currentPosition).equals(new Char(92))) {
        appendRange($this, source, lastPosition, currentPosition);
        var newPosition = appendEsc($this, source, currentPosition + 1 | 0);
        currentPosition = newPosition;
        lastPosition = newPosition;
      } else {
        currentPosition = currentPosition + 1 | 0;
        if (currentPosition >= source.length) {
          $this.fail('EOF', currentPosition);
        } else {
        }
      }
    }
    if (lastPosition === (startPosition + 1 | 0)) {
      $this._offset = lastPosition;
      $this._length = currentPosition - lastPosition | 0;
    } else {
      appendRange($this, source, lastPosition, currentPosition);
      $this._offset = -1;
    }
    $this._currentPosition = currentPosition + 1 | 0;
    $this._tokenClass = 1;
  }
  function appendEsc($this, source, startPosition) {
    var currentPosition = startPosition;
    var tmp0_require_0 = currentPosition < source.length;
    var tmp1_require_0 = currentPosition;
    if (!tmp0_require_0) {
      $this.fail('Unexpected EOF after escape character', tmp1_require_0);
    }var tmp0 = currentPosition;
    currentPosition = tmp0 + 1 | 0;
    var currentChar = charSequenceGet(source, tmp0);
    if (currentChar.equals(new Char(117))) {
      return appendHex($this, source, currentPosition);
    }var c = escapeToChar(currentChar.toInt_5());
    var tmp2_require_0 = !c.equals(new Char(0));
    var tmp3_require_0 = currentPosition;
    if (!tmp2_require_0) {
      $this.fail('' + "Invalid escaped char '" + currentChar + "'", tmp3_require_0);
    }append($this, c);
    return currentPosition;
  }
  function appendHex($this, source, startPos) {
    var curPos = startPos;
    var tmp3 = curPos;
    curPos = tmp3 + 1 | 0;
    var tmp = fromHexChar($this, source, tmp3) << 12;
    var tmp2 = curPos;
    curPos = tmp2 + 1 | 0;
    var tmp_0 = tmp + (fromHexChar($this, source, tmp2) << 8) | 0;
    var tmp1 = curPos;
    curPos = tmp1 + 1 | 0;
    var tmp_1 = tmp_0 + (fromHexChar($this, source, tmp1) << 4) | 0;
    var tmp0 = curPos;
    curPos = tmp0 + 1 | 0;
    append($this, numberToChar(tmp_1 + fromHexChar($this, source, tmp0) | 0));
    return curPos;
  }
  function fromHexChar($this, source, currentPosition) {
    var tmp0_require_0 = currentPosition < source.length;
    if (!tmp0_require_0) {
      $this.fail('Unexpected EOF during unicode escape', currentPosition);
    }var curChar = charSequenceGet(source, currentPosition);
    var tmp;
    if (new Char(48) <= curChar ? curChar <= new Char(57) : false) {
      tmp = curChar.toInt_5() - 48 | 0;
    } else if (new Char(97) <= curChar ? curChar <= new Char(102) : false) {
      tmp = (curChar.toInt_5() - 97 | 0) + 10 | 0;
    } else if (new Char(65) <= curChar ? curChar <= new Char(70) : false) {
      tmp = (curChar.toInt_5() - 65 | 0) + 10 | 0;
    } else {
      var tmp_0 = '' + "Invalid toHexChar char '" + curChar + "' in unicode escape";
      $this.fail$default(tmp_0, 0, 2, null);
    }
    return tmp;
  }
  function JsonReader(source) {
    this._source = source;
    this._currentPosition = 0;
    this._tokenClass = 12;
    this._tokenPosition = 0;
    this._offset = -1;
    this._length = 0;
    this._buf = charArray(16);
    this.nextToken();
  }
  JsonReader.prototype._get_isDone_ = function () {
    return this._tokenClass === 12;
  };
  JsonReader.prototype._get_canBeginValue_ = function () {
    var tmp0_subject = this._tokenClass;
    return ((((tmp0_subject === 8 ? true : tmp0_subject === 6) ? true : tmp0_subject === 0) ? true : tmp0_subject === 1) ? true : tmp0_subject === 10) ? true : false;
  };
  JsonReader.prototype.takeString = function () {
    if (!(this._tokenClass === 0) ? !(this._tokenClass === 1) : false) {
      this.fail('Expected string or non-null literal', this._tokenPosition);
    }return takeStringInternal$default(this, false, 2, null);
  };
  JsonReader.prototype.peekString = function (isLenient) {
    return (!(this._tokenClass === 1) ? !isLenient ? true : !(this._tokenClass === 0) : false) ? null : takeStringInternal(this, false);
  };
  JsonReader.prototype.takeStringQuoted = function () {
    var tmp0_subject = this._tokenClass;
    if (tmp0_subject === 1) {
    } else if (tmp0_subject === 10) {
      this.fail("Expected string literal but 'null' literal was found.\nUse 'coerceInputValues = true' in 'Json {}` builder to coerce nulls to default values.", this._tokenPosition);
    } else {
      this.fail("Expected string literal with quotes.\nUse 'isLenient = true' in 'Json {}` builder to accept non-compliant JSON.", this._tokenPosition);
    }
    return takeStringInternal$default(this, false, 2, null);
  };
  JsonReader.prototype.takeBooleanStringUnquoted = function () {
    if (!(this._tokenClass === 0)) {
      this.fail("Expected start of the unquoted boolean literal.\nUse 'isLenient = true' in 'Json {}` builder to accept non-compliant JSON.", this._tokenPosition);
    }return takeStringInternal$default(this, false, 2, null);
  };
  JsonReader.prototype.nextToken = function () {
    var source = this._source;
    var currentPosition = this._currentPosition;
    while (currentPosition < source.length) {
      var ch = charSequenceGet(source, currentPosition);
      var tc = charToTokenClass(ch);
      if (tc === 3) {
        var tmp0 = currentPosition;
        currentPosition = tmp0 + 1 | 0;
        Unit_getInstance();
      } else if (tc === 0) {
        nextLiteral(this, source, currentPosition);
        return Unit_getInstance();
      } else if (tc === 1) {
        nextString(this, source, currentPosition);
        return Unit_getInstance();
      } else {
        this._tokenPosition = currentPosition;
        this._tokenClass = tc;
        this._currentPosition = currentPosition + 1 | 0;
        return Unit_getInstance();
      }
    }
    this._tokenPosition = currentPosition;
    this._tokenClass = 12;
  };
  JsonReader.prototype.skipElement = function () {
    if (!(this._tokenClass === 6) ? !(this._tokenClass === 8) : false) {
      this.nextToken();
      return Unit_getInstance();
    }var tokenStack = ArrayList_init_$Create$();
    $l$1: do {
      $l$0: do {
        var tmp0_subject = this._tokenClass;
        if (tmp0_subject === 8 ? true : tmp0_subject === 6) {
          tokenStack.add_33(this._tokenClass);
          Unit_getInstance();
        } else if (tmp0_subject === 9) {
          if (!(last(tokenStack) === 8))
            throw JsonDecodingException_0(this._currentPosition, 'found ] instead of }', this._source);
          tokenStack.removeAt_2(tokenStack._get_size__45() - 1 | 0);
          Unit_getInstance();
        } else if (tmp0_subject === 7) {
          if (!(last(tokenStack) === 6))
            throw JsonDecodingException_0(this._currentPosition, 'found } instead of ]', this._source);
          tokenStack.removeAt_2(tokenStack._get_size__45() - 1 | 0);
          Unit_getInstance();
        }this.nextToken();
      }
       while (false);
    }
     while (!tokenStack.isEmpty_53());
  };
  JsonReader.prototype.toString = function () {
    return '' + "JsonReader(source='" + this._source + "', currentPosition=" + this._currentPosition + ', tokenClass=' + this._tokenClass + ', tokenPosition=' + this._tokenPosition + ', offset=' + this._offset + ')';
  };
  JsonReader.prototype.fail = function (message, position) {
    throw JsonDecodingException_0(position, message, this._source);
  };
  JsonReader.prototype.fail$default = function (message, position, $mask0, $handler) {
    if (!(($mask0 & 2) === 0))
      position = this._currentPosition;
    return this.fail(message, position);
  };
  JsonReader.$metadata$ = {
    simpleName: 'JsonReader',
    kind: 'class',
    interfaces: []
  };
  function charToTokenClass(c) {
    return c.toInt_5() < 126 ? CharMappings_getInstance()._C2TC[c.toInt_5()] : 0;
  }
  function rangeEquals(source, start, length, str) {
    var n = str.length;
    if (!(length === n))
      return false;
    var inductionVariable = 0;
    if (inductionVariable < n)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (!charSequenceGet(source, start + i | 0).equals(charSequenceGet(str, i)))
          return false;
      }
       while (inductionVariable < n);
    return true;
  }
  function escapeToChar(c) {
    return c < 117 ? CharMappings_getInstance()._ESCAPE_2_CHAR[c] : new Char(0);
  }
  function initEscape($this) {
    var inductionVariable = 0;
    if (inductionVariable <= 31)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        initC2ESC($this, i, new Char(117));
      }
       while (inductionVariable <= 31);
    initC2ESC($this, 8, new Char(98));
    initC2ESC($this, 9, new Char(116));
    initC2ESC($this, 10, new Char(110));
    initC2ESC($this, 12, new Char(102));
    initC2ESC($this, 13, new Char(114));
    initC2ESC_0($this, new Char(47), new Char(47));
    initC2ESC_0($this, new Char(34), new Char(34));
    initC2ESC_0($this, new Char(92), new Char(92));
  }
  function initCharToToken($this) {
    var inductionVariable = 0;
    if (inductionVariable <= 32)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        initC2TC($this, i, 11);
      }
       while (inductionVariable <= 32);
    initC2TC($this, 9, 3);
    initC2TC($this, 10, 3);
    initC2TC($this, 13, 3);
    initC2TC($this, 32, 3);
    initC2TC_0($this, new Char(44), 4);
    initC2TC_0($this, new Char(58), 5);
    initC2TC_0($this, new Char(123), 6);
    initC2TC_0($this, new Char(125), 7);
    initC2TC_0($this, new Char(91), 8);
    initC2TC_0($this, new Char(93), 9);
    initC2TC_0($this, new Char(34), 1);
    initC2TC_0($this, new Char(92), 2);
  }
  function initC2ESC($this, c, esc) {
    if (!esc.equals(new Char(117)))
      $this._ESCAPE_2_CHAR[esc.toInt_5()] = numberToChar(c);
  }
  function initC2ESC_0($this, c, esc) {
    return initC2ESC($this, c.toInt_5(), esc);
  }
  function initC2TC($this, c, cl) {
    $this._C2TC[c] = cl;
  }
  function initC2TC_0($this, c, cl) {
    return initC2TC($this, c.toInt_5(), cl);
  }
  function CharMappings() {
    CharMappings_instance = this;
    this._ESCAPE_2_CHAR = charArray(117);
    this._C2TC = new Int8Array(126);
    initEscape(this);
    initCharToToken(this);
  }
  CharMappings.$metadata$ = {
    simpleName: 'CharMappings',
    kind: 'object',
    interfaces: []
  };
  var CharMappings_instance;
  function CharMappings_getInstance() {
    if (CharMappings_instance == null)
      new CharMappings();
    return CharMappings_instance;
  }
  function decodeSerializableValuePolymorphic(_this_, deserializer) {
    var tmp;
    if (!(deserializer instanceof AbstractPolymorphicSerializer)) {
      tmp = true;
    } else {
      {
        tmp = _this_._get_json__6()._configuration._useArrayPolymorphism_0;
      }
    }
    if (tmp) {
      return deserializer.deserialize_52(_this_);
    } else {
    }
    var tmp0_cast_0 = _this_.decodeJsonElement_4();
    var tmp1_cast_0 = deserializer._get_descriptor__48();
    if (!(tmp0_cast_0 instanceof JsonObject)) {
      throw JsonDecodingException_1(-1, '' + 'Expected ' + getKClass_0(JsonObject) + ' as the serialized body of ' + tmp1_cast_0._get_serialName__16() + ', but had ' + getKClassFromExpression_0(tmp0_cast_0));
    } else {
    }
    var jsonTree = tmp0_cast_0;
    var discriminator = _this_._get_json__6()._configuration._classDiscriminator_0;
    var tmp0_safe_receiver = jsonTree.get_69(discriminator);
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : _get_jsonPrimitive_(tmp0_safe_receiver);
    var type = tmp1_safe_receiver == null ? null : tmp1_safe_receiver._get_content__6();
    var tmp2_elvis_lhs = deserializer.findPolymorphicSerializerOrNull(_this_, type);
    var tmp_0;
    if (tmp2_elvis_lhs == null) {
      throwSerializerNotFound(type, jsonTree);
    } else {
      tmp_0 = tmp2_elvis_lhs;
    }
    var actualSerializer = tmp_0;
    var tmp_1 = _this_._get_json__6();
    return readPolymorphicJson(tmp_1, discriminator, jsonTree, isInterface(actualSerializer, DeserializationStrategy) ? actualSerializer : THROW_CCE());
  }
  function findActualSerializer(_this_, serializer_16, value) {
    var casted = serializer_16 instanceof AbstractPolymorphicSerializer ? serializer_16 : THROW_CCE();
    var actualSerializer = findPolymorphicSerializer(casted, _this_, isObject(value) ? value : THROW_CCE());
    validateIfSealed(casted, actualSerializer, _this_._get_json__6()._configuration._classDiscriminator_0);
    var kind = actualSerializer._get_descriptor__48()._get_kind__16();
    checkKind(kind);
    return actualSerializer;
  }
  function throwSerializerNotFound(type, jsonTree) {
    var suffix = type == null ? "missing class discriminator ('null')" : '' + "class discriminator '" + type + "'";
    throw JsonDecodingException_0(-1, '' + 'Polymorphic serializer was not found for ' + suffix, jsonTree.toString());
  }
  function validateIfSealed(serializer_16, actualSerializer, classDiscriminator) {
    if (!(serializer_16 instanceof SealedClassSerializer))
      return Unit_getInstance();
    else {
    }
    if (jsonCachedSerialNames(actualSerializer._get_descriptor__48()).contains_51(classDiscriminator)) {
      var baseName = serializer_16._get_descriptor__48()._get_serialName__16();
      var actualName = actualSerializer._get_descriptor__48()._get_serialName__16();
      var tmp0_error_0 = '' + "Sealed class '" + actualName + "' cannot be serialized as base class '" + baseName + "' because" + ('' + " it has property name that conflicts with JSON class discriminator '" + classDiscriminator + "'. ") + 'You can either change class discriminator in JsonConfiguration, ' + 'rename property with @SerialName annotation or fall back to array polymorphism';
      throw IllegalStateException_init_$Create$(toString_1(tmp0_error_0));
    }}
  function checkKind(kind) {
    if (kind instanceof ENUM) {
      var tmp0_error_0 = "Enums cannot be serialized polymorphically with 'type' parameter. You can use 'JsonBuilder.useArrayPolymorphism' instead";
      throw IllegalStateException_init_$Create$(toString_1(tmp0_error_0));
    } else {
    }
    if (kind instanceof PrimitiveKind) {
      var tmp1_error_0 = "Primitives cannot be serialized polymorphically with 'type' parameter. You can use 'JsonBuilder.useArrayPolymorphism' instead";
      throw IllegalStateException_init_$Create$(toString_1(tmp1_error_0));
    } else {
    }
    if (kind instanceof PolymorphicKind) {
      var tmp2_error_0 = 'Actual serializer for polymorphic cannot be polymorphic itself';
      throw IllegalStateException_init_$Create$(toString_1(tmp2_error_0));
    } else {
    }
  }
  function checkKind_0($this, descriptor, actualClass) {
    var kind = descriptor._get_kind__16();
    var tmp;
    if (kind instanceof PolymorphicKind) {
      tmp = true;
    } else {
      {
        tmp = equals_1(kind, CONTEXTUAL_getInstance());
      }
    }
    if (tmp) {
      throw IllegalArgumentException_init_$Create$_0('' + 'Serializer for ' + actualClass._get_simpleName__4() + " can't be registered as a subclass for polymorphic serialization " + ('' + 'because its kind ' + kind + ' is not concrete. To work with multiple hierarchies, register it as a base class.'));
    } else {
    }
    if ($this._useArrayPolymorphism_1)
      return Unit_getInstance();
    var tmp_0;
    var tmp_1;
    if (equals_1(kind, LIST_getInstance()) ? true : equals_1(kind, MAP_getInstance())) {
      tmp_1 = true;
    } else {
      tmp_1 = kind instanceof PrimitiveKind;
    }
    if (tmp_1) {
      tmp_0 = true;
    } else {
      {
        tmp_0 = kind instanceof ENUM;
      }
    }
    if (tmp_0) {
      throw IllegalArgumentException_init_$Create$_0('' + 'Serializer for ' + actualClass._get_simpleName__4() + ' of kind ' + kind + ' cannot be serialized polymorphically with class discriminator.');
    } else {
    }
  }
  function checkDiscriminatorCollisions($this, descriptor, actualClass) {
    var inductionVariable = 0;
    var last_1 = descriptor._get_elementsCount__16();
    if (inductionVariable < last_1)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var name = descriptor.getElementName_16(i);
        if (name === $this._discriminator) {
          throw IllegalArgumentException_init_$Create$_0('' + 'Polymorphic serializer for ' + actualClass + " has property '" + name + "' that conflicts " + 'with JSON class discriminator. You can either change class discriminator in JsonConfiguration, ' + 'rename property with @SerialName annotation ' + 'or fall back to array polymorphism');
        }}
       while (inductionVariable < last_1);
  }
  function PolymorphismValidator(useArrayPolymorphism, discriminator) {
    this._useArrayPolymorphism_1 = useArrayPolymorphism;
    this._discriminator = discriminator;
  }
  PolymorphismValidator.prototype.contextual_0 = function (kClass, serializer_16) {
  };
  PolymorphismValidator.prototype.polymorphic_0 = function (baseClass, actualClass, actualSerializer) {
    var descriptor = actualSerializer._get_descriptor__48();
    checkKind_0(this, descriptor, actualClass);
    if (!this._useArrayPolymorphism_1) {
      checkDiscriminatorCollisions(this, descriptor, actualClass);
    }};
  PolymorphismValidator.prototype.polymorphicDefault_0 = function (baseClass, defaultSerializerProvider) {
  };
  PolymorphismValidator.$metadata$ = {
    simpleName: 'PolymorphismValidator',
    kind: 'class',
    interfaces: [SerializersModuleCollector]
  };
  function decodeMapIndex($this, tokenClass) {
    if (!(tokenClass === 4) ? $this._currentIndex % 2 === 1 : false) {
      var tmp0_requireTokenClass_0 = $this._reader_0;
      var tmp1_requireTokenClass_0 = 7;
      if (!(tmp0_requireTokenClass_0._tokenClass === tmp1_requireTokenClass_0)) {
        var tmp2__anonymous__1 = numberToChar(tmp0_requireTokenClass_0._tokenClass);
        tmp0_requireTokenClass_0.fail('Expected end of the object or comma', tmp0_requireTokenClass_0._tokenPosition);
      }}if ($this._currentIndex % 2 === 0) {
      var tmp3_requireTokenClass_0 = $this._reader_0;
      var tmp4_requireTokenClass_0 = 5;
      if (!(tmp3_requireTokenClass_0._tokenClass === tmp4_requireTokenClass_0)) {
        var tmp5__anonymous__1 = numberToChar(tmp3_requireTokenClass_0._tokenClass);
        tmp3_requireTokenClass_0.fail("Expected ':' after the key", tmp3_requireTokenClass_0._tokenPosition);
      }$this._reader_0.nextToken();
    }var tmp;
    if (!$this._reader_0._get_canBeginValue_()) {
      var tmp6_require_0 = $this._reader_0;
      var tmp7_require_0 = !(tokenClass === 4);
      var tmp8_require_0 = tmp6_require_0._currentPosition;
      if (!tmp7_require_0) {
        tmp6_require_0.fail('Unexpected trailing comma', tmp8_require_0);
      }tmp = -1;
    } else {
      var tmp0_this = $this;
      tmp0_this._currentIndex = tmp0_this._currentIndex + 1 | 0;
      tmp = tmp0_this._currentIndex;
    }
    return tmp;
  }
  function coerceInputValue($this, descriptor, index) {
    var elementDescriptor = descriptor.getElementDescriptor_16(index);
    if ($this._reader_0._tokenClass === 10 ? !elementDescriptor._get_isNullable__16() : false)
      return true;
    if (equals_1(elementDescriptor._get_kind__16(), ENUM_getInstance())) {
      var tmp0_elvis_lhs = $this._reader_0.peekString($this._configuration_0._isLenient_0);
      var tmp;
      if (tmp0_elvis_lhs == null) {
        return false;
      } else {
        tmp = tmp0_elvis_lhs;
      }
      var enumValue = tmp;
      var enumIndex = elementDescriptor.getElementIndex_16(enumValue);
      if (enumIndex === -3)
        return true;
    }return false;
  }
  function decodeObjectIndex($this, tokenClass, descriptor) {
    if (tokenClass === 4 ? !$this._reader_0._get_canBeginValue_() : false) {
      $this._reader_0.fail$default('Unexpected trailing comma', 0, 2, null);
    }while ($this._reader_0._get_canBeginValue_()) {
      var tmp0_this = $this;
      tmp0_this._currentIndex = tmp0_this._currentIndex + 1 | 0;
      Unit_getInstance();
      var key = $this.decodeString_8();
      var tmp0_requireTokenClass_0 = $this._reader_0;
      var tmp1_requireTokenClass_0 = 5;
      if (!(tmp0_requireTokenClass_0._tokenClass === tmp1_requireTokenClass_0)) {
        var tmp2__anonymous__1 = numberToChar(tmp0_requireTokenClass_0._tokenClass);
        tmp0_requireTokenClass_0.fail("Expected ':'", tmp0_requireTokenClass_0._tokenPosition);
      }$this._reader_0.nextToken();
      var index = descriptor.getElementIndex_16(key);
      var tmp;
      if (!(index === -3)) {
        var tmp_0;
        if ($this._configuration_0._coerceInputValues_0 ? coerceInputValue($this, descriptor, index) : false) {
          tmp_0 = false;
        } else {
          return index;
        }
        tmp = tmp_0;
      } else {
        tmp = true;
      }
      var isUnknown = tmp;
      if (isUnknown ? !$this._configuration_0._ignoreUnknownKeys_0 : false) {
        var tmp_1 = '' + "Encountered an unknown key '" + key + "'.\nUse 'ignoreUnknownKeys = true' in 'Json {}' builder to ignore unknown keys.";
        $this._reader_0.fail$default(tmp_1, 0, 2, null);
      } else {
        $this._reader_0.skipElement();
      }
      if ($this._reader_0._tokenClass === 4) {
        $this._reader_0.nextToken();
        var tmp3_require_0 = $this._reader_0;
        var tmp4_require_0 = $this._reader_0._get_canBeginValue_();
        var tmp5_require_0 = $this._reader_0._currentPosition;
        if (!tmp4_require_0) {
          tmp3_require_0.fail('Unexpected trailing comma', tmp5_require_0);
        }}}
    return -1;
  }
  function decodeListIndex($this, tokenClass) {
    if (!(tokenClass === 4) ? !($this._currentIndex === -1) : false) {
      var tmp0_requireTokenClass_0 = $this._reader_0;
      var tmp1_requireTokenClass_0 = 9;
      if (!(tmp0_requireTokenClass_0._tokenClass === tmp1_requireTokenClass_0)) {
        var tmp2__anonymous__1 = numberToChar(tmp0_requireTokenClass_0._tokenClass);
        tmp0_requireTokenClass_0.fail('Expected end of the array or comma', tmp0_requireTokenClass_0._tokenPosition);
      }}var tmp;
    if (!$this._reader_0._get_canBeginValue_()) {
      var tmp3_require_0 = $this._reader_0;
      var tmp4_require_0 = !(tokenClass === 4);
      var tmp5_require_0 = tmp3_require_0._currentPosition;
      if (!tmp4_require_0) {
        tmp3_require_0.fail('Unexpected trailing comma', tmp5_require_0);
      }tmp = -1;
    } else {
      var tmp0_this = $this;
      tmp0_this._currentIndex = tmp0_this._currentIndex + 1 | 0;
      tmp = tmp0_this._currentIndex;
    }
    return tmp;
  }
  function StreamingJsonDecoder(json, mode, reader) {
    AbstractDecoder.call(this);
    this._json = json;
    this._mode = mode;
    this._reader_0 = reader;
    this._serializersModule_1 = this._get_json__6()._get_serializersModule__14();
    this._currentIndex = -1;
    this._configuration_0 = this._get_json__6()._configuration;
  }
  StreamingJsonDecoder.prototype._get_json__6 = function () {
    return this._json;
  };
  StreamingJsonDecoder.prototype._get_serializersModule__14 = function () {
    return this._serializersModule_1;
  };
  StreamingJsonDecoder.prototype.decodeJsonElement_4 = function () {
    return (new JsonParser(this._get_json__6()._configuration, this._reader_0)).read_0();
  };
  StreamingJsonDecoder.prototype.decodeSerializableValue_16 = function (deserializer) {
    return decodeSerializableValuePolymorphic(this, deserializer);
  };
  StreamingJsonDecoder.prototype.beginStructure_11 = function (descriptor) {
    var newMode = switchMode(this._get_json__6(), descriptor);
    if (!newMode._begin.equals(new Char(0))) {
      var tmp0_requireTokenClass_0 = this._reader_0;
      var tmp1_requireTokenClass_0 = newMode._beginTc;
      if (!(tmp0_requireTokenClass_0._tokenClass === tmp1_requireTokenClass_0)) {
        var tmp2__anonymous__1 = numberToChar(tmp0_requireTokenClass_0._tokenClass);
        tmp0_requireTokenClass_0.fail('' + "Expected '" + newMode._begin + ', kind: ' + descriptor._get_kind__16() + "'", tmp0_requireTokenClass_0._tokenPosition);
      }this._reader_0.nextToken();
    }var tmp0_subject = newMode;
    return ((tmp0_subject.equals(WriteMode_LIST_getInstance()) ? true : tmp0_subject.equals(WriteMode_MAP_getInstance())) ? true : tmp0_subject.equals(WriteMode_POLY_OBJ_getInstance())) ? new StreamingJsonDecoder(this._get_json__6(), newMode, this._reader_0) : this._mode.equals(newMode) ? this : new StreamingJsonDecoder(this._get_json__6(), newMode, this._reader_0);
  };
  StreamingJsonDecoder.prototype.endStructure_11 = function (descriptor) {
    if (!this._mode._end.equals(new Char(0))) {
      var tmp0_requireTokenClass_0 = this._reader_0;
      var tmp1_requireTokenClass_0 = this._mode._endTc;
      if (!(tmp0_requireTokenClass_0._tokenClass === tmp1_requireTokenClass_0)) {
        var tmp2__anonymous__1 = numberToChar(tmp0_requireTokenClass_0._tokenClass);
        tmp0_requireTokenClass_0.fail('' + "Expected '" + this._mode._end + "'", tmp0_requireTokenClass_0._tokenPosition);
      }this._reader_0.nextToken();
    }};
  StreamingJsonDecoder.prototype.decodeNotNullMark_8 = function () {
    return !(this._reader_0._tokenClass === 10);
  };
  StreamingJsonDecoder.prototype.decodeNull_8 = function () {
    var tmp0_requireTokenClass_0 = this._reader_0;
    var tmp1_requireTokenClass_0 = 10;
    if (!(tmp0_requireTokenClass_0._tokenClass === tmp1_requireTokenClass_0)) {
      var tmp2__anonymous__1 = numberToChar(tmp0_requireTokenClass_0._tokenClass);
      tmp0_requireTokenClass_0.fail("Expected 'null' literal", tmp0_requireTokenClass_0._tokenPosition);
    }this._reader_0.nextToken();
    return null;
  };
  StreamingJsonDecoder.prototype.decodeElementIndex_8 = function (descriptor) {
    var tokenClass = this._reader_0._tokenClass;
    if (tokenClass === 4) {
      var tmp0_require_0 = this._reader_0;
      var tmp1_require_0 = !(this._currentIndex === -1);
      var tmp2_require_0 = this._reader_0._currentPosition;
      if (!tmp1_require_0) {
        tmp0_require_0.fail('Unexpected leading comma', tmp2_require_0);
      }this._reader_0.nextToken();
    }var tmp0_subject = this._mode;
    var tmp;
    if (tmp0_subject.equals(WriteMode_LIST_getInstance())) {
      tmp = decodeListIndex(this, tokenClass);
    } else if (tmp0_subject.equals(WriteMode_MAP_getInstance())) {
      tmp = decodeMapIndex(this, tokenClass);
    } else if (tmp0_subject.equals(WriteMode_POLY_OBJ_getInstance())) {
      var tmp1_this = this;
      tmp1_this._currentIndex = tmp1_this._currentIndex + 1 | 0;
      var tmp2_subject = tmp1_this._currentIndex;
      var tmp_0;
      switch (tmp2_subject) {
        case 0:
          tmp_0 = 0;
          break;
        case 1:
          tmp_0 = 1;
          break;
        default:tmp_0 = -1;
          break;
      }
      tmp = tmp_0;
    } else {
      tmp = decodeObjectIndex(this, tokenClass, descriptor);
    }
    return tmp;
  };
  StreamingJsonDecoder.prototype.decodeBoolean_8 = function () {
    var tmp;
    if (this._configuration_0._isLenient_0) {
      tmp = this._reader_0.takeString();
    } else {
      tmp = this._reader_0.takeBooleanStringUnquoted();
    }
    var string = tmp;
    var tmp0_safe_receiver = toBooleanStrictOrNull(string);
    if (tmp0_safe_receiver == null)
      null;
    else {
      return tmp0_safe_receiver;
    }
    Unit_getInstance();
    var tmp_0 = '' + "Failed to parse type 'boolean' for input '" + string + "'";
    this._reader_0.fail$default(tmp_0, 0, 2, null);
  };
  StreamingJsonDecoder.prototype.decodeByte_8 = function () {
    var tmp$ret$0;
    l$ret$1: do {
      var tmp0_parseString_0 = this._reader_0;
      var tmp1_parseString_0 = 'byte';
      var input_1 = tmp0_parseString_0.takeString();
      try {
        tmp$ret$0 = toByte(input_1);
        break l$ret$1;
      } catch ($p) {
        if ($p instanceof IllegalArgumentException) {
          var tmp = '' + "Failed to parse type '" + tmp1_parseString_0 + "' for input '" + input_1 + "'";
          tmp0_parseString_0.fail$default(tmp, 0, 2, null);
        } else {
          {
            throw $p;
          }
        }
      }
    }
     while (false);
    return tmp$ret$0;
  };
  StreamingJsonDecoder.prototype.decodeShort_8 = function () {
    var tmp$ret$0;
    l$ret$1: do {
      var tmp0_parseString_0 = this._reader_0;
      var tmp1_parseString_0 = 'short';
      var input_1 = tmp0_parseString_0.takeString();
      try {
        tmp$ret$0 = toShort(input_1);
        break l$ret$1;
      } catch ($p) {
        if ($p instanceof IllegalArgumentException) {
          var tmp = '' + "Failed to parse type '" + tmp1_parseString_0 + "' for input '" + input_1 + "'";
          tmp0_parseString_0.fail$default(tmp, 0, 2, null);
        } else {
          {
            throw $p;
          }
        }
      }
    }
     while (false);
    return tmp$ret$0;
  };
  StreamingJsonDecoder.prototype.decodeInt_8 = function () {
    var tmp$ret$0;
    l$ret$1: do {
      var tmp0_parseString_0 = this._reader_0;
      var tmp1_parseString_0 = 'int';
      var input_1 = tmp0_parseString_0.takeString();
      try {
        tmp$ret$0 = toInt(input_1);
        break l$ret$1;
      } catch ($p) {
        if ($p instanceof IllegalArgumentException) {
          var tmp = '' + "Failed to parse type '" + tmp1_parseString_0 + "' for input '" + input_1 + "'";
          tmp0_parseString_0.fail$default(tmp, 0, 2, null);
        } else {
          {
            throw $p;
          }
        }
      }
    }
     while (false);
    return tmp$ret$0;
  };
  StreamingJsonDecoder.prototype.decodeLong_8 = function () {
    var tmp$ret$0;
    l$ret$1: do {
      var tmp0_parseString_0 = this._reader_0;
      var tmp1_parseString_0 = 'long';
      var input_1 = tmp0_parseString_0.takeString();
      try {
        tmp$ret$0 = toLong(input_1);
        break l$ret$1;
      } catch ($p) {
        if ($p instanceof IllegalArgumentException) {
          var tmp = '' + "Failed to parse type '" + tmp1_parseString_0 + "' for input '" + input_1 + "'";
          tmp0_parseString_0.fail$default(tmp, 0, 2, null);
        } else {
          {
            throw $p;
          }
        }
      }
    }
     while (false);
    return tmp$ret$0;
  };
  StreamingJsonDecoder.prototype.decodeFloat_8 = function () {
    var tmp$ret$0;
    l$ret$1: do {
      var tmp0_parseString_0 = this._reader_0;
      var tmp1_parseString_0 = 'float';
      var input_1 = tmp0_parseString_0.takeString();
      try {
        var tmp0_unsafeCast_0_1_4 = toDouble(input_1);
        tmp$ret$0 = tmp0_unsafeCast_0_1_4;
        break l$ret$1;
      } catch ($p) {
        if ($p instanceof IllegalArgumentException) {
          var tmp = '' + "Failed to parse type '" + tmp1_parseString_0 + "' for input '" + input_1 + "'";
          tmp0_parseString_0.fail$default(tmp, 0, 2, null);
        } else {
          {
            throw $p;
          }
        }
      }
    }
     while (false);
    var result = tmp$ret$0;
    var specialFp = this._get_json__6()._configuration._allowSpecialFloatingPointValues_0;
    if (specialFp ? true : isFinite_0(result))
      return result;
    throwInvalidFloatingPointDecoded(this._reader_0, result);
  };
  StreamingJsonDecoder.prototype.decodeDouble_8 = function () {
    var tmp$ret$0;
    l$ret$1: do {
      var tmp0_parseString_0 = this._reader_0;
      var tmp1_parseString_0 = 'double';
      var input_1 = tmp0_parseString_0.takeString();
      try {
        tmp$ret$0 = toDouble(input_1);
        break l$ret$1;
      } catch ($p) {
        if ($p instanceof IllegalArgumentException) {
          var tmp = '' + "Failed to parse type '" + tmp1_parseString_0 + "' for input '" + input_1 + "'";
          tmp0_parseString_0.fail$default(tmp, 0, 2, null);
        } else {
          {
            throw $p;
          }
        }
      }
    }
     while (false);
    var result = tmp$ret$0;
    var specialFp = this._get_json__6()._configuration._allowSpecialFloatingPointValues_0;
    if (specialFp ? true : isFinite(result))
      return result;
    throwInvalidFloatingPointDecoded(this._reader_0, result);
  };
  StreamingJsonDecoder.prototype.decodeChar_8 = function () {
    var tmp$ret$0;
    l$ret$1: do {
      var tmp0_parseString_0 = this._reader_0;
      var tmp1_parseString_0 = 'char';
      var input_1 = tmp0_parseString_0.takeString();
      try {
        tmp$ret$0 = single_2(input_1);
        break l$ret$1;
      } catch ($p) {
        if ($p instanceof IllegalArgumentException) {
          var tmp = '' + "Failed to parse type '" + tmp1_parseString_0 + "' for input '" + input_1 + "'";
          tmp0_parseString_0.fail$default(tmp, 0, 2, null);
        } else {
          {
            throw $p;
          }
        }
      }
    }
     while (false);
    return tmp$ret$0;
  };
  StreamingJsonDecoder.prototype.decodeString_8 = function () {
    var tmp;
    if (this._configuration_0._isLenient_0) {
      tmp = this._reader_0.takeString();
    } else {
      tmp = this._reader_0.takeStringQuoted();
    }
    return tmp;
  };
  StreamingJsonDecoder.prototype.decodeInline_8 = function (inlineDescriptor) {
    return _get_isUnsignedNumber_(inlineDescriptor) ? new JsonDecoderForUnsignedTypes(this._reader_0, this._get_json__6()) : this;
  };
  StreamingJsonDecoder.$metadata$ = {
    simpleName: 'StreamingJsonDecoder',
    kind: 'class',
    interfaces: [JsonDecoder]
  };
  function JsonDecoderForUnsignedTypes(reader, json) {
    AbstractDecoder.call(this);
    this._reader_1 = reader;
    this._serializersModule_2 = json._get_serializersModule__14();
  }
  JsonDecoderForUnsignedTypes.prototype._get_serializersModule__14 = function () {
    return this._serializersModule_2;
  };
  JsonDecoderForUnsignedTypes.prototype.decodeElementIndex_8 = function (descriptor) {
    var tmp0_error_0 = 'unsupported';
    throw IllegalStateException_init_$Create$(toString_1(tmp0_error_0));
  };
  JsonDecoderForUnsignedTypes.prototype.decodeInt_8 = function () {
    var tmp$ret$0;
    l$ret$1: do {
      var tmp0_parseString_0 = this._reader_1;
      var tmp1_parseString_0 = 'UInt';
      var input_1 = tmp0_parseString_0.takeString();
      try {
        var tmp0_toInt_0_4 = toUInt(input_1);
        tmp$ret$0 = _UInt___get_data__impl_(tmp0_toInt_0_4);
        break l$ret$1;
      } catch ($p) {
        if ($p instanceof IllegalArgumentException) {
          var tmp = '' + "Failed to parse type '" + tmp1_parseString_0 + "' for input '" + input_1 + "'";
          tmp0_parseString_0.fail$default(tmp, 0, 2, null);
        } else {
          {
            throw $p;
          }
        }
      }
    }
     while (false);
    return tmp$ret$0;
  };
  JsonDecoderForUnsignedTypes.prototype.decodeLong_8 = function () {
    var tmp$ret$0;
    l$ret$1: do {
      var tmp0_parseString_0 = this._reader_1;
      var tmp1_parseString_0 = 'ULong';
      var input_1 = tmp0_parseString_0.takeString();
      try {
        var tmp0_toLong_0_4 = toULong(input_1);
        tmp$ret$0 = _ULong___get_data__impl_(tmp0_toLong_0_4);
        break l$ret$1;
      } catch ($p) {
        if ($p instanceof IllegalArgumentException) {
          var tmp = '' + "Failed to parse type '" + tmp1_parseString_0 + "' for input '" + input_1 + "'";
          tmp0_parseString_0.fail$default(tmp, 0, 2, null);
        } else {
          {
            throw $p;
          }
        }
      }
    }
     while (false);
    return tmp$ret$0;
  };
  JsonDecoderForUnsignedTypes.prototype.decodeByte_8 = function () {
    var tmp$ret$0;
    l$ret$1: do {
      var tmp0_parseString_0 = this._reader_1;
      var tmp1_parseString_0 = 'UByte';
      var input_1 = tmp0_parseString_0.takeString();
      try {
        var tmp0_toByte_0_4 = toUByte(input_1);
        tmp$ret$0 = _UByte___get_data__impl_(tmp0_toByte_0_4);
        break l$ret$1;
      } catch ($p) {
        if ($p instanceof IllegalArgumentException) {
          var tmp = '' + "Failed to parse type '" + tmp1_parseString_0 + "' for input '" + input_1 + "'";
          tmp0_parseString_0.fail$default(tmp, 0, 2, null);
        } else {
          {
            throw $p;
          }
        }
      }
    }
     while (false);
    return tmp$ret$0;
  };
  JsonDecoderForUnsignedTypes.prototype.decodeShort_8 = function () {
    var tmp$ret$0;
    l$ret$1: do {
      var tmp0_parseString_0 = this._reader_1;
      var tmp1_parseString_0 = 'UShort';
      var input_1 = tmp0_parseString_0.takeString();
      try {
        var tmp0_toShort_0_4 = toUShort(input_1);
        tmp$ret$0 = _UShort___get_data__impl_(tmp0_toShort_0_4);
        break l$ret$1;
      } catch ($p) {
        if ($p instanceof IllegalArgumentException) {
          var tmp = '' + "Failed to parse type '" + tmp1_parseString_0 + "' for input '" + input_1 + "'";
          tmp0_parseString_0.fail$default(tmp, 0, 2, null);
        } else {
          {
            throw $p;
          }
        }
      }
    }
     while (false);
    return tmp$ret$0;
  };
  JsonDecoderForUnsignedTypes.$metadata$ = {
    simpleName: 'JsonDecoderForUnsignedTypes',
    kind: 'class',
    interfaces: []
  };
  var unsignedNumberDescriptors;
  function StreamingJsonEncoder_init_$Init$(output, json, mode, modeReuseCache, $this) {
    StreamingJsonEncoder.call($this, new Composer(output, json), json, mode, modeReuseCache);
    return $this;
  }
  function StreamingJsonEncoder_init_$Create$(output, json, mode, modeReuseCache) {
    return StreamingJsonEncoder_init_$Init$(output, json, mode, modeReuseCache, Object.create(StreamingJsonEncoder.prototype));
  }
  function encodeTypeInfo($this, descriptor) {
    $this._composer.nextItem_0();
    $this.encodeString_1($this._configuration_1._classDiscriminator_0);
    $this._composer.print_13(new Char(58));
    Unit_getInstance();
    $this._composer.space_0();
    $this.encodeString_1(descriptor._get_serialName__16());
  }
  function Composer(sb, json) {
    this._sb = sb;
    this._json_0 = json;
    this._level = 0;
    this._writingFirst = true;
  }
  Composer.prototype.indent_0 = function () {
    this._writingFirst = true;
    var tmp0_this = this;
    var tmp1 = tmp0_this._level;
    tmp0_this._level = tmp1 + 1 | 0;
    Unit_getInstance();
  };
  Composer.prototype.unIndent_0 = function () {
    var tmp0_this = this;
    var tmp1 = tmp0_this._level;
    tmp0_this._level = tmp1 - 1 | 0;
    Unit_getInstance();
  };
  Composer.prototype.nextItem_0 = function () {
    this._writingFirst = false;
    if (this._json_0._configuration._prettyPrint_0) {
      this.print_14('\n');
      Unit_getInstance();
      var tmp0_repeat_0 = this._level;
      var inductionVariable = 0;
      if (inductionVariable < tmp0_repeat_0)
        do {
          var index_2 = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          this.print_14(this._json_0._configuration._prettyPrintIndent_0);
          Unit_getInstance();
        }
         while (inductionVariable < tmp0_repeat_0);
    }};
  Composer.prototype.space_0 = function () {
    if (this._json_0._configuration._prettyPrint_0) {
      this.print_13(new Char(32));
      Unit_getInstance();
    }};
  Composer.prototype.print_13 = function (v) {
    return this._sb.append_32(v);
  };
  Composer.prototype.print_14 = function (v) {
    return this._sb.append_7(v);
  };
  Composer.prototype.print_15 = function (v) {
    return this._sb.append_5(v);
  };
  Composer.prototype.print_16 = function (v) {
    return this._sb.append_5(v);
  };
  Composer.prototype.print_11 = function (v) {
    return this._sb.append_5(v);
  };
  Composer.prototype.print_12 = function (v) {
    return this._sb.append_5(v);
  };
  Composer.prototype.print_9 = function (v) {
    return this._sb.append_5(v);
  };
  Composer.prototype.print_10 = function (v) {
    return this._sb.append_5(v);
  };
  Composer.prototype.print_17 = function (v) {
    return this._sb.append_6(v);
  };
  Composer.prototype.printQuoted_0 = function (value) {
    return printQuoted(this._sb, value);
  };
  Composer.$metadata$ = {
    simpleName: 'Composer',
    kind: 'class',
    interfaces: []
  };
  function ComposerForUnsignedNumbers(sb, json) {
    Composer.call(this, sb, json);
  }
  ComposerForUnsignedNumbers.prototype.print_9 = function (v) {
    return Composer.prototype.print_14.call(this, UInt__toString_impl(_UInt___init__impl_(v)));
  };
  ComposerForUnsignedNumbers.prototype.print_10 = function (v) {
    return Composer.prototype.print_14.call(this, ULong__toString_impl(_ULong___init__impl_(v)));
  };
  ComposerForUnsignedNumbers.prototype.print_11 = function (v) {
    return Composer.prototype.print_14.call(this, UByte__toString_impl(_UByte___init__impl_(v)));
  };
  ComposerForUnsignedNumbers.prototype.print_12 = function (v) {
    return Composer.prototype.print_14.call(this, UShort__toString_impl(_UShort___init__impl_(v)));
  };
  ComposerForUnsignedNumbers.$metadata$ = {
    simpleName: 'ComposerForUnsignedNumbers',
    kind: 'class',
    interfaces: []
  };
  function StreamingJsonEncoder(composer, json, mode, modeReuseCache) {
    AbstractEncoder.call(this);
    this._composer = composer;
    this._json_1 = json;
    this._mode_0 = mode;
    this._modeReuseCache = modeReuseCache;
    this._serializersModule_3 = this._json_1._get_serializersModule__14();
    this._configuration_1 = this._json_1._configuration;
    this._forceQuoting = false;
    this._writePolymorphic = false;
    var i = this._mode_0._get_ordinal__0();
    if (!(this._modeReuseCache == null)) {
      if (!(this._modeReuseCache[i] === null) ? true : !(this._modeReuseCache[i] === this))
        this._modeReuseCache[i] = this;
    }}
  StreamingJsonEncoder.prototype._get_json__6 = function () {
    return this._json_1;
  };
  StreamingJsonEncoder.prototype._get_serializersModule__14 = function () {
    return this._serializersModule_3;
  };
  StreamingJsonEncoder.prototype.encodeSerializableValue_1 = function (serializer_16, value) {
    var tmp$ret$0;
    l$ret$1: do {
      var tmp;
      if (!(serializer_16 instanceof AbstractPolymorphicSerializer)) {
        tmp = true;
      } else {
        {
          tmp = this._get_json__6()._configuration._useArrayPolymorphism_0;
        }
      }
      if (tmp) {
        serializer_16.serialize_76(this, value);
        tmp$ret$0 = Unit_getInstance();
        break l$ret$1;
      } else {
      }
      var tmp_0 = isInterface(serializer_16, SerializationStrategy) ? serializer_16 : THROW_CCE();
      var actualSerializer_1 = findActualSerializer(this, tmp_0, isObject(value) ? value : THROW_CCE());
      this._writePolymorphic = true;
      actualSerializer_1.serialize_76(this, value);
    }
     while (false);
  };
  StreamingJsonEncoder.prototype.beginStructure_11 = function (descriptor) {
    var newMode = switchMode(this._json_1, descriptor);
    if (!newMode._begin.equals(new Char(0))) {
      this._composer.print_13(newMode._begin);
      Unit_getInstance();
      this._composer.indent_0();
    }if (this._writePolymorphic) {
      this._writePolymorphic = false;
      encodeTypeInfo(this, descriptor);
    }if (this._mode_0.equals(newMode)) {
      return this;
    }var tmp0_safe_receiver = this._modeReuseCache;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver[newMode._get_ordinal__0()];
    return tmp1_elvis_lhs == null ? new StreamingJsonEncoder(this._composer, this._json_1, newMode, this._modeReuseCache) : tmp1_elvis_lhs;
  };
  StreamingJsonEncoder.prototype.endStructure_11 = function (descriptor) {
    if (!this._mode_0._end.equals(new Char(0))) {
      this._composer.unIndent_0();
      this._composer.nextItem_0();
      this._composer.print_13(this._mode_0._end);
      Unit_getInstance();
    }};
  StreamingJsonEncoder.prototype.encodeElement_0 = function (descriptor, index) {
    var tmp0_subject = this._mode_0;
    if (tmp0_subject.equals(WriteMode_LIST_getInstance())) {
      if (!this._composer._writingFirst) {
        this._composer.print_13(new Char(44));
        Unit_getInstance();
      }this._composer.nextItem_0();
    } else if (tmp0_subject.equals(WriteMode_MAP_getInstance())) {
      if (!this._composer._writingFirst) {
        var tmp = this;
        var tmp_0;
        if (index % 2 === 0) {
          this._composer.print_13(new Char(44));
          Unit_getInstance();
          this._composer.nextItem_0();
          tmp_0 = true;
        } else {
          this._composer.print_13(new Char(58));
          Unit_getInstance();
          this._composer.space_0();
          tmp_0 = false;
        }
        tmp._forceQuoting = tmp_0;
      } else {
        this._forceQuoting = true;
        this._composer.nextItem_0();
      }
    } else if (tmp0_subject.equals(WriteMode_POLY_OBJ_getInstance())) {
      if (index === 0)
        this._forceQuoting = true;
      if (index === 1) {
        this._composer.print_13(new Char(44));
        Unit_getInstance();
        this._composer.space_0();
        this._forceQuoting = false;
      }} else {
      if (!this._composer._writingFirst) {
        this._composer.print_13(new Char(44));
        Unit_getInstance();
      }this._composer.nextItem_0();
      this.encodeString_1(descriptor.getElementName_16(index));
      this._composer.print_13(new Char(58));
      Unit_getInstance();
      this._composer.space_0();
    }
    return true;
  };
  StreamingJsonEncoder.prototype.encodeInline_1 = function (inlineDescriptor) {
    return _get_isUnsignedNumber_(inlineDescriptor) ? new StreamingJsonEncoder(new ComposerForUnsignedNumbers(this._composer._sb, this._composer._json_0), this._json_1, this._mode_0, null) : this;
  };
  StreamingJsonEncoder.prototype.encodeNull_1 = function () {
    this._composer.print_14('null');
    Unit_getInstance();
  };
  StreamingJsonEncoder.prototype.encodeBoolean_1 = function (value) {
    if (this._forceQuoting)
      this.encodeString_1(value.toString());
    else {
      this._composer.print_17(value);
      Unit_getInstance();
    }
  };
  StreamingJsonEncoder.prototype.encodeByte_1 = function (value) {
    if (this._forceQuoting)
      this.encodeString_1(value.toString());
    else {
      this._composer.print_11(value);
      Unit_getInstance();
    }
  };
  StreamingJsonEncoder.prototype.encodeShort_1 = function (value) {
    if (this._forceQuoting)
      this.encodeString_1(value.toString());
    else {
      this._composer.print_12(value);
      Unit_getInstance();
    }
  };
  StreamingJsonEncoder.prototype.encodeInt_1 = function (value) {
    if (this._forceQuoting)
      this.encodeString_1(value.toString());
    else {
      this._composer.print_9(value);
      Unit_getInstance();
    }
  };
  StreamingJsonEncoder.prototype.encodeLong_1 = function (value) {
    if (this._forceQuoting)
      this.encodeString_1(value.toString());
    else {
      this._composer.print_10(value);
      Unit_getInstance();
    }
  };
  StreamingJsonEncoder.prototype.encodeFloat_1 = function (value) {
    if (this._forceQuoting)
      this.encodeString_1(value.toString());
    else {
      this._composer.print_15(value);
      Unit_getInstance();
    }
    if (!this._configuration_1._allowSpecialFloatingPointValues_0 ? !isFinite_0(value) : false) {
      throw InvalidFloatingPointEncoded(value, this._composer._sb.toString());
    }};
  StreamingJsonEncoder.prototype.encodeDouble_1 = function (value) {
    if (this._forceQuoting)
      this.encodeString_1(value.toString());
    else {
      this._composer.print_16(value);
      Unit_getInstance();
    }
    if (!this._configuration_1._allowSpecialFloatingPointValues_0 ? !isFinite(value) : false) {
      throw InvalidFloatingPointEncoded(value, this._composer._sb.toString());
    }};
  StreamingJsonEncoder.prototype.encodeChar_1 = function (value) {
    this.encodeString_1(value.toString());
  };
  StreamingJsonEncoder.prototype.encodeString_1 = function (value) {
    return this._composer.printQuoted_0(value);
  };
  StreamingJsonEncoder.$metadata$ = {
    simpleName: 'StreamingJsonEncoder',
    kind: 'class',
    interfaces: [JsonEncoder]
  };
  function _get_isUnsignedNumber_(_this_) {
    return _this_._get_isInline__16() ? unsignedNumberDescriptors.contains_51(_this_) : false;
  }
  var ESCAPE_CHARS;
  function toHexChar(i) {
    var d = i & 15;
    return d < 10 ? numberToChar(d + 48 | 0) : numberToChar((d - 10 | 0) + 97 | 0);
  }
  function printQuoted(_this_, value) {
    _this_.append_32(new Char(34));
    Unit_getInstance();
    var lastPos = 0;
    var length = value.length;
    var inductionVariable = 0;
    if (inductionVariable < length)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var c = charSequenceGet(value, i).toInt_5();
        if (c >= ESCAPE_CHARS.length)
          continue;
        var tmp1_elvis_lhs = ESCAPE_CHARS[c];
        var tmp;
        if (tmp1_elvis_lhs == null) {
          continue;
        } else {
          tmp = tmp1_elvis_lhs;
        }
        var esc = tmp;
        _this_.append_30(value, lastPos, i);
        Unit_getInstance();
        _this_.append_7(esc);
        Unit_getInstance();
        lastPos = i + 1 | 0;
      }
       while (inductionVariable < length);
    _this_.append_30(value, lastPos, length);
    Unit_getInstance();
    _this_.append_32(new Char(34));
    Unit_getInstance();
  }
  function toBooleanStrictOrNull(_this_) {
    return equals_0(_this_, 'true', true) ? true : equals_0(_this_, 'false', true) ? false : null;
  }
  function ESCAPE_CHARS$init$() {
    var tmp0_arrayOfNulls_0 = 128;
    var tmp1_apply_0 = fillArrayVal(Array(tmp0_arrayOfNulls_0), null);
    var inductionVariable = 0;
    if (inductionVariable <= 31)
      do {
        var c_3 = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var c1_4 = toHexChar(c_3 >> 12);
        var c2_5 = toHexChar(c_3 >> 8);
        var c3_6 = toHexChar(c_3 >> 4);
        var c4_7 = toHexChar(c_3);
        tmp1_apply_0[c_3] = '' + '\\u' + c1_4 + c2_5 + c3_6 + c4_7;
      }
       while (inductionVariable <= 31);
    tmp1_apply_0[34] = '\\"';
    tmp1_apply_0[92] = '\\\\';
    tmp1_apply_0[9] = '\\t';
    tmp1_apply_0[8] = '\\b';
    tmp1_apply_0[10] = '\\n';
    tmp1_apply_0[13] = '\\r';
    tmp1_apply_0[12] = '\\f';
    return tmp1_apply_0;
  }
  function currentObject($this) {
    var tmp0_safe_receiver = $this._get_currentTagOrNull__4();
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      tmp = $this.currentElement_2(tmp0_safe_receiver);
    }
    var tmp1_elvis_lhs = tmp;
    return tmp1_elvis_lhs == null ? $this._get_value__33() : tmp1_elvis_lhs;
  }
  function unparsedPrimitive($this, primitive) {
    throw JsonDecodingException_0(-1, '' + "Failed to parse '" + primitive + "'", toString_1(currentObject($this)));
  }
  function AbstractJsonTreeDecoder(json, value) {
    NamedValueDecoder.call(this);
    this._json_2 = json;
    this._value_4 = value;
    this._configuration_2 = this._get_json__6()._configuration;
  }
  AbstractJsonTreeDecoder.prototype._get_json__6 = function () {
    return this._json_2;
  };
  AbstractJsonTreeDecoder.prototype._get_value__33 = function () {
    return this._value_4;
  };
  AbstractJsonTreeDecoder.prototype._get_serializersModule__14 = function () {
    return this._get_json__6()._get_serializersModule__14();
  };
  AbstractJsonTreeDecoder.prototype._get_configuration__3 = function () {
    return this._configuration_2;
  };
  AbstractJsonTreeDecoder.prototype.decodeJsonElement_4 = function () {
    return currentObject(this);
  };
  AbstractJsonTreeDecoder.prototype.decodeSerializableValue_16 = function (deserializer) {
    return decodeSerializableValuePolymorphic(this, deserializer);
  };
  AbstractJsonTreeDecoder.prototype.composeName_3 = function (parentName, childName) {
    return childName;
  };
  AbstractJsonTreeDecoder.prototype.beginStructure_11 = function (descriptor) {
    var currentObject_0 = currentObject(this);
    var tmp0_subject = descriptor._get_kind__16();
    var tmp;
    var tmp_0;
    if (equals_1(tmp0_subject, LIST_getInstance())) {
      tmp_0 = true;
    } else {
      tmp_0 = tmp0_subject instanceof PolymorphicKind;
    }
    if (tmp_0) {
      var tmp_1 = this._get_json__6();
      if (!(currentObject_0 instanceof JsonArray)) {
        throw JsonDecodingException_1(-1, '' + 'Expected ' + getKClass_0(JsonArray) + ' as the serialized body of ' + descriptor._get_serialName__16() + ', but had ' + getKClassFromExpression_0(currentObject_0));
      } else {
      }
      tmp = new JsonTreeListDecoder(tmp_1, currentObject_0);
    } else {
      if (equals_1(tmp0_subject, MAP_getInstance())) {
        var tmp0_selectMapMode_0 = this._get_json__6();
        var keyDescriptor_1 = descriptor.getElementDescriptor_16(0);
        var keyKind_2 = keyDescriptor_1._get_kind__16();
        var tmp_2;
        var tmp_3;
        if (keyKind_2 instanceof PrimitiveKind) {
          tmp_3 = true;
        } else {
          {
            tmp_3 = equals_1(keyKind_2, ENUM_getInstance());
          }
        }
        if (tmp_3) {
          var tmp_4 = this._get_json__6();
          if (!(currentObject_0 instanceof JsonObject)) {
            throw JsonDecodingException_1(-1, '' + 'Expected ' + getKClass_0(JsonObject) + ' as the serialized body of ' + descriptor._get_serialName__16() + ', but had ' + getKClassFromExpression_0(currentObject_0));
          } else {
          }
          tmp_2 = new JsonTreeMapDecoder(tmp_4, currentObject_0);
        } else {
          if (tmp0_selectMapMode_0._configuration._allowStructuredMapKeys_0) {
            var tmp_5 = this._get_json__6();
            if (!(currentObject_0 instanceof JsonArray)) {
              throw JsonDecodingException_1(-1, '' + 'Expected ' + getKClass_0(JsonArray) + ' as the serialized body of ' + descriptor._get_serialName__16() + ', but had ' + getKClassFromExpression_0(currentObject_0));
            } else {
            }
            tmp_2 = new JsonTreeListDecoder(tmp_5, currentObject_0);
          } else {
            {
              throw InvalidKeyKindException(keyDescriptor_1);
            }
          }
        }
        tmp = tmp_2;
      } else {
        {
          var tmp_6 = this._get_json__6();
          if (!(currentObject_0 instanceof JsonObject)) {
            throw JsonDecodingException_1(-1, '' + 'Expected ' + getKClass_0(JsonObject) + ' as the serialized body of ' + descriptor._get_serialName__16() + ', but had ' + getKClassFromExpression_0(currentObject_0));
          } else {
          }
          var tmp_7 = currentObject_0;
          tmp = JsonTreeDecoder_init_$Create$(tmp_6, tmp_7, null, null, 12, null);
        }
      }
    }
    return tmp;
  };
  AbstractJsonTreeDecoder.prototype.endStructure_11 = function (descriptor) {
  };
  AbstractJsonTreeDecoder.prototype.decodeNotNullMark_8 = function () {
    var tmp = currentObject(this);
    return !(tmp instanceof JsonNull);
  };
  AbstractJsonTreeDecoder.prototype.getValue_4 = function (tag) {
    var currentElement = this.currentElement_2(tag);
    var tmp0_elvis_lhs = currentElement instanceof JsonPrimitive ? currentElement : null;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      throw JsonDecodingException_0(-1, '' + 'Expected JsonPrimitive at ' + tag + ', found ' + currentElement, toString_1(currentObject(this)));
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  };
  AbstractJsonTreeDecoder.prototype.decodeTaggedNotNullMark_5 = function (tag) {
    return !(this.currentElement_2(tag) === JsonNull_getInstance());
  };
  AbstractJsonTreeDecoder.prototype.decodeTaggedNotNullMark_2 = function (tag) {
    return this.decodeTaggedNotNullMark_5((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE());
  };
  AbstractJsonTreeDecoder.prototype.decodeTaggedBoolean_5 = function (tag) {
    var value = this.getValue_4(tag);
    if (!this._get_json__6()._configuration._isLenient_0) {
      var literal = value instanceof JsonLiteral ? value : THROW_CCE();
      if (literal._isString)
        throw JsonDecodingException_0(-1, '' + "Boolean literal for key '" + tag + "' should be unquoted.\nUse 'isLenient = true' in 'Json {}` builder to accept non-compliant JSON.", toString_1(currentObject(this)));
    }var tmp$ret$0;
    l$ret$1: do {
      var tmp0_primitive_0 = 'boolean';
      try {
        var tmp0_elvis_lhs_4 = _get_booleanOrNull_(value);
        var tmp;
        if (tmp0_elvis_lhs_4 == null) {
          throw IllegalArgumentException_init_$Create$();
        } else {
          tmp = tmp0_elvis_lhs_4;
        }
        var tmp0_elvis_lhs_1 = tmp;
        var tmp_0;
        if (tmp0_elvis_lhs_1 == null) {
          unparsedPrimitive(this, tmp0_primitive_0);
        } else {
          tmp_0 = tmp0_elvis_lhs_1;
        }
        tmp$ret$0 = tmp_0;
        break l$ret$1;
      } catch ($p) {
        if ($p instanceof IllegalArgumentException) {
          unparsedPrimitive(this, tmp0_primitive_0);
        } else {
          {
            throw $p;
          }
        }
      }
    }
     while (false);
    return tmp$ret$0;
  };
  AbstractJsonTreeDecoder.prototype.decodeTaggedBoolean_2 = function (tag) {
    return this.decodeTaggedBoolean_5((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE());
  };
  AbstractJsonTreeDecoder.prototype.decodeTaggedByte_5 = function (tag) {
    var tmp$ret$0;
    l$ret$1: do {
      var tmp0_primitive_0 = this.getValue_4(tag);
      var tmp1_primitive_0 = 'byte';
      try {
        var result_4 = _get_int_(tmp0_primitive_0);
        var tmp;
        var containsLower = ByteCompanionObject_getInstance()._MIN_VALUE_3;
        if (result_4 <= ByteCompanionObject_getInstance()._MAX_VALUE_3 ? containsLower <= result_4 : false) {
          tmp = toByte_0(result_4);
        } else {
          {
            tmp = null;
          }
        }
        var tmp0_elvis_lhs_1 = tmp;
        var tmp_0;
        if (tmp0_elvis_lhs_1 == null) {
          unparsedPrimitive(this, tmp1_primitive_0);
        } else {
          tmp_0 = tmp0_elvis_lhs_1;
        }
        tmp$ret$0 = tmp_0;
        break l$ret$1;
      } catch ($p) {
        if ($p instanceof IllegalArgumentException) {
          unparsedPrimitive(this, tmp1_primitive_0);
        } else {
          {
            throw $p;
          }
        }
      }
    }
     while (false);
    return tmp$ret$0;
  };
  AbstractJsonTreeDecoder.prototype.decodeTaggedByte_2 = function (tag) {
    return this.decodeTaggedByte_5((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE());
  };
  AbstractJsonTreeDecoder.prototype.decodeTaggedShort_5 = function (tag) {
    var tmp$ret$0;
    l$ret$1: do {
      var tmp0_primitive_0 = this.getValue_4(tag);
      var tmp1_primitive_0 = 'short';
      try {
        var result_4 = _get_int_(tmp0_primitive_0);
        var tmp;
        var containsLower = ShortCompanionObject_getInstance()._MIN_VALUE_4;
        if (result_4 <= ShortCompanionObject_getInstance()._MAX_VALUE_4 ? containsLower <= result_4 : false) {
          tmp = toShort_0(result_4);
        } else {
          {
            tmp = null;
          }
        }
        var tmp0_elvis_lhs_1 = tmp;
        var tmp_0;
        if (tmp0_elvis_lhs_1 == null) {
          unparsedPrimitive(this, tmp1_primitive_0);
        } else {
          tmp_0 = tmp0_elvis_lhs_1;
        }
        tmp$ret$0 = tmp_0;
        break l$ret$1;
      } catch ($p) {
        if ($p instanceof IllegalArgumentException) {
          unparsedPrimitive(this, tmp1_primitive_0);
        } else {
          {
            throw $p;
          }
        }
      }
    }
     while (false);
    return tmp$ret$0;
  };
  AbstractJsonTreeDecoder.prototype.decodeTaggedShort_2 = function (tag) {
    return this.decodeTaggedShort_5((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE());
  };
  AbstractJsonTreeDecoder.prototype.decodeTaggedInt_5 = function (tag) {
    var tmp$ret$0;
    l$ret$1: do {
      var tmp0_primitive_0 = this.getValue_4(tag);
      var tmp1_primitive_0 = 'int';
      try {
        var tmp0_elvis_lhs_1 = _get_int_(tmp0_primitive_0);
        var tmp;
        if (tmp0_elvis_lhs_1 == null) {
          unparsedPrimitive(this, tmp1_primitive_0);
        } else {
          tmp = tmp0_elvis_lhs_1;
        }
        tmp$ret$0 = tmp;
        break l$ret$1;
      } catch ($p) {
        if ($p instanceof IllegalArgumentException) {
          unparsedPrimitive(this, tmp1_primitive_0);
        } else {
          {
            throw $p;
          }
        }
      }
    }
     while (false);
    return tmp$ret$0;
  };
  AbstractJsonTreeDecoder.prototype.decodeTaggedInt_2 = function (tag) {
    return this.decodeTaggedInt_5((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE());
  };
  AbstractJsonTreeDecoder.prototype.decodeTaggedLong_5 = function (tag) {
    var tmp$ret$0;
    l$ret$1: do {
      var tmp0_primitive_0 = this.getValue_4(tag);
      var tmp1_primitive_0 = 'long';
      try {
        var tmp0_elvis_lhs_1 = _get_long_(tmp0_primitive_0);
        var tmp;
        if (tmp0_elvis_lhs_1 == null) {
          unparsedPrimitive(this, tmp1_primitive_0);
        } else {
          tmp = tmp0_elvis_lhs_1;
        }
        tmp$ret$0 = tmp;
        break l$ret$1;
      } catch ($p) {
        if ($p instanceof IllegalArgumentException) {
          unparsedPrimitive(this, tmp1_primitive_0);
        } else {
          {
            throw $p;
          }
        }
      }
    }
     while (false);
    return tmp$ret$0;
  };
  AbstractJsonTreeDecoder.prototype.decodeTaggedLong_2 = function (tag) {
    return this.decodeTaggedLong_5((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE());
  };
  AbstractJsonTreeDecoder.prototype.decodeTaggedFloat_5 = function (tag) {
    var tmp$ret$0;
    l$ret$1: do {
      var tmp0_primitive_0 = this.getValue_4(tag);
      var tmp1_primitive_0 = 'float';
      try {
        var tmp0_elvis_lhs_1 = _get_float_(tmp0_primitive_0);
        var tmp;
        if (tmp0_elvis_lhs_1 == null) {
          unparsedPrimitive(this, tmp1_primitive_0);
        } else {
          tmp = tmp0_elvis_lhs_1;
        }
        tmp$ret$0 = tmp;
        break l$ret$1;
      } catch ($p) {
        if ($p instanceof IllegalArgumentException) {
          unparsedPrimitive(this, tmp1_primitive_0);
        } else {
          {
            throw $p;
          }
        }
      }
    }
     while (false);
    var result = tmp$ret$0;
    var specialFp = this._get_json__6()._configuration._allowSpecialFloatingPointValues_0;
    if (specialFp ? true : isFinite_0(result))
      return result;
    throw InvalidFloatingPointDecoded(result, tag, toString_1(currentObject(this)));
  };
  AbstractJsonTreeDecoder.prototype.decodeTaggedFloat_2 = function (tag) {
    return this.decodeTaggedFloat_5((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE());
  };
  AbstractJsonTreeDecoder.prototype.decodeTaggedDouble_5 = function (tag) {
    var tmp$ret$0;
    l$ret$1: do {
      var tmp0_primitive_0 = this.getValue_4(tag);
      var tmp1_primitive_0 = 'double';
      try {
        var tmp0_elvis_lhs_1 = _get_double_(tmp0_primitive_0);
        var tmp;
        if (tmp0_elvis_lhs_1 == null) {
          unparsedPrimitive(this, tmp1_primitive_0);
        } else {
          tmp = tmp0_elvis_lhs_1;
        }
        tmp$ret$0 = tmp;
        break l$ret$1;
      } catch ($p) {
        if ($p instanceof IllegalArgumentException) {
          unparsedPrimitive(this, tmp1_primitive_0);
        } else {
          {
            throw $p;
          }
        }
      }
    }
     while (false);
    var result = tmp$ret$0;
    var specialFp = this._get_json__6()._configuration._allowSpecialFloatingPointValues_0;
    if (specialFp ? true : isFinite(result))
      return result;
    throw InvalidFloatingPointDecoded(result, tag, toString_1(currentObject(this)));
  };
  AbstractJsonTreeDecoder.prototype.decodeTaggedDouble_2 = function (tag) {
    return this.decodeTaggedDouble_5((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE());
  };
  AbstractJsonTreeDecoder.prototype.decodeTaggedChar_5 = function (tag) {
    var tmp$ret$0;
    l$ret$1: do {
      var tmp0_primitive_0 = this.getValue_4(tag);
      var tmp1_primitive_0 = 'char';
      try {
        var tmp0_elvis_lhs_1 = single_2(tmp0_primitive_0._get_content__6());
        var tmp;
        if (tmp0_elvis_lhs_1 == null) {
          unparsedPrimitive(this, tmp1_primitive_0);
        } else {
          tmp = tmp0_elvis_lhs_1;
        }
        tmp$ret$0 = tmp;
        break l$ret$1;
      } catch ($p) {
        if ($p instanceof IllegalArgumentException) {
          unparsedPrimitive(this, tmp1_primitive_0);
        } else {
          {
            throw $p;
          }
        }
      }
    }
     while (false);
    return tmp$ret$0;
  };
  AbstractJsonTreeDecoder.prototype.decodeTaggedChar_2 = function (tag) {
    return this.decodeTaggedChar_5((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE());
  };
  AbstractJsonTreeDecoder.prototype.decodeTaggedString_5 = function (tag) {
    var value = this.getValue_4(tag);
    if (!this._get_json__6()._configuration._isLenient_0) {
      var literal = value instanceof JsonLiteral ? value : THROW_CCE();
      if (!literal._isString)
        throw JsonDecodingException_0(-1, '' + "String literal for key '" + tag + "' should be quoted.\nUse 'isLenient = true' in 'Json {}` builder to accept non-compliant JSON.", toString_1(currentObject(this)));
    }return value._get_content__6();
  };
  AbstractJsonTreeDecoder.prototype.decodeTaggedString_2 = function (tag) {
    return this.decodeTaggedString_5((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE());
  };
  AbstractJsonTreeDecoder.prototype.decodeTaggedInline_5 = function (tag, inlineDescriptor) {
    return new JsonDecoderForUnsignedTypes(new JsonReader(this.getValue_4(tag)._get_content__6()), this._get_json__6());
  };
  AbstractJsonTreeDecoder.prototype.decodeTaggedInline_2 = function (tag, inlineDescriptor) {
    return this.decodeTaggedInline_5((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE(), inlineDescriptor);
  };
  AbstractJsonTreeDecoder.$metadata$ = {
    simpleName: 'AbstractJsonTreeDecoder',
    kind: 'class',
    interfaces: [JsonDecoder]
  };
  function JsonTreeDecoder_init_$Init$(json, value, polyDiscriminator, polyDescriptor, $mask0, $marker, $this) {
    if (!(($mask0 & 4) === 0))
      polyDiscriminator = null;
    if (!(($mask0 & 8) === 0))
      polyDescriptor = null;
    JsonTreeDecoder.call($this, json, value, polyDiscriminator, polyDescriptor);
    return $this;
  }
  function JsonTreeDecoder_init_$Create$(json, value, polyDiscriminator, polyDescriptor, $mask0, $marker) {
    return JsonTreeDecoder_init_$Init$(json, value, polyDiscriminator, polyDescriptor, $mask0, $marker, Object.create(JsonTreeDecoder.prototype));
  }
  function coerceInputValue_0($this, descriptor, index, tag) {
    var elementDescriptor = descriptor.getElementDescriptor_16(index);
    var tmp;
    var tmp_0 = $this.currentElement_2(tag);
    if (tmp_0 instanceof JsonNull) {
      tmp = !elementDescriptor._get_isNullable__16();
    } else {
      {
        tmp = false;
      }
    }
    if (tmp)
      return true;
    else {
    }
    if (equals_1(elementDescriptor._get_kind__16(), ENUM_getInstance())) {
      var tmp_1 = $this.currentElement_2(tag);
      var tmp0_safe_receiver = tmp_1 instanceof JsonPrimitive ? tmp_1 : null;
      var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : _get_contentOrNull_(tmp0_safe_receiver);
      var tmp_2;
      if (tmp1_elvis_lhs == null) {
        return false;
      } else {
        tmp_2 = tmp1_elvis_lhs;
      }
      var enumValue = tmp_2;
      var enumIndex = elementDescriptor.getElementIndex_16(enumValue);
      if (enumIndex === -3)
        return true;
    }return false;
  }
  function JsonTreeDecoder(json, value, polyDiscriminator, polyDescriptor) {
    AbstractJsonTreeDecoder.call(this, json, value);
    this._value_5 = value;
    this._polyDiscriminator = polyDiscriminator;
    this._polyDescriptor = polyDescriptor;
    this._position_7 = 0;
  }
  JsonTreeDecoder.prototype._get_value__33 = function () {
    return this._value_5;
  };
  JsonTreeDecoder.prototype.decodeElementIndex_8 = function (descriptor) {
    while (this._position_7 < descriptor._get_elementsCount__16()) {
      var tmp0_this = this;
      var tmp1 = tmp0_this._position_7;
      tmp0_this._position_7 = tmp1 + 1 | 0;
      var name = this.getTag_4(descriptor, tmp1);
      var tmp;
      var tmp0_contains_0 = this._get_value__33();
      if ((isInterface(tmp0_contains_0, Map_0) ? tmp0_contains_0 : THROW_CCE()).containsKey_16(name)) {
        tmp = !this._get_configuration__3()._coerceInputValues_0 ? true : !coerceInputValue_0(this, descriptor, this._position_7 - 1 | 0, name);
      } else {
        {
          tmp = false;
        }
      }
      if (tmp) {
        return this._position_7 - 1 | 0;
      } else {
      }
    }
    return -1;
  };
  JsonTreeDecoder.prototype.currentElement_2 = function (tag) {
    return getValue(this._get_value__33(), tag);
  };
  JsonTreeDecoder.prototype.beginStructure_11 = function (descriptor) {
    if (descriptor === this._polyDescriptor)
      return this;
    return AbstractJsonTreeDecoder.prototype.beginStructure_11.call(this, descriptor);
  };
  JsonTreeDecoder.prototype.endStructure_11 = function (descriptor) {
    var tmp;
    if (this._get_configuration__3()._ignoreUnknownKeys_0) {
      tmp = true;
    } else {
      var tmp_0 = descriptor._get_kind__16();
      tmp = tmp_0 instanceof PolymorphicKind;
    }
    if (tmp)
      return Unit_getInstance();
    else {
    }
    var names = jsonCachedSerialNames(descriptor);
    var tmp0_iterator = this._get_value__33()._get_keys__10().iterator_64();
    while (tmp0_iterator.hasNext_31()) {
      var key = tmp0_iterator.next_35();
      if (!names.contains_51(key) ? !(key === this._polyDiscriminator) : false) {
        throw UnknownKeyException(key, this._get_value__33().toString());
      }}
  };
  JsonTreeDecoder.$metadata$ = {
    simpleName: 'JsonTreeDecoder',
    kind: 'class',
    interfaces: []
  };
  function JsonTreeListDecoder(json, value) {
    AbstractJsonTreeDecoder.call(this, json, value);
    this._value_6 = value;
    this._size_1 = this._value_6._get_size__45();
    this._currentIndex_0 = -1;
  }
  JsonTreeListDecoder.prototype._get_value__33 = function () {
    return this._value_6;
  };
  JsonTreeListDecoder.prototype.elementName_3 = function (desc, index) {
    return index.toString();
  };
  JsonTreeListDecoder.prototype.currentElement_2 = function (tag) {
    return this._value_6.get_80(toInt(tag));
  };
  JsonTreeListDecoder.prototype.decodeElementIndex_8 = function (descriptor) {
    while (this._currentIndex_0 < (this._size_1 - 1 | 0)) {
      var tmp0_this = this;
      var tmp1 = tmp0_this._currentIndex_0;
      tmp0_this._currentIndex_0 = tmp1 + 1 | 0;
      Unit_getInstance();
      return this._currentIndex_0;
    }
    return -1;
  };
  JsonTreeListDecoder.$metadata$ = {
    simpleName: 'JsonTreeListDecoder',
    kind: 'class',
    interfaces: []
  };
  function JsonTreeMapDecoder(json, value) {
    JsonTreeDecoder_init_$Init$(json, value, null, null, 12, null, this);
    this._value_7 = value;
    this._keys_0 = toList_0(this._value_7._get_keys__10());
    this._size_2 = imul(this._keys_0._get_size__45(), 2);
    this._position_8 = -1;
  }
  JsonTreeMapDecoder.prototype._get_value__33 = function () {
    return this._value_7;
  };
  JsonTreeMapDecoder.prototype.elementName_3 = function (desc, index) {
    var i = index / 2 | 0;
    return this._keys_0.get_80(i);
  };
  JsonTreeMapDecoder.prototype.decodeElementIndex_8 = function (descriptor) {
    while (this._position_8 < (this._size_2 - 1 | 0)) {
      var tmp0_this = this;
      var tmp1 = tmp0_this._position_8;
      tmp0_this._position_8 = tmp1 + 1 | 0;
      Unit_getInstance();
      return this._position_8;
    }
    return -1;
  };
  JsonTreeMapDecoder.prototype.currentElement_2 = function (tag) {
    return this._position_8 % 2 === 0 ? JsonPrimitive_0(tag) : getValue(this._value_7, tag);
  };
  JsonTreeMapDecoder.prototype.endStructure_11 = function (descriptor) {
  };
  JsonTreeMapDecoder.$metadata$ = {
    simpleName: 'JsonTreeMapDecoder',
    kind: 'class',
    interfaces: []
  };
  function readPolymorphicJson(_this_, discriminator, element, deserializer) {
    return (new JsonTreeDecoder(_this_, element, discriminator, deserializer._get_descriptor__48())).decodeSerializableValue_16(deserializer);
  }
  var WriteMode_OBJ_instance;
  var WriteMode_LIST_instance;
  var WriteMode_MAP_instance;
  var WriteMode_POLY_OBJ_instance;
  function values() {
    return [WriteMode_OBJ_getInstance(), WriteMode_LIST_getInstance(), WriteMode_MAP_getInstance(), WriteMode_POLY_OBJ_getInstance()];
  }
  var WriteMode_entriesInitialized;
  function WriteMode_initEntries() {
    if (WriteMode_entriesInitialized)
      return Unit_getInstance();
    WriteMode_entriesInitialized = true;
    WriteMode_OBJ_instance = new WriteMode('OBJ', 0, new Char(123), new Char(125));
    WriteMode_LIST_instance = new WriteMode('LIST', 1, new Char(91), new Char(93));
    WriteMode_MAP_instance = new WriteMode('MAP', 2, new Char(123), new Char(125));
    WriteMode_POLY_OBJ_instance = new WriteMode('POLY_OBJ', 3, new Char(91), new Char(93));
  }
  function WriteMode(name, ordinal, begin, end) {
    Enum.call(this, name, ordinal);
    this._begin = begin;
    this._end = end;
    this._beginTc = charToTokenClass(this._begin);
    this._endTc = charToTokenClass(this._end);
  }
  WriteMode.$metadata$ = {
    simpleName: 'WriteMode',
    kind: 'class',
    interfaces: []
  };
  function switchMode(_this_, desc) {
    var tmp0_subject = desc._get_kind__16();
    var tmp;
    if (tmp0_subject instanceof PolymorphicKind) {
      tmp = WriteMode_POLY_OBJ_getInstance();
    } else {
      if (equals_1(tmp0_subject, LIST_getInstance())) {
        tmp = WriteMode_LIST_getInstance();
      } else {
        if (equals_1(tmp0_subject, MAP_getInstance())) {
          var keyDescriptor_1 = desc.getElementDescriptor_16(0);
          var keyKind_2 = keyDescriptor_1._get_kind__16();
          var tmp_0;
          var tmp_1;
          if (keyKind_2 instanceof PrimitiveKind) {
            tmp_1 = true;
          } else {
            {
              tmp_1 = equals_1(keyKind_2, ENUM_getInstance());
            }
          }
          if (tmp_1) {
            tmp_0 = WriteMode_MAP_getInstance();
          } else {
            if (_this_._configuration._allowStructuredMapKeys_0) {
              tmp_0 = WriteMode_LIST_getInstance();
            } else {
              {
                throw InvalidKeyKindException(keyDescriptor_1);
              }
            }
          }
          tmp = tmp_0;
        } else {
          {
            tmp = WriteMode_OBJ_getInstance();
          }
        }
      }
    }
    return tmp;
  }
  function WriteMode_OBJ_getInstance() {
    WriteMode_initEntries();
    return WriteMode_OBJ_instance;
  }
  function WriteMode_LIST_getInstance() {
    WriteMode_initEntries();
    return WriteMode_LIST_instance;
  }
  function WriteMode_MAP_getInstance() {
    WriteMode_initEntries();
    return WriteMode_MAP_instance;
  }
  function WriteMode_POLY_OBJ_getInstance() {
    WriteMode_initEntries();
    return WriteMode_POLY_OBJ_instance;
  }
  function $serializer() {
    $serializer_instance = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('net.folivo.matrix.bot.anteroom.backend.model.Location', this, 2);
    tmp0_serialDesc.addElement_0('id', false);
    tmp0_serialDesc.addElement_0('name', false);
    this._descriptor_30 = tmp0_serialDesc;
  }
  $serializer.prototype._get_descriptor__48 = function () {
    return this._descriptor_30;
  };
  $serializer.prototype.childSerializers_2 = function () {
    var tmp0_arrayOf_0 = [IntSerializer_getInstance(), StringSerializer_getInstance()];
    return tmp0_arrayOf_0;
  };
  $serializer.prototype.deserialize_52 = function (decoder) {
    var tmp0_desc = this._descriptor_30;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = 0;
    var tmp5_local1 = null;
    var tmp6_input = decoder.beginStructure_11(tmp0_desc);
    if (tmp6_input.decodeSequentially_8()) {
      tmp4_local0 = tmp6_input.decodeIntElement_8(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.decodeStringElement_8(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.decodeElementIndex_8(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.decodeIntElement_8(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.decodeStringElement_8(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp6_input.endStructure_11(tmp0_desc);
    return Location_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  };
  $serializer.prototype.serialize_73 = function (encoder, value) {
    var tmp0_desc = this._descriptor_30;
    var tmp1_output = encoder.beginStructure_11(tmp0_desc);
    tmp1_output.encodeIntElement_1(tmp0_desc, 0, value._id);
    tmp1_output.encodeStringElement_1(tmp0_desc, 1, value._name_0);
    tmp1_output.endStructure_11(tmp0_desc);
  };
  $serializer.prototype.serialize_76 = function (encoder, value) {
    return this.serialize_73(encoder, value instanceof Location_0 ? value : THROW_CCE());
  };
  $serializer.$metadata$ = {
    simpleName: '$serializer',
    kind: 'object',
    interfaces: [GeneratedSerializer]
  };
  var $serializer_instance;
  function $serializer_getInstance() {
    if ($serializer_instance == null)
      new $serializer();
    return $serializer_instance;
  }
  function Location_init_$Init$(seen1, id, name, serializationConstructorMarker, $this) {
    if (0 === (seen1 & 1))
      throw MissingFieldException_init_$Create$('id');
    else
      $this._id = id;
    if (0 === (seen1 & 2))
      throw MissingFieldException_init_$Create$('name');
    else
      $this._name_0 = name;
    return $this;
  }
  function Location_init_$Create$(seen1, id, name, serializationConstructorMarker) {
    return Location_init_$Init$(seen1, id, name, serializationConstructorMarker, Object.create(Location_0.prototype));
  }
  function Location_0() {
  }
  Location_0.prototype.toString = function () {
    return '' + 'Location(id=' + this._id + ', name=' + this._name_0 + ')';
  };
  Location_0.prototype.hashCode = function () {
    var result = this._id;
    result = imul(result, 31) + getStringHashCode(this._name_0) | 0;
    return result;
  };
  Location_0.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Location_0))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof Location_0 ? other : THROW_CCE();
    if (!(this._id === tmp0_other_with_cast._id))
      return false;
    if (!(this._name_0 === tmp0_other_with_cast._name_0))
      return false;
    return true;
  };
  Location_0.$metadata$ = {
    simpleName: 'Location',
    kind: 'class',
    interfaces: [],
    associatedObjects: {0: $serializer_getInstance}
  };
  function Companion_21() {
    Companion_instance_20 = this;
  }
  Companion_21.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_20;
  function Companion_getInstance_20() {
    if (Companion_instance_20 == null)
      new Companion_21();
    return Companion_instance_20;
  }
  function $serializer_0() {
    $serializer_instance_0 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('net.folivo.matrix.bot.anteroom.backend.model.PatientArrival', this, 2);
    tmp0_serialDesc.addElement_0('token', false);
    tmp0_serialDesc.addElement_0('locationId', false);
    this._descriptor_31 = tmp0_serialDesc;
  }
  $serializer_0.prototype._get_descriptor__48 = function () {
    return this._descriptor_31;
  };
  $serializer_0.prototype.childSerializers_2 = function () {
    var tmp0_arrayOf_0 = [StringSerializer_getInstance(), IntSerializer_getInstance()];
    return tmp0_arrayOf_0;
  };
  $serializer_0.prototype.deserialize_52 = function (decoder) {
    var tmp0_desc = this._descriptor_31;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = 0;
    var tmp6_input = decoder.beginStructure_11(tmp0_desc);
    if (tmp6_input.decodeSequentially_8()) {
      tmp4_local0 = tmp6_input.decodeStringElement_8(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.decodeIntElement_8(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.decodeElementIndex_8(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.decodeStringElement_8(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.decodeIntElement_8(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp6_input.endStructure_11(tmp0_desc);
    return PatientArrival_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  };
  $serializer_0.prototype.serialize_75 = function (encoder, value) {
    var tmp0_desc = this._descriptor_31;
    var tmp1_output = encoder.beginStructure_11(tmp0_desc);
    tmp1_output.encodeStringElement_1(tmp0_desc, 0, value._token);
    tmp1_output.encodeIntElement_1(tmp0_desc, 1, value._locationId);
    tmp1_output.endStructure_11(tmp0_desc);
  };
  $serializer_0.prototype.serialize_76 = function (encoder, value) {
    return this.serialize_75(encoder, value instanceof PatientArrival ? value : THROW_CCE());
  };
  $serializer_0.$metadata$ = {
    simpleName: '$serializer',
    kind: 'object',
    interfaces: [GeneratedSerializer]
  };
  var $serializer_instance_0;
  function $serializer_getInstance_0() {
    if ($serializer_instance_0 == null)
      new $serializer_0();
    return $serializer_instance_0;
  }
  function PatientArrival_init_$Init$(seen1, token, locationId, serializationConstructorMarker, $this) {
    if (0 === (seen1 & 1))
      throw MissingFieldException_init_$Create$('token');
    else
      $this._token = token;
    if (0 === (seen1 & 2))
      throw MissingFieldException_init_$Create$('locationId');
    else
      $this._locationId = locationId;
    return $this;
  }
  function PatientArrival_init_$Create$(seen1, token, locationId, serializationConstructorMarker) {
    return PatientArrival_init_$Init$(seen1, token, locationId, serializationConstructorMarker, Object.create(PatientArrival.prototype));
  }
  function PatientArrival(token, locationId) {
    Companion_getInstance_20();
    this._token = token;
    this._locationId = locationId;
  }
  PatientArrival.prototype.toString = function () {
    return '' + 'PatientArrival(token=' + this._token + ', locationId=' + this._locationId + ')';
  };
  PatientArrival.prototype.hashCode = function () {
    var result = getStringHashCode(this._token);
    result = imul(result, 31) + this._locationId | 0;
    return result;
  };
  PatientArrival.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof PatientArrival))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof PatientArrival ? other : THROW_CCE();
    if (!(this._token === tmp0_other_with_cast._token))
      return false;
    if (!(this._locationId === tmp0_other_with_cast._locationId))
      return false;
    return true;
  };
  PatientArrival.$metadata$ = {
    simpleName: 'PatientArrival',
    kind: 'class',
    interfaces: [],
    associatedObjects: {0: $serializer_getInstance_0}
  };
  function invoke(_this_, values_5) {
    return invoke_1(_this_, [], values_5.slice());
  }
  function invoke_0(_this_, string, values_5) {
    var tmp0_arrayOf_0 = [string];
    return invoke_1(_this_, tmp0_arrayOf_0, values_5.slice());
  }
  function invoke_1(_this_, strings, values_5) {
    return function () {
      var $externalVarargReceiverTmp = _this_;
      return $externalVarargReceiverTmp.call.apply($externalVarargReceiverTmp, [null, strings].concat([].slice.call(values_5.slice())));
    }.call(this);
  }
  function AtomicArray(size_0) {
    var tmp = this;
    var tmp_0 = 0;
    var tmp_1 = size_0;
    var tmp_2 = fillArrayVal(Array(tmp_1), null);
    while (tmp_0 < tmp_1) {
      var tmp_3 = tmp_0;
      tmp_2[tmp_3] = atomic(null);
      tmp_0 = tmp_0 + 1 | 0;
    }
    tmp._array_0 = tmp_2;
  }
  AtomicArray.prototype.get$atomicfu = function (index) {
    return this._array_0[index];
  };
  AtomicArray.$metadata$ = {
    simpleName: 'AtomicArray',
    kind: 'class',
    interfaces: []
  };
  function atomicArrayOfNulls(size_0) {
    return new AtomicArray(size_0);
  }
  function AtomicRef(value) {
    this._value_8 = value;
  }
  AtomicRef.prototype._set_value_ = function (_set___) {
    this._value_8 = _set___;
  };
  AtomicRef.prototype._get_value__33 = function () {
    return this._value_8;
  };
  AtomicRef.prototype.compareAndSet$atomicfu = function (expect, update) {
    if (!(this._value_8 === expect))
      return false;
    this._value_8 = update;
    return true;
  };
  AtomicRef.prototype.getAndSet$atomicfu = function (value) {
    var oldValue = this._value_8;
    this._value_8 = value;
    return oldValue;
  };
  AtomicRef.prototype.toString = function () {
    return toString_0(this._value_8);
  };
  AtomicRef.$metadata$ = {
    simpleName: 'AtomicRef',
    kind: 'class',
    interfaces: []
  };
  Object.defineProperty(AtomicRef.prototype, 'kotlinx$atomicfu$value', {
    configurable: true,
    get: AtomicRef.prototype._get_value__33,
    set: AtomicRef.prototype._set_value_
  });
  function atomic(initial) {
    return new AtomicRef(initial);
  }
  function AtomicBoolean(value) {
    this._value_9 = value;
  }
  AtomicBoolean.prototype._set_value__0 = function (_set___) {
    this._value_9 = _set___;
  };
  AtomicBoolean.prototype._get_value__33 = function () {
    return this._value_9;
  };
  AtomicBoolean.prototype.compareAndSet$atomicfu = function (expect, update) {
    if (!(this._value_9 === expect))
      return false;
    this._value_9 = update;
    return true;
  };
  AtomicBoolean.prototype.getAndSet$atomicfu = function (value) {
    var oldValue = this._value_9;
    this._value_9 = value;
    return oldValue;
  };
  AtomicBoolean.prototype.toString = function () {
    return this._value_9.toString();
  };
  AtomicBoolean.$metadata$ = {
    simpleName: 'AtomicBoolean',
    kind: 'class',
    interfaces: []
  };
  Object.defineProperty(AtomicBoolean.prototype, 'kotlinx$atomicfu$value', {
    configurable: true,
    get: AtomicBoolean.prototype._get_value__33,
    set: AtomicBoolean.prototype._set_value__0
  });
  function atomic_0(initial) {
    return new AtomicBoolean(initial);
  }
  function AtomicInt(value) {
    this._value_10 = value;
  }
  AtomicInt.prototype._set_value__1 = function (_set___) {
    this._value_10 = _set___;
  };
  AtomicInt.prototype._get_value__33 = function () {
    return this._value_10;
  };
  AtomicInt.prototype.compareAndSet$atomicfu = function (expect, update) {
    if (!(this._value_10 === expect))
      return false;
    this._value_10 = update;
    return true;
  };
  AtomicInt.prototype.getAndSet$atomicfu = function (value) {
    var oldValue = this._value_10;
    this._value_10 = value;
    return oldValue;
  };
  AtomicInt.prototype.getAndIncrement$atomicfu = function () {
    var tmp0_this = this;
    var tmp1 = tmp0_this._value_10;
    tmp0_this._value_10 = tmp1 + 1 | 0;
    return tmp1;
  };
  AtomicInt.prototype.getAndDecrement$atomicfu = function () {
    var tmp0_this = this;
    var tmp1 = tmp0_this._value_10;
    tmp0_this._value_10 = tmp1 - 1 | 0;
    return tmp1;
  };
  AtomicInt.prototype.getAndAdd$atomicfu = function (delta_0) {
    var oldValue = this._value_10;
    var tmp0_this = this;
    tmp0_this._value_10 = tmp0_this._value_10 + delta_0 | 0;
    return oldValue;
  };
  AtomicInt.prototype.addAndGet$atomicfu = function (delta_0) {
    var tmp0_this = this;
    tmp0_this._value_10 = tmp0_this._value_10 + delta_0 | 0;
    return this._value_10;
  };
  AtomicInt.prototype.incrementAndGet$atomicfu = function () {
    var tmp0_this = this;
    tmp0_this._value_10 = tmp0_this._value_10 + 1 | 0;
    return tmp0_this._value_10;
  };
  AtomicInt.prototype.decrementAndGet$atomicfu = function () {
    var tmp0_this = this;
    tmp0_this._value_10 = tmp0_this._value_10 - 1 | 0;
    return tmp0_this._value_10;
  };
  AtomicInt.prototype.toString = function () {
    return this._value_10.toString();
  };
  AtomicInt.$metadata$ = {
    simpleName: 'AtomicInt',
    kind: 'class',
    interfaces: []
  };
  Object.defineProperty(AtomicInt.prototype, 'kotlinx$atomicfu$value', {
    configurable: true,
    get: AtomicInt.prototype._get_value__33,
    set: AtomicInt.prototype._set_value__1
  });
  function atomic_1(initial) {
    return new AtomicInt(initial);
  }
  function AbstractCoroutine(parentContext, active) {
    JobSupport.call(this, active);
    this._parentContext = parentContext;
    this._context = this._parentContext.plus_28(this);
  }
  AbstractCoroutine.prototype._get_context__86 = function () {
    return this._context;
  };
  AbstractCoroutine.prototype._get_coroutineContext__22 = function () {
    return this._context;
  };
  AbstractCoroutine.prototype._get_isActive__23 = function () {
    return JobSupport.prototype._get_isActive__23.call(this);
  };
  AbstractCoroutine.prototype.initParentJob_3 = function () {
    this.initParentJobInternal_7(this._parentContext.get_70(Key_getInstance_3()));
  };
  AbstractCoroutine.prototype.onStart_3 = function () {
  };
  AbstractCoroutine.prototype.onStartInternal_7 = function () {
    this.onStart_3();
  };
  AbstractCoroutine.prototype.onCompleted_3 = function (value) {
  };
  AbstractCoroutine.prototype.onCancelled_3 = function (cause, handled) {
  };
  AbstractCoroutine.prototype.cancellationExceptionMessage_7 = function () {
    return '' + _get_classSimpleName_(this) + ' was cancelled';
  };
  AbstractCoroutine.prototype.onCompletionInternal_7 = function (state) {
    if (state instanceof CompletedExceptionally)
      this.onCancelled_3(state._cause, state._get_handled__0());
    else {
      {
        this.onCompleted_3((state == null ? true : isObject(state)) ? state : THROW_CCE());
      }
    }
  };
  AbstractCoroutine.prototype.resumeWith_34 = function (result) {
    var state = this.makeCompletingOnce_4(toState$default(result, null, 1, null));
    if (state === COMPLETING_WAITING_CHILDREN)
      return Unit_getInstance();
    this.afterResume_3(state);
  };
  AbstractCoroutine.prototype.afterResume_3 = function (state) {
    return this.afterCompletion_7(state);
  };
  AbstractCoroutine.prototype.handleOnCompletionException_7 = function (exception) {
    handleCoroutineException(this._context, exception);
  };
  AbstractCoroutine.prototype.nameString_9 = function () {
    var tmp0_elvis_lhs = _get_coroutineName_(this._context);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return JobSupport.prototype.nameString_9.call(this);
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var coroutineName = tmp;
    return '' + '"' + coroutineName + '":' + JobSupport.prototype.nameString_9.call(this);
  };
  AbstractCoroutine.prototype.start_8 = function (start, receiver, block) {
    this.initParentJob_3();
    start.invoke_108(block, receiver, this);
  };
  AbstractCoroutine.$metadata$ = {
    simpleName: 'AbstractCoroutine',
    kind: 'class',
    interfaces: [Job, Continuation, CoroutineScope]
  };
  function launch(_this_, context, start, block) {
    var newContext = newCoroutineContext(_this_, context);
    var coroutine = start._get_isLazy_() ? new LazyStandaloneCoroutine(newContext, block) : new StandaloneCoroutine(newContext, true);
    coroutine.start_8(start, coroutine, block);
    return coroutine;
  }
  function launch$default(_this_, context, start, block, $mask0, $handler) {
    if (!(($mask0 & 1) === 0))
      context = EmptyCoroutineContext_getInstance();
    if (!(($mask0 & 2) === 0))
      start = CoroutineStart_DEFAULT_getInstance();
    return launch(_this_, context, start, block);
  }
  function async(_this_, context, start, block) {
    var newContext = newCoroutineContext(_this_, context);
    var coroutine = start._get_isLazy_() ? new LazyDeferredCoroutine(newContext, block) : new DeferredCoroutine(newContext, true);
    coroutine.start_8(start, coroutine, block);
    return coroutine;
  }
  function async$default(_this_, context, start, block, $mask0, $handler) {
    if (!(($mask0 & 1) === 0))
      context = EmptyCoroutineContext_getInstance();
    if (!(($mask0 & 2) === 0))
      start = CoroutineStart_DEFAULT_getInstance();
    return async(_this_, context, start, block);
  }
  function StandaloneCoroutine(parentContext, active) {
    AbstractCoroutine.call(this, parentContext, active);
  }
  StandaloneCoroutine.prototype.handleJobException_7 = function (exception) {
    handleCoroutineException(this._get_context__86(), exception);
    return true;
  };
  StandaloneCoroutine.$metadata$ = {
    simpleName: 'StandaloneCoroutine',
    kind: 'class',
    interfaces: []
  };
  function LazyStandaloneCoroutine(parentContext, block) {
    StandaloneCoroutine.call(this, parentContext, false);
    this._continuation = createCoroutineUnintercepted(block, this, this);
  }
  LazyStandaloneCoroutine.prototype.onStart_3 = function () {
    startCoroutineCancellable_0(this._continuation, this);
  };
  LazyStandaloneCoroutine.$metadata$ = {
    simpleName: 'LazyStandaloneCoroutine',
    kind: 'class',
    interfaces: []
  };
  function $awaitCOROUTINE$0(_this_, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this_ = _this_;
  }
  $awaitCOROUTINE$0.prototype.doResume_72 = function () {
    var suspendResult = this._result;
    $sm: do
      try {
        var tmp = this._state_0;
        switch (tmp) {
          case 0:
            this._exceptionState = 2;
            this._state_0 = 1;
            suspendResult = this.__this_.awaitInternal_2(this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            var tmp_0 = suspendResult;
            return (tmp_0 == null ? true : isObject(tmp_0)) ? tmp_0 : THROW_CCE();
          case 2:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 2) {
          throw $p;
        } else {
          this._state_0 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $awaitCOROUTINE$0.$metadata$ = {
    simpleName: '$awaitCOROUTINE$0',
    kind: 'class',
    interfaces: []
  };
  function DeferredCoroutine(parentContext, active) {
    AbstractCoroutine.call(this, parentContext, active);
  }
  DeferredCoroutine.prototype.await_2 = function ($cont) {
    var tmp = new $awaitCOROUTINE$0(this, $cont);
    tmp._result = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_72();
  };
  DeferredCoroutine.$metadata$ = {
    simpleName: 'DeferredCoroutine',
    kind: 'class',
    interfaces: [Deferred, SelectClause1]
  };
  function LazyDeferredCoroutine(parentContext, block) {
    DeferredCoroutine.call(this, parentContext, false);
    this._continuation_0 = createCoroutineUnintercepted(block, this, this);
  }
  LazyDeferredCoroutine.prototype.onStart_3 = function () {
    startCoroutineCancellable_0(this._continuation_0, this);
  };
  LazyDeferredCoroutine.$metadata$ = {
    simpleName: 'LazyDeferredCoroutine',
    kind: 'class',
    interfaces: []
  };
  function CancellableContinuation() {
  }
  CancellableContinuation.prototype.tryResume$default_1 = function (value, idempotent, $mask0, $handler) {
    if (!(($mask0 & 2) === 0))
      idempotent = null;
    return $handler == null ? this.tryResume_3(value, idempotent) : $handler(value, idempotent);
  };
  CancellableContinuation.$metadata$ = {
    simpleName: 'CancellableContinuation',
    kind: 'interface',
    interfaces: [Continuation]
  };
  function disposeOnCancellation(_this_, handle) {
    var tmp0__get_asHandler__0 = new DisposeOnCancel(handle);
    return _this_.invokeOnCancellation_1(tmp0__get_asHandler__0);
  }
  function DisposeOnCancel(handle) {
    CancelHandler.call(this);
    this._handle = handle;
  }
  DisposeOnCancel.prototype.invoke_375 = function (cause) {
    return this._handle.dispose_26();
  };
  DisposeOnCancel.prototype.invoke = function (cause) {
    return this.invoke_375(cause);
  };
  DisposeOnCancel.prototype.toString = function () {
    return '' + 'DisposeOnCancel[' + this._handle + ']';
  };
  DisposeOnCancel.$metadata$ = {
    simpleName: 'DisposeOnCancel',
    kind: 'class',
    interfaces: []
  };
  function removeOnCancellation(_this_, node) {
    var tmp0__get_asHandler__0 = new RemoveOnCancel(node);
    return _this_.invokeOnCancellation_1(tmp0__get_asHandler__0);
  }
  function getOrCreateCancellableContinuation(delegate) {
    if (!(delegate instanceof DispatchedContinuation)) {
      return new CancellableContinuationImpl(delegate, 2);
    } else {
    }
    var tmp0_safe_receiver = delegate.claimReusableCancellableContinuation();
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      var tmp_0;
      if (tmp0_safe_receiver.resetStateReusable_0()) {
        tmp_0 = tmp0_safe_receiver;
      } else {
        {
          tmp_0 = null;
        }
      }
      tmp = tmp_0;
    }
    var tmp1_elvis_lhs = tmp;
    var tmp_1;
    if (tmp1_elvis_lhs == null) {
      return new CancellableContinuationImpl(delegate, 2);
    } else {
      tmp_1 = tmp1_elvis_lhs;
    }
    return tmp_1;
  }
  function RemoveOnCancel(node) {
    BeforeResumeCancelHandler.call(this);
    this._node = node;
  }
  RemoveOnCancel.prototype.invoke_375 = function (cause) {
    this._node.remove_35();
    Unit_getInstance();
  };
  RemoveOnCancel.prototype.invoke = function (cause) {
    return this.invoke_375(cause);
  };
  RemoveOnCancel.prototype.toString = function () {
    return '' + 'RemoveOnCancel[' + this._node + ']';
  };
  RemoveOnCancel.$metadata$ = {
    simpleName: 'RemoveOnCancel',
    kind: 'class',
    interfaces: []
  };
  var RESUME_TOKEN;
  function _set_parentHandle_($this, value) {
    $this.__parentHandle._value_8 = value;
  }
  function _get_parentHandle_($this) {
    return $this.__parentHandle._value_8;
  }
  function isReusable($this) {
    var tmp;
    var tmp_0 = $this._delegate;
    if (tmp_0 instanceof DispatchedContinuation) {
      tmp = $this._delegate.isReusable($this);
    } else {
      {
        tmp = false;
      }
    }
    return tmp;
  }
  function setupCancellation($this) {
    if (checkCompleted($this))
      return Unit_getInstance();
    if (!(_get_parentHandle_($this) === null))
      return Unit_getInstance();
    var tmp0_elvis_lhs = $this._delegate._get_context__86().get_70(Key_getInstance_3());
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return Unit_getInstance();
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var parent = tmp;
    var tmp0__get_asHandler__0 = new ChildContinuation(parent, $this);
    var handle = parent.invokeOnCompletion$default_9(true, false, tmp0__get_asHandler__0, 2, null);
    _set_parentHandle_($this, handle);
    if ($this._get_isCompleted__9() ? !isReusable($this) : false) {
      handle.dispose_26();
      _set_parentHandle_($this, NonDisposableHandle_getInstance());
    }}
  function checkCompleted($this) {
    var completed = $this._get_isCompleted__9();
    if (!_get_isReusableMode_($this._get_resumeMode__1()))
      return completed;
    var tmp = $this._delegate;
    var tmp0_elvis_lhs = tmp instanceof DispatchedContinuation ? tmp : null;
    var tmp_0;
    if (tmp0_elvis_lhs == null) {
      return completed;
    } else {
      tmp_0 = tmp0_elvis_lhs;
    }
    var dispatched = tmp_0;
    var tmp1_elvis_lhs = dispatched.checkPostponedCancellation($this);
    var tmp_1;
    if (tmp1_elvis_lhs == null) {
      return completed;
    } else {
      tmp_1 = tmp1_elvis_lhs;
    }
    var cause = tmp_1;
    if (!completed) {
      $this.cancel_23(cause);
      Unit_getInstance();
    }return true;
  }
  function cancelLater($this, cause) {
    if (!_get_isReusableMode_($this._get_resumeMode__1()))
      return false;
    var tmp = $this._delegate;
    var tmp0_elvis_lhs = tmp instanceof DispatchedContinuation ? tmp : null;
    var tmp_0;
    if (tmp0_elvis_lhs == null) {
      return false;
    } else {
      tmp_0 = tmp0_elvis_lhs;
    }
    var dispatched = tmp_0;
    return dispatched.postponeCancellation(cause);
  }
  function callCancelHandler($this, handler, cause) {
    var tmp;
    try {
      tmp = invokeIt(handler, cause);
    } catch ($p) {
      var tmp_0;
      if ($p instanceof Error) {
        tmp_0 = handleCoroutineException($this._get_context__86(), new CompletionHandlerException('' + 'Exception in invokeOnCancellation handler for ' + $this, $p));
      } else {
        {
          throw $p;
        }
      }
      tmp = tmp_0;
    }
    return tmp;
  }
  function trySuspend($this) {
    var tmp0_loop_0 = $this.__decision;
    while (true) {
      var tmp1__anonymous__1 = tmp0_loop_0._value_10;
      var tmp0_subject_2 = tmp1__anonymous__1;
      switch (tmp0_subject_2) {
        case 0:
          if ($this.__decision.compareAndSet$atomicfu(0, 1))
            return true;
          break;
        case 2:
          return false;
        default:var tmp0_error_0_3 = 'Already suspended';
          throw IllegalStateException_init_$Create$(toString_1(tmp0_error_0_3));
      }
    }
    Unit_getInstance();
  }
  function tryResume($this) {
    var tmp0_loop_0 = $this.__decision;
    while (true) {
      var tmp1__anonymous__1 = tmp0_loop_0._value_10;
      var tmp0_subject_2 = tmp1__anonymous__1;
      switch (tmp0_subject_2) {
        case 0:
          if ($this.__decision.compareAndSet$atomicfu(0, 2))
            return true;
          break;
        case 1:
          return false;
        default:var tmp0_error_0_3 = 'Already resumed';
          throw IllegalStateException_init_$Create$(toString_1(tmp0_error_0_3));
      }
    }
    Unit_getInstance();
  }
  function multipleHandlersError($this, handler, state) {
    var tmp0_error_0 = '' + "It's prohibited to register multiple handlers, tried to register " + handler + ', already has ' + state;
    throw IllegalStateException_init_$Create$(toString_1(tmp0_error_0));
  }
  function makeCancelHandler($this, handler) {
    var tmp;
    if (handler instanceof CancelHandler) {
      tmp = handler;
    } else {
      {
        tmp = new InvokeOnCancel(handler);
      }
    }
    return tmp;
  }
  function dispatchResume($this, mode) {
    if (tryResume($this))
      return Unit_getInstance();
    dispatch($this, mode);
  }
  function resumedState($this, state, proposedUpdate, resumeMode, onCancellation, idempotent) {
    var tmp;
    if (proposedUpdate instanceof CompletedExceptionally) {
      tmp = proposedUpdate;
    } else {
      if (!_get_isCancellableMode_(resumeMode) ? idempotent == null : false) {
        tmp = proposedUpdate;
      } else {
        var tmp_0;
        var tmp_1;
        if (!(onCancellation == null)) {
          tmp_1 = true;
        } else {
          var tmp_2;
          if (state instanceof CancelHandler) {
            tmp_2 = !(state instanceof BeforeResumeCancelHandler);
          } else {
            {
              tmp_2 = false;
            }
          }
          tmp_1 = tmp_2;
        }
        if (tmp_1) {
          tmp_0 = true;
        } else {
          {
            tmp_0 = !(idempotent == null);
          }
        }
        if (tmp_0) {
          var tmp_3 = state instanceof CancelHandler ? state : null;
          tmp = CompletedContinuation_init_$Create$(proposedUpdate, tmp_3, onCancellation, idempotent, null, 16, null);
        } else {
          {
            tmp = proposedUpdate;
          }
        }
      }
    }
    return tmp;
  }
  function resumeImpl($this, proposedUpdate, resumeMode, onCancellation) {
    var tmp0_loop_0 = $this.__state;
    while (true) {
      var tmp$ret$0;
      l$ret$1: do {
        var tmp1__anonymous__1 = tmp0_loop_0._value_8;
        var tmp0_subject_2 = tmp1__anonymous__1;
        if (!(tmp0_subject_2 == null) ? isInterface(tmp0_subject_2, NotCompleted) : false) {
          var update_3 = resumedState($this, tmp1__anonymous__1, proposedUpdate, resumeMode, onCancellation, null);
          if (!$this.__state.compareAndSet$atomicfu(tmp1__anonymous__1, update_3)) {
            tmp$ret$0 = Unit_getInstance();
            break l$ret$1;
          }detachChildIfNonResuable($this);
          dispatchResume($this, resumeMode);
          return Unit_getInstance();
        } else {
          if (tmp0_subject_2 instanceof CancelledContinuation) {
            if (tmp1__anonymous__1.makeResumed()) {
              var tmp1_safe_receiver_4 = onCancellation;
              if (tmp1_safe_receiver_4 == null)
                null;
              else {
                $this.callOnCancellation_0(tmp1_safe_receiver_4, tmp1__anonymous__1._get_cause__54());
                Unit_getInstance();
              }
              Unit_getInstance();
              return Unit_getInstance();
            }} else {
          }
        }
        alreadyResumedError($this, proposedUpdate);
      }
       while (false);
    }
    Unit_getInstance();
  }
  function resumeImpl$default($this, proposedUpdate, resumeMode, onCancellation, $mask0, $handler) {
    if (!(($mask0 & 8) === 0))
      onCancellation = null;
    return resumeImpl($this, proposedUpdate, resumeMode, onCancellation);
  }
  function tryResumeImpl($this, proposedUpdate, idempotent, onCancellation) {
    var tmp0_loop_0 = $this.__state;
    while (true) {
      var tmp$ret$0;
      l$ret$1: do {
        var tmp1__anonymous__1 = tmp0_loop_0._value_8;
        var tmp0_subject_2 = tmp1__anonymous__1;
        if (!(tmp0_subject_2 == null) ? isInterface(tmp0_subject_2, NotCompleted) : false) {
          var update_3 = resumedState($this, tmp1__anonymous__1, proposedUpdate, $this._get_resumeMode__1(), onCancellation, idempotent);
          if (!$this.__state.compareAndSet$atomicfu(tmp1__anonymous__1, update_3)) {
            tmp$ret$0 = Unit_getInstance();
            break l$ret$1;
          }detachChildIfNonResuable($this);
          return RESUME_TOKEN;
        } else {
          if (tmp0_subject_2 instanceof CompletedContinuation_0) {
            var tmp;
            if (!(idempotent == null) ? tmp1__anonymous__1._idempotentResume === idempotent : false) {
              tmp = RESUME_TOKEN;
            } else {
              tmp = null;
            }
            return tmp;
          } else {
            return null;
          }
        }
      }
       while (false);
    }
    Unit_getInstance();
  }
  function alreadyResumedError($this, proposedUpdate) {
    var tmp0_error_0 = '' + 'Already resumed, but proposed with update ' + proposedUpdate;
    throw IllegalStateException_init_$Create$(toString_1(tmp0_error_0));
  }
  function detachChildIfNonResuable($this) {
    if (!isReusable($this))
      $this.detachChild_0();
  }
  function CancellableContinuationImpl(delegate, resumeMode) {
    DispatchedTask.call(this, resumeMode);
    this._delegate = delegate;
    this._context_0 = this._delegate._get_context__86();
    this.__decision = atomic_1(0);
    this.__state = atomic(Active_getInstance());
    this.__parentHandle = atomic(null);
  }
  CancellableContinuationImpl.prototype._get_delegate__2 = function () {
    return this._delegate;
  };
  CancellableContinuationImpl.prototype._get_context__86 = function () {
    return this._context_0;
  };
  CancellableContinuationImpl.prototype._get_state__9 = function () {
    return this.__state._value_8;
  };
  CancellableContinuationImpl.prototype._get_isCompleted__9 = function () {
    var tmp = this._get_state__9();
    return !(!(tmp == null) ? isInterface(tmp, NotCompleted) : false);
  };
  CancellableContinuationImpl.prototype._get_isCancelled__1 = function () {
    var tmp = this._get_state__9();
    return tmp instanceof CancelledContinuation;
  };
  CancellableContinuationImpl.prototype.initCancellability_0 = function () {
    setupCancellation(this);
  };
  CancellableContinuationImpl.prototype.resetStateReusable_0 = function () {
    var state = this.__state._value_8;
    var tmp;
    if (state instanceof CompletedContinuation_0) {
      tmp = !(state._idempotentResume == null);
    } else {
      {
        tmp = false;
      }
    }
    if (tmp) {
      this.detachChild_0();
      return false;
    } else {
    }
    this.__decision._value_10 = 0;
    this.__state._value_8 = Active_getInstance();
    return true;
  };
  CancellableContinuationImpl.prototype.takeState_2 = function () {
    return this._get_state__9();
  };
  CancellableContinuationImpl.prototype.cancelCompletedResult_2 = function (takenState, cause) {
    var tmp0_loop_0 = this.__state;
    while (true) {
      var tmp1__anonymous__1 = tmp0_loop_0._value_8;
      var tmp0_subject_2 = tmp1__anonymous__1;
      if (!(tmp0_subject_2 == null) ? isInterface(tmp0_subject_2, NotCompleted) : false) {
        var tmp0_error_0_3 = 'Not completed';
        throw IllegalStateException_init_$Create$(toString_1(tmp0_error_0_3));
      } else {
        if (tmp0_subject_2 instanceof CompletedExceptionally)
          return Unit_getInstance();
        else {
          if (tmp0_subject_2 instanceof CompletedContinuation_0) {
            var tmp1_check_0_4 = !tmp1__anonymous__1._get_cancelled_();
            if (!tmp1_check_0_4) {
              var message_1_5 = 'Must be called at most once';
              throw IllegalStateException_init_$Create$(toString_1(message_1_5));
            }var tmp = tmp1__anonymous__1;
            var update_6 = tmp.copy$default(null, null, null, null, cause, 15, null);
            if (this.__state.compareAndSet$atomicfu(tmp1__anonymous__1, update_6)) {
              tmp1__anonymous__1.invokeHandlers(this, cause);
              return Unit_getInstance();
            }} else {
            {
              if (this.__state.compareAndSet$atomicfu(tmp1__anonymous__1, CompletedContinuation_init_$Create$(tmp1__anonymous__1, null, null, null, cause, 14, null))) {
                return Unit_getInstance();
              } else {
              }
            }
          }
        }
      }
    }
    Unit_getInstance();
  };
  CancellableContinuationImpl.prototype.cancel_23 = function (cause) {
    var tmp0_loop_0 = this.__state;
    while (true) {
      var tmp$ret$0;
      l$ret$1: do {
        var tmp1__anonymous__1 = tmp0_loop_0._value_8;
        if (!(!(tmp1__anonymous__1 == null) ? isInterface(tmp1__anonymous__1, NotCompleted) : false))
          return false;
        else {
        }
        var update_2 = new CancelledContinuation(this, cause, tmp1__anonymous__1 instanceof CancelHandler);
        if (!this.__state.compareAndSet$atomicfu(tmp1__anonymous__1, update_2)) {
          tmp$ret$0 = Unit_getInstance();
          break l$ret$1;
        }var tmp0_safe_receiver_3 = tmp1__anonymous__1 instanceof CancelHandler ? tmp1__anonymous__1 : null;
        if (tmp0_safe_receiver_3 == null)
          null;
        else {
          this.callCancelHandler_0(tmp0_safe_receiver_3, cause);
          Unit_getInstance();
        }
        Unit_getInstance();
        detachChildIfNonResuable(this);
        dispatchResume(this, this._get_resumeMode__1());
        return true;
      }
       while (false);
    }
    Unit_getInstance();
  };
  CancellableContinuationImpl.prototype.parentCancelled_7 = function (cause) {
    if (cancelLater(this, cause))
      return Unit_getInstance();
    this.cancel_23(cause);
    Unit_getInstance();
    detachChildIfNonResuable(this);
  };
  CancellableContinuationImpl.prototype.callCancelHandler_0 = function (handler, cause) {
    var tmp;
    try {
      tmp = handler.invoke(cause);
    } catch ($p) {
      var tmp_0;
      if ($p instanceof Error) {
        tmp_0 = handleCoroutineException(this._get_context__86(), new CompletionHandlerException('' + 'Exception in invokeOnCancellation handler for ' + this, $p));
      } else {
        {
          throw $p;
        }
      }
      tmp = tmp_0;
    }
    return tmp;
  };
  CancellableContinuationImpl.prototype.callOnCancellation_0 = function (onCancellation, cause) {
    try {
      onCancellation(cause);
    } catch ($p) {
      if ($p instanceof Error) {
        handleCoroutineException(this._get_context__86(), new CompletionHandlerException('' + 'Exception in resume onCancellation handler for ' + this, $p));
      } else {
        {
          throw $p;
        }
      }
    }
  };
  CancellableContinuationImpl.prototype.getContinuationCancellationCause_0 = function (parent) {
    return parent.getCancellationException_9();
  };
  CancellableContinuationImpl.prototype.getResult_0 = function () {
    setupCancellation(this);
    if (trySuspend(this))
      return _get_COROUTINE_SUSPENDED_();
    var state = this._get_state__9();
    if (state instanceof CompletedExceptionally)
      throw recoverStackTrace(state._cause, this);
    else {
    }
    if (_get_isCancellableMode_(this._get_resumeMode__1())) {
      var job = this._get_context__86().get_70(Key_getInstance_3());
      if (!(job == null) ? !job._get_isActive__23() : false) {
        var cause = job.getCancellationException_9();
        this.cancelCompletedResult_2(state, cause);
        throw recoverStackTrace(cause, this);
      }}return this.getSuccessfulResult_2(state);
  };
  CancellableContinuationImpl.prototype.resumeWith_34 = function (result) {
    var tmp = toState(result, this);
    var tmp_0 = this._get_resumeMode__1();
    return resumeImpl$default(this, tmp, tmp_0, null, 8, null);
  };
  CancellableContinuationImpl.prototype.resume_1 = function (value, onCancellation) {
    return resumeImpl(this, value, this._get_resumeMode__1(), onCancellation);
  };
  CancellableContinuationImpl.prototype.invokeOnCancellation_1 = function (handler) {
    var cancelHandler = makeCancelHandler(this, handler);
    var tmp0_loop_0 = this.__state;
    while (true) {
      var tmp1__anonymous__1 = tmp0_loop_0._value_8;
      var tmp0_subject_2 = tmp1__anonymous__1;
      if (tmp0_subject_2 instanceof Active) {
        if (this.__state.compareAndSet$atomicfu(tmp1__anonymous__1, cancelHandler))
          return Unit_getInstance();
      } else {
        if (tmp0_subject_2 instanceof CancelHandler)
          multipleHandlersError(this, handler, tmp1__anonymous__1);
        else {
          if (tmp0_subject_2 instanceof CompletedExceptionally) {
            if (!tmp1__anonymous__1.makeHandled_0())
              multipleHandlersError(this, handler, tmp1__anonymous__1);
            if (tmp1__anonymous__1 instanceof CancelledContinuation) {
              var tmp1_safe_receiver_3 = tmp1__anonymous__1 instanceof CompletedExceptionally ? tmp1__anonymous__1 : null;
              callCancelHandler(this, handler, tmp1_safe_receiver_3 == null ? null : tmp1_safe_receiver_3._cause);
            } else {
            }
            return Unit_getInstance();
          } else {
            if (tmp0_subject_2 instanceof CompletedContinuation_0) {
              if (!(tmp1__anonymous__1._cancelHandler == null))
                multipleHandlersError(this, handler, tmp1__anonymous__1);
              if (cancelHandler instanceof BeforeResumeCancelHandler)
                return Unit_getInstance();
              else {
              }
              if (tmp1__anonymous__1._get_cancelled_()) {
                callCancelHandler(this, handler, tmp1__anonymous__1._cancelCause);
                return Unit_getInstance();
              }var tmp = tmp1__anonymous__1;
              var update_4 = tmp.copy$default(null, cancelHandler, null, null, null, 29, null);
              if (this.__state.compareAndSet$atomicfu(tmp1__anonymous__1, update_4))
                return Unit_getInstance();
            } else {
              {
                if (cancelHandler instanceof BeforeResumeCancelHandler)
                  return Unit_getInstance();
                else {
                }
                var update_5 = CompletedContinuation_init_$Create$(tmp1__anonymous__1, cancelHandler, null, null, null, 28, null);
                if (this.__state.compareAndSet$atomicfu(tmp1__anonymous__1, update_5))
                  return Unit_getInstance();
              }
            }
          }
        }
      }
    }
    Unit_getInstance();
  };
  CancellableContinuationImpl.prototype.detachChild_0 = function () {
    var handle = _get_parentHandle_(this);
    var tmp0_safe_receiver = handle;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.dispose_26();
      Unit_getInstance();
    }
    Unit_getInstance();
    _set_parentHandle_(this, NonDisposableHandle_getInstance());
  };
  CancellableContinuationImpl.prototype.tryResume_3 = function (value, idempotent) {
    return tryResumeImpl(this, value, idempotent, null);
  };
  CancellableContinuationImpl.prototype.tryResume_4 = function (value, idempotent, onCancellation) {
    return tryResumeImpl(this, value, idempotent, onCancellation);
  };
  CancellableContinuationImpl.prototype.tryResumeWithException_1 = function (exception) {
    return tryResumeImpl(this, CompletedExceptionally_init_$Create$(exception, false, 2, null), null, null);
  };
  CancellableContinuationImpl.prototype.completeResume_1 = function (token) {
    dispatchResume(this, this._get_resumeMode__1());
  };
  CancellableContinuationImpl.prototype.resumeUndispatched_1 = function (_this__0, value) {
    var tmp = this._delegate;
    var dc = tmp instanceof DispatchedContinuation ? tmp : null;
    var tmp_0;
    var tmp0_safe_receiver = dc;
    if ((tmp0_safe_receiver == null ? null : tmp0_safe_receiver._dispatcher) === _this__0) {
      tmp_0 = 4;
    } else {
      {
        tmp_0 = this._get_resumeMode__1();
      }
    }
    var tmp_1 = tmp_0;
    resumeImpl$default(this, value, tmp_1, null, 8, null);
  };
  CancellableContinuationImpl.prototype.getSuccessfulResult_2 = function (state) {
    var tmp0_subject = state;
    var tmp;
    if (tmp0_subject instanceof CompletedContinuation_0) {
      var tmp_0 = state._result_0;
      tmp = (tmp_0 == null ? true : isObject(tmp_0)) ? tmp_0 : THROW_CCE();
    } else {
      {
        tmp = (state == null ? true : isObject(state)) ? state : THROW_CCE();
      }
    }
    return tmp;
  };
  CancellableContinuationImpl.prototype.getExceptionalResult_2 = function (state) {
    var tmp0_safe_receiver = DispatchedTask.prototype.getExceptionalResult_2.call(this, state);
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      tmp = recoverStackTrace(tmp0_safe_receiver, this._delegate);
    }
    return tmp;
  };
  CancellableContinuationImpl.prototype.toString = function () {
    return '' + this.nameString_9() + '(' + toDebugString(this._delegate) + '){' + this._get_state__9() + '}@' + _get_hexAddress_(this);
  };
  CancellableContinuationImpl.prototype.nameString_9 = function () {
    return 'CancellableContinuation';
  };
  CancellableContinuationImpl.$metadata$ = {
    simpleName: 'CancellableContinuationImpl',
    kind: 'class',
    interfaces: [CancellableContinuation, CoroutineStackFrame]
  };
  function CancelHandler() {
    CancelHandlerBase.call(this);
  }
  CancelHandler.$metadata$ = {
    simpleName: 'CancelHandler',
    kind: 'class',
    interfaces: [NotCompleted]
  };
  function Active() {
    Active_instance = this;
  }
  Active.prototype.toString = function () {
    return 'Active';
  };
  Active.$metadata$ = {
    simpleName: 'Active',
    kind: 'object',
    interfaces: [NotCompleted]
  };
  var Active_instance;
  function Active_getInstance() {
    if (Active_instance == null)
      new Active();
    return Active_instance;
  }
  function NotCompleted() {
  }
  NotCompleted.$metadata$ = {
    simpleName: 'NotCompleted',
    kind: 'interface',
    interfaces: []
  };
  function CompletedContinuation_init_$Init$(result, cancelHandler, onCancellation, idempotentResume, cancelCause, $mask0, $marker, $this) {
    if (!(($mask0 & 2) === 0))
      cancelHandler = null;
    if (!(($mask0 & 4) === 0))
      onCancellation = null;
    if (!(($mask0 & 8) === 0))
      idempotentResume = null;
    if (!(($mask0 & 16) === 0))
      cancelCause = null;
    CompletedContinuation_0.call($this, result, cancelHandler, onCancellation, idempotentResume, cancelCause);
    return $this;
  }
  function CompletedContinuation_init_$Create$(result, cancelHandler, onCancellation, idempotentResume, cancelCause, $mask0, $marker) {
    return CompletedContinuation_init_$Init$(result, cancelHandler, onCancellation, idempotentResume, cancelCause, $mask0, $marker, Object.create(CompletedContinuation_0.prototype));
  }
  function CompletedContinuation_0(result, cancelHandler, onCancellation, idempotentResume, cancelCause) {
    this._result_0 = result;
    this._cancelHandler = cancelHandler;
    this._onCancellation = onCancellation;
    this._idempotentResume = idempotentResume;
    this._cancelCause = cancelCause;
  }
  CompletedContinuation_0.prototype._get_cancelled_ = function () {
    return !(this._cancelCause == null);
  };
  CompletedContinuation_0.prototype.invokeHandlers = function (cont, cause) {
    var tmp0_safe_receiver = this._cancelHandler;
    if (tmp0_safe_receiver == null)
      null;
    else {
      cont.callCancelHandler_0(tmp0_safe_receiver, cause);
      Unit_getInstance();
    }
    Unit_getInstance();
    var tmp1_safe_receiver = this._onCancellation;
    if (tmp1_safe_receiver == null)
      null;
    else {
      cont.callOnCancellation_0(tmp1_safe_receiver, cause);
      Unit_getInstance();
    }
    Unit_getInstance();
  };
  CompletedContinuation_0.prototype.copy = function (result, cancelHandler, onCancellation, idempotentResume, cancelCause) {
    return new CompletedContinuation_0(result, cancelHandler, onCancellation, idempotentResume, cancelCause);
  };
  CompletedContinuation_0.prototype.copy$default = function (result, cancelHandler, onCancellation, idempotentResume, cancelCause, $mask0, $handler) {
    if (!(($mask0 & 1) === 0))
      result = this._result_0;
    if (!(($mask0 & 2) === 0))
      cancelHandler = this._cancelHandler;
    if (!(($mask0 & 4) === 0))
      onCancellation = this._onCancellation;
    if (!(($mask0 & 8) === 0))
      idempotentResume = this._idempotentResume;
    if (!(($mask0 & 16) === 0))
      cancelCause = this._cancelCause;
    return this.copy(result, cancelHandler, onCancellation, idempotentResume, cancelCause);
  };
  CompletedContinuation_0.prototype.toString = function () {
    return '' + 'CompletedContinuation(result=' + this._result_0 + ', cancelHandler=' + this._cancelHandler + ', onCancellation=' + this._onCancellation + ', idempotentResume=' + this._idempotentResume + ', cancelCause=' + this._cancelCause + ')';
  };
  CompletedContinuation_0.prototype.hashCode = function () {
    return imul(imul(imul(imul(this._result_0 == null ? 0 : hashCode(this._result_0), 31) + (this._cancelHandler == null ? 0 : hashCode(this._cancelHandler)) | 0, 31) + (this._onCancellation == null ? 0 : hashCode(this._onCancellation)) | 0, 31) + (this._idempotentResume == null ? 0 : hashCode(this._idempotentResume)) | 0, 31) + (this._cancelCause == null ? 0 : hashCode(this._cancelCause)) | 0;
  };
  CompletedContinuation_0.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof CompletedContinuation_0))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof CompletedContinuation_0 ? other : THROW_CCE();
    if (!equals_1(this._result_0, tmp0_other_with_cast._result_0))
      return false;
    if (!equals_1(this._cancelHandler, tmp0_other_with_cast._cancelHandler))
      return false;
    if (!equals_1(this._onCancellation, tmp0_other_with_cast._onCancellation))
      return false;
    if (!equals_1(this._idempotentResume, tmp0_other_with_cast._idempotentResume))
      return false;
    if (!equals_1(this._cancelCause, tmp0_other_with_cast._cancelCause))
      return false;
    return true;
  };
  CompletedContinuation_0.$metadata$ = {
    simpleName: 'CompletedContinuation',
    kind: 'class',
    interfaces: []
  };
  function BeforeResumeCancelHandler() {
    CancelHandler.call(this);
  }
  BeforeResumeCancelHandler.$metadata$ = {
    simpleName: 'BeforeResumeCancelHandler',
    kind: 'class',
    interfaces: []
  };
  function InvokeOnCancel(handler) {
    CancelHandler.call(this);
    this._handler = handler;
  }
  InvokeOnCancel.prototype.invoke_375 = function (cause) {
    this._handler(cause);
  };
  InvokeOnCancel.prototype.invoke = function (cause) {
    return this.invoke_375(cause);
  };
  InvokeOnCancel.prototype.toString = function () {
    return '' + 'InvokeOnCancel[' + _get_classSimpleName_(this._handler) + '@' + _get_hexAddress_(this) + ']';
  };
  InvokeOnCancel.$metadata$ = {
    simpleName: 'InvokeOnCancel',
    kind: 'class',
    interfaces: []
  };
  function CompletableDeferred() {
  }
  CompletableDeferred.$metadata$ = {
    simpleName: 'CompletableDeferred',
    kind: 'interface',
    interfaces: [Deferred]
  };
  function CompletableDeferred_0(parent) {
    return new CompletableDeferredImpl(parent);
  }
  function CompletableDeferred$default(parent, $mask0, $handler) {
    if (!(($mask0 & 1) === 0))
      parent = null;
    return CompletableDeferred_0(parent);
  }
  function $awaitCOROUTINE$1(_this_, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__0 = _this_;
  }
  $awaitCOROUTINE$1.prototype.doResume_72 = function () {
    var suspendResult = this._result;
    $sm: do
      try {
        var tmp = this._state_0;
        switch (tmp) {
          case 0:
            this._exceptionState = 2;
            this._state_0 = 1;
            suspendResult = this.__this__0.awaitInternal_2(this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            var tmp_0 = suspendResult;
            return (tmp_0 == null ? true : isObject(tmp_0)) ? tmp_0 : THROW_CCE();
          case 2:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 2) {
          throw $p;
        } else {
          this._state_0 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $awaitCOROUTINE$1.$metadata$ = {
    simpleName: '$awaitCOROUTINE$1',
    kind: 'class',
    interfaces: []
  };
  function CompletableDeferredImpl(parent) {
    JobSupport.call(this, true);
    this.initParentJobInternal_7(parent);
  }
  CompletableDeferredImpl.prototype._get_onCancelComplete__7 = function () {
    return true;
  };
  CompletableDeferredImpl.prototype.await_2 = function ($cont) {
    var tmp = new $awaitCOROUTINE$1(this, $cont);
    tmp._result = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_72();
  };
  CompletableDeferredImpl.prototype.complete_0 = function (value) {
    return this.makeCompleting_2(value);
  };
  CompletableDeferredImpl.prototype.completeExceptionally_3 = function (exception) {
    return this.makeCompleting_2(CompletedExceptionally_init_$Create$(exception, false, 2, null));
  };
  CompletableDeferredImpl.$metadata$ = {
    simpleName: 'CompletableDeferredImpl',
    kind: 'class',
    interfaces: [CompletableDeferred, SelectClause1]
  };
  function CompletableJob() {
  }
  CompletableJob.$metadata$ = {
    simpleName: 'CompletableJob',
    kind: 'interface',
    interfaces: [Job]
  };
  function CompletedExceptionally_init_$Init$(cause, handled, $mask0, $marker, $this) {
    if (!(($mask0 & 2) === 0))
      handled = false;
    CompletedExceptionally.call($this, cause, handled);
    return $this;
  }
  function CompletedExceptionally_init_$Create$(cause, handled, $mask0, $marker) {
    return CompletedExceptionally_init_$Init$(cause, handled, $mask0, $marker, Object.create(CompletedExceptionally.prototype));
  }
  function CompletedExceptionally(cause, handled) {
    this._cause = cause;
    this.__handled = atomic_0(handled);
  }
  CompletedExceptionally.prototype._get_cause__54 = function () {
    return this._cause;
  };
  CompletedExceptionally.prototype._get_handled__0 = function () {
    return this.__handled._value_9;
  };
  CompletedExceptionally.prototype.makeHandled_0 = function () {
    return this.__handled.compareAndSet$atomicfu(false, true);
  };
  CompletedExceptionally.prototype.toString = function () {
    return '' + _get_classSimpleName_(this) + '[' + this._cause + ']';
  };
  CompletedExceptionally.$metadata$ = {
    simpleName: 'CompletedExceptionally',
    kind: 'class',
    interfaces: []
  };
  function CancelledContinuation(continuation, cause, handled) {
    var tmp0_elvis_lhs = cause;
    CompletedExceptionally.call(this, tmp0_elvis_lhs == null ? CancellationException_init_$Create$('' + 'Continuation ' + continuation + ' was cancelled normally') : tmp0_elvis_lhs, handled);
    this.__resumed = atomic_0(false);
  }
  CancelledContinuation.prototype.makeResumed = function () {
    return this.__resumed.compareAndSet$atomicfu(false, true);
  };
  CancelledContinuation.$metadata$ = {
    simpleName: 'CancelledContinuation',
    kind: 'class',
    interfaces: []
  };
  function toState(_this_, caller) {
    var exception_1 = Result__exceptionOrNull_impl(_this_);
    var tmp;
    if (exception_1 == null) {
      var tmp_0 = _Result___get_value__impl_(_this_);
      var tmp0__anonymous__2 = (tmp_0 == null ? true : isObject(tmp_0)) ? tmp_0 : THROW_CCE();
      tmp = tmp0__anonymous__2;
    } else {
      var tmp_1 = recoverStackTrace(exception_1, caller);
      tmp = CompletedExceptionally_init_$Create$(tmp_1, false, 2, null);
    }
    return tmp;
  }
  function toState_0(_this_, onCancellation) {
    var exception_1 = Result__exceptionOrNull_impl(_this_);
    var tmp;
    if (exception_1 == null) {
      var tmp_0 = _Result___get_value__impl_(_this_);
      var tmp0__anonymous__2 = (tmp_0 == null ? true : isObject(tmp_0)) ? tmp_0 : THROW_CCE();
      tmp = !(onCancellation == null) ? new CompletedWithCancellation(tmp0__anonymous__2, onCancellation) : tmp0__anonymous__2;
    } else {
      tmp = CompletedExceptionally_init_$Create$(exception_1, false, 2, null);
    }
    return tmp;
  }
  function toState$default(_this_, onCancellation, $mask0, $handler) {
    if (!(($mask0 & 1) === 0))
      onCancellation = null;
    return toState_0(_this_, onCancellation);
  }
  function CompletedWithCancellation(result, onCancellation) {
    this._result_1 = result;
    this._onCancellation_0 = onCancellation;
  }
  CompletedWithCancellation.prototype.toString = function () {
    return '' + 'CompletedWithCancellation(result=' + this._result_1 + ', onCancellation=' + this._onCancellation_0 + ')';
  };
  CompletedWithCancellation.prototype.hashCode = function () {
    return imul(this._result_1 == null ? 0 : hashCode(this._result_1), 31) + hashCode(this._onCancellation_0) | 0;
  };
  CompletedWithCancellation.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof CompletedWithCancellation))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof CompletedWithCancellation ? other : THROW_CCE();
    if (!equals_1(this._result_1, tmp0_other_with_cast._result_1))
      return false;
    if (!equals_1(this._onCancellation_0, tmp0_other_with_cast._onCancellation_0))
      return false;
    return true;
  };
  CompletedWithCancellation.$metadata$ = {
    simpleName: 'CompletedWithCancellation',
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__78() {
  }
  _no_name_provided__78.prototype.invoke_106 = function (it) {
    return it instanceof CoroutineDispatcher ? it : null;
  };
  _no_name_provided__78.prototype.invoke_542 = function (p1) {
    return this.invoke_106((!(p1 == null) ? isInterface(p1, Element_0) : false) ? p1 : THROW_CCE());
  };
  _no_name_provided__78.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function Key_1() {
    Key_instance_0 = this;
    var tmp = Key_getInstance();
    AbstractCoroutineContextKey.call(this, tmp, _no_name_provided_$factory_57());
  }
  Key_1.$metadata$ = {
    simpleName: 'Key',
    kind: 'object',
    interfaces: []
  };
  var Key_instance_0;
  function Key_getInstance_0() {
    if (Key_instance_0 == null)
      new Key_1();
    return Key_instance_0;
  }
  function CoroutineDispatcher() {
    Key_getInstance_0();
    AbstractCoroutineContextElement.call(this, Key_getInstance());
  }
  CoroutineDispatcher.prototype.isDispatchNeeded_8 = function (context) {
    return true;
  };
  CoroutineDispatcher.prototype.interceptContinuation_9 = function (continuation) {
    return new DispatchedContinuation(this, continuation);
  };
  CoroutineDispatcher.prototype.releaseInterceptedContinuation_9 = function (continuation) {
    var tmp0_safe_receiver = (continuation instanceof DispatchedContinuation ? continuation : THROW_CCE())._get_reusableCancellableContinuation_();
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.detachChild_0();
      Unit_getInstance();
    }
    Unit_getInstance();
  };
  CoroutineDispatcher.prototype.toString = function () {
    return '' + _get_classSimpleName_(this) + '@' + _get_hexAddress_(this);
  };
  CoroutineDispatcher.$metadata$ = {
    simpleName: 'CoroutineDispatcher',
    kind: 'class',
    interfaces: [ContinuationInterceptor]
  };
  function _no_name_provided_$factory_57() {
    var i = new _no_name_provided__78();
    return function (p1) {
      return i.invoke_106(p1);
    };
  }
  function handleCoroutineException(context, exception) {
    try {
      var tmp0_safe_receiver = context.get_70(Key_getInstance_1());
      if (tmp0_safe_receiver == null)
        null;
      else {
        tmp0_safe_receiver.handleException_0(context, exception);
        return Unit_getInstance();
      }
      Unit_getInstance();
    } catch ($p) {
      if ($p instanceof Error) {
        handleCoroutineExceptionImpl(context, handlerException(exception, $p));
        return Unit_getInstance();
      } else {
        {
          throw $p;
        }
      }
    }
    handleCoroutineExceptionImpl(context, exception);
  }
  function Key_2() {
    Key_instance_1 = this;
  }
  Key_2.$metadata$ = {
    simpleName: 'Key',
    kind: 'object',
    interfaces: [Key_0]
  };
  var Key_instance_1;
  function Key_getInstance_1() {
    if (Key_instance_1 == null)
      new Key_2();
    return Key_instance_1;
  }
  function CoroutineExceptionHandler() {
  }
  CoroutineExceptionHandler.$metadata$ = {
    simpleName: 'CoroutineExceptionHandler',
    kind: 'interface',
    interfaces: [Element_0]
  };
  function handlerException(originalException, thrownException) {
    if (originalException === thrownException)
      return originalException;
    var tmp0_apply_0 = RuntimeException_init_$Create$('Exception while trying to handle coroutine exception', thrownException);
    return tmp0_apply_0;
  }
  function Key_3() {
    Key_instance_2 = this;
  }
  Key_3.$metadata$ = {
    simpleName: 'Key',
    kind: 'object',
    interfaces: [Key_0]
  };
  var Key_instance_2;
  function Key_getInstance_2() {
    if (Key_instance_2 == null)
      new Key_3();
    return Key_instance_2;
  }
  function CoroutineName(name) {
    Key_getInstance_2();
    AbstractCoroutineContextElement.call(this, Key_getInstance_2());
    this._name_1 = name;
  }
  CoroutineName.prototype.toString = function () {
    return '' + 'CoroutineName(' + this._name_1 + ')';
  };
  CoroutineName.prototype.hashCode = function () {
    return getStringHashCode(this._name_1);
  };
  CoroutineName.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof CoroutineName))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof CoroutineName ? other : THROW_CCE();
    if (!(this._name_1 === tmp0_other_with_cast._name_1))
      return false;
    return true;
  };
  CoroutineName.$metadata$ = {
    simpleName: 'CoroutineName',
    kind: 'class',
    interfaces: []
  };
  function CoroutineScope() {
  }
  CoroutineScope.$metadata$ = {
    simpleName: 'CoroutineScope',
    kind: 'interface',
    interfaces: []
  };
  function cancel(_this_, cause) {
    var tmp0_elvis_lhs = _this_._get_coroutineContext__22().get_70(Key_getInstance_3());
    var tmp;
    if (tmp0_elvis_lhs == null) {
      var tmp0_error_0 = '' + 'Scope cannot be cancelled because it does not have a job: ' + _this_;
      throw IllegalStateException_init_$Create$(toString_1(tmp0_error_0));
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var job = tmp;
    job.cancel_20(cause);
  }
  function cancel$default(_this_, cause, $mask0, $handler) {
    if (!(($mask0 & 1) === 0))
      cause = null;
    return cancel(_this_, cause);
  }
  function cancel_0(_this_, message, cause) {
    return cancel(_this_, new CancellationException(message, cause));
  }
  function MainScope() {
    return new ContextScope(SupervisorJob$default(null, 1, null).plus_28(Dispatchers_getInstance()._Main));
  }
  function GlobalScope() {
    GlobalScope_instance = this;
  }
  GlobalScope.prototype._get_coroutineContext__22 = function () {
    return EmptyCoroutineContext_getInstance();
  };
  GlobalScope.$metadata$ = {
    simpleName: 'GlobalScope',
    kind: 'object',
    interfaces: [CoroutineScope]
  };
  var GlobalScope_instance;
  function GlobalScope_getInstance() {
    if (GlobalScope_instance == null)
      new GlobalScope();
    return GlobalScope_instance;
  }
  function CoroutineScope_0(context) {
    var tmp;
    if (!(context.get_70(Key_getInstance_3()) == null)) {
      tmp = context;
    } else {
      tmp = context.plus_28(Job$default(null, 1, null));
    }
    return new ContextScope(tmp);
  }
  var CoroutineStart_DEFAULT_instance;
  var CoroutineStart_LAZY_instance;
  var CoroutineStart_ATOMIC_instance;
  var CoroutineStart_UNDISPATCHED_instance;
  var CoroutineStart_entriesInitialized;
  function CoroutineStart_initEntries() {
    if (CoroutineStart_entriesInitialized)
      return Unit_getInstance();
    CoroutineStart_entriesInitialized = true;
    CoroutineStart_DEFAULT_instance = new CoroutineStart('DEFAULT', 0);
    CoroutineStart_LAZY_instance = new CoroutineStart('LAZY', 1);
    CoroutineStart_ATOMIC_instance = new CoroutineStart('ATOMIC', 2);
    CoroutineStart_UNDISPATCHED_instance = new CoroutineStart('UNDISPATCHED', 3);
  }
  function CoroutineStart(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  CoroutineStart.prototype.invoke_108 = function (block, receiver, completion) {
    var tmp0_subject = this;
    var tmp;
    if (tmp0_subject.equals(CoroutineStart_DEFAULT_getInstance())) {
      tmp = startCoroutineCancellable$default(block, receiver, completion, null, 4, null);
    } else if (tmp0_subject.equals(CoroutineStart_ATOMIC_getInstance())) {
      tmp = startCoroutine(block, receiver, completion);
    } else if (tmp0_subject.equals(CoroutineStart_UNDISPATCHED_getInstance())) {
      tmp = startCoroutineUndispatched(block, receiver, completion);
    } else if (tmp0_subject.equals(CoroutineStart_LAZY_getInstance())) {
      tmp = Unit_getInstance();
    } else {
      noWhenBranchMatchedException();
    }
    return tmp;
  };
  CoroutineStart.prototype._get_isLazy_ = function () {
    return this === CoroutineStart_LAZY_getInstance();
  };
  CoroutineStart.$metadata$ = {
    simpleName: 'CoroutineStart',
    kind: 'class',
    interfaces: []
  };
  function CoroutineStart_DEFAULT_getInstance() {
    CoroutineStart_initEntries();
    return CoroutineStart_DEFAULT_instance;
  }
  function CoroutineStart_LAZY_getInstance() {
    CoroutineStart_initEntries();
    return CoroutineStart_LAZY_instance;
  }
  function CoroutineStart_ATOMIC_getInstance() {
    CoroutineStart_initEntries();
    return CoroutineStart_ATOMIC_instance;
  }
  function CoroutineStart_UNDISPATCHED_getInstance() {
    CoroutineStart_initEntries();
    return CoroutineStart_UNDISPATCHED_instance;
  }
  function CopyableThrowable() {
  }
  CopyableThrowable.$metadata$ = {
    simpleName: 'CopyableThrowable',
    kind: 'interface',
    interfaces: []
  };
  function Deferred() {
  }
  Deferred.$metadata$ = {
    simpleName: 'Deferred',
    kind: 'interface',
    interfaces: [Job]
  };
  function delay(timeMillis, $cont) {
    if (timeMillis.compareTo_69(new Long(0, 0)) <= 0)
      return Unit_getInstance();
    var tmp0__anonymous__1_1 = $cont;
    var cancellable_2_2 = new CancellableContinuationImpl(intercepted(tmp0__anonymous__1_1), 1);
    cancellable_2_2.initCancellability_0();
    if (timeMillis.compareTo_69(new Long(-1, 2147483647)) < 0) {
      _get_delay_(cancellable_2_2._get_context__86()).scheduleResumeAfterDelay_3(timeMillis, cancellable_2_2);
    }return cancellable_2_2.getResult_0();
  }
  function Delay() {
  }
  Delay.$metadata$ = {
    simpleName: 'Delay',
    kind: 'interface',
    interfaces: []
  };
  function _get_delay_(_this_) {
    var tmp = _this_.get_70(Key_getInstance());
    var tmp0_elvis_lhs = (!(tmp == null) ? isInterface(tmp, Delay) : false) ? tmp : null;
    return tmp0_elvis_lhs == null ? _get_DefaultDelay_() : tmp0_elvis_lhs;
  }
  function delta($this, unconfined) {
    return unconfined ? new Long(0, 1) : new Long(1, 0);
  }
  function EventLoop() {
    CoroutineDispatcher.call(this);
    this._useCount = new Long(0, 0);
    this._shared = false;
    this._unconfinedQueue = null;
  }
  EventLoop.prototype.processUnconfinedEvent_0 = function () {
    var tmp0_elvis_lhs = this._unconfinedQueue;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return false;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var queue = tmp;
    var tmp1_elvis_lhs = queue.removeFirstOrNull_2();
    var tmp_0;
    if (tmp1_elvis_lhs == null) {
      return false;
    } else {
      tmp_0 = tmp1_elvis_lhs;
    }
    var task = tmp_0;
    task.run_4();
    return true;
  };
  EventLoop.prototype.dispatchUnconfined_0 = function (task) {
    var tmp0_elvis_lhs = this._unconfinedQueue;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      var tmp0_also_0 = new ArrayQueue();
      this._unconfinedQueue = tmp0_also_0;
      tmp = tmp0_also_0;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var queue = tmp;
    queue.addLast_16(task);
  };
  EventLoop.prototype._get_isUnconfinedLoopActive__0 = function () {
    return this._useCount.compareTo_69(delta(this, true)) >= 0;
  };
  EventLoop.prototype._get_isUnconfinedQueueEmpty__0 = function () {
    var tmp0_safe_receiver = this._unconfinedQueue;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver._get_isEmpty__4();
    return tmp1_elvis_lhs == null ? true : tmp1_elvis_lhs;
  };
  EventLoop.prototype.incrementUseCount_0 = function (unconfined) {
    var tmp0_this = this;
    tmp0_this._useCount = tmp0_this._useCount.plus_56(delta(this, unconfined));
    if (!unconfined)
      this._shared = true;
  };
  EventLoop.prototype.decrementUseCount_0 = function (unconfined) {
    var tmp0_this = this;
    tmp0_this._useCount = tmp0_this._useCount.minus_29(delta(this, unconfined));
    if (this._useCount.compareTo_69(new Long(0, 0)) > 0)
      return Unit_getInstance();
    if (this._shared) {
      this.shutdown_0();
    }};
  EventLoop.prototype.shutdown_0 = function () {
  };
  EventLoop.$metadata$ = {
    simpleName: 'EventLoop',
    kind: 'class',
    interfaces: []
  };
  function ThreadLocalEventLoop() {
    ThreadLocalEventLoop_instance = this;
    this._ref = new CommonThreadLocal();
  }
  ThreadLocalEventLoop.prototype._get_eventLoop_ = function () {
    var tmp0_elvis_lhs = this._ref.get_49();
    var tmp;
    if (tmp0_elvis_lhs == null) {
      var tmp0_also_0 = createEventLoop();
      ThreadLocalEventLoop_getInstance()._ref.set_3(tmp0_also_0);
      tmp = tmp0_also_0;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  };
  ThreadLocalEventLoop.$metadata$ = {
    simpleName: 'ThreadLocalEventLoop',
    kind: 'object',
    interfaces: []
  };
  var ThreadLocalEventLoop_instance;
  function ThreadLocalEventLoop_getInstance() {
    if (ThreadLocalEventLoop_instance == null)
      new ThreadLocalEventLoop();
    return ThreadLocalEventLoop_instance;
  }
  function CompletionHandlerException(message, cause) {
    RuntimeException_init_$Init$_1(message, cause, this);
    captureStack(this, CompletionHandlerException);
  }
  CompletionHandlerException.$metadata$ = {
    simpleName: 'CompletionHandlerException',
    kind: 'class',
    interfaces: []
  };
  function CoroutinesInternalError(message, cause) {
    Error_init_$Init$_0(message, cause, this);
    captureStack(this, CoroutinesInternalError);
  }
  CoroutinesInternalError.$metadata$ = {
    simpleName: 'CoroutinesInternalError',
    kind: 'class',
    interfaces: []
  };
  function Key_4() {
    Key_instance_3 = this;
    Key_getInstance_1();
    Unit_getInstance();
  }
  Key_4.$metadata$ = {
    simpleName: 'Key',
    kind: 'object',
    interfaces: [Key_0]
  };
  var Key_instance_3;
  function Key_getInstance_3() {
    if (Key_instance_3 == null)
      new Key_4();
    return Key_instance_3;
  }
  function Job() {
  }
  Job.prototype.cancel$default_15 = function (cause, $mask0, $handler) {
    if (!(($mask0 & 1) === 0))
      cause = null;
    return $handler == null ? this.cancel_20(cause) : $handler(cause);
  };
  Job.prototype.invokeOnCompletion$default_9 = function (onCancelling, invokeImmediately, handler, $mask0, $handler) {
    if (!(($mask0 & 1) === 0))
      onCancelling = false;
    if (!(($mask0 & 2) === 0))
      invokeImmediately = true;
    return $handler == null ? this.invokeOnCompletion_21(onCancelling, invokeImmediately, handler) : $handler(onCancelling, invokeImmediately, handler);
  };
  Job.$metadata$ = {
    simpleName: 'Job',
    kind: 'interface',
    interfaces: [Element_0]
  };
  function DisposableHandle() {
  }
  DisposableHandle.$metadata$ = {
    simpleName: 'DisposableHandle',
    kind: 'interface',
    interfaces: []
  };
  function ChildJob() {
  }
  ChildJob.$metadata$ = {
    simpleName: 'ChildJob',
    kind: 'interface',
    interfaces: [Job]
  };
  function ParentJob() {
  }
  ParentJob.$metadata$ = {
    simpleName: 'ParentJob',
    kind: 'interface',
    interfaces: [Job]
  };
  function ChildHandle() {
  }
  ChildHandle.$metadata$ = {
    simpleName: 'ChildHandle',
    kind: 'interface',
    interfaces: [DisposableHandle]
  };
  function NonDisposableHandle() {
    NonDisposableHandle_instance = this;
  }
  NonDisposableHandle.prototype.dispose_26 = function () {
  };
  NonDisposableHandle.prototype.childCancelled_10 = function (cause) {
    return false;
  };
  NonDisposableHandle.prototype.toString = function () {
    return 'NonDisposableHandle';
  };
  NonDisposableHandle.$metadata$ = {
    simpleName: 'NonDisposableHandle',
    kind: 'object',
    interfaces: [DisposableHandle, ChildHandle]
  };
  var NonDisposableHandle_instance;
  function NonDisposableHandle_getInstance() {
    if (NonDisposableHandle_instance == null)
      new NonDisposableHandle();
    return NonDisposableHandle_instance;
  }
  function Job_0(parent) {
    return new JobImpl(parent);
  }
  function Job$default(parent, $mask0, $handler) {
    if (!(($mask0 & 1) === 0))
      parent = null;
    return Job_0(parent);
  }
  function cancel_1(_this_, message, cause) {
    return _this_.cancel_20(new CancellationException(message, cause));
  }
  function cancel_2(_this_, cause) {
    var tmp0_safe_receiver = _this_.get_70(Key_getInstance_3());
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.cancel_20(cause);
      Unit_getInstance();
    }
    Unit_getInstance();
  }
  var COMPLETING_ALREADY;
  var COMPLETING_WAITING_CHILDREN;
  var COMPLETING_RETRY;
  var TOO_LATE_TO_CANCEL;
  var SEALED_0;
  var EMPTY_NEW;
  var EMPTY_ACTIVE;
  function Empty(isActive) {
    this._isActive = isActive;
  }
  Empty.prototype._get_isActive__23 = function () {
    return this._isActive;
  };
  Empty.prototype._get_list__12 = function () {
    return null;
  };
  Empty.prototype.toString = function () {
    return '' + 'Empty{' + (this._isActive ? 'Active' : 'New') + '}';
  };
  Empty.$metadata$ = {
    simpleName: 'Empty',
    kind: 'class',
    interfaces: [Incomplete]
  };
  function Incomplete() {
  }
  Incomplete.$metadata$ = {
    simpleName: 'Incomplete',
    kind: 'interface',
    interfaces: []
  };
  function NodeList_0() {
    LinkedListHead.call(this);
  }
  NodeList_0.prototype._get_isActive__23 = function () {
    return true;
  };
  NodeList_0.prototype._get_list__12 = function () {
    return this;
  };
  NodeList_0.prototype.getString = function (state) {
    var tmp0_apply_0_1 = StringBuilder_init_$Create$_0();
    tmp0_apply_0_1.append_7('List{');
    Unit_getInstance();
    tmp0_apply_0_1.append_7(state);
    Unit_getInstance();
    tmp0_apply_0_1.append_7('}[');
    Unit_getInstance();
    var first_3 = true;
    var cur_1_4 = this._get__next__1();
    while (!equals_1(cur_1_4, this)) {
      if (cur_1_4 instanceof JobNode) {
        var tmp0__anonymous__2_5 = cur_1_4;
        if (first_3)
          first_3 = false;
        else {
          tmp0_apply_0_1.append_7(', ');
          Unit_getInstance();
        }
        tmp0_apply_0_1.append_5(tmp0__anonymous__2_5);
        Unit_getInstance();
      } else {
      }
      cur_1_4 = cur_1_4.__next;
    }
    tmp0_apply_0_1.append_7(']');
    Unit_getInstance();
    return tmp0_apply_0_1.toString();
  };
  NodeList_0.prototype.toString = function () {
    return DEBUG ? this.getString('Active') : anyToString(this);
  };
  NodeList_0.$metadata$ = {
    simpleName: 'NodeList',
    kind: 'class',
    interfaces: [Incomplete]
  };
  function JobNode(job) {
    CompletionHandlerBase.call(this);
    this._job = job;
  }
  JobNode.prototype._get_job__2 = function () {
    return this._job;
  };
  JobNode.prototype._get_isActive__23 = function () {
    return true;
  };
  JobNode.prototype._get_list__12 = function () {
    return null;
  };
  JobNode.prototype.dispose_26 = function () {
    var tmp = this._job;
    return (tmp instanceof JobSupport ? tmp : THROW_CCE()).removeNode_7(this);
  };
  JobNode.prototype.toString = function () {
    return '' + _get_classSimpleName_(this) + '@' + _get_hexAddress_(this) + '[job@' + _get_hexAddress_(this._job) + ']';
  };
  JobNode.$metadata$ = {
    simpleName: 'JobNode',
    kind: 'class',
    interfaces: [DisposableHandle, Incomplete]
  };
  function _set_exceptionsHolder_($this, value) {
    $this.__exceptionsHolder._value_8 = value;
  }
  function _get_exceptionsHolder_($this) {
    return $this.__exceptionsHolder._value_8;
  }
  function allocateList($this) {
    return ArrayList_init_$Create$_0(4);
  }
  function finalizeFinishingState($this, state, proposedUpdate) {
    var tmp0_safe_receiver = proposedUpdate instanceof CompletedExceptionally ? proposedUpdate : null;
    var proposedException = tmp0_safe_receiver == null ? null : tmp0_safe_receiver._cause;
    var wasCancelling = false;
    wasCancelling = state._get_isCancelling_();
    var exceptions_2 = state.sealLocked(proposedException);
    var finalCause_3 = getFinalRootCause($this, state, exceptions_2);
    if (!(finalCause_3 == null))
      addSuppressedExceptions($this, finalCause_3, exceptions_2);
    var finalException = finalCause_3;
    var tmp;
    if (finalException == null) {
      tmp = proposedUpdate;
    } else if (finalException === proposedException) {
      tmp = proposedUpdate;
    } else {
      tmp = CompletedExceptionally_init_$Create$(finalException, false, 2, null);
    }
    var finalState = tmp;
    if (!(finalException == null)) {
      var handled = cancelParent($this, finalException) ? true : $this.handleJobException_7(finalException);
      if (handled) {
        (finalState instanceof CompletedExceptionally ? finalState : THROW_CCE()).makeHandled_0();
        Unit_getInstance();
      }}if (!wasCancelling)
      $this.onCancelling_7(finalException);
    $this.onCompletionInternal_7(finalState);
    var casSuccess = $this.__state_0.compareAndSet$atomicfu(state, boxIncomplete(finalState));
    completeStateFinalization($this, state, finalState);
    return finalState;
  }
  function getFinalRootCause($this, state, exceptions) {
    if (exceptions.isEmpty_53()) {
      if (state._get_isCancelling_()) {
        var tmp0_defaultCancellationException_0 = null;
        var tmp1_defaultCancellationException_0 = null;
        var tmp0_elvis_lhs_1 = tmp0_defaultCancellationException_0;
        return new JobCancellationException(tmp0_elvis_lhs_1 == null ? $this.cancellationExceptionMessage_7() : tmp0_elvis_lhs_1, tmp1_defaultCancellationException_0, $this);
      }return null;
    }var tmp$ret$0;
    l$ret$1: do {
      var tmp0_iterator_1 = exceptions.iterator_64();
      while (tmp0_iterator_1.hasNext_31()) {
        var element_2 = tmp0_iterator_1.next_35();
        if (!(element_2 instanceof CancellationException)) {
          tmp$ret$0 = element_2;
          break l$ret$1;
        } else {
        }
      }
      tmp$ret$0 = null;
    }
     while (false);
    var firstNonCancellation = tmp$ret$0;
    if (!(firstNonCancellation == null))
      return firstNonCancellation;
    var first_1 = exceptions.get_80(0);
    if (first_1 instanceof TimeoutCancellationException) {
      var tmp$ret$2;
      l$ret$3: do {
        var tmp0_iterator_1_0 = exceptions.iterator_64();
        while (tmp0_iterator_1_0.hasNext_31()) {
          var element_2_0 = tmp0_iterator_1_0.next_35();
          var tmp;
          if (!(element_2_0 === first_1)) {
            tmp = element_2_0 instanceof TimeoutCancellationException;
          } else {
            tmp = false;
          }
          if (tmp) {
            tmp$ret$2 = element_2_0;
            break l$ret$3;
          } else {
          }
        }
        tmp$ret$2 = null;
      }
       while (false);
      var detailedTimeoutException = tmp$ret$2;
      if (!(detailedTimeoutException == null))
        return detailedTimeoutException;
    } else {
    }
    return first_1;
  }
  function addSuppressedExceptions($this, rootCause, exceptions) {
    if (exceptions._get_size__45() <= 1)
      return Unit_getInstance();
    var seenExceptions = identitySet(exceptions._get_size__45());
    var unwrappedCause = unwrap(rootCause);
    var tmp0_iterator = exceptions.iterator_64();
    while (tmp0_iterator.hasNext_31()) {
      var exception = tmp0_iterator.next_35();
      var unwrapped = unwrap(exception);
      var tmp;
      var tmp_0;
      if (!(unwrapped === rootCause) ? !(unwrapped === unwrappedCause) : false) {
        tmp_0 = !(unwrapped instanceof CancellationException);
      } else {
        tmp_0 = false;
      }
      if (tmp_0) {
        tmp = seenExceptions.add_33(unwrapped);
      } else {
        {
          tmp = false;
        }
      }
      if (tmp) {
      } else {
      }
    }
  }
  function tryFinalizeSimpleState($this, state, update) {
    if (!$this.__state_0.compareAndSet$atomicfu(state, boxIncomplete(update)))
      return false;
    $this.onCancelling_7(null);
    $this.onCompletionInternal_7(update);
    completeStateFinalization($this, state, update);
    return true;
  }
  function completeStateFinalization($this, state, update) {
    var tmp0_safe_receiver = $this._get_parentHandle__7();
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.dispose_26();
      $this._set_parentHandle__7(NonDisposableHandle_getInstance());
      Unit_getInstance();
    }
    Unit_getInstance();
    var tmp1_safe_receiver = update instanceof CompletedExceptionally ? update : null;
    var cause = tmp1_safe_receiver == null ? null : tmp1_safe_receiver._cause;
    if (state instanceof JobNode) {
      try {
        state.invoke(cause);
      } catch ($p) {
        if ($p instanceof Error) {
          $this.handleOnCompletionException_7(new CompletionHandlerException('' + 'Exception in completion handler ' + state + ' for ' + $this, $p));
        } else {
          {
            throw $p;
          }
        }
      }
    } else {
      {
        var tmp2_safe_receiver = state._get_list__12();
        if (tmp2_safe_receiver == null)
          null;
        else {
          notifyCompletion(tmp2_safe_receiver, $this, cause);
          Unit_getInstance();
        }
        Unit_getInstance();
      }
    }
  }
  function notifyCancelling($this, list, cause) {
    $this.onCancelling_7(cause);
    var exception_1 = null;
    var cur_1 = list._get__next__1();
    while (!equals_1(cur_1, list)) {
      if (cur_1 instanceof JobCancellingNode) {
        var tmp0__anonymous__2_2 = cur_1;
        try {
          tmp0__anonymous__2_2.invoke(cause);
        } catch ($p) {
          if ($p instanceof Error) {
            var tmp0_safe_receiver_5_5 = exception_1;
            var tmp;
            if (tmp0_safe_receiver_5_5 == null) {
              tmp = null;
            } else {
              tmp = tmp0_safe_receiver_5_5;
            }
            var tmp1_elvis_lhs_4_4 = tmp;
            if (tmp1_elvis_lhs_4_4 == null) {
              exception_1 = new CompletionHandlerException('' + 'Exception in completion handler ' + tmp0__anonymous__2_2 + ' for ' + $this, $p);
              Unit_getInstance();
            } else
              tmp1_elvis_lhs_4_4;
            Unit_getInstance();
          } else {
            {
              throw $p;
            }
          }
        }
      } else {
      }
      cur_1 = cur_1.__next;
    }
    var tmp0_safe_receiver_8 = exception_1;
    if (tmp0_safe_receiver_8 == null)
      null;
    else {
      $this.handleOnCompletionException_7(tmp0_safe_receiver_8);
      Unit_getInstance();
    }
    Unit_getInstance();
    cancelParent($this, cause);
    Unit_getInstance();
  }
  function cancelParent($this, cause) {
    if ($this._get_isScopedCoroutine__7())
      return true;
    var isCancellation = cause instanceof CancellationException;
    var parent = $this._get_parentHandle__7();
    if (parent === null ? true : parent === NonDisposableHandle_getInstance()) {
      return isCancellation;
    }return parent.childCancelled_10(cause) ? true : isCancellation;
  }
  function notifyCompletion(_this_, $this, cause) {
    var exception_1 = null;
    var cur_1 = _this_._get__next__1();
    while (!equals_1(cur_1, _this_)) {
      if (cur_1 instanceof JobNode) {
        var tmp0__anonymous__2_2 = cur_1;
        try {
          tmp0__anonymous__2_2.invoke(cause);
        } catch ($p) {
          if ($p instanceof Error) {
            var tmp0_safe_receiver_5_5 = exception_1;
            var tmp;
            if (tmp0_safe_receiver_5_5 == null) {
              tmp = null;
            } else {
              tmp = tmp0_safe_receiver_5_5;
            }
            var tmp1_elvis_lhs_4_4 = tmp;
            if (tmp1_elvis_lhs_4_4 == null) {
              exception_1 = new CompletionHandlerException('' + 'Exception in completion handler ' + tmp0__anonymous__2_2 + ' for ' + $this, $p);
              Unit_getInstance();
            } else
              tmp1_elvis_lhs_4_4;
            Unit_getInstance();
          } else {
            {
              throw $p;
            }
          }
        }
      } else {
      }
      cur_1 = cur_1.__next;
    }
    var tmp0_safe_receiver_8 = exception_1;
    if (tmp0_safe_receiver_8 == null)
      null;
    else {
      $this.handleOnCompletionException_7(tmp0_safe_receiver_8);
      Unit_getInstance();
    }
    return Unit_getInstance();
  }
  function startInternal($this, state) {
    var tmp0_subject = state;
    if (tmp0_subject instanceof Empty) {
      if (state._isActive)
        return 0;
      if (!$this.__state_0.compareAndSet$atomicfu(state, EMPTY_ACTIVE))
        return -1;
      $this.onStartInternal_7();
      return 1;
    } else {
      if (tmp0_subject instanceof InactiveNodeList) {
        if (!$this.__state_0.compareAndSet$atomicfu(state, state._list_0))
          return -1;
        $this.onStartInternal_7();
        return 1;
      } else {
        return 0;
      }
    }
  }
  function makeNode($this, handler, onCancelling) {
    var tmp;
    if (onCancelling) {
      var tmp0_safe_receiver = handler instanceof JobCancellingNode ? handler : null;
      var tmp_0;
      if (tmp0_safe_receiver == null) {
        tmp_0 = null;
      } else {
        tmp_0 = tmp0_safe_receiver;
      }
      var tmp1_elvis_lhs = tmp_0;
      tmp = tmp1_elvis_lhs == null ? new InvokeOnCancelling($this, handler) : tmp1_elvis_lhs;
    } else {
      var tmp2_safe_receiver = handler instanceof JobNode ? handler : null;
      var tmp_1;
      if (tmp2_safe_receiver == null) {
        tmp_1 = null;
      } else {
        tmp_1 = tmp2_safe_receiver;
      }
      var tmp3_elvis_lhs = tmp_1;
      tmp = tmp3_elvis_lhs == null ? new InvokeOnCompletion($this, handler) : tmp3_elvis_lhs;
    }
    return tmp;
  }
  function addLastAtomic($this, expect, list, node) {
    var tmp$ret$0;
    l$ret$1: do {
      if (!($this._get_state__9() === expect)) {
        tmp$ret$0 = false;
        break l$ret$1;
      } else {
      }
      list.addLast_22(node);
      tmp$ret$0 = true;
    }
     while (false);
    return tmp$ret$0;
  }
  function promoteEmptyToNodeList($this, state) {
    var list = new NodeList_0();
    var update = state._isActive ? list : new InactiveNodeList(list);
    $this.__state_0.compareAndSet$atomicfu(state, update);
    Unit_getInstance();
  }
  function promoteSingleToNodeList($this, state) {
    state.addOneIfEmpty_8(new NodeList_0());
    Unit_getInstance();
    var list = state.__next;
    $this.__state_0.compareAndSet$atomicfu(state, list);
    Unit_getInstance();
  }
  function joinInternal($this) {
    while (true) {
      var tmp0__anonymous__1 = $this._get_state__9();
      if (!(!(tmp0__anonymous__1 == null) ? isInterface(tmp0__anonymous__1, Incomplete) : false))
        return false;
      else {
      }
      if (startInternal($this, tmp0__anonymous__1) >= 0)
        return true;
    }
    Unit_getInstance();
  }
  function joinSuspend($this, $cont) {
    var tmp0__anonymous__1_1 = $cont;
    var cancellable_2_2 = new CancellableContinuationImpl(intercepted(tmp0__anonymous__1_1), 1);
    cancellable_2_2.initCancellability_0();
    var tmp0__get_asHandler__0_4 = new ResumeOnCompletion($this, cancellable_2_2);
    disposeOnCancellation(cancellable_2_2, $this.invokeOnCompletion_22(tmp0__get_asHandler__0_4));
    return cancellable_2_2.getResult_0();
  }
  function cancelMakeCompleting($this, cause) {
    while (true) {
      var tmp0__anonymous__1 = $this._get_state__9();
      var tmp;
      if (!(!(tmp0__anonymous__1 == null) ? isInterface(tmp0__anonymous__1, Incomplete) : false)) {
        tmp = true;
      } else {
        {
          var tmp_0;
          if (tmp0__anonymous__1 instanceof Finishing) {
            tmp_0 = tmp0__anonymous__1._get_isCompleting_();
          } else {
            {
              tmp_0 = false;
            }
          }
          tmp = tmp_0;
        }
      }
      if (tmp) {
        return COMPLETING_ALREADY;
      } else {
      }
      var tmp_1 = createCauseException($this, cause);
      var proposedUpdate_2 = CompletedExceptionally_init_$Create$(tmp_1, false, 2, null);
      var finalState_3 = tryMakeCompleting($this, tmp0__anonymous__1, proposedUpdate_2);
      if (!(finalState_3 === COMPLETING_RETRY))
        return finalState_3;
    }
    Unit_getInstance();
  }
  function createCauseException($this, cause) {
    var tmp0_subject = cause;
    var tmp;
    if (tmp0_subject == null ? true : tmp0_subject instanceof Error) {
      var tmp1_elvis_lhs = cause;
      var tmp_0;
      if (tmp1_elvis_lhs == null) {
        var tmp0_defaultCancellationException_0 = null;
        var tmp1_defaultCancellationException_0 = null;
        var tmp0_elvis_lhs_1 = tmp0_defaultCancellationException_0;
        tmp_0 = new JobCancellationException(tmp0_elvis_lhs_1 == null ? $this.cancellationExceptionMessage_7() : tmp0_elvis_lhs_1, tmp1_defaultCancellationException_0, $this);
      } else {
        tmp_0 = tmp1_elvis_lhs;
      }
      tmp = tmp_0;
    } else {
      {
        tmp = ((!(cause == null) ? isInterface(cause, ParentJob) : false) ? cause : THROW_CCE()).getChildJobCancellationCause_8();
      }
    }
    return tmp;
  }
  function makeCancelling($this, cause) {
    var causeExceptionCache = null;
    while (true) {
      var tmp$ret$0;
      l$ret$1: do {
        var tmp0__anonymous__1 = $this._get_state__9();
        var tmp0_subject_2 = tmp0__anonymous__1;
        if (tmp0_subject_2 instanceof Finishing) {
          if (tmp0__anonymous__1._get_isSealed_())
            return TOO_LATE_TO_CANCEL;
          var wasCancelling_2_4 = tmp0__anonymous__1._get_isCancelling_();
          if (!(cause == null) ? true : !wasCancelling_2_4) {
            var tmp0_elvis_lhs_4_6 = causeExceptionCache;
            var tmp;
            if (tmp0_elvis_lhs_4_6 == null) {
              var tmp0_also_0_5_7 = createCauseException($this, cause);
              causeExceptionCache = tmp0_also_0_5_7;
              tmp = tmp0_also_0_5_7;
            } else {
              tmp = tmp0_elvis_lhs_4_6;
            }
            var causeException_3_5 = tmp;
            tmp0__anonymous__1.addExceptionLocked(causeException_3_5);
          }var tmp1_takeIf_0_6_8 = tmp0__anonymous__1._get_rootCause_();
          var tmp_0;
          if (!wasCancelling_2_4) {
            tmp_0 = tmp1_takeIf_0_6_8;
          } else {
            {
              tmp_0 = null;
            }
          }
          var notifyRootCause_3 = tmp_0;
          var tmp1_safe_receiver_9 = notifyRootCause_3;
          if (tmp1_safe_receiver_9 == null)
            null;
          else {
            notifyCancelling($this, tmp0__anonymous__1._list, tmp1_safe_receiver_9);
            Unit_getInstance();
          }
          Unit_getInstance();
          return COMPLETING_ALREADY;
        } else {
          if (!(tmp0_subject_2 == null) ? isInterface(tmp0_subject_2, Incomplete) : false) {
            var tmp2_elvis_lhs_11 = causeExceptionCache;
            var tmp_1;
            if (tmp2_elvis_lhs_11 == null) {
              var tmp0_also_0_12 = createCauseException($this, cause);
              causeExceptionCache = tmp0_also_0_12;
              tmp_1 = tmp0_also_0_12;
            } else {
              tmp_1 = tmp2_elvis_lhs_11;
            }
            var causeException_10 = tmp_1;
            if (tmp0__anonymous__1._get_isActive__23()) {
              if (tryMakeCancelling($this, tmp0__anonymous__1, causeException_10))
                return COMPLETING_ALREADY;
            } else {
              var finalState_13 = tryMakeCompleting($this, tmp0__anonymous__1, CompletedExceptionally_init_$Create$(causeException_10, false, 2, null));
              if (finalState_13 === COMPLETING_ALREADY) {
                var tmp1_error_0_14 = '' + 'Cannot happen in ' + tmp0__anonymous__1;
                throw IllegalStateException_init_$Create$(toString_1(tmp1_error_0_14));
              } else if (finalState_13 === COMPLETING_RETRY) {
                tmp$ret$0 = Unit_getInstance();
                break l$ret$1;
              } else
                return finalState_13;
            }
          } else {
            return TOO_LATE_TO_CANCEL;
          }
        }
      }
       while (false);
    }
    Unit_getInstance();
  }
  function getOrPromoteCancellingList($this, state) {
    var tmp1_elvis_lhs = state._get_list__12();
    var tmp;
    if (tmp1_elvis_lhs == null) {
      var tmp0_subject = state;
      var tmp_0;
      if (tmp0_subject instanceof Empty) {
        tmp_0 = new NodeList_0();
      } else {
        if (tmp0_subject instanceof JobNode) {
          promoteSingleToNodeList($this, state);
          tmp_0 = null;
        } else {
          {
            var tmp0_error_0 = '' + 'State should have list: ' + state;
            throw IllegalStateException_init_$Create$(toString_1(tmp0_error_0));
          }
        }
      }
      tmp = tmp_0;
    } else {
      tmp = tmp1_elvis_lhs;
    }
    return tmp;
  }
  function tryMakeCancelling($this, state, rootCause) {
    var tmp0_elvis_lhs = getOrPromoteCancellingList($this, state);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return false;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var list = tmp;
    var cancelling = new Finishing(list, false, rootCause);
    if (!$this.__state_0.compareAndSet$atomicfu(state, cancelling))
      return false;
    notifyCancelling($this, list, rootCause);
    return true;
  }
  function tryMakeCompleting($this, state, proposedUpdate) {
    if (!(!(state == null) ? isInterface(state, Incomplete) : false))
      return COMPLETING_ALREADY;
    else {
    }
    var tmp;
    var tmp_0;
    var tmp_1;
    if (state instanceof Empty) {
      tmp_1 = true;
    } else {
      {
        tmp_1 = state instanceof JobNode;
      }
    }
    if (tmp_1) {
      tmp_0 = !(state instanceof ChildHandleNode);
    } else {
      {
        tmp_0 = false;
      }
    }
    if (tmp_0) {
      tmp = !(proposedUpdate instanceof CompletedExceptionally);
    } else {
      {
        tmp = false;
      }
    }
    if (tmp) {
      if (tryFinalizeSimpleState($this, state, proposedUpdate)) {
        return proposedUpdate;
      }return COMPLETING_RETRY;
    } else {
    }
    return tryMakeCompletingSlowPath($this, state, proposedUpdate);
  }
  function tryMakeCompletingSlowPath($this, state, proposedUpdate) {
    var tmp0_elvis_lhs = getOrPromoteCancellingList($this, state);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return COMPLETING_RETRY;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var list = tmp;
    var tmp1_elvis_lhs = state instanceof Finishing ? state : null;
    var finishing = tmp1_elvis_lhs == null ? new Finishing(list, false, null) : tmp1_elvis_lhs;
    var notifyRootCause = null;
    if (finishing._get_isCompleting_())
      return COMPLETING_ALREADY;
    finishing._set_isCompleting_(true);
    if (!(finishing === state)) {
      if (!$this.__state_0.compareAndSet$atomicfu(state, finishing))
        return COMPLETING_RETRY;
    }var wasCancelling_2 = finishing._get_isCancelling_();
    var tmp0_safe_receiver_3 = proposedUpdate instanceof CompletedExceptionally ? proposedUpdate : null;
    if (tmp0_safe_receiver_3 == null)
      null;
    else {
      finishing.addExceptionLocked(tmp0_safe_receiver_3._cause);
      Unit_getInstance();
    }
    Unit_getInstance();
    var tmp0_takeIf_0_4 = finishing._get_rootCause_();
    var tmp_0;
    if (!wasCancelling_2) {
      tmp_0 = tmp0_takeIf_0_4;
    } else {
      {
        tmp_0 = null;
      }
    }
    notifyRootCause = tmp_0;
    var tmp2_safe_receiver = notifyRootCause;
    if (tmp2_safe_receiver == null)
      null;
    else {
      notifyCancelling($this, list, tmp2_safe_receiver);
      Unit_getInstance();
    }
    Unit_getInstance();
    var child_0 = firstChild($this, state);
    if (!(child_0 == null) ? tryWaitForChild($this, finishing, child_0, proposedUpdate) : false)
      return COMPLETING_WAITING_CHILDREN;
    return finalizeFinishingState($this, finishing, proposedUpdate);
  }
  function _get_exceptionOrNull_(_this_, $this) {
    var tmp0_safe_receiver = _this_ instanceof CompletedExceptionally ? _this_ : null;
    return tmp0_safe_receiver == null ? null : tmp0_safe_receiver._cause;
  }
  function firstChild($this, state) {
    var tmp1_elvis_lhs = state instanceof ChildHandleNode ? state : null;
    var tmp;
    if (tmp1_elvis_lhs == null) {
      var tmp0_safe_receiver = state._get_list__12();
      tmp = tmp0_safe_receiver == null ? null : nextChild(tmp0_safe_receiver, $this);
    } else {
      tmp = tmp1_elvis_lhs;
    }
    return tmp;
  }
  function tryWaitForChild($this, state, child_0, proposedUpdate) {
    var $this_0 = $this;
    var state_0 = state;
    var child_1 = child_0;
    var proposedUpdate_0 = proposedUpdate;
    while (true) {
      var $this_1 = $this_0;
      var state_1 = state_0;
      var child_2 = child_1;
      var proposedUpdate_1 = proposedUpdate_0;
      var tmp0__get_asHandler__0 = new ChildCompletion($this_1, state_1, child_2, proposedUpdate_1);
      var handle = child_2._childJob.invokeOnCompletion$default_9(false, false, tmp0__get_asHandler__0, 1, null);
      if (!(handle === NonDisposableHandle_getInstance()))
        return true;
      var tmp0_elvis_lhs = nextChild(child_2, $this_1);
      var tmp;
      if (tmp0_elvis_lhs == null) {
        return false;
      } else {
        tmp = tmp0_elvis_lhs;
      }
      var nextChild_0 = tmp;
      $this_0 = $this_1;
      state_0 = state_1;
      child_1 = nextChild_0;
      proposedUpdate_0 = proposedUpdate_1;
      continue;
    }
  }
  function continueCompleting($this, state, lastChild, proposedUpdate) {
    var waitChild = nextChild(lastChild, $this);
    if (!(waitChild == null) ? tryWaitForChild($this, state, waitChild, proposedUpdate) : false)
      return Unit_getInstance();
    var finalState = finalizeFinishingState($this, state, proposedUpdate);
    $this.afterCompletion_7(finalState);
  }
  function nextChild(_this_, $this) {
    var cur = _this_;
    $l$break: while (true) {
      var tmp0__get_isRemoved__0 = cur;
      if (!tmp0__get_isRemoved__0.__removed) {
        break $l$break;
      }var tmp1__get_prevNode__0 = cur;
      cur = tmp1__get_prevNode__0.__prev;
    }
    while (true) {
      var tmp2__get_nextNode__0 = cur;
      cur = tmp2__get_nextNode__0.__next;
      var tmp3__get_isRemoved__0 = cur;
      if (tmp3__get_isRemoved__0.__removed)
        continue;
      else {
      }
      if (cur instanceof ChildHandleNode)
        return cur;
      else {
      }
      if (cur instanceof NodeList_0)
        return null;
      else {
      }
    }
  }
  function stateString($this, state) {
    var tmp0_subject = state;
    var tmp;
    if (tmp0_subject instanceof Finishing) {
      tmp = state._get_isCancelling_() ? 'Cancelling' : state._get_isCompleting_() ? 'Completing' : 'Active';
    } else {
      if (!(tmp0_subject == null) ? isInterface(tmp0_subject, Incomplete) : false) {
        tmp = state._get_isActive__23() ? 'Active' : 'New';
      } else {
        if (tmp0_subject instanceof CompletedExceptionally) {
          tmp = 'Cancelled';
        } else {
          {
            tmp = 'Completed';
          }
        }
      }
    }
    return tmp;
  }
  function Finishing(list, isCompleting, rootCause) {
    this._list = list;
    this.__isCompleting = atomic_0(isCompleting);
    this.__rootCause = atomic(rootCause);
    this.__exceptionsHolder = atomic(null);
  }
  Finishing.prototype._get_list__12 = function () {
    return this._list;
  };
  Finishing.prototype._set_isCompleting_ = function (value) {
    this.__isCompleting._value_9 = value;
  };
  Finishing.prototype._get_isCompleting_ = function () {
    return this.__isCompleting._value_9;
  };
  Finishing.prototype._set_rootCause_ = function (value) {
    this.__rootCause._value_8 = value;
  };
  Finishing.prototype._get_rootCause_ = function () {
    return this.__rootCause._value_8;
  };
  Finishing.prototype._get_isSealed_ = function () {
    return _get_exceptionsHolder_(this) === SEALED_0;
  };
  Finishing.prototype._get_isCancelling_ = function () {
    return !(this._get_rootCause_() == null);
  };
  Finishing.prototype._get_isActive__23 = function () {
    return this._get_rootCause_() == null;
  };
  Finishing.prototype.sealLocked = function (proposedException) {
    var eh = _get_exceptionsHolder_(this);
    var tmp;
    if (eh == null) {
      tmp = allocateList(this);
    } else {
      if (eh instanceof Error) {
        var tmp0_also_0 = allocateList(this);
        tmp0_also_0.add_33(eh);
        Unit_getInstance();
        tmp = tmp0_also_0;
      } else {
        if (eh instanceof ArrayList) {
          tmp = eh instanceof ArrayList ? eh : THROW_CCE();
        } else {
          {
            var tmp1_error_0 = '' + 'State is ' + eh;
            throw IllegalStateException_init_$Create$(toString_1(tmp1_error_0));
          }
        }
      }
    }
    var list = tmp;
    var rootCause = this._get_rootCause_();
    var tmp0_safe_receiver = rootCause;
    if (tmp0_safe_receiver == null)
      null;
    else {
      list.add_27(0, tmp0_safe_receiver);
      Unit_getInstance();
    }
    Unit_getInstance();
    if (!(proposedException == null) ? !equals_1(proposedException, rootCause) : false) {
      list.add_33(proposedException);
      Unit_getInstance();
    }_set_exceptionsHolder_(this, SEALED_0);
    return list;
  };
  Finishing.prototype.addExceptionLocked = function (exception) {
    var rootCause = this._get_rootCause_();
    if (rootCause == null) {
      this._set_rootCause_(exception);
      return Unit_getInstance();
    }if (exception === rootCause)
      return Unit_getInstance();
    var eh = _get_exceptionsHolder_(this);
    if (eh == null)
      _set_exceptionsHolder_(this, exception);
    else {
      if (eh instanceof Error) {
        if (exception === eh)
          return Unit_getInstance();
        var tmp0_apply_0 = allocateList(this);
        tmp0_apply_0.add_33(eh);
        Unit_getInstance();
        tmp0_apply_0.add_33(exception);
        Unit_getInstance();
        _set_exceptionsHolder_(this, tmp0_apply_0);
      } else {
        if (eh instanceof ArrayList) {
          (eh instanceof ArrayList ? eh : THROW_CCE()).add_33(exception);
          Unit_getInstance();
        } else {
          {
            var tmp1_error_0 = '' + 'State is ' + eh;
            throw IllegalStateException_init_$Create$(toString_1(tmp1_error_0));
          }
        }
      }
    }
  };
  Finishing.prototype.toString = function () {
    return '' + 'Finishing[cancelling=' + this._get_isCancelling_() + ', completing=' + this._get_isCompleting_() + ', rootCause=' + this._get_rootCause_() + ', exceptions=' + _get_exceptionsHolder_(this) + ', list=' + this._list + ']';
  };
  Finishing.$metadata$ = {
    simpleName: 'Finishing',
    kind: 'class',
    interfaces: [Incomplete]
  };
  function ChildCompletion(parent, state, child_0, proposedUpdate) {
    JobNode.call(this, child_0._childJob);
    this._parent = parent;
    this._state_1 = state;
    this._child = child_0;
    this._proposedUpdate = proposedUpdate;
  }
  ChildCompletion.prototype.invoke_375 = function (cause) {
    continueCompleting(this._parent, this._state_1, this._child, this._proposedUpdate);
  };
  ChildCompletion.prototype.invoke = function (cause) {
    return this.invoke_375(cause);
  };
  ChildCompletion.$metadata$ = {
    simpleName: 'ChildCompletion',
    kind: 'class',
    interfaces: []
  };
  function AwaitContinuation(delegate, job) {
    CancellableContinuationImpl.call(this, delegate, 1);
    this._job_0 = job;
  }
  AwaitContinuation.prototype.getContinuationCancellationCause_0 = function (parent) {
    var state = this._job_0._get_state__9();
    if (state instanceof Finishing) {
      var tmp0_safe_receiver = state._get_rootCause_();
      if (tmp0_safe_receiver == null)
        null;
      else {
        return tmp0_safe_receiver;
      }
      Unit_getInstance();
    } else {
    }
    if (state instanceof CompletedExceptionally)
      return state._cause;
    else {
    }
    return parent.getCancellationException_9();
  };
  AwaitContinuation.prototype.nameString_9 = function () {
    return 'AwaitContinuation';
  };
  AwaitContinuation.$metadata$ = {
    simpleName: 'AwaitContinuation',
    kind: 'class',
    interfaces: []
  };
  function awaitSuspend($this, $cont) {
    var tmp0__anonymous__1 = $cont;
    var cont_2 = new AwaitContinuation(intercepted(tmp0__anonymous__1), $this);
    var tmp0__get_asHandler__0_3 = new ResumeAwaitOnCompletion($this, cont_2);
    disposeOnCancellation(cont_2, $this.invokeOnCompletion_22(tmp0__get_asHandler__0_3));
    return cont_2.getResult_0();
  }
  function JobSupport(active) {
    this.__state_0 = atomic(active ? EMPTY_ACTIVE : EMPTY_NEW);
    this.__parentHandle_0 = atomic(null);
  }
  JobSupport.prototype._get_key__47 = function () {
    return Key_getInstance_3();
  };
  JobSupport.prototype._set_parentHandle__7 = function (value) {
    this.__parentHandle_0._value_8 = value;
  };
  JobSupport.prototype._get_parentHandle__7 = function () {
    return this.__parentHandle_0._value_8;
  };
  JobSupport.prototype.initParentJobInternal_7 = function (parent) {
    if (parent == null) {
      this._set_parentHandle__7(NonDisposableHandle_getInstance());
      return Unit_getInstance();
    }parent.start_15();
    Unit_getInstance();
    var handle = parent.attachChild_9(this);
    this._set_parentHandle__7(handle);
    if (this._get_isCompleted__9()) {
      handle.dispose_26();
      this._set_parentHandle__7(NonDisposableHandle_getInstance());
    }};
  JobSupport.prototype._get_state__9 = function () {
    var tmp0_loop_0 = this.__state_0;
    while (true) {
      var tmp1__anonymous__1 = tmp0_loop_0._value_8;
      if (!(tmp1__anonymous__1 instanceof OpDescriptor))
        return tmp1__anonymous__1;
      else {
      }
      tmp1__anonymous__1.perform(this);
      Unit_getInstance();
    }
    Unit_getInstance();
  };
  JobSupport.prototype._get_isActive__23 = function () {
    var state = this._get_state__9();
    var tmp;
    if (!(state == null) ? isInterface(state, Incomplete) : false) {
      tmp = state._get_isActive__23();
    } else {
      {
        tmp = false;
      }
    }
    return tmp;
  };
  JobSupport.prototype._get_isCompleted__9 = function () {
    var tmp = this._get_state__9();
    return !(!(tmp == null) ? isInterface(tmp, Incomplete) : false);
  };
  JobSupport.prototype.start_15 = function () {
    while (true) {
      var tmp0__anonymous__1 = this._get_state__9();
      var tmp0_subject_2 = startInternal(this, tmp0__anonymous__1);
      if (tmp0_subject_2 === 0)
        return false;
      else if (tmp0_subject_2 === 1)
        return true;
    }
    Unit_getInstance();
  };
  JobSupport.prototype.onStartInternal_7 = function () {
  };
  JobSupport.prototype.getCancellationException_9 = function () {
    var state = this._get_state__9();
    var tmp;
    if (state instanceof Finishing) {
      var tmp0_safe_receiver = state._get_rootCause_();
      var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : this.toCancellationException_7(tmp0_safe_receiver, '' + _get_classSimpleName_(this) + ' is cancelling');
      var tmp_0;
      if (tmp1_elvis_lhs == null) {
        var tmp0_error_0 = '' + 'Job is still new or active: ' + this;
        throw IllegalStateException_init_$Create$(toString_1(tmp0_error_0));
      } else {
        tmp_0 = tmp1_elvis_lhs;
      }
      tmp = tmp_0;
    } else {
      if (!(state == null) ? isInterface(state, Incomplete) : false) {
        var tmp1_error_0 = '' + 'Job is still new or active: ' + this;
        throw IllegalStateException_init_$Create$(toString_1(tmp1_error_0));
      } else {
        if (state instanceof CompletedExceptionally) {
          var tmp_1 = state._cause;
          tmp = this.toCancellationException$default_7(tmp_1, null, 1, null);
        } else {
          {
            tmp = new JobCancellationException('' + _get_classSimpleName_(this) + ' has completed normally', null, this);
          }
        }
      }
    }
    return tmp;
  };
  JobSupport.prototype.toCancellationException_7 = function (_this__0, message) {
    var tmp0_elvis_lhs = _this__0 instanceof CancellationException ? _this__0 : null;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      var tmp0_elvis_lhs_1 = message;
      tmp = new JobCancellationException(tmp0_elvis_lhs_1 == null ? this.cancellationExceptionMessage_7() : tmp0_elvis_lhs_1, _this__0, this);
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  };
  JobSupport.prototype.toCancellationException$default_7 = function (_this__0, message, $mask0, $handler) {
    if (!(($mask0 & 1) === 0))
      message = null;
    return this.toCancellationException_7(_this__0, message);
  };
  JobSupport.prototype.invokeOnCompletion_22 = function (handler) {
    return this.invokeOnCompletion_21(false, true, handler);
  };
  JobSupport.prototype.invokeOnCompletion_21 = function (onCancelling, invokeImmediately, handler) {
    var nodeCache = null;
    while (true) {
      var tmp$ret$0;
      l$ret$1: do {
        var tmp0__anonymous__1 = this._get_state__9();
        var tmp0_subject_2 = tmp0__anonymous__1;
        if (tmp0_subject_2 instanceof Empty) {
          if (tmp0__anonymous__1._isActive) {
            var tmp1_elvis_lhs_4 = nodeCache;
            var tmp;
            if (tmp1_elvis_lhs_4 == null) {
              var tmp0_also_0_5 = makeNode(this, handler, onCancelling);
              nodeCache = tmp0_also_0_5;
              tmp = tmp0_also_0_5;
            } else {
              tmp = tmp1_elvis_lhs_4;
            }
            var node_3 = tmp;
            if (this.__state_0.compareAndSet$atomicfu(tmp0__anonymous__1, node_3))
              return node_3;
          } else
            promoteEmptyToNodeList(this, tmp0__anonymous__1);
        } else {
          if (!(tmp0_subject_2 == null) ? isInterface(tmp0_subject_2, Incomplete) : false) {
            var list_6 = tmp0__anonymous__1._get_list__12();
            if (list_6 == null) {
              promoteSingleToNodeList(this, tmp0__anonymous__1 instanceof JobNode ? tmp0__anonymous__1 : THROW_CCE());
            } else {
              var rootCause_7 = null;
              var handle_8 = NonDisposableHandle_getInstance();
              var tmp_0;
              if (onCancelling) {
                tmp_0 = tmp0__anonymous__1 instanceof Finishing;
              } else {
                tmp_0 = false;
              }
              if (tmp_0) {
                rootCause_7 = tmp0__anonymous__1._get_rootCause_();
                var tmp_1;
                if (rootCause_7 == null) {
                  tmp_1 = true;
                } else {
                  var tmp_2;
                  if (handler instanceof ChildHandleNode) {
                    tmp_2 = !tmp0__anonymous__1._get_isCompleting_();
                  } else {
                    {
                      tmp_2 = false;
                    }
                  }
                  tmp_1 = tmp_2;
                }
                if (tmp_1) {
                  var tmp0_elvis_lhs_3_10 = nodeCache;
                  var tmp_3;
                  if (tmp0_elvis_lhs_3_10 == null) {
                    var tmp0_also_0_4_11 = makeNode(this, handler, onCancelling);
                    nodeCache = tmp0_also_0_4_11;
                    tmp_3 = tmp0_also_0_4_11;
                  } else {
                    tmp_3 = tmp0_elvis_lhs_3_10;
                  }
                  var node_2_9 = tmp_3;
                  if (!addLastAtomic(this, tmp0__anonymous__1, list_6, node_2_9)) {
                    tmp$ret$0 = Unit_getInstance();
                    break l$ret$1;
                  }if (rootCause_7 == null)
                    return node_2_9;
                  handle_8 = node_2_9;
                } else {
                }
              } else {
              }
              if (!(rootCause_7 == null)) {
                if (invokeImmediately)
                  invokeIt(handler, rootCause_7);
                return handle_8;
              } else {
                var tmp2_elvis_lhs_13 = nodeCache;
                var tmp_4;
                if (tmp2_elvis_lhs_13 == null) {
                  var tmp1_also_0_14 = makeNode(this, handler, onCancelling);
                  nodeCache = tmp1_also_0_14;
                  tmp_4 = tmp1_also_0_14;
                } else {
                  tmp_4 = tmp2_elvis_lhs_13;
                }
                var node_12 = tmp_4;
                if (addLastAtomic(this, tmp0__anonymous__1, list_6, node_12))
                  return node_12;
              }
            }
          } else {
            {
              if (invokeImmediately) {
                var tmp3_safe_receiver_15 = tmp0__anonymous__1 instanceof CompletedExceptionally ? tmp0__anonymous__1 : null;
                invokeIt(handler, tmp3_safe_receiver_15 == null ? null : tmp3_safe_receiver_15._cause);
              }return NonDisposableHandle_getInstance();
            }
          }
        }
      }
       while (false);
    }
    Unit_getInstance();
  };
  JobSupport.prototype.join_3 = function ($cont) {
    if (!joinInternal(this)) {
      checkCompletion($cont._get_context__86());
      return Unit_getInstance();
    }return joinSuspend(this, $cont);
  };
  JobSupport.prototype.removeNode_7 = function (node) {
    while (true) {
      var tmp0__anonymous__1 = this._get_state__9();
      var tmp0_subject_2 = tmp0__anonymous__1;
      if (tmp0_subject_2 instanceof JobNode) {
        if (!(tmp0__anonymous__1 === node))
          return Unit_getInstance();
        if (this.__state_0.compareAndSet$atomicfu(tmp0__anonymous__1, EMPTY_ACTIVE))
          return Unit_getInstance();
      } else {
        if (!(tmp0_subject_2 == null) ? isInterface(tmp0_subject_2, Incomplete) : false) {
          if (!(tmp0__anonymous__1._get_list__12() == null)) {
            node.remove_35();
            Unit_getInstance();
          }return Unit_getInstance();
        } else {
          return Unit_getInstance();
        }
      }
    }
    Unit_getInstance();
  };
  JobSupport.prototype._get_onCancelComplete__7 = function () {
    return false;
  };
  JobSupport.prototype.cancel_20 = function (cause) {
    var tmp0_elvis_lhs = cause;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      var tmp0_defaultCancellationException_0 = null;
      var tmp1_defaultCancellationException_0 = null;
      var tmp0_elvis_lhs_1 = tmp0_defaultCancellationException_0;
      tmp = new JobCancellationException(tmp0_elvis_lhs_1 == null ? this.cancellationExceptionMessage_7() : tmp0_elvis_lhs_1, tmp1_defaultCancellationException_0, this);
    } else {
      tmp = tmp0_elvis_lhs;
    }
    this.cancelInternal_7(tmp);
  };
  JobSupport.prototype.cancellationExceptionMessage_7 = function () {
    return 'Job was cancelled';
  };
  JobSupport.prototype.cancelInternal_7 = function (cause) {
    this.cancelImpl_7(cause);
    Unit_getInstance();
  };
  JobSupport.prototype.parentCancelled_10 = function (parentJob) {
    this.cancelImpl_7(parentJob);
    Unit_getInstance();
  };
  JobSupport.prototype.childCancelled_10 = function (cause) {
    if (cause instanceof CancellationException)
      return true;
    else {
    }
    return this.cancelImpl_7(cause) ? this._get_handlesException__7() : false;
  };
  JobSupport.prototype.cancelImpl_7 = function (cause) {
    var finalState = COMPLETING_ALREADY;
    if (this._get_onCancelComplete__7()) {
      finalState = cancelMakeCompleting(this, cause);
      if (finalState === COMPLETING_WAITING_CHILDREN)
        return true;
    }if (finalState === COMPLETING_ALREADY) {
      finalState = makeCancelling(this, cause);
    }var tmp;
    if (finalState === COMPLETING_ALREADY) {
      tmp = true;
    } else if (finalState === COMPLETING_WAITING_CHILDREN) {
      tmp = true;
    } else if (finalState === TOO_LATE_TO_CANCEL) {
      tmp = false;
    } else {
      this.afterCompletion_7(finalState);
      tmp = true;
    }
    return tmp;
  };
  JobSupport.prototype.getChildJobCancellationCause_8 = function () {
    var state = this._get_state__9();
    var tmp0_subject = state;
    var tmp;
    if (tmp0_subject instanceof Finishing) {
      tmp = state._get_rootCause_();
    } else {
      if (tmp0_subject instanceof CompletedExceptionally) {
        tmp = state._cause;
      } else {
        if (!(tmp0_subject == null) ? isInterface(tmp0_subject, Incomplete) : false) {
          var tmp0_error_0 = '' + 'Cannot be cancelling child in this state: ' + state;
          throw IllegalStateException_init_$Create$(toString_1(tmp0_error_0));
        } else {
          {
            tmp = null;
          }
        }
      }
    }
    var rootCause = tmp;
    var tmp1_elvis_lhs = rootCause instanceof CancellationException ? rootCause : null;
    return tmp1_elvis_lhs == null ? new JobCancellationException('' + 'Parent job is ' + stateString(this, state), rootCause, this) : tmp1_elvis_lhs;
  };
  JobSupport.prototype.makeCompleting_2 = function (proposedUpdate) {
    while (true) {
      var tmp$ret$0;
      l$ret$1: do {
        var tmp0__anonymous__1 = this._get_state__9();
        var finalState_2 = tryMakeCompleting(this, tmp0__anonymous__1, proposedUpdate);
        if (finalState_2 === COMPLETING_ALREADY)
          return false;
        else if (finalState_2 === COMPLETING_WAITING_CHILDREN)
          return true;
        else if (finalState_2 === COMPLETING_RETRY) {
          tmp$ret$0 = Unit_getInstance();
          break l$ret$1;
        } else {
          this.afterCompletion_7(finalState_2);
          return true;
        }
      }
       while (false);
    }
    Unit_getInstance();
  };
  JobSupport.prototype.makeCompletingOnce_4 = function (proposedUpdate) {
    while (true) {
      var tmp$ret$0;
      l$ret$1: do {
        var tmp0__anonymous__1 = this._get_state__9();
        var finalState_2 = tryMakeCompleting(this, tmp0__anonymous__1, proposedUpdate);
        if (finalState_2 === COMPLETING_ALREADY)
          throw IllegalStateException_init_$Create$_0('' + 'Job ' + this + ' is already complete or completing, ' + ('' + 'but is being completed with ' + proposedUpdate), _get_exceptionOrNull_(proposedUpdate, this));
        else if (finalState_2 === COMPLETING_RETRY) {
          tmp$ret$0 = Unit_getInstance();
          break l$ret$1;
        } else
          return finalState_2;
      }
       while (false);
    }
    Unit_getInstance();
  };
  JobSupport.prototype.attachChild_9 = function (child_0) {
    var tmp0__get_asHandler__0 = new ChildHandleNode(this, child_0);
    var tmp = this.invokeOnCompletion$default_9(true, false, tmp0__get_asHandler__0, 2, null);
    return isInterface(tmp, ChildHandle) ? tmp : THROW_CCE();
  };
  JobSupport.prototype.handleOnCompletionException_7 = function (exception) {
    throw exception;
  };
  JobSupport.prototype.onCancelling_7 = function (cause) {
  };
  JobSupport.prototype._get_isScopedCoroutine__7 = function () {
    return false;
  };
  JobSupport.prototype._get_handlesException__7 = function () {
    return true;
  };
  JobSupport.prototype.handleJobException_7 = function (exception) {
    return false;
  };
  JobSupport.prototype.onCompletionInternal_7 = function (state) {
  };
  JobSupport.prototype.afterCompletion_7 = function (state) {
  };
  JobSupport.prototype.toString = function () {
    return '' + this.toDebugString_7() + '@' + _get_hexAddress_(this);
  };
  JobSupport.prototype.toDebugString_7 = function () {
    return '' + this.nameString_9() + '{' + stateString(this, this._get_state__9()) + '}';
  };
  JobSupport.prototype.nameString_9 = function () {
    return _get_classSimpleName_(this);
  };
  JobSupport.prototype.awaitInternal_2 = function ($cont) {
    $l$break: while (true) {
      var state = this._get_state__9();
      if (!(!(state == null) ? isInterface(state, Incomplete) : false)) {
        if (state instanceof CompletedExceptionally) {
          var tmp0_recoverAndThrow_0 = state._cause;
          throw tmp0_recoverAndThrow_0;
        } else {
        }
        return unboxState(state);
      } else {
      }
      if (startInternal(this, state) >= 0)
        break $l$break;
    }
    return awaitSuspend(this, $cont);
  };
  JobSupport.$metadata$ = {
    simpleName: 'JobSupport',
    kind: 'class',
    interfaces: [Job, ChildJob, ParentJob, SelectClause0]
  };
  function boxIncomplete(_this_) {
    var tmp;
    if (!(_this_ == null) ? isInterface(_this_, Incomplete) : false) {
      tmp = new IncompleteStateBox(_this_);
    } else {
      {
        tmp = _this_;
      }
    }
    return tmp;
  }
  function JobCancellingNode(job) {
    JobNode.call(this, job);
  }
  JobCancellingNode.$metadata$ = {
    simpleName: 'JobCancellingNode',
    kind: 'class',
    interfaces: []
  };
  function InactiveNodeList(list) {
    this._list_0 = list;
  }
  InactiveNodeList.prototype._get_list__12 = function () {
    return this._list_0;
  };
  InactiveNodeList.prototype._get_isActive__23 = function () {
    return false;
  };
  InactiveNodeList.prototype.toString = function () {
    return DEBUG ? this._list_0.getString('New') : anyToString(this);
  };
  InactiveNodeList.$metadata$ = {
    simpleName: 'InactiveNodeList',
    kind: 'class',
    interfaces: [Incomplete]
  };
  function ChildHandleNode(parent, childJob) {
    JobCancellingNode.call(this, parent);
    this._childJob = childJob;
  }
  ChildHandleNode.prototype.invoke_375 = function (cause) {
    return this._childJob.parentCancelled_10(this._get_job__2());
  };
  ChildHandleNode.prototype.invoke = function (cause) {
    return this.invoke_375(cause);
  };
  ChildHandleNode.prototype.childCancelled_10 = function (cause) {
    return this._get_job__2().childCancelled_10(cause);
  };
  ChildHandleNode.$metadata$ = {
    simpleName: 'ChildHandleNode',
    kind: 'class',
    interfaces: [ChildHandle]
  };
  function InvokeOnCancelling(job, handler) {
    JobCancellingNode.call(this, job);
    this._handler_0 = handler;
    this.__invoked = atomic_1(0);
  }
  InvokeOnCancelling.prototype.invoke_375 = function (cause) {
    if (this.__invoked.compareAndSet$atomicfu(0, 1))
      this._handler_0(cause);
  };
  InvokeOnCancelling.prototype.invoke = function (cause) {
    return this.invoke_375(cause);
  };
  InvokeOnCancelling.$metadata$ = {
    simpleName: 'InvokeOnCancelling',
    kind: 'class',
    interfaces: []
  };
  function InvokeOnCompletion(job, handler) {
    JobNode.call(this, job);
    this._handler_1 = handler;
  }
  InvokeOnCompletion.prototype.invoke_375 = function (cause) {
    return this._handler_1(cause);
  };
  InvokeOnCompletion.prototype.invoke = function (cause) {
    return this.invoke_375(cause);
  };
  InvokeOnCompletion.$metadata$ = {
    simpleName: 'InvokeOnCompletion',
    kind: 'class',
    interfaces: []
  };
  function ResumeOnCompletion(job, continuation) {
    JobNode.call(this, job);
    this._continuation_1 = continuation;
  }
  ResumeOnCompletion.prototype.invoke_375 = function (cause) {
    var tmp0_resume_0 = this._continuation_1;
    var tmp1_resume_0 = Unit_getInstance();
    var tmp0_success_0_1 = Companion_getInstance_3();
    return tmp0_resume_0.resumeWith_34(_Result___init__impl_(Unit_getInstance()));
  };
  ResumeOnCompletion.prototype.invoke = function (cause) {
    return this.invoke_375(cause);
  };
  ResumeOnCompletion.$metadata$ = {
    simpleName: 'ResumeOnCompletion',
    kind: 'class',
    interfaces: []
  };
  function unboxState(_this_) {
    var tmp0_safe_receiver = _this_ instanceof IncompleteStateBox ? _this_ : null;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver._state_2;
    return tmp1_elvis_lhs == null ? _this_ : tmp1_elvis_lhs;
  }
  function ResumeAwaitOnCompletion(job, continuation) {
    JobNode.call(this, job);
    this._continuation_2 = continuation;
  }
  ResumeAwaitOnCompletion.prototype.invoke_375 = function (cause) {
    var state = this._get_job__2()._get_state__9();
    if (state instanceof CompletedExceptionally) {
      var tmp0_resumeWithException_0 = this._continuation_2;
      var tmp1_resumeWithException_0 = state._cause;
      var tmp0_failure_0_1 = Companion_getInstance_3();
      tmp0_resumeWithException_0.resumeWith_34(_Result___init__impl_(createFailure(tmp1_resumeWithException_0)));
    } else {
      {
        var tmp2_resume_0 = this._continuation_2;
        var tmp = unboxState(state);
        var tmp3_resume_0 = (tmp == null ? true : isObject(tmp)) ? tmp : THROW_CCE();
        var tmp0_success_0_1 = Companion_getInstance_3();
        tmp2_resume_0.resumeWith_34(_Result___init__impl_(tmp3_resume_0));
      }
    }
  };
  ResumeAwaitOnCompletion.prototype.invoke = function (cause) {
    return this.invoke_375(cause);
  };
  ResumeAwaitOnCompletion.$metadata$ = {
    simpleName: 'ResumeAwaitOnCompletion',
    kind: 'class',
    interfaces: []
  };
  function IncompleteStateBox(state) {
    this._state_2 = state;
  }
  IncompleteStateBox.$metadata$ = {
    simpleName: 'IncompleteStateBox',
    kind: 'class',
    interfaces: []
  };
  function ChildContinuation(parent, child_0) {
    JobCancellingNode.call(this, parent);
    this._child_0 = child_0;
  }
  ChildContinuation.prototype.invoke_375 = function (cause) {
    this._child_0.parentCancelled_7(this._child_0.getContinuationCancellationCause_0(this._get_job__2()));
  };
  ChildContinuation.prototype.invoke = function (cause) {
    return this.invoke_375(cause);
  };
  ChildContinuation.$metadata$ = {
    simpleName: 'ChildContinuation',
    kind: 'class',
    interfaces: []
  };
  function handlesException($this) {
    var tmp = $this._get_parentHandle__7();
    var tmp0_safe_receiver = tmp instanceof ChildHandleNode ? tmp : null;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver._get_job__2();
    var tmp_0;
    if (tmp1_elvis_lhs == null) {
      return false;
    } else {
      tmp_0 = tmp1_elvis_lhs;
    }
    var parentJob = tmp_0;
    while (true) {
      if (parentJob._get_handlesException__7())
        return true;
      var tmp_1 = parentJob._get_parentHandle__7();
      var tmp2_safe_receiver = tmp_1 instanceof ChildHandleNode ? tmp_1 : null;
      var tmp3_elvis_lhs = tmp2_safe_receiver == null ? null : tmp2_safe_receiver._get_job__2();
      var tmp_2;
      if (tmp3_elvis_lhs == null) {
        return false;
      } else {
        tmp_2 = tmp3_elvis_lhs;
      }
      parentJob = tmp_2;
    }
  }
  function JobImpl(parent) {
    JobSupport.call(this, true);
    this.initParentJobInternal_7(parent);
    this._handlesException = handlesException(this);
  }
  JobImpl.prototype._get_onCancelComplete__7 = function () {
    return true;
  };
  JobImpl.prototype._get_handlesException__7 = function () {
    return this._handlesException;
  };
  JobImpl.prototype.complete_3 = function () {
    return this.makeCompleting_2(Unit_getInstance());
  };
  JobImpl.prototype.completeExceptionally_3 = function (exception) {
    return this.makeCompleting_2(CompletedExceptionally_init_$Create$(exception, false, 2, null));
  };
  JobImpl.$metadata$ = {
    simpleName: 'JobImpl',
    kind: 'class',
    interfaces: [CompletableJob]
  };
  function MainCoroutineDispatcher() {
    CoroutineDispatcher.call(this);
  }
  MainCoroutineDispatcher.prototype.toString = function () {
    var tmp0_elvis_lhs = this.toStringInternalImpl_0();
    return tmp0_elvis_lhs == null ? '' + _get_classSimpleName_(this) + '@' + _get_hexAddress_(this) : tmp0_elvis_lhs;
  };
  MainCoroutineDispatcher.prototype.toStringInternalImpl_0 = function () {
    var main_0 = Dispatchers_getInstance()._Main;
    if (this === main_0)
      return 'Dispatchers.Main';
    var tmp;
    try {
      tmp = main_0._get_immediate__0();
    } catch ($p) {
      var tmp_0;
      if ($p instanceof UnsupportedOperationException) {
        tmp_0 = null;
      } else {
        {
          throw $p;
        }
      }
      tmp = tmp_0;
    }
    var immediate = tmp;
    if (this === immediate)
      return 'Dispatchers.Main.immediate';
    return null;
  };
  MainCoroutineDispatcher.$metadata$ = {
    simpleName: 'MainCoroutineDispatcher',
    kind: 'class',
    interfaces: []
  };
  function SupervisorJob(parent) {
    return new SupervisorJobImpl(parent);
  }
  function SupervisorJob$default(parent, $mask0, $handler) {
    if (!(($mask0 & 1) === 0))
      parent = null;
    return SupervisorJob(parent);
  }
  function SupervisorJobImpl(parent) {
    JobImpl.call(this, parent);
  }
  SupervisorJobImpl.prototype.childCancelled_10 = function (cause) {
    return false;
  };
  SupervisorJobImpl.$metadata$ = {
    simpleName: 'SupervisorJobImpl',
    kind: 'class',
    interfaces: []
  };
  function TimeoutCancellationException() {
  }
  TimeoutCancellationException.$metadata$ = {
    simpleName: 'TimeoutCancellationException',
    kind: 'class',
    interfaces: [CopyableThrowable]
  };
  function Unconfined() {
    Unconfined_instance = this;
    CoroutineDispatcher.call(this);
  }
  Unconfined.prototype.isDispatchNeeded_8 = function (context) {
    return false;
  };
  Unconfined.prototype.dispatch_8 = function (context, block) {
    var yieldContext = context.get_70(Key_getInstance_4());
    if (!(yieldContext == null)) {
      yieldContext.dispatcherWasUnconfined__error = true;
      return Unit_getInstance();
    }throw UnsupportedOperationException_init_$Create$_0('Dispatchers.Unconfined.dispatch function can only be used by the yield function. If you wrap Unconfined dispatcher in your code, make sure you properly delegate isDispatchNeeded and dispatch calls.');
  };
  Unconfined.prototype.toString = function () {
    return 'Dispatchers.Unconfined';
  };
  Unconfined.$metadata$ = {
    simpleName: 'Unconfined',
    kind: 'object',
    interfaces: []
  };
  var Unconfined_instance;
  function Unconfined_getInstance() {
    if (Unconfined_instance == null)
      new Unconfined();
    return Unconfined_instance;
  }
  function Key_5() {
    Key_instance_4 = this;
  }
  Key_5.$metadata$ = {
    simpleName: 'Key',
    kind: 'object',
    interfaces: [Key_0]
  };
  var Key_instance_4;
  function Key_getInstance_4() {
    if (Key_instance_4 == null)
      new Key_5();
    return Key_instance_4;
  }
  function checkCompletion(_this_) {
    var job = _this_.get_70(Key_getInstance_3());
    if (!(job == null) ? !job._get_isActive__23() : false)
      throw job.getCancellationException_9();
  }
  var EMPTY;
  var OFFER_SUCCESS;
  var OFFER_FAILED;
  var POLL_FAILED;
  var ENQUEUE_FAILED;
  var HANDLER_INVOKED;
  function hasNextResult($this, result) {
    if (result instanceof Closed) {
      if (!(result._closeCause == null))
        throw recoverStackTrace_0(result._get_receiveException_());
      return false;
    } else {
    }
    return true;
  }
  function hasNextSuspend($this, $cont) {
    var tmp0__anonymous__1_1 = $cont;
    var cancellable_2_2 = getOrCreateCancellableContinuation(intercepted(tmp0__anonymous__1_1));
    var tmp$ret$0;
    l$ret$1: do {
      var receive_4 = new ReceiveHasNext($this, cancellable_2_2);
      while (true) {
        if (enqueueReceive($this._channel, receive_4)) {
          removeReceiveOnCancel($this._channel, cancellable_2_2, receive_4);
          tmp$ret$0 = Unit_getInstance();
          break l$ret$1;
        }var result_5 = $this._channel.pollInternal_3();
        $this._result_2 = result_5;
        if (result_5 instanceof Closed) {
          if (result_5._closeCause == null) {
            var tmp0_resume_0_6 = false;
            var tmp0_success_0_1_7 = Companion_getInstance_3();
            cancellable_2_2.resumeWith_34(_Result___init__impl_(tmp0_resume_0_6));
          } else {
            var tmp1_resumeWithException_0_8 = result_5._get_receiveException_();
            var tmp0_failure_0_1_9 = Companion_getInstance_3();
            cancellable_2_2.resumeWith_34(_Result___init__impl_(createFailure(tmp1_resumeWithException_0_8)));
          }
          tmp$ret$0 = Unit_getInstance();
          break l$ret$1;
        } else {
        }
        if (!(result_5 === POLL_FAILED)) {
          var tmp0_safe_receiver_10 = $this._channel._get_onUndeliveredElement__4();
          var tmp;
          if (tmp0_safe_receiver_10 == null) {
            tmp = null;
          } else {
            tmp = bindCancellationFun(tmp0_safe_receiver_10, (result_5 == null ? true : isObject(result_5)) ? result_5 : THROW_CCE(), cancellable_2_2._get_context__86());
          }
          cancellable_2_2.resume_1(true, tmp);
          tmp$ret$0 = Unit_getInstance();
          break l$ret$1;
        }}
    }
     while (false);
    return cancellable_2_2.getResult_0();
  }
  function enqueueReceive($this, receive) {
    var tmp0_also_0 = $this.enqueueReceiveInternal_3(receive);
    if (tmp0_also_0)
      $this.onReceiveEnqueued_3();
    return tmp0_also_0;
  }
  function removeReceiveOnCancel($this, cont, receive) {
    var tmp0__get_asHandler__0 = new RemoveReceiveOnCancel($this, receive);
    return cont.invokeOnCancellation_1(tmp0__get_asHandler__0);
  }
  function RemoveReceiveOnCancel($outer, receive) {
    this._$this_5 = $outer;
    BeforeResumeCancelHandler.call(this);
    this._receive = receive;
  }
  RemoveReceiveOnCancel.prototype.invoke_375 = function (cause) {
    if (this._receive.remove_35())
      this._$this_5.onReceiveDequeued_3();
  };
  RemoveReceiveOnCancel.prototype.invoke = function (cause) {
    return this.invoke_375(cause);
  };
  RemoveReceiveOnCancel.prototype.toString = function () {
    return '' + 'RemoveReceiveOnCancel[' + this._receive + ']';
  };
  RemoveReceiveOnCancel.$metadata$ = {
    simpleName: 'RemoveReceiveOnCancel',
    kind: 'class',
    interfaces: []
  };
  function Itr(channel) {
    this._channel = channel;
    this._result_2 = POLL_FAILED;
  }
  Itr.prototype.hasNext_31 = function ($cont) {
    if (!(this._result_2 === POLL_FAILED))
      return hasNextResult(this, this._result_2);
    this._result_2 = this._channel.pollInternal_3();
    if (!(this._result_2 === POLL_FAILED))
      return hasNextResult(this, this._result_2);
    return hasNextSuspend(this, $cont);
  };
  Itr.prototype.next_35 = function () {
    var result = this._result_2;
    if (result instanceof Closed)
      throw recoverStackTrace_0(result._get_receiveException_());
    else {
    }
    if (!(result === POLL_FAILED)) {
      this._result_2 = POLL_FAILED;
      return (result == null ? true : isObject(result)) ? result : THROW_CCE();
    }throw IllegalStateException_init_$Create$("'hasNext' should be called prior to 'next' invocation");
  };
  Itr.$metadata$ = {
    simpleName: 'Itr',
    kind: 'class',
    interfaces: [ChannelIterator]
  };
  function ReceiveHasNext(iterator_0, cont) {
    Receive.call(this);
    this._iterator_2 = iterator_0;
    this._cont = cont;
  }
  ReceiveHasNext.prototype.tryResumeReceive_2 = function (value, otherOp) {
    var tmp0_safe_receiver = otherOp;
    var tmp1_elvis_lhs = this._cont.tryResume_4(true, tmp0_safe_receiver == null ? null : tmp0_safe_receiver.desc__error, this.resumeOnCancellationFun(value));
    var tmp;
    if (tmp1_elvis_lhs == null) {
      return null;
    } else {
      tmp = tmp1_elvis_lhs;
    }
    var token = tmp;
    var tmp2_safe_receiver = otherOp;
    if (tmp2_safe_receiver == null)
      null;
    else {
      tmp2_safe_receiver.finishPrepare__error();
      Unit_getInstance();
    }
    Unit_getInstance();
    return RESUME_TOKEN;
  };
  ReceiveHasNext.prototype.completeResumeReceive_2 = function (value) {
    this._iterator_2._result_2 = value;
    this._cont.completeResume_1(RESUME_TOKEN);
  };
  ReceiveHasNext.prototype.resumeReceiveClosed_0 = function (closed) {
    var tmp;
    if (closed._closeCause == null) {
      tmp = this._cont.tryResume$default_1(false, null, 2, null);
    } else {
      tmp = this._cont.tryResumeWithException_1(closed._get_receiveException_());
    }
    var token = tmp;
    if (!(token == null)) {
      this._iterator_2._result_2 = closed;
      this._cont.completeResume_1(token);
    }};
  ReceiveHasNext.prototype.resumeOnCancellationFun = function (value) {
    var tmp0_safe_receiver = this._iterator_2._channel._get_onUndeliveredElement__4();
    return tmp0_safe_receiver == null ? null : bindCancellationFun(tmp0_safe_receiver, value, this._cont._get_context__86());
  };
  ReceiveHasNext.prototype.toString = function () {
    return '' + 'ReceiveHasNext@' + _get_hexAddress_(this);
  };
  ReceiveHasNext.$metadata$ = {
    simpleName: 'ReceiveHasNext',
    kind: 'class',
    interfaces: []
  };
  function AbstractChannel(onUndeliveredElement) {
    AbstractSendChannel.call(this, onUndeliveredElement);
  }
  AbstractChannel.prototype.pollInternal_3 = function () {
    while (true) {
      var tmp0_elvis_lhs = this.takeFirstSendOrPeekClosed_4();
      var tmp;
      if (tmp0_elvis_lhs == null) {
        return POLL_FAILED;
      } else {
        tmp = tmp0_elvis_lhs;
      }
      var send = tmp;
      var token = send.tryResumeSend_3(null);
      if (!(token == null)) {
        send.completeResumeSend_3();
        return send._get_pollResult__3();
      }send.undeliveredElement_3();
    }
  };
  AbstractChannel.prototype._get_isClosedForReceive__3 = function () {
    return !(this._get_closedForReceive__4() == null) ? this._get_isBufferEmpty__3() : false;
  };
  AbstractChannel.prototype.enqueueReceiveInternal_3 = function (receive) {
    var tmp;
    if (this._get_isBufferAlwaysEmpty__3()) {
      var tmp$ret$0;
      l$ret$1: do {
        var tmp0_addLastIfPrev_0 = this._get_queue__4();
        var tmp1__anonymous__1 = tmp0_addLastIfPrev_0.__prev;
        if (!!(tmp1__anonymous__1 instanceof Send)) {
          tmp$ret$0 = false;
          break l$ret$1;
        } else {
        }
        tmp0_addLastIfPrev_0.addLast_22(receive);
        tmp$ret$0 = true;
      }
       while (false);
      tmp = tmp$ret$0;
    } else {
      var tmp$ret$2;
      l$ret$3: do {
        var tmp2_addLastIfPrevAndIf_0 = this._get_queue__4();
        var tmp3__anonymous__1 = tmp2_addLastIfPrevAndIf_0.__prev;
        if (!!(tmp3__anonymous__1 instanceof Send)) {
          tmp$ret$2 = false;
          break l$ret$3;
        } else {
        }
        if (!this._get_isBufferEmpty__3()) {
          tmp$ret$2 = false;
          break l$ret$3;
        } else {
        }
        tmp2_addLastIfPrevAndIf_0.addLast_22(receive);
        tmp$ret$2 = true;
      }
       while (false);
      tmp = tmp$ret$2;
    }
    return tmp;
  };
  AbstractChannel.prototype.cancel_20 = function (cause) {
    if (this._get_isClosedForReceive__3())
      return Unit_getInstance();
    var tmp0_elvis_lhs = cause;
    this.cancelInternal_12(tmp0_elvis_lhs == null ? CancellationException_init_$Create$('' + _get_classSimpleName_(this) + ' was cancelled') : tmp0_elvis_lhs);
    Unit_getInstance();
  };
  AbstractChannel.prototype.cancelInternal_12 = function (cause) {
    var tmp0_also_0 = this.close_27(cause);
    this.onCancelIdempotent_3(tmp0_also_0);
    return tmp0_also_0;
  };
  AbstractChannel.prototype.onCancelIdempotent_3 = function (wasClosed) {
    var tmp0_elvis_lhs = this._get_closedForSend__4();
    var tmp;
    if (tmp0_elvis_lhs == null) {
      var tmp0_error_0 = 'Cannot happen';
      throw IllegalStateException_init_$Create$(toString_1(tmp0_error_0));
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var closed = tmp;
    var list = _InlineList___init__impl__0(null, 1, null);
    $l$break: while (true) {
      var previous = closed.__prev;
      if (previous instanceof LinkedListHead) {
        break $l$break;
      } else {
      }
      if (!previous.remove_35()) {
        previous.helpRemove_18();
        continue $l$break;
      }var tmp_0 = list;
      list = InlineList__plus_impl(tmp_0, previous instanceof Send ? previous : THROW_CCE());
    }
    var tmp$ret$0;
    l$ret$1: do {
      var tmp1_forEachReversed_0 = list;
      var tmp0_subject_1 = _get_holder_(tmp1_forEachReversed_0);
      if (tmp0_subject_1 == null) {
        tmp$ret$0 = Unit_getInstance();
        break l$ret$1;
      } else {
        if (!(tmp0_subject_1 instanceof ArrayList)) {
          var tmp_1 = _get_holder_(tmp1_forEachReversed_0);
          var tmp2__anonymous__5 = (tmp_1 == null ? true : isObject(tmp_1)) ? tmp_1 : THROW_CCE();
          tmp2__anonymous__5.resumeSendClosed_3(closed);
        } else {
          {
            var tmp_2 = _get_holder_(tmp1_forEachReversed_0);
            var list_2 = tmp_2 instanceof ArrayList ? tmp_2 : THROW_CCE();
            var inductionVariable = list_2._get_size__45() - 1 | 0;
            if (0 <= inductionVariable)
              do {
                var i_4 = inductionVariable;
                inductionVariable = inductionVariable + -1 | 0;
                var tmp3__anonymous__5 = list_2.get_80(i_4);
                tmp3__anonymous__5.resumeSendClosed_3(closed);
              }
               while (0 <= inductionVariable);
          }
        }
      }
    }
     while (false);
  };
  AbstractChannel.prototype.iterator_64 = function () {
    return new Itr(this);
  };
  AbstractChannel.prototype.takeFirstReceiveOrPeekClosed_4 = function () {
    var tmp0_also_0 = AbstractSendChannel.prototype.takeFirstReceiveOrPeekClosed_4.call(this);
    var tmp;
    if (!(tmp0_also_0 == null)) {
      tmp = !(tmp0_also_0 instanceof Closed);
    } else {
      tmp = false;
    }
    if (tmp)
      this.onReceiveDequeued_3();
    else {
    }
    return tmp0_also_0;
  };
  AbstractChannel.prototype.onReceiveEnqueued_3 = function () {
  };
  AbstractChannel.prototype.onReceiveDequeued_3 = function () {
  };
  AbstractChannel.$metadata$ = {
    simpleName: 'AbstractChannel',
    kind: 'class',
    interfaces: [Channel]
  };
  function helpCloseAndGetSendException($this, element, closed) {
    helpClose($this, closed);
    var tmp0_safe_receiver = $this._onUndeliveredElement;
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      tmp = callUndeliveredElementCatchingException$default(tmp0_safe_receiver, element, null, 2, null);
    }
    var tmp1_safe_receiver = tmp;
    if (tmp1_safe_receiver == null)
      null;
    else {
      addSuppressed(tmp1_safe_receiver, closed._get_sendException_());
      throw tmp1_safe_receiver;
    }
    Unit_getInstance();
    return closed._get_sendException_();
  }
  function sendSuspend($this, element, $cont) {
    var tmp0__anonymous__1_1 = $cont;
    var cancellable_2_2 = getOrCreateCancellableContinuation(intercepted(tmp0__anonymous__1_1));
    var tmp$ret$0;
    l$ret$1: do {
      loop: while (true) {
        if ($this._get_isFullImpl__4()) {
          var send_4 = $this._onUndeliveredElement == null ? new SendElement(element, cancellable_2_2) : new SendElementWithUndeliveredHandler(element, cancellable_2_2, $this._onUndeliveredElement);
          var enqueueResult_5 = $this.enqueueSend_4(send_4);
          if (enqueueResult_5 == null) {
            removeOnCancellation(cancellable_2_2, send_4);
            tmp$ret$0 = Unit_getInstance();
            break l$ret$1;
          } else {
            if (enqueueResult_5 instanceof Closed) {
              helpCloseAndResumeWithSendException(cancellable_2_2, $this, element, enqueueResult_5);
              tmp$ret$0 = Unit_getInstance();
              break l$ret$1;
            } else {
              if (enqueueResult_5 === ENQUEUE_FAILED) {
              } else {
                if (enqueueResult_5 instanceof Receive) {
                } else {
                  {
                    var tmp0_error_0_6 = '' + 'enqueueSend returned ' + enqueueResult_5;
                    throw IllegalStateException_init_$Create$(toString_1(tmp0_error_0_6));
                  }
                }
              }
            }
          }
        }var offerResult_7 = $this.offerInternal_4(element);
        if (offerResult_7 === OFFER_SUCCESS) {
          var tmp1_resume_0_8 = Unit_getInstance();
          var tmp0_success_0_1_9 = Companion_getInstance_3();
          cancellable_2_2.resumeWith_34(_Result___init__impl_(Unit_getInstance()));
          tmp$ret$0 = Unit_getInstance();
          break l$ret$1;
        } else {
          if (offerResult_7 === OFFER_FAILED)
            continue loop;
          else {
            if (offerResult_7 instanceof Closed) {
              helpCloseAndResumeWithSendException(cancellable_2_2, $this, element, offerResult_7);
              tmp$ret$0 = Unit_getInstance();
              break l$ret$1;
            } else {
              {
                var tmp2_error_0_10 = '' + 'offerInternal returned ' + offerResult_7;
                throw IllegalStateException_init_$Create$(toString_1(tmp2_error_0_10));
              }
            }
          }
        }
      }
    }
     while (false);
    return cancellable_2_2.getResult_0();
  }
  function helpCloseAndResumeWithSendException(_this_, $this, element, closed) {
    helpClose($this, closed);
    var sendException = closed._get_sendException_();
    var tmp0_safe_receiver = $this._onUndeliveredElement;
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      tmp = callUndeliveredElementCatchingException$default(tmp0_safe_receiver, element, null, 2, null);
    }
    var tmp1_safe_receiver = tmp;
    if (tmp1_safe_receiver == null)
      null;
    else {
      addSuppressed(tmp1_safe_receiver, sendException);
      var tmp0_failure_0_1_2 = Companion_getInstance_3();
      _this_.resumeWith_34(_Result___init__impl_(createFailure(tmp1_safe_receiver)));
      return Unit_getInstance();
    }
    Unit_getInstance();
    var tmp0_failure_0_1 = Companion_getInstance_3();
    _this_.resumeWith_34(_Result___init__impl_(createFailure(sendException)));
  }
  function invokeOnCloseHandler($this, cause) {
    var handler = $this._onCloseHandler._value_8;
    if ((!(handler === null) ? !(handler === HANDLER_INVOKED) : false) ? $this._onCloseHandler.compareAndSet$atomicfu(handler, HANDLER_INVOKED) : false) {
      ((!(handler == null) ? typeof handler === 'function' : false) ? handler : THROW_CCE())(cause);
    }}
  function helpClose($this, closed) {
    var closedList = _InlineList___init__impl__0(null, 1, null);
    $l$break: while (true) {
      var tmp = closed.__prev;
      var tmp0_elvis_lhs = tmp instanceof Receive ? tmp : null;
      var tmp_0;
      if (tmp0_elvis_lhs == null) {
        break $l$break;
      } else {
        tmp_0 = tmp0_elvis_lhs;
      }
      var previous = tmp_0;
      if (!previous.remove_35()) {
        previous.helpRemove_18();
        continue $l$break;
      }closedList = InlineList__plus_impl(closedList, previous);
    }
    var tmp$ret$0;
    l$ret$1: do {
      var tmp0_forEachReversed_0 = closedList;
      var tmp0_subject_1 = _get_holder_(tmp0_forEachReversed_0);
      if (tmp0_subject_1 == null) {
        tmp$ret$0 = Unit_getInstance();
        break l$ret$1;
      } else {
        if (!(tmp0_subject_1 instanceof ArrayList)) {
          var tmp_1 = _get_holder_(tmp0_forEachReversed_0);
          var tmp1__anonymous__5 = (tmp_1 == null ? true : isObject(tmp_1)) ? tmp_1 : THROW_CCE();
          tmp1__anonymous__5.resumeReceiveClosed_0(closed);
        } else {
          {
            var tmp_2 = _get_holder_(tmp0_forEachReversed_0);
            var list_2 = tmp_2 instanceof ArrayList ? tmp_2 : THROW_CCE();
            var inductionVariable = list_2._get_size__45() - 1 | 0;
            if (0 <= inductionVariable)
              do {
                var i_4 = inductionVariable;
                inductionVariable = inductionVariable + -1 | 0;
                var tmp2__anonymous__5 = list_2.get_80(i_4);
                tmp2__anonymous__5.resumeReceiveClosed_0(closed);
              }
               while (0 <= inductionVariable);
          }
        }
      }
    }
     while (false);
    $this.onClosedIdempotent_4(closed);
  }
  function _get_queueDebugStateString_($this) {
    var tmp0__get_nextNode__0 = $this._queue;
    var head = tmp0__get_nextNode__0.__next;
    if (head === $this._queue)
      return 'EmptyQueue';
    var tmp0_subject = head;
    var tmp;
    if (tmp0_subject instanceof Closed) {
      tmp = toString_1(head);
    } else {
      if (tmp0_subject instanceof Receive) {
        tmp = 'ReceiveQueued';
      } else {
        if (tmp0_subject instanceof Send) {
          tmp = 'SendQueued';
        } else {
          {
            tmp = '' + 'UNEXPECTED:' + head;
          }
        }
      }
    }
    var result = tmp;
    var tmp1__get_prevNode__0 = $this._queue;
    var tail = tmp1__get_prevNode__0.__prev;
    if (!(tail === head)) {
      result = result + ('' + ',queueSize=' + countQueueSize($this));
      if (tail instanceof Closed)
        result = result + ('' + ',closedForSend=' + tail);
      else {
      }
    }return result;
  }
  function countQueueSize($this) {
    var size_0 = 0;
    var tmp0_forEach_0 = $this._queue;
    var cur_1 = tmp0_forEach_0._get__next__1();
    while (!equals_1(cur_1, tmp0_forEach_0)) {
      if (cur_1 instanceof LinkedListNode) {
        var tmp1__anonymous__2 = cur_1;
        var tmp0_3 = size_0;
        size_0 = tmp0_3 + 1 | 0;
        Unit_getInstance();
      } else {
      }
      cur_1 = cur_1.__next;
    }
    return size_0;
  }
  function SendBuffered(element) {
    Send.call(this);
    this._element_0 = element;
  }
  SendBuffered.prototype._get_pollResult__3 = function () {
    return this._element_0;
  };
  SendBuffered.prototype.tryResumeSend_3 = function (otherOp) {
    var tmp0_also_0 = RESUME_TOKEN;
    var tmp0_safe_receiver_2 = otherOp;
    if (tmp0_safe_receiver_2 == null)
      null;
    else {
      tmp0_safe_receiver_2.finishPrepare__error();
      Unit_getInstance();
    }
    Unit_getInstance();
    return tmp0_also_0;
  };
  SendBuffered.prototype.completeResumeSend_3 = function () {
  };
  SendBuffered.prototype.resumeSendClosed_3 = function (closed) {
  };
  SendBuffered.prototype.toString = function () {
    return '' + 'SendBuffered@' + _get_hexAddress_(this) + '(' + this._element_0 + ')';
  };
  SendBuffered.$metadata$ = {
    simpleName: 'SendBuffered',
    kind: 'class',
    interfaces: []
  };
  function AbstractSendChannel(onUndeliveredElement) {
    this._onUndeliveredElement = onUndeliveredElement;
    this._queue = new LinkedListHead();
    this._onCloseHandler = atomic(null);
  }
  AbstractSendChannel.prototype._get_onUndeliveredElement__4 = function () {
    return this._onUndeliveredElement;
  };
  AbstractSendChannel.prototype._get_queue__4 = function () {
    return this._queue;
  };
  AbstractSendChannel.prototype.offerInternal_4 = function (element) {
    while (true) {
      var tmp0_elvis_lhs = this.takeFirstReceiveOrPeekClosed_4();
      var tmp;
      if (tmp0_elvis_lhs == null) {
        return OFFER_FAILED;
      } else {
        tmp = tmp0_elvis_lhs;
      }
      var receive = tmp;
      var token = receive.tryResumeReceive_2(element, null);
      if (!(token == null)) {
        receive.completeResumeReceive_2(element);
        return receive._get_offerResult__2();
      }}
  };
  AbstractSendChannel.prototype._get_closedForSend__4 = function () {
    var tmp0__get_prevNode__0 = this._queue;
    var tmp = tmp0__get_prevNode__0.__prev;
    var tmp0_safe_receiver = tmp instanceof Closed ? tmp : null;
    var tmp_0;
    if (tmp0_safe_receiver == null) {
      tmp_0 = null;
    } else {
      helpClose(this, tmp0_safe_receiver);
      tmp_0 = tmp0_safe_receiver;
    }
    return tmp_0;
  };
  AbstractSendChannel.prototype._get_closedForReceive__4 = function () {
    var tmp0__get_nextNode__0 = this._queue;
    var tmp = tmp0__get_nextNode__0.__next;
    var tmp0_safe_receiver = tmp instanceof Closed ? tmp : null;
    var tmp_0;
    if (tmp0_safe_receiver == null) {
      tmp_0 = null;
    } else {
      helpClose(this, tmp0_safe_receiver);
      tmp_0 = tmp0_safe_receiver;
    }
    return tmp_0;
  };
  AbstractSendChannel.prototype.takeFirstSendOrPeekClosed_4 = function () {
    var tmp$ret$0;
    l$ret$1: do {
      var tmp1_removeFirstIfIsInstanceOfOrPeekIf_0 = this._queue;
      var next_1 = tmp1_removeFirstIfIsInstanceOfOrPeekIf_0.__next;
      if (next_1 === tmp1_removeFirstIfIsInstanceOfOrPeekIf_0) {
        tmp$ret$0 = null;
        break l$ret$1;
      }if (!(next_1 instanceof Send)) {
        tmp$ret$0 = null;
        break l$ret$1;
      } else {
      }
      var tmp2__anonymous__3 = next_1;
      if (tmp2__anonymous__3 instanceof Closed) {
        tmp$ret$0 = next_1;
        break l$ret$1;
      } else {
      }
      var tmp0_check_0 = next_1.remove_35();
      if (!tmp0_check_0) {
        var message_1 = 'Should remove';
        throw IllegalStateException_init_$Create$(toString_1(message_1));
      }tmp$ret$0 = next_1;
    }
     while (false);
    return tmp$ret$0;
  };
  AbstractSendChannel.prototype.sendBuffered_0 = function (element) {
    var tmp$ret$0;
    l$ret$1: do {
      var tmp0_addLastIfPrev_0 = this._queue;
      var tmp1_addLastIfPrev_0 = new SendBuffered(element);
      var tmp2__anonymous__1 = tmp0_addLastIfPrev_0.__prev;
      if (isInterface(tmp2__anonymous__1, ReceiveOrClosed))
        return tmp2__anonymous__1;
      else {
      }
      if (!true) {
        tmp$ret$0 = false;
        break l$ret$1;
      } else {
      }
      tmp0_addLastIfPrev_0.addLast_22(tmp1_addLastIfPrev_0);
      tmp$ret$0 = true;
    }
     while (false);
    Unit_getInstance();
    return null;
  };
  AbstractSendChannel.prototype._get_isFullImpl__4 = function () {
    var tmp;
    var tmp0__get_nextNode__0 = this._queue;
    var tmp_0 = tmp0__get_nextNode__0.__next;
    if (!isInterface(tmp_0, ReceiveOrClosed)) {
      tmp = this._get_isBufferFull__4();
    } else {
      {
        tmp = false;
      }
    }
    return tmp;
  };
  AbstractSendChannel.prototype.send_6 = function (element, $cont) {
    if (this.offerInternal_4(element) === OFFER_SUCCESS)
      return Unit_getInstance();
    return sendSuspend(this, element, $cont);
  };
  AbstractSendChannel.prototype.offer_5 = function (element) {
    var result = this.offerInternal_4(element);
    var tmp;
    if (result === OFFER_SUCCESS) {
      tmp = true;
    } else {
      if (result === OFFER_FAILED) {
        var tmp0_elvis_lhs = this._get_closedForSend__4();
        var tmp_0;
        if (tmp0_elvis_lhs == null) {
          return false;
        } else {
          tmp_0 = tmp0_elvis_lhs;
        }
        throw recoverStackTrace_0(helpCloseAndGetSendException(this, element, tmp_0));
      } else {
        if (result instanceof Closed) {
          throw recoverStackTrace_0(helpCloseAndGetSendException(this, element, result));
        } else {
          {
            var tmp0_error_0 = '' + 'offerInternal returned ' + result;
            throw IllegalStateException_init_$Create$(toString_1(tmp0_error_0));
          }
        }
      }
    }
    return tmp;
  };
  AbstractSendChannel.prototype.enqueueSend_4 = function (send) {
    if (this._get_isBufferAlwaysFull__4()) {
      var tmp$ret$0;
      l$ret$1: do {
        var tmp0_addLastIfPrev_0 = this._queue;
        var tmp1__anonymous__1 = tmp0_addLastIfPrev_0.__prev;
        if (isInterface(tmp1__anonymous__1, ReceiveOrClosed))
          return tmp1__anonymous__1;
        else {
        }
        if (!true) {
          tmp$ret$0 = false;
          break l$ret$1;
        } else {
        }
        tmp0_addLastIfPrev_0.addLast_22(send);
        tmp$ret$0 = true;
      }
       while (false);
      Unit_getInstance();
    } else {
      var tmp$ret$2;
      l$ret$3: do {
        var tmp2_addLastIfPrevAndIf_0 = this._queue;
        var tmp3__anonymous__1 = tmp2_addLastIfPrevAndIf_0.__prev;
        if (isInterface(tmp3__anonymous__1, ReceiveOrClosed))
          return tmp3__anonymous__1;
        else {
        }
        if (!true) {
          tmp$ret$2 = false;
          break l$ret$3;
        } else {
        }
        if (!this._get_isBufferFull__4()) {
          tmp$ret$2 = false;
          break l$ret$3;
        } else {
        }
        tmp2_addLastIfPrevAndIf_0.addLast_22(send);
        tmp$ret$2 = true;
      }
       while (false);
      if (!tmp$ret$2)
        return ENQUEUE_FAILED;
      else {
      }
    }
    return null;
  };
  AbstractSendChannel.prototype.close_27 = function (cause) {
    var closed = new Closed(cause);
    var tmp$ret$0;
    l$ret$1: do {
      var tmp0_addLastIfPrev_0 = this._queue;
      var tmp1__anonymous__1 = tmp0_addLastIfPrev_0.__prev;
      if (!!(tmp1__anonymous__1 instanceof Closed)) {
        tmp$ret$0 = false;
        break l$ret$1;
      } else {
      }
      tmp0_addLastIfPrev_0.addLast_22(closed);
      tmp$ret$0 = true;
    }
     while (false);
    var closeAdded = tmp$ret$0;
    var tmp;
    if (closeAdded) {
      tmp = closed;
    } else {
      var tmp2__get_prevNode__0 = this._queue;
      var tmp_0 = tmp2__get_prevNode__0.__prev;
      tmp = tmp_0 instanceof Closed ? tmp_0 : THROW_CCE();
    }
    var actuallyClosed = tmp;
    helpClose(this, actuallyClosed);
    if (closeAdded)
      invokeOnCloseHandler(this, cause);
    return closeAdded;
  };
  AbstractSendChannel.prototype.onClosedIdempotent_4 = function (closed) {
  };
  AbstractSendChannel.prototype.takeFirstReceiveOrPeekClosed_4 = function () {
    var tmp$ret$0;
    l$ret$1: do {
      var tmp1_removeFirstIfIsInstanceOfOrPeekIf_0 = this._queue;
      var next_1 = tmp1_removeFirstIfIsInstanceOfOrPeekIf_0.__next;
      if (next_1 === tmp1_removeFirstIfIsInstanceOfOrPeekIf_0) {
        tmp$ret$0 = null;
        break l$ret$1;
      }if (!isInterface(next_1, ReceiveOrClosed)) {
        tmp$ret$0 = null;
        break l$ret$1;
      } else {
      }
      var tmp2__anonymous__3 = next_1;
      if (tmp2__anonymous__3 instanceof Closed) {
        tmp$ret$0 = next_1;
        break l$ret$1;
      } else {
      }
      var tmp0_check_0 = next_1.remove_35();
      if (!tmp0_check_0) {
        var message_1 = 'Should remove';
        throw IllegalStateException_init_$Create$(toString_1(message_1));
      }tmp$ret$0 = next_1;
    }
     while (false);
    return tmp$ret$0;
  };
  AbstractSendChannel.prototype.toString = function () {
    return '' + _get_classSimpleName_(this) + '@' + _get_hexAddress_(this) + '{' + _get_queueDebugStateString_(this) + '}' + this._get_bufferDebugString__4();
  };
  AbstractSendChannel.prototype._get_bufferDebugString__4 = function () {
    return '';
  };
  AbstractSendChannel.$metadata$ = {
    simpleName: 'AbstractSendChannel',
    kind: 'class',
    interfaces: [SendChannel]
  };
  function Send() {
    LinkedListNode.call(this);
  }
  Send.prototype.undeliveredElement_3 = function () {
  };
  Send.$metadata$ = {
    simpleName: 'Send',
    kind: 'class',
    interfaces: []
  };
  function ReceiveOrClosed() {
  }
  ReceiveOrClosed.$metadata$ = {
    simpleName: 'ReceiveOrClosed',
    kind: 'interface',
    interfaces: []
  };
  function Closed(closeCause) {
    Send.call(this);
    this._closeCause = closeCause;
  }
  Closed.prototype._get_sendException_ = function () {
    var tmp0_elvis_lhs = this._closeCause;
    return tmp0_elvis_lhs == null ? new ClosedSendChannelException('Channel was closed') : tmp0_elvis_lhs;
  };
  Closed.prototype._get_receiveException_ = function () {
    var tmp0_elvis_lhs = this._closeCause;
    return tmp0_elvis_lhs == null ? new ClosedReceiveChannelException('Channel was closed') : tmp0_elvis_lhs;
  };
  Closed.prototype._get_offerResult__2 = function () {
    return this;
  };
  Closed.prototype._get_pollResult__3 = function () {
    return this;
  };
  Closed.prototype.tryResumeSend_3 = function (otherOp) {
    var tmp0_also_0 = RESUME_TOKEN;
    var tmp0_safe_receiver_2 = otherOp;
    if (tmp0_safe_receiver_2 == null)
      null;
    else {
      tmp0_safe_receiver_2.finishPrepare__error();
      Unit_getInstance();
    }
    Unit_getInstance();
    return tmp0_also_0;
  };
  Closed.prototype.completeResumeSend_3 = function () {
  };
  Closed.prototype.tryResumeReceive_2 = function (value, otherOp) {
    var tmp0_also_0 = RESUME_TOKEN;
    var tmp0_safe_receiver_2 = otherOp;
    if (tmp0_safe_receiver_2 == null)
      null;
    else {
      tmp0_safe_receiver_2.finishPrepare__error();
      Unit_getInstance();
    }
    Unit_getInstance();
    return tmp0_also_0;
  };
  Closed.prototype.completeResumeReceive_2 = function (value) {
  };
  Closed.prototype.resumeSendClosed_3 = function (closed) {
    return Unit_getInstance();
  };
  Closed.prototype.toString = function () {
    return '' + 'Closed@' + _get_hexAddress_(this) + '[' + this._closeCause + ']';
  };
  Closed.$metadata$ = {
    simpleName: 'Closed',
    kind: 'class',
    interfaces: [ReceiveOrClosed]
  };
  function Receive() {
    LinkedListNode.call(this);
  }
  Receive.prototype._get_offerResult__2 = function () {
    return OFFER_SUCCESS;
  };
  Receive.$metadata$ = {
    simpleName: 'Receive',
    kind: 'class',
    interfaces: [ReceiveOrClosed]
  };
  function SendElement(pollResult, cont) {
    Send.call(this);
    this._pollResult = pollResult;
    this._cont_0 = cont;
  }
  SendElement.prototype._get_pollResult__3 = function () {
    return this._pollResult;
  };
  SendElement.prototype._get_cont__0 = function () {
    return this._cont_0;
  };
  SendElement.prototype.tryResumeSend_3 = function (otherOp) {
    var tmp0_safe_receiver = otherOp;
    var tmp1_elvis_lhs = this._cont_0.tryResume_3(Unit_getInstance(), tmp0_safe_receiver == null ? null : tmp0_safe_receiver.desc__error);
    var tmp;
    if (tmp1_elvis_lhs == null) {
      return null;
    } else {
      tmp = tmp1_elvis_lhs;
    }
    var token = tmp;
    var tmp2_safe_receiver = otherOp;
    if (tmp2_safe_receiver == null)
      null;
    else {
      tmp2_safe_receiver.finishPrepare__error();
      Unit_getInstance();
    }
    Unit_getInstance();
    return RESUME_TOKEN;
  };
  SendElement.prototype.completeResumeSend_3 = function () {
    return this._cont_0.completeResume_1(RESUME_TOKEN);
  };
  SendElement.prototype.resumeSendClosed_3 = function (closed) {
    var tmp0_resumeWithException_0 = this._cont_0;
    var tmp1_resumeWithException_0 = closed._get_sendException_();
    var tmp0_failure_0_1 = Companion_getInstance_3();
    return tmp0_resumeWithException_0.resumeWith_34(_Result___init__impl_(createFailure(tmp1_resumeWithException_0)));
  };
  SendElement.prototype.toString = function () {
    return '' + _get_classSimpleName_(this) + '@' + _get_hexAddress_(this) + '(' + this._get_pollResult__3() + ')';
  };
  SendElement.$metadata$ = {
    simpleName: 'SendElement',
    kind: 'class',
    interfaces: []
  };
  function SendElementWithUndeliveredHandler(pollResult, cont, onUndeliveredElement) {
    SendElement.call(this, pollResult, cont);
    this._onUndeliveredElement_0 = onUndeliveredElement;
  }
  SendElementWithUndeliveredHandler.prototype.remove_35 = function () {
    if (!SendElement.prototype.remove_35.call(this))
      return false;
    this.undeliveredElement_3();
    return true;
  };
  SendElementWithUndeliveredHandler.prototype.undeliveredElement_3 = function () {
    callUndeliveredElement(this._onUndeliveredElement_0, this._get_pollResult__3(), this._get_cont__0()._get_context__86());
  };
  SendElementWithUndeliveredHandler.$metadata$ = {
    simpleName: 'SendElementWithUndeliveredHandler',
    kind: 'class',
    interfaces: []
  };
  function updateBufferSize($this, currentSize) {
    if (currentSize < $this._capacity) {
      $this._size_3._value_10 = currentSize + 1 | 0;
      return null;
    }var tmp0_subject = $this._onBufferOverflow;
    var tmp;
    if (tmp0_subject.equals(BufferOverflow_SUSPEND_getInstance())) {
      tmp = OFFER_FAILED;
    } else if (tmp0_subject.equals(BufferOverflow_DROP_LATEST_getInstance())) {
      tmp = OFFER_SUCCESS;
    } else if (tmp0_subject.equals(BufferOverflow_DROP_OLDEST_getInstance())) {
      tmp = null;
    } else {
      noWhenBranchMatchedException();
    }
    return tmp;
  }
  function enqueueElement($this, currentSize, element) {
    if (currentSize < $this._capacity) {
      ensureCapacity($this, currentSize);
      $this._buffer_7[($this._head_0 + currentSize | 0) % $this._buffer_7.length] = element;
    } else {
      $this._buffer_7[$this._head_0 % $this._buffer_7.length] = null;
      $this._buffer_7[($this._head_0 + currentSize | 0) % $this._buffer_7.length] = element;
      $this._head_0 = ($this._head_0 + 1 | 0) % $this._buffer_7.length;
    }
  }
  function ensureCapacity($this, currentSize) {
    if (currentSize >= $this._buffer_7.length) {
      var tmp0_min_0 = imul($this._buffer_7.length, 2);
      var tmp1_min_0 = $this._capacity;
      var newSize = function () {
        var $externalVarargReceiverTmp = Math;
        return $externalVarargReceiverTmp.min.apply($externalVarargReceiverTmp, [].concat([].slice.call(new Int32Array([tmp0_min_0, tmp1_min_0]))));
      }.call(this);
      var newBuffer = fillArrayVal(Array(newSize), null);
      var inductionVariable = 0;
      if (inductionVariable < currentSize)
        do {
          var i = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          newBuffer[i] = $this._buffer_7[($this._head_0 + i | 0) % $this._buffer_7.length];
        }
         while (inductionVariable < currentSize);
      fill(newBuffer, EMPTY, currentSize, newSize);
      $this._buffer_7 = newBuffer;
      $this._head_0 = 0;
    }}
  function ArrayChannel(capacity, onBufferOverflow, onUndeliveredElement) {
    AbstractChannel.call(this, onUndeliveredElement);
    this._capacity = capacity;
    this._onBufferOverflow = onBufferOverflow;
    var tmp0_require_0 = this._capacity >= 1;
    if (!tmp0_require_0) {
      var message_1 = '' + 'ArrayChannel capacity must be at least 1, but ' + this._capacity + ' was specified';
      throw IllegalArgumentException_init_$Create$_0(toString_1(message_1));
    }this._lock = new NoOpLock();
    var tmp = this;
    var tmp0_min_0 = this._capacity;
    var tmp1_min_0 = 8;
    var tmp2_arrayOfNulls_0 = function () {
      var $externalVarargReceiverTmp = Math;
      return $externalVarargReceiverTmp.min.apply($externalVarargReceiverTmp, [].concat([].slice.call(new Int32Array([tmp0_min_0, tmp1_min_0]))));
    }.call(this);
    var tmp3_apply_0 = fillArrayVal(Array(tmp2_arrayOfNulls_0), null);
    fill$default(tmp3_apply_0, EMPTY, 0, 0, 6, null);
    tmp._buffer_7 = tmp3_apply_0;
    this._head_0 = 0;
    this._size_3 = atomic_1(0);
  }
  ArrayChannel.prototype._get_isBufferAlwaysEmpty__3 = function () {
    return false;
  };
  ArrayChannel.prototype._get_isBufferEmpty__3 = function () {
    return this._size_3._value_10 === 0;
  };
  ArrayChannel.prototype._get_isBufferAlwaysFull__4 = function () {
    return false;
  };
  ArrayChannel.prototype._get_isBufferFull__4 = function () {
    return this._size_3._value_10 === this._capacity ? this._onBufferOverflow.equals(BufferOverflow_SUSPEND_getInstance()) : false;
  };
  ArrayChannel.prototype._get_isClosedForReceive__3 = function () {
    var tmp0_withLock_0 = this._lock;
    return AbstractChannel.prototype._get_isClosedForReceive__3.call(this);
  };
  ArrayChannel.prototype.offerInternal_4 = function (element) {
    var receive = null;
    var tmp0_withLock_0 = this._lock;
    var tmp$ret$0;
    l$ret$1: do {
      var size_2 = this._size_3._value_10;
      var tmp0_safe_receiver_3 = this._get_closedForSend__4();
      if (tmp0_safe_receiver_3 == null)
        null;
      else {
        return tmp0_safe_receiver_3;
      }
      Unit_getInstance();
      var tmp1_safe_receiver_4 = updateBufferSize(this, size_2);
      if (tmp1_safe_receiver_4 == null)
        null;
      else {
        return tmp1_safe_receiver_4;
      }
      Unit_getInstance();
      if (size_2 === 0) {
        loop: while (true) {
          var tmp2_elvis_lhs_5 = this.takeFirstReceiveOrPeekClosed_4();
          var tmp;
          if (tmp2_elvis_lhs_5 == null) {
            break loop;
          } else {
            tmp = tmp2_elvis_lhs_5;
          }
          receive = tmp;
          if (receive instanceof Closed) {
            this._size_3._value_10 = size_2;
            return ensureNotNull(receive);
          } else {
          }
          var token_6 = ensureNotNull(receive).tryResumeReceive_2(element, null);
          if (!(token_6 == null)) {
            this._size_3._value_10 = size_2;
            tmp$ret$0 = Unit_getInstance();
            break l$ret$1;
          }}
      }enqueueElement(this, size_2, element);
      return OFFER_SUCCESS;
    }
     while (false);
    ensureNotNull(receive).completeResumeReceive_2(element);
    return ensureNotNull(receive)._get_offerResult__2();
  };
  ArrayChannel.prototype.enqueueSend_4 = function (send) {
    var tmp0_withLock_0 = this._lock;
    return AbstractChannel.prototype.enqueueSend_4.call(this, send);
  };
  ArrayChannel.prototype.pollInternal_3 = function () {
    var send = null;
    var resumed = false;
    var result = null;
    var tmp0_withLock_0 = this._lock;
    var size_2 = this._size_3._value_10;
    if (size_2 === 0) {
      var tmp0_elvis_lhs_3 = this._get_closedForSend__4();
      return tmp0_elvis_lhs_3 == null ? POLL_FAILED : tmp0_elvis_lhs_3;
    }result = this._buffer_7[this._head_0];
    this._buffer_7[this._head_0] = null;
    this._size_3._value_10 = size_2 - 1 | 0;
    var replacement_4 = POLL_FAILED;
    if (size_2 === this._capacity) {
      loop: while (true) {
        var tmp1_elvis_lhs_5 = this.takeFirstSendOrPeekClosed_4();
        var tmp;
        if (tmp1_elvis_lhs_5 == null) {
          break loop;
        } else {
          tmp = tmp1_elvis_lhs_5;
        }
        send = tmp;
        var token_6 = ensureNotNull(send).tryResumeSend_3(null);
        if (!(token_6 == null)) {
          resumed = true;
          replacement_4 = ensureNotNull(send)._get_pollResult__3();
          break loop;
        }ensureNotNull(send).undeliveredElement_3();
      }
    }var tmp_0;
    if (!(replacement_4 === POLL_FAILED)) {
      tmp_0 = !(replacement_4 instanceof Closed);
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      this._size_3._value_10 = size_2;
      this._buffer_7[(this._head_0 + size_2 | 0) % this._buffer_7.length] = replacement_4;
    } else {
    }
    this._head_0 = (this._head_0 + 1 | 0) % this._buffer_7.length;
    if (resumed)
      ensureNotNull(send).completeResumeSend_3();
    return result;
  };
  ArrayChannel.prototype.enqueueReceiveInternal_3 = function (receive) {
    var tmp0_withLock_0 = this._lock;
    return AbstractChannel.prototype.enqueueReceiveInternal_3.call(this, receive);
  };
  ArrayChannel.prototype.onCancelIdempotent_3 = function (wasClosed) {
    var onUndeliveredElement = this._get_onUndeliveredElement__4();
    var undeliveredElementException = null;
    var tmp0_withLock_0 = this._lock;
    var tmp0_repeat_0_2 = this._size_3._value_10;
    var inductionVariable = 0;
    if (inductionVariable < tmp0_repeat_0_2)
      do {
        var index_2_4 = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var value_4_5 = this._buffer_7[this._head_0];
        if (!(onUndeliveredElement == null) ? !(value_4_5 === EMPTY) : false) {
          undeliveredElementException = callUndeliveredElementCatchingException(onUndeliveredElement, (value_4_5 == null ? true : isObject(value_4_5)) ? value_4_5 : THROW_CCE(), undeliveredElementException);
        }this._buffer_7[this._head_0] = EMPTY;
        this._head_0 = (this._head_0 + 1 | 0) % this._buffer_7.length;
      }
       while (inductionVariable < tmp0_repeat_0_2);
    this._size_3._value_10 = 0;
    AbstractChannel.prototype.onCancelIdempotent_3.call(this, wasClosed);
    var tmp0_safe_receiver = undeliveredElementException;
    if (tmp0_safe_receiver == null)
      null;
    else {
      throw tmp0_safe_receiver;
    }
    Unit_getInstance();
  };
  ArrayChannel.prototype._get_bufferDebugString__4 = function () {
    return '' + '(buffer:capacity=' + this._capacity + ',size=' + this._size_3._value_10 + ')';
  };
  ArrayChannel.$metadata$ = {
    simpleName: 'ArrayChannel',
    kind: 'class',
    interfaces: []
  };
  var BufferOverflow_SUSPEND_instance;
  var BufferOverflow_DROP_OLDEST_instance;
  var BufferOverflow_DROP_LATEST_instance;
  var BufferOverflow_entriesInitialized;
  function BufferOverflow_initEntries() {
    if (BufferOverflow_entriesInitialized)
      return Unit_getInstance();
    BufferOverflow_entriesInitialized = true;
    BufferOverflow_SUSPEND_instance = new BufferOverflow('SUSPEND', 0);
    BufferOverflow_DROP_OLDEST_instance = new BufferOverflow('DROP_OLDEST', 1);
    BufferOverflow_DROP_LATEST_instance = new BufferOverflow('DROP_LATEST', 2);
  }
  function BufferOverflow(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  BufferOverflow.$metadata$ = {
    simpleName: 'BufferOverflow',
    kind: 'class',
    interfaces: []
  };
  function BufferOverflow_SUSPEND_getInstance() {
    BufferOverflow_initEntries();
    return BufferOverflow_SUSPEND_instance;
  }
  function BufferOverflow_DROP_OLDEST_getInstance() {
    BufferOverflow_initEntries();
    return BufferOverflow_DROP_OLDEST_instance;
  }
  function BufferOverflow_DROP_LATEST_getInstance() {
    BufferOverflow_initEntries();
    return BufferOverflow_DROP_LATEST_instance;
  }
  function Factory() {
    Factory_instance = this;
    this._UNLIMITED = 2147483647;
    this._RENDEZVOUS = 0;
    this._CONFLATED = -1;
    this._BUFFERED = -2;
    this._OPTIONAL_CHANNEL = -3;
    this._DEFAULT_BUFFER_PROPERTY_NAME = 'kotlinx.coroutines.channels.defaultBuffer';
    this._CHANNEL_DEFAULT_CAPACITY = systemProp('kotlinx.coroutines.channels.defaultBuffer', 64, 1, 2147483646);
  }
  Factory.$metadata$ = {
    simpleName: 'Factory',
    kind: 'object',
    interfaces: []
  };
  var Factory_instance;
  function Factory_getInstance() {
    if (Factory_instance == null)
      new Factory();
    return Factory_instance;
  }
  function Channel() {
  }
  Channel.$metadata$ = {
    simpleName: 'Channel',
    kind: 'interface',
    interfaces: [SendChannel, ReceiveChannel]
  };
  function Channel_0(capacity, onBufferOverflow, onUndeliveredElement) {
    var tmp0_subject = capacity;
    var tmp;
    switch (tmp0_subject) {
      case 0:
        tmp = onBufferOverflow.equals(BufferOverflow_SUSPEND_getInstance()) ? new RendezvousChannel(onUndeliveredElement) : new ArrayChannel(1, onBufferOverflow, onUndeliveredElement);
        break;
      case -1:
        var tmp0_require_0 = onBufferOverflow.equals(BufferOverflow_SUSPEND_getInstance());
        if (!tmp0_require_0) {
          var message_1 = 'CONFLATED capacity cannot be used with non-default onBufferOverflow';
          throw IllegalArgumentException_init_$Create$_0(toString_1(message_1));
        }
        tmp = new ConflatedChannel(onUndeliveredElement);
        break;
      case 2147483647:
        tmp = new LinkedListChannel(onUndeliveredElement);
        break;
      case -2:
        tmp = new ArrayChannel(onBufferOverflow.equals(BufferOverflow_SUSPEND_getInstance()) ? Factory_getInstance()._CHANNEL_DEFAULT_CAPACITY : 1, onBufferOverflow, onUndeliveredElement);
        break;
      default:tmp = (capacity === 1 ? onBufferOverflow.equals(BufferOverflow_DROP_OLDEST_getInstance()) : false) ? new ConflatedChannel(onUndeliveredElement) : new ArrayChannel(capacity, onBufferOverflow, onUndeliveredElement);
        break;
    }
    return tmp;
  }
  function Channel$default(capacity, onBufferOverflow, onUndeliveredElement, $mask0, $handler) {
    if (!(($mask0 & 1) === 0))
      capacity = 0;
    if (!(($mask0 & 2) === 0))
      onBufferOverflow = BufferOverflow_SUSPEND_getInstance();
    if (!(($mask0 & 4) === 0))
      onUndeliveredElement = null;
    return Channel_0(capacity, onBufferOverflow, onUndeliveredElement);
  }
  function ReceiveChannel() {
  }
  ReceiveChannel.prototype.cancel$default_15 = function (cause, $mask0, $handler) {
    if (!(($mask0 & 1) === 0))
      cause = null;
    return $handler == null ? this.cancel_20(cause) : $handler(cause);
  };
  ReceiveChannel.$metadata$ = {
    simpleName: 'ReceiveChannel',
    kind: 'interface',
    interfaces: []
  };
  function SendChannel() {
  }
  SendChannel.prototype.close$default_5 = function (cause, $mask0, $handler) {
    if (!(($mask0 & 1) === 0))
      cause = null;
    return $handler == null ? this.close_27(cause) : $handler(cause);
  };
  SendChannel.$metadata$ = {
    simpleName: 'SendChannel',
    kind: 'interface',
    interfaces: []
  };
  function ChannelIterator() {
  }
  ChannelIterator.$metadata$ = {
    simpleName: 'ChannelIterator',
    kind: 'interface',
    interfaces: []
  };
  function ClosedReceiveChannelException(message) {
    NoSuchElementException_init_$Init$_0(message, this);
    captureStack(this, ClosedReceiveChannelException);
  }
  ClosedReceiveChannelException.$metadata$ = {
    simpleName: 'ClosedReceiveChannelException',
    kind: 'class',
    interfaces: []
  };
  function ClosedSendChannelException(message) {
    IllegalStateException_init_$Init$_0(message, this);
    captureStack(this, ClosedSendChannelException);
  }
  ClosedSendChannelException.$metadata$ = {
    simpleName: 'ClosedSendChannelException',
    kind: 'class',
    interfaces: []
  };
  function cancelConsumed(_this_, cause) {
    var tmp0_safe_receiver = cause;
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      var tmp0_elvis_lhs_2 = tmp0_safe_receiver instanceof CancellationException ? tmp0_safe_receiver : null;
      tmp = tmp0_elvis_lhs_2 == null ? new CancellationException('Channel was consumed, consumer had failed', tmp0_safe_receiver) : tmp0_elvis_lhs_2;
    }
    _this_.cancel_20(tmp);
  }
  function updateValueLocked($this, element) {
    var old = $this._value_11;
    var tmp;
    if (old === EMPTY) {
      tmp = null;
    } else {
      var tmp0_safe_receiver = $this._get_onUndeliveredElement__4();
      var tmp_0;
      if (tmp0_safe_receiver == null) {
        tmp_0 = null;
      } else {
        var tmp_1 = (old == null ? true : isObject(old)) ? old : THROW_CCE();
        tmp_0 = callUndeliveredElementCatchingException$default(tmp0_safe_receiver, tmp_1, null, 2, null);
      }
      tmp = tmp_0;
    }
    var undeliveredElementException = tmp;
    $this._value_11 = element;
    return undeliveredElementException;
  }
  function ConflatedChannel(onUndeliveredElement) {
    AbstractChannel.call(this, onUndeliveredElement);
    this._lock_0 = new NoOpLock();
    this._value_11 = EMPTY;
  }
  ConflatedChannel.prototype._get_isBufferAlwaysEmpty__3 = function () {
    return false;
  };
  ConflatedChannel.prototype._get_isBufferEmpty__3 = function () {
    return this._value_11 === EMPTY;
  };
  ConflatedChannel.prototype._get_isBufferAlwaysFull__4 = function () {
    return false;
  };
  ConflatedChannel.prototype._get_isBufferFull__4 = function () {
    return false;
  };
  ConflatedChannel.prototype.offerInternal_4 = function (element) {
    var receive = null;
    var tmp0_withLock_0 = this._lock_0;
    var tmp$ret$0;
    l$ret$1: do {
      var tmp0_safe_receiver_2 = this._get_closedForSend__4();
      if (tmp0_safe_receiver_2 == null)
        null;
      else {
        return tmp0_safe_receiver_2;
      }
      Unit_getInstance();
      if (this._value_11 === EMPTY) {
        loop: while (true) {
          var tmp1_elvis_lhs_3 = this.takeFirstReceiveOrPeekClosed_4();
          var tmp;
          if (tmp1_elvis_lhs_3 == null) {
            break loop;
          } else {
            tmp = tmp1_elvis_lhs_3;
          }
          receive = tmp;
          if (receive instanceof Closed) {
            return ensureNotNull(receive);
          } else {
          }
          var token_4 = ensureNotNull(receive).tryResumeReceive_2(element, null);
          if (!(token_4 == null)) {
            tmp$ret$0 = Unit_getInstance();
            break l$ret$1;
          }}
      }var tmp2_safe_receiver_5 = updateValueLocked(this, element);
      if (tmp2_safe_receiver_5 == null)
        null;
      else {
        throw tmp2_safe_receiver_5;
      }
      Unit_getInstance();
      return OFFER_SUCCESS;
    }
     while (false);
    ensureNotNull(receive).completeResumeReceive_2(element);
    return ensureNotNull(receive)._get_offerResult__2();
  };
  ConflatedChannel.prototype.pollInternal_3 = function () {
    var result = null;
    var tmp0_withLock_0 = this._lock_0;
    if (this._value_11 === EMPTY) {
      var tmp0_elvis_lhs_2 = this._get_closedForSend__4();
      return tmp0_elvis_lhs_2 == null ? POLL_FAILED : tmp0_elvis_lhs_2;
    }result = this._value_11;
    this._value_11 = EMPTY;
    return result;
  };
  ConflatedChannel.prototype.onCancelIdempotent_3 = function (wasClosed) {
    var undeliveredElementException = null;
    var tmp0_withLock_0 = this._lock_0;
    undeliveredElementException = updateValueLocked(this, EMPTY);
    AbstractChannel.prototype.onCancelIdempotent_3.call(this, wasClosed);
    var tmp0_safe_receiver = undeliveredElementException;
    if (tmp0_safe_receiver == null)
      null;
    else {
      throw tmp0_safe_receiver;
    }
    Unit_getInstance();
  };
  ConflatedChannel.prototype.enqueueReceiveInternal_3 = function (receive) {
    var tmp0_withLock_0 = this._lock_0;
    return AbstractChannel.prototype.enqueueReceiveInternal_3.call(this, receive);
  };
  ConflatedChannel.prototype._get_bufferDebugString__4 = function () {
    return '' + '(value=' + this._value_11 + ')';
  };
  ConflatedChannel.$metadata$ = {
    simpleName: 'ConflatedChannel',
    kind: 'class',
    interfaces: []
  };
  function LinkedListChannel(onUndeliveredElement) {
    AbstractChannel.call(this, onUndeliveredElement);
  }
  LinkedListChannel.prototype._get_isBufferAlwaysEmpty__3 = function () {
    return true;
  };
  LinkedListChannel.prototype._get_isBufferEmpty__3 = function () {
    return true;
  };
  LinkedListChannel.prototype._get_isBufferAlwaysFull__4 = function () {
    return false;
  };
  LinkedListChannel.prototype._get_isBufferFull__4 = function () {
    return false;
  };
  LinkedListChannel.prototype.offerInternal_4 = function (element) {
    while (true) {
      var result = AbstractChannel.prototype.offerInternal_4.call(this, element);
      if (result === OFFER_SUCCESS)
        return OFFER_SUCCESS;
      else {
        if (result === OFFER_FAILED) {
          var sendResult = this.sendBuffered_0(element);
          if (sendResult == null)
            return OFFER_SUCCESS;
          else {
            if (sendResult instanceof Closed)
              return sendResult;
            else {
            }
          }
        } else {
          if (result instanceof Closed)
            return result;
          else {
            {
              var tmp0_error_0 = '' + 'Invalid offerInternal result ' + result;
              throw IllegalStateException_init_$Create$(toString_1(tmp0_error_0));
            }
          }
        }
      }
    }
  };
  LinkedListChannel.$metadata$ = {
    simpleName: 'LinkedListChannel',
    kind: 'class',
    interfaces: []
  };
  function RendezvousChannel(onUndeliveredElement) {
    AbstractChannel.call(this, onUndeliveredElement);
  }
  RendezvousChannel.prototype._get_isBufferAlwaysEmpty__3 = function () {
    return true;
  };
  RendezvousChannel.prototype._get_isBufferEmpty__3 = function () {
    return true;
  };
  RendezvousChannel.prototype._get_isBufferAlwaysFull__4 = function () {
    return true;
  };
  RendezvousChannel.prototype._get_isBufferFull__4 = function () {
    return true;
  };
  RendezvousChannel.$metadata$ = {
    simpleName: 'RendezvousChannel',
    kind: 'class',
    interfaces: []
  };
  function ensureCapacity_0($this) {
    var currentSize = $this._elements.length;
    var newCapacity = currentSize << 1;
    var newElements = fillArrayVal(Array(newCapacity), null);
    var tmp0_copyInto_0 = $this._elements;
    var tmp1_copyInto_0 = $this._head_1;
    var tmp2_copyInto_0 = 0;
    var tmp3_copyInto_0 = tmp0_copyInto_0.length;
    arrayCopy_0(tmp0_copyInto_0, newElements, tmp2_copyInto_0, tmp1_copyInto_0, tmp3_copyInto_0);
    Unit_getInstance();
    var tmp4_copyInto_0 = $this._elements;
    var tmp5_copyInto_0 = $this._elements.length - $this._head_1 | 0;
    var tmp6_copyInto_0 = $this._head_1;
    var tmp7_copyInto_0 = 0;
    arrayCopy_0(tmp4_copyInto_0, newElements, tmp5_copyInto_0, tmp7_copyInto_0, tmp6_copyInto_0);
    Unit_getInstance();
    $this._elements = newElements;
    $this._head_1 = 0;
    $this._tail = currentSize;
  }
  function ArrayQueue() {
    var tmp = this;
    var tmp0_arrayOfNulls_0 = 16;
    tmp._elements = fillArrayVal(Array(tmp0_arrayOfNulls_0), null);
    this._head_1 = 0;
    this._tail = 0;
  }
  ArrayQueue.prototype._get_isEmpty__4 = function () {
    return this._head_1 === this._tail;
  };
  ArrayQueue.prototype.addLast_16 = function (element) {
    this._elements[this._tail] = element;
    this._tail = (this._tail + 1 | 0) & (this._elements.length - 1 | 0);
    if (this._tail === this._head_1)
      ensureCapacity_0(this);
  };
  ArrayQueue.prototype.removeFirstOrNull_2 = function () {
    if (this._head_1 === this._tail)
      return null;
    var element = this._elements[this._head_1];
    this._elements[this._head_1] = null;
    this._head_1 = (this._head_1 + 1 | 0) & (this._elements.length - 1 | 0);
    return isObject(element) ? element : THROW_CCE();
  };
  ArrayQueue.$metadata$ = {
    simpleName: 'ArrayQueue',
    kind: 'class',
    interfaces: []
  };
  function OpDescriptor() {
  }
  OpDescriptor.$metadata$ = {
    simpleName: 'OpDescriptor',
    kind: 'class',
    interfaces: []
  };
  var UNDEFINED;
  var REUSABLE_CLAIMED;
  function DispatchedContinuation(dispatcher, continuation) {
    DispatchedTask.call(this, -1);
    this._dispatcher = dispatcher;
    this._continuation_3 = continuation;
    this.__state_1 = UNDEFINED;
    var tmp = this;
    var tmp_0 = this._continuation_3;
    tmp._callerFrame = isInterface(tmp_0, CoroutineStackFrame) ? tmp_0 : null;
    this._countOrElement = threadContextElements(this._get_context__86());
    this.__reusableCancellableContinuation = atomic(null);
  }
  DispatchedContinuation.prototype._get_context__86 = function () {
    return this._continuation_3._get_context__86();
  };
  DispatchedContinuation.prototype._get_reusableCancellableContinuation_ = function () {
    var tmp = this.__reusableCancellableContinuation._value_8;
    return tmp instanceof CancellableContinuationImpl ? tmp : null;
  };
  DispatchedContinuation.prototype.isReusable = function (requester) {
    var tmp0_elvis_lhs = this.__reusableCancellableContinuation._value_8;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return false;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var value = tmp;
    if (value instanceof CancellableContinuationImpl)
      return value === requester;
    else {
    }
    return true;
  };
  DispatchedContinuation.prototype.claimReusableCancellableContinuation = function () {
    var tmp0_loop_0 = this.__reusableCancellableContinuation;
    while (true) {
      var tmp1__anonymous__1 = tmp0_loop_0._value_8;
      if (tmp1__anonymous__1 === null) {
        this.__reusableCancellableContinuation._value_8 = REUSABLE_CLAIMED;
        return null;
      } else {
        if (tmp1__anonymous__1 instanceof CancellableContinuationImpl) {
          if (this.__reusableCancellableContinuation.compareAndSet$atomicfu(tmp1__anonymous__1, REUSABLE_CLAIMED)) {
            return tmp1__anonymous__1 instanceof CancellableContinuationImpl ? tmp1__anonymous__1 : THROW_CCE();
          }} else {
          {
            var tmp0_error_0_2 = '' + 'Inconsistent state ' + tmp1__anonymous__1;
            throw IllegalStateException_init_$Create$(toString_1(tmp0_error_0_2));
          }
        }
      }
    }
    Unit_getInstance();
  };
  DispatchedContinuation.prototype.checkPostponedCancellation = function (continuation) {
    var tmp0_loop_0 = this.__reusableCancellableContinuation;
    while (true) {
      var tmp1__anonymous__1 = tmp0_loop_0._value_8;
      if (tmp1__anonymous__1 === REUSABLE_CLAIMED) {
        if (this.__reusableCancellableContinuation.compareAndSet$atomicfu(REUSABLE_CLAIMED, continuation))
          return null;
      } else {
        if (tmp1__anonymous__1 === null)
          return null;
        else {
          if (tmp1__anonymous__1 instanceof Error) {
            var tmp0_require_0_2 = this.__reusableCancellableContinuation.compareAndSet$atomicfu(tmp1__anonymous__1, null);
            if (!tmp0_require_0_2) {
              var message_1_1_3 = 'Failed requirement.';
              throw IllegalArgumentException_init_$Create$_0(toString_1(message_1_1_3));
            }return tmp1__anonymous__1;
          } else {
            {
              var tmp1_error_0_4 = '' + 'Inconsistent state ' + tmp1__anonymous__1;
              throw IllegalStateException_init_$Create$(toString_1(tmp1_error_0_4));
            }
          }
        }
      }
    }
    Unit_getInstance();
  };
  DispatchedContinuation.prototype.postponeCancellation = function (cause) {
    var tmp0_loop_0 = this.__reusableCancellableContinuation;
    while (true) {
      var tmp1__anonymous__1 = tmp0_loop_0._value_8;
      var tmp0_subject_2 = tmp1__anonymous__1;
      if (equals_1(tmp0_subject_2, REUSABLE_CLAIMED)) {
        if (this.__reusableCancellableContinuation.compareAndSet$atomicfu(REUSABLE_CLAIMED, cause))
          return true;
      } else {
        if (tmp0_subject_2 instanceof Error)
          return true;
        else {
          {
            if (this.__reusableCancellableContinuation.compareAndSet$atomicfu(tmp1__anonymous__1, null))
              return false;
          }
        }
      }
    }
    Unit_getInstance();
  };
  DispatchedContinuation.prototype.takeState_2 = function () {
    var state = this.__state_1;
    this.__state_1 = UNDEFINED;
    return state;
  };
  DispatchedContinuation.prototype._get_delegate__2 = function () {
    return this;
  };
  DispatchedContinuation.prototype.resumeWith_34 = function (result) {
    var context = this._continuation_3._get_context__86();
    var state = toState$default(result, null, 1, null);
    if (this._dispatcher.isDispatchNeeded_8(context)) {
      this.__state_1 = state;
      this._set_resumeMode__0(0);
      this._dispatcher.dispatch_8(context, this);
    } else {
      var tmp$ret$0;
      l$ret$1: do {
        var tmp0_executeUnconfined_0 = 0;
        var tmp1_executeUnconfined_0 = false;
        var eventLoop_2 = ThreadLocalEventLoop_getInstance()._get_eventLoop_();
        if (tmp1_executeUnconfined_0 ? eventLoop_2._get_isUnconfinedQueueEmpty__0() : false) {
          tmp$ret$0 = false;
          break l$ret$1;
        }var tmp;
        if (eventLoop_2._get_isUnconfinedLoopActive__0()) {
          this.__state_1 = state;
          this._set_resumeMode__0(tmp0_executeUnconfined_0);
          eventLoop_2.dispatchUnconfined_0(this);
          tmp = true;
        } else {
          eventLoop_2.incrementUseCount_0(true);
          try {
            var tmp0_withCoroutineContext_0_4 = this._get_context__86();
            var tmp1_withCoroutineContext_0_5 = this._countOrElement;
            this._continuation_3.resumeWith_34(result);
            $l$break: while (true) {
              if (!eventLoop_2.processUnconfinedEvent_0())
                break $l$break;
            }
          } catch ($p) {
            if ($p instanceof Error) {
              this.handleFatalException_2($p, null);
            } else {
              {
                throw $p;
              }
            }
          }
          finally {
            eventLoop_2.decrementUseCount_0(true);
          }
          tmp = false;
        }
        tmp$ret$0 = tmp;
      }
       while (false);
      Unit_getInstance();
    }
  };
  DispatchedContinuation.prototype.cancelCompletedResult_2 = function (takenState, cause) {
    if (takenState instanceof CompletedWithCancellation) {
      takenState._onCancellation_0(cause);
    } else {
    }
  };
  DispatchedContinuation.prototype.toString = function () {
    return '' + 'DispatchedContinuation[' + this._dispatcher + ', ' + toDebugString(this._continuation_3) + ']';
  };
  DispatchedContinuation.$metadata$ = {
    simpleName: 'DispatchedContinuation',
    kind: 'class',
    interfaces: [CoroutineStackFrame, Continuation]
  };
  function resumeCancellableWith(_this_, result, onCancellation) {
    var tmp0_subject = _this_;
    var tmp;
    if (tmp0_subject instanceof DispatchedContinuation) {
      var tmp0_resumeCancellableWith_0 = _this_;
      var state_1 = toState_0(result, onCancellation);
      var tmp_0;
      if (tmp0_resumeCancellableWith_0._dispatcher.isDispatchNeeded_8(tmp0_resumeCancellableWith_0._get_context__86())) {
        tmp0_resumeCancellableWith_0.__state_1 = state_1;
        tmp0_resumeCancellableWith_0._set_resumeMode__0(1);
        tmp_0 = tmp0_resumeCancellableWith_0._dispatcher.dispatch_8(tmp0_resumeCancellableWith_0._get_context__86(), tmp0_resumeCancellableWith_0);
      } else {
        var tmp$ret$0;
        l$ret$1: do {
          var tmp0_executeUnconfined_0_2 = 1;
          var tmp1_executeUnconfined_0_3 = false;
          var eventLoop_2_4 = ThreadLocalEventLoop_getInstance()._get_eventLoop_();
          if (tmp1_executeUnconfined_0_3 ? eventLoop_2_4._get_isUnconfinedQueueEmpty__0() : false) {
            tmp$ret$0 = false;
            break l$ret$1;
          }var tmp_1;
          if (eventLoop_2_4._get_isUnconfinedLoopActive__0()) {
            tmp0_resumeCancellableWith_0.__state_1 = state_1;
            tmp0_resumeCancellableWith_0._set_resumeMode__0(tmp0_executeUnconfined_0_2);
            eventLoop_2_4.dispatchUnconfined_0(tmp0_resumeCancellableWith_0);
            tmp_1 = true;
          } else {
            eventLoop_2_4.incrementUseCount_0(true);
            try {
              var tmp$ret$2;
              l$ret$3: do {
                var job_1_4_5 = tmp0_resumeCancellableWith_0._get_context__86().get_70(Key_getInstance_3());
                if (!(job_1_4_5 == null) ? !job_1_4_5._get_isActive__23() : false) {
                  var cause_2_5_6 = job_1_4_5.getCancellationException_9();
                  tmp0_resumeCancellableWith_0.cancelCompletedResult_2(state_1, cause_2_5_6);
                  var tmp0_failure_0_1_6_7 = Companion_getInstance_3();
                  tmp0_resumeCancellableWith_0.resumeWith_34(_Result___init__impl_(createFailure(cause_2_5_6)));
                  tmp$ret$2 = true;
                  break l$ret$3;
                }tmp$ret$2 = false;
              }
               while (false);
              if (!tmp$ret$2) {
                var tmp0_withCoroutineContext_0_7_8 = tmp0_resumeCancellableWith_0._get_context__86();
                var tmp1_withCoroutineContext_0_8_9 = tmp0_resumeCancellableWith_0._countOrElement;
                tmp0_resumeCancellableWith_0._continuation_3.resumeWith_34(result);
              } else {
              }
              $l$break: while (true) {
                if (!eventLoop_2_4.processUnconfinedEvent_0())
                  break $l$break;
              }
            } catch ($p) {
              if ($p instanceof Error) {
                tmp0_resumeCancellableWith_0.handleFatalException_2($p, null);
              } else {
                {
                  throw $p;
                }
              }
            }
            finally {
              eventLoop_2_4.decrementUseCount_0(true);
            }
            tmp_1 = false;
          }
          tmp$ret$0 = tmp_1;
        }
         while (false);
        tmp_0 = Unit_getInstance();
      }
      tmp = tmp_0;
    } else {
      {
        tmp = _this_.resumeWith_34(result);
      }
    }
    return tmp;
  }
  function resumeCancellableWith$default(_this_, result, onCancellation, $mask0, $handler) {
    if (!(($mask0 & 2) === 0))
      onCancellation = null;
    return resumeCancellableWith(_this_, result, onCancellation);
  }
  function DispatchedTask(resumeMode) {
    SchedulerTask.call(this);
    this._resumeMode = resumeMode;
  }
  DispatchedTask.prototype._set_resumeMode__0 = function (_set___) {
    this._resumeMode = _set___;
  };
  DispatchedTask.prototype._get_resumeMode__1 = function () {
    return this._resumeMode;
  };
  DispatchedTask.prototype.cancelCompletedResult_2 = function (takenState, cause) {
  };
  DispatchedTask.prototype.getSuccessfulResult_2 = function (state) {
    return (state == null ? true : isObject(state)) ? state : THROW_CCE();
  };
  DispatchedTask.prototype.getExceptionalResult_2 = function (state) {
    var tmp0_safe_receiver = state instanceof CompletedExceptionally ? state : null;
    return tmp0_safe_receiver == null ? null : tmp0_safe_receiver._cause;
  };
  DispatchedTask.prototype.run_4 = function () {
    var taskContext = _get_taskContext_(this);
    var fatalException = null;
    try {
      var tmp = this._get_delegate__2();
      var delegate = tmp instanceof DispatchedContinuation ? tmp : THROW_CCE();
      var continuation = delegate._continuation_3;
      var context = continuation._get_context__86();
      var state = this.takeState_2();
      var tmp0_withCoroutineContext_0 = delegate._countOrElement;
      var exception_2 = this.getExceptionalResult_2(state);
      var job_3 = (exception_2 == null ? _get_isCancellableMode_(this._resumeMode) : false) ? context.get_70(Key_getInstance_3()) : null;
      if (!(job_3 == null) ? !job_3._get_isActive__23() : false) {
        var cause_4 = job_3.getCancellationException_9();
        this.cancelCompletedResult_2(state, cause_4);
        var tmp0_failure_0_5 = Companion_getInstance_3();
        var tmp1_failure_0_6 = recoverStackTrace(cause_4, continuation);
        continuation.resumeWith_34(_Result___init__impl_(createFailure(tmp1_failure_0_6)));
      } else {
        if (!(exception_2 == null)) {
          var tmp0_failure_0_1_7 = Companion_getInstance_3();
          continuation.resumeWith_34(_Result___init__impl_(createFailure(exception_2)));
        } else {
          var tmp2_resume_0_8 = this.getSuccessfulResult_2(state);
          var tmp0_success_0_1_9 = Companion_getInstance_3();
          continuation.resumeWith_34(_Result___init__impl_(tmp2_resume_0_8));
        }
      }
    } catch ($p) {
      if ($p instanceof Error) {
        fatalException = $p;
      } else {
        {
          throw $p;
        }
      }
    }
    finally {
      var tmp_0;
      try {
        var tmp0_success_0_1 = Companion_getInstance_3();
        var tmp1_success_0_2 = Unit_getInstance();
        tmp_0 = _Result___init__impl_(Unit_getInstance());
      } catch ($p_0) {
        var tmp_1;
        if ($p_0 instanceof Error) {
          var tmp2_failure_0_4 = Companion_getInstance_3();
          tmp_1 = _Result___init__impl_(createFailure($p_0));
        } else {
          {
            throw $p_0;
          }
        }
        tmp_0 = tmp_1;
      }
      var result = tmp_0;
      this.handleFatalException_2(fatalException, Result__exceptionOrNull_impl(result));
    }
  };
  DispatchedTask.prototype.handleFatalException_2 = function (exception, finallyException) {
    if (exception === null ? finallyException === null : false)
      return Unit_getInstance();
    if (!(exception === null) ? !(finallyException === null) : false) {
    }var tmp0_elvis_lhs = exception;
    var cause = tmp0_elvis_lhs == null ? finallyException : tmp0_elvis_lhs;
    var reason = new CoroutinesInternalError('' + 'Fatal exception in coroutines machinery for ' + this + '. ' + "Please read KDoc to 'handleFatalException' method and report this incident to maintainers", ensureNotNull(cause));
    handleCoroutineException(this._get_delegate__2()._get_context__86(), reason);
  };
  DispatchedTask.$metadata$ = {
    simpleName: 'DispatchedTask',
    kind: 'class',
    interfaces: []
  };
  function _get_isCancellableMode_(_this_) {
    return _this_ === 1 ? true : _this_ === 2;
  }
  function _get_isReusableMode_(_this_) {
    return _this_ === 2;
  }
  function dispatch(_this_, mode) {
    var delegate = _this_._get_delegate__2();
    var undispatched = mode === 4;
    var tmp;
    var tmp_0;
    if (!undispatched) {
      tmp_0 = delegate instanceof DispatchedContinuation;
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = _get_isCancellableMode_(mode) === _get_isCancellableMode_(_this_._resumeMode);
    } else {
      {
        tmp = false;
      }
    }
    if (tmp) {
      var dispatcher = delegate._dispatcher;
      var context = delegate._get_context__86();
      if (dispatcher.isDispatchNeeded_8(context)) {
        dispatcher.dispatch_8(context, _this_);
      } else {
        resumeUnconfined(_this_);
      }
    } else {
      {
        resume(_this_, delegate, undispatched);
      }
    }
  }
  function resumeUnconfined(_this_) {
    var eventLoop = ThreadLocalEventLoop_getInstance()._get_eventLoop_();
    if (eventLoop._get_isUnconfinedLoopActive__0()) {
      eventLoop.dispatchUnconfined_0(_this_);
    } else {
      eventLoop.incrementUseCount_0(true);
      try {
        resume(_this_, _this_._get_delegate__2(), true);
        $l$break: while (true) {
          if (!eventLoop.processUnconfinedEvent_0())
            break $l$break;
        }
      } catch ($p) {
        if ($p instanceof Error) {
          _this_.handleFatalException_2($p, null);
        } else {
          {
            throw $p;
          }
        }
      }
      finally {
        eventLoop.decrementUseCount_0(true);
      }
    }
  }
  function resume(_this_, delegate, undispatched) {
    var state = _this_.takeState_2();
    var exception = _this_.getExceptionalResult_2(state);
    var tmp;
    if (!(exception == null)) {
      var tmp0_failure_0 = Companion_getInstance_3();
      tmp = _Result___init__impl_(createFailure(exception));
    } else {
      var tmp1_success_0 = Companion_getInstance_3();
      var tmp2_success_0 = _this_.getSuccessfulResult_2(state);
      tmp = _Result___init__impl_(tmp2_success_0);
    }
    var result = tmp;
    if (undispatched) {
      var tmp3_resumeUndispatchedWith_0 = delegate instanceof DispatchedContinuation ? delegate : THROW_CCE();
      var tmp0_withCoroutineContext_0_1 = tmp3_resumeUndispatchedWith_0._get_context__86();
      var tmp1_withCoroutineContext_0_2 = tmp3_resumeUndispatchedWith_0._countOrElement;
      tmp3_resumeUndispatchedWith_0._continuation_3.resumeWith_34(result);
    } else
      delegate.resumeWith_34(result);
  }
  function _InlineList___init__impl_(holder) {
    return holder;
  }
  function _InlineList___init__impl__0(holder, $mask0, $marker) {
    if (!(($mask0 & 1) === 0))
      holder = null;
    var tmp = _InlineList___init__impl_(holder);
    return tmp;
  }
  function _get_holder_($this) {
    return $this;
  }
  function InlineList__plus_impl(this_0, element) {
    var tmp0_subject = _get_holder_(this_0);
    var tmp;
    if (tmp0_subject == null) {
      tmp = _InlineList___init__impl_(element);
    } else {
      if (tmp0_subject instanceof ArrayList) {
        var tmp_0 = _get_holder_(this_0);
        (tmp_0 instanceof ArrayList ? tmp_0 : THROW_CCE()).add_33(element);
        Unit_getInstance();
        tmp = _InlineList___init__impl_(_get_holder_(this_0));
      } else {
        {
          var list = ArrayList_init_$Create$_0(4);
          var tmp_1 = _get_holder_(this_0);
          list.add_33((tmp_1 == null ? true : isObject(tmp_1)) ? tmp_1 : THROW_CCE());
          Unit_getInstance();
          list.add_33(element);
          Unit_getInstance();
          tmp = _InlineList___init__impl_(list);
        }
      }
    }
    return tmp;
  }
  function bindCancellationFun(_this_, element, context) {
    return _no_name_provided_$factory_58(_this_, element, context);
  }
  function UndeliveredElementException(message, cause) {
    RuntimeException_init_$Init$_1(message, cause, this);
    captureStack(this, UndeliveredElementException);
  }
  UndeliveredElementException.$metadata$ = {
    simpleName: 'UndeliveredElementException',
    kind: 'class',
    interfaces: []
  };
  function callUndeliveredElementCatchingException(_this_, element, undeliveredElementException) {
    try {
      _this_(element);
    } catch ($p) {
      if ($p instanceof Error) {
        if (!(undeliveredElementException == null) ? !(undeliveredElementException.cause === $p) : false) {
        } else {
          return new UndeliveredElementException('' + 'Exception in undelivered element handler for ' + element, $p);
        }
      } else {
        {
          throw $p;
        }
      }
    }
    return undeliveredElementException;
  }
  function callUndeliveredElementCatchingException$default(_this_, element, undeliveredElementException, $mask0, $handler) {
    if (!(($mask0 & 2) === 0))
      undeliveredElementException = null;
    return callUndeliveredElementCatchingException(_this_, element, undeliveredElementException);
  }
  function callUndeliveredElement(_this_, element, context) {
    var tmp0_safe_receiver = callUndeliveredElementCatchingException(_this_, element, null);
    if (tmp0_safe_receiver == null)
      null;
    else {
      handleCoroutineException(context, tmp0_safe_receiver);
      Unit_getInstance();
    }
    Unit_getInstance();
  }
  function _no_name_provided__79($this_bindCancellationFun, $element, $context) {
    this._$this_bindCancellationFun = $this_bindCancellationFun;
    this._$element = $element;
    this._$context = $context;
  }
  _no_name_provided__79.prototype.invoke_354 = function (_anonymous_parameter_0_) {
    callUndeliveredElement(this._$this_bindCancellationFun, this._$element, this._$context);
  };
  _no_name_provided__79.prototype.invoke_542 = function (p1) {
    this.invoke_354(p1 instanceof Error ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__79.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided_$factory_58($this_bindCancellationFun, $element, $context) {
    var i = new _no_name_provided__79($this_bindCancellationFun, $element, $context);
    return function (p1) {
      i.invoke_354(p1);
      return Unit_getInstance();
    };
  }
  function ContextScope(context) {
    this._coroutineContext = context;
  }
  ContextScope.prototype._get_coroutineContext__22 = function () {
    return this._coroutineContext;
  };
  ContextScope.prototype.toString = function () {
    return '' + 'CoroutineScope(coroutineContext=' + this._coroutineContext + ')';
  };
  ContextScope.$metadata$ = {
    simpleName: 'ContextScope',
    kind: 'class',
    interfaces: [CoroutineScope]
  };
  function Symbol(symbol) {
    this._symbol = symbol;
  }
  Symbol.prototype.toString = function () {
    return this._symbol;
  };
  Symbol.$metadata$ = {
    simpleName: 'Symbol',
    kind: 'class',
    interfaces: []
  };
  function systemProp(propertyName, defaultValue, minValue, maxValue) {
    return systemProp_0(propertyName, toLong_0(defaultValue), toLong_0(minValue), toLong_0(maxValue)).toInt_5();
  }
  function systemProp_0(propertyName, defaultValue, minValue, maxValue) {
    var tmp0_elvis_lhs = systemProp_1(propertyName);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return defaultValue;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var value = tmp;
    var tmp1_elvis_lhs = toLongOrNull(value);
    var tmp_0;
    if (tmp1_elvis_lhs == null) {
      var tmp0_error_0 = '' + "System property '" + propertyName + "' has unrecognized value '" + value + "'";
      throw IllegalStateException_init_$Create$(toString_1(tmp0_error_0));
    } else {
      tmp_0 = tmp1_elvis_lhs;
    }
    var parsed = tmp_0;
    if (!(minValue.compareTo_69(parsed) <= 0 ? parsed.compareTo_69(maxValue) <= 0 : false)) {
      var tmp1_error_0 = '' + "System property '" + propertyName + "' should be in range " + minValue + '..' + maxValue + ", but is '" + parsed + "'";
      throw IllegalStateException_init_$Create$(toString_1(tmp1_error_0));
    }return parsed;
  }
  function startCoroutineCancellable(_this_, receiver, completion, onCancellation) {
    var tmp;
    try {
      var tmp_0 = intercepted(createCoroutineUnintercepted(_this_, receiver, completion));
      var tmp0_success_0_3 = Companion_getInstance_3();
      var tmp1_success_0_4 = Unit_getInstance();
      tmp = resumeCancellableWith(tmp_0, _Result___init__impl_(Unit_getInstance()), onCancellation);
    } catch ($p) {
      var tmp_1;
      if ($p instanceof Error) {
        var tmp0_failure_0 = Companion_getInstance_3();
        tmp_1 = completion.resumeWith_34(_Result___init__impl_(createFailure($p)));
      } else {
        {
          throw $p;
        }
      }
      tmp = tmp_1;
    }
    return tmp;
  }
  function startCoroutineCancellable$default(_this_, receiver, completion, onCancellation, $mask0, $handler) {
    if (!(($mask0 & 4) === 0))
      onCancellation = null;
    return startCoroutineCancellable(_this_, receiver, completion, onCancellation);
  }
  function startCoroutineCancellable_0(_this_, fatalCompletion) {
    var tmp;
    try {
      var tmp_0 = intercepted(_this_);
      var tmp0_success_0_4 = Companion_getInstance_3();
      var tmp1_success_0_5 = Unit_getInstance();
      var tmp_1 = _Result___init__impl_(Unit_getInstance());
      tmp = resumeCancellableWith$default(tmp_0, tmp_1, null, 2, null);
    } catch ($p) {
      var tmp_2;
      if ($p instanceof Error) {
        var tmp0_failure_0_2 = Companion_getInstance_3();
        tmp_2 = fatalCompletion.resumeWith_34(_Result___init__impl_(createFailure($p)));
      } else {
        {
          throw $p;
        }
      }
      tmp = tmp_2;
    }
    return tmp;
  }
  function startCoroutineUndispatched(_this_, receiver, completion) {
    var tmp$ret$0;
    l$ret$1: do {
      var actualCompletion_1 = completion;
      var tmp;
      try {
        var tmp0_withCoroutineContext_0_8 = completion._get_context__86();
        var tmp1_withCoroutineContext_0_9 = null;
        tmp = _this_(receiver, actualCompletion_1);
      } catch ($p) {
        var tmp_0;
        if ($p instanceof Error) {
          var tmp0_failure_0_1_4 = Companion_getInstance_3();
          actualCompletion_1.resumeWith_34(_Result___init__impl_(createFailure($p)));
          tmp$ret$0 = Unit_getInstance();
          break l$ret$1;
        } else {
          {
            throw $p;
          }
        }
        tmp = tmp_0;
      }
      var value_2 = tmp;
      if (!(value_2 === _get_COROUTINE_SUSPENDED_())) {
        var tmp0_resume_0_5 = (value_2 == null ? true : isObject(value_2)) ? value_2 : THROW_CCE();
        var tmp0_success_0_1_6 = Companion_getInstance_3();
        actualCompletion_1.resumeWith_34(_Result___init__impl_(tmp0_resume_0_5));
      }}
     while (false);
  }
  function SelectClause0() {
  }
  SelectClause0.$metadata$ = {
    simpleName: 'SelectClause0',
    kind: 'interface',
    interfaces: []
  };
  function SelectClause1() {
  }
  SelectClause1.$metadata$ = {
    simpleName: 'SelectClause1',
    kind: 'interface',
    interfaces: []
  };
  function CompletionHandlerBase() {
    LinkedListNode.call(this);
  }
  CompletionHandlerBase.$metadata$ = {
    simpleName: 'CompletionHandlerBase',
    kind: 'class',
    interfaces: []
  };
  function invokeIt(_this_, cause) {
    var tmp0_subject = typeof _this_;
    if (tmp0_subject === 'function')
      _this_(cause);
    else {
      _this_.invoke(cause);
    }
  }
  function CancelHandlerBase() {
  }
  CancelHandlerBase.$metadata$ = {
    simpleName: 'CancelHandlerBase',
    kind: 'class',
    interfaces: []
  };
  function toDebugString(_this_) {
    return toString_1(_this_);
  }
  function newCoroutineContext(_this_, context) {
    var combined = _this_._get_coroutineContext__22().plus_28(context);
    return (!(combined === Dispatchers_getInstance()._Default) ? combined.get_70(Key_getInstance()) == null : false) ? combined.plus_28(Dispatchers_getInstance()._Default) : combined;
  }
  function _get_DefaultDelay_() {
    var tmp = Dispatchers_getInstance()._Default;
    return isInterface(tmp, Delay) ? tmp : THROW_CCE();
  }
  function _get_coroutineName_(_this_) {
    return null;
  }
  function createDefaultDispatcher() {
    var tmp;
    if ((!(typeof navigator === 'undefined') ? navigator != null : false) ? navigator.product == 'ReactNative' : false) {
      tmp = NodeDispatcher_getInstance();
    } else {
      if (isJsdom()) {
        tmp = NodeDispatcher_getInstance();
      } else {
        var tmp_0;
        var tmp_1;
        if (!(typeof window === 'undefined')) {
          var tmp0_asDynamic_0 = window;
          tmp_1 = tmp0_asDynamic_0 != null;
        } else {
          tmp_1 = false;
        }
        if (tmp_1) {
          var tmp1_asDynamic_0 = window;
          tmp_0 = !(typeof tmp1_asDynamic_0.addEventListener === 'undefined');
        } else {
          {
            tmp_0 = false;
          }
        }
        if (tmp_0) {
          tmp = asCoroutineDispatcher(window);
        } else {
          if (typeof process === 'undefined') {
            tmp = SetTimeoutDispatcher_getInstance();
          } else {
            {
              tmp = NodeDispatcher_getInstance();
            }
          }
        }
      }
    }
    return tmp;
  }
  function isJsdom() {
    return ((((!(typeof navigator === 'undefined') ? navigator != null : false) ? navigator.userAgent != null : false) ? !(typeof navigator.userAgent === 'undefined') : false) ? !(typeof navigator.userAgent.match === 'undefined') : false) ? navigator.userAgent.match('\\bjsdom\\b') : false;
  }
  function handleCoroutineExceptionImpl(context, exception) {
    (function () {
      var $externalVarargReceiverTmp = console;
      return $externalVarargReceiverTmp.error.apply($externalVarargReceiverTmp, [].concat([exception]));
    }.call(this));
  }
  var counter;
  var DEBUG;
  function _get_classSimpleName_(_this_) {
    var tmp0_elvis_lhs = getKClassFromExpression_0(_this_)._get_simpleName__4();
    return tmp0_elvis_lhs == null ? 'Unknown' : tmp0_elvis_lhs;
  }
  function _get_hexAddress_(_this_) {
    var result = _this_.__debug_counter;
    if (!(typeof result === 'number')) {
      counter = counter + 1 | 0;
      result = counter;
      _this_.__debug_counter = result;
    }return ((!(result == null) ? typeof result === 'number' : false) ? result : THROW_CCE()).toString();
  }
  function Dispatchers() {
    Dispatchers_instance = this;
    this._Default = createDefaultDispatcher();
    this._Main = new JsMainDispatcher(this._Default, false);
    this._Unconfined = Unconfined_getInstance();
  }
  Dispatchers.$metadata$ = {
    simpleName: 'Dispatchers',
    kind: 'object',
    interfaces: []
  };
  var Dispatchers_instance;
  function Dispatchers_getInstance() {
    if (Dispatchers_instance == null)
      new Dispatchers();
    return Dispatchers_instance;
  }
  function JsMainDispatcher(delegate, invokeImmediately) {
    MainCoroutineDispatcher.call(this);
    this._delegate_0 = delegate;
    this._invokeImmediately = invokeImmediately;
    this._immediate = this._invokeImmediately ? this : new JsMainDispatcher(this._delegate_0, true);
  }
  JsMainDispatcher.prototype._get_immediate__0 = function () {
    return this._immediate;
  };
  JsMainDispatcher.prototype.isDispatchNeeded_8 = function (context) {
    return !this._invokeImmediately;
  };
  JsMainDispatcher.prototype.dispatch_8 = function (context, block) {
    return this._delegate_0.dispatch_8(context, block);
  };
  JsMainDispatcher.prototype.toString = function () {
    var tmp0_elvis_lhs = this.toStringInternalImpl_0();
    return tmp0_elvis_lhs == null ? this._delegate_0.toString() : tmp0_elvis_lhs;
  };
  JsMainDispatcher.$metadata$ = {
    simpleName: 'JsMainDispatcher',
    kind: 'class',
    interfaces: []
  };
  function createEventLoop() {
    return new UnconfinedEventLoop();
  }
  function UnconfinedEventLoop() {
    EventLoop.call(this);
  }
  UnconfinedEventLoop.prototype.dispatch_8 = function (context, block) {
    unsupported();
  };
  UnconfinedEventLoop.$metadata$ = {
    simpleName: 'UnconfinedEventLoop',
    kind: 'class',
    interfaces: []
  };
  function unsupported() {
    throw UnsupportedOperationException_init_$Create$_0('runBlocking event loop is not supported');
  }
  function JobCancellationException(message, cause, job) {
    CancellationException.call(this, message, cause);
    this._job_1 = job;
    captureStack(this, JobCancellationException);
  }
  JobCancellationException.prototype.toString = function () {
    return '' + CancellationException.prototype.toString.call(this) + '; job=' + this._job_1;
  };
  JobCancellationException.prototype.equals = function (other) {
    var tmp;
    if (other === this) {
      tmp = true;
    } else {
      var tmp_0;
      var tmp_1;
      var tmp_2;
      if (other instanceof JobCancellationException) {
        tmp_2 = other.message == this.message;
      } else {
        {
          tmp_2 = false;
        }
      }
      if (tmp_2) {
        tmp_1 = equals_1(other._job_1, this._job_1);
      } else {
        {
          tmp_1 = false;
        }
      }
      if (tmp_1) {
        tmp_0 = equals_1(other.cause, this.cause);
      } else {
        {
          tmp_0 = false;
        }
      }
      tmp = tmp_0;
    }
    return tmp;
  };
  JobCancellationException.prototype.hashCode = function () {
    var tmp = imul(imul(getStringHashCode(ensureNotNull(this.message)), 31) + hashCode(this._job_1) | 0, 31);
    var tmp0_safe_receiver = this.cause;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : hashCode(tmp0_safe_receiver);
    return tmp + (tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs) | 0;
  };
  JobCancellationException.$metadata$ = {
    simpleName: 'JobCancellationException',
    kind: 'class',
    interfaces: []
  };
  function CancellationException_init_$Init$(message, $this) {
    CancellationException.call($this, message, null);
    return $this;
  }
  function CancellationException_init_$Create$(message) {
    var tmp = CancellationException_init_$Init$(message, Object.create(CancellationException.prototype));
    captureStack(tmp, CancellationException_init_$Create$);
    return tmp;
  }
  function CancellationException(message, cause) {
    IllegalStateException_init_$Init$_1(message, cause, this);
    captureStack(this, CancellationException);
  }
  CancellationException.$metadata$ = {
    simpleName: 'CancellationException',
    kind: 'class',
    interfaces: []
  };
  function NodeDispatcher() {
    NodeDispatcher_instance = this;
    SetTimeoutBasedDispatcher.call(this);
  }
  NodeDispatcher.prototype.scheduleQueueProcessing_1 = function () {
    process.nextTick(this._get_messageQueue__1()._processQueue);
  };
  NodeDispatcher.$metadata$ = {
    simpleName: 'NodeDispatcher',
    kind: 'object',
    interfaces: []
  };
  var NodeDispatcher_instance;
  function NodeDispatcher_getInstance() {
    if (NodeDispatcher_instance == null)
      new NodeDispatcher();
    return NodeDispatcher_instance;
  }
  function SetTimeoutDispatcher() {
    SetTimeoutDispatcher_instance = this;
    SetTimeoutBasedDispatcher.call(this);
  }
  SetTimeoutDispatcher.prototype.scheduleQueueProcessing_1 = function () {
    setTimeout(this._get_messageQueue__1()._processQueue, 0);
    Unit_getInstance();
  };
  SetTimeoutDispatcher.$metadata$ = {
    simpleName: 'SetTimeoutDispatcher',
    kind: 'object',
    interfaces: []
  };
  var SetTimeoutDispatcher_instance;
  function SetTimeoutDispatcher_getInstance() {
    if (SetTimeoutDispatcher_instance == null)
      new SetTimeoutDispatcher();
    return SetTimeoutDispatcher_instance;
  }
  function _no_name_provided__80(this$0) {
    this._this$0_22 = this$0;
  }
  _no_name_provided__80.prototype.invoke_494 = function () {
    this._this$0_22.process_1();
  };
  _no_name_provided__80.prototype.invoke_540 = function () {
    this.invoke_494();
    return Unit_getInstance();
  };
  _no_name_provided__80.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function ScheduledMessageQueue($outer) {
    this._$this_6 = $outer;
    MessageQueue.call(this);
    var tmp = this;
    tmp._processQueue = _no_name_provided_$factory_59(this);
  }
  ScheduledMessageQueue.prototype.schedule_1 = function () {
    this._$this_6.scheduleQueueProcessing_1();
  };
  ScheduledMessageQueue.prototype.reschedule_1 = function () {
    setTimeout(this._processQueue, 0);
    Unit_getInstance();
  };
  ScheduledMessageQueue.$metadata$ = {
    simpleName: 'ScheduledMessageQueue',
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__81($continuation, this$0) {
    this._$continuation = $continuation;
    this._this$0_23 = this$0;
  }
  _no_name_provided__81.prototype.invoke_494 = function () {
    this._$continuation.resumeUndispatched_1(this._this$0_23, Unit_getInstance());
  };
  _no_name_provided__81.prototype.invoke_540 = function () {
    this.invoke_494();
    return Unit_getInstance();
  };
  _no_name_provided__81.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function SetTimeoutBasedDispatcher() {
    CoroutineDispatcher.call(this);
    this._messageQueue = new ScheduledMessageQueue(this);
  }
  SetTimeoutBasedDispatcher.prototype._get_messageQueue__1 = function () {
    return this._messageQueue;
  };
  SetTimeoutBasedDispatcher.prototype.dispatch_8 = function (context, block) {
    this._messageQueue.enqueue_1(block);
  };
  SetTimeoutBasedDispatcher.prototype.scheduleResumeAfterDelay_3 = function (timeMillis, continuation) {
    var handle = setTimeout(_no_name_provided_$factory_60(continuation, this), delayToInt(timeMillis));
    var tmp0__get_asHandler__0 = new ClearTimeout(handle);
    continuation.invokeOnCancellation_1(tmp0__get_asHandler__0);
  };
  SetTimeoutBasedDispatcher.$metadata$ = {
    simpleName: 'SetTimeoutBasedDispatcher',
    kind: 'class',
    interfaces: [Delay]
  };
  function MessageQueue() {
    ArrayQueue.call(this);
    this._yieldEvery = 16;
    this._scheduled = false;
  }
  MessageQueue.prototype.enqueue_1 = function (element) {
    this.addLast_16(element);
    if (!this._scheduled) {
      this._scheduled = true;
      this.schedule_1();
    }};
  MessageQueue.prototype.process_1 = function () {
    try {
      var tmp0_repeat_0 = this._yieldEvery;
      var inductionVariable = 0;
      if (inductionVariable < tmp0_repeat_0)
        do {
          var index_2 = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var tmp0_elvis_lhs_5 = this.removeFirstOrNull_2();
          var tmp;
          if (tmp0_elvis_lhs_5 == null) {
            return Unit_getInstance();
          } else {
            tmp = tmp0_elvis_lhs_5;
          }
          var element_4 = tmp;
          element_4.run_4();
        }
         while (inductionVariable < tmp0_repeat_0);
    }finally {
      if (this._get_isEmpty__4()) {
        this._scheduled = false;
      } else {
        this.reschedule_1();
      }
    }
  };
  MessageQueue.$metadata$ = {
    simpleName: 'MessageQueue',
    kind: 'class',
    interfaces: []
  };
  function delayToInt(timeMillis) {
    return coerceIn_1(timeMillis, new Long(0, 0), new Long(2147483647, 0)).toInt_5();
  }
  function ClearTimeout(handle) {
    CancelHandler.call(this);
    this._handle_0 = handle;
  }
  ClearTimeout.prototype.dispose_26 = function () {
    clearTimeout(this._handle_0);
  };
  ClearTimeout.prototype.invoke_375 = function (cause) {
    this.dispose_26();
  };
  ClearTimeout.prototype.invoke = function (cause) {
    return this.invoke_375(cause);
  };
  ClearTimeout.prototype.toString = function () {
    return '' + 'ClearTimeout[' + this._handle_0 + ']';
  };
  ClearTimeout.$metadata$ = {
    simpleName: 'ClearTimeout',
    kind: 'class',
    interfaces: [DisposableHandle]
  };
  function _no_name_provided__82($continuation, this$0) {
    this._$continuation_0 = $continuation;
    this._this$0_24 = this$0;
  }
  _no_name_provided__82.prototype.invoke_494 = function () {
    this._$continuation_0.resumeUndispatched_1(this._this$0_24, Unit_getInstance());
  };
  _no_name_provided__82.prototype.invoke_540 = function () {
    this.invoke_494();
    return Unit_getInstance();
  };
  _no_name_provided__82.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function WindowDispatcher(window_0) {
    CoroutineDispatcher.call(this);
    this._window = window_0;
    this._queue_0 = new WindowMessageQueue(this._window);
  }
  WindowDispatcher.prototype.dispatch_8 = function (context, block) {
    return this._queue_0.enqueue_1(block);
  };
  WindowDispatcher.prototype.scheduleResumeAfterDelay_3 = function (timeMillis, continuation) {
    (function () {
      var $externalVarargReceiverTmp = this._window;
      return $externalVarargReceiverTmp.setTimeout.apply($externalVarargReceiverTmp, [_no_name_provided_$factory_61(continuation, this), delayToInt(timeMillis)]);
    }.call(this));
    Unit_getInstance();
  };
  WindowDispatcher.$metadata$ = {
    simpleName: 'WindowDispatcher',
    kind: 'class',
    interfaces: [Delay]
  };
  function _no_name_provided__83(this$0) {
    this._this$0_25 = this$0;
  }
  _no_name_provided__83.prototype.invoke_371 = function (event) {
    if (event.source == this._this$0_25._window_0 ? event.data == this._this$0_25._messageName : false) {
      event.stopPropagation();
      this._this$0_25.process_1();
    }};
  _no_name_provided__83.prototype.invoke_542 = function (p1) {
    this.invoke_371((p1 == null ? true : p1) ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__83.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__84(this$0) {
    this._this$0_26 = this$0;
  }
  _no_name_provided__84.prototype.invoke_166 = function (it) {
    this._this$0_26.process_1();
  };
  _no_name_provided__84.prototype.invoke_542 = function (p1) {
    this.invoke_166(p1 instanceof Unit ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__84.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function WindowMessageQueue(window_0) {
    MessageQueue.call(this);
    this._window_0 = window_0;
    this._messageName = 'dispatchCoroutine';
    this._window_0.addEventListener('message', _no_name_provided_$factory_62(this), true);
  }
  WindowMessageQueue.prototype.schedule_1 = function () {
    var tmp = Promise.resolve(Unit_getInstance());
    tmp.then(_no_name_provided_$factory_63(this));
    Unit_getInstance();
  };
  WindowMessageQueue.prototype.reschedule_1 = function () {
    this._window_0.postMessage(this._messageName, '*');
  };
  WindowMessageQueue.$metadata$ = {
    simpleName: 'WindowMessageQueue',
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided_$factory_59(this$0) {
    var i = new _no_name_provided__80(this$0);
    return function () {
      i.invoke_494();
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_60($continuation, this$0) {
    var i = new _no_name_provided__81($continuation, this$0);
    return function () {
      i.invoke_494();
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_61($continuation, this$0) {
    var i = new _no_name_provided__82($continuation, this$0);
    return function () {
      i.invoke_494();
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_62(this$0) {
    var i = new _no_name_provided__83(this$0);
    return function (p1) {
      i.invoke_371(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_63(this$0) {
    var i = new _no_name_provided__84(this$0);
    return function (p1) {
      i.invoke_166(p1);
      return Unit_getInstance();
    };
  }
  function Runnable() {
  }
  Runnable.$metadata$ = {
    simpleName: 'Runnable',
    kind: 'interface',
    interfaces: []
  };
  function SchedulerTask() {
  }
  SchedulerTask.$metadata$ = {
    simpleName: 'SchedulerTask',
    kind: 'class',
    interfaces: [Runnable]
  };
  function _get_taskContext_(_this_) {
    return Unit_getInstance();
  }
  function asCoroutineDispatcher(_this_) {
    var tmp0_elvis_lhs = _this_.coroutineDispatcher;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      var tmp0_also_0 = new WindowDispatcher(_this_);
      _this_.coroutineDispatcher = tmp0_also_0;
      tmp = tmp0_also_0;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  }
  function identitySet(expectedSize) {
    return HashSet_init_$Create$_1(expectedSize);
  }
  function NoOpLock() {
  }
  NoOpLock.$metadata$ = {
    simpleName: 'NoOpLock',
    kind: 'class',
    interfaces: []
  };
  function LinkedListHead() {
    LinkedListNode.call(this);
  }
  LinkedListHead.prototype.remove_35 = function () {
    throw UnsupportedOperationException_init_$Create$();
  };
  LinkedListHead.$metadata$ = {
    simpleName: 'LinkedListHead',
    kind: 'class',
    interfaces: []
  };
  function LinkedListNode() {
    this.__next = this;
    this.__prev = this;
    this.__removed = false;
  }
  LinkedListNode.prototype._get__next__1 = function () {
    return this.__next;
  };
  LinkedListNode.prototype.addLast_22 = function (node) {
    var prev = this.__prev;
    node.__next = this;
    node.__prev = prev;
    prev.__next = node;
    this.__prev = node;
  };
  LinkedListNode.prototype.remove_35 = function () {
    if (this.__removed)
      return false;
    var prev = this.__prev;
    var next = this.__next;
    prev.__next = next;
    next.__prev = prev;
    this.__removed = true;
    return true;
  };
  LinkedListNode.prototype.addOneIfEmpty_8 = function (node) {
    if (!(this.__next === this))
      return false;
    this.addLast_22(node);
    return true;
  };
  LinkedListNode.prototype.helpRemove_18 = function () {
  };
  LinkedListNode.$metadata$ = {
    simpleName: 'LinkedListNode',
    kind: 'class',
    interfaces: []
  };
  function unwrap(exception) {
    return exception;
  }
  function CoroutineStackFrame() {
  }
  CoroutineStackFrame.$metadata$ = {
    simpleName: 'CoroutineStackFrame',
    kind: 'interface',
    interfaces: []
  };
  function recoverStackTrace(exception, continuation) {
    return exception;
  }
  function recoverStackTrace_0(exception) {
    return exception;
  }
  function systemProp_1(propertyName) {
    return null;
  }
  function threadContextElements(context) {
    return 0;
  }
  function CommonThreadLocal() {
    this._value_12 = null;
  }
  CommonThreadLocal.prototype.get_49 = function () {
    var tmp = this._value_12;
    return (tmp == null ? true : isObject(tmp)) ? tmp : THROW_CCE();
  };
  CommonThreadLocal.prototype.set_3 = function (value) {
    this._value_12 = value;
  };
  CommonThreadLocal.$metadata$ = {
    simpleName: 'CommonThreadLocal',
    kind: 'class',
    interfaces: []
  };
  function functionalComponent(displayName, func) {
    var fc = _no_name_provided_$factory_64(func);
    if (!(displayName == null)) {
      fc.displayName = displayName;
    }return fc;
  }
  function functionalComponent$default(displayName, func, $mask0, $handler) {
    if (!(($mask0 & 1) === 0))
      displayName = null;
    return functionalComponent(displayName, func);
  }
  function RBuilder() {
    var tmp = this;
    tmp._childList = ArrayList_init_$Create$();
  }
  RBuilder.prototype._get_childList__2 = function () {
    return this._childList;
  };
  RBuilder.prototype.child_11 = function (element) {
    this._childList.add_33(element);
    Unit_getInstance();
    return element;
  };
  RBuilder.prototype.unaryPlus_1 = function (_this__0) {
    this._childList.add_33(_this__0);
    Unit_getInstance();
  };
  RBuilder.prototype.child_12 = function (type, props, children) {
    return this.child_11(createElement.apply(null, [type, props].concat([].slice.call(copyToArray_0(children).slice()))));
  };
  RBuilder.prototype.child_13 = function (type, props, handler) {
    var tmp0_with_0 = new RElementBuilder(props);
    handler(tmp0_with_0);
    var children = tmp0_with_0._get_childList__2();
    return this.child_12(type, props, children);
  };
  RBuilder.prototype.invoke_154 = function (_this__0, handler) {
    return this.child_13(_this__0, {}, handler);
  };
  RBuilder.prototype.child_14 = function (klazz, handler) {
    return this.invoke_154(_get_rClass_(klazz), handler);
  };
  RBuilder.prototype.children_1 = function (_this__0) {
    addAll_0(this._childList, Children.toArray(_get_children_(_this__0)));
    Unit_getInstance();
  };
  RBuilder.$metadata$ = {
    simpleName: 'RBuilder',
    kind: 'class',
    interfaces: []
  };
  function RElementBuilder(attrs) {
    RBuilder.call(this);
    this._attrs = attrs;
  }
  RElementBuilder.prototype._get_attrs__1 = function () {
    return this._attrs;
  };
  RElementBuilder.prototype.attrs_0 = function (handler) {
    handler(this._get_attrs__1());
  };
  RElementBuilder.$metadata$ = {
    simpleName: 'RElementBuilder',
    kind: 'class',
    interfaces: []
  };
  function child(_this_, component, props, handler) {
    return _this_.child_13(component, props, handler);
  }
  function child$default(_this_, component, props, handler, $mask0, $handler) {
    if (!(($mask0 & 2) === 0)) {
      props = {};
    }if (!(($mask0 & 4) === 0)) {
      handler = _no_name_provided_$factory_65();
    }return child(_this_, component, props, handler);
  }
  function buildElements(handler) {
    var tmp0_apply_0 = new RBuilder();
    handler(tmp0_apply_0);
    var nodes = tmp0_apply_0._childList;
    var tmp0_subject = nodes._get_size__45();
    var tmp;
    switch (tmp0_subject) {
      case 0:
        tmp = null;
        break;
      case 1:
        tmp = first(nodes);
        break;
      default:var tmp_0 = Fragment;
        var tmp0_apply_0_1_1 = {};
        Unit_getInstance();
        tmp = createElement.apply(null, [tmp_0, tmp0_apply_0_1_1].concat([].slice.call(copyToArray_0(nodes).slice())));
        break;
    }
    return tmp;
  }
  function _no_name_provided__85($func, $props) {
    this._$func = $func;
    this._$props = $props;
  }
  _no_name_provided__85.prototype.invoke_414 = function ($this$buildElements) {
    this._$func($this$buildElements, this._$props);
  };
  _no_name_provided__85.prototype.invoke_542 = function (p1) {
    this.invoke_414(p1 instanceof RBuilder ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__85.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__86($func) {
    this._$func_0 = $func;
  }
  _no_name_provided__86.prototype.invoke_134 = function (props) {
    return buildElements(_no_name_provided_$factory_66(this._$func_0, props));
  };
  _no_name_provided__86.prototype.invoke_542 = function (p1) {
    return this.invoke_134((!(p1 == null) ? isObject(p1) : false) ? p1 : THROW_CCE());
  };
  _no_name_provided__86.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__87() {
  }
  _no_name_provided__87.prototype.invoke_136 = function ($this$null) {
    return Unit_getInstance();
  };
  _no_name_provided__87.prototype.invoke_542 = function (p1) {
    this.invoke_136(p1 instanceof RElementBuilder ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__87.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided_$factory_64($func) {
    var i = new _no_name_provided__86($func);
    return function (p1) {
      return i.invoke_134(p1);
    };
  }
  function _no_name_provided_$factory_65() {
    var i = new _no_name_provided__87();
    return function (p1) {
      i.invoke_136(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_66($func, $props) {
    var i = new _no_name_provided__85($func, $props);
    return function (p1) {
      i.invoke_414(p1);
      return Unit_getInstance();
    };
  }
  function _get_rClass_(_this_) {
    var tmp0_unsafeCast_0 = _get_js_(_this_);
    return tmp0_unsafeCast_0;
  }
  function _set_ref_(_this_, value) {
    _this_.ref = value;
  }
  function _get_children_(_this_) {
    return _this_.children;
  }
  function RStateDelegate(state, setState) {
    this._state_3 = state;
    this._setState = setState;
  }
  RStateDelegate.prototype.component1_4 = function () {
    return this._state_3;
  };
  RStateDelegate.prototype.component2_4 = function () {
    return this._setState;
  };
  RStateDelegate.prototype.getValue_5 = function (thisRef, property) {
    return this._state_3;
  };
  RStateDelegate.prototype.getValue_10 = function (thisRef, property) {
    return this.getValue_5((thisRef == null ? true : isObject(thisRef)) ? thisRef : THROW_CCE(), property);
  };
  RStateDelegate.prototype.setValue_3 = function (thisRef, property, value) {
    this._setState(value);
  };
  RStateDelegate.prototype.setValue_7 = function (thisRef, property, value) {
    var tmp = (thisRef == null ? true : isObject(thisRef)) ? thisRef : THROW_CCE();
    return this.setValue_3(tmp, property, (value == null ? true : isObject(value)) ? value : THROW_CCE());
  };
  RStateDelegate.$metadata$ = {
    simpleName: 'RStateDelegate',
    kind: 'class',
    interfaces: [ReadWriteProperty]
  };
  function useEffectWithCleanup(dependencies, effect) {
    if (!(dependencies == null)) {
      useEffect(effect, copyToArray_0(dependencies));
    } else {
      useEffect(effect);
    }
  }
  function useEffect_0(dependencies, effect) {
    var rawEffect = _no_name_provided_$factory_67(effect);
    if (!(dependencies == null)) {
      useEffect(rawEffect, copyToArray_0(dependencies));
    } else {
      useEffect(rawEffect);
    }
  }
  function useEffect$default(dependencies, effect, $mask0, $handler) {
    if (!(($mask0 & 1) === 0))
      dependencies = null;
    return useEffect_0(dependencies, effect);
  }
  function _no_name_provided__88($effect) {
    this._$effect = $effect;
  }
  _no_name_provided__88.prototype.invoke_540 = function () {
    this._$effect();
    return undefined;
  };
  _no_name_provided__88.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided_$factory_67($effect) {
    var i = new _no_name_provided__88($effect);
    return function () {
      return i.invoke_540();
    };
  }
  var emptyMap_0;
  function AttributeEnum() {
  }
  AttributeEnum.$metadata$ = {
    simpleName: 'AttributeEnum',
    kind: 'interface',
    interfaces: []
  };
  function Tag() {
  }
  Tag.$metadata$ = {
    simpleName: 'Tag',
    kind: 'interface',
    interfaces: []
  };
  function TagConsumer() {
  }
  TagConsumer.$metadata$ = {
    simpleName: 'TagConsumer',
    kind: 'interface',
    interfaces: []
  };
  function attributesMapOf(key, value) {
    var tmp0_subject = value;
    return tmp0_subject == null ? emptyMap_0 : singletonMapOf(key, value);
  }
  function attributesMapOf_0(pairs) {
    var result = null;
    var nestedLast = pairs.length - 1 | 0;
    var inductionVariable = 0;
    var last_1 = getProgressionLastElement(0, nestedLast, 2);
    if (inductionVariable <= last_1)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 2 | 0;
        var k = pairs[i];
        var v = pairs[i + 1 | 0];
        if (!(k == null) ? !(v == null) : false) {
          if (result == null) {
            result = LinkedHashMap_init_$Create$();
          }result.put_12(k, v);
          Unit_getInstance();
        }}
       while (!(i === last_1));
    var tmp1_elvis_lhs = result;
    return tmp1_elvis_lhs == null ? emptyMap_0 : tmp1_elvis_lhs;
  }
  function singletonMapOf(key, value) {
    return new SingletonStringMap(key, value);
  }
  function SingletonStringMap(key, value) {
    this._key_2 = key;
    this._value_13 = value;
  }
  SingletonStringMap.prototype._get_key__47 = function () {
    return this._key_2;
  };
  SingletonStringMap.prototype._get_value__33 = function () {
    return this._value_13;
  };
  SingletonStringMap.prototype._get_entries__10 = function () {
    return setOf_0(this);
  };
  SingletonStringMap.prototype._get_keys__10 = function () {
    return setOf_0(this._key_2);
  };
  SingletonStringMap.prototype._get_size__45 = function () {
    return 1;
  };
  SingletonStringMap.prototype._get_values__16 = function () {
    return listOf_0(this._value_13);
  };
  SingletonStringMap.prototype.containsKey_13 = function (key) {
    return key === this._key_2;
  };
  SingletonStringMap.prototype.containsKey_16 = function (key) {
    if (!(!(key == null) ? typeof key === 'string' : false))
      return false;
    else {
    }
    return this.containsKey_13((!(key == null) ? typeof key === 'string' : false) ? key : THROW_CCE());
  };
  SingletonStringMap.prototype.get_69 = function (key) {
    return key === this._key_2 ? this._value_13 : null;
  };
  SingletonStringMap.prototype.get_63 = function (key) {
    if (!(!(key == null) ? typeof key === 'string' : false))
      return null;
    else {
    }
    return this.get_69((!(key == null) ? typeof key === 'string' : false) ? key : THROW_CCE());
  };
  SingletonStringMap.prototype.isEmpty_53 = function () {
    return false;
  };
  SingletonStringMap.prototype.toString = function () {
    return '' + 'SingletonStringMap(key=' + this._key_2 + ', value=' + this._value_13 + ')';
  };
  SingletonStringMap.prototype.hashCode = function () {
    return imul(getStringHashCode(this._key_2), 31) + getStringHashCode(this._value_13) | 0;
  };
  SingletonStringMap.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof SingletonStringMap))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof SingletonStringMap ? other : THROW_CCE();
    if (!(this._key_2 === tmp0_other_with_cast._key_2))
      return false;
    if (!(this._value_13 === tmp0_other_with_cast._value_13))
      return false;
    return true;
  };
  SingletonStringMap.$metadata$ = {
    simpleName: 'SingletonStringMap',
    kind: 'class',
    interfaces: [Map_0, Entry]
  };
  function Attribute(encoder) {
    this._encoder = encoder;
  }
  Attribute.prototype.set_8 = function (thisRef, attributeName, value) {
    thisRef._get_attributes__12().put_12(attributeName, this._encoder.encode_5(attributeName, value));
    Unit_getInstance();
  };
  Attribute.$metadata$ = {
    simpleName: 'Attribute',
    kind: 'class',
    interfaces: []
  };
  function StringAttribute() {
    Attribute.call(this, StringEncoder_getInstance());
  }
  StringAttribute.$metadata$ = {
    simpleName: 'StringAttribute',
    kind: 'class',
    interfaces: []
  };
  function TickerAttribute() {
    Attribute.call(this, TickerEncoder_getInstance());
  }
  TickerAttribute.prototype.set_6 = function (thisRef, attributeName, value) {
    if (value) {
      thisRef._get_attributes__12().put_12(attributeName, attributeName);
      Unit_getInstance();
    } else {
      thisRef._get_attributes__12().remove_45(attributeName);
      Unit_getInstance();
    }
  };
  TickerAttribute.prototype.set_8 = function (thisRef, attributeName, value) {
    return this.set_6(thisRef, attributeName, (!(value == null) ? typeof value === 'boolean' : false) ? value : THROW_CCE());
  };
  TickerAttribute.$metadata$ = {
    simpleName: 'TickerAttribute',
    kind: 'class',
    interfaces: []
  };
  function EnumAttribute(values_5) {
    Attribute.call(this, new EnumEncoder(values_5));
    this._values_0 = values_5;
  }
  EnumAttribute.$metadata$ = {
    simpleName: 'EnumAttribute',
    kind: 'class',
    interfaces: []
  };
  function AttributeEncoder() {
  }
  AttributeEncoder.$metadata$ = {
    simpleName: 'AttributeEncoder',
    kind: 'interface',
    interfaces: []
  };
  function StringEncoder() {
    StringEncoder_instance = this;
  }
  StringEncoder.prototype.encode_1 = function (attributeName, value) {
    return value;
  };
  StringEncoder.prototype.encode_5 = function (attributeName, value) {
    return this.encode_1(attributeName, (!(value == null) ? typeof value === 'string' : false) ? value : THROW_CCE());
  };
  StringEncoder.$metadata$ = {
    simpleName: 'StringEncoder',
    kind: 'object',
    interfaces: [AttributeEncoder]
  };
  var StringEncoder_instance;
  function StringEncoder_getInstance() {
    if (StringEncoder_instance == null)
      new StringEncoder();
    return StringEncoder_instance;
  }
  function TickerEncoder() {
    TickerEncoder_instance = this;
  }
  TickerEncoder.prototype.encode_3 = function (attributeName, value) {
    return tickerEncode(value, attributeName);
  };
  TickerEncoder.prototype.encode_5 = function (attributeName, value) {
    return this.encode_3(attributeName, (!(value == null) ? typeof value === 'boolean' : false) ? value : THROW_CCE());
  };
  TickerEncoder.$metadata$ = {
    simpleName: 'TickerEncoder',
    kind: 'object',
    interfaces: [AttributeEncoder]
  };
  var TickerEncoder_instance;
  function TickerEncoder_getInstance() {
    if (TickerEncoder_instance == null)
      new TickerEncoder();
    return TickerEncoder_instance;
  }
  function EnumEncoder(valuesMap) {
    this._valuesMap = valuesMap;
  }
  EnumEncoder.prototype.encode_5 = function (attributeName, value) {
    return value._get_realValue__0();
  };
  EnumEncoder.$metadata$ = {
    simpleName: 'EnumEncoder',
    kind: 'class',
    interfaces: [AttributeEncoder]
  };
  function tickerEncode(_this_, attributeName) {
    return _this_ ? attributeName : '';
  }
  function enumEncode(_this_) {
    return _this_._get_realValue__0();
  }
  function switchToMutable($this) {
    var tmp;
    if ($this._backingMutable) {
      tmp = $this._backing;
    } else {
      $this._backingMutable = true;
      $this._backing = LinkedHashMap_init_$Create$_2($this._backing);
      tmp = $this._backing;
    }
    var tmp_0 = tmp;
    return isInterface(tmp_0, MutableMap) ? tmp_0 : THROW_CCE();
  }
  function DelegatingMap(initialValues, tag, consumer) {
    this._tag = tag;
    this._consumer = consumer;
    this._backing = initialValues;
    this._backingMutable = false;
  }
  DelegatingMap.prototype._get_size__45 = function () {
    return this._backing._get_size__45();
  };
  DelegatingMap.prototype.isEmpty_53 = function () {
    return this._backing.isEmpty_53();
  };
  DelegatingMap.prototype.containsKey_13 = function (key) {
    return this._backing.containsKey_16(key);
  };
  DelegatingMap.prototype.containsKey_16 = function (key) {
    if (!(!(key == null) ? typeof key === 'string' : false))
      return false;
    else {
    }
    return this.containsKey_13((!(key == null) ? typeof key === 'string' : false) ? key : THROW_CCE());
  };
  DelegatingMap.prototype.get_69 = function (key) {
    return this._backing.get_63(key);
  };
  DelegatingMap.prototype.get_63 = function (key) {
    if (!(!(key == null) ? typeof key === 'string' : false))
      return null;
    else {
    }
    return this.get_69((!(key == null) ? typeof key === 'string' : false) ? key : THROW_CCE());
  };
  DelegatingMap.prototype.put_6 = function (key, value) {
    var mutable = switchToMutable(this);
    var old = mutable.put_12(key, value);
    if (!(old === value)) {
      this._consumer().onTagAttributeChange_0(this._tag, key, value);
    }return old;
  };
  DelegatingMap.prototype.put_12 = function (key, value) {
    var tmp = (!(key == null) ? typeof key === 'string' : false) ? key : THROW_CCE();
    return this.put_6(tmp, (!(value == null) ? typeof value === 'string' : false) ? value : THROW_CCE());
  };
  DelegatingMap.prototype.remove_38 = function (key) {
    var mutable = switchToMutable(this);
    var tmp0_safe_receiver = mutable.remove_45(key);
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      this._consumer().onTagAttributeChange_0(this._tag, key, null);
      tmp = tmp0_safe_receiver;
    }
    return tmp;
  };
  DelegatingMap.prototype.remove_45 = function (key) {
    if (!(!(key == null) ? typeof key === 'string' : false))
      return null;
    else {
    }
    return this.remove_38((!(key == null) ? typeof key === 'string' : false) ? key : THROW_CCE());
  };
  DelegatingMap.prototype.putAll_3 = function (from) {
    if (from.isEmpty_53())
      return Unit_getInstance();
    var consumer = this._consumer();
    var mutable = switchToMutable(this);
    var tmp0_forEach_0 = from._get_entries__10();
    var tmp0_iterator_1 = tmp0_forEach_0.iterator_64();
    while (tmp0_iterator_1.hasNext_31()) {
      var element_2 = tmp0_iterator_1.next_35();
      if (!(mutable.put_12(element_2._get_key__47(), element_2._get_value__33()) === element_2._get_value__33())) {
        consumer.onTagAttributeChange_0(this._tag, element_2._get_key__47(), element_2._get_value__33());
      }}
  };
  DelegatingMap.prototype.putAll_8 = function (from) {
    return this.putAll_3(from);
  };
  DelegatingMap.prototype.clear_27 = function () {
    var tmp0_forEach_0 = this._backing;
    var tmp0_iterator_1 = tmp0_forEach_0._get_entries__10().iterator_64();
    while (tmp0_iterator_1.hasNext_31()) {
      var element_2 = tmp0_iterator_1.next_35();
      this._consumer().onTagAttributeChange_0(this._tag, element_2._get_key__47(), null);
    }
    this._backing = emptyMap();
    this._backingMutable = false;
  };
  DelegatingMap.prototype._get_immutableEntries_ = function () {
    return this._backing._get_entries__10();
  };
  DelegatingMap.prototype._get_keys__10 = function () {
    return switchToMutable(this)._get_keys__10();
  };
  DelegatingMap.prototype._get_values__16 = function () {
    return switchToMutable(this)._get_values__16();
  };
  DelegatingMap.prototype._get_entries__10 = function () {
    return switchToMutable(this)._get_entries__10();
  };
  DelegatingMap.$metadata$ = {
    simpleName: 'DelegatingMap',
    kind: 'class',
    interfaces: [MutableMap]
  };
  function CommonAttributeGroupFacade() {
  }
  CommonAttributeGroupFacade.$metadata$ = {
    simpleName: 'CommonAttributeGroupFacade',
    kind: 'interface',
    interfaces: [Tag]
  };
  var attributeStringString;
  var attributeBooleanTicker;
  var attributeInputTypeEnumInputTypeValues;
  var inputTypeValues;
  var InputType_button_instance;
  var InputType_checkBox_instance;
  var InputType_color_instance;
  var InputType_date_instance;
  var InputType_dateTime_instance;
  var InputType_dateTimeLocal_instance;
  var InputType_email_instance;
  var InputType_file_instance;
  var InputType_hidden_instance;
  var InputType_image_instance;
  var InputType_month_instance;
  var InputType_number_instance;
  var InputType_password_instance;
  var InputType_radio_instance;
  var InputType_range_instance;
  var InputType_reset_instance;
  var InputType_search_instance;
  var InputType_submit_instance;
  var InputType_text_instance;
  var InputType_tel_instance;
  var InputType_time_instance;
  var InputType_url_instance;
  var InputType_week_instance;
  function values_0() {
    return [InputType_button_getInstance(), InputType_checkBox_getInstance(), InputType_color_getInstance(), InputType_date_getInstance(), InputType_dateTime_getInstance(), InputType_dateTimeLocal_getInstance(), InputType_email_getInstance(), InputType_file_getInstance(), InputType_hidden_getInstance(), InputType_image_getInstance(), InputType_month_getInstance(), InputType_number_getInstance(), InputType_password_getInstance(), InputType_radio_getInstance(), InputType_range_getInstance(), InputType_reset_getInstance(), InputType_search_getInstance(), InputType_submit_getInstance(), InputType_text_getInstance(), InputType_tel_getInstance(), InputType_time_getInstance(), InputType_url_getInstance(), InputType_week_getInstance()];
  }
  var InputType_entriesInitialized;
  function InputType_initEntries() {
    if (InputType_entriesInitialized)
      return Unit_getInstance();
    InputType_entriesInitialized = true;
    InputType_button_instance = new InputType('button', 0, 'button');
    InputType_checkBox_instance = new InputType('checkBox', 1, 'checkbox');
    InputType_color_instance = new InputType('color', 2, 'color');
    InputType_date_instance = new InputType('date', 3, 'date');
    InputType_dateTime_instance = new InputType('dateTime', 4, 'datetime');
    InputType_dateTimeLocal_instance = new InputType('dateTimeLocal', 5, 'datetime-local');
    InputType_email_instance = new InputType('email', 6, 'email');
    InputType_file_instance = new InputType('file', 7, 'file');
    InputType_hidden_instance = new InputType('hidden', 8, 'hidden');
    InputType_image_instance = new InputType('image', 9, 'image');
    InputType_month_instance = new InputType('month', 10, 'month');
    InputType_number_instance = new InputType('number', 11, 'number');
    InputType_password_instance = new InputType('password', 12, 'password');
    InputType_radio_instance = new InputType('radio', 13, 'radio');
    InputType_range_instance = new InputType('range', 14, 'range');
    InputType_reset_instance = new InputType('reset', 15, 'reset');
    InputType_search_instance = new InputType('search', 16, 'search');
    InputType_submit_instance = new InputType('submit', 17, 'submit');
    InputType_text_instance = new InputType('text', 18, 'text');
    InputType_tel_instance = new InputType('tel', 19, 'tel');
    InputType_time_instance = new InputType('time', 20, 'time');
    InputType_url_instance = new InputType('url', 21, 'url');
    InputType_week_instance = new InputType('week', 22, 'week');
  }
  function InputType(name, ordinal, realValue) {
    Enum.call(this, name, ordinal);
    this._realValue = realValue;
  }
  InputType.prototype._get_realValue__0 = function () {
    return this._realValue;
  };
  InputType.$metadata$ = {
    simpleName: 'InputType',
    kind: 'class',
    interfaces: [AttributeEnum]
  };
  function InputType_button_getInstance() {
    InputType_initEntries();
    return InputType_button_instance;
  }
  function InputType_checkBox_getInstance() {
    InputType_initEntries();
    return InputType_checkBox_instance;
  }
  function InputType_color_getInstance() {
    InputType_initEntries();
    return InputType_color_instance;
  }
  function InputType_date_getInstance() {
    InputType_initEntries();
    return InputType_date_instance;
  }
  function InputType_dateTime_getInstance() {
    InputType_initEntries();
    return InputType_dateTime_instance;
  }
  function InputType_dateTimeLocal_getInstance() {
    InputType_initEntries();
    return InputType_dateTimeLocal_instance;
  }
  function InputType_email_getInstance() {
    InputType_initEntries();
    return InputType_email_instance;
  }
  function InputType_file_getInstance() {
    InputType_initEntries();
    return InputType_file_instance;
  }
  function InputType_hidden_getInstance() {
    InputType_initEntries();
    return InputType_hidden_instance;
  }
  function InputType_image_getInstance() {
    InputType_initEntries();
    return InputType_image_instance;
  }
  function InputType_month_getInstance() {
    InputType_initEntries();
    return InputType_month_instance;
  }
  function InputType_number_getInstance() {
    InputType_initEntries();
    return InputType_number_instance;
  }
  function InputType_password_getInstance() {
    InputType_initEntries();
    return InputType_password_instance;
  }
  function InputType_radio_getInstance() {
    InputType_initEntries();
    return InputType_radio_instance;
  }
  function InputType_range_getInstance() {
    InputType_initEntries();
    return InputType_range_instance;
  }
  function InputType_reset_getInstance() {
    InputType_initEntries();
    return InputType_reset_instance;
  }
  function InputType_search_getInstance() {
    InputType_initEntries();
    return InputType_search_instance;
  }
  function InputType_submit_getInstance() {
    InputType_initEntries();
    return InputType_submit_instance;
  }
  function InputType_text_getInstance() {
    InputType_initEntries();
    return InputType_text_instance;
  }
  function InputType_tel_getInstance() {
    InputType_initEntries();
    return InputType_tel_instance;
  }
  function InputType_time_getInstance() {
    InputType_initEntries();
    return InputType_time_instance;
  }
  function InputType_url_getInstance() {
    InputType_initEntries();
    return InputType_url_instance;
  }
  function InputType_week_getInstance() {
    InputType_initEntries();
    return InputType_week_instance;
  }
  function inputTypeValues$init$() {
    var tmp0_associateBy_0 = values_0();
    var capacity_1 = coerceAtLeast(mapCapacity(tmp0_associateBy_0.length), 16);
    var tmp0_associateByTo_0_2 = LinkedHashMap_init_$Create$_1(capacity_1);
    var indexedObject = tmp0_associateBy_0;
    var inductionVariable = 0;
    var last_1 = indexedObject.length;
    while (inductionVariable < last_1) {
      var element_2_4 = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      tmp0_associateByTo_0_2.put_12(element_2_4._realValue, element_2_4);
      Unit_getInstance();
    }
    return tmp0_associateByTo_0_2;
  }
  function CommonAttributeGroupFacadeFlowInteractivePhrasingContent() {
  }
  CommonAttributeGroupFacadeFlowInteractivePhrasingContent.$metadata$ = {
    simpleName: 'CommonAttributeGroupFacadeFlowInteractivePhrasingContent',
    kind: 'interface',
    interfaces: [CommonAttributeGroupFacade, CommonAttributeGroupFacadeFlowInteractiveContent, FlowPhrasingContent, HtmlBlockInlineTag, HtmlBlockTag, HtmlInlineTag]
  };
  function HtmlBlockTag() {
  }
  HtmlBlockTag.$metadata$ = {
    simpleName: 'HtmlBlockTag',
    kind: 'interface',
    interfaces: [CommonAttributeGroupFacade, FlowContent]
  };
  function HtmlBlockInlineTag() {
  }
  HtmlBlockInlineTag.$metadata$ = {
    simpleName: 'HtmlBlockInlineTag',
    kind: 'interface',
    interfaces: [CommonAttributeGroupFacade, FlowPhrasingContent, HtmlBlockTag, HtmlInlineTag]
  };
  function CommonAttributeGroupFacadeFlowInteractiveContent() {
  }
  CommonAttributeGroupFacadeFlowInteractiveContent.$metadata$ = {
    simpleName: 'CommonAttributeGroupFacadeFlowInteractiveContent',
    kind: 'interface',
    interfaces: [CommonAttributeGroupFacade, HtmlBlockTag, InteractiveContent]
  };
  function FlowPhrasingContent() {
  }
  FlowPhrasingContent.$metadata$ = {
    simpleName: 'FlowPhrasingContent',
    kind: 'interface',
    interfaces: [FlowContent, PhrasingContent]
  };
  function HtmlInlineTag() {
  }
  HtmlInlineTag.$metadata$ = {
    simpleName: 'HtmlInlineTag',
    kind: 'interface',
    interfaces: [CommonAttributeGroupFacade, PhrasingContent]
  };
  function FlowContent() {
  }
  FlowContent.$metadata$ = {
    simpleName: 'FlowContent',
    kind: 'interface',
    interfaces: [FlowOrHeadingContent, FlowOrMetaDataContent, FlowOrInteractiveContent, FlowOrPhrasingContent, FlowOrPhrasingOrMetaDataContent, SectioningOrFlowContent, FlowOrInteractiveOrPhrasingContent, Tag]
  };
  function InteractiveContent() {
  }
  InteractiveContent.$metadata$ = {
    simpleName: 'InteractiveContent',
    kind: 'interface',
    interfaces: [FlowOrInteractiveContent, FlowOrInteractiveOrPhrasingContent, Tag]
  };
  function PhrasingContent() {
  }
  PhrasingContent.$metadata$ = {
    simpleName: 'PhrasingContent',
    kind: 'interface',
    interfaces: [FlowOrPhrasingContent, FlowOrPhrasingOrMetaDataContent, FlowOrInteractiveOrPhrasingContent, Tag]
  };
  function FlowOrHeadingContent() {
  }
  FlowOrHeadingContent.$metadata$ = {
    simpleName: 'FlowOrHeadingContent',
    kind: 'interface',
    interfaces: [Tag]
  };
  function FlowOrMetaDataContent() {
  }
  FlowOrMetaDataContent.$metadata$ = {
    simpleName: 'FlowOrMetaDataContent',
    kind: 'interface',
    interfaces: [FlowOrPhrasingOrMetaDataContent, Tag]
  };
  function FlowOrInteractiveContent() {
  }
  FlowOrInteractiveContent.$metadata$ = {
    simpleName: 'FlowOrInteractiveContent',
    kind: 'interface',
    interfaces: [FlowOrInteractiveOrPhrasingContent, Tag]
  };
  function FlowOrPhrasingContent() {
  }
  FlowOrPhrasingContent.$metadata$ = {
    simpleName: 'FlowOrPhrasingContent',
    kind: 'interface',
    interfaces: [FlowOrInteractiveOrPhrasingContent, FlowOrPhrasingOrMetaDataContent, Tag]
  };
  function FlowOrPhrasingOrMetaDataContent() {
  }
  FlowOrPhrasingOrMetaDataContent.$metadata$ = {
    simpleName: 'FlowOrPhrasingOrMetaDataContent',
    kind: 'interface',
    interfaces: [Tag]
  };
  function SectioningOrFlowContent() {
  }
  SectioningOrFlowContent.$metadata$ = {
    simpleName: 'SectioningOrFlowContent',
    kind: 'interface',
    interfaces: [Tag]
  };
  function FlowOrInteractiveOrPhrasingContent() {
  }
  FlowOrInteractiveOrPhrasingContent.$metadata$ = {
    simpleName: 'FlowOrInteractiveOrPhrasingContent',
    kind: 'interface',
    interfaces: [Tag]
  };
  function BUTTON(initialAttributes, consumer) {
    HTMLTag.call(this, 'button', consumer, initialAttributes, null, true, false);
    this._consumer_0 = consumer;
  }
  BUTTON.prototype._get_consumer__7 = function () {
    return this._consumer_0;
  };
  BUTTON.$metadata$ = {
    simpleName: 'BUTTON',
    kind: 'class',
    interfaces: [CommonAttributeGroupFacadeFlowInteractivePhrasingContent]
  };
  function BR(initialAttributes, consumer) {
    HTMLTag.call(this, 'br', consumer, initialAttributes, null, true, true);
    this._consumer_1 = consumer;
  }
  BR.prototype._get_consumer__7 = function () {
    return this._consumer_1;
  };
  BR.$metadata$ = {
    simpleName: 'BR',
    kind: 'class',
    interfaces: [HtmlBlockInlineTag]
  };
  function B(initialAttributes, consumer) {
    HTMLTag.call(this, 'b', consumer, initialAttributes, null, true, false);
    this._consumer_2 = consumer;
  }
  B.prototype._get_consumer__7 = function () {
    return this._consumer_2;
  };
  B.$metadata$ = {
    simpleName: 'B',
    kind: 'class',
    interfaces: [HtmlBlockInlineTag]
  };
  function DIV(initialAttributes, consumer) {
    HTMLTag.call(this, 'div', consumer, initialAttributes, null, false, false);
    this._consumer_3 = consumer;
  }
  DIV.prototype._get_consumer__7 = function () {
    return this._consumer_3;
  };
  DIV.$metadata$ = {
    simpleName: 'DIV',
    kind: 'class',
    interfaces: [HtmlBlockTag]
  };
  function FORM(initialAttributes, consumer) {
    HTMLTag.call(this, 'form', consumer, initialAttributes, null, false, false);
    this._consumer_4 = consumer;
  }
  FORM.prototype._get_consumer__7 = function () {
    return this._consumer_4;
  };
  FORM.$metadata$ = {
    simpleName: 'FORM',
    kind: 'class',
    interfaces: [HtmlBlockTag]
  };
  function INPUT(initialAttributes, consumer) {
    HTMLTag.call(this, 'input', consumer, initialAttributes, null, true, true);
    this._consumer_5 = consumer;
  }
  INPUT.prototype._get_consumer__7 = function () {
    return this._consumer_5;
  };
  INPUT.prototype._set_type_ = function (newValue) {
    attributeInputTypeEnumInputTypeValues.set_8(this, 'type', newValue);
  };
  INPUT.prototype._set_autoFocus_ = function (newValue) {
    attributeBooleanTicker.set_8(this, 'autofocus', newValue);
  };
  INPUT.prototype._set_disabled_ = function (newValue) {
    attributeBooleanTicker.set_8(this, 'disabled', newValue);
  };
  INPUT.prototype._set_maxLength_ = function (newValue) {
    attributeStringString.set_8(this, 'maxlength', newValue);
  };
  INPUT.prototype._set_placeholder_ = function (newValue) {
    attributeStringString.set_8(this, 'placeholder', newValue);
  };
  INPUT.prototype._set_value__2 = function (newValue) {
    attributeStringString.set_8(this, 'value', newValue);
  };
  INPUT.prototype._set_name_ = function (newValue) {
    attributeStringString.set_8(this, 'name', newValue);
  };
  INPUT.$metadata$ = {
    simpleName: 'INPUT',
    kind: 'class',
    interfaces: [CommonAttributeGroupFacadeFlowInteractivePhrasingContent]
  };
  function P(initialAttributes, consumer) {
    HTMLTag.call(this, 'p', consumer, initialAttributes, null, false, false);
    this._consumer_6 = consumer;
  }
  P.prototype._get_consumer__7 = function () {
    return this._consumer_6;
  };
  P.$metadata$ = {
    simpleName: 'P',
    kind: 'class',
    interfaces: [HtmlBlockInlineTag]
  };
  function _no_name_provided__89(this$0) {
    this._this$0_27 = this$0;
  }
  _no_name_provided__89.prototype.invoke_540 = function () {
    return this._this$0_27._get_consumer__7();
  };
  _no_name_provided__89.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function HTMLTag(tagName, consumer, initialAttributes, namespace, inlineTag, emptyTag) {
    this._tagName = tagName;
    this._consumer_7 = consumer;
    this._namespace = namespace;
    this._inlineTag = inlineTag;
    this._emptyTag = emptyTag;
    var tmp = this;
    tmp._attributes = new DelegatingMap(initialAttributes, this, _no_name_provided_$factory_68(this));
  }
  HTMLTag.prototype._get_tagName__7 = function () {
    return this._tagName;
  };
  HTMLTag.prototype._get_consumer__7 = function () {
    return this._consumer_7;
  };
  HTMLTag.prototype._get_attributes__12 = function () {
    return this._attributes;
  };
  HTMLTag.prototype._get_attributesEntries__7 = function () {
    return this._get_attributes__12()._get_immutableEntries_();
  };
  HTMLTag.$metadata$ = {
    simpleName: 'HTMLTag',
    kind: 'class',
    interfaces: [Tag]
  };
  function _no_name_provided_$factory_68(this$0) {
    var i = new _no_name_provided__89(this$0);
    return function () {
      return i.invoke_540();
    };
  }
  function _set_onClickFunction_(_this_, newValue) {
    _this_._get_consumer__7().onTagEvent_0(_this_, 'onclick', newValue);
  }
  function _set_onSubmitFunction_(_this_, newValue) {
    _this_._get_consumer__7().onTagEvent_0(_this_, 'onsubmit', newValue);
  }
  function _set_onChangeFunction_(_this_, newValue) {
    _this_._get_consumer__7().onTagEvent_0(_this_, 'onchange', newValue);
  }
  function _no_name_provided__90(this$0) {
    this._this$0_28 = this$0;
  }
  _no_name_provided__90.prototype.onTagAttributeChange_0 = function (tag, attribute, value) {
    this._this$0_28.setProp_0(attribute, value);
  };
  _no_name_provided__90.prototype.onTagEvent_0 = function (tag, event, value) {
    this._this$0_28.setProp_0(event, value);
  };
  _no_name_provided__90.$metadata$ = {
    kind: 'class',
    interfaces: [TagConsumer]
  };
  function RDOMBuilder(factory) {
    RBuilder.call(this);
    var tmp = this;
    tmp._consumer_8 = new _no_name_provided__90(this);
    this._attrs_0 = factory(this._consumer_8);
    var tmp_0 = this;
    tmp_0._props = {};
    var tmp0_forEach_0 = this._attrs_0._get_attributesEntries__7();
    var tmp0_iterator_1 = tmp0_forEach_0.iterator_64();
    while (tmp0_iterator_1.hasNext_31()) {
      var element_2 = tmp0_iterator_1.next_35();
      this.setProp_0(element_2._get_key__47(), element_2._get_value__33());
    }
  }
  RDOMBuilder.prototype.setProp_0 = function (attribute, value) {
    var key = fixAttributeName(attribute);
    var tmp0_asDynamic_0 = this._props;
    tmp0_asDynamic_0[key] = value;
  };
  RDOMBuilder.prototype._get_attrs__1 = function () {
    return this._attrs_0;
  };
  RDOMBuilder.prototype._get_props__0 = function () {
    return this._props;
  };
  RDOMBuilder.prototype._set_ref__0 = function (value) {
    _set_ref_(this._props, value);
  };
  RDOMBuilder.prototype.create_1 = function () {
    var tmp = this._attrs_0._get_tagName__7();
    var tmp0_toTypedArray_0 = this._get_childList__2();
    return createElement.apply(null, [tmp, this._props].concat([].slice.call(copyToArray_0(tmp0_toTypedArray_0).slice())));
  };
  RDOMBuilder.$metadata$ = {
    simpleName: 'RDOMBuilder',
    kind: 'class',
    interfaces: []
  };
  function render_0(container, callback, handler) {
    return render(buildElements(handler), container, callback);
  }
  function render$default(container, callback, handler, $mask0, $handler) {
    if (!(($mask0 & 2) === 0)) {
      callback = _no_name_provided_$factory_69();
    }return render_0(container, callback, handler);
  }
  function _no_name_provided__91() {
  }
  _no_name_provided__91.prototype.invoke_494 = function () {
    return Unit_getInstance();
  };
  _no_name_provided__91.prototype.invoke_540 = function () {
    this.invoke_494();
    return Unit_getInstance();
  };
  _no_name_provided__91.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided_$factory_69() {
    var i = new _no_name_provided__91();
    return function () {
      i.invoke_494();
      return Unit_getInstance();
    };
  }
  var events;
  var attrsMap;
  var key$delegate;
  var defaultValue$delegate;
  var defaultValue$delegate_0;
  var value$delegate;
  function StringAttr() {
    StringAttr_instance = this;
  }
  StringAttr.$metadata$ = {
    simpleName: 'StringAttr',
    kind: 'object',
    interfaces: []
  };
  var StringAttr_instance;
  function StringAttr_getInstance() {
    if (StringAttr_instance == null)
      new StringAttr();
    return StringAttr_instance;
  }
  function fixAttributeName(event) {
    var tmp0_elvis_lhs = attrsMap.get_63(event);
    return tmp0_elvis_lhs == null ? event : tmp0_elvis_lhs;
  }
  function attrsMap$init$() {
    var tmp0_map_0 = events;
    var tmp0_mapTo_0_1 = ArrayList_init_$Create$_0(collectionSizeOrDefault(tmp0_map_0, 10));
    var tmp0_iterator_1_2 = tmp0_map_0.iterator_64();
    while (tmp0_iterator_1_2.hasNext_31()) {
      var item_2_3 = tmp0_iterator_1_2.next_35();
      tmp0_mapTo_0_1.add_33(to(item_2_3.toLowerCase(), item_2_3));
      Unit_getInstance();
    }
    var tmp1_apply_0 = toMutableMap(toMap(tmp0_mapTo_0_1));
    tmp1_apply_0.put_12('class', 'className');
    Unit_getInstance();
    tmp1_apply_0.put_12('ondblclick', 'onDoubleClick');
    Unit_getInstance();
    return tmp1_apply_0;
  }
  function _no_name_provided__92() {
  }
  _no_name_provided__92.prototype.invoke_540 = function () {
    return Regex_init_$Create$_0('^(&?)(.*)$');
  };
  _no_name_provided__92.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function CSSBuilder_init_$Init$(indent, allowClasses, parent, $mask0, $marker, $this) {
    if (!(($mask0 & 1) === 0))
      indent = '';
    if (!(($mask0 & 2) === 0))
      allowClasses = true;
    if (!(($mask0 & 4) === 0))
      parent = null;
    CSSBuilder.call($this, indent, allowClasses, parent);
    return $this;
  }
  function CSSBuilder_init_$Create$(indent, allowClasses, parent, $mask0, $marker) {
    return CSSBuilder_init_$Init$(indent, allowClasses, parent, $mask0, $marker, Object.create(CSSBuilder.prototype));
  }
  function Companion_22() {
    Companion_instance_21 = this;
    var tmp = this;
    tmp._NOT_REGEX$delegate = lazy(_no_name_provided_$factory_71());
  }
  Companion_22.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_21;
  function Companion_getInstance_21() {
    if (Companion_instance_21 == null)
      new Companion_22();
    return Companion_instance_21;
  }
  function _no_name_provided__93($block) {
    this._$block = $block;
  }
  _no_name_provided__93.prototype.invoke_534 = function ($this$invoke) {
    _set_content_($this$invoke, _get_quoted_(''));
    this._$block($this$invoke);
  };
  _no_name_provided__93.prototype.invoke_542 = function (p1) {
    this.invoke_534(p1 instanceof CSSBuilder ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__93.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function CSSBuilder(indent, allowClasses, parent) {
    Companion_getInstance_21();
    StyledElement.call(this);
    this._indent = indent;
    this._allowClasses = allowClasses;
    this._parent_0 = parent;
    var tmp = this;
    tmp._classes = ArrayList_init_$Create$();
    var tmp_0 = this;
    tmp_0._styleName = ArrayList_init_$Create$();
    var tmp_1 = this;
    tmp_1._rules = ArrayList_init_$Create$();
    var tmp_2 = this;
    tmp_2._multiRules = ArrayList_init_$Create$();
  }
  CSSBuilder.prototype.toString = function () {
    var tmp0_apply_0_1 = StringBuilder_init_$Create$_0();
    var tmp0_forEach_0_3 = this._get_declarations__0();
    var tmp0_iterator_1_4 = tmp0_forEach_0_3._get_entries__10().iterator_64();
    while (tmp0_iterator_1_4.hasNext_31()) {
      var element_2_5 = tmp0_iterator_1_4.next_35();
      tmp0_apply_0_1.append_7('' + hyphenize(element_2_5._get_key__47()) + ': ' + element_2_5._get_value__33() + ';\n');
      Unit_getInstance();
    }
    this.buildRules_1(tmp0_apply_0_1, this._indent);
    return tmp0_apply_0_1.toString();
  };
  CSSBuilder.prototype._get_rules__1 = function () {
    return this._rules;
  };
  CSSBuilder.prototype._get_multiRules__1 = function () {
    return this._multiRules;
  };
  CSSBuilder.prototype.invoke_146 = function (_this__0, block) {
    return this.rule$default_1(_this__0, false, false, block, 4, null);
  };
  CSSBuilder.prototype.disabled_0 = function (block) {
    return this.invoke_146('&:disabled', block);
  };
  CSSBuilder.prototype.after_0 = function (block) {
    return this.invoke_146('&::after', _no_name_provided_$factory_70(block));
  };
  CSSBuilder.prototype.placeholder_0 = function (block) {
    this.invoke_146('&::placeholder', block);
    Unit_getInstance();
    this.invoke_146('&::-webkit-input-placeholder', block);
    Unit_getInstance();
    this.invoke_146('&::-moz-placeholder', block);
    Unit_getInstance();
    this.invoke_146('&::-ms-input-placeholder', block);
    Unit_getInstance();
    this.invoke_146('&:-moz-placeholder', block);
    Unit_getInstance();
  };
  CSSBuilder.$metadata$ = {
    simpleName: 'CSSBuilder',
    kind: 'class',
    interfaces: [RuleContainer]
  };
  function Rule(selector, passStaticClassesToParent, block) {
    this._selector = selector;
    this._passStaticClassesToParent = passStaticClassesToParent;
    this._block = block;
  }
  Rule.prototype.component1_4 = function () {
    return this._selector;
  };
  Rule.prototype.component2_4 = function () {
    return this._passStaticClassesToParent;
  };
  Rule.prototype.component3 = function () {
    return this._block;
  };
  Rule.prototype.toString = function () {
    return '' + 'Rule(selector=' + this._selector + ', passStaticClassesToParent=' + this._passStaticClassesToParent + ', block=' + this._block + ')';
  };
  Rule.prototype.hashCode = function () {
    var result = getStringHashCode(this._selector);
    result = imul(result, 31) + (this._passStaticClassesToParent | 0) | 0;
    result = imul(result, 31) + hashCode(this._block) | 0;
    return result;
  };
  Rule.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Rule))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof Rule ? other : THROW_CCE();
    if (!(this._selector === tmp0_other_with_cast._selector))
      return false;
    if (!(this._passStaticClassesToParent === tmp0_other_with_cast._passStaticClassesToParent))
      return false;
    if (!equals_1(this._block, tmp0_other_with_cast._block))
      return false;
    return true;
  };
  Rule.$metadata$ = {
    simpleName: 'Rule',
    kind: 'class',
    interfaces: []
  };
  function RuleContainer() {
  }
  RuleContainer.prototype.buildRules_1 = function (_this__0, indent) {
    var resolvedRules = LinkedHashMap_init_$Create$();
    var tmp0_forEach_0 = this._get_rules__1();
    var tmp0_iterator_1 = tmp0_forEach_0.iterator_64();
    while (tmp0_iterator_1.hasNext_31()) {
      var element_2 = tmp0_iterator_1.next_35();
      var selector_4 = element_2.component1_4();
      var passStaticClassesToParent_5 = element_2.component2_4();
      var block_6 = element_2.component3();
      if (!resolvedRules.containsKey_16(selector_4)) {
        var tmp0_set_0_7 = new CSSBuilder('' + indent + '  ', false, passStaticClassesToParent_5 ? this : null);
        resolvedRules.put_12(selector_4, tmp0_set_0_7);
        Unit_getInstance();
      }var rule_8 = ensureNotNull(resolvedRules.get_63(selector_4));
      block_6(rule_8);
    }
    var tmp0_iterator_1_0 = resolvedRules._get_entries__10().iterator_64();
    while (tmp0_iterator_1_0.hasNext_31()) {
      var element_2_0 = tmp0_iterator_1_0.next_35();
      _this__0.append_7('' + element_2_0._get_key__47() + ' {\n');
      Unit_getInstance();
      _this__0.append_5(element_2_0._get_value__33());
      Unit_getInstance();
      _this__0.append_7('}\n');
      Unit_getInstance();
    }
    var tmp1_forEach_0 = this._get_multiRules__1();
    var tmp0_iterator_1_1 = tmp1_forEach_0.iterator_64();
    while (tmp0_iterator_1_1.hasNext_31()) {
      var element_2_1 = tmp0_iterator_1_1.next_35();
      var selector_4_0 = element_2_1.component1_4();
      var passStaticClassesToParent_5_0 = element_2_1.component2_4();
      var block_6_0 = element_2_1.component3();
      var tmp0_apply_0_8 = new CSSBuilder('' + indent + '  ', false, passStaticClassesToParent_5_0 ? this : null);
      block_6_0(tmp0_apply_0_8);
      var blockBuilder_7 = tmp0_apply_0_8;
      _this__0.append_7('' + selector_4_0 + ' {\n');
      Unit_getInstance();
      _this__0.append_5(blockBuilder_7);
      Unit_getInstance();
      _this__0.append_7('}\n');
      Unit_getInstance();
    }
  };
  RuleContainer.prototype.rule_2 = function (selector, block) {
    return this.rule$default_1(selector, false, false, block, 4, null);
  };
  RuleContainer.prototype.rule_3 = function (selector, passStaticClassesToParent, repeatable, block) {
    var tmp0_apply_0 = new Rule(selector, passStaticClassesToParent, block);
    (repeatable ? this._get_multiRules__1() : this._get_rules__1()).add_33(tmp0_apply_0);
    Unit_getInstance();
    return tmp0_apply_0;
  };
  RuleContainer.prototype.rule$default_1 = function (selector, passStaticClassesToParent, repeatable, block, $mask0, $handler) {
    if (!(($mask0 & 4) === 0))
      repeatable = false;
    return $handler == null ? this.rule_3(selector, passStaticClassesToParent, repeatable, block) : $handler(selector, passStaticClassesToParent, repeatable, block);
  };
  RuleContainer.$metadata$ = {
    simpleName: 'RuleContainer',
    kind: 'interface',
    interfaces: []
  };
  function _no_name_provided_$factory_70($block) {
    var i = new _no_name_provided__93($block);
    return function (p1) {
      i.invoke_534(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_71() {
    var i = new _no_name_provided__92();
    return function () {
      return i.invoke_540();
    };
  }
  var CAPITAL_LETTER;
  function hyphenize(_this_) {
    var tmp0_replace_0 = CAPITAL_LETTER;
    var tmp1_replace_0 = _no_name_provided_$factory_72();
    var tmp$ret$0;
    l$ret$1: do {
      var match_1_1 = tmp0_replace_0.find$default(_this_, 0, 2, null);
      if (match_1_1 == null) {
        tmp$ret$0 = toString_1(_this_);
        break l$ret$1;
      }var lastStart_2_2 = 0;
      var length_3_3 = charSequenceLength(_this_);
      var sb_4_4 = StringBuilder_init_$Create$(length_3_3);
      do {
        var foundMatch_5_5 = ensureNotNull(match_1_1);
        sb_4_4.append_30(_this_, lastStart_2_2, foundMatch_5_5._get_range__0()._get_start__1());
        Unit_getInstance();
        sb_4_4.append_31(tmp1_replace_0(foundMatch_5_5));
        Unit_getInstance();
        lastStart_2_2 = foundMatch_5_5._get_range__0()._get_endInclusive__1() + 1 | 0;
        match_1_1 = foundMatch_5_5.next_35();
      }
       while (lastStart_2_2 < length_3_3 ? !(match_1_1 == null) : false);
      if (lastStart_2_2 < length_3_3) {
        sb_4_4.append_30(_this_, lastStart_2_2, length_3_3);
        Unit_getInstance();
      }tmp$ret$0 = sb_4_4.toString();
    }
     while (false);
    return tmp$ret$0;
  }
  function times(_this_, n) {
    return repeat(_this_, n);
  }
  function _no_name_provided__94() {
  }
  _no_name_provided__94.prototype.invoke_235 = function (it) {
    var tmp0_toLowerCase_0 = it._get_value__33();
    return '' + '-' + tmp0_toLowerCase_0.toLowerCase();
  };
  _no_name_provided__94.prototype.invoke_542 = function (p1) {
    return this.invoke_235((!(p1 == null) ? isInterface(p1, MatchResult) : false) ? p1 : THROW_CCE());
  };
  _no_name_provided__94.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided_$factory_72() {
    var i = new _no_name_provided__94();
    return function (p1) {
      return i.invoke_235(p1);
    };
  }
  function Companion_23() {
    Companion_instance_22 = this;
    this._none = new LinearDimension('none');
    this._auto = new LinearDimension('auto');
    this._initial = new LinearDimension('initial');
    this._inherit = new LinearDimension('inherit');
    this._available = new LinearDimension('available');
    this._fillAvailable = new LinearDimension('fill-available');
    this._borderBox = new LinearDimension('border-box');
    this._contentBox = new LinearDimension('content-box');
    this._maxContent = new LinearDimension('max-content');
    this._minContent = new LinearDimension('min-content');
    this._fitContent = new LinearDimension('fit-content');
  }
  Companion_23.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_22;
  function Companion_getInstance_22() {
    if (Companion_instance_22 == null)
      new Companion_23();
    return Companion_instance_22;
  }
  function LinearDimension(value) {
    Companion_getInstance_22();
    CssValue.call(this, value);
    this._value_14 = value;
  }
  LinearDimension.prototype._get_value__33 = function () {
    return this._value_14;
  };
  LinearDimension.$metadata$ = {
    simpleName: 'LinearDimension',
    kind: 'class',
    interfaces: []
  };
  var Align_initial_instance;
  var Align_inherit_instance;
  var Align_unset_instance;
  var Align_auto_instance;
  var Align_stretch_instance;
  var Align_center_instance;
  var Align_start_instance;
  var Align_end_instance;
  var Align_selfStart_instance;
  var Align_selfEnd_instance;
  var Align_flexStart_instance;
  var Align_flexEnd_instance;
  var Align_baseline_instance;
  var Align_entriesInitialized;
  function Align_initEntries() {
    if (Align_entriesInitialized)
      return Unit_getInstance();
    Align_entriesInitialized = true;
    Align_initial_instance = new Align('initial', 0);
    Align_inherit_instance = new Align('inherit', 1);
    Align_unset_instance = new Align('unset', 2);
    Align_auto_instance = new Align('auto', 3);
    Align_stretch_instance = new Align('stretch', 4);
    Align_center_instance = new Align('center', 5);
    Align_start_instance = new Align('start', 6);
    Align_end_instance = new Align('end', 7);
    Align_selfStart_instance = new Align('selfStart', 8);
    Align_selfEnd_instance = new Align('selfEnd', 9);
    Align_flexStart_instance = new Align('flexStart', 10);
    Align_flexEnd_instance = new Align('flexEnd', 11);
    Align_baseline_instance = new Align('baseline', 12);
  }
  function Align(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  Align.prototype.toString = function () {
    return hyphenize(this._get_name__10());
  };
  Align.$metadata$ = {
    simpleName: 'Align',
    kind: 'class',
    interfaces: []
  };
  function _get_HSLA_REGEX_($this) {
    var tmp0_getValue_0 = $this._HSLA_REGEX$delegate;
    var tmp1_getValue_0 = HSLA_REGEX$factory();
    return tmp0_getValue_0._get_value__33();
  }
  function _get_RGBA_REGEX_($this) {
    var tmp0_getValue_0 = $this._RGBA_REGEX$delegate;
    var tmp1_getValue_0 = RGBA_REGEX$factory();
    return tmp0_getValue_0._get_value__33();
  }
  function _no_name_provided__95() {
  }
  _no_name_provided__95.prototype.invoke_540 = function () {
    return Regex_init_$Create$('^hsla?\\((-?[0-9]+\\.?[0-9]*(?:deg|grad|rad|turn)?)\\s*[, ]?\\s*(\\d{1,3})%\\s*[, ]\\s*(\\d{1,3})%\\s*[, ]?\\s*(\\d|(?:\\d?\\.\\d+))?\\)$', RegexOption_IGNORE_CASE_getInstance());
  };
  _no_name_provided__95.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__96() {
  }
  _no_name_provided__96.prototype.invoke_540 = function () {
    return Regex_init_$Create$('^rgba?\\((\\d{1,3}%?)\\s*[, ]\\s*(\\d{1,3}%?)\\s*[, ]\\s*(\\d{1,3}%?)[, ]?\\s*(\\d|(?:\\d?\\.\\d+))?\\)$', RegexOption_IGNORE_CASE_getInstance());
  };
  _no_name_provided__96.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function RGBA_init_$Init$(red, green, blue, alpha, $mask0, $marker, $this) {
    if (!(($mask0 & 8) === 0))
      alpha = 1.0;
    RGBA.call($this, red, green, blue, alpha);
    return $this;
  }
  function RGBA_init_$Create$(red, green, blue, alpha, $mask0, $marker) {
    return RGBA_init_$Init$(red, green, blue, alpha, $mask0, $marker, Object.create(RGBA.prototype));
  }
  function Color_init_$Init$(value, rgb, $this) {
    Color.call($this, value);
    $this._rgb = rgb;
    return $this;
  }
  function Color_init_$Create$(value, rgb) {
    return Color_init_$Init$(value, rgb, Object.create(Color.prototype));
  }
  function Companion_24() {
    Companion_instance_23 = this;
    this._initial_0 = new Color('initial');
    this._inherit_0 = new Color('inherit');
    this._unset = new Color('unset');
    this._transparent = new Color('transparent');
    this._currentColor = new Color('currentColor');
    this._aliceBlue = Color_init_$Create$('aliceblue', '#f0f8ff');
    this._antiqueWhite = Color_init_$Create$('antiquewhite', '#faebd7');
    this._aqua = Color_init_$Create$('aqua', '#00ffff');
    this._aquamarine = Color_init_$Create$('aquamarine', '#7fffd4');
    this._azure = Color_init_$Create$('azure', '#f0ffff');
    this._beige = Color_init_$Create$('beige', '#f5f5dc');
    this._bisque = Color_init_$Create$('bisque', '#ffe4c4');
    this._black = Color_init_$Create$('black', '#000000');
    this._blanchedAlmond = Color_init_$Create$('blanchedalmond', '#ffebcd');
    this._blue = Color_init_$Create$('blue', '#0000ff');
    this._blueViolet = Color_init_$Create$('blueviolet', '#8a2be2');
    this._brown = Color_init_$Create$('brown', '#a52a2a');
    this._burlyWood = Color_init_$Create$('burlywood', '#deb887');
    this._cadetBlue = Color_init_$Create$('cadetblue', '#5f9ea0');
    this._chartreuse = Color_init_$Create$('chartreuse', '#7fff00');
    this._chocolate = Color_init_$Create$('chocolate', '#d2691e');
    this._coral = Color_init_$Create$('coral', '#ff7f50');
    this._cornflowerBlue = Color_init_$Create$('cornflowerblue', '#6495ed');
    this._cornsilk = Color_init_$Create$('cornsilk', '#fff8dc');
    this._crimson = Color_init_$Create$('crimson', '#dc143c');
    this._cyan = Color_init_$Create$('cyan', '#00ffff');
    this._darkBlue = Color_init_$Create$('darkblue', '#00008b');
    this._darkCyan = Color_init_$Create$('darkcyan', '#008b8b');
    this._darkGoldenrod = Color_init_$Create$('darkgoldenrod', '#b8860b');
    this._darkGray = Color_init_$Create$('darkgray', '#a9a9a9');
    this._darkGreen = Color_init_$Create$('darkgreen', '#006400');
    this._darkGrey = Color_init_$Create$('darkgrey', '#a9a9a9');
    this._darkKhaki = Color_init_$Create$('darkkhaki', '#bdb76b');
    this._darkMagenta = Color_init_$Create$('darkmagenta', '#8b008b');
    this._darkOliveGreen = Color_init_$Create$('darkolivegreen', '#556b2f');
    this._darkOrange = Color_init_$Create$('darkorange', '#ff8c00');
    this._darkOrchid = Color_init_$Create$('darkorchid', '#9932cc');
    this._darkRed = Color_init_$Create$('darkred', '#8b0000');
    this._darkSalmon = Color_init_$Create$('darksalmon', '#e9967a');
    this._darkSeaGreen = Color_init_$Create$('darkseagreen', '#8fbc8f');
    this._darkSlateBlue = Color_init_$Create$('darkslateblue', '#483d8b');
    this._darkSlateGray = Color_init_$Create$('darkslategray', '#2f4f4f');
    this._darkSlateGrey = Color_init_$Create$('darkslategrey', '#2f4f4f');
    this._darkTurquoise = Color_init_$Create$('darkturquoise', '#00ced1');
    this._darkViolet = Color_init_$Create$('darkviolet', '#9400d3');
    this._deepPink = Color_init_$Create$('deeppink', '#ff1493');
    this._deepSkyBlue = Color_init_$Create$('deepskyblue', '#00bfff');
    this._dimGray = Color_init_$Create$('dimgray', '#696969');
    this._dimGrey = Color_init_$Create$('dimgrey', '#696969');
    this._dodgerBlue = Color_init_$Create$('dodgerblue', '#1e90ff');
    this._firebrick = Color_init_$Create$('firebrick', '#b22222');
    this._floralWhite = Color_init_$Create$('floralwhite', '#fffaf0');
    this._forestGreen = Color_init_$Create$('forestgreen', '#228b22');
    this._fuchsia = Color_init_$Create$('fuchsia', '#ff00ff');
    this._gainsboro = Color_init_$Create$('gainsboro', '#dcdcdc');
    this._ghostWhite = Color_init_$Create$('ghostwhite', '#f8f8ff');
    this._gold = Color_init_$Create$('gold', '#ffd700');
    this._goldenrod = Color_init_$Create$('goldenrod', '#daa520');
    this._gray = Color_init_$Create$('gray', '#808080');
    this._green = Color_init_$Create$('green', '#008000');
    this._greenYellow = Color_init_$Create$('greenyellow', '#adff2f');
    this._grey = Color_init_$Create$('grey', '#808080');
    this._honeydew = Color_init_$Create$('honeydew', '#f0fff0');
    this._hotPink = Color_init_$Create$('hotpink', '#ff69b4');
    this._indianRed = Color_init_$Create$('indianred', '#cd5c5c');
    this._indigo = Color_init_$Create$('indigo', '#4b0082');
    this._ivory = Color_init_$Create$('ivory', '#fffff0');
    this._khaki = Color_init_$Create$('khaki', '#f0e68c');
    this._lavender = Color_init_$Create$('lavender', '#e6e6fa');
    this._lavenderBlush = Color_init_$Create$('lavenderblush', '#fff0f5');
    this._lawnGreen = Color_init_$Create$('lawngreen', '#7cfc00');
    this._lemonChiffon = Color_init_$Create$('lemonchiffon', '#fffacd');
    this._lightBlue = Color_init_$Create$('lightblue', '#add8e6');
    this._lightCoral = Color_init_$Create$('lightcoral', '#f08080');
    this._lightCyan = Color_init_$Create$('lightcyan', '#e0ffff');
    this._lightGoldenrodYellow = Color_init_$Create$('lightgoldenrodyellow', '#fafad2');
    this._lightGray = Color_init_$Create$('lightgray', '#d3d3d3');
    this._lightGreen = Color_init_$Create$('lightgreen', '#90ee90');
    this._lightGrey = Color_init_$Create$('lightgrey', '#d3d3d3');
    this._lightPink = Color_init_$Create$('lightpink', '#ffb6c1');
    this._lightSalmon = Color_init_$Create$('lightsalmon', '#ffa07a');
    this._lightSeaGreen = Color_init_$Create$('lightseagreen', '#20b2aa');
    this._lightSkyBlue = Color_init_$Create$('lightskyblue', '#87cefa');
    this._lightSlateGray = Color_init_$Create$('lightslategray', '#778899');
    this._lightSlateGrey = Color_init_$Create$('lightslategrey', '#778899');
    this._lightSteelBlue = Color_init_$Create$('lightsteelblue', '#b0c4de');
    this._lightYellow = Color_init_$Create$('lightyellow', '#ffffe0');
    this._lime = Color_init_$Create$('lime', '#00ff00');
    this._limeGreen = Color_init_$Create$('limegreen', '#32cd32');
    this._linen = Color_init_$Create$('linen', '#faf0e6');
    this._magenta = Color_init_$Create$('magenta', '#ff00ff');
    this._maroon = Color_init_$Create$('maroon', '#800000');
    this._mediumAquamarine = Color_init_$Create$('mediumaquamarine', '#66cdaa');
    this._mediumBlue = Color_init_$Create$('mediumblue', '#0000cd');
    this._mediumOrchid = Color_init_$Create$('mediumorchid', '#ba55d3');
    this._mediumPurple = Color_init_$Create$('mediumpurple', '#9370d8');
    this._mediumSeaGreen = Color_init_$Create$('mediumseagreen', '#3cb371');
    this._mediumSlateBlue = Color_init_$Create$('mediumslateblue', '#7b68ee');
    this._mediumSpringGreen = Color_init_$Create$('mediumspringgreen', '#00fa9a');
    this._mediumTurquoise = Color_init_$Create$('mediumturquoise', '#48d1cc');
    this._mediumVioletRed = Color_init_$Create$('mediumvioletred', '#c71585');
    this._midnightBlue = Color_init_$Create$('midnightblue', '#191970');
    this._mintCream = Color_init_$Create$('mintcream', '#f5fffa');
    this._mistyRose = Color_init_$Create$('mistyrose', '#ffe4e1');
    this._moccasin = Color_init_$Create$('moccasin', '#ffe4b5');
    this._navajoWhite = Color_init_$Create$('navajowhite', '#ffdead');
    this._navy = Color_init_$Create$('navy', '#000080');
    this._oldLace = Color_init_$Create$('oldlace', '#fdf5e6');
    this._olive = Color_init_$Create$('olive', '#808000');
    this._oliveDrab = Color_init_$Create$('olivedrab', '#6b8e23');
    this._orange = Color_init_$Create$('orange', '#ffa500');
    this._orangeRed = Color_init_$Create$('orangered', '#ff4500');
    this._orchid = Color_init_$Create$('orchid', '#da70d6');
    this._paleGoldenrod = Color_init_$Create$('palegoldenrod', '#eee8aa');
    this._paleGreen = Color_init_$Create$('palegreen', '#98fb98');
    this._paleTurquoise = Color_init_$Create$('paleturquoise', '#afeeee');
    this._paleVioletRed = Color_init_$Create$('palevioletred', '#db7093');
    this._papayaWhip = Color_init_$Create$('papayawhip', '#ffefd5');
    this._peachPuff = Color_init_$Create$('peachpuff', '#ffdab9');
    this._peru = Color_init_$Create$('peru', '#cd853f');
    this._pink = Color_init_$Create$('pink', '#ffc0cb');
    this._plum = Color_init_$Create$('plum', '#dda0dd');
    this._powderBlue = Color_init_$Create$('powderblue', '#b0e0e6');
    this._purple = Color_init_$Create$('purple', '#800080');
    this._red = Color_init_$Create$('red', '#ff0000');
    this._rosyBrown = Color_init_$Create$('rosybrown', '#bc8f8f');
    this._royalBlue = Color_init_$Create$('royalblue', '#4169e1');
    this._saddleBrown = Color_init_$Create$('saddlebrown', '#8b4513');
    this._salmon = Color_init_$Create$('salmon', '#fa8072');
    this._sandyBrown = Color_init_$Create$('sandybrown', '#f4a460');
    this._seaGreen = Color_init_$Create$('seagreen', '#2e8b57');
    this._seaShell = Color_init_$Create$('seashell', '#fff5ee');
    this._sienna = Color_init_$Create$('sienna', '#a0522d');
    this._silver = Color_init_$Create$('silver', '#c0c0c0');
    this._skyBlue = Color_init_$Create$('skyblue', '#87ceeb');
    this._slateBlue = Color_init_$Create$('slateblue', '#6a5acd');
    this._slateGray = Color_init_$Create$('slategray', '#708090');
    this._slateGrey = Color_init_$Create$('slategrey', '#708090');
    this._snow = Color_init_$Create$('snow', '#fffafa');
    this._springGreen = Color_init_$Create$('springgreen', '#00ff7f');
    this._steelBlue = Color_init_$Create$('steelblue', '#4682b4');
    this._tan = Color_init_$Create$('tan', '#d2b48c');
    this._teal = Color_init_$Create$('teal', '#008080');
    this._thistle = Color_init_$Create$('thistle', '#d8bfd8');
    this._tomato = Color_init_$Create$('tomato', '#ff6347');
    this._turquoise = Color_init_$Create$('turquoise', '#40e0d0');
    this._violet = Color_init_$Create$('violet', '#ee82ee');
    this._wheat = Color_init_$Create$('wheat', '#f5deb3');
    this._white = Color_init_$Create$('white', '#ffffff');
    this._whiteSmoke = Color_init_$Create$('whitesmoke', '#f5f5f5');
    this._yellow = Color_init_$Create$('yellow', '#ffff00');
    this._yellowGreen = Color_init_$Create$('yellowgreen', '#9acd32');
    var tmp = this;
    tmp._HSLA_REGEX$delegate = lazy(_no_name_provided_$factory_73());
    var tmp_0 = this;
    tmp_0._RGBA_REGEX$delegate = lazy(_no_name_provided_$factory_74());
  }
  Companion_24.prototype.normalizeFractionalPercent = function (value) {
    return coerceIn(value, 0.0, 1.0);
  };
  Companion_24.prototype.normalizePercent = function (value) {
    return coerceIn_0(value, 0, 100);
  };
  Companion_24.prototype.normalizeRGB = function (value) {
    return coerceIn_0(value, 0, 255);
  };
  Companion_24.prototype.normalizeHue = function (value) {
    return roundToInt((value % 360 + 360) % 360);
  };
  Companion_24.prototype.normalizeAlpha = function (value) {
    return this.normalizeFractionalPercent(value);
  };
  Companion_24.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_23;
  function Companion_getInstance_23() {
    if (Companion_instance_23 == null)
      new Companion_24();
    return Companion_instance_23;
  }
  function RGBA(red, green, blue, alpha) {
    this._red_0 = red;
    this._green_0 = green;
    this._blue_0 = blue;
    this._alpha = alpha;
  }
  RGBA.prototype.toString = function () {
    return '' + 'RGBA(red=' + this._red_0 + ', green=' + this._green_0 + ', blue=' + this._blue_0 + ', alpha=' + this._alpha + ')';
  };
  RGBA.prototype.hashCode = function () {
    var result = this._red_0;
    result = imul(result, 31) + this._green_0 | 0;
    result = imul(result, 31) + this._blue_0 | 0;
    result = imul(result, 31) + getNumberHashCode(this._alpha) | 0;
    return result;
  };
  RGBA.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof RGBA))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof RGBA ? other : THROW_CCE();
    if (!(this._red_0 === tmp0_other_with_cast._red_0))
      return false;
    if (!(this._green_0 === tmp0_other_with_cast._green_0))
      return false;
    if (!(this._blue_0 === tmp0_other_with_cast._blue_0))
      return false;
    if (!equals_1(this._alpha, tmp0_other_with_cast._alpha))
      return false;
    return true;
  };
  RGBA.$metadata$ = {
    simpleName: 'RGBA',
    kind: 'class',
    interfaces: []
  };
  function HSLA(hue, saturation, lightness, alpha) {
    this._hue = hue;
    this._saturation = saturation;
    this._lightness = lightness;
    this._alpha_0 = alpha;
  }
  HSLA.prototype.toString = function () {
    return '' + 'HSLA(hue=' + this._hue + ', saturation=' + this._saturation + ', lightness=' + this._lightness + ', alpha=' + this._alpha_0 + ')';
  };
  HSLA.prototype.hashCode = function () {
    var result = this._hue;
    result = imul(result, 31) + this._saturation | 0;
    result = imul(result, 31) + this._lightness | 0;
    result = imul(result, 31) + getNumberHashCode(this._alpha_0) | 0;
    return result;
  };
  HSLA.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof HSLA))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof HSLA ? other : THROW_CCE();
    if (!(this._hue === tmp0_other_with_cast._hue))
      return false;
    if (!(this._saturation === tmp0_other_with_cast._saturation))
      return false;
    if (!(this._lightness === tmp0_other_with_cast._lightness))
      return false;
    if (!equals_1(this._alpha_0, tmp0_other_with_cast._alpha_0))
      return false;
    return true;
  };
  HSLA.$metadata$ = {
    simpleName: 'HSLA',
    kind: 'class',
    interfaces: []
  };
  function fromHSLANotation$getHSLParameter($match, this$0, index) {
    var tmp0_safe_receiver = $match;
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver._get_groups__0();
    var tmp2_safe_receiver = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.get_80(index);
    var tmp3_elvis_lhs = tmp2_safe_receiver == null ? null : tmp2_safe_receiver._value_1;
    var tmp;
    if (tmp3_elvis_lhs == null) {
      throw IllegalArgumentException_init_$Create$_0('' + 'Expected hsl or hsla notation, got ' + this$0._value_15);
    } else {
      tmp = tmp3_elvis_lhs;
    }
    return tmp;
  }
  function fromRGBANotation$getRGBParameter($match, this$0, index) {
    var tmp0_safe_receiver = $match;
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver._get_groups__0();
    var tmp2_safe_receiver = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.get_80(index);
    var tmp3_elvis_lhs = tmp2_safe_receiver == null ? null : tmp2_safe_receiver._value_1;
    var tmp;
    if (tmp3_elvis_lhs == null) {
      throw IllegalArgumentException_init_$Create$_0('' + 'Expected rgb or rgba notation, got ' + this$0._value_15);
    } else {
      tmp = tmp3_elvis_lhs;
    }
    var group = tmp;
    var tmp_0;
    var tmp_1 = new Char(37);
    if (endsWith$default(group, tmp_1, false, 2, null)) {
      var tmp_2 = Companion_getInstance_23();
      var tmp_3 = new Char(37);
      tmp_0 = numberToInt(tmp_2.normalizeFractionalPercent(toDouble(substringBefore$default_0(group, tmp_3, null, 2, null)) / 100.0) * 255.0);
    } else {
      {
        tmp_0 = Companion_getInstance_23().normalizeRGB(toInt(group));
      }
    }
    return tmp_0;
  }
  function Color(value) {
    Companion_getInstance_23();
    CssValue.call(this, value);
    this._value_15 = value;
    this._rgb = null;
  }
  Color.prototype._get_value__33 = function () {
    return this._value_15;
  };
  Color.prototype.withAlpha = function (alpha) {
    var tmp;
    if (startsWith_1(this._value_15, 'hsl', true)) {
      var tmp0_with_0 = this.fromHSLANotation();
      tmp = hsla(tmp0_with_0._hue, tmp0_with_0._saturation, tmp0_with_0._lightness, Companion_getInstance_23().normalizeAlpha(alpha) * tmp0_with_0._alpha_0);
    } else {
      var tmp1_with_0 = this.toRGBA();
      tmp = rgba(tmp1_with_0._red_0, tmp1_with_0._green_0, tmp1_with_0._blue_0, Companion_getInstance_23().normalizeAlpha(alpha) * tmp1_with_0._alpha);
    }
    return tmp;
  };
  Color.prototype.fromHSLANotation = function () {
    var tmp = _get_HSLA_REGEX_(Companion_getInstance_23());
    var match = tmp.find$default(this._value_15, 0, 2, null);
    var hueShape = fromHSLANotation$getHSLParameter(match, this, 1);
    var tmp_0 = Companion_getInstance_23();
    var tmp_1;
    if (endsWith_1(hueShape, 'grad', true)) {
      tmp_1 = toDouble(substringBefore$default(hueShape, 'grad', null, 2, null)) * 0.9;
    } else if (endsWith_1(hueShape, 'rad', true)) {
      tmp_1 = toDouble(substringBefore$default(hueShape, 'rad', null, 2, null)) * 180 / 3.141592653589793;
    } else if (endsWith_1(hueShape, 'turn', true)) {
      tmp_1 = toDouble(substringBefore$default(hueShape, 'turn', null, 2, null)) * 360.0;
    } else if (endsWith_1(hueShape, 'deg', true)) {
      tmp_1 = toDouble(substringBefore$default(hueShape, 'deg', null, 2, null));
    } else {
      tmp_1 = toDouble(hueShape);
    }
    var hue = tmp_0.normalizeHue(tmp_1);
    var saturation = Companion_getInstance_23().normalizePercent(toInt(fromHSLANotation$getHSLParameter(match, this, 2)));
    var lightness = Companion_getInstance_23().normalizePercent(toInt(fromHSLANotation$getHSLParameter(match, this, 3)));
    var tmp_2 = Companion_getInstance_23();
    var tmp0_safe_receiver = match;
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver._get_groups__0();
    var tmp2_safe_receiver = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.get_80(4);
    var tmp3_safe_receiver = tmp2_safe_receiver == null ? null : tmp2_safe_receiver._value_1;
    var tmp4_elvis_lhs = tmp3_safe_receiver == null ? null : toDouble(tmp3_safe_receiver);
    var alpha = tmp_2.normalizeAlpha(tmp4_elvis_lhs == null ? 1.0 : tmp4_elvis_lhs);
    return new HSLA(hue, saturation, lightness, alpha);
  };
  Color.prototype.fromRGBANotation = function () {
    var tmp = _get_RGBA_REGEX_(Companion_getInstance_23());
    var match = tmp.find$default(this._value_15, 0, 2, null);
    var red = fromRGBANotation$getRGBParameter(match, this, 1);
    var green = fromRGBANotation$getRGBParameter(match, this, 2);
    var blue = fromRGBANotation$getRGBParameter(match, this, 3);
    var tmp_0 = Companion_getInstance_23();
    var tmp0_safe_receiver = match;
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver._get_groups__0();
    var tmp2_safe_receiver = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.get_80(4);
    var tmp3_safe_receiver = tmp2_safe_receiver == null ? null : tmp2_safe_receiver._value_1;
    var tmp4_elvis_lhs = tmp3_safe_receiver == null ? null : toDouble(tmp3_safe_receiver);
    var alpha = tmp_0.normalizeAlpha(tmp4_elvis_lhs == null ? 1.0 : tmp4_elvis_lhs);
    return new RGBA(red, green, blue, alpha);
  };
  Color.prototype.toRGBA = function () {
    var tmp0_elvis_lhs = this._rgb;
    var v = tmp0_elvis_lhs == null ? this._value_15 : tmp0_elvis_lhs;
    var tmp;
    if (startsWith$default_1(v, 'rgb', false, 2, null)) {
      tmp = this.fromRGBANotation();
    } else {
      var tmp_0;
      if (startsWith$default_1(v, '#', false, 2, null)) {
        tmp_0 = v.length === 4;
      } else {
        {
          tmp_0 = false;
        }
      }
      if (tmp_0) {
        var tmp_1 = toInt_0(times(charSequenceGet(v, 1).toString(), 2), 16);
        var tmp_2 = toInt_0(times(charSequenceGet(v, 2).toString(), 2), 16);
        var tmp_3 = toInt_0(times(charSequenceGet(v, 3).toString(), 2), 16);
        tmp = RGBA_init_$Create$(tmp_1, tmp_2, tmp_3, 0.0, 8, null);
      } else {
        var tmp_4;
        if (startsWith$default_1(v, '#', false, 2, null)) {
          tmp_4 = v.length === 7 ? true : v.length === 9;
        } else {
          {
            tmp_4 = false;
          }
        }
        if (tmp_4) {
          var tmp_5 = toInt_0(substring(v, numberRangeToNumber(1, 2)), 16);
          var tmp_6 = toInt_0(substring(v, numberRangeToNumber(3, 4)), 16);
          var tmp_7 = toInt_0(substring(v, numberRangeToNumber(5, 6)), 16);
          tmp = RGBA_init_$Create$(tmp_5, tmp_6, tmp_7, 0.0, 8, null);
        } else {
          {
            throw IllegalArgumentException_init_$Create$_0('' + 'Only hexadecimal, rgb, and rgba notations are accepted, got ' + v);
          }
        }
      }
    }
    return tmp;
  };
  Color.$metadata$ = {
    simpleName: 'Color',
    kind: 'class',
    interfaces: []
  };
  function QuotedString(value) {
    CssValue.call(this, value);
    this._value_16 = value;
  }
  QuotedString.prototype._get_value__33 = function () {
    return this._value_16;
  };
  QuotedString.prototype.toString = function () {
    return '' + "'" + this._value_16 + "'";
  };
  QuotedString.$metadata$ = {
    simpleName: 'QuotedString',
    kind: 'class',
    interfaces: []
  };
  var Display_initial_instance;
  var Display_inherit_instance;
  var Display_unset_instance;
  var Display_block_instance;
  var Display_inline_instance;
  var Display_runIn_instance;
  var Display_flow_instance;
  var Display_flowRoot_instance;
  var Display_table_instance;
  var Display_flex_instance;
  var Display_grid_instance;
  var Display_subgrid_instance;
  var Display_listItem_instance;
  var Display_tableRowGroup_instance;
  var Display_tableHeaderGroup_instance;
  var Display_tableFooterGroup_instance;
  var Display_tableRow_instance;
  var Display_tableCell_instance;
  var Display_tableColumnGroup_instance;
  var Display_tableColumn_instance;
  var Display_tableCaption_instance;
  var Display_contents_instance;
  var Display_none_instance;
  var Display_inlineBlock_instance;
  var Display_inlineListItem_instance;
  var Display_inlineTable_instance;
  var Display_inlineFlex_instance;
  var Display_inlineGrid_instance;
  var Display_entriesInitialized;
  function Display_initEntries() {
    if (Display_entriesInitialized)
      return Unit_getInstance();
    Display_entriesInitialized = true;
    Display_initial_instance = new Display('initial', 0);
    Display_inherit_instance = new Display('inherit', 1);
    Display_unset_instance = new Display('unset', 2);
    Display_block_instance = new Display('block', 3);
    Display_inline_instance = new Display('inline', 4);
    Display_runIn_instance = new Display('runIn', 5);
    Display_flow_instance = new Display('flow', 6);
    Display_flowRoot_instance = new Display('flowRoot', 7);
    Display_table_instance = new Display('table', 8);
    Display_flex_instance = new Display('flex', 9);
    Display_grid_instance = new Display('grid', 10);
    Display_subgrid_instance = new Display('subgrid', 11);
    Display_listItem_instance = new Display('listItem', 12);
    Display_tableRowGroup_instance = new Display('tableRowGroup', 13);
    Display_tableHeaderGroup_instance = new Display('tableHeaderGroup', 14);
    Display_tableFooterGroup_instance = new Display('tableFooterGroup', 15);
    Display_tableRow_instance = new Display('tableRow', 16);
    Display_tableCell_instance = new Display('tableCell', 17);
    Display_tableColumnGroup_instance = new Display('tableColumnGroup', 18);
    Display_tableColumn_instance = new Display('tableColumn', 19);
    Display_tableCaption_instance = new Display('tableCaption', 20);
    Display_contents_instance = new Display('contents', 21);
    Display_none_instance = new Display('none', 22);
    Display_inlineBlock_instance = new Display('inlineBlock', 23);
    Display_inlineListItem_instance = new Display('inlineListItem', 24);
    Display_inlineTable_instance = new Display('inlineTable', 25);
    Display_inlineFlex_instance = new Display('inlineFlex', 26);
    Display_inlineGrid_instance = new Display('inlineGrid', 27);
  }
  function Display(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  Display.prototype.toString = function () {
    return hyphenize(this._get_name__10());
  };
  Display.$metadata$ = {
    simpleName: 'Display',
    kind: 'class',
    interfaces: []
  };
  var FlexDirection_initial_instance;
  var FlexDirection_inherit_instance;
  var FlexDirection_unset_instance;
  var FlexDirection_column_instance;
  var FlexDirection_columnReverse_instance;
  var FlexDirection_row_instance;
  var FlexDirection_rowReverse_instance;
  var FlexDirection_entriesInitialized;
  function FlexDirection_initEntries() {
    if (FlexDirection_entriesInitialized)
      return Unit_getInstance();
    FlexDirection_entriesInitialized = true;
    FlexDirection_initial_instance = new FlexDirection('initial', 0);
    FlexDirection_inherit_instance = new FlexDirection('inherit', 1);
    FlexDirection_unset_instance = new FlexDirection('unset', 2);
    FlexDirection_column_instance = new FlexDirection('column', 3);
    FlexDirection_columnReverse_instance = new FlexDirection('columnReverse', 4);
    FlexDirection_row_instance = new FlexDirection('row', 5);
    FlexDirection_rowReverse_instance = new FlexDirection('rowReverse', 6);
  }
  function FlexDirection(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  FlexDirection.prototype.toString = function () {
    return hyphenize(this._get_name__10());
  };
  FlexDirection.$metadata$ = {
    simpleName: 'FlexDirection',
    kind: 'class',
    interfaces: []
  };
  var FlexWrap_initial_instance;
  var FlexWrap_inherit_instance;
  var FlexWrap_unset_instance;
  var FlexWrap_nowrap_instance;
  var FlexWrap_wrap_instance;
  var FlexWrap_wrapReverse_instance;
  var FlexWrap_entriesInitialized;
  function FlexWrap_initEntries() {
    if (FlexWrap_entriesInitialized)
      return Unit_getInstance();
    FlexWrap_entriesInitialized = true;
    FlexWrap_initial_instance = new FlexWrap('initial', 0);
    FlexWrap_inherit_instance = new FlexWrap('inherit', 1);
    FlexWrap_unset_instance = new FlexWrap('unset', 2);
    FlexWrap_nowrap_instance = new FlexWrap('nowrap', 3);
    FlexWrap_wrap_instance = new FlexWrap('wrap', 4);
    FlexWrap_wrapReverse_instance = new FlexWrap('wrapReverse', 5);
  }
  function FlexWrap(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  FlexWrap.prototype.toString = function () {
    return hyphenize(this._get_name__10());
  };
  FlexWrap.$metadata$ = {
    simpleName: 'FlexWrap',
    kind: 'class',
    interfaces: []
  };
  function Companion_25() {
    Companion_instance_24 = this;
    this._initial_1 = new FontWeight('initial');
    this._inherit_1 = new FontWeight('inherit');
    this._unset_0 = new FontWeight('unset');
    this._normal = new FontWeight('normal');
    this._bold = new FontWeight('bold');
    this._bolder = new FontWeight('bolder');
    this._lighter = new FontWeight('lighter');
    this._w900 = new FontWeight('900');
    this._w800 = new FontWeight('800');
    this._w700 = new FontWeight('700');
    this._w600 = new FontWeight('600');
    this._w500 = new FontWeight('500');
    this._w400 = new FontWeight('400');
    this._w300 = new FontWeight('300');
    this._w200 = new FontWeight('200');
    this._w100 = new FontWeight('100');
  }
  Companion_25.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_24;
  function Companion_getInstance_24() {
    if (Companion_instance_24 == null)
      new Companion_25();
    return Companion_instance_24;
  }
  function FontWeight(value) {
    Companion_getInstance_24();
    CssValue.call(this, value);
    this._value_17 = value;
  }
  FontWeight.prototype._get_value__33 = function () {
    return this._value_17;
  };
  FontWeight.$metadata$ = {
    simpleName: 'FontWeight',
    kind: 'class',
    interfaces: []
  };
  function Companion_26() {
    Companion_instance_25 = this;
    this._auto_0 = new GridColumn('auto');
  }
  Companion_26.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_25;
  function Companion_getInstance_25() {
    if (Companion_instance_25 == null)
      new Companion_26();
    return Companion_instance_25;
  }
  function GridColumn(value) {
    Companion_getInstance_25();
    CssValue.call(this, value);
    this._value_18 = value;
  }
  GridColumn.prototype._get_value__33 = function () {
    return this._value_18;
  };
  GridColumn.$metadata$ = {
    simpleName: 'GridColumn',
    kind: 'class',
    interfaces: []
  };
  function Companion_27() {
    Companion_instance_26 = this;
    this._auto_1 = new GridRow('auto');
  }
  Companion_27.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_26;
  function Companion_getInstance_26() {
    if (Companion_instance_26 == null)
      new Companion_27();
    return Companion_instance_26;
  }
  function GridRow(value) {
    Companion_getInstance_26();
    CssValue.call(this, value);
    this._value_19 = value;
  }
  GridRow.prototype._get_value__33 = function () {
    return this._value_19;
  };
  GridRow.$metadata$ = {
    simpleName: 'GridRow',
    kind: 'class',
    interfaces: []
  };
  var JustifyContent_initial_instance;
  var JustifyContent_inherit_instance;
  var JustifyContent_unset_instance;
  var JustifyContent_center_instance;
  var JustifyContent_start_instance;
  var JustifyContent_end_instance;
  var JustifyContent_flexStart_instance;
  var JustifyContent_flexEnd_instance;
  var JustifyContent_left_instance;
  var JustifyContent_right_instance;
  var JustifyContent_baseline_instance;
  var JustifyContent_firstBaseline_instance;
  var JustifyContent_lastBaseline_instance;
  var JustifyContent_spaceBetween_instance;
  var JustifyContent_spaceAround_instance;
  var JustifyContent_spaceEvenly_instance;
  var JustifyContent_stretch_instance;
  var JustifyContent_safeCenter_instance;
  var JustifyContent_unsafeCenter_instance;
  var JustifyContent_entriesInitialized;
  function JustifyContent_initEntries() {
    if (JustifyContent_entriesInitialized)
      return Unit_getInstance();
    JustifyContent_entriesInitialized = true;
    JustifyContent_initial_instance = new JustifyContent('initial', 0);
    JustifyContent_inherit_instance = new JustifyContent('inherit', 1);
    JustifyContent_unset_instance = new JustifyContent('unset', 2);
    JustifyContent_center_instance = new JustifyContent('center', 3);
    JustifyContent_start_instance = new JustifyContent('start', 4);
    JustifyContent_end_instance = new JustifyContent('end', 5);
    JustifyContent_flexStart_instance = new JustifyContent('flexStart', 6);
    JustifyContent_flexEnd_instance = new JustifyContent('flexEnd', 7);
    JustifyContent_left_instance = new JustifyContent('left', 8);
    JustifyContent_right_instance = new JustifyContent('right', 9);
    JustifyContent_baseline_instance = new JustifyContent('baseline', 10);
    JustifyContent_firstBaseline_instance = new JustifyContent('firstBaseline', 11);
    JustifyContent_lastBaseline_instance = new JustifyContent('lastBaseline', 12);
    JustifyContent_spaceBetween_instance = new JustifyContent('spaceBetween', 13);
    JustifyContent_spaceAround_instance = new JustifyContent('spaceAround', 14);
    JustifyContent_spaceEvenly_instance = new JustifyContent('spaceEvenly', 15);
    JustifyContent_stretch_instance = new JustifyContent('stretch', 16);
    JustifyContent_safeCenter_instance = new JustifyContent('safeCenter', 17);
    JustifyContent_unsafeCenter_instance = new JustifyContent('unsafeCenter', 18);
  }
  function JustifyContent(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  JustifyContent.prototype.toString = function () {
    return hyphenize(this._get_name__10());
  };
  JustifyContent.$metadata$ = {
    simpleName: 'JustifyContent',
    kind: 'class',
    interfaces: []
  };
  var Position_initial_instance;
  var Position_inherit_instance;
  var Position_unset_instance;
  var Position_static_instance;
  var Position_relative_instance;
  var Position_absolute_instance;
  var Position_fixed_instance;
  var Position_sticky_instance;
  var Position_entriesInitialized;
  function Position_initEntries() {
    if (Position_entriesInitialized)
      return Unit_getInstance();
    Position_entriesInitialized = true;
    Position_initial_instance = new Position('initial', 0);
    Position_inherit_instance = new Position('inherit', 1);
    Position_unset_instance = new Position('unset', 2);
    Position_static_instance = new Position('static', 3);
    Position_relative_instance = new Position('relative', 4);
    Position_absolute_instance = new Position('absolute', 5);
    Position_fixed_instance = new Position('fixed', 6);
    Position_sticky_instance = new Position('sticky', 7);
  }
  function Position(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  Position.prototype.toString = function () {
    return this._get_name__10();
  };
  Position.$metadata$ = {
    simpleName: 'Position',
    kind: 'class',
    interfaces: []
  };
  var TextAlign_initial_instance;
  var TextAlign_inherit_instance;
  var TextAlign_unset_instance;
  var TextAlign_left_instance;
  var TextAlign_right_instance;
  var TextAlign_center_instance;
  var TextAlign_justify_instance;
  var TextAlign_justifyAll_instance;
  var TextAlign_start_instance;
  var TextAlign_end_instance;
  var TextAlign_matchParent_instance;
  var TextAlign_entriesInitialized;
  function TextAlign_initEntries() {
    if (TextAlign_entriesInitialized)
      return Unit_getInstance();
    TextAlign_entriesInitialized = true;
    TextAlign_initial_instance = new TextAlign('initial', 0);
    TextAlign_inherit_instance = new TextAlign('inherit', 1);
    TextAlign_unset_instance = new TextAlign('unset', 2);
    TextAlign_left_instance = new TextAlign('left', 3);
    TextAlign_right_instance = new TextAlign('right', 4);
    TextAlign_center_instance = new TextAlign('center', 5);
    TextAlign_justify_instance = new TextAlign('justify', 6);
    TextAlign_justifyAll_instance = new TextAlign('justifyAll', 7);
    TextAlign_start_instance = new TextAlign('start', 8);
    TextAlign_end_instance = new TextAlign('end', 9);
    TextAlign_matchParent_instance = new TextAlign('matchParent', 10);
  }
  function TextAlign(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  TextAlign.prototype.toString = function () {
    return hyphenize(this._get_name__10());
  };
  TextAlign.$metadata$ = {
    simpleName: 'TextAlign',
    kind: 'class',
    interfaces: []
  };
  function CssValue(value) {
    this._value_20 = value;
  }
  CssValue.prototype._get_value__33 = function () {
    return this._value_20;
  };
  CssValue.prototype.toString = function () {
    return this._get_value__33();
  };
  CssValue.$metadata$ = {
    simpleName: 'CssValue',
    kind: 'class',
    interfaces: []
  };
  function hsla(hue, saturation, lightness, alpha) {
    return new Color('' + 'hsla(' + hue + ', ' + saturation + '%, ' + lightness + '%, ' + formatAlpha(alpha) + ')');
  }
  function rgba(red, green, blue, alpha) {
    return new Color('' + 'rgba(' + red + ', ' + green + ', ' + blue + ', ' + formatAlpha(alpha) + ')');
  }
  function formatAlpha(alpha) {
    var tmp0_let_0 = alpha.toString();
    var tmp;
    if (contains$default(tmp0_let_0, '.', false, 2, null)) {
      tmp = tmp0_let_0;
    } else {
      {
        tmp = '' + tmp0_let_0 + '.0';
      }
    }
    return tmp;
  }
  function _get_quoted_(_this_) {
    return new QuotedString(_this_);
  }
  function Align_center_getInstance() {
    Align_initEntries();
    return Align_center_instance;
  }
  function Display_block_getInstance() {
    Display_initEntries();
    return Display_block_instance;
  }
  function Display_flex_getInstance() {
    Display_initEntries();
    return Display_flex_instance;
  }
  function Display_grid_getInstance() {
    Display_initEntries();
    return Display_grid_instance;
  }
  function Display_inlineBlock_getInstance() {
    Display_initEntries();
    return Display_inlineBlock_instance;
  }
  function FlexDirection_column_getInstance() {
    FlexDirection_initEntries();
    return FlexDirection_column_instance;
  }
  function FlexWrap_wrap_getInstance() {
    FlexWrap_initEntries();
    return FlexWrap_wrap_instance;
  }
  function JustifyContent_center_getInstance() {
    JustifyContent_initEntries();
    return JustifyContent_center_instance;
  }
  function Position_fixed_getInstance() {
    Position_initEntries();
    return Position_fixed_instance;
  }
  function TextAlign_center_getInstance() {
    TextAlign_initEntries();
    return TextAlign_center_instance;
  }
  function HSLA_REGEX$factory() {
    return getPropertyCallableRef('HSLA_REGEX', 1, KProperty1, function (receiver) {
      return _get_HSLA_REGEX_(receiver);
    }, null);
  }
  function RGBA_REGEX$factory() {
    return getPropertyCallableRef('RGBA_REGEX', 1, KProperty1, function (receiver) {
      return _get_RGBA_REGEX_(receiver);
    }, null);
  }
  function _no_name_provided_$factory_73() {
    var i = new _no_name_provided__95();
    return function () {
      return i.invoke_540();
    };
  }
  function _no_name_provided_$factory_74() {
    var i = new _no_name_provided__96();
    return function () {
      return i.invoke_540();
    };
  }
  function StyleList(delimiter) {
    this._delimiter = delimiter;
    var tmp = this;
    tmp._list_1 = ArrayList_init_$Create$();
  }
  StyleList.prototype.toString = function () {
    var tmp;
    if (this._list_1.isEmpty_53()) {
      tmp = 'none';
    } else {
      tmp = joinToString$default_0(this._list_1, this._delimiter, null, null, 0, null, null, 62, null);
    }
    return tmp;
  };
  StyleList.prototype.plusAssign = function (item) {
    var tmp0_this = this;
    var tmp0_plusAssign_0 = tmp0_this._list_1;
    tmp0_plusAssign_0.add_33(item);
    Unit_getInstance();
  };
  StyleList.$metadata$ = {
    simpleName: 'StyleList',
    kind: 'class',
    interfaces: []
  };
  function _set_alignContent_(_this_, _set___) {
    return alignContent$delegate.setValue_5(_this_, alignContent$factory(), _set___);
  }
  function _get_alignContent_(_this_) {
    return alignContent$delegate.getValue_7(_this_, alignContent$factory_0());
  }
  var alignContent$delegate;
  function _set_alignItems_(_this_, _set___) {
    return alignItems$delegate.setValue_5(_this_, alignItems$factory(), _set___);
  }
  function _get_alignItems_(_this_) {
    return alignItems$delegate.getValue_7(_this_, alignItems$factory_0());
  }
  var alignItems$delegate;
  function _set_alignSelf_(_this_, _set___) {
    return alignSelf$delegate.setValue_5(_this_, alignSelf$factory(), _set___);
  }
  function _get_alignSelf_(_this_) {
    return alignSelf$delegate.getValue_7(_this_, alignSelf$factory_0());
  }
  var alignSelf$delegate;
  function _set_animation_(_this_, _set___) {
    return animation$delegate.setValue_5(_this_, animation$factory(), _set___);
  }
  function _get_animation_(_this_) {
    return animation$delegate.getValue_7(_this_, animation$factory_0());
  }
  var animation$delegate;
  function _set_background_(_this_, _set___) {
    return background$delegate.setValue_5(_this_, background$factory(), _set___);
  }
  function _get_background_(_this_) {
    return background$delegate.getValue_7(_this_, background$factory_0());
  }
  var background$delegate;
  function _set_backgroundColor_(_this_, _set___) {
    return backgroundColor$delegate.setValue_5(_this_, backgroundColor$factory(), _set___);
  }
  function _get_backgroundColor_(_this_) {
    return backgroundColor$delegate.getValue_7(_this_, backgroundColor$factory_0());
  }
  var backgroundColor$delegate;
  function _set_backgroundPosition_(_this_, _set___) {
    return backgroundPosition$delegate.setValue_5(_this_, backgroundPosition$factory(), _set___);
  }
  function _get_backgroundPosition_(_this_) {
    return backgroundPosition$delegate.getValue_7(_this_, backgroundPosition$factory_0());
  }
  var backgroundPosition$delegate;
  function _set_backgroundSize_(_this_, _set___) {
    return backgroundSize$delegate.setValue_5(_this_, backgroundSize$factory(), _set___);
  }
  function _get_backgroundSize_(_this_) {
    return backgroundSize$delegate.getValue_7(_this_, backgroundSize$factory_0());
  }
  var backgroundSize$delegate;
  function _set_border_(_this_, _set___) {
    return border$delegate.setValue_5(_this_, border$factory(), _set___);
  }
  function _get_border_(_this_) {
    return border$delegate.getValue_7(_this_, border$factory_0());
  }
  var border$delegate;
  function _set_borderRadius_(_this_, _set___) {
    return borderRadius$delegate.setValue_5(_this_, borderRadius$factory(), _set___);
  }
  function _get_borderRadius_(_this_) {
    return borderRadius$delegate.getValue_7(_this_, borderRadius$factory_0());
  }
  var borderRadius$delegate;
  function _set_borderColor_(_this_, _set___) {
    return borderColor$delegate.setValue_5(_this_, borderColor$factory(), _set___);
  }
  function _get_borderColor_(_this_) {
    return borderColor$delegate.getValue_7(_this_, borderColor$factory_0());
  }
  var borderColor$delegate;
  function _set_color_(_this_, _set___) {
    return color$delegate.setValue_5(_this_, color$factory(), _set___);
  }
  function _get_color_(_this_) {
    return color$delegate.getValue_7(_this_, color$factory_0());
  }
  var color$delegate;
  function _set_content_(_this_, _set___) {
    return content$delegate.setValue_5(_this_, content$factory(), _set___);
  }
  function _get_content_(_this_) {
    return content$delegate.getValue_7(_this_, content$factory_0());
  }
  var content$delegate;
  function _set_display_(_this_, _set___) {
    return display$delegate.setValue_5(_this_, display$factory(), _set___);
  }
  function _get_display_(_this_) {
    return display$delegate.getValue_7(_this_, display$factory_0());
  }
  var display$delegate;
  function _set_flexDirection_(_this_, _set___) {
    return flexDirection$delegate.setValue_5(_this_, flexDirection$factory(), _set___);
  }
  function _get_flexDirection_(_this_) {
    return flexDirection$delegate.getValue_7(_this_, flexDirection$factory_0());
  }
  var flexDirection$delegate;
  function _set_flexGrow_(_this_, _set___) {
    return flexGrow$delegate.setValue_5(_this_, flexGrow$factory(), _set___);
  }
  function _get_flexGrow_(_this_) {
    return flexGrow$delegate.getValue_7(_this_, flexGrow$factory_0());
  }
  var flexGrow$delegate;
  function _set_flexWrap_(_this_, _set___) {
    return flexWrap$delegate.setValue_5(_this_, flexWrap$factory(), _set___);
  }
  function _get_flexWrap_(_this_) {
    return flexWrap$delegate.getValue_7(_this_, flexWrap$factory_0());
  }
  var flexWrap$delegate;
  function _set_fontSize_(_this_, _set___) {
    return fontSize$delegate.setValue_5(_this_, fontSize$factory(), _set___);
  }
  function _get_fontSize_(_this_) {
    return fontSize$delegate.getValue_7(_this_, fontSize$factory_0());
  }
  var fontSize$delegate;
  function _set_fontWeight_(_this_, _set___) {
    return fontWeight$delegate.setValue_5(_this_, fontWeight$factory(), _set___);
  }
  function _get_fontWeight_(_this_) {
    return fontWeight$delegate.getValue_7(_this_, fontWeight$factory_0());
  }
  var fontWeight$delegate;
  function _set_gridColumn_(_this_, _set___) {
    return gridColumn$delegate.setValue_5(_this_, gridColumn$factory(), _set___);
  }
  function _get_gridColumn_(_this_) {
    return gridColumn$delegate.getValue_7(_this_, gridColumn$factory_0());
  }
  var gridColumn$delegate;
  function _set_gridRow_(_this_, _set___) {
    return gridRow$delegate.setValue_5(_this_, gridRow$factory(), _set___);
  }
  function _get_gridRow_(_this_) {
    return gridRow$delegate.getValue_7(_this_, gridRow$factory_0());
  }
  var gridRow$delegate;
  function _set_height_(_this_, _set___) {
    return height$delegate.setValue_5(_this_, height$factory(), _set___);
  }
  function _get_height_(_this_) {
    return height$delegate.getValue_7(_this_, height$factory_0());
  }
  var height$delegate;
  function _set_justifyContent_(_this_, _set___) {
    return justifyContent$delegate.setValue_5(_this_, justifyContent$factory(), _set___);
  }
  function _get_justifyContent_(_this_) {
    return justifyContent$delegate.getValue_7(_this_, justifyContent$factory_0());
  }
  var justifyContent$delegate;
  function _set_left_(_this_, _set___) {
    return left$delegate.setValue_5(_this_, left$factory(), _set___);
  }
  function _get_left_(_this_) {
    return left$delegate.getValue_7(_this_, left$factory_0());
  }
  var left$delegate;
  function _set_margin_(_this_, _set___) {
    return margin$delegate.setValue_5(_this_, margin$factory(), _set___);
  }
  function _get_margin_(_this_) {
    return margin$delegate.getValue_7(_this_, margin$factory_0());
  }
  var margin$delegate;
  function _set_maxWidth_(_this_, _set___) {
    return maxWidth$delegate.setValue_5(_this_, maxWidth$factory(), _set___);
  }
  function _get_maxWidth_(_this_) {
    return maxWidth$delegate.getValue_7(_this_, maxWidth$factory_0());
  }
  var maxWidth$delegate;
  function _set_position_(_this_, _set___) {
    return position$delegate.setValue_5(_this_, position$factory(), _set___);
  }
  function _get_position_(_this_) {
    return position$delegate.getValue_7(_this_, position$factory_0());
  }
  var position$delegate;
  function _set_textAlign_(_this_, _set___) {
    return textAlign$delegate.setValue_5(_this_, textAlign$factory(), _set___);
  }
  function _get_textAlign_(_this_) {
    return textAlign$delegate.getValue_7(_this_, textAlign$factory_0());
  }
  var textAlign$delegate;
  function _set_top_(_this_, _set___) {
    return top$delegate.setValue_5(_this_, top$factory(), _set___);
  }
  function _get_top_(_this_) {
    return top$delegate.getValue_7(_this_, top$factory_0());
  }
  var top$delegate;
  function _set_transform_(_this_, _set___) {
    return transform$delegate.setValue_5(_this_, transform$factory(), _set___);
  }
  function _get_transform_(_this_) {
    return transform$delegate.getValue_7(_this_, transform$factory_0());
  }
  var transform$delegate;
  function _set_transition_(_this_, _set___) {
    return transition$delegate.setValue_5(_this_, transition$factory(), _set___);
  }
  function _get_transition_(_this_) {
    return transition$delegate.getValue_7(_this_, transition$factory_0());
  }
  var transition$delegate;
  function _set_width_(_this_, _set___) {
    return width$delegate.setValue_5(_this_, width$factory(), _set___);
  }
  function _get_width_(_this_) {
    return width$delegate.getValue_7(_this_, width$factory_0());
  }
  var width$delegate;
  function StyledElement() {
    this._declarations = LinkedHashMap_init_$Create$();
  }
  StyledElement.prototype._get_declarations__0 = function () {
    return this._declarations;
  };
  StyledElement.$metadata$ = {
    simpleName: 'StyledElement',
    kind: 'class',
    interfaces: []
  };
  function CSSProperty_init_$Init$(default_0, $mask0, $marker, $this) {
    if (!(($mask0 & 1) === 0))
      default_0 = null;
    CSSProperty.call($this, default_0);
    return $this;
  }
  function CSSProperty_init_$Create$(default_0, $mask0, $marker) {
    return CSSProperty_init_$Init$(default_0, $mask0, $marker, Object.create(CSSProperty.prototype));
  }
  function CSSProperty(default_0) {
    this._default = default_0;
  }
  CSSProperty.prototype.getValue_7 = function (thisRef, property) {
    var tmp0_safe_receiver = this._default;
    if (tmp0_safe_receiver == null)
      null;
    else {
      if (!thisRef._declarations.containsKey_16(property.callableName)) {
        var tmp0_set_0_2 = thisRef._declarations;
        var tmp1_set_0_3 = property.callableName;
        var tmp = tmp0_safe_receiver();
        var tmp2_set_0_4 = isObject(tmp) ? tmp : THROW_CCE();
        tmp0_set_0_2.put_12(tmp1_set_0_3, tmp2_set_0_4);
        Unit_getInstance();
      }Unit_getInstance();
    }
    Unit_getInstance();
    var tmp_0 = thisRef._declarations.get_63(property.callableName);
    return (tmp_0 == null ? true : isObject(tmp_0)) ? tmp_0 : THROW_CCE();
  };
  CSSProperty.prototype.setValue_5 = function (thisRef, property, value) {
    var tmp0_set_0 = thisRef._declarations;
    var tmp1_set_0 = property.callableName;
    var tmp2_set_0 = isObject(value) ? value : THROW_CCE();
    tmp0_set_0.put_12(tmp1_set_0, tmp2_set_0);
    Unit_getInstance();
  };
  CSSProperty.$metadata$ = {
    simpleName: 'CSSProperty',
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__97() {
  }
  _no_name_provided__97.prototype.invoke_540 = function () {
    return new Animations();
  };
  _no_name_provided__97.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__98() {
  }
  _no_name_provided__98.prototype.invoke_540 = function () {
    return new Transforms();
  };
  _no_name_provided__98.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__99() {
  }
  _no_name_provided__99.prototype.invoke_540 = function () {
    return new Transitions();
  };
  _no_name_provided__99.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function alignContent$factory() {
    return getPropertyCallableRef('alignContent', 1, KMutableProperty1, function (receiver) {
      return _get_alignContent_(receiver);
    }, function (receiver_0, value) {
      return _set_alignContent_(receiver_0, value);
    });
  }
  function alignContent$factory_0() {
    return getPropertyCallableRef('alignContent', 1, KMutableProperty1, function (receiver) {
      return _get_alignContent_(receiver);
    }, function (receiver_0, value) {
      return _set_alignContent_(receiver_0, value);
    });
  }
  function alignItems$factory() {
    return getPropertyCallableRef('alignItems', 1, KMutableProperty1, function (receiver) {
      return _get_alignItems_(receiver);
    }, function (receiver_0, value) {
      return _set_alignItems_(receiver_0, value);
    });
  }
  function alignItems$factory_0() {
    return getPropertyCallableRef('alignItems', 1, KMutableProperty1, function (receiver) {
      return _get_alignItems_(receiver);
    }, function (receiver_0, value) {
      return _set_alignItems_(receiver_0, value);
    });
  }
  function alignSelf$factory() {
    return getPropertyCallableRef('alignSelf', 1, KMutableProperty1, function (receiver) {
      return _get_alignSelf_(receiver);
    }, function (receiver_0, value) {
      return _set_alignSelf_(receiver_0, value);
    });
  }
  function alignSelf$factory_0() {
    return getPropertyCallableRef('alignSelf', 1, KMutableProperty1, function (receiver) {
      return _get_alignSelf_(receiver);
    }, function (receiver_0, value) {
      return _set_alignSelf_(receiver_0, value);
    });
  }
  function animation$factory() {
    return getPropertyCallableRef('animation', 1, KMutableProperty1, function (receiver) {
      return _get_animation_(receiver);
    }, function (receiver_0, value) {
      return _set_animation_(receiver_0, value);
    });
  }
  function animation$factory_0() {
    return getPropertyCallableRef('animation', 1, KMutableProperty1, function (receiver) {
      return _get_animation_(receiver);
    }, function (receiver_0, value) {
      return _set_animation_(receiver_0, value);
    });
  }
  function background$factory() {
    return getPropertyCallableRef('background', 1, KMutableProperty1, function (receiver) {
      return _get_background_(receiver);
    }, function (receiver_0, value) {
      return _set_background_(receiver_0, value);
    });
  }
  function background$factory_0() {
    return getPropertyCallableRef('background', 1, KMutableProperty1, function (receiver) {
      return _get_background_(receiver);
    }, function (receiver_0, value) {
      return _set_background_(receiver_0, value);
    });
  }
  function backgroundColor$factory() {
    return getPropertyCallableRef('backgroundColor', 1, KMutableProperty1, function (receiver) {
      return _get_backgroundColor_(receiver);
    }, function (receiver_0, value) {
      return _set_backgroundColor_(receiver_0, value);
    });
  }
  function backgroundColor$factory_0() {
    return getPropertyCallableRef('backgroundColor', 1, KMutableProperty1, function (receiver) {
      return _get_backgroundColor_(receiver);
    }, function (receiver_0, value) {
      return _set_backgroundColor_(receiver_0, value);
    });
  }
  function backgroundPosition$factory() {
    return getPropertyCallableRef('backgroundPosition', 1, KMutableProperty1, function (receiver) {
      return _get_backgroundPosition_(receiver);
    }, function (receiver_0, value) {
      return _set_backgroundPosition_(receiver_0, value);
    });
  }
  function backgroundPosition$factory_0() {
    return getPropertyCallableRef('backgroundPosition', 1, KMutableProperty1, function (receiver) {
      return _get_backgroundPosition_(receiver);
    }, function (receiver_0, value) {
      return _set_backgroundPosition_(receiver_0, value);
    });
  }
  function backgroundSize$factory() {
    return getPropertyCallableRef('backgroundSize', 1, KMutableProperty1, function (receiver) {
      return _get_backgroundSize_(receiver);
    }, function (receiver_0, value) {
      return _set_backgroundSize_(receiver_0, value);
    });
  }
  function backgroundSize$factory_0() {
    return getPropertyCallableRef('backgroundSize', 1, KMutableProperty1, function (receiver) {
      return _get_backgroundSize_(receiver);
    }, function (receiver_0, value) {
      return _set_backgroundSize_(receiver_0, value);
    });
  }
  function border$factory() {
    return getPropertyCallableRef('border', 1, KMutableProperty1, function (receiver) {
      return _get_border_(receiver);
    }, function (receiver_0, value) {
      return _set_border_(receiver_0, value);
    });
  }
  function border$factory_0() {
    return getPropertyCallableRef('border', 1, KMutableProperty1, function (receiver) {
      return _get_border_(receiver);
    }, function (receiver_0, value) {
      return _set_border_(receiver_0, value);
    });
  }
  function borderRadius$factory() {
    return getPropertyCallableRef('borderRadius', 1, KMutableProperty1, function (receiver) {
      return _get_borderRadius_(receiver);
    }, function (receiver_0, value) {
      return _set_borderRadius_(receiver_0, value);
    });
  }
  function borderRadius$factory_0() {
    return getPropertyCallableRef('borderRadius', 1, KMutableProperty1, function (receiver) {
      return _get_borderRadius_(receiver);
    }, function (receiver_0, value) {
      return _set_borderRadius_(receiver_0, value);
    });
  }
  function borderColor$factory() {
    return getPropertyCallableRef('borderColor', 1, KMutableProperty1, function (receiver) {
      return _get_borderColor_(receiver);
    }, function (receiver_0, value) {
      return _set_borderColor_(receiver_0, value);
    });
  }
  function borderColor$factory_0() {
    return getPropertyCallableRef('borderColor', 1, KMutableProperty1, function (receiver) {
      return _get_borderColor_(receiver);
    }, function (receiver_0, value) {
      return _set_borderColor_(receiver_0, value);
    });
  }
  function color$factory() {
    return getPropertyCallableRef('color', 1, KMutableProperty1, function (receiver) {
      return _get_color_(receiver);
    }, function (receiver_0, value) {
      return _set_color_(receiver_0, value);
    });
  }
  function color$factory_0() {
    return getPropertyCallableRef('color', 1, KMutableProperty1, function (receiver) {
      return _get_color_(receiver);
    }, function (receiver_0, value) {
      return _set_color_(receiver_0, value);
    });
  }
  function content$factory() {
    return getPropertyCallableRef('content', 1, KMutableProperty1, function (receiver) {
      return _get_content_(receiver);
    }, function (receiver_0, value) {
      return _set_content_(receiver_0, value);
    });
  }
  function content$factory_0() {
    return getPropertyCallableRef('content', 1, KMutableProperty1, function (receiver) {
      return _get_content_(receiver);
    }, function (receiver_0, value) {
      return _set_content_(receiver_0, value);
    });
  }
  function display$factory() {
    return getPropertyCallableRef('display', 1, KMutableProperty1, function (receiver) {
      return _get_display_(receiver);
    }, function (receiver_0, value) {
      return _set_display_(receiver_0, value);
    });
  }
  function display$factory_0() {
    return getPropertyCallableRef('display', 1, KMutableProperty1, function (receiver) {
      return _get_display_(receiver);
    }, function (receiver_0, value) {
      return _set_display_(receiver_0, value);
    });
  }
  function flexDirection$factory() {
    return getPropertyCallableRef('flexDirection', 1, KMutableProperty1, function (receiver) {
      return _get_flexDirection_(receiver);
    }, function (receiver_0, value) {
      return _set_flexDirection_(receiver_0, value);
    });
  }
  function flexDirection$factory_0() {
    return getPropertyCallableRef('flexDirection', 1, KMutableProperty1, function (receiver) {
      return _get_flexDirection_(receiver);
    }, function (receiver_0, value) {
      return _set_flexDirection_(receiver_0, value);
    });
  }
  function flexGrow$factory() {
    return getPropertyCallableRef('flexGrow', 1, KMutableProperty1, function (receiver) {
      return _get_flexGrow_(receiver);
    }, function (receiver_0, value) {
      return _set_flexGrow_(receiver_0, value);
    });
  }
  function flexGrow$factory_0() {
    return getPropertyCallableRef('flexGrow', 1, KMutableProperty1, function (receiver) {
      return _get_flexGrow_(receiver);
    }, function (receiver_0, value) {
      return _set_flexGrow_(receiver_0, value);
    });
  }
  function flexWrap$factory() {
    return getPropertyCallableRef('flexWrap', 1, KMutableProperty1, function (receiver) {
      return _get_flexWrap_(receiver);
    }, function (receiver_0, value) {
      return _set_flexWrap_(receiver_0, value);
    });
  }
  function flexWrap$factory_0() {
    return getPropertyCallableRef('flexWrap', 1, KMutableProperty1, function (receiver) {
      return _get_flexWrap_(receiver);
    }, function (receiver_0, value) {
      return _set_flexWrap_(receiver_0, value);
    });
  }
  function fontSize$factory() {
    return getPropertyCallableRef('fontSize', 1, KMutableProperty1, function (receiver) {
      return _get_fontSize_(receiver);
    }, function (receiver_0, value) {
      return _set_fontSize_(receiver_0, value);
    });
  }
  function fontSize$factory_0() {
    return getPropertyCallableRef('fontSize', 1, KMutableProperty1, function (receiver) {
      return _get_fontSize_(receiver);
    }, function (receiver_0, value) {
      return _set_fontSize_(receiver_0, value);
    });
  }
  function fontWeight$factory() {
    return getPropertyCallableRef('fontWeight', 1, KMutableProperty1, function (receiver) {
      return _get_fontWeight_(receiver);
    }, function (receiver_0, value) {
      return _set_fontWeight_(receiver_0, value);
    });
  }
  function fontWeight$factory_0() {
    return getPropertyCallableRef('fontWeight', 1, KMutableProperty1, function (receiver) {
      return _get_fontWeight_(receiver);
    }, function (receiver_0, value) {
      return _set_fontWeight_(receiver_0, value);
    });
  }
  function gridColumn$factory() {
    return getPropertyCallableRef('gridColumn', 1, KMutableProperty1, function (receiver) {
      return _get_gridColumn_(receiver);
    }, function (receiver_0, value) {
      return _set_gridColumn_(receiver_0, value);
    });
  }
  function gridColumn$factory_0() {
    return getPropertyCallableRef('gridColumn', 1, KMutableProperty1, function (receiver) {
      return _get_gridColumn_(receiver);
    }, function (receiver_0, value) {
      return _set_gridColumn_(receiver_0, value);
    });
  }
  function gridRow$factory() {
    return getPropertyCallableRef('gridRow', 1, KMutableProperty1, function (receiver) {
      return _get_gridRow_(receiver);
    }, function (receiver_0, value) {
      return _set_gridRow_(receiver_0, value);
    });
  }
  function gridRow$factory_0() {
    return getPropertyCallableRef('gridRow', 1, KMutableProperty1, function (receiver) {
      return _get_gridRow_(receiver);
    }, function (receiver_0, value) {
      return _set_gridRow_(receiver_0, value);
    });
  }
  function height$factory() {
    return getPropertyCallableRef('height', 1, KMutableProperty1, function (receiver) {
      return _get_height_(receiver);
    }, function (receiver_0, value) {
      return _set_height_(receiver_0, value);
    });
  }
  function height$factory_0() {
    return getPropertyCallableRef('height', 1, KMutableProperty1, function (receiver) {
      return _get_height_(receiver);
    }, function (receiver_0, value) {
      return _set_height_(receiver_0, value);
    });
  }
  function justifyContent$factory() {
    return getPropertyCallableRef('justifyContent', 1, KMutableProperty1, function (receiver) {
      return _get_justifyContent_(receiver);
    }, function (receiver_0, value) {
      return _set_justifyContent_(receiver_0, value);
    });
  }
  function justifyContent$factory_0() {
    return getPropertyCallableRef('justifyContent', 1, KMutableProperty1, function (receiver) {
      return _get_justifyContent_(receiver);
    }, function (receiver_0, value) {
      return _set_justifyContent_(receiver_0, value);
    });
  }
  function left$factory() {
    return getPropertyCallableRef('left', 1, KMutableProperty1, function (receiver) {
      return _get_left_(receiver);
    }, function (receiver_0, value) {
      return _set_left_(receiver_0, value);
    });
  }
  function left$factory_0() {
    return getPropertyCallableRef('left', 1, KMutableProperty1, function (receiver) {
      return _get_left_(receiver);
    }, function (receiver_0, value) {
      return _set_left_(receiver_0, value);
    });
  }
  function margin$factory() {
    return getPropertyCallableRef('margin', 1, KMutableProperty1, function (receiver) {
      return _get_margin_(receiver);
    }, function (receiver_0, value) {
      return _set_margin_(receiver_0, value);
    });
  }
  function margin$factory_0() {
    return getPropertyCallableRef('margin', 1, KMutableProperty1, function (receiver) {
      return _get_margin_(receiver);
    }, function (receiver_0, value) {
      return _set_margin_(receiver_0, value);
    });
  }
  function maxWidth$factory() {
    return getPropertyCallableRef('maxWidth', 1, KMutableProperty1, function (receiver) {
      return _get_maxWidth_(receiver);
    }, function (receiver_0, value) {
      return _set_maxWidth_(receiver_0, value);
    });
  }
  function maxWidth$factory_0() {
    return getPropertyCallableRef('maxWidth', 1, KMutableProperty1, function (receiver) {
      return _get_maxWidth_(receiver);
    }, function (receiver_0, value) {
      return _set_maxWidth_(receiver_0, value);
    });
  }
  function position$factory() {
    return getPropertyCallableRef('position', 1, KMutableProperty1, function (receiver) {
      return _get_position_(receiver);
    }, function (receiver_0, value) {
      return _set_position_(receiver_0, value);
    });
  }
  function position$factory_0() {
    return getPropertyCallableRef('position', 1, KMutableProperty1, function (receiver) {
      return _get_position_(receiver);
    }, function (receiver_0, value) {
      return _set_position_(receiver_0, value);
    });
  }
  function textAlign$factory() {
    return getPropertyCallableRef('textAlign', 1, KMutableProperty1, function (receiver) {
      return _get_textAlign_(receiver);
    }, function (receiver_0, value) {
      return _set_textAlign_(receiver_0, value);
    });
  }
  function textAlign$factory_0() {
    return getPropertyCallableRef('textAlign', 1, KMutableProperty1, function (receiver) {
      return _get_textAlign_(receiver);
    }, function (receiver_0, value) {
      return _set_textAlign_(receiver_0, value);
    });
  }
  function top$factory() {
    return getPropertyCallableRef('top', 1, KMutableProperty1, function (receiver) {
      return _get_top_(receiver);
    }, function (receiver_0, value) {
      return _set_top_(receiver_0, value);
    });
  }
  function top$factory_0() {
    return getPropertyCallableRef('top', 1, KMutableProperty1, function (receiver) {
      return _get_top_(receiver);
    }, function (receiver_0, value) {
      return _set_top_(receiver_0, value);
    });
  }
  function transform$factory() {
    return getPropertyCallableRef('transform', 1, KMutableProperty1, function (receiver) {
      return _get_transform_(receiver);
    }, function (receiver_0, value) {
      return _set_transform_(receiver_0, value);
    });
  }
  function transform$factory_0() {
    return getPropertyCallableRef('transform', 1, KMutableProperty1, function (receiver) {
      return _get_transform_(receiver);
    }, function (receiver_0, value) {
      return _set_transform_(receiver_0, value);
    });
  }
  function transition$factory() {
    return getPropertyCallableRef('transition', 1, KMutableProperty1, function (receiver) {
      return _get_transition_(receiver);
    }, function (receiver_0, value) {
      return _set_transition_(receiver_0, value);
    });
  }
  function transition$factory_0() {
    return getPropertyCallableRef('transition', 1, KMutableProperty1, function (receiver) {
      return _get_transition_(receiver);
    }, function (receiver_0, value) {
      return _set_transition_(receiver_0, value);
    });
  }
  function width$factory() {
    return getPropertyCallableRef('width', 1, KMutableProperty1, function (receiver) {
      return _get_width_(receiver);
    }, function (receiver_0, value) {
      return _set_width_(receiver_0, value);
    });
  }
  function width$factory_0() {
    return getPropertyCallableRef('width', 1, KMutableProperty1, function (receiver) {
      return _get_width_(receiver);
    }, function (receiver_0, value) {
      return _set_width_(receiver_0, value);
    });
  }
  function _no_name_provided_$factory_75() {
    var i = new _no_name_provided__97();
    return function () {
      return i.invoke_540();
    };
  }
  function _no_name_provided_$factory_76() {
    var i = new _no_name_provided__98();
    return function () {
      return i.invoke_540();
    };
  }
  function _no_name_provided_$factory_77() {
    var i = new _no_name_provided__99();
    return function () {
      return i.invoke_540();
    };
  }
  function Companion_28() {
    Companion_instance_27 = this;
    this._none_0 = new Animations();
  }
  Companion_28.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_27;
  function Companion_getInstance_27() {
    if (Companion_instance_27 == null)
      new Companion_28();
    return Companion_instance_27;
  }
  function Animations() {
    Companion_getInstance_27();
    StyleList.call(this, ', ');
  }
  Animations.$metadata$ = {
    simpleName: 'Animations',
    kind: 'class',
    interfaces: []
  };
  function Animation(duration, timing, delay_0, iterationCount, direction, fillMode, playState, name) {
    this._duration = duration;
    this._timing = timing;
    this._delay = delay_0;
    this._iterationCount = iterationCount;
    this._direction = direction;
    this._fillMode = fillMode;
    this._playState = playState;
    this._name_2 = name;
  }
  Animation.prototype.toString = function () {
    return '' + this._duration + ' ' + this._timing + ' ' + this._delay + ' ' + this._iterationCount + ' ' + this._direction + ' ' + this._fillMode + ' ' + this._playState + ' ' + this._name_2;
  };
  Animation.$metadata$ = {
    simpleName: 'Animation',
    kind: 'class',
    interfaces: []
  };
  function Companion_29() {
    Companion_instance_28 = this;
    this._infinite = new IterationCount('infinite');
  }
  Companion_29.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_28;
  function Companion_getInstance_28() {
    if (Companion_instance_28 == null)
      new Companion_29();
    return Companion_instance_28;
  }
  function IterationCount(value) {
    Companion_getInstance_28();
    CssValue.call(this, value);
    this._value_21 = value;
  }
  IterationCount.prototype._get_value__33 = function () {
    return this._value_21;
  };
  IterationCount.$metadata$ = {
    simpleName: 'IterationCount',
    kind: 'class',
    interfaces: []
  };
  var AnimationDirection_initial_instance;
  var AnimationDirection_inherit_instance;
  var AnimationDirection_unset_instance;
  var AnimationDirection_normal_instance;
  var AnimationDirection_reverse_instance;
  var AnimationDirection_alternate_instance;
  var AnimationDirection_alternateReverse_instance;
  var AnimationDirection_entriesInitialized;
  function AnimationDirection_initEntries() {
    if (AnimationDirection_entriesInitialized)
      return Unit_getInstance();
    AnimationDirection_entriesInitialized = true;
    AnimationDirection_initial_instance = new AnimationDirection('initial', 0);
    AnimationDirection_inherit_instance = new AnimationDirection('inherit', 1);
    AnimationDirection_unset_instance = new AnimationDirection('unset', 2);
    AnimationDirection_normal_instance = new AnimationDirection('normal', 3);
    AnimationDirection_reverse_instance = new AnimationDirection('reverse', 4);
    AnimationDirection_alternate_instance = new AnimationDirection('alternate', 5);
    AnimationDirection_alternateReverse_instance = new AnimationDirection('alternateReverse', 6);
  }
  function AnimationDirection(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  AnimationDirection.prototype.toString = function () {
    return hyphenize(this._get_name__10());
  };
  AnimationDirection.$metadata$ = {
    simpleName: 'AnimationDirection',
    kind: 'class',
    interfaces: []
  };
  var FillMode_initial_instance;
  var FillMode_inherit_instance;
  var FillMode_unset_instance;
  var FillMode_none_instance;
  var FillMode_forwards_instance;
  var FillMode_backwards_instance;
  var FillMode_both_instance;
  var FillMode_entriesInitialized;
  function FillMode_initEntries() {
    if (FillMode_entriesInitialized)
      return Unit_getInstance();
    FillMode_entriesInitialized = true;
    FillMode_initial_instance = new FillMode('initial', 0);
    FillMode_inherit_instance = new FillMode('inherit', 1);
    FillMode_unset_instance = new FillMode('unset', 2);
    FillMode_none_instance = new FillMode('none', 3);
    FillMode_forwards_instance = new FillMode('forwards', 4);
    FillMode_backwards_instance = new FillMode('backwards', 5);
    FillMode_both_instance = new FillMode('both', 6);
  }
  function FillMode(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  FillMode.prototype.toString = function () {
    return this._get_name__10();
  };
  FillMode.$metadata$ = {
    simpleName: 'FillMode',
    kind: 'class',
    interfaces: []
  };
  var PlayState_initial_instance;
  var PlayState_inherit_instance;
  var PlayState_unset_instance;
  var PlayState_running_instance;
  var PlayState_paused_instance;
  var PlayState_entriesInitialized;
  function PlayState_initEntries() {
    if (PlayState_entriesInitialized)
      return Unit_getInstance();
    PlayState_entriesInitialized = true;
    PlayState_initial_instance = new PlayState('initial', 0);
    PlayState_inherit_instance = new PlayState('inherit', 1);
    PlayState_unset_instance = new PlayState('unset', 2);
    PlayState_running_instance = new PlayState('running', 3);
    PlayState_paused_instance = new PlayState('paused', 4);
  }
  function PlayState(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  PlayState.prototype.toString = function () {
    return this._get_name__10();
  };
  PlayState.$metadata$ = {
    simpleName: 'PlayState',
    kind: 'class',
    interfaces: []
  };
  function _get_times_(_this_) {
    return new IterationCount('' + _this_);
  }
  function animation(_this_, name, duration, timing, delay_0, iterationCount, direction, fillMode, playState) {
    var tmp0_receiver = _this_;
    _get_animation_(tmp0_receiver).plusAssign(new Animation(duration, timing, delay_0, iterationCount, direction, fillMode, playState, name));
  }
  function AnimationDirection_normal_getInstance() {
    AnimationDirection_initEntries();
    return AnimationDirection_normal_instance;
  }
  function FillMode_none_getInstance() {
    FillMode_initEntries();
    return FillMode_none_instance;
  }
  function PlayState_running_getInstance() {
    PlayState_initEntries();
    return PlayState_running_instance;
  }
  function KeyframesBuilder(indent) {
    this._indent_0 = indent;
    var tmp = this;
    tmp._rules_0 = ArrayList_init_$Create$();
    var tmp_0 = this;
    tmp_0._multiRules_0 = ArrayList_init_$Create$();
  }
  KeyframesBuilder.prototype.toString = function () {
    var tmp0_apply_0_1 = StringBuilder_init_$Create$_0();
    this.buildRules_1(tmp0_apply_0_1, this._indent_0);
    return tmp0_apply_0_1.toString();
  };
  KeyframesBuilder.prototype._get_rules__1 = function () {
    return this._rules_0;
  };
  KeyframesBuilder.prototype._get_multiRules__1 = function () {
    return this._multiRules_0;
  };
  KeyframesBuilder.$metadata$ = {
    simpleName: 'KeyframesBuilder',
    kind: 'class',
    interfaces: [RuleContainer]
  };
  function Time(value) {
    CssValue.call(this, value);
    this._value_22 = value;
  }
  Time.prototype._get_value__33 = function () {
    return this._value_22;
  };
  Time.$metadata$ = {
    simpleName: 'Time',
    kind: 'class',
    interfaces: []
  };
  function Companion_30() {
    Companion_instance_29 = this;
    this._ease = new Timing('ease');
    this._linear = new Timing('linear');
    this._easeIn = new Timing('ease-in');
    this._easeOut = new Timing('ease-out');
    this._easeInOut = new Timing('ease-in-out');
    this._stepStart = new Timing('step-start');
    this._stepEnd = new Timing('step-end');
    this._materialStandard = cubicBezier(0.4, 0.0, 0.2, 1.0);
    this._materialDeceleration = cubicBezier(0.0, 0.0, 0.2, 1.0);
    this._materialAcceleration = cubicBezier(0.4, 0.0, 1.0, 1.0);
    this._materialSharp = cubicBezier(0.4, 0.0, 0.6, 1.0);
  }
  Companion_30.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_29;
  function Companion_getInstance_29() {
    if (Companion_instance_29 == null)
      new Companion_30();
    return Companion_instance_29;
  }
  function Timing(value) {
    Companion_getInstance_29();
    CssValue.call(this, value);
    this._value_23 = value;
  }
  Timing.prototype._get_value__33 = function () {
    return this._value_23;
  };
  Timing.$metadata$ = {
    simpleName: 'Timing',
    kind: 'class',
    interfaces: []
  };
  function cubicBezier(x1, y1, x2, y2) {
    return new Timing('' + 'cubic-bezier(' + x1 + ', ' + y1 + ', ' + x2 + ', ' + y2 + ')');
  }
  function _get_s_(_this_) {
    return new Time('' + _this_ + 's');
  }
  function Companion_31() {
    Companion_instance_30 = this;
    this._none_1 = new Transforms();
  }
  Companion_31.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_30;
  function Companion_getInstance_30() {
    if (Companion_instance_30 == null)
      new Companion_31();
    return Companion_instance_30;
  }
  function Transforms() {
    Companion_getInstance_30();
    StyleList.call(this, ' ');
  }
  Transforms.$metadata$ = {
    simpleName: 'Transforms',
    kind: 'class',
    interfaces: []
  };
  function Transform(name, args) {
    this._name_3 = name;
    this._args = args;
  }
  Transform.prototype.toString = function () {
    return '' + this._name_3 + '(' + joinToString$default(this._args, ', ', null, null, 0, null, null, 62, null) + ')';
  };
  Transform.$metadata$ = {
    simpleName: 'Transform',
    kind: 'class',
    interfaces: []
  };
  function transform(_this_, builder) {
    return builder(_get_transform_(_this_));
  }
  function rotate(_this_, a) {
    return add_0(_this_, 'rotate', [a]);
  }
  function Angle(value) {
    CssValue.call(this, value);
    this._value_24 = value;
  }
  Angle.prototype._get_value__33 = function () {
    return this._value_24;
  };
  Angle.$metadata$ = {
    simpleName: 'Angle',
    kind: 'class',
    interfaces: []
  };
  function _get_deg_(_this_) {
    return new Angle('' + _this_ + 'deg');
  }
  function add_0(_this_, name, args) {
    _this_.plusAssign(new Transform(name, args));
  }
  function Companion_32() {
    Companion_instance_31 = this;
    this._none_2 = new Transitions();
  }
  Companion_32.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_31;
  function Companion_getInstance_31() {
    if (Companion_instance_31 == null)
      new Companion_32();
    return Companion_instance_31;
  }
  function Transitions() {
    Companion_getInstance_31();
    StyleList.call(this, ', ');
  }
  Transitions.$metadata$ = {
    simpleName: 'Transitions',
    kind: 'class',
    interfaces: []
  };
  function Transition(property, duration, timing, delay_0) {
    this._property = property;
    this._duration_0 = duration;
    this._timing_0 = timing;
    this._delay_0 = delay_0;
  }
  Transition.prototype.toString = function () {
    return '' + this._property + ' ' + this._duration_0 + ' ' + this._timing_0 + ' ' + this._delay_0;
  };
  Transition.$metadata$ = {
    simpleName: 'Transition',
    kind: 'class',
    interfaces: []
  };
  function transition(_this_, property, duration, timing, delay_0) {
    var tmp0_receiver = _this_;
    _get_transition_(tmp0_receiver).plusAssign(new Transition(property, duration, timing, delay_0));
  }
  function transition$default(_this_, property, duration, timing, delay_0, $mask0, $handler) {
    if (!(($mask0 & 1) === 0))
      property = 'all';
    if (!(($mask0 & 2) === 0))
      duration = _get_s_(0);
    if (!(($mask0 & 4) === 0))
      timing = Companion_getInstance_29()._ease;
    if (!(($mask0 & 8) === 0))
      delay_0 = _get_s_(0);
    return transition(_this_, property, duration, timing, delay_0);
  }
  function animation_0(_this_, duration, timing, delay_0, iterationCount, direction, fillMode, playState, handler) {
    var tmp0_keyframes_0 = _this_._indent;
    var builder_1 = new KeyframesBuilder(tmp0_keyframes_0);
    handler(builder_1);
    return animation(_this_, keyframesName(builder_1.toString()), duration, timing, delay_0, iterationCount, direction, fillMode, playState);
  }
  function animation$default(_this_, duration, timing, delay_0, iterationCount, direction, fillMode, playState, handler, $mask0, $handler) {
    if (!(($mask0 & 1) === 0))
      duration = _get_s_(0);
    if (!(($mask0 & 2) === 0))
      timing = Companion_getInstance_29()._ease;
    if (!(($mask0 & 4) === 0))
      delay_0 = _get_s_(0);
    if (!(($mask0 & 8) === 0))
      iterationCount = _get_times_(1);
    if (!(($mask0 & 16) === 0))
      direction = AnimationDirection_normal_getInstance();
    if (!(($mask0 & 32) === 0))
      fillMode = FillMode_none_getInstance();
    if (!(($mask0 & 64) === 0))
      playState = PlayState_running_getInstance();
    return animation_0(_this_, duration, timing, delay_0, iterationCount, direction, fillMode, playState, handler);
  }
  function StyledDOMBuilder(factory) {
    RDOMBuilder.call(this, factory);
    this._type_0 = this._get_attrs__1()._get_tagName__7();
    var tmp = this;
    tmp._css_0 = CSSBuilder_init_$Create$(null, false, null, 7, null);
  }
  StyledDOMBuilder.prototype._get_css__0 = function () {
    return this._css_0;
  };
  StyledDOMBuilder.prototype.create_1 = function () {
    return Styled_getInstance().createElement_0(this._type_0, this._css_0, this._get_props__0(), this._get_childList__2());
  };
  StyledDOMBuilder.$metadata$ = {
    simpleName: 'StyledDOMBuilder',
    kind: 'class',
    interfaces: [StyledBuilder]
  };
  function StyledBuilder() {
  }
  StyledBuilder.$metadata$ = {
    simpleName: 'StyledBuilder',
    kind: 'interface',
    interfaces: []
  };
  function _no_name_provided__100() {
  }
  _no_name_provided__100.prototype.invoke_155 = function (it) {
    return it._css;
  };
  _no_name_provided__100.prototype.invoke_542 = function (p1) {
    return this.invoke_155((!(p1 == null) ? isObject(p1) : false) ? p1 : THROW_CCE());
  };
  _no_name_provided__100.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function wrap($this, type) {
    var tmp0_getOrPut_0 = $this._cache;
    var value_1 = tmp0_getOrPut_0.get_63(type);
    var tmp;
    if (value_1 == null) {
      var answer_2 = devOverrideUseRef(_no_name_provided_$factory_78(type));
      tmp0_getOrPut_0.put_12(type, answer_2);
      Unit_getInstance();
      tmp = answer_2;
    } else {
      tmp = value_1;
    }
    return tmp;
  }
  function _no_name_provided__101($type) {
    this._$type = $type;
  }
  _no_name_provided__101.prototype.invoke_540 = function () {
    var tmp = rawStyled(this._$type);
    return invoke(tmp, [_no_name_provided_$factory_79()]);
  };
  _no_name_provided__101.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function Styled() {
    Styled_instance = this;
    var tmp = this;
    tmp._cache = LinkedHashMap_init_$Create$();
  }
  Styled.prototype.createElement_0 = function (type, css_0, props, children) {
    var wrappedType = wrap(this, type);
    var styledProps = props;
    var tmp;
    var tmp_0;
    var tmp0_isNotEmpty_0 = css_0._rules;
    if (!tmp0_isNotEmpty_0.isEmpty_53()) {
      tmp_0 = true;
    } else {
      {
        var tmp1_isNotEmpty_0 = css_0._multiRules;
        tmp_0 = !tmp1_isNotEmpty_0.isEmpty_53();
      }
    }
    if (tmp_0) {
      tmp = true;
    } else {
      {
        var tmp2_isNotEmpty_0 = css_0._get_declarations__0();
        tmp = !tmp2_isNotEmpty_0.isEmpty_53();
      }
    }
    if (tmp) {
      styledProps._css = css_0.toString();
    } else {
    }
    var tmp3_isNotEmpty_0 = css_0._classes;
    if (!tmp3_isNotEmpty_0.isEmpty_53()) {
      var tmp_1 = css_0._classes;
      styledProps.className = joinToString$default_0(tmp_1, ' ', null, null, 0, null, null, 62, null);
    } else {
    }
    var tmp4_isNotEmpty_0 = css_0._styleName;
    if (!tmp4_isNotEmpty_0.isEmpty_53()) {
      var tmp_2 = css_0._styleName;
      styledProps['data-style'] = joinToString$default_0(tmp_2, ' ', null, null, 0, null, null, 62, null);
    } else {
    }
    var tmp_3 = wrappedType;
    return createElement.apply(null, [tmp_3, styledProps].concat([].slice.call(copyToArray_0(children).slice())));
  };
  Styled.$metadata$ = {
    simpleName: 'Styled',
    kind: 'object',
    interfaces: []
  };
  var Styled_instance;
  function Styled_getInstance() {
    if (Styled_instance == null)
      new Styled();
    return Styled_instance;
  }
  function devOverrideUseRef(action) {
    var tmp;
    if (process.env.NODE_ENV !== 'production') {
      var tmp0_asDynamic_0 = ReactModule;
      var useRef_0 = tmp0_asDynamic_0.useRef;
      var tmp1_asDynamic_0 = ReactModule;
      tmp1_asDynamic_0.useRef = _no_name_provided_$factory_80();
      var result = action();
      var tmp2_asDynamic_0 = ReactModule;
      tmp2_asDynamic_0.useRef = useRef_0;
      tmp = result;
    } else {
      tmp = action();
    }
    return tmp;
  }
  function keyframesName(string) {
    var keyframes_0 = invoke_0(keyframes, string, []);
    var tmp0_asDynamic_0 = invoke(css, [keyframes_0.rules]);
    var keyframesInternal = tmp0_asDynamic_0;
    var name = keyframes_0.getName();
    if (!(keyframesInternal == null) ? typeof keyframesInternal === 'string' : false)
      injectGlobalKeyframeStyle(name, keyframesInternal);
    else {
      if (!(keyframesInternal == null) ? isArray(keyframesInternal) : false)
        injectGlobalKeyframeStyle(name, keyframesInternal[0]);
      else {
        injectGlobals(keyframesInternal);
      }
    }
    return keyframes_0.getName();
  }
  function injectGlobalKeyframeStyle(name, style) {
    var tmp;
    if (startsWith$default_1(style, '@-webkit-keyframes', false, 2, null)) {
      tmp = true;
    } else {
      {
        tmp = startsWith$default_1(style, '@keyframes', false, 2, null);
      }
    }
    if (tmp) {
      injectGlobal(style);
    } else {
      {
        var tmp0_arrayOf_0 = ['' + '@-webkit-keyframes ' + name + ' {' + style + '}', '' + '@keyframes ' + name + ' {' + style + '}'];
        injectGlobals(tmp0_arrayOf_0);
      }
    }
  }
  function injectGlobals(strings) {
    var globalStyle = devOverrideUseRef(_no_name_provided_$factory_81(strings));
    var tmp = Promise.resolve(Unit_getInstance());
    tmp.then(_no_name_provided_$factory_82(globalStyle));
    Unit_getInstance();
  }
  function injectGlobal(string) {
    var globalStyle = devOverrideUseRef(_no_name_provided_$factory_83(string));
    var tmp = Promise.resolve(Unit_getInstance());
    tmp.then(_no_name_provided_$factory_84(globalStyle));
    Unit_getInstance();
  }
  function _get_root_($this) {
    var tmp0_getValue_0 = $this._root$delegate;
    var tmp1_getValue_0 = root$factory();
    return tmp0_getValue_0._get_value__33();
  }
  function _no_name_provided__102() {
  }
  _no_name_provided__102.prototype.invoke_158 = function ($this$functionalComponent, props) {
    var tmp0_forEach_0 = props.globalStyles;
    var tmp0_iterator_1 = tmp0_forEach_0.iterator_64();
    while (tmp0_iterator_1.hasNext_31()) {
      var element_2 = tmp0_iterator_1.next_35();
      var tmp0_apply_0_1_4 = {};
      Unit_getInstance();
      $this$functionalComponent.child_12(element_2, tmp0_apply_0_1_4, emptyList());
      Unit_getInstance();
    }
  };
  _no_name_provided__102.prototype.invoke_537 = function (p1, p2) {
    var tmp = p1 instanceof RBuilder ? p1 : THROW_CCE();
    this.invoke_158(tmp, (!(p2 == null) ? isObject(p2) : false) ? p2 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__102.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__103() {
  }
  _no_name_provided__103.prototype.invoke_540 = function () {
    var tmp = ensureNotNull(window.document.body).appendChild(window.document.createElement('div'));
    var element = tmp instanceof Element ? tmp : THROW_CCE();
    element.setAttribute('id', 'sc-global-styles');
    return element;
  };
  _no_name_provided__103.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function GlobalStyles() {
    GlobalStyles_instance = this;
    var tmp = this;
    tmp._component = functionalComponent$default(null, _no_name_provided_$factory_85(), 1, null);
    var tmp_0 = this;
    tmp_0._root$delegate = lazy(_no_name_provided_$factory_86());
    var tmp_1 = this;
    tmp_1._styles = ArrayList_init_$Create$();
  }
  GlobalStyles.prototype.add_21 = function (globalStyle) {
    this._styles.add_33(globalStyle);
    Unit_getInstance();
    var tmp = GlobalStyles_getInstance()._component;
    var tmp0_apply_0_1 = {};
    tmp0_apply_0_1.globalStyles = GlobalStyles_getInstance()._styles;
    var reactElement = createElement.apply(null, [tmp, tmp0_apply_0_1]);
    render(reactElement, _get_root_(this));
  };
  GlobalStyles.$metadata$ = {
    simpleName: 'GlobalStyles',
    kind: 'object',
    interfaces: []
  };
  var GlobalStyles_instance;
  function GlobalStyles_getInstance() {
    if (GlobalStyles_instance == null)
      new GlobalStyles();
    return GlobalStyles_instance;
  }
  function _no_name_provided__104() {
  }
  _no_name_provided__104.prototype.invoke_540 = function () {
    throw Error_init_$Create$('invalid hook call');
  };
  _no_name_provided__104.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__105($strings) {
    this._$strings = $strings;
  }
  _no_name_provided__105.prototype.invoke_540 = function () {
    return invoke_1(createGlobalStyle, this._$strings, []);
  };
  _no_name_provided__105.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__106($globalStyle) {
    this._$globalStyle = $globalStyle;
  }
  _no_name_provided__106.prototype.invoke_166 = function (it) {
    GlobalStyles_getInstance().add_21(this._$globalStyle);
  };
  _no_name_provided__106.prototype.invoke_542 = function (p1) {
    this.invoke_166(p1 instanceof Unit ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__106.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__107($string) {
    this._$string = $string;
  }
  _no_name_provided__107.prototype.invoke_540 = function () {
    return invoke_0(createGlobalStyle, this._$string, []);
  };
  _no_name_provided__107.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__108($globalStyle) {
    this._$globalStyle_0 = $globalStyle;
  }
  _no_name_provided__108.prototype.invoke_166 = function (it) {
    GlobalStyles_getInstance().add_21(this._$globalStyle_0);
  };
  _no_name_provided__108.prototype.invoke_542 = function (p1) {
    this.invoke_166(p1 instanceof Unit ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__108.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function root$factory() {
    return getPropertyCallableRef('root', 1, KProperty1, function (receiver) {
      return _get_root_(receiver);
    }, null);
  }
  function _no_name_provided_$factory_78($type) {
    var i = new _no_name_provided__101($type);
    return function () {
      return i.invoke_540();
    };
  }
  function _no_name_provided_$factory_79() {
    var i = new _no_name_provided__100();
    return function (p1) {
      return i.invoke_155(p1);
    };
  }
  function _no_name_provided_$factory_80() {
    var i = new _no_name_provided__104();
    return function () {
      return i.invoke_540();
    };
  }
  function _no_name_provided_$factory_81($strings) {
    var i = new _no_name_provided__105($strings);
    return function () {
      return i.invoke_540();
    };
  }
  function _no_name_provided_$factory_82($globalStyle) {
    var i = new _no_name_provided__106($globalStyle);
    return function (p1) {
      i.invoke_166(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_83($string) {
    var i = new _no_name_provided__107($string);
    return function () {
      return i.invoke_540();
    };
  }
  function _no_name_provided_$factory_84($globalStyle) {
    var i = new _no_name_provided__108($globalStyle);
    return function (p1) {
      i.invoke_166(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_85() {
    var i = new _no_name_provided__102();
    return function (p1, p2) {
      i.invoke_158(p1, p2);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_86() {
    var i = new _no_name_provided__103();
    return function () {
      return i.invoke_540();
    };
  }
  function rawStyled(target) {
    var tmp0_asDynamic_0 = StyledComponents;
    return tmp0_asDynamic_0.default(target);
  }
  function hashRouter(_this_, basename, hashType, getUserConfirmation, handler) {
    var tmp = getKClass_0(HashRouter);
    return _this_.child_14(tmp, _no_name_provided_$factory_87(handler, basename, hashType, getUserConfirmation));
  }
  function hashRouter$default(_this_, basename, hashType, getUserConfirmation, handler, $mask0, $handler) {
    if (!(($mask0 & 1) === 0))
      basename = '';
    if (!(($mask0 & 2) === 0))
      hashType = HashType_slash_getInstance();
    if (!(($mask0 & 4) === 0))
      getUserConfirmation = null;
    return hashRouter(_this_, basename, hashType, getUserConfirmation, handler);
  }
  function switch_0(_this_, handler) {
    return _this_.child_14(getKClass_0(Switch), handler);
  }
  function route(_this_, path, exact, strict, render_1) {
    var tmp0_child_0 = _no_name_provided_$factory_88(path, exact, strict, render_1);
    return _this_.child_14(getKClass_0(Route), tmp0_child_0);
  }
  function route$default(_this_, path, exact, strict, render_1, $mask0, $handler) {
    if (!(($mask0 & 2) === 0))
      exact = false;
    if (!(($mask0 & 4) === 0))
      strict = false;
    return route(_this_, path, exact, strict, render_1);
  }
  function redirect(_this_, from, to_1, push, exact, strict) {
    var tmp = getKClass_0(Redirect);
    return _this_.child_14(tmp, _no_name_provided_$factory_89(from, to_1, push, exact, strict));
  }
  function redirect$default(_this_, from, to_1, push, exact, strict, $mask0, $handler) {
    if (!(($mask0 & 1) === 0))
      from = null;
    if (!(($mask0 & 4) === 0))
      push = false;
    if (!(($mask0 & 8) === 0))
      exact = false;
    if (!(($mask0 & 16) === 0))
      strict = false;
    return redirect(_this_, from, to_1, push, exact, strict);
  }
  var HashType_slash_instance;
  var HashType_noslash_instance;
  var HashType_hashbang_instance;
  var HashType_entriesInitialized;
  function HashType_initEntries() {
    if (HashType_entriesInitialized)
      return Unit_getInstance();
    HashType_entriesInitialized = true;
    HashType_slash_instance = new HashType('slash', 0);
    HashType_noslash_instance = new HashType('noslash', 1);
    HashType_hashbang_instance = new HashType('hashbang', 2);
  }
  function HashType(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  HashType.$metadata$ = {
    simpleName: 'HashType',
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__109($basename, $hashType, $getUserConfirmation) {
    this._$basename = $basename;
    this._$hashType = $hashType;
    this._$getUserConfirmation = $getUserConfirmation;
  }
  _no_name_provided__109.prototype.invoke_168 = function ($this$attrs) {
    $this$attrs.basename = this._$basename;
    $this$attrs.hashType = this._$hashType._get_name__10();
    $this$attrs.getUserConfirmation = this._$getUserConfirmation;
  };
  _no_name_provided__109.prototype.invoke_542 = function (p1) {
    this.invoke_168((!(p1 == null) ? isObject(p1) : false) ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__109.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__110($handler, $basename, $hashType, $getUserConfirmation) {
    this._$handler = $handler;
    this._$basename_0 = $basename;
    this._$hashType_0 = $hashType;
    this._$getUserConfirmation_0 = $getUserConfirmation;
  }
  _no_name_provided__110.prototype.invoke_170 = function ($this$child) {
    $this$child.attrs_0(_no_name_provided_$factory_90(this._$basename_0, this._$hashType_0, this._$getUserConfirmation_0));
    this._$handler($this$child);
  };
  _no_name_provided__110.prototype.invoke_542 = function (p1) {
    this.invoke_170(p1 instanceof RElementBuilder ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__110.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__111($render) {
    this._$render = $render;
  }
  _no_name_provided__111.prototype.invoke_172 = function (it) {
    return this._$render();
  };
  _no_name_provided__111.prototype.invoke_542 = function (p1) {
    return this.invoke_172((!(p1 == null) ? isObject(p1) : false) ? p1 : THROW_CCE());
  };
  _no_name_provided__111.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__112($path, $exact, $strict, $render) {
    this._$path = $path;
    this._$exact = $exact;
    this._$strict = $strict;
    this._$render_0 = $render;
  }
  _no_name_provided__112.prototype.invoke_174 = function ($this$attrs) {
    $this$attrs.path = this._$path;
    $this$attrs.exact = this._$exact;
    $this$attrs.strict = this._$strict;
    $this$attrs.render = _no_name_provided_$factory_92(this._$render_0);
  };
  _no_name_provided__112.prototype.invoke_542 = function (p1) {
    this.invoke_174((!(p1 == null) ? isObject(p1) : false) ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__112.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__113($path, $exact, $strict, $render) {
    this._$path_0 = $path;
    this._$exact_0 = $exact;
    this._$strict_0 = $strict;
    this._$render_1 = $render;
  }
  _no_name_provided__113.prototype.invoke_176 = function ($this$child) {
    $this$child.attrs_0(_no_name_provided_$factory_91(this._$path_0, this._$exact_0, this._$strict_0, this._$render_1));
  };
  _no_name_provided__113.prototype.invoke_542 = function (p1) {
    this.invoke_176(p1 instanceof RElementBuilder ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__113.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__114($from, $to, $push, $exact, $strict) {
    this._$from = $from;
    this._$to = $to;
    this._$push = $push;
    this._$exact_1 = $exact;
    this._$strict_1 = $strict;
  }
  _no_name_provided__114.prototype.invoke_178 = function ($this$attrs) {
    $this$attrs.from = this._$from;
    $this$attrs.to = this._$to;
    $this$attrs.push = this._$push;
    $this$attrs.exact = this._$exact_1;
    $this$attrs.strict = this._$strict_1;
  };
  _no_name_provided__114.prototype.invoke_542 = function (p1) {
    this.invoke_178((!(p1 == null) ? isObject(p1) : false) ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__114.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__115($from, $to, $push, $exact, $strict) {
    this._$from_0 = $from;
    this._$to_0 = $to;
    this._$push_0 = $push;
    this._$exact_2 = $exact;
    this._$strict_2 = $strict;
  }
  _no_name_provided__115.prototype.invoke_180 = function ($this$child) {
    $this$child.attrs_0(_no_name_provided_$factory_93(this._$from_0, this._$to_0, this._$push_0, this._$exact_2, this._$strict_2));
  };
  _no_name_provided__115.prototype.invoke_542 = function (p1) {
    this.invoke_180(p1 instanceof RElementBuilder ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__115.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function HashType_slash_getInstance() {
    HashType_initEntries();
    return HashType_slash_instance;
  }
  function _no_name_provided_$factory_87($handler, $basename, $hashType, $getUserConfirmation) {
    var i = new _no_name_provided__110($handler, $basename, $hashType, $getUserConfirmation);
    return function (p1) {
      i.invoke_170(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_88($path, $exact, $strict, $render) {
    var i = new _no_name_provided__113($path, $exact, $strict, $render);
    return function (p1) {
      i.invoke_176(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_89($from, $to, $push, $exact, $strict) {
    var i = new _no_name_provided__115($from, $to, $push, $exact, $strict);
    return function (p1) {
      i.invoke_180(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_90($basename, $hashType, $getUserConfirmation) {
    var i = new _no_name_provided__109($basename, $hashType, $getUserConfirmation);
    return function (p1) {
      i.invoke_168(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_91($path, $exact, $strict, $render) {
    var i = new _no_name_provided__112($path, $exact, $strict, $render);
    return function (p1) {
      i.invoke_174(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_92($render) {
    var i = new _no_name_provided__111($render);
    return function (p1) {
      return i.invoke_172(p1);
    };
  }
  function _no_name_provided_$factory_93($from, $to, $push, $exact, $strict) {
    var i = new _no_name_provided__114($from, $to, $push, $exact, $strict);
    return function (p1) {
      i.invoke_178(p1);
      return Unit_getInstance();
    };
  }
  function ByteReadChannel(content) {
    return ByteReadChannel_0(content, 0, content.length);
  }
  function ByteChannel() {
  }
  ByteChannel.$metadata$ = {
    simpleName: 'ByteChannel',
    kind: 'interface',
    interfaces: [ByteReadChannel_1, ByteWriteChannel]
  };
  function ByteChannelSequentialBase_init_$Init$(initial, autoFlush, pool, $mask0, $marker, $this) {
    if (!(($mask0 & 4) === 0))
      pool = Companion_getInstance_36()._Pool;
    ByteChannelSequentialBase.call($this, initial, autoFlush, pool);
    return $this;
  }
  function _get_flushSize_($this) {
    return $this._flushBuffer._get_size__45();
  }
  function _set__totalBytesRead_($this, value) {
    $this._state_4._totalBytesRead = value;
  }
  function _get__totalBytesRead_($this) {
    return $this._state_4._totalBytesRead;
  }
  function _set__totalBytesWritten_($this, value) {
    $this._state_4._totalBytesWritten = value;
  }
  function _get__totalBytesWritten_($this) {
    return $this._state_4._totalBytesWritten;
  }
  function _set_closedCause_($this, value) {
    $this._state_4._closedCause = value;
  }
  function flushImpl($this) {
    if ($this._writable._get_isEmpty__4()) {
      return false;
    }flushWrittenBytes($this);
    $this._slot.resume_2();
    return true;
  }
  function flushWrittenBytes($this) {
    var tmp0_synchronized_0 = $this._flushMutex;
    var buffer_2 = ensureNotNull($this._writable.stealAll_4());
    $this._flushBuffer.writeChunkBuffer_0(buffer_2);
  }
  function ensureNotClosed($this) {
    if ($this._get_closed__0()) {
      var tmp0_elvis_lhs = $this._get_closedCause__0();
      throw tmp0_elvis_lhs == null ? new ClosedWriteChannelException('Channel is already closed') : tmp0_elvis_lhs;
    }}
  function ensureNotFailed($this) {
    var tmp0_safe_receiver = $this._get_closedCause__0();
    if (tmp0_safe_receiver == null)
      null;
    else {
      throw tmp0_safe_receiver;
    }
    Unit_getInstance();
  }
  function ensureNotFailed_0($this, closeable) {
    var tmp0_safe_receiver = $this._get_closedCause__0();
    if (tmp0_safe_receiver == null)
      null;
    else {
      closeable.release_4();
      throw tmp0_safe_receiver;
    }
    Unit_getInstance();
  }
  function readRemainingSuspend($this, builder, limit, $cont) {
    var tmp = new $readRemainingSuspendCOROUTINE$27($this, builder, limit, $cont);
    tmp._result = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_72();
  }
  function readAvailableSuspend($this, dst, $cont) {
    var tmp = new $readAvailableSuspendCOROUTINE$31($this, dst, $cont);
    tmp._result = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_72();
  }
  function $awaitAtLeastNBytesAvailableForWriteCOROUTINE$0(_this_, count_0, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__1 = _this_;
    this._count = count_0;
  }
  $awaitAtLeastNBytesAvailableForWriteCOROUTINE$0.prototype.doResume_72 = function () {
    var suspendResult = this._result;
    $sm: do
      try {
        var tmp = this._state_0;
        switch (tmp) {
          case 0:
            this._exceptionState = 4;
            this._state_0 = 1;
            continue $sm;
          case 1:
            if (!(this.__this__1._get_availableForWrite__0() < this._count ? !this.__this__1._get_closed__0() : false)) {
              this._state_0 = 5;
              continue $sm;
            }
            if (!flushImpl(this.__this__1)) {
              this._state_0 = 2;
              suspendResult = this.__this__1._slot.sleep(this);
              if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
                return suspendResult;
              }continue $sm;
            } else {
              this._state_0 = 3;
              continue $sm;
            }

            break;
          case 2:
            suspendResult;
            this._state_0 = 3;
            continue $sm;
          case 3:
            this._state_0 = 1;
            continue $sm;
          case 4:
            throw this._exception_0;
          case 5:
            return Unit_getInstance();
        }
      } catch ($p) {
        if (this._exceptionState === 4) {
          throw $p;
        } else {
          this._state_0 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $awaitAtLeastNBytesAvailableForWriteCOROUTINE$0.$metadata$ = {
    simpleName: '$awaitAtLeastNBytesAvailableForWriteCOROUTINE$0',
    kind: 'class',
    interfaces: []
  };
  function $awaitAtLeastNBytesAvailableForReadCOROUTINE$1(_this_, count_0, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__2 = _this_;
    this._count_0 = count_0;
  }
  $awaitAtLeastNBytesAvailableForReadCOROUTINE$1.prototype.doResume_72 = function () {
    var suspendResult = this._result;
    $sm: do
      try {
        var tmp = this._state_0;
        switch (tmp) {
          case 0:
            this._exceptionState = 3;
            this._state_0 = 1;
            continue $sm;
          case 1:
            if (!(this.__this__2._get_availableForRead__0() < this._count_0 ? !this.__this__2._get_closed__0() : false)) {
              this._state_0 = 4;
              continue $sm;
            }
            this._state_0 = 2;
            suspendResult = this.__this__2._slot.sleep(this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 2:
            suspendResult;
            this._state_0 = 1;
            continue $sm;
          case 3:
            throw this._exception_0;
          case 4:
            return Unit_getInstance();
        }
      } catch ($p) {
        if (this._exceptionState === 3) {
          throw $p;
        } else {
          this._state_0 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $awaitAtLeastNBytesAvailableForReadCOROUTINE$1.$metadata$ = {
    simpleName: '$awaitAtLeastNBytesAvailableForReadCOROUTINE$1',
    kind: 'class',
    interfaces: []
  };
  function $writeFullyCOROUTINE$9(_this_, src, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__3 = _this_;
    this._src = src;
  }
  $writeFullyCOROUTINE$9.prototype.doResume_72 = function () {
    var suspendResult = this._result;
    $sm: do
      try {
        var tmp = this._state_0;
        switch (tmp) {
          case 0:
            this._exceptionState = 2;
            this._state_0 = 1;
            suspendResult = this.__this__3.awaitAtLeastNBytesAvailableForWrite_0(1, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            suspendResult;
            var count_0 = this._src._get_writePosition__1() - this._src._get_readPosition__1() | 0;
            writeFully$default_0(this.__this__3._writable, this._src, 0, 2, null);
            this.__this__3.afterWrite_0(count_0);
            return Unit_getInstance();
          case 2:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 2) {
          throw $p;
        } else {
          this._state_0 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $writeFullyCOROUTINE$9.$metadata$ = {
    simpleName: '$writeFullyCOROUTINE$9',
    kind: 'class',
    interfaces: []
  };
  function $writeFullyCOROUTINE$10(_this_, src, offset, length, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__4 = _this_;
    this._src_0 = src;
    this._offset_0 = offset;
    this._length_0 = length;
  }
  $writeFullyCOROUTINE$10.prototype.doResume_72 = function () {
    var suspendResult = this._result;
    $sm: do
      try {
        var tmp = this._state_0;
        switch (tmp) {
          case 0:
            this._exceptionState = 4;
            this._currentIndex0 = this._offset_0;
            this._endIndex1 = this._offset_0 + this._length_0 | 0;
            this._state_0 = 1;
            continue $sm;
          case 1:
            if (!(this._currentIndex0 < this._endIndex1)) {
              this._state_0 = 3;
              continue $sm;
            }
            this._state_0 = 2;
            suspendResult = this.__this__4.awaitAtLeastNBytesAvailableForWrite_0(1, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 2:
            suspendResult;
            var tmp0_min_0 = this.__this__4._get_availableForWrite__0();
            var tmp1_min_0 = this._endIndex1 - this._currentIndex0 | 0;
            var bytesCount = function () {
              var $externalVarargReceiverTmp = Math;
              return $externalVarargReceiverTmp.min.apply($externalVarargReceiverTmp, [].concat([].slice.call(new Int32Array([tmp0_min_0, tmp1_min_0]))));
            }.call(this);
            writeFully_2(this.__this__4._writable, this._src_0, this._currentIndex0, bytesCount);
            this._currentIndex0 = this._currentIndex0 + bytesCount | 0;
            this.__this__4.afterWrite_0(bytesCount);
            this._state_0 = 1;
            continue $sm;
          case 3:
            return Unit_getInstance();
          case 4:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 4) {
          throw $p;
        } else {
          this._state_0 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $writeFullyCOROUTINE$10.$metadata$ = {
    simpleName: '$writeFullyCOROUTINE$10',
    kind: 'class',
    interfaces: []
  };
  function $readRemainingCOROUTINE$26(_this_, limit, headerSizeHint, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__5 = _this_;
    this._limit_0 = limit;
    this._headerSizeHint = headerSizeHint;
  }
  $readRemainingCOROUTINE$26.prototype.doResume_72 = function () {
    var suspendResult = this._result;
    $sm: do
      try {
        var tmp = this._state_0;
        switch (tmp) {
          case 0:
            this._exceptionState = 3;
            ensureNotFailed(this.__this__5);
            this._builder0 = BytePacketBuilder_0(this._headerSizeHint);
            var tmp_0 = this;
            var tmp_1 = this;
            tmp_1._tmp0_minOf_01 = this.__this__5._readable._get_remaining__2();
            tmp_0._size2 = this._limit_0.compareTo_69(this._tmp0_minOf_01) <= 0 ? this._limit_0 : this._tmp0_minOf_01;
            this._builder0.writePacket_2(this.__this__5._readable, this._size2);
            var tmp_2 = this;
            var tmp_3 = this;
            tmp_3._tmp1_minus_03 = this._builder0._get_size__45();
            tmp_2._remaining4 = this._limit_0.minus_29(toLong_0(this._tmp1_minus_03));
            if (this._remaining4.equals(new Long(0, 0)) ? true : this.__this__5._get_isClosedForRead__0()) {
              var tmp_4 = this;
              this.__this__5.afterRead_0(this._remaining4.toInt_5());
              ensureNotFailed_0(this.__this__5, this._builder0);
              tmp_4._WHEN_RESULT5 = this._builder0.build_16();
              this._state_0 = 2;
              continue $sm;
            } else {
              this._state_0 = 1;
              suspendResult = readRemainingSuspend(this.__this__5, this._builder0, this._limit_0, this);
              if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
                return suspendResult;
              }continue $sm;
            }

            break;
          case 1:
            this._WHEN_RESULT5 = suspendResult;
            this._state_0 = 2;
            continue $sm;
          case 2:
            return this._WHEN_RESULT5;
          case 3:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 3) {
          throw $p;
        } else {
          this._state_0 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $readRemainingCOROUTINE$26.$metadata$ = {
    simpleName: '$readRemainingCOROUTINE$26',
    kind: 'class',
    interfaces: []
  };
  function $readRemainingSuspendCOROUTINE$27(_this_, builder, limit, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__6 = _this_;
    this._builder = builder;
    this._limit_1 = limit;
  }
  $readRemainingSuspendCOROUTINE$27.prototype.doResume_72 = function () {
    var suspendResult = this._result;
    $sm: do
      try {
        var tmp = this._state_0;
        switch (tmp) {
          case 0:
            this._exceptionState = 5;
            this._state_0 = 1;
            continue $sm;
          case 1:
            if (!(toLong_0(this._builder._get_size__45()).compareTo_69(this._limit_1) < 0)) {
              this._state_0 = 4;
              continue $sm;
            }
            var tmp_0 = this;
            var tmp_1 = this;
            var tmp0_minus_0 = this._builder._get_size__45();
            tmp_1._tmp1_minOf_00 = this._limit_1.minus_29(toLong_0(tmp0_minus_0));
            var tmp_2 = this;
            tmp_2._tmp2_minOf_01 = this.__this__6._readable._get_remaining__2();
            tmp_0._partLimit2 = this._tmp1_minOf_00.compareTo_69(this._tmp2_minOf_01) <= 0 ? this._tmp1_minOf_00 : this._tmp2_minOf_01;
            this._builder.writePacket_2(this.__this__6._readable, this._partLimit2);
            this.__this__6.afterRead_0(this._partLimit2.toInt_5());
            ensureNotFailed_0(this.__this__6, this._builder);
            if (this.__this__6._get_isClosedForRead__0() ? true : this._builder._get_size__45() === this._limit_1.toInt_5()) {
              this._state_0 = 4;
              continue $sm;
            } else {
              this._state_0 = 2;
              continue $sm;
            }

            break;
          case 2:
            this._state_0 = 3;
            suspendResult = this.__this__6.awaitSuspend_0(1, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 3:
            suspendResult;
            Unit_getInstance();
            this._state_0 = 1;
            continue $sm;
          case 4:
            ensureNotFailed_0(this.__this__6, this._builder);
            return this._builder.build_16();
          case 5:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 5) {
          throw $p;
        } else {
          this._state_0 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $readRemainingSuspendCOROUTINE$27.$metadata$ = {
    simpleName: '$readRemainingSuspendCOROUTINE$27',
    kind: 'class',
    interfaces: []
  };
  function $readAvailableCOROUTINE$30(_this_, dst, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__7 = _this_;
    this._dst = dst;
  }
  $readAvailableCOROUTINE$30.prototype.doResume_72 = function () {
    var suspendResult = this._result;
    $sm: do
      try {
        var tmp = this._state_0;
        switch (tmp) {
          case 0:
            this._exceptionState = 3;
            if (!(this.__this__7._get_closedCause__0() == null)) {
              var tmp_0 = this;
              throw ensureNotNull(this.__this__7._get_closedCause__0());
            } else {
              if (this.__this__7._readable.canRead_0()) {
                var tmp_1 = this;
                var tmp0_minOf_0 = toLong_0(this._dst._get_limit__1() - this._dst._get_writePosition__1() | 0);
                var tmp1_minOf_0 = this.__this__7._readable._get_remaining__2();
                var size_0 = (tmp0_minOf_0.compareTo_69(tmp1_minOf_0) <= 0 ? tmp0_minOf_0 : tmp1_minOf_0).toInt_5();
                readFully_2(this.__this__7._readable, this._dst, size_0);
                this.__this__7.afterRead_0(size_0);
                tmp_1._WHEN_RESULT0 = size_0;
                this._state_0 = 2;
                continue $sm;
              } else {
                if (this.__this__7._get_closed__0()) {
                  this._WHEN_RESULT0 = this.__this__7.readAvailableClosed_0();
                  this._state_0 = 2;
                  continue $sm;
                } else {
                  if (!(this._dst._get_limit__1() > this._dst._get_writePosition__1())) {
                    this._WHEN_RESULT0 = 0;
                    this._state_0 = 2;
                    continue $sm;
                  } else {
                    {
                      this._state_0 = 1;
                      suspendResult = readAvailableSuspend(this.__this__7, this._dst, this);
                      if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
                        return suspendResult;
                      }continue $sm;
                    }
                  }
                  Unit_getInstance();
                }
                Unit_getInstance();
              }
              Unit_getInstance();
            }

            break;
          case 1:
            this._WHEN_RESULT0 = suspendResult;
            this._state_0 = 2;
            continue $sm;
          case 2:
            return this._WHEN_RESULT0;
          case 3:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 3) {
          throw $p;
        } else {
          this._state_0 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $readAvailableCOROUTINE$30.$metadata$ = {
    simpleName: '$readAvailableCOROUTINE$30',
    kind: 'class',
    interfaces: []
  };
  function $readAvailableSuspendCOROUTINE$31(_this_, dst, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__8 = _this_;
    this._dst_0 = dst;
  }
  $readAvailableSuspendCOROUTINE$31.prototype.doResume_72 = function () {
    var suspendResult = this._result;
    $sm: do
      try {
        var tmp = this._state_0;
        switch (tmp) {
          case 0:
            this._exceptionState = 3;
            this._state_0 = 1;
            suspendResult = this.__this__8.awaitSuspend_0(1, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            suspendResult;
            Unit_getInstance();
            this._state_0 = 2;
            suspendResult = this.__this__8.readAvailable_0(this._dst_0, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 2:
            return suspendResult;
          case 3:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 3) {
          throw $p;
        } else {
          this._state_0 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $readAvailableSuspendCOROUTINE$31.$metadata$ = {
    simpleName: '$readAvailableSuspendCOROUTINE$31',
    kind: 'class',
    interfaces: []
  };
  function $awaitInternalAtLeast1COROUTINE$40(_this_, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__9 = _this_;
  }
  $awaitInternalAtLeast1COROUTINE$40.prototype.doResume_72 = function () {
    var suspendResult = this._result;
    $sm: do
      try {
        var tmp = this._state_0;
        switch (tmp) {
          case 0:
            this._exceptionState = 2;
            var tmp_0 = this;
            tmp_0._tmp0__get_isNotEmpty__01 = this.__this__9._readable;
            if (!this._tmp0__get_isNotEmpty__01._get_endOfInput__4()) {
              var tmp_1 = this;
              tmp_1._WHEN_RESULT0_0 = true;
              this._state_0 = 3;
              continue $sm;
            } else {
              {
                this._state_0 = 1;
                suspendResult = this.__this__9.awaitSuspend_0(1, this);
                if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
                  return suspendResult;
                }continue $sm;
              }
            }

            break;
          case 1:
            this._WHEN_RESULT0_0 = suspendResult;
            this._state_0 = 3;
            continue $sm;
          case 2:
            throw this._exception_0;
          case 3:
            return this._WHEN_RESULT0_0;
        }
      } catch ($p) {
        if (this._exceptionState === 2) {
          throw $p;
        } else {
          this._state_0 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $awaitInternalAtLeast1COROUTINE$40.$metadata$ = {
    simpleName: '$awaitInternalAtLeast1COROUTINE$40',
    kind: 'class',
    interfaces: []
  };
  function $awaitSuspendCOROUTINE$41(_this_, atLeast, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__10 = _this_;
    this._atLeast = atLeast;
  }
  $awaitSuspendCOROUTINE$41.prototype.doResume_72 = function () {
    var suspendResult = this._result;
    $sm: do
      try {
        var tmp = this._state_0;
        switch (tmp) {
          case 0:
            this._exceptionState = 2;
            var tmp_0 = this;
            tmp_0._tmp0_require_00 = this._atLeast >= 0;
            if (!this._tmp0_require_00) {
              var message_1_1 = 'Failed requirement.';
              throw IllegalArgumentException_init_$Create$_0(toString_1(message_1_1));
            }
            this._state_0 = 1;
            suspendResult = this.__this__10.awaitAtLeastNBytesAvailableForRead_0(this._atLeast, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            suspendResult;
            this.__this__10.prepareFlushedBytes_0();
            var tmp0_safe_receiver = this.__this__10._get_closedCause__0();
            if (tmp0_safe_receiver == null)
              null;
            else {
              throw tmp0_safe_receiver;
            }

            Unit_getInstance();
            return !this.__this__10._get_isClosedForRead__0() ? this.__this__10._get_availableForRead__0() >= this._atLeast : false;
          case 2:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 2) {
          throw $p;
        } else {
          this._state_0 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $awaitSuspendCOROUTINE$41.$metadata$ = {
    simpleName: '$awaitSuspendCOROUTINE$41',
    kind: 'class',
    interfaces: []
  };
  function ByteChannelSequentialBase(initial, autoFlush, pool) {
    this._autoFlush = autoFlush;
    this._state_4 = new ByteChannelSequentialBaseSharedState();
    this._writable = new BytePacketBuilder(0, pool);
    this._readable = ByteReadPacket_init_$Create$(initial, pool);
    this._slot = new AwaitingSlot();
    this._flushMutex = new Object();
    var tmp = this;
    tmp._flushBuffer = BytePacketBuilder$default(0, 1, null);
  }
  ByteChannelSequentialBase.prototype._get_autoFlush__0 = function () {
    return this._autoFlush;
  };
  ByteChannelSequentialBase.prototype._set_closed__0 = function (value) {
    this._state_4._closed = value;
  };
  ByteChannelSequentialBase.prototype._get_closed__0 = function () {
    return this._state_4._closed;
  };
  ByteChannelSequentialBase.prototype._get_availableForRead__0 = function () {
    return _get_flushSize_(this) + this._readable._get_remaining__2().toInt_5() | 0;
  };
  ByteChannelSequentialBase.prototype._get_availableForWrite__0 = function () {
    var tmp0_maxOf_0 = 0;
    var tmp1_maxOf_0 = 4088 - (this._get_availableForRead__0() + this._writable._get_size__45() | 0) | 0;
    return function () {
      var $externalVarargReceiverTmp = Math;
      return $externalVarargReceiverTmp.max.apply($externalVarargReceiverTmp, [].concat([].slice.call(new Int32Array([tmp0_maxOf_0, tmp1_maxOf_0]))));
    }.call(this);
  };
  ByteChannelSequentialBase.prototype._get_isClosedForRead__0 = function () {
    var tmp;
    var tmp_0;
    var tmp_1;
    if (this._get_closed__0()) {
      var tmp0__get_isEmpty__0 = this._readable;
      tmp_1 = tmp0__get_isEmpty__0._get_endOfInput__4();
    } else {
      tmp_1 = false;
    }
    if (tmp_1) {
      tmp_0 = _get_flushSize_(this) === 0;
    } else {
      {
        tmp_0 = false;
      }
    }
    if (tmp_0) {
      tmp = this._writable._get_isEmpty__4();
    } else {
      {
        tmp = false;
      }
    }
    return tmp;
  };
  ByteChannelSequentialBase.prototype._get_closedCause__0 = function () {
    return this._state_4._closedCause;
  };
  ByteChannelSequentialBase.prototype.awaitAtLeastNBytesAvailableForWrite_0 = function (count_0, $cont) {
    var tmp = new $awaitAtLeastNBytesAvailableForWriteCOROUTINE$0(this, count_0, $cont);
    tmp._result = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_72();
  };
  ByteChannelSequentialBase.prototype.awaitAtLeastNBytesAvailableForRead_0 = function (count_0, $cont) {
    var tmp = new $awaitAtLeastNBytesAvailableForReadCOROUTINE$1(this, count_0, $cont);
    tmp._result = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_72();
  };
  ByteChannelSequentialBase.prototype.flush_8 = function () {
    flushImpl(this);
    Unit_getInstance();
  };
  ByteChannelSequentialBase.prototype.prepareFlushedBytes_0 = function () {
    var tmp0_synchronized_0 = this._flushMutex;
    unsafeAppend(this._readable, this._flushBuffer);
    Unit_getInstance();
  };
  ByteChannelSequentialBase.prototype.writeFully_1 = function (src, $cont) {
    var tmp = new $writeFullyCOROUTINE$9(this, src, $cont);
    tmp._result = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_72();
  };
  ByteChannelSequentialBase.prototype.writeFully_3 = function (src, offset, length, $cont) {
    var tmp = new $writeFullyCOROUTINE$10(this, src, offset, length, $cont);
    tmp._result = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_72();
  };
  ByteChannelSequentialBase.prototype.afterRead_0 = function (count_0) {
    var tmp0_this = this;
    var tmp0_plus_0 = _get__totalBytesRead_(tmp0_this);
    _set__totalBytesRead_(tmp0_this, tmp0_plus_0.plus_56(toLong_0(count_0)));
    this._slot.resume_2();
  };
  ByteChannelSequentialBase.prototype.readRemaining_1 = function (limit, headerSizeHint, $cont) {
    var tmp = new $readRemainingCOROUTINE$26(this, limit, headerSizeHint, $cont);
    tmp._result = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_72();
  };
  ByteChannelSequentialBase.prototype.readAvailableClosed_0 = function () {
    var tmp0_safe_receiver = this._get_closedCause__0();
    if (tmp0_safe_receiver == null)
      null;
    else {
      throw tmp0_safe_receiver;
    }
    Unit_getInstance();
    return -1;
  };
  ByteChannelSequentialBase.prototype.readAvailable_0 = function (dst, $cont) {
    var tmp = new $readAvailableCOROUTINE$30(this, dst, $cont);
    tmp._result = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_72();
  };
  ByteChannelSequentialBase.prototype.awaitInternalAtLeast1_0 = function ($cont) {
    var tmp = new $awaitInternalAtLeast1COROUTINE$40(this, $cont);
    tmp._result = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_72();
  };
  ByteChannelSequentialBase.prototype.awaitSuspend_0 = function (atLeast, $cont) {
    var tmp = new $awaitSuspendCOROUTINE$41(this, atLeast, $cont);
    tmp._result = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_72();
  };
  ByteChannelSequentialBase.prototype.cancel_23 = function (cause) {
    if (!(this._get_closedCause__0() == null) ? true : this._get_closed__0()) {
      return false;
    }var tmp0_elvis_lhs = cause;
    return this.close_27(tmp0_elvis_lhs == null ? CancellationException_init_$Create$('Channel cancelled') : tmp0_elvis_lhs);
  };
  ByteChannelSequentialBase.prototype.close_27 = function (cause) {
    if (this._get_closed__0() ? true : !(this._get_closedCause__0() == null))
      return false;
    _set_closedCause_(this, cause);
    this._set_closed__0(true);
    if (!(cause == null)) {
      this._readable.release_4();
      this._writable.release_4();
      this._flushBuffer.release_4();
    } else {
      this.flush_8();
    }
    this._slot.cancel_21(cause);
    return true;
  };
  ByteChannelSequentialBase.prototype.transferTo_0 = function (dst, limit) {
    var size_0 = this._readable._get_remaining__2();
    var tmp;
    if (size_0.compareTo_69(limit) <= 0) {
      dst._writable.writePacket_1(this._readable);
      dst.afterWrite_0(size_0.toInt_5());
      this.afterRead_0(size_0.toInt_5());
      tmp = size_0;
    } else {
      tmp = new Long(0, 0);
    }
    return tmp;
  };
  ByteChannelSequentialBase.prototype.afterWrite_0 = function (count_0) {
    var tmp0_this = this;
    var tmp0_plus_0 = _get__totalBytesWritten_(tmp0_this);
    _set__totalBytesWritten_(tmp0_this, tmp0_plus_0.plus_56(toLong_0(count_0)));
    if (this._get_closed__0()) {
      this._writable.release_4();
      ensureNotClosed(this);
    }if (this._get_autoFlush__0() ? true : this._get_availableForWrite__0() === 0) {
      this.flush_8();
    }};
  ByteChannelSequentialBase.$metadata$ = {
    simpleName: 'ByteChannelSequentialBase',
    kind: 'class',
    interfaces: [ByteChannel, ByteReadChannel_1, ByteWriteChannel, SuspendableReadSession, HasReadSession, HasWriteSession]
  };
  function readRemaining(_this_, $cont) {
    return _this_.readRemaining_1(new Long(-1, 2147483647), 0, $cont);
  }
  function cancel_3(_this_) {
    return _this_.cancel_23(null);
  }
  function readRemaining_0(_this_, limit, $cont) {
    return _this_.readRemaining_1(limit, 0, $cont);
  }
  function ClosedWriteChannelException(message) {
    CancellationException_init_$Init$(message, this);
    captureStack(this, ClosedWriteChannelException);
  }
  ClosedWriteChannelException.$metadata$ = {
    simpleName: 'ClosedWriteChannelException',
    kind: 'class',
    interfaces: []
  };
  function close(_this_) {
    return _this_.close_27(null);
  }
  function writeFully(_this_, src, $cont) {
    return _this_.writeFully_3(src, 0, src.length, $cont);
  }
  function WriterJob() {
  }
  WriterJob.$metadata$ = {
    simpleName: 'WriterJob',
    kind: 'interface',
    interfaces: [Job]
  };
  function writer(_this_, coroutineContext, autoFlush, block) {
    return launchChannel(_this_, coroutineContext, ByteChannel_0(autoFlush), true, block);
  }
  function writer$default(_this_, coroutineContext, autoFlush, block, $mask0, $handler) {
    if (!(($mask0 & 1) === 0))
      coroutineContext = EmptyCoroutineContext_getInstance();
    if (!(($mask0 & 2) === 0))
      autoFlush = false;
    return writer(_this_, coroutineContext, autoFlush, block);
  }
  function WriterScope() {
  }
  WriterScope.$metadata$ = {
    simpleName: 'WriterScope',
    kind: 'interface',
    interfaces: [CoroutineScope]
  };
  function ChannelJob(delegate, channel) {
    this._delegate_1 = delegate;
    this._channel_0 = channel;
  }
  ChannelJob.prototype._get_channel__2 = function () {
    return this._channel_0;
  };
  ChannelJob.prototype.attachChild_9 = function (child_0) {
    return this._delegate_1.attachChild_9(child_0);
  };
  ChannelJob.prototype.getCancellationException_9 = function () {
    return this._delegate_1.getCancellationException_9();
  };
  ChannelJob.prototype.invokeOnCompletion_21 = function (onCancelling, invokeImmediately, handler) {
    return this._delegate_1.invokeOnCompletion_21(onCancelling, invokeImmediately, handler);
  };
  ChannelJob.prototype.get_70 = function (key) {
    return this._delegate_1.get_70(key);
  };
  ChannelJob.prototype.fold_26 = function (initial, operation) {
    return this._delegate_1.fold_26(initial, operation);
  };
  ChannelJob.prototype.cancel_20 = function (cause) {
    this._delegate_1.cancel_20(cause);
  };
  ChannelJob.prototype.invokeOnCompletion_22 = function (handler) {
    return this._delegate_1.invokeOnCompletion_22(handler);
  };
  ChannelJob.prototype.minusKey_27 = function (key) {
    return this._delegate_1.minusKey_27(key);
  };
  ChannelJob.prototype.plus_28 = function (context) {
    return this._delegate_1.plus_28(context);
  };
  ChannelJob.prototype.start_15 = function () {
    return this._delegate_1.start_15();
  };
  ChannelJob.prototype._get_isActive__23 = function () {
    return this._delegate_1._get_isActive__23();
  };
  ChannelJob.prototype._get_key__47 = function () {
    return this._delegate_1._get_key__47();
  };
  ChannelJob.prototype.toString = function () {
    return '' + 'ChannelJob[' + this._delegate_1 + ']';
  };
  ChannelJob.$metadata$ = {
    simpleName: 'ChannelJob',
    kind: 'class',
    interfaces: [ReaderJob, WriterJob, Job]
  };
  function launchChannel(_this_, context, channel, attachJob, block) {
    var dispatcher = _this_._get_coroutineContext__22().get_70(Key_getInstance_0());
    var job = launch$default(_this_, context, null, _no_name_provided_$factory_94(attachJob, channel, block, dispatcher, null), 2, null);
    job.invokeOnCompletion_22(_no_name_provided_$factory_95(channel));
    Unit_getInstance();
    return new ChannelJob(job, channel);
  }
  function ReaderJob() {
  }
  ReaderJob.$metadata$ = {
    simpleName: 'ReaderJob',
    kind: 'interface',
    interfaces: [Job]
  };
  function ChannelScope(delegate, channel) {
    this._channel_1 = channel;
    this._$$delegate_0_2 = delegate;
  }
  ChannelScope.prototype._get_channel__2 = function () {
    return this._channel_1;
  };
  ChannelScope.prototype._get_coroutineContext__22 = function () {
    return this._$$delegate_0_2._get_coroutineContext__22();
  };
  ChannelScope.$metadata$ = {
    simpleName: 'ChannelScope',
    kind: 'class',
    interfaces: [ReaderScope, WriterScope, CoroutineScope]
  };
  function ReaderScope() {
  }
  ReaderScope.$metadata$ = {
    simpleName: 'ReaderScope',
    kind: 'interface',
    interfaces: [CoroutineScope]
  };
  function _no_name_provided__116($attachJob, $channel, $block, $dispatcher, resultContinuation) {
    this._$attachJob = $attachJob;
    this._$channel = $channel;
    this._$block_0 = $block;
    this._$dispatcher = $dispatcher;
    CoroutineImpl_0.call(this, resultContinuation);
  }
  _no_name_provided__116.prototype.invoke_489 = function (_this__0, $cont) {
    var tmp = this.create_38(_this__0, $cont);
    tmp._result = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_72();
  };
  _no_name_provided__116.prototype.invoke_542 = function (p1, $cont) {
    this.invoke_489((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $cont);
    return Unit_getInstance();
  };
  _no_name_provided__116.prototype.doResume_72 = function () {
    var suspendResult = this._result;
    $sm: do
      try {
        var tmp = this._state_0;
        switch (tmp) {
          case 0:
            this._exceptionState = 3;
            if (this._$attachJob) {
              this._$channel.attachJob_1(ensureNotNull(this.__this__11._get_coroutineContext__22().get_70(Key_getInstance_3())));
            }
            var tmp_0 = this;
            var tmp_1 = new ChannelScope(this.__this__11, this._$channel);
            tmp_0._scope0 = isInterface(tmp_1, CoroutineScope) ? tmp_1 : THROW_CCE();
            this._exceptionState = 2;
            this._state_0 = 1;
            suspendResult = this._$block_0(this._scope0, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            suspendResult;
            this._exceptionState = 3;
            this._state_0 = 4;
            continue $sm;
          case 2:
            this._exceptionState = 3;
            var tmp_2 = this._exception_0;
            if (tmp_2 instanceof Error) {
              var cause = this._exception_0;
              if (!equals_1(this._$dispatcher, Dispatchers_getInstance()._Unconfined) ? !(this._$dispatcher == null) : false) {
                throw cause;
              }this._$channel.cancel_23(cause);
              Unit_getInstance();
              this._state_0 = 4;
              continue $sm;
            } else {
              {
                throw this._exception_0;
              }
            }

            break;
          case 3:
            throw this._exception_0;
          case 4:
            this._exceptionState = 3;
            return Unit_getInstance();
        }
      } catch ($p) {
        if (this._exceptionState === 3) {
          throw $p;
        } else {
          this._state_0 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  _no_name_provided__116.prototype.create_38 = function (_this__0, completion) {
    var i = new _no_name_provided__116(this._$attachJob, this._$channel, this._$block_0, this._$dispatcher, completion);
    i.__this__11 = _this__0;
    return i;
  };
  _no_name_provided__116.$metadata$ = {
    kind: 'class',
    interfaces: [],
    suspendArity: 1
  };
  function _no_name_provided__117($channel) {
    this._$channel_0 = $channel;
  }
  _no_name_provided__117.prototype.invoke_375 = function (cause) {
    this._$channel_0.close_27(cause);
    Unit_getInstance();
  };
  _no_name_provided__117.prototype.invoke_542 = function (p1) {
    this.invoke_375((p1 == null ? true : p1 instanceof Error) ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__117.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided_$factory_94($attachJob, $channel, $block, $dispatcher, resultContinuation) {
    var i = new _no_name_provided__116($attachJob, $channel, $block, $dispatcher, resultContinuation);
    var l = function (p1, $cont) {
      return i.invoke_489(p1, $cont);
    };
    l.$arity = 1;
    return l;
  }
  function _no_name_provided_$factory_95($channel) {
    var i = new _no_name_provided__117($channel);
    return function (p1) {
      i.invoke_375(p1);
      return Unit_getInstance();
    };
  }
  function ReadSession() {
  }
  ReadSession.$metadata$ = {
    simpleName: 'ReadSession',
    kind: 'interface',
    interfaces: []
  };
  function SuspendableReadSession() {
  }
  SuspendableReadSession.$metadata$ = {
    simpleName: 'SuspendableReadSession',
    kind: 'interface',
    interfaces: [ReadSession]
  };
  function HasReadSession() {
  }
  HasReadSession.$metadata$ = {
    simpleName: 'HasReadSession',
    kind: 'interface',
    interfaces: []
  };
  function HasWriteSession() {
  }
  HasWriteSession.$metadata$ = {
    simpleName: 'HasWriteSession',
    kind: 'interface',
    interfaces: []
  };
  function Allocator() {
  }
  Allocator.$metadata$ = {
    simpleName: 'Allocator',
    kind: 'interface',
    interfaces: []
  };
  function encodeToImpl(_this_, destination, input, fromIndex, toIndex) {
    var start = fromIndex;
    if (start >= toIndex)
      return 0;
    var bytesWritten = 0;
    var tmp0_writeWhileSize_0 = 1;
    var tail_1 = prepareWriteHead(destination, tmp0_writeWhileSize_0, null);
    try {
      var size_2;
      $l$break: while (true) {
        var tmp1__anonymous__3 = tail_1;
        var before_4 = tmp1__anonymous__3._get_limit__1() - tmp1__anonymous__3._get_writePosition__1() | 0;
        var rc_5 = encodeImpl(_this_, input, start, toIndex, tmp1__anonymous__3);
        var tmp0_check_0_6 = rc_5 >= 0;
        if (!tmp0_check_0_6) {
          var message_2_1_7 = 'Check failed.';
          throw IllegalStateException_init_$Create$(toString_1(message_2_1_7));
        }start = start + rc_5 | 0;
        var tmp = bytesWritten;
        bytesWritten = tmp + (before_4 - (tmp1__anonymous__3._get_limit__1() - tmp1__anonymous__3._get_writePosition__1() | 0) | 0) | 0;
        size_2 = start >= toIndex ? 0 : rc_5 === 0 ? 8 : 1;
        if (size_2 <= 0)
          break $l$break;
        tail_1 = prepareWriteHead(destination, size_2, tail_1);
      }
    }finally {
      afterHeadWrite(destination, tail_1);
    }
    bytesWritten = bytesWritten + encodeCompleteImpl(_this_, destination) | 0;
    return bytesWritten;
  }
  function encodeCompleteImpl(_this_, dst) {
    var size_0 = 1;
    var bytesWritten = 0;
    var tail_1 = prepareWriteHead(dst, 1, null);
    try {
      $l$break: while (true) {
        var tmp0__anonymous__2 = tail_1;
        var before_3 = tmp0__anonymous__2._get_limit__1() - tmp0__anonymous__2._get_writePosition__1() | 0;
        if (encodeComplete(_this_, tmp0__anonymous__2)) {
          size_0 = 0;
        } else {
          var tmp0_4 = size_0;
          size_0 = tmp0_4 + 1 | 0;
          Unit_getInstance();
        }
        var tmp = bytesWritten;
        bytesWritten = tmp + (before_3 - (tmp0__anonymous__2._get_limit__1() - tmp0__anonymous__2._get_writePosition__1() | 0) | 0) | 0;
        if (!(size_0 > 0))
          break $l$break;
        else {
        }
        tail_1 = prepareWriteHead(dst, 1, tail_1);
      }
    }finally {
      afterHeadWrite(dst, tail_1);
    }
    return bytesWritten;
  }
  function decode(_this_, input, max) {
    var tmp0_minOf_0 = toLong_0(max);
    var tmp1_minOf_0 = sizeEstimate(input);
    var tmp2_buildString_0 = (tmp0_minOf_0.compareTo_69(tmp1_minOf_0) <= 0 ? tmp0_minOf_0 : tmp1_minOf_0).toInt_5();
    var tmp0_apply_0_1 = StringBuilder_init_$Create$(tmp2_buildString_0);
    decode_0(_this_, input, tmp0_apply_0_1, max);
    Unit_getInstance();
    return tmp0_apply_0_1.toString();
  }
  function decode$default(_this_, input, max, $mask0, $handler) {
    if (!(($mask0 & 2) === 0))
      max = IntCompanionObject_getInstance()._MAX_VALUE_5;
    return decode(_this_, input, max);
  }
  function encodeToByteArrayImpl1(_this_, input, fromIndex, toIndex) {
    var start = fromIndex;
    if (start >= toIndex)
      return EmptyByteArray;
    var single_3 = Companion_getInstance_36()._Pool.borrow_12();
    try {
      var rc = encodeImpl(_this_, input, start, toIndex, single_3);
      start = start + rc | 0;
      if (start === toIndex) {
        var result = new Int8Array(single_3._get_writePosition__1() - single_3._get_readPosition__1() | 0);
        readFully$default(single_3, result, 0, 0, 6, null);
        return result;
      }var tmp$ret$0;
      l$ret$1: do {
        var tmp0_buildPacket_0 = 0;
        var builder_2 = BytePacketBuilder_0(tmp0_buildPacket_0);
        try {
          builder_2.appendSingleChunk_2(single_3.duplicate_0());
          encodeToImpl(_this_, builder_2, input, start, toIndex);
          Unit_getInstance();
          tmp$ret$0 = builder_2.build_16();
          break l$ret$1;
        } catch ($p) {
          if ($p instanceof Error) {
            builder_2.release_4();
            throw $p;
          } else {
            {
              throw $p;
            }
          }
        }
      }
       while (false);
      var tmp = tmp$ret$0;
      return readBytes$default(tmp, 0, 1, null);
    }finally {
      single_3.release_7(Companion_getInstance_36()._Pool);
    }
  }
  function sizeEstimate(_this_) {
    var tmp0_subject = _this_;
    var tmp;
    if (tmp0_subject instanceof ByteReadPacket) {
      tmp = _this_._get_remaining__2();
    } else {
      if (tmp0_subject instanceof AbstractInput) {
        var tmp0_maxOf_0 = _this_._get_remaining__2();
        var tmp1_maxOf_0 = new Long(16, 0);
        tmp = tmp0_maxOf_0.compareTo_69(tmp1_maxOf_0) >= 0 ? tmp0_maxOf_0 : tmp1_maxOf_0;
      } else {
        {
          tmp = new Long(16, 0);
        }
      }
    }
    return tmp;
  }
  function encode(_this_, input, fromIndex, toIndex) {
    var tmp$ret$0;
    l$ret$1: do {
      var tmp0_buildPacket_0 = 0;
      var builder_2 = BytePacketBuilder_0(tmp0_buildPacket_0);
      try {
        encodeToImpl(_this_, builder_2, input, fromIndex, toIndex);
        Unit_getInstance();
        tmp$ret$0 = builder_2.build_16();
        break l$ret$1;
      } catch ($p) {
        if ($p instanceof Error) {
          builder_2.release_4();
          throw $p;
        } else {
          {
            throw $p;
          }
        }
      }
    }
     while (false);
    return tmp$ret$0;
  }
  function encode$default(_this_, input, fromIndex, toIndex, $mask0, $handler) {
    if (!(($mask0 & 2) === 0))
      fromIndex = 0;
    if (!(($mask0 & 4) === 0))
      toIndex = charSequenceLength(input);
    return encode(_this_, input, fromIndex, toIndex);
  }
  function _set__head_($this, newHead) {
    $this._state_5._head_2 = newHead;
    $this._state_5._headMemory = newHead._get_memory__1();
    $this._state_5._headPosition = newHead._get_readPosition__1();
    $this._state_5._headEndExclusive = newHead._get_writePosition__1();
  }
  function _get__head_($this) {
    return $this._state_5._head_2;
  }
  function _set_tailRemaining_($this, newValue) {
    var tmp0_require_0 = newValue.compareTo_69(new Long(0, 0)) >= 0;
    if (!tmp0_require_0) {
      var m_2 = new _no_name_provided__3_0(newValue);
      m_2.doFail_4_13();
    }$this._state_5._tailRemaining = newValue;
  }
  function _get_tailRemaining_($this) {
    return $this._state_5._tailRemaining;
  }
  function doPrefetch($this, min) {
    var tail = findTail(_get__head_($this));
    var available = numberToLong($this._get_headEndExclusive__2() - $this._get_headPosition__2() | 0).plus_56(_get_tailRemaining_($this));
    do {
      var next = $this.fill_7();
      if (next == null) {
        $this._noMoreChunksAvailable = true;
        return false;
      }var chunkSize = next._get_writePosition__1() - next._get_readPosition__1() | 0;
      if (tail === Companion_getInstance_36()._get_Empty__1()) {
        _set__head_($this, next);
        tail = next;
      } else {
        tail._set_next__0(next);
        var tmp0_this = $this;
        var tmp0_plus_0 = _get_tailRemaining_(tmp0_this);
        _set_tailRemaining_(tmp0_this, tmp0_plus_0.plus_56(toLong_0(chunkSize)));
      }
      var tmp1_plus_0 = available;
      available = tmp1_plus_0.plus_56(toLong_0(chunkSize));
    }
     while (available.compareTo_69(min) < 0);
    return true;
  }
  function readASCII($this, out, min, max) {
    if (max === 0 ? min === 0 : false)
      return 0;
    else if ($this._get_endOfInput__4())
      if (min === 0)
        return 0;
      else {
        atLeastMinCharactersRequire($this, min);
      }
     else if (max < min) {
      minShouldBeLess($this, min, max);
    }var copied = 0;
    var utf8 = false;
    var tmp$ret$0;
    l$ret$1: do {
      var release_1 = true;
      var tmp0_elvis_lhs_3 = prepareReadFirstHead($this, 1);
      var tmp;
      if (tmp0_elvis_lhs_3 == null) {
        tmp$ret$0 = Unit_getInstance();
        break l$ret$1;
      } else {
        tmp = tmp0_elvis_lhs_3;
      }
      var current_2 = tmp;
      try {
        $l$break_0: do {
          var tmp0__anonymous__6 = current_2;
          var tmp$ret$2;
          l$ret$3: do {
            var tmp0__anonymous__1_3_9 = tmp0__anonymous__6._memory;
            var tmp1__anonymous__1_3_10 = tmp0__anonymous__6._get_readPosition__1();
            var tmp2__anonymous__1_3_11 = tmp0__anonymous__6._get_writePosition__1();
            var inductionVariable = tmp1__anonymous__1_3_10;
            if (inductionVariable < tmp2__anonymous__1_3_11)
              do {
                var index_3_5_13 = inductionVariable;
                inductionVariable = inductionVariable + 1 | 0;
                var codepoint_4_6_14 = tmp0__anonymous__1_3_9._view.getInt8(index_3_5_13) & 255;
                var tmp_0;
                if ((codepoint_4_6_14 & 128) === 128) {
                  tmp_0 = true;
                } else {
                  var tmp3__anonymous__5_15 = numberToChar(codepoint_4_6_14);
                  var tmp_1;
                  if (copied === max) {
                    tmp_1 = false;
                  } else {
                    out.append_32(tmp3__anonymous__5_15);
                    Unit_getInstance();
                    var tmp0_6_16 = copied;
                    copied = tmp0_6_16 + 1 | 0;
                    Unit_getInstance();
                    tmp_1 = true;
                  }
                  tmp_0 = !tmp_1;
                }
                if (tmp_0) {
                  tmp0__anonymous__6.discardExact_5(index_3_5_13 - tmp1__anonymous__1_3_10 | 0);
                  tmp$ret$2 = false;
                  break l$ret$3;
                } else {
                }
              }
               while (inductionVariable < tmp2__anonymous__1_3_11);
            var rc_2_8 = tmp2__anonymous__1_3_11 - tmp1__anonymous__1_3_10 | 0;
            tmp0__anonymous__6.discardExact_5(rc_2_8);
            Unit_getInstance();
            tmp$ret$2 = true;
          }
           while (false);
          var rc_7 = tmp$ret$2;
          var tmp_2;
          if (rc_7) {
            tmp_2 = true;
          } else if (copied === max) {
            tmp_2 = false;
          } else {
            utf8 = true;
            tmp_2 = false;
          }
          if (!tmp_2) {
            break $l$break_0;
          } else {
          }
          release_1 = false;
          var tmp1_elvis_lhs_5 = prepareReadNextHead($this, current_2);
          var tmp_3;
          if (tmp1_elvis_lhs_5 == null) {
            break $l$break_0;
          } else {
            tmp_3 = tmp1_elvis_lhs_5;
          }
          var next_4 = tmp_3;
          current_2 = next_4;
          release_1 = true;
        }
         while (true);
      }finally {
        if (release_1) {
          completeReadHead($this, current_2);
        }}
    }
     while (false);
    if (utf8) {
      return copied + readUtf8($this, out, min - copied | 0, max - copied | 0) | 0;
    }if (copied < min) {
      prematureEndOfStreamChars($this, min, copied);
    }return copied;
  }
  function atLeastMinCharactersRequire($this, min) {
    throw new EOFException('' + 'at least ' + min + ' characters required but no bytes available');
  }
  function minShouldBeLess($this, min, max) {
    throw IllegalArgumentException_init_$Create$_0('' + 'min should be less or equal to max but min = ' + min + ', max = ' + max);
  }
  function prematureEndOfStreamChars($this, min, copied) {
    throw new MalformedUTF8InputException('' + 'Premature end of stream: expected at least ' + min + ' chars but had only ' + copied);
  }
  function readUtf8($this, out, min, max) {
    var copied = 0;
    var tmp$ret$0;
    l$ret$1: do {
      var tmp3_takeWhileSize_0 = 1;
      var release_1 = true;
      var tmp0_elvis_lhs_3 = prepareReadFirstHead($this, tmp3_takeWhileSize_0);
      var tmp;
      if (tmp0_elvis_lhs_3 == null) {
        tmp$ret$0 = Unit_getInstance();
        break l$ret$1;
      } else {
        tmp = tmp0_elvis_lhs_3;
      }
      var current_2 = tmp;
      var size_4 = tmp3_takeWhileSize_0;
      try {
        $l$break_0: do {
          var tmp0__get_readRemaining__0 = current_2;
          var before_5 = tmp0__get_readRemaining__0._get_writePosition__1() - tmp0__get_readRemaining__0._get_readPosition__1() | 0;
          var after_6;
          if (before_5 >= size_4) {
            try {
              var tmp4__anonymous__8 = current_2;
              var tmp$ret$2;
              l$ret$3: do {
                var byteCount_1_10 = 0;
                var value_2_11 = 0;
                var lastByteCount_3_12 = 0;
                var tmp0__anonymous__4_3_14 = tmp4__anonymous__8._memory;
                var tmp1__anonymous__4_3_15 = tmp4__anonymous__8._get_readPosition__1();
                var tmp2__anonymous__4_3_16 = tmp4__anonymous__8._get_writePosition__1();
                var inductionVariable = tmp1__anonymous__4_3_15;
                if (inductionVariable < tmp2__anonymous__4_3_16)
                  do {
                    var index_6_5_18 = inductionVariable;
                    inductionVariable = inductionVariable + 1 | 0;
                    var v_7_6_19 = tmp0__anonymous__4_3_14._view.getInt8(index_6_5_18) & 255;
                    if ((v_7_6_19 & 128) === 0) {
                      if (!(byteCount_1_10 === 0)) {
                        malformedByteCount(byteCount_1_10);
                      }var tmp3__anonymous__14_20 = numberToChar(v_7_6_19);
                      var tmp_0;
                      if (copied === max) {
                        tmp_0 = false;
                      } else {
                        out.append_32(tmp3__anonymous__14_20);
                        Unit_getInstance();
                        var tmp0_15_21 = copied;
                        copied = tmp0_15_21 + 1 | 0;
                        Unit_getInstance();
                        tmp_0 = true;
                      }
                      if (!tmp_0) {
                        tmp4__anonymous__8.discardExact_5(index_6_5_18 - tmp1__anonymous__4_3_15 | 0);
                        tmp$ret$2 = -1;
                        break l$ret$3;
                      } else {
                      }
                    } else if (byteCount_1_10 === 0) {
                      var mask_8_7_22 = 128;
                      value_2_11 = v_7_6_19;
                      var inductionVariable_0 = 1;
                      if (inductionVariable_0 <= 6)
                        $l$break: do {
                          var i_10_9_24 = inductionVariable_0;
                          inductionVariable_0 = inductionVariable_0 + 1 | 0;
                          if (!((value_2_11 & mask_8_7_22) === 0)) {
                            value_2_11 = value_2_11 & ~mask_8_7_22;
                            mask_8_7_22 = mask_8_7_22 >> 1;
                            var tmp2_11_10_25 = byteCount_1_10;
                            byteCount_1_10 = tmp2_11_10_25 + 1 | 0;
                            Unit_getInstance();
                          } else {
                            break $l$break;
                          }
                        }
                         while (inductionVariable_0 <= 6);
                      lastByteCount_3_12 = byteCount_1_10;
                      var tmp3_12_11_26 = byteCount_1_10;
                      byteCount_1_10 = tmp3_12_11_26 - 1 | 0;
                      Unit_getInstance();
                      if (lastByteCount_3_12 > (tmp2__anonymous__4_3_16 - index_6_5_18 | 0)) {
                        tmp4__anonymous__8.discardExact_5(index_6_5_18 - tmp1__anonymous__4_3_15 | 0);
                        tmp$ret$2 = lastByteCount_3_12;
                        break l$ret$3;
                      }} else {
                      value_2_11 = value_2_11 << 6 | v_7_6_19 & 127;
                      var tmp4_13_12_27 = byteCount_1_10;
                      byteCount_1_10 = tmp4_13_12_27 - 1 | 0;
                      Unit_getInstance();
                      if (byteCount_1_10 === 0) {
                        if (isBmpCodePoint(value_2_11)) {
                          var tmp4__anonymous__14_28 = numberToChar(value_2_11);
                          var tmp_1;
                          if (copied === max) {
                            tmp_1 = false;
                          } else {
                            out.append_32(tmp4__anonymous__14_28);
                            Unit_getInstance();
                            var tmp0_15_29 = copied;
                            copied = tmp0_15_29 + 1 | 0;
                            Unit_getInstance();
                            tmp_1 = true;
                          }
                          if (!tmp_1) {
                            tmp4__anonymous__8.discardExact_5(((index_6_5_18 - tmp1__anonymous__4_3_15 | 0) - lastByteCount_3_12 | 0) + 1 | 0);
                            tmp$ret$2 = -1;
                            break l$ret$3;
                          } else {
                          }
                        } else if (!isValidCodePoint(value_2_11)) {
                          malformedCodePoint(value_2_11);
                        } else {
                          var tmp_2;
                          var tmp5__anonymous__14_30 = numberToChar(highSurrogate(value_2_11));
                          var tmp_3;
                          if (copied === max) {
                            tmp_3 = false;
                          } else {
                            out.append_32(tmp5__anonymous__14_30);
                            Unit_getInstance();
                            var tmp0_15_31 = copied;
                            copied = tmp0_15_31 + 1 | 0;
                            Unit_getInstance();
                            tmp_3 = true;
                          }
                          if (!tmp_3) {
                            tmp_2 = true;
                          } else {
                            {
                              var tmp6__anonymous__14_32 = numberToChar(lowSurrogate(value_2_11));
                              var tmp_4;
                              if (copied === max) {
                                tmp_4 = false;
                              } else {
                                out.append_32(tmp6__anonymous__14_32);
                                Unit_getInstance();
                                var tmp0_15_33 = copied;
                                copied = tmp0_15_33 + 1 | 0;
                                Unit_getInstance();
                                tmp_4 = true;
                              }
                              tmp_2 = !tmp_4;
                            }
                          }
                          if (tmp_2) {
                            tmp4__anonymous__8.discardExact_5(((index_6_5_18 - tmp1__anonymous__4_3_15 | 0) - lastByteCount_3_12 | 0) + 1 | 0);
                            tmp$ret$2 = -1;
                            break l$ret$3;
                          } else {
                          }
                        }
                        value_2_11 = 0;
                      }}
                  }
                   while (inductionVariable < tmp2__anonymous__4_3_16);
                var rc_2_13 = tmp2__anonymous__4_3_16 - tmp1__anonymous__4_3_15 | 0;
                tmp4__anonymous__8.discardExact_5(rc_2_13);
                Unit_getInstance();
                tmp$ret$2 = 0;
              }
               while (false);
              var size_9 = tmp$ret$2;
              size_4 = size_9 === 0 ? 1 : size_9 > 0 ? size_9 : 0;
            }finally {
              var tmp1__get_readRemaining__0 = current_2;
              after_6 = tmp1__get_readRemaining__0._get_writePosition__1() - tmp1__get_readRemaining__0._get_readPosition__1() | 0;
            }
          } else {
            after_6 = before_5;
          }
          release_1 = false;
          var tmp_5;
          if (after_6 === 0) {
            tmp_5 = prepareReadNextHead($this, current_2);
          } else {
            var tmp_6;
            if (after_6 < size_4) {
              tmp_6 = true;
            } else {
              var tmp2__get_endGap__0 = current_2;
              tmp_6 = (tmp2__get_endGap__0._capacity_0 - tmp2__get_endGap__0._get_limit__1() | 0) < 8;
            }
            if (tmp_6) {
              completeReadHead($this, current_2);
              tmp_5 = prepareReadFirstHead($this, size_4);
            } else {
              {
                tmp_5 = current_2;
              }
            }
          }
          var next_7 = tmp_5;
          if (next_7 == null) {
            break $l$break_0;
          }current_2 = next_7;
          release_1 = true;
        }
         while (size_4 > 0);
      }finally {
        if (release_1) {
          completeReadHead($this, current_2);
        }}
    }
     while (false);
    if (copied < min) {
      prematureEndOfStreamChars($this, min, copied);
    }return copied;
  }
  function discardAsMuchAsPossible($this, n, skipped) {
    var $this_0 = $this;
    var n_0 = n;
    var skipped_0 = skipped;
    while (true) {
      var $this_1 = $this_0;
      var n_1 = n_0;
      var skipped_1 = skipped_0;
      if (n_1.equals(new Long(0, 0)))
        return skipped_1;
      var tmp0_elvis_lhs = $this_1.prepareRead_2(1);
      var tmp;
      if (tmp0_elvis_lhs == null) {
        return skipped_1;
      } else {
        tmp = tmp0_elvis_lhs;
      }
      var current = tmp;
      var tmp0_minOf_0 = toLong_0(current._get_writePosition__1() - current._get_readPosition__1() | 0);
      var size_0 = (tmp0_minOf_0.compareTo_69(n_1) <= 0 ? tmp0_minOf_0 : n_1).toInt_5();
      current.discardExact_5(size_0);
      var tmp1_this = $this_1;
      tmp1_this._set_headPosition__2(tmp1_this._get_headPosition__2() + size_0 | 0);
      afterRead($this_1, current);
      $this_0 = $this_1;
      n_0 = n_1.minus_29(toLong_0(size_0));
      skipped_0 = skipped_1.plus_56(toLong_0(size_0));
      continue;
    }
  }
  function discardAsMuchAsPossible_0($this, n, skipped) {
    var $this_0 = $this;
    var n_0 = n;
    var skipped_0 = skipped;
    while (true) {
      var $this_1 = $this_0;
      var n_1 = n_0;
      var skipped_1 = skipped_0;
      if (n_1 === 0)
        return skipped_1;
      var tmp0_elvis_lhs = $this_1.prepareRead_2(1);
      var tmp;
      if (tmp0_elvis_lhs == null) {
        return skipped_1;
      } else {
        tmp = tmp0_elvis_lhs;
      }
      var current = tmp;
      var tmp0_minOf_0 = current._get_writePosition__1() - current._get_readPosition__1() | 0;
      var size_0 = function () {
        var $externalVarargReceiverTmp = Math;
        return $externalVarargReceiverTmp.min.apply($externalVarargReceiverTmp, [].concat([].slice.call(new Int32Array([tmp0_minOf_0, n_1]))));
      }.call(this);
      current.discardExact_5(size_0);
      var tmp1_this = $this_1;
      tmp1_this._set_headPosition__2(tmp1_this._get_headPosition__2() + size_0 | 0);
      afterRead($this_1, current);
      $this_0 = $this_1;
      n_0 = n_1 - size_0 | 0;
      skipped_0 = skipped_1 + size_0 | 0;
      continue;
    }
  }
  function fixGapAfterReadFallback($this, current) {
    if ($this._noMoreChunksAvailable ? current._get_next__1() == null : false) {
      $this._set_headPosition__2(current._get_readPosition__1());
      $this._set_headEndExclusive__2(current._get_writePosition__1());
      _set_tailRemaining_($this, new Long(0, 0));
      return Unit_getInstance();
    }var size_0 = current._get_writePosition__1() - current._get_readPosition__1() | 0;
    var tmp0_minOf_0 = 8 - (current._capacity_0 - current._get_limit__1() | 0) | 0;
    var overrun = function () {
      var $externalVarargReceiverTmp = Math;
      return $externalVarargReceiverTmp.min.apply($externalVarargReceiverTmp, [].concat([].slice.call(new Int32Array([size_0, tmp0_minOf_0]))));
    }.call(this);
    if (size_0 > overrun) {
      fixGapAfterReadFallbackUnreserved($this, current, size_0, overrun);
    } else {
      var new_0 = $this._pool.borrow_12();
      new_0.reserveEndGap_1(8);
      new_0._set_next__0(current.cleanNext_0());
      writeBufferAppend(new_0, current, size_0);
      Unit_getInstance();
      _set__head_($this, new_0);
    }
    current.release_7($this._pool);
  }
  function fixGapAfterReadFallbackUnreserved($this, current, size_0, overrun) {
    var chunk1 = $this._pool.borrow_12();
    var chunk2 = $this._pool.borrow_12();
    chunk1.reserveEndGap_1(8);
    chunk2.reserveEndGap_1(8);
    chunk1._set_next__0(chunk2);
    chunk2._set_next__0(current.cleanNext_0());
    writeBufferAppend(chunk1, current, size_0 - overrun | 0);
    Unit_getInstance();
    writeBufferAppend(chunk2, current, overrun);
    Unit_getInstance();
    _set__head_($this, chunk1);
    _set_tailRemaining_($this, remainingAll(chunk2));
  }
  function ensureNext($this, current, empty) {
    var $this_0 = $this;
    var current_0 = current;
    var empty_0 = empty;
    while (true) {
      var $this_1 = $this_0;
      var current_1 = current_0;
      var empty_1 = empty_0;
      if (current_1 === empty_1) {
        return doFill($this_1);
      }var next = current_1.cleanNext_0();
      current_1.release_7($this_1._pool);
      var tmp;
      if (next == null) {
        _set__head_($this_1, empty_1);
        _set_tailRemaining_($this_1, new Long(0, 0));
        $this_0 = $this_1;
        current_0 = empty_1;
        empty_0 = empty_1;
        continue;
      } else {
        if (next._get_writePosition__1() > next._get_readPosition__1()) {
          _set__head_($this_1, next);
          var tmp0_this = $this_1;
          var tmp0_minus_0 = _get_tailRemaining_(tmp0_this);
          var tmp1_minus_0 = next._get_writePosition__1() - next._get_readPosition__1() | 0;
          _set_tailRemaining_(tmp0_this, tmp0_minus_0.minus_29(toLong_0(tmp1_minus_0)));
          tmp = next;
        } else {
          {
            $this_0 = $this_1;
            current_0 = next;
            empty_0 = empty_1;
            continue;
          }
        }
      }
      return tmp;
    }
  }
  function doFill($this) {
    if ($this._noMoreChunksAvailable)
      return null;
    var chunk = $this.fill_7();
    if (chunk == null) {
      $this._noMoreChunksAvailable = true;
      return null;
    }appendView($this, chunk);
    return chunk;
  }
  function appendView($this, chunk) {
    var tail = findTail(_get__head_($this));
    if (tail === Companion_getInstance_36()._get_Empty__1()) {
      _set__head_($this, chunk);
      var tmp0_require_0 = _get_tailRemaining_($this).equals(new Long(0, 0));
      if (!tmp0_require_0) {
        var m_2 = new _no_name_provided__3_2();
        m_2.doFail_4_13();
      }var tmp0_safe_receiver = chunk._get_next__1();
      var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : remainingAll(tmp0_safe_receiver);
      _set_tailRemaining_($this, tmp1_elvis_lhs == null ? new Long(0, 0) : tmp1_elvis_lhs);
    } else {
      tail._set_next__0(chunk);
      var tmp2_this = $this;
      _set_tailRemaining_(tmp2_this, _get_tailRemaining_(tmp2_this).plus_56(remainingAll(chunk)));
    }
  }
  function prepareReadLoop($this, minSize, head) {
    var $this_0 = $this;
    var minSize_0 = minSize;
    var head_0 = head;
    while (true) {
      var $this_1 = $this_0;
      var minSize_1 = minSize_0;
      var head_1 = head_0;
      var headSize = $this_1._get_headEndExclusive__2() - $this_1._get_headPosition__2() | 0;
      if (headSize >= minSize_1)
        return head_1;
      var tmp0_elvis_lhs = head_1._get_next__1();
      var tmp1_elvis_lhs = tmp0_elvis_lhs == null ? doFill($this_1) : tmp0_elvis_lhs;
      var tmp;
      if (tmp1_elvis_lhs == null) {
        return null;
      } else {
        tmp = tmp1_elvis_lhs;
      }
      var next = tmp;
      if (headSize === 0) {
        if (!(head_1 === Companion_getInstance_36()._get_Empty__1())) {
          $this_1.releaseHead_2(head_1);
          Unit_getInstance();
        }$this_0 = $this_1;
        minSize_0 = minSize_1;
        head_0 = next;
        continue;
      } else {
        var desiredExtraBytes = minSize_1 - headSize | 0;
        var copied = writeBufferAppend(head_1, next, desiredExtraBytes);
        $this_1._set_headEndExclusive__2(head_1._get_writePosition__1());
        var tmp2_this = $this_1;
        var tmp0_minus_0 = _get_tailRemaining_(tmp2_this);
        _set_tailRemaining_(tmp2_this, tmp0_minus_0.minus_29(toLong_0(copied)));
        if (!(next._get_writePosition__1() > next._get_readPosition__1())) {
          head_1._set_next__0(null);
          head_1._set_next__0(next.cleanNext_0());
          next.release_7($this_1._pool);
        } else {
          {
            next.reserveStartGap_1(copied);
          }
        }
      }
      if ((head_1._get_writePosition__1() - head_1._get_readPosition__1() | 0) >= minSize_1)
        return head_1;
      else {
      }
      if (minSize_1 > 8) {
        minSizeIsTooBig($this_1, minSize_1);
      }$this_0 = $this_1;
      minSize_0 = minSize_1;
      head_0 = head_1;
      continue;
    }
  }
  function minSizeIsTooBig($this, minSize) {
    throw IllegalStateException_init_$Create$('' + 'minSize of ' + minSize + ' is too big (should be less than 8)');
  }
  function afterRead($this, head) {
    if ((head._get_writePosition__1() - head._get_readPosition__1() | 0) === 0) {
      $this.releaseHead_2(head);
      Unit_getInstance();
    } else {
    }
  }
  function Companion_33() {
    Companion_instance_32 = this;
  }
  Companion_33.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_32;
  function Companion_getInstance_32() {
    if (Companion_instance_32 == null)
      new Companion_33();
    return Companion_instance_32;
  }
  function _no_name_provided__3_0($newValue) {
    this._$newValue = $newValue;
    RequireFailureCapture.call(this);
  }
  _no_name_provided__3_0.prototype.doFail_4_13 = function () {
    throw IllegalArgumentException_init_$Create$_0('' + "tailRemaining shouldn't be negative: " + this._$newValue);
  };
  _no_name_provided__3_0.$metadata$ = {
    simpleName: '<no name provided>_3',
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__3_1($n) {
    this._$n = $n;
    RequireFailureCapture.call(this);
  }
  _no_name_provided__3_1.prototype.doFail_4_13 = function () {
    throw IllegalArgumentException_init_$Create$_0('' + 'Negative discard is not allowed: ' + this._$n);
  };
  _no_name_provided__3_1.$metadata$ = {
    simpleName: '<no name provided>_3',
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__3_2() {
    RequireFailureCapture.call(this);
  }
  _no_name_provided__3_2.prototype.doFail_4_13 = function () {
    throw IllegalStateException_init_$Create$('It should be no tail remaining bytes if current tail is EmptyBuffer');
  };
  _no_name_provided__3_2.$metadata$ = {
    simpleName: '<no name provided>_3',
    kind: 'class',
    interfaces: []
  };
  function AbstractInput(head, remaining, pool) {
    Companion_getInstance_32();
    this._pool = pool;
    this._state_5 = new AbstractInputSharedState(head, remaining);
    this._noMoreChunksAvailable = false;
  }
  AbstractInput.prototype._get_pool__2 = function () {
    return this._pool;
  };
  AbstractInput.prototype._get_head__7 = function () {
    var tmp0_also_0 = _get__head_(this);
    tmp0_also_0.discardUntilIndex_1(this._get_headPosition__2());
    return tmp0_also_0;
  };
  AbstractInput.prototype._get_headMemory__2 = function () {
    return this._state_5._headMemory;
  };
  AbstractInput.prototype._set_headPosition__2 = function (value) {
    this._state_5._headPosition = value;
  };
  AbstractInput.prototype._get_headPosition__2 = function () {
    return this._state_5._headPosition;
  };
  AbstractInput.prototype._set_headEndExclusive__2 = function (value) {
    this._state_5._headEndExclusive = value;
  };
  AbstractInput.prototype._get_headEndExclusive__2 = function () {
    return this._state_5._headEndExclusive;
  };
  AbstractInput.prototype.prefetch_2 = function (min) {
    if (min.compareTo_69(new Long(0, 0)) <= 0)
      return true;
    var headRemaining = this._get_headEndExclusive__2() - this._get_headPosition__2() | 0;
    if (toLong_0(headRemaining).compareTo_69(min) >= 0 ? true : numberToLong(headRemaining).plus_56(_get_tailRemaining_(this)).compareTo_69(min) >= 0)
      return true;
    return doPrefetch(this, min);
  };
  AbstractInput.prototype.peekTo_4 = function (destination, destinationOffset, offset, min, max) {
    this.prefetch_2(min.plus_56(offset));
    Unit_getInstance();
    var current = this._get_head__7();
    var copied = new Long(0, 0);
    var skip = offset;
    var writePosition = destinationOffset;
    var tmp0_minOf_0 = toLong_0(destination._view.byteLength).minus_29(destinationOffset);
    var maxCopySize = max.compareTo_69(tmp0_minOf_0) <= 0 ? max : tmp0_minOf_0;
    $l$break: while (copied.compareTo_69(min) < 0 ? copied.compareTo_69(maxCopySize) < 0 : false) {
      var tmp1__get_readRemaining__0 = current;
      var chunkSize = tmp1__get_readRemaining__0._get_writePosition__1() - tmp1__get_readRemaining__0._get_readPosition__1() | 0;
      if (toLong_0(chunkSize).compareTo_69(skip) > 0) {
        var tmp2_minOf_0 = numberToLong(chunkSize).minus_29(skip);
        var tmp3_minOf_0 = maxCopySize.minus_29(copied);
        var size_0 = tmp2_minOf_0.compareTo_69(tmp3_minOf_0) <= 0 ? tmp2_minOf_0 : tmp3_minOf_0;
        current._get_memory__1().copyTo_0(destination, numberToLong(current._get_readPosition__1()).plus_56(skip), size_0, writePosition);
        skip = new Long(0, 0);
        copied = copied.plus_56(size_0);
        writePosition = writePosition.plus_56(size_0);
      } else {
        var tmp4_minus_0 = skip;
        skip = tmp4_minus_0.minus_29(toLong_0(chunkSize));
      }
      var tmp0_elvis_lhs = current._get_next__1();
      var tmp;
      if (tmp0_elvis_lhs == null) {
        break $l$break;
      } else {
        tmp = tmp0_elvis_lhs;
      }
      current = tmp;
    }
    return copied;
  };
  AbstractInput.prototype._get_remaining__2 = function () {
    return toLong_0(this._get_headEndExclusive__2() - this._get_headPosition__2() | 0).plus_56(_get_tailRemaining_(this));
  };
  AbstractInput.prototype.canRead_0 = function () {
    return !(this._get_headPosition__2() === this._get_headEndExclusive__2()) ? true : !_get_tailRemaining_(this).equals(new Long(0, 0));
  };
  AbstractInput.prototype._get_endOfInput__4 = function () {
    var tmp;
    var tmp_0;
    if ((this._get_headEndExclusive__2() - this._get_headPosition__2() | 0) === 0) {
      tmp_0 = _get_tailRemaining_(this).equals(new Long(0, 0));
    } else {
      {
        tmp_0 = false;
      }
    }
    if (tmp_0) {
      tmp = this._noMoreChunksAvailable ? true : doFill(this) == null;
    } else {
      {
        tmp = false;
      }
    }
    return tmp;
  };
  AbstractInput.prototype.release_4 = function () {
    var head = this._get_head__7();
    var empty = Companion_getInstance_36()._get_Empty__1();
    if (!(head === empty)) {
      _set__head_(this, empty);
      _set_tailRemaining_(this, new Long(0, 0));
      releaseAll(head, this._pool);
    }};
  AbstractInput.prototype.close_39 = function () {
    this.release_4();
    if (!this._noMoreChunksAvailable) {
      this._noMoreChunksAvailable = true;
    }this.closeSource_2();
  };
  AbstractInput.prototype.stealAll_4 = function () {
    var head = this._get_head__7();
    var empty = Companion_getInstance_36()._get_Empty__1();
    if (head === empty)
      return null;
    _set__head_(this, empty);
    _set_tailRemaining_(this, new Long(0, 0));
    return head;
  };
  AbstractInput.prototype.steal_0 = function () {
    var head = this._get_head__7();
    var next = head._get_next__1();
    var empty = Companion_getInstance_36()._get_Empty__1();
    if (head === empty)
      return null;
    if (next == null) {
      _set__head_(this, empty);
      _set_tailRemaining_(this, new Long(0, 0));
    } else {
      _set__head_(this, next);
      var tmp0_this = this;
      var tmp0_minus_0 = _get_tailRemaining_(tmp0_this);
      var tmp1_minus_0 = next._get_writePosition__1() - next._get_readPosition__1() | 0;
      _set_tailRemaining_(tmp0_this, tmp0_minus_0.minus_29(toLong_0(tmp1_minus_0)));
    }
    head._set_next__0(null);
    return head;
  };
  AbstractInput.prototype.append_29 = function (chain) {
    if (chain === Companion_getInstance_36()._get_Empty__1())
      return Unit_getInstance();
    var size_0 = remainingAll(chain);
    if (_get__head_(this) === Companion_getInstance_36()._get_Empty__1()) {
      _set__head_(this, chain);
      var tmp0_minus_0 = this._get_headEndExclusive__2() - this._get_headPosition__2() | 0;
      _set_tailRemaining_(this, size_0.minus_29(toLong_0(tmp0_minus_0)));
    } else {
      findTail(_get__head_(this))._set_next__0(chain);
      var tmp0_this = this;
      _set_tailRemaining_(tmp0_this, _get_tailRemaining_(tmp0_this).plus_56(size_0));
    }
  };
  AbstractInput.prototype.tryWriteAppend_0 = function (chain) {
    var tail = findTail(this._get_head__7());
    var size_0 = chain._get_writePosition__1() - chain._get_readPosition__1() | 0;
    var tmp;
    if (size_0 === 0) {
      tmp = true;
    } else {
      tmp = (tail._get_limit__1() - tail._get_writePosition__1() | 0) < size_0;
    }
    if (tmp)
      return false;
    else {
    }
    writeBufferAppend(tail, chain, size_0);
    Unit_getInstance();
    if (this._get_head__7() === tail) {
      this._set_headEndExclusive__2(tail._get_writePosition__1());
    } else {
      var tmp0_this = this;
      var tmp0_plus_0 = _get_tailRemaining_(tmp0_this);
      _set_tailRemaining_(tmp0_this, tmp0_plus_0.plus_56(toLong_0(size_0)));
    }
    return true;
  };
  AbstractInput.prototype.discard_6 = function (n) {
    var tmp0_require_0 = n >= 0;
    if (!tmp0_require_0) {
      var m_2 = new _no_name_provided__3_1(n);
      m_2.doFail_4_13();
    }return discardAsMuchAsPossible_0(this, n, 0);
  };
  AbstractInput.prototype.discardExact_5 = function (n) {
    if (!(this.discard_6(n) === n))
      throw new EOFException('' + 'Unable to discard ' + n + ' bytes due to end of packet');
  };
  AbstractInput.prototype.discard_9 = function (n) {
    if (n.compareTo_69(new Long(0, 0)) <= 0)
      return new Long(0, 0);
    return discardAsMuchAsPossible(this, n, new Long(0, 0));
  };
  AbstractInput.prototype.readText_3 = function (min, max) {
    if (min === 0 ? max === 0 ? true : this._get_endOfInput__4() : false)
      return '';
    var remaining = this._get_remaining__2();
    if (remaining.compareTo_69(new Long(0, 0)) > 0 ? toLong_0(max).compareTo_69(remaining) >= 0 : false) {
      var tmp = remaining.toInt_5();
      return readTextExactBytes$default(this, tmp, null, 2, null);
    }var tmp0_buildString_0 = coerceAtMost(coerceAtLeast(min, 16), max);
    var tmp0_apply_0_1 = StringBuilder_init_$Create$(tmp0_buildString_0);
    readASCII(this, tmp0_apply_0_1, min, max);
    Unit_getInstance();
    return tmp0_apply_0_1.toString();
  };
  AbstractInput.prototype.readText$default_2 = function (min, max, $mask0, $handler) {
    if (!(($mask0 & 1) === 0))
      min = 0;
    if (!(($mask0 & 2) === 0))
      max = IntCompanionObject_getInstance()._MAX_VALUE_5;
    return this.readText_3(min, max);
  };
  AbstractInput.prototype.prepareReadHead_2 = function (minSize) {
    return prepareReadLoop(this, minSize, this._get_head__7());
  };
  AbstractInput.prototype.ensureNextHead_2 = function (current) {
    return this.ensureNext_2(current);
  };
  AbstractInput.prototype.ensureNext_2 = function (current) {
    return ensureNext(this, current, Companion_getInstance_36()._get_Empty__1());
  };
  AbstractInput.prototype.fixGapAfterRead_2 = function (current) {
    var tmp0_elvis_lhs = current._get_next__1();
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return fixGapAfterReadFallback(this, current);
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var next = tmp;
    var remaining = current._get_writePosition__1() - current._get_readPosition__1() | 0;
    var tmp0_minOf_0 = 8 - (current._capacity_0 - current._get_limit__1() | 0) | 0;
    var overrunSize = function () {
      var $externalVarargReceiverTmp = Math;
      return $externalVarargReceiverTmp.min.apply($externalVarargReceiverTmp, [].concat([].slice.call(new Int32Array([remaining, tmp0_minOf_0]))));
    }.call(this);
    if (next._get_startGap__1() < overrunSize) {
      return fixGapAfterReadFallback(this, current);
    }restoreStartGap(next, overrunSize);
    if (remaining > overrunSize) {
      current.releaseEndGap_1();
      this._set_headEndExclusive__2(current._get_writePosition__1());
      var tmp1_this = this;
      var tmp1_plus_0 = _get_tailRemaining_(tmp1_this);
      _set_tailRemaining_(tmp1_this, tmp1_plus_0.plus_56(toLong_0(overrunSize)));
    } else {
      _set__head_(this, next);
      var tmp2_this = this;
      var tmp2_minus_0 = _get_tailRemaining_(tmp2_this);
      var tmp3_minus_0 = (next._get_writePosition__1() - next._get_readPosition__1() | 0) - overrunSize | 0;
      _set_tailRemaining_(tmp2_this, tmp2_minus_0.minus_29(toLong_0(tmp3_minus_0)));
      current.cleanNext_0();
      Unit_getInstance();
      current.release_7(this._pool);
    }
  };
  AbstractInput.prototype.fill_7 = function () {
    var buffer = this._pool.borrow_12();
    try {
      buffer.reserveEndGap_1(8);
      var tmp = buffer._get_memory__1();
      var tmp_0 = buffer._get_writePosition__1();
      var copied = this.fill_6(tmp, tmp_0, buffer._get_limit__1() - buffer._get_writePosition__1() | 0);
      if (copied === 0) {
        this._noMoreChunksAvailable = true;
        if (!(buffer._get_writePosition__1() > buffer._get_readPosition__1())) {
          buffer.release_7(this._pool);
          return null;
        } else {
        }
      }buffer.commitWritten_1(copied);
      return buffer;
    } catch ($p) {
      if ($p instanceof Error) {
        buffer.release_7(this._pool);
        throw $p;
      } else {
        {
          throw $p;
        }
      }
    }
  };
  AbstractInput.prototype.markNoMoreChunksAvailable_0 = function () {
    if (!this._noMoreChunksAvailable) {
      this._noMoreChunksAvailable = true;
    }};
  AbstractInput.prototype.prepareRead_2 = function (minSize) {
    var head = this._get_head__7();
    if ((this._get_headEndExclusive__2() - this._get_headPosition__2() | 0) >= minSize)
      return head;
    return prepareReadLoop(this, minSize, head);
  };
  AbstractInput.prototype.releaseHead_2 = function (head) {
    var tmp0_elvis_lhs = head.cleanNext_0();
    var next = tmp0_elvis_lhs == null ? Companion_getInstance_36()._get_Empty__1() : tmp0_elvis_lhs;
    _set__head_(this, next);
    var tmp1_this = this;
    var tmp0_minus_0 = _get_tailRemaining_(tmp1_this);
    var tmp1_minus_0 = next._get_writePosition__1() - next._get_readPosition__1() | 0;
    _set_tailRemaining_(tmp1_this, tmp0_minus_0.minus_29(toLong_0(tmp1_minus_0)));
    head.release_7(this._pool);
    return next;
  };
  AbstractInput.$metadata$ = {
    simpleName: 'AbstractInput',
    kind: 'class',
    interfaces: [Input]
  };
  function AbstractOutput_init_$Init$(pool, $this) {
    AbstractOutput.call($this, 0, pool);
    return $this;
  }
  function _set__head__0($this, value) {
    $this._state_6._head_3 = value;
  }
  function _get__head__0($this) {
    return $this._state_6._head_3;
  }
  function _set__tail_($this, value) {
    $this._state_6._tail_0 = value;
  }
  function _get__tail_($this) {
    return $this._state_6._tail_0;
  }
  function _set_tailEndExclusive_($this, value) {
    $this._state_6._tailEndExclusive = value;
  }
  function _set_tailInitialPosition_($this, value) {
    $this._state_6._tailInitialPosition = value;
  }
  function _get_tailInitialPosition_($this) {
    return $this._state_6._tailInitialPosition;
  }
  function _set_chainedSize_($this, value) {
    $this._state_6._chainedSize = value;
  }
  function _get_chainedSize_($this) {
    return $this._state_6._chainedSize;
  }
  function flushChain($this) {
    var tmp0_elvis_lhs = $this.stealAll_4();
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return Unit_getInstance();
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var oldTail = tmp;
    try {
      var current_2 = oldTail;
      $l$break: do {
        var tmp0__anonymous__4 = current_2;
        var tmp_0 = tmp0__anonymous__4._get_memory__1();
        var tmp_1 = tmp0__anonymous__4._get_readPosition__1();
        $this.flush_6(tmp_0, tmp_1, tmp0__anonymous__4._get_writePosition__1() - tmp0__anonymous__4._get_readPosition__1() | 0);
        var tmp0_elvis_lhs_3 = current_2._get_next__1();
        var tmp_2;
        if (tmp0_elvis_lhs_3 == null) {
          break $l$break;
        } else {
          tmp_2 = tmp0_elvis_lhs_3;
        }
        current_2 = tmp_2;
      }
       while (true);
    }finally {
      releaseAll(oldTail, $this._pool_0);
    }
  }
  function appendNewChunk($this) {
    var new_0 = $this._pool_0.borrow_12();
    new_0.reserveEndGap_1(8);
    $this.appendSingleChunk_2(new_0);
    return new_0;
  }
  function appendChainImpl($this, head, newTail, chainedSizeDelta) {
    var _tail = _get__tail_($this);
    if (_tail == null) {
      _set__head__0($this, head);
      _set_chainedSize_($this, 0);
    } else {
      _tail._set_next__0(head);
      var tailPosition = $this._get_tailPosition__2();
      _tail.commitWrittenUntilIndex_1(tailPosition);
      Unit_getInstance();
      var tmp0_this = $this;
      _set_chainedSize_(tmp0_this, _get_chainedSize_(tmp0_this) + (tailPosition - _get_tailInitialPosition_($this) | 0) | 0);
    }
    _set__tail_($this, newTail);
    var tmp1_this = $this;
    _set_chainedSize_(tmp1_this, _get_chainedSize_(tmp1_this) + chainedSizeDelta | 0);
    $this._set_tailMemory__2(newTail._get_memory__1());
    $this._set_tailPosition__2(newTail._get_writePosition__1());
    _set_tailInitialPosition_($this, newTail._get_readPosition__1());
    _set_tailEndExclusive_($this, newTail._get_limit__1());
  }
  function writeByteFallback($this, v) {
    appendNewChunk($this).writeByte_6(v);
    var tmp0_this = $this;
    var tmp1 = tmp0_this._get_tailPosition__2();
    tmp0_this._set_tailPosition__2(tmp1 + 1 | 0);
    Unit_getInstance();
  }
  function appendCharFallback($this, c) {
    var tmp$ret$0;
    l$ret$1: do {
      var tmp1_write_0 = 3;
      var buffer_1 = $this.prepareWriteHead_2(tmp1_write_0);
      try {
        var tmp16_putUtf8Char_0_6 = buffer_1._memory;
        var tmp17_putUtf8Char_0_7 = buffer_1._get_writePosition__1();
        var tmp18_putUtf8Char_0_8 = c.toInt_5();
        var tmp;
        if (0 <= tmp18_putUtf8Char_0_8 ? tmp18_putUtf8Char_0_8 <= 127 : false) {
          var tmp0_storeAt_0_9 = toByte_0(tmp18_putUtf8Char_0_8);
          tmp16_putUtf8Char_0_6._view.setInt8(tmp17_putUtf8Char_0_7, tmp0_storeAt_0_9);
          tmp = 1;
        } else if (128 <= tmp18_putUtf8Char_0_8 ? tmp18_putUtf8Char_0_8 <= 2047 : false) {
          var tmp1_set_0_10 = toByte_0(192 | tmp18_putUtf8Char_0_8 >> 6 & 31);
          tmp16_putUtf8Char_0_6._view.setInt8(tmp17_putUtf8Char_0_7, tmp1_set_0_10);
          var tmp2_set_0_11 = tmp17_putUtf8Char_0_7 + 1 | 0;
          var tmp3_set_0_12 = toByte_0(128 | tmp18_putUtf8Char_0_8 & 63);
          tmp16_putUtf8Char_0_6._view.setInt8(tmp2_set_0_11, tmp3_set_0_12);
          tmp = 2;
        } else if (2048 <= tmp18_putUtf8Char_0_8 ? tmp18_putUtf8Char_0_8 <= 65535 : false) {
          var tmp4_set_0_13 = toByte_0(224 | tmp18_putUtf8Char_0_8 >> 12 & 15);
          tmp16_putUtf8Char_0_6._view.setInt8(tmp17_putUtf8Char_0_7, tmp4_set_0_13);
          var tmp5_set_0_14 = tmp17_putUtf8Char_0_7 + 1 | 0;
          var tmp6_set_0_15 = toByte_0(128 | tmp18_putUtf8Char_0_8 >> 6 & 63);
          tmp16_putUtf8Char_0_6._view.setInt8(tmp5_set_0_14, tmp6_set_0_15);
          var tmp7_set_0_16 = tmp17_putUtf8Char_0_7 + 2 | 0;
          var tmp8_set_0_17 = toByte_0(128 | tmp18_putUtf8Char_0_8 & 63);
          tmp16_putUtf8Char_0_6._view.setInt8(tmp7_set_0_16, tmp8_set_0_17);
          tmp = 3;
        } else if (65536 <= tmp18_putUtf8Char_0_8 ? tmp18_putUtf8Char_0_8 <= 1114111 : false) {
          var tmp9_set_0_18 = toByte_0(240 | tmp18_putUtf8Char_0_8 >> 18 & 7);
          tmp16_putUtf8Char_0_6._view.setInt8(tmp17_putUtf8Char_0_7, tmp9_set_0_18);
          var tmp10_set_0_19 = tmp17_putUtf8Char_0_7 + 1 | 0;
          var tmp11_set_0_20 = toByte_0(128 | tmp18_putUtf8Char_0_8 >> 12 & 63);
          tmp16_putUtf8Char_0_6._view.setInt8(tmp10_set_0_19, tmp11_set_0_20);
          var tmp12_set_0_21 = tmp17_putUtf8Char_0_7 + 2 | 0;
          var tmp13_set_0_22 = toByte_0(128 | tmp18_putUtf8Char_0_8 >> 6 & 63);
          tmp16_putUtf8Char_0_6._view.setInt8(tmp12_set_0_21, tmp13_set_0_22);
          var tmp14_set_0_23 = tmp17_putUtf8Char_0_7 + 3 | 0;
          var tmp15_set_0_24 = toByte_0(128 | tmp18_putUtf8Char_0_8 & 63);
          tmp16_putUtf8Char_0_6._view.setInt8(tmp14_set_0_23, tmp15_set_0_24);
          tmp = 4;
        } else {
          malformedCodePoint(tmp18_putUtf8Char_0_8);
        }
        var size_5 = tmp;
        buffer_1.commitWritten_1(size_5);
        var result_2 = size_5;
        var tmp0_check_0 = result_2 >= 0;
        if (!tmp0_check_0) {
          var message_1 = "The returned value shouldn't be negative";
          throw IllegalStateException_init_$Create$(toString_1(message_1));
        }tmp$ret$0 = result_2;
        break l$ret$1;
      }finally {
        $this.afterHeadWrite_2();
      }
    }
     while (false);
    Unit_getInstance();
  }
  function writePacketMerging($this, tail, foreignStolen, pool) {
    tail.commitWrittenUntilIndex_1($this._get_tailPosition__2());
    Unit_getInstance();
    var lastSize = tail._get_writePosition__1() - tail._get_readPosition__1() | 0;
    var nextSize = foreignStolen._get_writePosition__1() - foreignStolen._get_readPosition__1() | 0;
    var maxCopySize = PACKET_MAX_COPY_SIZE;
    var tmp;
    var tmp_0;
    if (nextSize < maxCopySize) {
      var tmp_1 = tail._capacity_0 - tail._get_limit__1() | 0;
      tmp_0 = nextSize <= (tmp_1 + (tail._get_limit__1() - tail._get_writePosition__1() | 0) | 0);
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = nextSize;
    } else {
      {
        tmp = -1;
      }
    }
    var appendSize = tmp;
    var tmp_2;
    if ((lastSize < maxCopySize ? lastSize <= foreignStolen._get_startGap__1() : false) ? isExclusivelyOwned(foreignStolen) : false) {
      tmp_2 = lastSize;
    } else {
      tmp_2 = -1;
    }
    var prependSize = tmp_2;
    if (appendSize === -1 ? prependSize === -1 : false) {
      $this.appendChain_2(foreignStolen);
    } else if (prependSize === -1 ? true : appendSize <= prependSize) {
      var tmp_3 = tail._get_limit__1() - tail._get_writePosition__1() | 0;
      writeBufferAppend(tail, foreignStolen, tmp_3 + (tail._capacity_0 - tail._get_limit__1() | 0) | 0);
      Unit_getInstance();
      $this.afterHeadWrite_2();
      var tmp0_safe_receiver = foreignStolen.cleanNext_0();
      if (tmp0_safe_receiver == null)
        null;
      else {
        $this.appendChain_2(tmp0_safe_receiver);
        Unit_getInstance();
      }
      Unit_getInstance();
      foreignStolen.release_7(pool);
    } else if (appendSize === -1 ? true : prependSize < appendSize) {
      writePacketSlowPrepend($this, foreignStolen, tail);
    } else {
      throw IllegalStateException_init_$Create$('' + 'prep = ' + prependSize + ', app = ' + appendSize);
    }
  }
  function writePacketSlowPrepend($this, foreignStolen, tail) {
    writeBufferPrepend(foreignStolen, tail);
    Unit_getInstance();
    var tmp0_elvis_lhs = _get__head__0($this);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      var tmp0_error_0 = "head should't be null since it is already handled in the fast-path";
      throw IllegalStateException_init_$Create$(toString_1(tmp0_error_0));
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var _head = tmp;
    if (_head === tail) {
      _set__head__0($this, foreignStolen);
    } else {
      var pre = _head;
      $l$break: while (true) {
        var next = ensureNotNull(pre._get_next__1());
        if (next === tail)
          break $l$break;
        pre = next;
      }
      pre._set_next__0(foreignStolen);
    }
    tail.release_7($this._pool_0);
    _set__tail_($this, findTail(foreignStolen));
  }
  function AbstractOutput(headerSizeHint, pool) {
    this._headerSizeHint_0 = headerSizeHint;
    this._pool_0 = pool;
    this._state_6 = new AbstractOutputSharedState();
    this._byteOrder = ByteOrder_BIG_ENDIAN_getInstance();
  }
  AbstractOutput.prototype._get_pool__2 = function () {
    return this._pool_0;
  };
  AbstractOutput.prototype._get_head__7 = function () {
    var tmp0_elvis_lhs = _get__head__0(this);
    return tmp0_elvis_lhs == null ? Companion_getInstance_36()._get_Empty__1() : tmp0_elvis_lhs;
  };
  AbstractOutput.prototype._set_tailMemory__2 = function (value) {
    this._state_6._tailMemory = value;
  };
  AbstractOutput.prototype._get_tailMemory__2 = function () {
    return this._state_6._tailMemory;
  };
  AbstractOutput.prototype._set_tailPosition__2 = function (value) {
    this._state_6._tailPosition = value;
  };
  AbstractOutput.prototype._get_tailPosition__2 = function () {
    return this._state_6._tailPosition;
  };
  AbstractOutput.prototype._get_tailEndExclusive__2 = function () {
    return this._state_6._tailEndExclusive;
  };
  AbstractOutput.prototype._get__size__0 = function () {
    return _get_chainedSize_(this) + (this._get_tailPosition__2() - _get_tailInitialPosition_(this) | 0) | 0;
  };
  AbstractOutput.prototype.flush_8 = function () {
    flushChain(this);
  };
  AbstractOutput.prototype.stealAll_4 = function () {
    var tmp0_elvis_lhs = _get__head__0(this);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return null;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var head = tmp;
    var tmp1_safe_receiver = _get__tail_(this);
    if (tmp1_safe_receiver == null)
      null;
    else
      tmp1_safe_receiver.commitWrittenUntilIndex_1(this._get_tailPosition__2());
    Unit_getInstance();
    _set__head__0(this, null);
    _set__tail_(this, null);
    this._set_tailPosition__2(0);
    _set_tailEndExclusive_(this, 0);
    _set_tailInitialPosition_(this, 0);
    _set_chainedSize_(this, 0);
    this._set_tailMemory__2(Companion_getInstance_38()._Empty_0);
    return head;
  };
  AbstractOutput.prototype.afterBytesStolen_0 = function () {
    var head = this._get_head__7();
    if (!(head === Companion_getInstance_36()._get_Empty__1())) {
      var tmp0_check_0 = head._get_next__1() == null;
      if (!tmp0_check_0) {
        var message_2_1 = 'Check failed.';
        throw IllegalStateException_init_$Create$(toString_1(message_2_1));
      }head.resetForWrite_3();
      head.reserveStartGap_1(this._headerSizeHint_0);
      head.reserveEndGap_1(8);
      this._set_tailPosition__2(head._get_writePosition__1());
      _set_tailInitialPosition_(this, this._get_tailPosition__2());
      _set_tailEndExclusive_(this, head._get_limit__1());
    }};
  AbstractOutput.prototype.appendSingleChunk_2 = function (buffer) {
    var tmp0_check_0 = buffer._get_next__1() == null;
    if (!tmp0_check_0) {
      var message_1 = 'It should be a single buffer chunk.';
      throw IllegalStateException_init_$Create$(toString_1(message_1));
    }appendChainImpl(this, buffer, buffer, 0);
  };
  AbstractOutput.prototype.appendChain_2 = function (head) {
    var tail = findTail(head);
    var tmp0_minus_0 = remainingAll(head);
    var tmp1_minus_0 = tail._get_writePosition__1() - tail._get_readPosition__1() | 0;
    var tmp2_toIntOrFail_0 = tmp0_minus_0.minus_29(toLong_0(tmp1_minus_0));
    var tmp3_toIntOrFail_0 = 'total size increase';
    if (tmp2_toIntOrFail_0.compareTo_69(toLong_0(IntCompanionObject_getInstance()._MAX_VALUE_5)) >= 0) {
      failLongToIntConversion(tmp2_toIntOrFail_0, tmp3_toIntOrFail_0);
    }var chainedSizeDelta = tmp2_toIntOrFail_0.toInt_5();
    appendChainImpl(this, head, tail, chainedSizeDelta);
  };
  AbstractOutput.prototype.writeByte_6 = function (v) {
    var index = this._get_tailPosition__2();
    if (index < this._get_tailEndExclusive__2()) {
      this._set_tailPosition__2(index + 1 | 0);
      var tmp0_set_0 = this._get_tailMemory__2();
      tmp0_set_0._view.setInt8(index, v);
      return Unit_getInstance();
    }return writeByteFallback(this, v);
  };
  AbstractOutput.prototype.close_39 = function () {
    try {
      this.flush_8();
    }finally {
      this.closeDestination_2();
    }
  };
  AbstractOutput.prototype.append_32 = function (c) {
    var tailPosition = this._get_tailPosition__2();
    if ((this._get_tailEndExclusive__2() - tailPosition | 0) >= 3) {
      var tmp16_putUtf8Char_0 = this._get_tailMemory__2();
      var tmp17_putUtf8Char_0 = c.toInt_5();
      var tmp;
      if (0 <= tmp17_putUtf8Char_0 ? tmp17_putUtf8Char_0 <= 127 : false) {
        var tmp0_storeAt_0 = toByte_0(tmp17_putUtf8Char_0);
        tmp16_putUtf8Char_0._view.setInt8(tailPosition, tmp0_storeAt_0);
        tmp = 1;
      } else if (128 <= tmp17_putUtf8Char_0 ? tmp17_putUtf8Char_0 <= 2047 : false) {
        var tmp1_set_0 = toByte_0(192 | tmp17_putUtf8Char_0 >> 6 & 31);
        tmp16_putUtf8Char_0._view.setInt8(tailPosition, tmp1_set_0);
        var tmp2_set_0 = tailPosition + 1 | 0;
        var tmp3_set_0 = toByte_0(128 | tmp17_putUtf8Char_0 & 63);
        tmp16_putUtf8Char_0._view.setInt8(tmp2_set_0, tmp3_set_0);
        tmp = 2;
      } else if (2048 <= tmp17_putUtf8Char_0 ? tmp17_putUtf8Char_0 <= 65535 : false) {
        var tmp4_set_0 = toByte_0(224 | tmp17_putUtf8Char_0 >> 12 & 15);
        tmp16_putUtf8Char_0._view.setInt8(tailPosition, tmp4_set_0);
        var tmp5_set_0 = tailPosition + 1 | 0;
        var tmp6_set_0 = toByte_0(128 | tmp17_putUtf8Char_0 >> 6 & 63);
        tmp16_putUtf8Char_0._view.setInt8(tmp5_set_0, tmp6_set_0);
        var tmp7_set_0 = tailPosition + 2 | 0;
        var tmp8_set_0 = toByte_0(128 | tmp17_putUtf8Char_0 & 63);
        tmp16_putUtf8Char_0._view.setInt8(tmp7_set_0, tmp8_set_0);
        tmp = 3;
      } else if (65536 <= tmp17_putUtf8Char_0 ? tmp17_putUtf8Char_0 <= 1114111 : false) {
        var tmp9_set_0 = toByte_0(240 | tmp17_putUtf8Char_0 >> 18 & 7);
        tmp16_putUtf8Char_0._view.setInt8(tailPosition, tmp9_set_0);
        var tmp10_set_0 = tailPosition + 1 | 0;
        var tmp11_set_0 = toByte_0(128 | tmp17_putUtf8Char_0 >> 12 & 63);
        tmp16_putUtf8Char_0._view.setInt8(tmp10_set_0, tmp11_set_0);
        var tmp12_set_0 = tailPosition + 2 | 0;
        var tmp13_set_0 = toByte_0(128 | tmp17_putUtf8Char_0 >> 6 & 63);
        tmp16_putUtf8Char_0._view.setInt8(tmp12_set_0, tmp13_set_0);
        var tmp14_set_0 = tailPosition + 3 | 0;
        var tmp15_set_0 = toByte_0(128 | tmp17_putUtf8Char_0 & 63);
        tmp16_putUtf8Char_0._view.setInt8(tmp14_set_0, tmp15_set_0);
        tmp = 4;
      } else {
        malformedCodePoint(tmp17_putUtf8Char_0);
      }
      var size_0 = tmp;
      this._set_tailPosition__2(tailPosition + size_0 | 0);
      return this;
    }appendCharFallback(this, c);
    return this;
  };
  AbstractOutput.prototype.append_31 = function (csq) {
    if (csq == null) {
      this.append_30('null', 0, 4);
      Unit_getInstance();
    } else {
      this.append_30(csq, 0, charSequenceLength(csq));
      Unit_getInstance();
    }
    return this;
  };
  AbstractOutput.prototype.append_30 = function (csq, start, end) {
    if (csq == null) {
      return this.append_30('null', start, end);
    }writeText(this, csq, start, end, Charsets_getInstance()._UTF_8);
    return this;
  };
  AbstractOutput.prototype.writePacket_1 = function (p) {
    var foreignStolen = p.stealAll_4();
    if (foreignStolen == null) {
      p.release_4();
      return Unit_getInstance();
    }var _tail = _get__tail_(this);
    if (_tail == null) {
      this.appendChain_2(foreignStolen);
      return Unit_getInstance();
    }writePacketMerging(this, _tail, foreignStolen, p._get_pool__2());
  };
  AbstractOutput.prototype.writeChunkBuffer_0 = function (chunkBuffer) {
    var _tail = _get__tail_(this);
    if (_tail == null) {
      this.appendChain_2(chunkBuffer);
      return Unit_getInstance();
    }writePacketMerging(this, _tail, chunkBuffer, this._pool_0);
  };
  AbstractOutput.prototype.writePacket_2 = function (p, n) {
    var remaining = n;
    $l$break: while (remaining.compareTo_69(new Long(0, 0)) > 0) {
      var headRemaining = toLong_0(p._get_headEndExclusive__2() - p._get_headPosition__2() | 0);
      if (headRemaining.compareTo_69(remaining) <= 0) {
        remaining = remaining.minus_29(headRemaining);
        var tmp0_elvis_lhs = p.steal_0();
        var tmp;
        if (tmp0_elvis_lhs == null) {
          throw new EOFException('Unexpected end of packet');
        } else {
          tmp = tmp0_elvis_lhs;
        }
        this.appendSingleChunk_2(tmp);
      } else {
        var tmp0_read_0 = 1;
        var tmp0_elvis_lhs_3 = p.prepareRead_2(tmp0_read_0);
        var tmp_0;
        if (tmp0_elvis_lhs_3 == null) {
          prematureEndOfStream(tmp0_read_0);
        } else {
          tmp_0 = tmp0_elvis_lhs_3;
        }
        var buffer_2 = tmp_0;
        var positionBefore_4 = buffer_2._get_readPosition__1();
        try {
          writeFully_3(this, buffer_2, remaining.toInt_5());
        }finally {
          var positionAfter_5 = buffer_2._get_readPosition__1();
          if (positionAfter_5 < positionBefore_4) {
            throw IllegalStateException_init_$Create$("Buffer's position shouldn't be rewinded");
          }if (positionAfter_5 === buffer_2._get_writePosition__1()) {
            p.ensureNext_2(buffer_2);
            Unit_getInstance();
          } else {
            p._set_headPosition__2(positionAfter_5);
          }
        }
        break $l$break;
      }
    }
  };
  AbstractOutput.prototype.release_4 = function () {
    this.close_39();
  };
  AbstractOutput.prototype.prepareWriteHead_2 = function (n) {
    if ((this._get_tailEndExclusive__2() - this._get_tailPosition__2() | 0) >= n) {
      var tmp0_safe_receiver = _get__tail_(this);
      if (tmp0_safe_receiver == null)
        null;
      else {
        tmp0_safe_receiver.commitWrittenUntilIndex_1(this._get_tailPosition__2());
        Unit_getInstance();
        return tmp0_safe_receiver;
      }
      Unit_getInstance();
    } else {
    }
    return appendNewChunk(this);
  };
  AbstractOutput.prototype.afterHeadWrite_2 = function () {
    var tmp0_safe_receiver = _get__tail_(this);
    if (tmp0_safe_receiver == null)
      null;
    else {
      this._set_tailPosition__2(tmp0_safe_receiver._get_writePosition__1());
      Unit_getInstance();
    }
    Unit_getInstance();
  };
  AbstractOutput.$metadata$ = {
    simpleName: 'AbstractOutput',
    kind: 'class',
    interfaces: [Appendable, Output]
  };
  function _set_readPosition_($this, value) {
    $this._bufferState._readPosition = value;
  }
  function _set_writePosition_($this, value) {
    $this._bufferState._writePosition = value;
  }
  function _set_startGap_($this, value) {
    $this._bufferState._startGap = value;
  }
  function _set_limit_($this, value) {
    $this._bufferState._limit_4 = value;
  }
  function Companion_34() {
    Companion_instance_33 = this;
    this._ReservedSize = 8;
  }
  Companion_34.prototype._get_Empty__1 = function () {
    return Companion_getInstance_41()._Empty_1;
  };
  Companion_34.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_33;
  function Companion_getInstance_33() {
    if (Companion_instance_33 == null)
      new Companion_34();
    return Companion_instance_33;
  }
  function _no_name_provided__3_3($startGap) {
    this._$startGap = $startGap;
    RequireFailureCapture.call(this);
  }
  _no_name_provided__3_3.prototype.doFail_4_13 = function () {
    throw IllegalArgumentException_init_$Create$_0('' + "startGap shouldn't be negative: " + this._$startGap);
  };
  _no_name_provided__3_3.$metadata$ = {
    simpleName: '<no name provided>_3',
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__3_4($endGap) {
    this._$endGap = $endGap;
    RequireFailureCapture.call(this);
  }
  _no_name_provided__3_4.prototype.doFail_4_13 = function () {
    throw IllegalArgumentException_init_$Create$_0('' + "endGap shouldn't be negative: " + this._$endGap);
  };
  _no_name_provided__3_4.$metadata$ = {
    simpleName: '<no name provided>_3',
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__3_5($newReadPosition) {
    this._$newReadPosition = $newReadPosition;
    RequireFailureCapture.call(this);
  }
  _no_name_provided__3_5.prototype.doFail_4_13 = function () {
    throw IllegalArgumentException_init_$Create$_0('' + "newReadPosition shouldn't be negative: " + this._$newReadPosition);
  };
  _no_name_provided__3_5.$metadata$ = {
    simpleName: '<no name provided>_3',
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__3_6($newReadPosition, this$0) {
    this._$newReadPosition_0 = $newReadPosition;
    this._this$0_29 = this$0;
    RequireFailureCapture.call(this);
  }
  _no_name_provided__3_6.prototype.doFail_4_13 = function () {
    throw IllegalArgumentException_init_$Create$_0('' + "newReadPosition shouldn't be ahead of the read position: " + this._$newReadPosition_0 + ' > ' + this._this$0_29._get_readPosition__1());
  };
  _no_name_provided__3_6.$metadata$ = {
    simpleName: '<no name provided>_3',
    kind: 'class',
    interfaces: []
  };
  function Buffer(memory) {
    Companion_getInstance_33();
    this._memory = memory;
    var tmp = this;
    var tmp0__get_size32__0 = this._memory;
    tmp._bufferState = new BufferSharedState(tmp0__get_size32__0._view.byteLength);
    var tmp_0 = this;
    var tmp0__get_size32__0_0 = this._memory;
    tmp_0._capacity_0 = tmp0__get_size32__0_0._view.byteLength;
  }
  Buffer.prototype._get_memory__1 = function () {
    return this._memory;
  };
  Buffer.prototype._get_readPosition__1 = function () {
    return this._bufferState._readPosition;
  };
  Buffer.prototype._get_writePosition__1 = function () {
    return this._bufferState._writePosition;
  };
  Buffer.prototype._get_startGap__1 = function () {
    return this._bufferState._startGap;
  };
  Buffer.prototype._get_limit__1 = function () {
    return this._bufferState._limit_4;
  };
  Buffer.prototype._get_capacity__1 = function () {
    return this._capacity_0;
  };
  Buffer.prototype._set_attachment__1 = function (value) {
    this._bufferState._attachment = value;
  };
  Buffer.prototype.discardExact_5 = function (count_0) {
    if (count_0 === 0)
      return Unit_getInstance();
    var newReadPosition = this._get_readPosition__1() + count_0 | 0;
    if (count_0 < 0 ? true : newReadPosition > this._get_writePosition__1()) {
      discardFailed(count_0, this._get_writePosition__1() - this._get_readPosition__1() | 0);
    }_set_readPosition_(this, newReadPosition);
  };
  Buffer.prototype.discard_9 = function (count_0) {
    var tmp0_minOf_0 = toLong_0(this._get_writePosition__1() - this._get_readPosition__1() | 0);
    var size_0 = (count_0.compareTo_69(tmp0_minOf_0) <= 0 ? count_0 : tmp0_minOf_0).toInt_5();
    this.discardExact_5(size_0);
    return toLong_0(size_0);
  };
  Buffer.prototype.commitWritten_1 = function (count_0) {
    var newWritePosition = this._get_writePosition__1() + count_0 | 0;
    if (count_0 < 0 ? true : newWritePosition > this._get_limit__1()) {
      commitWrittenFailed(count_0, this._get_limit__1() - this._get_writePosition__1() | 0);
    }_set_writePosition_(this, newWritePosition);
  };
  Buffer.prototype.commitWrittenUntilIndex_1 = function (position) {
    var limit = this._get_limit__1();
    if (position < this._get_writePosition__1()) {
      var tmp = position - this._get_writePosition__1() | 0;
      commitWrittenFailed(tmp, this._get_limit__1() - this._get_writePosition__1() | 0);
    }if (position >= limit) {
      if (position === limit) {
        _set_writePosition_(this, position);
        return false;
      }var tmp_0 = position - this._get_writePosition__1() | 0;
      commitWrittenFailed(tmp_0, this._get_limit__1() - this._get_writePosition__1() | 0);
    }_set_writePosition_(this, position);
    return true;
  };
  Buffer.prototype.discardUntilIndex_1 = function (position) {
    if (position < 0 ? true : position > this._get_writePosition__1()) {
      var tmp = position - this._get_readPosition__1() | 0;
      discardFailed(tmp, this._get_writePosition__1() - this._get_readPosition__1() | 0);
    }if (!(this._get_readPosition__1() === position)) {
      _set_readPosition_(this, position);
    }};
  Buffer.prototype.rewind_1 = function (count_0) {
    var newReadPosition = this._get_readPosition__1() - count_0 | 0;
    if (newReadPosition < this._get_startGap__1()) {
      rewindFailed(count_0, this._get_readPosition__1() - this._get_startGap__1() | 0);
    }_set_readPosition_(this, newReadPosition);
  };
  Buffer.prototype.reserveStartGap_1 = function (startGap) {
    var tmp0_require_0 = startGap >= 0;
    if (!tmp0_require_0) {
      var m_2 = new _no_name_provided__3_3(startGap);
      m_2.doFail_4_13();
    }if (this._get_readPosition__1() >= startGap) {
      _set_startGap_(this, startGap);
      return Unit_getInstance();
    }if (this._get_readPosition__1() === this._get_writePosition__1()) {
      if (startGap > this._get_limit__1()) {
        startGapReservationFailedDueToLimit(this, startGap);
      }_set_writePosition_(this, startGap);
      _set_readPosition_(this, startGap);
      _set_startGap_(this, startGap);
      return Unit_getInstance();
    }startGapReservationFailed(this, startGap);
  };
  Buffer.prototype.reserveEndGap_1 = function (endGap) {
    var tmp0_require_0 = endGap >= 0;
    if (!tmp0_require_0) {
      var m_2 = new _no_name_provided__3_4(endGap);
      m_2.doFail_4_13();
    }var newLimit = this._capacity_0 - endGap | 0;
    if (newLimit >= this._get_writePosition__1()) {
      _set_limit_(this, newLimit);
      return Unit_getInstance();
    }if (newLimit < 0) {
      endGapReservationFailedDueToCapacity(this, endGap);
    }if (newLimit < this._get_startGap__1()) {
      endGapReservationFailedDueToStartGap(this, endGap);
    }if (this._get_readPosition__1() === this._get_writePosition__1()) {
      _set_limit_(this, newLimit);
      _set_readPosition_(this, newLimit);
      _set_writePosition_(this, newLimit);
      return Unit_getInstance();
    }endGapReservationFailedDueToContent(this, endGap);
  };
  Buffer.prototype.resetForRead_0 = function () {
    _set_startGap_(this, 0);
    _set_readPosition_(this, 0);
    var capacity = this._capacity_0;
    _set_writePosition_(this, capacity);
  };
  Buffer.prototype.resetForWrite_3 = function () {
    this.resetForWrite_4(this._capacity_0 - this._get_startGap__1() | 0);
  };
  Buffer.prototype.resetForWrite_4 = function (limit) {
    var startGap = this._get_startGap__1();
    _set_readPosition_(this, startGap);
    _set_writePosition_(this, startGap);
    _set_limit_(this, limit);
  };
  Buffer.prototype.releaseGaps_1 = function () {
    this.releaseStartGap_1(0);
    this.releaseEndGap_1();
  };
  Buffer.prototype.releaseEndGap_1 = function () {
    _set_limit_(this, this._capacity_0);
  };
  Buffer.prototype.releaseStartGap_1 = function (newReadPosition) {
    var tmp0_require_0 = newReadPosition >= 0;
    if (!tmp0_require_0) {
      var m_2 = new _no_name_provided__3_5(newReadPosition);
      m_2.doFail_4_13();
    }var tmp1_require_0 = newReadPosition <= this._get_readPosition__1();
    if (!tmp1_require_0) {
      var m_2_0 = new _no_name_provided__3_6(newReadPosition, this);
      m_2_0.doFail_4_13();
    }_set_readPosition_(this, newReadPosition);
    if (this._get_startGap__1() > newReadPosition) {
      _set_startGap_(this, newReadPosition);
    }};
  Buffer.prototype.duplicateTo_1 = function (copy) {
    _set_limit_(copy, this._get_limit__1());
    _set_startGap_(copy, this._get_startGap__1());
    _set_readPosition_(copy, this._get_readPosition__1());
    _set_writePosition_(copy, this._get_writePosition__1());
  };
  Buffer.prototype.readByte_1 = function () {
    var readPosition = this._get_readPosition__1();
    if (readPosition === this._get_writePosition__1()) {
      throw new EOFException('No readable bytes available.');
    }_set_readPosition_(this, readPosition + 1 | 0);
    var tmp0_get_0 = this._memory;
    return tmp0_get_0._view.getInt8(readPosition);
  };
  Buffer.prototype.writeByte_6 = function (value) {
    var writePosition = this._get_writePosition__1();
    if (writePosition === this._get_limit__1()) {
      throw new InsufficientSpaceException('No free space in the buffer to write a byte');
    }var tmp0_set_0 = this._memory;
    tmp0_set_0._view.setInt8(writePosition, value);
    _set_writePosition_(this, writePosition + 1 | 0);
  };
  Buffer.prototype.reset_2 = function () {
    this.releaseGaps_1();
    this.resetForWrite_3();
  };
  Buffer.prototype.toString = function () {
    var tmp = this._get_writePosition__1() - this._get_readPosition__1() | 0;
    var tmp_0 = this._get_limit__1() - this._get_writePosition__1() | 0;
    var tmp_1 = this._get_startGap__1();
    return '' + 'Buffer(' + tmp + ' used, ' + tmp_0 + ' free, ' + (tmp_1 + (this._capacity_0 - this._get_limit__1() | 0) | 0) + ' reserved of ' + this._capacity_0 + ')';
  };
  Buffer.$metadata$ = {
    simpleName: 'Buffer',
    kind: 'class',
    interfaces: []
  };
  function InsufficientSpaceException_init_$Init$(name, size_0, availableSpace, $this) {
    InsufficientSpaceException.call($this, '' + 'Not enough free space to write ' + name + ' of ' + size_0 + ' bytes, available ' + availableSpace + ' bytes.');
    return $this;
  }
  function InsufficientSpaceException_init_$Create$(name, size_0, availableSpace) {
    var tmp = InsufficientSpaceException_init_$Init$(name, size_0, availableSpace, Object.create(InsufficientSpaceException.prototype));
    captureStack(tmp, InsufficientSpaceException_init_$Create$);
    return tmp;
  }
  function InsufficientSpaceException(message) {
    Exception_init_$Init$_0(message, this);
    captureStack(this, InsufficientSpaceException);
  }
  InsufficientSpaceException.$metadata$ = {
    simpleName: 'InsufficientSpaceException',
    kind: 'class',
    interfaces: []
  };
  function discardFailed(count_0, readRemaining_1) {
    throw new EOFException('' + 'Unable to discard ' + count_0 + ' bytes: only ' + readRemaining_1 + ' available for reading');
  }
  function commitWrittenFailed(count_0, writeRemaining) {
    throw new EOFException('' + 'Unable to discard ' + count_0 + ' bytes: only ' + writeRemaining + ' available for writing');
  }
  function rewindFailed(count_0, rewindRemaining) {
    throw IllegalArgumentException_init_$Create$_0('' + 'Unable to rewind ' + count_0 + ' bytes: only ' + rewindRemaining + ' could be rewinded');
  }
  function startGapReservationFailedDueToLimit(_this_, startGap) {
    if (startGap > _this_._capacity_0) {
      throw IllegalArgumentException_init_$Create$_0('' + 'Start gap ' + startGap + ' is bigger than the capacity ' + _this_._capacity_0);
    }throw IllegalStateException_init_$Create$('' + 'Unable to reserve ' + startGap + ' start gap: there are already ' + (_this_._capacity_0 - _this_._get_limit__1() | 0) + ' bytes reserved in the end');
  }
  function startGapReservationFailed(_this_, startGap) {
    var tmp = '' + 'Unable to reserve ' + startGap + ' start gap: ';
    throw IllegalStateException_init_$Create$(tmp + ('' + 'there are already ' + (_this_._get_writePosition__1() - _this_._get_readPosition__1() | 0) + ' content bytes starting at offset ' + _this_._get_readPosition__1()));
  }
  function endGapReservationFailedDueToCapacity(_this_, endGap) {
    throw IllegalArgumentException_init_$Create$_0('' + 'End gap ' + endGap + ' is too big: capacity is ' + _this_._capacity_0);
  }
  function endGapReservationFailedDueToStartGap(_this_, endGap) {
    throw IllegalArgumentException_init_$Create$_0('' + 'End gap ' + endGap + ' is too big: there are already ' + _this_._get_startGap__1() + ' bytes reserved in the beginning');
  }
  function endGapReservationFailedDueToContent(_this_, endGap) {
    var tmp = '' + 'Unable to reserve end gap ' + endGap + ':';
    throw IllegalArgumentException_init_$Create$_0(tmp + ('' + ' there are already ' + (_this_._get_writePosition__1() - _this_._get_readPosition__1() | 0) + ' content bytes at offset ' + _this_._get_readPosition__1()));
  }
  function restoreStartGap(_this_, size_0) {
    _this_.releaseStartGap_1(_this_._get_readPosition__1() - size_0 | 0);
  }
  function writeBufferAppend(_this_, other, maxSize) {
    var tmp0_minOf_0 = other._get_writePosition__1() - other._get_readPosition__1() | 0;
    var size_0 = function () {
      var $externalVarargReceiverTmp = Math;
      return $externalVarargReceiverTmp.min.apply($externalVarargReceiverTmp, [].concat([].slice.call(new Int32Array([tmp0_minOf_0, maxSize]))));
    }.call(this);
    if ((_this_._get_limit__1() - _this_._get_writePosition__1() | 0) <= size_0) {
      writeBufferAppendUnreserve(_this_, size_0);
    } else {
    }
    var tmp1__anonymous__2 = _this_._memory;
    var tmp2__anonymous__2 = _this_._get_writePosition__1();
    var tmp3__anonymous__2 = _this_._get_limit__1();
    var tmp0__anonymous__2_4 = other._memory;
    var tmp1__anonymous__2_5 = other._get_readPosition__1();
    var tmp2__anonymous__2_6 = other._get_writePosition__1();
    tmp0__anonymous__2_4.copyTo(tmp1__anonymous__2, tmp1__anonymous__2_5, size_0, tmp2__anonymous__2);
    var rc_1_3 = size_0;
    other.discardExact_5(rc_1_3);
    var rc_1 = rc_1_3;
    _this_.commitWritten_1(rc_1);
    return rc_1;
  }
  function writeBufferPrepend(_this_, other) {
    var size_0 = other._get_writePosition__1() - other._get_readPosition__1() | 0;
    var readPosition = _this_._get_readPosition__1();
    if (readPosition < size_0) {
      throw IllegalArgumentException_init_$Create$_0('Not enough space in the beginning to prepend bytes');
    }var newReadPosition = readPosition - size_0 | 0;
    other._memory.copyTo(_this_._memory, other._get_readPosition__1(), size_0, newReadPosition);
    other.discardExact_5(size_0);
    _this_.releaseStartGap_1(newReadPosition);
    return size_0;
  }
  function writeBufferAppendUnreserve(_this_, writeSize) {
    var tmp = _this_._get_limit__1() - _this_._get_writePosition__1() | 0;
    if ((tmp + (_this_._capacity_0 - _this_._get_limit__1() | 0) | 0) < writeSize) {
      throw IllegalArgumentException_init_$Create$_0("Can't append buffer: not enough free space at the end");
    } else {
    }
    var newWritePosition = _this_._get_writePosition__1() + writeSize | 0;
    var overrunSize = newWritePosition - _this_._get_limit__1() | 0;
    if (overrunSize > 0) {
      _this_.releaseEndGap_1();
    }}
  function appendChars(_this_, csq, start, end) {
    var charactersWritten;
    var tmp0__anonymous__2 = _this_._memory;
    var tmp1__anonymous__2 = _this_._get_writePosition__1();
    var tmp2__anonymous__2 = _this_._get_limit__1();
    var result_3 = encodeUTF8(tmp0__anonymous__2, csq, start, end, tmp1__anonymous__2, tmp2__anonymous__2);
    var tmp0__get_highShort__0_6 = _EncodeResult___get_value__impl_(result_3);
    var tmp1_toUShort_0_5 = toShort_0(tmp0__get_highShort__0_6 >>> 16);
    var tmp2_toInt_0_4 = _UShort___init__impl_(tmp1_toUShort_0_5);
    charactersWritten = _UShort___get_data__impl_(tmp2_toInt_0_4) & 65535;
    var tmp3__get_lowShort__0_9 = _EncodeResult___get_value__impl_(result_3);
    var tmp4_toUShort_0_8 = toShort_0(tmp3__get_lowShort__0_9 & 65535);
    var tmp5_toInt_0_7 = _UShort___init__impl_(tmp4_toUShort_0_8);
    var rc_1 = _UShort___get_data__impl_(tmp5_toInt_0_7) & 65535;
    _this_.commitWritten_1(rc_1);
    Unit_getInstance();
    return start + charactersWritten | 0;
  }
  function append_0(_this_, c) {
    var tmp0__anonymous__2 = _this_._memory;
    var tmp1__anonymous__2 = _this_._get_writePosition__1();
    var tmp2__anonymous__2 = _this_._get_limit__1();
    var tmp16_putUtf8Char_0_4 = c.toInt_5();
    var tmp;
    if (0 <= tmp16_putUtf8Char_0_4 ? tmp16_putUtf8Char_0_4 <= 127 : false) {
      var tmp0_storeAt_0_5 = toByte_0(tmp16_putUtf8Char_0_4);
      tmp0__anonymous__2._view.setInt8(tmp1__anonymous__2, tmp0_storeAt_0_5);
      tmp = 1;
    } else if (128 <= tmp16_putUtf8Char_0_4 ? tmp16_putUtf8Char_0_4 <= 2047 : false) {
      var tmp1_set_0_6 = toByte_0(192 | tmp16_putUtf8Char_0_4 >> 6 & 31);
      tmp0__anonymous__2._view.setInt8(tmp1__anonymous__2, tmp1_set_0_6);
      var tmp2_set_0_7 = tmp1__anonymous__2 + 1 | 0;
      var tmp3_set_0_8 = toByte_0(128 | tmp16_putUtf8Char_0_4 & 63);
      tmp0__anonymous__2._view.setInt8(tmp2_set_0_7, tmp3_set_0_8);
      tmp = 2;
    } else if (2048 <= tmp16_putUtf8Char_0_4 ? tmp16_putUtf8Char_0_4 <= 65535 : false) {
      var tmp4_set_0_9 = toByte_0(224 | tmp16_putUtf8Char_0_4 >> 12 & 15);
      tmp0__anonymous__2._view.setInt8(tmp1__anonymous__2, tmp4_set_0_9);
      var tmp5_set_0_10 = tmp1__anonymous__2 + 1 | 0;
      var tmp6_set_0_11 = toByte_0(128 | tmp16_putUtf8Char_0_4 >> 6 & 63);
      tmp0__anonymous__2._view.setInt8(tmp5_set_0_10, tmp6_set_0_11);
      var tmp7_set_0_12 = tmp1__anonymous__2 + 2 | 0;
      var tmp8_set_0_13 = toByte_0(128 | tmp16_putUtf8Char_0_4 & 63);
      tmp0__anonymous__2._view.setInt8(tmp7_set_0_12, tmp8_set_0_13);
      tmp = 3;
    } else if (65536 <= tmp16_putUtf8Char_0_4 ? tmp16_putUtf8Char_0_4 <= 1114111 : false) {
      var tmp9_set_0_14 = toByte_0(240 | tmp16_putUtf8Char_0_4 >> 18 & 7);
      tmp0__anonymous__2._view.setInt8(tmp1__anonymous__2, tmp9_set_0_14);
      var tmp10_set_0_15 = tmp1__anonymous__2 + 1 | 0;
      var tmp11_set_0_16 = toByte_0(128 | tmp16_putUtf8Char_0_4 >> 12 & 63);
      tmp0__anonymous__2._view.setInt8(tmp10_set_0_15, tmp11_set_0_16);
      var tmp12_set_0_17 = tmp1__anonymous__2 + 2 | 0;
      var tmp13_set_0_18 = toByte_0(128 | tmp16_putUtf8Char_0_4 >> 6 & 63);
      tmp0__anonymous__2._view.setInt8(tmp12_set_0_17, tmp13_set_0_18);
      var tmp14_set_0_19 = tmp1__anonymous__2 + 3 | 0;
      var tmp15_set_0_20 = toByte_0(128 | tmp16_putUtf8Char_0_4 & 63);
      tmp0__anonymous__2._view.setInt8(tmp14_set_0_19, tmp15_set_0_20);
      tmp = 4;
    } else {
      malformedCodePoint(tmp16_putUtf8Char_0_4);
    }
    var size_3 = tmp;
    var tmp_0;
    if (size_3 > (tmp2__anonymous__2 - tmp1__anonymous__2 | 0)) {
      appendFailed(1);
    } else {
      tmp_0 = size_3;
    }
    var rc_1 = tmp_0;
    _this_.commitWritten_1(rc_1);
    Unit_getInstance();
    return _this_;
  }
  function appendFailed(length) {
    throw new BufferLimitExceededException('' + 'Not enough free space available to write ' + length + ' character(s).');
  }
  var DefaultChunkedBufferPool;
  function DefaultBufferPool_init_$Init$(bufferSize, capacity, allocator, $mask0, $marker, $this) {
    if (!(($mask0 & 1) === 0))
      bufferSize = 4096;
    if (!(($mask0 & 2) === 0))
      capacity = 1000;
    if (!(($mask0 & 4) === 0))
      allocator = DefaultAllocator_getInstance();
    DefaultBufferPool.call($this, bufferSize, capacity, allocator);
    return $this;
  }
  function DefaultBufferPool_init_$Create$(bufferSize, capacity, allocator, $mask0, $marker) {
    return DefaultBufferPool_init_$Init$(bufferSize, capacity, allocator, $mask0, $marker, Object.create(DefaultBufferPool.prototype));
  }
  function DefaultBufferPool(bufferSize, capacity, allocator) {
    DefaultPool.call(this, capacity);
    this._bufferSize = bufferSize;
    this._allocator = allocator;
  }
  DefaultBufferPool.prototype.produceInstance_4 = function () {
    return new IoBuffer(this._allocator.alloc_0(this._bufferSize), null);
  };
  DefaultBufferPool.prototype.disposeInstance_1 = function (instance) {
    this._allocator.free_0(instance._get_memory__1());
    DefaultPool.prototype.disposeInstance_3.call(this, instance);
    instance.unlink_0();
  };
  DefaultBufferPool.prototype.disposeInstance_3 = function (instance) {
    return this.disposeInstance_1(instance instanceof IoBuffer ? instance : THROW_CCE());
  };
  DefaultBufferPool.prototype.validateInstance_1 = function (instance) {
    DefaultPool.prototype.validateInstance_3.call(this, instance);
    if (instance === Companion_getInstance_41()._Empty_1) {
      var tmp0_error_0 = "IoBuffer.Empty couldn't be recycled";
      throw IllegalStateException_init_$Create$(toString_1(tmp0_error_0));
    }var tmp1_check_0 = !(instance === Companion_getInstance_41()._Empty_1);
    if (!tmp1_check_0) {
      var message_1 = "Empty instance couldn't be recycled";
      throw IllegalStateException_init_$Create$(toString_1(message_1));
    }var tmp2_check_0 = !(instance === Companion_getInstance_33()._get_Empty__1());
    if (!tmp2_check_0) {
      var message_1_0 = "Empty instance couldn't be recycled";
      throw IllegalStateException_init_$Create$(toString_1(message_1_0));
    }var tmp3_check_0 = !(instance === Companion_getInstance_36()._get_Empty__1());
    if (!tmp3_check_0) {
      var message_1_1 = "Empty instance couldn't be recycled";
      throw IllegalStateException_init_$Create$(toString_1(message_1_1));
    }var tmp4_check_0 = instance._get_referenceCount__0() === 0;
    if (!tmp4_check_0) {
      var message_1_2 = 'Unable to clear buffer: it is still in use.';
      throw IllegalStateException_init_$Create$(toString_1(message_1_2));
    }var tmp5_check_0 = instance._get_next__1() == null;
    if (!tmp5_check_0) {
      var message_1_3 = "Recycled instance shouldn't be a part of a chain.";
      throw IllegalStateException_init_$Create$(toString_1(message_1_3));
    }var tmp6_check_0 = instance._get_origin__0() == null;
    if (!tmp6_check_0) {
      var message_1_4 = "Recycled instance shouldn't be a view or another buffer.";
      throw IllegalStateException_init_$Create$(toString_1(message_1_4));
    }};
  DefaultBufferPool.prototype.validateInstance_3 = function (instance) {
    return this.validateInstance_1(instance instanceof IoBuffer ? instance : THROW_CCE());
  };
  DefaultBufferPool.prototype.clearInstance_1 = function (instance) {
    var tmp0_apply_0 = DefaultPool.prototype.clearInstance_5.call(this, instance);
    tmp0_apply_0.unpark_0();
    tmp0_apply_0.reset_2();
    return tmp0_apply_0;
  };
  DefaultBufferPool.prototype.clearInstance_5 = function (instance) {
    return this.clearInstance_1(instance instanceof IoBuffer ? instance : THROW_CCE());
  };
  DefaultBufferPool.$metadata$ = {
    simpleName: 'DefaultBufferPool',
    kind: 'class',
    interfaces: []
  };
  function readFully(_this_, dst, length) {
    var tmp0_require_0 = length >= 0;
    if (!tmp0_require_0) {
      var message_1_1 = 'Failed requirement.';
      throw IllegalArgumentException_init_$Create$_0(toString_1(message_1_1));
    }var tmp1_require_0 = length <= (dst._get_limit__1() - dst._get_writePosition__1() | 0);
    if (!tmp1_require_0) {
      var message_1_1_0 = 'Failed requirement.';
      throw IllegalArgumentException_init_$Create$_0(toString_1(message_1_1_0));
    }var tmp5_readExact_0 = 'buffer content';
    var value_2;
    var tmp2__anonymous__3_2 = _this_._memory;
    var tmp3__anonymous__3_2 = _this_._get_readPosition__1();
    var tmp4__anonymous__3_2 = _this_._get_writePosition__1();
    var tmp0_require_0_3 = (tmp4__anonymous__3_2 - tmp3__anonymous__3_2 | 0) >= length;
    if (!tmp0_require_0_3) {
      var m_2_4 = new _no_name_provided__3_5_0(tmp5_readExact_0, length);
      m_2_4.doFail_4_6_1();
    }tmp2__anonymous__3_2.copyTo(dst._memory, tmp3__anonymous__3_2, length, dst._get_writePosition__1());
    value_2 = dst.commitWritten_1(length);
    var rc_1 = length;
    _this_.discardExact_5(rc_1);
    Unit_getInstance();
    return length;
  }
  function writeFully_0(_this_, source, offset, length) {
    var tmp3_writeExact_0 = 'byte array';
    var tmp0__anonymous__2_2 = _this_._memory;
    var tmp1__anonymous__2_2 = _this_._get_writePosition__1();
    var tmp2__anonymous__2_2 = _this_._get_limit__1();
    var writeRemaining_3_3 = tmp2__anonymous__2_2 - tmp1__anonymous__2_2 | 0;
    if (writeRemaining_3_3 < length) {
      throw InsufficientSpaceException_init_$Create$(tmp3_writeExact_0, length, writeRemaining_3_3);
    }var tmp0_let_0_1_5 = of(Companion_getInstance_38(), source, offset, length);
    tmp0_let_0_1_5.copyTo(tmp0__anonymous__2_2, 0, length, tmp1__anonymous__2_2);
    var rc_1 = length;
    _this_.commitWritten_1(rc_1);
    Unit_getInstance();
  }
  function readShort(_this_) {
    var tmp3_readExact_0 = 2;
    var tmp4_readExact_0 = 'short integer';
    var value_2;
    var tmp0__anonymous__3_2 = _this_._memory;
    var tmp1__anonymous__3_2 = _this_._get_readPosition__1();
    var tmp2__anonymous__3_2 = _this_._get_writePosition__1();
    var tmp0_require_0_3 = (tmp2__anonymous__3_2 - tmp1__anonymous__3_2 | 0) >= tmp3_readExact_0;
    if (!tmp0_require_0_3) {
      var m_2_4 = new _no_name_provided__3_5_1(tmp4_readExact_0, tmp3_readExact_0);
      m_2_4.doFail_4_6_1();
    }value_2 = tmp0__anonymous__3_2._view.getInt16(tmp1__anonymous__3_2, false);
    var rc_1 = tmp3_readExact_0;
    _this_.discardExact_5(rc_1);
    Unit_getInstance();
    return value_2;
  }
  function readFully_0(_this_, destination, offset, length) {
    var tmp3_readExact_0 = 'byte array';
    var value_2;
    var tmp0__anonymous__3_2 = _this_._memory;
    var tmp1__anonymous__3_2 = _this_._get_readPosition__1();
    var tmp2__anonymous__3_2 = _this_._get_writePosition__1();
    var tmp0_require_0_3 = (tmp2__anonymous__3_2 - tmp1__anonymous__3_2 | 0) >= length;
    if (!tmp0_require_0_3) {
      var m_2_4 = new _no_name_provided__3_5_2(tmp3_readExact_0, length);
      m_2_4.doFail_4_6_1();
    }value_2 = copyTo_2(tmp0__anonymous__3_2, destination, tmp1__anonymous__3_2, length, offset);
    var rc_1 = length;
    _this_.discardExact_5(rc_1);
    Unit_getInstance();
  }
  function readFully$default(_this_, destination, offset, length, $mask0, $handler) {
    if (!(($mask0 & 2) === 0))
      offset = 0;
    if (!(($mask0 & 4) === 0))
      length = destination.length - offset | 0;
    return readFully_0(_this_, destination, offset, length);
  }
  function writeShort(_this_, value) {
    var tmp3_writeExact_0 = 2;
    var tmp4_writeExact_0 = 'short integer';
    var tmp0__anonymous__2_2 = _this_._memory;
    var tmp1__anonymous__2_2 = _this_._get_writePosition__1();
    var tmp2__anonymous__2_2 = _this_._get_limit__1();
    var writeRemaining_3_3 = tmp2__anonymous__2_2 - tmp1__anonymous__2_2 | 0;
    if (writeRemaining_3_3 < tmp3_writeExact_0) {
      throw InsufficientSpaceException_init_$Create$(tmp4_writeExact_0, tmp3_writeExact_0, writeRemaining_3_3);
    }tmp0__anonymous__2_2._view.setInt16(tmp1__anonymous__2_2, value, false);
    var rc_1 = tmp3_writeExact_0;
    _this_.commitWritten_1(rc_1);
    return Unit_getInstance();
  }
  function writeFully_1(_this_, src, length) {
    var tmp0_require_0 = length >= 0;
    if (!tmp0_require_0) {
      var m_2 = new _no_name_provided__3_7(length);
      m_2.doFail_4_13();
    }var tmp1_require_0 = length <= (src._get_writePosition__1() - src._get_readPosition__1() | 0);
    if (!tmp1_require_0) {
      var m_2_0 = new _no_name_provided__3_8(length, src);
      m_2_0.doFail_4_13();
    }var tmp2_require_0 = length <= (_this_._get_limit__1() - _this_._get_writePosition__1() | 0);
    if (!tmp2_require_0) {
      var m_2_1 = new _no_name_provided__3_9(length, _this_);
      m_2_1.doFail_4_13();
    }var tmp6_writeExact_0 = 'buffer readable content';
    var tmp3__anonymous__2_2 = _this_._memory;
    var tmp4__anonymous__2_2 = _this_._get_writePosition__1();
    var tmp5__anonymous__2_2 = _this_._get_limit__1();
    var writeRemaining_3_3 = tmp5__anonymous__2_2 - tmp4__anonymous__2_2 | 0;
    if (writeRemaining_3_3 < length) {
      throw InsufficientSpaceException_init_$Create$(tmp6_writeExact_0, length, writeRemaining_3_3);
    }src._memory.copyTo(tmp3__anonymous__2_2, src._get_readPosition__1(), length, tmp4__anonymous__2_2);
    src.discardExact_5(length);
    var rc_1 = length;
    _this_.commitWritten_1(rc_1);
    Unit_getInstance();
  }
  function _no_name_provided__3_5_0($tmp5_readExact_0, $length) {
    this._$tmp5_readExact_0 = $tmp5_readExact_0;
    this._$length = $length;
    RequireFailureCapture.call(this);
  }
  _no_name_provided__3_5_0.prototype.doFail_4_6_1 = function () {
    throw new EOFException('' + 'Not enough bytes to read a ' + this._$tmp5_readExact_0 + ' of size ' + this._$length + '.');
  };
  _no_name_provided__3_5_0.$metadata$ = {
    simpleName: '<no name provided>_3_5',
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__3_5_1($tmp4_readExact_0, $tmp3_readExact_0) {
    this._$tmp4_readExact_0 = $tmp4_readExact_0;
    this._$tmp3_readExact_0 = $tmp3_readExact_0;
    RequireFailureCapture.call(this);
  }
  _no_name_provided__3_5_1.prototype.doFail_4_6_1 = function () {
    throw new EOFException('' + 'Not enough bytes to read a ' + this._$tmp4_readExact_0 + ' of size ' + this._$tmp3_readExact_0 + '.');
  };
  _no_name_provided__3_5_1.$metadata$ = {
    simpleName: '<no name provided>_3_5',
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__3_5_2($tmp3_readExact_0, $length) {
    this._$tmp3_readExact_0_0 = $tmp3_readExact_0;
    this._$length_0 = $length;
    RequireFailureCapture.call(this);
  }
  _no_name_provided__3_5_2.prototype.doFail_4_6_1 = function () {
    throw new EOFException('' + 'Not enough bytes to read a ' + this._$tmp3_readExact_0_0 + ' of size ' + this._$length_0 + '.');
  };
  _no_name_provided__3_5_2.$metadata$ = {
    simpleName: '<no name provided>_3_5',
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__3_7($length) {
    this._$length_1 = $length;
    RequireFailureCapture.call(this);
  }
  _no_name_provided__3_7.prototype.doFail_4_13 = function () {
    throw IllegalArgumentException_init_$Create$_0('' + "length shouldn't be negative: " + this._$length_1);
  };
  _no_name_provided__3_7.$metadata$ = {
    simpleName: '<no name provided>_3',
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__3_8($length, $src) {
    this._$length_2 = $length;
    this._$src = $src;
    RequireFailureCapture.call(this);
  }
  _no_name_provided__3_8.prototype.doFail_4_13 = function () {
    throw IllegalArgumentException_init_$Create$_0('' + "length shouldn't be greater than the source read remaining: " + this._$length_2 + ' > ' + (this._$src._get_writePosition__1() - this._$src._get_readPosition__1() | 0));
  };
  _no_name_provided__3_8.$metadata$ = {
    simpleName: '<no name provided>_3',
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__3_9($length, $this_writeFully) {
    this._$length_3 = $length;
    this._$this_writeFully = $this_writeFully;
    RequireFailureCapture.call(this);
  }
  _no_name_provided__3_9.prototype.doFail_4_13 = function () {
    throw IllegalArgumentException_init_$Create$_0('' + "length shouldn't be greater than the destination write remaining space: " + this._$length_3 + ' > ' + (this._$this_writeFully._get_limit__1() - this._$this_writeFully._get_writePosition__1() | 0));
  };
  _no_name_provided__3_9.$metadata$ = {
    simpleName: '<no name provided>_3',
    kind: 'class',
    interfaces: []
  };
  function peekTo(_this_, destination, destinationOffset, offset, min, max) {
    var tmp0_minOf_0 = toLong_0(destination._view.byteLength).minus_29(destinationOffset);
    var tmp1_minOf_0 = toLong_0(_this_._get_writePosition__1() - _this_._get_readPosition__1() | 0);
    var tmp0_minOf_0_1 = max.compareTo_69(tmp1_minOf_0) <= 0 ? max : tmp1_minOf_0;
    var size_0 = tmp0_minOf_0.compareTo_69(tmp0_minOf_0_1) <= 0 ? tmp0_minOf_0 : tmp0_minOf_0_1;
    _this_._memory.copyTo_0(destination, numberToLong(_this_._get_readPosition__1()).plus_56(offset), size_0, destinationOffset);
    return size_0;
  }
  function EmptyBufferPoolImpl() {
    EmptyBufferPoolImpl_instance = this;
    NoPoolImpl.call(this);
  }
  EmptyBufferPoolImpl.prototype.borrow_12 = function () {
    return Companion_getInstance_41()._Empty_1;
  };
  EmptyBufferPoolImpl.$metadata$ = {
    simpleName: 'EmptyBufferPoolImpl',
    kind: 'object',
    interfaces: []
  };
  var EmptyBufferPoolImpl_instance;
  function EmptyBufferPoolImpl_getInstance() {
    if (EmptyBufferPoolImpl_instance == null)
      new EmptyBufferPoolImpl();
    return EmptyBufferPoolImpl_instance;
  }
  function BufferLimitExceededException(message) {
    Exception_init_$Init$_0(message, this);
    captureStack(this, BufferLimitExceededException);
  }
  BufferLimitExceededException.$metadata$ = {
    simpleName: 'BufferLimitExceededException',
    kind: 'class',
    interfaces: []
  };
  function releaseAll(_this_, pool) {
    var $this = _this_;
    var pool_0 = pool;
    while (true) {
      var $this_0 = $this;
      var pool_1 = pool_0;
      if ($this_0 == null)
        return Unit_getInstance();
      var next = $this_0.cleanNext_0();
      $this_0.release_7(pool_1);
      $this = next;
      pool_0 = pool_1;
      continue;
    }
  }
  function findTail(_this_) {
    var $this = _this_;
    while (true) {
      var $this_0 = $this;
      var tmp0_elvis_lhs = $this_0._get_next__1();
      var tmp;
      if (tmp0_elvis_lhs == null) {
        return $this_0;
      } else {
        tmp = tmp0_elvis_lhs;
      }
      var next = tmp;
      $this = next;
      continue;
    }
  }
  function remainingAll(_this_) {
    return remainingAll_0(_this_, new Long(0, 0));
  }
  function remainingAll_0(_this_, n) {
    var $this = _this_;
    var n_0 = n;
    while (true) {
      var $this_0 = $this;
      var n_1 = n_0;
      var rem = toLong_0($this_0._get_writePosition__1() - $this_0._get_readPosition__1() | 0).plus_56(n_1);
      var tmp0_elvis_lhs = $this_0._get_next__1();
      var tmp;
      if (tmp0_elvis_lhs == null) {
        return rem;
      } else {
        tmp = tmp0_elvis_lhs;
      }
      var next = tmp;
      $this = next;
      n_0 = rem;
      continue;
    }
  }
  function BytePacketBuilderPlatformBase(pool) {
    BytePacketBuilderBase.call(this, pool);
  }
  BytePacketBuilderPlatformBase.$metadata$ = {
    simpleName: 'BytePacketBuilderPlatformBase',
    kind: 'class',
    interfaces: []
  };
  function BytePacketBuilderBase(pool) {
    AbstractOutput_init_$Init$(pool, this);
  }
  BytePacketBuilderBase.$metadata$ = {
    simpleName: 'BytePacketBuilderBase',
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__3_10(this$0) {
    this._this$0_30 = this$0;
    RequireFailureCapture.call(this);
  }
  _no_name_provided__3_10.prototype.doFail_4_13 = function () {
    throw IllegalArgumentException_init_$Create$_0('' + "shouldn't be negative: headerSizeHint = " + this._this$0_30._headerSizeHint_1);
  };
  _no_name_provided__3_10.$metadata$ = {
    simpleName: '<no name provided>_3',
    kind: 'class',
    interfaces: []
  };
  function BytePacketBuilder(headerSizeHint, pool) {
    BytePacketBuilderPlatformBase.call(this, pool);
    this._headerSizeHint_1 = headerSizeHint;
    var tmp0_require_0 = this._headerSizeHint_1 >= 0;
    if (!tmp0_require_0) {
      var m_2 = new _no_name_provided__3_10(this);
      m_2.doFail_4_13();
    }}
  BytePacketBuilder.prototype._get_size__45 = function () {
    return this._get__size__0();
  };
  BytePacketBuilder.prototype._get_isEmpty__4 = function () {
    return this._get__size__0() === 0;
  };
  BytePacketBuilder.prototype.closeDestination_2 = function () {
  };
  BytePacketBuilder.prototype.flush_6 = function (source, offset, length) {
  };
  BytePacketBuilder.prototype.append_32 = function (c) {
    var tmp = BytePacketBuilderPlatformBase.prototype.append_32.call(this, c);
    return tmp instanceof BytePacketBuilder ? tmp : THROW_CCE();
  };
  BytePacketBuilder.prototype.append_31 = function (csq) {
    var tmp = BytePacketBuilderPlatformBase.prototype.append_31.call(this, csq);
    return tmp instanceof BytePacketBuilder ? tmp : THROW_CCE();
  };
  BytePacketBuilder.prototype.append_30 = function (csq, start, end) {
    var tmp = BytePacketBuilderPlatformBase.prototype.append_30.call(this, csq, start, end);
    return tmp instanceof BytePacketBuilder ? tmp : THROW_CCE();
  };
  BytePacketBuilder.prototype.build_16 = function () {
    var size_0 = this._get_size__45();
    var head = this.stealAll_4();
    var tmp0_subject = head;
    return tmp0_subject == null ? Companion_getInstance_34()._Empty : new ByteReadPacket(head, toLong_0(size_0), this._get_pool__2());
  };
  BytePacketBuilder.prototype.toString = function () {
    return '' + 'BytePacketBuilder(' + this._get_size__45() + ' bytes written)';
  };
  BytePacketBuilder.$metadata$ = {
    simpleName: 'BytePacketBuilder',
    kind: 'class',
    interfaces: []
  };
  function ByteReadPacket_init_$Init$(head, pool, $this) {
    ByteReadPacket.call($this, head, remainingAll(head), pool);
    return $this;
  }
  function ByteReadPacket_init_$Create$(head, pool) {
    return ByteReadPacket_init_$Init$(head, pool, Object.create(ByteReadPacket.prototype));
  }
  function Companion_35() {
    Companion_instance_34 = this;
    this._Empty = new ByteReadPacket(Companion_getInstance_36()._get_Empty__1(), new Long(0, 0), Companion_getInstance_36()._EmptyPool);
  }
  Companion_35.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_34;
  function Companion_getInstance_34() {
    if (Companion_instance_34 == null)
      new Companion_35();
    return Companion_instance_34;
  }
  function ByteReadPacket(head, remaining, pool) {
    Companion_getInstance_34();
    ByteReadPacketPlatformBase.call(this, head, remaining, pool);
    this.markNoMoreChunksAvailable_0();
  }
  ByteReadPacket.prototype.fill_7 = function () {
    return null;
  };
  ByteReadPacket.prototype.fill_6 = function (destination, offset, length) {
    return 0;
  };
  ByteReadPacket.prototype.closeSource_2 = function () {
  };
  ByteReadPacket.prototype.toString = function () {
    return '' + 'ByteReadPacket(' + this._get_remaining__2() + ' bytes remaining)';
  };
  ByteReadPacket.$metadata$ = {
    simpleName: 'ByteReadPacket',
    kind: 'class',
    interfaces: [Input]
  };
  function ByteReadPacketPlatformBase(head, remaining, pool) {
    ByteReadPacketBase.call(this, head, remaining, pool);
  }
  ByteReadPacketPlatformBase.$metadata$ = {
    simpleName: 'ByteReadPacketPlatformBase',
    kind: 'class',
    interfaces: []
  };
  function discardExact(_this_, n) {
    discardExact_0(_this_, toLong_0(n));
  }
  function discardExact_0(_this_, n) {
    var discarded = _this_.discard_9(n);
    if (!discarded.equals(n)) {
      throw IllegalStateException_init_$Create$('' + 'Only ' + discarded + ' bytes were discarded of ' + n + ' requested');
    }}
  function readFully_1(_this_, dst, offset, length) {
    var remaining_1 = length;
    var dstOffset_2 = offset;
    var tmp$ret$0;
    l$ret$1: do {
      var release_1 = true;
      var tmp0_elvis_lhs_3 = prepareReadFirstHead(_this_, 1);
      var tmp;
      if (tmp0_elvis_lhs_3 == null) {
        tmp$ret$0 = Unit_getInstance();
        break l$ret$1;
      } else {
        tmp = tmp0_elvis_lhs_3;
      }
      var current_2 = tmp;
      try {
        $l$break_0: do {
          var tmp0__anonymous__3_6 = current_2;
          var tmp0_minOf_0_8 = remaining_1;
          var tmp1_minOf_0_9 = tmp0__anonymous__3_6._get_writePosition__1() - tmp0__anonymous__3_6._get_readPosition__1() | 0;
          var count_4_7 = function () {
            var $externalVarargReceiverTmp = Math;
            return $externalVarargReceiverTmp.min.apply($externalVarargReceiverTmp, [].concat([].slice.call(new Int32Array([tmp0_minOf_0_8, tmp1_minOf_0_9]))));
          }.call(this);
          var tmp1__anonymous__5 = dstOffset_2;
          readFully_0(tmp0__anonymous__3_6, dst, tmp1__anonymous__5, count_4_7);
          remaining_1 = remaining_1 - count_4_7 | 0;
          dstOffset_2 = dstOffset_2 + count_4_7 | 0;
          if (!(remaining_1 > 0)) {
            break $l$break_0;
          } else {
          }
          release_1 = false;
          var tmp1_elvis_lhs_5 = prepareReadNextHead(_this_, current_2);
          var tmp_0;
          if (tmp1_elvis_lhs_5 == null) {
            break $l$break_0;
          } else {
            tmp_0 = tmp1_elvis_lhs_5;
          }
          var next_4 = tmp_0;
          current_2 = next_4;
          release_1 = true;
        }
         while (true);
      }finally {
        if (release_1) {
          completeReadHead(_this_, current_2);
        }}
    }
     while (false);
    var tmp2_requireNoRemaining_0 = remaining_1;
    if (tmp2_requireNoRemaining_0 > 0) {
      prematureEndOfStream(tmp2_requireNoRemaining_0);
    }}
  function readFully_2(_this_, dst, length) {
    var tmp1_readFullyBytesTemplate_0 = 0;
    var remaining_1 = length;
    var dstOffset_2 = tmp1_readFullyBytesTemplate_0;
    var tmp$ret$0;
    l$ret$1: do {
      var release_1 = true;
      var tmp0_elvis_lhs_3 = prepareReadFirstHead(_this_, 1);
      var tmp;
      if (tmp0_elvis_lhs_3 == null) {
        tmp$ret$0 = Unit_getInstance();
        break l$ret$1;
      } else {
        tmp = tmp0_elvis_lhs_3;
      }
      var current_2 = tmp;
      try {
        $l$break_0: do {
          var tmp0__anonymous__3_6 = current_2;
          var tmp0_minOf_0_8 = remaining_1;
          var tmp1_minOf_0_9 = tmp0__anonymous__3_6._get_writePosition__1() - tmp0__anonymous__3_6._get_readPosition__1() | 0;
          var count_4_7 = function () {
            var $externalVarargReceiverTmp = Math;
            return $externalVarargReceiverTmp.min.apply($externalVarargReceiverTmp, [].concat([].slice.call(new Int32Array([tmp0_minOf_0_8, tmp1_minOf_0_9]))));
          }.call(this);
          var tmp2__anonymous__5 = dstOffset_2;
          readFully(tmp0__anonymous__3_6, dst, count_4_7);
          Unit_getInstance();
          remaining_1 = remaining_1 - count_4_7 | 0;
          dstOffset_2 = dstOffset_2 + count_4_7 | 0;
          if (!(remaining_1 > 0)) {
            break $l$break_0;
          } else {
          }
          release_1 = false;
          var tmp1_elvis_lhs_5 = prepareReadNextHead(_this_, current_2);
          var tmp_0;
          if (tmp1_elvis_lhs_5 == null) {
            break $l$break_0;
          } else {
            tmp_0 = tmp1_elvis_lhs_5;
          }
          var next_4 = tmp_0;
          current_2 = next_4;
          release_1 = true;
        }
         while (true);
      }finally {
        if (release_1) {
          completeReadHead(_this_, current_2);
        }}
    }
     while (false);
    var tmp3_requireNoRemaining_0 = remaining_1;
    if (tmp3_requireNoRemaining_0 > 0) {
      prematureEndOfStream(tmp3_requireNoRemaining_0);
    }}
  function readAvailable(_this_, dst, offset, length) {
    var remaining_1 = length;
    var dstOffset_2 = offset;
    var tmp$ret$0;
    l$ret$1: do {
      var release_1 = true;
      var tmp0_elvis_lhs_3 = prepareReadFirstHead(_this_, 1);
      var tmp;
      if (tmp0_elvis_lhs_3 == null) {
        tmp$ret$0 = Unit_getInstance();
        break l$ret$1;
      } else {
        tmp = tmp0_elvis_lhs_3;
      }
      var current_2 = tmp;
      try {
        $l$break_0: do {
          var tmp0__anonymous__3_6 = current_2;
          var tmp0_minOf_0_8 = remaining_1;
          var tmp1_minOf_0_9 = tmp0__anonymous__3_6._get_writePosition__1() - tmp0__anonymous__3_6._get_readPosition__1() | 0;
          var count_4_7 = function () {
            var $externalVarargReceiverTmp = Math;
            return $externalVarargReceiverTmp.min.apply($externalVarargReceiverTmp, [].concat([].slice.call(new Int32Array([tmp0_minOf_0_8, tmp1_minOf_0_9]))));
          }.call(this);
          var tmp1__anonymous__5 = dstOffset_2;
          readFully_0(tmp0__anonymous__3_6, dst, tmp1__anonymous__5, count_4_7);
          remaining_1 = remaining_1 - count_4_7 | 0;
          dstOffset_2 = dstOffset_2 + count_4_7 | 0;
          if (!(remaining_1 > 0)) {
            break $l$break_0;
          } else {
          }
          release_1 = false;
          var tmp1_elvis_lhs_5 = prepareReadNextHead(_this_, current_2);
          var tmp_0;
          if (tmp1_elvis_lhs_5 == null) {
            break $l$break_0;
          } else {
            tmp_0 = tmp1_elvis_lhs_5;
          }
          var next_4 = tmp_0;
          current_2 = next_4;
          release_1 = true;
        }
         while (true);
      }finally {
        if (release_1) {
          completeReadHead(_this_, current_2);
        }}
    }
     while (false);
    return length - remaining_1 | 0;
  }
  function readAvailable$default(_this_, dst, offset, length, $mask0, $handler) {
    if (!(($mask0 & 2) === 0))
      offset = 0;
    if (!(($mask0 & 4) === 0))
      length = dst.length - offset | 0;
    return readAvailable(_this_, dst, offset, length);
  }
  function peekTo_0(_this_, destination, offset, min, max) {
    checkPeekTo(destination, offset, min, max);
    var tmp = toLong_0(destination._get_writePosition__1());
    var tmp_0 = toLong_0(offset);
    var tmp_1 = toLong_0(min);
    var copied = _this_.peekTo_4(destination._memory, tmp, tmp_0, tmp_1, toLong_0(coerceAtMost(max, destination._get_limit__1() - destination._get_writePosition__1() | 0))).toInt_5();
    destination.commitWritten_1(copied);
    return copied;
  }
  function peekTo$default(_this_, destination, offset, min, max, $mask0, $handler) {
    if (!(($mask0 & 2) === 0))
      offset = 0;
    if (!(($mask0 & 4) === 0))
      min = 1;
    if (!(($mask0 & 8) === 0))
      max = IntCompanionObject_getInstance()._MAX_VALUE_5;
    return peekTo_0(_this_, destination, offset, min, max);
  }
  function readShort_0(_this_) {
    var tmp$ret$0;
    l$ret$1: do {
      var tmp1_readPrimitive_0 = 2;
      var tmp;
      if (_this_ instanceof AbstractInput) {
        var tmp0__get_headRemaining__0 = _this_;
        tmp = (tmp0__get_headRemaining__0._get_headEndExclusive__2() - tmp0__get_headRemaining__0._get_headPosition__2() | 0) > tmp1_readPrimitive_0;
      } else {
        {
          tmp = false;
        }
      }
      if (tmp) {
        var index_1 = _this_._get_headPosition__2();
        _this_._set_headPosition__2(index_1 + tmp1_readPrimitive_0 | 0);
        var tmp2__anonymous__2 = _this_._get_headMemory__2();
        tmp$ret$0 = tmp2__anonymous__2._view.getInt16(index_1, false);
        break l$ret$1;
      } else {
      }
      tmp$ret$0 = readShortFallback(_this_);
    }
     while (false);
    return tmp$ret$0;
  }
  function readShortFallback(_this_) {
    var tmp0_readPrimitiveFallback_0 = 2;
    var tmp0_elvis_lhs_2 = prepareReadFirstHead(_this_, tmp0_readPrimitiveFallback_0);
    var tmp;
    if (tmp0_elvis_lhs_2 == null) {
      prematureEndOfStream(tmp0_readPrimitiveFallback_0);
    } else {
      tmp = tmp0_elvis_lhs_2;
    }
    var head_1 = tmp;
    var value_3 = readShort(head_1);
    completeReadHead(_this_, head_1);
    return value_3;
  }
  function writeFully_2(_this_, src, offset, length) {
    var currentOffset_1 = offset;
    var remaining_2 = length;
    var tail_1 = prepareWriteHead(_this_, 1, null);
    try {
      $l$break: while (true) {
        var tmp0__anonymous__3_2 = tail_1;
        var tmp0_minOf_0_4 = remaining_2;
        var tmp1_minOf_0_5 = tmp0__anonymous__3_2._get_limit__1() - tmp0__anonymous__3_2._get_writePosition__1() | 0;
        var size_4_3 = function () {
          var $externalVarargReceiverTmp = Math;
          return $externalVarargReceiverTmp.min.apply($externalVarargReceiverTmp, [].concat([].slice.call(new Int32Array([tmp0_minOf_0_4, tmp1_minOf_0_5]))));
        }.call(this);
        var tmp1__anonymous__5 = currentOffset_1;
        writeFully_0(tmp0__anonymous__3_2, src, tmp1__anonymous__5, size_4_3);
        currentOffset_1 = currentOffset_1 + size_4_3 | 0;
        remaining_2 = remaining_2 - size_4_3 | 0;
        if (!(remaining_2 > 0))
          break $l$break;
        else {
        }
        tail_1 = prepareWriteHead(_this_, 1, tail_1);
      }
    }finally {
      afterHeadWrite(_this_, tail_1);
    }
  }
  function writeFully$default(_this_, src, offset, length, $mask0, $handler) {
    if (!(($mask0 & 2) === 0))
      offset = 0;
    if (!(($mask0 & 4) === 0))
      length = src.length - offset | 0;
    return writeFully_2(_this_, src, offset, length);
  }
  function writeFully_3(_this_, src, length) {
    var tmp1_writeFullyBytesTemplate_0 = 0;
    var currentOffset_1 = tmp1_writeFullyBytesTemplate_0;
    var remaining_2 = length;
    var tail_1 = prepareWriteHead(_this_, 1, null);
    try {
      $l$break: while (true) {
        var tmp0__anonymous__3_2 = tail_1;
        var tmp0_minOf_0_4 = remaining_2;
        var tmp1_minOf_0_5 = tmp0__anonymous__3_2._get_limit__1() - tmp0__anonymous__3_2._get_writePosition__1() | 0;
        var size_4_3 = function () {
          var $externalVarargReceiverTmp = Math;
          return $externalVarargReceiverTmp.min.apply($externalVarargReceiverTmp, [].concat([].slice.call(new Int32Array([tmp0_minOf_0_4, tmp1_minOf_0_5]))));
        }.call(this);
        var tmp2__anonymous__5 = currentOffset_1;
        writeFully_1(tmp0__anonymous__3_2, src, size_4_3);
        currentOffset_1 = currentOffset_1 + size_4_3 | 0;
        remaining_2 = remaining_2 - size_4_3 | 0;
        if (!(remaining_2 > 0))
          break $l$break;
        else {
        }
        tail_1 = prepareWriteHead(_this_, 1, tail_1);
      }
    }finally {
      afterHeadWrite(_this_, tail_1);
    }
  }
  function writeFully$default_0(_this_, src, length, $mask0, $handler) {
    if (!(($mask0 & 2) === 0)) {
      length = src._get_writePosition__1() - src._get_readPosition__1() | 0;
    }return writeFully_3(_this_, src, length);
  }
  function writeShort_0(_this_, value) {
    var tmp$ret$0;
    l$ret$1: do {
      var tmp0_writePrimitiveTemplate_0 = 2;
      if (_this_ instanceof AbstractOutput) {
        var index_1 = _this_._get_tailPosition__2();
        if ((_this_._get_tailEndExclusive__2() - index_1 | 0) > tmp0_writePrimitiveTemplate_0) {
          _this_._set_tailPosition__2(index_1 + tmp0_writePrimitiveTemplate_0 | 0);
          var tmp1__anonymous__2 = _this_._get_tailMemory__2();
          tmp1__anonymous__2._view.setInt16(index_1, value, false);
          tmp$ret$0 = true;
          break l$ret$1;
        }} else {
      }
      tmp$ret$0 = false;
    }
     while (false);
    if (!tmp$ret$0) {
      writeShortFallback(_this_, value);
    } else {
    }
  }
  function writeShortFallback(_this_, value) {
    var tmp$ret$0;
    l$ret$1: do {
      var tmp0_writePrimitiveFallbackTemplate_0 = 2;
      if (_this_ instanceof AbstractOutput) {
        var tail_1 = _this_.prepareWriteHead_2(tmp0_writePrimitiveFallbackTemplate_0);
        writeShort(tail_1, value);
        _this_.afterHeadWrite_2();
        tmp$ret$0 = true;
        break l$ret$1;
      } else {
      }
      tmp$ret$0 = false;
    }
     while (false);
    if (!tmp$ret$0) {
      _this_.writeByte_6(toByte_0(value >>> 8));
      _this_.writeByte_6(toByte_0(value & 255));
    } else {
    }
  }
  function Companion_36() {
    Companion_instance_35 = this;
  }
  Companion_36.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_35;
  function Companion_getInstance_35() {
    if (Companion_instance_35 == null)
      new Companion_36();
    return Companion_instance_35;
  }
  function ByteReadPacketBase(head, remaining, pool) {
    Companion_getInstance_35();
    AbstractInput.call(this, head, remaining, pool);
  }
  ByteReadPacketBase.$metadata$ = {
    simpleName: 'ByteReadPacketBase',
    kind: 'class',
    interfaces: []
  };
  function prematureEndOfStream(size_0) {
    throw new EOFException('' + 'Premature end of stream: expected ' + size_0 + ' bytes');
  }
  function writeText(_this_, text, fromIndex, toIndex, charset_1) {
    if (charset_1 === Charsets_getInstance()._UTF_8) {
      return writeTextUtf8(_this_, text, fromIndex, toIndex);
    }encodeToImpl(charset_1.newEncoder_0(), _this_, text, fromIndex, toIndex);
    Unit_getInstance();
  }
  function writeText$default(_this_, text, fromIndex, toIndex, charset_1, $mask0, $handler) {
    if (!(($mask0 & 2) === 0))
      fromIndex = 0;
    if (!(($mask0 & 4) === 0))
      toIndex = charSequenceLength(text);
    if (!(($mask0 & 8) === 0))
      charset_1 = Charsets_getInstance()._UTF_8;
    return writeText(_this_, text, fromIndex, toIndex, charset_1);
  }
  function readTextExactBytes(_this_, bytesCount, charset_1) {
    return decodeExactBytes(charset_1.newDecoder_0(), _this_, bytesCount);
  }
  function readTextExactBytes$default(_this_, bytesCount, charset_1, $mask0, $handler) {
    if (!(($mask0 & 2) === 0))
      charset_1 = Charsets_getInstance()._UTF_8;
    return readTextExactBytes(_this_, bytesCount, charset_1);
  }
  function writeTextUtf8(_this_, text, fromIndex, toIndex) {
    var index = fromIndex;
    var tmp0_writeWhileSize_0 = 1;
    var tail_1 = prepareWriteHead(_this_, tmp0_writeWhileSize_0, null);
    try {
      var size_2;
      $l$break: while (true) {
        var tmp1__anonymous__3 = tail_1;
        var memory_4 = tmp1__anonymous__3._memory;
        var dstOffset_5 = tmp1__anonymous__3._get_writePosition__1();
        var dstLimit_6 = tmp1__anonymous__3._get_limit__1();
        var tmp0_container_7 = encodeUTF8(memory_4, text, index, toIndex, dstOffset_5, dstLimit_6);
        var tmp0__get_highShort__0_10 = _EncodeResult___get_value__impl_(tmp0_container_7);
        var tmp1_toUShort_0_9 = toShort_0(tmp0__get_highShort__0_10 >>> 16);
        var characters_8 = _UShort___init__impl_(tmp1_toUShort_0_9);
        var tmp2__get_lowShort__0_13 = _EncodeResult___get_value__impl_(tmp0_container_7);
        var tmp3_toUShort_0_12 = toShort_0(tmp2__get_lowShort__0_13 & 65535);
        var bytes_11 = _UShort___init__impl_(tmp3_toUShort_0_12);
        var tmp = index;
        index = tmp + (_UShort___get_data__impl_(characters_8) & 65535) | 0;
        tmp1__anonymous__3.commitWritten_1(_UShort___get_data__impl_(bytes_11) & 65535);
        var tmp_0;
        var tmp_1;
        if ((_UShort___get_data__impl_(characters_8) & 65535) === 0) {
          tmp_1 = index < toIndex;
        } else {
          {
            tmp_1 = false;
          }
        }
        if (tmp_1) {
          tmp_0 = 8;
        } else {
          if (index < toIndex) {
            tmp_0 = 1;
          } else {
            {
              tmp_0 = 0;
            }
          }
        }
        size_2 = tmp_0;
        if (size_2 <= 0)
          break $l$break;
        tail_1 = prepareWriteHead(_this_, size_2, tail_1);
      }
    }finally {
      afterHeadWrite(_this_, tail_1);
    }
  }
  function readText(_this_, charset_1, max) {
    return decode(charset_1.newDecoder_0(), _this_, max);
  }
  function readText$default(_this_, charset_1, max, $mask0, $handler) {
    if (!(($mask0 & 1) === 0))
      charset_1 = Charsets_getInstance()._UTF_8;
    if (!(($mask0 & 2) === 0))
      max = IntCompanionObject_getInstance()._MAX_VALUE_5;
    return readText(_this_, charset_1, max);
  }
  function readBytes(_this_, n) {
    var tmp;
    if (!(n === 0)) {
      var tmp0_also_0 = new Int8Array(n);
      readFully_1(_this_, tmp0_also_0, 0, n);
      tmp = tmp0_also_0;
    } else {
      tmp = EmptyByteArray;
    }
    return tmp;
  }
  function readBytes$default(_this_, n, $mask0, $handler) {
    if (!(($mask0 & 1) === 0)) {
      var tmp0_coerceAtMostMaxIntOrFail_0 = _this_._get_remaining__2();
      var tmp1_coerceAtMostMaxIntOrFail_0 = 'Unable to convert to a ByteArray: packet is too big';
      if (tmp0_coerceAtMostMaxIntOrFail_0.compareTo_69(toLong_0(IntCompanionObject_getInstance()._MAX_VALUE_5)) > 0)
        throw IllegalArgumentException_init_$Create$_0(tmp1_coerceAtMostMaxIntOrFail_0);
      n = tmp0_coerceAtMostMaxIntOrFail_0.toInt_5();
    }return readBytes(_this_, n);
  }
  function _no_name_provided__3_11() {
    RequireFailureCapture.call(this);
  }
  _no_name_provided__3_11.prototype.doFail_4_13 = function () {
    throw IllegalArgumentException_init_$Create$_0('Only ChunkBuffer.Empty instance could be recycled.');
  };
  _no_name_provided__3_11.$metadata$ = {
    simpleName: '<no name provided>_3',
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__118() {
  }
  _no_name_provided__118.prototype.borrow_12 = function () {
    return DefaultChunkedBufferPool.borrow_12();
  };
  _no_name_provided__118.prototype.recycle_7 = function (instance) {
    if (!(instance instanceof IoBuffer)) {
      throw IllegalArgumentException_init_$Create$_0('Only IoBuffer instances can be recycled.');
    } else {
    }
    DefaultChunkedBufferPool.recycle_14(instance);
  };
  _no_name_provided__118.prototype.recycle_14 = function (instance) {
    return this.recycle_7(instance instanceof ChunkBuffer ? instance : THROW_CCE());
  };
  _no_name_provided__118.prototype.dispose_26 = function () {
    DefaultChunkedBufferPool.dispose_26();
  };
  _no_name_provided__118.$metadata$ = {
    kind: 'class',
    interfaces: [ObjectPool]
  };
  function _no_name_provided__119() {
  }
  _no_name_provided__119.prototype.borrow_12 = function () {
    return Companion_getInstance_36()._get_Empty__1();
  };
  _no_name_provided__119.prototype.recycle_7 = function (instance) {
    var tmp0_require_0 = instance === Companion_getInstance_36()._get_Empty__1();
    if (!tmp0_require_0) {
      var m_2 = new _no_name_provided__3_11();
      m_2.doFail_4_13();
    }};
  _no_name_provided__119.prototype.recycle_14 = function (instance) {
    return this.recycle_7(instance instanceof ChunkBuffer ? instance : THROW_CCE());
  };
  _no_name_provided__119.prototype.dispose_26 = function () {
  };
  _no_name_provided__119.$metadata$ = {
    kind: 'class',
    interfaces: [ObjectPool]
  };
  function _no_name_provided__120() {
    NoPoolImpl.call(this);
  }
  _no_name_provided__120.prototype.borrow_12 = function () {
    return new IoBuffer(DefaultAllocator_getInstance().alloc_0(4096), null);
  };
  _no_name_provided__120.prototype.recycle_7 = function (instance) {
    if (!(instance instanceof IoBuffer)) {
      throw IllegalArgumentException_init_$Create$_0('Only IoBuffer instances can be recycled.');
    } else {
    }
    DefaultAllocator_getInstance().free_0(instance._get_memory__1());
  };
  _no_name_provided__120.prototype.recycle_14 = function (instance) {
    return this.recycle_7(instance instanceof ChunkBuffer ? instance : THROW_CCE());
  };
  _no_name_provided__120.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__121() {
    NoPoolImpl.call(this);
  }
  _no_name_provided__121.prototype.borrow_12 = function () {
    throw UnsupportedOperationException_init_$Create$_0("This pool doesn't support borrow");
  };
  _no_name_provided__121.prototype.recycle_7 = function (instance) {
  };
  _no_name_provided__121.prototype.recycle_14 = function (instance) {
    return this.recycle_7(instance instanceof ChunkBuffer ? instance : THROW_CCE());
  };
  _no_name_provided__121.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _set_origin_($this, _set___) {
    return $this._origin$delegate.setValue_7($this, origin$factory(), _set___);
  }
  function appendNext($this, chunk) {
    if (!$this._nextRef.compareAndSet$atomicfu(null, chunk)) {
      throw IllegalStateException_init_$Create$('This chunk has already a next chunk.');
    }}
  function Companion_37() {
    Companion_instance_36 = this;
    var tmp = this;
    tmp._Pool = new _no_name_provided__118();
    var tmp_0 = this;
    tmp_0._EmptyPool = new _no_name_provided__119();
    var tmp_1 = this;
    tmp_1._NoPool = new _no_name_provided__120();
    var tmp_2 = this;
    tmp_2._NoPoolManuallyManaged = new _no_name_provided__121();
  }
  Companion_37.prototype._get_Empty__1 = function () {
    return Companion_getInstance_41()._Empty_1;
  };
  Companion_37.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_36;
  function Companion_getInstance_36() {
    if (Companion_instance_36 == null)
      new Companion_37();
    return Companion_instance_36;
  }
  function _no_name_provided__3_12() {
    RequireFailureCapture.call(this);
  }
  _no_name_provided__3_12.prototype.doFail_4_13 = function () {
    throw IllegalArgumentException_init_$Create$_0("A chunk couldn't be a view of itself.");
  };
  _no_name_provided__3_12.$metadata$ = {
    simpleName: '<no name provided>_3',
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__3_13() {
    RequireFailureCapture.call(this);
  }
  _no_name_provided__3_13.prototype.doFail_4_13 = function () {
    throw IllegalArgumentException_init_$Create$_0('Unable to reset buffer with origin');
  };
  _no_name_provided__3_13.$metadata$ = {
    simpleName: '<no name provided>_3',
    kind: 'class',
    interfaces: []
  };
  function ChunkBuffer(memory, origin) {
    Companion_getInstance_36();
    Buffer.call(this, memory);
    var tmp0_require_0 = !(origin === this);
    if (!tmp0_require_0) {
      var m_2 = new _no_name_provided__3_12();
      m_2.doFail_4_13();
    }this._nextRef = atomic(null);
    this._refCount = atomic_1(1);
    var tmp = this;
    tmp._origin$delegate = new _no_name_provided__124(origin);
  }
  ChunkBuffer.prototype._get_origin__0 = function () {
    return this._origin$delegate.getValue_10(this, origin$factory_0());
  };
  ChunkBuffer.prototype._set_next__0 = function (newValue) {
    if (newValue == null) {
      this.cleanNext_0();
      Unit_getInstance();
    } else {
      appendNext(this, newValue);
    }
  };
  ChunkBuffer.prototype._get_next__1 = function () {
    return this._nextRef._value_8;
  };
  ChunkBuffer.prototype._get_referenceCount__0 = function () {
    return this._refCount._value_10;
  };
  ChunkBuffer.prototype.cleanNext_0 = function () {
    return this._nextRef.getAndSet$atomicfu(null);
  };
  ChunkBuffer.prototype.duplicate_0 = function () {
    var tmp0_elvis_lhs = this._get_origin__0();
    var tmp0_let_0 = tmp0_elvis_lhs == null ? this : tmp0_elvis_lhs;
    tmp0_let_0.acquire_0();
    var tmp0_also_0_2 = new ChunkBuffer(this._get_memory__1(), tmp0_let_0);
    this.duplicateTo_1(tmp0_also_0_2);
    return tmp0_also_0_2;
  };
  ChunkBuffer.prototype.release_7 = function (pool) {
    if (this.release_8()) {
      var origin = this._get_origin__0();
      if (!(origin == null)) {
        this.unlink_0();
        origin.release_7(pool);
      } else {
        pool.recycle_14(this);
      }
    }};
  ChunkBuffer.prototype.unlink_0 = function () {
    if (!this._refCount.compareAndSet$atomicfu(0, -1)) {
      throw IllegalStateException_init_$Create$('Unable to unlink: buffer is in use.');
    }this.cleanNext_0();
    Unit_getInstance();
    _set_origin_(this, null);
  };
  ChunkBuffer.prototype.acquire_0 = function () {
    var tmp$ret$0;
    l$ret$1: do {
      var tmp0_update_0 = this._refCount;
      while (true) {
        var cur_1 = tmp0_update_0._value_10;
        if (cur_1 <= 0)
          throw IllegalStateException_init_$Create$('Unable to acquire chunk: it is already released.');
        var upd_2 = cur_1 + 1 | 0;
        if (tmp0_update_0.compareAndSet$atomicfu(cur_1, upd_2)) {
          tmp$ret$0 = Unit_getInstance();
          break l$ret$1;
        }}
    }
     while (false);
  };
  ChunkBuffer.prototype.unpark_0 = function () {
    var tmp$ret$0;
    l$ret$1: do {
      var tmp0_update_0 = this._refCount;
      while (true) {
        var cur_1 = tmp0_update_0._value_10;
        if (cur_1 < 0) {
          throw IllegalStateException_init_$Create$("This instance is already disposed and couldn't be borrowed.");
        }if (cur_1 > 0) {
          throw IllegalStateException_init_$Create$('This instance is already in use but somehow appeared in the pool.');
        }var upd_2 = 1;
        if (tmp0_update_0.compareAndSet$atomicfu(cur_1, upd_2)) {
          tmp$ret$0 = Unit_getInstance();
          break l$ret$1;
        }}
    }
     while (false);
  };
  ChunkBuffer.prototype.release_8 = function () {
    var tmp$ret$0;
    l$ret$1: do {
      var tmp0_updateAndGet_0 = this._refCount;
      while (true) {
        var cur_1 = tmp0_updateAndGet_0._value_10;
        if (cur_1 <= 0)
          throw IllegalStateException_init_$Create$('Unable to release: it is already released.');
        var upd_2 = cur_1 - 1 | 0;
        if (tmp0_updateAndGet_0.compareAndSet$atomicfu(cur_1, upd_2)) {
          tmp$ret$0 = upd_2;
          break l$ret$1;
        }}
    }
     while (false);
    return tmp$ret$0 === 0;
  };
  ChunkBuffer.prototype.reset_2 = function () {
    var tmp0_require_0 = this._get_origin__0() == null;
    if (!tmp0_require_0) {
      var m_2 = new _no_name_provided__3_13();
      m_2.doFail_4_13();
    }Buffer.prototype.reset_2.call(this);
    this._set_attachment__1(null);
    this._nextRef._value_8 = null;
  };
  ChunkBuffer.$metadata$ = {
    simpleName: 'ChunkBuffer',
    kind: 'class',
    interfaces: []
  };
  function isExclusivelyOwned(_this_) {
    return _this_._get_referenceCount__0() === 1;
  }
  function origin$factory() {
    return getPropertyCallableRef('origin', 1, KMutableProperty1, function (receiver) {
      return receiver._get_origin__0();
    }, function (receiver_0, value) {
      return _set_origin_(receiver_0, value);
    });
  }
  function origin$factory_0() {
    return getPropertyCallableRef('origin', 1, KMutableProperty1, function (receiver) {
      return receiver._get_origin__0();
    }, function (receiver_0, value) {
      return _set_origin_(receiver_0, value);
    });
  }
  function failLongToIntConversion(value, name) {
    throw IllegalArgumentException_init_$Create$_0('' + 'Long value ' + value + ' of ' + name + " doesn't fit into 32-bit integer");
  }
  function RequireFailureCapture() {
  }
  RequireFailureCapture.$metadata$ = {
    simpleName: 'RequireFailureCapture',
    kind: 'class',
    interfaces: []
  };
  function _EncodeResult___init__impl_(value) {
    return value;
  }
  function _EncodeResult___get_value__impl_(this_0) {
    return this_0;
  }
  function _EncodeResult___init__impl__0(characters, bytes) {
    var tmp = (_UShort___get_data__impl_(characters) & 65535) << 16;
    var tmp_0 = _EncodeResult___init__impl_(tmp | _UShort___get_data__impl_(bytes) & 65535);
    return tmp_0;
  }
  function encodeUTF8(_this_, text, from, to_1, dstOffset, dstLimit) {
    var tmp0_toInt_0 = _UShort___init__impl_(-1);
    var tmp1_minOf_0 = from + (_UShort___get_data__impl_(tmp0_toInt_0) & 65535) | 0;
    var lastCharIndex = function () {
      var $externalVarargReceiverTmp = Math;
      return $externalVarargReceiverTmp.min.apply($externalVarargReceiverTmp, [].concat([].slice.call(new Int32Array([to_1, tmp1_minOf_0]))));
    }.call(this);
    var tmp2_toInt_0 = _UShort___init__impl_(-1);
    var resultLimit = coerceAtMost(dstLimit, _UShort___get_data__impl_(tmp2_toInt_0) & 65535);
    var resultPosition = dstOffset;
    var index = from;
    $l$break: do {
      if (resultPosition >= resultLimit ? true : index >= lastCharIndex) {
        var tmp3_toUShort_0 = index - from | 0;
        var tmp = _UShort___init__impl_(toShort_0(tmp3_toUShort_0));
        var tmp4_toUShort_0 = resultPosition - dstOffset | 0;
        return _EncodeResult___init__impl__0(tmp, _UShort___init__impl_(toShort_0(tmp4_toUShort_0)));
      }var tmp0 = index;
      index = tmp0 + 1 | 0;
      var character = charSequenceGet(text, tmp0).toInt_5() & 65535;
      if ((character & 65408) === 0) {
        var tmp1 = resultPosition;
        resultPosition = tmp1 + 1 | 0;
        var tmp5_storeAt_0 = tmp1;
        var tmp6_storeAt_0 = toByte_0(character);
        _this_._view.setInt8(tmp5_storeAt_0, tmp6_storeAt_0);
      } else {
        break $l$break;
      }
    }
     while (true);
    var tmp2 = index;
    index = tmp2 - 1 | 0;
    Unit_getInstance();
    return encodeUTF8Stage1(_this_, text, index, lastCharIndex, from, resultPosition, resultLimit, dstOffset);
  }
  function encodeUTF8Stage1(_this_, text, index1, lastCharIndex, from, resultPosition1, resultLimit, dstOffset) {
    var index = index1;
    var resultPosition = resultPosition1;
    var stage1Limit = resultLimit - 3 | 0;
    $l$break: do {
      var freeSpace = stage1Limit - resultPosition | 0;
      if (freeSpace <= 0 ? true : index >= lastCharIndex) {
        break $l$break;
      }var tmp0 = index;
      index = tmp0 + 1 | 0;
      var character = charSequenceGet(text, tmp0);
      var tmp;
      if (isHighSurrogate(character)) {
        var tmp_0;
        if (index === lastCharIndex ? true : !isLowSurrogate(charSequenceGet(text, index))) {
          tmp_0 = 63;
        } else {
          var tmp1 = index;
          index = tmp1 + 1 | 0;
          tmp_0 = codePoint(character, charSequenceGet(text, tmp1));
        }
        tmp = tmp_0;
      } else {
        tmp = character.toInt_5();
      }
      var codepoint = tmp;
      var tmp0_putUtf8Char_0 = resultPosition;
      var tmp_1;
      if (0 <= codepoint ? codepoint <= 127 : false) {
        var tmp0_storeAt_0_1 = toByte_0(codepoint);
        _this_._view.setInt8(tmp0_putUtf8Char_0, tmp0_storeAt_0_1);
        tmp_1 = 1;
      } else if (128 <= codepoint ? codepoint <= 2047 : false) {
        var tmp1_set_0_2 = toByte_0(192 | codepoint >> 6 & 31);
        _this_._view.setInt8(tmp0_putUtf8Char_0, tmp1_set_0_2);
        var tmp2_set_0_3 = tmp0_putUtf8Char_0 + 1 | 0;
        var tmp3_set_0_4 = toByte_0(128 | codepoint & 63);
        _this_._view.setInt8(tmp2_set_0_3, tmp3_set_0_4);
        tmp_1 = 2;
      } else if (2048 <= codepoint ? codepoint <= 65535 : false) {
        var tmp4_set_0_5 = toByte_0(224 | codepoint >> 12 & 15);
        _this_._view.setInt8(tmp0_putUtf8Char_0, tmp4_set_0_5);
        var tmp5_set_0_6 = tmp0_putUtf8Char_0 + 1 | 0;
        var tmp6_set_0_7 = toByte_0(128 | codepoint >> 6 & 63);
        _this_._view.setInt8(tmp5_set_0_6, tmp6_set_0_7);
        var tmp7_set_0_8 = tmp0_putUtf8Char_0 + 2 | 0;
        var tmp8_set_0_9 = toByte_0(128 | codepoint & 63);
        _this_._view.setInt8(tmp7_set_0_8, tmp8_set_0_9);
        tmp_1 = 3;
      } else if (65536 <= codepoint ? codepoint <= 1114111 : false) {
        var tmp9_set_0_10 = toByte_0(240 | codepoint >> 18 & 7);
        _this_._view.setInt8(tmp0_putUtf8Char_0, tmp9_set_0_10);
        var tmp10_set_0_11 = tmp0_putUtf8Char_0 + 1 | 0;
        var tmp11_set_0_12 = toByte_0(128 | codepoint >> 12 & 63);
        _this_._view.setInt8(tmp10_set_0_11, tmp11_set_0_12);
        var tmp12_set_0_13 = tmp0_putUtf8Char_0 + 2 | 0;
        var tmp13_set_0_14 = toByte_0(128 | codepoint >> 6 & 63);
        _this_._view.setInt8(tmp12_set_0_13, tmp13_set_0_14);
        var tmp14_set_0_15 = tmp0_putUtf8Char_0 + 3 | 0;
        var tmp15_set_0_16 = toByte_0(128 | codepoint & 63);
        _this_._view.setInt8(tmp14_set_0_15, tmp15_set_0_16);
        tmp_1 = 4;
      } else {
        malformedCodePoint(codepoint);
      }
      var size_0 = tmp_1;
      resultPosition = resultPosition + size_0 | 0;
    }
     while (true);
    if (resultPosition === stage1Limit) {
      return encodeUTF8Stage2(_this_, text, index, lastCharIndex, from, resultPosition, resultLimit, dstOffset);
    }var tmp1_toUShort_0 = index - from | 0;
    var tmp_2 = _UShort___init__impl_(toShort_0(tmp1_toUShort_0));
    var tmp2_toUShort_0 = resultPosition - dstOffset | 0;
    return _EncodeResult___init__impl__0(tmp_2, _UShort___init__impl_(toShort_0(tmp2_toUShort_0)));
  }
  function malformedCodePoint(value) {
    throw IllegalArgumentException_init_$Create$_0('' + 'Malformed code-point ' + value + ' found');
  }
  function codePoint(high, low) {
    var highValue = high.toInt_5() - 55232 | 0;
    var lowValue = low.toInt_5() - 56320 | 0;
    return highValue << 10 | lowValue;
  }
  function encodeUTF8Stage2(_this_, text, index1, lastCharIndex, from, resultPosition1, resultLimit, dstOffset) {
    var index = index1;
    var resultPosition = resultPosition1;
    $l$break_0: do {
      var freeSpace = resultLimit - resultPosition | 0;
      if (freeSpace <= 0 ? true : index >= lastCharIndex) {
        break $l$break_0;
      }var tmp0 = index;
      index = tmp0 + 1 | 0;
      var character = charSequenceGet(text, tmp0);
      var tmp;
      if (!isHighSurrogate(character)) {
        tmp = character.toInt_5();
      } else {
        var tmp_0;
        if (index === lastCharIndex ? true : !isLowSurrogate(charSequenceGet(text, index))) {
          tmp_0 = 63;
        } else {
          var tmp1 = index;
          index = tmp1 + 1 | 0;
          tmp_0 = codePoint(character, charSequenceGet(text, tmp1));
        }
        tmp = tmp_0;
      }
      var codepoint = tmp;
      var tmp_1;
      if (1 <= codepoint ? codepoint <= 127 : false) {
        tmp_1 = 1;
      } else if (128 <= codepoint ? codepoint <= 2047 : false) {
        tmp_1 = 2;
      } else if (2048 <= codepoint ? codepoint <= 65535 : false) {
        tmp_1 = 3;
      } else if (65536 <= codepoint ? codepoint <= 1114111 : false) {
        tmp_1 = 4;
      } else {
        malformedCodePoint(codepoint);
      }
      if (tmp_1 > freeSpace) {
        var tmp2 = index;
        index = tmp2 - 1 | 0;
        Unit_getInstance();
        break $l$break_0;
      } else {
      }
      var tmp0_putUtf8Char_0 = resultPosition;
      var tmp_2;
      if (0 <= codepoint ? codepoint <= 127 : false) {
        var tmp0_storeAt_0_1 = toByte_0(codepoint);
        _this_._view.setInt8(tmp0_putUtf8Char_0, tmp0_storeAt_0_1);
        tmp_2 = 1;
      } else if (128 <= codepoint ? codepoint <= 2047 : false) {
        var tmp1_set_0_2 = toByte_0(192 | codepoint >> 6 & 31);
        _this_._view.setInt8(tmp0_putUtf8Char_0, tmp1_set_0_2);
        var tmp2_set_0_3 = tmp0_putUtf8Char_0 + 1 | 0;
        var tmp3_set_0_4 = toByte_0(128 | codepoint & 63);
        _this_._view.setInt8(tmp2_set_0_3, tmp3_set_0_4);
        tmp_2 = 2;
      } else if (2048 <= codepoint ? codepoint <= 65535 : false) {
        var tmp4_set_0_5 = toByte_0(224 | codepoint >> 12 & 15);
        _this_._view.setInt8(tmp0_putUtf8Char_0, tmp4_set_0_5);
        var tmp5_set_0_6 = tmp0_putUtf8Char_0 + 1 | 0;
        var tmp6_set_0_7 = toByte_0(128 | codepoint >> 6 & 63);
        _this_._view.setInt8(tmp5_set_0_6, tmp6_set_0_7);
        var tmp7_set_0_8 = tmp0_putUtf8Char_0 + 2 | 0;
        var tmp8_set_0_9 = toByte_0(128 | codepoint & 63);
        _this_._view.setInt8(tmp7_set_0_8, tmp8_set_0_9);
        tmp_2 = 3;
      } else if (65536 <= codepoint ? codepoint <= 1114111 : false) {
        var tmp9_set_0_10 = toByte_0(240 | codepoint >> 18 & 7);
        _this_._view.setInt8(tmp0_putUtf8Char_0, tmp9_set_0_10);
        var tmp10_set_0_11 = tmp0_putUtf8Char_0 + 1 | 0;
        var tmp11_set_0_12 = toByte_0(128 | codepoint >> 12 & 63);
        _this_._view.setInt8(tmp10_set_0_11, tmp11_set_0_12);
        var tmp12_set_0_13 = tmp0_putUtf8Char_0 + 2 | 0;
        var tmp13_set_0_14 = toByte_0(128 | codepoint >> 6 & 63);
        _this_._view.setInt8(tmp12_set_0_13, tmp13_set_0_14);
        var tmp14_set_0_15 = tmp0_putUtf8Char_0 + 3 | 0;
        var tmp15_set_0_16 = toByte_0(128 | codepoint & 63);
        _this_._view.setInt8(tmp14_set_0_15, tmp15_set_0_16);
        tmp_2 = 4;
      } else {
        malformedCodePoint(codepoint);
      }
      var size_0 = tmp_2;
      resultPosition = resultPosition + size_0 | 0;
    }
     while (true);
    var tmp1_toUShort_0 = index - from | 0;
    var tmp_3 = _UShort___init__impl_(toShort_0(tmp1_toUShort_0));
    var tmp2_toUShort_0 = resultPosition - dstOffset | 0;
    return _EncodeResult___init__impl__0(tmp_3, _UShort___init__impl_(toShort_0(tmp2_toUShort_0)));
  }
  function MalformedUTF8InputException(message) {
    Exception_init_$Init$_0(message, this);
    captureStack(this, MalformedUTF8InputException);
  }
  MalformedUTF8InputException.$metadata$ = {
    simpleName: 'MalformedUTF8InputException',
    kind: 'class',
    interfaces: []
  };
  function malformedByteCount(byteCount) {
    throw new MalformedUTF8InputException('' + 'Expected ' + byteCount + ' more character bytes');
  }
  function isBmpCodePoint(cp) {
    return cp >>> 16 === 0;
  }
  function isValidCodePoint(codePoint_0) {
    return codePoint_0 <= 1114111;
  }
  function highSurrogate(cp) {
    return (cp >>> 10) + 55232 | 0;
  }
  function lowSurrogate(cp) {
    return (cp & 1023) + 56320 | 0;
  }
  var EmptyByteArray;
  function prepareWriteHead(_this_, capacity, current) {
    if (_this_ instanceof AbstractOutput) {
      if (!(current == null)) {
        _this_.afterHeadWrite_2();
      }return _this_.prepareWriteHead_2(capacity);
    } else {
    }
    return prepareWriteHeadFallback(_this_, current);
  }
  function afterHeadWrite(_this_, current) {
    if (_this_ instanceof AbstractOutput) {
      return _this_.afterHeadWrite_2();
    } else {
    }
    afterWriteHeadFallback(_this_, current);
  }
  function prepareReadFirstHead(_this_, minSize) {
    if (_this_ instanceof AbstractInput) {
      return _this_.prepareReadHead_2(minSize);
    } else {
    }
    if (_this_ instanceof ChunkBuffer) {
      var tmp;
      var tmp0_canRead_0 = _this_;
      if (tmp0_canRead_0._get_writePosition__1() > tmp0_canRead_0._get_readPosition__1()) {
        tmp = _this_;
      } else {
        {
          tmp = null;
        }
      }
      return tmp;
    } else {
    }
    return prepareReadHeadFallback(_this_, minSize);
  }
  function completeReadHead(_this_, current) {
    if (current === _this_) {
      return Unit_getInstance();
    }if (_this_ instanceof AbstractInput) {
      if (!(current._get_writePosition__1() > current._get_readPosition__1())) {
        _this_.ensureNext_2(current);
        Unit_getInstance();
      } else {
        if ((current._capacity_0 - current._get_limit__1() | 0) < 8) {
          _this_.fixGapAfterRead_2(current);
        } else {
          {
            _this_._set_headPosition__2(current._get_readPosition__1());
          }
        }
      }
      return Unit_getInstance();
    } else {
    }
    completeReadHeadFallback(_this_, current);
  }
  function prepareWriteHeadFallback(_this_, current) {
    if (!(current == null)) {
      writeFully$default_0(_this_, current, 0, 2, null);
      current.resetForWrite_3();
      return current;
    }return Companion_getInstance_36()._Pool.borrow_12();
  }
  function afterWriteHeadFallback(_this_, current) {
    writeFully$default_0(_this_, current, 0, 2, null);
    current.release_7(Companion_getInstance_36()._Pool);
  }
  function prepareReadHeadFallback(_this_, minSize) {
    if (_this_._get_endOfInput__4())
      return null;
    var buffer = Companion_getInstance_36()._Pool.borrow_12();
    var tmp = buffer._get_memory__1();
    var tmp_0 = toLong_0(buffer._get_writePosition__1());
    var tmp_1 = new Long(0, 0);
    var tmp_2 = toLong_0(minSize);
    var copied = _this_.peekTo_4(tmp, tmp_0, tmp_1, tmp_2, toLong_0(buffer._get_limit__1() - buffer._get_writePosition__1() | 0)).toInt_5();
    buffer.commitWritten_1(copied);
    if (copied < minSize) {
      prematureEndOfStream(minSize);
    }return buffer;
  }
  function completeReadHeadFallback(_this_, current) {
    var tmp = current._get_capacity__1();
    var tmp_0 = tmp - (current._get_limit__1() - current._get_writePosition__1() | 0) | 0;
    var discardAmount = tmp_0 - (current._get_writePosition__1() - current._get_readPosition__1() | 0) | 0;
    discardExact(_this_, discardAmount);
    current.release_7(Companion_getInstance_36()._Pool);
  }
  function prepareReadNextHead(_this_, current) {
    if (current === _this_) {
      var tmp;
      var tmp0_canRead_0 = _this_;
      if (tmp0_canRead_0._get_writePosition__1() > tmp0_canRead_0._get_readPosition__1()) {
        tmp = _this_;
      } else {
        {
          tmp = null;
        }
      }
      return tmp;
    }if (_this_ instanceof AbstractInput) {
      return _this_.ensureNextHead_2(current);
    } else {
    }
    return prepareNextReadHeadFallback(_this_, current);
  }
  function prepareNextReadHeadFallback(_this_, current) {
    var tmp = current._get_capacity__1();
    var tmp_0 = tmp - (current._get_limit__1() - current._get_writePosition__1() | 0) | 0;
    var discardAmount = tmp_0 - (current._get_writePosition__1() - current._get_readPosition__1() | 0) | 0;
    discardExact(_this_, discardAmount);
    current.resetForWrite_3();
    var tmp_1;
    if (_this_._get_endOfInput__4()) {
      tmp_1 = true;
    } else {
      tmp_1 = peekTo$default(_this_, current, 0, 0, 0, 14, null) <= 0;
    }
    if (tmp_1) {
      current.release_7(Companion_getInstance_36()._Pool);
      return null;
    } else {
    }
    return current;
  }
  function unsafeAppend(_this_, builder) {
    var builderSize = builder._get_size__45();
    var tmp0_elvis_lhs = builder.stealAll_4();
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return 0;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var builderHead = tmp;
    if ((builderSize <= PACKET_MAX_COPY_SIZE ? builderHead._get_next__1() == null : false) ? _this_.tryWriteAppend_0(builderHead) : false) {
      builder.afterBytesStolen_0();
      return builderSize;
    }_this_.append_29(builderHead);
    return builderSize;
  }
  function checkPeekTo(destination, offset, min, max) {
    var tmp0_require_0 = offset >= 0;
    if (!tmp0_require_0) {
      var m_1 = new _no_name_provided__2_0(offset);
      m_1.doFail_3_4();
    }var tmp1_require_0 = min >= 0;
    if (!tmp1_require_0) {
      var m_1_0 = new _no_name_provided__2_1(min);
      m_1_0.doFail_3_4();
    }var tmp2_require_0 = max >= min;
    if (!tmp2_require_0) {
      var m_1_1 = new _no_name_provided__2_2(max, min);
      m_1_1.doFail_3_4();
    }var tmp3_require_0 = min <= (destination._get_limit__1() - destination._get_writePosition__1() | 0);
    if (!tmp3_require_0) {
      var m_1_2 = new _no_name_provided__2_3(min, destination);
      m_1_2.doFail_3_4();
    }}
  function _no_name_provided__2_0($offset) {
    this._$offset = $offset;
    RequireFailureCapture.call(this);
  }
  _no_name_provided__2_0.prototype.doFail_3_4 = function () {
    throw IllegalArgumentException_init_$Create$_0('' + "offset shouldn't be negative: " + this._$offset + '.');
  };
  _no_name_provided__2_0.$metadata$ = {
    simpleName: '<no name provided>_2',
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__2_1($min) {
    this._$min = $min;
    RequireFailureCapture.call(this);
  }
  _no_name_provided__2_1.prototype.doFail_3_4 = function () {
    throw IllegalArgumentException_init_$Create$_0('' + "min shouldn't be negative: " + this._$min + '.');
  };
  _no_name_provided__2_1.$metadata$ = {
    simpleName: '<no name provided>_2',
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__2_2($max, $min) {
    this._$max = $max;
    this._$min_0 = $min;
    RequireFailureCapture.call(this);
  }
  _no_name_provided__2_2.prototype.doFail_3_4 = function () {
    throw IllegalArgumentException_init_$Create$_0('' + "max should't be less than min: max = " + this._$max + ', min = ' + this._$min_0 + '.');
  };
  _no_name_provided__2_2.$metadata$ = {
    simpleName: '<no name provided>_2',
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__2_3($min, $destination) {
    this._$min_1 = $min;
    this._$destination = $destination;
    RequireFailureCapture.call(this);
  }
  _no_name_provided__2_3.prototype.doFail_3_4 = function () {
    throw IllegalArgumentException_init_$Create$_0('Not enough free space in the destination buffer ' + ('' + 'to write the specified minimum number of bytes: min = ' + this._$min_1 + ', free = ' + (this._$destination._get_limit__1() - this._$destination._get_writePosition__1() | 0) + '.'));
  };
  _no_name_provided__2_3.$metadata$ = {
    simpleName: '<no name provided>_2',
    kind: 'class',
    interfaces: []
  };
  function trySuspend_0($this, $cont) {
    var tmp = new $trySuspendCOROUTINE$55($this, $cont);
    tmp._result = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_72();
  }
  function $sleepCOROUTINE$54(_this_, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__12 = _this_;
  }
  $sleepCOROUTINE$54.prototype.doResume_72 = function () {
    var suspendResult = this._result;
    $sm: do
      try {
        var tmp = this._state_0;
        switch (tmp) {
          case 0:
            this._exceptionState = 3;
            this._state_0 = 1;
            suspendResult = trySuspend_0(this.__this__12, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            if (suspendResult) {
              return Unit_getInstance();
            } else {
              this._state_0 = 2;
              continue $sm;
            }

            break;
          case 2:
            this.__this__12.resume_2();
            return Unit_getInstance();
          case 3:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 3) {
          throw $p;
        } else {
          this._state_0 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $sleepCOROUTINE$54.$metadata$ = {
    simpleName: '$sleepCOROUTINE$54',
    kind: 'class',
    interfaces: []
  };
  function $trySuspendCOROUTINE$55(_this_, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__13 = _this_;
  }
  $trySuspendCOROUTINE$55.prototype.doResume_72 = function () {
    var suspendResult = this._result;
    $sm: do
      try {
        var tmp = this._state_0;
        switch (tmp) {
          case 0:
            this._exceptionState = 3;
            this._suspended0 = false;
            var tmp_0 = this;
            tmp_0._job1 = Job$default(null, 1, null);
            if (this.__this__13._suspension.compareAndSet$atomicfu(null, this._job1)) {
              this._suspended0 = true;
              this._state_0 = 1;
              suspendResult = this._job1.join_3(this);
              if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
                return suspendResult;
              }continue $sm;
            } else {
              this._state_0 = 2;
              continue $sm;
            }

            break;
          case 1:
            suspendResult;
            this._state_0 = 2;
            continue $sm;
          case 2:
            return this._suspended0;
          case 3:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 3) {
          throw $p;
        } else {
          this._state_0 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $trySuspendCOROUTINE$55.$metadata$ = {
    simpleName: '$trySuspendCOROUTINE$55',
    kind: 'class',
    interfaces: []
  };
  function AwaitingSlot() {
    this._suspension = atomic(null);
    makeShared(this);
  }
  AwaitingSlot.prototype.sleep = function ($cont) {
    var tmp = new $sleepCOROUTINE$54(this, $cont);
    tmp._result = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_72();
  };
  AwaitingSlot.prototype.resume_2 = function () {
    var tmp0_safe_receiver = this._suspension.getAndSet$atomicfu(null);
    if (tmp0_safe_receiver == null)
      null;
    else
      tmp0_safe_receiver.complete_3();
    Unit_getInstance();
  };
  AwaitingSlot.prototype.cancel_21 = function (cause) {
    var tmp0_elvis_lhs = this._suspension.getAndSet$atomicfu(null);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return Unit_getInstance();
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var continuation = tmp;
    if (!(cause == null)) {
      continuation.completeExceptionally_3(cause);
      Unit_getInstance();
    } else {
      continuation.complete_3();
      Unit_getInstance();
    }
  };
  AwaitingSlot.$metadata$ = {
    simpleName: 'AwaitingSlot',
    kind: 'class',
    interfaces: []
  };
  function copyToSequentialImpl(_this_, dst, limit, $cont) {
    var tmp = new $copyToSequentialImplCOROUTINE$56(_this_, dst, limit, $cont);
    tmp._result = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_72();
  }
  function copyToTail(_this_, dst, limit, $cont) {
    var tmp = new $copyToTailCOROUTINE$57(_this_, dst, limit, $cont);
    tmp._result = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_72();
  }
  function $copyToSequentialImplCOROUTINE$56(_this_, dst, limit, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__14 = _this_;
    this._dst_1 = dst;
    this._limit_2 = limit;
  }
  $copyToSequentialImplCOROUTINE$56.prototype.doResume_72 = function () {
    var suspendResult = this._result;
    $sm: do
      try {
        var tmp = this._state_0;
        switch (tmp) {
          case 0:
            this._exceptionState = 10;
            var tmp_0 = this;
            tmp_0._tmp0_require_00_0 = !(this.__this__14 === this._dst_1);
            if (!this._tmp0_require_00_0) {
              var message_1_1 = 'Failed requirement.';
              throw IllegalArgumentException_init_$Create$_0(toString_1(message_1_1));
            }
            if (!(this.__this__14._get_closedCause__0() == null)) {
              this._dst_1.close_27(this.__this__14._get_closedCause__0());
              Unit_getInstance();
              return new Long(0, 0);
            }
            this._remainingLimit1 = this._limit_2;
            this._state_0 = 1;
            continue $sm;
          case 1:
            if (!(this._remainingLimit1.compareTo_69(new Long(0, 0)) > 0)) {
              this._state_0 = 9;
              continue $sm;
            }
            this._state_0 = 2;
            suspendResult = this.__this__14.awaitInternalAtLeast1_0(this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 2:
            this._ARGUMENT2 = suspendResult;
            if (!this._ARGUMENT2) {
              this._state_0 = 9;
              continue $sm;
            } else {
              this._state_0 = 3;
              continue $sm;
            }

            break;
          case 3:
            this._transferred3 = this.__this__14.transferTo_0(this._dst_1, this._remainingLimit1);
            if (this._transferred3.equals(new Long(0, 0))) {
              this._state_0 = 6;
              suspendResult = copyToTail(this.__this__14, this._dst_1, this._remainingLimit1, this);
              if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
                return suspendResult;
              }continue $sm;
            } else {
              if (this._dst_1._get_availableForWrite__0() === 0) {
                this._state_0 = 4;
                suspendResult = this._dst_1.awaitAtLeastNBytesAvailableForWrite_0(1, this);
                if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
                  return suspendResult;
                }continue $sm;
              } else {
                this._state_0 = 5;
                continue $sm;
              }
              Unit_getInstance();
            }

            break;
          case 4:
            suspendResult;
            this._state_0 = 5;
            continue $sm;
          case 5:
            this._WHEN_RESULT4 = this._transferred3;
            this._state_0 = 8;
            continue $sm;
          case 6:
            var tail = suspendResult;
            if (tail.equals(new Long(0, 0))) {
              this._state_0 = 9;
              continue $sm;
            } else {
              this._state_0 = 7;
              continue $sm;
            }

            break;
          case 7:
            this._WHEN_RESULT4 = tail;
            this._state_0 = 8;
            continue $sm;
          case 8:
            var copied = this._WHEN_RESULT4;
            this._remainingLimit1 = this._remainingLimit1.minus_29(copied);
            this._state_0 = 1;
            continue $sm;
          case 9:
            return this._limit_2.minus_29(this._remainingLimit1);
          case 10:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 10) {
          throw $p;
        } else {
          this._state_0 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $copyToSequentialImplCOROUTINE$56.$metadata$ = {
    simpleName: '$copyToSequentialImplCOROUTINE$56',
    kind: 'class',
    interfaces: []
  };
  function $copyToTailCOROUTINE$57(_this_, dst, limit, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__15 = _this_;
    this._dst_2 = dst;
    this._limit_3 = limit;
  }
  $copyToTailCOROUTINE$57.prototype.doResume_72 = function () {
    var suspendResult = this._result;
    $sm: do
      try {
        var tmp = this._state_0;
        switch (tmp) {
          case 0:
            this._exceptionState = 9;
            this._lastPiece0 = Companion_getInstance_36()._Pool.borrow_12();
            this._state_0 = 1;
            continue $sm;
          case 1:
            this._state_0 = 2;
            continue $sm;
          case 2:
            this._exceptionState = 8;
            this._lastPiece0.resetForWrite_4(coerceAtMost_0(this._limit_3, toLong_0(this._lastPiece0._get_capacity__1())).toInt_5());
            this._state_0 = 3;
            suspendResult = this.__this__15.readAvailable_0(this._lastPiece0, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 3:
            this._rc3 = suspendResult;
            if (this._rc3 === -1) {
              this._lastPiece0.release_7(Companion_getInstance_36()._Pool);
              this._tmp$ret$02 = new Long(0, 0);
              this._exceptionState = 9;
              this._state_0 = 6;
              continue $sm;
            } else {
              this._state_0 = 4;
              continue $sm;
            }

            break;
          case 4:
            this._state_0 = 5;
            suspendResult = this._dst_2.writeFully_1(this._lastPiece0, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 5:
            suspendResult;
            this._tmp$ret$02 = toLong_0(this._rc3);
            this._exceptionState = 9;
            this._state_0 = 6;
            var tmp_0 = this;
            continue $sm;
          case 6:
            var tmp_1 = this._tmp$ret$02;
            this._lastPiece0.release_7(Companion_getInstance_36()._Pool);
            return tmp_1;
          case 7:
            this._lastPiece0.release_7(Companion_getInstance_36()._Pool);
            return Unit_getInstance();
          case 8:
            this._exceptionState = 9;
            var t = this._exception_0;
            this._lastPiece0.release_7(Companion_getInstance_36()._Pool);
            throw t;
          case 9:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 9) {
          throw $p;
        } else {
          this._state_0 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $copyToTailCOROUTINE$57.$metadata$ = {
    simpleName: '$copyToTailCOROUTINE$57',
    kind: 'class',
    interfaces: []
  };
  function ObjectPool() {
  }
  ObjectPool.prototype.close_39 = function () {
    this.dispose_26();
  };
  ObjectPool.$metadata$ = {
    simpleName: 'ObjectPool',
    kind: 'interface',
    interfaces: [Closeable]
  };
  function NoPoolImpl() {
  }
  NoPoolImpl.prototype.recycle_14 = function (instance) {
  };
  NoPoolImpl.prototype.dispose_26 = function () {
  };
  NoPoolImpl.$metadata$ = {
    simpleName: 'NoPoolImpl',
    kind: 'class',
    interfaces: [ObjectPool]
  };
  function copyTo(_this_, dst, limit, $cont) {
    var tmp = _this_ instanceof ByteChannelSequentialBase ? _this_ : THROW_CCE();
    return copyToSequentialImpl(tmp, dst instanceof ByteChannelSequentialBase ? dst : THROW_CCE(), limit, $cont);
  }
  function _no_name_provided__122(this$0) {
    this._this$0_31 = this$0;
  }
  _no_name_provided__122.prototype.invoke_375 = function (cause) {
    this._this$0_31._attachedJob = null;
    if (!(cause == null)) {
      this._this$0_31.cancel_23(cause);
      Unit_getInstance();
    }};
  _no_name_provided__122.prototype.invoke_542 = function (p1) {
    this.invoke_375((p1 == null ? true : p1 instanceof Error) ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__122.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function ByteChannelJS(initial, autoFlush) {
    ByteChannelSequentialBase_init_$Init$(initial, autoFlush, null, 4, null, this);
    this._attachedJob = null;
  }
  ByteChannelJS.prototype.attachJob_1 = function (job) {
    var tmp0_safe_receiver = this._attachedJob;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.cancel$default_15(null, 1, null);
      Unit_getInstance();
    }
    Unit_getInstance();
    this._attachedJob = job;
    job.invokeOnCompletion$default_9(true, false, _no_name_provided_$factory_96(this), 2, null);
    Unit_getInstance();
  };
  ByteChannelJS.prototype.toString = function () {
    return '' + 'ByteChannel[' + this._attachedJob + ', ' + hashCode(this) + ']';
  };
  ByteChannelJS.$metadata$ = {
    simpleName: 'ByteChannelJS',
    kind: 'class',
    interfaces: []
  };
  function ByteChannel_0(autoFlush) {
    return new ByteChannelJS(Companion_getInstance_41()._Empty_1, autoFlush);
  }
  function ByteReadChannel_0(content, offset, length) {
    if (content.length === 0)
      return Companion_getInstance_37()._get_Empty__1();
    else {
    }
    var head = Companion_getInstance_41()._Pool_0.borrow_12();
    var tail = head;
    var start = offset;
    var end = start + length | 0;
    $l$break: while (true) {
      tail.reserveEndGap_1(8);
      var tmp1_minOf_0 = end - start | 0;
      var tmp0__get_writeRemaining__0 = tail;
      var tmp2_minOf_0 = tmp0__get_writeRemaining__0._get_limit__1() - tmp0__get_writeRemaining__0._get_writePosition__1() | 0;
      var size_0 = function () {
        var $externalVarargReceiverTmp = Math;
        return $externalVarargReceiverTmp.min.apply($externalVarargReceiverTmp, [].concat([].slice.call(new Int32Array([tmp1_minOf_0, tmp2_minOf_0]))));
      }.call(this);
      writeFully_0(tail instanceof Buffer ? tail : THROW_CCE(), content, start, size_0);
      start = start + size_0 | 0;
      if (start === end)
        break $l$break;
      var current = tail;
      tail = Companion_getInstance_41()._Pool_0.borrow_12();
      current._set_next__0(tail);
    }
    var tmp3_apply_0 = new ByteChannelJS(head, false);
    close(tmp3_apply_0);
    Unit_getInstance();
    return tmp3_apply_0;
  }
  function _no_name_provided_$factory_96(this$0) {
    var i = new _no_name_provided__122(this$0);
    return function (p1) {
      i.invoke_375(p1);
      return Unit_getInstance();
    };
  }
  function ByteChannelSequentialBaseSharedState() {
    this._closed = false;
    this._readByteOrder = ByteOrder_BIG_ENDIAN_getInstance();
    this._writeByteOrder = ByteOrder_BIG_ENDIAN_getInstance();
    this._totalBytesRead = new Long(0, 0);
    this._totalBytesWritten = new Long(0, 0);
    this._closedCause = null;
    this._lastReadAvailable = 0;
    this._lastReadView = Companion_getInstance_36()._get_Empty__1();
  }
  ByteChannelSequentialBaseSharedState.$metadata$ = {
    simpleName: 'ByteChannelSequentialBaseSharedState',
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__123() {
  }
  _no_name_provided__123.prototype.invoke_540 = function () {
    var tmp0_apply_0 = new ByteChannelJS(Companion_getInstance_41()._Empty_1, false);
    tmp0_apply_0.close_27(null);
    Unit_getInstance();
    return tmp0_apply_0;
  };
  _no_name_provided__123.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function Companion_38() {
    Companion_instance_37 = this;
    var tmp = this;
    tmp._Empty$delegate = lazy(_no_name_provided_$factory_97());
  }
  Companion_38.prototype._get_Empty__1 = function () {
    var tmp0_getValue_0 = this._Empty$delegate;
    var tmp1_getValue_0 = Empty$factory();
    return tmp0_getValue_0._get_value__33();
  };
  Companion_38.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_37;
  function Companion_getInstance_37() {
    if (Companion_instance_37 == null)
      new Companion_38();
    return Companion_instance_37;
  }
  function ByteReadChannel_1() {
  }
  ByteReadChannel_1.$metadata$ = {
    simpleName: 'ByteReadChannel',
    kind: 'interface',
    interfaces: []
  };
  function Empty$factory() {
    return getPropertyCallableRef('Empty', 1, KProperty1, function (receiver) {
      return receiver._get_Empty__1();
    }, null);
  }
  function _no_name_provided_$factory_97() {
    var i = new _no_name_provided__123();
    return function () {
      return i.invoke_540();
    };
  }
  function ByteWriteChannel() {
  }
  ByteWriteChannel.$metadata$ = {
    simpleName: 'ByteWriteChannel',
    kind: 'interface',
    interfaces: []
  };
  function makeShared(_this_) {
  }
  function preventFreeze(_this_) {
  }
  function DefaultAllocator() {
    DefaultAllocator_instance = this;
  }
  DefaultAllocator.prototype.alloc_0 = function (size_0) {
    return new Memory(new DataView(new ArrayBuffer(size_0)));
  };
  DefaultAllocator.prototype.free_0 = function (instance) {
  };
  DefaultAllocator.$metadata$ = {
    simpleName: 'DefaultAllocator',
    kind: 'object',
    interfaces: [Allocator]
  };
  var DefaultAllocator_instance;
  function DefaultAllocator_getInstance() {
    if (DefaultAllocator_instance == null)
      new DefaultAllocator();
    return DefaultAllocator_instance;
  }
  function of(_this_, array, offset, length) {
    var typedArray = array;
    return of_0(Companion_getInstance_38(), typedArray, offset, length);
  }
  function of_0(_this_, view, offset, length) {
    return of_1(Companion_getInstance_38(), view.buffer, view.byteOffset + offset | 0, length);
  }
  function of_1(_this_, buffer, offset, length) {
    return new Memory(new DataView(buffer, offset, length));
  }
  function of$default(_this_, buffer, offset, length, $mask0, $handler) {
    if (!(($mask0 & 2) === 0))
      offset = 0;
    if (!(($mask0 & 4) === 0))
      length = buffer.byteLength - offset | 0;
    return of_1(_this_, buffer, offset, length);
  }
  function Companion_39() {
    Companion_instance_38 = this;
    this._Empty_0 = new Memory(new DataView(new ArrayBuffer(0)));
  }
  Companion_39.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_38;
  function Companion_getInstance_38() {
    if (Companion_instance_38 == null)
      new Companion_39();
    return Companion_instance_38;
  }
  function Memory(view) {
    Companion_getInstance_38();
    this._view = view;
  }
  Memory.prototype.slice_0 = function (offset, length) {
    var tmp0_require_0 = offset >= 0;
    if (!tmp0_require_0) {
      var message_1 = '' + "offset shouldn't be negative: " + offset;
      throw IllegalArgumentException_init_$Create$_0(toString_1(message_1));
    }var tmp1_require_0 = length >= 0;
    if (!tmp1_require_0) {
      var message_1_0 = '' + "length shouldn't be negative: " + length;
      throw IllegalArgumentException_init_$Create$_0(toString_1(message_1_0));
    }var tmp = toLong_0(offset + length | 0);
    if (tmp.compareTo_69(toLong_0(this._view.byteLength)) > 0) {
      throw IndexOutOfBoundsException_init_$Create$_0('' + 'offset + length > size: ' + offset + ' + ' + length + ' > ' + toLong_0(this._view.byteLength));
    } else {
    }
    return new Memory(new DataView(this._view.buffer, this._view.byteOffset + offset | 0, length));
  };
  Memory.prototype.copyTo = function (destination, offset, length, destinationOffset) {
    var src = new Int8Array(this._view.buffer, this._view.byteOffset + offset | 0, length);
    var dst = new Int8Array(destination._view.buffer, destination._view.byteOffset + destinationOffset | 0, length);
    dst.set(src);
  };
  Memory.prototype.copyTo_0 = function (destination, offset, length, destinationOffset) {
    var tmp0_toIntOrFail_0 = 'offset';
    if (offset.compareTo_69(toLong_0(IntCompanionObject_getInstance()._MAX_VALUE_5)) >= 0) {
      failLongToIntConversion(offset, tmp0_toIntOrFail_0);
    }var tmp = offset.toInt_5();
    var tmp1_toIntOrFail_0 = 'length';
    if (length.compareTo_69(toLong_0(IntCompanionObject_getInstance()._MAX_VALUE_5)) >= 0) {
      failLongToIntConversion(length, tmp1_toIntOrFail_0);
    }var tmp_0 = length.toInt_5();
    var tmp2_toIntOrFail_0 = 'destinationOffset';
    if (destinationOffset.compareTo_69(toLong_0(IntCompanionObject_getInstance()._MAX_VALUE_5)) >= 0) {
      failLongToIntConversion(destinationOffset, tmp2_toIntOrFail_0);
    }this.copyTo(destination, tmp, tmp_0, destinationOffset.toInt_5());
  };
  Memory.$metadata$ = {
    simpleName: 'Memory',
    kind: 'class',
    interfaces: []
  };
  function copyTo_0(_this_, destination, offset, length, destinationOffset) {
    copyTo_1(_this_.buffer, destination, offset + _this_.byteOffset | 0, length, destinationOffset);
  }
  function copyTo_1(_this_, destination, offset, length, destinationOffset) {
    var from = new Int8Array(_this_, offset, length);
    var to_1 = new Int8Array(destination._view.buffer, destination._view.byteOffset + destinationOffset | 0, length);
    to_1.set(from, 0);
  }
  function copyTo_2(_this_, destination, offset, length, destinationOffset) {
    var to_1 = destination;
    var from = new Int8Array(_this_._view.buffer, _this_._view.byteOffset + offset | 0, length);
    to_1.set(from, destinationOffset);
  }
  var isLittleEndianPlatform;
  function Companion_40() {
    Companion_instance_39 = this;
  }
  Companion_40.prototype.forName = function (name) {
    switch (name) {
      case 'UTF-8':
      case 'utf-8':
      case 'UTF8':
      case 'utf8':
        return Charsets_getInstance()._UTF_8;
    }
    var tmp;
    var tmp_0;
    switch (name) {
      case 'ISO-8859-1':
      case 'iso-8859-1':
        tmp_0 = true;
        break;
      default:var tmp_1 = new Char(95);
        var tmp_2 = new Char(45);
        var tmp0_let_0 = replace$default(name, tmp_1, tmp_2, false, 4, null);
        var tmp_3;
        if (tmp0_let_0 === 'iso-8859-1') {
          tmp_3 = true;
        } else {
          tmp_3 = tmp0_let_0.toLowerCase() === 'iso-8859-1';
        }

        tmp_0 = tmp_3;
        break;
    }
    if (tmp_0) {
      tmp = true;
    } else {
      {
        tmp = name === 'latin1';
      }
    }
    if (tmp) {
      return Charsets_getInstance()._ISO_8859_1;
    } else {
    }
    throw IllegalArgumentException_init_$Create$_0('' + 'Charset ' + name + ' is not supported');
  };
  Companion_40.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_39;
  function Companion_getInstance_39() {
    if (Companion_instance_39 == null)
      new Companion_40();
    return Companion_instance_39;
  }
  function Charset(_name) {
    Companion_getInstance_39();
    this.__name = _name;
  }
  Charset.$metadata$ = {
    simpleName: 'Charset',
    kind: 'class',
    interfaces: []
  };
  function Charsets() {
    Charsets_instance = this;
    this._UTF_8 = new CharsetImpl('UTF-8');
    this._ISO_8859_1 = new CharsetImpl('ISO-8859-1');
  }
  Charsets.$metadata$ = {
    simpleName: 'Charsets',
    kind: 'object',
    interfaces: []
  };
  var Charsets_instance;
  function Charsets_getInstance() {
    if (Charsets_instance == null)
      new Charsets();
    return Charsets_instance;
  }
  function CharsetEncoder(_charset) {
    this.__charset = _charset;
  }
  CharsetEncoder.$metadata$ = {
    simpleName: 'CharsetEncoder',
    kind: 'class',
    interfaces: []
  };
  function decodeExactBytes(_this_, input, inputLength) {
    if (inputLength === 0)
      return '';
    var tmp;
    if (input instanceof AbstractInput) {
      var tmp0__get_headRemaining__0 = input;
      tmp = (tmp0__get_headRemaining__0._get_headEndExclusive__2() - tmp0__get_headRemaining__0._get_headPosition__2() | 0) >= inputLength;
    } else {
      {
        tmp = false;
      }
    }
    if (tmp) {
      var decoder = TextDecoderFatal(_get_charset_(_this_).__name, true);
      var head = input._get_head__7();
      var view = input._get_headMemory__2()._view;
      var tmp$ret$0;
      l$ret$1: do {
        try {
          var subView_4 = (head._get_readPosition__1() === 0 ? inputLength === view.byteLength : false) ? view : new DataView(view.buffer, view.byteOffset + head._get_readPosition__1() | 0, inputLength);
          tmp$ret$0 = decoder.decode(subView_4);
          break l$ret$1;
        } catch ($p) {
          if ($p instanceof Error) {
            var tmp0_elvis_lhs_2 = $p.message;
            throw new MalformedInputException('' + 'Failed to decode bytes: ' + (tmp0_elvis_lhs_2 == null ? 'no cause provided' : tmp0_elvis_lhs_2));
          } else {
            {
              throw $p;
            }
          }
        }
      }
       while (false);
      var text = tmp$ret$0;
      input.discardExact_5(inputLength);
      return text;
    } else {
    }
    return decodeExactBytesSlow(_this_, input, inputLength);
  }
  function CharsetDecoder(_charset) {
    this.__charset_0 = _charset;
  }
  CharsetDecoder.$metadata$ = {
    simpleName: 'CharsetDecoder',
    kind: 'class',
    interfaces: []
  };
  function CharsetImpl(name) {
    Charset.call(this, name);
    this._name_4 = name;
  }
  CharsetImpl.prototype.newEncoder_0 = function () {
    return new CharsetEncoderImpl(this);
  };
  CharsetImpl.prototype.newDecoder_0 = function () {
    return new CharsetDecoderImpl(this);
  };
  CharsetImpl.prototype.toString = function () {
    return '' + 'CharsetImpl(name=' + this._name_4 + ')';
  };
  CharsetImpl.prototype.hashCode = function () {
    return getStringHashCode(this._name_4);
  };
  CharsetImpl.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof CharsetImpl))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof CharsetImpl ? other : THROW_CCE();
    if (!(this._name_4 === tmp0_other_with_cast._name_4))
      return false;
    return true;
  };
  CharsetImpl.$metadata$ = {
    simpleName: 'CharsetImpl',
    kind: 'class',
    interfaces: []
  };
  function _get_charset_(_this_) {
    return _this_.__charset_0;
  }
  function decodeExactBytesSlow(_this_, input, inputLength) {
    var decoder = TextDecoderFatal(_get_name_(_get_charset_(_this_)), true);
    var inputRemaining = inputLength;
    var sb = StringBuilder_init_$Create$(inputLength);
    var tmp$ret$16;
    l$ret$17: do {
      try {
        var tmp$ret$0;
        l$ret$1: do {
          var tmp0_takeWhileSize_0_4 = 6;
          var release_1_5 = true;
          var tmp0_elvis_lhs_3_7 = prepareReadFirstHead(input, tmp0_takeWhileSize_0_4);
          var tmp;
          if (tmp0_elvis_lhs_3_7 == null) {
            tmp$ret$0 = Unit_getInstance();
            break l$ret$1;
          } else {
            tmp = tmp0_elvis_lhs_3_7;
          }
          var current_2_6 = tmp;
          var size_4_8 = tmp0_takeWhileSize_0_4;
          try {
            $l$break: do {
              var tmp0__get_readRemaining__0_6_10 = current_2_6;
              var before_5_9 = tmp0__get_readRemaining__0_6_10._get_writePosition__1() - tmp0__get_readRemaining__0_6_10._get_readPosition__1() | 0;
              var after_7_11;
              if (before_5_9 >= size_4_8) {
                try {
                  var tmp1__anonymous__11_12 = current_2_6;
                  var chunkSize_12_13 = tmp1__anonymous__11_12._get_writePosition__1() - tmp1__anonymous__11_12._get_readPosition__1() | 0;
                  var tmp0_minOf_0_14_15 = inputRemaining;
                  var size_13_14 = function () {
                    var $externalVarargReceiverTmp = Math;
                    return $externalVarargReceiverTmp.min.apply($externalVarargReceiverTmp, [].concat([].slice.call(new Int32Array([chunkSize_12_13, tmp0_minOf_0_14_15]))));
                  }.call(this);
                  var tmp_0;
                  if (tmp1__anonymous__11_12._get_readPosition__1() === 0 ? tmp1__anonymous__11_12._memory._view.byteLength === size_13_14 : false) {
                    var tmp$ret$2;
                    l$ret$3: do {
                      var tmp1_decodeStream_0_16_17 = tmp1__anonymous__11_12._memory._view;
                      var tmp2_decodeStream_0_17_18 = true;
                      var tmp$ret$4;
                      l$ret$5: do {
                        try {
                          var tmp_1;
                          if (tmp2_decodeStream_0_17_18) {
                            tmp_1 = decoder.decode(tmp1_decodeStream_0_16_17, STREAM_TRUE);
                          } else {
                            tmp_1 = decoder.decode(tmp1_decodeStream_0_16_17);
                          }
                          tmp$ret$2 = tmp_1;
                          break l$ret$3;
                        } catch ($p) {
                          if ($p instanceof Error) {
                            var tmp0_elvis_lhs_2_19_20 = $p.message;
                            throw new MalformedInputException('' + 'Failed to decode bytes: ' + (tmp0_elvis_lhs_2_19_20 == null ? 'no cause provided' : tmp0_elvis_lhs_2_19_20));
                          } else {
                            {
                              throw $p;
                            }
                          }
                        }
                      }
                       while (false);
                    }
                     while (false);
                    tmp_0 = tmp$ret$2;
                  } else {
                    var tmp$ret$6;
                    l$ret$7: do {
                      var tmp3_decodeStream_0_20_21 = new Int8Array(tmp1__anonymous__11_12._memory._view.buffer, tmp1__anonymous__11_12._memory._view.byteOffset + tmp1__anonymous__11_12._get_readPosition__1() | 0, size_13_14);
                      var tmp4_decodeStream_0_21_22 = true;
                      var tmp$ret$8;
                      l$ret$9: do {
                        try {
                          var tmp_2;
                          if (tmp4_decodeStream_0_21_22) {
                            tmp_2 = decoder.decode(tmp3_decodeStream_0_20_21, STREAM_TRUE);
                          } else {
                            tmp_2 = decoder.decode(tmp3_decodeStream_0_20_21);
                          }
                          tmp$ret$6 = tmp_2;
                          break l$ret$7;
                        } catch ($p_0) {
                          if ($p_0 instanceof Error) {
                            var tmp0_elvis_lhs_2_23_24 = $p_0.message;
                            throw new MalformedInputException('' + 'Failed to decode bytes: ' + (tmp0_elvis_lhs_2_23_24 == null ? 'no cause provided' : tmp0_elvis_lhs_2_23_24));
                          } else {
                            {
                              throw $p_0;
                            }
                          }
                        }
                      }
                       while (false);
                    }
                     while (false);
                    tmp_0 = tmp$ret$6;
                  }
                  var text_15_16 = tmp_0;
                  sb.append_7(text_15_16);
                  Unit_getInstance();
                  tmp1__anonymous__11_12.discardExact_5(size_13_14);
                  inputRemaining = inputRemaining - size_13_14 | 0;
                  size_4_8 = inputRemaining > 0 ? 6 : 0;
                }finally {
                  var tmp1__get_readRemaining__0_8_25 = current_2_6;
                  after_7_11 = tmp1__get_readRemaining__0_8_25._get_writePosition__1() - tmp1__get_readRemaining__0_8_25._get_readPosition__1() | 0;
                }
              } else {
                after_7_11 = before_5_9;
              }
              release_1_5 = false;
              var tmp_3;
              if (after_7_11 === 0) {
                tmp_3 = prepareReadNextHead(input, current_2_6);
              } else {
                var tmp_4;
                if (after_7_11 < size_4_8) {
                  tmp_4 = true;
                } else {
                  var tmp2__get_endGap__0_10_27 = current_2_6;
                  tmp_4 = (tmp2__get_endGap__0_10_27._capacity_0 - tmp2__get_endGap__0_10_27._get_limit__1() | 0) < 8;
                }
                if (tmp_4) {
                  completeReadHead(input, current_2_6);
                  tmp_3 = prepareReadFirstHead(input, size_4_8);
                } else {
                  {
                    tmp_3 = current_2_6;
                  }
                }
              }
              var next_9_26 = tmp_3;
              if (next_9_26 == null) {
                break $l$break;
              }current_2_6 = next_9_26;
              release_1_5 = true;
            }
             while (size_4_8 > 0);
          }finally {
            if (release_1_5) {
              completeReadHead(input, current_2_6);
            }}
        }
         while (false);
        if (inputRemaining > 0) {
          var tmp$ret$10;
          l$ret$11: do {
            var release_1_28 = true;
            var tmp0_elvis_lhs_3_30 = prepareReadFirstHead(input, 1);
            var tmp_5;
            if (tmp0_elvis_lhs_3_30 == null) {
              tmp$ret$10 = Unit_getInstance();
              break l$ret$11;
            } else {
              tmp_5 = tmp0_elvis_lhs_3_30;
            }
            var current_2_29 = tmp_5;
            try {
              $l$break_1: do {
                var tmp2__anonymous__6_31 = current_2_29;
                var chunkSize_7_32 = tmp2__anonymous__6_31._get_writePosition__1() - tmp2__anonymous__6_31._get_readPosition__1() | 0;
                var tmp0_minOf_0_9_34 = inputRemaining;
                var size_8_33 = function () {
                  var $externalVarargReceiverTmp = Math;
                  return $externalVarargReceiverTmp.min.apply($externalVarargReceiverTmp, [].concat([].slice.call(new Int32Array([chunkSize_7_32, tmp0_minOf_0_9_34]))));
                }.call(this);
                var tmp_6;
                if (tmp2__anonymous__6_31._get_readPosition__1() === 0 ? tmp2__anonymous__6_31._memory._view.byteLength === size_8_33 : false) {
                  tmp_6 = decoder.decode(tmp2__anonymous__6_31._memory._view);
                } else {
                  var tmp$ret$12;
                  l$ret$13: do {
                    var tmp1_decodeStream_0_11_36 = new Int8Array(tmp2__anonymous__6_31._memory._view.buffer, tmp2__anonymous__6_31._memory._view.byteOffset + tmp2__anonymous__6_31._get_readPosition__1() | 0, size_8_33);
                    var tmp2_decodeStream_0_12_37 = true;
                    var tmp$ret$14;
                    l$ret$15: do {
                      try {
                        var tmp_7;
                        if (tmp2_decodeStream_0_12_37) {
                          tmp_7 = decoder.decode(tmp1_decodeStream_0_11_36, STREAM_TRUE);
                        } else {
                          tmp_7 = decoder.decode(tmp1_decodeStream_0_11_36);
                        }
                        tmp$ret$12 = tmp_7;
                        break l$ret$13;
                      } catch ($p_1) {
                        if ($p_1 instanceof Error) {
                          var tmp0_elvis_lhs_2_14_39 = $p_1.message;
                          throw new MalformedInputException('' + 'Failed to decode bytes: ' + (tmp0_elvis_lhs_2_14_39 == null ? 'no cause provided' : tmp0_elvis_lhs_2_14_39));
                        } else {
                          {
                            throw $p_1;
                          }
                        }
                      }
                    }
                     while (false);
                  }
                   while (false);
                  tmp_6 = tmp$ret$12;
                }
                var text_10_35 = tmp_6;
                sb.append_7(text_10_35);
                Unit_getInstance();
                tmp2__anonymous__6_31.discardExact_5(size_8_33);
                inputRemaining = inputRemaining - size_8_33 | 0;
                if (!true) {
                  break $l$break_1;
                } else {
                }
                release_1_28 = false;
                var tmp1_elvis_lhs_5_41 = prepareReadNextHead(input, current_2_29);
                var tmp_8;
                if (tmp1_elvis_lhs_5_41 == null) {
                  break $l$break_1;
                } else {
                  tmp_8 = tmp1_elvis_lhs_5_41;
                }
                var next_4_40 = tmp_8;
                current_2_29 = next_4_40;
                release_1_28 = true;
              }
               while (true);
            }finally {
              if (release_1_28) {
                completeReadHead(input, current_2_29);
              }}
          }
           while (false);
        }tmp$ret$16 = sb.append_7(decoder.decode());
        break l$ret$17;
      } catch ($p_2) {
        if ($p_2 instanceof Error) {
          var tmp0_elvis_lhs_2 = $p_2.message;
          throw new MalformedInputException('' + 'Failed to decode bytes: ' + (tmp0_elvis_lhs_2 == null ? 'no cause provided' : tmp0_elvis_lhs_2));
        } else {
          {
            throw $p_2;
          }
        }
      }
    }
     while (false);
    Unit_getInstance();
    if (inputRemaining > 0) {
      throw new EOFException('' + 'Not enough bytes available: had only ' + (inputLength - inputRemaining | 0) + ' instead of ' + inputLength);
    }return sb.toString();
  }
  function CharsetEncoderImpl(charset_1) {
    CharsetEncoder.call(this, charset_1);
    this._charset = charset_1;
  }
  CharsetEncoderImpl.prototype.toString = function () {
    return '' + 'CharsetEncoderImpl(charset=' + this._charset + ')';
  };
  CharsetEncoderImpl.prototype.hashCode = function () {
    return hashCode(this._charset);
  };
  CharsetEncoderImpl.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof CharsetEncoderImpl))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof CharsetEncoderImpl ? other : THROW_CCE();
    if (!equals_1(this._charset, tmp0_other_with_cast._charset))
      return false;
    return true;
  };
  CharsetEncoderImpl.$metadata$ = {
    simpleName: 'CharsetEncoderImpl',
    kind: 'class',
    interfaces: []
  };
  function CharsetDecoderImpl(charset_1) {
    CharsetDecoder.call(this, charset_1);
    this._charset_0 = charset_1;
  }
  CharsetDecoderImpl.prototype.toString = function () {
    return '' + 'CharsetDecoderImpl(charset=' + this._charset_0 + ')';
  };
  CharsetDecoderImpl.prototype.hashCode = function () {
    return hashCode(this._charset_0);
  };
  CharsetDecoderImpl.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof CharsetDecoderImpl))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof CharsetDecoderImpl ? other : THROW_CCE();
    if (!equals_1(this._charset_0, tmp0_other_with_cast._charset_0))
      return false;
    return true;
  };
  CharsetDecoderImpl.$metadata$ = {
    simpleName: 'CharsetDecoderImpl',
    kind: 'class',
    interfaces: []
  };
  function _get_name_(_this_) {
    return _this_.__name;
  }
  function encodeImpl(_this_, input, fromIndex, toIndex, dst) {
    var tmp0_require_0 = fromIndex <= toIndex;
    if (!tmp0_require_0) {
      var message_1_1 = 'Failed requirement.';
      throw IllegalArgumentException_init_$Create$_0(toString_1(message_1_1));
    }if (equals_1(_get_charset__0(_this_), Charsets_getInstance()._ISO_8859_1)) {
      return encodeISO88591(input, fromIndex, toIndex, dst);
    }var tmp1_require_0 = _get_charset__0(_this_) === Charsets_getInstance()._UTF_8;
    if (!tmp1_require_0) {
      var message_1 = 'Only UTF-8 encoding is supported in JS';
      throw IllegalArgumentException_init_$Create$_0(toString_1(message_1));
    }var encoder = TextEncoderCtor();
    var start = fromIndex;
    var dstRemaining = dst._get_limit__1() - dst._get_writePosition__1() | 0;
    $l$break: while (start < toIndex ? dstRemaining > 0 : false) {
      var tmp2_minOf_0 = toIndex - start | 0;
      var tmp3_minOf_0 = dstRemaining / 6 | 0;
      var numChars = coerceAtLeast(function () {
        var $externalVarargReceiverTmp = Math;
        return $externalVarargReceiverTmp.min.apply($externalVarargReceiverTmp, [].concat([].slice.call(new Int32Array([tmp2_minOf_0, tmp3_minOf_0]))));
      }.call(this), 1);
      var dropLastChar = isHighSurrogate(charSequenceGet(input, (start + numChars | 0) - 1 | 0));
      var endIndexExclusive = (dropLastChar ? numChars === 1 : false) ? start + 2 | 0 : dropLastChar ? (start + numChars | 0) - 1 | 0 : start + numChars | 0;
      var tmp4_substring_0 = start;
      var array1 = encoder.encode(toString_1(charSequenceSubSequence(input, tmp4_substring_0, endIndexExclusive)));
      if (array1.length > dstRemaining)
        break $l$break;
      writeFully$default_1(dst, array1, 0, 0, 6, null);
      start = endIndexExclusive;
      dstRemaining = dstRemaining - array1.length | 0;
    }
    return start - fromIndex | 0;
  }
  function encodeComplete(_this_, dst) {
    return true;
  }
  function MalformedInputException(message) {
    extendThrowable(this, message, void 1);
    captureStack(this, MalformedInputException);
  }
  MalformedInputException.$metadata$ = {
    simpleName: 'MalformedInputException',
    kind: 'class',
    interfaces: []
  };
  function _get_charset__0(_this_) {
    return _this_.__charset;
  }
  function encodeToByteArray(_this_, input, fromIndex, toIndex) {
    return encodeToByteArrayImpl1(_this_, input, fromIndex, toIndex);
  }
  function decode_0(_this_, input, dst, max) {
    var decoder = TextDecoderFatal(_get_name_(_get_charset_(_this_)), true);
    var charactersCopied = 0;
    var tmp$ret$0;
    l$ret$1: do {
      var tmp0_takeWhileSize_0 = 1;
      var release_1 = true;
      var tmp0_elvis_lhs_3 = prepareReadFirstHead(input, tmp0_takeWhileSize_0);
      var tmp;
      if (tmp0_elvis_lhs_3 == null) {
        tmp$ret$0 = Unit_getInstance();
        break l$ret$1;
      } else {
        tmp = tmp0_elvis_lhs_3;
      }
      var current_2 = tmp;
      var size_4 = tmp0_takeWhileSize_0;
      try {
        $l$break: do {
          var tmp0__get_readRemaining__0_6 = current_2;
          var before_5 = tmp0__get_readRemaining__0_6._get_writePosition__1() - tmp0__get_readRemaining__0_6._get_readPosition__1() | 0;
          var after_7;
          if (before_5 >= size_4) {
            try {
              var tmp$ret$2;
              l$ret$3: do {
                var tmp1__anonymous__11 = current_2;
                var rem_12 = max - charactersCopied | 0;
                var bufferSize_13 = tmp1__anonymous__11._get_writePosition__1() - tmp1__anonymous__11._get_readPosition__1() | 0;
                if (rem_12 < bufferSize_13) {
                  tmp$ret$2 = 0;
                  break l$ret$3;
                }var tmp0__anonymous__2_2_15 = tmp1__anonymous__11._memory;
                var tmp1__anonymous__2_2_16 = tmp1__anonymous__11._get_readPosition__1();
                var tmp2__anonymous__2_2_17 = tmp1__anonymous__11._get_writePosition__1();
                var tmp3__anonymous__3_18 = new Int8Array(tmp0__anonymous__2_2_15._view.buffer, tmp0__anonymous__2_2_15._view.byteOffset + tmp1__anonymous__2_2_16 | 0, tmp2__anonymous__2_2_17 - tmp1__anonymous__2_2_16 | 0);
                var tmp$ret$8;
                l$ret$9: do {
                  try {
                    var tmp$ret$4;
                    l$ret$5: do {
                      var tmp0_decodeStream_0_4_5_20 = true;
                      var tmp$ret$6;
                      l$ret$7: do {
                        try {
                          var tmp_0;
                          if (tmp0_decodeStream_0_4_5_20) {
                            tmp_0 = decoder.decode(tmp3__anonymous__3_18, STREAM_TRUE);
                          } else {
                            tmp_0 = decoder.decode(tmp3__anonymous__3_18);
                          }
                          tmp$ret$4 = tmp_0;
                          break l$ret$5;
                        } catch ($p) {
                          if ($p instanceof Error) {
                            var tmp0_elvis_lhs_2_6_7_22 = $p.message;
                            throw new MalformedInputException('' + 'Failed to decode bytes: ' + (tmp0_elvis_lhs_2_6_7_22 == null ? 'no cause provided' : tmp0_elvis_lhs_2_6_7_22));
                          } else {
                            {
                              throw $p;
                            }
                          }
                        }
                      }
                       while (false);
                    }
                     while (false);
                    tmp$ret$8 = tmp$ret$4;
                    break l$ret$9;
                  } catch ($p_0) {
                    if ($p_0 instanceof Error) {
                      var tmp0_elvis_lhs_2_9_24 = $p_0.message;
                      throw new MalformedInputException('' + 'Failed to decode bytes: ' + (tmp0_elvis_lhs_2_9_24 == null ? 'no cause provided' : tmp0_elvis_lhs_2_9_24));
                    } else {
                      {
                        throw $p_0;
                      }
                    }
                  }
                }
                 while (false);
                var decodedText_4_19 = tmp$ret$8;
                dst.append_31(decodedText_4_19);
                Unit_getInstance();
                charactersCopied = charactersCopied + decodedText_4_19.length | 0;
                var rc_1_14 = tmp3__anonymous__3_18.byteLength;
                tmp1__anonymous__11.discardExact_5(rc_1_14);
                Unit_getInstance();
                var tmp_1;
                if (charactersCopied === max) {
                  var tmp_2;
                  try {
                    tmp_2 = decoder.decode();
                  } catch ($p_1) {
                    var tmp_3;
                    {
                      tmp_3 = '';
                    }
                    tmp_2 = tmp_3;
                  }
                  var tail_25 = tmp_2;
                  if (charSequenceLength(tail_25) > 0) {
                    tmp1__anonymous__11.rewind_1(bufferSize_13);
                  } else {
                  }
                  tmp_1 = 0;
                } else if (charactersCopied < max) {
                  tmp_1 = 8;
                } else {
                  tmp_1 = 0;
                }
                tmp$ret$2 = tmp_1;
              }
               while (false);
              size_4 = tmp$ret$2;
            }finally {
              var tmp1__get_readRemaining__0_8 = current_2;
              after_7 = tmp1__get_readRemaining__0_8._get_writePosition__1() - tmp1__get_readRemaining__0_8._get_readPosition__1() | 0;
            }
          } else {
            after_7 = before_5;
          }
          release_1 = false;
          var tmp_4;
          if (after_7 === 0) {
            tmp_4 = prepareReadNextHead(input, current_2);
          } else {
            var tmp_5;
            if (after_7 < size_4) {
              tmp_5 = true;
            } else {
              var tmp2__get_endGap__0_10 = current_2;
              tmp_5 = (tmp2__get_endGap__0_10._capacity_0 - tmp2__get_endGap__0_10._get_limit__1() | 0) < 8;
            }
            if (tmp_5) {
              completeReadHead(input, current_2);
              tmp_4 = prepareReadFirstHead(input, size_4);
            } else {
              {
                tmp_4 = current_2;
              }
            }
          }
          var next_9 = tmp_4;
          if (next_9 == null) {
            break $l$break;
          }current_2 = next_9;
          release_1 = true;
        }
         while (size_4 > 0);
      }finally {
        if (release_1) {
          completeReadHead(input, current_2);
        }}
    }
     while (false);
    if (charactersCopied < max) {
      var size_0 = 1;
      var tmp$ret$10;
      l$ret$11: do {
        var tmp2_takeWhileSize_0 = 1;
        var release_1_0 = true;
        var tmp0_elvis_lhs_3_0 = prepareReadFirstHead(input, tmp2_takeWhileSize_0);
        var tmp_6;
        if (tmp0_elvis_lhs_3_0 == null) {
          tmp$ret$10 = Unit_getInstance();
          break l$ret$11;
        } else {
          tmp_6 = tmp0_elvis_lhs_3_0;
        }
        var current_2_0 = tmp_6;
        var size_4_0 = tmp2_takeWhileSize_0;
        try {
          $l$break_0: do {
            var tmp0__get_readRemaining__0_6_0 = current_2_0;
            var before_5_0 = tmp0__get_readRemaining__0_6_0._get_writePosition__1() - tmp0__get_readRemaining__0_6_0._get_readPosition__1() | 0;
            var after_7_0;
            if (before_5_0 >= size_4_0) {
              try {
                var tmp3__anonymous__11 = current_2_0;
                var tmp0__anonymous__2_2_14 = tmp3__anonymous__11._memory;
                var tmp1__anonymous__2_2_15 = tmp3__anonymous__11._get_readPosition__1();
                var tmp2__anonymous__2_2_16 = tmp3__anonymous__11._get_writePosition__1();
                var tmp3__anonymous__3_17 = new Int8Array(tmp0__anonymous__2_2_14._view.buffer, tmp0__anonymous__2_2_14._view.byteOffset + tmp1__anonymous__2_2_15 | 0, tmp2__anonymous__2_2_16 - tmp1__anonymous__2_2_15 | 0);
                var result_4_18 = decodeBufferImpl(tmp3__anonymous__3_17, decoder, max - charactersCopied | 0);
                dst.append_31(result_4_18._charactersDecoded);
                Unit_getInstance();
                charactersCopied = charactersCopied + result_4_18._charactersDecoded.length | 0;
                var rc_1_13 = result_4_18._bytesConsumed;
                tmp3__anonymous__11.discardExact_5(rc_1_13);
                var rc_12 = rc_1_13;
                if (rc_12 > 0)
                  size_0 = 1;
                else if (size_0 === 8)
                  size_0 = 0;
                else {
                  var tmp0_19 = size_0;
                  size_0 = tmp0_19 + 1 | 0;
                  Unit_getInstance();
                }
                size_4_0 = size_0;
              }finally {
                var tmp1__get_readRemaining__0_8_0 = current_2_0;
                after_7_0 = tmp1__get_readRemaining__0_8_0._get_writePosition__1() - tmp1__get_readRemaining__0_8_0._get_readPosition__1() | 0;
              }
            } else {
              after_7_0 = before_5_0;
            }
            release_1_0 = false;
            var tmp_7;
            if (after_7_0 === 0) {
              tmp_7 = prepareReadNextHead(input, current_2_0);
            } else {
              var tmp_8;
              if (after_7_0 < size_4_0) {
                tmp_8 = true;
              } else {
                var tmp2__get_endGap__0_10_0 = current_2_0;
                tmp_8 = (tmp2__get_endGap__0_10_0._capacity_0 - tmp2__get_endGap__0_10_0._get_limit__1() | 0) < 8;
              }
              if (tmp_8) {
                completeReadHead(input, current_2_0);
                tmp_7 = prepareReadFirstHead(input, size_4_0);
              } else {
                {
                  tmp_7 = current_2_0;
                }
              }
            }
            var next_9_0 = tmp_7;
            if (next_9_0 == null) {
              break $l$break_0;
            }current_2_0 = next_9_0;
            release_1_0 = true;
          }
           while (size_4_0 > 0);
        }finally {
          if (release_1_0) {
            completeReadHead(input, current_2_0);
          }}
      }
       while (false);
    }return charactersCopied;
  }
  function DecodeBufferResult(charactersDecoded, bytesConsumed) {
    this._charactersDecoded = charactersDecoded;
    this._bytesConsumed = bytesConsumed;
  }
  DecodeBufferResult.prototype.toString = function () {
    return '' + 'DecodeBufferResult(charactersDecoded=' + this._charactersDecoded + ', bytesConsumed=' + this._bytesConsumed + ')';
  };
  DecodeBufferResult.prototype.hashCode = function () {
    var result = getStringHashCode(this._charactersDecoded);
    result = imul(result, 31) + this._bytesConsumed | 0;
    return result;
  };
  DecodeBufferResult.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof DecodeBufferResult))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof DecodeBufferResult ? other : THROW_CCE();
    if (!(this._charactersDecoded === tmp0_other_with_cast._charactersDecoded))
      return false;
    if (!(this._bytesConsumed === tmp0_other_with_cast._bytesConsumed))
      return false;
    return true;
  };
  DecodeBufferResult.$metadata$ = {
    simpleName: 'DecodeBufferResult',
    kind: 'class',
    interfaces: []
  };
  function decodeBufferImpl(_this_, nativeDecoder, maxCharacters) {
    if (maxCharacters === 0) {
      return new DecodeBufferResult('', 0);
    }try {
      var sizeInBytes = coerceAtMost(maxCharacters, _this_.byteLength);
      var text = nativeDecoder.decode(_this_.subarray(0, sizeInBytes));
      if (text.length <= maxCharacters) {
        return new DecodeBufferResult(text, sizeInBytes);
      }} catch ($p) {
    }
    return decodeBufferImplSlow(_this_, nativeDecoder, maxCharacters);
  }
  function decodeBufferImplSlow(_this_, nativeDecoder, maxCharacters) {
    var maxBytes = coerceAtMost(maxCharacters >= 268435455 ? IntCompanionObject_getInstance()._MAX_VALUE_5 : imul(maxCharacters, 8), _this_.byteLength);
    var sizeInBytes = maxBytes;
    while (sizeInBytes > 8) {
      try {
        var text = nativeDecoder.decode(_this_.subarray(0, sizeInBytes));
        if (text.length <= maxCharacters) {
          return new DecodeBufferResult(text, sizeInBytes);
        }} catch ($p) {
      }
      sizeInBytes = sizeInBytes / 2 | 0;
    }
    sizeInBytes = 8;
    while (sizeInBytes > 0) {
      try {
        var text_0 = nativeDecoder.decode(_this_.subarray(0, sizeInBytes));
        if (text_0.length <= maxCharacters) {
          return new DecodeBufferResult(text_0, sizeInBytes);
        }} catch ($p_0) {
      }
      var tmp0 = sizeInBytes;
      sizeInBytes = tmp0 - 1 | 0;
      Unit_getInstance();
    }
    var tmp$ret$0;
    l$ret$1: do {
      try {
        tmp$ret$0 = nativeDecoder.decode(_this_);
        break l$ret$1;
      } catch ($p_1) {
        if ($p_1 instanceof Error) {
          var tmp0_elvis_lhs_2 = $p_1.message;
          throw new MalformedInputException('' + 'Failed to decode bytes: ' + (tmp0_elvis_lhs_2 == null ? 'no cause provided' : tmp0_elvis_lhs_2));
        } else {
          {
            throw $p_1;
          }
        }
      }
    }
     while (false);
    Unit_getInstance();
    throw new MalformedInputException('Unable to decode buffer');
  }
  function encodeISO88591(input, fromIndex, toIndex, dst) {
    if (fromIndex >= toIndex)
      return 0;
    var tmp0__anonymous__2_2 = dst._memory;
    var tmp1__anonymous__2_2 = dst._get_writePosition__1();
    var tmp2__anonymous__2_2 = dst._get_limit__1();
    var tmp3__anonymous__3 = tmp0__anonymous__2_2.slice_0(tmp1__anonymous__2_2, tmp2__anonymous__2_2 - tmp1__anonymous__2_2 | 0)._view;
    var i8_4 = new Int8Array(tmp3__anonymous__3.buffer, tmp3__anonymous__3.byteOffset, tmp3__anonymous__3.byteLength);
    var writeIndex_5 = 0;
    var inductionVariable = fromIndex;
    if (inductionVariable < toIndex)
      do {
        var index_7 = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var character_8 = charSequenceGet(input, index_7).toInt_5();
        if (character_8 > 255) {
          failedToMapError(character_8);
        }var tmp1_10 = writeIndex_5;
        writeIndex_5 = tmp1_10 + 1 | 0;
        var tmp0_set_0_9 = tmp1_10;
        var tmp1_set_0_11 = toByte_0(character_8);
        i8_4[tmp0_set_0_9] = tmp1_set_0_11;
      }
       while (inductionVariable < toIndex);
    var rc_1 = writeIndex_5;
    dst.commitWritten_1(rc_1);
    Unit_getInstance();
    return toIndex - fromIndex | 0;
  }
  function failedToMapError(ch) {
    throw new MalformedInputException('' + 'The character with unicode point ' + ch + " couldn't be mapped to ISO-8859-1 character");
  }
  function threadLocal(value) {
    var tmp = _no_name_provided_$factory_98(value);
    return new sam$kotlin_properties_ReadOnlyProperty$0(tmp);
  }
  function _no_name_provided__124($value) {
    this._$value = $value;
    this._value_25 = this._$value;
  }
  _no_name_provided__124.prototype.getValue_8 = function (thisRef, property) {
    return this._value_25;
  };
  _no_name_provided__124.prototype.getValue_10 = function (thisRef, property) {
    return this.getValue_8(isObject(thisRef) ? thisRef : THROW_CCE(), property);
  };
  _no_name_provided__124.prototype.setValue_6 = function (thisRef, property, value) {
    this._value_25 = value;
  };
  _no_name_provided__124.prototype.setValue_7 = function (thisRef, property, value) {
    var tmp = isObject(thisRef) ? thisRef : THROW_CCE();
    return this.setValue_6(tmp, property, (value == null ? true : isObject(value)) ? value : THROW_CCE());
  };
  _no_name_provided__124.$metadata$ = {
    kind: 'class',
    interfaces: [ReadWriteProperty]
  };
  function sam$kotlin_properties_ReadOnlyProperty$0(function_0) {
    this._function = function_0;
  }
  sam$kotlin_properties_ReadOnlyProperty$0.prototype.getValue_10 = function (thisRef, property) {
    return this._function(thisRef, property);
  };
  sam$kotlin_properties_ReadOnlyProperty$0.$metadata$ = {
    simpleName: 'sam$kotlin_properties_ReadOnlyProperty$0',
    kind: 'class',
    interfaces: [ReadOnlyProperty]
  };
  function _no_name_provided__125($value) {
    this._$value_0 = $value;
  }
  _no_name_provided__125.prototype.invoke_189 = function (thisRef, property) {
    return this._$value_0;
  };
  _no_name_provided__125.prototype.invoke_537 = function (p1, p2) {
    var tmp = isObject(p1) ? p1 : THROW_CCE();
    return this.invoke_189(tmp, (!(p2 == null) ? isInterface(p2, KProperty) : false) ? p2 : THROW_CCE());
  };
  _no_name_provided__125.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided_$factory_98($value) {
    var i = new _no_name_provided__125($value);
    return function (p1, p2) {
      return i.invoke_189(p1, p2);
    };
  }
  function AbstractInputSharedState(head, remaining) {
    this._head_2 = head;
    this._headMemory = this._head_2._get_memory__1();
    this._headPosition = this._head_2._get_readPosition__1();
    this._headEndExclusive = this._head_2._get_writePosition__1();
    var tmp = this;
    var tmp0_minus_0 = this._headEndExclusive - this._headPosition | 0;
    tmp._tailRemaining = remaining.minus_29(toLong_0(tmp0_minus_0));
  }
  AbstractInputSharedState.$metadata$ = {
    simpleName: 'AbstractInputSharedState',
    kind: 'class',
    interfaces: []
  };
  function AbstractOutputSharedState() {
    this._head_3 = null;
    this._tail_0 = null;
    this._tailMemory = Companion_getInstance_38()._Empty_0;
    this._tailPosition = 0;
    this._tailEndExclusive = 0;
    this._tailInitialPosition = 0;
    this._chainedSize = 0;
  }
  AbstractOutputSharedState.$metadata$ = {
    simpleName: 'AbstractOutputSharedState',
    kind: 'class',
    interfaces: []
  };
  function BufferSharedState(limit) {
    this._limit_4 = limit;
    this._readPosition = 0;
    this._writePosition = 0;
    this._startGap = 0;
    this._attachment = null;
  }
  BufferSharedState.$metadata$ = {
    simpleName: 'BufferSharedState',
    kind: 'class',
    interfaces: []
  };
  var ByteOrder_BIG_ENDIAN_instance;
  var ByteOrder_LITTLE_ENDIAN_instance;
  function Companion_41() {
    Companion_instance_40 = this;
    var buffer = new ArrayBuffer(4);
    var arr = new Int32Array(buffer);
    var view = new DataView(buffer);
    var tmp0_set_0 = 0;
    var tmp1_set_0 = 287454020;
    arr[tmp0_set_0] = tmp1_set_0;
    this._native = view.getInt32(0, true) === 287454020 ? ByteOrder_LITTLE_ENDIAN_getInstance() : ByteOrder_BIG_ENDIAN_getInstance();
  }
  Companion_41.prototype.nativeOrder = function () {
    return this._native;
  };
  Companion_41.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_40;
  function Companion_getInstance_40() {
    if (Companion_instance_40 == null)
      new Companion_41();
    return Companion_instance_40;
  }
  var ByteOrder_entriesInitialized;
  function ByteOrder_initEntries() {
    if (ByteOrder_entriesInitialized)
      return Unit_getInstance();
    ByteOrder_entriesInitialized = true;
    ByteOrder_BIG_ENDIAN_instance = new ByteOrder('BIG_ENDIAN', 0);
    ByteOrder_LITTLE_ENDIAN_instance = new ByteOrder('LITTLE_ENDIAN', 1);
    Companion_getInstance_40();
  }
  function ByteOrder(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  ByteOrder.$metadata$ = {
    simpleName: 'ByteOrder',
    kind: 'class',
    interfaces: []
  };
  function ByteOrder_BIG_ENDIAN_getInstance() {
    ByteOrder_initEntries();
    return ByteOrder_BIG_ENDIAN_instance;
  }
  function ByteOrder_LITTLE_ENDIAN_getInstance() {
    ByteOrder_initEntries();
    return ByteOrder_LITTLE_ENDIAN_instance;
  }
  function Closeable() {
  }
  Closeable.$metadata$ = {
    simpleName: 'Closeable',
    kind: 'interface',
    interfaces: []
  };
  function Input() {
  }
  Input.$metadata$ = {
    simpleName: 'Input',
    kind: 'interface',
    interfaces: [Closeable]
  };
  function _no_name_provided__2_4($instance) {
    this._$instance = $instance;
    RequireFailureCapture.call(this);
  }
  _no_name_provided__2_4.prototype.doFail_3_4 = function () {
    throw IllegalArgumentException_init_$Create$_0('' + 'unable to recycle buffer: buffer view is in use (refCount = ' + this._$instance._get_referenceCount__0() + ')');
  };
  _no_name_provided__2_4.$metadata$ = {
    simpleName: '<no name provided>_2',
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__2_5() {
    RequireFailureCapture.call(this);
  }
  _no_name_provided__2_5.prototype.doFail_3_4 = function () {
    throw IllegalArgumentException_init_$Create$_0("Unable to recycle buffer view: view copy shouldn't be recycled");
  };
  _no_name_provided__2_5.$metadata$ = {
    simpleName: '<no name provided>_2',
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__126() {
    DefaultPool.call(this, 100);
  }
  _no_name_provided__126.prototype.produceInstance_4 = function () {
    return new IoBuffer(DefaultAllocator_getInstance().alloc_0(4096), null);
  };
  _no_name_provided__126.prototype.clearInstance_1 = function (instance) {
    var tmp0_apply_0 = DefaultPool.prototype.clearInstance_5.call(this, instance);
    tmp0_apply_0.unpark_0();
    tmp0_apply_0.reset_2();
    return tmp0_apply_0;
  };
  _no_name_provided__126.prototype.clearInstance_5 = function (instance) {
    return this.clearInstance_1(instance instanceof IoBuffer ? instance : THROW_CCE());
  };
  _no_name_provided__126.prototype.validateInstance_1 = function (instance) {
    DefaultPool.prototype.validateInstance_3.call(this, instance);
    var tmp0_require_0 = instance._get_referenceCount__0() === 0;
    if (!tmp0_require_0) {
      var m_1 = new _no_name_provided__2_4(instance);
      m_1.doFail_3_4();
    }var tmp1_require_0 = instance._get_origin__0() == null;
    if (!tmp1_require_0) {
      var m_1_0 = new _no_name_provided__2_5();
      m_1_0.doFail_3_4();
    }};
  _no_name_provided__126.prototype.validateInstance_3 = function (instance) {
    return this.validateInstance_1(instance instanceof IoBuffer ? instance : THROW_CCE());
  };
  _no_name_provided__126.prototype.disposeInstance_1 = function (instance) {
    DefaultAllocator_getInstance().free_0(instance._get_memory__1());
    instance.unlink_0();
  };
  _no_name_provided__126.prototype.disposeInstance_3 = function (instance) {
    return this.disposeInstance_1(instance instanceof IoBuffer ? instance : THROW_CCE());
  };
  _no_name_provided__126.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__127() {
    NoPoolImpl.call(this);
  }
  _no_name_provided__127.prototype.borrow_12 = function () {
    return new IoBuffer(DefaultAllocator_getInstance().alloc_0(4096), null);
  };
  _no_name_provided__127.prototype.recycle_12 = function (instance) {
    DefaultAllocator_getInstance().free_0(instance._get_memory__1());
  };
  _no_name_provided__127.prototype.recycle_14 = function (instance) {
    return this.recycle_12(instance instanceof IoBuffer ? instance : THROW_CCE());
  };
  _no_name_provided__127.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function Companion_42() {
    Companion_instance_41 = this;
    this._EmptyBuffer = new ArrayBuffer(0);
    this._EmptyDataView = new DataView(this._EmptyBuffer);
    this._Empty_1 = new IoBuffer(Companion_getInstance_38()._Empty_0, null);
    var tmp = this;
    tmp._Pool_0 = new _no_name_provided__126();
    var tmp_0 = this;
    tmp_0._NoPool_0 = new _no_name_provided__127();
    this._EmptyPool_0 = EmptyBufferPoolImpl_getInstance();
  }
  Companion_42.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_41;
  function Companion_getInstance_41() {
    if (Companion_instance_41 == null)
      new Companion_42();
    return Companion_instance_41;
  }
  function IoBuffer(memory, origin) {
    Companion_getInstance_41();
    ChunkBuffer.call(this, memory, origin);
  }
  IoBuffer.prototype._get_endOfInput__4 = function () {
    return this._get_writePosition__1() === this._get_readPosition__1();
  };
  IoBuffer.prototype.peekTo_4 = function (destination, destinationOffset, offset, min, max) {
    return peekTo(this instanceof Buffer ? this : THROW_CCE(), destination, destinationOffset, offset, min, max);
  };
  IoBuffer.prototype.append_30 = function (csq, start, end) {
    var tmp0_elvis_lhs = csq;
    var idx = appendChars(this, tmp0_elvis_lhs == null ? 'null' : tmp0_elvis_lhs, start, end);
    if (!(idx === end))
      throw IllegalStateException_init_$Create$('Not enough free space to append char sequence');
    return this;
  };
  IoBuffer.prototype.append_31 = function (csq) {
    return csq == null ? this.append_31('null') : this.append_30(csq, 0, charSequenceLength(csq));
  };
  IoBuffer.prototype.append_32 = function (c) {
    append_0(this instanceof Buffer ? this : THROW_CCE(), c);
    Unit_getInstance();
    return this;
  };
  IoBuffer.prototype.close_39 = function () {
    throw UnsupportedOperationException_init_$Create$_0('close for buffer view is not supported');
  };
  IoBuffer.prototype.toString = function () {
    var tmp = this._get_writePosition__1() - this._get_readPosition__1() | 0;
    var tmp_0 = this._get_limit__1() - this._get_writePosition__1() | 0;
    var tmp_1 = this._get_startGap__1();
    return '' + 'Buffer[readable = ' + tmp + ', writable = ' + tmp_0 + ', startGap = ' + tmp_1 + ', endGap = ' + (this._capacity_0 - this._get_limit__1() | 0) + ']';
  };
  IoBuffer.$metadata$ = {
    simpleName: 'IoBuffer',
    kind: 'class',
    interfaces: [Input, Output]
  };
  function writeFully_4(_this_, src, offset, length) {
    var tmp0__anonymous__2 = _this_._memory;
    var tmp1__anonymous__2 = _this_._get_writePosition__1();
    var tmp2__anonymous__2 = _this_._get_limit__1();
    if ((tmp2__anonymous__2 - tmp1__anonymous__2 | 0) < length) {
      throw new InsufficientSpaceException('' + 'Not enough free space to write ' + length + ' bytes');
    }copyTo_0(src, tmp0__anonymous__2, offset, length, tmp1__anonymous__2);
    var rc_1 = length;
    _this_.commitWritten_1(rc_1);
    Unit_getInstance();
  }
  function writeFully$default_1(_this_, src, offset, length, $mask0, $handler) {
    if (!(($mask0 & 2) === 0))
      offset = 0;
    if (!(($mask0 & 4) === 0))
      length = src.byteLength - offset | 0;
    return writeFully_4(_this_, src, offset, length);
  }
  function Output() {
  }
  Output.$metadata$ = {
    simpleName: 'Output',
    kind: 'interface',
    interfaces: [Appendable, Closeable]
  };
  var PACKET_MAX_COPY_SIZE;
  function BytePacketBuilder_0(headerSizeHint) {
    return new BytePacketBuilder(headerSizeHint, Companion_getInstance_36()._Pool);
  }
  function BytePacketBuilder$default(headerSizeHint, $mask0, $handler) {
    if (!(($mask0 & 1) === 0))
      headerSizeHint = 0;
    return BytePacketBuilder_0(headerSizeHint);
  }
  function String_0(bytes, offset, length, charset_1) {
    if ((offset < 0 ? true : length < 0) ? true : (offset + length | 0) > bytes.length) {
      checkIndices(offset, length, bytes);
    }var i8 = bytes;
    var bufferOffset = i8.byteOffset + offset | 0;
    var buffer = i8.buffer.slice(bufferOffset, bufferOffset + length | 0);
    var tmp = Companion_getInstance_38();
    var view = new IoBuffer(of$default(tmp, buffer, 0, 0, 6, null), null);
    view.resetForRead_0();
    var packet = ByteReadPacket_init_$Create$(view, Companion_getInstance_36()._NoPoolManuallyManaged);
    return decode(charset_1.newDecoder_0(), packet, IntCompanionObject_getInstance()._MAX_VALUE_5);
  }
  function String$default(bytes, offset, length, charset_1, $mask0, $handler) {
    if (!(($mask0 & 2) === 0))
      offset = 0;
    if (!(($mask0 & 4) === 0))
      length = bytes.length;
    if (!(($mask0 & 8) === 0))
      charset_1 = Charsets_getInstance()._UTF_8;
    return String_0(bytes, offset, length, charset_1);
  }
  function checkIndices(offset, length, bytes) {
    var tmp0_require_0 = offset >= 0;
    if (!tmp0_require_0) {
      throw IndexOutOfBoundsException_init_$Create$_0('' + 'offset (' + offset + ") shouldn't be negative");
    }var tmp1_require_0 = length >= 0;
    if (!tmp1_require_0) {
      throw IndexOutOfBoundsException_init_$Create$_0('' + 'length (' + length + ") shouldn't be negative");
    }var tmp2_require_0 = (offset + length | 0) <= bytes.length;
    if (!tmp2_require_0) {
      throw IndexOutOfBoundsException_init_$Create$_0('' + 'offset (' + offset + ') + length (' + length + ') > bytes.size (' + bytes.length + ')');
    }throw IndexOutOfBoundsException_init_$Create$();
  }
  function EOFException(message) {
    IOException_init_$Init$(message, this);
    captureStack(this, EOFException);
  }
  EOFException.$metadata$ = {
    simpleName: 'EOFException',
    kind: 'class',
    interfaces: []
  };
  function IOException_init_$Init$(message, $this) {
    IOException.call($this, message, null);
    return $this;
  }
  function IOException(message, cause) {
    Exception_init_$Init$_1(message, cause, this);
    captureStack(this, IOException);
  }
  IOException.$metadata$ = {
    simpleName: 'IOException',
    kind: 'class',
    interfaces: []
  };
  var IS_NODE;
  var STREAM_TRUE;
  var FATAL_TRUE;
  function TextDecoderFatal(encoding, fatal) {
    if (IS_NODE ? true : typeof TextDecoder == 'undefined') {
      var module_0 = require('text-encoding');
      if (module_0.TextDecoder === undefined)
        throw IllegalStateException_init_$Create$('TextDecoder is not supported by your browser and no text-encoding module found');
      var ctor = module_0.TextDecoder;
      var objPrototype = Object.create(ctor.prototype);
      return fatal ? ctor.call(objPrototype, encoding, FATAL_TRUE) : ctor.call(objPrototype, encoding);
    }return fatal ? new TextDecoder(encoding, FATAL_TRUE) : new TextDecoder(encoding);
  }
  function IS_NODE$init$() {
    var tmp = typeof process !== 'undefined' && process.versions != null && process.versions.node != null;
    return (!(tmp == null) ? typeof tmp === 'boolean' : false) ? tmp : THROW_CCE();
  }
  function STREAM_TRUE$init$() {
    var tmp0_apply_0 = new Object();
    var tmp0_with_0_2 = tmp0_apply_0;
    tmp0_with_0_2.stream = true;
    return tmp0_apply_0;
  }
  function FATAL_TRUE$init$() {
    var tmp0_apply_0 = new Object();
    var tmp0_with_0_2 = tmp0_apply_0;
    tmp0_with_0_2.fatal = true;
    return tmp0_apply_0;
  }
  function TextEncoderCtor() {
    if (typeof TextEncoder == 'undefined') {
      var module_0 = require('text-encoding');
      if (module_0.TextEncoder === undefined)
        throw IllegalStateException_init_$Create$('TextEncoder is not supported by your browser and no text-encoding module found');
      var ctor = module_0.TextEncoder;
      var objPrototype = Object.create(ctor.prototype);
      return ctor.call(objPrototype);
    }return new TextEncoder();
  }
  function DefaultPool(capacity) {
    this._capacity_1 = capacity;
    var tmp = this;
    var tmp0_arrayOfNulls_0 = this._capacity_1;
    tmp._instances = fillArrayVal(Array(tmp0_arrayOfNulls_0), null);
    this._size_4 = 0;
  }
  DefaultPool.prototype.disposeInstance_3 = function (instance) {
  };
  DefaultPool.prototype.clearInstance_5 = function (instance) {
    return instance;
  };
  DefaultPool.prototype.validateInstance_3 = function (instance) {
  };
  DefaultPool.prototype.borrow_12 = function () {
    if (this._size_4 === 0)
      return this.produceInstance_4();
    var tmp0_this = this;
    tmp0_this._size_4 = tmp0_this._size_4 - 1 | 0;
    var idx = tmp0_this._size_4;
    var tmp = this._instances[idx];
    var instance = isObject(tmp) ? tmp : THROW_CCE();
    this._instances[idx] = null;
    return this.clearInstance_5(instance);
  };
  DefaultPool.prototype.recycle_14 = function (instance) {
    this.validateInstance_3(instance);
    if (this._size_4 === this._capacity_1) {
      this.disposeInstance_3(instance);
    } else {
      var tmp0_this = this;
      var tmp1 = tmp0_this._size_4;
      tmp0_this._size_4 = tmp1 + 1 | 0;
      this._instances[tmp1] = instance;
    }
  };
  DefaultPool.prototype.dispose_26 = function () {
    var inductionVariable = 0;
    var last_1 = this._size_4;
    if (inductionVariable < last_1)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var tmp = this._instances[i];
        var instance = isObject(tmp) ? tmp : THROW_CCE();
        this._instances[i] = null;
        this.disposeInstance_3(instance);
      }
       while (inductionVariable < last_1);
    this._size_4 = 0;
  };
  DefaultPool.$metadata$ = {
    simpleName: 'DefaultPool',
    kind: 'class',
    interfaces: [ObjectPool]
  };
  function AttributeKey(name) {
    this._name_5 = name;
  }
  AttributeKey.prototype.toString = function () {
    var tmp;
    var tmp0_isEmpty_0 = this._name_5;
    if (charSequenceLength(tmp0_isEmpty_0) === 0) {
      tmp = anyToString(this);
    } else {
      {
        tmp = '' + 'AttributeKey: ' + this._name_5;
      }
    }
    return tmp;
  };
  AttributeKey.$metadata$ = {
    simpleName: 'AttributeKey',
    kind: 'class',
    interfaces: []
  };
  function Attributes() {
  }
  Attributes.prototype.get_65 = function (key) {
    var tmp0_elvis_lhs = this.getOrNull_0(key);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      throw IllegalStateException_init_$Create$('' + 'No instance for key ' + key);
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  };
  Attributes.$metadata$ = {
    simpleName: 'Attributes',
    kind: 'interface',
    interfaces: []
  };
  var BASE64_INVERSE_ALPHABET;
  function encodeBase64(_this_) {
    var tmp$ret$0;
    l$ret$1: do {
      var tmp0_buildPacket_0 = 0;
      var builder_1 = BytePacketBuilder_0(tmp0_buildPacket_0);
      try {
        writeFully$default(builder_1, _this_, 0, 0, 6, null);
        tmp$ret$0 = builder_1.build_16();
        break l$ret$1;
      } catch ($p) {
        if ($p instanceof Error) {
          builder_1.release_4();
          throw $p;
        } else {
          {
            throw $p;
          }
        }
      }
    }
     while (false);
    return encodeBase64_0(tmp$ret$0);
  }
  function encodeBase64_0(_this_) {
    var tmp0_apply_0_1 = StringBuilder_init_$Create$_0();
    var data_3 = new Int8Array(3);
    while (_this_._get_remaining__2().compareTo_69(new Long(0, 0)) > 0) {
      var read_4 = readAvailable$default(_this_, data_3, 0, 0, 6, null);
      clearFrom(data_3, read_4);
      var padSize_5 = imul(data_3.length - read_4 | 0, 8) / 6 | 0;
      var chunk_6 = (data_3[0] & 255) << 16 | (data_3[1] & 255) << 8 | data_3[2] & 255;
      var inductionVariable = data_3.length;
      if (padSize_5 <= inductionVariable)
        do {
          var index_8 = inductionVariable;
          inductionVariable = inductionVariable + -1 | 0;
          var char_9 = chunk_6 >> imul(6, index_8) & 63;
          tmp0_apply_0_1.append_32(toBase64(char_9));
          Unit_getInstance();
        }
         while (!(index_8 === padSize_5));
      var inductionVariable_0 = 0;
      if (inductionVariable_0 < padSize_5)
        do {
          var index_2_11 = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          tmp0_apply_0_1.append_32(new Char(61));
          Unit_getInstance();
        }
         while (inductionVariable_0 < padSize_5);
    }
    return tmp0_apply_0_1.toString();
  }
  function clearFrom(_this_, from) {
    var tmp0_forEach_0 = until(from, _this_.length);
    var inductionVariable = tmp0_forEach_0._get_first__2();
    var last_1 = tmp0_forEach_0._get_last__2();
    if (inductionVariable <= last_1)
      do {
        var element_2 = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        _this_[element_2] = 0;
      }
       while (!(element_2 === last_1));
  }
  function toBase64(_this_) {
    return charSequenceGet('ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/', _this_);
  }
  function BASE64_INVERSE_ALPHABET$init$() {
    var tmp = 0;
    var tmp_0 = 256;
    var tmp_1 = new Int32Array(tmp_0);
    while (tmp < tmp_0) {
      var tmp_2 = tmp;
      var tmp_3 = numberToChar(tmp_2);
      tmp_1[tmp_2] = indexOf$default('ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/', tmp_3, 0, false, 6, null);
      tmp = tmp + 1 | 0;
    }
    return tmp_1;
  }
  function toByteArray_0(_this_, $cont) {
    var tmp = new $toByteArrayCOROUTINE$0(_this_, $cont);
    tmp._result = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_72();
  }
  function $toByteArrayCOROUTINE$0(_this_, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__16 = _this_;
  }
  $toByteArrayCOROUTINE$0.prototype.doResume_72 = function () {
    var suspendResult = this._result;
    $sm: do
      try {
        var tmp = this._state_0;
        switch (tmp) {
          case 0:
            this._exceptionState = 2;
            this._state_0 = 1;
            suspendResult = readRemaining(this.__this__16, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            var ARGUMENT = suspendResult;
            return readBytes$default(ARGUMENT, 0, 1, null);
          case 2:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 2) {
          throw $p;
        } else {
          this._state_0 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $toByteArrayCOROUTINE$0.$metadata$ = {
    simpleName: '$toByteArrayCOROUTINE$0',
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__128() {
  }
  _no_name_provided__128.prototype.invoke_191 = function (_this__0) {
    return _this__0._content_3;
  };
  _no_name_provided__128.prototype.invoke_542 = function (p1) {
    return this.invoke_191(p1 instanceof CaseInsensitiveString ? p1 : THROW_CCE());
  };
  _no_name_provided__128.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__129() {
  }
  _no_name_provided__129.prototype.invoke_229 = function (_this__0) {
    return caseInsensitive(_this__0);
  };
  _no_name_provided__129.prototype.invoke_542 = function (p1) {
    return this.invoke_229((!(p1 == null) ? typeof p1 === 'string' : false) ? p1 : THROW_CCE());
  };
  _no_name_provided__129.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__130() {
  }
  _no_name_provided__130.prototype.invoke_195 = function (_this__0) {
    return new Entry_0(_this__0._get_key__47()._content_3, _this__0._get_value__33());
  };
  _no_name_provided__130.prototype.invoke_542 = function (p1) {
    return this.invoke_195((!(p1 == null) ? isInterface(p1, MutableEntry) : false) ? p1 : THROW_CCE());
  };
  _no_name_provided__130.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__131() {
  }
  _no_name_provided__131.prototype.invoke_197 = function (_this__0) {
    return new Entry_0(caseInsensitive(_this__0._get_key__47()), _this__0._get_value__33());
  };
  _no_name_provided__131.prototype.invoke_542 = function (p1) {
    return this.invoke_197((!(p1 == null) ? isInterface(p1, MutableEntry) : false) ? p1 : THROW_CCE());
  };
  _no_name_provided__131.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function CaseInsensitiveMap() {
    var tmp = this;
    tmp._delegate_2 = LinkedHashMap_init_$Create$();
  }
  CaseInsensitiveMap.prototype._get_size__45 = function () {
    return this._delegate_2._get_size__45();
  };
  CaseInsensitiveMap.prototype.containsKey_13 = function (key) {
    return this._delegate_2.containsKey_16(new CaseInsensitiveString(key));
  };
  CaseInsensitiveMap.prototype.containsKey_16 = function (key) {
    if (!(!(key == null) ? typeof key === 'string' : false))
      return false;
    else {
    }
    return this.containsKey_13((!(key == null) ? typeof key === 'string' : false) ? key : THROW_CCE());
  };
  CaseInsensitiveMap.prototype.get_69 = function (key) {
    return this._delegate_2.get_63(caseInsensitive(key));
  };
  CaseInsensitiveMap.prototype.get_63 = function (key) {
    if (!(!(key == null) ? typeof key === 'string' : false))
      return null;
    else {
    }
    return this.get_69((!(key == null) ? typeof key === 'string' : false) ? key : THROW_CCE());
  };
  CaseInsensitiveMap.prototype.isEmpty_53 = function () {
    return this._delegate_2.isEmpty_53();
  };
  CaseInsensitiveMap.prototype.clear_27 = function () {
    this._delegate_2.clear_27();
  };
  CaseInsensitiveMap.prototype.put_9 = function (key, value) {
    return this._delegate_2.put_12(caseInsensitive(key), value);
  };
  CaseInsensitiveMap.prototype.put_12 = function (key, value) {
    var tmp = (!(key == null) ? typeof key === 'string' : false) ? key : THROW_CCE();
    return this.put_9(tmp, (value == null ? true : isObject(value)) ? value : THROW_CCE());
  };
  CaseInsensitiveMap.prototype.putAll_5 = function (from) {
    var tmp0_iterator_1 = from._get_entries__10().iterator_64();
    while (tmp0_iterator_1.hasNext_31()) {
      var element_2 = tmp0_iterator_1.next_35();
      var key_4 = element_2._get_key__47();
      var value_5 = element_2._get_value__33();
      this.put_9(key_4, value_5);
      Unit_getInstance();
    }
  };
  CaseInsensitiveMap.prototype.putAll_8 = function (from) {
    return this.putAll_5(from);
  };
  CaseInsensitiveMap.prototype.remove_38 = function (key) {
    return this._delegate_2.remove_45(caseInsensitive(key));
  };
  CaseInsensitiveMap.prototype.remove_45 = function (key) {
    if (!(!(key == null) ? typeof key === 'string' : false))
      return null;
    else {
    }
    return this.remove_38((!(key == null) ? typeof key === 'string' : false) ? key : THROW_CCE());
  };
  CaseInsensitiveMap.prototype._get_keys__10 = function () {
    var tmp = this._delegate_2._get_keys__10();
    var tmp_0 = _no_name_provided_$factory_99();
    return new DelegatingMutableSet(tmp, tmp_0, _no_name_provided_$factory_100());
  };
  CaseInsensitiveMap.prototype._get_entries__10 = function () {
    var tmp = this._delegate_2._get_entries__10();
    var tmp_0 = _no_name_provided_$factory_101();
    return new DelegatingMutableSet(tmp, tmp_0, _no_name_provided_$factory_102());
  };
  CaseInsensitiveMap.prototype._get_values__16 = function () {
    return this._delegate_2._get_values__16();
  };
  CaseInsensitiveMap.prototype.equals = function (other) {
    var tmp;
    if (other == null) {
      tmp = true;
    } else {
      tmp = !(other instanceof CaseInsensitiveMap);
    }
    if (tmp)
      return false;
    else {
    }
    return equals_1(other._delegate_2, this._delegate_2);
  };
  CaseInsensitiveMap.prototype.hashCode = function () {
    return hashCode(this._delegate_2);
  };
  CaseInsensitiveMap.$metadata$ = {
    simpleName: 'CaseInsensitiveMap',
    kind: 'class',
    interfaces: [MutableMap]
  };
  function Entry_0(key, value) {
    this._key_3 = key;
    this._value_26 = value;
  }
  Entry_0.prototype._get_key__47 = function () {
    return this._key_3;
  };
  Entry_0.prototype._get_value__33 = function () {
    return this._value_26;
  };
  Entry_0.prototype.setValue_10 = function (newValue) {
    this._value_26 = newValue;
    return this._value_26;
  };
  Entry_0.prototype.setValue_11 = function (newValue) {
    return this.setValue_10((newValue == null ? true : isObject(newValue)) ? newValue : THROW_CCE());
  };
  Entry_0.prototype.hashCode = function () {
    return (527 + hashCode(ensureNotNull(this._key_3)) | 0) + hashCode(ensureNotNull(this._value_26)) | 0;
  };
  Entry_0.prototype.equals = function (other) {
    var tmp;
    if (other == null) {
      tmp = true;
    } else {
      tmp = !(!(other == null) ? isInterface(other, Entry) : false);
    }
    if (tmp)
      return false;
    else {
    }
    return equals_1(other._get_key__47(), this._key_3) ? equals_1(other._get_value__33(), this._value_26) : false;
  };
  Entry_0.prototype.toString = function () {
    return '' + this._key_3 + '=' + this._value_26;
  };
  Entry_0.$metadata$ = {
    simpleName: 'Entry',
    kind: 'class',
    interfaces: [MutableEntry]
  };
  function _no_name_provided_$factory_99() {
    var i = new _no_name_provided__128();
    return function (p1) {
      return i.invoke_191(p1);
    };
  }
  function _no_name_provided_$factory_100() {
    var i = new _no_name_provided__129();
    return function (p1) {
      return i.invoke_229(p1);
    };
  }
  function _no_name_provided_$factory_101() {
    var i = new _no_name_provided__130();
    return function (p1) {
      return i.invoke_195(p1);
    };
  }
  function _no_name_provided_$factory_102() {
    var i = new _no_name_provided__131();
    return function (p1) {
      return i.invoke_197(p1);
    };
  }
  function toCharArray(_this_) {
    var tmp = 0;
    var tmp_0 = _this_.length;
    var tmp_1 = charArray(tmp_0);
    while (tmp < tmp_0) {
      var tmp_2 = tmp;
      tmp_1[tmp_2] = charSequenceGet(_this_, tmp_2);
      tmp = tmp + 1 | 0;
    }
    return tmp_1;
  }
  function isLowerCase(_this_) {
    var tmp0_asDynamic_0_2 = _this_.toString();
    var tmp1_unsafeCast_0_1 = tmp0_asDynamic_0_2.toLowerCase().charCodeAt(0);
    return numberToChar(tmp1_unsafeCast_0_1).equals(_this_);
  }
  function caseInsensitiveMap() {
    return new CaseInsensitiveMap();
  }
  function SilentSupervisor(parent) {
    var tmp = SupervisorJob(parent);
    return tmp.plus_28(new _no_name_provided__1_2());
  }
  function SilentSupervisor$default(parent, $mask0, $handler) {
    if (!(($mask0 & 1) === 0))
      parent = null;
    return SilentSupervisor(parent);
  }
  function _no_name_provided__1_2() {
    AbstractCoroutineContextElement.call(this, Key_getInstance_1());
  }
  _no_name_provided__1_2.prototype.handleException_2 = function (context, exception) {
    return Unit_getInstance();
  };
  _no_name_provided__1_2.prototype.handleException_0 = function (context, exception) {
    return this.handleException_2(context, exception);
  };
  _no_name_provided__1_2.$metadata$ = {
    simpleName: '<no name provided>_1',
    kind: 'class',
    interfaces: [CoroutineExceptionHandler]
  };
  var digits;
  function _no_name_provided__132(this$0) {
    this._this$0_32 = this$0;
    this._delegateIterator = this._this$0_32._delegate_3.iterator_64();
  }
  _no_name_provided__132.prototype.hasNext_31 = function () {
    return this._delegateIterator.hasNext_31();
  };
  _no_name_provided__132.prototype.next_35 = function () {
    return this._this$0_32._convertTo(this._delegateIterator.next_35());
  };
  _no_name_provided__132.prototype.remove_51 = function () {
    return this._delegateIterator.remove_51();
  };
  _no_name_provided__132.$metadata$ = {
    kind: 'class',
    interfaces: [MutableIterator]
  };
  function DelegatingMutableSet(delegate, convertTo, convert) {
    this._delegate_3 = delegate;
    this._convertTo = convertTo;
    this._convert = convert;
    this._size_5 = this._delegate_3._get_size__45();
  }
  DelegatingMutableSet.prototype.convert = function (_this__0) {
    var tmp0_mapTo_0_1 = ArrayList_init_$Create$_0(collectionSizeOrDefault(_this__0, 10));
    var tmp0_iterator_1_2 = _this__0.iterator_64();
    while (tmp0_iterator_1_2.hasNext_31()) {
      var item_2_3 = tmp0_iterator_1_2.next_35();
      tmp0_mapTo_0_1.add_33(this._convert(item_2_3));
      Unit_getInstance();
    }
    return tmp0_mapTo_0_1;
  };
  DelegatingMutableSet.prototype.convertTo = function (_this__0) {
    var tmp0_mapTo_0_1 = ArrayList_init_$Create$_0(collectionSizeOrDefault(_this__0, 10));
    var tmp0_iterator_1_2 = _this__0.iterator_64();
    while (tmp0_iterator_1_2.hasNext_31()) {
      var item_2_3 = tmp0_iterator_1_2.next_35();
      tmp0_mapTo_0_1.add_33(this._convertTo(item_2_3));
      Unit_getInstance();
    }
    return tmp0_mapTo_0_1;
  };
  DelegatingMutableSet.prototype._get_size__45 = function () {
    return this._size_5;
  };
  DelegatingMutableSet.prototype.add_22 = function (element) {
    return this._delegate_3.add_33(this._convert(element));
  };
  DelegatingMutableSet.prototype.add_33 = function (element) {
    return this.add_22((element == null ? true : isObject(element)) ? element : THROW_CCE());
  };
  DelegatingMutableSet.prototype.addAll_14 = function (elements) {
    return this._delegate_3.addAll_23(this.convert(elements));
  };
  DelegatingMutableSet.prototype.addAll_23 = function (elements) {
    return this.addAll_14(elements);
  };
  DelegatingMutableSet.prototype.clear_27 = function () {
    this._delegate_3.clear_27();
  };
  DelegatingMutableSet.prototype.contains_38 = function (element) {
    return this._delegate_3.contains_51(this._convert(element));
  };
  DelegatingMutableSet.prototype.contains_51 = function (element) {
    if (!(element == null ? true : isObject(element)))
      return false;
    else {
    }
    return this.contains_38((element == null ? true : isObject(element)) ? element : THROW_CCE());
  };
  DelegatingMutableSet.prototype.containsAll_27 = function (elements) {
    return this._delegate_3.containsAll_38(this.convert(elements));
  };
  DelegatingMutableSet.prototype.containsAll_38 = function (elements) {
    return this.containsAll_27(elements);
  };
  DelegatingMutableSet.prototype.isEmpty_53 = function () {
    return this._delegate_3.isEmpty_53();
  };
  DelegatingMutableSet.prototype.iterator_64 = function () {
    return new _no_name_provided__132(this);
  };
  DelegatingMutableSet.prototype.hashCode = function () {
    return hashCode(this._delegate_3);
  };
  DelegatingMutableSet.prototype.equals = function (other) {
    var tmp;
    if (other == null) {
      tmp = true;
    } else {
      tmp = !(!(other == null) ? isInterface(other, Set) : false);
    }
    if (tmp)
      return false;
    else {
    }
    var elements = this.convertTo(this._delegate_3);
    var tmp_0;
    if (other.containsAll_38(elements)) {
      var tmp0_containsAll_0 = other;
      tmp_0 = elements.containsAll_38(tmp0_containsAll_0);
    } else {
      tmp_0 = false;
    }
    return tmp_0;
  };
  DelegatingMutableSet.prototype.toString = function () {
    return toString_1(this.convertTo(this._delegate_3));
  };
  DelegatingMutableSet.$metadata$ = {
    simpleName: 'DelegatingMutableSet',
    kind: 'class',
    interfaces: [MutableSet]
  };
  function Hash() {
    Hash_instance = this;
  }
  Hash.prototype.combine = function (objects) {
    return hashCode(toList(objects));
  };
  Hash.$metadata$ = {
    simpleName: 'Hash',
    kind: 'object',
    interfaces: []
  };
  var Hash_instance;
  function Hash_getInstance() {
    if (Hash_instance == null)
      new Hash();
    return Hash_instance;
  }
  function ensureListForKey($this, name, size_0) {
    if ($this._built)
      throw IllegalStateException_init_$Create$('Cannot modify a builder when final structure has already been built');
    var tmp0_elvis_lhs = $this._values_1.get_63(name);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      var tmp0_also_0 = ArrayList_init_$Create$_0(size_0);
      $this.validateName_1(name);
      var tmp0_set_0_2 = $this._values_1;
      tmp0_set_0_2.put_12(name, tmp0_also_0);
      Unit_getInstance();
      tmp = tmp0_also_0;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  }
  function _no_name_provided__133(this$0) {
    this._this$0_33 = this$0;
  }
  _no_name_provided__133.prototype.invoke_273 = function (name, values_5) {
    this._this$0_33.appendAll_3(name, values_5);
  };
  _no_name_provided__133.prototype.invoke_537 = function (p1, p2) {
    var tmp = (!(p1 == null) ? typeof p1 === 'string' : false) ? p1 : THROW_CCE();
    this.invoke_273(tmp, (!(p2 == null) ? isInterface(p2, List) : false) ? p2 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__133.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function StringValuesBuilder(caseInsensitiveName, size_0) {
    this._caseInsensitiveName = caseInsensitiveName;
    this._values_1 = this._caseInsensitiveName ? caseInsensitiveMap() : LinkedHashMap_init_$Create$_1(size_0);
    this._built = false;
  }
  StringValuesBuilder.prototype._get_values__16 = function () {
    return this._values_1;
  };
  StringValuesBuilder.prototype._set_built__1 = function (_set___) {
    this._built = _set___;
  };
  StringValuesBuilder.prototype._get_built__1 = function () {
    return this._built;
  };
  StringValuesBuilder.prototype.getAll_8 = function (name) {
    return this._values_1.get_63(name);
  };
  StringValuesBuilder.prototype.isEmpty_53 = function () {
    return this._values_1.isEmpty_53();
  };
  StringValuesBuilder.prototype.entries_9 = function () {
    return unmodifiable(this._values_1._get_entries__10());
  };
  StringValuesBuilder.prototype.set_13 = function (name, value) {
    this.validateValue_1(value);
    var list = ensureListForKey(this, name, 1);
    list.clear_27();
    list.add_33(value);
    Unit_getInstance();
  };
  StringValuesBuilder.prototype.get_69 = function (name) {
    var tmp0_safe_receiver = this.getAll_8(name);
    return tmp0_safe_receiver == null ? null : firstOrNull_0(tmp0_safe_receiver);
  };
  StringValuesBuilder.prototype.append_35 = function (name, value) {
    this.validateValue_1(value);
    ensureListForKey(this, name, 1).add_33(value);
    Unit_getInstance();
  };
  StringValuesBuilder.prototype.appendAll_1 = function (stringValues) {
    stringValues.forEach_7(_no_name_provided_$factory_103(this));
  };
  StringValuesBuilder.prototype.appendAll_3 = function (name, values_5) {
    var tmp0_safe_receiver = isInterface(values_5, Collection) ? values_5 : null;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver._get_size__45();
    var tmp0_let_0 = ensureListForKey(this, name, tmp1_elvis_lhs == null ? 2 : tmp1_elvis_lhs);
    var tmp0_iterator_1_2 = values_5.iterator_64();
    while (tmp0_iterator_1_2.hasNext_31()) {
      var element_2_3 = tmp0_iterator_1_2.next_35();
      this.validateValue_1(element_2_3);
      tmp0_let_0.add_33(element_2_3);
      Unit_getInstance();
    }
  };
  StringValuesBuilder.prototype.remove_52 = function (name) {
    this._values_1.remove_45(name);
    Unit_getInstance();
  };
  StringValuesBuilder.prototype.clear_27 = function () {
    this._values_1.clear_27();
  };
  StringValuesBuilder.prototype.validateName_1 = function (name) {
  };
  StringValuesBuilder.prototype.validateValue_1 = function (value) {
  };
  StringValuesBuilder.$metadata$ = {
    simpleName: 'StringValuesBuilder',
    kind: 'class',
    interfaces: []
  };
  function appendAll(_this_, builder) {
    var tmp0_forEach_0_2 = builder.entries_9();
    var tmp0_iterator_1_3 = tmp0_forEach_0_2.iterator_64();
    while (tmp0_iterator_1_3.hasNext_31()) {
      var element_2_4 = tmp0_iterator_1_3.next_35();
      var name_4_5 = element_2_4._get_key__47();
      var values_5_6 = element_2_4._get_value__33();
      _this_.appendAll_3(name_4_5, values_5_6);
    }
    return _this_;
  }
  function flattenEntries(_this_) {
    var tmp0_flatMap_0 = _this_.entries_9();
    var tmp0_flatMapTo_0_1 = ArrayList_init_$Create$();
    var tmp0_iterator_1_2 = tmp0_flatMap_0.iterator_64();
    while (tmp0_iterator_1_2.hasNext_31()) {
      var element_2_3 = tmp0_iterator_1_2.next_35();
      var tmp0_map_0_6 = element_2_3._get_value__33();
      var tmp0_mapTo_0_1_7 = ArrayList_init_$Create$_0(collectionSizeOrDefault(tmp0_map_0_6, 10));
      var tmp0_iterator_1_2_8 = tmp0_map_0_6.iterator_64();
      while (tmp0_iterator_1_2_8.hasNext_31()) {
        var item_2_3_9 = tmp0_iterator_1_2_8.next_35();
        tmp0_mapTo_0_1_7.add_33(to(element_2_3._get_key__47(), item_2_3_9));
        Unit_getInstance();
      }
      var list_3_4 = tmp0_mapTo_0_1_7;
      addAll(tmp0_flatMapTo_0_1, list_3_4);
      Unit_getInstance();
    }
    return tmp0_flatMapTo_0_1;
  }
  function StringValues() {
  }
  StringValues.prototype.get_69 = function (name) {
    var tmp0_safe_receiver = this.getAll_8(name);
    return tmp0_safe_receiver == null ? null : firstOrNull_0(tmp0_safe_receiver);
  };
  StringValues.prototype.contains_56 = function (name) {
    return !(this.getAll_8(name) == null);
  };
  StringValues.prototype.forEach_7 = function (body) {
    var tmp0_forEach_0 = this.entries_9();
    var tmp0_iterator_1 = tmp0_forEach_0.iterator_64();
    while (tmp0_iterator_1.hasNext_31()) {
      var element_2 = tmp0_iterator_1.next_35();
      var k_4 = element_2._get_key__47();
      var v_5 = element_2._get_value__33();
      body(k_4, v_5);
    }
    return Unit_getInstance();
  };
  StringValues.$metadata$ = {
    simpleName: 'StringValues',
    kind: 'interface',
    interfaces: []
  };
  function listForKey($this, name) {
    return $this._get_values__16().get_63(name);
  }
  function _no_name_provided__134(this$0, $values) {
    this._this$0_34 = this$0;
    this._$values = $values;
  }
  _no_name_provided__134.prototype.invoke_540 = function () {
    var tmp;
    if (this._this$0_34._get_caseInsensitiveName__4()) {
      var tmp0_apply_0 = caseInsensitiveMap();
      tmp0_apply_0.putAll_8(this._$values);
      tmp = tmp0_apply_0;
    } else {
      tmp = toMap_2(this._$values);
    }
    return tmp;
  };
  _no_name_provided__134.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function StringValuesImpl(caseInsensitiveName, values_5) {
    this._caseInsensitiveName_0 = caseInsensitiveName;
    var tmp = this;
    tmp._values$delegate = lazy(_no_name_provided_$factory_104(this, values_5));
  }
  StringValuesImpl.prototype._get_caseInsensitiveName__4 = function () {
    return this._caseInsensitiveName_0;
  };
  StringValuesImpl.prototype._get_values__16 = function () {
    var tmp0_getValue_0 = this._values$delegate;
    var tmp1_getValue_0 = values$factory();
    return tmp0_getValue_0._get_value__33();
  };
  StringValuesImpl.prototype.get_69 = function (name) {
    var tmp0_safe_receiver = listForKey(this, name);
    return tmp0_safe_receiver == null ? null : firstOrNull_0(tmp0_safe_receiver);
  };
  StringValuesImpl.prototype.getAll_8 = function (name) {
    return listForKey(this, name);
  };
  StringValuesImpl.prototype.contains_56 = function (name) {
    return !(listForKey(this, name) == null);
  };
  StringValuesImpl.prototype.isEmpty_53 = function () {
    return this._get_values__16().isEmpty_53();
  };
  StringValuesImpl.prototype.entries_9 = function () {
    return unmodifiable(this._get_values__16()._get_entries__10());
  };
  StringValuesImpl.prototype.forEach_7 = function (body) {
    var tmp0_iterator_0 = this._get_values__16();
    var tmp0_iterator = tmp0_iterator_0._get_entries__10().iterator_64();
    while (tmp0_iterator.hasNext_31()) {
      var tmp1_loop_parameter = tmp0_iterator.next_35();
      var key = tmp1_loop_parameter._get_key__47();
      var value = tmp1_loop_parameter._get_value__33();
      body(key, value);
    }
  };
  StringValuesImpl.prototype.toString = function () {
    return '' + 'StringValues(case=' + !this._get_caseInsensitiveName__4() + ') ' + this.entries_9();
  };
  StringValuesImpl.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(!(other == null) ? isInterface(other, StringValues) : false))
      return false;
    else {
    }
    if (!(this._get_caseInsensitiveName__4() === other._get_caseInsensitiveName__4()))
      return false;
    return entriesEquals(this.entries_9(), other.entries_9());
  };
  StringValuesImpl.prototype.hashCode = function () {
    return entriesHashCode(this.entries_9(), imul(31, this._get_caseInsensitiveName__4() | 0));
  };
  StringValuesImpl.$metadata$ = {
    simpleName: 'StringValuesImpl',
    kind: 'class',
    interfaces: [StringValues]
  };
  function entriesEquals(a, b) {
    return equals_1(a, b);
  }
  function entriesHashCode(entries, seed) {
    return imul(seed, 31) + hashCode(entries) | 0;
  }
  function values$factory() {
    return getPropertyCallableRef('values', 1, KProperty1, function (receiver) {
      return receiver._get_values__16();
    }, null);
  }
  function _no_name_provided_$factory_103(this$0) {
    var i = new _no_name_provided__133(this$0);
    return function (p1, p2) {
      i.invoke_273(p1, p2);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_104(this$0, $values) {
    var i = new _no_name_provided__134(this$0, $values);
    return function () {
      return i.invoke_540();
    };
  }
  function toLowerCasePreservingASCIIRules(_this_) {
    var tmp$ret$0;
    l$ret$1: do {
      var inductionVariable = 0;
      var last_1 = charSequenceLength(_this_) - 1 | 0;
      if (inductionVariable <= last_1)
        do {
          var index_2 = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var tmp0__anonymous__3 = charSequenceGet(_this_, index_2);
          if (!toLowerCasePreservingASCII(tmp0__anonymous__3).equals(tmp0__anonymous__3)) {
            tmp$ret$0 = index_2;
            break l$ret$1;
          } else {
          }
        }
         while (inductionVariable <= last_1);
      tmp$ret$0 = -1;
    }
     while (false);
    var firstIndex = tmp$ret$0;
    if (firstIndex === -1) {
      return _this_;
    }var original = _this_;
    var tmp1_buildString_0 = _this_.length;
    var tmp0_apply_0_1 = StringBuilder_init_$Create$(tmp1_buildString_0);
    tmp0_apply_0_1.append_30(original, 0, firstIndex);
    Unit_getInstance();
    var inductionVariable_0 = firstIndex;
    var last_2 = _get_lastIndex__1(original);
    if (inductionVariable_0 <= last_2)
      do {
        var index_4 = inductionVariable_0;
        inductionVariable_0 = inductionVariable_0 + 1 | 0;
        tmp0_apply_0_1.append_32(toLowerCasePreservingASCII(charSequenceGet(original, index_4)));
        Unit_getInstance();
      }
       while (!(index_4 === last_2));
    return tmp0_apply_0_1.toString();
  }
  function toLowerCasePreservingASCII(ch) {
    var tmp0_subject = ch;
    var tmp;
    if (new Char(65) <= tmp0_subject ? tmp0_subject <= new Char(90) : false) {
      tmp = ch.plus_55(32);
    } else if (new Char(0) <= tmp0_subject ? tmp0_subject <= new Char(127) : false) {
      tmp = ch;
    } else {
      var tmp0_asDynamic_0_2 = ch.toString();
      var tmp1_unsafeCast_0_1 = tmp0_asDynamic_0_2.toLowerCase().charCodeAt(0);
      tmp = numberToChar(tmp1_unsafeCast_0_1);
    }
    return tmp;
  }
  function CaseInsensitiveString(content) {
    this._content_3 = content;
    var tmp = this;
    var tmp0_toLowerCase_0 = this._content_3;
    tmp._hash = getStringHashCode(tmp0_toLowerCase_0.toLowerCase());
  }
  CaseInsensitiveString.prototype.equals = function (other) {
    var tmp0_safe_receiver = other instanceof CaseInsensitiveString ? other : null;
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver._content_3;
    return (tmp1_safe_receiver == null ? null : equals_0(tmp1_safe_receiver, this._content_3, true)) === true;
  };
  CaseInsensitiveString.prototype.hashCode = function () {
    return this._hash;
  };
  CaseInsensitiveString.prototype.toString = function () {
    return this._content_3;
  };
  CaseInsensitiveString.$metadata$ = {
    simpleName: 'CaseInsensitiveString',
    kind: 'class',
    interfaces: []
  };
  function caseInsensitive(_this_) {
    return new CaseInsensitiveString(_this_);
  }
  function sharedListOf(values_5) {
    if (PlatformUtils_getInstance()._IS_NATIVE) {
      var tmp0_apply_0 = new ConcurrentList();
      addAll_0(tmp0_apply_0, values_5);
      Unit_getInstance();
      return tmp0_apply_0;
    }var tmp1_mapTo_0 = ArrayList_init_$Create$_0(values_5.length);
    var indexedObject = values_5;
    var inductionVariable = 0;
    var last_1 = indexedObject.length;
    while (inductionVariable < last_1) {
      var item_2 = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      tmp1_mapTo_0.add_33(item_2);
      Unit_getInstance();
    }
    return tmp1_mapTo_0;
  }
  function _set_data_($this, _set___) {
    return $this._data$delegate.setValue_7($this, data$factory(), _set___);
  }
  function _get_data_($this) {
    return $this._data$delegate.getValue_10($this, data$factory_0());
  }
  function _set_size_($this, _set___) {
    return $this._size$delegate.setValue_7($this, size$factory(), _set___);
  }
  function checkIndex($this, index) {
    if (index >= $this._get_size__45() ? true : index < 0)
      throw IndexOutOfBoundsException_init_$Create$();
  }
  function increaseCapacity($this, targetCapacity) {
    var newData = new SharedList(targetCapacity);
    var inductionVariable = 0;
    var last_1 = _get_data_($this)._size_6;
    if (inductionVariable < last_1)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        newData.set_12(index, _get_data_($this).get_80(index));
      }
       while (inductionVariable < last_1);
    _set_data_($this, newData);
  }
  function increaseCapacity$default($this, targetCapacity, $mask0, $handler) {
    if (!(($mask0 & 2) === 0))
      targetCapacity = imul(_get_data_($this)._size_6, 2);
    return increaseCapacity($this, targetCapacity);
  }
  function sweep($this, firstNull) {
    var writePosition = firstNull;
    var inductionVariable = writePosition + 1 | 0;
    var last_1 = $this._get_size__45();
    if (inductionVariable < last_1)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (_get_data_($this).get_80(index) == null) {
          continue;
        }_get_data_($this).set_12(writePosition, _get_data_($this).get_80(index));
        writePosition = writePosition + 1 | 0;
      }
       while (inductionVariable < last_1);
    var inductionVariable_0 = writePosition;
    var last_2 = $this._get_size__45();
    if (inductionVariable_0 < last_2)
      do {
        var index_0 = inductionVariable_0;
        inductionVariable_0 = inductionVariable_0 + 1 | 0;
        _get_data_($this).set_12(index_0, null);
      }
       while (inductionVariable_0 < last_2);
    _set_size_($this, writePosition);
  }
  function reserve($this, index, gapSize) {
    var targetSize = gapSize + $this._get_size__45() | 0;
    while (_get_data_($this)._size_6 < targetSize) {
      increaseCapacity$default($this, 0, 2, null);
    }
    var readPosition = $this._get_size__45() - 1 | 0;
    while (readPosition >= index) {
      _get_data_($this).set_12(readPosition + gapSize | 0, _get_data_($this).get_80(readPosition));
      readPosition = readPosition - 1 | 0;
    }
    var inductionVariable = index;
    var last_1 = index + gapSize | 0;
    if (inductionVariable < last_1)
      do {
        var current = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        _get_data_($this).set_12(current, null);
      }
       while (inductionVariable < last_1);
    var tmp1_this = $this;
    _set_size_(tmp1_this, tmp1_this._get_size__45() + gapSize | 0);
  }
  function _no_name_provided__135($index, this$0) {
    this._$index = $index;
    this._this$0_35 = this$0;
    var tmp = this;
    tmp._current$delegate = new _no_name_provided__124(this._$index);
  }
  _no_name_provided__135.prototype._set_current_ = function (_set___) {
    return this._current$delegate.setValue_7(this, current$factory(), _set___);
  };
  _no_name_provided__135.prototype._get_current__0 = function () {
    return this._current$delegate.getValue_10(this, current$factory_0());
  };
  _no_name_provided__135.prototype.hasNext_31 = function () {
    return this._get_current__0() < this._this$0_35._get_size__45();
  };
  _no_name_provided__135.prototype.next_35 = function () {
    var tmp0_this = this;
    var tmp1 = tmp0_this._get_current__0();
    tmp0_this._set_current_(tmp1 + 1 | 0);
    return this._this$0_35.get_80(tmp1);
  };
  _no_name_provided__135.prototype.remove_51 = function () {
    this._this$0_35.removeAt_2(this._get_current__0() - 1 | 0);
    Unit_getInstance();
    var tmp0_this = this;
    var tmp1 = tmp0_this._get_current__0();
    tmp0_this._set_current_(tmp1 - 1 | 0);
    Unit_getInstance();
  };
  _no_name_provided__135.$metadata$ = {
    kind: 'class',
    interfaces: [MutableListIterator]
  };
  function ConcurrentList() {
    var tmp = this;
    var tmp0_shared_0 = new SharedList(32);
    tmp._data$delegate = new _no_name_provided__124(tmp0_shared_0);
    var tmp_0 = this;
    var tmp0_shared_0_0 = 0;
    tmp_0._size$delegate = new _no_name_provided__124(tmp0_shared_0_0);
    this._lock_1 = new Object();
    makeShared(this);
  }
  ConcurrentList.prototype._get_size__45 = function () {
    return this._size$delegate.getValue_10(this, size$factory_0());
  };
  ConcurrentList.prototype.hashCode = function () {
    var tmp0_synchronized_0 = this._lock_1;
    var tmp0_fold_0_2 = 7;
    var accumulator_1_3 = tmp0_fold_0_2;
    var tmp0_iterator_2_4 = this.iterator_64();
    while (tmp0_iterator_2_4.hasNext_31()) {
      var element_3_5 = tmp0_iterator_2_4.next_35();
      var tmp1__anonymous__4_6 = accumulator_1_3;
      var tmp = Hash_getInstance();
      var tmp0_safe_receiver_2_6_8 = element_3_5;
      var tmp1_elvis_lhs_1_5_7 = tmp0_safe_receiver_2_6_8 == null ? null : hashCode(tmp0_safe_receiver_2_6_8);
      accumulator_1_3 = tmp.combine([tmp1__anonymous__4_6, tmp1_elvis_lhs_1_5_7 == null ? 0 : tmp1_elvis_lhs_1_5_7]);
    }
    return accumulator_1_3;
  };
  ConcurrentList.prototype.equals = function (other) {
    var tmp0_synchronized_0 = this._lock_1;
    var tmp$ret$0;
    l$ret$1: do {
      var tmp;
      var tmp_0;
      if (other == null) {
        tmp_0 = true;
      } else {
        tmp_0 = !(!(other == null) ? isInterface(other, List) : false);
      }
      if (tmp_0) {
        tmp = true;
      } else {
        {
          tmp = !(other._get_size__45() === this._get_size__45());
        }
      }
      if (tmp) {
        tmp$ret$0 = false;
        break l$ret$1;
      } else {
      }
      var index_1_2 = 0;
      var tmp0_iterator_2_3 = this.iterator_64();
      while (tmp0_iterator_2_3.hasNext_31()) {
        var item_3_4 = tmp0_iterator_2_3.next_35();
        var tmp1_4_6 = index_1_2;
        index_1_2 = tmp1_4_6 + 1 | 0;
        var tmp0__anonymous__5_5 = checkIndexOverflow(tmp1_4_6);
        if (!equals_1(other.get_80(tmp0__anonymous__5_5), item_3_4)) {
          tmp$ret$0 = false;
          break l$ret$1;
        }}
      tmp$ret$0 = true;
    }
     while (false);
    return tmp$ret$0;
  };
  ConcurrentList.prototype.toString = function () {
    var tmp0_synchronized_0 = this._lock_1;
    var tmp0_apply_0_1_2 = StringBuilder_init_$Create$_0();
    tmp0_apply_0_1_2.append_32(new Char(91));
    Unit_getInstance();
    var index_1_3_3 = 0;
    var tmp0_iterator_2_4_4 = this.iterator_64();
    while (tmp0_iterator_2_4_4.hasNext_31()) {
      var item_3_5_5 = tmp0_iterator_2_4_4.next_35();
      var tmp1_4_7_7 = index_1_3_3;
      index_1_3_3 = tmp1_4_7_7 + 1 | 0;
      var tmp0__anonymous__5_6_6 = checkIndexOverflow(tmp1_4_7_7);
      tmp0_apply_0_1_2.append_7('' + item_3_5_5);
      Unit_getInstance();
      if ((tmp0__anonymous__5_6_6 + 1 | 0) < this._get_size__45()) {
        tmp0_apply_0_1_2.append_7(', ');
        Unit_getInstance();
      }}
    tmp0_apply_0_1_2.append_32(new Char(93));
    Unit_getInstance();
    return tmp0_apply_0_1_2.toString();
  };
  ConcurrentList.prototype.contains_42 = function (element) {
    return this.indexOf_2(element) >= 0;
  };
  ConcurrentList.prototype.contains_51 = function (element) {
    if (!(element == null ? true : isObject(element)))
      return false;
    else {
    }
    return this.contains_42((element == null ? true : isObject(element)) ? element : THROW_CCE());
  };
  ConcurrentList.prototype.containsAll_29 = function (elements) {
    var tmp$ret$0;
    l$ret$1: do {
      var tmp;
      if (isInterface(elements, Collection)) {
        tmp = elements.isEmpty_53();
      } else {
        {
          tmp = false;
        }
      }
      if (tmp) {
        tmp$ret$0 = true;
        break l$ret$1;
      } else {
      }
      var tmp0_iterator_1 = elements.iterator_64();
      while (tmp0_iterator_1.hasNext_31()) {
        var element_2 = tmp0_iterator_1.next_35();
        if (!this.contains_42(element_2)) {
          tmp$ret$0 = false;
          break l$ret$1;
        } else {
        }
      }
      tmp$ret$0 = true;
    }
     while (false);
    return tmp$ret$0;
  };
  ConcurrentList.prototype.containsAll_38 = function (elements) {
    return this.containsAll_29(elements);
  };
  ConcurrentList.prototype.get_80 = function (index) {
    var tmp0_synchronized_0 = this._lock_1;
    if (index >= this._get_size__45()) {
      throw NoSuchElementException_init_$Create$();
    }return ensureNotNull(_get_data_(this).get_80(index));
  };
  ConcurrentList.prototype.indexOf_2 = function (element) {
    var tmp0_synchronized_0 = this._lock_1;
    var inductionVariable = 0;
    var last_1 = this._get_size__45();
    if (inductionVariable < last_1)
      do {
        var index_3 = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (equals_1(_get_data_(this).get_80(index_3), element)) {
          return index_3;
        }}
       while (inductionVariable < last_1);
    return -1;
  };
  ConcurrentList.prototype.isEmpty_53 = function () {
    return this._get_size__45() === 0;
  };
  ConcurrentList.prototype.add_24 = function (element) {
    var tmp0_synchronized_0 = this._lock_1;
    if (this._get_size__45() >= _get_data_(this)._size_6) {
      increaseCapacity$default(this, 0, 2, null);
    }_get_data_(this).set_12(this._get_size__45(), element);
    var tmp0_this_2 = this;
    _set_size_(tmp0_this_2, tmp0_this_2._get_size__45() + 1 | 0);
    return true;
  };
  ConcurrentList.prototype.add_33 = function (element) {
    return this.add_24((element == null ? true : isObject(element)) ? element : THROW_CCE());
  };
  ConcurrentList.prototype.add_26 = function (index, element) {
    reserve(this, index, 1);
    _get_data_(this).set_12(index, element);
  };
  ConcurrentList.prototype.add_27 = function (index, element) {
    return this.add_26(index, (element == null ? true : isObject(element)) ? element : THROW_CCE());
  };
  ConcurrentList.prototype.addAll_16 = function (elements) {
    var tmp$ret$0;
    l$ret$1: do {
      var tmp;
      if (isInterface(elements, Collection)) {
        tmp = elements.isEmpty_53();
      } else {
        {
          tmp = false;
        }
      }
      if (tmp) {
        tmp$ret$0 = true;
        break l$ret$1;
      } else {
      }
      var tmp0_iterator_1 = elements.iterator_64();
      while (tmp0_iterator_1.hasNext_31()) {
        var element_2 = tmp0_iterator_1.next_35();
        if (!this.add_24(element_2)) {
          tmp$ret$0 = false;
          break l$ret$1;
        } else {
        }
      }
      tmp$ret$0 = true;
    }
     while (false);
    Unit_getInstance();
    return !elements.isEmpty_53();
  };
  ConcurrentList.prototype.addAll_23 = function (elements) {
    return this.addAll_16(elements);
  };
  ConcurrentList.prototype.clear_27 = function () {
    var tmp0_synchronized_0 = this._lock_1;
    _set_data_(this, new SharedList(32));
    return _set_size_(this, 0);
  };
  ConcurrentList.prototype.iterator_64 = function () {
    return this.listIterator_1();
  };
  ConcurrentList.prototype.listIterator_1 = function () {
    return this.listIterator_3(0);
  };
  ConcurrentList.prototype.listIterator_3 = function (index) {
    return new _no_name_provided__135(index, this);
  };
  ConcurrentList.prototype.removeAt_2 = function (index) {
    var tmp0_synchronized_0 = this._lock_1;
    checkIndex(this, index);
    var old_2 = _get_data_(this).get_80(index);
    _get_data_(this).set_12(index, null);
    sweep(this, index);
    return ensureNotNull(old_2);
  };
  ConcurrentList.prototype.set_10 = function (index, element) {
    var tmp0_synchronized_0 = this._lock_1;
    checkIndex(this, index);
    var old_2 = _get_data_(this).get_80(index);
    _get_data_(this).set_12(index, element);
    var tmp0_elvis_lhs_3 = old_2;
    return tmp0_elvis_lhs_3 == null ? element : tmp0_elvis_lhs_3;
  };
  ConcurrentList.prototype.set_11 = function (index, element) {
    return this.set_10(index, (element == null ? true : isObject(element)) ? element : THROW_CCE());
  };
  ConcurrentList.$metadata$ = {
    simpleName: 'ConcurrentList',
    kind: 'class',
    interfaces: [MutableList]
  };
  function data$factory() {
    return getPropertyCallableRef('data', 1, KMutableProperty1, function (receiver) {
      return _get_data_(receiver);
    }, function (receiver_0, value) {
      return _set_data_(receiver_0, value);
    });
  }
  function data$factory_0() {
    return getPropertyCallableRef('data', 1, KMutableProperty1, function (receiver) {
      return _get_data_(receiver);
    }, function (receiver_0, value) {
      return _set_data_(receiver_0, value);
    });
  }
  function size$factory() {
    return getPropertyCallableRef('size', 1, KMutableProperty1, function (receiver) {
      return receiver._get_size__45();
    }, function (receiver_0, value) {
      return _set_size_(receiver_0, value);
    });
  }
  function size$factory_0() {
    return getPropertyCallableRef('size', 1, KMutableProperty1, function (receiver) {
      return receiver._get_size__45();
    }, function (receiver_0, value) {
      return _set_size_(receiver_0, value);
    });
  }
  function current$factory() {
    return getPropertyCallableRef('current', 1, KMutableProperty1, function (receiver) {
      return receiver._get_current__0();
    }, function (receiver_0, value) {
      return receiver_0._set_current_(value);
    });
  }
  function current$factory_0() {
    return getPropertyCallableRef('current', 1, KMutableProperty1, function (receiver) {
      return receiver._get_current__0();
    }, function (receiver_0, value) {
      return receiver_0._set_current_(value);
    });
  }
  function _set_current_($this, _set___) {
    return $this._current$delegate_0.setValue_7($this, current$factory_1(), _set___);
  }
  function _get_current_($this) {
    return $this._current$delegate_0.getValue_10($this, current$factory_2());
  }
  function _get_previous_($this) {
    var tmp0_safe_receiver = _get_current_($this);
    return tmp0_safe_receiver == null ? null : tmp0_safe_receiver._get_previous__0();
  }
  function ConcurrentMap_init_$Init$(lock, initialCapacity, $mask0, $marker, $this) {
    if (!(($mask0 & 1) === 0))
      lock = new Lock();
    if (!(($mask0 & 2) === 0))
      initialCapacity = 32;
    ConcurrentMap.call($this, lock, initialCapacity);
    return $this;
  }
  function ConcurrentMap_init_$Create$(lock, initialCapacity, $mask0, $marker) {
    return ConcurrentMap_init_$Init$(lock, initialCapacity, $mask0, $marker, Object.create(ConcurrentMap.prototype));
  }
  function _set_table_($this, _set___) {
    return $this._table$delegate.setValue_7($this, table$factory(), _set___);
  }
  function _get_table_($this) {
    return $this._table$delegate.getValue_10($this, table$factory_0());
  }
  function _set_insertionOrder_($this, _set___) {
    return $this._insertionOrder$delegate.setValue_7($this, insertionOrder$factory(), _set___);
  }
  function _get_insertionOrder_($this) {
    return $this._insertionOrder$delegate.getValue_10($this, insertionOrder$factory_0());
  }
  function _get_loadFactor_($this) {
    return $this.__size._value_10 / _get_table_($this)._size_6;
  }
  function findBucket($this, key) {
    var bucketId = hashCode(key) & (_get_table_($this)._size_6 - 1 | 0);
    return _get_table_($this).get_80(bucketId);
  }
  function findOrCreateBucket($this, key) {
    var bucketId = hashCode(key) & (_get_table_($this)._size_6 - 1 | 0);
    var result = _get_table_($this).get_80(bucketId);
    if (result == null) {
      var bucket = new SharedForwardList();
      _get_table_($this).set_12(bucketId, bucket);
      return bucket;
    }return result;
  }
  function upsize($this) {
    var newTable = ConcurrentMap_init_$Create$(null, imul(_get_table_($this)._size_6, 2), 1, null);
    newTable.putAll_7($this);
    _set_table_($this, _get_table_(newTable));
  }
  function locked($this, block) {
    var tmp$ret$0;
    l$ret$1: do {
      var tmp0_withLock_0 = $this._lock_2;
      try {
        tmp0_withLock_0.lock();
        tmp$ret$0 = block();
        break l$ret$1;
      }finally {
        tmp0_withLock_0.unlock();
      }
    }
     while (false);
    return tmp$ret$0;
  }
  function _no_name_provided__136(this$0, $value) {
    this._this$0_36 = this$0;
    this._$value_1 = $value;
  }
  _no_name_provided__136.prototype.invoke_540 = function () {
    var tmp0_iterator = _get_table_(this._this$0_36).iterator_64();
    while (tmp0_iterator.hasNext_31()) {
      var bucket = tmp0_iterator.next_35();
      var tmp1_elvis_lhs = bucket;
      if (tmp1_elvis_lhs == null)
        continue;
      else
        tmp1_elvis_lhs;
      Unit_getInstance();
      var tmp2_iterator = bucket.iterator_64();
      while (tmp2_iterator.hasNext_31()) {
        var item = tmp2_iterator.next_35();
        if (equals_1(item._get_value__33(), this._$value_1)) {
          return true;
        }}
    }
    return false;
  };
  _no_name_provided__136.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__137(this$0, $key) {
    this._this$0_37 = this$0;
    this._$key = $key;
  }
  _no_name_provided__137.prototype.invoke_540 = function () {
    var tmp0_elvis_lhs = findBucket(this._this$0_37, this._$key);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return null;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var bucket = tmp;
    var tmp$ret$0;
    l$ret$1: do {
      var tmp0_iterator_1_1 = bucket.iterator_64();
      while (tmp0_iterator_1_1.hasNext_31()) {
        var element_2_2 = tmp0_iterator_1_1.next_35();
        if (equals_1(element_2_2._key_4, this._$key)) {
          tmp$ret$0 = element_2_2;
          break l$ret$1;
        } else {
        }
      }
      tmp$ret$0 = null;
    }
     while (false);
    var item = tmp$ret$0;
    var tmp1_safe_receiver = item;
    return tmp1_safe_receiver == null ? null : tmp1_safe_receiver._get_value__33();
  };
  _no_name_provided__137.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__138(this$0) {
    this._this$0_38 = this$0;
  }
  _no_name_provided__138.prototype.invoke_494 = function () {
    _set_table_(this._this$0_38, new SharedList(32));
    _set_insertionOrder_(this._this$0_38, new SharedForwardList());
  };
  _no_name_provided__138.prototype.invoke_540 = function () {
    this.invoke_494();
    return Unit_getInstance();
  };
  _no_name_provided__138.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__139(this$0, $key, $value) {
    this._this$0_39 = this$0;
    this._$key_0 = $key;
    this._$value_2 = $value;
  }
  _no_name_provided__139.prototype.invoke_540 = function () {
    if (_get_loadFactor_(this._this$0_39) > 0.5) {
      upsize(this._this$0_39);
    }var bucket = findOrCreateBucket(this._this$0_39, this._$key_0);
    var tmp$ret$0;
    l$ret$1: do {
      var tmp0_iterator_1_1 = bucket.iterator_64();
      while (tmp0_iterator_1_1.hasNext_31()) {
        var element_2_2 = tmp0_iterator_1_1.next_35();
        if (equals_1(element_2_2._key_4, this._$key_0)) {
          tmp$ret$0 = element_2_2;
          break l$ret$1;
        } else {
        }
      }
      tmp$ret$0 = null;
    }
     while (false);
    var item = tmp$ret$0;
    if (!(item == null)) {
      var oldValue = item._get_value__33();
      item._set_value__3(this._$value_2);
      return oldValue;
    }var mapNode = new MapNode(this._$key_0, this._$value_2);
    var node = _get_insertionOrder_(this._this$0_39).appendLast(mapNode);
    mapNode._set_backReference_(node);
    bucket.appendFirst(mapNode);
    Unit_getInstance();
    this._this$0_39.__size.incrementAndGet$atomicfu();
    Unit_getInstance();
    return null;
  };
  _no_name_provided__139.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__140(this$0, $key) {
    this._this$0_40 = this$0;
    this._$key_1 = $key;
  }
  _no_name_provided__140.prototype.invoke_540 = function () {
    var tmp0_elvis_lhs = findBucket(this._this$0_40, this._$key_1);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return null;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var bucket = tmp;
    var tmp0_with_0 = bucket.iterator_64();
    while (tmp0_with_0.hasNext_31()) {
      var item_2 = tmp0_with_0.next_35();
      if (equals_1(item_2._key_4, this._$key_1)) {
        var result_3 = item_2._get_value__33();
        this._this$0_40.__size.decrementAndGet$atomicfu();
        Unit_getInstance();
        item_2.remove_51();
        tmp0_with_0.remove_51();
        return result_3;
      }}
    return null;
  };
  _no_name_provided__140.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__141($other, this$0) {
    this._$other = $other;
    this._this$0_41 = this$0;
  }
  _no_name_provided__141.prototype.invoke_540 = function () {
    var tmp;
    var tmp_0;
    if (this._$other == null) {
      tmp_0 = true;
    } else {
      var tmp_1 = this._$other;
      tmp_0 = !(!(tmp_1 == null) ? isInterface(tmp_1, Map_0) : false);
    }
    if (tmp_0) {
      tmp = true;
    } else {
      {
        tmp = !(this._$other._get_size__45() === this._this$0_41._get_size__45());
      }
    }
    if (tmp) {
      return false;
    } else {
    }
    var tmp0_iterator = this._$other._get_entries__10().iterator_64();
    while (tmp0_iterator.hasNext_31()) {
      var tmp1_loop_parameter = tmp0_iterator.next_35();
      var key = tmp1_loop_parameter._get_key__47();
      var value = tmp1_loop_parameter._get_value__33();
      var tmp_2 = this._this$0_41;
      if (!equals_1((isInterface(tmp_2, Map_0) ? tmp_2 : THROW_CCE()).get_63(key), value)) {
        return false;
      } else {
      }
    }
    return true;
  };
  _no_name_provided__141.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__142(this$0) {
    this._this$0_42 = this$0;
  }
  _no_name_provided__142.prototype.invoke_540 = function () {
    var current = 7;
    var tmp0_iterator = this._this$0_42._get_entries__10().iterator_64();
    while (tmp0_iterator.hasNext_31()) {
      var tmp1_loop_parameter = tmp0_iterator.next_35();
      var key = tmp1_loop_parameter._get_key__47();
      var value = tmp1_loop_parameter._get_value__33();
      current = Hash_getInstance().combine([hashCode(key), hashCode(value), current]);
    }
    return current;
  };
  _no_name_provided__142.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__143(this$0) {
    this._this$0_43 = this$0;
  }
  _no_name_provided__143.prototype.invoke_540 = function () {
    var tmp0_apply_0_1 = StringBuilder_init_$Create$_0();
    tmp0_apply_0_1.append_7('{');
    Unit_getInstance();
    var tmp0_forEachIndexed_0_3 = this._this$0_43._get_entries__10();
    var index_1_4 = 0;
    var tmp0_iterator_2_5 = tmp0_forEachIndexed_0_3.iterator_64();
    while (tmp0_iterator_2_5.hasNext_31()) {
      var item_3_6 = tmp0_iterator_2_5.next_35();
      var tmp1_4_8 = index_1_4;
      index_1_4 = tmp1_4_8 + 1 | 0;
      var tmp1__anonymous__5_7 = checkIndexOverflow(tmp1_4_8);
      var key_6_9 = item_3_6._get_key__47();
      var value_7_10 = item_3_6._get_value__33();
      tmp0_apply_0_1.append_7('' + key_6_9 + '=' + value_7_10);
      Unit_getInstance();
      if (!(tmp1__anonymous__5_7 === (this._this$0_43._get_size__45() - 1 | 0))) {
        tmp0_apply_0_1.append_7(', ');
        Unit_getInstance();
      }}
    tmp0_apply_0_1.append_7('}');
    Unit_getInstance();
    return tmp0_apply_0_1.toString();
  };
  _no_name_provided__143.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__144(this$0) {
    this._this$0_44 = this$0;
    var tmp = this;
    var tmp0_shared_0 = _get_insertionOrder_(this._this$0_44).first_0();
    tmp._current$delegate_0 = new _no_name_provided__124(tmp0_shared_0);
    makeShared(this);
  }
  _no_name_provided__144.prototype.hasNext_31 = function () {
    return !(_get_current_(this) == null);
  };
  _no_name_provided__144.prototype.next_35 = function () {
    var result = ensureNotNull(ensureNotNull(_get_current_(this))._item);
    var tmp0_safe_receiver = _get_current_(this);
    _set_current_(this, tmp0_safe_receiver == null ? null : tmp0_safe_receiver._get_next__1());
    return result;
  };
  _no_name_provided__144.prototype.remove_51 = function () {
    var item = ensureNotNull(ensureNotNull(_get_previous_(this))._item);
    this._this$0_44.remove_44(item._key_4);
    Unit_getInstance();
  };
  _no_name_provided__144.$metadata$ = {
    kind: 'class',
    interfaces: [MutableIterator]
  };
  function ConcurrentMap(lock, initialCapacity) {
    this._lock_2 = lock;
    var tmp = this;
    var tmp0_shared_0 = new SharedList(initialCapacity);
    tmp._table$delegate = new _no_name_provided__124(tmp0_shared_0);
    var tmp_0 = this;
    var tmp0_shared_0_0 = new SharedForwardList();
    tmp_0._insertionOrder$delegate = new _no_name_provided__124(tmp0_shared_0_0);
    this.__size = atomic_1(0);
    makeShared(this);
  }
  ConcurrentMap.prototype._get_size__45 = function () {
    return this.__size._value_10;
  };
  ConcurrentMap.prototype.containsKey_15 = function (key) {
    return !(this.get_62(key) == null);
  };
  ConcurrentMap.prototype.containsKey_16 = function (key) {
    if (!isObject(key))
      return false;
    else {
    }
    return this.containsKey_15(isObject(key) ? key : THROW_CCE());
  };
  ConcurrentMap.prototype.containsValue_3 = function (value) {
    return locked(this, _no_name_provided_$factory_105(this, value));
  };
  ConcurrentMap.prototype.get_62 = function (key) {
    return locked(this, _no_name_provided_$factory_106(this, key));
  };
  ConcurrentMap.prototype.get_63 = function (key) {
    if (!isObject(key))
      return null;
    else {
    }
    return this.get_62(isObject(key) ? key : THROW_CCE());
  };
  ConcurrentMap.prototype.isEmpty_53 = function () {
    return this._get_size__45() === 0;
  };
  ConcurrentMap.prototype.clear_27 = function () {
    return locked(this, _no_name_provided_$factory_107(this));
  };
  ConcurrentMap.prototype.put_11 = function (key, value) {
    return locked(this, _no_name_provided_$factory_108(this, key, value));
  };
  ConcurrentMap.prototype.put_12 = function (key, value) {
    var tmp = isObject(key) ? key : THROW_CCE();
    return this.put_11(tmp, isObject(value) ? value : THROW_CCE());
  };
  ConcurrentMap.prototype.putAll_7 = function (from) {
    var tmp0_iterator = from._get_entries__10().iterator_64();
    while (tmp0_iterator.hasNext_31()) {
      var tmp1_loop_parameter = tmp0_iterator.next_35();
      var key = tmp1_loop_parameter._get_key__47();
      var value = tmp1_loop_parameter._get_value__33();
      this.put_11(key, value);
      Unit_getInstance();
    }
  };
  ConcurrentMap.prototype.putAll_8 = function (from) {
    return this.putAll_7(from);
  };
  ConcurrentMap.prototype.remove_44 = function (key) {
    return locked(this, _no_name_provided_$factory_109(this, key));
  };
  ConcurrentMap.prototype.remove_45 = function (key) {
    if (!isObject(key))
      return null;
    else {
    }
    return this.remove_44(isObject(key) ? key : THROW_CCE());
  };
  ConcurrentMap.prototype._get_entries__10 = function () {
    return new MutableMapEntries(this);
  };
  ConcurrentMap.prototype._get_keys__10 = function () {
    return new ConcurrentMapKeys(this);
  };
  ConcurrentMap.prototype._get_values__16 = function () {
    return new ConcurrentMapValues(this);
  };
  ConcurrentMap.prototype.equals = function (other) {
    return locked(this, _no_name_provided_$factory_110(other, this));
  };
  ConcurrentMap.prototype.hashCode = function () {
    return locked(this, _no_name_provided_$factory_111(this));
  };
  ConcurrentMap.prototype.toString = function () {
    return locked(this, _no_name_provided_$factory_112(this));
  };
  ConcurrentMap.prototype.iterator_64 = function () {
    return new _no_name_provided__144(this);
  };
  ConcurrentMap.$metadata$ = {
    simpleName: 'ConcurrentMap',
    kind: 'class',
    interfaces: [MutableMap]
  };
  function table$factory() {
    return getPropertyCallableRef('table', 1, KMutableProperty1, function (receiver) {
      return _get_table_(receiver);
    }, function (receiver_0, value) {
      return _set_table_(receiver_0, value);
    });
  }
  function table$factory_0() {
    return getPropertyCallableRef('table', 1, KMutableProperty1, function (receiver) {
      return _get_table_(receiver);
    }, function (receiver_0, value) {
      return _set_table_(receiver_0, value);
    });
  }
  function insertionOrder$factory() {
    return getPropertyCallableRef('insertionOrder', 1, KMutableProperty1, function (receiver) {
      return _get_insertionOrder_(receiver);
    }, function (receiver_0, value) {
      return _set_insertionOrder_(receiver_0, value);
    });
  }
  function insertionOrder$factory_0() {
    return getPropertyCallableRef('insertionOrder', 1, KMutableProperty1, function (receiver) {
      return _get_insertionOrder_(receiver);
    }, function (receiver_0, value) {
      return _set_insertionOrder_(receiver_0, value);
    });
  }
  function current$factory_1() {
    return getPropertyCallableRef('current', 1, KMutableProperty1, function (receiver) {
      return _get_current_(receiver);
    }, function (receiver_0, value) {
      return _set_current_(receiver_0, value);
    });
  }
  function current$factory_2() {
    return getPropertyCallableRef('current', 1, KMutableProperty1, function (receiver) {
      return _get_current_(receiver);
    }, function (receiver_0, value) {
      return _set_current_(receiver_0, value);
    });
  }
  function _no_name_provided_$factory_105(this$0, $value) {
    var i = new _no_name_provided__136(this$0, $value);
    return function () {
      return i.invoke_540();
    };
  }
  function _no_name_provided_$factory_106(this$0, $key) {
    var i = new _no_name_provided__137(this$0, $key);
    return function () {
      return i.invoke_540();
    };
  }
  function _no_name_provided_$factory_107(this$0) {
    var i = new _no_name_provided__138(this$0);
    return function () {
      i.invoke_494();
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_108(this$0, $key, $value) {
    var i = new _no_name_provided__139(this$0, $key, $value);
    return function () {
      return i.invoke_540();
    };
  }
  function _no_name_provided_$factory_109(this$0, $key) {
    var i = new _no_name_provided__140(this$0, $key);
    return function () {
      return i.invoke_540();
    };
  }
  function _no_name_provided_$factory_110($other, this$0) {
    var i = new _no_name_provided__141($other, this$0);
    return function () {
      return i.invoke_540();
    };
  }
  function _no_name_provided_$factory_111(this$0) {
    var i = new _no_name_provided__142(this$0);
    return function () {
      return i.invoke_540();
    };
  }
  function _no_name_provided_$factory_112(this$0) {
    var i = new _no_name_provided__143(this$0);
    return function () {
      return i.invoke_540();
    };
  }
  function _no_name_provided__145(this$0) {
    this._this$0_45 = this$0;
    this._delegateIterator_0 = this._this$0_45._delegate_4.iterator_64();
    makeShared(this);
  }
  _no_name_provided__145.prototype.hasNext_31 = function () {
    return this._delegateIterator_0.hasNext_31();
  };
  _no_name_provided__145.prototype.next_35 = function () {
    return this._delegateIterator_0.next_35()._get_key__47();
  };
  _no_name_provided__145.prototype.remove_51 = function () {
    this._delegateIterator_0.remove_51();
  };
  _no_name_provided__145.$metadata$ = {
    kind: 'class',
    interfaces: [MutableIterator]
  };
  function ConcurrentMapKeys(delegate) {
    this._delegate_4 = delegate;
    makeShared(this);
  }
  ConcurrentMapKeys.prototype.add_28 = function (element) {
    throw UnsupportedOperationException_init_$Create$();
  };
  ConcurrentMapKeys.prototype.add_33 = function (element) {
    return this.add_28(isObject(element) ? element : THROW_CCE());
  };
  ConcurrentMapKeys.prototype.addAll_18 = function (elements) {
    throw UnsupportedOperationException_init_$Create$();
  };
  ConcurrentMapKeys.prototype.addAll_23 = function (elements) {
    return this.addAll_18(elements);
  };
  ConcurrentMapKeys.prototype.clear_27 = function () {
    this._delegate_4.clear_27();
  };
  ConcurrentMapKeys.prototype.iterator_64 = function () {
    return new _no_name_provided__145(this);
  };
  ConcurrentMapKeys.prototype._get_size__45 = function () {
    return this._delegate_4._get_size__45();
  };
  ConcurrentMapKeys.prototype.contains_44 = function (element) {
    var tmp0_contains_0 = this._delegate_4;
    return (isInterface(tmp0_contains_0, Map_0) ? tmp0_contains_0 : THROW_CCE()).containsKey_16(element);
  };
  ConcurrentMapKeys.prototype.contains_51 = function (element) {
    if (!isObject(element))
      return false;
    else {
    }
    return this.contains_44(isObject(element) ? element : THROW_CCE());
  };
  ConcurrentMapKeys.prototype.containsAll_31 = function (elements) {
    var tmp$ret$0;
    l$ret$1: do {
      var tmp;
      if (isInterface(elements, Collection)) {
        tmp = elements.isEmpty_53();
      } else {
        {
          tmp = false;
        }
      }
      if (tmp) {
        tmp$ret$0 = true;
        break l$ret$1;
      } else {
      }
      var tmp0_iterator_1 = elements.iterator_64();
      while (tmp0_iterator_1.hasNext_31()) {
        var element_2 = tmp0_iterator_1.next_35();
        if (!this.contains_44(element_2)) {
          tmp$ret$0 = false;
          break l$ret$1;
        } else {
        }
      }
      tmp$ret$0 = true;
    }
     while (false);
    return tmp$ret$0;
  };
  ConcurrentMapKeys.prototype.containsAll_38 = function (elements) {
    return this.containsAll_31(elements);
  };
  ConcurrentMapKeys.prototype.isEmpty_53 = function () {
    return this._get_size__45() === 0;
  };
  ConcurrentMapKeys.$metadata$ = {
    simpleName: 'ConcurrentMapKeys',
    kind: 'class',
    interfaces: [MutableSet]
  };
  function _no_name_provided__146(this$0) {
    this._this$0_46 = this$0;
    this._delegateIterator_1 = this._this$0_46._delegate_5.iterator_64();
    makeShared(this);
  }
  _no_name_provided__146.prototype.hasNext_31 = function () {
    return this._delegateIterator_1.hasNext_31();
  };
  _no_name_provided__146.prototype.next_35 = function () {
    return this._delegateIterator_1.next_35()._get_value__33();
  };
  _no_name_provided__146.prototype.remove_51 = function () {
    this._delegateIterator_1.remove_51();
  };
  _no_name_provided__146.$metadata$ = {
    kind: 'class',
    interfaces: [MutableIterator]
  };
  function ConcurrentMapValues(delegate) {
    this._delegate_5 = delegate;
    makeShared(this);
  }
  ConcurrentMapValues.prototype._get_size__45 = function () {
    return this._delegate_5._get_size__45();
  };
  ConcurrentMapValues.prototype.contains_46 = function (element) {
    return this._delegate_5.containsValue_3(element);
  };
  ConcurrentMapValues.prototype.contains_51 = function (element) {
    if (!isObject(element))
      return false;
    else {
    }
    return this.contains_46(isObject(element) ? element : THROW_CCE());
  };
  ConcurrentMapValues.prototype.containsAll_33 = function (elements) {
    var tmp$ret$0;
    l$ret$1: do {
      var tmp;
      if (isInterface(elements, Collection)) {
        tmp = elements.isEmpty_53();
      } else {
        {
          tmp = false;
        }
      }
      if (tmp) {
        tmp$ret$0 = true;
        break l$ret$1;
      } else {
      }
      var tmp0_iterator_1 = elements.iterator_64();
      while (tmp0_iterator_1.hasNext_31()) {
        var element_2 = tmp0_iterator_1.next_35();
        if (!this.contains_46(element_2)) {
          tmp$ret$0 = false;
          break l$ret$1;
        } else {
        }
      }
      tmp$ret$0 = true;
    }
     while (false);
    return tmp$ret$0;
  };
  ConcurrentMapValues.prototype.containsAll_38 = function (elements) {
    return this.containsAll_33(elements);
  };
  ConcurrentMapValues.prototype.isEmpty_53 = function () {
    return this._delegate_5._get_size__45() === 0;
  };
  ConcurrentMapValues.prototype.add_30 = function (element) {
    throw UnsupportedOperationException_init_$Create$();
  };
  ConcurrentMapValues.prototype.add_33 = function (element) {
    return this.add_30(isObject(element) ? element : THROW_CCE());
  };
  ConcurrentMapValues.prototype.addAll_20 = function (elements) {
    throw UnsupportedOperationException_init_$Create$();
  };
  ConcurrentMapValues.prototype.addAll_23 = function (elements) {
    return this.addAll_20(elements);
  };
  ConcurrentMapValues.prototype.iterator_64 = function () {
    return new _no_name_provided__146(this);
  };
  ConcurrentMapValues.$metadata$ = {
    simpleName: 'ConcurrentMapValues',
    kind: 'class',
    interfaces: [MutableCollection]
  };
  function ForwardListIterator(head) {
    var tmp = this;
    tmp._previous$delegate = new _no_name_provided__124(head);
  }
  ForwardListIterator.prototype._set_previous__0 = function (_set___) {
    return this._previous$delegate.setValue_7(this, previous$factory(), _set___);
  };
  ForwardListIterator.prototype._get_previous__0 = function () {
    return this._previous$delegate.getValue_10(this, previous$factory_0());
  };
  ForwardListIterator.prototype._get_current__0 = function () {
    var tmp0_safe_receiver = this._get_previous__0();
    return tmp0_safe_receiver == null ? null : tmp0_safe_receiver._get_next__1();
  };
  ForwardListIterator.prototype.hasNext_31 = function () {
    var tmp0_safe_receiver = this._get_current__0();
    return !((tmp0_safe_receiver == null ? null : tmp0_safe_receiver._item) == null);
  };
  ForwardListIterator.prototype.next_35 = function () {
    this._set_previous__0(this._get_current__0());
    var tmp0_safe_receiver = this._get_previous__0();
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver._item;
    var tmp;
    if (tmp1_elvis_lhs == null) {
      throw NoSuchElementException_init_$Create$();
    } else {
      tmp = tmp1_elvis_lhs;
    }
    return tmp;
  };
  ForwardListIterator.prototype.remove_51 = function () {
    var tmp0_safe_receiver = this._get_previous__0();
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      tmp0_safe_receiver.remove_51();
      tmp = Unit_getInstance();
    }
    var tmp1_elvis_lhs = tmp;
    if (tmp1_elvis_lhs == null) {
      var tmp0_error_0 = 'Fail to remove element before iteration';
      throw IllegalStateException_init_$Create$(toString_1(tmp0_error_0));
    } else {
      Unit_getInstance();
    }
  };
  ForwardListIterator.$metadata$ = {
    simpleName: 'ForwardListIterator',
    kind: 'class',
    interfaces: [MutableIterator]
  };
  function previous$factory() {
    return getPropertyCallableRef('previous', 1, KMutableProperty1, function (receiver) {
      return receiver._get_previous__0();
    }, function (receiver_0, value) {
      return receiver_0._set_previous__0(value);
    });
  }
  function previous$factory_0() {
    return getPropertyCallableRef('previous', 1, KMutableProperty1, function (receiver) {
      return receiver._get_previous__0();
    }, function (receiver_0, value) {
      return receiver_0._set_previous__0(value);
    });
  }
  function ForwardListNode(list, next, item, previous) {
    this._list_2 = list;
    this._item = item;
    var tmp = this;
    tmp._next$delegate = new _no_name_provided__124(next);
    var tmp_0 = this;
    tmp_0._previous$delegate_0 = new _no_name_provided__124(previous);
    makeShared(this);
  }
  ForwardListNode.prototype._set_next__1 = function (_set___) {
    return this._next$delegate.setValue_7(this, next$factory(), _set___);
  };
  ForwardListNode.prototype._get_next__1 = function () {
    return this._next$delegate.getValue_10(this, next$factory_0());
  };
  ForwardListNode.prototype._set_previous__0 = function (_set___) {
    return this._previous$delegate_0.setValue_7(this, previous$factory_1(), _set___);
  };
  ForwardListNode.prototype._get_previous__0 = function () {
    return this._previous$delegate_0.getValue_10(this, previous$factory_2());
  };
  ForwardListNode.prototype.insertAfter = function (value) {
    var result = new ForwardListNode(this._list_2, this._get_next__1(), value, this);
    this._set_next__1(result);
    return result;
  };
  ForwardListNode.prototype.removeNext = function () {
    if (equals_1(this._get_next__1(), this._list_2._get_tail_())) {
      this._list_2._set_tail_(this);
    }var tmp0_safe_receiver = this._get_next__1();
    this._set_next__1(tmp0_safe_receiver == null ? null : tmp0_safe_receiver._get_next__1());
    var tmp1_safe_receiver = this._get_next__1();
    if (tmp1_safe_receiver == null) {
      Unit_getInstance();
    } else
      tmp1_safe_receiver._set_previous__0(this);
  };
  ForwardListNode.prototype.remove_51 = function () {
    ensureNotNull(this._get_previous__0()).removeNext();
  };
  ForwardListNode.$metadata$ = {
    simpleName: 'ForwardListNode',
    kind: 'class',
    interfaces: []
  };
  function next$factory() {
    return getPropertyCallableRef('next', 1, KMutableProperty1, function (receiver) {
      return receiver._get_next__1();
    }, function (receiver_0, value) {
      return receiver_0._set_next__1(value);
    });
  }
  function next$factory_0() {
    return getPropertyCallableRef('next', 1, KMutableProperty1, function (receiver) {
      return receiver._get_next__1();
    }, function (receiver_0, value) {
      return receiver_0._set_next__1(value);
    });
  }
  function previous$factory_1() {
    return getPropertyCallableRef('previous', 1, KMutableProperty1, function (receiver) {
      return receiver._get_previous__0();
    }, function (receiver_0, value) {
      return receiver_0._set_previous__0(value);
    });
  }
  function previous$factory_2() {
    return getPropertyCallableRef('previous', 1, KMutableProperty1, function (receiver) {
      return receiver._get_previous__0();
    }, function (receiver_0, value) {
      return receiver_0._set_previous__0(value);
    });
  }
  function MapNode(key, value) {
    this._key_4 = key;
    var tmp = this;
    var tmp0_shared_0 = null;
    tmp._backReference$delegate = new _no_name_provided__124(tmp0_shared_0);
    var tmp_0 = this;
    tmp_0._value$delegate = new _no_name_provided__124(value);
    var tmp_1 = this;
    var tmp0_hashCode_0 = this._key_4;
    var tmp0_safe_receiver_2 = tmp0_hashCode_0;
    var tmp1_elvis_lhs_1 = tmp0_safe_receiver_2 == null ? null : hashCode(tmp0_safe_receiver_2);
    tmp_1._hash_0 = tmp1_elvis_lhs_1 == null ? 0 : tmp1_elvis_lhs_1;
    makeShared(this);
  }
  MapNode.prototype._get_key__47 = function () {
    return this._key_4;
  };
  MapNode.prototype._set_backReference_ = function (_set___) {
    return this._backReference$delegate.setValue_7(this, backReference$factory(), _set___);
  };
  MapNode.prototype._get_backReference_ = function () {
    return this._backReference$delegate.getValue_10(this, backReference$factory_0());
  };
  MapNode.prototype._set_value__3 = function (_set___) {
    return this._value$delegate.setValue_7(this, value$factory(), _set___);
  };
  MapNode.prototype._get_value__33 = function () {
    return this._value$delegate.getValue_10(this, value$factory_0());
  };
  MapNode.prototype.setValue_10 = function (newValue) {
    var result = this._get_value__33();
    this._set_value__3(newValue);
    return result;
  };
  MapNode.prototype.setValue_11 = function (newValue) {
    return this.setValue_10((newValue == null ? true : isObject(newValue)) ? newValue : THROW_CCE());
  };
  MapNode.prototype.remove_51 = function () {
    ensureNotNull(this._get_backReference_()).remove_51();
    this._set_backReference_(null);
  };
  MapNode.prototype.toString = function () {
    return '' + 'MapItem[' + this._key_4 + ', ' + this._get_value__33() + ']';
  };
  MapNode.$metadata$ = {
    simpleName: 'MapNode',
    kind: 'class',
    interfaces: [MutableEntry]
  };
  function backReference$factory() {
    return getPropertyCallableRef('backReference', 1, KMutableProperty1, function (receiver) {
      return receiver._get_backReference_();
    }, function (receiver_0, value) {
      return receiver_0._set_backReference_(value);
    });
  }
  function backReference$factory_0() {
    return getPropertyCallableRef('backReference', 1, KMutableProperty1, function (receiver) {
      return receiver._get_backReference_();
    }, function (receiver_0, value) {
      return receiver_0._set_backReference_(value);
    });
  }
  function value$factory() {
    return getPropertyCallableRef('value', 1, KMutableProperty1, function (receiver) {
      return receiver._get_value__33();
    }, function (receiver_0, value) {
      return receiver_0._set_value__3(value);
    });
  }
  function value$factory_0() {
    return getPropertyCallableRef('value', 1, KMutableProperty1, function (receiver) {
      return receiver._get_value__33();
    }, function (receiver_0, value) {
      return receiver_0._set_value__3(value);
    });
  }
  function _no_name_provided__147(this$0) {
    this._this$0_47 = this$0;
    this._origin = this._this$0_47._delegate_6.iterator_64();
  }
  _no_name_provided__147.prototype.hasNext_31 = function () {
    return this._origin.hasNext_31();
  };
  _no_name_provided__147.prototype.next_35 = function () {
    return this._origin.next_35();
  };
  _no_name_provided__147.prototype.remove_51 = function () {
    return this._origin.remove_51();
  };
  _no_name_provided__147.$metadata$ = {
    kind: 'class',
    interfaces: [MutableIterator]
  };
  function MutableMapEntries(delegate) {
    this._delegate_6 = delegate;
    makeShared(this);
  }
  MutableMapEntries.prototype.add_32 = function (element) {
    return !equals_1(this._delegate_6.put_11(element._get_key__47(), element._get_value__33()), element._get_value__33());
  };
  MutableMapEntries.prototype.add_33 = function (element) {
    return this.add_32((!(element == null) ? isInterface(element, MutableEntry) : false) ? element : THROW_CCE());
  };
  MutableMapEntries.prototype.addAll_22 = function (elements) {
    var result = false;
    var tmp0_iterator_1 = elements.iterator_64();
    while (tmp0_iterator_1.hasNext_31()) {
      var element_2 = tmp0_iterator_1.next_35();
      result = this.add_32(element_2) ? true : result;
    }
    return result;
  };
  MutableMapEntries.prototype.addAll_23 = function (elements) {
    return this.addAll_22(elements);
  };
  MutableMapEntries.prototype.clear_27 = function () {
    this._delegate_6.clear_27();
  };
  MutableMapEntries.prototype.iterator_64 = function () {
    return new _no_name_provided__147(this);
  };
  MutableMapEntries.prototype._get_size__45 = function () {
    return this._delegate_6._get_size__45();
  };
  MutableMapEntries.prototype.contains_48 = function (element) {
    return equals_1(this._delegate_6.get_62(element._get_key__47()), element._get_value__33());
  };
  MutableMapEntries.prototype.contains_51 = function (element) {
    if (!(!(element == null) ? isInterface(element, MutableEntry) : false))
      return false;
    else {
    }
    return this.contains_48((!(element == null) ? isInterface(element, MutableEntry) : false) ? element : THROW_CCE());
  };
  MutableMapEntries.prototype.containsAll_35 = function (elements) {
    var tmp$ret$0;
    l$ret$1: do {
      var tmp;
      if (isInterface(elements, Collection)) {
        tmp = elements.isEmpty_53();
      } else {
        {
          tmp = false;
        }
      }
      if (tmp) {
        tmp$ret$0 = true;
        break l$ret$1;
      } else {
      }
      var tmp0_iterator_1 = elements.iterator_64();
      while (tmp0_iterator_1.hasNext_31()) {
        var element_2 = tmp0_iterator_1.next_35();
        if (!this.contains_48(element_2)) {
          tmp$ret$0 = false;
          break l$ret$1;
        } else {
        }
      }
      tmp$ret$0 = true;
    }
     while (false);
    return tmp$ret$0;
  };
  MutableMapEntries.prototype.containsAll_38 = function (elements) {
    return this.containsAll_35(elements);
  };
  MutableMapEntries.prototype.isEmpty_53 = function () {
    return this._delegate_6.isEmpty_53();
  };
  MutableMapEntries.$metadata$ = {
    simpleName: 'MutableMapEntries',
    kind: 'class',
    interfaces: [MutableSet]
  };
  function SharedForwardList() {
    var tmp = this;
    var tmp0_shared_0 = null;
    tmp._head$delegate = new _no_name_provided__124(tmp0_shared_0);
    var tmp_0 = this;
    var tmp0_shared_0_0 = this._get_head__7();
    tmp_0._tail$delegate = new _no_name_provided__124(tmp0_shared_0_0);
    makeShared(this);
    this._set_head_(new ForwardListNode(this, null, null, null));
    this._set_tail_(this._get_head__7());
  }
  SharedForwardList.prototype._set_head_ = function (_set___) {
    return this._head$delegate.setValue_7(this, head$factory(), _set___);
  };
  SharedForwardList.prototype._get_head__7 = function () {
    return this._head$delegate.getValue_10(this, head$factory_0());
  };
  SharedForwardList.prototype._set_tail_ = function (_set___) {
    return this._tail$delegate.setValue_7(this, tail$factory(), _set___);
  };
  SharedForwardList.prototype._get_tail_ = function () {
    return this._tail$delegate.getValue_10(this, tail$factory_0());
  };
  SharedForwardList.prototype.first_0 = function () {
    return ensureNotNull(this._get_head__7())._get_next__1();
  };
  SharedForwardList.prototype.appendFirst = function (value) {
    var newValue = ensureNotNull(this._get_head__7()).insertAfter(value);
    if (equals_1(this._get_head__7(), this._get_tail_())) {
      this._set_tail_(newValue);
    }return newValue;
  };
  SharedForwardList.prototype.appendLast = function (value) {
    this._set_tail_(ensureNotNull(this._get_tail_()).insertAfter(value));
    return ensureNotNull(this._get_tail_());
  };
  SharedForwardList.prototype.iterator_64 = function () {
    return new ForwardListIterator(ensureNotNull(this._get_head__7()));
  };
  SharedForwardList.$metadata$ = {
    simpleName: 'SharedForwardList',
    kind: 'class',
    interfaces: [MutableIterable]
  };
  function head$factory() {
    return getPropertyCallableRef('head', 1, KMutableProperty1, function (receiver) {
      return receiver._get_head__7();
    }, function (receiver_0, value) {
      return receiver_0._set_head_(value);
    });
  }
  function head$factory_0() {
    return getPropertyCallableRef('head', 1, KMutableProperty1, function (receiver) {
      return receiver._get_head__7();
    }, function (receiver_0, value) {
      return receiver_0._set_head_(value);
    });
  }
  function tail$factory() {
    return getPropertyCallableRef('tail', 1, KMutableProperty1, function (receiver) {
      return receiver._get_tail_();
    }, function (receiver_0, value) {
      return receiver_0._set_tail_(value);
    });
  }
  function tail$factory_0() {
    return getPropertyCallableRef('tail', 1, KMutableProperty1, function (receiver) {
      return receiver._get_tail_();
    }, function (receiver_0, value) {
      return receiver_0._set_tail_(value);
    });
  }
  function _no_name_provided__148($index, this$0) {
    this._$index_0 = $index;
    this._this$0_48 = this$0;
    this._currentIndex_1 = atomic_1(this._$index_0);
    makeShared(this);
  }
  _no_name_provided__148.prototype.hasNext_31 = function () {
    return this._currentIndex_1._value_10 < this._this$0_48._size_6;
  };
  _no_name_provided__148.prototype.next_35 = function () {
    var tmp0_check_0 = this.hasNext_31();
    if (!tmp0_check_0) {
      var message_2_1 = 'Check failed.';
      throw IllegalStateException_init_$Create$(toString_1(message_2_1));
    }var current = this._currentIndex_1.getAndIncrement$atomicfu();
    return this._this$0_48._data_3.get$atomicfu(current)._value_8;
  };
  _no_name_provided__148.$metadata$ = {
    kind: 'class',
    interfaces: [ListIterator]
  };
  function SharedList(size_0) {
    this._size_6 = size_0;
    this._data_3 = atomicArrayOfNulls(this._size_6);
    makeShared(this);
  }
  SharedList.prototype._get_size__45 = function () {
    return this._size_6;
  };
  SharedList.prototype.set_12 = function (index, value) {
    this._data_3.get$atomicfu(index)._value_8 = value;
  };
  SharedList.prototype.contains_50 = function (element) {
    var inductionVariable = 0;
    var last_1 = this._size_6;
    if (inductionVariable < last_1)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (equals_1(this._data_3.get$atomicfu(index)._value_8, element)) {
          return true;
        }}
       while (inductionVariable < last_1);
    return false;
  };
  SharedList.prototype.contains_51 = function (element) {
    if (!(element == null ? true : isObject(element)))
      return false;
    else {
    }
    return this.contains_50((element == null ? true : isObject(element)) ? element : THROW_CCE());
  };
  SharedList.prototype.containsAll_37 = function (elements) {
    var tmp$ret$0;
    l$ret$1: do {
      var tmp;
      if (isInterface(elements, Collection)) {
        tmp = elements.isEmpty_53();
      } else {
        {
          tmp = false;
        }
      }
      if (tmp) {
        tmp$ret$0 = true;
        break l$ret$1;
      } else {
      }
      var tmp0_iterator_1 = elements.iterator_64();
      while (tmp0_iterator_1.hasNext_31()) {
        var element_2 = tmp0_iterator_1.next_35();
        if (!this.contains_50(element_2)) {
          tmp$ret$0 = false;
          break l$ret$1;
        } else {
        }
      }
      tmp$ret$0 = true;
    }
     while (false);
    return tmp$ret$0;
  };
  SharedList.prototype.containsAll_38 = function (elements) {
    return this.containsAll_37(elements);
  };
  SharedList.prototype.get_80 = function (index) {
    return this._data_3.get$atomicfu(index)._value_8;
  };
  SharedList.prototype.isEmpty_53 = function () {
    return this._size_6 === 0;
  };
  SharedList.prototype.iterator_64 = function () {
    return this.listIterator_3(0);
  };
  SharedList.prototype.listIterator_3 = function (index) {
    return new _no_name_provided__148(index, this);
  };
  SharedList.$metadata$ = {
    simpleName: 'SharedList',
    kind: 'class',
    interfaces: [List]
  };
  function Companion_43() {
    Companion_instance_42 = this;
    this._START = GMTDate_0(new Long(0, 0));
  }
  Companion_43.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_42;
  function Companion_getInstance_42() {
    if (Companion_instance_42 == null)
      new Companion_43();
    return Companion_instance_42;
  }
  function GMTDate(seconds, minutes, hours, dayOfWeek, dayOfMonth, dayOfYear, month, year, timestamp) {
    Companion_getInstance_42();
    this._seconds = seconds;
    this._minutes = minutes;
    this._hours = hours;
    this._dayOfWeek = dayOfWeek;
    this._dayOfMonth = dayOfMonth;
    this._dayOfYear = dayOfYear;
    this._month = month;
    this._year = year;
    this._timestamp = timestamp;
  }
  GMTDate.prototype.compareTo_34 = function (other) {
    return this._timestamp.compareTo_69(other._timestamp);
  };
  GMTDate.prototype.compareTo_35 = function (other) {
    return this.compareTo_34(other instanceof GMTDate ? other : THROW_CCE());
  };
  GMTDate.prototype.toString = function () {
    return '' + 'GMTDate(seconds=' + this._seconds + ', minutes=' + this._minutes + ', hours=' + this._hours + ', dayOfWeek=' + this._dayOfWeek + ', dayOfMonth=' + this._dayOfMonth + ', dayOfYear=' + this._dayOfYear + ', month=' + this._month + ', year=' + this._year + ', timestamp=' + this._timestamp + ')';
  };
  GMTDate.prototype.hashCode = function () {
    var result = this._seconds;
    result = imul(result, 31) + this._minutes | 0;
    result = imul(result, 31) + this._hours | 0;
    result = imul(result, 31) + this._dayOfWeek.hashCode() | 0;
    result = imul(result, 31) + this._dayOfMonth | 0;
    result = imul(result, 31) + this._dayOfYear | 0;
    result = imul(result, 31) + this._month.hashCode() | 0;
    result = imul(result, 31) + this._year | 0;
    result = imul(result, 31) + this._timestamp.hashCode() | 0;
    return result;
  };
  GMTDate.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof GMTDate))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof GMTDate ? other : THROW_CCE();
    if (!(this._seconds === tmp0_other_with_cast._seconds))
      return false;
    if (!(this._minutes === tmp0_other_with_cast._minutes))
      return false;
    if (!(this._hours === tmp0_other_with_cast._hours))
      return false;
    if (!this._dayOfWeek.equals(tmp0_other_with_cast._dayOfWeek))
      return false;
    if (!(this._dayOfMonth === tmp0_other_with_cast._dayOfMonth))
      return false;
    if (!(this._dayOfYear === tmp0_other_with_cast._dayOfYear))
      return false;
    if (!this._month.equals(tmp0_other_with_cast._month))
      return false;
    if (!(this._year === tmp0_other_with_cast._year))
      return false;
    if (!this._timestamp.equals(tmp0_other_with_cast._timestamp))
      return false;
    return true;
  };
  GMTDate.$metadata$ = {
    simpleName: 'GMTDate',
    kind: 'class',
    interfaces: [Comparable]
  };
  var WeekDay_MONDAY_instance;
  var WeekDay_TUESDAY_instance;
  var WeekDay_WEDNESDAY_instance;
  var WeekDay_THURSDAY_instance;
  var WeekDay_FRIDAY_instance;
  var WeekDay_SATURDAY_instance;
  var WeekDay_SUNDAY_instance;
  function Companion_44() {
    Companion_instance_43 = this;
  }
  Companion_44.prototype.from_1 = function (ordinal) {
    return values_1()[ordinal];
  };
  Companion_44.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_43;
  function Companion_getInstance_43() {
    if (Companion_instance_43 == null)
      new Companion_44();
    return Companion_instance_43;
  }
  function values_1() {
    return [WeekDay_MONDAY_getInstance(), WeekDay_TUESDAY_getInstance(), WeekDay_WEDNESDAY_getInstance(), WeekDay_THURSDAY_getInstance(), WeekDay_FRIDAY_getInstance(), WeekDay_SATURDAY_getInstance(), WeekDay_SUNDAY_getInstance()];
  }
  var WeekDay_entriesInitialized;
  function WeekDay_initEntries() {
    if (WeekDay_entriesInitialized)
      return Unit_getInstance();
    WeekDay_entriesInitialized = true;
    WeekDay_MONDAY_instance = new WeekDay('MONDAY', 0, 'Mon');
    WeekDay_TUESDAY_instance = new WeekDay('TUESDAY', 1, 'Tue');
    WeekDay_WEDNESDAY_instance = new WeekDay('WEDNESDAY', 2, 'Wed');
    WeekDay_THURSDAY_instance = new WeekDay('THURSDAY', 3, 'Thu');
    WeekDay_FRIDAY_instance = new WeekDay('FRIDAY', 4, 'Fri');
    WeekDay_SATURDAY_instance = new WeekDay('SATURDAY', 5, 'Sat');
    WeekDay_SUNDAY_instance = new WeekDay('SUNDAY', 6, 'Sun');
    Companion_getInstance_43();
  }
  function WeekDay(name, ordinal, value) {
    Enum.call(this, name, ordinal);
    this._value_27 = value;
  }
  WeekDay.$metadata$ = {
    simpleName: 'WeekDay',
    kind: 'class',
    interfaces: []
  };
  var Month_JANUARY_instance;
  var Month_FEBRUARY_instance;
  var Month_MARCH_instance;
  var Month_APRIL_instance;
  var Month_MAY_instance;
  var Month_JUNE_instance;
  var Month_JULY_instance;
  var Month_AUGUST_instance;
  var Month_SEPTEMBER_instance;
  var Month_OCTOBER_instance;
  var Month_NOVEMBER_instance;
  var Month_DECEMBER_instance;
  function Companion_45() {
    Companion_instance_44 = this;
  }
  Companion_45.prototype.from_1 = function (ordinal) {
    return values_2()[ordinal];
  };
  Companion_45.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_44;
  function Companion_getInstance_44() {
    if (Companion_instance_44 == null)
      new Companion_45();
    return Companion_instance_44;
  }
  function values_2() {
    return [Month_JANUARY_getInstance(), Month_FEBRUARY_getInstance(), Month_MARCH_getInstance(), Month_APRIL_getInstance(), Month_MAY_getInstance(), Month_JUNE_getInstance(), Month_JULY_getInstance(), Month_AUGUST_getInstance(), Month_SEPTEMBER_getInstance(), Month_OCTOBER_getInstance(), Month_NOVEMBER_getInstance(), Month_DECEMBER_getInstance()];
  }
  var Month_entriesInitialized;
  function Month_initEntries() {
    if (Month_entriesInitialized)
      return Unit_getInstance();
    Month_entriesInitialized = true;
    Month_JANUARY_instance = new Month('JANUARY', 0, 'Jan');
    Month_FEBRUARY_instance = new Month('FEBRUARY', 1, 'Feb');
    Month_MARCH_instance = new Month('MARCH', 2, 'Mar');
    Month_APRIL_instance = new Month('APRIL', 3, 'Apr');
    Month_MAY_instance = new Month('MAY', 4, 'May');
    Month_JUNE_instance = new Month('JUNE', 5, 'Jun');
    Month_JULY_instance = new Month('JULY', 6, 'Jul');
    Month_AUGUST_instance = new Month('AUGUST', 7, 'Aug');
    Month_SEPTEMBER_instance = new Month('SEPTEMBER', 8, 'Sep');
    Month_OCTOBER_instance = new Month('OCTOBER', 9, 'Oct');
    Month_NOVEMBER_instance = new Month('NOVEMBER', 10, 'Nov');
    Month_DECEMBER_instance = new Month('DECEMBER', 11, 'Dec');
    Companion_getInstance_44();
  }
  function Month(name, ordinal, value) {
    Enum.call(this, name, ordinal);
    this._value_28 = value;
  }
  Month.$metadata$ = {
    simpleName: 'Month',
    kind: 'class',
    interfaces: []
  };
  function WeekDay_MONDAY_getInstance() {
    WeekDay_initEntries();
    return WeekDay_MONDAY_instance;
  }
  function WeekDay_TUESDAY_getInstance() {
    WeekDay_initEntries();
    return WeekDay_TUESDAY_instance;
  }
  function WeekDay_WEDNESDAY_getInstance() {
    WeekDay_initEntries();
    return WeekDay_WEDNESDAY_instance;
  }
  function WeekDay_THURSDAY_getInstance() {
    WeekDay_initEntries();
    return WeekDay_THURSDAY_instance;
  }
  function WeekDay_FRIDAY_getInstance() {
    WeekDay_initEntries();
    return WeekDay_FRIDAY_instance;
  }
  function WeekDay_SATURDAY_getInstance() {
    WeekDay_initEntries();
    return WeekDay_SATURDAY_instance;
  }
  function WeekDay_SUNDAY_getInstance() {
    WeekDay_initEntries();
    return WeekDay_SUNDAY_instance;
  }
  function Month_JANUARY_getInstance() {
    Month_initEntries();
    return Month_JANUARY_instance;
  }
  function Month_FEBRUARY_getInstance() {
    Month_initEntries();
    return Month_FEBRUARY_instance;
  }
  function Month_MARCH_getInstance() {
    Month_initEntries();
    return Month_MARCH_instance;
  }
  function Month_APRIL_getInstance() {
    Month_initEntries();
    return Month_APRIL_instance;
  }
  function Month_MAY_getInstance() {
    Month_initEntries();
    return Month_MAY_instance;
  }
  function Month_JUNE_getInstance() {
    Month_initEntries();
    return Month_JUNE_instance;
  }
  function Month_JULY_getInstance() {
    Month_initEntries();
    return Month_JULY_instance;
  }
  function Month_AUGUST_getInstance() {
    Month_initEntries();
    return Month_AUGUST_instance;
  }
  function Month_SEPTEMBER_getInstance() {
    Month_initEntries();
    return Month_SEPTEMBER_instance;
  }
  function Month_OCTOBER_getInstance() {
    Month_initEntries();
    return Month_OCTOBER_instance;
  }
  function Month_NOVEMBER_getInstance() {
    Month_initEntries();
    return Month_NOVEMBER_instance;
  }
  function Month_DECEMBER_getInstance() {
    Month_initEntries();
    return Month_DECEMBER_instance;
  }
  function proceedLoop($this, $cont) {
    var tmp = new $proceedLoopCOROUTINE$1($this, $cont);
    tmp._result = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_72();
  }
  function $proceedLoopCOROUTINE$1(_this_, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__17 = _this_;
  }
  $proceedLoopCOROUTINE$1.prototype.doResume_72 = function () {
    var suspendResult = this._result;
    $sm: do
      try {
        var tmp = this._state_0;
        switch (tmp) {
          case 0:
            this._exceptionState = 6;
            this._state_0 = 1;
            continue $sm;
          case 1:
            this._index0 = this.__this__17._index_4;
            if (this._index0 === -1) {
              this._state_0 = 5;
              continue $sm;
            } else {
              this._state_0 = 2;
              continue $sm;
            }

            break;
          case 2:
            this._interceptors1 = this.__this__17._interceptors;
            if (this._index0 >= this._interceptors1._get_size__45()) {
              this.__this__17.finish();
              this._state_0 = 5;
              continue $sm;
            } else {
              this._state_0 = 3;
              continue $sm;
            }

            break;
          case 3:
            this._executeInterceptor2 = this._interceptors1.get_80(this._index0);
            this.__this__17._index_4 = this._index0 + 1 | 0;
            this._state_0 = 4;
            suspendResult = this._executeInterceptor2(this.__this__17, this.__this__17._subject, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 4:
            suspendResult;
            {
              this._state_0 = 1;
              continue $sm;
            }

            this._state_0 = 5;
            continue $sm;
          case 5:
            return this.__this__17._subject;
          case 6:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 6) {
          throw $p;
        } else {
          this._state_0 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $proceedLoopCOROUTINE$1.$metadata$ = {
    simpleName: '$proceedLoopCOROUTINE$1',
    kind: 'class',
    interfaces: []
  };
  function DebugPipelineContext(context, interceptors, subject, coroutineContext) {
    this._context_1 = context;
    this._interceptors = interceptors;
    this._coroutineContext_0 = coroutineContext;
    this._subject = subject;
    this._index_4 = 0;
  }
  DebugPipelineContext.prototype._get_context__86 = function () {
    return this._context_1;
  };
  DebugPipelineContext.prototype._get_coroutineContext__22 = function () {
    return this._coroutineContext_0;
  };
  DebugPipelineContext.prototype.finish = function () {
    this._index_4 = -1;
  };
  DebugPipelineContext.prototype.proceedWith_1 = function (subject, $cont) {
    this._subject = subject;
    return this.proceed_1($cont);
  };
  DebugPipelineContext.prototype.proceed_1 = function ($cont) {
    var index = this._index_4;
    if (index < 0)
      return this._subject;
    if (index >= this._interceptors._get_size__45()) {
      this.finish();
      return this._subject;
    }return proceedLoop(this, $cont);
  };
  DebugPipelineContext.prototype.execute_3 = function (initial, $cont) {
    this._index_4 = 0;
    this._subject = initial;
    return this.proceed_1($cont);
  };
  DebugPipelineContext.prototype.execute_4 = function (initial, $cont) {
    return this.execute_3(isObject(initial) ? initial : THROW_CCE(), $cont);
  };
  DebugPipelineContext.$metadata$ = {
    simpleName: 'DebugPipelineContext',
    kind: 'class',
    interfaces: [PipelineContext, PipelineExecutor]
  };
  function _set_interceptors_($this, _set___) {
    return $this._interceptors$delegate.setValue_7($this, interceptors$factory(), _set___);
  }
  function _get_interceptors_($this) {
    return $this._interceptors$delegate.getValue_10($this, interceptors$factory_0());
  }
  function PhaseContent_init_$Init$(phase, relation, $this) {
    var tmp = Companion_getInstance_45()._SharedArrayList;
    PhaseContent.call($this, phase, relation, isInterface(tmp, MutableList) ? tmp : THROW_CCE());
    var tmp0_check_0 = Companion_getInstance_45()._SharedArrayList.isEmpty_53();
    if (!tmp0_check_0) {
      var message_1 = 'The shared empty array list has been modified';
      throw IllegalStateException_init_$Create$(toString_1(message_1));
    }return $this;
  }
  function PhaseContent_init_$Create$(phase, relation) {
    return PhaseContent_init_$Init$(phase, relation, Object.create(PhaseContent.prototype));
  }
  function copyInterceptors($this) {
    _set_interceptors_($this, $this.copiedInterceptors());
    $this._set_shared_(false);
  }
  function Companion_46() {
    Companion_instance_45 = this;
    this._SharedArrayList = sharedListOf([]);
  }
  Companion_46.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_45;
  function Companion_getInstance_45() {
    if (Companion_instance_45 == null)
      new Companion_46();
    return Companion_instance_45;
  }
  function PhaseContent(phase, relation, interceptors) {
    Companion_getInstance_45();
    this._phase = phase;
    this._relation = relation;
    var tmp = this;
    tmp._interceptors$delegate = new _no_name_provided__124(interceptors);
    var tmp_0 = this;
    var tmp0_shared_0 = true;
    tmp_0._shared$delegate = new _no_name_provided__124(tmp0_shared_0);
  }
  PhaseContent.prototype._set_shared_ = function (_set___) {
    return this._shared$delegate.setValue_7(this, shared$factory(), _set___);
  };
  PhaseContent.prototype._get_shared_ = function () {
    return this._shared$delegate.getValue_10(this, shared$factory_0());
  };
  PhaseContent.prototype._get_isEmpty__4 = function () {
    return _get_interceptors_(this).isEmpty_53();
  };
  PhaseContent.prototype._get_size__45 = function () {
    return _get_interceptors_(this)._get_size__45();
  };
  PhaseContent.prototype.addInterceptor = function (interceptor) {
    if (this._get_shared_()) {
      copyInterceptors(this);
    }_get_interceptors_(this).add_33(interceptor);
    Unit_getInstance();
  };
  PhaseContent.prototype.addTo = function (destination) {
    var interceptors = _get_interceptors_(this);
    if (destination instanceof ArrayList) {
      destination.ensureCapacity_8(destination._get_size__45() + interceptors._get_size__45() | 0);
    } else {
    }
    var inductionVariable = 0;
    var last_1 = interceptors._get_size__45();
    if (inductionVariable < last_1)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        destination.add_33(interceptors.get_80(index));
        Unit_getInstance();
      }
       while (inductionVariable < last_1);
  };
  PhaseContent.prototype.sharedInterceptors = function () {
    this._set_shared_(true);
    return _get_interceptors_(this);
  };
  PhaseContent.prototype.copiedInterceptors = function () {
    var tmp0_apply_0 = sharedListOf([]);
    tmp0_apply_0.addAll_23(_get_interceptors_(this));
    Unit_getInstance();
    return tmp0_apply_0;
  };
  PhaseContent.prototype.toString = function () {
    return '' + 'Phase `' + this._phase._name_6 + '`, ' + this._get_size__45() + ' handlers';
  };
  PhaseContent.$metadata$ = {
    simpleName: 'PhaseContent',
    kind: 'class',
    interfaces: []
  };
  function interceptors$factory() {
    return getPropertyCallableRef('interceptors', 1, KMutableProperty1, function (receiver) {
      return _get_interceptors_(receiver);
    }, function (receiver_0, value) {
      return _set_interceptors_(receiver_0, value);
    });
  }
  function interceptors$factory_0() {
    return getPropertyCallableRef('interceptors', 1, KMutableProperty1, function (receiver) {
      return _get_interceptors_(receiver);
    }, function (receiver_0, value) {
      return _set_interceptors_(receiver_0, value);
    });
  }
  function shared$factory() {
    return getPropertyCallableRef('shared', 1, KMutableProperty1, function (receiver) {
      return receiver._get_shared_();
    }, function (receiver_0, value) {
      return receiver_0._set_shared_(value);
    });
  }
  function shared$factory_0() {
    return getPropertyCallableRef('shared', 1, KMutableProperty1, function (receiver) {
      return receiver._get_shared_();
    }, function (receiver_0, value) {
      return receiver_0._set_shared_(value);
    });
  }
  function _set_interceptorsQuantity_($this, _set___) {
    return $this._interceptorsQuantity$delegate.setValue_7($this, interceptorsQuantity$factory(), _set___);
  }
  function _get_interceptorsQuantity_($this) {
    return $this._interceptorsQuantity$delegate.getValue_10($this, interceptorsQuantity$factory_0());
  }
  function _set_interceptors__0($this, value) {
    $this.__interceptors._value_8 = value;
  }
  function _get_interceptors__0($this) {
    return $this.__interceptors._value_8;
  }
  function _set_interceptorsListShared_($this, _set___) {
    return $this._interceptorsListShared$delegate.setValue_7($this, interceptorsListShared$factory(), _set___);
  }
  function _get_interceptorsListShared_($this) {
    return $this._interceptorsListShared$delegate.getValue_10($this, interceptorsListShared$factory_0());
  }
  function _set_interceptorsListSharedPhase_($this, _set___) {
    return $this._interceptorsListSharedPhase$delegate.setValue_7($this, interceptorsListSharedPhase$factory(), _set___);
  }
  function _get_interceptorsListSharedPhase_($this) {
    return $this._interceptorsListSharedPhase$delegate.getValue_10($this, interceptorsListSharedPhase$factory_0());
  }
  function createContext_0($this, context, subject, coroutineContext) {
    return pipelineExecutorFor(context, sharedInterceptorsList($this), subject, coroutineContext, $this._get_developmentMode__4());
  }
  function findPhase($this, phase) {
    var phasesList = $this._phasesRaw;
    var inductionVariable = 0;
    var last_1 = phasesList._get_size__45();
    if (inductionVariable < last_1)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var current = phasesList.get_80(index);
        if (current === phase) {
          var content = PhaseContent_init_$Create$(phase, Last_getInstance());
          phasesList.set_11(index, content);
          Unit_getInstance();
          return content;
        }var tmp;
        if (current instanceof PhaseContent) {
          tmp = current._phase === phase;
        } else {
          {
            tmp = false;
          }
        }
        if (tmp) {
          return current instanceof PhaseContent ? current : THROW_CCE();
        } else {
        }
      }
       while (inductionVariable < last_1);
    return null;
  }
  function findPhaseIndex($this, phase) {
    var phasesList = $this._phasesRaw;
    var inductionVariable = 0;
    var last_1 = phasesList._get_size__45();
    if (inductionVariable < last_1)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var current = phasesList.get_80(index);
        var tmp;
        if (current === phase) {
          tmp = true;
        } else {
          var tmp_0;
          if (current instanceof PhaseContent) {
            tmp_0 = current._phase === phase;
          } else {
            {
              tmp_0 = false;
            }
          }
          tmp = tmp_0;
        }
        if (tmp) {
          return index;
        } else {
        }
      }
       while (inductionVariable < last_1);
    return -1;
  }
  function hasPhase($this, phase) {
    var phasesList = $this._phasesRaw;
    var inductionVariable = 0;
    var last_1 = phasesList._get_size__45();
    if (inductionVariable < last_1)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var current = phasesList.get_80(index);
        var tmp;
        if (current === phase) {
          tmp = true;
        } else {
          var tmp_0;
          if (current instanceof PhaseContent) {
            tmp_0 = current._phase === phase;
          } else {
            {
              tmp_0 = false;
            }
          }
          tmp = tmp_0;
        }
        if (tmp) {
          return true;
        } else {
        }
      }
       while (inductionVariable < last_1);
    return false;
  }
  function cacheInterceptors($this) {
    var interceptorsQuantity = _get_interceptorsQuantity_($this);
    if (interceptorsQuantity === 0) {
      notSharedInterceptorsList($this, emptyList());
      return emptyList();
    }var phases = $this._phasesRaw;
    if (interceptorsQuantity === 1) {
      var inductionVariable = 0;
      var last_1 = _get_lastIndex__0(phases);
      if (inductionVariable <= last_1)
        do {
          var phaseIndex = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var tmp = phases.get_80(phaseIndex);
          var tmp1_elvis_lhs = tmp instanceof PhaseContent ? tmp : null;
          var tmp_0;
          if (tmp1_elvis_lhs == null) {
            continue;
          } else {
            tmp_0 = tmp1_elvis_lhs;
          }
          var phaseContent = tmp_0;
          if (!phaseContent._get_isEmpty__4()) {
            var interceptors = phaseContent.sharedInterceptors();
            setInterceptorsListFromPhase($this, phaseContent);
            return interceptors;
          }}
         while (!(phaseIndex === last_1));
    }var destination = sharedListOf([]);
    var inductionVariable_0 = 0;
    var last_2 = _get_lastIndex__0(phases);
    if (inductionVariable_0 <= last_2)
      do {
        var phaseIndex_0 = inductionVariable_0;
        inductionVariable_0 = inductionVariable_0 + 1 | 0;
        var tmp_1 = phases.get_80(phaseIndex_0);
        var tmp3_elvis_lhs = tmp_1 instanceof PhaseContent ? tmp_1 : null;
        var tmp_2;
        if (tmp3_elvis_lhs == null) {
          continue;
        } else {
          tmp_2 = tmp3_elvis_lhs;
        }
        var phase = tmp_2;
        phase.addTo(destination);
      }
       while (!(phaseIndex_0 === last_2));
    notSharedInterceptorsList($this, destination);
    return destination;
  }
  function sharedInterceptorsList($this) {
    if (_get_interceptors__0($this) == null) {
      cacheInterceptors($this);
      Unit_getInstance();
    }_set_interceptorsListShared_($this, true);
    return ensureNotNull(_get_interceptors__0($this));
  }
  function resetInterceptorsList($this) {
    _set_interceptors__0($this, null);
    _set_interceptorsListShared_($this, false);
    _set_interceptorsListSharedPhase_($this, null);
  }
  function notSharedInterceptorsList($this, list) {
    _set_interceptors__0($this, list);
    _set_interceptorsListShared_($this, false);
    _set_interceptorsListSharedPhase_($this, null);
  }
  function setInterceptorsListFromPhase($this, phaseContent) {
    _set_interceptors__0($this, phaseContent.sharedInterceptors());
    _set_interceptorsListShared_($this, false);
    _set_interceptorsListSharedPhase_($this, phaseContent._phase);
  }
  function tryAddToPhaseFastPath($this, phase, block) {
    var currentInterceptors = _get_interceptors__0($this);
    if ($this._phasesRaw.isEmpty_53() ? true : currentInterceptors == null) {
      return false;
    }var tmp;
    if (_get_interceptorsListShared_($this)) {
      tmp = true;
    } else {
      tmp = !(!(currentInterceptors == null) ? isInterface(currentInterceptors, MutableList) : false);
    }
    if (tmp) {
      return false;
    } else {
    }
    if (equals_1(_get_interceptorsListSharedPhase_($this), phase)) {
      currentInterceptors.add_33(block);
      Unit_getInstance();
      return true;
    }if (equals_1(phase, last($this._phasesRaw)) ? true : findPhaseIndex($this, phase) === _get_lastIndex__0($this._phasesRaw)) {
      ensureNotNull(findPhase($this, phase)).addInterceptor(block);
      currentInterceptors.add_33(block);
      Unit_getInstance();
      return true;
    }return false;
  }
  function Pipeline(phases) {
    this._attributes_0 = Attributes_0(true);
    this._developmentMode = false;
    this._phasesRaw = sharedListOf(phases.slice());
    var tmp = this;
    var tmp0_shared_0 = 0;
    tmp._interceptorsQuantity$delegate = new _no_name_provided__124(tmp0_shared_0);
    this.__interceptors = atomic(null);
    var tmp_0 = this;
    var tmp0_shared_0_0 = false;
    tmp_0._interceptorsListShared$delegate = new _no_name_provided__124(tmp0_shared_0_0);
    var tmp_1 = this;
    var tmp0_shared_0_1 = null;
    tmp_1._interceptorsListSharedPhase$delegate = new _no_name_provided__124(tmp0_shared_0_1);
  }
  Pipeline.prototype._get_developmentMode__4 = function () {
    return this._developmentMode;
  };
  Pipeline.prototype.execute_1 = function (context, subject, $cont) {
    return createContext_0(this, context, subject, $cont._get_context__86()).execute_4(subject, $cont);
  };
  Pipeline.prototype.insertPhaseBefore_0 = function (reference, phase) {
    if (hasPhase(this, phase))
      return Unit_getInstance();
    var index = findPhaseIndex(this, reference);
    if (index === -1) {
      throw new InvalidPhaseException('' + 'Phase ' + reference + ' was not registered for this pipeline');
    }this._phasesRaw.add_27(index, PhaseContent_init_$Create$(phase, new Before(reference)));
  };
  Pipeline.prototype.intercept = function (phase, block) {
    var tmp0_elvis_lhs = findPhase(this, phase);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      throw new InvalidPhaseException('' + 'Phase ' + phase + ' was not registered for this pipeline');
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var phaseContent = tmp;
    if (tryAddToPhaseFastPath(this, phase, block)) {
      var tmp1_this = this;
      var tmp2 = _get_interceptorsQuantity_(tmp1_this);
      _set_interceptorsQuantity_(tmp1_this, tmp2 + 1 | 0);
      Unit_getInstance();
      return Unit_getInstance();
    }phaseContent.addInterceptor(block);
    var tmp3_this = this;
    var tmp4 = _get_interceptorsQuantity_(tmp3_this);
    _set_interceptorsQuantity_(tmp3_this, tmp4 + 1 | 0);
    Unit_getInstance();
    resetInterceptorsList(this);
    this.afterIntercepted_3();
  };
  Pipeline.prototype.afterIntercepted_3 = function () {
  };
  Pipeline.$metadata$ = {
    simpleName: 'Pipeline',
    kind: 'class',
    interfaces: []
  };
  function interceptorsQuantity$factory() {
    return getPropertyCallableRef('interceptorsQuantity', 1, KMutableProperty1, function (receiver) {
      return _get_interceptorsQuantity_(receiver);
    }, function (receiver_0, value) {
      return _set_interceptorsQuantity_(receiver_0, value);
    });
  }
  function interceptorsQuantity$factory_0() {
    return getPropertyCallableRef('interceptorsQuantity', 1, KMutableProperty1, function (receiver) {
      return _get_interceptorsQuantity_(receiver);
    }, function (receiver_0, value) {
      return _set_interceptorsQuantity_(receiver_0, value);
    });
  }
  function interceptorsListShared$factory() {
    return getPropertyCallableRef('interceptorsListShared', 1, KMutableProperty1, function (receiver) {
      return _get_interceptorsListShared_(receiver);
    }, function (receiver_0, value) {
      return _set_interceptorsListShared_(receiver_0, value);
    });
  }
  function interceptorsListShared$factory_0() {
    return getPropertyCallableRef('interceptorsListShared', 1, KMutableProperty1, function (receiver) {
      return _get_interceptorsListShared_(receiver);
    }, function (receiver_0, value) {
      return _set_interceptorsListShared_(receiver_0, value);
    });
  }
  function interceptorsListSharedPhase$factory() {
    return getPropertyCallableRef('interceptorsListSharedPhase', 1, KMutableProperty1, function (receiver) {
      return _get_interceptorsListSharedPhase_(receiver);
    }, function (receiver_0, value) {
      return _set_interceptorsListSharedPhase_(receiver_0, value);
    });
  }
  function interceptorsListSharedPhase$factory_0() {
    return getPropertyCallableRef('interceptorsListSharedPhase', 1, KMutableProperty1, function (receiver) {
      return _get_interceptorsListSharedPhase_(receiver);
    }, function (receiver_0, value) {
      return _set_interceptorsListSharedPhase_(receiver_0, value);
    });
  }
  function PipelineContext() {
  }
  PipelineContext.$metadata$ = {
    simpleName: 'PipelineContext',
    kind: 'interface',
    interfaces: [CoroutineScope]
  };
  function PipelineExecutor() {
  }
  PipelineExecutor.$metadata$ = {
    simpleName: 'PipelineExecutor',
    kind: 'interface',
    interfaces: []
  };
  function pipelineExecutorFor(context, interceptors, subject, coroutineContext, debugMode) {
    var tmp;
    if (debugMode) {
      tmp = new DebugPipelineContext(context, interceptors, subject, coroutineContext);
    } else {
      tmp = new SuspendFunctionGun(subject, context, interceptors);
    }
    return tmp;
  }
  function PipelinePhase(name) {
    this._name_6 = name;
  }
  PipelinePhase.prototype.toString = function () {
    return '' + "Phase('" + this._name_6 + "')";
  };
  PipelinePhase.$metadata$ = {
    simpleName: 'PipelinePhase',
    kind: 'class',
    interfaces: []
  };
  function InvalidPhaseException(message) {
    extendThrowable(this, message, void 1);
    captureStack(this, InvalidPhaseException);
  }
  InvalidPhaseException.$metadata$ = {
    simpleName: 'InvalidPhaseException',
    kind: 'class',
    interfaces: []
  };
  function Before(relativeTo) {
    PipelinePhaseRelation.call(this);
    this._relativeTo = relativeTo;
  }
  Before.$metadata$ = {
    simpleName: 'Before',
    kind: 'class',
    interfaces: []
  };
  function Last() {
    Last_instance = this;
    PipelinePhaseRelation.call(this);
  }
  Last.$metadata$ = {
    simpleName: 'Last',
    kind: 'object',
    interfaces: []
  };
  var Last_instance;
  function Last_getInstance() {
    if (Last_instance == null)
      new Last();
    return Last_instance;
  }
  function PipelinePhaseRelation() {
  }
  PipelinePhaseRelation.$metadata$ = {
    simpleName: 'PipelinePhaseRelation',
    kind: 'class',
    interfaces: []
  };
  function recoverStackTraceBridge(exception, continuation) {
    var tmp;
    try {
      tmp = withCause(recoverStackTrace(exception, continuation), exception.cause);
    } catch ($p) {
      var tmp_0;
      if ($p instanceof Error) {
        tmp_0 = exception;
      } else {
        {
          throw $p;
        }
      }
      tmp = tmp_0;
    }
    return tmp;
  }
  function loop($this, direct) {
    do {
      var index = $this._index_5;
      if (index === $this._blocks._get_size__45()) {
        if (!direct) {
          var tmp0_success_0 = Companion_getInstance_3();
          var tmp1_success_0 = $this._subject_0;
          resumeRootWith($this, _Result___init__impl_(tmp1_success_0));
          return false;
        }return true;
      }$this._index_5 = index + 1 | 0;
      var next = $this._blocks.get_80(index);
      try {
        var me = $this;
        var tmp2_startCoroutineUninterceptedOrReturn3_0 = me._subject_0;
        var tmp3_startCoroutineUninterceptedOrReturn3_0 = me._continuation_4;
        var block_1 = _no_name_provided_$factory_113(next, me, tmp2_startCoroutineUninterceptedOrReturn3_0, null);
        var rc = block_1(tmp3_startCoroutineUninterceptedOrReturn3_0);
        if (rc === _get_COROUTINE_SUSPENDED_()) {
          return false;
        }} catch ($p) {
        if ($p instanceof Error) {
          var tmp4_failure_0 = Companion_getInstance_3();
          resumeRootWith($this, _Result___init__impl_(createFailure($p)));
          return false;
        } else {
          {
            throw $p;
          }
        }
      }
    }
     while (true);
  }
  function resumeRootWith($this, result) {
    var rootContinuation = $this._rootContinuation;
    var tmp0_subject = rootContinuation;
    var tmp;
    if (tmp0_subject == null) {
      throw IllegalStateException_init_$Create$('No more continuations to resume');
    } else {
      if (!(tmp0_subject == null) ? isInterface(tmp0_subject, Continuation) : false) {
        $this._rootContinuation = null;
        $this._lastPeekedIndex = -1;
        tmp = rootContinuation;
      } else {
        if (tmp0_subject instanceof ArrayList) {
          if (rootContinuation.isEmpty_53())
            throw IllegalStateException_init_$Create$('No more continuations to resume');
          $this._lastPeekedIndex = _get_lastIndex__0(rootContinuation) - 1 | 0;
          tmp = rootContinuation.removeAt_2(_get_lastIndex__0(rootContinuation));
        } else {
          {
            unexpectedRootContinuationValue($this, rootContinuation);
          }
        }
      }
    }
    var tmp_0 = tmp;
    var next = (!(tmp_0 == null) ? isInterface(tmp_0, Continuation) : false) ? tmp_0 : THROW_CCE();
    if (!_Result___get_isFailure__impl_(result)) {
      next.resumeWith_34(result);
    } else {
      var exception = recoverStackTraceBridge(ensureNotNull(Result__exceptionOrNull_impl(result)), next);
      var tmp0_failure_0_1 = Companion_getInstance_3();
      next.resumeWith_34(_Result___init__impl_(createFailure(exception)));
    }
  }
  function discardLastRootContinuation($this) {
    var rootContinuation = $this._rootContinuation;
    var tmp0_subject = rootContinuation;
    if (tmp0_subject == null)
      throw IllegalStateException_init_$Create$('No more continuations to resume');
    else {
      if (!(tmp0_subject == null) ? isInterface(tmp0_subject, Continuation) : false) {
        $this._lastPeekedIndex = -1;
        $this._rootContinuation = null;
      } else {
        if (tmp0_subject instanceof ArrayList) {
          if (rootContinuation.isEmpty_53())
            throw IllegalStateException_init_$Create$('No more continuations to resume');
          rootContinuation.removeAt_2(_get_lastIndex__0(rootContinuation));
          Unit_getInstance();
          $this._lastPeekedIndex = _get_lastIndex__0(rootContinuation);
        } else {
          {
            unexpectedRootContinuationValue($this, rootContinuation);
          }
        }
      }
    }
  }
  function addContinuation($this, continuation) {
    var rootContinuation = $this._rootContinuation;
    if (rootContinuation == null) {
      $this._lastPeekedIndex = 0;
      $this._rootContinuation = continuation;
    } else {
      if (!(rootContinuation == null) ? isInterface(rootContinuation, Continuation) : false) {
        var tmp = $this;
        var tmp0_apply_0 = ArrayList_init_$Create$_0($this._blocks._get_size__45());
        tmp0_apply_0.add_33(rootContinuation);
        Unit_getInstance();
        tmp0_apply_0.add_33(continuation);
        Unit_getInstance();
        $this._lastPeekedIndex = 1;
        tmp._rootContinuation = tmp0_apply_0;
      } else {
        if (rootContinuation instanceof ArrayList) {
          if (rootContinuation instanceof ArrayList)
            rootContinuation;
          else
            THROW_CCE();
          Unit_getInstance();
          rootContinuation.add_33(continuation);
          Unit_getInstance();
          $this._lastPeekedIndex = _get_lastIndex__0(rootContinuation);
        } else {
          {
            unexpectedRootContinuationValue($this, rootContinuation);
          }
        }
      }
    }
  }
  function unexpectedRootContinuationValue($this, rootContinuation) {
    throw IllegalStateException_init_$Create$('' + 'Unexpected rootContinuation content: ' + rootContinuation);
  }
  function _no_name_provided__149(this$0) {
    this._this$0_49 = this$0;
  }
  _no_name_provided__149.prototype._get_context__86 = function () {
    var cont = this._this$0_49._rootContinuation;
    var tmp;
    if (cont == null) {
      throw IllegalStateException_init_$Create$('Not started');
    } else {
      if (!(cont == null) ? isInterface(cont, Continuation) : false) {
        tmp = cont._get_context__86();
      } else {
        if (!(cont == null) ? isInterface(cont, List) : false) {
          tmp = last((!(cont == null) ? isInterface(cont, List) : false) ? cont : THROW_CCE())._get_context__86();
        } else {
          {
            throw IllegalStateException_init_$Create$('Unexpected rootContinuation value');
          }
        }
      }
    }
    return tmp;
  };
  _no_name_provided__149.prototype.resumeWith_33 = function (result) {
    if (_Result___get_isFailure__impl_(result)) {
      var tmp0_failure_0 = Companion_getInstance_3();
      var tmp1_failure_0 = ensureNotNull(Result__exceptionOrNull_impl(result));
      resumeRootWith(this._this$0_49, _Result___init__impl_(createFailure(tmp1_failure_0)));
      return Unit_getInstance();
    }loop(this._this$0_49, false);
    Unit_getInstance();
  };
  _no_name_provided__149.prototype.resumeWith_34 = function (result) {
    return this.resumeWith_33(result);
  };
  _no_name_provided__149.$metadata$ = {
    kind: 'class',
    interfaces: [Continuation, CoroutineStackFrame_0]
  };
  function _no_name_provided__150($next, $me, $tmp2_startCoroutineUninterceptedOrReturn3_0, resultContinuation) {
    this._$next = $next;
    this._$me = $me;
    this._$tmp2_startCoroutineUninterceptedOrReturn3_0 = $tmp2_startCoroutineUninterceptedOrReturn3_0;
    CoroutineImpl_0.call(this, resultContinuation);
  }
  _no_name_provided__150.prototype.invoke_494 = function ($cont) {
    var tmp = this.create_3($cont);
    tmp._result = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_72();
  };
  _no_name_provided__150.prototype.doResume_72 = function () {
    var suspendResult = this._result;
    $sm: do
      try {
        var tmp = this._state_0;
        switch (tmp) {
          case 0:
            this._exceptionState = 2;
            this._state_0 = 1;
            suspendResult = this._$next(this._$me, this._$tmp2_startCoroutineUninterceptedOrReturn3_0, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            suspendResult;
            return Unit_getInstance();
          case 2:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 2) {
          throw $p;
        } else {
          this._state_0 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  _no_name_provided__150.prototype.create_3 = function (completion) {
    var i = new _no_name_provided__150(this._$next, this._$me, this._$tmp2_startCoroutineUninterceptedOrReturn3_0, completion);
    return i;
  };
  _no_name_provided__150.$metadata$ = {
    kind: 'class',
    interfaces: [],
    suspendArity: 0
  };
  function SuspendFunctionGun(initial, context, blocks) {
    this._context_2 = context;
    this._blocks = blocks;
    this._lastPeekedIndex = -1;
    var tmp = this;
    tmp._continuation_4 = new _no_name_provided__149(this);
    this._subject_0 = initial;
    this._rootContinuation = null;
    this._index_5 = 0;
    preventFreeze(this);
  }
  SuspendFunctionGun.prototype._get_context__86 = function () {
    return this._context_2;
  };
  SuspendFunctionGun.prototype._get_coroutineContext__22 = function () {
    return this._continuation_4._get_context__86();
  };
  SuspendFunctionGun.prototype.proceed_1 = function ($cont) {
    var tmp$ret$0;
    l$ret$1: do {
      var tmp0__anonymous__1 = $cont;
      if (this._index_5 === this._blocks._get_size__45()) {
        tmp$ret$0 = this._subject_0;
        break l$ret$1;
      }addContinuation(this, tmp0__anonymous__1);
      if (loop(this, true)) {
        discardLastRootContinuation(this);
        tmp$ret$0 = this._subject_0;
        break l$ret$1;
      }tmp$ret$0 = _get_COROUTINE_SUSPENDED_();
    }
     while (false);
    return tmp$ret$0;
  };
  SuspendFunctionGun.prototype.proceedWith_1 = function (subject, $cont) {
    this._subject_0 = subject;
    return this.proceed_1($cont);
  };
  SuspendFunctionGun.prototype.execute_3 = function (initial, $cont) {
    this._index_5 = 0;
    if (this._index_5 === this._blocks._get_size__45())
      return initial;
    this._subject_0 = initial;
    if (!(this._rootContinuation == null))
      throw IllegalStateException_init_$Create$('Already started');
    return this.proceed_1($cont);
  };
  SuspendFunctionGun.prototype.execute_4 = function (initial, $cont) {
    return this.execute_3(isObject(initial) ? initial : THROW_CCE(), $cont);
  };
  SuspendFunctionGun.$metadata$ = {
    simpleName: 'SuspendFunctionGun',
    kind: 'class',
    interfaces: [PipelineContext, PipelineExecutor, CoroutineScope]
  };
  function _no_name_provided_$factory_113($next, $me, $tmp2_startCoroutineUninterceptedOrReturn3_0, resultContinuation) {
    var i = new _no_name_provided__150($next, $me, $tmp2_startCoroutineUninterceptedOrReturn3_0, resultContinuation);
    var l = function ($cont) {
      return i.invoke_494($cont);
    };
    l.$arity = 0;
    return l;
  }
  function Attributes_0(concurrent) {
    return new AttributesJs();
  }
  function AttributesJs() {
    var tmp = this;
    tmp._map_1 = LinkedHashMap_init_$Create$();
  }
  AttributesJs.prototype.getOrNull_0 = function (key) {
    var tmp = this._map_1.get_63(key);
    return (tmp == null ? true : isObject(tmp)) ? tmp : THROW_CCE();
  };
  AttributesJs.prototype.contains_52 = function (key) {
    return this._map_1.containsKey_16(key);
  };
  AttributesJs.prototype.put_13 = function (key, value) {
    var tmp0_set_0 = this._map_1;
    tmp0_set_0.put_12(key, value);
    Unit_getInstance();
  };
  AttributesJs.prototype.computeIfAbsent_0 = function (key, block) {
    var tmp0_safe_receiver = this._map_1.get_63(key);
    if (tmp0_safe_receiver == null)
      null;
    else {
      return isObject(tmp0_safe_receiver) ? tmp0_safe_receiver : THROW_CCE();
    }
    Unit_getInstance();
    var tmp0_also_0 = block();
    var tmp0_set_0_2 = this._map_1;
    tmp0_set_0_2.put_12(key, tmp0_also_0);
    Unit_getInstance();
    return tmp0_also_0;
  };
  AttributesJs.prototype._get_allKeys__0 = function () {
    return toList_0(this._map_1._get_keys__10());
  };
  AttributesJs.$metadata$ = {
    simpleName: 'AttributesJs',
    kind: 'class',
    interfaces: [Attributes]
  };
  function unmodifiable(_this_) {
    return _this_;
  }
  var _crypto;
  function _crypto$init$() {
    return PlatformUtils_getInstance()._IS_NODE ? require('crypto') : crypto ? crypto : msCrypto;
  }
  function Lock() {
  }
  Lock.prototype.lock = function () {
  };
  Lock.prototype.unlock = function () {
  };
  Lock.$metadata$ = {
    simpleName: 'Lock',
    kind: 'class',
    interfaces: []
  };
  function PlatformUtils() {
    PlatformUtils_instance = this;
    var tmp = this;
    var tmp_0 = typeof window !== 'undefined' && typeof window.document !== 'undefined';
    tmp._IS_BROWSER = (!(tmp_0 == null) ? typeof tmp_0 === 'boolean' : false) ? tmp_0 : THROW_CCE();
    var tmp_1 = this;
    var tmp_2 = typeof process !== 'undefined' && process.versions != null && process.versions.node != null;
    tmp_1._IS_NODE = (!(tmp_2 == null) ? typeof tmp_2 === 'boolean' : false) ? tmp_2 : THROW_CCE();
    this._IS_JVM = false;
    this._IS_NATIVE = false;
    this._IS_DEVELOPMENT_MODE = false;
  }
  PlatformUtils.$metadata$ = {
    simpleName: 'PlatformUtils',
    kind: 'object',
    interfaces: []
  };
  var PlatformUtils_instance;
  function PlatformUtils_getInstance() {
    if (PlatformUtils_instance == null)
      new PlatformUtils();
    return PlatformUtils_instance;
  }
  function CoroutineStackFrame_0() {
  }
  CoroutineStackFrame_0.$metadata$ = {
    simpleName: 'CoroutineStackFrame',
    kind: 'interface',
    interfaces: []
  };
  function GMTDate_0(timestamp) {
    var tmp0_safe_receiver = timestamp;
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.toDouble_4();
    var tmp;
    if (tmp1_safe_receiver == null) {
      tmp = null;
    } else {
      tmp = new Date(tmp1_safe_receiver);
    }
    var tmp2_elvis_lhs = tmp;
    var date = tmp2_elvis_lhs == null ? new Date() : tmp2_elvis_lhs;
    if (isNaN_0(date.getTime()))
      throw new InvalidTimestampException(ensureNotNull(timestamp));
    var dayOfWeek_2 = Companion_getInstance_43().from_1((date.getUTCDay() + 6 | 0) % 7);
    var month_3 = Companion_getInstance_44().from_1(date.getUTCMonth());
    return new GMTDate(date.getUTCSeconds(), date.getUTCMinutes(), date.getUTCHours(), dayOfWeek_2, date.getUTCDate(), date.getUTCFullYear(), month_3, date.getUTCFullYear(), numberToLong(date.getTime()));
  }
  function GMTDate$default(timestamp, $mask0, $handler) {
    if (!(($mask0 & 1) === 0))
      timestamp = null;
    return GMTDate_0(timestamp);
  }
  function InvalidTimestampException(timestamp) {
    IllegalStateException_init_$Init$_0('' + 'Invalid date timestamp exception: ' + timestamp, this);
    captureStack(this, InvalidTimestampException);
  }
  InvalidTimestampException.$metadata$ = {
    simpleName: 'InvalidTimestampException',
    kind: 'class',
    interfaces: []
  };
  function withCause(_this_, cause) {
    return _this_;
  }
  var URL_ALPHABET;
  var URL_ALPHABET_CHARS;
  var HEX_ALPHABET;
  var URL_PROTOCOL_PART;
  var VALID_PATH_PART;
  var OAUTH_SYMBOLS;
  var LETTERS_AND_NUMBERS;
  var TOKENS;
  function encodeURLPath(_this_) {
    var tmp0_apply_0_1 = StringBuilder_init_$Create$_0();
    var charset_3 = Charsets_getInstance()._UTF_8;
    var index_4 = 0;
    while (index_4 < _this_.length) {
      var current_5 = charSequenceGet(_this_, index_4);
      if ((current_5.equals(new Char(47)) ? true : URL_ALPHABET_CHARS.contains_51(current_5)) ? true : VALID_PATH_PART.contains_51(current_5)) {
        tmp0_apply_0_1.append_32(current_5);
        Unit_getInstance();
        var tmp0_6 = index_4;
        index_4 = tmp0_6 + 1 | 0;
        Unit_getInstance();
        continue;
      }if (((current_5.equals(new Char(37)) ? (index_4 + 2 | 0) < _this_.length : false) ? HEX_ALPHABET.contains_51(charSequenceGet(_this_, index_4 + 1 | 0)) : false) ? HEX_ALPHABET.contains_51(charSequenceGet(_this_, index_4 + 2 | 0)) : false) {
        tmp0_apply_0_1.append_32(current_5);
        Unit_getInstance();
        tmp0_apply_0_1.append_32(charSequenceGet(_this_, index_4 + 1 | 0));
        Unit_getInstance();
        tmp0_apply_0_1.append_32(charSequenceGet(_this_, index_4 + 2 | 0));
        Unit_getInstance();
        index_4 = index_4 + 3 | 0;
        continue;
      }var symbolSize_7 = isSurrogate(current_5) ? 2 : 1;
      var tmp = encode(charset_3.newEncoder_0(), _this_, index_4, index_4 + symbolSize_7 | 0);
      forEach(tmp, _no_name_provided_$factory_114(tmp0_apply_0_1));
      index_4 = index_4 + symbolSize_7 | 0;
    }
    return tmp0_apply_0_1.toString();
  }
  function encodeURLQueryComponent(_this_, encodeFull, spaceToPlus, charset_1) {
    var tmp0_apply_0_1 = StringBuilder_init_$Create$_0();
    var tmp = charset_1.newEncoder_0();
    var content_3 = encode$default(tmp, _this_, 0, 0, 6, null);
    forEach(content_3, _no_name_provided_$factory_115(spaceToPlus, tmp0_apply_0_1, encodeFull));
    return tmp0_apply_0_1.toString();
  }
  function encodeURLQueryComponent$default(_this_, encodeFull, spaceToPlus, charset_1, $mask0, $handler) {
    if (!(($mask0 & 1) === 0))
      encodeFull = false;
    if (!(($mask0 & 2) === 0))
      spaceToPlus = false;
    if (!(($mask0 & 4) === 0))
      charset_1 = Charsets_getInstance()._UTF_8;
    return encodeURLQueryComponent(_this_, encodeFull, spaceToPlus, charset_1);
  }
  function encodeURLParameter(_this_, spaceToPlus) {
    var tmp0_apply_0_1 = StringBuilder_init_$Create$_0();
    var tmp = Charsets_getInstance()._UTF_8.newEncoder_0();
    var content_3 = encode$default(tmp, _this_, 0, 0, 6, null);
    forEach(content_3, _no_name_provided_$factory_116(tmp0_apply_0_1, spaceToPlus));
    return tmp0_apply_0_1.toString();
  }
  function encodeURLParameter$default(_this_, spaceToPlus, $mask0, $handler) {
    if (!(($mask0 & 1) === 0))
      spaceToPlus = false;
    return encodeURLParameter(_this_, spaceToPlus);
  }
  function decodeURLPart(_this_, start, end, charset_1) {
    return decodeScan(_this_, start, end, false, charset_1);
  }
  function decodeURLPart$default(_this_, start, end, charset_1, $mask0, $handler) {
    if (!(($mask0 & 1) === 0))
      start = 0;
    if (!(($mask0 & 2) === 0))
      end = _this_.length;
    if (!(($mask0 & 4) === 0))
      charset_1 = Charsets_getInstance()._UTF_8;
    return decodeURLPart(_this_, start, end, charset_1);
  }
  function forEach(_this_, block) {
    var tmp$ret$0;
    l$ret$1: do {
      var release_1 = true;
      var tmp0_elvis_lhs_3 = prepareReadFirstHead(_this_, 1);
      var tmp;
      if (tmp0_elvis_lhs_3 == null) {
        tmp$ret$0 = Unit_getInstance();
        break l$ret$1;
      } else {
        tmp = tmp0_elvis_lhs_3;
      }
      var current_2 = tmp;
      try {
        $l$break_1: do {
          var tmp0__anonymous__6 = current_2;
          $l$break: while (true) {
            if (!(tmp0__anonymous__6._get_writePosition__1() > tmp0__anonymous__6._get_readPosition__1())) {
              break $l$break;
            }block(tmp0__anonymous__6.readByte_1());
          }
          if (!true) {
            break $l$break_1;
          } else {
          }
          release_1 = false;
          var tmp1_elvis_lhs_5 = prepareReadNextHead(_this_, current_2);
          var tmp_0;
          if (tmp1_elvis_lhs_5 == null) {
            break $l$break_1;
          } else {
            tmp_0 = tmp1_elvis_lhs_5;
          }
          var next_4 = tmp_0;
          current_2 = next_4;
          release_1 = true;
        }
         while (true);
      }finally {
        if (release_1) {
          completeReadHead(_this_, current_2);
        }}
    }
     while (false);
  }
  function percentEncode(_this_) {
    var tmp0_buildString_0 = 3;
    var tmp0_apply_0_1 = StringBuilder_init_$Create$(tmp0_buildString_0);
    var code_3 = _this_ & 255;
    tmp0_apply_0_1.append_32(new Char(37));
    Unit_getInstance();
    tmp0_apply_0_1.append_32(hexDigitToChar(code_3 >> 4));
    Unit_getInstance();
    tmp0_apply_0_1.append_32(hexDigitToChar(code_3 & 15));
    Unit_getInstance();
    return tmp0_apply_0_1.toString();
  }
  function decodeScan(_this_, start, end, plusIsSpace, charset_1) {
    var inductionVariable = start;
    if (inductionVariable < end)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var ch = charSequenceGet(_this_, index);
        if (ch.equals(new Char(37)) ? true : plusIsSpace ? ch.equals(new Char(43)) : false) {
          return decodeImpl(_this_, start, end, index, plusIsSpace, charset_1);
        }}
       while (inductionVariable < end);
    var tmp;
    if (start === 0 ? end === _this_.length : false) {
      tmp = toString_1(_this_);
    } else {
      tmp = _this_.substring(start, end);
    }
    return tmp;
  }
  function hexDigitToChar(digit) {
    var tmp0_subject = digit;
    return (0 <= tmp0_subject ? tmp0_subject <= 9 : false) ? (new Char(48)).plus_55(digit) : (new Char(65)).plus_55(digit).minus_28(10);
  }
  function decodeImpl(_this_, start, end, prefixEnd, plusIsSpace, charset_1) {
    var length = end - start | 0;
    var sbSize = length > 255 ? length / 3 | 0 : length;
    var sb = StringBuilder_init_$Create$(sbSize);
    if (prefixEnd > start) {
      sb.append_30(_this_, start, prefixEnd);
      Unit_getInstance();
    }var index = prefixEnd;
    var bytes = null;
    while (index < end) {
      var c = charSequenceGet(_this_, index);
      if (plusIsSpace ? c.equals(new Char(43)) : false) {
        sb.append_32(new Char(32));
        Unit_getInstance();
        var tmp0 = index;
        index = tmp0 + 1 | 0;
        Unit_getInstance();
      } else if (c.equals(new Char(37))) {
        if (bytes == null) {
          bytes = new Int8Array((end - index | 0) / 3 | 0);
        }var count_0 = 0;
        while (index < end ? charSequenceGet(_this_, index).equals(new Char(37)) : false) {
          if ((index + 2 | 0) >= end) {
            var tmp0_substring_0 = index;
            var tmp1_substring_0 = charSequenceLength(_this_);
            throw new URLDecodeException('' + 'Incomplete trailing HEX escape: ' + toString_1(charSequenceSubSequence(_this_, tmp0_substring_0, tmp1_substring_0)) + ', in ' + _this_ + ' at ' + index);
          }var digit1 = charToHexDigit(charSequenceGet(_this_, index + 1 | 0));
          var digit2 = charToHexDigit(charSequenceGet(_this_, index + 2 | 0));
          if (digit1 === -1 ? true : digit2 === -1) {
            throw new URLDecodeException('' + 'Wrong HEX escape: %' + charSequenceGet(_this_, index + 1 | 0) + charSequenceGet(_this_, index + 2 | 0) + ', in ' + _this_ + ', at ' + index);
          }var tmp = bytes;
          var tmp1 = count_0;
          count_0 = tmp1 + 1 | 0;
          tmp[tmp1] = toByte_0(imul(digit1, 16) + digit2 | 0);
          index = index + 3 | 0;
        }
        sb.append_7(String_0(bytes, 0, count_0, charset_1));
        Unit_getInstance();
      } else {
        sb.append_32(c);
        Unit_getInstance();
        var tmp2 = index;
        index = tmp2 + 1 | 0;
        Unit_getInstance();
      }
    }
    return sb.toString();
  }
  function URLDecodeException(message) {
    Exception_init_$Init$_0(message, this);
    captureStack(this, URLDecodeException);
  }
  URLDecodeException.$metadata$ = {
    simpleName: 'URLDecodeException',
    kind: 'class',
    interfaces: []
  };
  function charToHexDigit(c2) {
    var tmp0_subject = c2;
    return (new Char(48) <= tmp0_subject ? tmp0_subject <= new Char(57) : false) ? c2.minus(new Char(48)) : (new Char(65) <= tmp0_subject ? tmp0_subject <= new Char(70) : false) ? c2.minus(new Char(65)) + 10 | 0 : (new Char(97) <= tmp0_subject ? tmp0_subject <= new Char(102) : false) ? c2.minus(new Char(97)) + 10 | 0 : -1;
  }
  function encodeURLParameterValue(_this_) {
    var tmp0_apply_0_1 = StringBuilder_init_$Create$_0();
    var tmp = Charsets_getInstance()._UTF_8.newEncoder_0();
    var content_3 = encode$default(tmp, _this_, 0, 0, 6, null);
    forEach(content_3, _no_name_provided_$factory_117(tmp0_apply_0_1));
    return tmp0_apply_0_1.toString();
  }
  function decodeURLQueryComponent(_this_, start, end, plusIsSpace, charset_1) {
    return decodeScan(_this_, start, end, plusIsSpace, charset_1);
  }
  function decodeURLQueryComponent$default(_this_, start, end, plusIsSpace, charset_1, $mask0, $handler) {
    if (!(($mask0 & 1) === 0))
      start = 0;
    if (!(($mask0 & 2) === 0))
      end = _this_.length;
    if (!(($mask0 & 4) === 0))
      plusIsSpace = false;
    if (!(($mask0 & 8) === 0))
      charset_1 = Charsets_getInstance()._UTF_8;
    return decodeURLQueryComponent(_this_, start, end, plusIsSpace, charset_1);
  }
  function _no_name_provided__151($tmp0_apply_0_1) {
    this._$tmp0_apply_0_1 = $tmp0_apply_0_1;
  }
  _no_name_provided__151.prototype.invoke_218 = function (it) {
    this._$tmp0_apply_0_1.append_7(percentEncode(it));
    Unit_getInstance();
  };
  _no_name_provided__151.prototype.invoke_542 = function (p1) {
    this.invoke_218((!(p1 == null) ? typeof p1 === 'number' : false) ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__151.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__152($spaceToPlus, $tmp0_apply_0_1, $encodeFull) {
    this._$spaceToPlus = $spaceToPlus;
    this._$tmp0_apply_0_1_0 = $tmp0_apply_0_1;
    this._$encodeFull = $encodeFull;
  }
  _no_name_provided__152.prototype.invoke_218 = function (it) {
    if (it === 32)
      if (this._$spaceToPlus) {
        this._$tmp0_apply_0_1_0.append_32(new Char(43));
        Unit_getInstance();
      } else {
        this._$tmp0_apply_0_1_0.append_7('%20');
        Unit_getInstance();
      }
     else if (URL_ALPHABET.contains_51(it) ? true : !this._$encodeFull ? URL_PROTOCOL_PART.contains_51(it) : false) {
      this._$tmp0_apply_0_1_0.append_32(numberToChar(it));
      Unit_getInstance();
    } else {
      this._$tmp0_apply_0_1_0.append_7(percentEncode(it));
      Unit_getInstance();
    }
  };
  _no_name_provided__152.prototype.invoke_542 = function (p1) {
    this.invoke_218((!(p1 == null) ? typeof p1 === 'number' : false) ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__152.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__153($tmp0_apply_0_1, $spaceToPlus) {
    this._$tmp0_apply_0_1_1 = $tmp0_apply_0_1;
    this._$spaceToPlus_0 = $spaceToPlus;
  }
  _no_name_provided__153.prototype.invoke_218 = function (it) {
    if (URL_ALPHABET.contains_51(it) ? true : OAUTH_SYMBOLS.contains_51(it)) {
      this._$tmp0_apply_0_1_1.append_32(numberToChar(it));
      Unit_getInstance();
    } else if (this._$spaceToPlus_0 ? it === 32 : false) {
      this._$tmp0_apply_0_1_1.append_32(new Char(43));
      Unit_getInstance();
    } else {
      this._$tmp0_apply_0_1_1.append_7(percentEncode(it));
      Unit_getInstance();
    }
  };
  _no_name_provided__153.prototype.invoke_542 = function (p1) {
    this.invoke_218((!(p1 == null) ? typeof p1 === 'number' : false) ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__153.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__154($tmp0_apply_0_1) {
    this._$tmp0_apply_0_1_2 = $tmp0_apply_0_1;
  }
  _no_name_provided__154.prototype.invoke_218 = function (it) {
    if ((URL_ALPHABET.contains_51(it) ? true : OAUTH_SYMBOLS.contains_51(it)) ? true : it === 61) {
      this._$tmp0_apply_0_1_2.append_32(numberToChar(it));
      Unit_getInstance();
    } else if (it === 32) {
      this._$tmp0_apply_0_1_2.append_32(new Char(43));
      Unit_getInstance();
    } else {
      this._$tmp0_apply_0_1_2.append_7(percentEncode(it));
      Unit_getInstance();
    }
  };
  _no_name_provided__154.prototype.invoke_542 = function (p1) {
    this.invoke_218((!(p1 == null) ? typeof p1 === 'number' : false) ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__154.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided_$factory_114($tmp0_apply_0_1) {
    var i = new _no_name_provided__151($tmp0_apply_0_1);
    return function (p1) {
      i.invoke_218(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_115($spaceToPlus, $tmp0_apply_0_1, $encodeFull) {
    var i = new _no_name_provided__152($spaceToPlus, $tmp0_apply_0_1, $encodeFull);
    return function (p1) {
      i.invoke_218(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_116($tmp0_apply_0_1, $spaceToPlus) {
    var i = new _no_name_provided__153($tmp0_apply_0_1, $spaceToPlus);
    return function (p1) {
      i.invoke_218(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_117($tmp0_apply_0_1) {
    var i = new _no_name_provided__154($tmp0_apply_0_1);
    return function (p1) {
      i.invoke_218(p1);
      return Unit_getInstance();
    };
  }
  function URL_ALPHABET$init$() {
    var tmp0_map_0 = plus(plus_0((new Char(97)).rangeTo(new Char(122)), (new Char(65)).rangeTo(new Char(90))), (new Char(48)).rangeTo(new Char(57)));
    var tmp0_mapTo_0_1 = ArrayList_init_$Create$_0(collectionSizeOrDefault(tmp0_map_0, 10));
    var tmp0_iterator_1_2 = tmp0_map_0.iterator_64();
    while (tmp0_iterator_1_2.hasNext_31()) {
      var item_2_3 = tmp0_iterator_1_2.next_35();
      tmp0_mapTo_0_1.add_33(item_2_3.toByte_4());
      Unit_getInstance();
    }
    return tmp0_mapTo_0_1;
  }
  function URL_PROTOCOL_PART$init$() {
    var tmp0_map_0 = listOf([new Char(58), new Char(47), new Char(63), new Char(35), new Char(91), new Char(93), new Char(64), new Char(33), new Char(36), new Char(38), new Char(39), new Char(40), new Char(41), new Char(42), new Char(44), new Char(59), new Char(61), new Char(45), new Char(46), new Char(95), new Char(126), new Char(43)]);
    var tmp0_mapTo_0_1 = ArrayList_init_$Create$_0(collectionSizeOrDefault(tmp0_map_0, 10));
    var tmp0_iterator_1_2 = tmp0_map_0.iterator_64();
    while (tmp0_iterator_1_2.hasNext_31()) {
      var item_2_3 = tmp0_iterator_1_2.next_35();
      tmp0_mapTo_0_1.add_33(item_2_3.toByte_4());
      Unit_getInstance();
    }
    return tmp0_mapTo_0_1;
  }
  function OAUTH_SYMBOLS$init$() {
    var tmp0_map_0 = listOf([new Char(45), new Char(46), new Char(95), new Char(126)]);
    var tmp0_mapTo_0_1 = ArrayList_init_$Create$_0(collectionSizeOrDefault(tmp0_map_0, 10));
    var tmp0_iterator_1_2 = tmp0_map_0.iterator_64();
    while (tmp0_iterator_1_2.hasNext_31()) {
      var item_2_3 = tmp0_iterator_1_2.next_35();
      tmp0_mapTo_0_1.add_33(item_2_3.toByte_4());
      Unit_getInstance();
    }
    return tmp0_mapTo_0_1;
  }
  function ContentTypeMatcher() {
  }
  ContentTypeMatcher.$metadata$ = {
    simpleName: 'ContentTypeMatcher',
    kind: 'interface',
    interfaces: []
  };
  function ContentType_init_$Init$(contentType_2, contentSubtype, parameters, $this) {
    ContentType.call($this, contentType_2, contentSubtype, '' + contentType_2 + '/' + contentSubtype, parameters);
    return $this;
  }
  function ContentType_init_$Create$(contentType_2, contentSubtype, parameters) {
    return ContentType_init_$Init$(contentType_2, contentSubtype, parameters, Object.create(ContentType.prototype));
  }
  function ContentType_init_$Init$_0(contentType_2, contentSubtype, parameters, $mask0, $marker, $this) {
    if (!(($mask0 & 4) === 0))
      parameters = emptyList();
    ContentType_init_$Init$(contentType_2, contentSubtype, parameters, $this);
    return $this;
  }
  function ContentType_init_$Create$_0(contentType_2, contentSubtype, parameters, $mask0, $marker) {
    return ContentType_init_$Init$_0(contentType_2, contentSubtype, parameters, $mask0, $marker, Object.create(ContentType.prototype));
  }
  function hasParameter($this, name, value) {
    var tmp0_subject = $this._get_parameters__0()._get_size__45();
    var tmp;
    switch (tmp0_subject) {
      case 0:
        tmp = false;
        break;
      case 1:
        var tmp0_let_0 = $this._get_parameters__0().get_80(0);
        tmp = equals_0(tmp0_let_0._name_7, name, true) ? equals_0(tmp0_let_0._value_29, value, true) : false;
        break;
      default:var tmp$ret$0;
        l$ret$1: do {
          var tmp1_any_0 = $this._get_parameters__0();
          var tmp_0;
          if (isInterface(tmp1_any_0, Collection)) {
            tmp_0 = tmp1_any_0.isEmpty_53();
          } else {
            {
              tmp_0 = false;
            }
          }
          if (tmp_0) {
            tmp$ret$0 = false;
            break l$ret$1;
          } else {
          }
          var tmp0_iterator_1 = tmp1_any_0.iterator_64();
          while (tmp0_iterator_1.hasNext_31()) {
            var element_2 = tmp0_iterator_1.next_35();
            if (equals_0(element_2._name_7, name, true) ? equals_0(element_2._value_29, value, true) : false) {
              tmp$ret$0 = true;
              break l$ret$1;
            } else {
            }
          }
          tmp$ret$0 = false;
        }
         while (false);
        tmp = tmp$ret$0;
        break;
    }
    return tmp;
  }
  function Companion_47() {
    Companion_instance_46 = this;
    var tmp = this;
    tmp._Any = ContentType_init_$Create$_0('*', '*', null, 4, null);
  }
  Companion_47.prototype.parse_0 = function (value) {
    if (isBlank(value))
      return this._Any;
    var tmp0_parse_0 = Companion_getInstance_47();
    var headerValue_1 = single_0(parseHeaderValue(value));
    var tmp1__anonymous__2 = headerValue_1._value_30;
    var tmp2__anonymous__2 = headerValue_1._params;
    var tmp = new Char(47);
    var slash_3 = indexOf$default(tmp1__anonymous__2, tmp, 0, false, 6, null);
    if (slash_3 === -1) {
      if (toString_1(trim(isCharSequence(tmp1__anonymous__2) ? tmp1__anonymous__2 : THROW_CCE())) === '*') {
        return Companion_getInstance_46()._Any;
      } else {
      }
      throw new BadContentTypeFormatException(value);
    }var tmp0_substring_0_6 = 0;
    var tmp1_trim_0_5 = tmp1__anonymous__2.substring(tmp0_substring_0_6, slash_3);
    var type_4 = toString_1(trim(isCharSequence(tmp1_trim_0_5) ? tmp1_trim_0_5 : THROW_CCE()));
    if (charSequenceLength(type_4) === 0) {
      throw new BadContentTypeFormatException(value);
    } else {
    }
    var tmp2_substring_0_9 = slash_3 + 1 | 0;
    var tmp3_trim_0_8 = tmp1__anonymous__2.substring(tmp2_substring_0_9);
    var subtype_7 = toString_1(trim(isCharSequence(tmp3_trim_0_8) ? tmp3_trim_0_8 : THROW_CCE()));
    var tmp_0;
    if (charSequenceLength(subtype_7) === 0) {
      tmp_0 = true;
    } else {
      {
        var tmp_1 = new Char(47);
        tmp_0 = contains$default_0(subtype_7, tmp_1, false, 2, null);
      }
    }
    if (tmp_0) {
      throw new BadContentTypeFormatException(value);
    } else {
    }
    return ContentType_init_$Create$(type_4, subtype_7, tmp2__anonymous__2);
  };
  Companion_47.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_46;
  function Companion_getInstance_46() {
    if (Companion_instance_46 == null)
      new Companion_47();
    return Companion_instance_46;
  }
  function Application() {
    Application_instance = this;
    var tmp = this;
    tmp._Any_0 = ContentType_init_$Create$_0('application', '*', null, 4, null);
    var tmp_0 = this;
    tmp_0._Atom = ContentType_init_$Create$_0('application', 'atom+xml', null, 4, null);
    var tmp_1 = this;
    tmp_1._Cbor = ContentType_init_$Create$_0('application', 'cbor', null, 4, null);
    var tmp_2 = this;
    tmp_2._Json = ContentType_init_$Create$_0('application', 'json', null, 4, null);
    var tmp_3 = this;
    tmp_3._HalJson = ContentType_init_$Create$_0('application', 'hal+json', null, 4, null);
    var tmp_4 = this;
    tmp_4._JavaScript = ContentType_init_$Create$_0('application', 'javascript', null, 4, null);
    var tmp_5 = this;
    tmp_5._OctetStream = ContentType_init_$Create$_0('application', 'octet-stream', null, 4, null);
    var tmp_6 = this;
    tmp_6._FontWoff = ContentType_init_$Create$_0('application', 'font-woff', null, 4, null);
    var tmp_7 = this;
    tmp_7._Rss = ContentType_init_$Create$_0('application', 'rss+xml', null, 4, null);
    var tmp_8 = this;
    tmp_8._Xml = ContentType_init_$Create$_0('application', 'xml', null, 4, null);
    var tmp_9 = this;
    tmp_9._Xml_Dtd = ContentType_init_$Create$_0('application', 'xml-dtd', null, 4, null);
    var tmp_10 = this;
    tmp_10._Zip = ContentType_init_$Create$_0('application', 'zip', null, 4, null);
    var tmp_11 = this;
    tmp_11._GZip = ContentType_init_$Create$_0('application', 'gzip', null, 4, null);
    var tmp_12 = this;
    tmp_12._FormUrlEncoded = ContentType_init_$Create$_0('application', 'x-www-form-urlencoded', null, 4, null);
    var tmp_13 = this;
    tmp_13._Pdf = ContentType_init_$Create$_0('application', 'pdf', null, 4, null);
    var tmp_14 = this;
    tmp_14._ProtoBuf = ContentType_init_$Create$_0('application', 'protobuf', null, 4, null);
    var tmp_15 = this;
    tmp_15._Wasm = ContentType_init_$Create$_0('application', 'wasm', null, 4, null);
    var tmp_16 = this;
    tmp_16._ProblemJson = ContentType_init_$Create$_0('application', 'problem+json', null, 4, null);
    var tmp_17 = this;
    tmp_17._ProblemXml = ContentType_init_$Create$_0('application', 'problem+xml', null, 4, null);
  }
  Application.$metadata$ = {
    simpleName: 'Application',
    kind: 'object',
    interfaces: []
  };
  var Application_instance;
  function Application_getInstance() {
    if (Application_instance == null)
      new Application();
    return Application_instance;
  }
  function Text_0() {
    Text_instance = this;
    var tmp = this;
    tmp._Any_1 = ContentType_init_$Create$_0('text', '*', null, 4, null);
    var tmp_0 = this;
    tmp_0._Plain = ContentType_init_$Create$_0('text', 'plain', null, 4, null);
    var tmp_1 = this;
    tmp_1._CSS = ContentType_init_$Create$_0('text', 'css', null, 4, null);
    var tmp_2 = this;
    tmp_2._CSV = ContentType_init_$Create$_0('text', 'csv', null, 4, null);
    var tmp_3 = this;
    tmp_3._Html = ContentType_init_$Create$_0('text', 'html', null, 4, null);
    var tmp_4 = this;
    tmp_4._JavaScript_0 = ContentType_init_$Create$_0('text', 'javascript', null, 4, null);
    var tmp_5 = this;
    tmp_5._VCard = ContentType_init_$Create$_0('text', 'vcard', null, 4, null);
    var tmp_6 = this;
    tmp_6._Xml_0 = ContentType_init_$Create$_0('text', 'xml', null, 4, null);
    var tmp_7 = this;
    tmp_7._EventStream = ContentType_init_$Create$_0('text', 'event-stream', null, 4, null);
  }
  Text_0.$metadata$ = {
    simpleName: 'Text',
    kind: 'object',
    interfaces: []
  };
  var Text_instance;
  function Text_getInstance() {
    if (Text_instance == null)
      new Text_0();
    return Text_instance;
  }
  function ContentType(contentType_2, contentSubtype, existingContent, parameters) {
    Companion_getInstance_46();
    HeaderValueWithParameters.call(this, existingContent, parameters);
    this._contentType = contentType_2;
    this._contentSubtype = contentSubtype;
  }
  ContentType.prototype.withParameter = function (name, value) {
    if (hasParameter(this, name, value))
      return this;
    return new ContentType(this._contentType, this._contentSubtype, this._get_content__6(), plus_1(this._get_parameters__0(), new HeaderValueParam(name, value)));
  };
  ContentType.prototype.withoutParameters = function () {
    var tmp;
    if (this._get_parameters__0().isEmpty_53()) {
      tmp = this;
    } else {
      tmp = ContentType_init_$Create$_0(this._contentType, this._contentSubtype, null, 4, null);
    }
    return tmp;
  };
  ContentType.prototype.match_0 = function (pattern) {
    if (!(pattern._contentType === '*') ? !equals_0(pattern._contentType, this._contentType, true) : false) {
      return false;
    }if (!(pattern._contentSubtype === '*') ? !equals_0(pattern._contentSubtype, this._contentSubtype, true) : false) {
      return false;
    }var tmp0_iterator = pattern._get_parameters__0().iterator_64();
    while (tmp0_iterator.hasNext_31()) {
      var tmp1_loop_parameter = tmp0_iterator.next_35();
      var patternName = tmp1_loop_parameter.component1_4();
      var patternValue = tmp1_loop_parameter.component2_4();
      var tmp2_subject = patternName;
      var tmp;
      if (tmp2_subject === '*') {
        var tmp3_subject = patternValue;
        var tmp_0;
        if (tmp3_subject === '*') {
          tmp_0 = true;
        } else {
          var tmp$ret$0;
          l$ret$1: do {
            var tmp0_any_0 = this._get_parameters__0();
            var tmp_1;
            if (isInterface(tmp0_any_0, Collection)) {
              tmp_1 = tmp0_any_0.isEmpty_53();
            } else {
              {
                tmp_1 = false;
              }
            }
            if (tmp_1) {
              tmp$ret$0 = false;
              break l$ret$1;
            } else {
            }
            var tmp0_iterator_1 = tmp0_any_0.iterator_64();
            while (tmp0_iterator_1.hasNext_31()) {
              var element_2 = tmp0_iterator_1.next_35();
              if (equals_0(element_2._value_29, patternValue, true)) {
                tmp$ret$0 = true;
                break l$ret$1;
              } else {
              }
            }
            tmp$ret$0 = false;
          }
           while (false);
          tmp_0 = tmp$ret$0;
        }
        tmp = tmp_0;
      } else {
        var value = this.parameter_1(patternName);
        var tmp4_subject = patternValue;
        tmp = tmp4_subject === '*' ? !(value == null) : equals_0(value, patternValue, true);
      }
      var matches_0 = tmp;
      if (!matches_0) {
        return false;
      }}
    return true;
  };
  ContentType.prototype.equals = function (other) {
    var tmp;
    var tmp_0;
    var tmp_1;
    if (other instanceof ContentType) {
      tmp_1 = equals_0(this._contentType, other._contentType, true);
    } else {
      {
        tmp_1 = false;
      }
    }
    if (tmp_1) {
      tmp_0 = equals_0(this._contentSubtype, other._contentSubtype, true);
    } else {
      {
        tmp_0 = false;
      }
    }
    if (tmp_0) {
      tmp = equals_1(this._get_parameters__0(), other._get_parameters__0());
    } else {
      {
        tmp = false;
      }
    }
    return tmp;
  };
  ContentType.prototype.hashCode = function () {
    var tmp0_toLowerCase_0 = this._contentType;
    var result = getStringHashCode(tmp0_toLowerCase_0.toLowerCase());
    var tmp = result;
    var tmp_0 = imul(31, result);
    var tmp1_toLowerCase_0 = this._contentSubtype;
    result = tmp + (tmp_0 + getStringHashCode(tmp1_toLowerCase_0.toLowerCase()) | 0) | 0;
    result = result + imul(31, hashCode(this._get_parameters__0())) | 0;
    return result;
  };
  ContentType.$metadata$ = {
    simpleName: 'ContentType',
    kind: 'class',
    interfaces: []
  };
  function BadContentTypeFormatException(value) {
    Exception_init_$Init$_0('' + 'Bad Content-Type format: ' + value, this);
    captureStack(this, BadContentTypeFormatException);
  }
  BadContentTypeFormatException.$metadata$ = {
    simpleName: 'BadContentTypeFormatException',
    kind: 'class',
    interfaces: []
  };
  function charset(_this_) {
    var tmp0_safe_receiver = _this_.parameter_1('charset');
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      tmp = Companion_getInstance_39().forName(tmp0_safe_receiver);
    }
    return tmp;
  }
  function withCharset(_this_, charset_1) {
    return _this_.withParameter('charset', _get_name_(charset_1));
  }
  var loweredPartNames;
  var clientCookieHeaderPattern;
  var cookieCharsShouldBeEscaped;
  function clientCookieHeaderPattern$init$() {
    var tmp0_toRegex_0 = '(^|;)\\s*([^()<>@;:/\\\\"\\[\\]\\?=\\{\\}\\s]+)\\s*(=\\s*("[^"]*"|[^;]*))?';
    return Regex_init_$Create$_0(tmp0_toRegex_0);
  }
  var HTTP_DATE_FORMATS;
  var contentTypesByExtensions$delegate;
  var extensionsByContentType$delegate;
  function groupByPairs(_this_) {
    var tmp0_groupByTo_0_1 = LinkedHashMap_init_$Create$();
    var tmp0_iterator_1_2 = _this_.iterator_64();
    while (tmp0_iterator_1_2.hasNext_31()) {
      var element_2_3 = tmp0_iterator_1_2.next_35();
      var key_3_4 = element_2_3._first;
      var value_1_6 = tmp0_groupByTo_0_1.get_63(key_3_4);
      var tmp;
      if (value_1_6 == null) {
        var answer_2_7 = ArrayList_init_$Create$();
        tmp0_groupByTo_0_1.put_12(key_3_4, answer_2_7);
        Unit_getInstance();
        tmp = answer_2_7;
      } else {
        tmp = value_1_6;
      }
      var list_4_5 = tmp;
      list_4_5.add_33(element_2_3);
      Unit_getInstance();
    }
    var tmp0_mapValues_0 = tmp0_groupByTo_0_1;
    var tmp1_mapValuesTo_0_1 = LinkedHashMap_init_$Create$_1(mapCapacity(tmp0_mapValues_0._get_size__45()));
    var tmp0_associateByTo_0_2 = tmp0_mapValues_0._get_entries__10();
    var tmp0_iterator_1_3 = tmp0_associateByTo_0_2.iterator_64();
    while (tmp0_iterator_1_3.hasNext_31()) {
      var element_2_4 = tmp0_iterator_1_3.next_35();
      var tmp_0 = element_2_4._get_key__47();
      var tmp0_map_0_6 = element_2_4._get_value__33();
      var tmp0_mapTo_0_1_7 = ArrayList_init_$Create$_0(collectionSizeOrDefault(tmp0_map_0_6, 10));
      var tmp0_iterator_1_2_8 = tmp0_map_0_6.iterator_64();
      while (tmp0_iterator_1_2_8.hasNext_31()) {
        var item_2_3_9 = tmp0_iterator_1_2_8.next_35();
        tmp0_mapTo_0_1_7.add_33(item_2_3_9._second);
        Unit_getInstance();
      }
      tmp1_mapValuesTo_0_1.put_12(tmp_0, tmp0_mapTo_0_1_7);
      Unit_getInstance();
    }
    return tmp1_mapValuesTo_0_1;
  }
  function toContentType(_this_) {
    var tmp;
    try {
      tmp = Companion_getInstance_46().parse_0(_this_);
    } catch ($p) {
      var tmp_0;
      if ($p instanceof Error) {
        throw IllegalArgumentException_init_$Create$_1('' + 'Failed to parse ' + _this_, $p);
      } else {
        {
          throw $p;
        }
      }
      tmp = tmp_0;
    }
    return tmp;
  }
  function _no_name_provided__155() {
  }
  _no_name_provided__155.prototype.invoke_540 = function () {
    var tmp0_apply_0 = caseInsensitiveMap();
    tmp0_apply_0.putAll_8(groupByPairs(asSequence(_get_mimes_())));
    return tmp0_apply_0;
  };
  _no_name_provided__155.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__156() {
  }
  _no_name_provided__156.prototype.invoke_221 = function (_name_for_destructuring_parameter_0_) {
    var first_1 = _name_for_destructuring_parameter_0_.component1_4();
    var second = _name_for_destructuring_parameter_0_.component2_4();
    return to(second, first_1);
  };
  _no_name_provided__156.prototype.invoke_542 = function (p1) {
    return this.invoke_221(p1 instanceof Pair ? p1 : THROW_CCE());
  };
  _no_name_provided__156.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__157() {
  }
  _no_name_provided__157.prototype.invoke_540 = function () {
    var tmp = asSequence(_get_mimes_());
    return groupByPairs(map(tmp, _no_name_provided_$factory_120()));
  };
  _no_name_provided__157.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided_$factory_118() {
    var i = new _no_name_provided__155();
    return function () {
      return i.invoke_540();
    };
  }
  function _no_name_provided_$factory_119() {
    var i = new _no_name_provided__157();
    return function () {
      return i.invoke_540();
    };
  }
  function _no_name_provided_$factory_120() {
    var i = new _no_name_provided__156();
    return function (p1) {
      return i.invoke_221(p1);
    };
  }
  var HeaderFieldValueSeparators;
  function Companion_48() {
    Companion_instance_47 = this;
  }
  Companion_48.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_47;
  function Companion_getInstance_47() {
    if (Companion_instance_47 == null)
      new Companion_48();
    return Companion_instance_47;
  }
  function HeaderValueWithParameters(content, parameters) {
    Companion_getInstance_47();
    this._content_4 = content;
    this._parameters = parameters;
  }
  HeaderValueWithParameters.prototype._get_content__6 = function () {
    return this._content_4;
  };
  HeaderValueWithParameters.prototype._get_parameters__0 = function () {
    return this._parameters;
  };
  HeaderValueWithParameters.prototype.parameter_1 = function (name) {
    var tmp$ret$0;
    l$ret$1: do {
      var tmp0_firstOrNull_0 = this._parameters;
      var tmp0_iterator_1 = tmp0_firstOrNull_0.iterator_64();
      while (tmp0_iterator_1.hasNext_31()) {
        var element_2 = tmp0_iterator_1.next_35();
        if (equals_0(element_2._name_7, name, true)) {
          tmp$ret$0 = element_2;
          break l$ret$1;
        } else {
        }
      }
      tmp$ret$0 = null;
    }
     while (false);
    var tmp0_safe_receiver = tmp$ret$0;
    return tmp0_safe_receiver == null ? null : tmp0_safe_receiver._value_29;
  };
  HeaderValueWithParameters.prototype.toString = function () {
    var tmp;
    if (this._parameters.isEmpty_53()) {
      tmp = this._content_4;
    } else {
      var tmp_0 = this._content_4.length;
      var tmp0_sumBy_0 = this._parameters;
      var sum_1 = 0;
      var tmp0_iterator_2 = tmp0_sumBy_0.iterator_64();
      while (tmp0_iterator_2.hasNext_31()) {
        var element_3 = tmp0_iterator_2.next_35();
        var tmp_1 = sum_1;
        sum_1 = tmp_1 + ((element_3._name_7.length + element_3._value_29.length | 0) + 3 | 0) | 0;
      }
      var size_0 = tmp_0 + sum_1 | 0;
      var tmp1_apply_0 = StringBuilder_init_$Create$(size_0);
      tmp1_apply_0.append_7(this._content_4);
      Unit_getInstance();
      var inductionVariable = 0;
      var last_1 = this._parameters._get_size__45();
      if (inductionVariable < last_1)
        do {
          var index_3 = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var tmp1_container_4 = this._parameters.get_80(index_3);
          var name_5 = tmp1_container_4.component1_4();
          var value_6 = tmp1_container_4.component2_4();
          tmp1_apply_0.append_7('; ');
          Unit_getInstance();
          tmp1_apply_0.append_7(name_5);
          Unit_getInstance();
          tmp1_apply_0.append_7('=');
          Unit_getInstance();
          if (checkNeedEscape(value_6)) {
            tmp1_apply_0.append_7(quote(value_6));
            Unit_getInstance();
          } else {
            tmp1_apply_0.append_7(value_6);
            Unit_getInstance();
          }
        }
         while (inductionVariable < last_1);
      tmp = tmp1_apply_0.toString();
    }
    return tmp;
  };
  HeaderValueWithParameters.$metadata$ = {
    simpleName: 'HeaderValueWithParameters',
    kind: 'class',
    interfaces: []
  };
  function checkNeedEscape(_this_) {
    if (charSequenceLength(_this_) === 0)
      return true;
    else {
    }
    if (isQuoted(_this_))
      return false;
    var inductionVariable = 0;
    var last_1 = _this_.length;
    if (inductionVariable < last_1)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (HeaderFieldValueSeparators.contains_51(charSequenceGet(_this_, index)))
          return true;
      }
       while (inductionVariable < last_1);
    return false;
  }
  function quote(_this_) {
    var tmp0_apply_0_1 = StringBuilder_init_$Create$_0();
    quoteTo(_this_, tmp0_apply_0_1);
    return tmp0_apply_0_1.toString();
  }
  function isQuoted(_this_) {
    if (_this_.length < 2) {
      return false;
    }if (!first_0(_this_).equals(new Char(34)) ? true : !last_0(_this_).equals(new Char(34))) {
      return false;
    }var startIndex = 1;
    $l$break: do {
      var tmp = new Char(34);
      var tmp_0 = startIndex;
      var index = indexOf$default(_this_, tmp, tmp_0, false, 4, null);
      if (index === _get_lastIndex__1(_this_)) {
        break $l$break;
      }var slashesCount = 0;
      var slashIndex = index - 1 | 0;
      while (charSequenceGet(_this_, slashIndex).equals(new Char(92))) {
        var tmp0 = slashesCount;
        slashesCount = tmp0 + 1 | 0;
        Unit_getInstance();
        var tmp1 = slashIndex;
        slashIndex = tmp1 - 1 | 0;
        Unit_getInstance();
      }
      if (slashesCount % 2 === 0) {
        return false;
      }startIndex = index + 1 | 0;
    }
     while (startIndex < _this_.length);
    return true;
  }
  function quoteTo(_this_, out) {
    out.append_7('"');
    Unit_getInstance();
    var inductionVariable = 0;
    var last_1 = _this_.length;
    if (inductionVariable < last_1)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var ch = charSequenceGet(_this_, i);
        var tmp1_subject = ch;
        if (tmp1_subject.equals(new Char(92))) {
          out.append_7('\\\\');
          Unit_getInstance();
        } else if (tmp1_subject.equals(new Char(10))) {
          out.append_7('\\n');
          Unit_getInstance();
        } else if (tmp1_subject.equals(new Char(13))) {
          out.append_7('\\r');
          Unit_getInstance();
        } else if (tmp1_subject.equals(new Char(9))) {
          out.append_7('\\t');
          Unit_getInstance();
        } else if (tmp1_subject.equals(new Char(34))) {
          out.append_7('\\"');
          Unit_getInstance();
        } else {
          out.append_32(ch);
          Unit_getInstance();
        }
      }
       while (inductionVariable < last_1);
    out.append_7('"');
    Unit_getInstance();
  }
  function escapeIfNeeded(_this_) {
    return checkNeedEscape(_this_) ? quote(_this_) : _this_;
  }
  function HeadersBuilder_init_$Init$(size_0, $mask0, $marker, $this) {
    if (!(($mask0 & 1) === 0))
      size_0 = 8;
    HeadersBuilder.call($this, size_0);
    return $this;
  }
  function HeadersBuilder_init_$Create$(size_0, $mask0, $marker) {
    return HeadersBuilder_init_$Init$(size_0, $mask0, $marker, Object.create(HeadersBuilder.prototype));
  }
  function HeadersBuilder(size_0) {
    StringValuesBuilder.call(this, true, size_0);
  }
  HeadersBuilder.prototype.build_16 = function () {
    var tmp0_require_0 = !this._get_built__1();
    if (!tmp0_require_0) {
      var message_1 = 'HeadersBuilder can only build a single Headers instance';
      throw IllegalArgumentException_init_$Create$_0(toString_1(message_1));
    }this._set_built__1(true);
    return new HeadersImpl(this._get_values__16());
  };
  HeadersBuilder.prototype.validateName_1 = function (name) {
    StringValuesBuilder.prototype.validateName_1.call(this, name);
    HttpHeaders_getInstance().checkHeaderName(name);
  };
  HeadersBuilder.prototype.validateValue_1 = function (value) {
    StringValuesBuilder.prototype.validateValue_1.call(this, value);
    HttpHeaders_getInstance().checkHeaderValue(value);
  };
  HeadersBuilder.$metadata$ = {
    simpleName: 'HeadersBuilder',
    kind: 'class',
    interfaces: []
  };
  function Companion_49() {
    Companion_instance_48 = this;
    this._Empty_2 = EmptyHeaders_getInstance();
  }
  Companion_49.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_48;
  function Companion_getInstance_48() {
    if (Companion_instance_48 == null)
      new Companion_49();
    return Companion_instance_48;
  }
  function Headers_0() {
  }
  Headers_0.$metadata$ = {
    simpleName: 'Headers',
    kind: 'interface',
    interfaces: [StringValues]
  };
  function HeadersImpl(values_5) {
    StringValuesImpl.call(this, true, values_5);
  }
  HeadersImpl.prototype.toString = function () {
    return '' + 'Headers ' + this.entries_9();
  };
  HeadersImpl.$metadata$ = {
    simpleName: 'HeadersImpl',
    kind: 'class',
    interfaces: [Headers_0]
  };
  function EmptyHeaders() {
    EmptyHeaders_instance = this;
  }
  EmptyHeaders.prototype._get_caseInsensitiveName__4 = function () {
    return true;
  };
  EmptyHeaders.prototype.getAll_8 = function (name) {
    return null;
  };
  EmptyHeaders.prototype.entries_9 = function () {
    return emptySet();
  };
  EmptyHeaders.prototype.toString = function () {
    return '' + 'Headers ' + this.entries_9();
  };
  EmptyHeaders.$metadata$ = {
    simpleName: 'EmptyHeaders',
    kind: 'object',
    interfaces: [Headers_0]
  };
  var EmptyHeaders_instance;
  function EmptyHeaders_getInstance() {
    if (EmptyHeaders_instance == null)
      new EmptyHeaders();
    return EmptyHeaders_instance;
  }
  function HeaderValueParam(name, value) {
    this._name_7 = name;
    this._value_29 = value;
  }
  HeaderValueParam.prototype.equals = function (other) {
    var tmp;
    var tmp_0;
    if (other instanceof HeaderValueParam) {
      tmp_0 = equals_0(other._name_7, this._name_7, true);
    } else {
      {
        tmp_0 = false;
      }
    }
    if (tmp_0) {
      tmp = equals_0(other._value_29, this._value_29, true);
    } else {
      {
        tmp = false;
      }
    }
    return tmp;
  };
  HeaderValueParam.prototype.hashCode = function () {
    var tmp0_toLowerCase_0 = this._name_7;
    var result = getStringHashCode(tmp0_toLowerCase_0.toLowerCase());
    var tmp = result;
    var tmp_0 = imul(31, result);
    var tmp1_toLowerCase_0 = this._value_29;
    result = tmp + (tmp_0 + getStringHashCode(tmp1_toLowerCase_0.toLowerCase()) | 0) | 0;
    return result;
  };
  HeaderValueParam.prototype.component1_4 = function () {
    return this._name_7;
  };
  HeaderValueParam.prototype.component2_4 = function () {
    return this._value_29;
  };
  HeaderValueParam.prototype.toString = function () {
    return '' + 'HeaderValueParam(name=' + this._name_7 + ', value=' + this._value_29 + ')';
  };
  HeaderValueParam.$metadata$ = {
    simpleName: 'HeaderValueParam',
    kind: 'class',
    interfaces: []
  };
  function HeaderValue(value, params) {
    this._value_30 = value;
    this._params = params;
    var tmp = this;
    var tmp$ret$0;
    l$ret$1: do {
      var tmp0_firstOrNull_0 = this._params;
      var tmp0_iterator_1 = tmp0_firstOrNull_0.iterator_64();
      while (tmp0_iterator_1.hasNext_31()) {
        var element_2 = tmp0_iterator_1.next_35();
        if (element_2._name_7 === 'q') {
          tmp$ret$0 = element_2;
          break l$ret$1;
        } else {
        }
      }
      tmp$ret$0 = null;
    }
     while (false);
    var tmp0_safe_receiver = tmp$ret$0;
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver._value_29;
    var tmp2_safe_receiver = tmp1_safe_receiver == null ? null : toDoubleOrNull(tmp1_safe_receiver);
    var tmp_0;
    if (tmp2_safe_receiver == null) {
      tmp_0 = null;
    } else {
      var tmp_1;
      if (rangeTo(0.0, 1.0).contains_42(tmp2_safe_receiver)) {
        tmp_1 = tmp2_safe_receiver;
      } else {
        {
          tmp_1 = null;
        }
      }
      tmp_0 = tmp_1;
    }
    var tmp3_elvis_lhs = tmp_0;
    tmp._quality = tmp3_elvis_lhs == null ? 1.0 : tmp3_elvis_lhs;
  }
  HeaderValue.prototype.toString = function () {
    return '' + 'HeaderValue(value=' + this._value_30 + ', params=' + this._params + ')';
  };
  HeaderValue.prototype.hashCode = function () {
    var result = getStringHashCode(this._value_30);
    result = imul(result, 31) + hashCode(this._params) | 0;
    return result;
  };
  HeaderValue.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof HeaderValue))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof HeaderValue ? other : THROW_CCE();
    if (!(this._value_30 === tmp0_other_with_cast._value_30))
      return false;
    if (!equals_1(this._params, tmp0_other_with_cast._params))
      return false;
    return true;
  };
  HeaderValue.$metadata$ = {
    simpleName: 'HeaderValue',
    kind: 'class',
    interfaces: []
  };
  function parseHeaderValue(text) {
    return parseHeaderValue_0(text, false);
  }
  function parseHeaderValue_0(text, parametersOnly) {
    if (text == null) {
      return emptyList();
    }var position = 0;
    var tmp = LazyThreadSafetyMode_NONE_getInstance();
    var items = lazy_0(tmp, _no_name_provided_$factory_121());
    while (position <= _get_lastIndex__1(text)) {
      position = parseHeaderValueItem(text, position, items, parametersOnly);
    }
    return valueOrEmpty(items);
  }
  function parseHeaderValueItem(text, start, items, parametersOnly) {
    var position = start;
    var tmp = LazyThreadSafetyMode_NONE_getInstance();
    var parameters = lazy_0(tmp, _no_name_provided_$factory_122());
    var valueEnd = parametersOnly ? position : null;
    while (position <= _get_lastIndex__1(text)) {
      var tmp0_subject = charSequenceGet(text, position);
      if (tmp0_subject.equals(new Char(44))) {
        var tmp_0 = items._get_value__33();
        var tmp1_elvis_lhs = valueEnd;
        tmp_0.add_33(new HeaderValue(subtrim(text, start, tmp1_elvis_lhs == null ? position : tmp1_elvis_lhs), valueOrEmpty(parameters)));
        Unit_getInstance();
        return position + 1 | 0;
      } else if (tmp0_subject.equals(new Char(59))) {
        if (valueEnd == null)
          valueEnd = position;
        position = parseHeaderValueParameter(text, position + 1 | 0, parameters);
      } else {
        var tmp_1;
        if (parametersOnly) {
          tmp_1 = parseHeaderValueParameter(text, position, parameters);
        } else {
          tmp_1 = position + 1 | 0;
        }
        position = tmp_1;
      }
    }
    var tmp_2 = items._get_value__33();
    var tmp2_elvis_lhs = valueEnd;
    tmp_2.add_33(new HeaderValue(subtrim(text, start, tmp2_elvis_lhs == null ? position : tmp2_elvis_lhs), valueOrEmpty(parameters)));
    Unit_getInstance();
    return position;
  }
  function valueOrEmpty(_this_) {
    return _this_.isInitialized_0() ? _this_._get_value__33() : emptyList();
  }
  function subtrim(_this_, start, end) {
    var tmp0_trim_0 = _this_.substring(start, end);
    return toString_1(trim(isCharSequence(tmp0_trim_0) ? tmp0_trim_0 : THROW_CCE()));
  }
  function parseHeaderValueParameter(text, start, parameters) {
    var position = start;
    while (position <= _get_lastIndex__1(text)) {
      var tmp0_subject = charSequenceGet(text, position);
      if (tmp0_subject.equals(new Char(61))) {
        var tmp1_container = parseHeaderValueParameterValue(text, position + 1 | 0);
        var paramEnd = tmp1_container.component1_4();
        var paramValue = tmp1_container.component2_4();
        parseHeaderValueParameter$addParam(parameters, text, start, position, paramValue);
        return paramEnd;
      } else if (tmp0_subject.equals(new Char(59)) ? true : tmp0_subject.equals(new Char(44))) {
        parseHeaderValueParameter$addParam(parameters, text, start, position, '');
        return position;
      } else {
        var tmp2 = position;
        position = tmp2 + 1 | 0;
        Unit_getInstance();
      }
    }
    parseHeaderValueParameter$addParam(parameters, text, start, position, '');
    return position;
  }
  function parseHeaderValueParameterValue(value, start) {
    if (value.length === start) {
      return to(start, '');
    }var position = start;
    if (charSequenceGet(value, start).equals(new Char(34))) {
      return parseHeaderValueParameterValueQuoted(value, position + 1 | 0);
    }while (position <= _get_lastIndex__1(value)) {
      var tmp0_subject = charSequenceGet(value, position);
      if (tmp0_subject.equals(new Char(59)) ? true : tmp0_subject.equals(new Char(44)))
        return to(position, subtrim(value, start, position));
      else {
        var tmp1 = position;
        position = tmp1 + 1 | 0;
        Unit_getInstance();
      }
    }
    return to(position, subtrim(value, start, position));
  }
  function parseHeaderValueParameterValueQuoted(value, start) {
    var position = start;
    var builder = StringBuilder_init_$Create$_0();
    loop: while (position <= _get_lastIndex__1(value)) {
      var currentChar = charSequenceGet(value, position);
      if (currentChar.equals(new Char(34)) ? nextIsSemicolonOrEnd(value, position) : false) {
        return to(position + 1 | 0, builder.toString());
      } else if (currentChar.equals(new Char(92)) ? position < (_get_lastIndex__1(value) - 2 | 0) : false) {
        builder.append_32(charSequenceGet(value, position + 1 | 0));
        Unit_getInstance();
        position = position + 2 | 0;
        continue loop;
      }builder.append_32(currentChar);
      Unit_getInstance();
      var tmp0 = position;
      position = tmp0 + 1 | 0;
      Unit_getInstance();
    }
    var tmp = position;
    var tmp0_plus_0 = new Char(34);
    var tmp1_plus_0 = builder.toString();
    return to(tmp, tmp0_plus_0.toString() + tmp1_plus_0);
  }
  function nextIsSemicolonOrEnd(_this_, start) {
    var position = start + 1 | 0;
    loop: while (position < _this_.length ? charSequenceGet(_this_, position).equals(new Char(32)) : false) {
      position = position + 1 | 0;
    }
    return position === _this_.length ? true : charSequenceGet(_this_, position).equals(new Char(59));
  }
  function parseHeaderValueParameter$addParam($parameters, text, start, end, value) {
    var name = subtrim(text, start, end);
    if (charSequenceLength(name) === 0) {
      return Unit_getInstance();
    } else {
    }
    $parameters._get_value__33().add_33(new HeaderValueParam(name, value));
    Unit_getInstance();
  }
  function _no_name_provided__158() {
  }
  _no_name_provided__158.prototype.invoke_540 = function () {
    return ArrayList_init_$Create$();
  };
  _no_name_provided__158.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__159() {
  }
  _no_name_provided__159.prototype.invoke_540 = function () {
    return ArrayList_init_$Create$();
  };
  _no_name_provided__159.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided_$factory_121() {
    var i = new _no_name_provided__158();
    return function () {
      return i.invoke_540();
    };
  }
  function _no_name_provided_$factory_122() {
    var i = new _no_name_provided__159();
    return function () {
      return i.invoke_540();
    };
  }
  function HttpHeaders() {
    HttpHeaders_instance = this;
    this._Accept = 'Accept';
    this._AcceptCharset = 'Accept-Charset';
    this._AcceptEncoding = 'Accept-Encoding';
    this._AcceptLanguage = 'Accept-Language';
    this._AcceptRanges = 'Accept-Ranges';
    this._Age = 'Age';
    this._Allow = 'Allow';
    this._ALPN = 'ALPN';
    this._AuthenticationInfo = 'Authentication-Info';
    this._Authorization = 'Authorization';
    this._CacheControl = 'Cache-Control';
    this._Connection = 'Connection';
    this._ContentDisposition = 'Content-Disposition';
    this._ContentEncoding = 'Content-Encoding';
    this._ContentLanguage = 'Content-Language';
    this._ContentLength = 'Content-Length';
    this._ContentLocation = 'Content-Location';
    this._ContentRange = 'Content-Range';
    this._ContentType = 'Content-Type';
    this._Cookie = 'Cookie';
    this._DASL = 'DASL';
    this._Date = 'Date';
    this._DAV = 'DAV';
    this._Depth = 'Depth';
    this._Destination = 'Destination';
    this._ETag = 'ETag';
    this._Expect = 'Expect';
    this._Expires = 'Expires';
    this._From = 'From';
    this._Forwarded = 'Forwarded';
    this._Host = 'Host';
    this._HTTP2Settings = 'HTTP2-Settings';
    this._If = 'If';
    this._IfMatch = 'If-Match';
    this._IfModifiedSince = 'If-Modified-Since';
    this._IfNoneMatch = 'If-None-Match';
    this._IfRange = 'If-Range';
    this._IfScheduleTagMatch = 'If-Schedule-Tag-Match';
    this._IfUnmodifiedSince = 'If-Unmodified-Since';
    this._LastModified = 'Last-Modified';
    this._Location = 'Location';
    this._LockToken = 'Lock-Token';
    this._Link = 'Link';
    this._MaxForwards = 'Max-Forwards';
    this._MIMEVersion = 'MIME-Version';
    this._OrderingType = 'Ordering-Type';
    this._Origin = 'Origin';
    this._Overwrite = 'Overwrite';
    this._Position = 'Position';
    this._Pragma = 'Pragma';
    this._Prefer = 'Prefer';
    this._PreferenceApplied = 'Preference-Applied';
    this._ProxyAuthenticate = 'Proxy-Authenticate';
    this._ProxyAuthenticationInfo = 'Proxy-Authentication-Info';
    this._ProxyAuthorization = 'Proxy-Authorization';
    this._PublicKeyPins = 'Public-Key-Pins';
    this._PublicKeyPinsReportOnly = 'Public-Key-Pins-Report-Only';
    this._Range = 'Range';
    this._Referrer = 'Referer';
    this._RetryAfter = 'Retry-After';
    this._ScheduleReply = 'Schedule-Reply';
    this._ScheduleTag = 'Schedule-Tag';
    this._SecWebSocketAccept = 'Sec-WebSocket-Accept';
    this._SecWebSocketExtensions = 'Sec-WebSocket-Extensions';
    this._SecWebSocketKey = 'Sec-WebSocket-Key';
    this._SecWebSocketProtocol = 'Sec-WebSocket-Protocol';
    this._SecWebSocketVersion = 'Sec-WebSocket-Version';
    this._Server = 'Server';
    this._SetCookie = 'Set-Cookie';
    this._SLUG = 'SLUG';
    this._StrictTransportSecurity = 'Strict-Transport-Security';
    this._TE = 'TE';
    this._Timeout = 'Timeout';
    this._Trailer = 'Trailer';
    this._TransferEncoding = 'Transfer-Encoding';
    this._Upgrade = 'Upgrade';
    this._UserAgent = 'User-Agent';
    this._Vary = 'Vary';
    this._Via = 'Via';
    this._Warning = 'Warning';
    this._WWWAuthenticate = 'WWW-Authenticate';
    this._AccessControlAllowOrigin = 'Access-Control-Allow-Origin';
    this._AccessControlAllowMethods = 'Access-Control-Allow-Methods';
    this._AccessControlAllowCredentials = 'Access-Control-Allow-Credentials';
    this._AccessControlAllowHeaders = 'Access-Control-Allow-Headers';
    this._AccessControlRequestMethod = 'Access-Control-Request-Method';
    this._AccessControlRequestHeaders = 'Access-Control-Request-Headers';
    this._AccessControlExposeHeaders = 'Access-Control-Expose-Headers';
    this._AccessControlMaxAge = 'Access-Control-Max-Age';
    this._XHttpMethodOverride = 'X-Http-Method-Override';
    this._XForwardedHost = 'X-Forwarded-Host';
    this._XForwardedServer = 'X-Forwarded-Server';
    this._XForwardedProto = 'X-Forwarded-Proto';
    this._XForwardedFor = 'X-Forwarded-For';
    this._XRequestId = 'X-Request-ID';
    this._XCorrelationId = 'X-Correlation-ID';
    this._XTotalCount = 'X-Total-Count';
    var tmp = this;
    var tmp0_arrayOf_0 = [this._ContentLength, this._ContentType, this._TransferEncoding, this._Upgrade];
    tmp._UnsafeHeadersArray = tmp0_arrayOf_0;
    this._UnsafeHeadersList = asList(this._UnsafeHeadersArray);
  }
  HttpHeaders.prototype.checkHeaderName = function (name) {
    var index_1 = 0;
    var indexedObject = name;
    var inductionVariable = 0;
    var last_1 = indexedObject.length;
    while (inductionVariable < last_1) {
      var item_3 = charSequenceGet(indexedObject, inductionVariable);
      inductionVariable = inductionVariable + 1 | 0;
      var tmp1_4 = index_1;
      index_1 = tmp1_4 + 1 | 0;
      var tmp0__anonymous__5 = tmp1_4;
      if (item_3.compareTo_12(new Char(32)) <= 0 ? true : isDelimiter(item_3)) {
        throw new IllegalHeaderNameException(name, tmp0__anonymous__5);
      }}
  };
  HttpHeaders.prototype.checkHeaderValue = function (value) {
    var index_1 = 0;
    var indexedObject = value;
    var inductionVariable = 0;
    var last_1 = indexedObject.length;
    while (inductionVariable < last_1) {
      var item_3 = charSequenceGet(indexedObject, inductionVariable);
      inductionVariable = inductionVariable + 1 | 0;
      var tmp$ret$0;
      l$ret$1: do {
        var tmp1_4 = index_1;
        index_1 = tmp1_4 + 1 | 0;
        var tmp0__anonymous__5 = tmp1_4;
        if (item_3.equals(new Char(32)) ? true : item_3.equals(new Char(9))) {
          tmp$ret$0 = Unit_getInstance();
          break l$ret$1;
        }if (item_3.compareTo_12(new Char(32)) < 0) {
          throw new IllegalHeaderValueException(value, tmp0__anonymous__5);
        }}
       while (false);
    }
  };
  HttpHeaders.$metadata$ = {
    simpleName: 'HttpHeaders',
    kind: 'object',
    interfaces: []
  };
  var HttpHeaders_instance;
  function HttpHeaders_getInstance() {
    if (HttpHeaders_instance == null)
      new HttpHeaders();
    return HttpHeaders_instance;
  }
  function UnsafeHeaderException(header) {
    IllegalArgumentException_init_$Init$_0('' + 'Header ' + header + ' is controlled by the engine and ' + 'cannot be set explicitly', this);
    captureStack(this, UnsafeHeaderException);
  }
  UnsafeHeaderException.$metadata$ = {
    simpleName: 'UnsafeHeaderException',
    kind: 'class',
    interfaces: []
  };
  function isDelimiter(ch) {
    return contains$default_0('"(),/:;<=>?@[\\]{}', ch, false, 2, null);
  }
  function IllegalHeaderNameException(headerName, position) {
    IllegalArgumentException_init_$Init$_0('' + "Header name '" + headerName + "' contains illegal character '" + charSequenceGet(headerName, position) + "'" + ('' + ' (code ' + (charSequenceGet(headerName, position).toInt_5() & 255) + ')'), this);
    this._headerName = headerName;
    this._position_9 = position;
    captureStack(this, IllegalHeaderNameException);
  }
  IllegalHeaderNameException.$metadata$ = {
    simpleName: 'IllegalHeaderNameException',
    kind: 'class',
    interfaces: []
  };
  function IllegalHeaderValueException(headerValue, position) {
    IllegalArgumentException_init_$Init$_0('' + "Header value '" + headerValue + "' contains illegal character '" + charSequenceGet(headerValue, position) + "'" + ('' + ' (code ' + (charSequenceGet(headerValue, position).toInt_5() & 255) + ')'), this);
    this._headerValue = headerValue;
    this._position_10 = position;
    captureStack(this, IllegalHeaderValueException);
  }
  IllegalHeaderValueException.$metadata$ = {
    simpleName: 'IllegalHeaderValueException',
    kind: 'class',
    interfaces: []
  };
  function HttpMessageBuilder() {
  }
  HttpMessageBuilder.$metadata$ = {
    simpleName: 'HttpMessageBuilder',
    kind: 'interface',
    interfaces: []
  };
  function HttpMessage() {
  }
  HttpMessage.$metadata$ = {
    simpleName: 'HttpMessage',
    kind: 'interface',
    interfaces: []
  };
  function contentType(_this_) {
    var tmp0_safe_receiver = _this_._get_headers__15().get_69(HttpHeaders_getInstance()._ContentType);
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      tmp = Companion_getInstance_46().parse_0(tmp0_safe_receiver);
    }
    return tmp;
  }
  function charset_0(_this_) {
    var tmp0_safe_receiver = contentType_1(_this_);
    return tmp0_safe_receiver == null ? null : charset(tmp0_safe_receiver);
  }
  function contentType_0(_this_, type) {
    return _this_._get_headers__15().set_13(HttpHeaders_getInstance()._ContentType, type.toString());
  }
  function contentType_1(_this_) {
    var tmp0_safe_receiver = _this_._get_headers__15().get_69(HttpHeaders_getInstance()._ContentType);
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      tmp = Companion_getInstance_46().parse_0(tmp0_safe_receiver);
    }
    return tmp;
  }
  function Companion_50() {
    Companion_instance_49 = this;
    this._Get = new HttpMethod('GET');
    this._Post = new HttpMethod('POST');
    this._Put = new HttpMethod('PUT');
    this._Patch = new HttpMethod('PATCH');
    this._Delete = new HttpMethod('DELETE');
    this._Head = new HttpMethod('HEAD');
    this._Options = new HttpMethod('OPTIONS');
    this._DefaultMethods = listOf([this._Get, this._Post, this._Put, this._Patch, this._Delete, this._Head, this._Options]);
  }
  Companion_50.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_49;
  function Companion_getInstance_49() {
    if (Companion_instance_49 == null)
      new Companion_50();
    return Companion_instance_49;
  }
  function HttpMethod(value) {
    Companion_getInstance_49();
    this._value_31 = value;
  }
  HttpMethod.prototype.toString = function () {
    return '' + 'HttpMethod(value=' + this._value_31 + ')';
  };
  HttpMethod.prototype.hashCode = function () {
    return getStringHashCode(this._value_31);
  };
  HttpMethod.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof HttpMethod))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof HttpMethod ? other : THROW_CCE();
    if (!(this._value_31 === tmp0_other_with_cast._value_31))
      return false;
    return true;
  };
  HttpMethod.$metadata$ = {
    simpleName: 'HttpMethod',
    kind: 'class',
    interfaces: []
  };
  function Companion_51() {
    Companion_instance_50 = this;
    this._HTTP_2_0 = new HttpProtocolVersion('HTTP', 2, 0);
    this._HTTP_1_1 = new HttpProtocolVersion('HTTP', 1, 1);
    this._HTTP_1_0 = new HttpProtocolVersion('HTTP', 1, 0);
    this._SPDY_3 = new HttpProtocolVersion('SPDY', 3, 0);
    this._QUIC = new HttpProtocolVersion('QUIC', 1, 0);
  }
  Companion_51.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_50;
  function Companion_getInstance_50() {
    if (Companion_instance_50 == null)
      new Companion_51();
    return Companion_instance_50;
  }
  function HttpProtocolVersion(name, major, minor) {
    Companion_getInstance_50();
    this._name_8 = name;
    this._major = major;
    this._minor = minor;
  }
  HttpProtocolVersion.prototype.toString = function () {
    return '' + this._name_8 + '/' + this._major + '.' + this._minor;
  };
  HttpProtocolVersion.prototype.hashCode = function () {
    var result = getStringHashCode(this._name_8);
    result = imul(result, 31) + this._major | 0;
    result = imul(result, 31) + this._minor | 0;
    return result;
  };
  HttpProtocolVersion.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof HttpProtocolVersion))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof HttpProtocolVersion ? other : THROW_CCE();
    if (!(this._name_8 === tmp0_other_with_cast._name_8))
      return false;
    if (!(this._major === tmp0_other_with_cast._major))
      return false;
    if (!(this._minor === tmp0_other_with_cast._minor))
      return false;
    return true;
  };
  HttpProtocolVersion.$metadata$ = {
    simpleName: 'HttpProtocolVersion',
    kind: 'class',
    interfaces: []
  };
  function Companion_52() {
    Companion_instance_51 = this;
    this._Continue = new HttpStatusCode(100, 'Continue');
    this._SwitchingProtocols = new HttpStatusCode(101, 'Switching Protocols');
    this._Processing = new HttpStatusCode(102, 'Processing');
    this._OK = new HttpStatusCode(200, 'OK');
    this._Created = new HttpStatusCode(201, 'Created');
    this._Accepted = new HttpStatusCode(202, 'Accepted');
    this._NonAuthoritativeInformation = new HttpStatusCode(203, 'Non-Authoritative Information');
    this._NoContent = new HttpStatusCode(204, 'No Content');
    this._ResetContent = new HttpStatusCode(205, 'Reset Content');
    this._PartialContent = new HttpStatusCode(206, 'Partial Content');
    this._MultiStatus = new HttpStatusCode(207, 'Multi-Status');
    this._MultipleChoices = new HttpStatusCode(300, 'Multiple Choices');
    this._MovedPermanently = new HttpStatusCode(301, 'Moved Permanently');
    this._Found = new HttpStatusCode(302, 'Found');
    this._SeeOther = new HttpStatusCode(303, 'See Other');
    this._NotModified = new HttpStatusCode(304, 'Not Modified');
    this._UseProxy = new HttpStatusCode(305, 'Use Proxy');
    this._SwitchProxy = new HttpStatusCode(306, 'Switch Proxy');
    this._TemporaryRedirect = new HttpStatusCode(307, 'Temporary Redirect');
    this._PermanentRedirect = new HttpStatusCode(308, 'Permanent Redirect');
    this._BadRequest = new HttpStatusCode(400, 'Bad Request');
    this._Unauthorized = new HttpStatusCode(401, 'Unauthorized');
    this._PaymentRequired = new HttpStatusCode(402, 'Payment Required');
    this._Forbidden = new HttpStatusCode(403, 'Forbidden');
    this._NotFound = new HttpStatusCode(404, 'Not Found');
    this._MethodNotAllowed = new HttpStatusCode(405, 'Method Not Allowed');
    this._NotAcceptable = new HttpStatusCode(406, 'Not Acceptable');
    this._ProxyAuthenticationRequired = new HttpStatusCode(407, 'Proxy Authentication Required');
    this._RequestTimeout = new HttpStatusCode(408, 'Request Timeout');
    this._Conflict = new HttpStatusCode(409, 'Conflict');
    this._Gone = new HttpStatusCode(410, 'Gone');
    this._LengthRequired = new HttpStatusCode(411, 'Length Required');
    this._PreconditionFailed = new HttpStatusCode(412, 'Precondition Failed');
    this._PayloadTooLarge = new HttpStatusCode(413, 'Payload Too Large');
    this._RequestURITooLong = new HttpStatusCode(414, 'Request-URI Too Long');
    this._UnsupportedMediaType = new HttpStatusCode(415, 'Unsupported Media Type');
    this._RequestedRangeNotSatisfiable = new HttpStatusCode(416, 'Requested Range Not Satisfiable');
    this._ExpectationFailed = new HttpStatusCode(417, 'Expectation Failed');
    this._UnprocessableEntity = new HttpStatusCode(422, 'Unprocessable Entity');
    this._Locked = new HttpStatusCode(423, 'Locked');
    this._FailedDependency = new HttpStatusCode(424, 'Failed Dependency');
    this._UpgradeRequired = new HttpStatusCode(426, 'Upgrade Required');
    this._TooManyRequests = new HttpStatusCode(429, 'Too Many Requests');
    this._RequestHeaderFieldTooLarge = new HttpStatusCode(431, 'Request Header Fields Too Large');
    this._InternalServerError = new HttpStatusCode(500, 'Internal Server Error');
    this._NotImplemented = new HttpStatusCode(501, 'Not Implemented');
    this._BadGateway = new HttpStatusCode(502, 'Bad Gateway');
    this._ServiceUnavailable = new HttpStatusCode(503, 'Service Unavailable');
    this._GatewayTimeout = new HttpStatusCode(504, 'Gateway Timeout');
    this._VersionNotSupported = new HttpStatusCode(505, 'HTTP Version Not Supported');
    this._VariantAlsoNegotiates = new HttpStatusCode(506, 'Variant Also Negotiates');
    this._InsufficientStorage = new HttpStatusCode(507, 'Insufficient Storage');
    this._allStatusCodes = allStatusCodes();
    var tmp = this;
    var tmp_0 = 0;
    var tmp_1 = 1000;
    var tmp_2 = fillArrayVal(Array(tmp_1), null);
    while (tmp_0 < tmp_1) {
      var tmp_3 = tmp_0;
      var tmp$ret$0;
      l$ret$1: do {
        var tmp0_firstOrNull_0 = Companion_getInstance_51()._allStatusCodes;
        var tmp0_iterator_1 = tmp0_firstOrNull_0.iterator_64();
        while (tmp0_iterator_1.hasNext_31()) {
          var element_2 = tmp0_iterator_1.next_35();
          if (element_2._value_32 === tmp_3) {
            tmp$ret$0 = element_2;
            break l$ret$1;
          } else {
          }
        }
        tmp$ret$0 = null;
      }
       while (false);
      tmp_2[tmp_3] = tmp$ret$0;
      tmp_0 = tmp_0 + 1 | 0;
    }
    tmp._byValue = tmp_2;
  }
  Companion_52.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_51;
  function Companion_getInstance_51() {
    if (Companion_instance_51 == null)
      new Companion_52();
    return Companion_instance_51;
  }
  function HttpStatusCode(value, description) {
    Companion_getInstance_51();
    this._value_32 = value;
    this._description = description;
  }
  HttpStatusCode.prototype.toString = function () {
    return '' + this._value_32 + ' ' + this._description;
  };
  HttpStatusCode.prototype.equals = function (other) {
    var tmp;
    if (other instanceof HttpStatusCode) {
      tmp = other._value_32 === this._value_32;
    } else {
      {
        tmp = false;
      }
    }
    return tmp;
  };
  HttpStatusCode.prototype.hashCode = function () {
    return this._value_32;
  };
  HttpStatusCode.$metadata$ = {
    simpleName: 'HttpStatusCode',
    kind: 'class',
    interfaces: []
  };
  function allStatusCodes() {
    return listOf([Companion_getInstance_51()._Continue, Companion_getInstance_51()._SwitchingProtocols, Companion_getInstance_51()._Processing, Companion_getInstance_51()._OK, Companion_getInstance_51()._Created, Companion_getInstance_51()._Accepted, Companion_getInstance_51()._NonAuthoritativeInformation, Companion_getInstance_51()._NoContent, Companion_getInstance_51()._ResetContent, Companion_getInstance_51()._PartialContent, Companion_getInstance_51()._MultiStatus, Companion_getInstance_51()._MultipleChoices, Companion_getInstance_51()._MovedPermanently, Companion_getInstance_51()._Found, Companion_getInstance_51()._SeeOther, Companion_getInstance_51()._NotModified, Companion_getInstance_51()._UseProxy, Companion_getInstance_51()._SwitchProxy, Companion_getInstance_51()._TemporaryRedirect, Companion_getInstance_51()._PermanentRedirect, Companion_getInstance_51()._BadRequest, Companion_getInstance_51()._Unauthorized, Companion_getInstance_51()._PaymentRequired, Companion_getInstance_51()._Forbidden, Companion_getInstance_51()._NotFound, Companion_getInstance_51()._MethodNotAllowed, Companion_getInstance_51()._NotAcceptable, Companion_getInstance_51()._ProxyAuthenticationRequired, Companion_getInstance_51()._RequestTimeout, Companion_getInstance_51()._Conflict, Companion_getInstance_51()._Gone, Companion_getInstance_51()._LengthRequired, Companion_getInstance_51()._PreconditionFailed, Companion_getInstance_51()._PayloadTooLarge, Companion_getInstance_51()._RequestURITooLong, Companion_getInstance_51()._UnsupportedMediaType, Companion_getInstance_51()._RequestedRangeNotSatisfiable, Companion_getInstance_51()._ExpectationFailed, Companion_getInstance_51()._UnprocessableEntity, Companion_getInstance_51()._Locked, Companion_getInstance_51()._FailedDependency, Companion_getInstance_51()._UpgradeRequired, Companion_getInstance_51()._TooManyRequests, Companion_getInstance_51()._RequestHeaderFieldTooLarge, Companion_getInstance_51()._InternalServerError, Companion_getInstance_51()._NotImplemented, Companion_getInstance_51()._BadGateway, Companion_getInstance_51()._ServiceUnavailable, Companion_getInstance_51()._GatewayTimeout, Companion_getInstance_51()._VersionNotSupported, Companion_getInstance_51()._VariantAlsoNegotiates, Companion_getInstance_51()._InsufficientStorage]);
  }
  function formUrlEncodeTo(_this_, out) {
    formUrlEncodeTo_1(_this_.entries_9(), out);
  }
  function formUrlEncodeTo_0(_this_, out) {
    formUrlEncodeTo_1(_this_.entries_9(), out);
  }
  function formUrlEncodeTo_1(_this_, out) {
    var tmp0_flatMapTo_0_1 = ArrayList_init_$Create$();
    var tmp0_iterator_1_2 = _this_.iterator_64();
    while (tmp0_iterator_1_2.hasNext_31()) {
      var element_2_3 = tmp0_iterator_1_2.next_35();
      var key_6 = element_2_3._get_key__47();
      var value_7 = element_2_3._get_value__33();
      var tmp;
      if (value_7.isEmpty_53()) {
        tmp = listOf_0(to(key_6, null));
      } else {
        var tmp0_mapTo_0_1_8 = ArrayList_init_$Create$_0(collectionSizeOrDefault(value_7, 10));
        var tmp0_iterator_1_2_9 = value_7.iterator_64();
        while (tmp0_iterator_1_2_9.hasNext_31()) {
          var item_2_3_10 = tmp0_iterator_1_2_9.next_35();
          tmp0_mapTo_0_1_8.add_33(to(key_6, item_2_3_10));
          Unit_getInstance();
        }
        tmp = tmp0_mapTo_0_1_8;
      }
      var list_3_4 = tmp;
      addAll(tmp0_flatMapTo_0_1, list_3_4);
      Unit_getInstance();
    }
    formUrlEncodeTo_2(tmp0_flatMapTo_0_1, out);
  }
  function formUrlEncodeTo_2(_this_, out) {
    joinTo$default(_this_, out, '&', null, null, 0, null, _no_name_provided_$factory_123(), 60, null);
    Unit_getInstance();
  }
  function _no_name_provided__160() {
  }
  _no_name_provided__160.prototype.invoke_226 = function (it) {
    var key = encodeURLParameter(it._first, true);
    var tmp;
    if (it._second == null) {
      tmp = key;
    } else {
      var value = encodeURLParameterValue(toString_0(it._second));
      tmp = '' + key + '=' + value;
    }
    return tmp;
  };
  _no_name_provided__160.prototype.invoke_542 = function (p1) {
    return this.invoke_226(p1 instanceof Pair ? p1 : THROW_CCE());
  };
  _no_name_provided__160.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided_$factory_123() {
    var i = new _no_name_provided__160();
    return function (p1) {
      return i.invoke_226(p1);
    };
  }
  var IPv4address;
  var IPv6address;
  var IP_PARSER;
  function _get_mimes_() {
    var tmp0_getValue_0 = mimes$delegate;
    var tmp1_getValue_0 = null;
    var tmp2_getValue_0 = mimes$factory();
    return tmp0_getValue_0._get_value__33();
  }
  var mimes$delegate;
  function loadMimes() {
    var tmp = lineSequence(_get_rawMimes_());
    return toList_2(mapNotNull(tmp, _no_name_provided_$factory_125()));
  }
  function _get_rawMimes_() {
    return '\n.123,application/vnd.lotus-1-2-3\n.3dmf,x-world/x-3dmf\n.3dml,text/vnd.in3d.3dml\n.3dm,x-world/x-3dmf\n.3g2,video/3gpp2\n.3gp,video/3gpp\n.7z,application/x-7z-compressed\n.aab,application/x-authorware-bin\n.aac,audio/aac\n.aam,application/x-authorware-map\n.a,application/octet-stream\n.aas,application/x-authorware-seg\n.abc,text/vnd.abc\n.abw,application/x-abiword\n.ac,application/pkix-attr-cert\n.acc,application/vnd.americandynamics.acc\n.ace,application/x-ace-compressed\n.acgi,text/html\n.acu,application/vnd.acucobol\n.adp,audio/adpcm\n.aep,application/vnd.audiograph\n.afl,video/animaflex\n.afp,application/vnd.ibm.modcap\n.ahead,application/vnd.ahead.space\n.ai,application/postscript\n.aif,audio/aiff\n.aifc,audio/aiff\n.aiff,audio/aiff\n.aim,application/x-aim\n.aip,text/x-audiosoft-intra\n.air,application/vnd.adobe.air-application-installer-package+zip\n.ait,application/vnd.dvb.ait\n.ami,application/vnd.amiga.ami\n.ani,application/x-navi-animation\n.aos,application/x-nokia-9000-communicator-add-on-software\n.apk,application/vnd.android.package-archive\n.application,application/x-ms-application\n,application/pgp-encrypted\n.apr,application/vnd.lotus-approach\n.aps,application/mime\n.arc,application/octet-stream\n.arj,application/arj\n.arj,application/octet-stream\n.art,image/x-jg\n.asf,video/x-ms-asf\n.asm,text/x-asm\n.aso,application/vnd.accpac.simply.aso\n.asp,text/asp\n.asx,application/x-mplayer2\n.asx,video/x-ms-asf\n.asx,video/x-ms-asf-plugin\n.atc,application/vnd.acucorp\n.atomcat,application/atomcat+xml\n.atomsvc,application/atomsvc+xml\n.atom,application/atom+xml\n.atx,application/vnd.antix.game-component\n.au,audio/basic\n.au,audio/x-au\n.avi,video/avi\n.avi,video/msvideo\n.avi,video/x-msvideo\n.avs,video/avs-video\n.aw,application/applixware\n.azf,application/vnd.airzip.filesecure.azf\n.azs,application/vnd.airzip.filesecure.azs\n.azw,application/vnd.amazon.ebook\n.bcpio,application/x-bcpio\n.bdf,application/x-font-bdf\n.bdm,application/vnd.syncml.dm+wbxml\n.bed,application/vnd.realvnc.bed\n.bh2,application/vnd.fujitsu.oasysprs\n.bin,application/macbinary\n.bin,application/mac-binary\n.bin,application/octet-stream\n.bin,application/x-binary\n.bin,application/x-macbinary\n.bmi,application/vnd.bmi\n.bm,image/bmp\n.bmp,image/bmp\n.bmp,image/x-windows-bmp\n.boo,application/book\n.book,application/book\n.box,application/vnd.previewsystems.box\n.boz,application/x-bzip2\n.bsh,application/x-bsh\n.btif,image/prs.btif\n.bz2,application/x-bzip2\n.bz,application/x-bzip\n.c11amc,application/vnd.cluetrust.cartomobile-config\n.c11amz,application/vnd.cluetrust.cartomobile-config-pkg\n.c4g,application/vnd.clonk.c4group\n.cab,application/vnd.ms-cab-compressed\n.car,application/vnd.curl.car\n.cat,application/vnd.ms-pki.seccat\n.ccad,application/clariscad\n.cco,application/x-cocoa\n.cc,text/plain\n.cc,text/x-c\n.ccxml,application/ccxml+xml,\n.cdbcmsg,application/vnd.contact.cmsg\n.cdf,application/cdf\n.cdf,application/x-cdf\n.cdf,application/x-netcdf\n.cdkey,application/vnd.mediastation.cdkey\n.cdmia,application/cdmi-capability\n.cdmic,application/cdmi-container\n.cdmid,application/cdmi-domain\n.cdmio,application/cdmi-object\n.cdmiq,application/cdmi-queue\n.cdx,chemical/x-cdx\n.cdxml,application/vnd.chemdraw+xml\n.cdy,application/vnd.cinderella\n.cer,application/pkix-cert\n.cgm,image/cgm\n.cha,application/x-chat\n.chat,application/x-chat\n.chm,application/vnd.ms-htmlhelp\n.chrt,application/vnd.kde.kchart\n.cif,chemical/x-cif\n.cii,application/vnd.anser-web-certificate-issue-initiation\n.cil,application/vnd.ms-artgalry\n.cla,application/vnd.claymore\n.class,application/java\n.class,application/java-byte-code\n.class,application/java-vm\n.class,application/x-java-class\n.clkk,application/vnd.crick.clicker.keyboard\n.clkp,application/vnd.crick.clicker.palette\n.clkt,application/vnd.crick.clicker.template\n.clkw,application/vnd.crick.clicker.wordbank\n.clkx,application/vnd.crick.clicker\n.clp,application/x-msclip\n.cmc,application/vnd.cosmocaller\n.cmdf,chemical/x-cmdf\n.cml,chemical/x-cml\n.cmp,application/vnd.yellowriver-custom-menu\n.cmx,image/x-cmx\n.cod,application/vnd.rim.cod\n.com,application/octet-stream\n.com,text/plain\n.conf,text/plain\n.cpio,application/x-cpio\n.cpp,text/x-c\n.cpt,application/mac-compactpro\n.cpt,application/x-compactpro\n.cpt,application/x-cpt\n.crd,application/x-mscardfile\n.crl,application/pkcs-crl\n.crl,application/pkix-crl\n.crt,application/pkix-cert\n.crt,application/x-x509-ca-cert\n.crt,application/x-x509-user-cert\n.cryptonote,application/vnd.rig.cryptonote\n.csh,application/x-csh\n.csh,text/x-script.csh\n.csml,chemical/x-csml\n.csp,application/vnd.commonspace\n.css,text/css\n.csv,text/csv\n.c,text/plain\n.c++,text/plain\n.c,text/x-c\n.cu,application/cu-seeme\n.curl,text/vnd.curl\n.cww,application/prs.cww\n.cxx,text/plain\n.dat,binary/octet-stream\n.dae,model/vnd.collada+xml\n.daf,application/vnd.mobius.daf\n.davmount,application/davmount+xml\n.dcr,application/x-director\n.dcurl,text/vnd.curl.dcurl\n.dd2,application/vnd.oma.dd2+xml\n.ddd,application/vnd.fujixerox.ddd\n.deb,application/x-debian-package\n.deepv,application/x-deepv\n.def,text/plain\n.der,application/x-x509-ca-cert\n.dfac,application/vnd.dreamfactory\n.dif,video/x-dv\n.dir,application/x-director\n.dis,application/vnd.mobius.dis\n.djvu,image/vnd.djvu\n.dl,video/dl\n.dl,video/x-dl\n.dna,application/vnd.dna\n.doc,application/msword\n.docm,application/vnd.ms-word.document.macroenabled.12\n.docx,application/vnd.openxmlformats-officedocument.wordprocessingml.document\n.dot,application/msword\n.dotm,application/vnd.ms-word.template.macroenabled.12\n.dotx,application/vnd.openxmlformats-officedocument.wordprocessingml.template\n.dp,application/commonground\n.dp,application/vnd.osgi.dp\n.dpg,application/vnd.dpgraph\n.dra,audio/vnd.dra\n.drw,application/drafting\n.dsc,text/prs.lines.tag\n.dssc,application/dssc+der\n.dtb,application/x-dtbook+xml\n.dtd,application/xml-dtd\n.dts,audio/vnd.dts\n.dtshd,audio/vnd.dts.hd\n.dump,application/octet-stream\n.dvi,application/x-dvi\n.dv,video/x-dv\n.dwf,drawing/x-dwf (old)\n.dwf,model/vnd.dwf\n.dwg,application/acad\n.dwg,image/vnd.dwg\n.dwg,image/x-dwg\n.dxf,application/dxf\n.dxf,image/vnd.dwg\n.dxf,image/vnd.dxf\n.dxf,image/x-dwg\n.dxp,application/vnd.spotfire.dxp\n.dxr,application/x-director\n.ecelp4800,audio/vnd.nuera.ecelp4800\n.ecelp7470,audio/vnd.nuera.ecelp7470\n.ecelp9600,audio/vnd.nuera.ecelp9600\n.edm,application/vnd.novadigm.edm\n.edx,application/vnd.novadigm.edx\n.efif,application/vnd.picsel\n.ei6,application/vnd.pg.osasli\n.elc,application/x-bytecode.elisp (compiled elisp)\n.elc,application/x-elc\n.el,text/x-script.elisp\n.eml,message/rfc822\n.emma,application/emma+xml\n.env,application/x-envoy\n.eol,audio/vnd.digital-winds\n.eot,application/vnd.ms-fontobject\n.eps,application/postscript\n.epub,application/epub+zip\n.es3,application/vnd.eszigno3+xml\n.es,application/ecmascript\n.es,application/x-esrehber\n.esf,application/vnd.epson.esf\n.etx,text/x-setext\n.evy,application/envoy\n.evy,application/x-envoy\n.exe,application/octet-stream\n.exe,application/x-msdownload\n.exi,application/exi\n.ext,application/vnd.novadigm.ext\n.ez2,application/vnd.ezpix-album\n.ez3,application/vnd.ezpix-package\n.f4v,video/x-f4v\n.f77,text/x-fortran\n.f90,text/plain\n.f90,text/x-fortran\n.fbs,image/vnd.fastbidsheet\n.fcs,application/vnd.isac.fcs\n.fdf,application/vnd.fdf\n.fe_launch,application/vnd.denovo.fcselayout-link\n.fg5,application/vnd.fujitsu.oasysgp\n.fh,image/x-freehand\n.fif,application/fractals\n.fif,image/fif\n.fig,application/x-xfig\n.fli,video/fli\n.fli,video/x-fli\n.flo,application/vnd.micrografx.flo\n.flo,image/florian\n.flv,video/x-flv\n.flw,application/vnd.kde.kivio\n.flx,text/vnd.fmi.flexstor\n.fly,text/vnd.fly\n.fm,application/vnd.framemaker\n.fmf,video/x-atomic3d-feature\n.fnc,application/vnd.frogans.fnc\n.for,text/plain\n.for,text/x-fortran\n.fpx,image/vnd.fpx\n.fpx,image/vnd.net-fpx\n.frl,application/freeloader\n.fsc,application/vnd.fsc.weblaunch\n.fst,image/vnd.fst\n.ftc,application/vnd.fluxtime.clip\n.f,text/plain\n.f,text/x-fortran\n.fti,application/vnd.anser-web-funds-transfer-initiation\n.funk,audio/make\n.fvt,video/vnd.fvt\n.fxp,application/vnd.adobe.fxp\n.fzs,application/vnd.fuzzysheet\n.g2w,application/vnd.geoplan\n.g3,image/g3fax\n.g3w,application/vnd.geospace\n.gac,application/vnd.groove-account\n.gdl,model/vnd.gdl\n.geo,application/vnd.dynageo\n.gex,application/vnd.geometry-explorer\n.ggb,application/vnd.geogebra.file\n.ggt,application/vnd.geogebra.tool\n.ghf,application/vnd.groove-help\n.gif,image/gif\n.gim,application/vnd.groove-identity-message\n.gl,video/gl\n.gl,video/x-gl\n.gmx,application/vnd.gmx\n.gnumeric,application/x-gnumeric\n.gph,application/vnd.flographit\n.gqf,application/vnd.grafeq\n.gram,application/srgs\n.grv,application/vnd.groove-injector\n.grxml,application/srgs+xml\n.gsd,audio/x-gsm\n.gsf,application/x-font-ghostscript\n.gsm,audio/x-gsm\n.gsp,application/x-gsp\n.gss,application/x-gss\n.gtar,application/x-gtar\n.g,text/plain\n.gtm,application/vnd.groove-tool-message\n.gtw,model/vnd.gtw\n.gv,text/vnd.graphviz\n.gxt,application/vnd.geonext\n.gz,application/x-compressed\n.gz,application/x-gzip\n.gzip,application/x-gzip\n.gzip,multipart/x-gzip\n.h261,video/h261\n.h263,video/h263\n.h264,video/h264\n.hal,application/vnd.hal+xml\n.hbci,application/vnd.hbci\n.hdf,application/x-hdf\n.help,application/x-helpfile\n.hgl,application/vnd.hp-hpgl\n.hh,text/plain\n.hh,text/x-h\n.hlb,text/x-script\n.hlp,application/hlp\n.hlp,application/winhlp\n.hlp,application/x-helpfile\n.hlp,application/x-winhelp\n.hpg,application/vnd.hp-hpgl\n.hpgl,application/vnd.hp-hpgl\n.hpid,application/vnd.hp-hpid\n.hps,application/vnd.hp-hps\n.hqx,application/binhex\n.hqx,application/binhex4\n.hqx,application/mac-binhex\n.hqx,application/mac-binhex40\n.hqx,application/x-binhex40\n.hqx,application/x-mac-binhex40\n.hta,application/hta\n.htc,text/x-component\n.h,text/plain\n.h,text/x-h\n.htke,application/vnd.kenameaapp\n.htmls,text/html\n.html,text/html\n.htm,text/html\n.htt,text/webviewhtml\n.htx,text/html\n.hvd,application/vnd.yamaha.hv-dic\n.hvp,application/vnd.yamaha.hv-voice\n.hvs,application/vnd.yamaha.hv-script\n.i2g,application/vnd.intergeo\n.icc,application/vnd.iccprofile\n.ice,x-conference/x-cooltalk\n.ico,image/x-icon\n.ics,text/calendar\n.idc,text/plain\n.ief,image/ief\n.iefs,image/ief\n.iff,application/iff\n.ifm,application/vnd.shana.informed.formdata\n.iges,application/iges\n.iges,model/iges\n.igl,application/vnd.igloader\n.igm,application/vnd.insors.igm\n.igs,application/iges\n.igs,model/iges\n.igx,application/vnd.micrografx.igx\n.iif,application/vnd.shana.informed.interchange\n.ima,application/x-ima\n.imap,application/x-httpd-imap\n.imp,application/vnd.accpac.simply.imp\n.ims,application/vnd.ms-ims\n.inf,application/inf\n.ins,application/x-internett-signup\n.ip,application/x-ip2\n.ipfix,application/ipfix\n.ipk,application/vnd.shana.informed.package\n.irm,application/vnd.ibm.rights-management\n.irp,application/vnd.irepository.package+xml\n.isu,video/x-isvideo\n.it,audio/it\n.itp,application/vnd.shana.informed.formtemplate\n.iv,application/x-inventor\n.ivp,application/vnd.immervision-ivp\n.ivr,i-world/i-vrml\n.ivu,application/vnd.immervision-ivu\n.ivy,application/x-livescreen\n.jad,text/vnd.sun.j2me.app-descriptor\n.jam,application/vnd.jam\n.jam,audio/x-jam\n.jar,application/java-archive\n.java,text/plain\n.java,text/x-java-source\n.jav,text/plain\n.jav,text/x-java-source\n.jcm,application/x-java-commerce\n.jfif,image/jpeg\n.jfif,image/pjpeg\n.jfif-tbnl,image/jpeg\n.jisp,application/vnd.jisp\n.jlt,application/vnd.hp-jlyt\n.jnlp,application/x-java-jnlp-file\n.joda,application/vnd.joost.joda-archive\n.jpeg,image/jpeg\n.jpe,image/jpeg\n.jpg,image/jpeg\n.jpgv,video/jpeg\n.jpm,video/jpm\n.jps,image/x-jps\n.js,application/javascript\n.json,application/json\n.jut,image/jutvision\n.kar,audio/midi\n.karbon,application/vnd.kde.karbon\n.kar,music/x-karaoke\n.key,application/pgp-keys\n.keychain,application/octet-stream\n.kfo,application/vnd.kde.kformula\n.kia,application/vnd.kidspiration\n.kml,application/vnd.google-earth.kml+xml\n.kmz,application/vnd.google-earth.kmz\n.kne,application/vnd.kinar\n.kon,application/vnd.kde.kontour\n.kpr,application/vnd.kde.kpresenter\n.ksh,application/x-ksh\n.ksh,text/x-script.ksh\n.ksp,application/vnd.kde.kspread\n.ktx,image/ktx\n.ktz,application/vnd.kahootz\n.kwd,application/vnd.kde.kword\n.la,audio/nspaudio\n.la,audio/x-nspaudio\n.lam,audio/x-liveaudio\n.lasxml,application/vnd.las.las+xml\n.latex,application/x-latex\n.lbd,application/vnd.llamagraphics.life-balance.desktop\n.lbe,application/vnd.llamagraphics.life-balance.exchange+xml\n.les,application/vnd.hhe.lesson-player\n.lha,application/lha\n.lha,application/x-lha\n.link66,application/vnd.route66.link66+xml\n.list,text/plain\n.lma,audio/nspaudio\n.lma,audio/x-nspaudio\n.log,text/plain\n.lrm,application/vnd.ms-lrm\n.lsp,application/x-lisp\n.lsp,text/x-script.lisp\n.lst,text/plain\n.lsx,text/x-la-asf\n.ltf,application/vnd.frogans.ltf\n.ltx,application/x-latex\n.lvp,audio/vnd.lucent.voice\n.lwp,application/vnd.lotus-wordpro\n.lzh,application/octet-stream\n.lzh,application/x-lzh\n.lzx,application/lzx\n.lzx,application/octet-stream\n.lzx,application/x-lzx\n.m1v,video/mpeg\n.m21,application/mp21\n.m2a,audio/mpeg\n.m2v,video/mpeg\n.m3u8,application/vnd.apple.mpegurl\n.m3u,audio/x-mpegurl\n.m4a,audio/mp4\n.m4v,video/mp4\n.ma,application/mathematica\n.mads,application/mads+xml\n.mag,application/vnd.ecowin.chart\n.man,application/x-troff-man\n.map,application/x-navimap\n.mar,text/plain\n.mathml,application/mathml+xml\n.mbd,application/mbedlet\n.mbk,application/vnd.mobius.mbk\n.mbox,application/mbox\n.mc1,application/vnd.medcalcdata\n.mc$,application/x-magic-cap-package-1.0\n.mcd,application/mcad\n.mcd,application/vnd.mcd\n.mcd,application/x-mathcad\n.mcf,image/vasa\n.mcf,text/mcf\n.mcp,application/netmc\n.mcurl,text/vnd.curl.mcurl\n.mdb,application/x-msaccess\n.mdi,image/vnd.ms-modi\n.me,application/x-troff-me\n.meta4,application/metalink4+xml\n.mets,application/mets+xml\n.mfm,application/vnd.mfmp\n.mgp,application/vnd.osgeo.mapguide.package\n.mgz,application/vnd.proteus.magazine\n.mht,message/rfc822\n.mhtml,message/rfc822\n.mid,application/x-midi\n.mid,audio/midi\n.mid,audio/x-mid\n.midi,application/x-midi\n.midi,audio/midi\n.midi,audio/x-mid\n.midi,audio/x-midi\n.midi,music/crescendo\n.midi,x-music/x-midi\n.mid,music/crescendo\n.mid,x-music/x-midi\n.mif,application/vnd.mif\n.mif,application/x-frame\n.mif,application/x-mif\n.mime,message/rfc822\n.mime,www/mime\n.mj2,video/mj2\n.mjf,audio/x-vnd.audioexplosion.mjuicemediafile\n.mjpg,video/x-motion-jpeg\n.mkv,video/x-matroska\n.mkv,audio/x-matroska\n.mlp,application/vnd.dolby.mlp\n.mm,application/base64\n.mm,application/x-meme\n.mmd,application/vnd.chipnuts.karaoke-mmd\n.mme,application/base64\n.mmf,application/vnd.smaf\n.mmr,image/vnd.fujixerox.edmics-mmr\n.mny,application/x-msmoney\n.mod,audio/mod\n.mod,audio/x-mod\n.mods,application/mods+xml\n.moov,video/quicktime\n.movie,video/x-sgi-movie\n.mov,video/quicktime\n.mp2,audio/mpeg\n.mp2,audio/x-mpeg\n.mp2,video/mpeg\n.mp2,video/x-mpeg\n.mp2,video/x-mpeq2a\n.mp3,audio/mpeg\n.mp3,audio/mpeg3\n.mp4a,audio/mp4\n.mp4,video/mp4\n.mp4,application/mp4\n.mpa,audio/mpeg\n.mpc,application/vnd.mophun.certificate\n.mpc,application/x-project\n.mpeg,video/mpeg\n.mpe,video/mpeg\n.mpga,audio/mpeg\n.mpg,video/mpeg\n.mpg,audio/mpeg\n.mpkg,application/vnd.apple.installer+xml\n.mpm,application/vnd.blueice.multipass\n.mpn,application/vnd.mophun.application\n.mpp,application/vnd.ms-project\n.mpt,application/x-project\n.mpv,application/x-project\n.mpx,application/x-project\n.mpy,application/vnd.ibm.minipay\n.mqy,application/vnd.mobius.mqy\n.mrc,application/marc\n.mrcx,application/marcxml+xml\n.ms,application/x-troff-ms\n.mscml,application/mediaservercontrol+xml\n.mseq,application/vnd.mseq\n.msf,application/vnd.epson.msf\n.msg,application/vnd.ms-outlook\n.msh,model/mesh\n.msl,application/vnd.mobius.msl\n.msty,application/vnd.muvee.style\n.m,text/plain\n.m,text/x-m\n.mts,model/vnd.mts\n.mus,application/vnd.musician\n.musicxml,application/vnd.recordare.musicxml+xml\n.mvb,application/x-msmediaview\n.mv,video/x-sgi-movie\n.mwf,application/vnd.mfer\n.mxf,application/mxf\n.mxl,application/vnd.recordare.musicxml\n.mxml,application/xv+xml\n.mxs,application/vnd.triscape.mxs\n.mxu,video/vnd.mpegurl\n.my,audio/make\n.mzz,application/x-vnd.audioexplosion.mzz\n.n3,text/n3\nN/A,application/andrew-inset\n.nap,image/naplps\n.naplps,image/naplps\n.nbp,application/vnd.wolfram.player\n.nc,application/x-netcdf\n.ncm,application/vnd.nokia.configuration-message\n.ncx,application/x-dtbncx+xml\n.n-gage,application/vnd.nokia.n-gage.symbian.install\n.ngdat,application/vnd.nokia.n-gage.data\n.niff,image/x-niff\n.nif,image/x-niff\n.nix,application/x-mix-transfer\n.nlu,application/vnd.neurolanguage.nlu\n.nml,application/vnd.enliven\n.nnd,application/vnd.noblenet-directory\n.nns,application/vnd.noblenet-sealer\n.nnw,application/vnd.noblenet-web\n.npx,image/vnd.net-fpx\n.nsc,application/x-conference\n.nsf,application/vnd.lotus-notes\n.nvd,application/x-navidoc\n.oa2,application/vnd.fujitsu.oasys2\n.oa3,application/vnd.fujitsu.oasys3\n.o,application/octet-stream\n.oas,application/vnd.fujitsu.oasys\n.obd,application/x-msbinder\n.oda,application/oda\n.odb,application/vnd.oasis.opendocument.database\n.odc,application/vnd.oasis.opendocument.chart\n.odf,application/vnd.oasis.opendocument.formula\n.odft,application/vnd.oasis.opendocument.formula-template\n.odg,application/vnd.oasis.opendocument.graphics\n.odi,application/vnd.oasis.opendocument.image\n.odm,application/vnd.oasis.opendocument.text-master\n.odp,application/vnd.oasis.opendocument.presentation\n.ods,application/vnd.oasis.opendocument.spreadsheet\n.odt,application/vnd.oasis.opendocument.text\n.oga,audio/ogg\n.ogg,audio/ogg\n.ogv,video/ogg\n.ogx,application/ogg\n.omc,application/x-omc\n.omcd,application/x-omcdatamaker\n.omcr,application/x-omcregerator\n.onetoc,application/onenote\n.opf,application/oebps-package+xml\n.org,application/vnd.lotus-organizer\n.osf,application/vnd.yamaha.openscoreformat\n.osfpvg,application/vnd.yamaha.openscoreformat.osfpvg+xml\n.otc,application/vnd.oasis.opendocument.chart-template\n.otf,application/x-font-otf\n.otg,application/vnd.oasis.opendocument.graphics-template\n.oth,application/vnd.oasis.opendocument.text-web\n.oti,application/vnd.oasis.opendocument.image-template\n.otp,application/vnd.oasis.opendocument.presentation-template\n.ots,application/vnd.oasis.opendocument.spreadsheet-template\n.ott,application/vnd.oasis.opendocument.text-template\n.oxt,application/vnd.openofficeorg.extension\n.p10,application/pkcs10\n.p12,application/pkcs-12\n.p7a,application/x-pkcs7-signature\n.p7b,application/x-pkcs7-certificates\n.p7c,application/pkcs7-mime\n.p7m,application/pkcs7-mime\n.p7r,application/x-pkcs7-certreqresp\n.p7s,application/pkcs7-signature\n.p8,application/pkcs8\n.pages,application/vnd.apple.pages\n.part,application/pro_eng\n.par,text/plain-bas\n.pas,text/pascal\n.paw,application/vnd.pawaafile\n.pbd,application/vnd.powerbuilder6\n.pbm,image/x-portable-bitmap\n.pcf,application/x-font-pcf\n.pcl,application/vnd.hp-pcl\n.pcl,application/x-pcl\n.pclxl,application/vnd.hp-pclxl\n.pct,image/x-pict\n.pcurl,application/vnd.curl.pcurl\n.pcx,image/x-pcx\n.pdb,application/vnd.palm\n.pdb,chemical/x-pdb\n.pdf,application/pdf\n.pem,application/x-pem-file\n.pfa,application/x-font-type1\n.pfr,application/font-tdpfr\n.pfunk,audio/make\n.pfunk,audio/make.my.funk\n.pfx,application/x-pkcs12\n.pgm,image/x-portable-graymap\n.pgn,application/x-chess-pgn\n.pgp,application/pgp-signature\n.pic,image/pict\n.pict,image/pict\n.pkg,application/x-newton-compatible-pkg\n.pki,application/pkixcmp\n.pkipath,application/pkix-pkipath\n.pko,application/vnd.ms-pki.pko\n.plb,application/vnd.3gpp.pic-bw-large\n.plc,application/vnd.mobius.plc\n.plf,application/vnd.pocketlearn\n.pls,application/pls+xml\n.pl,text/plain\n.pl,text/x-script.perl\n.plx,application/x-pixclscript\n.pm4,application/x-pagemaker\n.pm5,application/x-pagemaker\n.pm,image/x-xpixmap\n.pml,application/vnd.ctc-posml\n.pm,text/x-script.perl-module\n.png,image/png\n.pnm,application/x-portable-anymap\n.pnm,image/x-portable-anymap\n.portpkg,application/vnd.macports.portpkg\n.pot,application/mspowerpoint\n.pot,application/vnd.ms-powerpoint\n.potm,application/vnd.ms-powerpoint.template.macroenabled.12\n.potx,application/vnd.openxmlformats-officedocument.presentationml.template\n.pov,model/x-pov\n.ppa,application/vnd.ms-powerpoint\n.ppam,application/vnd.ms-powerpoint.addin.macroenabled.12\n.ppd,application/vnd.cups-ppd\n.ppm,image/x-portable-pixmap\n.pps,application/mspowerpoint\n.pps,application/vnd.ms-powerpoint\n.ppsm,application/vnd.ms-powerpoint.slideshow.macroenabled.12\n.ppsx,application/vnd.openxmlformats-officedocument.presentationml.slideshow\n.ppt,application/mspowerpoint\n.ppt,application/powerpoint\n.ppt,application/vnd.ms-powerpoint\n.ppt,application/x-mspowerpoint\n.pptm,application/vnd.ms-powerpoint.presentation.macroenabled.12\n.pptx,application/vnd.openxmlformats-officedocument.presentationml.presentation\n.ppz,application/mspowerpoint\n.prc,application/x-mobipocket-ebook\n.pre,application/vnd.lotus-freelance\n.pre,application/x-freelance\n.prf,application/pics-rules\n.prt,application/pro_eng\n.ps,application/postscript\n.psb,application/vnd.3gpp.pic-bw-small\n.psd,application/octet-stream\n.psd,image/vnd.adobe.photoshop\n.psf,application/x-font-linux-psf\n.pskcxml,application/pskc+xml\n.p,text/x-pascal\n.ptid,application/vnd.pvi.ptid1\n.pub,application/x-mspublisher\n.pvb,application/vnd.3gpp.pic-bw-var\n.pvu,paleovu/x-pv\n.pwn,application/vnd.3m.post-it-notes\n.pwz,application/vnd.ms-powerpoint\n.pya,audio/vnd.ms-playready.media.pya\n.pyc,application/x-bytecode.python\n.py,text/x-script.python\n.pyv,video/vnd.ms-playready.media.pyv\n.qam,application/vnd.epson.quickanime\n.qbo,application/vnd.intu.qbo\n.qcp,audio/vnd.qcelp\n.qd3d,x-world/x-3dmf\n.qd3,x-world/x-3dmf\n.qfx,application/vnd.intu.qfx\n.qif,image/x-quicktime\n.qps,application/vnd.publishare-delta-tree\n.qtc,video/x-qtc\n.qtif,image/x-quicktime\n.qti,image/x-quicktime\n.qt,video/quicktime\n.qxd,application/vnd.quark.quarkxpress\n.ra,audio/x-pn-realaudio\n.ra,audio/x-pn-realaudio-plugin\n.ra,audio/x-realaudio\n.ram,audio/x-pn-realaudio\n.rar,application/x-rar-compressed\n.ras,application/x-cmu-raster\n.ras,image/cmu-raster\n.ras,image/x-cmu-raster\n.rast,image/cmu-raster\n.rcprofile,application/vnd.ipunplugged.rcprofile\n.rdf,application/rdf+xml\n.rdz,application/vnd.data-vision.rdz\n.rep,application/vnd.businessobjects\n.res,application/x-dtbresource+xml\n.rexx,text/x-script.rexx\n.rf,image/vnd.rn-realflash\n.rgb,image/x-rgb\n.rif,application/reginfo+xml\n.rip,audio/vnd.rip\n.rl,application/resource-lists+xml\n.rlc,image/vnd.fujixerox.edmics-rlc\n.rld,application/resource-lists-diff+xml\n.rm,application/vnd.rn-realmedia\n.rm,audio/x-pn-realaudio\n.rmi,audio/mid\n.rmm,audio/x-pn-realaudio\n.rmp,audio/x-pn-realaudio\n.rmp,audio/x-pn-realaudio-plugin\n.rms,application/vnd.jcp.javame.midlet-rms\n.rnc,application/relax-ng-compact-syntax\n.rng,application/ringing-tones\n.rng,application/vnd.nokia.ringing-tone\n.rnx,application/vnd.rn-realplayer\n.roff,application/x-troff\n.rp9,application/vnd.cloanto.rp9\n.rp,image/vnd.rn-realpix\n.rpm,audio/x-pn-realaudio-plugin\n.rpm,application/x-rpm\n.rpss,application/vnd.nokia.radio-presets\n.rpst,application/vnd.nokia.radio-preset\n.rq,application/sparql-query\n.rs,application/rls-services+xml\n.rsd,application/rsd+xml\n.rss,application/rss+xml\n.rtf,application/rtf\n.rtf,text/rtf\n.rt,text/richtext\n.rt,text/vnd.rn-realtext\n.rtx,application/rtf\n.rtx,text/richtext\n.rv,video/vnd.rn-realvideo\n.s3m,audio/s3m\n.saf,application/vnd.yamaha.smaf-audio\n.saveme,application/octet-stream\n.sbk,application/x-tbook\n.sbml,application/sbml+xml\n.sc,application/vnd.ibm.secure-container\n.scd,application/x-msschedule\n.scm,application/vnd.lotus-screencam\n.scm,application/x-lotusscreencam\n.scm,text/x-script.guile\n.scm,text/x-script.scheme\n.scm,video/x-scm\n.scq,application/scvp-cv-request\n.scs,application/scvp-cv-response\n.scurl,text/vnd.curl.scurl\n.sda,application/vnd.stardivision.draw\n.sdc,application/vnd.stardivision.calc\n.sdd,application/vnd.stardivision.impress\n.sdf,application/octet-stream\n.sdkm,application/vnd.solent.sdkm+xml\n.sdml,text/plain\n.sdp,application/sdp\n.sdp,application/x-sdp\n.sdr,application/sounder\n.sdw,application/vnd.stardivision.writer\n.sea,application/sea\n.sea,application/x-sea\n.see,application/vnd.seemail\n.seed,application/vnd.fdsn.seed\n.sema,application/vnd.sema\n.semd,application/vnd.semd\n.semf,application/vnd.semf\n.ser,application/java-serialized-object\n.set,application/set\n.setpay,application/set-payment-initiation\n.setreg,application/set-registration-initiation\n.sfd-hdstx,application/vnd.hydrostatix.sof-data\n.sfs,application/vnd.spotfire.sfs\n.sgl,application/vnd.stardivision.writer-global\n.sgml,text/sgml\n.sgml,text/x-sgml\n.sgm,text/sgml\n.sgm,text/x-sgml\n.sh,application/x-bsh\n.sh,application/x-sh\n.sh,application/x-shar\n.shar,application/x-bsh\n.shar,application/x-shar\n.shf,application/shf+xml\n.sh,text/x-script.sh\n.shtml,text/html\n.shtml,text/x-server-parsed-html\n.sid,audio/x-psid\n.sis,application/vnd.symbian.install\n.sit,application/x-sit\n.sit,application/x-stuffit\n.sitx,application/x-stuffitx\n.skd,application/x-koan\n.skm,application/x-koan\n.skp,application/vnd.koan\n.skp,application/x-koan\n.skt,application/x-koan\n.sl,application/x-seelogo\n.sldm,application/vnd.ms-powerpoint.slide.macroenabled.12\n.sldx,application/vnd.openxmlformats-officedocument.presentationml.slide\n.slt,application/vnd.epson.salt\n.sm,application/vnd.stepmania.stepchart\n.smf,application/vnd.stardivision.math\n.smi,application/smil\n.smi,application/smil+xml\n.smil,application/smil\n.snd,audio/basic\n.snd,audio/x-adpcm\n.snf,application/x-font-snf\n.sol,application/solids\n.spc,application/x-pkcs7-certificates\n.spc,text/x-speech\n.spf,application/vnd.yamaha.smaf-phrase\n.spl,application/futuresplash\n.spl,application/x-futuresplash\n.spot,text/vnd.in3d.spot\n.spp,application/scvp-vp-response\n.spq,application/scvp-vp-request\n.spr,application/x-sprite\n.sprite,application/x-sprite\n.src,application/x-wais-source\n.srt,text/srt\n.sru,application/sru+xml\n.srx,application/sparql-results+xml\n.sse,application/vnd.kodak-descriptor\n.ssf,application/vnd.epson.ssf\n.ssi,text/x-server-parsed-html\n.ssm,application/streamingmedia\n.ssml,application/ssml+xml\n.sst,application/vnd.ms-pki.certstore\n.st,application/vnd.sailingtracker.track\n.stc,application/vnd.sun.xml.calc.template\n.std,application/vnd.sun.xml.draw.template\n.step,application/step\n.s,text/x-asm\n.stf,application/vnd.wt.stf\n.sti,application/vnd.sun.xml.impress.template\n.stk,application/hyperstudio\n.stl,application/sla\n.stl,application/vnd.ms-pki.stl\n.stl,application/x-navistyle\n.stp,application/step\n.str,application/vnd.pg.format\n.stw,application/vnd.sun.xml.writer.template\n.sub,image/vnd.dvb.subtitle\n.sus,application/vnd.sus-calendar\n.sv4cpio,application/x-sv4cpio\n.sv4crc,application/x-sv4crc\n.svc,application/vnd.dvb.service\n.svd,application/vnd.svd\n.svf,image/vnd.dwg\n.svf,image/x-dwg\n.svg,image/svg+xml\n.svr,application/x-world\n.svr,x-world/x-svr\n.swf,application/x-shockwave-flash\n.swi,application/vnd.aristanetworks.swi\n.sxc,application/vnd.sun.xml.calc\n.sxd,application/vnd.sun.xml.draw\n.sxg,application/vnd.sun.xml.writer.global\n.sxi,application/vnd.sun.xml.impress\n.sxm,application/vnd.sun.xml.math\n.sxw,application/vnd.sun.xml.writer\n.talk,text/x-speech\n.tao,application/vnd.tao.intent-module-archive\n.t,application/x-troff\n.tar,application/x-tar\n.tbk,application/toolbook\n.tbk,application/x-tbook\n.tcap,application/vnd.3gpp2.tcap\n.tcl,application/x-tcl\n.tcl,text/x-script.tcl\n.tcsh,text/x-script.tcsh\n.teacher,application/vnd.smart.teacher\n.tei,application/tei+xml\n.tex,application/x-tex\n.texi,application/x-texinfo\n.texinfo,application/x-texinfo\n.text,text/plain\n.tfi,application/thraud+xml\n.tfm,application/x-tex-tfm\n.tgz,application/gnutar\n.tgz,application/x-compressed\n.thmx,application/vnd.ms-officetheme\n.tiff,image/tiff\n.tif,image/tiff\n.tmo,application/vnd.tmobile-livetv\n.torrent,application/x-bittorrent\n.tpl,application/vnd.groove-tool-template\n.tpt,application/vnd.trid.tpt\n.tra,application/vnd.trueapp\n.tr,application/x-troff\n.trm,application/x-msterminal\n.tsd,application/timestamped-data\n.tsi,audio/tsp-audio\n.tsp,application/dsptype\n.tsp,audio/tsplayer\n.tsv,text/tab-separated-values\n.t,text/troff\n.ttf,application/x-font-ttf\n.ttl,text/turtle\n.turbot,image/florian\n.twd,application/vnd.simtech-mindmapper\n.txd,application/vnd.genomatix.tuxedo\n.txf,application/vnd.mobius.txf\n.txt,text/plain\n.ufd,application/vnd.ufdl\n.uil,text/x-uil\n.umj,application/vnd.umajin\n.unis,text/uri-list\n.uni,text/uri-list\n.unityweb,application/vnd.unity\n.unv,application/i-deas\n.uoml,application/vnd.uoml+xml\n.uris,text/uri-list\n.uri,text/uri-list\n.ustar,application/x-ustar\n.ustar,multipart/x-ustar\n.utz,application/vnd.uiq.theme\n.uu,application/octet-stream\n.uue,text/x-uuencode\n.uu,text/x-uuencode\n.uva,audio/vnd.dece.audio\n.uvh,video/vnd.dece.hd\n.uvi,image/vnd.dece.graphic\n.uvm,video/vnd.dece.mobile\n.uvp,video/vnd.dece.pd\n.uvs,video/vnd.dece.sd\n.uvu,video/vnd.uvvu.mp4\n.uvv,video/vnd.dece.video\n.vcd,application/x-cdlink\n.vcf,text/x-vcard\n.vcg,application/vnd.groove-vcard\n.vcs,text/x-vcalendar\n.vcx,application/vnd.vcx\n.vda,application/vda\n.vdo,video/vdo\n.vew,application/groupwise\n.vis,application/vnd.visionary\n.vivo,video/vivo\n.vivo,video/vnd.vivo\n.viv,video/vivo\n.viv,video/vnd.vivo\n.vmd,application/vocaltec-media-desc\n.vmf,application/vocaltec-media-file\n.vob,video/dvd\n.voc,audio/voc\n.voc,audio/x-voc\n.vos,video/vosaic\n.vox,audio/voxware\n.vqe,audio/x-twinvq-plugin\n.vqf,audio/x-twinvq\n.vql,audio/x-twinvq-plugin\n.vrml,application/x-vrml\n.vrml,model/vrml\n.vrml,x-world/x-vrml\n.vrt,x-world/x-vrt\n.vsd,application/vnd.visio\n.vsd,application/x-visio\n.vsf,application/vnd.vsf\n.vst,application/x-visio\n.vsw,application/x-visio\n.vtt,text/vtt\n.vtu,model/vnd.vtu\n.vxml,application/voicexml+xml\n.w60,application/wordperfect6.0\n.w61,application/wordperfect6.1\n.w6w,application/msword\n.wad,application/x-doom\n.war,application/zip\n.wasm,application/wasm\n.wav,audio/wav\n.wax,audio/x-ms-wax\n.wb1,application/x-qpro\n.wbmp,image/vnd.wap.wbmp\n.wbs,application/vnd.criticaltools.wbs+xml\n.wbxml,application/vnd.wap.wbxml\n.weba,audio/webm\n.web,application/vnd.xara\n.webm,video/webm\n.webp,image/webp\n.wg,application/vnd.pmi.widget\n.wgt,application/widget\n.wiz,application/msword\n.wk1,application/x-123\n.wma,audio/x-ms-wma\n.wmd,application/x-ms-wmd\n.wmf,application/x-msmetafile\n.wmf,windows/metafile\n.wmlc,application/vnd.wap.wmlc\n.wmlsc,application/vnd.wap.wmlscriptc\n.wmls,text/vnd.wap.wmlscript\n.wml,text/vnd.wap.wml\n.wm,video/x-ms-wm\n.wmv,video/x-ms-wmv\n.wmx,video/x-ms-wmx\n.wmz,application/x-ms-wmz\n.woff,application/x-font-woff\n.word,application/msword\n.wp5,application/wordperfect\n.wp5,application/wordperfect6.0\n.wp6,application/wordperfect\n.wp,application/wordperfect\n.wpd,application/vnd.wordperfect\n.wpd,application/wordperfect\n.wpd,application/x-wpwin\n.wpl,application/vnd.ms-wpl\n.wps,application/vnd.ms-works\n.wq1,application/x-lotus\n.wqd,application/vnd.wqd\n.wri,application/mswrite\n.wri,application/x-mswrite\n.wri,application/x-wri\n.wrl,application/x-world\n.wrl,model/vrml\n.wrl,x-world/x-vrml\n.wrz,model/vrml\n.wrz,x-world/x-vrml\n.wsc,text/scriplet\n.wsdl,application/wsdl+xml\n.wspolicy,application/wspolicy+xml\n.wsrc,application/x-wais-source\n.wtb,application/vnd.webturbo\n.wtk,application/x-wintalk\n.wvx,video/x-ms-wvx\n.x3d,application/vnd.hzn-3d-crossword\n.xap,application/x-silverlight-app\n.xar,application/vnd.xara\n.xbap,application/x-ms-xbap\n.xbd,application/vnd.fujixerox.docuworks.binder\n.xbm,image/xbm\n.xbm,image/x-xbitmap\n.xbm,image/x-xbm\n.xdf,application/xcap-diff+xml\n.xdm,application/vnd.syncml.dm+xml\n.xdp,application/vnd.adobe.xdp+xml\n.xdr,video/x-amt-demorun\n.xdssc,application/dssc+xml\n.xdw,application/vnd.fujixerox.docuworks\n.xenc,application/xenc+xml\n.xer,application/patch-ops-error+xml\n.xfdf,application/vnd.adobe.xfdf\n.xfdl,application/vnd.xfdl\n.xgz,xgl/drawing\n.xhtml,application/xhtml+xml\n.xif,image/vnd.xiff\n.xla,application/excel\n.xla,application/x-excel\n.xla,application/x-msexcel\n.xlam,application/vnd.ms-excel.addin.macroenabled.12\n.xl,application/excel\n.xlb,application/excel\n.xlb,application/vnd.ms-excel\n.xlb,application/x-excel\n.xlc,application/excel\n.xlc,application/vnd.ms-excel\n.xlc,application/x-excel\n.xld,application/excel\n.xld,application/x-excel\n.xlk,application/excel\n.xlk,application/x-excel\n.xll,application/excel\n.xll,application/vnd.ms-excel\n.xll,application/x-excel\n.xlm,application/excel\n.xlm,application/vnd.ms-excel\n.xlm,application/x-excel\n.xls,application/excel\n.xls,application/vnd.ms-excel\n.xls,application/x-excel\n.xls,application/x-msexcel\n.xlsb,application/vnd.ms-excel.sheet.binary.macroenabled.12\n.xlsm,application/vnd.ms-excel.sheet.macroenabled.12\n.xlsx,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet\n.xlt,application/excel\n.xlt,application/x-excel\n.xltm,application/vnd.ms-excel.template.macroenabled.12\n.xltx,application/vnd.openxmlformats-officedocument.spreadsheetml.template\n.xlv,application/excel\n.xlv,application/x-excel\n.xlw,application/excel\n.xlw,application/vnd.ms-excel\n.xlw,application/x-excel\n.xlw,application/x-msexcel\n.xm,audio/xm\n.xml,application/xml\n.xml,text/xml\n.xmz,xgl/movie\n.xo,application/vnd.olpc-sugar\n.xop,application/xop+xml\n.xpi,application/x-xpinstall\n.xpix,application/x-vnd.ls-xpix\n.xpm,image/xpm\n.xpm,image/x-xpixmap\n.x-png,image/png\n.xpr,application/vnd.is-xpr\n.xps,application/vnd.ms-xpsdocument\n.xpw,application/vnd.intercon.formnet\n.xslt,application/xslt+xml\n.xsm,application/vnd.syncml+xml\n.xspf,application/xspf+xml\n.xsr,video/x-amt-showrun\n.xul,application/vnd.mozilla.xul+xml\n.xwd,image/x-xwd\n.xwd,image/x-xwindowdump\n.xyz,chemical/x-pdb\n.xyz,chemical/x-xyz\n.xz,application/x-xz\n.yaml,text/yaml\n.yang,application/yang\n.yin,application/yin+xml\n.z,application/x-compress\n.z,application/x-compressed\n.zaz,application/vnd.zzazz.deck+xml\n.zip,application/zip\n.zip,application/x-compressed\n.zip,application/x-zip-compressed\n.zip,multipart/x-zip\n.zir,application/vnd.zul\n.zmm,application/vnd.handheld-entertainment+xml\n.zoo,application/octet-stream\n.zsh,text/x-script.zsh\n';
  }
  function _no_name_provided__161() {
  }
  _no_name_provided__161.prototype.invoke_540 = function () {
    return loadMimes();
  };
  _no_name_provided__161.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__162() {
  }
  _no_name_provided__162.prototype.invoke_229 = function (it) {
    var line = toString_1(trim(isCharSequence(it) ? it : THROW_CCE()));
    if (charSequenceLength(line) === 0)
      return null;
    else {
    }
    var tmp = new Char(44);
    var index = indexOf$default(line, tmp, 0, false, 6, null);
    var tmp0_substring_0 = 0;
    var extension = line.substring(tmp0_substring_0, index);
    var tmp1_substring_0 = index + 1 | 0;
    var mime = line.substring(tmp1_substring_0);
    return to(toLowerCasePreservingASCIIRules(removePrefix(extension, '.')), toContentType(mime));
  };
  _no_name_provided__162.prototype.invoke_542 = function (p1) {
    return this.invoke_229((!(p1 == null) ? typeof p1 === 'string' : false) ? p1 : THROW_CCE());
  };
  _no_name_provided__162.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function mimes$factory() {
    return getPropertyCallableRef('mimes', 0, KProperty0, function () {
      return _get_mimes_();
    }, null);
  }
  function _no_name_provided_$factory_124() {
    var i = new _no_name_provided__161();
    return function () {
      return i.invoke_540();
    };
  }
  function _no_name_provided_$factory_125() {
    var i = new _no_name_provided__162();
    return function (p1) {
      return i.invoke_229(p1);
    };
  }
  function ParametersBuilder_init_$Init$(size_0, $mask0, $marker, $this) {
    if (!(($mask0 & 1) === 0))
      size_0 = 8;
    ParametersBuilder.call($this, size_0);
    return $this;
  }
  function ParametersBuilder_init_$Create$(size_0, $mask0, $marker) {
    return ParametersBuilder_init_$Init$(size_0, $mask0, $marker, Object.create(ParametersBuilder.prototype));
  }
  function ParametersBuilder(size_0) {
    StringValuesBuilder.call(this, true, size_0);
  }
  ParametersBuilder.prototype.build_16 = function () {
    var tmp0_require_0 = !this._get_built__1();
    if (!tmp0_require_0) {
      var message_1 = 'ParametersBuilder can only build a single Parameters instance';
      throw IllegalArgumentException_init_$Create$_0(toString_1(message_1));
    }this._set_built__1(true);
    return new ParametersImpl(this._get_values__16());
  };
  ParametersBuilder.$metadata$ = {
    simpleName: 'ParametersBuilder',
    kind: 'class',
    interfaces: []
  };
  function Companion_53() {
    Companion_instance_52 = this;
    this._Empty_3 = EmptyParameters_getInstance();
  }
  Companion_53.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_52;
  function Companion_getInstance_52() {
    if (Companion_instance_52 == null)
      new Companion_53();
    return Companion_instance_52;
  }
  function Parameters() {
  }
  Parameters.$metadata$ = {
    simpleName: 'Parameters',
    kind: 'interface',
    interfaces: [StringValues]
  };
  function ParametersImpl(values_5) {
    StringValuesImpl.call(this, true, values_5);
  }
  ParametersImpl.prototype.toString = function () {
    return '' + 'Parameters ' + this.entries_9();
  };
  ParametersImpl.$metadata$ = {
    simpleName: 'ParametersImpl',
    kind: 'class',
    interfaces: [Parameters]
  };
  function EmptyParameters() {
    EmptyParameters_instance = this;
  }
  EmptyParameters.prototype._get_caseInsensitiveName__4 = function () {
    return true;
  };
  EmptyParameters.prototype.getAll_8 = function (name) {
    return null;
  };
  EmptyParameters.prototype.entries_9 = function () {
    return emptySet();
  };
  EmptyParameters.prototype.isEmpty_53 = function () {
    return true;
  };
  EmptyParameters.prototype.toString = function () {
    return '' + 'Parameters ' + this.entries_9();
  };
  EmptyParameters.prototype.equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, Parameters) : false) {
      tmp = other.isEmpty_53();
    } else {
      {
        tmp = false;
      }
    }
    return tmp;
  };
  EmptyParameters.$metadata$ = {
    simpleName: 'EmptyParameters',
    kind: 'object',
    interfaces: [Parameters]
  };
  var EmptyParameters_instance;
  function EmptyParameters_getInstance() {
    if (EmptyParameters_instance == null)
      new EmptyParameters();
    return EmptyParameters_instance;
  }
  function parseQueryString(query, startIndex, limit) {
    var tmp;
    if (startIndex > _get_lastIndex__1(query)) {
      tmp = Companion_getInstance_52()._Empty_3;
    } else {
      var tmp0_build_0 = Companion_getInstance_52();
      var tmp0_apply_0_1 = ParametersBuilder_init_$Create$(0, 1, null);
      parse(tmp0_apply_0_1, query, startIndex, limit);
      tmp = tmp0_apply_0_1.build_16();
    }
    return tmp;
  }
  function parseQueryString$default(query, startIndex, limit, $mask0, $handler) {
    if (!(($mask0 & 2) === 0))
      startIndex = 0;
    if (!(($mask0 & 4) === 0))
      limit = 1000;
    return parseQueryString(query, startIndex, limit);
  }
  function parse(_this_, query, startIndex, limit) {
    var count_0 = 0;
    var nameIndex = startIndex;
    var equalIndex = -1;
    var inductionVariable = startIndex;
    var last_1 = _get_lastIndex__1(query);
    if (inductionVariable <= last_1)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (count_0 === limit) {
          return Unit_getInstance();
        }var tmp1_subject = charSequenceGet(query, index);
        if (tmp1_subject.equals(new Char(38))) {
          appendParam(_this_, query, nameIndex, equalIndex, index);
          nameIndex = index + 1 | 0;
          equalIndex = -1;
          var tmp2 = count_0;
          count_0 = tmp2 + 1 | 0;
          Unit_getInstance();
        } else if (tmp1_subject.equals(new Char(61))) {
          if (equalIndex === -1) {
            equalIndex = index;
          }}}
       while (!(index === last_1));
    if (count_0 === limit) {
      return Unit_getInstance();
    }appendParam(_this_, query, nameIndex, equalIndex, query.length);
  }
  function appendParam(_this_, query, nameIndex, equalIndex, endIndex) {
    if (equalIndex === -1) {
      var spaceNameIndex = trimStart_0(nameIndex, endIndex, query);
      var spaceEndIndex = trimEnd(spaceNameIndex, endIndex, query);
      if (spaceEndIndex > spaceNameIndex) {
        var name = decodeURLQueryComponent$default(query, spaceNameIndex, spaceEndIndex, false, null, 12, null);
        _this_.appendAll_3(name, emptyList());
      }} else {
      var spaceNameIndex_0 = trimStart_0(nameIndex, equalIndex, query);
      var spaceEqualIndex = trimEnd(spaceNameIndex_0, equalIndex, query);
      if (spaceEqualIndex > spaceNameIndex_0) {
        var name_0 = decodeURLQueryComponent$default(query, spaceNameIndex_0, spaceEqualIndex, false, null, 12, null);
        var spaceValueIndex = trimStart_0(equalIndex + 1 | 0, endIndex, query);
        var spaceEndIndex_0 = trimEnd(spaceValueIndex, endIndex, query);
        var value = decodeURLQueryComponent$default(query, spaceValueIndex, spaceEndIndex_0, true, null, 8, null);
        _this_.append_35(name_0, value);
      }}
  }
  function trimStart_0(start, end, query) {
    var spaceIndex = start;
    while (spaceIndex < end ? isWhitespace(charSequenceGet(query, spaceIndex)) : false) {
      var tmp0 = spaceIndex;
      spaceIndex = tmp0 + 1 | 0;
      Unit_getInstance();
    }
    return spaceIndex;
  }
  function trimEnd(start, end, text) {
    var spaceIndex = end;
    while (spaceIndex > start ? isWhitespace(charSequenceGet(text, spaceIndex - 1 | 0)) : false) {
      var tmp0 = spaceIndex;
      spaceIndex = tmp0 - 1 | 0;
      Unit_getInstance();
    }
    return spaceIndex;
  }
  function URLBuilder_init_$Init$(protocol, host, port, user, password, encodedPath, parameters, fragment, trailingQuery, $mask0, $marker, $this) {
    if (!(($mask0 & 1) === 0))
      protocol = Companion_getInstance_55()._HTTP;
    if (!(($mask0 & 2) === 0))
      host = 'localhost';
    if (!(($mask0 & 4) === 0))
      port = 0;
    if (!(($mask0 & 8) === 0))
      user = null;
    if (!(($mask0 & 16) === 0))
      password = null;
    if (!(($mask0 & 32) === 0))
      encodedPath = '/';
    if (!(($mask0 & 64) === 0)) {
      parameters = ParametersBuilder_init_$Create$(0, 1, null);
    }if (!(($mask0 & 128) === 0))
      fragment = '';
    if (!(($mask0 & 256) === 0))
      trailingQuery = false;
    URLBuilder.call($this, protocol, host, port, user, password, encodedPath, parameters, fragment, trailingQuery);
    return $this;
  }
  function URLBuilder_init_$Create$(protocol, host, port, user, password, encodedPath, parameters, fragment, trailingQuery, $mask0, $marker) {
    return URLBuilder_init_$Init$(protocol, host, port, user, password, encodedPath, parameters, fragment, trailingQuery, $mask0, $marker, Object.create(URLBuilder.prototype));
  }
  function appendTo($this, out) {
    out.append_31($this._protocol._name_9);
    Unit_getInstance();
    var tmp0_subject = $this._protocol._name_9;
    if (tmp0_subject === 'file') {
      appendFile(out, $this._host, $this._encodedPath);
      return out;
    } else if (tmp0_subject === 'mailto') {
      appendMailto(out, _get_userAndPassword_($this), $this._encodedPath);
      return out;
    }out.append_31('://');
    Unit_getInstance();
    out.append_31(_get_authority__0($this));
    Unit_getInstance();
    appendUrlFullPath(out, $this._encodedPath, $this._parameters_0, $this._trailingQuery);
    var tmp0_isNotEmpty_0 = $this._fragment;
    if (charSequenceLength(tmp0_isNotEmpty_0) > 0) {
      out.append_32(new Char(35));
      Unit_getInstance();
      var tmp = $this._fragment;
      out.append_31(encodeURLQueryComponent$default(tmp, false, false, null, 7, null));
      Unit_getInstance();
    } else {
    }
    return out;
  }
  function Companion_54() {
    Companion_instance_53 = this;
  }
  Companion_54.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_53;
  function Companion_getInstance_53() {
    if (Companion_instance_53 == null)
      new Companion_54();
    return Companion_instance_53;
  }
  function URLBuilder(protocol, host, port, user, password, encodedPath, parameters, fragment, trailingQuery) {
    Companion_getInstance_53();
    this._protocol = protocol;
    this._host = host;
    this._port = port;
    this._user = user;
    this._password = password;
    this._encodedPath = encodedPath;
    this._parameters_0 = parameters;
    this._fragment = fragment;
    this._trailingQuery = trailingQuery;
    var tmp0_safe_receiver = _get_originHost_(Companion_getInstance_53());
    if (tmp0_safe_receiver == null)
      null;
    else {
      takeFrom(this, tmp0_safe_receiver);
    }
    Unit_getInstance();
    var tmp0_isEmpty_0 = this._encodedPath;
    if (charSequenceLength(tmp0_isEmpty_0) === 0) {
      this._encodedPath = '/';
    } else {
    }
  }
  URLBuilder.prototype.buildString = function () {
    return appendTo(this, StringBuilder_init_$Create$(256)).toString();
  };
  URLBuilder.prototype.build_16 = function () {
    return new Url(this._protocol, this._host, this._port, this._encodedPath, this._parameters_0.build_16(), this._fragment, this._user, this._password, this._trailingQuery);
  };
  URLBuilder.$metadata$ = {
    simpleName: 'URLBuilder',
    kind: 'class',
    interfaces: []
  };
  function Companion_55() {
    Companion_instance_54 = this;
  }
  Companion_55.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_54;
  function Companion_getInstance_54() {
    if (Companion_instance_54 == null)
      new Companion_55();
    return Companion_instance_54;
  }
  function Url(protocol, host, specifiedPort, encodedPath, parameters, fragment, user, password, trailingQuery) {
    Companion_getInstance_54();
    this._protocol_0 = protocol;
    this._host_0 = host;
    this._specifiedPort = specifiedPort;
    this._encodedPath_0 = encodedPath;
    this._parameters_1 = parameters;
    this._fragment_0 = fragment;
    this._user_0 = user;
    this._password_0 = password;
    this._trailingQuery_0 = trailingQuery;
    var tmp;
    var containsArg = this._specifiedPort;
    if (1 <= containsArg ? containsArg <= 65536 : false) {
      tmp = true;
    } else {
      {
        tmp = this._specifiedPort === 0;
      }
    }
    var tmp0_require_0 = tmp;
    if (!tmp0_require_0) {
      var message_1 = 'port must be between 1 and 65536, or 0 if not set';
      throw IllegalArgumentException_init_$Create$_0(toString_1(message_1));
    }}
  Url.prototype._get_port_ = function () {
    var tmp0_takeUnless_0 = this._specifiedPort;
    var tmp;
    if (!(tmp0_takeUnless_0 === 0)) {
      tmp = tmp0_takeUnless_0;
    } else {
      {
        tmp = null;
      }
    }
    var tmp0_elvis_lhs = tmp;
    return tmp0_elvis_lhs == null ? this._protocol_0._defaultPort : tmp0_elvis_lhs;
  };
  Url.prototype.toString = function () {
    var tmp0_apply_0_1 = StringBuilder_init_$Create$_0();
    var tmp$ret$0;
    l$ret$1: do {
      tmp0_apply_0_1.append_7(this._protocol_0._name_9);
      Unit_getInstance();
      var tmp0_subject_3 = this._protocol_0._name_9;
      if (tmp0_subject_3 === 'file') {
        appendFile(tmp0_apply_0_1, this._host_0, this._encodedPath_0);
        tmp$ret$0 = Unit_getInstance();
        break l$ret$1;
      } else if (tmp0_subject_3 === 'mailto') {
        var tmp1_elvis_lhs_5 = this._user_0;
        var tmp;
        if (tmp1_elvis_lhs_5 == null) {
          var tmp0_error_0_6 = "User can't be empty.";
          throw IllegalStateException_init_$Create$(toString_1(tmp0_error_0_6));
        } else {
          tmp = tmp1_elvis_lhs_5;
        }
        var userValue_4 = tmp;
        appendMailto(tmp0_apply_0_1, userValue_4, this._host_0);
        tmp$ret$0 = Unit_getInstance();
        break l$ret$1;
      }tmp0_apply_0_1.append_7('://');
      Unit_getInstance();
      tmp0_apply_0_1.append_7(_get_authority_(this));
      Unit_getInstance();
      tmp0_apply_0_1.append_7(_get_fullPath_(this));
      Unit_getInstance();
      var tmp1_isNotEmpty_0_7 = this._fragment_0;
      if (charSequenceLength(tmp1_isNotEmpty_0_7) > 0) {
        tmp0_apply_0_1.append_32(new Char(35));
        Unit_getInstance();
        tmp0_apply_0_1.append_7(this._fragment_0);
        Unit_getInstance();
      } else {
      }
    }
     while (false);
    return tmp0_apply_0_1.toString();
  };
  Url.prototype.hashCode = function () {
    var result = this._protocol_0.hashCode();
    result = imul(result, 31) + getStringHashCode(this._host_0) | 0;
    result = imul(result, 31) + this._specifiedPort | 0;
    result = imul(result, 31) + getStringHashCode(this._encodedPath_0) | 0;
    result = imul(result, 31) + hashCode(this._parameters_1) | 0;
    result = imul(result, 31) + getStringHashCode(this._fragment_0) | 0;
    result = imul(result, 31) + (this._user_0 == null ? 0 : getStringHashCode(this._user_0)) | 0;
    result = imul(result, 31) + (this._password_0 == null ? 0 : getStringHashCode(this._password_0)) | 0;
    result = imul(result, 31) + (this._trailingQuery_0 | 0) | 0;
    return result;
  };
  Url.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Url))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof Url ? other : THROW_CCE();
    if (!this._protocol_0.equals(tmp0_other_with_cast._protocol_0))
      return false;
    if (!(this._host_0 === tmp0_other_with_cast._host_0))
      return false;
    if (!(this._specifiedPort === tmp0_other_with_cast._specifiedPort))
      return false;
    if (!(this._encodedPath_0 === tmp0_other_with_cast._encodedPath_0))
      return false;
    if (!equals_1(this._parameters_1, tmp0_other_with_cast._parameters_1))
      return false;
    if (!(this._fragment_0 === tmp0_other_with_cast._fragment_0))
      return false;
    if (!(this._user_0 == tmp0_other_with_cast._user_0))
      return false;
    if (!(this._password_0 == tmp0_other_with_cast._password_0))
      return false;
    if (!(this._trailingQuery_0 === tmp0_other_with_cast._trailingQuery_0))
      return false;
    return true;
  };
  Url.$metadata$ = {
    simpleName: 'Url',
    kind: 'class',
    interfaces: []
  };
  function _get_authority_(_this_) {
    var tmp0_apply_0_1 = StringBuilder_init_$Create$_0();
    tmp0_apply_0_1.append_7(_get_userAndPassword__0(_this_));
    Unit_getInstance();
    if (_this_._specifiedPort === 0) {
      tmp0_apply_0_1.append_7(_this_._host_0);
      Unit_getInstance();
    } else {
      tmp0_apply_0_1.append_7(_get_hostWithPort_(_this_));
      Unit_getInstance();
    }
    return tmp0_apply_0_1.toString();
  }
  function _get_authority__0(_this_) {
    var tmp0_apply_0_1 = StringBuilder_init_$Create$_0();
    tmp0_apply_0_1.append_7(_get_userAndPassword_(_this_));
    Unit_getInstance();
    tmp0_apply_0_1.append_7(_this_._host);
    Unit_getInstance();
    if (!(_this_._port === 0) ? !(_this_._port === _this_._protocol._defaultPort) : false) {
      tmp0_apply_0_1.append_7(':');
      Unit_getInstance();
      tmp0_apply_0_1.append_7(_this_._port.toString());
      Unit_getInstance();
    }return tmp0_apply_0_1.toString();
  }
  function appendFile(_this_, host, encodedPath) {
    _this_.append_31('://');
    Unit_getInstance();
    _this_.append_31(host);
    Unit_getInstance();
    _this_.append_31(encodedPath);
    Unit_getInstance();
  }
  function appendMailto(_this_, user, host) {
    _this_.append_31(':');
    Unit_getInstance();
    _this_.append_31(encodeURLParameter$default(user, false, 1, null));
    Unit_getInstance();
    _this_.append_32(new Char(64));
    Unit_getInstance();
    _this_.append_31(host);
    Unit_getInstance();
  }
  function _get_userAndPassword_(_this_) {
    var tmp0_apply_0_1 = StringBuilder_init_$Create$_0();
    appendUserAndPassword(tmp0_apply_0_1, _this_._user, _this_._password);
    return tmp0_apply_0_1.toString();
  }
  function _get_userAndPassword__0(_this_) {
    var tmp0_apply_0_1 = StringBuilder_init_$Create$_0();
    appendUserAndPassword(tmp0_apply_0_1, _this_._user_0, _this_._password_0);
    return tmp0_apply_0_1.toString();
  }
  function appendUserAndPassword(_this_, user, password) {
    var tmp0_elvis_lhs = user;
    if (tmp0_elvis_lhs == null)
      return Unit_getInstance();
    else
      tmp0_elvis_lhs;
    Unit_getInstance();
    _this_.append_7(encodeURLParameter$default(user, false, 1, null));
    Unit_getInstance();
    if (!(password == null)) {
      _this_.append_32(new Char(58));
      Unit_getInstance();
      _this_.append_7(encodeURLParameter$default(password, false, 1, null));
      Unit_getInstance();
    }_this_.append_7('@');
    Unit_getInstance();
  }
  function takeFrom(_this_, urlString) {
    var tmp;
    try {
      tmp = takeFromUnsafe(_this_, urlString);
    } catch ($p) {
      var tmp_0;
      if ($p instanceof Error) {
        throw new URLParserException(urlString, $p);
      } else {
        {
          throw $p;
        }
      }
      tmp = tmp_0;
    }
    return tmp;
  }
  function takeFromUnsafe(_this_, urlString) {
    var tmp$ret$0;
    l$ret$1: do {
      var inductionVariable = 0;
      var last_1 = charSequenceLength(urlString) - 1 | 0;
      if (inductionVariable <= last_1)
        do {
          var index_2 = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var tmp0__anonymous__3 = charSequenceGet(urlString, index_2);
          if (!isWhitespace(tmp0__anonymous__3)) {
            tmp$ret$0 = index_2;
            break l$ret$1;
          } else {
          }
        }
         while (inductionVariable <= last_1);
      tmp$ret$0 = -1;
    }
     while (false);
    var startIndex = tmp$ret$0;
    var tmp$ret$2;
    l$ret$3: do {
      var inductionVariable_0 = charSequenceLength(urlString) - 1 | 0;
      if (0 <= inductionVariable_0)
        do {
          var index_2_0 = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + -1 | 0;
          var tmp1__anonymous__3 = charSequenceGet(urlString, index_2_0);
          if (!isWhitespace(tmp1__anonymous__3)) {
            tmp$ret$2 = index_2_0;
            break l$ret$3;
          } else {
          }
        }
         while (0 <= inductionVariable_0);
      tmp$ret$2 = -1;
    }
     while (false);
    var endIndex = tmp$ret$2 + 1 | 0;
    var schemeLength = findScheme(urlString, startIndex, endIndex);
    if (schemeLength > 0) {
      var tmp2_substring_0 = startIndex;
      var tmp3_substring_0 = startIndex + schemeLength | 0;
      var scheme = urlString.substring(tmp2_substring_0, tmp3_substring_0);
      _this_._protocol = Companion_getInstance_55().createOrDefault(scheme);
      startIndex = startIndex + (schemeLength + 1 | 0) | 0;
    }var slashCount = count(urlString, startIndex, endIndex, new Char(47));
    startIndex = startIndex + slashCount | 0;
    if (_this_._protocol._name_9 === 'file') {
      parseFile(_this_, urlString, startIndex, endIndex, slashCount);
      return _this_;
    }if (_this_._protocol._name_9 === 'mailto') {
      var tmp4_require_0 = slashCount === 0;
      if (!tmp4_require_0) {
        var message_1_1 = 'Failed requirement.';
        throw IllegalArgumentException_init_$Create$_0(toString_1(message_1_1));
      }parseMailto(_this_, urlString, startIndex, endIndex);
      return _this_;
    }if (slashCount >= 2) {
      loop: while (true) {
        var tmp = toCharArray('@/\\?#');
        var tmp_0 = startIndex;
        var tmp5_takeIf_0 = indexOfAny$default(urlString, tmp, tmp_0, false, 4, null);
        var tmp_1;
        if (tmp5_takeIf_0 > 0) {
          tmp_1 = tmp5_takeIf_0;
        } else {
          {
            tmp_1 = null;
          }
        }
        var tmp0_elvis_lhs = tmp_1;
        var delimiter = tmp0_elvis_lhs == null ? endIndex : tmp0_elvis_lhs;
        if (delimiter < endIndex ? charSequenceGet(urlString, delimiter).equals(new Char(64)) : false) {
          var passwordIndex = indexOfColonInHostPort(urlString, startIndex, delimiter);
          if (!(passwordIndex === -1)) {
            var tmp_2 = _this_;
            var tmp6_substring_0 = startIndex;
            var tmp_3 = urlString.substring(tmp6_substring_0, passwordIndex);
            tmp_2._user = decodeURLPart$default(tmp_3, 0, 0, null, 7, null);
            var tmp_4 = _this_;
            var tmp7_substring_0 = passwordIndex + 1 | 0;
            var tmp_5 = urlString.substring(tmp7_substring_0, delimiter);
            tmp_4._password = decodeURLPart$default(tmp_5, 0, 0, null, 7, null);
          } else {
            var tmp_6 = _this_;
            var tmp8_substring_0 = startIndex;
            var tmp_7 = urlString.substring(tmp8_substring_0, delimiter);
            tmp_6._user = decodeURLPart$default(tmp_7, 0, 0, null, 7, null);
          }
          startIndex = delimiter + 1 | 0;
        } else {
          fillHost(_this_, urlString, startIndex, delimiter);
          startIndex = delimiter;
          break loop;
        }
      }
    }if (startIndex >= endIndex) {
      _this_._encodedPath = charSequenceGet(urlString, endIndex - 1 | 0).equals(new Char(47)) ? '/' : '';
      return _this_;
    }var tmp_8 = _this_;
    var tmp_9;
    if (slashCount === 0) {
      var tmp_10 = _this_._encodedPath;
      var tmp_11 = new Char(47);
      var lastSlashIndex = lastIndexOf$default_0(tmp_10, tmp_11, 0, false, 6, null);
      var tmp_12;
      if (!(lastSlashIndex === (_this_._encodedPath.length - 1 | 0))) {
        var tmp_13;
        if (!(lastSlashIndex === -1)) {
          var tmp9_substring_0 = _this_._encodedPath;
          var tmp10_substring_0 = 0;
          var tmp11_substring_0 = lastSlashIndex + 1 | 0;
          tmp_13 = tmp9_substring_0.substring(tmp10_substring_0, tmp11_substring_0);
        } else {
          tmp_13 = '/';
        }
        tmp_12 = tmp_13;
      } else {
        tmp_12 = _this_._encodedPath;
      }
      tmp_9 = tmp_12;
    } else {
      tmp_9 = '';
    }
    tmp_8._encodedPath = tmp_9;
    var tmp_14 = toCharArray('?#');
    var tmp_15 = startIndex;
    var tmp12_takeIf_0 = indexOfAny$default(urlString, tmp_14, tmp_15, false, 4, null);
    var tmp_16;
    if (tmp12_takeIf_0 > 0) {
      tmp_16 = tmp12_takeIf_0;
    } else {
      {
        tmp_16 = null;
      }
    }
    var tmp1_elvis_lhs = tmp_16;
    var pathEnd = tmp1_elvis_lhs == null ? endIndex : tmp1_elvis_lhs;
    var tmp13_substring_0 = startIndex;
    var rawPath = urlString.substring(tmp13_substring_0, pathEnd);
    var tmp2_this = _this_;
    tmp2_this._encodedPath = tmp2_this._encodedPath + encodeURLPath(rawPath);
    startIndex = pathEnd;
    if (startIndex < endIndex ? charSequenceGet(urlString, startIndex).equals(new Char(63)) : false) {
      startIndex = parseQuery(_this_, urlString, startIndex, endIndex);
    }parseFragment(_this_, urlString, startIndex, endIndex);
    return _this_;
  }
  function URLParserException(urlString, cause) {
    IllegalStateException_init_$Init$_1('' + 'Fail to parse url: ' + urlString, cause, this);
    captureStack(this, URLParserException);
  }
  URLParserException.$metadata$ = {
    simpleName: 'URLParserException',
    kind: 'class',
    interfaces: []
  };
  function findScheme(urlString, startIndex, endIndex) {
    var current = startIndex;
    var incorrectSchemePosition = -1;
    var firstChar = charSequenceGet(urlString, current);
    if (!(new Char(97) <= firstChar ? firstChar <= new Char(122) : false) ? !(new Char(65) <= firstChar ? firstChar <= new Char(90) : false) : false) {
      incorrectSchemePosition = current;
    }while (current < endIndex) {
      var char = charSequenceGet(urlString, current);
      if (char.equals(new Char(58))) {
        if (!(incorrectSchemePosition === -1)) {
          throw IllegalArgumentException_init_$Create$_0('' + 'Illegal character in scheme at position ' + incorrectSchemePosition);
        }return current - startIndex | 0;
      }if ((char.equals(new Char(47)) ? true : char.equals(new Char(63))) ? true : char.equals(new Char(35)))
        return -1;
      if ((((((incorrectSchemePosition === -1 ? !(new Char(97) <= char ? char <= new Char(122) : false) : false) ? !(new Char(65) <= char ? char <= new Char(90) : false) : false) ? !(new Char(48) <= char ? char <= new Char(57) : false) : false) ? !char.equals(new Char(46)) : false) ? !char.equals(new Char(43)) : false) ? !char.equals(new Char(45)) : false) {
        incorrectSchemePosition = current;
      }current = current + 1 | 0;
      Unit_getInstance();
    }
    return -1;
  }
  function count(urlString, startIndex, endIndex, char) {
    var result = 0;
    $l$break: while ((startIndex + result | 0) < endIndex) {
      if (!charSequenceGet(urlString, startIndex + result | 0).equals(char))
        break $l$break;
      var tmp0 = result;
      result = tmp0 + 1 | 0;
      Unit_getInstance();
    }
    return result;
  }
  function parseFile(_this_, urlString, startIndex, endIndex, slashCount) {
    var tmp0_subject = slashCount;
    switch (tmp0_subject) {
      case 2:
        var tmp = new Char(47);
        var nextSlash = indexOf$default(urlString, tmp, startIndex, false, 4, null);
        if (nextSlash === -1 ? true : nextSlash === endIndex) {
          var tmp_0 = _this_;
          tmp_0._host = urlString.substring(startIndex, endIndex);
          return Unit_getInstance();
        }
        var tmp_1 = _this_;
        tmp_1._host = urlString.substring(startIndex, nextSlash);
        var tmp_2 = _this_;
        tmp_2._encodedPath = urlString.substring(nextSlash, endIndex);
        break;
      case 3:
        _this_._host = '';
        var tmp_3 = _this_;
        tmp_3._encodedPath = '/' + urlString.substring(startIndex, endIndex);
        break;
      default:throw IllegalArgumentException_init_$Create$_0('' + 'Invalid file url: ' + urlString);
    }
  }
  function parseMailto(_this_, urlString, startIndex, endIndex) {
    var delimiter = indexOf$default_0(urlString, '@', startIndex, false, 4, null);
    if (delimiter === -1) {
      throw IllegalArgumentException_init_$Create$_0('' + 'Invalid mailto url: ' + urlString + ", it should contain '@'.");
    }var tmp = _this_;
    var tmp_0 = urlString.substring(startIndex, delimiter);
    tmp._user = decodeURLPart$default(tmp_0, 0, 0, null, 7, null);
    var tmp_1 = _this_;
    var tmp0_substring_0 = delimiter + 1 | 0;
    tmp_1._host = urlString.substring(tmp0_substring_0, endIndex);
  }
  function indexOfColonInHostPort(_this_, startIndex, endIndex) {
    var skip = false;
    var inductionVariable = startIndex;
    if (inductionVariable < endIndex)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var tmp1_subject = charSequenceGet(_this_, index);
        if (tmp1_subject.equals(new Char(91)))
          skip = true;
        else if (tmp1_subject.equals(new Char(93)))
          skip = false;
        else if (tmp1_subject.equals(new Char(58)))
          if (!skip)
            return index;
      }
       while (inductionVariable < endIndex);
    return -1;
  }
  function fillHost(_this_, urlString, startIndex, endIndex) {
    var tmp0_takeIf_0 = indexOfColonInHostPort(urlString, startIndex, endIndex);
    var tmp;
    if (tmp0_takeIf_0 > 0) {
      tmp = tmp0_takeIf_0;
    } else {
      {
        tmp = null;
      }
    }
    var tmp0_elvis_lhs = tmp;
    var colonIndex = tmp0_elvis_lhs == null ? endIndex : tmp0_elvis_lhs;
    var tmp_0 = _this_;
    tmp_0._host = urlString.substring(startIndex, colonIndex);
    if ((colonIndex + 1 | 0) < endIndex) {
      var tmp_1 = _this_;
      var tmp1_substring_0 = colonIndex + 1 | 0;
      tmp_1._port = toInt(urlString.substring(tmp1_substring_0, endIndex));
    } else {
      _this_._port = 0;
    }
  }
  function parseQuery(_this_, urlString, startIndex, endIndex) {
    if ((startIndex + 1 | 0) === endIndex) {
      _this_._trailingQuery = true;
      return endIndex;
    }var tmp = new Char(35);
    var tmp_0 = startIndex + 1 | 0;
    var tmp0_takeIf_0 = indexOf$default(urlString, tmp, tmp_0, false, 4, null);
    var tmp_1;
    if (tmp0_takeIf_0 > 0) {
      tmp_1 = tmp0_takeIf_0;
    } else {
      {
        tmp_1 = null;
      }
    }
    var tmp0_elvis_lhs = tmp_1;
    var fragmentStart = tmp0_elvis_lhs == null ? endIndex : tmp0_elvis_lhs;
    var tmp1_substring_0 = startIndex + 1 | 0;
    var tmp_2 = urlString.substring(tmp1_substring_0, fragmentStart);
    var rawParameters = parseQueryString$default(tmp_2, 0, 0, 6, null);
    rawParameters.forEach_7(_no_name_provided_$factory_126(_this_));
    return fragmentStart;
  }
  function parseFragment(_this_, urlString, startIndex, endIndex) {
    if (startIndex < endIndex ? charSequenceGet(urlString, startIndex).equals(new Char(35)) : false) {
      var tmp = _this_;
      var tmp0_substring_0 = startIndex + 1 | 0;
      tmp._fragment = urlString.substring(tmp0_substring_0, endIndex);
    }}
  function _no_name_provided__163($this_parseQuery) {
    this._$this_parseQuery = $this_parseQuery;
  }
  _no_name_provided__163.prototype.invoke_273 = function (key, values_5) {
    this._$this_parseQuery._parameters_0.appendAll_3(key, values_5);
  };
  _no_name_provided__163.prototype.invoke_537 = function (p1, p2) {
    var tmp = (!(p1 == null) ? typeof p1 === 'string' : false) ? p1 : THROW_CCE();
    this.invoke_273(tmp, (!(p2 == null) ? isInterface(p2, List) : false) ? p2 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__163.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided_$factory_126($this_parseQuery) {
    var i = new _no_name_provided__163($this_parseQuery);
    return function (p1, p2) {
      i.invoke_273(p1, p2);
      return Unit_getInstance();
    };
  }
  function Companion_56() {
    Companion_instance_55 = this;
    this._HTTP = new URLProtocol('http', 80);
    this._HTTPS = new URLProtocol('https', 443);
    this._WS = new URLProtocol('ws', 80);
    this._WSS = new URLProtocol('wss', 443);
    this._SOCKS = new URLProtocol('socks', 1080);
    var tmp = this;
    var tmp0_associateBy_0 = listOf([this._HTTP, this._HTTPS, this._WS, this._WSS, this._SOCKS]);
    var capacity_1 = coerceAtLeast(mapCapacity(collectionSizeOrDefault(tmp0_associateBy_0, 10)), 16);
    var tmp0_associateByTo_0_2 = LinkedHashMap_init_$Create$_1(capacity_1);
    var tmp0_iterator_1_3 = tmp0_associateBy_0.iterator_64();
    while (tmp0_iterator_1_3.hasNext_31()) {
      var element_2_4 = tmp0_iterator_1_3.next_35();
      tmp0_associateByTo_0_2.put_12(element_2_4._name_9, element_2_4);
      Unit_getInstance();
    }
    tmp._byName = tmp0_associateByTo_0_2;
  }
  Companion_56.prototype.createOrDefault = function (name) {
    var tmp0_let_0 = toLowerCasePreservingASCIIRules(name);
    var tmp0_elvis_lhs_2 = Companion_getInstance_55()._byName.get_63(tmp0_let_0);
    return tmp0_elvis_lhs_2 == null ? new URLProtocol(tmp0_let_0, 0) : tmp0_elvis_lhs_2;
  };
  Companion_56.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_55;
  function Companion_getInstance_55() {
    if (Companion_instance_55 == null)
      new Companion_56();
    return Companion_instance_55;
  }
  function URLProtocol(name, defaultPort) {
    Companion_getInstance_55();
    this._name_9 = name;
    this._defaultPort = defaultPort;
    var tmp$ret$0;
    l$ret$1: do {
      var tmp0_all_0 = this._name_9;
      var indexedObject = tmp0_all_0;
      var inductionVariable = 0;
      var last_1 = indexedObject.length;
      while (inductionVariable < last_1) {
        var element_2 = charSequenceGet(indexedObject, inductionVariable);
        inductionVariable = inductionVariable + 1 | 0;
        if (!isLowerCase(element_2)) {
          tmp$ret$0 = false;
          break l$ret$1;
        } else {
        }
      }
      tmp$ret$0 = true;
    }
     while (false);
    var tmp1_require_0 = tmp$ret$0;
    if (!tmp1_require_0) {
      var message_1 = 'All characters should be lower case';
      throw IllegalArgumentException_init_$Create$_0(toString_1(message_1));
    }}
  URLProtocol.prototype.toString = function () {
    return '' + 'URLProtocol(name=' + this._name_9 + ', defaultPort=' + this._defaultPort + ')';
  };
  URLProtocol.prototype.hashCode = function () {
    var result = getStringHashCode(this._name_9);
    result = imul(result, 31) + this._defaultPort | 0;
    return result;
  };
  URLProtocol.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof URLProtocol))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof URLProtocol ? other : THROW_CCE();
    if (!(this._name_9 === tmp0_other_with_cast._name_9))
      return false;
    if (!(this._defaultPort === tmp0_other_with_cast._defaultPort))
      return false;
    return true;
  };
  URLProtocol.$metadata$ = {
    simpleName: 'URLProtocol',
    kind: 'class',
    interfaces: []
  };
  function isSecure(_this_) {
    return _this_._name_9 === 'https' ? true : _this_._name_9 === 'wss';
  }
  function takeFrom_0(_this_, url_0) {
    _this_._protocol = url_0._protocol;
    _this_._host = url_0._host;
    _this_._port = url_0._port;
    _this_._encodedPath = url_0._encodedPath;
    _this_._user = url_0._user;
    _this_._password = url_0._password;
    appendAll(_this_._parameters_0, url_0._parameters_0);
    Unit_getInstance();
    _this_._fragment = url_0._fragment;
    _this_._trailingQuery = url_0._trailingQuery;
    return _this_;
  }
  function appendUrlFullPath(_this_, encodedPath, queryParameters, trailingQuery) {
    var tmp;
    if (!isBlank(encodedPath)) {
      tmp = !startsWith$default_1(encodedPath, '/', false, 2, null);
    } else {
      {
        tmp = false;
      }
    }
    if (tmp) {
      _this_.append_32(new Char(47));
      Unit_getInstance();
    } else {
    }
    _this_.append_31(encodedPath);
    Unit_getInstance();
    if (!queryParameters.isEmpty_53() ? true : trailingQuery) {
      _this_.append_31('?');
      Unit_getInstance();
    }formUrlEncodeTo(queryParameters, _this_);
  }
  function _get_fullPath_(_this_) {
    var tmp0_apply_0_1 = StringBuilder_init_$Create$_0();
    appendUrlFullPath_0(tmp0_apply_0_1, _this_._encodedPath_0, _this_._parameters_1, _this_._trailingQuery_0);
    return tmp0_apply_0_1.toString();
  }
  function _get_hostWithPort_(_this_) {
    return '' + _this_._host_0 + ':' + _this_._get_port_();
  }
  function appendUrlFullPath_0(_this_, encodedPath, queryParameters, trailingQuery) {
    var tmp;
    if (!isBlank(encodedPath)) {
      tmp = !startsWith$default_1(encodedPath, '/', false, 2, null);
    } else {
      {
        tmp = false;
      }
    }
    if (tmp) {
      _this_.append_32(new Char(47));
      Unit_getInstance();
    } else {
    }
    _this_.append_31(encodedPath);
    Unit_getInstance();
    if (!queryParameters.isEmpty_53() ? true : trailingQuery) {
      _this_.append_31('?');
      Unit_getInstance();
    }formUrlEncodeTo_0(queryParameters, _this_);
  }
  var HeaderValueEncoding_QUOTED_WHEN_REQUIRED_instance;
  var HeaderValueEncoding_QUOTED_ALWAYS_instance;
  var HeaderValueEncoding_URI_ENCODE_instance;
  var HeaderValueEncoding_entriesInitialized;
  function HeaderValueEncoding_initEntries() {
    if (HeaderValueEncoding_entriesInitialized)
      return Unit_getInstance();
    HeaderValueEncoding_entriesInitialized = true;
    HeaderValueEncoding_QUOTED_WHEN_REQUIRED_instance = new HeaderValueEncoding('QUOTED_WHEN_REQUIRED', 0);
    HeaderValueEncoding_QUOTED_ALWAYS_instance = new HeaderValueEncoding('QUOTED_ALWAYS', 1);
    HeaderValueEncoding_URI_ENCODE_instance = new HeaderValueEncoding('URI_ENCODE', 2);
  }
  function HeaderValueEncoding(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  HeaderValueEncoding.$metadata$ = {
    simpleName: 'HeaderValueEncoding',
    kind: 'class',
    interfaces: []
  };
  function HeaderValueEncoding_QUOTED_WHEN_REQUIRED_getInstance() {
    HeaderValueEncoding_initEntries();
    return HeaderValueEncoding_QUOTED_WHEN_REQUIRED_instance;
  }
  function HeaderValueEncoding_QUOTED_ALWAYS_getInstance() {
    HeaderValueEncoding_initEntries();
    return HeaderValueEncoding_QUOTED_ALWAYS_instance;
  }
  function HeaderValueEncoding_URI_ENCODE_getInstance() {
    HeaderValueEncoding_initEntries();
    return HeaderValueEncoding_URI_ENCODE_instance;
  }
  var token68Pattern;
  var authSchemePattern;
  var parameterPattern;
  var escapeRegex;
  function Parameterized_init_$Init$(authScheme, parameters, encoding, $this) {
    var tmp0_map_0 = parameters._get_entries__10();
    var tmp0_mapTo_0_1 = ArrayList_init_$Create$_0(collectionSizeOrDefault(tmp0_map_0, 10));
    var tmp0_iterator_1_2 = tmp0_map_0.iterator_64();
    while (tmp0_iterator_1_2.hasNext_31()) {
      var item_2_3 = tmp0_iterator_1_2.next_35();
      tmp0_mapTo_0_1.add_33(new HeaderValueParam(item_2_3._get_key__47(), item_2_3._get_value__33()));
      Unit_getInstance();
    }
    Parameterized.call($this, authScheme, tmp0_mapTo_0_1, encoding);
    return $this;
  }
  function Parameterized_init_$Init$_0(authScheme, parameters, encoding, $mask0, $marker, $this) {
    if (!(($mask0 & 4) === 0))
      encoding = HeaderValueEncoding_QUOTED_WHEN_REQUIRED_getInstance();
    Parameterized_init_$Init$(authScheme, parameters, encoding, $this);
    return $this;
  }
  function Parameterized_init_$Create$(authScheme, parameters, encoding, $mask0, $marker) {
    return Parameterized_init_$Init$_0(authScheme, parameters, encoding, $mask0, $marker, Object.create(Parameterized.prototype));
  }
  function encode_0(_this_, $this, encoding) {
    var tmp0_subject = encoding;
    var tmp;
    if (tmp0_subject.equals(HeaderValueEncoding_QUOTED_WHEN_REQUIRED_getInstance())) {
      tmp = escapeIfNeeded(_this_);
    } else if (tmp0_subject.equals(HeaderValueEncoding_QUOTED_ALWAYS_getInstance())) {
      tmp = quote(_this_);
    } else if (tmp0_subject.equals(HeaderValueEncoding_URI_ENCODE_getInstance())) {
      tmp = encodeURLParameter$default(_this_, false, 1, null);
    } else {
      noWhenBranchMatchedException();
    }
    return tmp;
  }
  function _no_name_provided__164(this$0, $encoding) {
    this._this$0_50 = this$0;
    this._$encoding = $encoding;
  }
  _no_name_provided__164.prototype.invoke_233 = function (it) {
    return '' + it._name_7 + '=' + encode_0(it._value_29, this._this$0_50, this._$encoding);
  };
  _no_name_provided__164.prototype.invoke_542 = function (p1) {
    return this.invoke_233(p1 instanceof HeaderValueParam ? p1 : THROW_CCE());
  };
  _no_name_provided__164.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function Single(authScheme, blob) {
    HttpAuthHeader.call(this, authScheme);
    this._blob = blob;
    var tmp0_matches_0 = this._blob;
    var tmp1_matches_0 = token68Pattern;
    if (!tmp1_matches_0.matches_0(tmp0_matches_0)) {
      var tmp = '' + 'invalid blob value: it should be token68 but it is ' + this._blob;
      throw ParseException_init_$Create$(tmp, null, 2, null);
    } else {
    }
  }
  Single.prototype.render_3 = function () {
    return '' + this._get_authScheme__1() + ' ' + this._blob;
  };
  Single.prototype.equals = function (other) {
    if (!(other instanceof Single))
      return false;
    else {
    }
    return equals_0(other._get_authScheme__1(), this._get_authScheme__1(), true) ? equals_0(other._blob, this._blob, true) : false;
  };
  Single.prototype.hashCode = function () {
    var tmp = Hash_getInstance();
    var tmp0_toLowerCase_0 = this._get_authScheme__1();
    var tmp_0 = tmp0_toLowerCase_0.toLowerCase();
    var tmp1_toLowerCase_0 = this._blob;
    return tmp.combine([tmp_0, tmp1_toLowerCase_0.toLowerCase()]);
  };
  Single.$metadata$ = {
    simpleName: 'Single',
    kind: 'class',
    interfaces: []
  };
  function Parameterized(authScheme, parameters, encoding) {
    HttpAuthHeader.call(this, authScheme);
    this._parameters_2 = parameters;
    this._encoding = encoding;
    var tmp0_forEach_0 = this._parameters_2;
    var tmp0_iterator_1 = tmp0_forEach_0.iterator_64();
    while (tmp0_iterator_1.hasNext_31()) {
      var element_2 = tmp0_iterator_1.next_35();
      var tmp0_matches_0_4 = element_2._name_7;
      var tmp1_matches_0_5 = token68Pattern;
      if (!tmp1_matches_0_5.matches_0(tmp0_matches_0_4)) {
        var tmp = '' + 'parameter name should be a token but it is ' + element_2._name_7;
        throw ParseException_init_$Create$(tmp, null, 2, null);
      } else {
      }
    }
  }
  Parameterized.prototype.render_1 = function (encoding) {
    var tmp = '' + this._get_authScheme__1() + ' ';
    return joinToString$default_0(this._parameters_2, ', ', tmp, null, 0, null, _no_name_provided_$factory_127(this, encoding), 28, null);
  };
  Parameterized.prototype.parameter_1 = function (name) {
    var tmp$ret$0;
    l$ret$1: do {
      var tmp0_firstOrNull_0 = this._parameters_2;
      var tmp0_iterator_1 = tmp0_firstOrNull_0.iterator_64();
      while (tmp0_iterator_1.hasNext_31()) {
        var element_2 = tmp0_iterator_1.next_35();
        if (element_2._name_7 === name) {
          tmp$ret$0 = element_2;
          break l$ret$1;
        } else {
        }
      }
      tmp$ret$0 = null;
    }
     while (false);
    var tmp0_safe_receiver = tmp$ret$0;
    return tmp0_safe_receiver == null ? null : tmp0_safe_receiver._value_29;
  };
  Parameterized.prototype.render_3 = function () {
    return this.render_1(this._encoding);
  };
  Parameterized.prototype.equals = function (other) {
    if (!(other instanceof Parameterized))
      return false;
    else {
    }
    return equals_0(other._get_authScheme__1(), this._get_authScheme__1(), true) ? equals_1(other._parameters_2, this._parameters_2) : false;
  };
  Parameterized.prototype.hashCode = function () {
    var tmp = Hash_getInstance();
    var tmp0_toLowerCase_0 = this._get_authScheme__1();
    return tmp.combine([tmp0_toLowerCase_0.toLowerCase(), this._parameters_2]);
  };
  Parameterized.$metadata$ = {
    simpleName: 'Parameterized',
    kind: 'class',
    interfaces: []
  };
  function Companion_57() {
    Companion_instance_56 = this;
  }
  Companion_57.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_56;
  function Companion_getInstance_56() {
    if (Companion_instance_56 == null)
      new Companion_57();
    return Companion_instance_56;
  }
  function HttpAuthHeader(authScheme) {
    Companion_getInstance_56();
    this._authScheme = authScheme;
    var tmp0_matches_0 = this._authScheme;
    var tmp1_matches_0 = token68Pattern;
    if (!tmp1_matches_0.matches_0(tmp0_matches_0)) {
      var tmp = '' + 'invalid authScheme value: it should be token but it is ' + this._authScheme;
      throw ParseException_init_$Create$(tmp, null, 2, null);
    } else {
    }
  }
  HttpAuthHeader.prototype._get_authScheme__1 = function () {
    return this._authScheme;
  };
  HttpAuthHeader.prototype.toString = function () {
    return this.render_3();
  };
  HttpAuthHeader.$metadata$ = {
    simpleName: 'HttpAuthHeader',
    kind: 'class',
    interfaces: []
  };
  function parseAuthorizationHeader(headerValue) {
    var tmp0_elvis_lhs = authSchemePattern.find$default(headerValue, 0, 2, null);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return null;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var schemeRegion = tmp;
    var authScheme = schemeRegion._get_value__33();
    var tmp0_trimStart_0 = substringAfterMatch(headerValue, schemeRegion);
    var remaining = toString_1(trimStart(isCharSequence(tmp0_trimStart_0) ? tmp0_trimStart_0 : THROW_CCE()));
    var token68 = token68Pattern.find$default(remaining, 0, 2, null);
    if (!(token68 == null) ? isBlank(substringAfterMatch(remaining, token68)) : false) {
      return new Single(authScheme, token68._get_value__33());
    }var tmp1_associateBy_0 = parameterPattern.findAll$default(remaining, 0, 2, null);
    var tmp0_associateByTo_0_1 = LinkedHashMap_init_$Create$();
    var tmp0_iterator_1_2 = tmp1_associateBy_0.iterator_64();
    while (tmp0_iterator_1_2.hasNext_31()) {
      var element_2_3 = tmp0_iterator_1_2.next_35();
      var tmp_0 = ensureNotNull(element_2_3._get_groups__0().get_80(1))._value_1;
      tmp0_associateByTo_0_1.put_12(tmp_0, unescapedIfQuoted(ensureNotNull(element_2_3._get_groups__0().get_80(2))._value_1));
      Unit_getInstance();
    }
    var parameters = tmp0_associateByTo_0_1;
    return Parameterized_init_$Create$(authScheme, parameters, null, 4, null);
  }
  function substringAfterMatch(_this_, result) {
    return drop(_this_, result._get_range__0()._get_last__2() + (result._get_range__0().isEmpty_53() ? 0 : 1) | 0);
  }
  function unescapedIfQuoted(_this_) {
    var tmp;
    var tmp_0;
    var tmp_1 = new Char(34);
    if (startsWith$default(_this_, tmp_1, false, 2, null)) {
      var tmp_2 = new Char(34);
      tmp_0 = endsWith$default(_this_, tmp_2, false, 2, null);
    } else {
      {
        tmp_0 = false;
      }
    }
    if (tmp_0) {
      var tmp0_replace_0 = removeSurrounding(_this_, '"');
      var tmp1_replace_0 = escapeRegex;
      var tmp2_replace_0 = _no_name_provided_$factory_128();
      var tmp$ret$0;
      l$ret$1: do {
        var match_1_1 = tmp1_replace_0.find$default(tmp0_replace_0, 0, 2, null);
        if (match_1_1 == null) {
          tmp$ret$0 = toString_1(tmp0_replace_0);
          break l$ret$1;
        }var lastStart_2_2 = 0;
        var length_3_3 = charSequenceLength(tmp0_replace_0);
        var sb_4_4 = StringBuilder_init_$Create$(length_3_3);
        do {
          var foundMatch_5_5 = ensureNotNull(match_1_1);
          sb_4_4.append_30(tmp0_replace_0, lastStart_2_2, foundMatch_5_5._get_range__0()._get_start__1());
          Unit_getInstance();
          sb_4_4.append_31(tmp2_replace_0(foundMatch_5_5));
          Unit_getInstance();
          lastStart_2_2 = foundMatch_5_5._get_range__0()._get_endInclusive__1() + 1 | 0;
          match_1_1 = foundMatch_5_5.next_35();
        }
         while (lastStart_2_2 < length_3_3 ? !(match_1_1 == null) : false);
        if (lastStart_2_2 < length_3_3) {
          sb_4_4.append_30(tmp0_replace_0, lastStart_2_2, length_3_3);
          Unit_getInstance();
        }tmp$ret$0 = sb_4_4.toString();
      }
       while (false);
      tmp = tmp$ret$0;
    } else {
      {
        tmp = _this_;
      }
    }
    return tmp;
  }
  function _no_name_provided__165() {
  }
  _no_name_provided__165.prototype.invoke_235 = function (it) {
    return takeLast(it._get_value__33(), 1);
  };
  _no_name_provided__165.prototype.invoke_542 = function (p1) {
    return this.invoke_235((!(p1 == null) ? isInterface(p1, MatchResult) : false) ? p1 : THROW_CCE());
  };
  _no_name_provided__165.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided_$factory_127(this$0, $encoding) {
    var i = new _no_name_provided__164(this$0, $encoding);
    return function (p1) {
      return i.invoke_233(p1);
    };
  }
  function _no_name_provided_$factory_128() {
    var i = new _no_name_provided__165();
    return function (p1) {
      return i.invoke_235(p1);
    };
  }
  function token68Pattern$init$() {
    var tmp0_toRegex_0 = '[a-zA-Z0-9\\-._~+/]+=*';
    return Regex_init_$Create$_0(tmp0_toRegex_0);
  }
  function authSchemePattern$init$() {
    var tmp0_toRegex_0 = '\\S+';
    return Regex_init_$Create$_0(tmp0_toRegex_0);
  }
  function parameterPattern$init$() {
    var tmp0_toRegex_0 = '' + '\\s*,?\\s*(' + token68Pattern + ')\\s*=\\s*(("((\\\\.)|[^\\\\"])*")|[^\\s,]*)\\s*,?\\s*';
    return Regex_init_$Create$_0(tmp0_toRegex_0);
  }
  function escapeRegex$init$() {
    var tmp0_toRegex_0 = '\\\\.';
    return Regex_init_$Create$_0(tmp0_toRegex_0);
  }
  var CachingProperty;
  function NoContent() {
    OutgoingContent.call(this);
  }
  NoContent.$metadata$ = {
    simpleName: 'NoContent',
    kind: 'class',
    interfaces: []
  };
  function ReadChannelContent() {
    OutgoingContent.call(this);
  }
  ReadChannelContent.$metadata$ = {
    simpleName: 'ReadChannelContent',
    kind: 'class',
    interfaces: []
  };
  function WriteChannelContent() {
  }
  WriteChannelContent.$metadata$ = {
    simpleName: 'WriteChannelContent',
    kind: 'class',
    interfaces: []
  };
  function ByteArrayContent() {
    OutgoingContent.call(this);
  }
  ByteArrayContent.$metadata$ = {
    simpleName: 'ByteArrayContent',
    kind: 'class',
    interfaces: []
  };
  function OutgoingContent() {
    this._extensionProperties = null;
  }
  OutgoingContent.prototype._get_contentType__6 = function () {
    return null;
  };
  OutgoingContent.prototype._get_contentLength__6 = function () {
    return null;
  };
  OutgoingContent.prototype._get_headers__15 = function () {
    return Companion_getInstance_48()._Empty_2;
  };
  OutgoingContent.$metadata$ = {
    simpleName: 'OutgoingContent',
    kind: 'class',
    interfaces: []
  };
  function TextContent_init_$Init$(text, contentType_2, status, $mask0, $marker, $this) {
    if (!(($mask0 & 4) === 0))
      status = null;
    TextContent.call($this, text, contentType_2, status);
    return $this;
  }
  function TextContent_init_$Create$(text, contentType_2, status, $mask0, $marker) {
    return TextContent_init_$Init$(text, contentType_2, status, $mask0, $marker, Object.create(TextContent.prototype));
  }
  function TextContent(text, contentType_2, status) {
    ByteArrayContent.call(this);
    this._text = text;
    this._contentType_0 = contentType_2;
    this._status = status;
    var tmp = this;
    var tmp0_toByteArray_0 = this._text;
    var tmp0_elvis_lhs = charset(this._contentType_0);
    var tmp1_toByteArray_0 = tmp0_elvis_lhs == null ? Charsets_getInstance()._UTF_8 : tmp0_elvis_lhs;
    tmp._bytes = encodeToByteArray(tmp1_toByteArray_0.newEncoder_0(), tmp0_toByteArray_0, 0, tmp0_toByteArray_0.length);
  }
  TextContent.prototype._get_contentType__6 = function () {
    return this._contentType_0;
  };
  TextContent.prototype._get_contentLength__6 = function () {
    return toLong_0(this._bytes.length);
  };
  TextContent.prototype.bytes_1 = function () {
    return this._bytes;
  };
  TextContent.prototype.toString = function () {
    return '' + 'TextContent[' + this._contentType_0 + '] "' + take(this._text, 30) + '"';
  };
  TextContent.$metadata$ = {
    simpleName: 'TextContent',
    kind: 'class',
    interfaces: []
  };
  function ParseException_init_$Init$(message, cause, $mask0, $marker, $this) {
    if (!(($mask0 & 2) === 0))
      cause = null;
    ParseException.call($this, message, cause);
    return $this;
  }
  function ParseException_init_$Create$(message, cause, $mask0, $marker) {
    var tmp = ParseException_init_$Init$(message, cause, $mask0, $marker, Object.create(ParseException.prototype));
    captureStack(tmp, ParseException_init_$Create$);
    return tmp;
  }
  function ParseException(message, cause) {
    IllegalArgumentException_init_$Init$_1(message, cause, this);
    this._message = message;
    this._cause_0 = cause;
    captureStack(this, ParseException);
  }
  ParseException.prototype._get_message__52 = function () {
    return this._message;
  };
  ParseException.prototype._get_cause__54 = function () {
    return this._cause_0;
  };
  ParseException.$metadata$ = {
    simpleName: 'ParseException',
    kind: 'class',
    interfaces: []
  };
  Object.defineProperty(ParseException.prototype, 'message', {
    configurable: true,
    get: ParseException.prototype._get_message__52
  });
  Object.defineProperty(ParseException.prototype, 'cause', {
    configurable: true,
    get: ParseException.prototype._get_cause__54
  });
  function Parser() {
  }
  Parser.$metadata$ = {
    simpleName: 'Parser',
    kind: 'interface',
    interfaces: []
  };
  function Grammar() {
  }
  Grammar.$metadata$ = {
    simpleName: 'Grammar',
    kind: 'class',
    interfaces: []
  };
  function then(_this_, grammar) {
    return new SequenceGrammar(listOf([_this_, grammar]));
  }
  function then_0(_this_, value) {
    return then(_this_, new StringGrammar(value));
  }
  function then_1(_this_, grammar) {
    return then(new StringGrammar(_this_), grammar);
  }
  function atLeastOne(grammar) {
    return new AtLeastOne(grammar);
  }
  function or(_this_, value) {
    return or_0(_this_, new StringGrammar(value));
  }
  function or_0(_this_, grammar) {
    return new OrGrammar(listOf([_this_, grammar]));
  }
  function SequenceGrammar(sourceGrammars) {
    Grammar.call(this);
    var tmp = this;
    var result_1 = ArrayList_init_$Create$();
    var tmp0_iterator_1 = sourceGrammars.iterator_64();
    while (tmp0_iterator_1.hasNext_31()) {
      var element_2 = tmp0_iterator_1.next_35();
      if (element_2 instanceof SequenceGrammar) {
        var tmp0_plusAssign_0_4 = element_2._get_grammars__1();
        addAll(result_1, tmp0_plusAssign_0_4);
        Unit_getInstance();
      } else {
        {
          result_1.add_33(element_2);
          Unit_getInstance();
        }
      }
    }
    tmp._grammars = result_1;
  }
  SequenceGrammar.prototype._get_grammars__1 = function () {
    return this._grammars;
  };
  SequenceGrammar.$metadata$ = {
    simpleName: 'SequenceGrammar',
    kind: 'class',
    interfaces: [ComplexGrammar]
  };
  function StringGrammar(value) {
    Grammar.call(this);
    this._value_33 = value;
  }
  StringGrammar.$metadata$ = {
    simpleName: 'StringGrammar',
    kind: 'class',
    interfaces: []
  };
  function AtLeastOne(grammar) {
    Grammar.call(this);
    this._grammar = grammar;
  }
  AtLeastOne.prototype._get_grammar__0 = function () {
    return this._grammar;
  };
  AtLeastOne.$metadata$ = {
    simpleName: 'AtLeastOne',
    kind: 'class',
    interfaces: [SimpleGrammar]
  };
  function OrGrammar(sourceGrammars) {
    Grammar.call(this);
    var tmp = this;
    var result_1 = ArrayList_init_$Create$();
    var tmp0_iterator_1 = sourceGrammars.iterator_64();
    while (tmp0_iterator_1.hasNext_31()) {
      var element_2 = tmp0_iterator_1.next_35();
      if (element_2 instanceof OrGrammar) {
        var tmp0_plusAssign_0_4 = element_2._get_grammars__1();
        addAll(result_1, tmp0_plusAssign_0_4);
        Unit_getInstance();
      } else {
        {
          result_1.add_33(element_2);
          Unit_getInstance();
        }
      }
    }
    tmp._grammars_0 = result_1;
  }
  OrGrammar.prototype._get_grammars__1 = function () {
    return this._grammars_0;
  };
  OrGrammar.$metadata$ = {
    simpleName: 'OrGrammar',
    kind: 'class',
    interfaces: [ComplexGrammar]
  };
  function ComplexGrammar() {
  }
  ComplexGrammar.$metadata$ = {
    simpleName: 'ComplexGrammar',
    kind: 'interface',
    interfaces: []
  };
  function SimpleGrammar() {
  }
  SimpleGrammar.$metadata$ = {
    simpleName: 'SimpleGrammar',
    kind: 'interface',
    interfaces: []
  };
  function RawGrammar(value) {
    Grammar.call(this);
    this._value_34 = value;
  }
  RawGrammar.$metadata$ = {
    simpleName: 'RawGrammar',
    kind: 'class',
    interfaces: []
  };
  function to_0(_this_, other) {
    return new RangeGrammar(_this_, other);
  }
  function NamedGrammar() {
  }
  NamedGrammar.$metadata$ = {
    simpleName: 'NamedGrammar',
    kind: 'class',
    interfaces: []
  };
  function MaybeGrammar() {
  }
  MaybeGrammar.$metadata$ = {
    simpleName: 'MaybeGrammar',
    kind: 'class',
    interfaces: [SimpleGrammar]
  };
  function ManyGrammar() {
  }
  ManyGrammar.$metadata$ = {
    simpleName: 'ManyGrammar',
    kind: 'class',
    interfaces: [SimpleGrammar]
  };
  function AnyOfGrammar() {
  }
  AnyOfGrammar.$metadata$ = {
    simpleName: 'AnyOfGrammar',
    kind: 'class',
    interfaces: []
  };
  function RangeGrammar(from, to_1) {
    Grammar.call(this);
    this._from = from;
    this._to = to_1;
  }
  RangeGrammar.$metadata$ = {
    simpleName: 'RangeGrammar',
    kind: 'class',
    interfaces: []
  };
  function _get_digits_() {
    return atLeastOne(_get_digit_());
  }
  function _get_hex_() {
    return or_0(or_0(_get_digit_(), to_0(new Char(65), new Char(70))), to_0(new Char(97), new Char(102)));
  }
  function _get_digit_() {
    return new RawGrammar('\\d');
  }
  function RegexParser(expression, indexes) {
    this._expression = expression;
    this._indexes = indexes;
  }
  RegexParser.$metadata$ = {
    simpleName: 'RegexParser',
    kind: 'class',
    interfaces: [Parser]
  };
  function buildRegexParser(_this_) {
    var groups = LinkedHashMap_init_$Create$();
    var expression = toRegex$default(_this_, groups, 0, false, 6, null)._regex;
    return new RegexParser(Regex_init_$Create$_0(expression), groups);
  }
  function GrammarRegex_init_$Init$(regexRaw, groupsCountRaw, group, $mask0, $marker, $this) {
    if (!(($mask0 & 2) === 0))
      groupsCountRaw = 0;
    if (!(($mask0 & 4) === 0))
      group = false;
    GrammarRegex.call($this, regexRaw, groupsCountRaw, group);
    return $this;
  }
  function GrammarRegex_init_$Create$(regexRaw, groupsCountRaw, group, $mask0, $marker) {
    return GrammarRegex_init_$Init$(regexRaw, groupsCountRaw, group, $mask0, $marker, Object.create(GrammarRegex.prototype));
  }
  function GrammarRegex(regexRaw, groupsCountRaw, group) {
    this._regex = group ? '' + '(' + regexRaw + ')' : regexRaw;
    this._groupsCount = group ? groupsCountRaw + 1 | 0 : groupsCountRaw;
  }
  GrammarRegex.$metadata$ = {
    simpleName: 'GrammarRegex',
    kind: 'class',
    interfaces: []
  };
  function toRegex(_this_, groups, offset, shouldGroup) {
    var tmp0_subject = _this_;
    var tmp;
    if (tmp0_subject instanceof StringGrammar) {
      var tmp_0 = Companion_getInstance_12().escape(_this_._value_33);
      tmp = GrammarRegex_init_$Create$(tmp_0, 0, false, 6, null);
    } else {
      if (tmp0_subject instanceof RawGrammar) {
        var tmp_1 = _this_._value_34;
        tmp = GrammarRegex_init_$Create$(tmp_1, 0, false, 6, null);
      } else {
        if (tmp0_subject instanceof NamedGrammar) {
          var tmp_2 = _this_._grammar_0;
          var tmp_3 = offset + 1 | 0;
          var nested = toRegex$default(tmp_2, groups, tmp_3, false, 4, null);
          add_1(groups, _this_._name_10, offset);
          tmp = new GrammarRegex(nested._regex, nested._groupsCount, true);
        } else {
          if (isInterface(tmp0_subject, ComplexGrammar)) {
            var expression = StringBuilder_init_$Create$_0();
            var currentOffset = shouldGroup ? offset + 1 | 0 : offset;
            var tmp0_forEachIndexed_0 = _this_._get_grammars__1();
            var index_1 = 0;
            var tmp0_iterator_2 = tmp0_forEachIndexed_0.iterator_64();
            while (tmp0_iterator_2.hasNext_31()) {
              var item_3 = tmp0_iterator_2.next_35();
              var tmp1_4 = index_1;
              index_1 = tmp1_4 + 1 | 0;
              var tmp1__anonymous__5 = checkIndexOverflow(tmp1_4);
              var current_6 = toRegex(item_3, groups, currentOffset, true);
              var tmp_4;
              if (!(tmp1__anonymous__5 === 0)) {
                tmp_4 = _this_ instanceof OrGrammar;
              } else {
                tmp_4 = false;
              }
              if (tmp_4) {
                expression.append_7('|');
                Unit_getInstance();
              } else {
              }
              expression.append_7(current_6._regex);
              Unit_getInstance();
              currentOffset = currentOffset + current_6._groupsCount | 0;
            }
            var groupsCount = shouldGroup ? (currentOffset - offset | 0) - 1 | 0 : currentOffset - offset | 0;
            tmp = new GrammarRegex(expression.toString(), groupsCount, shouldGroup);
          } else {
            if (isInterface(tmp0_subject, SimpleGrammar)) {
              var tmp1_subject = _this_;
              var tmp_5;
              if (tmp1_subject instanceof MaybeGrammar) {
                tmp_5 = new Char(63);
              } else {
                if (tmp1_subject instanceof ManyGrammar) {
                  tmp_5 = new Char(42);
                } else {
                  if (tmp1_subject instanceof AtLeastOne) {
                    tmp_5 = new Char(43);
                  } else {
                    {
                      var tmp2_error_0 = '' + 'Unsupported simple grammar element: ' + _this_;
                      throw IllegalStateException_init_$Create$(toString_1(tmp2_error_0));
                    }
                  }
                }
              }
              var operator = tmp_5;
              var nested_0 = toRegex(_this_._get_grammar__0(), groups, offset, true);
              var tmp_6 = '' + nested_0._regex + operator;
              tmp = GrammarRegex_init_$Create$(tmp_6, nested_0._groupsCount, false, 4, null);
            } else {
              if (tmp0_subject instanceof AnyOfGrammar) {
                var tmp_7 = '' + '[' + Companion_getInstance_12().escape(_this_._value_35) + ']';
                tmp = GrammarRegex_init_$Create$(tmp_7, 0, false, 6, null);
              } else {
                if (tmp0_subject instanceof RangeGrammar) {
                  var tmp_8 = '' + '[' + _this_._from + '-' + _this_._to + ']';
                  tmp = GrammarRegex_init_$Create$(tmp_8, 0, false, 6, null);
                } else {
                  {
                    var tmp3_error_0 = '' + 'Unsupported grammar element: ' + _this_;
                    throw IllegalStateException_init_$Create$(toString_1(tmp3_error_0));
                  }
                }
              }
            }
          }
        }
      }
    }
    return tmp;
  }
  function toRegex$default(_this_, groups, offset, shouldGroup, $mask0, $handler) {
    if (!(($mask0 & 2) === 0))
      offset = 1;
    if (!(($mask0 & 4) === 0))
      shouldGroup = false;
    return toRegex(_this_, groups, offset, shouldGroup);
  }
  function add_1(_this_, key, value) {
    if (!(isInterface(_this_, Map_0) ? _this_ : THROW_CCE()).containsKey_16(key)) {
      var tmp0_set_0 = ArrayList_init_$Create$();
      _this_.put_12(key, tmp0_set_0);
      Unit_getInstance();
    } else {
    }
    var tmp1_plusAssign_0 = ensureNotNull(_this_.get_63(key));
    tmp1_plusAssign_0.add_33(value);
    Unit_getInstance();
  }
  function _get_originHost_(_this_) {
    var tmp;
    if (PlatformUtils_getInstance()._IS_BROWSER) {
      tmp = window.location.origin;
    } else {
      tmp = null;
    }
    return tmp;
  }
  var ChunkSizeBufferPool;
  var CrLf;
  var LastChunkBytes;
  function _no_name_provided__166() {
    DefaultPool.call(this, 2048);
  }
  _no_name_provided__166.prototype.produceInstance_4 = function () {
    return StringBuilder_init_$Create$(128);
  };
  _no_name_provided__166.prototype.clearInstance_4 = function (instance) {
    instance.clear_15();
    Unit_getInstance();
    return instance;
  };
  _no_name_provided__166.prototype.clearInstance_5 = function (instance) {
    return this.clearInstance_4(instance instanceof StringBuilder ? instance : THROW_CCE());
  };
  _no_name_provided__166.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function ChunkSizeBufferPool$init$() {
    return new _no_name_provided__166();
  }
  function CrLf$init$() {
    var tmp0_toByteArray_0 = '\r\n';
    var tmp1_toByteArray_0 = Charsets_getInstance()._UTF_8;
    return encodeToByteArray(tmp1_toByteArray_0.newEncoder_0(), tmp0_toByteArray_0, 0, tmp0_toByteArray_0.length);
  }
  function LastChunkBytes$init$() {
    var tmp0_toByteArray_0 = '0\r\n\r\n';
    var tmp1_toByteArray_0 = Charsets_getInstance()._UTF_8;
    return encodeToByteArray(tmp1_toByteArray_0.newEncoder_0(), tmp0_toByteArray_0, 0, tmp0_toByteArray_0.length);
  }
  var EMPTY_INT_ARRAY;
  var IntArrayPool;
  function _no_name_provided__167() {
    DefaultPool.call(this, 1000);
  }
  _no_name_provided__167.prototype.produceInstance_4 = function () {
    return new Int32Array(512);
  };
  _no_name_provided__167.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function IntArrayPool$init$() {
    return new _no_name_provided__167();
  }
  var versions;
  function build($this, resultList, from, maxLength, idx, length, charAt) {
    var tmp0_groupByTo_0_1 = LinkedHashMap_init_$Create$();
    var tmp0_iterator_1_2 = from.iterator_64();
    while (tmp0_iterator_1_2.hasNext_31()) {
      var element_2_3 = tmp0_iterator_1_2.next_35();
      var key_3_4 = charAt(element_2_3, idx);
      var value_1_6 = tmp0_groupByTo_0_1.get_63(key_3_4);
      var tmp;
      if (value_1_6 == null) {
        var answer_2_7 = ArrayList_init_$Create$();
        tmp0_groupByTo_0_1.put_12(key_3_4, answer_2_7);
        Unit_getInstance();
        tmp = answer_2_7;
      } else {
        tmp = value_1_6;
      }
      var list_4_5 = tmp;
      list_4_5.add_33(element_2_3);
      Unit_getInstance();
    }
    var tmp0_forEach_0 = tmp0_groupByTo_0_1;
    var tmp0_iterator_1 = tmp0_forEach_0._get_entries__10().iterator_64();
    while (tmp0_iterator_1.hasNext_31()) {
      var element_2 = tmp0_iterator_1.next_35();
      var ch_4 = element_2._get_key__47();
      var list_5 = element_2._get_value__33();
      var nextIdx_6 = idx + 1 | 0;
      var children_7 = ArrayList_init_$Create$();
      var tmp_0 = Companion_getInstance_57();
      var tmp0_filterTo_0_1_8 = ArrayList_init_$Create$();
      var tmp0_iterator_1_2_9 = list_5.iterator_64();
      while (tmp0_iterator_1_2_9.hasNext_31()) {
        var element_2_3_10 = tmp0_iterator_1_2_9.next_35();
        if (length(element_2_3_10) > nextIdx_6) {
          tmp0_filterTo_0_1_8.add_33(element_2_3_10);
          Unit_getInstance();
        } else {
        }
      }
      build(tmp_0, children_7, tmp0_filterTo_0_1_8, maxLength, nextIdx_6, length, charAt);
      children_7.trimToSize();
      var tmp0_filterTo_0_1_11 = ArrayList_init_$Create$();
      var tmp0_iterator_1_2_12 = list_5.iterator_64();
      while (tmp0_iterator_1_2_12.hasNext_31()) {
        var element_2_3_13 = tmp0_iterator_1_2_12.next_35();
        if (length(element_2_3_13) === nextIdx_6) {
          tmp0_filterTo_0_1_11.add_33(element_2_3_13);
          Unit_getInstance();
        } else {
        }
      }
      resultList.add_33(new Node_0(ch_4, tmp0_filterTo_0_1_11, children_7));
      Unit_getInstance();
    }
  }
  function _no_name_provided__168() {
  }
  _no_name_provided__168.prototype.invoke_237 = function (it) {
    return charSequenceLength(it);
  };
  _no_name_provided__168.prototype.invoke_542 = function (p1) {
    return this.invoke_237((!(p1 == null) ? isCharSequence(p1) : false) ? p1 : THROW_CCE());
  };
  _no_name_provided__168.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__169() {
  }
  _no_name_provided__169.prototype.invoke_239 = function (s, idx) {
    return charSequenceGet(s, idx);
  };
  _no_name_provided__169.prototype.invoke_537 = function (p1, p2) {
    var tmp = (!(p1 == null) ? isCharSequence(p1) : false) ? p1 : THROW_CCE();
    return this.invoke_239(tmp, (!(p2 == null) ? typeof p2 === 'number' : false) ? p2 : THROW_CCE());
  };
  _no_name_provided__169.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function Node_0(ch, exact, children) {
    this._ch = ch;
    this._exact = exact;
    this._children = children;
    var tmp = this;
    var tmp_0 = 0;
    var tmp_1 = 256;
    var tmp_2 = fillArrayVal(Array(tmp_1), null);
    while (tmp_0 < tmp_1) {
      var tmp_3 = tmp_0;
      var tmp$ret$0;
      l$ret$1: do {
        var tmp0_singleOrNull_0 = this._children;
        var single_1_0 = null;
        var found_2 = false;
        var tmp0_iterator_3 = tmp0_singleOrNull_0.iterator_64();
        while (tmp0_iterator_3.hasNext_31()) {
          var element_4 = tmp0_iterator_3.next_35();
          if (element_4._ch.toInt_5() === tmp_3) {
            if (found_2) {
              tmp$ret$0 = null;
              break l$ret$1;
            }single_1_0 = element_4;
            found_2 = true;
          } else {
          }
        }
        if (!found_2) {
          tmp$ret$0 = null;
          break l$ret$1;
        }tmp$ret$0 = single_1_0;
      }
       while (false);
      tmp_2[tmp_3] = tmp$ret$0;
      tmp_0 = tmp_0 + 1 | 0;
    }
    tmp._array_1 = tmp_2;
  }
  Node_0.$metadata$ = {
    simpleName: 'Node',
    kind: 'class',
    interfaces: []
  };
  function Companion_58() {
    Companion_instance_57 = this;
  }
  Companion_58.prototype.build_13 = function (from) {
    var tmp = _no_name_provided_$factory_129();
    return this.build_14(from, tmp, _no_name_provided_$factory_130());
  };
  Companion_58.prototype.build_14 = function (from, length, charAt) {
    var tmp$ret$0;
    l$ret$1: do {
      var iterator_1_1 = from.iterator_64();
      if (!iterator_1_1.hasNext_31()) {
        tmp$ret$0 = null;
        break l$ret$1;
      }var maxElem_2_2 = iterator_1_1.next_35();
      if (!iterator_1_1.hasNext_31()) {
        tmp$ret$0 = maxElem_2_2;
        break l$ret$1;
      }var maxValue_3_3 = length(maxElem_2_2);
      do {
        var e_4_4 = iterator_1_1.next_35();
        var v_5_5 = length(e_4_4);
        if (compareTo(maxValue_3_3, v_5_5) < 0) {
          maxElem_2_2 = e_4_4;
          maxValue_3_3 = v_5_5;
        }}
       while (iterator_1_1.hasNext_31());
      tmp$ret$0 = maxElem_2_2;
    }
     while (false);
    var tmp0_safe_receiver = tmp$ret$0;
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      tmp = length(tmp0_safe_receiver);
    }
    var tmp1_elvis_lhs = tmp;
    var tmp_0;
    if (tmp1_elvis_lhs == null) {
      throw NoSuchElementException_init_$Create$_0('Unable to build char tree from an empty list');
    } else {
      tmp_0 = tmp1_elvis_lhs;
    }
    var maxLen = tmp_0;
    var tmp$ret$2;
    l$ret$3: do {
      var tmp_1;
      if (isInterface(from, Collection)) {
        tmp_1 = from.isEmpty_53();
      } else {
        {
          tmp_1 = false;
        }
      }
      if (tmp_1) {
        tmp$ret$2 = false;
        break l$ret$3;
      } else {
      }
      var tmp0_iterator_1 = from.iterator_64();
      while (tmp0_iterator_1.hasNext_31()) {
        var element_2 = tmp0_iterator_1.next_35();
        if (length(element_2) === 0) {
          tmp$ret$2 = true;
          break l$ret$3;
        } else {
        }
      }
      tmp$ret$2 = false;
    }
     while (false);
    if (tmp$ret$2)
      throw IllegalArgumentException_init_$Create$_0('There should be no empty entries');
    else {
    }
    var root = ArrayList_init_$Create$();
    build(this, root, from, maxLen, 0, length, charAt);
    root.trimToSize();
    return new AsciiCharTree(new Node_0(new Char(0), emptyList(), root));
  };
  Companion_58.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_57;
  function Companion_getInstance_57() {
    if (Companion_instance_57 == null)
      new Companion_58();
    return Companion_instance_57;
  }
  function AsciiCharTree(root) {
    Companion_getInstance_57();
    this._root = root;
  }
  AsciiCharTree.$metadata$ = {
    simpleName: 'AsciiCharTree',
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided_$factory_129() {
    var i = new _no_name_provided__168();
    return function (p1) {
      return i.invoke_237(p1);
    };
  }
  function _no_name_provided_$factory_130() {
    var i = new _no_name_provided__169();
    return function (p1, p2) {
      return i.invoke_239(p1, p2);
    };
  }
  var CharArrayPool;
  function _no_name_provided__170() {
    DefaultPool.call(this, 4096);
  }
  _no_name_provided__170.prototype.produceInstance_4 = function () {
    return charArray(2048);
  };
  _no_name_provided__170.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function CharArrayPool$init$() {
    return new _no_name_provided__170();
  }
  var DefaultHttpMethods;
  var HexTable;
  var HexLetterTable;
  function _no_name_provided__171() {
  }
  _no_name_provided__171.prototype.invoke_241 = function (it) {
    return it._value_31.length;
  };
  _no_name_provided__171.prototype.invoke_542 = function (p1) {
    return this.invoke_241(p1 instanceof HttpMethod ? p1 : THROW_CCE());
  };
  _no_name_provided__171.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__172() {
  }
  _no_name_provided__172.prototype.invoke_243 = function (m, idx) {
    return charSequenceGet(m._value_31, idx);
  };
  _no_name_provided__172.prototype.invoke_537 = function (p1, p2) {
    var tmp = p1 instanceof HttpMethod ? p1 : THROW_CCE();
    return this.invoke_243(tmp, (!(p2 == null) ? typeof p2 === 'number' : false) ? p2 : THROW_CCE());
  };
  _no_name_provided__172.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided_$factory_131() {
    var i = new _no_name_provided__171();
    return function (p1) {
      return i.invoke_241(p1);
    };
  }
  function _no_name_provided_$factory_132() {
    var i = new _no_name_provided__172();
    return function (p1, p2) {
      return i.invoke_243(p1, p2);
    };
  }
  function DefaultHttpMethods$init$() {
    var tmp = Companion_getInstance_57();
    var tmp_0 = Companion_getInstance_49()._DefaultMethods;
    var tmp_1 = _no_name_provided_$factory_131();
    return tmp.build_14(tmp_0, tmp_1, _no_name_provided_$factory_132());
  }
  function HexTable$init$() {
    var tmp0_map_0 = numberRangeToNumber(0, 255);
    var tmp0_mapTo_0_1 = ArrayList_init_$Create$_0(collectionSizeOrDefault(tmp0_map_0, 10));
    var inductionVariable = tmp0_map_0._get_first__2();
    var last_1 = tmp0_map_0._get_last__2();
    if (inductionVariable <= last_1)
      do {
        var item_2_3 = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var tmp;
        if (48 <= item_2_3 ? item_2_3 <= 57 : false) {
          tmp = numberToLong(item_2_3).minus_29(new Long(48, 0));
        } else if (toLong_0(item_2_3).compareTo_69(new Long(97, 0)) >= 0 ? toLong_0(item_2_3).compareTo_69(new Long(102, 0)) <= 0 : false) {
          var tmp0_plus_0_5 = numberToLong(item_2_3).minus_29(new Long(97, 0));
          var tmp1_plus_0_6 = 10;
          tmp = tmp0_plus_0_5.plus_56(toLong_0(tmp1_plus_0_6));
        } else if (toLong_0(item_2_3).compareTo_69(new Long(65, 0)) >= 0 ? toLong_0(item_2_3).compareTo_69(new Long(70, 0)) <= 0 : false) {
          var tmp2_plus_0_7 = numberToLong(item_2_3).minus_29(new Long(65, 0));
          var tmp3_plus_0_8 = 10;
          tmp = tmp2_plus_0_7.plus_56(toLong_0(tmp3_plus_0_8));
        } else {
          tmp = new Long(-1, -1);
        }
        tmp0_mapTo_0_1.add_33(tmp);
        Unit_getInstance();
      }
       while (!(item_2_3 === last_1));
    return toLongArray(tmp0_mapTo_0_1);
  }
  function HexLetterTable$init$() {
    var tmp0_map_0 = numberRangeToNumber(0, 15);
    var tmp0_mapTo_0_1 = ArrayList_init_$Create$_0(collectionSizeOrDefault(tmp0_map_0, 10));
    var inductionVariable = tmp0_map_0._get_first__2();
    var last_1 = tmp0_map_0._get_last__2();
    if (inductionVariable <= last_1)
      do {
        var item_2_3 = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        tmp0_mapTo_0_1.add_33(item_2_3 < 10 ? toByte_0(48 + item_2_3 | 0) : toByte_0((new Char(97)).plus_55(item_2_3).minus_28(10).toInt_5()));
        Unit_getInstance();
      }
       while (!(item_2_3 === last_1));
    return toByteArray(tmp0_mapTo_0_1);
  }
  var Codes_NORMAL_instance;
  var Codes_GOING_AWAY_instance;
  var Codes_PROTOCOL_ERROR_instance;
  var Codes_CANNOT_ACCEPT_instance;
  var Codes_CLOSED_ABNORMALLY_instance;
  var Codes_NOT_CONSISTENT_instance;
  var Codes_VIOLATED_POLICY_instance;
  var Codes_TOO_BIG_instance;
  var Codes_NO_EXTENSION_instance;
  var Codes_INTERNAL_ERROR_instance;
  var Codes_SERVICE_RESTART_instance;
  var Codes_TRY_AGAIN_LATER_instance;
  function Companion_59() {
    Companion_instance_58 = this;
    var tmp = this;
    var tmp0_associateBy_0 = values_3();
    var capacity_1 = coerceAtLeast(mapCapacity(tmp0_associateBy_0.length), 16);
    var tmp0_associateByTo_0_2 = LinkedHashMap_init_$Create$_1(capacity_1);
    var indexedObject = tmp0_associateBy_0;
    var inductionVariable = 0;
    var last_1 = indexedObject.length;
    while (inductionVariable < last_1) {
      var element_2_4 = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      tmp0_associateByTo_0_2.put_12(element_2_4._code, element_2_4);
      Unit_getInstance();
    }
    tmp._byCodeMap = tmp0_associateByTo_0_2;
    this._UNEXPECTED_CONDITION = Codes_INTERNAL_ERROR_getInstance();
  }
  Companion_59.prototype.byCode = function (code) {
    return this._byCodeMap.get_63(code);
  };
  Companion_59.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_58;
  function Companion_getInstance_58() {
    if (Companion_instance_58 == null)
      new Companion_59();
    return Companion_instance_58;
  }
  function values_3() {
    return [Codes_NORMAL_getInstance(), Codes_GOING_AWAY_getInstance(), Codes_PROTOCOL_ERROR_getInstance(), Codes_CANNOT_ACCEPT_getInstance(), Codes_CLOSED_ABNORMALLY_getInstance(), Codes_NOT_CONSISTENT_getInstance(), Codes_VIOLATED_POLICY_getInstance(), Codes_TOO_BIG_getInstance(), Codes_NO_EXTENSION_getInstance(), Codes_INTERNAL_ERROR_getInstance(), Codes_SERVICE_RESTART_getInstance(), Codes_TRY_AGAIN_LATER_getInstance()];
  }
  var Codes_entriesInitialized;
  function Codes_initEntries() {
    if (Codes_entriesInitialized)
      return Unit_getInstance();
    Codes_entriesInitialized = true;
    Codes_NORMAL_instance = new Codes('NORMAL', 0, 1000);
    Codes_GOING_AWAY_instance = new Codes('GOING_AWAY', 1, 1001);
    Codes_PROTOCOL_ERROR_instance = new Codes('PROTOCOL_ERROR', 2, 1002);
    Codes_CANNOT_ACCEPT_instance = new Codes('CANNOT_ACCEPT', 3, 1003);
    Codes_CLOSED_ABNORMALLY_instance = new Codes('CLOSED_ABNORMALLY', 4, 1006);
    Codes_NOT_CONSISTENT_instance = new Codes('NOT_CONSISTENT', 5, 1007);
    Codes_VIOLATED_POLICY_instance = new Codes('VIOLATED_POLICY', 6, 1008);
    Codes_TOO_BIG_instance = new Codes('TOO_BIG', 7, 1009);
    Codes_NO_EXTENSION_instance = new Codes('NO_EXTENSION', 8, 1010);
    Codes_INTERNAL_ERROR_instance = new Codes('INTERNAL_ERROR', 9, 1011);
    Codes_SERVICE_RESTART_instance = new Codes('SERVICE_RESTART', 10, 1012);
    Codes_TRY_AGAIN_LATER_instance = new Codes('TRY_AGAIN_LATER', 11, 1013);
    Companion_getInstance_58();
  }
  function Codes(name, ordinal, code) {
    Enum.call(this, name, ordinal);
    this._code = code;
  }
  Codes.$metadata$ = {
    simpleName: 'Codes',
    kind: 'class',
    interfaces: []
  };
  function Codes_NORMAL_getInstance() {
    Codes_initEntries();
    return Codes_NORMAL_instance;
  }
  function Codes_GOING_AWAY_getInstance() {
    Codes_initEntries();
    return Codes_GOING_AWAY_instance;
  }
  function Codes_PROTOCOL_ERROR_getInstance() {
    Codes_initEntries();
    return Codes_PROTOCOL_ERROR_instance;
  }
  function Codes_CANNOT_ACCEPT_getInstance() {
    Codes_initEntries();
    return Codes_CANNOT_ACCEPT_instance;
  }
  function Codes_CLOSED_ABNORMALLY_getInstance() {
    Codes_initEntries();
    return Codes_CLOSED_ABNORMALLY_instance;
  }
  function Codes_NOT_CONSISTENT_getInstance() {
    Codes_initEntries();
    return Codes_NOT_CONSISTENT_instance;
  }
  function Codes_VIOLATED_POLICY_getInstance() {
    Codes_initEntries();
    return Codes_VIOLATED_POLICY_instance;
  }
  function Codes_TOO_BIG_getInstance() {
    Codes_initEntries();
    return Codes_TOO_BIG_instance;
  }
  function Codes_NO_EXTENSION_getInstance() {
    Codes_initEntries();
    return Codes_NO_EXTENSION_instance;
  }
  function Codes_INTERNAL_ERROR_getInstance() {
    Codes_initEntries();
    return Codes_INTERNAL_ERROR_instance;
  }
  function Codes_SERVICE_RESTART_getInstance() {
    Codes_initEntries();
    return Codes_SERVICE_RESTART_instance;
  }
  function Codes_TRY_AGAIN_LATER_getInstance() {
    Codes_initEntries();
    return Codes_TRY_AGAIN_LATER_instance;
  }
  function CloseReason(code, message) {
    this._code_0 = code;
    this._message_0 = message;
  }
  CloseReason.prototype._get_knownReason_ = function () {
    return Companion_getInstance_58().byCode(this._code_0);
  };
  CloseReason.prototype.toString = function () {
    var tmp0_elvis_lhs = this._get_knownReason_();
    return '' + 'CloseReason(reason=' + (tmp0_elvis_lhs == null ? this._code_0 : tmp0_elvis_lhs) + ', message=' + this._message_0 + ')';
  };
  CloseReason.prototype.hashCode = function () {
    var result = this._code_0;
    result = imul(result, 31) + getStringHashCode(this._message_0) | 0;
    return result;
  };
  CloseReason.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof CloseReason))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof CloseReason ? other : THROW_CCE();
    if (!(this._code_0 === tmp0_other_with_cast._code_0))
      return false;
    if (!(this._message_0 === tmp0_other_with_cast._message_0))
      return false;
    return true;
  };
  CloseReason.$metadata$ = {
    simpleName: 'CloseReason',
    kind: 'class',
    interfaces: []
  };
  function NonDisposableHandle_0() {
    NonDisposableHandle_instance_0 = this;
  }
  NonDisposableHandle_0.prototype.dispose_26 = function () {
  };
  NonDisposableHandle_0.prototype.toString = function () {
    return 'NonDisposableHandle';
  };
  NonDisposableHandle_0.$metadata$ = {
    simpleName: 'NonDisposableHandle',
    kind: 'object',
    interfaces: [DisposableHandle]
  };
  var NonDisposableHandle_instance_0;
  function NonDisposableHandle_getInstance_0() {
    if (NonDisposableHandle_instance_0 == null)
      new NonDisposableHandle_0();
    return NonDisposableHandle_instance_0;
  }
  var FrameType_TEXT_instance;
  var FrameType_BINARY_instance;
  var FrameType_CLOSE_instance;
  var FrameType_PING_instance;
  var FrameType_PONG_instance;
  function Companion_60() {
    Companion_instance_59 = this;
    var tmp = this;
    var tmp0_maxBy_0 = values_4();
    var tmp$ret$0;
    l$ret$1: do {
      if (tmp0_maxBy_0.length === 0) {
        tmp$ret$0 = null;
        break l$ret$1;
      } else {
      }
      var maxElem_1_1 = tmp0_maxBy_0[0];
      var lastIndex_2_2 = _get_lastIndex_(tmp0_maxBy_0);
      if (lastIndex_2_2 === 0) {
        tmp$ret$0 = maxElem_1_1;
        break l$ret$1;
      }var tmp1__anonymous__8 = maxElem_1_1;
      var maxValue_3_3 = tmp1__anonymous__8._opcode;
      var inductionVariable = 1;
      if (inductionVariable <= lastIndex_2_2)
        do {
          var i_5_5 = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var e_6_6 = tmp0_maxBy_0[i_5_5];
          var v_7_7 = e_6_6._opcode;
          if (compareTo(maxValue_3_3, v_7_7) < 0) {
            maxElem_1_1 = e_6_6;
            maxValue_3_3 = v_7_7;
          }}
         while (!(i_5_5 === lastIndex_2_2));
      tmp$ret$0 = maxElem_1_1;
    }
     while (false);
    tmp._maxOpcode = ensureNotNull(tmp$ret$0)._opcode;
    var tmp_0 = this;
    var tmp_1 = 0;
    var tmp_2 = this._maxOpcode + 1 | 0;
    var tmp_3 = fillArrayVal(Array(tmp_2), null);
    while (tmp_1 < tmp_2) {
      var tmp_4 = tmp_1;
      var tmp$ret$2;
      l$ret$3: do {
        var tmp0_singleOrNull_0 = values_4();
        var single_1_0 = null;
        var found_2 = false;
        var indexedObject = tmp0_singleOrNull_0;
        var inductionVariable_0 = 0;
        var last_1 = indexedObject.length;
        while (inductionVariable_0 < last_1) {
          var element_4 = indexedObject[inductionVariable_0];
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          if (element_4._opcode === tmp_4) {
            if (found_2) {
              tmp$ret$2 = null;
              break l$ret$3;
            }single_1_0 = element_4;
            found_2 = true;
          } else {
          }
        }
        if (!found_2) {
          tmp$ret$2 = null;
          break l$ret$3;
        }tmp$ret$2 = single_1_0;
      }
       while (false);
      tmp_3[tmp_4] = tmp$ret$2;
      tmp_1 = tmp_1 + 1 | 0;
    }
    tmp_0._byOpcodeArray = tmp_3;
  }
  Companion_60.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_59;
  function Companion_getInstance_59() {
    if (Companion_instance_59 == null)
      new Companion_60();
    return Companion_instance_59;
  }
  function values_4() {
    return [FrameType_TEXT_getInstance(), FrameType_BINARY_getInstance(), FrameType_CLOSE_getInstance(), FrameType_PING_getInstance(), FrameType_PONG_getInstance()];
  }
  var FrameType_entriesInitialized;
  function FrameType_initEntries() {
    if (FrameType_entriesInitialized)
      return Unit_getInstance();
    FrameType_entriesInitialized = true;
    FrameType_TEXT_instance = new FrameType('TEXT', 0, false, 1);
    FrameType_BINARY_instance = new FrameType('BINARY', 1, false, 2);
    FrameType_CLOSE_instance = new FrameType('CLOSE', 2, true, 8);
    FrameType_PING_instance = new FrameType('PING', 3, true, 9);
    FrameType_PONG_instance = new FrameType('PONG', 4, true, 10);
    Companion_getInstance_59();
  }
  function FrameType(name, ordinal, controlFrame, opcode) {
    Enum.call(this, name, ordinal);
    this._controlFrame = controlFrame;
    this._opcode = opcode;
  }
  FrameType.$metadata$ = {
    simpleName: 'FrameType',
    kind: 'class',
    interfaces: []
  };
  function FrameType_TEXT_getInstance() {
    FrameType_initEntries();
    return FrameType_TEXT_instance;
  }
  function FrameType_BINARY_getInstance() {
    FrameType_initEntries();
    return FrameType_BINARY_instance;
  }
  function FrameType_CLOSE_getInstance() {
    FrameType_initEntries();
    return FrameType_CLOSE_instance;
  }
  function FrameType_PING_getInstance() {
    FrameType_initEntries();
    return FrameType_PING_instance;
  }
  function FrameType_PONG_getInstance() {
    FrameType_initEntries();
    return FrameType_PONG_instance;
  }
  function DefaultWebSocketSession() {
  }
  DefaultWebSocketSession.$metadata$ = {
    simpleName: 'DefaultWebSocketSession',
    kind: 'interface',
    interfaces: [WebSocketSession]
  };
  function Binary_init_$Init$(fin, data, $this) {
    Binary.call($this, fin, data, false, false, false);
    return $this;
  }
  function Binary_init_$Create$(fin, data) {
    return Binary_init_$Init$(fin, data, Object.create(Binary.prototype));
  }
  function Text_init_$Init$(fin, data, $this) {
    Text_1.call($this, fin, data, false, false, false);
    return $this;
  }
  function Text_init_$Init$_0(text, $this) {
    var tmp0_toByteArray_0 = Charsets_getInstance()._UTF_8;
    Text_init_$Init$(true, encodeToByteArray(tmp0_toByteArray_0.newEncoder_0(), text, 0, text.length), $this);
    return $this;
  }
  function Text_init_$Create$(text) {
    return Text_init_$Init$_0(text, Object.create(Text_1.prototype));
  }
  function Close_init_$Init$(reason, $this) {
    var tmp$ret$0;
    l$ret$1: do {
      var tmp0_buildPacket_0 = 0;
      var builder_1 = BytePacketBuilder_0(tmp0_buildPacket_0);
      try {
        writeShort_0(builder_1, reason._code_0);
        writeText$default(builder_1, reason._message_0, 0, 0, null, 14, null);
        tmp$ret$0 = builder_1.build_16();
        break l$ret$1;
      } catch ($p) {
        if ($p instanceof Error) {
          builder_1.release_4();
          throw $p;
        } else {
          {
            throw $p;
          }
        }
      }
    }
     while (false);
    Close_init_$Init$_0(tmp$ret$0, $this);
    return $this;
  }
  function Close_init_$Create$(reason) {
    return Close_init_$Init$(reason, Object.create(Close.prototype));
  }
  function Close_init_$Init$_0(packet, $this) {
    Close.call($this, readBytes$default(packet, 0, 1, null));
    return $this;
  }
  function Binary(fin, data, rsv1, rsv2, rsv3) {
    Frame.call(this, fin, FrameType_BINARY_getInstance(), data, NonDisposableHandle_getInstance_0(), rsv1, rsv2, rsv3);
  }
  Binary.$metadata$ = {
    simpleName: 'Binary',
    kind: 'class',
    interfaces: []
  };
  function Text_1(fin, data, rsv1, rsv2, rsv3) {
    Frame.call(this, fin, FrameType_TEXT_getInstance(), data, NonDisposableHandle_getInstance_0(), rsv1, rsv2, rsv3);
  }
  Text_1.$metadata$ = {
    simpleName: 'Text',
    kind: 'class',
    interfaces: []
  };
  function Close(data) {
    Frame.call(this, true, FrameType_CLOSE_getInstance(), data, NonDisposableHandle_getInstance_0(), false, false, false);
  }
  Close.$metadata$ = {
    simpleName: 'Close',
    kind: 'class',
    interfaces: []
  };
  function Companion_61() {
    Companion_instance_60 = this;
    this._Empty_4 = new Int8Array(0);
  }
  Companion_61.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_60;
  function Companion_getInstance_60() {
    if (Companion_instance_60 == null)
      new Companion_61();
    return Companion_instance_60;
  }
  function Frame(fin, frameType, data, disposableHandle, rsv1, rsv2, rsv3) {
    Companion_getInstance_60();
    this._fin = fin;
    this._frameType = frameType;
    this._data_4 = data;
    this._disposableHandle = disposableHandle;
    this._rsv1 = rsv1;
    this._rsv2 = rsv2;
    this._rsv3 = rsv3;
  }
  Frame.prototype.toString = function () {
    return '' + 'Frame ' + this._frameType + ' (fin=' + this._fin + ', buffer len = ' + this._data_4.length + ')';
  };
  Frame.$metadata$ = {
    simpleName: 'Frame',
    kind: 'class',
    interfaces: []
  };
  function WebSocketSession() {
  }
  WebSocketSession.$metadata$ = {
    simpleName: 'WebSocketSession',
    kind: 'interface',
    interfaces: [CoroutineScope]
  };
  function _set_manageEngine_($this, _set___) {
    return $this._manageEngine$delegate.setValue_7($this, manageEngine$factory(), _set___);
  }
  function _get_manageEngine_($this) {
    return $this._manageEngine$delegate.getValue_10($this, manageEngine$factory_0());
  }
  function HttpClient_init_$Init$(engine, userConfig, manageEngine, $this) {
    HttpClient.call($this, engine, userConfig);
    _set_manageEngine_($this, manageEngine);
    return $this;
  }
  function HttpClient_init_$Create$(engine, userConfig, manageEngine) {
    return HttpClient_init_$Init$(engine, userConfig, manageEngine, Object.create(HttpClient.prototype));
  }
  function _no_name_provided__173(this$0) {
    this._this$0_51 = this$0;
  }
  _no_name_provided__173.prototype.invoke_375 = function (it) {
    if (!(it == null)) {
      cancel$default(this._this$0_51._engine, null, 1, null);
    }};
  _no_name_provided__173.prototype.invoke_542 = function (p1) {
    this.invoke_375((p1 == null ? true : p1 instanceof Error) ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__173.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__174(this$0, resultContinuation) {
    this._this$0_52 = this$0;
    CoroutineImpl_0.call(this, resultContinuation);
  }
  _no_name_provided__174.prototype.invoke_382 = function (_this__0, call, $cont) {
    var tmp = this.create_34(_this__0, call, $cont);
    tmp._result = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_72();
  };
  _no_name_provided__174.prototype.invoke_537 = function (p1, p2, $cont) {
    var tmp = (!(p1 == null) ? isInterface(p1, PipelineContext) : false) ? p1 : THROW_CCE();
    this.invoke_382(tmp, isObject(p2) ? p2 : THROW_CCE(), $cont);
    return Unit_getInstance();
  };
  _no_name_provided__174.prototype.doResume_72 = function () {
    var suspendResult = this._result;
    $sm: do
      try {
        var tmp = this._state_0;
        switch (tmp) {
          case 0:
            this._exceptionState = 3;
            var tmp_0 = this;
            var tmp_1 = this._call;
            tmp_0._tmp0_check_00 = tmp_1 instanceof HttpClientCall;
            if (!this._tmp0_check_00) {
              var message_1 = '' + 'Error: HttpClientCall expected, but found ' + this._call + '(' + getKClassFromExpression_0(this._call) + ').';
              throw IllegalStateException_init_$Create$(toString_1(message_1));
            }
            this._state_0 = 1;
            suspendResult = this._this$0_52._receivePipeline.execute_1(this._call, this._call._get_response__0(), this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            this._ARGUMENT1 = suspendResult;
            this._receivedCall2 = this._ARGUMENT1._get_call__4();
            this._state_0 = 2;
            suspendResult = this.__this__18.proceedWith_1(this._receivedCall2, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 2:
            suspendResult;
            Unit_getInstance();
            return Unit_getInstance();
          case 3:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 3) {
          throw $p;
        } else {
          this._state_0 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  _no_name_provided__174.prototype.create_34 = function (_this__0, call, completion) {
    var i = new _no_name_provided__174(this._this$0_52, completion);
    i.__this__18 = _this__0;
    i._call = call;
    return i;
  };
  _no_name_provided__174.$metadata$ = {
    kind: 'class',
    interfaces: [],
    suspendArity: 2
  };
  function _no_name_provided__175() {
  }
  _no_name_provided__175.prototype.invoke_260 = function (_this__0) {
    defaultTransformers(_this__0);
  };
  _no_name_provided__175.prototype.invoke_542 = function (p1) {
    this.invoke_260(p1 instanceof HttpClient ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__175.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function $executeCOROUTINE$0(_this_, builder, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__19 = _this_;
    this._builder_0 = builder;
  }
  $executeCOROUTINE$0.prototype.doResume_72 = function () {
    var suspendResult = this._result;
    $sm: do
      try {
        var tmp = this._state_0;
        switch (tmp) {
          case 0:
            this._exceptionState = 2;
            this._state_0 = 1;
            suspendResult = this.__this__19._requestPipeline.execute_1(this._builder_0, this._builder_0._body_0, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            var tmp_0 = suspendResult;
            return tmp_0 instanceof HttpClientCall ? tmp_0 : THROW_CCE();
          case 2:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 2) {
          throw $p;
        } else {
          this._state_0 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $executeCOROUTINE$0.$metadata$ = {
    simpleName: '$executeCOROUTINE$0',
    kind: 'class',
    interfaces: []
  };
  function HttpClient(engine, userConfig) {
    this._engine = engine;
    this._userConfig = userConfig;
    var tmp = this;
    var tmp0_shared_0 = false;
    tmp._manageEngine$delegate = new _no_name_provided__124(tmp0_shared_0);
    this._closed_0 = atomic_0(false);
    this._clientJob = Job_0(this._engine._get_coroutineContext__22().get_70(Key_getInstance_3()));
    this._coroutineContext_1 = this._engine._get_coroutineContext__22().plus_28(this._clientJob);
    this._requestPipeline = new HttpRequestPipeline(this._userConfig._get_developmentMode__4());
    this._responsePipeline = new HttpResponsePipeline(this._userConfig._get_developmentMode__4());
    this._sendPipeline = new HttpSendPipeline(this._userConfig._get_developmentMode__4());
    this._receivePipeline = new HttpReceivePipeline(this._userConfig._get_developmentMode__4());
    this._attributes_1 = Attributes_0(true);
    this._engineConfig = this._engine._get_config__1();
    this._config = new HttpClientConfig();
    checkCoroutinesVersion();
    if (_get_manageEngine_(this)) {
      this._clientJob.invokeOnCompletion_22(_no_name_provided_$factory_133(this));
      Unit_getInstance();
    }this._engine.install_19(this);
    var tmp_0 = Phases_getInstance_0()._Receive;
    this._sendPipeline.intercept(tmp_0, _no_name_provided_$factory_134(this, null));
    var tmp0_with_0 = this._userConfig;
    var tmp_1 = Feature_getInstance_2();
    this._config.install$default(tmp_1, null, 2, null);
    if (tmp0_with_0._get_useDefaultTransformers_()) {
      var tmp_2 = Feature_getInstance_0();
      this._config.install$default(tmp_2, null, 2, null);
      this._config.install_0('DefaultTransformers', _no_name_provided_$factory_135());
    }var tmp_3 = Feature_getInstance_3();
    this._config.install$default(tmp_3, null, 2, null);
    if (tmp0_with_0._get_followRedirects_()) {
      var tmp_4 = Feature_getInstance_1();
      this._config.install$default(tmp_4, null, 2, null);
    }var tmp0_this_3 = this;
    tmp0_this_3._config.plusAssign_3(tmp0_with_0);
    addDefaultResponseValidation(this._config);
    this._config.install_19(this);
    makeShared(this);
  }
  HttpClient.prototype._get_coroutineContext__22 = function () {
    return this._coroutineContext_1;
  };
  HttpClient.prototype.execute_9 = function (builder, $cont) {
    var tmp = new $executeCOROUTINE$0(this, builder, $cont);
    tmp._result = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_72();
  };
  HttpClient.prototype.close_39 = function () {
    var success = this._closed_0.compareAndSet$atomicfu(false, true);
    if (!success)
      return Unit_getInstance();
    var tmp0_forEach_0 = this._attributes_1._get_allKeys__0();
    var tmp0_iterator_1 = tmp0_forEach_0.iterator_64();
    while (tmp0_iterator_1.hasNext_31()) {
      var element_2 = tmp0_iterator_1.next_35();
      var feature_4 = this._attributes_1.get_65(element_2 instanceof AttributeKey ? element_2 : THROW_CCE());
      if (isInterface(feature_4, Closeable)) {
        feature_4.close_39();
      } else {
      }
    }
    this._clientJob.complete_3();
    Unit_getInstance();
    if (_get_manageEngine_(this)) {
      this._engine.close_39();
    }};
  HttpClient.prototype.toString = function () {
    return '' + 'HttpClient[' + this._engine + ']';
  };
  HttpClient.$metadata$ = {
    simpleName: 'HttpClient',
    kind: 'class',
    interfaces: [CoroutineScope, Closeable]
  };
  function HttpClient_0(engineFactory, block) {
    var tmp0_apply_0 = new HttpClientConfig();
    block(tmp0_apply_0);
    var config = tmp0_apply_0;
    var engine = engineFactory.create_25(config._get_engineConfig_());
    var client = HttpClient_init_$Create$(engine, config, true);
    var tmp = ensureNotNull(client._coroutineContext_1.get_70(Key_getInstance_3()));
    tmp.invokeOnCompletion_22(_no_name_provided_$factory_136(engine));
    Unit_getInstance();
    return client;
  }
  function _no_name_provided__176($engine) {
    this._$engine = $engine;
  }
  _no_name_provided__176.prototype.invoke_375 = function (it) {
    this._$engine.close_39();
  };
  _no_name_provided__176.prototype.invoke_542 = function (p1) {
    this.invoke_375((p1 == null ? true : p1 instanceof Error) ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__176.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function manageEngine$factory() {
    return getPropertyCallableRef('manageEngine', 1, KMutableProperty1, function (receiver) {
      return _get_manageEngine_(receiver);
    }, function (receiver_0, value) {
      return _set_manageEngine_(receiver_0, value);
    });
  }
  function manageEngine$factory_0() {
    return getPropertyCallableRef('manageEngine', 1, KMutableProperty1, function (receiver) {
      return _get_manageEngine_(receiver);
    }, function (receiver_0, value) {
      return _set_manageEngine_(receiver_0, value);
    });
  }
  function _no_name_provided_$factory_133(this$0) {
    var i = new _no_name_provided__173(this$0);
    return function (p1) {
      i.invoke_375(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_134(this$0, resultContinuation) {
    var i = new _no_name_provided__174(this$0, resultContinuation);
    var l = function (p1, p2, $cont) {
      return i.invoke_382(p1, p2, $cont);
    };
    l.$arity = 2;
    return l;
  }
  function _no_name_provided_$factory_135() {
    var i = new _no_name_provided__175();
    return function (p1) {
      i.invoke_260(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_136($engine) {
    var i = new _no_name_provided__176($engine);
    return function (p1) {
      i.invoke_375(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided__177() {
  }
  _no_name_provided__177.prototype.invoke_540 = function () {
    return Attributes_0(true);
  };
  _no_name_provided__177.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__178() {
  }
  _no_name_provided__178.prototype.invoke_254 = function (_this__0) {
    return Unit_getInstance();
  };
  _no_name_provided__178.prototype.invoke_542 = function (p1) {
    this.invoke_254(p1 instanceof HttpClientEngineConfig ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__178.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__179() {
  }
  _no_name_provided__179.prototype.invoke_256 = function (_this__0) {
    return Unit_getInstance();
  };
  _no_name_provided__179.prototype.invoke_542 = function (p1) {
    this.invoke_256(isObject(p1) ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__179.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__180($previousConfigBlock, $configure) {
    this._$previousConfigBlock = $previousConfigBlock;
    this._$configure = $configure;
  }
  _no_name_provided__180.prototype.invoke_258 = function (_this__0) {
    var tmp0_safe_receiver_2 = this._$previousConfigBlock;
    if (tmp0_safe_receiver_2 == null)
      null;
    else
      tmp0_safe_receiver_2(_this__0);
    Unit_getInstance();
    this._$configure(isObject(_this__0) ? _this__0 : THROW_CCE());
  };
  _no_name_provided__180.prototype.invoke_542 = function (p1) {
    this.invoke_258(isObject(p1) ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__180.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__181($feature) {
    this._$feature = $feature;
  }
  _no_name_provided__181.prototype.invoke_260 = function (scope_0) {
    var attributes_2 = scope_0._attributes_1.computeIfAbsent_0(FEATURE_INSTALLED_LIST, _no_name_provided_$factory_141());
    var config_4 = ensureNotNull(scope_0._config._featureConfigurations.get_63(this._$feature._get_key__47()));
    var featureData_5 = this._$feature.prepare_17(config_4);
    this._$feature.install_23(featureData_5, scope_0);
    attributes_2.put_13(this._$feature._get_key__47(), featureData_5);
  };
  _no_name_provided__181.prototype.invoke_542 = function (p1) {
    this.invoke_260(p1 instanceof HttpClient ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__181.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function HttpClientConfig() {
    this._features = sharedMap();
    this._featureConfigurations = sharedMap();
    this._customInterceptors = sharedMap();
    var tmp = this;
    tmp._engineConfig$delegate = new _no_name_provided__124(_no_name_provided_$factory_137());
    var tmp_0 = this;
    var tmp0_shared_0 = true;
    tmp_0._followRedirects$delegate = new _no_name_provided__124(tmp0_shared_0);
    var tmp_1 = this;
    var tmp0_shared_0_0 = true;
    tmp_1._useDefaultTransformers$delegate = new _no_name_provided__124(tmp0_shared_0_0);
    var tmp_2 = this;
    var tmp0_shared_0_1 = true;
    tmp_2._expectSuccess$delegate = new _no_name_provided__124(tmp0_shared_0_1);
    var tmp_3 = this;
    var tmp0_shared_0_2 = PlatformUtils_getInstance()._IS_DEVELOPMENT_MODE;
    tmp_3._developmentMode$delegate = new _no_name_provided__124(tmp0_shared_0_2);
  }
  HttpClientConfig.prototype._set_engineConfig_ = function (_set___) {
    return this._engineConfig$delegate.setValue_7(this, engineConfig$factory(), _set___);
  };
  HttpClientConfig.prototype._get_engineConfig_ = function () {
    return this._engineConfig$delegate.getValue_10(this, engineConfig$factory_0());
  };
  HttpClientConfig.prototype._set_followRedirects_ = function (_set___) {
    return this._followRedirects$delegate.setValue_7(this, followRedirects$factory(), _set___);
  };
  HttpClientConfig.prototype._get_followRedirects_ = function () {
    return this._followRedirects$delegate.getValue_10(this, followRedirects$factory_0());
  };
  HttpClientConfig.prototype._set_useDefaultTransformers_ = function (_set___) {
    return this._useDefaultTransformers$delegate.setValue_7(this, useDefaultTransformers$factory(), _set___);
  };
  HttpClientConfig.prototype._get_useDefaultTransformers_ = function () {
    return this._useDefaultTransformers$delegate.getValue_10(this, useDefaultTransformers$factory_0());
  };
  HttpClientConfig.prototype._set_expectSuccess_ = function (_set___) {
    return this._expectSuccess$delegate.setValue_7(this, expectSuccess$factory(), _set___);
  };
  HttpClientConfig.prototype._get_expectSuccess_ = function () {
    return this._expectSuccess$delegate.getValue_10(this, expectSuccess$factory_0());
  };
  HttpClientConfig.prototype._set_developmentMode_ = function (_set___) {
    return this._developmentMode$delegate.setValue_7(this, developmentMode$factory(), _set___);
  };
  HttpClientConfig.prototype._get_developmentMode__4 = function () {
    return this._developmentMode$delegate.getValue_10(this, developmentMode$factory_0());
  };
  HttpClientConfig.prototype.install = function (feature_0, configure) {
    var previousConfigBlock = this._featureConfigurations.get_63(feature_0._get_key__47());
    var tmp0_set_0 = this._featureConfigurations;
    var tmp1_set_0 = feature_0._get_key__47();
    tmp0_set_0.put_12(tmp1_set_0, _no_name_provided_$factory_139(previousConfigBlock, configure));
    Unit_getInstance();
    if (this._features.containsKey_16(feature_0._get_key__47()))
      return Unit_getInstance();
    var tmp2_set_0 = this._features;
    var tmp3_set_0 = feature_0._get_key__47();
    tmp2_set_0.put_12(tmp3_set_0, _no_name_provided_$factory_140(feature_0));
    Unit_getInstance();
  };
  HttpClientConfig.prototype.install$default = function (feature_0, configure, $mask0, $handler) {
    if (!(($mask0 & 2) === 0)) {
      configure = _no_name_provided_$factory_138();
    }return this.install(feature_0, configure);
  };
  HttpClientConfig.prototype.install_0 = function (key, block) {
    var tmp0_set_0 = this._customInterceptors;
    tmp0_set_0.put_12(key, block);
    Unit_getInstance();
  };
  HttpClientConfig.prototype.install_19 = function (client) {
    var tmp0_forEach_0 = this._features._get_values__16();
    var tmp0_iterator_1 = tmp0_forEach_0.iterator_64();
    while (tmp0_iterator_1.hasNext_31()) {
      var element_2 = tmp0_iterator_1.next_35();
      element_2(client);
      Unit_getInstance();
    }
    var tmp1_forEach_0 = this._customInterceptors._get_values__16();
    var tmp0_iterator_1_0 = tmp1_forEach_0.iterator_64();
    while (tmp0_iterator_1_0.hasNext_31()) {
      var element_2_0 = tmp0_iterator_1_0.next_35();
      element_2_0(client);
      Unit_getInstance();
    }
  };
  HttpClientConfig.prototype.plusAssign_3 = function (other) {
    this._set_followRedirects_(other._get_followRedirects_());
    this._set_useDefaultTransformers_(other._get_useDefaultTransformers_());
    this._set_expectSuccess_(other._get_expectSuccess_());
    var tmp0_this = this;
    var tmp0_plusAssign_0 = tmp0_this._features;
    var tmp1_plusAssign_0 = other._features;
    tmp0_plusAssign_0.putAll_8(tmp1_plusAssign_0);
    var tmp1_this = this;
    var tmp2_plusAssign_0 = tmp1_this._featureConfigurations;
    var tmp3_plusAssign_0 = other._featureConfigurations;
    tmp2_plusAssign_0.putAll_8(tmp3_plusAssign_0);
    var tmp2_this = this;
    var tmp4_plusAssign_0 = tmp2_this._customInterceptors;
    var tmp5_plusAssign_0 = other._customInterceptors;
    tmp4_plusAssign_0.putAll_8(tmp5_plusAssign_0);
  };
  HttpClientConfig.$metadata$ = {
    simpleName: 'HttpClientConfig',
    kind: 'class',
    interfaces: []
  };
  function engineConfig$factory() {
    return getPropertyCallableRef('engineConfig', 1, KMutableProperty1, function (receiver) {
      return receiver._get_engineConfig_();
    }, function (receiver_0, value) {
      return receiver_0._set_engineConfig_(value);
    });
  }
  function engineConfig$factory_0() {
    return getPropertyCallableRef('engineConfig', 1, KMutableProperty1, function (receiver) {
      return receiver._get_engineConfig_();
    }, function (receiver_0, value) {
      return receiver_0._set_engineConfig_(value);
    });
  }
  function followRedirects$factory() {
    return getPropertyCallableRef('followRedirects', 1, KMutableProperty1, function (receiver) {
      return receiver._get_followRedirects_();
    }, function (receiver_0, value) {
      return receiver_0._set_followRedirects_(value);
    });
  }
  function followRedirects$factory_0() {
    return getPropertyCallableRef('followRedirects', 1, KMutableProperty1, function (receiver) {
      return receiver._get_followRedirects_();
    }, function (receiver_0, value) {
      return receiver_0._set_followRedirects_(value);
    });
  }
  function useDefaultTransformers$factory() {
    return getPropertyCallableRef('useDefaultTransformers', 1, KMutableProperty1, function (receiver) {
      return receiver._get_useDefaultTransformers_();
    }, function (receiver_0, value) {
      return receiver_0._set_useDefaultTransformers_(value);
    });
  }
  function useDefaultTransformers$factory_0() {
    return getPropertyCallableRef('useDefaultTransformers', 1, KMutableProperty1, function (receiver) {
      return receiver._get_useDefaultTransformers_();
    }, function (receiver_0, value) {
      return receiver_0._set_useDefaultTransformers_(value);
    });
  }
  function expectSuccess$factory() {
    return getPropertyCallableRef('expectSuccess', 1, KMutableProperty1, function (receiver) {
      return receiver._get_expectSuccess_();
    }, function (receiver_0, value) {
      return receiver_0._set_expectSuccess_(value);
    });
  }
  function expectSuccess$factory_0() {
    return getPropertyCallableRef('expectSuccess', 1, KMutableProperty1, function (receiver) {
      return receiver._get_expectSuccess_();
    }, function (receiver_0, value) {
      return receiver_0._set_expectSuccess_(value);
    });
  }
  function developmentMode$factory() {
    return getPropertyCallableRef('developmentMode', 1, KMutableProperty1, function (receiver) {
      return receiver._get_developmentMode__4();
    }, function (receiver_0, value) {
      return receiver_0._set_developmentMode_(value);
    });
  }
  function developmentMode$factory_0() {
    return getPropertyCallableRef('developmentMode', 1, KMutableProperty1, function (receiver) {
      return receiver._get_developmentMode__4();
    }, function (receiver_0, value) {
      return receiver_0._set_developmentMode_(value);
    });
  }
  function _no_name_provided_$factory_137() {
    var i = new _no_name_provided__178();
    return function (p1) {
      i.invoke_254(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_138() {
    var i = new _no_name_provided__179();
    return function (p1) {
      i.invoke_256(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_139($previousConfigBlock, $configure) {
    var i = new _no_name_provided__180($previousConfigBlock, $configure);
    return function (p1) {
      i.invoke_258(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_140($feature) {
    var i = new _no_name_provided__181($feature);
    return function (p1) {
      i.invoke_260(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_141() {
    var i = new _no_name_provided__177();
    return function () {
      return i.invoke_540();
    };
  }
  function Companion_62() {
    Companion_instance_61 = this;
    this._CustomResponse = new AttributeKey('CustomResponse');
  }
  Companion_62.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_61;
  function Companion_getInstance_61() {
    if (Companion_instance_61 == null)
      new Companion_62();
    return Companion_instance_61;
  }
  function $receiveCOROUTINE$1(_this_, info, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__20 = _this_;
    this._info = info;
  }
  $receiveCOROUTINE$1.prototype.doResume_72 = function () {
    var suspendResult = this._result;
    $sm: do
      try {
        var tmp = this._state_0;
        switch (tmp) {
          case 0:
            this._exceptionState = 10;
            this._state_0 = 1;
            continue $sm;
          case 1:
            this._state_0 = 2;
            continue $sm;
          case 2:
            this._exceptionState = 9;
            this._exceptionState = 8;
            if (instanceOf(this.__this__20._get_response__0(), this._info._type_1)) {
              this._tmp$ret$01 = this.__this__20._get_response__0();
              this._exceptionState = 10;
              this._state_0 = 7;
              continue $sm;
            } else {
              this._state_0 = 3;
              continue $sm;
            }

            break;
          case 3:
            if (!this.__this__20._get_allowDoubleReceive__0() ? !this.__this__20._received.compareAndSet$atomicfu(false, true) : false)
              throw new DoubleReceiveException(this.__this__20);
            this._tmp0_elvis_lhs2 = this.__this__20._get_attributes__12().getOrNull_0(Companion_getInstance_61()._CustomResponse);
            if (this._tmp0_elvis_lhs2 == null) {
              this._state_0 = 4;
              suspendResult = this.__this__20.getResponseContent_0(this);
              if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
                return suspendResult;
              }continue $sm;
            } else {
              this._WHEN_RESULT3 = this._tmp0_elvis_lhs2;
              this._state_0 = 5;
              continue $sm;
            }

            break;
          case 4:
            this._WHEN_RESULT3 = suspendResult;
            this._state_0 = 5;
            continue $sm;
          case 5:
            this._responseData4 = this._WHEN_RESULT3;
            this._subject5 = new HttpResponseContainer(this._info, this._responseData4);
            var tmp_0 = this;
            var tmp1_elvis_lhs = this.__this__20._get_client__0();
            var tmp_1;
            if (tmp1_elvis_lhs == null) {
              var tmp0_error_0 = '' + 'Failed to receive call(' + this.__this__20 + ') in different native thread.';
              throw IllegalStateException_init_$Create$(toString_1(tmp0_error_0));
            } else {
              tmp_1 = tmp1_elvis_lhs;
            }

            tmp_0._currentClient6 = tmp_1;
            this._state_0 = 6;
            suspendResult = this._currentClient6._responsePipeline.execute_1(this.__this__20, this._subject5, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 6:
            var ARGUMENT = suspendResult;
            var result = ARGUMENT._response_2;
            if (!instanceOf(result, this._info._type_1)) {
              var from = getKClassFromExpression_0(result);
              var to_1 = this._info._type_1;
              throw new NoTransformationFoundException(this.__this__20._get_response__0(), from, to_1);
            }
            this._tmp$ret$01 = result;
            this._exceptionState = 10;
            this._state_0 = 7;
            var tmp_2 = this;
            continue $sm;
          case 7:
            var tmp_3 = this._tmp$ret$01;
            complete(this.__this__20._get_response__0());
            return tmp_3;
          case 8:
            this._exceptionState = 9;
            var tmp_4 = this._exception_0;
            if (tmp_4 instanceof Error) {
              var cause = this._exception_0;
              var tmp_5 = this;
              cancel_0(this.__this__20._get_response__0(), 'Receive failed', cause);
              throw cause;
            } else {
              {
                throw this._exception_0;
              }
            }

            break;
          case 9:
            this._exceptionState = 10;
            var t = this._exception_0;
            complete(this.__this__20._get_response__0());
            throw t;
          case 10:
            throw this._exception_0;
          case 11:
            complete(this.__this__20._get_response__0());
            return Unit_getInstance();
        }
      } catch ($p) {
        if (this._exceptionState === 10) {
          throw $p;
        } else {
          this._state_0 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $receiveCOROUTINE$1.$metadata$ = {
    simpleName: '$receiveCOROUTINE$1',
    kind: 'class',
    interfaces: []
  };
  function HttpClientCall(client) {
    Companion_getInstance_61();
    this._received = atomic_0(false);
    this._client$delegate = threadLocal(client);
    this._allowDoubleReceive = false;
  }
  HttpClientCall.prototype._get_client__0 = function () {
    return this._client$delegate.getValue_10(this, client$factory());
  };
  HttpClientCall.prototype._get_coroutineContext__22 = function () {
    return this._get_response__0()._get_coroutineContext__22();
  };
  HttpClientCall.prototype._get_attributes__12 = function () {
    return this._get_request__0()._get_attributes__12();
  };
  HttpClientCall.prototype._set_request__0 = function (_set___) {
    this._request = _set___;
  };
  HttpClientCall.prototype._get_request__0 = function () {
    var tmp = this._request;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('request');
    }
  };
  HttpClientCall.prototype._set_response__0 = function (_set___) {
    this._response = _set___;
  };
  HttpClientCall.prototype._get_response__0 = function () {
    var tmp = this._response;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('response');
    }
  };
  HttpClientCall.prototype._get_allowDoubleReceive__0 = function () {
    return this._allowDoubleReceive;
  };
  HttpClientCall.prototype.getResponseContent_0 = function ($cont) {
    return this._get_response__0()._get_content__6();
  };
  HttpClientCall.prototype.receive_0 = function (info, $cont) {
    var tmp = new $receiveCOROUTINE$1(this, info, $cont);
    tmp._result = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_72();
  };
  HttpClientCall.prototype.toString = function () {
    return '' + 'HttpClientCall[' + this._get_request__0()._get_url__1() + ', ' + this._get_response__0()._get_status__1() + ']';
  };
  HttpClientCall.$metadata$ = {
    simpleName: 'HttpClientCall',
    kind: 'class',
    interfaces: [CoroutineScope]
  };
  function HttpClientCall_0(client, requestData, responseData) {
    var tmp0_apply_0 = new HttpClientCall(client);
    tmp0_apply_0._request = new DefaultHttpRequest(tmp0_apply_0, requestData);
    tmp0_apply_0._response = new DefaultHttpResponse(tmp0_apply_0, responseData);
    var tmp = responseData._body_2;
    if (!isInterface(tmp, ByteReadChannel_1)) {
      tmp0_apply_0._get_attributes__12().put_13(Companion_getInstance_61()._CustomResponse, responseData._body_2);
    } else {
    }
    return tmp0_apply_0;
  }
  function DoubleReceiveException(call) {
    IllegalStateException_init_$Init$(this);
    this._message_1 = '' + 'Response already received: ' + call;
    captureStack(this, DoubleReceiveException);
  }
  DoubleReceiveException.prototype._get_message__52 = function () {
    return this._message_1;
  };
  DoubleReceiveException.$metadata$ = {
    simpleName: 'DoubleReceiveException',
    kind: 'class',
    interfaces: []
  };
  Object.defineProperty(DoubleReceiveException.prototype, 'message', {
    configurable: true,
    get: DoubleReceiveException.prototype._get_message__52
  });
  function _no_name_provided__182() {
  }
  _no_name_provided__182.prototype.invoke_262 = function (_name_for_destructuring_parameter_0_) {
    var key = _name_for_destructuring_parameter_0_.component1_4();
    var value = _name_for_destructuring_parameter_0_.component2_4();
    return '' + key + ': ' + value + '\n';
  };
  _no_name_provided__182.prototype.invoke_542 = function (p1) {
    return this.invoke_262(p1 instanceof Pair ? p1 : THROW_CCE());
  };
  _no_name_provided__182.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function NoTransformationFoundException(response, from, to_1) {
    UnsupportedOperationException_init_$Init$(this);
    var tmp = this;
    var tmp_0 = _get_request_(response)._get_url__1();
    var tmp_1 = response._get_status__1();
    var tmp_2 = flattenEntries(response._get_headers__15());
    var tmp_3 = '' + 'No transformation found: ' + from + ' -> ' + to_1 + '\n        |with response from ' + tmp_0 + ':\n        |status: ' + tmp_1 + '\n        |response headers: \n        |' + joinToString$default_0(tmp_2, null, null, null, 0, null, _no_name_provided_$factory_142(), 31, null) + '\n    ';
    tmp._message_2 = trimMargin$default(tmp_3, null, 1, null);
    captureStack(this, NoTransformationFoundException);
  }
  NoTransformationFoundException.prototype._get_message__52 = function () {
    return this._message_2;
  };
  NoTransformationFoundException.$metadata$ = {
    simpleName: 'NoTransformationFoundException',
    kind: 'class',
    interfaces: []
  };
  Object.defineProperty(NoTransformationFoundException.prototype, 'message', {
    configurable: true,
    get: NoTransformationFoundException.prototype._get_message__52
  });
  function client$factory() {
    return getPropertyCallableRef('client', 1, KProperty1, function (receiver) {
      return receiver._get_client__0();
    }, null);
  }
  function _no_name_provided_$factory_142() {
    var i = new _no_name_provided__182();
    return function (p1) {
      return i.invoke_262(p1);
    };
  }
  function save(_this_, $cont) {
    var tmp = new $saveCOROUTINE$3(_this_, $cont);
    tmp._result = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_72();
  }
  function $getResponseContentCOROUTINE$4(_this_, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__21 = _this_;
  }
  $getResponseContentCOROUTINE$4.prototype.doResume_72 = function () {
    var suspendResult = this._result;
    $sm: do
      try {
        var tmp = this._state_0;
        switch (tmp) {
          case 0:
            this._exceptionState = 2;
            if (this.__this__21._responseContent == null) {
              this.__this__21._responseContent = this.__this__21._get_response__0()._get_content__6();
            }
            this._state_0 = 1;
            suspendResult = toByteArray_0(ensureNotNull(this.__this__21._responseContent), this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            var contentBytes = suspendResult;
            this.__this__21._responseContent = ByteReadChannel(contentBytes);
            return ByteReadChannel(contentBytes);
          case 2:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 2) {
          throw $p;
        } else {
          this._state_0 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $getResponseContentCOROUTINE$4.$metadata$ = {
    simpleName: '$getResponseContentCOROUTINE$4',
    kind: 'class',
    interfaces: []
  };
  function SavedHttpCall(client) {
    HttpClientCall.call(this, client);
    this._responseContent = null;
    this._allowDoubleReceive_0 = true;
  }
  SavedHttpCall.prototype.getResponseContent_0 = function ($cont) {
    var tmp = new $getResponseContentCOROUTINE$4(this, $cont);
    tmp._result = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_72();
  };
  SavedHttpCall.prototype._get_allowDoubleReceive__0 = function () {
    return this._allowDoubleReceive_0;
  };
  SavedHttpCall.$metadata$ = {
    simpleName: 'SavedHttpCall',
    kind: 'class',
    interfaces: []
  };
  function SavedHttpRequest(call, origin) {
    this._call_0 = call;
    this._$$delegate_0_3 = origin;
  }
  SavedHttpRequest.prototype._get_call__4 = function () {
    return this._call_0;
  };
  SavedHttpRequest.prototype._get_attributes__12 = function () {
    return this._$$delegate_0_3._get_attributes__12();
  };
  SavedHttpRequest.prototype._get_coroutineContext__22 = function () {
    return this._$$delegate_0_3._get_coroutineContext__22();
  };
  SavedHttpRequest.prototype._get_headers__15 = function () {
    return this._$$delegate_0_3._get_headers__15();
  };
  SavedHttpRequest.prototype._get_method__1 = function () {
    return this._$$delegate_0_3._get_method__1();
  };
  SavedHttpRequest.prototype._get_url__1 = function () {
    return this._$$delegate_0_3._get_url__1();
  };
  SavedHttpRequest.$metadata$ = {
    simpleName: 'SavedHttpRequest',
    kind: 'class',
    interfaces: [HttpRequest]
  };
  function SavedHttpResponse(call, body, origin) {
    HttpResponse.call(this);
    this._call_1 = call;
    var tmp = this;
    tmp._context_3 = Job$default(null, 1, null);
    this._status_0 = origin._get_status__1();
    this._version = origin._get_version__1();
    this._requestTime = origin._get_requestTime__1();
    this._responseTime = origin._get_responseTime__1();
    this._headers = origin._get_headers__15();
    this._coroutineContext_2 = origin._get_coroutineContext__22().plus_28(this._context_3);
    this._content_5 = ByteReadChannel(body);
  }
  SavedHttpResponse.prototype._get_call__4 = function () {
    return this._call_1;
  };
  SavedHttpResponse.prototype._get_status__1 = function () {
    return this._status_0;
  };
  SavedHttpResponse.prototype._get_version__1 = function () {
    return this._version;
  };
  SavedHttpResponse.prototype._get_requestTime__1 = function () {
    return this._requestTime;
  };
  SavedHttpResponse.prototype._get_responseTime__1 = function () {
    return this._responseTime;
  };
  SavedHttpResponse.prototype._get_headers__15 = function () {
    return this._headers;
  };
  SavedHttpResponse.prototype._get_coroutineContext__22 = function () {
    return this._coroutineContext_2;
  };
  SavedHttpResponse.prototype._get_content__6 = function () {
    return this._content_5;
  };
  SavedHttpResponse.$metadata$ = {
    simpleName: 'SavedHttpResponse',
    kind: 'class',
    interfaces: []
  };
  function $saveCOROUTINE$3(_this_, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__22 = _this_;
  }
  $saveCOROUTINE$3.prototype.doResume_72 = function () {
    var suspendResult = this._result;
    $sm: do
      try {
        var tmp = this._state_0;
        switch (tmp) {
          case 0:
            this._exceptionState = 2;
            var tmp_0 = this;
            var tmp0_elvis_lhs = this.__this__22._get_client__0();
            var tmp_1;
            if (tmp0_elvis_lhs == null) {
              var tmp0_error_0 = 'Failed to save call in different native thread.';
              throw IllegalStateException_init_$Create$(toString_1(tmp0_error_0));
            } else {
              tmp_1 = tmp0_elvis_lhs;
            }

            tmp_0._currentClient0 = tmp_1;
            var tmp_2 = this;
            tmp_2._tmp1_also_01 = new SavedHttpCall(this._currentClient0);
            this._state_0 = 1;
            suspendResult = readRemaining(this.__this__22._get_response__0()._get_content__6(), this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            var content_2 = suspendResult;
            this._tmp1_also_01._set_request__0(new SavedHttpRequest(this._tmp1_also_01, this.__this__22._get_request__0()));
            this._tmp1_also_01._set_response__0(new SavedHttpResponse(this._tmp1_also_01, readBytes$default(content_2, 0, 1, null), this.__this__22._get_response__0()));
            return this._tmp1_also_01;
          case 2:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 2) {
          throw $p;
        } else {
          this._state_0 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $saveCOROUTINE$3.$metadata$ = {
    simpleName: '$saveCOROUTINE$3',
    kind: 'class',
    interfaces: []
  };
  function TypeInfo_init_$Init$(type, reifiedType, kotlinType, $mask0, $marker, $this) {
    if (!(($mask0 & 4) === 0))
      kotlinType = null;
    TypeInfo.call($this, type, reifiedType, kotlinType);
    return $this;
  }
  function TypeInfo_init_$Create$(type, reifiedType, kotlinType, $mask0, $marker) {
    return TypeInfo_init_$Init$(type, reifiedType, kotlinType, $mask0, $marker, Object.create(TypeInfo.prototype));
  }
  function TypeInfo(type, reifiedType, kotlinType) {
    this._type_1 = type;
    this._reifiedType = reifiedType;
    this._kotlinType = kotlinType;
  }
  TypeInfo.prototype.toString = function () {
    return '' + 'TypeInfo(type=' + this._type_1 + ', reifiedType=' + this._reifiedType + ', kotlinType=' + this._kotlinType + ')';
  };
  TypeInfo.prototype.hashCode = function () {
    var result = this._type_1.hashCode();
    result = imul(result, 31) + hashCode(this._reifiedType) | 0;
    result = imul(result, 31) + (this._kotlinType == null ? 0 : hashCode(this._kotlinType)) | 0;
    return result;
  };
  TypeInfo.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof TypeInfo))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof TypeInfo ? other : THROW_CCE();
    if (!this._type_1.equals(tmp0_other_with_cast._type_1))
      return false;
    if (!equals_1(this._reifiedType, tmp0_other_with_cast._reifiedType))
      return false;
    if (!equals_1(this._kotlinType, tmp0_other_with_cast._kotlinType))
      return false;
    return true;
  };
  TypeInfo.$metadata$ = {
    simpleName: 'TypeInfo',
    kind: 'class',
    interfaces: []
  };
  var CALL_COROUTINE;
  function _get_closed_($this) {
    var tmp0_safe_receiver = $this._get_coroutineContext__22().get_70(Key_getInstance_3());
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver._get_isActive__23();
    return !(tmp1_elvis_lhs == null ? false : tmp1_elvis_lhs);
  }
  function executeWithinCallContext($this, requestData, $cont) {
    var tmp = new $executeWithinCallContextCOROUTINE$5($this, requestData, $cont);
    tmp._result = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_72();
  }
  function checkExtensions($this, requestData) {
    var tmp0_iterator = requestData._requiredCapabilities.iterator_64();
    while (tmp0_iterator.hasNext_31()) {
      var requestedExtension = tmp0_iterator.next_35();
      var tmp0_require_0 = $this._get_supportedCapabilities__1().contains_51(requestedExtension);
      if (!tmp0_require_0) {
        var message_1 = '' + "Engine doesn't support " + requestedExtension;
        throw IllegalArgumentException_init_$Create$_0(toString_1(message_1));
      }}
  }
  function _no_name_provided__183(this$0, $client, resultContinuation) {
    this._this$0_53 = this$0;
    this._$client = $client;
    CoroutineImpl_0.call(this, resultContinuation);
  }
  _no_name_provided__183.prototype.invoke_382 = function (_this__0, content, $cont) {
    var tmp = this.create_34(_this__0, content, $cont);
    tmp._result = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_72();
  };
  _no_name_provided__183.prototype.invoke_537 = function (p1, p2, $cont) {
    var tmp = (!(p1 == null) ? isInterface(p1, PipelineContext) : false) ? p1 : THROW_CCE();
    this.invoke_382(tmp, isObject(p2) ? p2 : THROW_CCE(), $cont);
    return Unit_getInstance();
  };
  _no_name_provided__183.prototype.doResume_72 = function () {
    var suspendResult = this._result;
    $sm: do
      try {
        var tmp = this._state_0;
        switch (tmp) {
          case 0:
            this._exceptionState = 3;
            var tmp_0 = this;
            var tmp_1 = this;
            tmp_1._tmp0_apply_00 = new HttpRequestBuilder();
            this._tmp0_apply_00.takeFromWithExecutionContext(this.__this__23._get_context__86());
            Unit_getInstance();
            this._tmp0_apply_00._body_0 = this._content_6;
            tmp_0._requestData1 = this._tmp0_apply_00.build_16();
            validateHeaders(this._requestData1);
            checkExtensions(this._this$0_53, this._requestData1);
            this._state_0 = 1;
            suspendResult = executeWithinCallContext(this._this$0_53, this._requestData1, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            this._responseData2 = suspendResult;
            this._call3 = HttpClientCall_0(this._$client, this._requestData1, this._responseData2);
            this._state_0 = 2;
            suspendResult = this.__this__23.proceedWith_1(this._call3, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 2:
            suspendResult;
            Unit_getInstance();
            return Unit_getInstance();
          case 3:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 3) {
          throw $p;
        } else {
          this._state_0 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  _no_name_provided__183.prototype.create_34 = function (_this__0, content, completion) {
    var i = new _no_name_provided__183(this._this$0_53, this._$client, completion);
    i.__this__23 = _this__0;
    i._content_6 = content;
    return i;
  };
  _no_name_provided__183.$metadata$ = {
    kind: 'class',
    interfaces: [],
    suspendArity: 2
  };
  function _no_name_provided__184(this$0, $requestData, resultContinuation) {
    this._this$0_54 = this$0;
    this._$requestData = $requestData;
    CoroutineImpl_0.call(this, resultContinuation);
  }
  _no_name_provided__184.prototype.invoke_266 = function (_this__0, $cont) {
    var tmp = this.create_38(_this__0, $cont);
    tmp._result = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_72();
  };
  _no_name_provided__184.prototype.invoke_542 = function (p1, $cont) {
    return this.invoke_266((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $cont);
  };
  _no_name_provided__184.prototype.doResume_72 = function () {
    var suspendResult = this._result;
    $sm: do
      try {
        var tmp = this._state_0;
        switch (tmp) {
          case 0:
            this._exceptionState = 2;
            if (_get_closed_(this._this$0_54)) {
              throw ClientEngineClosedException_init_$Create$(null, 1, null);
            }
            this._state_0 = 1;
            suspendResult = this._this$0_54.execute_16(this._$requestData, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            return suspendResult;
          case 2:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 2) {
          throw $p;
        } else {
          this._state_0 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  _no_name_provided__184.prototype.create_38 = function (_this__0, completion) {
    var i = new _no_name_provided__184(this._this$0_54, this._$requestData, completion);
    i.__this__24 = _this__0;
    return i;
  };
  _no_name_provided__184.$metadata$ = {
    kind: 'class',
    interfaces: [],
    suspendArity: 1
  };
  function $executeWithinCallContextCOROUTINE$5(_this_, requestData, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__25 = _this_;
    this._requestData = requestData;
  }
  $executeWithinCallContextCOROUTINE$5.prototype.doResume_72 = function () {
    var suspendResult = this._result;
    $sm: do
      try {
        var tmp = this._state_0;
        switch (tmp) {
          case 0:
            this._exceptionState = 3;
            this._state_0 = 1;
            suspendResult = createCallContext(this.__this__25, this._requestData._executionContext_0, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            this._callContext0 = suspendResult;
            makeShared(this._callContext0);
            this._context1 = this._callContext0.plus_28(new KtorCallContextElement(this._callContext0));
            this._state_0 = 2;
            suspendResult = async$default(this.__this__25, this._context1, null, _no_name_provided_$factory_144(this.__this__25, this._requestData, null), 2, null).await_2(this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 2:
            return suspendResult;
          case 3:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 3) {
          throw $p;
        } else {
          this._state_0 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $executeWithinCallContextCOROUTINE$5.$metadata$ = {
    simpleName: '$executeWithinCallContextCOROUTINE$5',
    kind: 'class',
    interfaces: []
  };
  function HttpClientEngine() {
  }
  HttpClientEngine.prototype._get_supportedCapabilities__1 = function () {
    return emptySet();
  };
  HttpClientEngine.prototype.install_19 = function (client) {
    var tmp = Phases_getInstance_0()._Engine;
    client._sendPipeline.intercept(tmp, _no_name_provided_$factory_143(this, client, null));
  };
  HttpClientEngine.$metadata$ = {
    simpleName: 'HttpClientEngine',
    kind: 'interface',
    interfaces: [CoroutineScope, Closeable]
  };
  function validateHeaders(request) {
    var requestHeaders = request._headers_2;
    var tmp0_iterator = HttpHeaders_getInstance()._UnsafeHeadersList.iterator_64();
    while (tmp0_iterator.hasNext_31()) {
      var header = tmp0_iterator.next_35();
      if (requestHeaders.contains_56(header)) {
        throw new UnsafeHeaderException(header);
      }}
  }
  function HttpClientEngineFactory() {
  }
  HttpClientEngineFactory.$metadata$ = {
    simpleName: 'HttpClientEngineFactory',
    kind: 'interface',
    interfaces: []
  };
  function _no_name_provided_$factory_143(this$0, $client, resultContinuation) {
    var i = new _no_name_provided__183(this$0, $client, resultContinuation);
    var l = function (p1, p2, $cont) {
      return i.invoke_382(p1, p2, $cont);
    };
    l.$arity = 2;
    return l;
  }
  function _no_name_provided_$factory_144(this$0, $requestData, resultContinuation) {
    var i = new _no_name_provided__184(this$0, $requestData, resultContinuation);
    var l = function (p1, $cont) {
      return i.invoke_266(p1, $cont);
    };
    l.$arity = 1;
    return l;
  }
  function ClientEngineClosedException_init_$Init$(cause, $mask0, $marker, $this) {
    if (!(($mask0 & 1) === 0))
      cause = null;
    ClientEngineClosedException.call($this, cause);
    return $this;
  }
  function ClientEngineClosedException_init_$Create$(cause, $mask0, $marker) {
    var tmp = ClientEngineClosedException_init_$Init$(cause, $mask0, $marker, Object.create(ClientEngineClosedException.prototype));
    captureStack(tmp, ClientEngineClosedException_init_$Create$);
    return tmp;
  }
  function ClientEngineClosedException(cause) {
    IllegalStateException_init_$Init$_0('Client already closed', this);
    this._cause_1 = cause;
    captureStack(this, ClientEngineClosedException);
  }
  ClientEngineClosedException.prototype._get_cause__54 = function () {
    return this._cause_1;
  };
  ClientEngineClosedException.$metadata$ = {
    simpleName: 'ClientEngineClosedException',
    kind: 'class',
    interfaces: []
  };
  Object.defineProperty(ClientEngineClosedException.prototype, 'cause', {
    configurable: true,
    get: ClientEngineClosedException.prototype._get_cause__54
  });
  function _no_name_provided__185(this$0) {
    this._this$0_55 = this$0;
  }
  _no_name_provided__185.prototype.invoke_540 = function () {
    return SilentSupervisor$default(null, 1, null).plus_28(this._this$0_55._get_dispatcher__0()).plus_28(new CoroutineName('' + this._this$0_55._engineName + '-context'));
  };
  _no_name_provided__185.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__186(this$0) {
    this._this$0_56 = this$0;
  }
  _no_name_provided__186.prototype.invoke_375 = function (it) {
    close_0(this._this$0_56._get_dispatcher__0());
    Unit_getInstance();
  };
  _no_name_provided__186.prototype.invoke_542 = function (p1) {
    this.invoke_375((p1 == null ? true : p1 instanceof Error) ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__186.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function HttpClientEngineBase(engineName) {
    this._engineName = engineName;
    this._closed_1 = atomic_0(false);
    var tmp = this;
    tmp._coroutineContext$delegate = lazy(_no_name_provided_$factory_145(this));
  }
  HttpClientEngineBase.prototype._get_coroutineContext__22 = function () {
    var tmp0_getValue_0 = this._coroutineContext$delegate;
    var tmp1_getValue_0 = coroutineContext$factory();
    return tmp0_getValue_0._get_value__33();
  };
  HttpClientEngineBase.prototype.close_39 = function () {
    if (!this._closed_1.compareAndSet$atomicfu(false, true))
      return Unit_getInstance();
    var tmp = this._get_coroutineContext__22().get_70(Key_getInstance_3());
    var tmp0_elvis_lhs = (!(tmp == null) ? isInterface(tmp, CompletableJob) : false) ? tmp : null;
    var tmp_0;
    if (tmp0_elvis_lhs == null) {
      return Unit_getInstance();
    } else {
      tmp_0 = tmp0_elvis_lhs;
    }
    var requestJob = tmp_0;
    requestJob.complete_3();
    Unit_getInstance();
    requestJob.invokeOnCompletion_22(_no_name_provided_$factory_146(this));
    Unit_getInstance();
  };
  HttpClientEngineBase.$metadata$ = {
    simpleName: 'HttpClientEngineBase',
    kind: 'class',
    interfaces: [HttpClientEngine]
  };
  function close_0(_this_) {
    var tmp;
    try {
      var tmp0_safe_receiver = isInterface(_this_, Closeable) ? _this_ : null;
      var tmp_0;
      if (tmp0_safe_receiver == null) {
        tmp_0 = null;
      } else {
        tmp0_safe_receiver.close_39();
        tmp_0 = Unit_getInstance();
      }
      tmp = tmp_0;
    } catch ($p) {
      var tmp_1;
      if ($p instanceof Error) {
        tmp_1 = Unit_getInstance();
      } else {
        {
          throw $p;
        }
      }
      tmp = tmp_1;
    }
    return tmp;
  }
  function coroutineContext$factory() {
    return getPropertyCallableRef('coroutineContext', 1, KProperty1, function (receiver) {
      return receiver._get_coroutineContext__22();
    }, null);
  }
  function _no_name_provided_$factory_145(this$0) {
    var i = new _no_name_provided__185(this$0);
    return function () {
      return i.invoke_540();
    };
  }
  function _no_name_provided_$factory_146(this$0) {
    var i = new _no_name_provided__186(this$0);
    return function (p1) {
      i.invoke_375(p1);
      return Unit_getInstance();
    };
  }
  var ENGINE_CAPABILITIES_KEY;
  var DEFAULT_CAPABILITIES;
  function HttpClientEngineCapability() {
  }
  HttpClientEngineCapability.$metadata$ = {
    simpleName: 'HttpClientEngineCapability',
    kind: 'interface',
    interfaces: []
  };
  function HttpClientEngineConfig() {
    this._threadsCount = 4;
    this._pipelining = false;
    this._proxy = null;
  }
  HttpClientEngineConfig.$metadata$ = {
    simpleName: 'HttpClientEngineConfig',
    kind: 'class',
    interfaces: []
  };
  var KTOR_DEFAULT_USER_AGENT;
  function Companion_63() {
    Companion_instance_62 = this;
  }
  Companion_63.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: [Key_0]
  };
  var Companion_instance_62;
  function Companion_getInstance_62() {
    if (Companion_instance_62 == null)
      new Companion_63();
    return Companion_instance_62;
  }
  function KtorCallContextElement(callContext_0) {
    Companion_getInstance_62();
    this._callContext = callContext_0;
  }
  KtorCallContextElement.prototype._get_key__47 = function () {
    return Companion_getInstance_62();
  };
  KtorCallContextElement.$metadata$ = {
    simpleName: 'KtorCallContextElement',
    kind: 'class',
    interfaces: [Element_0]
  };
  function callContext($cont) {
    return ensureNotNull($cont._get_context__86().get_70(Companion_getInstance_62()))._callContext;
  }
  function mergeHeaders(requestHeaders, content, block) {
    var tmp = buildHeaders(_no_name_provided_$factory_147(requestHeaders, content));
    tmp.forEach_7(_no_name_provided_$factory_148(block));
    var missingAgent = requestHeaders.get_69(HttpHeaders_getInstance()._UserAgent) == null ? content._get_headers__15().get_69(HttpHeaders_getInstance()._UserAgent) == null : false;
    if (missingAgent ? needUserAgent() : false) {
      block(HttpHeaders_getInstance()._UserAgent, KTOR_DEFAULT_USER_AGENT);
    }var tmp0_safe_receiver = content._get_contentType__6();
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.toString();
    var type = tmp1_elvis_lhs == null ? content._get_headers__15().get_69(HttpHeaders_getInstance()._ContentType) : tmp1_elvis_lhs;
    var tmp2_safe_receiver = content._get_contentLength__6();
    var tmp3_elvis_lhs = tmp2_safe_receiver == null ? null : tmp2_safe_receiver.toString();
    var length = tmp3_elvis_lhs == null ? content._get_headers__15().get_69(HttpHeaders_getInstance()._ContentLength) : tmp3_elvis_lhs;
    var tmp4_safe_receiver = type;
    if (tmp4_safe_receiver == null)
      null;
    else {
      block(HttpHeaders_getInstance()._ContentType, tmp4_safe_receiver);
      Unit_getInstance();
    }
    Unit_getInstance();
    var tmp5_safe_receiver = length;
    if (tmp5_safe_receiver == null)
      null;
    else {
      block(HttpHeaders_getInstance()._ContentLength, tmp5_safe_receiver);
      Unit_getInstance();
    }
    Unit_getInstance();
  }
  function needUserAgent() {
    return !PlatformUtils_getInstance()._IS_BROWSER;
  }
  function _no_name_provided__187($requestHeaders, $content) {
    this._$requestHeaders = $requestHeaders;
    this._$content = $content;
  }
  _no_name_provided__187.prototype.invoke_332 = function (_this__0) {
    _this__0.appendAll_1(this._$requestHeaders);
    _this__0.appendAll_1(this._$content._get_headers__15());
  };
  _no_name_provided__187.prototype.invoke_542 = function (p1) {
    this.invoke_332(p1 instanceof HeadersBuilder ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__187.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__188($block) {
    this._$block_1 = $block;
  }
  _no_name_provided__188.prototype.invoke_273 = function (key, values_5) {
    if (HttpHeaders_getInstance()._ContentLength === key)
      return Unit_getInstance();
    if (HttpHeaders_getInstance()._ContentType === key)
      return Unit_getInstance();
    this._$block_1(key, joinToString$default_0(values_5, ',', null, null, 0, null, null, 62, null));
  };
  _no_name_provided__188.prototype.invoke_537 = function (p1, p2) {
    var tmp = (!(p1 == null) ? typeof p1 === 'string' : false) ? p1 : THROW_CCE();
    this.invoke_273(tmp, (!(p2 == null) ? isInterface(p2, List) : false) ? p2 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__188.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided_$factory_147($requestHeaders, $content) {
    var i = new _no_name_provided__187($requestHeaders, $content);
    return function (p1) {
      i.invoke_332(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_148($block) {
    var i = new _no_name_provided__188($block);
    return function (p1, p2) {
      i.invoke_273(p1, p2);
      return Unit_getInstance();
    };
  }
  function defaultRequest(_this_, block) {
    var tmp = Feature_getInstance();
    _this_.install(tmp, _no_name_provided_$factory_149(block));
  }
  function _no_name_provided__189($feature, resultContinuation) {
    this._$feature_0 = $feature;
    CoroutineImpl_0.call(this, resultContinuation);
  }
  _no_name_provided__189.prototype.invoke_382 = function (_this__0, it, $cont) {
    var tmp = this.create_34(_this__0, it, $cont);
    tmp._result = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_72();
  };
  _no_name_provided__189.prototype.invoke_537 = function (p1, p2, $cont) {
    var tmp = (!(p1 == null) ? isInterface(p1, PipelineContext) : false) ? p1 : THROW_CCE();
    this.invoke_382(tmp, isObject(p2) ? p2 : THROW_CCE(), $cont);
    return Unit_getInstance();
  };
  _no_name_provided__189.prototype.doResume_72 = function () {
    var suspendResult = this._result;
    $sm: do
      try {
        var tmp = this._state_0;
        if (tmp === 0) {
          this._exceptionState = 1;
          var tmp0_apply_0 = this.__this__26._get_context__86();
          var tmp1_apply_0 = this._$feature_0._builder_1;
          tmp1_apply_0(tmp0_apply_0);
          Unit_getInstance();
          return Unit_getInstance();
        } else if (tmp === 1) {
          throw this._exception_0;
        }} catch ($p) {
        throw $p;
      }
     while (true);
  };
  _no_name_provided__189.prototype.create_34 = function (_this__0, it, completion) {
    var i = new _no_name_provided__189(this._$feature_0, completion);
    i.__this__26 = _this__0;
    i._it = it;
    return i;
  };
  _no_name_provided__189.$metadata$ = {
    kind: 'class',
    interfaces: [],
    suspendArity: 2
  };
  function Feature() {
    Feature_instance = this;
    this._key_5 = new AttributeKey('DefaultRequest');
  }
  Feature.prototype._get_key__47 = function () {
    return this._key_5;
  };
  Feature.prototype.prepare = function (block) {
    return new DefaultRequest(block);
  };
  Feature.prototype.prepare_17 = function (block) {
    return this.prepare(block);
  };
  Feature.prototype.install_4 = function (feature_0, scope_0) {
    var tmp = Phases_getInstance()._Before;
    scope_0._requestPipeline.intercept(tmp, _no_name_provided_$factory_150(feature_0, null));
  };
  Feature.prototype.install_23 = function (feature_0, scope_0) {
    return this.install_4(feature_0 instanceof DefaultRequest ? feature_0 : THROW_CCE(), scope_0);
  };
  Feature.$metadata$ = {
    simpleName: 'Feature',
    kind: 'object',
    interfaces: [HttpClientFeature]
  };
  var Feature_instance;
  function Feature_getInstance() {
    if (Feature_instance == null)
      new Feature();
    return Feature_instance;
  }
  function DefaultRequest(builder) {
    Feature_getInstance();
    this._builder_1 = builder;
  }
  DefaultRequest.$metadata$ = {
    simpleName: 'DefaultRequest',
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__190($block) {
    this._$block_2 = $block;
  }
  _no_name_provided__190.prototype.invoke_394 = function (_this__0) {
    this._$block_2(_this__0);
  };
  _no_name_provided__190.prototype.invoke_542 = function (p1) {
    this.invoke_394(p1 instanceof HttpRequestBuilder ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__190.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided_$factory_149($block) {
    var i = new _no_name_provided__190($block);
    return function (p1) {
      i.invoke_394(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_150($feature, resultContinuation) {
    var i = new _no_name_provided__189($feature, resultContinuation);
    var l = function (p1, p2, $cont) {
      return i.invoke_382(p1, p2, $cont);
    };
    l.$arity = 2;
    return l;
  }
  var ValidateMark;
  function addDefaultResponseValidation(_this_) {
    HttpResponseValidator(_this_, _no_name_provided_$factory_151(_this_));
  }
  function RedirectResponseException(response, cachedResponseText) {
    ResponseException.call(this, response, cachedResponseText);
    this._message_3 = '' + 'Unhandled redirect: ' + response._get_call__4()._get_request__0()._get_url__1() + '. Status: ' + response._get_status__1() + '. Text: "' + cachedResponseText + '"';
    captureStack(this, RedirectResponseException);
  }
  RedirectResponseException.prototype._get_message__52 = function () {
    return this._message_3;
  };
  RedirectResponseException.$metadata$ = {
    simpleName: 'RedirectResponseException',
    kind: 'class',
    interfaces: []
  };
  Object.defineProperty(RedirectResponseException.prototype, 'message', {
    configurable: true,
    get: RedirectResponseException.prototype._get_message__52
  });
  function ClientRequestException(response, cachedResponseText) {
    ResponseException.call(this, response, cachedResponseText);
    this._message_4 = '' + 'Client request(' + response._get_call__4()._get_request__0()._get_url__1() + ') invalid: ' + response._get_status__1() + '. Text: "' + cachedResponseText + '"';
    captureStack(this, ClientRequestException);
  }
  ClientRequestException.prototype._get_message__52 = function () {
    return this._message_4;
  };
  ClientRequestException.$metadata$ = {
    simpleName: 'ClientRequestException',
    kind: 'class',
    interfaces: []
  };
  Object.defineProperty(ClientRequestException.prototype, 'message', {
    configurable: true,
    get: ClientRequestException.prototype._get_message__52
  });
  function ServerResponseException(response, cachedResponseText) {
    ResponseException.call(this, response, cachedResponseText);
    this._message_5 = '' + 'Server error(' + response._get_call__4()._get_request__0()._get_url__1() + ': ' + response._get_status__1() + '. Text: "' + cachedResponseText + '"';
    captureStack(this, ServerResponseException);
  }
  ServerResponseException.prototype._get_message__52 = function () {
    return this._message_5;
  };
  ServerResponseException.$metadata$ = {
    simpleName: 'ServerResponseException',
    kind: 'class',
    interfaces: []
  };
  Object.defineProperty(ServerResponseException.prototype, 'message', {
    configurable: true,
    get: ServerResponseException.prototype._get_message__52
  });
  function ResponseException(response, cachedResponseText) {
    IllegalStateException_init_$Init$_0('' + 'Bad response: ' + response + '. Text: "' + cachedResponseText + '"', this);
    this.__response$delegate = threadLocal(response);
    captureStack(this, ResponseException);
  }
  ResponseException.$metadata$ = {
    simpleName: 'ResponseException',
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__191(resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
  }
  _no_name_provided__191.prototype.invoke_279 = function (response, $cont) {
    var tmp = this.create_23(response, $cont);
    tmp._result = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_72();
  };
  _no_name_provided__191.prototype.invoke_542 = function (p1, $cont) {
    this.invoke_279(p1 instanceof HttpResponse ? p1 : THROW_CCE(), $cont);
    return Unit_getInstance();
  };
  _no_name_provided__191.prototype.doResume_72 = function () {
    var suspendResult = this._result;
    $sm: do
      try {
        var tmp = this._state_0;
        switch (tmp) {
          case 0:
            this._exceptionState = 3;
            this._statusCode0 = this._response_0._get_status__1()._value_32;
            this._originCall1 = this._response_0._get_call__4();
            if (this._statusCode0 < 300 ? true : this._originCall1._get_attributes__12().contains_52(ValidateMark))
              return Unit_getInstance();
            this._state_0 = 1;
            suspendResult = save(this._originCall1, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            this._tmp0_apply_02 = suspendResult;
            this._tmp0_apply_02._get_attributes__12().put_13(ValidateMark, Unit_getInstance());
            this._exceptionCall3 = this._tmp0_apply_02;
            this._exceptionResponse4 = this._exceptionCall3._get_response__0();
            this._state_0 = 2;
            suspendResult = readText$default_0(this._exceptionResponse4, null, 1, null, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 2:
            var exceptionResponseText = suspendResult;
            var tmp0_subject = this._statusCode0;
            if (300 <= tmp0_subject ? tmp0_subject <= 399 : false)
              throw new RedirectResponseException(this._exceptionResponse4, exceptionResponseText);
            else if (400 <= tmp0_subject ? tmp0_subject <= 499 : false)
              throw new ClientRequestException(this._exceptionResponse4, exceptionResponseText);
            else if (500 <= tmp0_subject ? tmp0_subject <= 599 : false)
              throw new ServerResponseException(this._exceptionResponse4, exceptionResponseText);
            else
              throw new ResponseException(this._exceptionResponse4, exceptionResponseText);
            return Unit_getInstance();
          case 3:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 3) {
          throw $p;
        } else {
          this._state_0 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  _no_name_provided__191.prototype.create_23 = function (response, completion) {
    var i = new _no_name_provided__191(completion);
    i._response_0 = response;
    return i;
  };
  _no_name_provided__191.$metadata$ = {
    kind: 'class',
    interfaces: [],
    suspendArity: 1
  };
  function _no_name_provided__192($this_addDefaultResponseValidation) {
    this._$this_addDefaultResponseValidation = $this_addDefaultResponseValidation;
  }
  _no_name_provided__192.prototype.invoke_281 = function (_this__0) {
    _this__0._expectSuccess = this._$this_addDefaultResponseValidation._get_expectSuccess_();
    _this__0.validateResponse(_no_name_provided_$factory_152(null));
  };
  _no_name_provided__192.prototype.invoke_542 = function (p1) {
    this.invoke_281(p1 instanceof Config ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__192.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided_$factory_151($this_addDefaultResponseValidation) {
    var i = new _no_name_provided__192($this_addDefaultResponseValidation);
    return function (p1) {
      i.invoke_281(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_152(resultContinuation) {
    var i = new _no_name_provided__191(resultContinuation);
    var l = function (p1, $cont) {
      return i.invoke_279(p1, $cont);
    };
    l.$arity = 1;
    return l;
  }
  function defaultTransformers(_this_) {
    var client = _this_;
    var tmp = Phases_getInstance()._Render;
    _this_._requestPipeline.intercept(tmp, _no_name_provided_$factory_153(null));
    var tmp_0 = Phases_getInstance_1()._Parse;
    _this_._responsePipeline.intercept(tmp_0, _no_name_provided_$factory_154(client, null));
    platformDefaultTransformers(_this_);
  }
  function _no_name_provided__193($contentType, $body) {
    this._$contentType = $contentType;
    this._$body = $body;
    ByteArrayContent.call(this);
    var tmp = this;
    var tmp0_elvis_lhs = this._$contentType;
    tmp._contentType_1 = tmp0_elvis_lhs == null ? Application_getInstance()._OctetStream : tmp0_elvis_lhs;
    this._contentLength = toLong_0(this._$body.length);
  }
  _no_name_provided__193.prototype._get_contentType__6 = function () {
    return this._contentType_1;
  };
  _no_name_provided__193.prototype._get_contentLength__6 = function () {
    return this._contentLength;
  };
  _no_name_provided__193.prototype.bytes_1 = function () {
    return this._$body;
  };
  _no_name_provided__193.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__194($contentType, $body) {
    this._$contentType_0 = $contentType;
    this._$body_0 = $body;
    ReadChannelContent.call(this);
    var tmp = this;
    var tmp0_elvis_lhs = this._$contentType_0;
    tmp._contentType_2 = tmp0_elvis_lhs == null ? Application_getInstance()._OctetStream : tmp0_elvis_lhs;
  }
  _no_name_provided__194.prototype._get_contentType__6 = function () {
    return this._contentType_2;
  };
  _no_name_provided__194.prototype.readFrom_0 = function () {
    return this._$body_0;
  };
  _no_name_provided__194.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__195(resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
  }
  _no_name_provided__195.prototype.invoke_382 = function (_this__0, body, $cont) {
    var tmp = this.create_34(_this__0, body, $cont);
    tmp._result = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_72();
  };
  _no_name_provided__195.prototype.invoke_537 = function (p1, p2, $cont) {
    var tmp = (!(p1 == null) ? isInterface(p1, PipelineContext) : false) ? p1 : THROW_CCE();
    this.invoke_382(tmp, isObject(p2) ? p2 : THROW_CCE(), $cont);
    return Unit_getInstance();
  };
  _no_name_provided__195.prototype.doResume_72 = function () {
    var suspendResult = this._result;
    $sm: do
      try {
        var tmp = this._state_0;
        switch (tmp) {
          case 0:
            this._exceptionState = 3;
            if (this.__this__27._get_context__86()._headers_1.get_69(HttpHeaders_getInstance()._Accept) == null) {
              this.__this__27._get_context__86()._headers_1.append_35(HttpHeaders_getInstance()._Accept, '*/*');
            }
            var tmp_0 = this;
            var tmp0_safe_receiver = this.__this__27._get_context__86()._headers_1.get_69(HttpHeaders_getInstance()._ContentType);
            var tmp_1;
            if (tmp0_safe_receiver == null) {
              tmp_1 = null;
            } else {
              tmp_1 = Companion_getInstance_46().parse_0(tmp0_safe_receiver);
            }

            tmp_0._contentType0 = tmp_1;
            var tmp_2 = this;
            var tmp1_subject = this._body;
            var tmp_3;
            if (typeof tmp1_subject === 'string') {
              var tmp_4 = this._body;
              var tmp2_elvis_lhs = this._contentType0;
              var tmp_5 = tmp2_elvis_lhs == null ? Text_getInstance()._Plain : tmp2_elvis_lhs;
              tmp_3 = TextContent_init_$Create$(tmp_4, tmp_5, null, 4, null);
            } else {
              if (isByteArray(tmp1_subject)) {
                tmp_3 = new _no_name_provided__193(this._contentType0, this._body);
              } else {
                if (isInterface(tmp1_subject, ByteReadChannel_1)) {
                  tmp_3 = new _no_name_provided__194(this._contentType0, this._body);
                } else {
                  {
                    tmp_3 = null;
                  }
                }
              }
            }

            tmp_2._content1 = tmp_3;
            if (!(this._content1 == null)) {
              this.__this__27._get_context__86()._headers_1.remove_52(HttpHeaders_getInstance()._ContentType);
              this._state_0 = 1;
              suspendResult = this.__this__27.proceedWith_1(this._content1, this);
              if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
                return suspendResult;
              }continue $sm;
            } else {
              this._state_0 = 2;
              continue $sm;
            }

            break;
          case 1:
            suspendResult;
            Unit_getInstance();
            this._state_0 = 2;
            continue $sm;
          case 2:
            return Unit_getInstance();
          case 3:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 3) {
          throw $p;
        } else {
          this._state_0 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  _no_name_provided__195.prototype.create_34 = function (_this__0, body, completion) {
    var i = new _no_name_provided__195(completion);
    i.__this__27 = _this__0;
    i._body = body;
    return i;
  };
  _no_name_provided__195.$metadata$ = {
    kind: 'class',
    interfaces: [],
    suspendArity: 2
  };
  function _no_name_provided__196($body, $response, resultContinuation) {
    this._$body_1 = $body;
    this._$response = $response;
    CoroutineImpl_0.call(this, resultContinuation);
  }
  _no_name_provided__196.prototype.invoke_361 = function (_this__0, $cont) {
    var tmp = this.create_28(_this__0, $cont);
    tmp._result = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_72();
  };
  _no_name_provided__196.prototype.invoke_542 = function (p1, $cont) {
    this.invoke_361((!(p1 == null) ? isInterface(p1, WriterScope) : false) ? p1 : THROW_CCE(), $cont);
    return Unit_getInstance();
  };
  _no_name_provided__196.prototype.doResume_72 = function () {
    var suspendResult = this._result;
    $sm: do
      try {
        var tmp = this._state_0;
        switch (tmp) {
          case 0:
            this._exceptionState = 5;
            this._state_0 = 1;
            continue $sm;
          case 1:
            this._exceptionState = 4;
            this._exceptionState = 3;
            this._state_0 = 2;
            suspendResult = copyTo(this._$body_1, this.__this__28._get_channel__2(), new Long(-1, 2147483647), this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 2:
            var tmp_0 = this;
            suspendResult;
            tmp_0._tmp$ret$00 = Unit_getInstance();
            this._exceptionState = 5;
            this._state_0 = 6;
            continue $sm;
          case 3:
            this._exceptionState = 4;
            var tmp_1 = this._exception_0;
            if (tmp_1 instanceof CancellationException) {
              var cause = this._exception_0;
              var tmp_2 = this;
              cancel(this._$response, cause);
              throw cause;
            } else {
              {
                var tmp_3 = this._exception_0;
                if (tmp_3 instanceof Error) {
                  var cause_0 = this._exception_0;
                  var tmp_4 = this;
                  cancel_0(this._$response, 'Receive failed', cause_0);
                  throw cause_0;
                } else {
                  {
                    throw this._exception_0;
                  }
                }
              }
            }

            break;
          case 4:
            this._exceptionState = 5;
            var t = this._exception_0;
            complete(this._$response);
            throw t;
          case 5:
            throw this._exception_0;
          case 6:
            complete(this._$response);
            return Unit_getInstance();
        }
      } catch ($p) {
        if (this._exceptionState === 5) {
          throw $p;
        } else {
          this._state_0 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  _no_name_provided__196.prototype.create_28 = function (_this__0, completion) {
    var i = new _no_name_provided__196(this._$body_1, this._$response, completion);
    i.__this__28 = _this__0;
    return i;
  };
  _no_name_provided__196.$metadata$ = {
    kind: 'class',
    interfaces: [],
    suspendArity: 1
  };
  function _no_name_provided__197($responseJobHolder) {
    this._$responseJobHolder = $responseJobHolder;
  }
  _no_name_provided__197.prototype.invoke_375 = function (it) {
    this._$responseJobHolder.complete_3();
    Unit_getInstance();
  };
  _no_name_provided__197.prototype.invoke_542 = function (p1) {
    this.invoke_375((p1 == null ? true : p1 instanceof Error) ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__197.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__198($client, resultContinuation) {
    this._$client_0 = $client;
    CoroutineImpl_0.call(this, resultContinuation);
  }
  _no_name_provided__198.prototype.invoke_384 = function (_this__0, _name_for_destructuring_parameter_0_, $cont) {
    var tmp = this.create_35(_this__0, _name_for_destructuring_parameter_0_, $cont);
    tmp._result = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_72();
  };
  _no_name_provided__198.prototype.invoke_537 = function (p1, p2, $cont) {
    var tmp = (!(p1 == null) ? isInterface(p1, PipelineContext) : false) ? p1 : THROW_CCE();
    this.invoke_384(tmp, p2 instanceof HttpResponseContainer ? p2 : THROW_CCE(), $cont);
    return Unit_getInstance();
  };
  _no_name_provided__198.prototype.doResume_72 = function () {
    var suspendResult = this._result;
    $sm: do
      try {
        var tmp = this._state_0;
        switch (tmp) {
          case 0:
            this._exceptionState = 11;
            this._info0 = this.__name_for_destructuring_parameter_0_.component1_4();
            this._body1 = this.__name_for_destructuring_parameter_0_.component2_4();
            var tmp_0 = this._body1;
            if (!isInterface(tmp_0, ByteReadChannel_1))
              return Unit_getInstance();
            else {
            }

            this._response2 = this.__this__29._get_context__86()._get_response__0();
            var tmp_1 = this;
            var tmp0_safe_receiver = this._response2._get_headers__15().get_69(HttpHeaders_getInstance()._ContentLength);
            var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : toLong(tmp0_safe_receiver);
            tmp_1._contentLength3 = tmp1_elvis_lhs == null ? new Long(-1, 2147483647) : tmp1_elvis_lhs;
            this._tmp2_subject4 = this._info0._type_1;
            if (this._tmp2_subject4.equals(getKClass_0(Unit))) {
              cancel_3(this._body1);
              Unit_getInstance();
              this._state_0 = 9;
              suspendResult = this.__this__29.proceedWith_1(new HttpResponseContainer(this._info0, Unit_getInstance()), this);
              if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
                return suspendResult;
              }continue $sm;
            } else {
              if (this._tmp2_subject4.equals(PrimitiveClasses_getInstance()._get_intClass_())) {
                this._state_0 = 7;
                suspendResult = readRemaining(this._body1, this);
                if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
                  return suspendResult;
                }continue $sm;
              } else {
                if (this._tmp2_subject4.equals(getKClass_0(ByteReadPacket)) ? true : this._tmp2_subject4.equals(getKClass_0(Input))) {
                  this._state_0 = 5;
                  suspendResult = readRemaining(this._body1, this);
                  if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
                    return suspendResult;
                  }continue $sm;
                } else {
                  if (this._tmp2_subject4.equals(PrimitiveClasses_getInstance()._get_byteArrayClass_())) {
                    this._state_0 = 3;
                    suspendResult = readRemaining_0(this._body1, this._contentLength3, this);
                    if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
                      return suspendResult;
                    }continue $sm;
                  } else {
                    if (this._tmp2_subject4.equals(getKClass_0(ByteReadChannel_1))) {
                      this._responseJobHolder5 = Job_0(this._response2._get_coroutineContext__22().get_70(Key_getInstance_3()));
                      var tmp_2 = this;
                      var tmp_3 = this;
                      tmp_3._tmp1_also_06 = writer$default(this.__this__29, this._$client_0._coroutineContext_1, false, _no_name_provided_$factory_155(this._body1, this._response2, null), 2, null);
                      this._tmp1_also_06.invokeOnCompletion_22(_no_name_provided_$factory_156(this._responseJobHolder5));
                      Unit_getInstance();
                      tmp_2._channel7 = this._tmp1_also_06._get_channel__2();
                      this._state_0 = 2;
                      suspendResult = this.__this__29.proceedWith_1(new HttpResponseContainer(this._info0, this._channel7), this);
                      if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
                        return suspendResult;
                      }continue $sm;
                    } else {
                      if (this._tmp2_subject4.equals(getKClass_0(HttpStatusCode))) {
                        cancel_3(this._body1);
                        Unit_getInstance();
                        this._state_0 = 1;
                        suspendResult = this.__this__29.proceedWith_1(new HttpResponseContainer(this._info0, this._response2._get_status__1()), this);
                        if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
                          return suspendResult;
                        }continue $sm;
                      } else {
                        this._state_0 = 10;
                        continue $sm;
                      }
                    }
                  }
                }
              }
            }

            break;
          case 1:
            suspendResult;
            Unit_getInstance();
            this._state_0 = 10;
            continue $sm;
          case 2:
            suspendResult;
            Unit_getInstance();
            this._state_0 = 10;
            continue $sm;
          case 3:
            this._readRemaining8 = suspendResult;
            if (this._contentLength3.compareTo_69(new Long(-1, 2147483647)) < 0) {
              var tmp0_check_0 = this._readRemaining8._get_remaining__2().equals(this._contentLength3);
              if (!tmp0_check_0) {
                var message_1 = '' + 'Expected ' + this._contentLength3 + ', actual ' + this._readRemaining8._get_remaining__2();
                throw IllegalStateException_init_$Create$(toString_1(message_1));
              }}
            this._state_0 = 4;
            suspendResult = this.__this__29.proceedWith_1(new HttpResponseContainer(this._info0, readBytes$default(this._readRemaining8, 0, 1, null)), this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 4:
            suspendResult;
            Unit_getInstance();
            this._state_0 = 10;
            continue $sm;
          case 5:
            this._ARGUMENT9 = suspendResult;
            this._ARGUMENT10 = new HttpResponseContainer(this._info0, this._ARGUMENT9);
            this._state_0 = 6;
            suspendResult = this.__this__29.proceedWith_1(this._ARGUMENT10, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 6:
            suspendResult;
            Unit_getInstance();
            this._state_0 = 10;
            continue $sm;
          case 7:
            this._ARGUMENT11 = suspendResult;
            var tmp_4 = this;
            tmp_4._ARGUMENT12 = this._ARGUMENT11.readText$default_2(0, 0, 3, null);
            this._ARGUMENT13 = toInt(this._ARGUMENT12);
            this._ARGUMENT14 = new HttpResponseContainer(this._info0, this._ARGUMENT13);
            this._state_0 = 8;
            suspendResult = this.__this__29.proceedWith_1(this._ARGUMENT14, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 8:
            suspendResult;
            Unit_getInstance();
            this._state_0 = 10;
            continue $sm;
          case 9:
            suspendResult;
            Unit_getInstance();
            this._state_0 = 10;
            continue $sm;
          case 10:
            return Unit_getInstance();
          case 11:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 11) {
          throw $p;
        } else {
          this._state_0 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  _no_name_provided__198.prototype.create_35 = function (_this__0, _name_for_destructuring_parameter_0_, completion) {
    var i = new _no_name_provided__198(this._$client_0, completion);
    i.__this__29 = _this__0;
    i.__name_for_destructuring_parameter_0_ = _name_for_destructuring_parameter_0_;
    return i;
  };
  _no_name_provided__198.$metadata$ = {
    kind: 'class',
    interfaces: [],
    suspendArity: 2
  };
  function _no_name_provided_$factory_153(resultContinuation) {
    var i = new _no_name_provided__195(resultContinuation);
    var l = function (p1, p2, $cont) {
      return i.invoke_382(p1, p2, $cont);
    };
    l.$arity = 2;
    return l;
  }
  function _no_name_provided_$factory_154($client, resultContinuation) {
    var i = new _no_name_provided__198($client, resultContinuation);
    var l = function (p1, p2, $cont) {
      return i.invoke_384(p1, p2, $cont);
    };
    l.$arity = 2;
    return l;
  }
  function _no_name_provided_$factory_155($body, $response, resultContinuation) {
    var i = new _no_name_provided__196($body, $response, resultContinuation);
    var l = function (p1, $cont) {
      return i.invoke_361(p1, $cont);
    };
    l.$arity = 1;
    return l;
  }
  function _no_name_provided_$factory_156($responseJobHolder) {
    var i = new _no_name_provided__197($responseJobHolder);
    return function (p1) {
      i.invoke_375(p1);
      return Unit_getInstance();
    };
  }
  var ExpectSuccessAttributeKey;
  function HttpResponseValidator(_this_, block) {
    _this_.install(Companion_getInstance_63(), block);
  }
  function _no_name_provided__199($feature, resultContinuation) {
    this._$feature_1 = $feature;
    CoroutineImpl_0.call(this, resultContinuation);
  }
  _no_name_provided__199.prototype.invoke_382 = function (_this__0, it, $cont) {
    var tmp = this.create_34(_this__0, it, $cont);
    tmp._result = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_72();
  };
  _no_name_provided__199.prototype.invoke_537 = function (p1, p2, $cont) {
    var tmp = (!(p1 == null) ? isInterface(p1, PipelineContext) : false) ? p1 : THROW_CCE();
    this.invoke_382(tmp, isObject(p2) ? p2 : THROW_CCE(), $cont);
    return Unit_getInstance();
  };
  _no_name_provided__199.prototype.doResume_72 = function () {
    var suspendResult = this._result;
    $sm: do
      try {
        var tmp = this._state_0;
        switch (tmp) {
          case 0:
            this._exceptionState = 5;
            this._exceptionState = 3;
            this._state_0 = 1;
            suspendResult = this.__this__30.proceedWith_1(this._it_0, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            suspendResult;
            Unit_getInstance();
            this._exceptionState = 5;
            this._state_0 = 2;
            continue $sm;
          case 2:
            this._exceptionState = 5;
            return Unit_getInstance();
          case 3:
            this._exceptionState = 5;
            var tmp_0 = this._exception_0;
            if (tmp_0 instanceof Error) {
              this._cause0 = this._exception_0;
              this._unwrappedCause1 = unwrapCancellationException(this._cause0);
              this._state_0 = 4;
              suspendResult = processException(this._$feature_1, this._unwrappedCause1, this);
              if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
                return suspendResult;
              }continue $sm;
            } else {
              {
                throw this._exception_0;
              }
            }

            break;
          case 4:
            suspendResult;
            throw this._unwrappedCause1;
          case 5:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 5) {
          throw $p;
        } else {
          this._state_0 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  _no_name_provided__199.prototype.create_34 = function (_this__0, it, completion) {
    var i = new _no_name_provided__199(this._$feature_1, completion);
    i.__this__30 = _this__0;
    i._it_0 = it;
    return i;
  };
  _no_name_provided__199.$metadata$ = {
    kind: 'class',
    interfaces: [],
    suspendArity: 2
  };
  function _no_name_provided__200($feature, resultContinuation) {
    this._$feature_2 = $feature;
    CoroutineImpl_0.call(this, resultContinuation);
  }
  _no_name_provided__200.prototype.invoke_384 = function (_this__0, container, $cont) {
    var tmp = this.create_35(_this__0, container, $cont);
    tmp._result = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_72();
  };
  _no_name_provided__200.prototype.invoke_537 = function (p1, p2, $cont) {
    var tmp = (!(p1 == null) ? isInterface(p1, PipelineContext) : false) ? p1 : THROW_CCE();
    this.invoke_384(tmp, p2 instanceof HttpResponseContainer ? p2 : THROW_CCE(), $cont);
    return Unit_getInstance();
  };
  _no_name_provided__200.prototype.doResume_72 = function () {
    var suspendResult = this._result;
    $sm: do
      try {
        var tmp = this._state_0;
        switch (tmp) {
          case 0:
            this._exceptionState = 5;
            this._exceptionState = 3;
            this._state_0 = 1;
            suspendResult = this.__this__31.proceedWith_1(this._container, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            suspendResult;
            Unit_getInstance();
            this._exceptionState = 5;
            this._state_0 = 2;
            continue $sm;
          case 2:
            this._exceptionState = 5;
            return Unit_getInstance();
          case 3:
            this._exceptionState = 5;
            var tmp_0 = this._exception_0;
            if (tmp_0 instanceof Error) {
              this._cause0_0 = this._exception_0;
              this._unwrappedCause1_0 = unwrapCancellationException(this._cause0_0);
              this._state_0 = 4;
              suspendResult = processException(this._$feature_2, this._unwrappedCause1_0, this);
              if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
                return suspendResult;
              }continue $sm;
            } else {
              {
                throw this._exception_0;
              }
            }

            break;
          case 4:
            suspendResult;
            throw this._unwrappedCause1_0;
          case 5:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 5) {
          throw $p;
        } else {
          this._state_0 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  _no_name_provided__200.prototype.create_35 = function (_this__0, container, completion) {
    var i = new _no_name_provided__200(this._$feature_2, completion);
    i.__this__31 = _this__0;
    i._container = container;
    return i;
  };
  _no_name_provided__200.$metadata$ = {
    kind: 'class',
    interfaces: [],
    suspendArity: 2
  };
  function _no_name_provided__201($feature, resultContinuation) {
    this._$feature_3 = $feature;
    CoroutineImpl_0.call(this, resultContinuation);
  }
  _no_name_provided__201.prototype.invoke_379 = function (_this__0, call, _anonymous_parameter_1_, $cont) {
    var tmp = this.create_33(_this__0, call, _anonymous_parameter_1_, $cont);
    tmp._result = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_72();
  };
  _no_name_provided__201.prototype.invoke_380 = function (p1, p2, p3, $cont) {
    var tmp = (!(p1 == null) ? isInterface(p1, Sender) : false) ? p1 : THROW_CCE();
    var tmp_0 = p2 instanceof HttpClientCall ? p2 : THROW_CCE();
    return this.invoke_379(tmp, tmp_0, p3 instanceof HttpRequestBuilder ? p3 : THROW_CCE(), $cont);
  };
  _no_name_provided__201.prototype.doResume_72 = function () {
    var suspendResult = this._result;
    $sm: do
      try {
        var tmp = this._state_0;
        switch (tmp) {
          case 0:
            this._exceptionState = 3;
            var tmp_0 = this;
            var tmp0_elvis_lhs = this._call_2._get_attributes__12().getOrNull_0(ExpectSuccessAttributeKey);
            tmp_0._expectSuccess0 = tmp0_elvis_lhs == null ? this._$feature_3._expectSuccess_0 : tmp0_elvis_lhs;
            if (this._expectSuccess0) {
              this._state_0 = 1;
              suspendResult = validateResponse(this._$feature_3, this._call_2._get_response__0(), this);
              if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
                return suspendResult;
              }continue $sm;
            } else {
              this._state_0 = 2;
              continue $sm;
            }

            break;
          case 1:
            suspendResult;
            this._state_0 = 2;
            continue $sm;
          case 2:
            return this._call_2;
          case 3:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 3) {
          throw $p;
        } else {
          this._state_0 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  _no_name_provided__201.prototype.create_33 = function (_this__0, call, _anonymous_parameter_1_, completion) {
    var i = new _no_name_provided__201(this._$feature_3, completion);
    i.__this__32 = _this__0;
    i._call_2 = call;
    i.__anonymous_parameter_1_ = _anonymous_parameter_1_;
    return i;
  };
  _no_name_provided__201.$metadata$ = {
    kind: 'class',
    interfaces: [],
    suspendArity: 3
  };
  function validateResponse($this, response, $cont) {
    var tmp = new $validateResponseCOROUTINE$6($this, response, $cont);
    tmp._result = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_72();
  }
  function processException($this, cause, $cont) {
    var tmp = new $processExceptionCOROUTINE$7($this, cause, $cont);
    tmp._result = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_72();
  }
  function Config() {
    var tmp = this;
    tmp._responseValidators = ArrayList_init_$Create$();
    var tmp_0 = this;
    tmp_0._responseExceptionHandlers = ArrayList_init_$Create$();
    this._expectSuccess = true;
  }
  Config.prototype.validateResponse = function (block) {
    var tmp0_this = this;
    var tmp0_plusAssign_0 = tmp0_this._responseValidators;
    tmp0_plusAssign_0.add_33(block);
    Unit_getInstance();
  };
  Config.$metadata$ = {
    simpleName: 'Config',
    kind: 'class',
    interfaces: []
  };
  function Companion_64() {
    Companion_instance_63 = this;
    this._key_6 = new AttributeKey('HttpResponseValidator');
  }
  Companion_64.prototype._get_key__47 = function () {
    return this._key_6;
  };
  Companion_64.prototype.prepare_4 = function (block) {
    var tmp0_apply_0 = new Config();
    block(tmp0_apply_0);
    var config = tmp0_apply_0;
    return new HttpCallValidator(reversed(config._responseValidators), reversed(config._responseExceptionHandlers), config._expectSuccess);
  };
  Companion_64.prototype.prepare_17 = function (block) {
    return this.prepare_4(block);
  };
  Companion_64.prototype.install_6 = function (feature_0, scope_0) {
    var tmp = Phases_getInstance()._Before;
    scope_0._requestPipeline.intercept(tmp, _no_name_provided_$factory_157(feature_0, null));
    var BeforeReceive = new PipelinePhase('BeforeReceive');
    scope_0._responsePipeline.insertPhaseBefore_0(Phases_getInstance_1()._Receive_0, BeforeReceive);
    scope_0._responsePipeline.intercept(BeforeReceive, _no_name_provided_$factory_158(feature_0, null));
    var tmp_0 = get(scope_0, Feature_getInstance_3());
    tmp_0.intercept_0(_no_name_provided_$factory_159(feature_0, null));
  };
  Companion_64.prototype.install_23 = function (feature_0, scope_0) {
    return this.install_6(feature_0 instanceof HttpCallValidator ? feature_0 : THROW_CCE(), scope_0);
  };
  Companion_64.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: [HttpClientFeature]
  };
  var Companion_instance_63;
  function Companion_getInstance_63() {
    if (Companion_instance_63 == null)
      new Companion_64();
    return Companion_instance_63;
  }
  function $validateResponseCOROUTINE$6(_this_, response, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__33 = _this_;
    this._response_1 = response;
  }
  $validateResponseCOROUTINE$6.prototype.doResume_72 = function () {
    var suspendResult = this._result;
    $sm: do
      try {
        var tmp = this._state_0;
        switch (tmp) {
          case 0:
            this._exceptionState = 4;
            var tmp_0 = this;
            tmp_0._tmp0_forEach_00 = this.__this__33._responseValidators_0;
            this._tmp0_iterator_11 = this._tmp0_forEach_00.iterator_64();
            this._state_0 = 1;
            continue $sm;
          case 1:
            if (!this._tmp0_iterator_11.hasNext_31()) {
              this._state_0 = 3;
              continue $sm;
            }
            this._element_22 = this._tmp0_iterator_11.next_35();
            this._state_0 = 2;
            suspendResult = this._element_22(this._response_1, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 2:
            suspendResult;
            this._state_0 = 1;
            continue $sm;
          case 3:
            return Unit_getInstance();
          case 4:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 4) {
          throw $p;
        } else {
          this._state_0 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $validateResponseCOROUTINE$6.$metadata$ = {
    simpleName: '$validateResponseCOROUTINE$6',
    kind: 'class',
    interfaces: []
  };
  function $processExceptionCOROUTINE$7(_this_, cause, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__34 = _this_;
    this._cause_2 = cause;
  }
  $processExceptionCOROUTINE$7.prototype.doResume_72 = function () {
    var suspendResult = this._result;
    $sm: do
      try {
        var tmp = this._state_0;
        switch (tmp) {
          case 0:
            this._exceptionState = 4;
            var tmp_0 = this;
            tmp_0._tmp0_forEach_00_0 = this.__this__34._callExceptionHandlers;
            this._tmp0_iterator_11_0 = this._tmp0_forEach_00_0.iterator_64();
            this._state_0 = 1;
            continue $sm;
          case 1:
            if (!this._tmp0_iterator_11_0.hasNext_31()) {
              this._state_0 = 3;
              continue $sm;
            }
            this._element_22_0 = this._tmp0_iterator_11_0.next_35();
            this._state_0 = 2;
            suspendResult = this._element_22_0(this._cause_2, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 2:
            suspendResult;
            this._state_0 = 1;
            continue $sm;
          case 3:
            return Unit_getInstance();
          case 4:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 4) {
          throw $p;
        } else {
          this._state_0 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $processExceptionCOROUTINE$7.$metadata$ = {
    simpleName: '$processExceptionCOROUTINE$7',
    kind: 'class',
    interfaces: []
  };
  function HttpCallValidator(responseValidators, callExceptionHandlers, expectSuccess) {
    Companion_getInstance_63();
    this._responseValidators_0 = responseValidators;
    this._callExceptionHandlers = callExceptionHandlers;
    this._expectSuccess_0 = expectSuccess;
  }
  HttpCallValidator.$metadata$ = {
    simpleName: 'HttpCallValidator',
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided_$factory_157($feature, resultContinuation) {
    var i = new _no_name_provided__199($feature, resultContinuation);
    var l = function (p1, p2, $cont) {
      return i.invoke_382(p1, p2, $cont);
    };
    l.$arity = 2;
    return l;
  }
  function _no_name_provided_$factory_158($feature, resultContinuation) {
    var i = new _no_name_provided__200($feature, resultContinuation);
    var l = function (p1, p2, $cont) {
      return i.invoke_384(p1, p2, $cont);
    };
    l.$arity = 2;
    return l;
  }
  function _no_name_provided_$factory_159($feature, resultContinuation) {
    var i = new _no_name_provided__201($feature, resultContinuation);
    var l = function (p1, p2, p3, $cont) {
      return i.invoke_379(p1, p2, p3, $cont);
    };
    l.$arity = 3;
    return l;
  }
  var FEATURE_INSTALLED_LIST;
  function HttpClientFeature() {
  }
  HttpClientFeature.$metadata$ = {
    simpleName: 'HttpClientFeature',
    kind: 'interface',
    interfaces: []
  };
  function get(_this_, feature_0) {
    var requestedFeature = feature(_this_, feature_0);
    if (!(requestedFeature == null)) {
      return requestedFeature;
    }var message = '' + 'Feature ' + feature_0 + ' is not installed. Consider using `install(' + feature_0._get_key__47() + ')` in client config first.';
    throw IllegalStateException_init_$Create$(toString_1(message));
  }
  function feature(_this_, feature_0) {
    var tmp0_safe_receiver = _this_._attributes_1.getOrNull_0(FEATURE_INSTALLED_LIST);
    return tmp0_safe_receiver == null ? null : tmp0_safe_receiver.getOrNull_0(feature_0._get_key__47());
  }
  function _no_name_provided__202($feature, resultContinuation) {
    this._$feature_4 = $feature;
    CoroutineImpl_0.call(this, resultContinuation);
  }
  _no_name_provided__202.prototype.invoke_382 = function (_this__0, content, $cont) {
    var tmp = this.create_34(_this__0, content, $cont);
    tmp._result = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_72();
  };
  _no_name_provided__202.prototype.invoke_537 = function (p1, p2, $cont) {
    var tmp = (!(p1 == null) ? isInterface(p1, PipelineContext) : false) ? p1 : THROW_CCE();
    this.invoke_382(tmp, isObject(p2) ? p2 : THROW_CCE(), $cont);
    return Unit_getInstance();
  };
  _no_name_provided__202.prototype.doResume_72 = function () {
    var suspendResult = this._result;
    $sm: do
      try {
        var tmp = this._state_0;
        switch (tmp) {
          case 0:
            this._exceptionState = 2;
            this._$feature_4.addCharsetHeaders(this.__this__35._get_context__86());
            var tmp_0 = this._content_7;
            if (!(typeof tmp_0 === 'string')) {
              return Unit_getInstance();
            } else {
            }

            this._contentType0_0 = contentType(this.__this__35._get_context__86());
            if (!(this._contentType0_0 == null) ? !(this._contentType0_0._contentType === Text_getInstance()._Plain._contentType) : false)
              return Unit_getInstance();
            var tmp_1 = this;
            var tmp0_safe_receiver = this._contentType0_0;
            tmp_1._contentCharset1 = tmp0_safe_receiver == null ? null : charset(tmp0_safe_receiver);
            this._state_0 = 1;
            suspendResult = this.__this__35.proceedWith_1(wrapContent(this._$feature_4, this._content_7, this._contentCharset1), this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            suspendResult;
            Unit_getInstance();
            return Unit_getInstance();
          case 2:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 2) {
          throw $p;
        } else {
          this._state_0 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  _no_name_provided__202.prototype.create_34 = function (_this__0, content, completion) {
    var i = new _no_name_provided__202(this._$feature_4, completion);
    i.__this__35 = _this__0;
    i._content_7 = content;
    return i;
  };
  _no_name_provided__202.$metadata$ = {
    kind: 'class',
    interfaces: [],
    suspendArity: 2
  };
  function _no_name_provided__203($feature, resultContinuation) {
    this._$feature_5 = $feature;
    CoroutineImpl_0.call(this, resultContinuation);
  }
  _no_name_provided__203.prototype.invoke_384 = function (_this__0, _name_for_destructuring_parameter_0_, $cont) {
    var tmp = this.create_35(_this__0, _name_for_destructuring_parameter_0_, $cont);
    tmp._result = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_72();
  };
  _no_name_provided__203.prototype.invoke_537 = function (p1, p2, $cont) {
    var tmp = (!(p1 == null) ? isInterface(p1, PipelineContext) : false) ? p1 : THROW_CCE();
    this.invoke_384(tmp, p2 instanceof HttpResponseContainer ? p2 : THROW_CCE(), $cont);
    return Unit_getInstance();
  };
  _no_name_provided__203.prototype.doResume_72 = function () {
    var suspendResult = this._result;
    $sm: do
      try {
        var tmp = this._state_0;
        switch (tmp) {
          case 0:
            this._exceptionState = 3;
            this._info0_0 = this.__name_for_destructuring_parameter_0__0.component1_4();
            this._body1_0 = this.__name_for_destructuring_parameter_0__0.component2_4();
            var tmp_0;
            if (!this._info0_0._type_1.equals(PrimitiveClasses_getInstance()._get_stringClass_())) {
              tmp_0 = true;
            } else {
              var tmp_1 = this._body1_0;
              tmp_0 = !isInterface(tmp_1, ByteReadChannel_1);
            }

            if (tmp_0)
              return Unit_getInstance();
            else {
            }

            this._state_0 = 1;
            suspendResult = readRemaining(this._body1_0, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            this._bodyBytes2 = suspendResult;
            this._content3 = this._$feature_5.read_1(this.__this__36._get_context__86(), this._bodyBytes2);
            this._state_0 = 2;
            suspendResult = this.__this__36.proceedWith_1(new HttpResponseContainer(this._info0_0, this._content3), this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 2:
            suspendResult;
            Unit_getInstance();
            return Unit_getInstance();
          case 3:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 3) {
          throw $p;
        } else {
          this._state_0 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  _no_name_provided__203.prototype.create_35 = function (_this__0, _name_for_destructuring_parameter_0_, completion) {
    var i = new _no_name_provided__203(this._$feature_5, completion);
    i.__this__36 = _this__0;
    i.__name_for_destructuring_parameter_0__0 = _name_for_destructuring_parameter_0_;
    return i;
  };
  _no_name_provided__203.$metadata$ = {
    kind: 'class',
    interfaces: [],
    suspendArity: 2
  };
  function Config_0() {
    var tmp = this;
    tmp._charsets = LinkedHashSet_init_$Create$();
    var tmp_0 = this;
    tmp_0._charsetQuality = LinkedHashMap_init_$Create$();
    this._sendCharset = null;
    this._responseCharsetFallback = Charsets_getInstance()._UTF_8;
    this._defaultCharset = Charsets_getInstance()._UTF_8;
  }
  Config_0.$metadata$ = {
    simpleName: 'Config',
    kind: 'class',
    interfaces: []
  };
  function Feature_0() {
    Feature_instance_0 = this;
    this._key_7 = new AttributeKey('HttpPlainText');
  }
  Feature_0.prototype._get_key__47 = function () {
    return this._key_7;
  };
  Feature_0.prototype.prepare_4 = function (block) {
    var tmp0_apply_0 = new Config_0();
    block(tmp0_apply_0);
    var config = tmp0_apply_0;
    return new HttpPlainText(config._charsets, config._charsetQuality, config._sendCharset, config._responseCharsetFallback);
  };
  Feature_0.prototype.prepare_17 = function (block) {
    return this.prepare_4(block);
  };
  Feature_0.prototype.install_9 = function (feature_0, scope_0) {
    var tmp = Phases_getInstance()._Render;
    scope_0._requestPipeline.intercept(tmp, _no_name_provided_$factory_162(feature_0, null));
    var tmp_0 = Phases_getInstance_1()._Parse;
    scope_0._responsePipeline.intercept(tmp_0, _no_name_provided_$factory_163(feature_0, null));
  };
  Feature_0.prototype.install_23 = function (feature_0, scope_0) {
    return this.install_9(feature_0 instanceof HttpPlainText ? feature_0 : THROW_CCE(), scope_0);
  };
  Feature_0.$metadata$ = {
    simpleName: 'Feature',
    kind: 'object',
    interfaces: [HttpClientFeature]
  };
  var Feature_instance_0;
  function Feature_getInstance_0() {
    if (Feature_instance_0 == null)
      new Feature_0();
    return Feature_instance_0;
  }
  function wrapContent($this, content, contentCharset) {
    var tmp0_elvis_lhs = contentCharset;
    var charset_1 = tmp0_elvis_lhs == null ? $this._requestCharset : tmp0_elvis_lhs;
    var tmp = withCharset(Text_getInstance()._Plain, charset_1);
    return TextContent_init_$Create$(content, tmp, null, 4, null);
  }
  function sam$kotlin_Comparator$0(function_0) {
    this._function_0 = function_0;
  }
  sam$kotlin_Comparator$0.prototype.compare_0 = function (a, b) {
    return this._function_0(a, b);
  };
  sam$kotlin_Comparator$0.prototype.compare = function (a, b) {
    return this.compare_0(a, b);
  };
  sam$kotlin_Comparator$0.$metadata$ = {
    simpleName: 'sam$kotlin_Comparator$0',
    kind: 'class',
    interfaces: [Comparator]
  };
  function _no_name_provided__204() {
  }
  _no_name_provided__204.prototype.invoke_301 = function (a, b) {
    return compareValues(b._second, a._second);
  };
  _no_name_provided__204.prototype.invoke_537 = function (p1, p2) {
    var tmp = p1 instanceof Pair ? p1 : THROW_CCE();
    return this.invoke_301(tmp, p2 instanceof Pair ? p2 : THROW_CCE());
  };
  _no_name_provided__204.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__205() {
  }
  _no_name_provided__205.prototype.invoke_303 = function (a, b) {
    var tmp = _get_name_(a);
    return compareValues(tmp, _get_name_(b));
  };
  _no_name_provided__205.prototype.invoke_537 = function (p1, p2) {
    var tmp = p1 instanceof Charset ? p1 : THROW_CCE();
    return this.invoke_303(tmp, p2 instanceof Charset ? p2 : THROW_CCE());
  };
  _no_name_provided__205.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function HttpPlainText(charsets, charsetQuality, sendCharset, responseCharsetFallback) {
    Feature_getInstance_0();
    this._responseCharsetFallback_0 = responseCharsetFallback;
    var tmp0_sortedByDescending_0 = toList_1(charsetQuality);
    var tmp = _no_name_provided_$factory_160();
    var withQuality = sortedWith(tmp0_sortedByDescending_0, new sam$kotlin_Comparator$0(tmp));
    var tmp0_filterTo_0_1 = ArrayList_init_$Create$();
    var tmp0_iterator_1_2 = charsets.iterator_64();
    while (tmp0_iterator_1_2.hasNext_31()) {
      var element_2_3 = tmp0_iterator_1_2.next_35();
      if (!charsetQuality.containsKey_16(element_2_3)) {
        tmp0_filterTo_0_1.add_33(element_2_3);
        Unit_getInstance();
      } else {
      }
    }
    var tmp1_sortedBy_0 = tmp0_filterTo_0_1;
    var tmp_0 = _no_name_provided_$factory_161();
    var withoutQuality = sortedWith(tmp1_sortedBy_0, new sam$kotlin_Comparator$0(tmp_0));
    var tmp_1 = this;
    var tmp0_apply_0_1 = StringBuilder_init_$Create$_0();
    var tmp0_iterator_1_3 = withoutQuality.iterator_64();
    while (tmp0_iterator_1_3.hasNext_31()) {
      var element_2_4 = tmp0_iterator_1_3.next_35();
      if (tmp0_apply_0_1._get_length__0() > 0) {
        tmp0_apply_0_1.append_7(',');
        Unit_getInstance();
      }tmp0_apply_0_1.append_7(_get_name_(element_2_4));
      Unit_getInstance();
    }
    var tmp0_iterator_1_5 = withQuality.iterator_64();
    while (tmp0_iterator_1_5.hasNext_31()) {
      var element_2_6 = tmp0_iterator_1_5.next_35();
      var charset_4_7 = element_2_6.component1_4();
      var quality_5_8 = element_2_6.component2_4();
      if (tmp0_apply_0_1._get_length__0() > 0) {
        tmp0_apply_0_1.append_7(',');
        Unit_getInstance();
      }var containsArg = quality_5_8;
      var tmp0_check_0_6_9 = 0.0 <= containsArg ? containsArg <= 1.0 : false;
      if (!tmp0_check_0_6_9) {
        var message_2_1_7_10 = 'Check failed.';
        throw IllegalStateException_init_$Create$(toString_1(message_2_1_7_10));
      }var tmp1_roundToInt_0_9_12 = 100 * quality_5_8;
      var truncatedQuality_8_11 = roundToInt(tmp1_roundToInt_0_9_12) / 100.0;
      tmp0_apply_0_1.append_7('' + _get_name_(charset_4_7) + ';q=' + truncatedQuality_8_11);
      Unit_getInstance();
    }
    if (charSequenceLength(tmp0_apply_0_1) === 0) {
      tmp0_apply_0_1.append_7(_get_name_(this._responseCharsetFallback_0));
      Unit_getInstance();
    } else {
    }
    tmp_1._acceptCharsetHeader = tmp0_apply_0_1.toString();
    var tmp_2 = this;
    var tmp0_elvis_lhs = sendCharset;
    var tmp2_elvis_lhs = tmp0_elvis_lhs == null ? firstOrNull_0(withoutQuality) : tmp0_elvis_lhs;
    var tmp_3;
    if (tmp2_elvis_lhs == null) {
      var tmp1_safe_receiver = firstOrNull_0(withQuality);
      tmp_3 = tmp1_safe_receiver == null ? null : tmp1_safe_receiver._first;
    } else {
      tmp_3 = tmp2_elvis_lhs;
    }
    var tmp3_elvis_lhs = tmp_3;
    tmp_2._requestCharset = tmp3_elvis_lhs == null ? Charsets_getInstance()._UTF_8 : tmp3_elvis_lhs;
  }
  HttpPlainText.prototype.read_1 = function (call, body) {
    var tmp0_elvis_lhs = charset_0(call._get_response__0());
    var actualCharset = tmp0_elvis_lhs == null ? this._responseCharsetFallback_0 : tmp0_elvis_lhs;
    return readText$default(body, actualCharset, 0, 2, null);
  };
  HttpPlainText.prototype.addCharsetHeaders = function (context) {
    if (!(context._headers_1.get_69(HttpHeaders_getInstance()._AcceptCharset) == null))
      return Unit_getInstance();
    context._headers_1.set_13(HttpHeaders_getInstance()._AcceptCharset, this._acceptCharsetHeader);
  };
  HttpPlainText.$metadata$ = {
    simpleName: 'HttpPlainText',
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided_$factory_160() {
    var i = new _no_name_provided__204();
    return function (p1, p2) {
      return i.invoke_301(p1, p2);
    };
  }
  function _no_name_provided_$factory_161() {
    var i = new _no_name_provided__205();
    return function (p1, p2) {
      return i.invoke_303(p1, p2);
    };
  }
  function _no_name_provided_$factory_162($feature, resultContinuation) {
    var i = new _no_name_provided__202($feature, resultContinuation);
    var l = function (p1, p2, $cont) {
      return i.invoke_382(p1, p2, $cont);
    };
    l.$arity = 2;
    return l;
  }
  function _no_name_provided_$factory_163($feature, resultContinuation) {
    var i = new _no_name_provided__203($feature, resultContinuation);
    var l = function (p1, p2, $cont) {
      return i.invoke_384(p1, p2, $cont);
    };
    l.$arity = 2;
    return l;
  }
  var ALLOWED_FOR_REDIRECT;
  function handleCall(_this_, $this, context, origin, allowHttpsDowngrade, $cont) {
    var tmp = new $handleCallCOROUTINE$8($this, _this_, context, origin, allowHttpsDowngrade, $cont);
    tmp._result = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_72();
  }
  function _no_name_provided__206($feature, resultContinuation) {
    this._$feature_6 = $feature;
    CoroutineImpl_0.call(this, resultContinuation);
  }
  _no_name_provided__206.prototype.invoke_379 = function (_this__0, origin, context, $cont) {
    var tmp = this.create_33(_this__0, origin, context, $cont);
    tmp._result = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_72();
  };
  _no_name_provided__206.prototype.invoke_380 = function (p1, p2, p3, $cont) {
    var tmp = (!(p1 == null) ? isInterface(p1, Sender) : false) ? p1 : THROW_CCE();
    var tmp_0 = p2 instanceof HttpClientCall ? p2 : THROW_CCE();
    return this.invoke_379(tmp, tmp_0, p3 instanceof HttpRequestBuilder ? p3 : THROW_CCE(), $cont);
  };
  _no_name_provided__206.prototype.doResume_72 = function () {
    var suspendResult = this._result;
    $sm: do
      try {
        var tmp = this._state_0;
        switch (tmp) {
          case 0:
            this._exceptionState = 2;
            if (this._$feature_6._get_checkHttpMethod_() ? !ALLOWED_FOR_REDIRECT.contains_51(this._origin_0._get_request__0()._get_method__1()) : false) {
              return this._origin_0;
            }
            this._state_0 = 1;
            suspendResult = handleCall(this.__this__37, Feature_getInstance_1(), this._context_4, this._origin_0, this._$feature_6._get_allowHttpsDowngrade_(), this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            return suspendResult;
          case 2:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 2) {
          throw $p;
        } else {
          this._state_0 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  _no_name_provided__206.prototype.create_33 = function (_this__0, origin, context, completion) {
    var i = new _no_name_provided__206(this._$feature_6, completion);
    i.__this__37 = _this__0;
    i._origin_0 = origin;
    i._context_4 = context;
    return i;
  };
  _no_name_provided__206.$metadata$ = {
    kind: 'class',
    interfaces: [],
    suspendArity: 3
  };
  function $handleCallCOROUTINE$8(_this_, _this__0, context, origin, allowHttpsDowngrade, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__38 = _this_;
    this.__this__39 = _this__0;
    this._context_5 = context;
    this._origin_1 = origin;
    this._allowHttpsDowngrade = allowHttpsDowngrade;
  }
  $handleCallCOROUTINE$8.prototype.doResume_72 = function () {
    var suspendResult = this._result;
    $sm: do
      try {
        var tmp = this._state_0;
        switch (tmp) {
          case 0:
            this._exceptionState = 3;
            if (!isRedirect(this._origin_1._get_response__0()._get_status__1()))
              return this._origin_1;
            this._call0 = this._origin_1;
            this._requestBuilder1 = this._context_5;
            this._originProtocol2 = this._origin_1._get_request__0()._get_url__1()._protocol_0;
            this._originAuthority3 = _get_authority_(this._origin_1._get_request__0()._get_url__1());
            this._state_0 = 1;
            continue $sm;
          case 1:
            if (false) {
              this._state_0 = 4;
              continue $sm;
            }
            this._location4 = this._call0._get_response__0()._get_headers__15().get_69(HttpHeaders_getInstance()._Location);
            var tmp_0 = this;
            var tmp_1 = this;
            tmp_1._tmp0_apply_05 = new HttpRequestBuilder();
            this._tmp0_apply_05.takeFromWithExecutionContext(this._requestBuilder1);
            Unit_getInstance();
            this._tmp0_apply_05._url_0._parameters_0.clear_27();
            var tmp0_safe_receiver_2 = this._location4;
            if (tmp0_safe_receiver_2 == null)
              null;
            else {
              takeFrom(this._tmp0_apply_05._url_0, tmp0_safe_receiver_2);
            }

            Unit_getInstance();
            if ((!this._allowHttpsDowngrade ? isSecure(this._originProtocol2) : false) ? !isSecure(this._tmp0_apply_05._url_0._protocol) : false) {
              return this._call0;
            }
            if (!(this._originAuthority3 === _get_authority__0(this._tmp0_apply_05._url_0))) {
              this._tmp0_apply_05._headers_1.remove_52(HttpHeaders_getInstance()._Authorization);
            }
            tmp_0._requestBuilder1 = this._tmp0_apply_05;
            this._state_0 = 2;
            suspendResult = this.__this__39.execute_9(this._requestBuilder1, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 2:
            this._call0 = suspendResult;
            if (!isRedirect(this._call0._get_response__0()._get_status__1()))
              return this._call0;
            this._state_0 = 1;
            continue $sm;
          case 3:
            throw this._exception_0;
          case 4:
            return Unit_getInstance();
        }
      } catch ($p) {
        if (this._exceptionState === 3) {
          throw $p;
        } else {
          this._state_0 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $handleCallCOROUTINE$8.$metadata$ = {
    simpleName: '$handleCallCOROUTINE$8',
    kind: 'class',
    interfaces: []
  };
  function Feature_1() {
    Feature_instance_1 = this;
    this._key_8 = new AttributeKey('HttpRedirect');
  }
  Feature_1.prototype._get_key__47 = function () {
    return this._key_8;
  };
  Feature_1.prototype.prepare_6 = function (block) {
    var tmp0_apply_0 = new HttpRedirect();
    block(tmp0_apply_0);
    return tmp0_apply_0;
  };
  Feature_1.prototype.prepare_17 = function (block) {
    return this.prepare_6(block);
  };
  Feature_1.prototype.install_11 = function (feature_0, scope_0) {
    var tmp = get(scope_0, Feature_getInstance_3());
    tmp.intercept_0(_no_name_provided_$factory_164(feature_0, null));
  };
  Feature_1.prototype.install_23 = function (feature_0, scope_0) {
    return this.install_11(feature_0 instanceof HttpRedirect ? feature_0 : THROW_CCE(), scope_0);
  };
  Feature_1.$metadata$ = {
    simpleName: 'Feature',
    kind: 'object',
    interfaces: [HttpClientFeature]
  };
  var Feature_instance_1;
  function Feature_getInstance_1() {
    if (Feature_instance_1 == null)
      new Feature_1();
    return Feature_instance_1;
  }
  function HttpRedirect() {
    Feature_getInstance_1();
    this.__checkHttpMethod = atomic_0(true);
    this.__allowHttpsDowngrade = atomic_0(false);
  }
  HttpRedirect.prototype._get_checkHttpMethod_ = function () {
    return this.__checkHttpMethod._value_9;
  };
  HttpRedirect.prototype._get_allowHttpsDowngrade_ = function () {
    return this.__allowHttpsDowngrade._value_9;
  };
  HttpRedirect.$metadata$ = {
    simpleName: 'HttpRedirect',
    kind: 'class',
    interfaces: []
  };
  function isRedirect(_this_) {
    var tmp0_subject = _this_._value_32;
    return ((((tmp0_subject === Companion_getInstance_51()._MovedPermanently._value_32 ? true : tmp0_subject === Companion_getInstance_51()._Found._value_32) ? true : tmp0_subject === Companion_getInstance_51()._TemporaryRedirect._value_32) ? true : tmp0_subject === Companion_getInstance_51()._PermanentRedirect._value_32) ? true : tmp0_subject === Companion_getInstance_51()._SeeOther._value_32) ? true : false;
  }
  function _no_name_provided_$factory_164($feature, resultContinuation) {
    var i = new _no_name_provided__206($feature, resultContinuation);
    var l = function (p1, p2, p3, $cont) {
      return i.invoke_379(p1, p2, p3, $cont);
    };
    l.$arity = 3;
    return l;
  }
  function _no_name_provided__207($scope, resultContinuation) {
    this._$scope = $scope;
    CoroutineImpl_0.call(this, resultContinuation);
  }
  _no_name_provided__207.prototype.invoke_382 = function (_this__0, it, $cont) {
    var tmp = this.create_34(_this__0, it, $cont);
    tmp._result = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_72();
  };
  _no_name_provided__207.prototype.invoke_537 = function (p1, p2, $cont) {
    var tmp = (!(p1 == null) ? isInterface(p1, PipelineContext) : false) ? p1 : THROW_CCE();
    this.invoke_382(tmp, isObject(p2) ? p2 : THROW_CCE(), $cont);
    return Unit_getInstance();
  };
  _no_name_provided__207.prototype.doResume_72 = function () {
    var suspendResult = this._result;
    $sm: do
      try {
        var tmp = this._state_0;
        switch (tmp) {
          case 0:
            this._exceptionState = 6;
            var tmp_0 = this;
            var tmp_1 = this;
            tmp_1._tmp0_also_00 = Job_0(this.__this__40._get_context__86()._executionContext);
            makeShared(this._tmp0_also_00);
            tmp_0._executionContext1 = this._tmp0_also_00;
            attachToClientEngineJob(this._executionContext1, ensureNotNull(this._$scope._coroutineContext_1.get_70(Key_getInstance_3())));
            this._state_0 = 1;
            continue $sm;
          case 1:
            this._exceptionState = 4;
            this._exceptionState = 3;
            this.__this__40._get_context__86()._set_executionContext_(this._executionContext1);
            this._state_0 = 2;
            suspendResult = this.__this__40.proceed_1(this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 2:
            var tmp_2 = this;
            suspendResult;
            tmp_2._tmp$ret$02_0 = Unit_getInstance();
            this._exceptionState = 6;
            this._state_0 = 5;
            continue $sm;
          case 3:
            this._exceptionState = 4;
            var tmp_3 = this._exception_0;
            if (tmp_3 instanceof Error) {
              var cause = this._exception_0;
              var tmp_4 = this;
              this._executionContext1.completeExceptionally_3(cause);
              Unit_getInstance();
              throw cause;
            } else {
              {
                throw this._exception_0;
              }
            }

            break;
          case 4:
            this._exceptionState = 6;
            var t = this._exception_0;
            this._executionContext1.complete_3();
            Unit_getInstance();
            throw t;
          case 5:
            this._executionContext1.complete_3();
            Unit_getInstance();
            return Unit_getInstance();
          case 6:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 6) {
          throw $p;
        } else {
          this._state_0 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  _no_name_provided__207.prototype.create_34 = function (_this__0, it, completion) {
    var i = new _no_name_provided__207(this._$scope, completion);
    i.__this__40 = _this__0;
    i._it_1 = it;
    return i;
  };
  _no_name_provided__207.$metadata$ = {
    kind: 'class',
    interfaces: [],
    suspendArity: 2
  };
  function Feature_2() {
    Feature_instance_2 = this;
    this._key_9 = new AttributeKey('RequestLifecycle');
  }
  Feature_2.prototype._get_key__47 = function () {
    return this._key_9;
  };
  Feature_2.prototype.prepare_8 = function (block) {
    return new HttpRequestLifecycle();
  };
  Feature_2.prototype.prepare_17 = function (block) {
    return this.prepare_8(block);
  };
  Feature_2.prototype.install_13 = function (feature_0, scope_0) {
    var tmp = Phases_getInstance()._Before;
    scope_0._requestPipeline.intercept(tmp, _no_name_provided_$factory_165(scope_0, null));
  };
  Feature_2.prototype.install_23 = function (feature_0, scope_0) {
    return this.install_13(feature_0 instanceof HttpRequestLifecycle ? feature_0 : THROW_CCE(), scope_0);
  };
  Feature_2.$metadata$ = {
    simpleName: 'Feature',
    kind: 'object',
    interfaces: [HttpClientFeature]
  };
  var Feature_instance_2;
  function Feature_getInstance_2() {
    if (Feature_instance_2 == null)
      new Feature_2();
    return Feature_instance_2;
  }
  function HttpRequestLifecycle() {
    Feature_getInstance_2();
  }
  HttpRequestLifecycle.$metadata$ = {
    simpleName: 'HttpRequestLifecycle',
    kind: 'class',
    interfaces: []
  };
  function attachToClientEngineJob(requestJob, clientEngineJob) {
    makeShared(clientEngineJob);
    var handler = clientEngineJob.invokeOnCompletion_22(_no_name_provided_$factory_166(requestJob));
    requestJob.invokeOnCompletion_22(_no_name_provided_$factory_167(handler));
    Unit_getInstance();
  }
  function _no_name_provided__208($requestJob) {
    this._$requestJob = $requestJob;
  }
  _no_name_provided__208.prototype.invoke_375 = function (cause) {
    if (!(cause == null)) {
      cancel_1(this._$requestJob, 'Engine failed', cause);
    } else {
      this._$requestJob.complete_3();
      Unit_getInstance();
    }
  };
  _no_name_provided__208.prototype.invoke_542 = function (p1) {
    this.invoke_375((p1 == null ? true : p1 instanceof Error) ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__208.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__209($handler) {
    this._$handler_0 = $handler;
  }
  _no_name_provided__209.prototype.invoke_375 = function (it) {
    this._$handler_0.dispose_26();
  };
  _no_name_provided__209.prototype.invoke_542 = function (p1) {
    this.invoke_375((p1 == null ? true : p1 instanceof Error) ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__209.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided_$factory_165($scope, resultContinuation) {
    var i = new _no_name_provided__207($scope, resultContinuation);
    var l = function (p1, p2, $cont) {
      return i.invoke_382(p1, p2, $cont);
    };
    l.$arity = 2;
    return l;
  }
  function _no_name_provided_$factory_166($requestJob) {
    var i = new _no_name_provided__208($requestJob);
    return function (p1) {
      i.invoke_375(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_167($handler) {
    var i = new _no_name_provided__209($handler);
    return function (p1) {
      i.invoke_375(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided__210($feature, $scope, resultContinuation) {
    this._$feature_7 = $feature;
    this._$scope_0 = $scope;
    CoroutineImpl_0.call(this, resultContinuation);
  }
  _no_name_provided__210.prototype.invoke_382 = function (_this__0, content, $cont) {
    var tmp = this.create_34(_this__0, content, $cont);
    tmp._result = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_72();
  };
  _no_name_provided__210.prototype.invoke_537 = function (p1, p2, $cont) {
    var tmp = (!(p1 == null) ? isInterface(p1, PipelineContext) : false) ? p1 : THROW_CCE();
    this.invoke_382(tmp, isObject(p2) ? p2 : THROW_CCE(), $cont);
    return Unit_getInstance();
  };
  _no_name_provided__210.prototype.doResume_72 = function () {
    var suspendResult = this._result;
    $sm: do
      try {
        var tmp = this._state_0;
        switch (tmp) {
          case 0:
            this._exceptionState = 9;
            var tmp_0 = this;
            var tmp_1 = this._content_8;
            tmp_0._tmp0_check_00_0 = tmp_1 instanceof OutgoingContent;
            if (!this._tmp0_check_00_0) {
              var tmp_2 = '' + '\n|Fail to serialize body. Content has type: ' + getKClassFromExpression_0(this._content_8) + ', but OutgoingContent expected.\n|If you expect serialized body, please check that you have installed the corresponding feature(like `Json`) and set `Content-Type` header.';
              var message_1 = trimMargin$default(tmp_2, null, 1, null);
              throw IllegalStateException_init_$Create$(toString_1(message_1));
            }
            this.__this__41._get_context__86()._body_0 = this._content_8;
            this._sender1 = new DefaultSender(this._$feature_7._get_maxSendCount_(), this._$scope_0);
            this._state_0 = 1;
            suspendResult = this._sender1.execute_9(this.__this__41._get_context__86(), this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            this._currentCall2 = suspendResult;
            this._state_0 = 2;
            continue $sm;
          case 2:
            this._callChanged3 = false;
            this._tmp0_iterator4 = this._$feature_7._interceptors_0.iterator_64();
            this._state_0 = 3;
            continue $sm;
          case 3:
            if (!this._tmp0_iterator4.hasNext_31()) {
              this._state_0 = 6;
              continue $sm;
            }
            this._interceptor5 = this._tmp0_iterator4.next_35();
            this._state_0 = 4;
            suspendResult = this._interceptor5(this._sender1, this._currentCall2, this.__this__41._get_context__86(), this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 4:
            this._transformed6 = suspendResult;
            if (this._transformed6 === this._currentCall2) {
              this._state_0 = 3;
              continue $sm;
            } else {
              this._state_0 = 5;
              continue $sm;
            }

            break;
          case 5:
            this._currentCall2 = this._transformed6;
            this._callChanged3 = true;
            this._state_0 = 6;
            continue $sm;
          case 6:
            if (this._callChanged3) {
              this._state_0 = 2;
              continue $sm;
            }
            this._state_0 = 7;
            continue $sm;
          case 7:
            this._state_0 = 8;
            suspendResult = this.__this__41.proceedWith_1(this._currentCall2, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 8:
            suspendResult;
            Unit_getInstance();
            return Unit_getInstance();
          case 9:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 9) {
          throw $p;
        } else {
          this._state_0 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  _no_name_provided__210.prototype.create_34 = function (_this__0, content, completion) {
    var i = new _no_name_provided__210(this._$feature_7, this._$scope_0, completion);
    i.__this__41 = _this__0;
    i._content_8 = content;
    return i;
  };
  _no_name_provided__210.$metadata$ = {
    kind: 'class',
    interfaces: [],
    suspendArity: 2
  };
  function $executeCOROUTINE$9(_this_, requestBuilder, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__42 = _this_;
    this._requestBuilder = requestBuilder;
  }
  $executeCOROUTINE$9.prototype.doResume_72 = function () {
    var suspendResult = this._result;
    $sm: do
      try {
        var tmp = this._state_0;
        switch (tmp) {
          case 0:
            this._exceptionState = 2;
            var tmp0_safe_receiver = this.__this__42._currentCall;
            if (tmp0_safe_receiver == null)
              null;
            else {
              cancel$default(tmp0_safe_receiver, null, 1, null);
              Unit_getInstance();
            }

            Unit_getInstance();
            if (this.__this__42._sentCount >= this.__this__42._maxSendCount) {
              throw new SendCountExceedException('' + 'Max send count ' + this.__this__42._maxSendCount + ' exceeded');
            }
            var tmp1_this = this.__this__42;
            var tmp2 = tmp1_this._sentCount;
            tmp1_this._sentCount = tmp2 + 1 | 0;
            Unit_getInstance();
            this._state_0 = 1;
            suspendResult = this.__this__42._client._sendPipeline.execute_1(this._requestBuilder, this._requestBuilder._body_0, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            var sendResult = suspendResult;
            var tmp3_elvis_lhs = sendResult instanceof HttpClientCall ? sendResult : null;
            var tmp_0;
            if (tmp3_elvis_lhs == null) {
              var tmp0_error_0 = '' + 'Failed to execute send pipeline. Expected to got [HttpClientCall], but received ' + sendResult;
              throw IllegalStateException_init_$Create$(toString_1(tmp0_error_0));
            } else {
              tmp_0 = tmp3_elvis_lhs;
            }

            var call = tmp_0;
            this.__this__42._currentCall = call;
            return call;
          case 2:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 2) {
          throw $p;
        } else {
          this._state_0 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $executeCOROUTINE$9.$metadata$ = {
    simpleName: '$executeCOROUTINE$9',
    kind: 'class',
    interfaces: []
  };
  function HttpSend_init_$Init$(maxSendCount, $mask0, $marker, $this) {
    if (!(($mask0 & 1) === 0))
      maxSendCount = 20;
    HttpSend.call($this, maxSendCount);
    return $this;
  }
  function HttpSend_init_$Create$(maxSendCount, $mask0, $marker) {
    return HttpSend_init_$Init$(maxSendCount, $mask0, $marker, Object.create(HttpSend.prototype));
  }
  function Feature_3() {
    Feature_instance_3 = this;
    this._key_10 = new AttributeKey('HttpSend');
  }
  Feature_3.prototype._get_key__47 = function () {
    return this._key_10;
  };
  Feature_3.prototype.prepare_10 = function (block) {
    var tmp0_apply_0 = HttpSend_init_$Create$(0, 1, null);
    block(tmp0_apply_0);
    return tmp0_apply_0;
  };
  Feature_3.prototype.prepare_17 = function (block) {
    return this.prepare_10(block);
  };
  Feature_3.prototype.install_15 = function (feature_0, scope_0) {
    var tmp = Phases_getInstance()._Send;
    scope_0._requestPipeline.intercept(tmp, _no_name_provided_$factory_168(feature_0, scope_0, null));
  };
  Feature_3.prototype.install_23 = function (feature_0, scope_0) {
    return this.install_15(feature_0 instanceof HttpSend ? feature_0 : THROW_CCE(), scope_0);
  };
  Feature_3.$metadata$ = {
    simpleName: 'Feature',
    kind: 'object',
    interfaces: [HttpClientFeature]
  };
  var Feature_instance_3;
  function Feature_getInstance_3() {
    if (Feature_instance_3 == null)
      new Feature_3();
    return Feature_instance_3;
  }
  function DefaultSender(maxSendCount, client) {
    this._maxSendCount = maxSendCount;
    this._client = client;
    this._sentCount = 0;
    this._currentCall = null;
  }
  DefaultSender.prototype.execute_9 = function (requestBuilder, $cont) {
    var tmp = new $executeCOROUTINE$9(this, requestBuilder, $cont);
    tmp._result = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_72();
  };
  DefaultSender.$metadata$ = {
    simpleName: 'DefaultSender',
    kind: 'class',
    interfaces: [Sender]
  };
  function HttpSend(maxSendCount) {
    Feature_getInstance_3();
    var tmp = this;
    tmp._maxSendCount$delegate = new _no_name_provided__124(maxSendCount);
    this._interceptors_0 = sharedList();
    makeShared(this);
  }
  HttpSend.prototype._set_maxSendCount_ = function (_set___) {
    return this._maxSendCount$delegate.setValue_7(this, maxSendCount$factory(), _set___);
  };
  HttpSend.prototype._get_maxSendCount_ = function () {
    return this._maxSendCount$delegate.getValue_10(this, maxSendCount$factory_0());
  };
  HttpSend.prototype.intercept_0 = function (block) {
    var tmp0_this = this;
    var tmp0_plusAssign_0 = tmp0_this._interceptors_0;
    tmp0_plusAssign_0.add_33(block);
    Unit_getInstance();
  };
  HttpSend.$metadata$ = {
    simpleName: 'HttpSend',
    kind: 'class',
    interfaces: []
  };
  function Sender() {
  }
  Sender.$metadata$ = {
    simpleName: 'Sender',
    kind: 'interface',
    interfaces: []
  };
  function SendCountExceedException(message) {
    IllegalStateException_init_$Init$_0(message, this);
    captureStack(this, SendCountExceedException);
  }
  SendCountExceedException.$metadata$ = {
    simpleName: 'SendCountExceedException',
    kind: 'class',
    interfaces: []
  };
  function maxSendCount$factory() {
    return getPropertyCallableRef('maxSendCount', 1, KMutableProperty1, function (receiver) {
      return receiver._get_maxSendCount_();
    }, function (receiver_0, value) {
      return receiver_0._set_maxSendCount_(value);
    });
  }
  function maxSendCount$factory_0() {
    return getPropertyCallableRef('maxSendCount', 1, KMutableProperty1, function (receiver) {
      return receiver._get_maxSendCount_();
    }, function (receiver_0, value) {
      return receiver_0._set_maxSendCount_(value);
    });
  }
  function _no_name_provided_$factory_168($feature, $scope, resultContinuation) {
    var i = new _no_name_provided__210($feature, $scope, resultContinuation);
    var l = function (p1, p2, $cont) {
      return i.invoke_382(p1, p2, $cont);
    };
    l.$arity = 2;
    return l;
  }
  function _set__requestTimeoutMillis_($this, _set___) {
    return $this.__requestTimeoutMillis$delegate.setValue_7($this, _requestTimeoutMillis$factory(), _set___);
  }
  function _get__requestTimeoutMillis_($this) {
    return $this.__requestTimeoutMillis$delegate.getValue_10($this, _requestTimeoutMillis$factory_0());
  }
  function _set__connectTimeoutMillis_($this, _set___) {
    return $this.__connectTimeoutMillis$delegate.setValue_7($this, _connectTimeoutMillis$factory(), _set___);
  }
  function _get__connectTimeoutMillis_($this) {
    return $this.__connectTimeoutMillis$delegate.getValue_10($this, _connectTimeoutMillis$factory_0());
  }
  function _set__socketTimeoutMillis_($this, _set___) {
    return $this.__socketTimeoutMillis$delegate.setValue_7($this, _socketTimeoutMillis$factory(), _set___);
  }
  function _get__socketTimeoutMillis_($this) {
    return $this.__socketTimeoutMillis$delegate.getValue_10($this, _socketTimeoutMillis$factory_0());
  }
  function HttpTimeoutCapabilityConfiguration_init_$Init$(requestTimeoutMillis, connectTimeoutMillis, socketTimeoutMillis, $this) {
    HttpTimeoutCapabilityConfiguration.call($this);
    $this._set_requestTimeoutMillis_(requestTimeoutMillis);
    $this._set_connectTimeoutMillis_(connectTimeoutMillis);
    $this._set_socketTimeoutMillis_(socketTimeoutMillis);
    return $this;
  }
  function HttpTimeoutCapabilityConfiguration_init_$Init$_0(requestTimeoutMillis, connectTimeoutMillis, socketTimeoutMillis, $mask0, $marker, $this) {
    if (!(($mask0 & 1) === 0))
      requestTimeoutMillis = null;
    if (!(($mask0 & 2) === 0))
      connectTimeoutMillis = null;
    if (!(($mask0 & 4) === 0))
      socketTimeoutMillis = null;
    HttpTimeoutCapabilityConfiguration_init_$Init$(requestTimeoutMillis, connectTimeoutMillis, socketTimeoutMillis, $this);
    return $this;
  }
  function HttpTimeoutCapabilityConfiguration_init_$Create$(requestTimeoutMillis, connectTimeoutMillis, socketTimeoutMillis, $mask0, $marker) {
    return HttpTimeoutCapabilityConfiguration_init_$Init$_0(requestTimeoutMillis, connectTimeoutMillis, socketTimeoutMillis, $mask0, $marker, Object.create(HttpTimeoutCapabilityConfiguration.prototype));
  }
  function checkTimeoutValue($this, value) {
    var tmp0_require_0 = value == null ? true : value.compareTo_69(new Long(0, 0)) > 0;
    if (!tmp0_require_0) {
      var message_1 = 'Only positive timeout values are allowed, for infinite timeout use HttpTimeout.INFINITE_TIMEOUT_MS';
      throw IllegalArgumentException_init_$Create$_0(toString_1(message_1));
    }return value;
  }
  function Companion_65() {
    Companion_instance_64 = this;
    this._key_11 = new AttributeKey('TimeoutConfiguration');
  }
  Companion_65.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_64;
  function Companion_getInstance_64() {
    if (Companion_instance_64 == null)
      new Companion_65();
    return Companion_instance_64;
  }
  function _no_name_provided__211($requestTimeout_5, $executionContext_7, $this, resultContinuation) {
    this._$requestTimeout_5 = $requestTimeout_5;
    this._$executionContext_7 = $executionContext_7;
    this._$this_7 = $this;
    CoroutineImpl_0.call(this, resultContinuation);
  }
  _no_name_provided__211.prototype.invoke_489 = function (_this__0, $cont) {
    var tmp = this.create_38(_this__0, $cont);
    tmp._result = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_72();
  };
  _no_name_provided__211.prototype.invoke_542 = function (p1, $cont) {
    this.invoke_489((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $cont);
    return Unit_getInstance();
  };
  _no_name_provided__211.prototype.doResume_72 = function () {
    var suspendResult = this._result;
    $sm: do
      try {
        var tmp = this._state_0;
        switch (tmp) {
          case 0:
            this._exceptionState = 2;
            this._state_0 = 1;
            suspendResult = delay(this._$requestTimeout_5, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            suspendResult;
            this._$executionContext_7.cancel_20(new HttpRequestTimeoutException(this._$this_7._get_context__86()));
            return Unit_getInstance();
          case 2:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 2) {
          throw $p;
        } else {
          this._state_0 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  _no_name_provided__211.prototype.create_38 = function (_this__0, completion) {
    var i = new _no_name_provided__211(this._$requestTimeout_5, this._$executionContext_7, this._$this_7, completion);
    i.__this__43 = _this__0;
    return i;
  };
  _no_name_provided__211.$metadata$ = {
    kind: 'class',
    interfaces: [],
    suspendArity: 1
  };
  function _no_name_provided__212($killer_8) {
    this._$killer_8 = $killer_8;
  }
  _no_name_provided__212.prototype.invoke_375 = function (it) {
    this._$killer_8.cancel$default_15(null, 1, null);
  };
  _no_name_provided__212.prototype.invoke_542 = function (p1) {
    this.invoke_375((p1 == null ? true : p1 instanceof Error) ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__212.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__213($feature, $scope, resultContinuation) {
    this._$feature_8 = $feature;
    this._$scope_1 = $scope;
    CoroutineImpl_0.call(this, resultContinuation);
  }
  _no_name_provided__213.prototype.invoke_382 = function (_this__0, it, $cont) {
    var tmp = this.create_34(_this__0, it, $cont);
    tmp._result = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_72();
  };
  _no_name_provided__213.prototype.invoke_537 = function (p1, p2, $cont) {
    var tmp = (!(p1 == null) ? isInterface(p1, PipelineContext) : false) ? p1 : THROW_CCE();
    this.invoke_382(tmp, isObject(p2) ? p2 : THROW_CCE(), $cont);
    return Unit_getInstance();
  };
  _no_name_provided__213.prototype.doResume_72 = function () {
    var suspendResult = this._result;
    $sm: do
      try {
        var tmp = this._state_0;
        if (tmp === 0) {
          this._exceptionState = 1;
          var configuration = this.__this__44._get_context__86().getCapabilityOrNull(Feature_getInstance_4());
          if (configuration == null ? hasNotNullTimeouts(this._$feature_8) : false) {
            configuration = HttpTimeoutCapabilityConfiguration_init_$Create$(null, null, null, 7, null);
            this.__this__44._get_context__86().setCapability(Feature_getInstance_4(), configuration);
          }var tmp0_safe_receiver = configuration;
          if (tmp0_safe_receiver == null)
            null;
          else {
            var tmp$ret$0;
            l$ret$1: do {
              var tmp0_elvis_lhs_2 = tmp0_safe_receiver._get_connectTimeoutMillis_();
              tmp0_safe_receiver._set_connectTimeoutMillis_(tmp0_elvis_lhs_2 == null ? this._$feature_8._connectTimeoutMillis : tmp0_elvis_lhs_2);
              var tmp1_elvis_lhs_3 = tmp0_safe_receiver._get_socketTimeoutMillis_();
              tmp0_safe_receiver._set_socketTimeoutMillis_(tmp1_elvis_lhs_3 == null ? this._$feature_8._socketTimeoutMillis : tmp1_elvis_lhs_3);
              var tmp2_elvis_lhs_4 = tmp0_safe_receiver._get_requestTimeoutMillis_();
              tmp0_safe_receiver._set_requestTimeoutMillis_(tmp2_elvis_lhs_4 == null ? this._$feature_8._requestTimeoutMillis : tmp2_elvis_lhs_4);
              var tmp3_elvis_lhs_6 = tmp0_safe_receiver._get_requestTimeoutMillis_();
              var requestTimeout_5 = tmp3_elvis_lhs_6 == null ? this._$feature_8._requestTimeoutMillis : tmp3_elvis_lhs_6;
              if (requestTimeout_5 == null ? true : equals_1(requestTimeout_5, new Long(-1, 2147483647))) {
                tmp$ret$0 = Unit_getInstance();
                break l$ret$1;
              }var executionContext_7 = this.__this__44._get_context__86()._executionContext;
              var killer_8 = launch$default(this._$scope_1, null, null, _no_name_provided_$factory_170(requestTimeout_5, executionContext_7, this.__this__44, null), 3, null);
              var tmp_0 = this.__this__44._get_context__86()._executionContext;
              tmp_0.invokeOnCompletion_22(_no_name_provided_$factory_171(killer_8));
              Unit_getInstance();
            }
             while (false);
          }
          Unit_getInstance();
          return Unit_getInstance();
        } else if (tmp === 1) {
          throw this._exception_0;
        }} catch ($p) {
        throw $p;
      }
     while (true);
  };
  _no_name_provided__213.prototype.create_34 = function (_this__0, it, completion) {
    var i = new _no_name_provided__213(this._$feature_8, this._$scope_1, completion);
    i.__this__44 = _this__0;
    i._it_2 = it;
    return i;
  };
  _no_name_provided__213.$metadata$ = {
    kind: 'class',
    interfaces: [],
    suspendArity: 2
  };
  HttpTimeoutCapabilityConfiguration.prototype._set_requestTimeoutMillis_ = function (value) {
    _set__requestTimeoutMillis_(this, checkTimeoutValue(this, value));
  };
  HttpTimeoutCapabilityConfiguration.prototype._get_requestTimeoutMillis_ = function () {
    return _get__requestTimeoutMillis_(this);
  };
  HttpTimeoutCapabilityConfiguration.prototype._set_connectTimeoutMillis_ = function (value) {
    _set__connectTimeoutMillis_(this, checkTimeoutValue(this, value));
  };
  HttpTimeoutCapabilityConfiguration.prototype._get_connectTimeoutMillis_ = function () {
    return _get__connectTimeoutMillis_(this);
  };
  HttpTimeoutCapabilityConfiguration.prototype._set_socketTimeoutMillis_ = function (value) {
    _set__socketTimeoutMillis_(this, checkTimeoutValue(this, value));
  };
  HttpTimeoutCapabilityConfiguration.prototype._get_socketTimeoutMillis_ = function () {
    return _get__socketTimeoutMillis_(this);
  };
  HttpTimeoutCapabilityConfiguration.prototype.build_16 = function () {
    return new HttpTimeout(this._get_requestTimeoutMillis_(), this._get_connectTimeoutMillis_(), this._get_socketTimeoutMillis_());
  };
  HttpTimeoutCapabilityConfiguration.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (other == null ? true : !getKClassFromExpression_0(this).equals(getKClassFromExpression_0(other)))
      return false;
    if (other instanceof HttpTimeoutCapabilityConfiguration)
      other;
    else
      THROW_CCE();
    Unit_getInstance();
    if (!equals_1(_get__requestTimeoutMillis_(this), _get__requestTimeoutMillis_(other)))
      return false;
    if (!equals_1(_get__connectTimeoutMillis_(this), _get__connectTimeoutMillis_(other)))
      return false;
    if (!equals_1(_get__socketTimeoutMillis_(this), _get__socketTimeoutMillis_(other)))
      return false;
    return true;
  };
  HttpTimeoutCapabilityConfiguration.prototype.hashCode = function () {
    var tmp0_safe_receiver = _get__requestTimeoutMillis_(this);
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.hashCode();
    var result = tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs;
    var tmp = imul(31, result);
    var tmp2_safe_receiver = _get__connectTimeoutMillis_(this);
    var tmp3_elvis_lhs = tmp2_safe_receiver == null ? null : tmp2_safe_receiver.hashCode();
    result = tmp + (tmp3_elvis_lhs == null ? 0 : tmp3_elvis_lhs) | 0;
    var tmp_0 = imul(31, result);
    var tmp4_safe_receiver = _get__socketTimeoutMillis_(this);
    var tmp5_elvis_lhs = tmp4_safe_receiver == null ? null : tmp4_safe_receiver.hashCode();
    result = tmp_0 + (tmp5_elvis_lhs == null ? 0 : tmp5_elvis_lhs) | 0;
    return result;
  };
  function HttpTimeoutCapabilityConfiguration() {
    Companion_getInstance_64();
    var tmp = this;
    var tmp0_shared_0 = new Long(0, 0);
    tmp.__requestTimeoutMillis$delegate = new _no_name_provided__124(tmp0_shared_0);
    var tmp_0 = this;
    var tmp0_shared_0_0 = new Long(0, 0);
    tmp_0.__connectTimeoutMillis$delegate = new _no_name_provided__124(tmp0_shared_0_0);
    var tmp_1 = this;
    var tmp0_shared_0_1 = new Long(0, 0);
    tmp_1.__socketTimeoutMillis$delegate = new _no_name_provided__124(tmp0_shared_0_1);
  }
  HttpTimeoutCapabilityConfiguration.$metadata$ = {
    simpleName: 'HttpTimeoutCapabilityConfiguration',
    kind: 'class',
    interfaces: []
  };
  function hasNotNullTimeouts($this) {
    return (!($this._requestTimeoutMillis == null) ? true : !($this._connectTimeoutMillis == null)) ? true : !($this._socketTimeoutMillis == null);
  }
  function Feature_4() {
    Feature_instance_4 = this;
    this._key_12 = new AttributeKey('TimeoutFeature');
    this._INFINITE_TIMEOUT_MS = new Long(-1, 2147483647);
  }
  Feature_4.prototype._get_key__47 = function () {
    return this._key_12;
  };
  Feature_4.prototype.prepare_12 = function (block) {
    var tmp0_apply_0 = HttpTimeoutCapabilityConfiguration_init_$Create$(null, null, null, 7, null);
    block(tmp0_apply_0);
    return tmp0_apply_0.build_16();
  };
  Feature_4.prototype.prepare_17 = function (block) {
    return this.prepare_12(block);
  };
  Feature_4.prototype.install_17 = function (feature_0, scope_0) {
    var tmp = Phases_getInstance()._Before;
    scope_0._requestPipeline.intercept(tmp, _no_name_provided_$factory_169(feature_0, scope_0, null));
  };
  Feature_4.prototype.install_23 = function (feature_0, scope_0) {
    return this.install_17(feature_0 instanceof HttpTimeout ? feature_0 : THROW_CCE(), scope_0);
  };
  Feature_4.$metadata$ = {
    simpleName: 'Feature',
    kind: 'object',
    interfaces: [HttpClientFeature, HttpClientEngineCapability]
  };
  var Feature_instance_4;
  function Feature_getInstance_4() {
    if (Feature_instance_4 == null)
      new Feature_4();
    return Feature_instance_4;
  }
  function HttpTimeout(requestTimeoutMillis, connectTimeoutMillis, socketTimeoutMillis) {
    Feature_getInstance_4();
    this._requestTimeoutMillis = requestTimeoutMillis;
    this._connectTimeoutMillis = connectTimeoutMillis;
    this._socketTimeoutMillis = socketTimeoutMillis;
  }
  HttpTimeout.$metadata$ = {
    simpleName: 'HttpTimeout',
    kind: 'class',
    interfaces: []
  };
  function HttpRequestTimeoutException(request) {
    var tmp = request._url_0.buildString();
    var tmp0_safe_receiver = request.getCapabilityOrNull(Feature_getInstance_4());
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver._get_requestTimeoutMillis_();
    CancellationException_init_$Init$('' + 'Request timeout has been expired [url=' + tmp + ', request_timeout=' + (tmp1_elvis_lhs == null ? 'unknown' : tmp1_elvis_lhs) + ' ms]', this);
    captureStack(this, HttpRequestTimeoutException);
  }
  HttpRequestTimeoutException.$metadata$ = {
    simpleName: 'HttpRequestTimeoutException',
    kind: 'class',
    interfaces: []
  };
  function _requestTimeoutMillis$factory() {
    return getPropertyCallableRef('_requestTimeoutMillis', 1, KMutableProperty1, function (receiver) {
      return _get__requestTimeoutMillis_(receiver);
    }, function (receiver_0, value) {
      return _set__requestTimeoutMillis_(receiver_0, value);
    });
  }
  function _requestTimeoutMillis$factory_0() {
    return getPropertyCallableRef('_requestTimeoutMillis', 1, KMutableProperty1, function (receiver) {
      return _get__requestTimeoutMillis_(receiver);
    }, function (receiver_0, value) {
      return _set__requestTimeoutMillis_(receiver_0, value);
    });
  }
  function _connectTimeoutMillis$factory() {
    return getPropertyCallableRef('_connectTimeoutMillis', 1, KMutableProperty1, function (receiver) {
      return _get__connectTimeoutMillis_(receiver);
    }, function (receiver_0, value) {
      return _set__connectTimeoutMillis_(receiver_0, value);
    });
  }
  function _connectTimeoutMillis$factory_0() {
    return getPropertyCallableRef('_connectTimeoutMillis', 1, KMutableProperty1, function (receiver) {
      return _get__connectTimeoutMillis_(receiver);
    }, function (receiver_0, value) {
      return _set__connectTimeoutMillis_(receiver_0, value);
    });
  }
  function _socketTimeoutMillis$factory() {
    return getPropertyCallableRef('_socketTimeoutMillis', 1, KMutableProperty1, function (receiver) {
      return _get__socketTimeoutMillis_(receiver);
    }, function (receiver_0, value) {
      return _set__socketTimeoutMillis_(receiver_0, value);
    });
  }
  function _socketTimeoutMillis$factory_0() {
    return getPropertyCallableRef('_socketTimeoutMillis', 1, KMutableProperty1, function (receiver) {
      return _get__socketTimeoutMillis_(receiver);
    }, function (receiver_0, value) {
      return _set__socketTimeoutMillis_(receiver_0, value);
    });
  }
  function _no_name_provided_$factory_169($feature, $scope, resultContinuation) {
    var i = new _no_name_provided__213($feature, $scope, resultContinuation);
    var l = function (p1, p2, $cont) {
      return i.invoke_382(p1, p2, $cont);
    };
    l.$arity = 2;
    return l;
  }
  function _no_name_provided_$factory_170($requestTimeout_5, $executionContext_7, $this, resultContinuation) {
    var i = new _no_name_provided__211($requestTimeout_5, $executionContext_7, $this, resultContinuation);
    var l = function (p1, $cont) {
      return i.invoke_489(p1, $cont);
    };
    l.$arity = 1;
    return l;
  }
  function _no_name_provided_$factory_171($killer_8) {
    var i = new _no_name_provided__212($killer_8);
    return function (p1) {
      i.invoke_375(p1);
      return Unit_getInstance();
    };
  }
  var REQUEST_EXTENSIONS_KEY;
  function WebSocketCapability() {
    WebSocketCapability_instance = this;
  }
  WebSocketCapability.prototype.toString = function () {
    return 'WebSocketCapability';
  };
  WebSocketCapability.$metadata$ = {
    simpleName: 'WebSocketCapability',
    kind: 'object',
    interfaces: [HttpClientEngineCapability]
  };
  var WebSocketCapability_instance;
  function WebSocketCapability_getInstance() {
    if (WebSocketCapability_instance == null)
      new WebSocketCapability();
    return WebSocketCapability_instance;
  }
  function WebSocketException(message) {
    IllegalStateException_init_$Init$_0(message, this);
    captureStack(this, WebSocketException);
  }
  WebSocketException.$metadata$ = {
    simpleName: 'WebSocketException',
    kind: 'class',
    interfaces: []
  };
  function ClientUpgradeContent() {
  }
  ClientUpgradeContent.$metadata$ = {
    simpleName: 'ClientUpgradeContent',
    kind: 'class',
    interfaces: []
  };
  function DefaultHttpRequest(call, data) {
    this._call_3 = call;
    this._method = data._method_1;
    this._url = data._url_1;
    this._content_9 = data._body_1;
    this._headers_0 = data._headers_2;
    this._attributes_2 = data._attributes_4;
  }
  DefaultHttpRequest.prototype._get_call__4 = function () {
    return this._call_3;
  };
  DefaultHttpRequest.prototype._get_coroutineContext__22 = function () {
    return this._get_call__4()._get_coroutineContext__22();
  };
  DefaultHttpRequest.prototype._get_method__1 = function () {
    return this._method;
  };
  DefaultHttpRequest.prototype._get_url__1 = function () {
    return this._url;
  };
  DefaultHttpRequest.prototype._get_headers__15 = function () {
    return this._headers_0;
  };
  DefaultHttpRequest.prototype._get_attributes__12 = function () {
    return this._attributes_2;
  };
  DefaultHttpRequest.$metadata$ = {
    simpleName: 'DefaultHttpRequest',
    kind: 'class',
    interfaces: [HttpRequest]
  };
  function Companion_66() {
    Companion_instance_65 = this;
  }
  Companion_66.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_65;
  function Companion_getInstance_65() {
    if (Companion_instance_65 == null)
      new Companion_66();
    return Companion_instance_65;
  }
  function _no_name_provided__214() {
  }
  _no_name_provided__214.prototype.invoke_540 = function () {
    return sharedMap();
  };
  _no_name_provided__214.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function HttpRequestBuilder() {
    Companion_getInstance_65();
    var tmp = this;
    tmp._url_0 = URLBuilder_init_$Create$(null, null, 0, null, null, null, null, null, false, 511, null);
    this._method_0 = Companion_getInstance_49()._Get;
    var tmp_0 = this;
    tmp_0._headers_1 = HeadersBuilder_init_$Create$(0, 1, null);
    this._body_0 = EmptyContent_getInstance();
    var tmp_1 = this;
    var tmp0_also_0 = SupervisorJob$default(null, 1, null);
    makeShared(tmp0_also_0);
    tmp_1._executionContext = tmp0_also_0;
    this._attributes_3 = Attributes_0(true);
  }
  HttpRequestBuilder.prototype._get_headers__15 = function () {
    return this._headers_1;
  };
  HttpRequestBuilder.prototype._set_executionContext_ = function (value) {
    makeShared(value);
    this._executionContext = value;
  };
  HttpRequestBuilder.prototype.build_16 = function () {
    var tmp = this._url_0.build_16();
    var tmp_0 = this._method_0;
    var tmp_1 = this._headers_1.build_16();
    var tmp_2 = this._body_0;
    var tmp0_elvis_lhs = tmp_2 instanceof OutgoingContent ? tmp_2 : null;
    var tmp_3;
    if (tmp0_elvis_lhs == null) {
      var tmp0_error_0 = '' + 'No request transformation found: ' + this._body_0;
      throw IllegalStateException_init_$Create$(toString_1(tmp0_error_0));
    } else {
      tmp_3 = tmp0_elvis_lhs;
    }
    return new HttpRequestData(tmp, tmp_0, tmp_1, tmp_3, this._executionContext, this._attributes_3);
  };
  HttpRequestBuilder.prototype.takeFromWithExecutionContext = function (builder) {
    this._set_executionContext_(builder._executionContext);
    return this.takeFrom(builder);
  };
  HttpRequestBuilder.prototype.takeFrom = function (builder) {
    this._method_0 = builder._method_0;
    this._body_0 = builder._body_0;
    takeFrom_0(this._url_0, builder._url_0);
    Unit_getInstance();
    this._url_0._encodedPath = isBlank(this._url_0._encodedPath) ? '/' : this._url_0._encodedPath;
    appendAll(this._headers_1, builder._headers_1);
    Unit_getInstance();
    var tmp0_forEach_0 = builder._attributes_3._get_allKeys__0();
    var tmp0_iterator_1 = tmp0_forEach_0.iterator_64();
    while (tmp0_iterator_1.hasNext_31()) {
      var element_2 = tmp0_iterator_1.next_35();
      this._attributes_3.put_13(element_2 instanceof AttributeKey ? element_2 : THROW_CCE(), builder._attributes_3.get_65(element_2));
    }
    return this;
  };
  HttpRequestBuilder.prototype.setCapability = function (key, capability) {
    var capabilities = this._attributes_3.computeIfAbsent_0(ENGINE_CAPABILITIES_KEY, _no_name_provided_$factory_172());
    capabilities.put_12(key, capability);
    Unit_getInstance();
  };
  HttpRequestBuilder.prototype.getCapabilityOrNull = function (key) {
    var tmp0_safe_receiver = this._attributes_3.getOrNull_0(ENGINE_CAPABILITIES_KEY);
    var tmp = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.get_63(key);
    return (tmp == null ? true : isObject(tmp)) ? tmp : THROW_CCE();
  };
  HttpRequestBuilder.$metadata$ = {
    simpleName: 'HttpRequestBuilder',
    kind: 'class',
    interfaces: [HttpMessageBuilder]
  };
  function HttpRequestData(url_0, method, headers, body, executionContext, attributes) {
    this._url_1 = url_0;
    this._method_1 = method;
    this._headers_2 = headers;
    this._body_1 = body;
    this._executionContext_0 = executionContext;
    this._attributes_4 = attributes;
    var tmp = this;
    var tmp0_safe_receiver = this._attributes_4.getOrNull_0(ENGINE_CAPABILITIES_KEY);
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver._get_keys__10();
    tmp._requiredCapabilities = tmp1_elvis_lhs == null ? emptySet() : tmp1_elvis_lhs;
  }
  HttpRequestData.prototype.toString = function () {
    return '' + 'HttpRequestData(url=' + this._url_1 + ', method=' + this._method_1 + ')';
  };
  HttpRequestData.$metadata$ = {
    simpleName: 'HttpRequestData',
    kind: 'class',
    interfaces: []
  };
  function HttpResponseData(statusCode, requestTime, headers, version, body, callContext_0) {
    this._statusCode = statusCode;
    this._requestTime_0 = requestTime;
    this._headers_3 = headers;
    this._version_0 = version;
    this._body_2 = body;
    this._callContext_0 = callContext_0;
    var tmp = this;
    tmp._responseTime_0 = GMTDate$default(null, 1, null);
  }
  HttpResponseData.prototype.toString = function () {
    return '' + 'HttpResponseData=(statusCode=' + this._statusCode + ')';
  };
  HttpResponseData.$metadata$ = {
    simpleName: 'HttpResponseData',
    kind: 'class',
    interfaces: []
  };
  function HttpRequest() {
  }
  HttpRequest.prototype._get_coroutineContext__22 = function () {
    return this._get_call__4()._get_coroutineContext__22();
  };
  HttpRequest.$metadata$ = {
    simpleName: 'HttpRequest',
    kind: 'interface',
    interfaces: [HttpMessage, CoroutineScope]
  };
  function url(_this_, scheme, host, port, path, block) {
    var tmp0_apply_0 = _this_._url_0;
    tmp0_apply_0._protocol = Companion_getInstance_55().createOrDefault(scheme);
    tmp0_apply_0._host = host;
    tmp0_apply_0._port = port;
    tmp0_apply_0._encodedPath = path;
    block(_this_._url_0);
    Unit_getInstance();
  }
  function url$default(_this_, scheme, host, port, path, block, $mask0, $handler) {
    if (!(($mask0 & 1) === 0))
      scheme = 'http';
    if (!(($mask0 & 2) === 0))
      host = 'localhost';
    if (!(($mask0 & 4) === 0))
      port = 0;
    if (!(($mask0 & 8) === 0))
      path = '/';
    if (!(($mask0 & 16) === 0)) {
      block = _no_name_provided_$factory_173();
    }return url(_this_, scheme, host, port, path, block);
  }
  function isUpgradeRequest(_this_) {
    var tmp = _this_._body_1;
    return tmp instanceof ClientUpgradeContent;
  }
  function _no_name_provided__215() {
  }
  _no_name_provided__215.prototype.invoke_322 = function (_this__0) {
    return Unit_getInstance();
  };
  _no_name_provided__215.prototype.invoke_542 = function (p1) {
    this.invoke_322(p1 instanceof URLBuilder ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__215.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided_$factory_172() {
    var i = new _no_name_provided__214();
    return function () {
      return i.invoke_540();
    };
  }
  function _no_name_provided_$factory_173() {
    var i = new _no_name_provided__215();
    return function (p1) {
      i.invoke_322(p1);
      return Unit_getInstance();
    };
  }
  function Phases() {
    Phases_instance = this;
    this._Before = new PipelinePhase('Before');
    this._State = new PipelinePhase('State');
    this._Transform = new PipelinePhase('Transform');
    this._Render = new PipelinePhase('Render');
    this._Send = new PipelinePhase('Send');
  }
  Phases.$metadata$ = {
    simpleName: 'Phases',
    kind: 'object',
    interfaces: []
  };
  var Phases_instance;
  function Phases_getInstance() {
    if (Phases_instance == null)
      new Phases();
    return Phases_instance;
  }
  function HttpRequestPipeline(developmentMode) {
    Phases_getInstance();
    Pipeline.call(this, [Phases_getInstance()._Before, Phases_getInstance()._State, Phases_getInstance()._Transform, Phases_getInstance()._Render, Phases_getInstance()._Send]);
    this._developmentMode_0 = developmentMode;
  }
  HttpRequestPipeline.prototype._get_developmentMode__4 = function () {
    return this._developmentMode_0;
  };
  HttpRequestPipeline.$metadata$ = {
    simpleName: 'HttpRequestPipeline',
    kind: 'class',
    interfaces: []
  };
  function Phases_0() {
    Phases_instance_0 = this;
    this._Before_0 = new PipelinePhase('Before');
    this._State_0 = new PipelinePhase('State');
    this._Monitoring = new PipelinePhase('Monitoring');
    this._Engine = new PipelinePhase('Engine');
    this._Receive = new PipelinePhase('Receive');
  }
  Phases_0.$metadata$ = {
    simpleName: 'Phases',
    kind: 'object',
    interfaces: []
  };
  var Phases_instance_0;
  function Phases_getInstance_0() {
    if (Phases_instance_0 == null)
      new Phases_0();
    return Phases_instance_0;
  }
  function HttpSendPipeline(developmentMode) {
    Phases_getInstance_0();
    Pipeline.call(this, [Phases_getInstance_0()._Before_0, Phases_getInstance_0()._State_0, Phases_getInstance_0()._Monitoring, Phases_getInstance_0()._Engine, Phases_getInstance_0()._Receive]);
    this._developmentMode_1 = developmentMode;
  }
  HttpSendPipeline.prototype._get_developmentMode__4 = function () {
    return this._developmentMode_1;
  };
  HttpSendPipeline.$metadata$ = {
    simpleName: 'HttpSendPipeline',
    kind: 'class',
    interfaces: []
  };
  var RN_BYTES;
  function RN_BYTES$init$() {
    var tmp0_toByteArray_0 = '\r\n';
    var tmp1_toByteArray_0 = Charsets_getInstance()._UTF_8;
    return encodeToByteArray(tmp1_toByteArray_0.newEncoder_0(), tmp0_toByteArray_0, 0, tmp0_toByteArray_0.length);
  }
  function accept(_this_, contentType_2) {
    return _this_._headers_1.append_35(HttpHeaders_getInstance()._Accept, contentType_2.toString());
  }
  function DefaultHttpResponse(call, responseData) {
    HttpResponse.call(this);
    this._call_4 = call;
    this._coroutineContext_3 = responseData._callContext_0;
    this._status_1 = responseData._statusCode;
    this._version_1 = responseData._version_0;
    this._requestTime_1 = responseData._requestTime_0;
    this._responseTime_1 = responseData._responseTime_0;
    var tmp = this;
    var tmp_0 = responseData._body_2;
    var tmp0_elvis_lhs = isInterface(tmp_0, ByteReadChannel_1) ? tmp_0 : null;
    tmp._content_10 = tmp0_elvis_lhs == null ? Companion_getInstance_37()._get_Empty__1() : tmp0_elvis_lhs;
    this._headers_4 = responseData._headers_3;
  }
  DefaultHttpResponse.prototype._get_call__4 = function () {
    return this._call_4;
  };
  DefaultHttpResponse.prototype._get_coroutineContext__22 = function () {
    return this._coroutineContext_3;
  };
  DefaultHttpResponse.prototype._get_status__1 = function () {
    return this._status_1;
  };
  DefaultHttpResponse.prototype._get_version__1 = function () {
    return this._version_1;
  };
  DefaultHttpResponse.prototype._get_requestTime__1 = function () {
    return this._requestTime_1;
  };
  DefaultHttpResponse.prototype._get_responseTime__1 = function () {
    return this._responseTime_1;
  };
  DefaultHttpResponse.prototype._get_content__6 = function () {
    return this._content_10;
  };
  DefaultHttpResponse.prototype._get_headers__15 = function () {
    return this._headers_4;
  };
  DefaultHttpResponse.$metadata$ = {
    simpleName: 'DefaultHttpResponse',
    kind: 'class',
    interfaces: []
  };
  function HttpResponse() {
  }
  HttpResponse.prototype.toString = function () {
    return '' + 'HttpResponse[' + _get_request_(this)._get_url__1() + ', ' + this._get_status__1() + ']';
  };
  HttpResponse.$metadata$ = {
    simpleName: 'HttpResponse',
    kind: 'class',
    interfaces: [HttpMessage, CoroutineScope]
  };
  function complete(_this_) {
    var tmp = ensureNotNull(_this_._get_coroutineContext__22().get_70(Key_getInstance_3()));
    var job = isInterface(tmp, CompletableJob) ? tmp : THROW_CCE();
    job.complete_3();
    Unit_getInstance();
  }
  function _get_request_(_this_) {
    return _this_._get_call__4()._get_request__0();
  }
  function Phases_1() {
    Phases_instance_1 = this;
    this._Receive_0 = new PipelinePhase('Receive');
    this._Parse = new PipelinePhase('Parse');
    this._Transform_0 = new PipelinePhase('Transform');
    this._State_1 = new PipelinePhase('State');
    this._After = new PipelinePhase('After');
  }
  Phases_1.$metadata$ = {
    simpleName: 'Phases',
    kind: 'object',
    interfaces: []
  };
  var Phases_instance_1;
  function Phases_getInstance_1() {
    if (Phases_instance_1 == null)
      new Phases_1();
    return Phases_instance_1;
  }
  function HttpResponsePipeline(developmentMode) {
    Phases_getInstance_1();
    Pipeline.call(this, [Phases_getInstance_1()._Receive_0, Phases_getInstance_1()._Parse, Phases_getInstance_1()._Transform_0, Phases_getInstance_1()._State_1, Phases_getInstance_1()._After]);
    this._developmentMode_2 = developmentMode;
  }
  HttpResponsePipeline.prototype._get_developmentMode__4 = function () {
    return this._developmentMode_2;
  };
  HttpResponsePipeline.$metadata$ = {
    simpleName: 'HttpResponsePipeline',
    kind: 'class',
    interfaces: []
  };
  function Phases_2() {
    Phases_instance_2 = this;
    this._Before_1 = new PipelinePhase('Before');
    this._State_2 = new PipelinePhase('State');
    this._After_0 = new PipelinePhase('After');
  }
  Phases_2.$metadata$ = {
    simpleName: 'Phases',
    kind: 'object',
    interfaces: []
  };
  var Phases_instance_2;
  function Phases_getInstance_2() {
    if (Phases_instance_2 == null)
      new Phases_2();
    return Phases_instance_2;
  }
  function HttpReceivePipeline(developmentMode) {
    Phases_getInstance_2();
    Pipeline.call(this, [Phases_getInstance_2()._Before_1, Phases_getInstance_2()._State_2, Phases_getInstance_2()._After_0]);
    this._developmentMode_3 = developmentMode;
  }
  HttpReceivePipeline.prototype._get_developmentMode__4 = function () {
    return this._developmentMode_3;
  };
  HttpReceivePipeline.$metadata$ = {
    simpleName: 'HttpReceivePipeline',
    kind: 'class',
    interfaces: []
  };
  function HttpResponseContainer(expectedType, response) {
    this._expectedType = expectedType;
    this._response_2 = response;
  }
  HttpResponseContainer.prototype.component1_4 = function () {
    return this._expectedType;
  };
  HttpResponseContainer.prototype.component2_4 = function () {
    return this._response_2;
  };
  HttpResponseContainer.prototype.toString = function () {
    return '' + 'HttpResponseContainer(expectedType=' + this._expectedType + ', response=' + this._response_2 + ')';
  };
  HttpResponseContainer.prototype.hashCode = function () {
    var result = this._expectedType.hashCode();
    result = imul(result, 31) + hashCode(this._response_2) | 0;
    return result;
  };
  HttpResponseContainer.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof HttpResponseContainer))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof HttpResponseContainer ? other : THROW_CCE();
    if (!this._expectedType.equals(tmp0_other_with_cast._expectedType))
      return false;
    if (!equals_1(this._response_2, tmp0_other_with_cast._response_2))
      return false;
    return true;
  };
  HttpResponseContainer.$metadata$ = {
    simpleName: 'HttpResponseContainer',
    kind: 'class',
    interfaces: []
  };
  function readText_0(_this_, fallbackCharset, $cont) {
    var tmp = new $readTextCOROUTINE$17(_this_, fallbackCharset, $cont);
    tmp._result = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_72();
  }
  function readText$default_0(_this_, fallbackCharset, $mask0, $handler, $cont) {
    if (!(($mask0 & 1) === 0))
      fallbackCharset = null;
    return readText_0(_this_, fallbackCharset, $cont);
  }
  function checkCapabilities($this) {
    var tmp0_safe_receiver = $this._builder_2._attributes_3.getOrNull_0(ENGINE_CAPABILITIES_KEY);
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver._get_keys__10();
    var tmp;
    if (tmp1_safe_receiver == null) {
      tmp = null;
    } else {
      var tmp0_filterIsInstanceTo_0_1 = ArrayList_init_$Create$();
      var tmp0_iterator_1_2 = tmp1_safe_receiver.iterator_64();
      while (tmp0_iterator_1_2.hasNext_31()) {
        var element_2_3 = tmp0_iterator_1_2.next_35();
        if (!(element_2_3 == null) ? isInterface(element_2_3, HttpClientFeature) : false) {
          tmp0_filterIsInstanceTo_0_1.add_33(element_2_3);
          Unit_getInstance();
        } else {
        }
      }
      tmp = tmp0_filterIsInstanceTo_0_1;
    }
    var tmp2_safe_receiver = tmp;
    if (tmp2_safe_receiver == null)
      null;
    else {
      var tmp0_iterator_1 = tmp2_safe_receiver.iterator_64();
      while (tmp0_iterator_1.hasNext_31()) {
        var element_2 = tmp0_iterator_1.next_35();
        var tmp$ret$0;
        l$ret$1: do {
          var tmp0_requireNotNull_0_4 = feature($this._client_0, element_2);
          if (tmp0_requireNotNull_0_4 == null) {
            var message_1_5 = '' + 'Consider installing ' + element_2 + ' feature because the request requires it to be installed';
            throw IllegalArgumentException_init_$Create$_0(toString_1(message_1_5));
          } else {
            tmp$ret$0 = tmp0_requireNotNull_0_4;
            break l$ret$1;
          }
        }
         while (false);
        Unit_getInstance();
      }
      Unit_getInstance();
    }
    Unit_getInstance();
  }
  function _no_name_provided__216(resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
  }
  _no_name_provided__216.prototype.invoke_324 = function (it, $cont) {
    var tmp = this.create_23(it, $cont);
    tmp._result = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_72();
  };
  _no_name_provided__216.prototype.invoke_542 = function (p1, $cont) {
    return this.invoke_324(p1 instanceof HttpResponse ? p1 : THROW_CCE(), $cont);
  };
  _no_name_provided__216.prototype.doResume_72 = function () {
    var suspendResult = this._result;
    $sm: do
      try {
        var tmp = this._state_0;
        switch (tmp) {
          case 0:
            this._exceptionState = 2;
            this._state_0 = 1;
            suspendResult = save(this._it_3._get_call__4(), this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            var savedCall = suspendResult;
            return savedCall._get_response__0();
          case 2:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 2) {
          throw $p;
        } else {
          this._state_0 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  _no_name_provided__216.prototype.create_23 = function (it, completion) {
    var i = new _no_name_provided__216(completion);
    i._it_3 = it;
    return i;
  };
  _no_name_provided__216.$metadata$ = {
    kind: 'class',
    interfaces: [],
    suspendArity: 1
  };
  function $executeCOROUTINE$18(_this_, block, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__45 = _this_;
    this._block_0 = block;
  }
  $executeCOROUTINE$18.prototype.doResume_72 = function () {
    var suspendResult = this._result;
    $sm: do
      try {
        var tmp = this._state_0;
        switch (tmp) {
          case 0:
            this._exceptionState = 11;
            this._state_0 = 1;
            suspendResult = this.__this__45.executeUnsafe(this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            this._response0 = suspendResult;
            this._state_0 = 2;
            continue $sm;
          case 2:
            this._state_0 = 3;
            continue $sm;
          case 3:
            this._exceptionState = 9;
            this._state_0 = 4;
            suspendResult = this._block_0(this._response0, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 4:
            this._tmp$ret$02_1 = suspendResult;
            this._exceptionState = 11;
            this._state_0 = 5;
            var tmp_0 = this;
            continue $sm;
          case 5:
            this._tmp3 = this._tmp$ret$02_1;
            this._state_0 = 6;
            suspendResult = this.__this__45.cleanup(this._response0, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 6:
            suspendResult;
            return this._tmp3;
          case 7:
            this._state_0 = 8;
            suspendResult = this.__this__45.cleanup(this._response0, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 8:
            suspendResult;
            return Unit_getInstance();
          case 9:
            this._exceptionState = 11;
            this._t4 = this._exception_0;
            this._state_0 = 10;
            suspendResult = this.__this__45.cleanup(this._response0, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 10:
            suspendResult;
            throw this._t4;
          case 11:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 11) {
          throw $p;
        } else {
          this._state_0 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $executeCOROUTINE$18.$metadata$ = {
    simpleName: '$executeCOROUTINE$18',
    kind: 'class',
    interfaces: []
  };
  function $executeUnsafeCOROUTINE$21(_this_, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__46 = _this_;
  }
  $executeUnsafeCOROUTINE$21.prototype.doResume_72 = function () {
    var suspendResult = this._result;
    $sm: do
      try {
        var tmp = this._state_0;
        switch (tmp) {
          case 0:
            this._exceptionState = 2;
            this._builder0_0 = (new HttpRequestBuilder()).takeFromWithExecutionContext(this.__this__46._builder_2);
            this._state_0 = 1;
            suspendResult = this.__this__46._client_0.execute_9(this._builder0_0, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            var call = suspendResult;
            return call._get_response__0();
          case 2:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 2) {
          throw $p;
        } else {
          this._state_0 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $executeUnsafeCOROUTINE$21.$metadata$ = {
    simpleName: '$executeUnsafeCOROUTINE$21',
    kind: 'class',
    interfaces: []
  };
  function $cleanupCOROUTINE$22(_this_, _this__0, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__47 = _this_;
    this.__this__48 = _this__0;
  }
  $cleanupCOROUTINE$22.prototype.doResume_72 = function () {
    var suspendResult = this._result;
    $sm: do
      try {
        var tmp = this._state_0;
        switch (tmp) {
          case 0:
            this._exceptionState = 4;
            var tmp_0 = this;
            var tmp_1 = ensureNotNull(this.__this__48._get_coroutineContext__22().get_70(Key_getInstance_3()));
            tmp_0._job0 = isInterface(tmp_1, CompletableJob) ? tmp_1 : THROW_CCE();
            this._job0.complete_3();
            Unit_getInstance();
            this._exceptionState = 1;
            cancel_3(this.__this__48._get_content__6());
            Unit_getInstance();
            this._exceptionState = 4;
            this._state_0 = 2;
            continue $sm;
          case 1:
            this._exceptionState = 4;
            var tmp_2 = this._exception_0;
            if (tmp_2 instanceof Error) {
              this.___21 = this._exception_0;
              this._state_0 = 2;
              continue $sm;
            } else {
              {
                throw this._exception_0;
              }
            }

            break;
          case 2:
            this._exceptionState = 4;
            this._state_0 = 3;
            suspendResult = this._job0.join_3(this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 3:
            suspendResult;
            Unit_getInstance();
            return Unit_getInstance();
          case 4:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 4) {
          throw $p;
        } else {
          this._state_0 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $cleanupCOROUTINE$22.$metadata$ = {
    simpleName: '$cleanupCOROUTINE$22',
    kind: 'class',
    interfaces: []
  };
  function HttpStatement(builder, client) {
    this._builder_2 = builder;
    this._client_0 = client;
    checkCapabilities(this);
  }
  HttpStatement.prototype.execute_14 = function (block, $cont) {
    var tmp = new $executeCOROUTINE$18(this, block, $cont);
    tmp._result = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_72();
  };
  HttpStatement.prototype.execute_15 = function ($cont) {
    return this.execute_14(_no_name_provided_$factory_174(null), $cont);
  };
  HttpStatement.prototype.executeUnsafe = function ($cont) {
    var tmp = new $executeUnsafeCOROUTINE$21(this, $cont);
    tmp._result = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_72();
  };
  HttpStatement.prototype.cleanup = function (_this__0, $cont) {
    var tmp = new $cleanupCOROUTINE$22(this, _this__0, $cont);
    tmp._result = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_72();
  };
  HttpStatement.prototype.toString = function () {
    return '' + 'HttpStatement[' + this._builder_2._url_0.buildString() + ']';
  };
  HttpStatement.$metadata$ = {
    simpleName: 'HttpStatement',
    kind: 'class',
    interfaces: []
  };
  function $readTextCOROUTINE$17(_this_, fallbackCharset, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__49 = _this_;
    this._fallbackCharset = fallbackCharset;
  }
  $readTextCOROUTINE$17.prototype.doResume_72 = function () {
    var suspendResult = this._result;
    $sm: do
      try {
        var tmp = this._state_0;
        switch (tmp) {
          case 0:
            this._exceptionState = 2;
            var tmp_0 = this;
            var tmp0_elvis_lhs = charset_0(this.__this__49);
            var tmp1_elvis_lhs = tmp0_elvis_lhs == null ? this._fallbackCharset : tmp0_elvis_lhs;
            tmp_0._originCharset0 = tmp1_elvis_lhs == null ? Charsets_getInstance()._UTF_8 : tmp1_elvis_lhs;
            this._decoder1 = this._originCharset0.newDecoder_0();
            this._state_0 = 1;
            var tmp_1 = this.__this__49._get_call__4();
            var tmp_2;
            try {
              tmp_2 = new TypeInfo(getKClass_0(Input), JsType_getInstance(), createKType_0(getKClass_0(Input), [], false));
            } catch ($p) {
              var tmp_3;
              {
                var tmp_4 = getKClass_0(Input);
                var tmp_5 = JsType_getInstance();
                tmp_3 = TypeInfo_init_$Create$(tmp_4, tmp_5, null, 4, null);
              }
              tmp_2 = tmp_3;
            }

            suspendResult = tmp_1.receive_0(tmp_2, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            var tmp_6 = suspendResult;
            var input = isInterface(tmp_6, Input) ? tmp_6 : THROW_CCE();
            return decode$default(this._decoder1, input, 0, 2, null);
          case 2:
            throw this._exception_0;
        }
      } catch ($p_0) {
        if (this._exceptionState === 2) {
          throw $p_0;
        } else {
          this._state_0 = this._exceptionState;
          this._exception_0 = $p_0;
        }
      }
     while (true);
  };
  $readTextCOROUTINE$17.$metadata$ = {
    simpleName: '$readTextCOROUTINE$17',
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided_$factory_174(resultContinuation) {
    var i = new _no_name_provided__216(resultContinuation);
    var l = function (p1, $cont) {
      return i.invoke_324(p1, $cont);
    };
    l.$arity = 1;
    return l;
  }
  function EmptyContent() {
    EmptyContent_instance = this;
    NoContent.call(this);
    this._contentLength_0 = new Long(0, 0);
  }
  EmptyContent.prototype._get_contentLength__6 = function () {
    return this._contentLength_0;
  };
  EmptyContent.prototype.toString = function () {
    return 'EmptyContent';
  };
  EmptyContent.$metadata$ = {
    simpleName: 'EmptyContent',
    kind: 'object',
    interfaces: []
  };
  var EmptyContent_instance;
  function EmptyContent_getInstance() {
    if (EmptyContent_instance == null)
      new EmptyContent();
    return EmptyContent_instance;
  }
  function sharedMap() {
    if (PlatformUtils_getInstance()._IS_NATIVE) {
      return ConcurrentMap_init_$Create$(null, 0, 3, null);
    }return LinkedHashMap_init_$Create$();
  }
  function sharedList() {
    if (PlatformUtils_getInstance()._IS_NATIVE) {
      return new ConcurrentList();
    }return ArrayList_init_$Create$();
  }
  function buildHeaders(block) {
    var tmp0_apply_0 = HeadersBuilder_init_$Create$(0, 1, null);
    block(tmp0_apply_0);
    return tmp0_apply_0.build_16();
  }
  function HttpClient_1(block) {
    return HttpClient_0(JsClient_0(), block);
  }
  function instanceOf(_this_, type) {
    return type.isInstance_4(_this_);
  }
  function Type() {
  }
  Type.$metadata$ = {
    simpleName: 'Type',
    kind: 'interface',
    interfaces: []
  };
  function JsType() {
    JsType_instance = this;
  }
  JsType.$metadata$ = {
    simpleName: 'JsType',
    kind: 'object',
    interfaces: [Type]
  };
  var JsType_instance;
  function JsType_getInstance() {
    if (JsType_instance == null)
      new JsType();
    return JsType_instance;
  }
  function createCallContext(_this_, parentJob, $cont) {
    var callJob = Job_0(parentJob);
    var callContext_0 = _this_._get_coroutineContext__22().plus_28(callJob).plus_28(CALL_COROUTINE);
    var tmp$ret$0;
    l$ret$1: do {
      var tmp0_elvis_lhs_2 = $cont._get_context__86().get_70(Key_getInstance_3());
      var tmp;
      if (tmp0_elvis_lhs_2 == null) {
        tmp$ret$0 = Unit_getInstance();
        break l$ret$1;
      } else {
        tmp = tmp0_elvis_lhs_2;
      }
      var userJob_1 = tmp;
      var cleanupHandler_3 = userJob_1.invokeOnCompletion$default_9(true, false, _no_name_provided_$factory_175(callJob), 2, null);
      callJob.invokeOnCompletion_22(_no_name_provided_$factory_176(cleanupHandler_3));
      Unit_getInstance();
    }
     while (false);
    return callContext_0;
  }
  function _no_name_provided__217($callJob) {
    this._$callJob = $callJob;
  }
  _no_name_provided__217.prototype.invoke_375 = function (cause) {
    var tmp0_elvis_lhs_5 = cause;
    if (tmp0_elvis_lhs_5 == null)
      return Unit_getInstance();
    else
      tmp0_elvis_lhs_5;
    Unit_getInstance();
    this._$callJob.cancel_20(CancellationException_init_$Create$(cause.message));
  };
  _no_name_provided__217.prototype.invoke_542 = function (p1) {
    this.invoke_375((p1 == null ? true : p1 instanceof Error) ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__217.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__218($cleanupHandler_3) {
    this._$cleanupHandler_3 = $cleanupHandler_3;
  }
  _no_name_provided__218.prototype.invoke_375 = function (it) {
    this._$cleanupHandler_3.dispose_26();
  };
  _no_name_provided__218.prototype.invoke_542 = function (p1) {
    this.invoke_375((p1 == null ? true : p1 instanceof Error) ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__218.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided_$factory_175($callJob) {
    var i = new _no_name_provided__217($callJob);
    return function (p1) {
      i.invoke_375(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_176($cleanupHandler_3) {
    var i = new _no_name_provided__218($cleanupHandler_3);
    return function (p1) {
      i.invoke_375(p1);
      return Unit_getInstance();
    };
  }
  function JsClient_0() {
    return Js_getInstance();
  }
  function Js() {
    Js_instance = this;
  }
  Js.prototype.create_24 = function (block) {
    var tmp0_apply_0 = new HttpClientEngineConfig();
    block(tmp0_apply_0);
    return new JsClientEngine(tmp0_apply_0);
  };
  Js.prototype.create_25 = function (block) {
    return this.create_24(block);
  };
  Js.$metadata$ = {
    simpleName: 'Js',
    kind: 'object',
    interfaces: [HttpClientEngineFactory]
  };
  var Js_instance;
  function Js_getInstance() {
    if (Js_instance == null)
      new Js();
    return Js_instance;
  }
  function createWebSocket($this, urlString_capturingHack) {
    var tmp;
    if (PlatformUtils_getInstance()._IS_NODE) {
      var ws_capturingHack = require('ws');
      tmp = new ws_capturingHack(urlString_capturingHack);
    } else {
      tmp = new WebSocket(urlString_capturingHack);
    }
    return tmp;
  }
  function executeWebSocketRequest($this, request, callContext_0, $cont) {
    var tmp = new $executeWebSocketRequestCOROUTINE$24($this, request, callContext_0, $cont);
    tmp._result = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_72();
  }
  function $executeCOROUTINE$23(_this_, data, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__50 = _this_;
    this._data_5 = data;
  }
  $executeCOROUTINE$23.prototype.doResume_72 = function () {
    var suspendResult = this._result;
    $sm: do
      try {
        var tmp = this._state_0;
        switch (tmp) {
          case 0:
            this._exceptionState = 6;
            this._state_0 = 1;
            suspendResult = callContext(this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            this._callContext0_0 = suspendResult;
            if (isUpgradeRequest(this._data_5)) {
              this._state_0 = 5;
              suspendResult = executeWebSocketRequest(this.__this__50, this._data_5, this._callContext0_0, this);
              if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
                return suspendResult;
              }continue $sm;
            } else {
              this._state_0 = 2;
              continue $sm;
            }

            break;
          case 2:
            var tmp_0 = this;
            tmp_0._requestTime1 = GMTDate$default(null, 1, null);
            this._state_0 = 3;
            suspendResult = toRaw(this._data_5, this._callContext0_0, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 3:
            this._rawRequest2 = suspendResult;
            this._state_0 = 4;
            suspendResult = commonFetch(this._data_5._url_1.toString(), this._rawRequest2, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 4:
            var rawResponse = suspendResult;
            var status = new HttpStatusCode(numberToInt(rawResponse.status), rawResponse.statusText);
            var headers = mapToKtor(rawResponse.headers);
            var version = Companion_getInstance_50()._HTTP_1_1;
            var body = readBody(CoroutineScope_0(this._callContext0_0), rawResponse);
            return new HttpResponseData(status, this._requestTime1, headers, version, body, this._callContext0_0);
          case 5:
            return suspendResult;
          case 6:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 6) {
          throw $p;
        } else {
          this._state_0 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $executeCOROUTINE$23.$metadata$ = {
    simpleName: '$executeCOROUTINE$23',
    kind: 'class',
    interfaces: []
  };
  function $executeWebSocketRequestCOROUTINE$24(_this_, request, callContext_0, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__51 = _this_;
    this._request_0 = request;
    this._callContext_1 = callContext_0;
  }
  $executeWebSocketRequestCOROUTINE$24.prototype.doResume_72 = function () {
    var suspendResult = this._result;
    $sm: do
      try {
        var tmp = this._state_0;
        switch (tmp) {
          case 0:
            this._exceptionState = 4;
            var tmp_0 = this;
            tmp_0._requestTime0 = GMTDate$default(null, 1, null);
            this._urlString1 = this._request_0._url_1.toString();
            this._socket2 = createWebSocket(this.__this__51, this._urlString1);
            this._exceptionState = 2;
            this._state_0 = 1;
            suspendResult = awaitConnection(this._socket2, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            suspendResult;
            Unit_getInstance();
            this._exceptionState = 4;
            this._state_0 = 3;
            continue $sm;
          case 2:
            this._exceptionState = 4;
            var tmp_1 = this._exception_0;
            if (tmp_1 instanceof Error) {
              var cause = this._exception_0;
              cancel_2(this._callContext_1, new CancellationException('' + 'Failed to connect to ' + this._urlString1, cause));
              throw cause;
            } else {
              {
                throw this._exception_0;
              }
            }

            break;
          case 3:
            this._exceptionState = 4;
            var session = new JsWebSocketSession(this._callContext_1, this._socket2);
            return new HttpResponseData(Companion_getInstance_51()._OK, this._requestTime0, Companion_getInstance_48()._Empty_2, Companion_getInstance_50()._HTTP_1_1, session, this._callContext_1);
          case 4:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 4) {
          throw $p;
        } else {
          this._state_0 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $executeWebSocketRequestCOROUTINE$24.$metadata$ = {
    simpleName: '$executeWebSocketRequestCOROUTINE$24',
    kind: 'class',
    interfaces: []
  };
  function JsClientEngine(config) {
    HttpClientEngineBase.call(this, 'ktor-js');
    this._config_0 = config;
    this._dispatcher_0 = Dispatchers_getInstance()._Default;
    this._supportedCapabilities = setOf([Feature_getInstance_4(), WebSocketCapability_getInstance()]);
    var tmp0_check_0 = this._config_0._proxy == null;
    if (!tmp0_check_0) {
      var message_1 = 'Proxy unsupported in Js engine.';
      throw IllegalStateException_init_$Create$(toString_1(message_1));
    }}
  JsClientEngine.prototype._get_config__1 = function () {
    return this._config_0;
  };
  JsClientEngine.prototype._get_dispatcher__0 = function () {
    return this._dispatcher_0;
  };
  JsClientEngine.prototype._get_supportedCapabilities__1 = function () {
    return this._supportedCapabilities;
  };
  JsClientEngine.prototype.execute_16 = function (data, $cont) {
    var tmp = new $executeCOROUTINE$23(this, data, $cont);
    tmp._result = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_72();
  };
  JsClientEngine.$metadata$ = {
    simpleName: 'JsClientEngine',
    kind: 'class',
    interfaces: []
  };
  function mapToKtor(_this_) {
    return buildHeaders(_no_name_provided_$factory_177(_this_));
  }
  function awaitConnection(_this_, $cont) {
    var tmp0__anonymous__1_1 = $cont;
    var cancellable_2_2 = new CancellableContinuationImpl(intercepted(tmp0__anonymous__1_1), 1);
    cancellable_2_2.initCancellability_0();
    var tmp$ret$0;
    l$ret$1: do {
      if (cancellable_2_2._get_isCancelled__1()) {
        tmp$ret$0 = Unit_getInstance();
        break l$ret$1;
      }var eventListener_4 = _no_name_provided_$factory_178(cancellable_2_2, _this_);
      _this_.addEventListener('open', eventListener_4);
      _this_.addEventListener('error', eventListener_4);
      cancellable_2_2.invokeOnCancellation_1(_no_name_provided_$factory_179(_this_, eventListener_4));
    }
     while (false);
    return cancellable_2_2.getResult_0();
  }
  function JsError(origin) {
    extendThrowable(this, '' + 'Error from javascript[' + origin + '].', void 1);
    this._origin_2 = origin;
    captureStack(this, JsError);
  }
  JsError.$metadata$ = {
    simpleName: 'JsError',
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__219($this) {
    this._$this_8 = $this;
  }
  _no_name_provided__219.prototype.invoke_338 = function (value, key) {
    this._$this_8.append_35(key, value);
  };
  _no_name_provided__219.prototype.invoke_537 = function (p1, p2) {
    var tmp = (!(p1 == null) ? typeof p1 === 'string' : false) ? p1 : THROW_CCE();
    this.invoke_338(tmp, (!(p2 == null) ? typeof p2 === 'string' : false) ? p2 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__219.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__220($this_mapToKtor) {
    this._$this_mapToKtor = $this_mapToKtor;
  }
  _no_name_provided__220.prototype.invoke_332 = function (_this__0) {
    this._$this_mapToKtor.forEach(_no_name_provided_$factory_180(_this__0));
    Unit_getInstance();
  };
  _no_name_provided__220.prototype.invoke_542 = function (p1) {
    this.invoke_332(p1 instanceof HeadersBuilder ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__220.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__221($cancellable_2_2, $this_awaitConnection) {
    this._$cancellable_2_2 = $cancellable_2_2;
    this._$this_awaitConnection = $this_awaitConnection;
  }
  _no_name_provided__221.prototype.invoke_504 = function (event) {
    var tmp0_subject_6 = event.type;
    if (tmp0_subject_6 === 'open') {
      var tmp0_success_0_1_7 = Companion_getInstance_3();
      this._$cancellable_2_2.resumeWith_34(_Result___init__impl_(this._$this_awaitConnection));
    } else if (tmp0_subject_6 === 'error') {
      var tmp0_resumeWithException_0_8 = new WebSocketException(JSON.stringify(event));
      var tmp0_failure_0_1_9 = Companion_getInstance_3();
      this._$cancellable_2_2.resumeWith_34(_Result___init__impl_(createFailure(tmp0_resumeWithException_0_8)));
    }};
  _no_name_provided__221.prototype.invoke_542 = function (p1) {
    this.invoke_504(p1 instanceof Event ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__221.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__222($this_awaitConnection, $eventListener_4) {
    this._$this_awaitConnection_0 = $this_awaitConnection;
    this._$eventListener_4 = $eventListener_4;
  }
  _no_name_provided__222.prototype.invoke_375 = function (it) {
    this._$this_awaitConnection_0.removeEventListener('open', this._$eventListener_4);
    this._$this_awaitConnection_0.removeEventListener('error', this._$eventListener_4);
    if (!(it == null)) {
      this._$this_awaitConnection_0.close();
    }};
  _no_name_provided__222.prototype.invoke_542 = function (p1) {
    this.invoke_375((p1 == null ? true : p1 instanceof Error) ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__222.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided_$factory_177($this_mapToKtor) {
    var i = new _no_name_provided__220($this_mapToKtor);
    return function (p1) {
      i.invoke_332(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_178($cancellable_2_2, $this_awaitConnection) {
    var i = new _no_name_provided__221($cancellable_2_2, $this_awaitConnection);
    return function (p1) {
      i.invoke_504(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_179($this_awaitConnection, $eventListener_4) {
    var i = new _no_name_provided__222($this_awaitConnection, $eventListener_4);
    return function (p1) {
      i.invoke_375(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_180($this) {
    var i = new _no_name_provided__219($this);
    return function (p1, p2) {
      i.invoke_338(p1, p2);
      return Unit_getInstance();
    };
  }
  function toRaw(_this_, callContext_0, $cont) {
    var tmp = new $toRawCOROUTINE$25(_this_, callContext_0, $cont);
    tmp._result = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_72();
  }
  function buildObject(block) {
    var tmp = {};
    var tmp0_apply_0 = (tmp == null ? true : isObject(tmp)) ? tmp : THROW_CCE();
    block(tmp0_apply_0);
    return tmp0_apply_0;
  }
  function _no_name_provided__223($jsHeaders) {
    this._$jsHeaders = $jsHeaders;
  }
  _no_name_provided__223.prototype.invoke_338 = function (key, value) {
    this._$jsHeaders[key] = value;
  };
  _no_name_provided__223.prototype.invoke_537 = function (p1, p2) {
    var tmp = (!(p1 == null) ? typeof p1 === 'string' : false) ? p1 : THROW_CCE();
    this.invoke_338(tmp, (!(p2 == null) ? typeof p2 === 'string' : false) ? p2 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__223.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__224($content, resultContinuation) {
    this._$content_0 = $content;
    CoroutineImpl_0.call(this, resultContinuation);
  }
  _no_name_provided__224.prototype.invoke_361 = function (_this__0, $cont) {
    var tmp = this.create_28(_this__0, $cont);
    tmp._result = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_72();
  };
  _no_name_provided__224.prototype.invoke_542 = function (p1, $cont) {
    this.invoke_361((!(p1 == null) ? isInterface(p1, WriterScope) : false) ? p1 : THROW_CCE(), $cont);
    return Unit_getInstance();
  };
  _no_name_provided__224.prototype.doResume_72 = function () {
    var suspendResult = this._result;
    $sm: do
      try {
        var tmp = this._state_0;
        switch (tmp) {
          case 0:
            this._exceptionState = 2;
            this._state_0 = 1;
            suspendResult = this._$content_0.writeTo(this.__this__52._get_channel__2(), this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            suspendResult;
            return Unit_getInstance();
          case 2:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 2) {
          throw $p;
        } else {
          this._state_0 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  _no_name_provided__224.prototype.create_28 = function (_this__0, completion) {
    var i = new _no_name_provided__224(this._$content_0, completion);
    i.__this__52 = _this__0;
    return i;
  };
  _no_name_provided__224.$metadata$ = {
    kind: 'class',
    interfaces: [],
    suspendArity: 1
  };
  function _no_name_provided__225($this_toRaw, $jsHeaders, $bodyBytes) {
    this._$this_toRaw = $this_toRaw;
    this._$jsHeaders_0 = $jsHeaders;
    this._$bodyBytes = $bodyBytes;
  }
  _no_name_provided__225.prototype.invoke_342 = function (_this__0) {
    _this__0.method = this._$this_toRaw._method_1._value_31;
    _this__0.headers = this._$jsHeaders_0;
    var tmp0__get_FOLLOW__0 = null;
    var tmp0_asDynamic_0_2 = 'follow';
    var tmp1_unsafeCast_0_1 = tmp0_asDynamic_0_2;
    _this__0.redirect = tmp1_unsafeCast_0_1;
    var tmp0_safe_receiver = this._$bodyBytes;
    if (tmp0_safe_receiver == null)
      null;
    else {
      _this__0.body = new Uint8Array(toTypedArray(tmp0_safe_receiver));
      Unit_getInstance();
    }
    Unit_getInstance();
  };
  _no_name_provided__225.prototype.invoke_542 = function (p1) {
    this.invoke_342((!(p1 == null) ? isObject(p1) : false) ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__225.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function $toRawCOROUTINE$25(_this_, callContext_0, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__53 = _this_;
    this._callContext_2 = callContext_0;
  }
  $toRawCOROUTINE$25.prototype.doResume_72 = function () {
    var suspendResult = this._result;
    $sm: do
      try {
        var tmp = this._state_0;
        switch (tmp) {
          case 0:
            this._exceptionState = 4;
            this._jsHeaders0 = {};
            mergeHeaders(this.__this__53._headers_2, this.__this__53._body_1, _no_name_provided_$factory_181(this._jsHeaders0));
            this._content1_0 = this.__this__53._body_1;
            var tmp_0 = this._content1_0;
            if (tmp_0 instanceof ByteArrayContent) {
              this._WHEN_RESULT2 = this._content1_0.bytes_1();
              this._state_0 = 3;
              continue $sm;
            } else {
              {
                var tmp_1 = this._content1_0;
                if (tmp_1 instanceof ReadChannelContent) {
                  this._state_0 = 2;
                  suspendResult = readRemaining(this._content1_0.readFrom_0(), this);
                  if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
                    return suspendResult;
                  }continue $sm;
                } else {
                  {
                    var tmp_2 = this._content1_0;
                    if (tmp_2 instanceof WriteChannelContent) {
                      this._state_0 = 1;
                      var tmp_3 = GlobalScope_getInstance();
                      suspendResult = readRemaining(writer$default(tmp_3, this._callContext_2, false, _no_name_provided_$factory_182(this._content1_0, null), 2, null)._get_channel__2(), this);
                      if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
                        return suspendResult;
                      }continue $sm;
                    } else {
                      {
                        this._WHEN_RESULT2 = null;
                        this._state_0 = 3;
                        continue $sm;
                      }
                    }
                    Unit_getInstance();
                  }
                }
                Unit_getInstance();
              }
            }

            break;
          case 1:
            var ARGUMENT = suspendResult;
            var tmp_4 = this;
            tmp_4._WHEN_RESULT2 = readBytes$default(ARGUMENT, 0, 1, null);
            this._state_0 = 3;
            continue $sm;
          case 2:
            var ARGUMENT_0 = suspendResult;
            var tmp_5 = this;
            tmp_5._WHEN_RESULT2 = readBytes$default(ARGUMENT_0, 0, 1, null);
            this._state_0 = 3;
            continue $sm;
          case 3:
            var bodyBytes = this._WHEN_RESULT2;
            return buildObject(_no_name_provided_$factory_183(this.__this__53, this._jsHeaders0, bodyBytes));
          case 4:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 4) {
          throw $p;
        } else {
          this._state_0 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $toRawCOROUTINE$25.$metadata$ = {
    simpleName: '$toRawCOROUTINE$25',
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided_$factory_181($jsHeaders) {
    var i = new _no_name_provided__223($jsHeaders);
    return function (p1, p2) {
      i.invoke_338(p1, p2);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_182($content, resultContinuation) {
    var i = new _no_name_provided__224($content, resultContinuation);
    var l = function (p1, $cont) {
      return i.invoke_361(p1, $cont);
    };
    l.$arity = 1;
    return l;
  }
  function _no_name_provided_$factory_183($this_toRaw, $jsHeaders, $bodyBytes) {
    var i = new _no_name_provided__225($this_toRaw, $jsHeaders, $bodyBytes);
    return function (p1) {
      i.invoke_342(p1);
      return Unit_getInstance();
    };
  }
  function readChunk(_this_, $cont) {
    var tmp0__anonymous__1_1 = $cont;
    var cancellable_2_2 = new CancellableContinuationImpl(intercepted(tmp0__anonymous__1_1), 1);
    cancellable_2_2.initCancellability_0();
    var tmp = _this_.read();
    var tmp_0 = tmp.then(_no_name_provided_$factory_184(cancellable_2_2));
    tmp_0.catch(_no_name_provided_$factory_185(cancellable_2_2));
    Unit_getInstance();
    return cancellable_2_2.getResult_0();
  }
  function asByteArray(_this_) {
    var tmp0_asDynamic_0 = new Int8Array(_this_.buffer, _this_.byteOffset, _this_.length);
    return tmp0_asDynamic_0;
  }
  function _no_name_provided__226($cancellable_2_2) {
    this._$cancellable_2_2_0 = $cancellable_2_2;
  }
  _no_name_provided__226.prototype.invoke_344 = function (it) {
    var chunk_5 = it.value;
    var result_6 = (it.done ? true : chunk_5 == null) ? null : chunk_5;
    var tmp0_success_0_7 = Companion_getInstance_3();
    this._$cancellable_2_2_0.resumeWith_34(_Result___init__impl_(result_6));
  };
  _no_name_provided__226.prototype.invoke_542 = function (p1) {
    this.invoke_344((!(p1 == null) ? isObject(p1) : false) ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__226.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__227($cancellable_2_2) {
    this._$cancellable_2_2_1 = $cancellable_2_2;
  }
  _no_name_provided__227.prototype.invoke_354 = function (cause) {
    var tmp0_failure_0_1_9 = Companion_getInstance_3();
    this._$cancellable_2_2_1.resumeWith_34(_Result___init__impl_(createFailure(cause)));
  };
  _no_name_provided__227.prototype.invoke_542 = function (p1) {
    this.invoke_354(p1 instanceof Error ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__227.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided_$factory_184($cancellable_2_2) {
    var i = new _no_name_provided__226($cancellable_2_2);
    return function (p1) {
      i.invoke_344(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_185($cancellable_2_2) {
    var i = new _no_name_provided__227($cancellable_2_2);
    return function (p1) {
      i.invoke_354(p1);
      return Unit_getInstance();
    };
  }
  function readBodyBrowser(_this_, response) {
    var tmp = response.body;
    var tmp0_elvis_lhs = (!(tmp == null) ? isObject(tmp) : false) ? tmp : null;
    var tmp_0;
    if (tmp0_elvis_lhs == null) {
      var tmp0_error_0 = '' + 'Fail to obtain native stream: ' + response;
      throw IllegalStateException_init_$Create$(toString_1(tmp0_error_0));
    } else {
      tmp_0 = tmp0_elvis_lhs;
    }
    var stream = tmp_0;
    return channelFromStream(_this_, stream);
  }
  function channelFromStream(_this_, stream) {
    return writer$default(_this_, null, false, _no_name_provided_$factory_186(stream, null), 3, null)._get_channel__2();
  }
  function _no_name_provided__228($stream, resultContinuation) {
    this._$stream = $stream;
    CoroutineImpl_0.call(this, resultContinuation);
  }
  _no_name_provided__228.prototype.invoke_361 = function (_this__0, $cont) {
    var tmp = this.create_28(_this__0, $cont);
    tmp._result = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_72();
  };
  _no_name_provided__228.prototype.invoke_542 = function (p1, $cont) {
    this.invoke_361((!(p1 == null) ? isInterface(p1, WriterScope) : false) ? p1 : THROW_CCE(), $cont);
    return Unit_getInstance();
  };
  _no_name_provided__228.prototype.doResume_72 = function () {
    var suspendResult = this._result;
    $sm: do
      try {
        var tmp = this._state_0;
        switch (tmp) {
          case 0:
            this._exceptionState = 6;
            this._reader0 = this._$stream.getReader();
            this._state_0 = 1;
            continue $sm;
          case 1:
            if (false) {
              this._state_0 = 8;
              continue $sm;
            }
            this._exceptionState = 5;
            this._state_0 = 2;
            suspendResult = readChunk(this._reader0, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 2:
            this._tmp0_elvis_lhs1 = suspendResult;
            if (this._tmp0_elvis_lhs1 == null) {
              this._exceptionState = 6;
              this._state_0 = 8;
              var tmp_0 = this;
              continue $sm;
            } else {
              this._WHEN_RESULT2_0 = this._tmp0_elvis_lhs1;
              this._state_0 = 3;
              continue $sm;
            }

            break;
          case 3:
            this._chunk3 = this._WHEN_RESULT2_0;
            this._state_0 = 4;
            suspendResult = writeFully(this.__this__54._get_channel__2(), asByteArray(this._chunk3), this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 4:
            suspendResult;
            this._exceptionState = 6;
            this._state_0 = 7;
            continue $sm;
          case 5:
            this._exceptionState = 6;
            var tmp_1 = this._exception_0;
            if (tmp_1 instanceof Error) {
              var cause = this._exception_0;
              this._reader0.cancel(cause);
              Unit_getInstance();
              throw cause;
            } else {
              {
                throw this._exception_0;
              }
            }

            break;
          case 6:
            throw this._exception_0;
          case 7:
            this._exceptionState = 6;
            this._state_0 = 1;
            continue $sm;
          case 8:
            return Unit_getInstance();
        }
      } catch ($p) {
        if (this._exceptionState === 6) {
          throw $p;
        } else {
          this._state_0 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  _no_name_provided__228.prototype.create_28 = function (_this__0, completion) {
    var i = new _no_name_provided__228(this._$stream, completion);
    i.__this__54 = _this__0;
    return i;
  };
  _no_name_provided__228.$metadata$ = {
    kind: 'class',
    interfaces: [],
    suspendArity: 1
  };
  function _no_name_provided_$factory_186($stream, resultContinuation) {
    var i = new _no_name_provided__228($stream, resultContinuation);
    var l = function (p1, $cont) {
      return i.invoke_361(p1, $cont);
    };
    l.$arity = 1;
    return l;
  }
  function commonFetch(input, init, $cont) {
    var tmp0__anonymous__1_1 = $cont;
    var cancellable_2_2 = new CancellableContinuationImpl(intercepted(tmp0__anonymous__1_1), 1);
    cancellable_2_2.initCancellability_0();
    var controller_4 = AbortController_0();
    init.signal = controller_4.signal;
    cancellable_2_2.invokeOnCancellation_1(_no_name_provided_$factory_187(controller_4));
    var tmp;
    if (PlatformUtils_getInstance()._IS_BROWSER) {
      tmp = fetch(input, init);
    } else {
      tmp = jsRequireNodeFetch()(input, init);
    }
    var promise_6 = tmp;
    var tmp_0 = _no_name_provided_$factory_188(cancellable_2_2);
    promise_6.then(tmp_0, _no_name_provided_$factory_189(cancellable_2_2));
    Unit_getInstance();
    return cancellable_2_2.getResult_0();
  }
  function readBody(_this_, response) {
    var tmp;
    if (PlatformUtils_getInstance()._IS_BROWSER) {
      tmp = readBodyBrowser(_this_, response);
    } else {
      tmp = readBodyNode(_this_, response);
    }
    return tmp;
  }
  function AbortController_0() {
    var tmp;
    if (PlatformUtils_getInstance()._IS_BROWSER) {
      tmp = new AbortController();
    } else {
      var controller = require('abort-controller');
      tmp = new controller();
    }
    return tmp;
  }
  function jsRequireNodeFetch() {
    var tmp;
    try {
      tmp = require('node-fetch');
    } catch ($p) {
      var tmp_0;
      {
        throw Error_init_$Create$('' + "Error loading module 'node-fetch': " + $p);
      }
      tmp = tmp_0;
    }
    return tmp;
  }
  function _no_name_provided__229($controller_4) {
    this._$controller_4 = $controller_4;
  }
  _no_name_provided__229.prototype.invoke_375 = function (it) {
    this._$controller_4.abort();
  };
  _no_name_provided__229.prototype.invoke_542 = function (p1) {
    this.invoke_375((p1 == null ? true : p1 instanceof Error) ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__229.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__230($cancellable_2_2) {
    this._$cancellable_2_2_2 = $cancellable_2_2;
  }
  _no_name_provided__230.prototype.invoke_352 = function (it) {
    var tmp0_success_0_8 = Companion_getInstance_3();
    this._$cancellable_2_2_2.resumeWith_34(_Result___init__impl_(it));
  };
  _no_name_provided__230.prototype.invoke_542 = function (p1) {
    this.invoke_352((!(p1 == null) ? isObject(p1) : false) ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__230.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__231($cancellable_2_2) {
    this._$cancellable_2_2_3 = $cancellable_2_2;
  }
  _no_name_provided__231.prototype.invoke_354 = function (it) {
    var tmp0_failure_0_10 = Companion_getInstance_3();
    var tmp1_failure_0_11 = Error_init_$Create$_0('Fail to fetch', it);
    this._$cancellable_2_2_3.resumeWith_34(_Result___init__impl_(createFailure(tmp1_failure_0_11)));
  };
  _no_name_provided__231.prototype.invoke_542 = function (p1) {
    this.invoke_354(p1 instanceof Error ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__231.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided_$factory_187($controller_4) {
    var i = new _no_name_provided__229($controller_4);
    return function (p1) {
      i.invoke_375(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_188($cancellable_2_2) {
    var i = new _no_name_provided__230($cancellable_2_2);
    return function (p1) {
      i.invoke_352(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_189($cancellable_2_2) {
    var i = new _no_name_provided__231($cancellable_2_2);
    return function (p1) {
      i.invoke_354(p1);
      return Unit_getInstance();
    };
  }
  function readBodyNode(_this_, response) {
    return writer$default(_this_, null, false, _no_name_provided_$factory_190(response, null), 3, null)._get_channel__2();
  }
  function _no_name_provided__232($responseData, $body) {
    this._$responseData = $responseData;
    this._$body_2 = $body;
  }
  _no_name_provided__232.prototype.invoke_356 = function (chunk) {
    var result = this._$responseData.offer_5(asByteArray(new Uint8Array(chunk)));
    return this._$body_2.pause();
  };
  _no_name_provided__232.prototype.invoke_542 = function (p1) {
    return this.invoke_356(p1 instanceof ArrayBuffer ? p1 : THROW_CCE());
  };
  _no_name_provided__232.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__233($responseData, $this) {
    this._$responseData_0 = $responseData;
    this._$this_9 = $this;
  }
  _no_name_provided__233.prototype.invoke_358 = function (error_1) {
    var cause = new JsError(error_1);
    this._$responseData_0.close_27(cause);
    Unit_getInstance();
    return this._$this_9._get_channel__2().close_27(cause);
  };
  _no_name_provided__233.prototype.invoke_542 = function (p1) {
    return this.invoke_358((p1 == null ? true : p1) ? p1 : THROW_CCE());
  };
  _no_name_provided__233.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__234($responseData) {
    this._$responseData_1 = $responseData;
  }
  _no_name_provided__234.prototype.invoke_540 = function () {
    return this._$responseData_1.close$default_5(null, 1, null);
  };
  _no_name_provided__234.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__235($response, resultContinuation) {
    this._$response_0 = $response;
    CoroutineImpl_0.call(this, resultContinuation);
  }
  _no_name_provided__235.prototype.invoke_361 = function (_this__0, $cont) {
    var tmp = this.create_28(_this__0, $cont);
    tmp._result = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_72();
  };
  _no_name_provided__235.prototype.invoke_542 = function (p1, $cont) {
    this.invoke_361((!(p1 == null) ? isInterface(p1, WriterScope) : false) ? p1 : THROW_CCE(), $cont);
    return Unit_getInstance();
  };
  _no_name_provided__235.prototype.doResume_72 = function () {
    var suspendResult = this._result;
    $sm: do
      try {
        var tmp = this._state_0;
        switch (tmp) {
          case 0:
            this._exceptionState = 6;
            var tmp_0 = this;
            var tmp0_elvis_lhs = this._$response_0.body;
            var tmp_1;
            if (tmp0_elvis_lhs == null) {
              var tmp0_error_0 = 'Fail to get body';
              throw IllegalStateException_init_$Create$(toString_1(tmp0_error_0));
            } else {
              tmp_1 = tmp0_elvis_lhs;
            }

            tmp_0._body0 = tmp_1;
            var tmp_2 = this;
            tmp_2._responseData1 = Channel$default(1, null, null, 6, null);
            this._body0.on('data', _no_name_provided_$factory_191(this._responseData1, this._body0));
            this._body0.on('error', _no_name_provided_$factory_192(this._responseData1, this.__this__55));
            this._body0.on('end', _no_name_provided_$factory_193(this._responseData1));
            this._exceptionState = 5;
            this._tmp1_iterator2 = this._responseData1.iterator_64();
            this._state_0 = 1;
            continue $sm;
          case 1:
            this._state_0 = 2;
            suspendResult = this._tmp1_iterator2.hasNext_31(this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 2:
            if (!suspendResult) {
              this._state_0 = 4;
              continue $sm;
            }
            this._chunk3_0 = this._tmp1_iterator2.next_35();
            this._state_0 = 3;
            suspendResult = writeFully(this.__this__55._get_channel__2(), this._chunk3_0, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 3:
            suspendResult;
            this._body0.resume();
            this._state_0 = 1;
            continue $sm;
          case 4:
            this._exceptionState = 6;
            this._state_0 = 7;
            continue $sm;
          case 5:
            this._exceptionState = 6;
            var tmp_3 = this._exception_0;
            if (tmp_3 instanceof Error) {
              var cause = this._exception_0;
              this._body0.destroy(cause);
              throw cause;
            } else {
              {
                throw this._exception_0;
              }
            }

            break;
          case 6:
            throw this._exception_0;
          case 7:
            this._exceptionState = 6;
            Unit_getInstance();
            return Unit_getInstance();
        }
      } catch ($p) {
        if (this._exceptionState === 6) {
          throw $p;
        } else {
          this._state_0 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  _no_name_provided__235.prototype.create_28 = function (_this__0, completion) {
    var i = new _no_name_provided__235(this._$response_0, completion);
    i.__this__55 = _this__0;
    return i;
  };
  _no_name_provided__235.$metadata$ = {
    kind: 'class',
    interfaces: [],
    suspendArity: 1
  };
  function _no_name_provided_$factory_190($response, resultContinuation) {
    var i = new _no_name_provided__235($response, resultContinuation);
    var l = function (p1, $cont) {
      return i.invoke_361(p1, $cont);
    };
    l.$arity = 1;
    return l;
  }
  function _no_name_provided_$factory_191($responseData, $body) {
    var i = new _no_name_provided__232($responseData, $body);
    return function (p1) {
      return i.invoke_356(p1);
    };
  }
  function _no_name_provided_$factory_192($responseData, $this) {
    var i = new _no_name_provided__233($responseData, $this);
    return function (p1) {
      return i.invoke_358(p1);
    };
  }
  function _no_name_provided_$factory_193($responseData) {
    var i = new _no_name_provided__234($responseData);
    return function () {
      return i.invoke_540();
    };
  }
  function platformDefaultTransformers(_this_) {
  }
  function _no_name_provided__236($event, this$0, resultContinuation) {
    this._$event = $event;
    this._this$0_57 = this$0;
    CoroutineImpl_0.call(this, resultContinuation);
  }
  _no_name_provided__236.prototype.invoke_489 = function (_this__0, $cont) {
    var tmp = this.create_38(_this__0, $cont);
    tmp._result = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_72();
  };
  _no_name_provided__236.prototype.invoke_542 = function (p1, $cont) {
    this.invoke_489((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $cont);
    return Unit_getInstance();
  };
  _no_name_provided__236.prototype.doResume_72 = function () {
    var suspendResult = this._result;
    $sm: do
      try {
        var tmp = this._state_0;
        if (tmp === 0) {
          this._exceptionState = 1;
          var data = this._$event.data;
          var tmp0_subject = data;
          var tmp_0;
          if (tmp0_subject instanceof ArrayBuffer) {
            var tmp0_unsafeCast_0 = new Int8Array(data);
            tmp_0 = Binary_init_$Create$(false, tmp0_unsafeCast_0);
          } else {
            if (!(tmp0_subject == null) ? typeof tmp0_subject === 'string' : false) {
              tmp_0 = Text_init_$Create$(data);
            } else {
              {
                var error_1 = IllegalStateException_init_$Create$('' + 'Unknown frame type: ' + this._$event.type);
                this._this$0_57.__closeReason.completeExceptionally_3(error_1);
                Unit_getInstance();
                throw error_1;
              }
            }
          }
          var frame = tmp_0;
          this._this$0_57.__incoming.offer_5(frame);
          Unit_getInstance();
          return Unit_getInstance();
        } else if (tmp === 1) {
          throw this._exception_0;
        }} catch ($p) {
        throw $p;
      }
     while (true);
  };
  _no_name_provided__236.prototype.create_38 = function (_this__0, completion) {
    var i = new _no_name_provided__236(this._$event, this._this$0_57, completion);
    i.__this__56 = _this__0;
    return i;
  };
  _no_name_provided__236.$metadata$ = {
    kind: 'class',
    interfaces: [],
    suspendArity: 1
  };
  function _no_name_provided__237($event, this$0, resultContinuation) {
    this._$event_0 = $event;
    this._this$0_58 = this$0;
    CoroutineImpl_0.call(this, resultContinuation);
  }
  _no_name_provided__237.prototype.invoke_489 = function (_this__0, $cont) {
    var tmp = this.create_38(_this__0, $cont);
    tmp._result = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_72();
  };
  _no_name_provided__237.prototype.invoke_542 = function (p1, $cont) {
    this.invoke_489((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $cont);
    return Unit_getInstance();
  };
  _no_name_provided__237.prototype.doResume_72 = function () {
    var suspendResult = this._result;
    $sm: do
      try {
        var tmp = this._state_0;
        switch (tmp) {
          case 0:
            this._exceptionState = 2;
            var tmp_0 = this;
            var tmp_1 = this._$event_0.code;
            var tmp_2 = (!(tmp_1 == null) ? typeof tmp_1 === 'number' : false) ? tmp_1 : THROW_CCE();
            var tmp_3 = this._$event_0.reason;
            tmp_0._reason0 = new CloseReason(tmp_2, (!(tmp_3 == null) ? typeof tmp_3 === 'string' : false) ? tmp_3 : THROW_CCE());
            this._this$0_58.__closeReason.complete_0(this._reason0);
            Unit_getInstance();
            this._state_0 = 1;
            suspendResult = this._this$0_58.__incoming.send_6(Close_init_$Create$(this._reason0), this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            suspendResult;
            this._this$0_58.__incoming.close$default_5(null, 1, null);
            Unit_getInstance();
            this._this$0_58.__outgoing.cancel$default_15(null, 1, null);
            return Unit_getInstance();
          case 2:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 2) {
          throw $p;
        } else {
          this._state_0 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  _no_name_provided__237.prototype.create_38 = function (_this__0, completion) {
    var i = new _no_name_provided__237(this._$event_0, this._this$0_58, completion);
    i.__this__57 = _this__0;
    return i;
  };
  _no_name_provided__237.$metadata$ = {
    kind: 'class',
    interfaces: [],
    suspendArity: 1
  };
  function isReservedStatusCode(_this_, $this) {
    var tmp0_let_0 = Companion_getInstance_58().byCode(_this_);
    return tmp0_let_0 == null ? true : equals_1(tmp0_let_0, Codes_CLOSED_ABNORMALLY_getInstance());
  }
  function _no_name_provided__238(this$0) {
    this._this$0_59 = this$0;
  }
  _no_name_provided__238.prototype.invoke_504 = function (it) {
    var event = it;
    launch$default(this._this$0_59, null, null, _no_name_provided_$factory_199(event, this._this$0_59, null), 3, null);
    Unit_getInstance();
  };
  _no_name_provided__238.prototype.invoke_542 = function (p1) {
    this.invoke_504(p1 instanceof Event ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__238.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__239(this$0) {
    this._this$0_60 = this$0;
  }
  _no_name_provided__239.prototype.invoke_504 = function (it) {
    var cause = new WebSocketException('' + it);
    this._this$0_60.__closeReason.completeExceptionally_3(cause);
    Unit_getInstance();
    this._this$0_60.__incoming.close_27(cause);
    Unit_getInstance();
    this._this$0_60.__outgoing.cancel$default_15(null, 1, null);
  };
  _no_name_provided__239.prototype.invoke_542 = function (p1) {
    this.invoke_504(p1 instanceof Event ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__239.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__240(this$0) {
    this._this$0_61 = this$0;
  }
  _no_name_provided__240.prototype.invoke_371 = function (event) {
    launch$default(this._this$0_61, null, null, _no_name_provided_$factory_200(event, this._this$0_61, null), 3, null);
    Unit_getInstance();
  };
  _no_name_provided__240.prototype.invoke_542 = function (p1) {
    this.invoke_371((p1 == null ? true : p1) ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__240.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__241(this$0, resultContinuation) {
    this._this$0_62 = this$0;
    CoroutineImpl_0.call(this, resultContinuation);
  }
  _no_name_provided__241.prototype.invoke_489 = function (_this__0, $cont) {
    var tmp = this.create_38(_this__0, $cont);
    tmp._result = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_72();
  };
  _no_name_provided__241.prototype.invoke_542 = function (p1, $cont) {
    this.invoke_489((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $cont);
    return Unit_getInstance();
  };
  _no_name_provided__241.prototype.doResume_72 = function () {
    var suspendResult = this._result;
    $sm: do
      try {
        var tmp = this._state_0;
        switch (tmp) {
          case 0:
            this._exceptionState = 10;
            var tmp_0 = this;
            tmp_0._tmp0_consumeEach_00 = this._this$0_62.__outgoing;
            this._state_0 = 1;
            continue $sm;
          case 1:
            this._cause_1_12 = null;
            this._state_0 = 2;
            continue $sm;
          case 2:
            this._state_0 = 3;
            continue $sm;
          case 3:
            this._exceptionState = 9;
            this._exceptionState = 8;
            this._tmp0_iterator_4_25 = this._tmp0_consumeEach_00.iterator_64();
            this._state_0 = 4;
            continue $sm;
          case 4:
            this._state_0 = 5;
            suspendResult = this._tmp0_iterator_4_25.hasNext_31(this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 5:
            if (!suspendResult) {
              this._state_0 = 6;
              continue $sm;
            }
            var e_5_3 = this._tmp0_iterator_4_25.next_35();
            var tmp0_subject_6 = e_5_3._frameType;
            if (tmp0_subject_6.equals(FrameType_TEXT_getInstance())) {
              var text_7 = e_5_3._data_4;
              this._this$0_62._websocket.send(String$default(text_7, 0, 0, null, 14, null));
            } else if (tmp0_subject_6.equals(FrameType_BINARY_getInstance())) {
              var tmp_1 = e_5_3._data_4;
              var source_8 = tmp_1 instanceof Int8Array ? tmp_1 : THROW_CCE();
              var frameData_9 = source_8.buffer.slice(source_8.byteOffset, source_8.byteOffset + source_8.byteLength | 0);
              this._this$0_62._websocket.send(frameData_9);
            } else if (tmp0_subject_6.equals(FrameType_CLOSE_getInstance())) {
              var tmp$ret$0;
              l$ret$1: do {
                var tmp0_buildPacket_0_11 = 0;
                var builder_1_12 = BytePacketBuilder_0(tmp0_buildPacket_0_11);
                try {
                  writeFully$default(builder_1_12, e_5_3._data_4, 0, 0, 6, null);
                  tmp$ret$0 = builder_1_12.build_16();
                  break l$ret$1;
                } catch ($p) {
                  if ($p instanceof Error) {
                    builder_1_12.release_4();
                    throw $p;
                  } else {
                    {
                      throw $p;
                    }
                  }
                }
              }
               while (false);
              var data_10 = tmp$ret$0;
              var code_14 = readShort_0(data_10);
              var reason_15 = data_10.readText$default_2(0, 0, 3, null);
              this._this$0_62.__closeReason.complete_0(new CloseReason(code_14, reason_15));
              Unit_getInstance();
              if (isReservedStatusCode(code_14, this._this$0_62)) {
                this._this$0_62._websocket.close();
              } else {
                this._this$0_62._websocket.close(code_14, reason_15);
              }
            } else if (tmp0_subject_6.equals(FrameType_PING_getInstance()) ? true : tmp0_subject_6.equals(FrameType_PONG_getInstance())) {
            } else {
              noWhenBranchMatchedException();
            }

            this._state_0 = 4;
            continue $sm;
          case 6:
            this._tmp$ret$24 = Unit_getInstance();
            this._exceptionState = 10;
            this._state_0 = 7;
            var tmp_2 = this;
            continue $sm;
          case 7:
            var tmp_3 = this;
            tmp_3._tmp$ret$61 = cancelConsumed(this._tmp0_consumeEach_00, this._cause_1_12);
            this._state_0 = 12;
            continue $sm;
          case 8:
            this._exceptionState = 9;
            var tmp_4 = this._exception_0;
            if (tmp_4 instanceof Error) {
              var e_2_4 = this._exception_0;
              var tmp_5 = this;
              this._cause_1_12 = e_2_4;
              throw e_2_4;
            } else {
              {
                throw this._exception_0;
              }
            }

            break;
          case 9:
            this._exceptionState = 10;
            var t = this._exception_0;
            cancelConsumed(this._tmp0_consumeEach_00, this._cause_1_12);
            throw t;
          case 10:
            throw this._exception_0;
          case 11:
            cancelConsumed(this._tmp0_consumeEach_00, this._cause_1_12);
            if (false) {
              this._state_0 = 1;
              continue $sm;
            }
            this._state_0 = 12;
            continue $sm;
          case 12:
            return Unit_getInstance();
        }
      } catch ($p_0) {
        if (this._exceptionState === 10) {
          throw $p_0;
        } else {
          this._state_0 = this._exceptionState;
          this._exception_0 = $p_0;
        }
      }
     while (true);
  };
  _no_name_provided__241.prototype.create_38 = function (_this__0, completion) {
    var i = new _no_name_provided__241(this._this$0_62, completion);
    i.__this__58 = _this__0;
    return i;
  };
  _no_name_provided__241.$metadata$ = {
    kind: 'class',
    interfaces: [],
    suspendArity: 1
  };
  function _no_name_provided__242(this$0) {
    this._this$0_63 = this$0;
  }
  _no_name_provided__242.prototype.invoke_375 = function (cause) {
    if (cause == null) {
      this._this$0_63._websocket.close();
    } else {
      this._this$0_63._websocket.close(Codes_INTERNAL_ERROR_getInstance()._code, 'Client failed');
    }
  };
  _no_name_provided__242.prototype.invoke_542 = function (p1) {
    this.invoke_375((p1 == null ? true : p1 instanceof Error) ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__242.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function JsWebSocketSession(coroutineContext, websocket) {
    this._coroutineContext_4 = coroutineContext;
    this._websocket = websocket;
    var tmp = this;
    tmp.__closeReason = CompletableDeferred$default(null, 1, null);
    var tmp_0 = this;
    tmp_0.__incoming = Channel$default(2147483647, null, null, 6, null);
    var tmp_1 = this;
    tmp_1.__outgoing = Channel$default(2147483647, null, null, 6, null);
    this._incoming = this.__incoming;
    this._outgoing = this.__outgoing;
    this._closeReason = this.__closeReason;
    var tmp0__get_ARRAYBUFFER__0 = null;
    var tmp0_asDynamic_0_2 = 'arraybuffer';
    var tmp1_unsafeCast_0_1 = tmp0_asDynamic_0_2;
    this._websocket.binaryType = tmp1_unsafeCast_0_1;
    this._websocket.addEventListener('message', _no_name_provided_$factory_194(this));
    this._websocket.addEventListener('error', _no_name_provided_$factory_195(this));
    this._websocket.addEventListener('close', _no_name_provided_$factory_196(this));
    launch$default(this, null, null, _no_name_provided_$factory_197(this, null), 3, null);
    Unit_getInstance();
    var tmp0_safe_receiver = this._coroutineContext_4.get_70(Key_getInstance_3());
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.invokeOnCompletion_22(_no_name_provided_$factory_198(this));
    }
    Unit_getInstance();
  }
  JsWebSocketSession.prototype._get_coroutineContext__22 = function () {
    return this._coroutineContext_4;
  };
  JsWebSocketSession.$metadata$ = {
    simpleName: 'JsWebSocketSession',
    kind: 'class',
    interfaces: [DefaultWebSocketSession]
  };
  function _no_name_provided_$factory_194(this$0) {
    var i = new _no_name_provided__238(this$0);
    return function (p1) {
      i.invoke_504(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_195(this$0) {
    var i = new _no_name_provided__239(this$0);
    return function (p1) {
      i.invoke_504(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_196(this$0) {
    var i = new _no_name_provided__240(this$0);
    return function (p1) {
      i.invoke_371(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_197(this$0, resultContinuation) {
    var i = new _no_name_provided__241(this$0, resultContinuation);
    var l = function (p1, $cont) {
      return i.invoke_489(p1, $cont);
    };
    l.$arity = 1;
    return l;
  }
  function _no_name_provided_$factory_198(this$0) {
    var i = new _no_name_provided__242(this$0);
    return function (p1) {
      i.invoke_375(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_199($event, this$0, resultContinuation) {
    var i = new _no_name_provided__236($event, this$0, resultContinuation);
    var l = function (p1, $cont) {
      return i.invoke_489(p1, $cont);
    };
    l.$arity = 1;
    return l;
  }
  function _no_name_provided_$factory_200($event, this$0, resultContinuation) {
    var i = new _no_name_provided__237($event, this$0, resultContinuation);
    var l = function (p1, $cont) {
      return i.invoke_489(p1, $cont);
    };
    l.$arity = 1;
    return l;
  }
  function checkCoroutinesVersion() {
  }
  function unwrapCancellationException(_this_) {
    return _this_;
  }
  function _no_name_provided__243($feature, resultContinuation) {
    this._$feature_9 = $feature;
    CoroutineImpl_0.call(this, resultContinuation);
  }
  _no_name_provided__243.prototype.invoke_382 = function (_this__0, it, $cont) {
    var tmp = this.create_34(_this__0, it, $cont);
    tmp._result = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_72();
  };
  _no_name_provided__243.prototype.invoke_537 = function (p1, p2, $cont) {
    var tmp = (!(p1 == null) ? isInterface(p1, PipelineContext) : false) ? p1 : THROW_CCE();
    this.invoke_382(tmp, isObject(p2) ? p2 : THROW_CCE(), $cont);
    return Unit_getInstance();
  };
  _no_name_provided__243.prototype.doResume_72 = function () {
    var suspendResult = this._result;
    $sm: do
      try {
        var tmp = this._state_0;
        switch (tmp) {
          case 0:
            this._exceptionState = 4;
            this._tmp0_iterator0 = _get_alwaysSend_(this._$feature_9).iterator_64();
            this._state_0 = 1;
            continue $sm;
          case 1:
            if (!this._tmp0_iterator0.hasNext_31()) {
              this._state_0 = 3;
              continue $sm;
            }
            this._provider1 = this._tmp0_iterator0.next_35();
            this._state_0 = 2;
            suspendResult = this._provider1.addRequestHeaders_0(this.__this__59._get_context__86(), this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 2:
            suspendResult;
            this._state_0 = 1;
            continue $sm;
          case 3:
            return Unit_getInstance();
          case 4:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 4) {
          throw $p;
        } else {
          this._state_0 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  _no_name_provided__243.prototype.create_34 = function (_this__0, it, completion) {
    var i = new _no_name_provided__243(this._$feature_9, completion);
    i.__this__59 = _this__0;
    i._it_4 = it;
    return i;
  };
  _no_name_provided__243.$metadata$ = {
    kind: 'class',
    interfaces: [],
    suspendArity: 2
  };
  function _no_name_provided__244($circuitBreaker, $feature, resultContinuation) {
    this._$circuitBreaker = $circuitBreaker;
    this._$feature_10 = $feature;
    CoroutineImpl_0.call(this, resultContinuation);
  }
  _no_name_provided__244.prototype.invoke_379 = function (_this__0, origin, context, $cont) {
    var tmp = this.create_33(_this__0, origin, context, $cont);
    tmp._result = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_72();
  };
  _no_name_provided__244.prototype.invoke_380 = function (p1, p2, p3, $cont) {
    var tmp = (!(p1 == null) ? isInterface(p1, Sender) : false) ? p1 : THROW_CCE();
    var tmp_0 = p2 instanceof HttpClientCall ? p2 : THROW_CCE();
    return this.invoke_379(tmp, tmp_0, p3 instanceof HttpRequestBuilder ? p3 : THROW_CCE(), $cont);
  };
  _no_name_provided__244.prototype.doResume_72 = function () {
    var suspendResult = this._result;
    $sm: do
      try {
        var tmp = this._state_0;
        switch (tmp) {
          case 0:
            this._exceptionState = 5;
            if (!this._origin_3._get_response__0()._get_status__1().equals(Companion_getInstance_51()._Unauthorized))
              return this._origin_3;
            if (this._origin_3._get_request__0()._get_attributes__12().contains_52(this._$circuitBreaker))
              return this._origin_3;
            this._call0_0 = this._origin_3;
            var tmp_0 = this;
            var tmp_1 = this;
            tmp_1._tmp0_apply_01 = HashSet_init_$Create$_0(this._$feature_10._providers);
            this._tmp0_apply_01.removeAll_1(_get_alwaysSend_(this._$feature_10));
            Unit_getInstance();
            tmp_0._candidateProviders2 = this._tmp0_apply_01;
            this._state_0 = 1;
            continue $sm;
          case 1:
            if (!this._call0_0._get_response__0()._get_status__1().equals(Companion_getInstance_51()._Unauthorized)) {
              this._state_0 = 4;
              continue $sm;
            }
            var tmp_2 = this;
            var tmp0_elvis_lhs = this._call0_0._get_response__0()._get_headers__15().get_69(HttpHeaders_getInstance()._WWWAuthenticate);
            var tmp_3;
            if (tmp0_elvis_lhs == null) {
              return this._call0_0;
            } else {
              tmp_3 = tmp0_elvis_lhs;
            }

            tmp_2._headerValue3 = tmp_3;
            var tmp_4 = this;
            var tmp1_elvis_lhs = parseAuthorizationHeader(this._headerValue3);
            var tmp_5;
            if (tmp1_elvis_lhs == null) {
              return this._call0_0;
            } else {
              tmp_5 = tmp1_elvis_lhs;
            }

            tmp_4._authHeader4 = tmp_5;
            var tmp_6 = this;
            var tmp$ret$0;
            l$ret$1: do {
              var tmp0_iterator_1_1 = this._candidateProviders2.iterator_64();
              while (tmp0_iterator_1_1.hasNext_31()) {
                var element_2_2 = tmp0_iterator_1_1.next_35();
                if (element_2_2.isApplicable_0(this._authHeader4)) {
                  tmp$ret$0 = element_2_2;
                  break l$ret$1;
                } else {
                }
              }
              tmp$ret$0 = null;
            }
             while (false);
            var tmp2_elvis_lhs = tmp$ret$0;
            var tmp_7;
            if (tmp2_elvis_lhs == null) {
              return this._call0_0;
            } else {
              tmp_7 = tmp2_elvis_lhs;
            }

            tmp_6._provider5 = tmp_7;
            this._candidateProviders2.remove_14(this._provider5);
            Unit_getInstance();
            this._request6 = new HttpRequestBuilder();
            this._request6.takeFromWithExecutionContext(this._context_6);
            Unit_getInstance();
            this._state_0 = 2;
            suspendResult = this._provider5.addRequestHeaders_0(this._request6, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 2:
            suspendResult;
            this._request6._attributes_3.put_13(this._$circuitBreaker, Unit_getInstance());
            this._state_0 = 3;
            suspendResult = this.__this__60.execute_9(this._request6, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 3:
            this._call0_0 = suspendResult;
            this._state_0 = 1;
            continue $sm;
          case 4:
            return this._call0_0;
          case 5:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 5) {
          throw $p;
        } else {
          this._state_0 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  _no_name_provided__244.prototype.create_33 = function (_this__0, origin, context, completion) {
    var i = new _no_name_provided__244(this._$circuitBreaker, this._$feature_10, completion);
    i.__this__60 = _this__0;
    i._origin_3 = origin;
    i._context_6 = context;
    return i;
  };
  _no_name_provided__244.$metadata$ = {
    kind: 'class',
    interfaces: [],
    suspendArity: 3
  };
  function Auth_init_$Init$(providers, $mask0, $marker, $this) {
    if (!(($mask0 & 1) === 0)) {
      providers = ArrayList_init_$Create$();
    }Auth.call($this, providers);
    return $this;
  }
  function Auth_init_$Create$(providers, $mask0, $marker) {
    return Auth_init_$Init$(providers, $mask0, $marker, Object.create(Auth.prototype));
  }
  function _get_alwaysSend_($this) {
    var tmp0_getValue_0 = $this._alwaysSend$delegate;
    var tmp1_getValue_0 = alwaysSend$factory();
    return tmp0_getValue_0._get_value__33();
  }
  function Feature_5() {
    Feature_instance_5 = this;
    this._key_13 = new AttributeKey('DigestAuth');
  }
  Feature_5.prototype._get_key__47 = function () {
    return this._key_13;
  };
  Feature_5.prototype.prepare_14 = function (block) {
    var tmp0_apply_0 = Auth_init_$Create$(null, 1, null);
    block(tmp0_apply_0);
    return tmp0_apply_0;
  };
  Feature_5.prototype.prepare_17 = function (block) {
    return this.prepare_14(block);
  };
  Feature_5.prototype.install_20 = function (feature_0, scope_0) {
    var tmp = Phases_getInstance()._State;
    scope_0._requestPipeline.intercept(tmp, _no_name_provided_$factory_202(feature_0, null));
    var circuitBreaker = new AttributeKey('auth-request');
    var tmp_0 = ensureNotNull(feature(scope_0, Feature_getInstance_3()));
    tmp_0.intercept_0(_no_name_provided_$factory_203(circuitBreaker, feature_0, null));
  };
  Feature_5.prototype.install_23 = function (feature_0, scope_0) {
    return this.install_20(feature_0 instanceof Auth ? feature_0 : THROW_CCE(), scope_0);
  };
  Feature_5.$metadata$ = {
    simpleName: 'Feature',
    kind: 'object',
    interfaces: [HttpClientFeature]
  };
  var Feature_instance_5;
  function Feature_getInstance_5() {
    if (Feature_instance_5 == null)
      new Feature_5();
    return Feature_instance_5;
  }
  function _no_name_provided__245(this$0) {
    this._this$0_64 = this$0;
  }
  _no_name_provided__245.prototype.invoke_540 = function () {
    var tmp0_filter_0 = this._this$0_64._providers;
    var tmp0_filterTo_0_1 = ArrayList_init_$Create$();
    var tmp0_iterator_1_2 = tmp0_filter_0.iterator_64();
    while (tmp0_iterator_1_2.hasNext_31()) {
      var element_2_3 = tmp0_iterator_1_2.next_35();
      if (element_2_3._get_sendWithoutRequest__0()) {
        tmp0_filterTo_0_1.add_33(element_2_3);
        Unit_getInstance();
      } else {
      }
    }
    return tmp0_filterTo_0_1;
  };
  _no_name_provided__245.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function Auth(providers) {
    Feature_getInstance_5();
    this._providers = providers;
    var tmp = this;
    tmp._alwaysSend$delegate = lazy(_no_name_provided_$factory_201(this));
  }
  Auth.$metadata$ = {
    simpleName: 'Auth',
    kind: 'class',
    interfaces: []
  };
  function alwaysSend$factory() {
    return getPropertyCallableRef('alwaysSend', 1, KProperty1, function (receiver) {
      return _get_alwaysSend_(receiver);
    }, null);
  }
  function _no_name_provided_$factory_201(this$0) {
    var i = new _no_name_provided__245(this$0);
    return function () {
      return i.invoke_540();
    };
  }
  function _no_name_provided_$factory_202($feature, resultContinuation) {
    var i = new _no_name_provided__243($feature, resultContinuation);
    var l = function (p1, p2, $cont) {
      return i.invoke_382(p1, p2, $cont);
    };
    l.$arity = 2;
    return l;
  }
  function _no_name_provided_$factory_203($circuitBreaker, $feature, resultContinuation) {
    var i = new _no_name_provided__244($circuitBreaker, $feature, resultContinuation);
    var l = function (p1, p2, p3, $cont) {
      return i.invoke_379(p1, p2, p3, $cont);
    };
    l.$arity = 3;
    return l;
  }
  function AuthProvider() {
  }
  AuthProvider.$metadata$ = {
    simpleName: 'AuthProvider',
    kind: 'interface',
    interfaces: []
  };
  function basic(_this_, block) {
    var tmp0_apply_0 = new BasicAuthConfig();
    block(tmp0_apply_0);
    var tmp1_with_0 = tmp0_apply_0;
    _this_._providers.add_33(new BasicAuthProvider(tmp1_with_0._get_username_(), tmp1_with_0._get_password_(), tmp1_with_0._realm, tmp1_with_0._sendWithoutRequest));
    Unit_getInstance();
  }
  function BasicAuthConfig() {
    this._realm = null;
    this._sendWithoutRequest = false;
  }
  BasicAuthConfig.prototype._get_username_ = function () {
    var tmp = this._username;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('username');
    }
  };
  BasicAuthConfig.prototype._get_password_ = function () {
    var tmp = this._password_1;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('password');
    }
  };
  BasicAuthConfig.$metadata$ = {
    simpleName: 'BasicAuthConfig',
    kind: 'class',
    interfaces: []
  };
  function BasicAuthProvider(username, password, realm, sendWithoutRequest) {
    this._username_0 = username;
    this._password_2 = password;
    this._realm_0 = realm;
    this._sendWithoutRequest_0 = sendWithoutRequest;
    this._defaultCharset_0 = Charsets_getInstance()._UTF_8;
  }
  BasicAuthProvider.prototype._get_sendWithoutRequest__0 = function () {
    return this._sendWithoutRequest_0;
  };
  BasicAuthProvider.prototype.isApplicable_0 = function (auth) {
    if (!(auth._authScheme === 'Basic'))
      return false;
    if (!(this._realm_0 == null)) {
      if (!(auth instanceof Parameterized))
        return false;
      else {
      }
      return auth.parameter_1('realm') == this._realm_0;
    }return true;
  };
  BasicAuthProvider.prototype.addRequestHeaders_0 = function (request, $cont) {
    request._headers_1.set_13(HttpHeaders_getInstance()._Authorization, this.constructBasicAuthValue());
  };
  BasicAuthProvider.prototype.constructBasicAuthValue = function () {
    var authString = '' + this._username_0 + ':' + this._password_2;
    var tmp0_toByteArray_0 = this._defaultCharset_0;
    var authBuf = encodeBase64(encodeToByteArray(tmp0_toByteArray_0.newEncoder_0(), authString, 0, authString.length));
    return '' + 'Basic ' + authBuf;
  };
  BasicAuthProvider.$metadata$ = {
    simpleName: 'BasicAuthProvider',
    kind: 'class',
    interfaces: [AuthProvider]
  };
  function JsonContentTypeMatcher() {
  }
  JsonContentTypeMatcher.prototype.contains_57 = function (contentType_2) {
    if (Application_getInstance()._Json.match_0(contentType_2)) {
      return true;
    }var value = contentType_2.withoutParameters().toString();
    var tmp;
    if (startsWith$default_1(value, 'application/', false, 2, null)) {
      tmp = endsWith$default_1(value, '+json', false, 2, null);
    } else {
      {
        tmp = false;
      }
    }
    return tmp;
  };
  JsonContentTypeMatcher.$metadata$ = {
    simpleName: 'JsonContentTypeMatcher',
    kind: 'class',
    interfaces: [ContentTypeMatcher]
  };
  function _no_name_provided__246($feature, resultContinuation) {
    this._$feature_11 = $feature;
    CoroutineImpl_0.call(this, resultContinuation);
  }
  _no_name_provided__246.prototype.invoke_382 = function (_this__0, payload, $cont) {
    var tmp = this.create_34(_this__0, payload, $cont);
    tmp._result = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_72();
  };
  _no_name_provided__246.prototype.invoke_537 = function (p1, p2, $cont) {
    var tmp = (!(p1 == null) ? isInterface(p1, PipelineContext) : false) ? p1 : THROW_CCE();
    this.invoke_382(tmp, isObject(p2) ? p2 : THROW_CCE(), $cont);
    return Unit_getInstance();
  };
  _no_name_provided__246.prototype.doResume_72 = function () {
    var suspendResult = this._result;
    $sm: do
      try {
        var tmp = this._state_0;
        switch (tmp) {
          case 0:
            this._exceptionState = 2;
            var tmp_0 = this;
            tmp_0._tmp0_forEach_00_1 = this._$feature_11._acceptContentTypes;
            var tmp0_iterator_1 = this._tmp0_forEach_00_1.iterator_64();
            while (tmp0_iterator_1.hasNext_31()) {
              var element_2 = tmp0_iterator_1.next_35();
              accept(this.__this__61._get_context__86(), element_2);
            }

            var tmp_1 = this;
            var tmp0_elvis_lhs = contentType(this.__this__61._get_context__86());
            var tmp_2;
            if (tmp0_elvis_lhs == null) {
              return Unit_getInstance();
            } else {
              tmp_2 = tmp0_elvis_lhs;
            }

            tmp_1._contentType1 = tmp_2;
            if (!this._$feature_11.canHandle(this._contentType1))
              return Unit_getInstance();
            this.__this__61._get_context__86()._headers_1.remove_52(HttpHeaders_getInstance()._ContentType);
            var tmp_3 = this;
            var tmp1_subject = this._payload;
            var tmp_4;
            if (equals_1(tmp1_subject, Unit_getInstance())) {
              tmp_4 = EmptyContent_getInstance();
            } else {
              if (tmp1_subject instanceof EmptyContent) {
                tmp_4 = EmptyContent_getInstance();
              } else {
                {
                  tmp_4 = this._$feature_11._serializer_1.write_1(this._payload, this._contentType1);
                }
              }
            }

            tmp_3._serializedContent2 = tmp_4;
            this._state_0 = 1;
            suspendResult = this.__this__61.proceedWith_1(this._serializedContent2, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            suspendResult;
            Unit_getInstance();
            return Unit_getInstance();
          case 2:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 2) {
          throw $p;
        } else {
          this._state_0 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  _no_name_provided__246.prototype.create_34 = function (_this__0, payload, completion) {
    var i = new _no_name_provided__246(this._$feature_11, completion);
    i.__this__61 = _this__0;
    i._payload = payload;
    return i;
  };
  _no_name_provided__246.$metadata$ = {
    kind: 'class',
    interfaces: [],
    suspendArity: 2
  };
  function _no_name_provided__247($feature, resultContinuation) {
    this._$feature_12 = $feature;
    CoroutineImpl_0.call(this, resultContinuation);
  }
  _no_name_provided__247.prototype.invoke_384 = function (_this__0, _name_for_destructuring_parameter_0_, $cont) {
    var tmp = this.create_35(_this__0, _name_for_destructuring_parameter_0_, $cont);
    tmp._result = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_72();
  };
  _no_name_provided__247.prototype.invoke_537 = function (p1, p2, $cont) {
    var tmp = (!(p1 == null) ? isInterface(p1, PipelineContext) : false) ? p1 : THROW_CCE();
    this.invoke_384(tmp, p2 instanceof HttpResponseContainer ? p2 : THROW_CCE(), $cont);
    return Unit_getInstance();
  };
  _no_name_provided__247.prototype.doResume_72 = function () {
    var suspendResult = this._result;
    $sm: do
      try {
        var tmp = this._state_0;
        switch (tmp) {
          case 0:
            this._exceptionState = 3;
            this._info0_1 = this.__name_for_destructuring_parameter_0__1.component1_4();
            this._body1_1 = this.__name_for_destructuring_parameter_0__1.component2_4();
            var tmp_0 = this._body1_1;
            if (!isInterface(tmp_0, ByteReadChannel_1))
              return Unit_getInstance();
            else {
            }

            var tmp_1 = this;
            var tmp0_elvis_lhs = contentType_1(this.__this__62._get_context__86()._get_response__0());
            var tmp_2;
            if (tmp0_elvis_lhs == null) {
              return Unit_getInstance();
            } else {
              tmp_2 = tmp0_elvis_lhs;
            }

            tmp_1._contentType2 = tmp_2;
            if (!this._$feature_12.canHandle(this._contentType2))
              return Unit_getInstance();
            this._ARGUMENT3 = this._$feature_12._serializer_1;
            this._state_0 = 1;
            suspendResult = readRemaining(this._body1_1, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            this._ARGUMENT4 = suspendResult;
            this._parsedBody5 = this._ARGUMENT3.read_3(this._info0_1, this._ARGUMENT4);
            this._response6 = new HttpResponseContainer(this._info0_1, this._parsedBody5);
            this._state_0 = 2;
            suspendResult = this.__this__62.proceedWith_1(this._response6, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 2:
            suspendResult;
            Unit_getInstance();
            return Unit_getInstance();
          case 3:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 3) {
          throw $p;
        } else {
          this._state_0 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  _no_name_provided__247.prototype.create_35 = function (_this__0, _name_for_destructuring_parameter_0_, completion) {
    var i = new _no_name_provided__247(this._$feature_12, completion);
    i.__this__62 = _this__0;
    i.__name_for_destructuring_parameter_0__1 = _name_for_destructuring_parameter_0_;
    return i;
  };
  _no_name_provided__247.$metadata$ = {
    kind: 'class',
    interfaces: [],
    suspendArity: 2
  };
  function Config_1() {
    this._serializer_0 = null;
    this.__acceptContentTypes = mutableListOf([Application_getInstance()._Json]);
    this.__receiveContentTypeMatchers = mutableListOf([new JsonContentTypeMatcher()]);
  }
  Config_1.prototype._get_acceptContentTypes_ = function () {
    return this.__acceptContentTypes;
  };
  Config_1.prototype._get_receiveContentTypeMatchers_ = function () {
    return this.__receiveContentTypeMatchers;
  };
  Config_1.$metadata$ = {
    simpleName: 'Config',
    kind: 'class',
    interfaces: []
  };
  function Feature_6() {
    Feature_instance_6 = this;
    this._key_14 = new AttributeKey('Json');
  }
  Feature_6.prototype._get_key__47 = function () {
    return this._key_14;
  };
  Feature_6.prototype.prepare_16 = function (block) {
    var tmp0_apply_0 = new Config_1();
    block(tmp0_apply_0);
    var config = tmp0_apply_0;
    var tmp0_elvis_lhs = config._serializer_0;
    var serializer_16 = tmp0_elvis_lhs == null ? defaultSerializer() : tmp0_elvis_lhs;
    var allowedContentTypes = toList_0(config._get_acceptContentTypes_());
    var receiveContentTypeMatchers = config._get_receiveContentTypeMatchers_();
    return new JsonFeature(serializer_16, allowedContentTypes, receiveContentTypeMatchers);
  };
  Feature_6.prototype.prepare_17 = function (block) {
    return this.prepare_16(block);
  };
  Feature_6.prototype.install_22 = function (feature_0, scope_0) {
    var tmp = Phases_getInstance()._Transform;
    scope_0._requestPipeline.intercept(tmp, _no_name_provided_$factory_204(feature_0, null));
    var tmp_0 = Phases_getInstance_1()._Transform_0;
    scope_0._responsePipeline.intercept(tmp_0, _no_name_provided_$factory_205(feature_0, null));
  };
  Feature_6.prototype.install_23 = function (feature_0, scope_0) {
    return this.install_22(feature_0 instanceof JsonFeature ? feature_0 : THROW_CCE(), scope_0);
  };
  Feature_6.$metadata$ = {
    simpleName: 'Feature',
    kind: 'object',
    interfaces: [HttpClientFeature]
  };
  var Feature_instance_6;
  function Feature_getInstance_6() {
    if (Feature_instance_6 == null)
      new Feature_6();
    return Feature_instance_6;
  }
  function JsonFeature(serializer_16, acceptContentTypes, receiveContentTypeMatchers) {
    Feature_getInstance_6();
    this._serializer_1 = serializer_16;
    this._acceptContentTypes = acceptContentTypes;
    this._receiveContentTypeMatchers = receiveContentTypeMatchers;
  }
  JsonFeature.prototype.canHandle = function (contentType_2) {
    var tmp$ret$0;
    l$ret$1: do {
      var tmp0_any_0 = this._acceptContentTypes;
      var tmp;
      if (isInterface(tmp0_any_0, Collection)) {
        tmp = tmp0_any_0.isEmpty_53();
      } else {
        {
          tmp = false;
        }
      }
      if (tmp) {
        tmp$ret$0 = false;
        break l$ret$1;
      } else {
      }
      var tmp0_iterator_1 = tmp0_any_0.iterator_64();
      while (tmp0_iterator_1.hasNext_31()) {
        var element_2 = tmp0_iterator_1.next_35();
        if (contentType_2.match_0(element_2)) {
          tmp$ret$0 = true;
          break l$ret$1;
        } else {
        }
      }
      tmp$ret$0 = false;
    }
     while (false);
    var accepted = tmp$ret$0;
    var matchers = this._receiveContentTypeMatchers;
    var tmp_0;
    if (accepted) {
      tmp_0 = true;
    } else {
      var tmp$ret$2;
      l$ret$3: do {
        var tmp_1;
        if (isInterface(matchers, Collection)) {
          tmp_1 = matchers.isEmpty_53();
        } else {
          {
            tmp_1 = false;
          }
        }
        if (tmp_1) {
          tmp$ret$2 = false;
          break l$ret$3;
        } else {
        }
        var tmp0_iterator_1_0 = matchers.iterator_64();
        while (tmp0_iterator_1_0.hasNext_31()) {
          var element_2_0 = tmp0_iterator_1_0.next_35();
          if (element_2_0.contains_57(contentType_2)) {
            tmp$ret$2 = true;
            break l$ret$3;
          } else {
          }
        }
        tmp$ret$2 = false;
      }
       while (false);
      tmp_0 = tmp$ret$2;
    }
    return tmp_0;
  };
  JsonFeature.$metadata$ = {
    simpleName: 'JsonFeature',
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided_$factory_204($feature, resultContinuation) {
    var i = new _no_name_provided__246($feature, resultContinuation);
    var l = function (p1, p2, $cont) {
      return i.invoke_382(p1, p2, $cont);
    };
    l.$arity = 2;
    return l;
  }
  function _no_name_provided_$factory_205($feature, resultContinuation) {
    var i = new _no_name_provided__247($feature, resultContinuation);
    var l = function (p1, p2, $cont) {
      return i.invoke_384(p1, p2, $cont);
    };
    l.$arity = 2;
    return l;
  }
  function JsonSerializer() {
  }
  JsonSerializer.$metadata$ = {
    simpleName: 'JsonSerializer',
    kind: 'interface',
    interfaces: []
  };
  var serializersStore;
  function defaultSerializer() {
    return first(serializersStore);
  }
  function serializersStore$init$() {
    return ArrayList_init_$Create$();
  }
  function _no_name_provided__248() {
  }
  _no_name_provided__248.prototype.invoke_388 = function (_this__0) {
    _this__0._isLenient = false;
    _this__0._ignoreUnknownKeys = false;
    _this__0._allowSpecialFloatingPointValues = true;
    _this__0._useArrayPolymorphism = false;
  };
  _no_name_provided__248.prototype.invoke_542 = function (p1) {
    this.invoke_388(p1 instanceof JsonBuilder ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__248.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__249() {
  }
  _no_name_provided__249.prototype.invoke_388 = function (_this__0) {
    _this__0._isLenient = false;
    _this__0._ignoreUnknownKeys = false;
    _this__0._allowSpecialFloatingPointValues = true;
    _this__0._useArrayPolymorphism = false;
  };
  _no_name_provided__249.prototype.invoke_542 = function (p1) {
    this.invoke_388(p1 instanceof JsonBuilder ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__249.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function KotlinxSerializer_init_$Init$(json, $mask0, $marker, $this) {
    if (!(($mask0 & 1) === 0))
      json = Companion_getInstance_66()._DefaultJson;
    KotlinxSerializer.call($this, json);
    return $this;
  }
  function KotlinxSerializer_init_$Create$(json, $mask0, $marker) {
    return KotlinxSerializer_init_$Init$(json, $mask0, $marker, Object.create(KotlinxSerializer.prototype));
  }
  function Companion_67() {
    Companion_instance_66 = this;
    var tmp = this;
    tmp._DefaultJsonConfiguration = Json$default(null, _no_name_provided_$factory_206(), 1, null);
    var tmp_0 = this;
    tmp_0._DefaultJson = Json$default(null, _no_name_provided_$factory_207(), 1, null);
  }
  Companion_67.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_66;
  function Companion_getInstance_66() {
    if (Companion_instance_66 == null)
      new Companion_67();
    return Companion_instance_66;
  }
  function KotlinxSerializer(json) {
    Companion_getInstance_66();
    this._json_3 = json;
  }
  KotlinxSerializer.prototype.write_1 = function (data, contentType_2) {
    var tmp = this.writeContent_16(data);
    return TextContent_init_$Create$(tmp, contentType_2, null, 4, null);
  };
  KotlinxSerializer.prototype.writeContent_16 = function (data) {
    return this._json_3.encodeToString_1(buildSerializer(data, this._json_3._get_serializersModule__14()), data);
  };
  KotlinxSerializer.prototype.read_3 = function (type, body) {
    var text = readText$default(body, null, 0, 3, null);
    var deserializationStrategy = this._json_3._get_serializersModule__14().getContextual_0(type._type_1);
    var tmp2_elvis_lhs = deserializationStrategy;
    var tmp;
    if (tmp2_elvis_lhs == null) {
      var tmp0_safe_receiver = type._kotlinType;
      var tmp_0;
      if (tmp0_safe_receiver == null) {
        tmp_0 = null;
      } else {
        tmp_0 = serializer(tmp0_safe_receiver);
      }
      var tmp1_elvis_lhs = tmp_0;
      tmp = tmp1_elvis_lhs == null ? serializer_0(type._type_1) : tmp1_elvis_lhs;
    } else {
      tmp = tmp2_elvis_lhs;
    }
    var mapper = tmp;
    return ensureNotNull(this._json_3.decodeFromString_1(mapper, text));
  };
  KotlinxSerializer.$metadata$ = {
    simpleName: 'KotlinxSerializer',
    kind: 'class',
    interfaces: [JsonSerializer]
  };
  function buildSerializer(value, module_0) {
    var tmp0_subject = value;
    var tmp;
    if (tmp0_subject instanceof JsonElement) {
      tmp = Companion_getInstance_16().serializer_0();
    } else {
      if (isInterface(tmp0_subject, List)) {
        tmp = ListSerializer(elementSerializer(value, module_0));
      } else {
        if (isArray(tmp0_subject)) {
          var tmp1_safe_receiver = firstOrNull(value);
          var tmp_0;
          if (tmp1_safe_receiver == null) {
            tmp_0 = null;
          } else {
            tmp_0 = buildSerializer(tmp1_safe_receiver, module_0);
          }
          var tmp2_elvis_lhs = tmp_0;
          tmp = tmp2_elvis_lhs == null ? ListSerializer(serializer_2(StringCompanionObject_getInstance())) : tmp2_elvis_lhs;
        } else {
          if (isInterface(tmp0_subject, Set)) {
            tmp = SetSerializer(elementSerializer(value, module_0));
          } else {
            if (isInterface(tmp0_subject, Map_0)) {
              var keySerializer = elementSerializer(value._get_keys__10(), module_0);
              var valueSerializer = elementSerializer(value._get_values__16(), module_0);
              tmp = MapSerializer(keySerializer, valueSerializer);
            } else {
              {
                var tmp3_elvis_lhs = module_0.getContextual_0(getKClassFromExpression_0(value));
                tmp = tmp3_elvis_lhs == null ? serializer_0(getKClassFromExpression_0(value)) : tmp3_elvis_lhs;
              }
            }
          }
        }
      }
    }
    var tmp_1 = tmp;
    return isInterface(tmp_1, KSerializer) ? tmp_1 : THROW_CCE();
  }
  function elementSerializer(_this_, module_0) {
    var tmp0_map_0 = filterNotNull(_this_);
    var tmp0_mapTo_0_1 = ArrayList_init_$Create$_0(collectionSizeOrDefault(tmp0_map_0, 10));
    var tmp0_iterator_1_2 = tmp0_map_0.iterator_64();
    while (tmp0_iterator_1_2.hasNext_31()) {
      var item_2_3 = tmp0_iterator_1_2.next_35();
      tmp0_mapTo_0_1.add_33(buildSerializer(item_2_3, module_0));
      Unit_getInstance();
    }
    var tmp1_distinctBy_0 = tmp0_mapTo_0_1;
    var set_1 = HashSet_init_$Create$();
    var list_2 = ArrayList_init_$Create$();
    var tmp0_iterator_3 = tmp1_distinctBy_0.iterator_64();
    while (tmp0_iterator_3.hasNext_31()) {
      var e_4 = tmp0_iterator_3.next_35();
      var key_5 = e_4._get_descriptor__48()._get_serialName__16();
      if (set_1.add_33(key_5)) {
        list_2.add_33(e_4);
        Unit_getInstance();
      }}
    var serializers = list_2;
    if (serializers._get_size__45() > 1) {
      var tmp0_mapTo_0_1_0 = ArrayList_init_$Create$_0(collectionSizeOrDefault(serializers, 10));
      var tmp0_iterator_1_2_0 = serializers.iterator_64();
      while (tmp0_iterator_1_2_0.hasNext_31()) {
        var item_2_3_0 = tmp0_iterator_1_2_0.next_35();
        tmp0_mapTo_0_1_0.add_33(item_2_3_0._get_descriptor__48()._get_serialName__16());
        Unit_getInstance();
      }
      var tmp2_error_0 = 'Serializing collections of different element types is not yet supported. ' + ('' + 'Selected serializers: ' + tmp0_mapTo_0_1_0);
      throw IllegalStateException_init_$Create$(toString_1(tmp2_error_0));
    }var tmp0_elvis_lhs = singleOrNull(serializers);
    var selected = tmp0_elvis_lhs == null ? serializer_2(StringCompanionObject_getInstance()) : tmp0_elvis_lhs;
    if (selected._get_descriptor__48()._get_isNullable__16()) {
      return selected;
    }if (isInterface(selected, KSerializer))
      selected;
    else
      THROW_CCE();
    Unit_getInstance();
    var tmp$ret$0;
    l$ret$1: do {
      var tmp;
      if (isInterface(_this_, Collection)) {
        tmp = _this_.isEmpty_53();
      } else {
        {
          tmp = false;
        }
      }
      if (tmp) {
        tmp$ret$0 = false;
        break l$ret$1;
      } else {
      }
      var tmp0_iterator_1 = _this_.iterator_64();
      while (tmp0_iterator_1.hasNext_31()) {
        var element_2 = tmp0_iterator_1.next_35();
        if (element_2 == null) {
          tmp$ret$0 = true;
          break l$ret$1;
        } else {
        }
      }
      tmp$ret$0 = false;
    }
     while (false);
    if (tmp$ret$0) {
      return _get_nullable_(selected);
    } else {
    }
    return selected;
  }
  function _no_name_provided_$factory_206() {
    var i = new _no_name_provided__248();
    return function (p1) {
      i.invoke_388(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_207() {
    var i = new _no_name_provided__249();
    return function (p1) {
      i.invoke_388(p1);
      return Unit_getInstance();
    };
  }
  var initializer;
  function SerializerInitializer() {
    SerializerInitializer_instance = this;
    var tmp0_plusAssign_0 = serializersStore;
    var tmp1_plusAssign_0 = KotlinxSerializer_init_$Create$(null, 1, null);
    tmp0_plusAssign_0.add_33(tmp1_plusAssign_0);
    Unit_getInstance();
  }
  SerializerInitializer.$metadata$ = {
    simpleName: 'SerializerInitializer',
    kind: 'object',
    interfaces: []
  };
  var SerializerInitializer_instance;
  function SerializerInitializer_getInstance() {
    if (SerializerInitializer_instance == null)
      new SerializerInitializer();
    return SerializerInitializer_instance;
  }
  var endpoint;
  var apiContext;
  function _no_name_provided__250($apiUsername, $apiPassword) {
    this._$apiUsername = $apiUsername;
    this._$apiPassword = $apiPassword;
  }
  _no_name_provided__250.prototype.invoke_390 = function ($this$basic) {
    $this$basic._sendWithoutRequest = true;
    $this$basic._username = this._$apiUsername;
    $this$basic._password_1 = this._$apiPassword;
  };
  _no_name_provided__250.prototype.invoke_542 = function (p1) {
    this.invoke_390(p1 instanceof BasicAuthConfig ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__250.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__251() {
  }
  _no_name_provided__251.prototype.invoke_392 = function ($this$install) {
    var tmp = $this$install;
    tmp._serializer_0 = KotlinxSerializer_init_$Create$(null, 1, null);
  };
  _no_name_provided__251.prototype.invoke_542 = function (p1) {
    this.invoke_392(p1 instanceof Config_1 ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__251.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__252() {
  }
  _no_name_provided__252.prototype.invoke_394 = function ($this$defaultRequest) {
    contentType_0($this$defaultRequest, Application_getInstance()._Json);
  };
  _no_name_provided__252.prototype.invoke_542 = function (p1) {
    this.invoke_394(p1 instanceof HttpRequestBuilder ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__252.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__253($apiUsername, $apiPassword) {
    this._$apiUsername_0 = $apiUsername;
    this._$apiPassword_0 = $apiPassword;
  }
  _no_name_provided__253.prototype.invoke_396 = function ($this$install) {
    basic($this$install, _no_name_provided_$factory_212(this._$apiUsername_0, this._$apiPassword_0));
  };
  _no_name_provided__253.prototype.invoke_542 = function (p1) {
    this.invoke_396(p1 instanceof Auth ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__253.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__254($apiUsername, $apiPassword) {
    this._$apiUsername_1 = $apiUsername;
    this._$apiPassword_1 = $apiPassword;
  }
  _no_name_provided__254.prototype.invoke_398 = function ($this$HttpClient) {
    var tmp = Feature_getInstance_6();
    $this$HttpClient.install(tmp, _no_name_provided_$factory_209());
    defaultRequest($this$HttpClient, _no_name_provided_$factory_210());
    var tmp_0 = Feature_getInstance_5();
    $this$HttpClient.install(tmp_0, _no_name_provided_$factory_211(this._$apiUsername_1, this._$apiPassword_1));
  };
  _no_name_provided__254.prototype.invoke_542 = function (p1) {
    this.invoke_398(p1 instanceof HttpClientConfig ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__254.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function $postTokenCOROUTINE$0(_this_, token, location, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__63 = _this_;
    this._token_0 = token;
    this._location = location;
  }
  $postTokenCOROUTINE$0.prototype.doResume_72 = function () {
    var suspendResult = this._result;
    $sm: do
      try {
        var tmp = this._state_0;
        switch (tmp) {
          case 0:
            this._exceptionState = 8;
            var tmp_0 = this;
            tmp_0._tmp0_post_00 = this.__this__63._client_1;
            var tmp_1 = this;
            tmp_1._tmp1_post_01 = '' + endpoint + '/api/terminal/patient/arrival';
            var tmp_2 = this;
            tmp_2._tmp3_post_0_22 = 'http';
            var tmp_3 = this;
            tmp_3._tmp4_post_0_33 = 'localhost';
            var tmp_4 = this;
            tmp_4._tmp5_post_0_44 = 0;
            var tmp_5 = this;
            tmp_5._tmp6_post_0_55 = '/';
            var tmp_6 = this;
            tmp_6._tmp7_post_0_66 = EmptyContent_getInstance();
            var tmp_7 = this;
            var tmp0_apply_0_8 = new HttpRequestBuilder();
            url$default(tmp0_apply_0_8, this._tmp3_post_0_22, this._tmp4_post_0_33, this._tmp5_post_0_44, this._tmp6_post_0_55, null, 16, null);
            tmp0_apply_0_8._method_0 = Companion_getInstance_49()._Post;
            tmp0_apply_0_8._body_0 = this._tmp7_post_0_66;
            takeFrom(tmp0_apply_0_8._url_0, this._tmp1_post_01);
            Unit_getInstance();
            tmp0_apply_0_8._body_0 = new PatientArrival(this._token_0, this._location);
            Unit_getInstance();
            tmp_7._tmp2_request_0_77 = tmp0_apply_0_8;
            var tmp_8 = this;
            tmp_8._tmp1_receive_0_98 = new HttpStatement(this._tmp2_request_0_77, this._tmp0_post_00);
            this._tmp0_subject_1_109 = getKClass_0(Unit);
            if (this._tmp0_subject_1_109.equals(getKClass_0(HttpStatement))) {
              var tmp_9 = this._tmp1_receive_0_98;
              if (tmp_9 instanceof Unit)
                tmp_9;
              else
                THROW_CCE();
              this._state_0 = 7;
              continue $sm;
            } else {
              if (this._tmp0_subject_1_109.equals(getKClass_0(HttpResponse))) {
                this._state_0 = 6;
                suspendResult = this._tmp1_receive_0_98.execute_15(this);
                if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
                  return suspendResult;
                }continue $sm;
              } else {
                this._state_0 = 1;
                suspendResult = this._tmp1_receive_0_98.executeUnsafe(this);
                if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
                  return suspendResult;
                }continue $sm;
              }
            }

            break;
          case 1:
            this._response_2_1110 = suspendResult;
            this._state_0 = 2;
            continue $sm;
          case 2:
            this._exceptionState = 5;
            this._state_0 = 3;
            var tmp_10 = this._response_2_1110._get_call__4();
            var tmp_11;
            try {
              tmp_11 = new TypeInfo(getKClass_0(Unit), JsType_getInstance(), createKType_0(getKClass_0(Unit), [], false));
            } catch ($p) {
              var tmp_12;
              {
                var tmp_13 = getKClass_0(Unit);
                var tmp_14 = JsType_getInstance();
                tmp_12 = TypeInfo_init_$Create$(tmp_13, tmp_14, null, 4, null);
              }
              tmp_11 = tmp_12;
            }

            suspendResult = tmp_10.receive_0(tmp_11, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 3:
            var tmp_15 = this;
            var tmp_16 = suspendResult;
            tmp_15._tmp$ret$011 = tmp_16 instanceof Unit ? tmp_16 : THROW_CCE();
            this._exceptionState = 8;
            this._state_0 = 4;
            continue $sm;
          case 4:
            complete(this._response_2_1110);
            this._state_0 = 7;
            continue $sm;
          case 5:
            this._exceptionState = 8;
            var t = this._exception_0;
            complete(this._response_2_1110);
            throw t;
          case 6:
            var tmp_17 = suspendResult;
            if (tmp_17 instanceof Unit)
              tmp_17;
            else
              THROW_CCE();
            this._state_0 = 7;
            continue $sm;
          case 7:
            return Unit_getInstance();
          case 8:
            throw this._exception_0;
        }
      } catch ($p_0) {
        if (this._exceptionState === 8) {
          throw $p_0;
        } else {
          this._state_0 = this._exceptionState;
          this._exception_0 = $p_0;
        }
      }
     while (true);
  };
  $postTokenCOROUTINE$0.$metadata$ = {
    simpleName: '$postTokenCOROUTINE$0',
    kind: 'class',
    interfaces: []
  };
  function $getLocationsCOROUTINE$1(_this_, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__64 = _this_;
  }
  $getLocationsCOROUTINE$1.prototype.doResume_72 = function () {
    var suspendResult = this._result;
    $sm: do
      try {
        var tmp = this._state_0;
        switch (tmp) {
          case 0:
            this._exceptionState = 8;
            var tmp_0 = this;
            tmp_0._tmp0_get_00 = this.__this__64._client_1;
            var tmp_1 = this;
            tmp_1._tmp1_get_01 = '' + endpoint + '/api/terminal/locations';
            var tmp_2 = this;
            tmp_2._tmp3_get_0_22 = 'http';
            var tmp_3 = this;
            tmp_3._tmp4_get_0_33 = 'localhost';
            var tmp_4 = this;
            tmp_4._tmp5_get_0_44 = 0;
            var tmp_5 = this;
            tmp_5._tmp6_get_0_55 = '/';
            var tmp_6 = this;
            tmp_6._tmp7_get_0_66 = EmptyContent_getInstance();
            var tmp_7 = this;
            var tmp0_apply_0_8 = new HttpRequestBuilder();
            url$default(tmp0_apply_0_8, this._tmp3_get_0_22, this._tmp4_get_0_33, this._tmp5_get_0_44, this._tmp6_get_0_55, null, 16, null);
            tmp0_apply_0_8._method_0 = Companion_getInstance_49()._Get;
            tmp0_apply_0_8._body_0 = this._tmp7_get_0_66;
            takeFrom(tmp0_apply_0_8._url_0, this._tmp1_get_01);
            Unit_getInstance();
            Unit_getInstance();
            Unit_getInstance();
            tmp_7._tmp2_request_0_77_0 = tmp0_apply_0_8;
            var tmp_8 = this;
            tmp_8._tmp1_receive_0_98_0 = new HttpStatement(this._tmp2_request_0_77_0, this._tmp0_get_00);
            this._tmp0_subject_1_109_0 = getKClass_0(List);
            if (this._tmp0_subject_1_109_0.equals(getKClass_0(HttpStatement))) {
              var tmp_9 = this;
              var tmp_10 = this._tmp1_receive_0_98_0;
              tmp_9._WHEN_RESULT10 = isInterface(tmp_10, List) ? tmp_10 : THROW_CCE();
              this._state_0 = 7;
              continue $sm;
            } else {
              if (this._tmp0_subject_1_109_0.equals(getKClass_0(HttpResponse))) {
                this._state_0 = 6;
                suspendResult = this._tmp1_receive_0_98_0.execute_15(this);
                if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
                  return suspendResult;
                }continue $sm;
              } else {
                this._state_0 = 1;
                suspendResult = this._tmp1_receive_0_98_0.executeUnsafe(this);
                if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
                  return suspendResult;
                }continue $sm;
              }
              Unit_getInstance();
            }

            break;
          case 1:
            this._response_2_1111 = suspendResult;
            this._state_0 = 2;
            continue $sm;
          case 2:
            this._exceptionState = 5;
            this._state_0 = 3;
            var tmp_11 = this._response_2_1111._get_call__4();
            var tmp_12;
            try {
              tmp_12 = new TypeInfo(getKClass_0(List), JsType_getInstance(), createKType_0(getKClass_0(List), [createInvariantKTypeProjection_0(createKType_0(getKClass_0(Location_0), [], false))], false));
            } catch ($p) {
              var tmp_13;
              {
                var tmp_14 = getKClass_0(List);
                var tmp_15 = JsType_getInstance();
                tmp_13 = TypeInfo_init_$Create$(tmp_14, tmp_15, null, 4, null);
              }
              tmp_12 = tmp_13;
            }

            suspendResult = tmp_11.receive_0(tmp_12, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 3:
            var tmp_16 = this;
            var tmp_17 = suspendResult;
            tmp_16._tmp$ret$012 = isInterface(tmp_17, List) ? tmp_17 : THROW_CCE();
            this._exceptionState = 8;
            this._state_0 = 4;
            continue $sm;
          case 4:
            var tmp_18 = this._tmp$ret$012;
            complete(this._response_2_1111);
            this._WHEN_RESULT10 = tmp_18;
            this._state_0 = 7;
            continue $sm;
          case 5:
            this._exceptionState = 8;
            var t = this._exception_0;
            complete(this._response_2_1111);
            throw t;
          case 6:
            var tmp_19 = this;
            var tmp_20 = suspendResult;
            tmp_19._WHEN_RESULT10 = isInterface(tmp_20, List) ? tmp_20 : THROW_CCE();
            this._state_0 = 7;
            continue $sm;
          case 7:
            return this._WHEN_RESULT10;
          case 8:
            throw this._exception_0;
        }
      } catch ($p_0) {
        if (this._exceptionState === 8) {
          throw $p_0;
        } else {
          this._state_0 = this._exceptionState;
          this._exception_0 = $p_0;
        }
      }
     while (true);
  };
  $getLocationsCOROUTINE$1.$metadata$ = {
    simpleName: '$getLocationsCOROUTINE$1',
    kind: 'class',
    interfaces: []
  };
  function Api(apiUsername, apiPassword) {
    var tmp = this;
    tmp._client_1 = HttpClient_1(_no_name_provided_$factory_208(apiUsername, apiPassword));
  }
  Api.prototype.postToken = function (token, location, $cont) {
    var tmp = new $postTokenCOROUTINE$0(this, token, location, $cont);
    tmp._result = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_72();
  };
  Api.prototype.getLocations = function ($cont) {
    var tmp = new $getLocationsCOROUTINE$1(this, $cont);
    tmp._result = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_72();
  };
  Api.$metadata$ = {
    simpleName: 'Api',
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided_$factory_208($apiUsername, $apiPassword) {
    var i = new _no_name_provided__254($apiUsername, $apiPassword);
    return function (p1) {
      i.invoke_398(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_209() {
    var i = new _no_name_provided__251();
    return function (p1) {
      i.invoke_392(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_210() {
    var i = new _no_name_provided__252();
    return function (p1) {
      i.invoke_394(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_211($apiUsername, $apiPassword) {
    var i = new _no_name_provided__253($apiUsername, $apiPassword);
    return function (p1) {
      i.invoke_396(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_212($apiUsername, $apiPassword) {
    var i = new _no_name_provided__250($apiUsername, $apiPassword);
    return function (p1) {
      i.invoke_390(p1);
      return Unit_getInstance();
    };
  }
  function ThemeColors() {
    ThemeColors_instance = this;
    this._light = new Color('#f1faee');
    this._dark = new Color('#1d3557');
    this._primary = new Color('#457b9d');
    this._secondary = new Color('#a8dadc');
    this._highlight = new Color('#f4a261');
    this._success = new Color('#679436');
  }
  ThemeColors.$metadata$ = {
    simpleName: 'ThemeColors',
    kind: 'object',
    interfaces: []
  };
  var ThemeColors_instance;
  function ThemeColors_getInstance() {
    if (ThemeColors_instance == null)
      new ThemeColors();
    return ThemeColors_instance;
  }
  var app;
  function app_0(_this_) {
    return child$default(_this_, app, null, null, 6, null);
  }
  function _no_name_provided__255() {
  }
  _no_name_provided__255.prototype.invoke_414 = function ($this$secured) {
    locationSelector_0($this$secured);
    Unit_getInstance();
  };
  _no_name_provided__255.prototype.invoke_542 = function (p1) {
    this.invoke_414(p1 instanceof RBuilder ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__255.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__256() {
  }
  _no_name_provided__256.prototype.invoke_414 = function ($this$secured) {
    patientArrivalForm_0($this$secured);
    Unit_getInstance();
  };
  _no_name_provided__256.prototype.invoke_542 = function (p1) {
    this.invoke_414(p1 instanceof RBuilder ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__256.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__257($this_switch) {
    this._$this_switch = $this_switch;
  }
  _no_name_provided__257.prototype.invoke_540 = function () {
    return login_0(this._$this_switch);
  };
  _no_name_provided__257.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__258($this_switch) {
    this._$this_switch_0 = $this_switch;
  }
  _no_name_provided__258.prototype.invoke_540 = function () {
    return logout_0(this._$this_switch_0);
  };
  _no_name_provided__258.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__259($this_switch) {
    this._$this_switch_1 = $this_switch;
  }
  _no_name_provided__259.prototype.invoke_540 = function () {
    return secured_0(this._$this_switch_1, _no_name_provided_$factory_220());
  };
  _no_name_provided__259.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__260($this_switch) {
    this._$this_switch_2 = $this_switch;
  }
  _no_name_provided__260.prototype.invoke_540 = function () {
    return secured_0(this._$this_switch_2, _no_name_provided_$factory_221());
  };
  _no_name_provided__260.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__261() {
  }
  _no_name_provided__261.prototype.invoke_410 = function ($this$switch) {
    route$default($this$switch, '/login', false, false, _no_name_provided_$factory_216($this$switch), 6, null);
    Unit_getInstance();
    route$default($this$switch, '/logout', false, false, _no_name_provided_$factory_217($this$switch), 6, null);
    Unit_getInstance();
    route$default($this$switch, '/location', false, false, _no_name_provided_$factory_218($this$switch), 6, null);
    Unit_getInstance();
    route$default($this$switch, '/', true, false, _no_name_provided_$factory_219($this$switch), 4, null);
    Unit_getInstance();
  };
  _no_name_provided__261.prototype.invoke_542 = function (p1) {
    this.invoke_410(p1 instanceof RElementBuilder ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__261.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__262() {
  }
  _no_name_provided__262.prototype.invoke_410 = function ($this$hashRouter) {
    switch_0($this$hashRouter, _no_name_provided_$factory_215());
    Unit_getInstance();
  };
  _no_name_provided__262.prototype.invoke_542 = function (p1) {
    this.invoke_410(p1 instanceof RElementBuilder ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__262.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__263() {
  }
  _no_name_provided__263.prototype.invoke_536 = function ($this$functionalComponent, it) {
    hashRouter$default($this$functionalComponent, null, null, null, _no_name_provided_$factory_214(), 7, null);
    Unit_getInstance();
  };
  _no_name_provided__263.prototype.invoke_537 = function (p1, p2) {
    var tmp = p1 instanceof RBuilder ? p1 : THROW_CCE();
    var tmp_0;
    if (false) {
      tmp_0 = p2;
    } else {
      {
        tmp_0 = THROW_CCE();
      }
    }
    this.invoke_536(tmp, tmp_0);
    return Unit_getInstance();
  };
  _no_name_provided__263.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided_$factory_213() {
    var i = new _no_name_provided__263();
    return function (p1, p2) {
      i.invoke_536(p1, p2);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_214() {
    var i = new _no_name_provided__262();
    return function (p1) {
      i.invoke_410(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_215() {
    var i = new _no_name_provided__261();
    return function (p1) {
      i.invoke_410(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_216($this_switch) {
    var i = new _no_name_provided__257($this_switch);
    return function () {
      return i.invoke_540();
    };
  }
  function _no_name_provided_$factory_217($this_switch) {
    var i = new _no_name_provided__258($this_switch);
    return function () {
      return i.invoke_540();
    };
  }
  function _no_name_provided_$factory_218($this_switch) {
    var i = new _no_name_provided__259($this_switch);
    return function () {
      return i.invoke_540();
    };
  }
  function _no_name_provided_$factory_219($this_switch) {
    var i = new _no_name_provided__260($this_switch);
    return function () {
      return i.invoke_540();
    };
  }
  function _no_name_provided_$factory_220() {
    var i = new _no_name_provided__255();
    return function (p1) {
      i.invoke_414(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_221() {
    var i = new _no_name_provided__256();
    return function (p1) {
      i.invoke_414(p1);
      return Unit_getInstance();
    };
  }
  var scope;
  function main() {
    var tmp = window;
    tmp.onload = _no_name_provided_$factory_222();
  }
  function _no_name_provided__264() {
  }
  _no_name_provided__264.prototype.invoke_414 = function ($this$render) {
    app_0($this$render);
    Unit_getInstance();
  };
  _no_name_provided__264.prototype.invoke_542 = function (p1) {
    this.invoke_414(p1 instanceof RBuilder ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__264.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__265() {
  }
  _no_name_provided__265.prototype.invoke_504 = function (it) {
    var tmp = document.getElementById('root');
    render$default(tmp, null, _no_name_provided_$factory_223(), 2, null);
  };
  _no_name_provided__265.prototype.invoke_542 = function (p1) {
    this.invoke_504(p1 instanceof Event ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__265.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided_$factory_222() {
    var i = new _no_name_provided__265();
    return function (p1) {
      i.invoke_504(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_223() {
    var i = new _no_name_provided__264();
    return function (p1) {
      i.invoke_414(p1);
      return Unit_getInstance();
    };
  }
  var locationSelector;
  function locationSelector_0(_this_) {
    return child$default(_this_, locationSelector, null, _no_name_provided_$factory_225(), 2, null);
  }
  function _no_name_provided__266($api, $isCancelled, $setLocations, resultContinuation) {
    this._$api = $api;
    this._$isCancelled = $isCancelled;
    this._$setLocations = $setLocations;
    CoroutineImpl_0.call(this, resultContinuation);
  }
  _no_name_provided__266.prototype.invoke_489 = function ($this$launch, $cont) {
    var tmp = this.create_38($this$launch, $cont);
    tmp._result = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_72();
  };
  _no_name_provided__266.prototype.invoke_542 = function (p1, $cont) {
    this.invoke_489((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $cont);
    return Unit_getInstance();
  };
  _no_name_provided__266.prototype.doResume_72 = function () {
    var suspendResult = this._result;
    $sm: do
      try {
        var tmp = this._state_0;
        switch (tmp) {
          case 0:
            this._exceptionState = 2;
            this._state_0 = 1;
            suspendResult = this._$api.getLocations(this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            var fetchedLocations = suspendResult;
            if (!this._$isCancelled._v)
              this._$setLocations(fetchedLocations);
            return Unit_getInstance();
          case 2:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 2) {
          throw $p;
        } else {
          this._state_0 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  _no_name_provided__266.prototype.create_38 = function ($this$launch, completion) {
    var i = new _no_name_provided__266(this._$api, this._$isCancelled, this._$setLocations, completion);
    i._$this$launch = $this$launch;
    return i;
  };
  _no_name_provided__266.$metadata$ = {
    kind: 'class',
    interfaces: [],
    suspendArity: 1
  };
  function _no_name_provided__267($isCancelled) {
    this._$isCancelled_0 = $isCancelled;
  }
  _no_name_provided__267.prototype.invoke_494 = function () {
    this._$isCancelled_0._v = true;
  };
  _no_name_provided__267.prototype.invoke_540 = function () {
    this.invoke_494();
    return Unit_getInstance();
  };
  _no_name_provided__267.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__268($api, $setLocations) {
    this._$api_0 = $api;
    this._$setLocations_0 = $setLocations;
  }
  _no_name_provided__268.prototype.invoke_540 = function () {
    var isCancelled = {_v: false};
    launch$default(scope, null, null, _no_name_provided_$factory_230(this._$api_0, isCancelled, this._$setLocations_0, null), 3, null);
    Unit_getInstance();
    var cleanUp = _no_name_provided_$factory_231(isCancelled);
    return cleanUp;
  };
  _no_name_provided__268.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__269() {
  }
  _no_name_provided__269.prototype.invoke_532 = function (it) {
    return new DIV(emptyMap_0, it);
  };
  _no_name_provided__269.prototype.invoke_542 = function (p1) {
    return this.invoke_532((!(p1 == null) ? isInterface(p1, TagConsumer) : false) ? p1 : THROW_CCE());
  };
  _no_name_provided__269.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__270($tmp0_styledButton_0_4_8, $tmp1_styledButton_0_5_9, $tmp2_styledButton_0_6_10) {
    this._$tmp0_styledButton_0_4_8 = $tmp0_styledButton_0_4_8;
    this._$tmp1_styledButton_0_5_9 = $tmp1_styledButton_0_5_9;
    this._$tmp2_styledButton_0_6_10 = $tmp2_styledButton_0_6_10;
  }
  _no_name_provided__270.prototype.invoke_532 = function (it) {
    var tmp0_safe_receiver_3_9_13 = this._$tmp0_styledButton_0_4_8;
    var tmp = tmp0_safe_receiver_3_9_13 == null ? null : enumEncode(tmp0_safe_receiver_3_9_13);
    var tmp1_safe_receiver_4_10_14 = this._$tmp1_styledButton_0_5_9;
    var tmp_0 = tmp1_safe_receiver_4_10_14 == null ? null : enumEncode(tmp1_safe_receiver_4_10_14);
    var tmp2_safe_receiver_5_11_15 = this._$tmp2_styledButton_0_6_10;
    return new BUTTON(attributesMapOf_0(['formenctype', tmp, 'formmethod', tmp_0, 'type', tmp2_safe_receiver_5_11_15 == null ? null : enumEncode(tmp2_safe_receiver_5_11_15)]), it);
  };
  _no_name_provided__270.prototype.invoke_542 = function (p1) {
    return this.invoke_532((!(p1 == null) ? isInterface(p1, TagConsumer) : false) ? p1 : THROW_CCE());
  };
  _no_name_provided__270.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__271($setLocation, $locationId_8_13_17, $history) {
    this._$setLocation = $setLocation;
    this._$locationId_8_13_17 = $locationId_8_13_17;
    this._$history = $history;
  }
  _no_name_provided__271.prototype.invoke_504 = function (event) {
    event.preventDefault();
    this._$setLocation(this._$locationId_8_13_17.toString());
    this._$history.push('/');
  };
  _no_name_provided__271.prototype.invoke_542 = function (p1) {
    this.invoke_504(p1 instanceof Event ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__271.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__272() {
  }
  _no_name_provided__272.prototype.invoke_536 = function ($this$functionalComponent, it) {
    var api = useContext(apiContext);
    var history = useHistory();
    var tmp0_container = useLocalStorage('location', '');
    var location = tmp0_container.component1_4();
    var setLocation = tmp0_container.component2_4();
    var tmp0_useState_0 = emptyList();
    var tmp0_container_1 = useState(tmp0_useState_0);
    var state_2 = tmp0_container_1[0];
    var setState_3 = tmp0_container_1[1];
    var tmp = (state_2 == null ? true : isObject(state_2)) ? state_2 : THROW_CCE();
    var tmp1_container = new RStateDelegate(tmp, (!(setState_3 == null) ? typeof setState_3 === 'function' : false) ? setState_3 : THROW_CCE());
    var locations = tmp1_container.component1_4();
    var setLocations = tmp1_container.component2_4();
    var tmp_0 = emptyList();
    useEffectWithCleanup(tmp_0, _no_name_provided_$factory_226(api, setLocations));
    var tmp1_styledTag_0_1 = _no_name_provided_$factory_227();
    var tmp0_apply_0_3 = new StyledDOMBuilder(tmp1_styledTag_0_1);
    var tmp0__anonymous__1_5 = tmp0_apply_0_3._get_css__0();
    _set_display_(tmp0__anonymous__1_5, Display_flex_getInstance());
    _set_flexDirection_(tmp0__anonymous__1_5, FlexDirection_column_getInstance());
    _set_alignItems_(tmp0__anonymous__1_5, Align_center_getInstance());
    var tmp0_iterator_1_6 = locations.iterator_64();
    while (tmp0_iterator_1_6.hasNext_31()) {
      var element_2_7 = tmp0_iterator_1_6.next_35();
      var tmp0_styledButton_0_4_8 = null;
      var tmp1_styledButton_0_5_9 = null;
      var tmp2_styledButton_0_6_10 = null;
      var tmp1_styledTag_0_1_7_11 = _no_name_provided_$factory_228(tmp0_styledButton_0_4_8, tmp1_styledButton_0_5_9, tmp2_styledButton_0_6_10);
      var tmp0_apply_0_6_12_16 = new StyledDOMBuilder(tmp1_styledTag_0_1_7_11);
      var locationId_8_13_17 = element_2_7._id;
      var tmp0__anonymous__1_9_14_18 = tmp0_apply_0_6_12_16._get_css__0();
      var tmp_1;
      if (charSequenceLength(location) > 0) {
        tmp_1 = locationId_8_13_17 === toInt(location);
      } else {
        {
          tmp_1 = false;
        }
      }
      if (tmp_1) {
        _set_fontWeight_(tmp0__anonymous__1_9_14_18, Companion_getInstance_24()._bold);
      } else {
      }
      tmp0_apply_0_6_12_16.unaryPlus_1(element_2_7._name_0);
      var tmp1__anonymous__1_10_15_19 = tmp0_apply_0_6_12_16._attrs_0;
      _set_onClickFunction_(tmp1__anonymous__1_10_15_19, _no_name_provided_$factory_229(setLocation, locationId_8_13_17, history));
      tmp0_apply_0_3.child_11(tmp0_apply_0_6_12_16.create_1());
      Unit_getInstance();
    }
    $this$functionalComponent.child_11(tmp0_apply_0_3.create_1());
    Unit_getInstance();
  };
  _no_name_provided__272.prototype.invoke_537 = function (p1, p2) {
    var tmp = p1 instanceof RBuilder ? p1 : THROW_CCE();
    var tmp_0;
    if (false) {
      tmp_0 = p2;
    } else {
      {
        tmp_0 = THROW_CCE();
      }
    }
    this.invoke_536(tmp, tmp_0);
    return Unit_getInstance();
  };
  _no_name_provided__272.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__273() {
  }
  _no_name_provided__273.prototype.invoke_538 = function ($this$child) {
    return Unit_getInstance();
  };
  _no_name_provided__273.prototype.invoke_542 = function (p1) {
    this.invoke_538(p1 instanceof RElementBuilder ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__273.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided_$factory_224() {
    var i = new _no_name_provided__272();
    return function (p1, p2) {
      i.invoke_536(p1, p2);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_225() {
    var i = new _no_name_provided__273();
    return function (p1) {
      i.invoke_538(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_226($api, $setLocations) {
    var i = new _no_name_provided__268($api, $setLocations);
    return function () {
      return i.invoke_540();
    };
  }
  function _no_name_provided_$factory_227() {
    var i = new _no_name_provided__269();
    return function (p1) {
      return i.invoke_532(p1);
    };
  }
  function _no_name_provided_$factory_228($tmp0_styledButton_0_4_8, $tmp1_styledButton_0_5_9, $tmp2_styledButton_0_6_10) {
    var i = new _no_name_provided__270($tmp0_styledButton_0_4_8, $tmp1_styledButton_0_5_9, $tmp2_styledButton_0_6_10);
    return function (p1) {
      return i.invoke_532(p1);
    };
  }
  function _no_name_provided_$factory_229($setLocation, $locationId_8_13_17, $history) {
    var i = new _no_name_provided__271($setLocation, $locationId_8_13_17, $history);
    return function (p1) {
      i.invoke_504(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_230($api, $isCancelled, $setLocations, resultContinuation) {
    var i = new _no_name_provided__266($api, $isCancelled, $setLocations, resultContinuation);
    var l = function (p1, $cont) {
      return i.invoke_489(p1, $cont);
    };
    l.$arity = 1;
    return l;
  }
  function _no_name_provided_$factory_231($isCancelled) {
    var i = new _no_name_provided__267($isCancelled);
    return function () {
      i.invoke_494();
      return Unit_getInstance();
    };
  }
  var login;
  function login_0(_this_) {
    return child$default(_this_, login, null, _no_name_provided_$factory_233(), 2, null);
  }
  function _no_name_provided__274($tmp2_styledForm_0, $tmp3_styledForm_0, $tmp4_styledForm_0) {
    this._$tmp2_styledForm_0 = $tmp2_styledForm_0;
    this._$tmp3_styledForm_0 = $tmp3_styledForm_0;
    this._$tmp4_styledForm_0 = $tmp4_styledForm_0;
  }
  _no_name_provided__274.prototype.invoke_532 = function (it) {
    var tmp0_safe_receiver_3 = this._$tmp3_styledForm_0;
    var tmp = tmp0_safe_receiver_3 == null ? null : enumEncode(tmp0_safe_receiver_3);
    var tmp1_safe_receiver_4 = this._$tmp4_styledForm_0;
    return new FORM(attributesMapOf_0(['action', this._$tmp2_styledForm_0, 'enctype', tmp, 'method', tmp1_safe_receiver_4 == null ? null : enumEncode(tmp1_safe_receiver_4)]), it);
  };
  _no_name_provided__274.prototype.invoke_542 = function (p1) {
    return this.invoke_532((!(p1 == null) ? isInterface(p1, TagConsumer) : false) ? p1 : THROW_CCE());
  };
  _no_name_provided__274.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__275($setSubmittedUsername, $inputUsername, $setSubmittedPassword, $inputPassword, $history) {
    this._$setSubmittedUsername = $setSubmittedUsername;
    this._$inputUsername = $inputUsername;
    this._$setSubmittedPassword = $setSubmittedPassword;
    this._$inputPassword = $inputPassword;
    this._$history_0 = $history;
  }
  _no_name_provided__275.prototype.invoke_504 = function (event) {
    event.preventDefault();
    this._$setSubmittedUsername(this._$inputUsername);
    this._$setSubmittedPassword(this._$inputPassword);
    this._$history_0.push('/');
  };
  _no_name_provided__275.prototype.invoke_542 = function (p1) {
    this.invoke_504(p1 instanceof Event ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__275.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__276($tmp2_styledInput_0_10, $tmp3_styledInput_0_11, $tmp4_styledInput_0_12, $tmp5_styledInput_0_13) {
    this._$tmp2_styledInput_0_10 = $tmp2_styledInput_0_10;
    this._$tmp3_styledInput_0_11 = $tmp3_styledInput_0_11;
    this._$tmp4_styledInput_0_12 = $tmp4_styledInput_0_12;
    this._$tmp5_styledInput_0_13 = $tmp5_styledInput_0_13;
  }
  _no_name_provided__276.prototype.invoke_532 = function (it) {
    var tmp0_safe_receiver_3_16 = this._$tmp2_styledInput_0_10;
    var tmp = tmp0_safe_receiver_3_16 == null ? null : enumEncode(tmp0_safe_receiver_3_16);
    var tmp1_safe_receiver_4_17 = this._$tmp3_styledInput_0_11;
    var tmp_0 = tmp1_safe_receiver_4_17 == null ? null : enumEncode(tmp1_safe_receiver_4_17);
    var tmp2_safe_receiver_5_18 = this._$tmp4_styledInput_0_12;
    return new INPUT(attributesMapOf_0(['type', tmp, 'formenctype', tmp_0, 'formmethod', tmp2_safe_receiver_5_18 == null ? null : enumEncode(tmp2_safe_receiver_5_18), 'name', this._$tmp5_styledInput_0_13]), it);
  };
  _no_name_provided__276.prototype.invoke_542 = function (p1) {
    return this.invoke_532((!(p1 == null) ? isInterface(p1, TagConsumer) : false) ? p1 : THROW_CCE());
  };
  _no_name_provided__276.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__277($setInputUsername) {
    this._$setInputUsername = $setInputUsername;
  }
  _no_name_provided__277.prototype.invoke_504 = function (event) {
    var tmp = event.target;
    this._$setInputUsername((tmp instanceof HTMLInputElement ? tmp : THROW_CCE()).value);
  };
  _no_name_provided__277.prototype.invoke_542 = function (p1) {
    this.invoke_504(p1 instanceof Event ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__277.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__278($tmp6_styledInput_0_22, $tmp7_styledInput_0_23, $tmp8_styledInput_0_24, $tmp9_styledInput_0_25) {
    this._$tmp6_styledInput_0_22 = $tmp6_styledInput_0_22;
    this._$tmp7_styledInput_0_23 = $tmp7_styledInput_0_23;
    this._$tmp8_styledInput_0_24 = $tmp8_styledInput_0_24;
    this._$tmp9_styledInput_0_25 = $tmp9_styledInput_0_25;
  }
  _no_name_provided__278.prototype.invoke_532 = function (it) {
    var tmp0_safe_receiver_3_28 = this._$tmp6_styledInput_0_22;
    var tmp = tmp0_safe_receiver_3_28 == null ? null : enumEncode(tmp0_safe_receiver_3_28);
    var tmp1_safe_receiver_4_29 = this._$tmp7_styledInput_0_23;
    var tmp_0 = tmp1_safe_receiver_4_29 == null ? null : enumEncode(tmp1_safe_receiver_4_29);
    var tmp2_safe_receiver_5_30 = this._$tmp8_styledInput_0_24;
    return new INPUT(attributesMapOf_0(['type', tmp, 'formenctype', tmp_0, 'formmethod', tmp2_safe_receiver_5_30 == null ? null : enumEncode(tmp2_safe_receiver_5_30), 'name', this._$tmp9_styledInput_0_25]), it);
  };
  _no_name_provided__278.prototype.invoke_542 = function (p1) {
    return this.invoke_532((!(p1 == null) ? isInterface(p1, TagConsumer) : false) ? p1 : THROW_CCE());
  };
  _no_name_provided__278.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__279($setInputPassword) {
    this._$setInputPassword = $setInputPassword;
  }
  _no_name_provided__279.prototype.invoke_504 = function (event) {
    var tmp = event.target;
    this._$setInputPassword((tmp instanceof HTMLInputElement ? tmp : THROW_CCE()).value);
  };
  _no_name_provided__279.prototype.invoke_542 = function (p1) {
    this.invoke_504(p1 instanceof Event ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__279.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__280($tmp10_styledInput_0_34, $tmp11_styledInput_0_35, $tmp12_styledInput_0_36, $tmp13_styledInput_0_37) {
    this._$tmp10_styledInput_0_34 = $tmp10_styledInput_0_34;
    this._$tmp11_styledInput_0_35 = $tmp11_styledInput_0_35;
    this._$tmp12_styledInput_0_36 = $tmp12_styledInput_0_36;
    this._$tmp13_styledInput_0_37 = $tmp13_styledInput_0_37;
  }
  _no_name_provided__280.prototype.invoke_532 = function (it) {
    var tmp0_safe_receiver_3_40 = this._$tmp10_styledInput_0_34;
    var tmp = tmp0_safe_receiver_3_40 == null ? null : enumEncode(tmp0_safe_receiver_3_40);
    var tmp1_safe_receiver_4_41 = this._$tmp11_styledInput_0_35;
    var tmp_0 = tmp1_safe_receiver_4_41 == null ? null : enumEncode(tmp1_safe_receiver_4_41);
    var tmp2_safe_receiver_5_42 = this._$tmp12_styledInput_0_36;
    return new INPUT(attributesMapOf_0(['type', tmp, 'formenctype', tmp_0, 'formmethod', tmp2_safe_receiver_5_42 == null ? null : enumEncode(tmp2_safe_receiver_5_42), 'name', this._$tmp13_styledInput_0_37]), it);
  };
  _no_name_provided__280.prototype.invoke_542 = function (p1) {
    return this.invoke_532((!(p1 == null) ? isInterface(p1, TagConsumer) : false) ? p1 : THROW_CCE());
  };
  _no_name_provided__280.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__281() {
  }
  _no_name_provided__281.prototype.invoke_536 = function ($this$functionalComponent, it) {
    var setSubmittedUsername = useLocalStorage('username', '')._setState_0;
    var setSubmittedPassword = useLocalStorage('password', '')._setState_0;
    var tmp0_useState_0 = '';
    var tmp0_container_1 = useState(tmp0_useState_0);
    var state_2 = tmp0_container_1[0];
    var setState_3 = tmp0_container_1[1];
    var tmp = (state_2 == null ? true : isObject(state_2)) ? state_2 : THROW_CCE();
    var tmp0_container = new RStateDelegate(tmp, (!(setState_3 == null) ? typeof setState_3 === 'function' : false) ? setState_3 : THROW_CCE());
    var inputUsername = tmp0_container.component1_4();
    var setInputUsername = tmp0_container.component2_4();
    var tmp1_useState_0 = '';
    var tmp0_container_1_0 = useState(tmp1_useState_0);
    var state_2_0 = tmp0_container_1_0[0];
    var setState_3_0 = tmp0_container_1_0[1];
    var tmp_0 = (state_2_0 == null ? true : isObject(state_2_0)) ? state_2_0 : THROW_CCE();
    var tmp1_container = new RStateDelegate(tmp_0, (!(setState_3_0 == null) ? typeof setState_3_0 === 'function' : false) ? setState_3_0 : THROW_CCE());
    var inputPassword = tmp1_container.component1_4();
    var setInputPassword = tmp1_container.component2_4();
    var history = useHistory();
    var tmp2_styledForm_0 = null;
    var tmp3_styledForm_0 = null;
    var tmp4_styledForm_0 = null;
    var tmp1_styledTag_0_1 = _no_name_provided_$factory_234(tmp2_styledForm_0, tmp3_styledForm_0, tmp4_styledForm_0);
    var tmp0_apply_0_5 = new StyledDOMBuilder(tmp1_styledTag_0_1);
    var tmp0__anonymous__1_7 = tmp0_apply_0_5._get_css__0();
    _set_display_(tmp0__anonymous__1_7, Display_flex_getInstance());
    _set_flexDirection_(tmp0__anonymous__1_7, FlexDirection_column_getInstance());
    _set_alignItems_(tmp0__anonymous__1_7, Align_center_getInstance());
    var tmp1__anonymous__1_8 = tmp0_apply_0_5._attrs_0;
    _set_onSubmitFunction_(tmp1__anonymous__1_8, _no_name_provided_$factory_235(setSubmittedUsername, inputUsername, setSubmittedPassword, inputPassword, history));
    var tmp2_styledInput_0_10 = null;
    var tmp3_styledInput_0_11 = null;
    var tmp4_styledInput_0_12 = null;
    var tmp5_styledInput_0_13 = null;
    var tmp1_styledTag_0_1_14 = _no_name_provided_$factory_236(tmp2_styledInput_0_10, tmp3_styledInput_0_11, tmp4_styledInput_0_12, tmp5_styledInput_0_13);
    var tmp0_apply_0_6_19 = new StyledDOMBuilder(tmp1_styledTag_0_1_14);
    var tmp0__anonymous__1_8_20 = tmp0_apply_0_6_19._attrs_0;
    tmp0__anonymous__1_8_20._set_type_(InputType_text_getInstance());
    tmp0__anonymous__1_8_20._set_name_('username');
    tmp0__anonymous__1_8_20._set_value__2(inputUsername);
    tmp0__anonymous__1_8_20._set_placeholder_('Benutzername');
    _set_onChangeFunction_(tmp0__anonymous__1_8_20, _no_name_provided_$factory_237(setInputUsername));
    tmp0_apply_0_5.child_11(tmp0_apply_0_6_19.create_1());
    Unit_getInstance();
    var tmp6_styledInput_0_22 = null;
    var tmp7_styledInput_0_23 = null;
    var tmp8_styledInput_0_24 = null;
    var tmp9_styledInput_0_25 = null;
    var tmp1_styledTag_0_1_26 = _no_name_provided_$factory_238(tmp6_styledInput_0_22, tmp7_styledInput_0_23, tmp8_styledInput_0_24, tmp9_styledInput_0_25);
    var tmp0_apply_0_6_31 = new StyledDOMBuilder(tmp1_styledTag_0_1_26);
    var tmp0__anonymous__1_8_32 = tmp0_apply_0_6_31._attrs_0;
    tmp0__anonymous__1_8_32._set_type_(InputType_password_getInstance());
    tmp0__anonymous__1_8_32._set_name_('password');
    tmp0__anonymous__1_8_32._set_value__2(inputPassword);
    tmp0__anonymous__1_8_32._set_placeholder_('Passwort');
    _set_onChangeFunction_(tmp0__anonymous__1_8_32, _no_name_provided_$factory_239(setInputPassword));
    tmp0_apply_0_5.child_11(tmp0_apply_0_6_31.create_1());
    Unit_getInstance();
    var tmp10_styledInput_0_34 = null;
    var tmp11_styledInput_0_35 = null;
    var tmp12_styledInput_0_36 = null;
    var tmp13_styledInput_0_37 = null;
    var tmp1_styledTag_0_1_38 = _no_name_provided_$factory_240(tmp10_styledInput_0_34, tmp11_styledInput_0_35, tmp12_styledInput_0_36, tmp13_styledInput_0_37);
    var tmp0_apply_0_6_43 = new StyledDOMBuilder(tmp1_styledTag_0_1_38);
    var tmp0__anonymous__1_8_44 = tmp0_apply_0_6_43._attrs_0;
    tmp0__anonymous__1_8_44._set_type_(InputType_submit_getInstance());
    tmp0__anonymous__1_8_44._set_value__2('Anmelden');
    tmp0_apply_0_5.child_11(tmp0_apply_0_6_43.create_1());
    Unit_getInstance();
    $this$functionalComponent.child_11(tmp0_apply_0_5.create_1());
    Unit_getInstance();
  };
  _no_name_provided__281.prototype.invoke_537 = function (p1, p2) {
    var tmp = p1 instanceof RBuilder ? p1 : THROW_CCE();
    var tmp_0;
    if (false) {
      tmp_0 = p2;
    } else {
      {
        tmp_0 = THROW_CCE();
      }
    }
    this.invoke_536(tmp, tmp_0);
    return Unit_getInstance();
  };
  _no_name_provided__281.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__282() {
  }
  _no_name_provided__282.prototype.invoke_538 = function ($this$child) {
    return Unit_getInstance();
  };
  _no_name_provided__282.prototype.invoke_542 = function (p1) {
    this.invoke_538(p1 instanceof RElementBuilder ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__282.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided_$factory_232() {
    var i = new _no_name_provided__281();
    return function (p1, p2) {
      i.invoke_536(p1, p2);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_233() {
    var i = new _no_name_provided__282();
    return function (p1) {
      i.invoke_538(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_234($tmp2_styledForm_0, $tmp3_styledForm_0, $tmp4_styledForm_0) {
    var i = new _no_name_provided__274($tmp2_styledForm_0, $tmp3_styledForm_0, $tmp4_styledForm_0);
    return function (p1) {
      return i.invoke_532(p1);
    };
  }
  function _no_name_provided_$factory_235($setSubmittedUsername, $inputUsername, $setSubmittedPassword, $inputPassword, $history) {
    var i = new _no_name_provided__275($setSubmittedUsername, $inputUsername, $setSubmittedPassword, $inputPassword, $history);
    return function (p1) {
      i.invoke_504(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_236($tmp2_styledInput_0_10, $tmp3_styledInput_0_11, $tmp4_styledInput_0_12, $tmp5_styledInput_0_13) {
    var i = new _no_name_provided__276($tmp2_styledInput_0_10, $tmp3_styledInput_0_11, $tmp4_styledInput_0_12, $tmp5_styledInput_0_13);
    return function (p1) {
      return i.invoke_532(p1);
    };
  }
  function _no_name_provided_$factory_237($setInputUsername) {
    var i = new _no_name_provided__277($setInputUsername);
    return function (p1) {
      i.invoke_504(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_238($tmp6_styledInput_0_22, $tmp7_styledInput_0_23, $tmp8_styledInput_0_24, $tmp9_styledInput_0_25) {
    var i = new _no_name_provided__278($tmp6_styledInput_0_22, $tmp7_styledInput_0_23, $tmp8_styledInput_0_24, $tmp9_styledInput_0_25);
    return function (p1) {
      return i.invoke_532(p1);
    };
  }
  function _no_name_provided_$factory_239($setInputPassword) {
    var i = new _no_name_provided__279($setInputPassword);
    return function (p1) {
      i.invoke_504(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_240($tmp10_styledInput_0_34, $tmp11_styledInput_0_35, $tmp12_styledInput_0_36, $tmp13_styledInput_0_37) {
    var i = new _no_name_provided__280($tmp10_styledInput_0_34, $tmp11_styledInput_0_35, $tmp12_styledInput_0_36, $tmp13_styledInput_0_37);
    return function (p1) {
      return i.invoke_532(p1);
    };
  }
  var logout;
  function logout_0(_this_) {
    return child$default(_this_, logout, null, _no_name_provided_$factory_242(), 2, null);
  }
  function _no_name_provided__283($setUsername, $setPassword, $setLocation) {
    this._$setUsername = $setUsername;
    this._$setPassword = $setPassword;
    this._$setLocation_0 = $setLocation;
  }
  _no_name_provided__283.prototype.invoke_494 = function () {
    this._$setUsername('');
    this._$setPassword('');
    this._$setLocation_0('');
  };
  _no_name_provided__283.prototype.invoke_540 = function () {
    this.invoke_494();
    return Unit_getInstance();
  };
  _no_name_provided__283.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__284() {
  }
  _no_name_provided__284.prototype.invoke_536 = function ($this$functionalComponent, it) {
    var setUsername = useLocalStorage('username', '')._setState_0;
    var setPassword = useLocalStorage('password', '')._setState_0;
    var setLocation = useLocalStorage('location', '')._setState_0;
    var tmp = emptyList();
    useEffect_0(tmp, _no_name_provided_$factory_243(setUsername, setPassword, setLocation));
    redirect$default($this$functionalComponent, null, '/', false, false, false, 29, null);
    Unit_getInstance();
  };
  _no_name_provided__284.prototype.invoke_537 = function (p1, p2) {
    var tmp = p1 instanceof RBuilder ? p1 : THROW_CCE();
    var tmp_0;
    if (false) {
      tmp_0 = p2;
    } else {
      {
        tmp_0 = THROW_CCE();
      }
    }
    this.invoke_536(tmp, tmp_0);
    return Unit_getInstance();
  };
  _no_name_provided__284.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__285() {
  }
  _no_name_provided__285.prototype.invoke_538 = function ($this$child) {
    return Unit_getInstance();
  };
  _no_name_provided__285.prototype.invoke_542 = function (p1) {
    this.invoke_538(p1 instanceof RElementBuilder ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__285.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided_$factory_241() {
    var i = new _no_name_provided__284();
    return function (p1, p2) {
      i.invoke_536(p1, p2);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_242() {
    var i = new _no_name_provided__285();
    return function (p1) {
      i.invoke_538(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_243($setUsername, $setPassword, $setLocation) {
    var i = new _no_name_provided__283($setUsername, $setPassword, $setLocation);
    return function () {
      i.invoke_494();
      return Unit_getInstance();
    };
  }
  var patientArrivalForm;
  function patientArrivalForm_0(_this_) {
    return child$default(_this_, patientArrivalForm, null, _no_name_provided_$factory_245(), 2, null);
  }
  function _no_name_provided__286($setDoesFetch, $setToken, $api, $token, $location, $pseudoSendDelay, $setDoesThanks, $setErrorMessage, resultContinuation) {
    this._$setDoesFetch = $setDoesFetch;
    this._$setToken = $setToken;
    this._$api_1 = $api;
    this._$token = $token;
    this._$location = $location;
    this._$pseudoSendDelay = $pseudoSendDelay;
    this._$setDoesThanks = $setDoesThanks;
    this._$setErrorMessage = $setErrorMessage;
    CoroutineImpl_0.call(this, resultContinuation);
  }
  _no_name_provided__286.prototype.invoke_489 = function ($this$launch, $cont) {
    var tmp = this.create_38($this$launch, $cont);
    tmp._result = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_72();
  };
  _no_name_provided__286.prototype.invoke_542 = function (p1, $cont) {
    this.invoke_489((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $cont);
    return Unit_getInstance();
  };
  _no_name_provided__286.prototype.doResume_72 = function () {
    var suspendResult = this._result;
    $sm: do
      try {
        var tmp = this._state_0;
        switch (tmp) {
          case 0:
            this._exceptionState = 7;
            this._$setDoesFetch(true);
            this._$setToken(' ');
            this._exceptionState = 4;
            this._state_0 = 1;
            suspendResult = this._$api_1.postToken(this._$token, this._$location, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            suspendResult;
            this._state_0 = 2;
            suspendResult = delay(numberToLong(this._$pseudoSendDelay).times_27(new Long(1000, 0)), this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 2:
            suspendResult;
            this._$setDoesThanks(true);
            this._state_0 = 3;
            suspendResult = delay(numberToLong(this._$pseudoSendDelay).times_27(new Long(1000, 0)), this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 3:
            suspendResult;
            this._$setDoesThanks(false);
            this._exceptionState = 7;
            this._state_0 = 6;
            continue $sm;
          case 4:
            this._exceptionState = 7;
            var tmp_0 = this._exception_0;
            if (tmp_0 instanceof Error) {
              this._error_4_11_180 = this._exception_0;
              var tmp0_elvis_lhs_5_12_19 = this._error_4_11_180.message;
              this._$setErrorMessage(tmp0_elvis_lhs_5_12_19 == null ? 'unbekannter Fehler' : tmp0_elvis_lhs_5_12_19);
              this._state_0 = 5;
              var tmp_1 = this;
              tmp_1._tmp0_times_0_6_13_201 = numberToLong(this._$pseudoSendDelay).times_27(new Long(1000, 0));
              var tmp_2 = this;
              tmp_2._tmp1_times_0_7_14_212 = 4;
              suspendResult = delay(this._tmp0_times_0_6_13_201.times_27(toLong_0(this._tmp1_times_0_7_14_212)), this);
              if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
                return suspendResult;
              }continue $sm;
            } else {
              {
                throw this._exception_0;
              }
            }

            break;
          case 5:
            suspendResult;
            this._$setErrorMessage('');
            this._state_0 = 6;
            continue $sm;
          case 6:
            this._exceptionState = 7;
            this._$setToken('');
            this._$setDoesFetch(false);
            this._$setDoesThanks(false);
            return Unit_getInstance();
          case 7:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 7) {
          throw $p;
        } else {
          this._state_0 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  _no_name_provided__286.prototype.create_38 = function ($this$launch, completion) {
    var i = new _no_name_provided__286(this._$setDoesFetch, this._$setToken, this._$api_1, this._$token, this._$location, this._$pseudoSendDelay, this._$setDoesThanks, this._$setErrorMessage, completion);
    i._$this$launch_0 = $this$launch;
    return i;
  };
  _no_name_provided__286.$metadata$ = {
    kind: 'class',
    interfaces: [],
    suspendArity: 1
  };
  function _no_name_provided__287($setToken) {
    this._$setToken_0 = $setToken;
  }
  _no_name_provided__287.prototype.invoke_541 = function (it) {
    this._$setToken_0(it);
  };
  _no_name_provided__287.prototype.invoke_542 = function (p1) {
    this.invoke_541((!(p1 == null) ? typeof p1 === 'string' : false) ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__287.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__288() {
  }
  _no_name_provided__288.prototype.invoke_532 = function (it) {
    return new DIV(emptyMap_0, it);
  };
  _no_name_provided__288.prototype.invoke_542 = function (p1) {
    return this.invoke_532((!(p1 == null) ? isInterface(p1, TagConsumer) : false) ? p1 : THROW_CCE());
  };
  _no_name_provided__288.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__289($tmp1_styledForm_0_6, $tmp2_styledForm_0_7, $tmp3_styledForm_0_8) {
    this._$tmp1_styledForm_0_6 = $tmp1_styledForm_0_6;
    this._$tmp2_styledForm_0_7 = $tmp2_styledForm_0_7;
    this._$tmp3_styledForm_0_8 = $tmp3_styledForm_0_8;
  }
  _no_name_provided__289.prototype.invoke_532 = function (it) {
    var tmp0_safe_receiver_3_11 = this._$tmp2_styledForm_0_7;
    var tmp = tmp0_safe_receiver_3_11 == null ? null : enumEncode(tmp0_safe_receiver_3_11);
    var tmp1_safe_receiver_4_12 = this._$tmp3_styledForm_0_8;
    return new FORM(attributesMapOf_0(['action', this._$tmp1_styledForm_0_6, 'enctype', tmp, 'method', tmp1_safe_receiver_4_12 == null ? null : enumEncode(tmp1_safe_receiver_4_12)]), it);
  };
  _no_name_provided__289.prototype.invoke_542 = function (p1) {
    return this.invoke_532((!(p1 == null) ? isInterface(p1, TagConsumer) : false) ? p1 : THROW_CCE());
  };
  _no_name_provided__289.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__290($setDoesFetch, $setToken, $api, $token, $location, $pseudoSendDelay, $setDoesThanks, $setErrorMessage) {
    this._$setDoesFetch_0 = $setDoesFetch;
    this._$setToken_1 = $setToken;
    this._$api_2 = $api;
    this._$token_0 = $token;
    this._$location_0 = $location;
    this._$pseudoSendDelay_0 = $pseudoSendDelay;
    this._$setDoesThanks_0 = $setDoesThanks;
    this._$setErrorMessage_0 = $setErrorMessage;
  }
  _no_name_provided__290.prototype.invoke_504 = function (event) {
    event.preventDefault();
    launch$default(scope, null, null, _no_name_provided_$factory_258(this._$setDoesFetch_0, this._$setToken_1, this._$api_2, this._$token_0, this._$location_0, this._$pseudoSendDelay_0, this._$setDoesThanks_0, this._$setErrorMessage_0, null), 3, null);
    Unit_getInstance();
  };
  _no_name_provided__290.prototype.invoke_542 = function (p1) {
    this.invoke_504(p1 instanceof Event ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__290.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__291() {
  }
  _no_name_provided__291.prototype.invoke_532 = function (it) {
    return new P(emptyMap_0, it);
  };
  _no_name_provided__291.prototype.invoke_542 = function (p1) {
    return this.invoke_532((!(p1 == null) ? isInterface(p1, TagConsumer) : false) ? p1 : THROW_CCE());
  };
  _no_name_provided__291.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__292() {
  }
  _no_name_provided__292.prototype.invoke_532 = function (it) {
    return new P(emptyMap_0, it);
  };
  _no_name_provided__292.prototype.invoke_542 = function (p1) {
    return this.invoke_532((!(p1 == null) ? isInterface(p1, TagConsumer) : false) ? p1 : THROW_CCE());
  };
  _no_name_provided__292.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__293() {
  }
  _no_name_provided__293.prototype.invoke_532 = function (it) {
    return new P(emptyMap_0, it);
  };
  _no_name_provided__293.prototype.invoke_542 = function (p1) {
    return this.invoke_532((!(p1 == null) ? isInterface(p1, TagConsumer) : false) ? p1 : THROW_CCE());
  };
  _no_name_provided__293.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__294($tmp1_br_0_6_27_34) {
    this._$tmp1_br_0_6_27_34 = $tmp1_br_0_6_27_34;
  }
  _no_name_provided__294.prototype.invoke_532 = function (it) {
    return new BR(attributesMapOf('class', this._$tmp1_br_0_6_27_34), it);
  };
  _no_name_provided__294.prototype.invoke_542 = function (p1) {
    return this.invoke_532((!(p1 == null) ? isInterface(p1, TagConsumer) : false) ? p1 : THROW_CCE());
  };
  _no_name_provided__294.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__295($tmp2_b_0_10_31_38) {
    this._$tmp2_b_0_10_31_38 = $tmp2_b_0_10_31_38;
  }
  _no_name_provided__295.prototype.invoke_532 = function (it) {
    return new B(attributesMapOf('class', this._$tmp2_b_0_10_31_38), it);
  };
  _no_name_provided__295.prototype.invoke_542 = function (p1) {
    return this.invoke_532((!(p1 == null) ? isInterface(p1, TagConsumer) : false) ? p1 : THROW_CCE());
  };
  _no_name_provided__295.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__296($token, $errorMessage, $doesFetch, $doesThanks, $pseudoSendDelay, $setToken) {
    this._$token_1 = $token;
    this._$errorMessage = $errorMessage;
    this._$doesFetch = $doesFetch;
    this._$doesThanks = $doesThanks;
    this._$pseudoSendDelay_1 = $pseudoSendDelay;
    this._$setToken_2 = $setToken;
  }
  _no_name_provided__296.prototype.invoke_512 = function ($this$patientArrivalFormInput) {
    $this$patientArrivalFormInput.token = this._$token_1;
    $this$patientArrivalFormInput.setToken = _no_name_provided_$factory_259(this._$setToken_2);
    $this$patientArrivalFormInput.hasError = charSequenceLength(this._$errorMessage) > 0;
    $this$patientArrivalFormInput.doesFetch = this._$doesFetch;
    $this$patientArrivalFormInput.doesThanks = this._$doesThanks;
    $this$patientArrivalFormInput.pseudoSendDelay = this._$pseudoSendDelay_1;
  };
  _no_name_provided__296.prototype.invoke_542 = function (p1) {
    this.invoke_512((!(p1 == null) ? isObject(p1) : false) ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__296.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__297() {
  }
  _no_name_provided__297.prototype.invoke_532 = function (it) {
    return new P(emptyMap_0, it);
  };
  _no_name_provided__297.prototype.invoke_542 = function (p1) {
    return this.invoke_532((!(p1 == null) ? isInterface(p1, TagConsumer) : false) ? p1 : THROW_CCE());
  };
  _no_name_provided__297.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__298() {
  }
  _no_name_provided__298.prototype.invoke_532 = function (it) {
    return new DIV(emptyMap_0, it);
  };
  _no_name_provided__298.prototype.invoke_542 = function (p1) {
    return this.invoke_532((!(p1 == null) ? isInterface(p1, TagConsumer) : false) ? p1 : THROW_CCE());
  };
  _no_name_provided__298.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__299() {
  }
  _no_name_provided__299.prototype.invoke_532 = function (it) {
    return new P(emptyMap_0, it);
  };
  _no_name_provided__299.prototype.invoke_542 = function (p1) {
    return this.invoke_532((!(p1 == null) ? isInterface(p1, TagConsumer) : false) ? p1 : THROW_CCE());
  };
  _no_name_provided__299.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__300() {
  }
  _no_name_provided__300.prototype.invoke_536 = function ($this$functionalComponent, it) {
    var pseudoSendDelay = 4;
    var api = useContext(apiContext);
    var rawLocation = useLocalStorage('location', '')._state_7;
    var tmp;
    if (charSequenceLength(rawLocation) === 0) {
      tmp = 0;
    } else {
      {
        tmp = toInt(rawLocation);
      }
    }
    var location = tmp;
    var tmp0_useState_0 = '';
    var tmp0_container_1 = useState(tmp0_useState_0);
    var state_2 = tmp0_container_1[0];
    var setState_3 = tmp0_container_1[1];
    var tmp_0 = (state_2 == null ? true : isObject(state_2)) ? state_2 : THROW_CCE();
    var tmp0_container = new RStateDelegate(tmp_0, (!(setState_3 == null) ? typeof setState_3 === 'function' : false) ? setState_3 : THROW_CCE());
    var token = tmp0_container.component1_4();
    var setToken = tmp0_container.component2_4();
    var tmp1_useState_0 = false;
    var tmp0_container_1_0 = useState(tmp1_useState_0);
    var state_2_0 = tmp0_container_1_0[0];
    var setState_3_0 = tmp0_container_1_0[1];
    var tmp_1 = (state_2_0 == null ? true : isObject(state_2_0)) ? state_2_0 : THROW_CCE();
    var tmp1_container = new RStateDelegate(tmp_1, (!(setState_3_0 == null) ? typeof setState_3_0 === 'function' : false) ? setState_3_0 : THROW_CCE());
    var doesFetch = tmp1_container.component1_4();
    var setDoesFetch = tmp1_container.component2_4();
    var tmp2_useState_0 = false;
    var tmp0_container_1_1 = useState(tmp2_useState_0);
    var state_2_1 = tmp0_container_1_1[0];
    var setState_3_1 = tmp0_container_1_1[1];
    var tmp_2 = (state_2_1 == null ? true : isObject(state_2_1)) ? state_2_1 : THROW_CCE();
    var tmp2_container = new RStateDelegate(tmp_2, (!(setState_3_1 == null) ? typeof setState_3_1 === 'function' : false) ? setState_3_1 : THROW_CCE());
    var doesThanks = tmp2_container.component1_4();
    var setDoesThanks = tmp2_container.component2_4();
    var tmp3_useState_0 = '';
    var tmp0_container_1_2 = useState(tmp3_useState_0);
    var state_2_2 = tmp0_container_1_2[0];
    var setState_3_2 = tmp0_container_1_2[1];
    var tmp_3 = (state_2_2 == null ? true : isObject(state_2_2)) ? state_2_2 : THROW_CCE();
    var tmp3_container = new RStateDelegate(tmp_3, (!(setState_3_2 == null) ? typeof setState_3_2 === 'function' : false) ? setState_3_2 : THROW_CCE());
    var errorMessage = tmp3_container.component1_4();
    var setErrorMessage = tmp3_container.component2_4();
    var tmp1_styledTag_0_1 = _no_name_provided_$factory_246();
    var tmp0_apply_0_3 = new StyledDOMBuilder(tmp1_styledTag_0_1);
    var tmp0__anonymous__1_5 = tmp0_apply_0_3._get_css__0();
    _set_height_(tmp0__anonymous__1_5, new LinearDimension('100vh'));
    _set_width_(tmp0__anonymous__1_5, new LinearDimension('100vw'));
    _set_display_(tmp0__anonymous__1_5, Display_flex_getInstance());
    _set_backgroundColor_(tmp0__anonymous__1_5, ThemeColors_getInstance()._light);
    _set_color_(tmp0__anonymous__1_5, ThemeColors_getInstance()._dark);
    var tmp1_styledForm_0_6 = null;
    var tmp2_styledForm_0_7 = null;
    var tmp3_styledForm_0_8 = null;
    var tmp1_styledTag_0_1_9 = _no_name_provided_$factory_247(tmp1_styledForm_0_6, tmp2_styledForm_0_7, tmp3_styledForm_0_8);
    var tmp0_apply_0_5_13 = new StyledDOMBuilder(tmp1_styledTag_0_1_9);
    var tmp0__anonymous__1_7_14 = tmp0_apply_0_5_13._get_css__0();
    _set_display_(tmp0__anonymous__1_7_14, Display_flex_getInstance());
    _set_flexGrow_(tmp0__anonymous__1_7_14, 1.0);
    _set_flexWrap_(tmp0__anonymous__1_7_14, FlexWrap_wrap_getInstance());
    _set_flexDirection_(tmp0__anonymous__1_7_14, FlexDirection_column_getInstance());
    _set_justifyContent_(tmp0__anonymous__1_7_14, JustifyContent_center_getInstance());
    _set_alignContent_(tmp0__anonymous__1_7_14, Align_center_getInstance());
    var tmp1__anonymous__1_8_15 = tmp0_apply_0_5_13._attrs_0;
    _set_onSubmitFunction_(tmp1__anonymous__1_8_15, _no_name_provided_$factory_248(setDoesFetch, setToken, api, token, location, pseudoSendDelay, setDoesThanks, setErrorMessage));
    var tmp1_styledTag_0_1_15_22 = _no_name_provided_$factory_249();
    var tmp0_apply_0_3_17_24 = new StyledDOMBuilder(tmp1_styledTag_0_1_15_22);
    var tmp0__anonymous__1_5_18_25 = tmp0_apply_0_3_17_24._get_css__0();
    _set_fontSize_(tmp0__anonymous__1_5_18_25, new LinearDimension('4em'));
    _set_textAlign_(tmp0__anonymous__1_5_18_25, TextAlign_center_getInstance());
    _set_margin_(tmp0__anonymous__1_5_18_25, '0');
    tmp0_apply_0_3_17_24.unaryPlus_1('Patienten Check-In');
    tmp0_apply_0_5_13.child_11(tmp0_apply_0_3_17_24.create_1());
    Unit_getInstance();
    var tmp1_styledTag_0_1_19_26 = _no_name_provided_$factory_250();
    var tmp0_apply_0_3_21_28 = new StyledDOMBuilder(tmp1_styledTag_0_1_19_26);
    var tmp0__anonymous__1_5_22_29 = tmp0_apply_0_3_21_28._get_css__0();
    _set_fontSize_(tmp0__anonymous__1_5_22_29, new LinearDimension('1em'));
    _set_textAlign_(tmp0__anonymous__1_5_22_29, TextAlign_center_getInstance());
    _set_margin_(tmp0__anonymous__1_5_22_29, '0');
    _set_backgroundColor_(tmp0__anonymous__1_5_22_29, ThemeColors_getInstance()._secondary);
    tmp0_apply_0_3_21_28.unaryPlus_1('Haben Sie gleich einen Termin bei uns? Nutzen Sie unseren Patienten-Check-In, sodass wir wissen, dass Sie da sind.');
    tmp0_apply_0_5_13.child_11(tmp0_apply_0_3_21_28.create_1());
    Unit_getInstance();
    var tmp1_styledTag_0_1_23_30 = _no_name_provided_$factory_251();
    var tmp0_apply_0_3_25_32 = new StyledDOMBuilder(tmp1_styledTag_0_1_23_30);
    var tmp0__anonymous__1_5_26_33 = tmp0_apply_0_3_25_32._get_css__0();
    _set_fontSize_(tmp0__anonymous__1_5_26_33, new LinearDimension('2em'));
    _set_textAlign_(tmp0__anonymous__1_5_26_33, TextAlign_center_getInstance());
    _set_margin_(tmp0__anonymous__1_5_26_33, '0.5em');
    tmp0_apply_0_3_25_32.unaryPlus_1('Tragen Sie bitte hier die Patientennummer ');
    var tmp1_br_0_6_27_34 = null;
    var tmp1_tag_0_1_7_28_35 = _no_name_provided_$factory_252(tmp1_br_0_6_27_34);
    var tmp0_apply_0_3_9_30_37 = new RDOMBuilder(tmp1_tag_0_1_7_28_35);
    Unit_getInstance();
    tmp0_apply_0_3_25_32.child_11(tmp0_apply_0_3_9_30_37.create_1());
    Unit_getInstance();
    var tmp2_b_0_10_31_38 = null;
    var tmp1_tag_0_1_11_32_39 = _no_name_provided_$factory_253(tmp2_b_0_10_31_38);
    var tmp0_apply_0_3_13_34_41 = new RDOMBuilder(tmp1_tag_0_1_11_32_39);
    tmp0_apply_0_3_13_34_41.unaryPlus_1('oder');
    tmp0_apply_0_3_25_32.child_11(tmp0_apply_0_3_13_34_41.create_1());
    Unit_getInstance();
    tmp0_apply_0_3_25_32.unaryPlus_1(' die ersten beiden Buchstaben des Vornamens und die ersten beiden Buchstaben des Nachnamens ein:');
    tmp0_apply_0_5_13.child_11(tmp0_apply_0_3_25_32.create_1());
    Unit_getInstance();
    patientArrivalFormInput_0(tmp0_apply_0_5_13, _no_name_provided_$factory_254(token, errorMessage, doesFetch, doesThanks, pseudoSendDelay, setToken));
    Unit_getInstance();
    var tmp1_styledTag_0_1_37_44 = _no_name_provided_$factory_255();
    var tmp0_apply_0_3_39_46 = new StyledDOMBuilder(tmp1_styledTag_0_1_37_44);
    var tmp0__anonymous__1_5_40_47 = tmp0_apply_0_3_39_46._get_css__0();
    _set_fontSize_(tmp0__anonymous__1_5_40_47, new LinearDimension('2em'));
    _set_textAlign_(tmp0__anonymous__1_5_40_47, TextAlign_center_getInstance());
    _set_margin_(tmp0__anonymous__1_5_40_47, '0.5em');
    tmp0_apply_0_3_39_46.unaryPlus_1('Best\xE4tigen Sie durch die Eingabe-Taste.');
    tmp0_apply_0_5_13.child_11(tmp0_apply_0_3_39_46.create_1());
    Unit_getInstance();
    tmp0_apply_0_3.child_11(tmp0_apply_0_5_13.create_1());
    Unit_getInstance();
    if (charSequenceLength(errorMessage) > 0) {
      var tmp1_styledTag_0_1_48 = _no_name_provided_$factory_256();
      var tmp0_apply_0_3_50 = new StyledDOMBuilder(tmp1_styledTag_0_1_48);
      var tmp0__anonymous__1_5_51 = tmp0_apply_0_3_50._get_css__0();
      _set_position_(tmp0__anonymous__1_5_51, Position_fixed_getInstance());
      _set_left_(tmp0__anonymous__1_5_51, new LinearDimension('0'));
      _set_top_(tmp0__anonymous__1_5_51, new LinearDimension('0'));
      _set_width_(tmp0__anonymous__1_5_51, new LinearDimension('100%'));
      _set_height_(tmp0__anonymous__1_5_51, new LinearDimension('100%'));
      _set_backgroundColor_(tmp0__anonymous__1_5_51, Companion_getInstance_23()._black.withAlpha(0.8));
      _set_display_(tmp0__anonymous__1_5_51, Display_flex_getInstance());
      _set_alignItems_(tmp0__anonymous__1_5_51, Align_center_getInstance());
      _set_justifyContent_(tmp0__anonymous__1_5_51, JustifyContent_center_getInstance());
      var tmp1_styledTag_0_1_6_52 = _no_name_provided_$factory_257();
      var tmp0_apply_0_3_8_54 = new StyledDOMBuilder(tmp1_styledTag_0_1_6_52);
      var tmp0__anonymous__1_5_9_55 = tmp0_apply_0_3_8_54._get_css__0();
      _set_color_(tmp0__anonymous__1_5_9_55, Companion_getInstance_23()._red);
      _set_margin_(tmp0__anonymous__1_5_9_55, '5em');
      tmp0_apply_0_3_8_54.unaryPlus_1('' + 'Es gab einen Fehler. Bitte versuchen Sie es gleich erneut oder geben einem unserer Mitarbeiter bescheid. Fehlermeldung: ' + errorMessage);
      tmp0_apply_0_3_50.child_11(tmp0_apply_0_3_8_54.create_1());
      Unit_getInstance();
      tmp0_apply_0_3.child_11(tmp0_apply_0_3_50.create_1());
      Unit_getInstance();
    } else {
    }
    $this$functionalComponent.child_11(tmp0_apply_0_3.create_1());
    Unit_getInstance();
  };
  _no_name_provided__300.prototype.invoke_537 = function (p1, p2) {
    var tmp = p1 instanceof RBuilder ? p1 : THROW_CCE();
    var tmp_0;
    if (false) {
      tmp_0 = p2;
    } else {
      {
        tmp_0 = THROW_CCE();
      }
    }
    this.invoke_536(tmp, tmp_0);
    return Unit_getInstance();
  };
  _no_name_provided__300.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__301() {
  }
  _no_name_provided__301.prototype.invoke_538 = function ($this$child) {
    return Unit_getInstance();
  };
  _no_name_provided__301.prototype.invoke_542 = function (p1) {
    this.invoke_538(p1 instanceof RElementBuilder ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__301.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided_$factory_244() {
    var i = new _no_name_provided__300();
    return function (p1, p2) {
      i.invoke_536(p1, p2);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_245() {
    var i = new _no_name_provided__301();
    return function (p1) {
      i.invoke_538(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_246() {
    var i = new _no_name_provided__288();
    return function (p1) {
      return i.invoke_532(p1);
    };
  }
  function _no_name_provided_$factory_247($tmp1_styledForm_0_6, $tmp2_styledForm_0_7, $tmp3_styledForm_0_8) {
    var i = new _no_name_provided__289($tmp1_styledForm_0_6, $tmp2_styledForm_0_7, $tmp3_styledForm_0_8);
    return function (p1) {
      return i.invoke_532(p1);
    };
  }
  function _no_name_provided_$factory_248($setDoesFetch, $setToken, $api, $token, $location, $pseudoSendDelay, $setDoesThanks, $setErrorMessage) {
    var i = new _no_name_provided__290($setDoesFetch, $setToken, $api, $token, $location, $pseudoSendDelay, $setDoesThanks, $setErrorMessage);
    return function (p1) {
      i.invoke_504(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_249() {
    var i = new _no_name_provided__291();
    return function (p1) {
      return i.invoke_532(p1);
    };
  }
  function _no_name_provided_$factory_250() {
    var i = new _no_name_provided__292();
    return function (p1) {
      return i.invoke_532(p1);
    };
  }
  function _no_name_provided_$factory_251() {
    var i = new _no_name_provided__293();
    return function (p1) {
      return i.invoke_532(p1);
    };
  }
  function _no_name_provided_$factory_252($tmp1_br_0_6_27_34) {
    var i = new _no_name_provided__294($tmp1_br_0_6_27_34);
    return function (p1) {
      return i.invoke_532(p1);
    };
  }
  function _no_name_provided_$factory_253($tmp2_b_0_10_31_38) {
    var i = new _no_name_provided__295($tmp2_b_0_10_31_38);
    return function (p1) {
      return i.invoke_532(p1);
    };
  }
  function _no_name_provided_$factory_254($token, $errorMessage, $doesFetch, $doesThanks, $pseudoSendDelay, $setToken) {
    var i = new _no_name_provided__296($token, $errorMessage, $doesFetch, $doesThanks, $pseudoSendDelay, $setToken);
    return function (p1) {
      i.invoke_512(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_255() {
    var i = new _no_name_provided__297();
    return function (p1) {
      return i.invoke_532(p1);
    };
  }
  function _no_name_provided_$factory_256() {
    var i = new _no_name_provided__298();
    return function (p1) {
      return i.invoke_532(p1);
    };
  }
  function _no_name_provided_$factory_257() {
    var i = new _no_name_provided__299();
    return function (p1) {
      return i.invoke_532(p1);
    };
  }
  function _no_name_provided_$factory_258($setDoesFetch, $setToken, $api, $token, $location, $pseudoSendDelay, $setDoesThanks, $setErrorMessage, resultContinuation) {
    var i = new _no_name_provided__286($setDoesFetch, $setToken, $api, $token, $location, $pseudoSendDelay, $setDoesThanks, $setErrorMessage, resultContinuation);
    var l = function (p1, $cont) {
      return i.invoke_489(p1, $cont);
    };
    l.$arity = 1;
    return l;
  }
  function _no_name_provided_$factory_259($setToken) {
    var i = new _no_name_provided__287($setToken);
    return function (p1) {
      i.invoke_541(p1);
      return Unit_getInstance();
    };
  }
  var patientArrivalFormInput;
  function textGenerator(text, setInput, $cont) {
    var tmp = new $textGeneratorCOROUTINE$2(text, setInput, $cont);
    tmp._result = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_72();
  }
  function patientArrivalFormInput_0(_this_, handler) {
    return child$default(_this_, patientArrivalFormInput, null, _no_name_provided_$factory_261(handler), 2, null);
  }
  function _no_name_provided__302($setInputPlaceholder, resultContinuation) {
    this._$setInputPlaceholder = $setInputPlaceholder;
    CoroutineImpl_0.call(this, resultContinuation);
  }
  _no_name_provided__302.prototype.invoke_489 = function ($this$launch, $cont) {
    var tmp = this.create_38($this$launch, $cont);
    tmp._result = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_72();
  };
  _no_name_provided__302.prototype.invoke_542 = function (p1, $cont) {
    this.invoke_489((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $cont);
    return Unit_getInstance();
  };
  _no_name_provided__302.prototype.doResume_72 = function () {
    var suspendResult = this._result;
    $sm: do
      try {
        var tmp = this._state_0;
        switch (tmp) {
          case 0:
            this._exceptionState = 12;
            this._state_0 = 1;
            continue $sm;
          case 1:
            if (false) {
              this._state_0 = 13;
              continue $sm;
            }
            this._state_0 = 2;
            suspendResult = textGenerator('Pa Ge', this._$setInputPlaceholder, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 2:
            suspendResult;
            this._state_0 = 3;
            suspendResult = textGenerator('1234', this._$setInputPlaceholder, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 3:
            suspendResult;
            this._state_0 = 4;
            suspendResult = textGenerator('Ja Ri', this._$setInputPlaceholder, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 4:
            suspendResult;
            this._state_0 = 5;
            suspendResult = textGenerator('1111', this._$setInputPlaceholder, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 5:
            suspendResult;
            this._state_0 = 6;
            suspendResult = textGenerator('Sa M\xFC', this._$setInputPlaceholder, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 6:
            suspendResult;
            this._state_0 = 7;
            suspendResult = textGenerator('54321', this._$setInputPlaceholder, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 7:
            suspendResult;
            this._state_0 = 8;
            suspendResult = textGenerator('La Lu', this._$setInputPlaceholder, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 8:
            suspendResult;
            this._state_0 = 9;
            suspendResult = textGenerator('12345', this._$setInputPlaceholder, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 9:
            suspendResult;
            this._state_0 = 10;
            suspendResult = textGenerator('Hu Hu', this._$setInputPlaceholder, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 10:
            suspendResult;
            this._state_0 = 11;
            suspendResult = textGenerator('2424', this._$setInputPlaceholder, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 11:
            suspendResult;
            this._state_0 = 1;
            continue $sm;
          case 12:
            throw this._exception_0;
          case 13:
            return Unit_getInstance();
        }
      } catch ($p) {
        if (this._exceptionState === 12) {
          throw $p;
        } else {
          this._state_0 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  _no_name_provided__302.prototype.create_38 = function ($this$launch, completion) {
    var i = new _no_name_provided__302(this._$setInputPlaceholder, completion);
    i._$this$launch_1 = $this$launch;
    return i;
  };
  _no_name_provided__302.$metadata$ = {
    kind: 'class',
    interfaces: [],
    suspendArity: 1
  };
  function _no_name_provided__303($job) {
    this._$job = $job;
  }
  _no_name_provided__303.prototype.invoke_494 = function () {
    this._$job.cancel$default_15(null, 1, null);
  };
  _no_name_provided__303.prototype.invoke_540 = function () {
    this.invoke_494();
    return Unit_getInstance();
  };
  _no_name_provided__303.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__304($setInputPlaceholder) {
    this._$setInputPlaceholder_0 = $setInputPlaceholder;
  }
  _no_name_provided__304.prototype.invoke_540 = function () {
    var job = launch$default(scope, null, null, _no_name_provided_$factory_271(this._$setInputPlaceholder_0, null), 3, null);
    var cleanUp = _no_name_provided_$factory_272(job);
    return cleanUp;
  };
  _no_name_provided__304.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__305($inputRef) {
    this._$inputRef = $inputRef;
  }
  _no_name_provided__305.prototype.invoke_494 = function () {
    var tmp0_safe_receiver = this._$inputRef.current;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.focus();
      Unit_getInstance();
    }
    Unit_getInstance();
  };
  _no_name_provided__305.prototype.invoke_540 = function () {
    this.invoke_494();
    return Unit_getInstance();
  };
  _no_name_provided__305.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__306() {
  }
  _no_name_provided__306.prototype.invoke_532 = function (it) {
    return new DIV(emptyMap_0, it);
  };
  _no_name_provided__306.prototype.invoke_542 = function (p1) {
    return this.invoke_532((!(p1 == null) ? isInterface(p1, TagConsumer) : false) ? p1 : THROW_CCE());
  };
  _no_name_provided__306.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__307($tmp1_styledInput_0_6, $tmp2_styledInput_0_7, $tmp3_styledInput_0_8, $tmp4_styledInput_0_9) {
    this._$tmp1_styledInput_0_6 = $tmp1_styledInput_0_6;
    this._$tmp2_styledInput_0_7 = $tmp2_styledInput_0_7;
    this._$tmp3_styledInput_0_8 = $tmp3_styledInput_0_8;
    this._$tmp4_styledInput_0_9 = $tmp4_styledInput_0_9;
  }
  _no_name_provided__307.prototype.invoke_532 = function (it) {
    var tmp0_safe_receiver_3_12 = this._$tmp1_styledInput_0_6;
    var tmp = tmp0_safe_receiver_3_12 == null ? null : enumEncode(tmp0_safe_receiver_3_12);
    var tmp1_safe_receiver_4_13 = this._$tmp2_styledInput_0_7;
    var tmp_0 = tmp1_safe_receiver_4_13 == null ? null : enumEncode(tmp1_safe_receiver_4_13);
    var tmp2_safe_receiver_5_14 = this._$tmp3_styledInput_0_8;
    return new INPUT(attributesMapOf_0(['type', tmp, 'formenctype', tmp_0, 'formmethod', tmp2_safe_receiver_5_14 == null ? null : enumEncode(tmp2_safe_receiver_5_14), 'name', this._$tmp4_styledInput_0_9]), it);
  };
  _no_name_provided__307.prototype.invoke_542 = function (p1) {
    return this.invoke_532((!(p1 == null) ? isInterface(p1, TagConsumer) : false) ? p1 : THROW_CCE());
  };
  _no_name_provided__307.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__308() {
  }
  _no_name_provided__308.prototype.invoke_534 = function ($this$placeholder) {
    _set_color_($this$placeholder, ThemeColors_getInstance()._light);
  };
  _no_name_provided__308.prototype.invoke_542 = function (p1) {
    this.invoke_534(p1 instanceof CSSBuilder ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__308.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__309($props) {
    this._$props_0 = $props;
  }
  _no_name_provided__309.prototype.invoke_534 = function ($this$disabled) {
    _set_backgroundPosition_($this$disabled, 'left');
    var tmp = _get_s_(this._$props_0.pseudoSendDelay);
    transition$default($this$disabled, 'all', tmp, null, null, 12, null);
  };
  _no_name_provided__309.prototype.invoke_542 = function (p1) {
    this.invoke_534(p1 instanceof CSSBuilder ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__309.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__310($props) {
    this._$props_1 = $props;
  }
  _no_name_provided__310.prototype.invoke_504 = function (event) {
    var tmp = this._$props_1.setToken;
    var tmp_0 = event.target;
    tmp((tmp_0 instanceof HTMLInputElement ? tmp_0 : THROW_CCE()).value);
  };
  _no_name_provided__310.prototype.invoke_542 = function (p1) {
    this.invoke_504(p1 instanceof Event ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__310.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__311() {
  }
  _no_name_provided__311.prototype.invoke_532 = function (it) {
    return new DIV(emptyMap_0, it);
  };
  _no_name_provided__311.prototype.invoke_542 = function (p1) {
    return this.invoke_532((!(p1 == null) ? isInterface(p1, TagConsumer) : false) ? p1 : THROW_CCE());
  };
  _no_name_provided__311.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__312() {
  }
  _no_name_provided__312.prototype.invoke_532 = function (it) {
    return new DIV(emptyMap_0, it);
  };
  _no_name_provided__312.prototype.invoke_542 = function (p1) {
    return this.invoke_532((!(p1 == null) ? isInterface(p1, TagConsumer) : false) ? p1 : THROW_CCE());
  };
  _no_name_provided__312.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__313() {
  }
  _no_name_provided__313.prototype.invoke_510 = function ($this$functionalComponent, props) {
    var maxInputLength = 6;
    var tmp0_useState_0 = '';
    var tmp0_container_1 = useState(tmp0_useState_0);
    var state_2 = tmp0_container_1[0];
    var setState_3 = tmp0_container_1[1];
    var tmp = (state_2 == null ? true : isObject(state_2)) ? state_2 : THROW_CCE();
    var tmp0_container = new RStateDelegate(tmp, (!(setState_3 == null) ? typeof setState_3 === 'function' : false) ? setState_3 : THROW_CCE());
    var inputPlaceholder = tmp0_container.component1_4();
    var setInputPlaceholder = tmp0_container.component2_4();
    var tmp_0 = emptyList();
    useEffectWithCleanup(tmp_0, _no_name_provided_$factory_262(setInputPlaceholder));
    var inputRef = useRef(null);
    useEffect$default(null, _no_name_provided_$factory_263(inputRef), 1, null);
    var tmp1_styledTag_0_1 = _no_name_provided_$factory_264();
    var tmp0_apply_0_3 = new StyledDOMBuilder(tmp1_styledTag_0_1);
    var tmp0__anonymous__1_5 = tmp0_apply_0_3._get_css__0();
    _set_display_(tmp0__anonymous__1_5, Display_grid_getInstance());
    _set_justifyContent_(tmp0__anonymous__1_5, JustifyContent_center_getInstance());
    var tmp1_styledInput_0_6 = null;
    var tmp2_styledInput_0_7 = null;
    var tmp3_styledInput_0_8 = null;
    var tmp4_styledInput_0_9 = null;
    var tmp1_styledTag_0_1_10 = _no_name_provided_$factory_265(tmp1_styledInput_0_6, tmp2_styledInput_0_7, tmp3_styledInput_0_8, tmp4_styledInput_0_9);
    var tmp0_apply_0_6_15 = new StyledDOMBuilder(tmp1_styledTag_0_1_10);
    var tmp0__anonymous__1_8_16 = tmp0_apply_0_6_15._get_css__0();
    _set_gridRow_(tmp0__anonymous__1_8_16, new GridRow('1'));
    _set_gridColumn_(tmp0__anonymous__1_8_16, new GridColumn('1'));
    _set_border_(tmp0__anonymous__1_8_16, '0.1em solid');
    _set_borderRadius_(tmp0__anonymous__1_8_16, new LinearDimension('0.2em'));
    _set_fontSize_(tmp0__anonymous__1_8_16, new LinearDimension('10em'));
    _set_width_(tmp0__anonymous__1_8_16, new LinearDimension('' + (maxInputLength + 1 | 0) + 'ch'));
    _set_maxWidth_(tmp0__anonymous__1_8_16, new LinearDimension('90vw'));
    _set_textAlign_(tmp0__anonymous__1_8_16, TextAlign_center_getInstance());
    _set_alignSelf_(tmp0__anonymous__1_8_16, Align_center_getInstance());
    tmp0__anonymous__1_8_16.placeholder_0(_no_name_provided_$factory_266());
    _set_color_(tmp0__anonymous__1_8_16, ThemeColors_getInstance()._dark);
    if (!props.hasError)
      _set_background_(tmp0__anonymous__1_8_16, '' + 'linear-gradient(to left, ' + ThemeColors_getInstance()._secondary + ' 50%, ' + ThemeColors_getInstance()._success + ' 50%)');
    else
      _set_backgroundColor_(tmp0__anonymous__1_8_16, Companion_getInstance_23()._red);
    _set_backgroundSize_(tmp0__anonymous__1_8_16, '200% 100%');
    _set_backgroundPosition_(tmp0__anonymous__1_8_16, 'right bottom');
    tmp0__anonymous__1_8_16.disabled_0(_no_name_provided_$factory_267(props));
    Unit_getInstance();
    var tmp1__anonymous__1_11_19 = tmp0_apply_0_6_15._attrs_0;
    tmp0_apply_0_6_15._set_ref__0(inputRef);
    tmp1__anonymous__1_11_19._set_type_(InputType_text_getInstance());
    tmp1__anonymous__1_11_19._set_value__2(props.token);
    tmp1__anonymous__1_11_19._set_disabled_(props.doesFetch);
    tmp1__anonymous__1_11_19._set_maxLength_(maxInputLength.toString());
    tmp1__anonymous__1_11_19._set_autoFocus_(true);
    tmp1__anonymous__1_11_19._set_placeholder_(inputPlaceholder);
    _set_onChangeFunction_(tmp1__anonymous__1_11_19, _no_name_provided_$factory_268(props));
    tmp0_apply_0_3.child_11(tmp0_apply_0_6_15.create_1());
    Unit_getInstance();
    if (props.doesFetch) {
      var tmp1_styledTag_0_1_21 = _no_name_provided_$factory_269();
      var tmp0_apply_0_3_23 = new StyledDOMBuilder(tmp1_styledTag_0_1_21);
      var tmp0__anonymous__1_5_24 = tmp0_apply_0_3_23._get_css__0();
      _set_gridRow_(tmp0__anonymous__1_5_24, new GridRow('1'));
      _set_gridColumn_(tmp0__anonymous__1_5_24, new GridColumn('1'));
      _set_textAlign_(tmp0__anonymous__1_5_24, TextAlign_center_getInstance());
      _set_alignSelf_(tmp0__anonymous__1_5_24, Align_center_getInstance());
      if (props.doesThanks) {
        var tmp1_styledTag_0_1_6_25 = _no_name_provided_$factory_270();
        var tmp0_apply_0_3_8_27 = new StyledDOMBuilder(tmp1_styledTag_0_1_6_25);
        var tmp0__anonymous__1_5_9_28 = tmp0_apply_0_3_8_27._get_css__0();
        _set_fontSize_(tmp0__anonymous__1_5_9_28, new LinearDimension('4em'));
        tmp0_apply_0_3_8_27.unaryPlus_1('\uD83D\uDC4D Vielen Dank \uD83D\uDC4D');
        tmp0_apply_0_3_23.child_11(tmp0_apply_0_3_8_27.create_1());
        Unit_getInstance();
      } else {
        spinner_0(tmp0_apply_0_3_23);
        Unit_getInstance();
      }
      tmp0_apply_0_3.child_11(tmp0_apply_0_3_23.create_1());
      Unit_getInstance();
    }$this$functionalComponent.child_11(tmp0_apply_0_3.create_1());
    Unit_getInstance();
  };
  _no_name_provided__313.prototype.invoke_537 = function (p1, p2) {
    var tmp = p1 instanceof RBuilder ? p1 : THROW_CCE();
    this.invoke_510(tmp, (!(p2 == null) ? isObject(p2) : false) ? p2 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__313.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__314($handler) {
    this._$handler_1 = $handler;
  }
  _no_name_provided__314.prototype.invoke_512 = function ($this$attrs) {
    this._$handler_1($this$attrs);
  };
  _no_name_provided__314.prototype.invoke_542 = function (p1) {
    this.invoke_512((!(p1 == null) ? isObject(p1) : false) ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__314.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__315($handler) {
    this._$handler_2 = $handler;
  }
  _no_name_provided__315.prototype.invoke_514 = function ($this$child) {
    $this$child.attrs_0(_no_name_provided_$factory_273(this._$handler_2));
  };
  _no_name_provided__315.prototype.invoke_542 = function (p1) {
    this.invoke_514(p1 instanceof RElementBuilder ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__315.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function $textGeneratorCOROUTINE$2(text, setInput, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this._text_0 = text;
    this._setInput = setInput;
  }
  $textGeneratorCOROUTINE$2.prototype.doResume_72 = function () {
    var suspendResult = this._result;
    $sm: do
      try {
        var tmp = this._state_0;
        switch (tmp) {
          case 0:
            this._exceptionState = 9;
            var tmp_0 = this;
            tmp_0._tmp0_fold_00 = '';
            this._accumulator_11 = this._tmp0_fold_00;
            this._tmp0_iterator_22 = iterator(this._text_0);
            this._state_0 = 1;
            continue $sm;
          case 1:
            if (!this._tmp0_iterator_22.hasNext_31()) {
              this._state_0 = 3;
              continue $sm;
            }
            this._element_33 = this._tmp0_iterator_22.next_35();
            var tmp_1 = this;
            tmp_1._tmp1__anonymous__44 = this._accumulator_11;
            this._out_55 = this._tmp1__anonymous__44 + this._element_33;
            this._setInput(this._out_55);
            this._state_0 = 2;
            suspendResult = delay(Default_getInstance().nextLong_4(new Long(200, 0), new Long(500, 0)), this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 2:
            suspendResult;
            this._accumulator_11 = this._out_55;
            this._state_0 = 1;
            continue $sm;
          case 3:
            Unit_getInstance();
            this._state_0 = 4;
            suspendResult = delay(Default_getInstance().nextLong_4(new Long(1700, 0), new Long(2100, 0)), this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 4:
            suspendResult;
            this._accumulator_16 = this._text_0;
            this._tmp0_iterator_27 = iterator(this._text_0);
            this._state_0 = 5;
            continue $sm;
          case 5:
            if (!this._tmp0_iterator_27.hasNext_31()) {
              this._state_0 = 7;
              continue $sm;
            }
            this._element_38 = this._tmp0_iterator_27.next_35();
            var tmp_2 = this;
            tmp_2._tmp2__anonymous__49 = this._accumulator_16;
            this._out_510 = dropLast(this._tmp2__anonymous__49, 1);
            this._setInput(this._out_510);
            this._state_0 = 6;
            suspendResult = delay(Default_getInstance().nextLong_4(new Long(200, 0), new Long(300, 0)), this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 6:
            suspendResult;
            this._accumulator_16 = this._out_510;
            this._state_0 = 5;
            continue $sm;
          case 7:
            Unit_getInstance();
            this._state_0 = 8;
            suspendResult = delay(Default_getInstance().nextLong_4(new Long(300, 0), new Long(600, 0)), this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 8:
            suspendResult;
            return Unit_getInstance();
          case 9:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 9) {
          throw $p;
        } else {
          this._state_0 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $textGeneratorCOROUTINE$2.$metadata$ = {
    simpleName: '$textGeneratorCOROUTINE$2',
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided_$factory_260() {
    var i = new _no_name_provided__313();
    return function (p1, p2) {
      i.invoke_510(p1, p2);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_261($handler) {
    var i = new _no_name_provided__315($handler);
    return function (p1) {
      i.invoke_514(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_262($setInputPlaceholder) {
    var i = new _no_name_provided__304($setInputPlaceholder);
    return function () {
      return i.invoke_540();
    };
  }
  function _no_name_provided_$factory_263($inputRef) {
    var i = new _no_name_provided__305($inputRef);
    return function () {
      i.invoke_494();
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_264() {
    var i = new _no_name_provided__306();
    return function (p1) {
      return i.invoke_532(p1);
    };
  }
  function _no_name_provided_$factory_265($tmp1_styledInput_0_6, $tmp2_styledInput_0_7, $tmp3_styledInput_0_8, $tmp4_styledInput_0_9) {
    var i = new _no_name_provided__307($tmp1_styledInput_0_6, $tmp2_styledInput_0_7, $tmp3_styledInput_0_8, $tmp4_styledInput_0_9);
    return function (p1) {
      return i.invoke_532(p1);
    };
  }
  function _no_name_provided_$factory_266() {
    var i = new _no_name_provided__308();
    return function (p1) {
      i.invoke_534(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_267($props) {
    var i = new _no_name_provided__309($props);
    return function (p1) {
      i.invoke_534(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_268($props) {
    var i = new _no_name_provided__310($props);
    return function (p1) {
      i.invoke_504(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_269() {
    var i = new _no_name_provided__311();
    return function (p1) {
      return i.invoke_532(p1);
    };
  }
  function _no_name_provided_$factory_270() {
    var i = new _no_name_provided__312();
    return function (p1) {
      return i.invoke_532(p1);
    };
  }
  function _no_name_provided_$factory_271($setInputPlaceholder, resultContinuation) {
    var i = new _no_name_provided__302($setInputPlaceholder, resultContinuation);
    var l = function (p1, $cont) {
      return i.invoke_489(p1, $cont);
    };
    l.$arity = 1;
    return l;
  }
  function _no_name_provided_$factory_272($job) {
    var i = new _no_name_provided__303($job);
    return function () {
      i.invoke_494();
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_273($handler) {
    var i = new _no_name_provided__314($handler);
    return function (p1) {
      i.invoke_512(p1);
      return Unit_getInstance();
    };
  }
  var secured;
  function secured_0(_this_, handler) {
    return child$default(_this_, secured, null, handler, 2, null);
  }
  function _no_name_provided__316($username, $password) {
    this._$username = $username;
    this._$password = $password;
  }
  _no_name_provided__316.prototype.invoke_516 = function ($this$attrs) {
    $this$attrs.value = new Api(this._$username, this._$password);
  };
  _no_name_provided__316.prototype.invoke_542 = function (p1) {
    this.invoke_516((!(p1 == null) ? isObject(p1) : false) ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__316.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__317($props, $username, $password) {
    this._$props_2 = $props;
    this._$username_0 = $username;
    this._$password_0 = $password;
  }
  _no_name_provided__317.prototype.invoke_518 = function ($this$invoke) {
    $this$invoke.attrs_0(_no_name_provided_$factory_276(this._$username_0, this._$password_0));
    $this$invoke.children_1(this._$props_2);
  };
  _no_name_provided__317.prototype.invoke_542 = function (p1) {
    this.invoke_518(p1 instanceof RElementBuilder ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__317.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__318() {
  }
  _no_name_provided__318.prototype.invoke_520 = function ($this$functionalComponent, props) {
    var tmp0_get_0 = window.localStorage;
    var tmp1_get_0 = 'username';
    var tmp0_elvis_lhs = tmp0_get_0[tmp1_get_0];
    var username = tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
    var tmp2_get_0 = window.localStorage;
    var tmp3_get_0 = 'password';
    var tmp1_elvis_lhs = tmp2_get_0[tmp3_get_0];
    var password = tmp1_elvis_lhs == null ? '' : tmp1_elvis_lhs;
    var tmp4_get_0 = window.localStorage;
    var tmp5_get_0 = 'location';
    var tmp2_elvis_lhs = tmp4_get_0[tmp5_get_0];
    var location = tmp2_elvis_lhs == null ? '' : tmp2_elvis_lhs;
    var path = useLocation().pathname;
    var tmp;
    if (charSequenceLength(username) === 0) {
      tmp = true;
    } else {
      {
        tmp = charSequenceLength(password) === 0;
      }
    }
    var redirectToLogin = tmp;
    var tmp_0;
    if (charSequenceLength(location) === 0) {
      tmp_0 = !(path === '/location');
    } else {
      {
        tmp_0 = false;
      }
    }
    var redirectToLocation = tmp_0;
    if (redirectToLogin) {
      redirect$default($this$functionalComponent, null, '/login', false, false, false, 29, null);
      Unit_getInstance();
    } else if (redirectToLocation) {
      redirect$default($this$functionalComponent, null, '/location', false, false, false, 29, null);
      Unit_getInstance();
    } else {
      var tmp_1 = apiContext.Provider;
      $this$functionalComponent.invoke_154(tmp_1, _no_name_provided_$factory_275(props, username, password));
      Unit_getInstance();
    }
  };
  _no_name_provided__318.prototype.invoke_537 = function (p1, p2) {
    var tmp = p1 instanceof RBuilder ? p1 : THROW_CCE();
    this.invoke_520(tmp, (!(p2 == null) ? isObject(p2) : false) ? p2 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__318.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided_$factory_274() {
    var i = new _no_name_provided__318();
    return function (p1, p2) {
      i.invoke_520(p1, p2);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_275($props, $username, $password) {
    var i = new _no_name_provided__317($props, $username, $password);
    return function (p1) {
      i.invoke_518(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_276($username, $password) {
    var i = new _no_name_provided__316($username, $password);
    return function (p1) {
      i.invoke_516(p1);
      return Unit_getInstance();
    };
  }
  var spinner;
  function spinner_0(_this_) {
    return child$default(_this_, spinner, null, _no_name_provided_$factory_278(), 2, null);
  }
  function _no_name_provided__319() {
  }
  _no_name_provided__319.prototype.invoke_524 = function ($this$transform) {
    rotate($this$transform, _get_deg_(0));
  };
  _no_name_provided__319.prototype.invoke_542 = function (p1) {
    this.invoke_524(p1 instanceof Transforms ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__319.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__320() {
  }
  _no_name_provided__320.prototype.invoke_524 = function ($this$transform) {
    rotate($this$transform, _get_deg_(360));
  };
  _no_name_provided__320.prototype.invoke_542 = function (p1) {
    this.invoke_524(p1 instanceof Transforms ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__320.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__321() {
  }
  _no_name_provided__321.prototype.invoke_534 = function ($this$rule) {
    transform($this$rule, _no_name_provided_$factory_284());
  };
  _no_name_provided__321.prototype.invoke_542 = function (p1) {
    this.invoke_534(p1 instanceof CSSBuilder ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__321.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__322() {
  }
  _no_name_provided__322.prototype.invoke_534 = function ($this$rule) {
    transform($this$rule, _no_name_provided_$factory_285());
  };
  _no_name_provided__322.prototype.invoke_542 = function (p1) {
    this.invoke_534(p1 instanceof CSSBuilder ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__322.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__323() {
  }
  _no_name_provided__323.prototype.invoke_530 = function ($this$animation) {
    $this$animation.rule_2('0%', _no_name_provided_$factory_282());
    Unit_getInstance();
    $this$animation.rule_2('100%', _no_name_provided_$factory_283());
    Unit_getInstance();
  };
  _no_name_provided__323.prototype.invoke_542 = function (p1) {
    this.invoke_530(p1 instanceof KeyframesBuilder ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__323.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__324() {
  }
  _no_name_provided__324.prototype.invoke_532 = function (it) {
    return new DIV(emptyMap_0, it);
  };
  _no_name_provided__324.prototype.invoke_542 = function (p1) {
    return this.invoke_532((!(p1 == null) ? isInterface(p1, TagConsumer) : false) ? p1 : THROW_CCE());
  };
  _no_name_provided__324.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__325($size) {
    this._$size = $size;
  }
  _no_name_provided__325.prototype.invoke_534 = function ($this$after) {
    _set_content_($this$after, _get_quoted_(' '));
    _set_display_($this$after, Display_block_getInstance());
    _set_width_($this$after, new LinearDimension('' + this._$size + 'em'));
    _set_height_($this$after, new LinearDimension('' + this._$size + 'em'));
    _set_borderRadius_($this$after, new LinearDimension('50%'));
    _set_border_($this$after, '' + (this._$size / 10 | 0) + 'em solid ' + ThemeColors_getInstance()._dark);
    _set_borderColor_($this$after, new Color('' + ThemeColors_getInstance()._dark + ' transparent ' + ThemeColors_getInstance()._dark + ' transparent'));
    var tmp0_duration_3_7 = _get_s_(1.2);
    var tmp1_iterationCount_4_8 = Companion_getInstance_28()._infinite;
    var tmp2_timing_5_9 = Companion_getInstance_29()._linear;
    animation$default($this$after, tmp0_duration_3_7, tmp2_timing_5_9, null, tmp1_iterationCount_4_8, null, null, null, _no_name_provided_$factory_281(), 116, null);
  };
  _no_name_provided__325.prototype.invoke_542 = function (p1) {
    this.invoke_534(p1 instanceof CSSBuilder ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__325.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__326() {
  }
  _no_name_provided__326.prototype.invoke_536 = function ($this$functionalComponent, it) {
    var size_0 = 10;
    var tmp1_styledTag_0_1 = _no_name_provided_$factory_279();
    var tmp0_apply_0_3 = new StyledDOMBuilder(tmp1_styledTag_0_1);
    var tmp0__anonymous__1_5 = tmp0_apply_0_3._get_css__0();
    _set_display_(tmp0__anonymous__1_5, Display_inlineBlock_getInstance());
    _set_width_(tmp0__anonymous__1_5, new LinearDimension('' + (size_0 + (size_0 / 5 | 0) | 0) + 'em'));
    _set_height_(tmp0__anonymous__1_5, new LinearDimension('' + (size_0 + (size_0 / 5 | 0) | 0) + 'em'));
    tmp0__anonymous__1_5.after_0(_no_name_provided_$factory_280(size_0));
    Unit_getInstance();
    $this$functionalComponent.child_11(tmp0_apply_0_3.create_1());
    Unit_getInstance();
  };
  _no_name_provided__326.prototype.invoke_537 = function (p1, p2) {
    var tmp = p1 instanceof RBuilder ? p1 : THROW_CCE();
    var tmp_0;
    if (false) {
      tmp_0 = p2;
    } else {
      {
        tmp_0 = THROW_CCE();
      }
    }
    this.invoke_536(tmp, tmp_0);
    return Unit_getInstance();
  };
  _no_name_provided__326.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__327() {
  }
  _no_name_provided__327.prototype.invoke_538 = function ($this$child) {
    return Unit_getInstance();
  };
  _no_name_provided__327.prototype.invoke_542 = function (p1) {
    this.invoke_538(p1 instanceof RElementBuilder ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__327.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided_$factory_277() {
    var i = new _no_name_provided__326();
    return function (p1, p2) {
      i.invoke_536(p1, p2);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_278() {
    var i = new _no_name_provided__327();
    return function (p1) {
      i.invoke_538(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_279() {
    var i = new _no_name_provided__324();
    return function (p1) {
      return i.invoke_532(p1);
    };
  }
  function _no_name_provided_$factory_280($size) {
    var i = new _no_name_provided__325($size);
    return function (p1) {
      i.invoke_534(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_281() {
    var i = new _no_name_provided__323();
    return function (p1) {
      i.invoke_530(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_282() {
    var i = new _no_name_provided__321();
    return function (p1) {
      i.invoke_534(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_283() {
    var i = new _no_name_provided__322();
    return function (p1) {
      i.invoke_534(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_284() {
    var i = new _no_name_provided__319();
    return function (p1) {
      i.invoke_524(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_285() {
    var i = new _no_name_provided__320();
    return function (p1) {
      i.invoke_524(p1);
      return Unit_getInstance();
    };
  }
  function UseLocalStorageStateDelegate(state, setState) {
    this._state_7 = state;
    this._setState_0 = setState;
  }
  UseLocalStorageStateDelegate.prototype.component1_4 = function () {
    return this._state_7;
  };
  UseLocalStorageStateDelegate.prototype.component2_4 = function () {
    return this._setState_0;
  };
  UseLocalStorageStateDelegate.prototype.toString = function () {
    return '' + 'UseLocalStorageStateDelegate(state=' + this._state_7 + ', setState=' + this._setState_0 + ')';
  };
  UseLocalStorageStateDelegate.prototype.hashCode = function () {
    var result = getStringHashCode(this._state_7);
    result = imul(result, 31) + hashCode(this._setState_0) | 0;
    return result;
  };
  UseLocalStorageStateDelegate.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof UseLocalStorageStateDelegate))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof UseLocalStorageStateDelegate ? other : THROW_CCE();
    if (!(this._state_7 === tmp0_other_with_cast._state_7))
      return false;
    if (!equals_1(this._setState_0, tmp0_other_with_cast._setState_0))
      return false;
    return true;
  };
  UseLocalStorageStateDelegate.$metadata$ = {
    simpleName: 'UseLocalStorageStateDelegate',
    kind: 'class',
    interfaces: []
  };
  function useLocalStorage(key, initialValue) {
    var tmp0_useState_0 = _no_name_provided_$factory_286(key, initialValue);
    var tmp0_container_1 = useState(tmp0_useState_0);
    var state_2 = tmp0_container_1[0];
    var setState_3 = tmp0_container_1[1];
    var tmp = (state_2 == null ? true : isObject(state_2)) ? state_2 : THROW_CCE();
    var tmp0_container = new RStateDelegate(tmp, (!(setState_3 == null) ? typeof setState_3 === 'function' : false) ? setState_3 : THROW_CCE());
    var storedValue = tmp0_container.component1_4();
    var setStoredValue = tmp0_container.component2_4();
    var setValue = _no_name_provided_$factory_287(setStoredValue, key);
    return new UseLocalStorageStateDelegate(storedValue, setValue);
  }
  function _no_name_provided__328($key, $initialValue) {
    this._$key_2 = $key;
    this._$initialValue = $initialValue;
  }
  _no_name_provided__328.prototype.invoke_540 = function () {
    var tmp;
    try {
      var tmp0_get_0 = window.localStorage;
      var item = tmp0_get_0[this._$key_2];
      var tmp0_elvis_lhs = item;
      tmp = tmp0_elvis_lhs == null ? this._$initialValue : tmp0_elvis_lhs;
    } catch ($p) {
      var tmp_0;
      if ($p instanceof Error) {
        (function () {
          var $externalVarargReceiverTmp = console;
          return $externalVarargReceiverTmp.log.apply($externalVarargReceiverTmp, [].concat([$p]));
        }.call(this));
        tmp_0 = this._$initialValue;
      } else {
        {
          throw $p;
        }
      }
      tmp = tmp_0;
    }
    return tmp;
  };
  _no_name_provided__328.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__329($setStoredValue, $key) {
    this._$setStoredValue = $setStoredValue;
    this._$key_3 = $key;
  }
  _no_name_provided__329.prototype.invoke_541 = function (value) {
    try {
      this._$setStoredValue(value);
      var tmp0_set_0 = window.localStorage;
      tmp0_set_0[this._$key_3] = value;
    } catch ($p) {
      if ($p instanceof Error) {
        (function () {
          var $externalVarargReceiverTmp = console;
          return $externalVarargReceiverTmp.log.apply($externalVarargReceiverTmp, [].concat([$p]));
        }.call(this));
      } else {
        {
          throw $p;
        }
      }
    }
  };
  _no_name_provided__329.prototype.invoke_542 = function (p1) {
    this.invoke_541((!(p1 == null) ? typeof p1 === 'string' : false) ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__329.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided_$factory_286($key, $initialValue) {
    var i = new _no_name_provided__328($key, $initialValue);
    return function () {
      return i.invoke_540();
    };
  }
  function _no_name_provided_$factory_287($setStoredValue, $key) {
    var i = new _no_name_provided__329($setStoredValue, $key);
    return function (p1) {
      i.invoke_541(p1);
      return Unit_getInstance();
    };
  }
  AbstractMap.prototype._get_entries__10 = Map_0.prototype._get_entries__10;
  CombinedContext.prototype.plus_28 = CoroutineContext.prototype.plus_28;
  AbstractCoroutineContextElement.prototype.get_70 = Element_0.prototype.get_70;
  AbstractCoroutineContextElement.prototype.fold_26 = Element_0.prototype.fold_26;
  AbstractCoroutineContextElement.prototype.minusKey_27 = Element_0.prototype.minusKey_27;
  AbstractCoroutineContextElement.prototype.plus_28 = CoroutineContext.prototype.plus_28;
  CharIterator.prototype.hasNext_31 = Iterator.prototype.hasNext_31;
  IntIterator.prototype.hasNext_31 = Iterator.prototype.hasNext_31;
  AbstractMutableList.prototype.get_80 = List.prototype.get_80;
  AbstractMutableMap.prototype._get_entries__10 = MutableMap.prototype._get_entries__10;
  InternalHashCodeMap.prototype.createJsMap_0 = InternalMap.prototype.createJsMap_0;
  KClassImpl.prototype._get_simpleName__4 = KClass.prototype._get_simpleName__4;
  KClassImpl.prototype.isInstance_4 = KClass.prototype.isInstance_4;
  SerialDescriptorImpl.prototype._get_isNullable__16 = SerialDescriptor.prototype._get_isNullable__16;
  SerialDescriptorImpl.prototype._get_isInline__16 = SerialDescriptor.prototype._get_isInline__16;
  AbstractDecoder.prototype.decodeSerializableElement$default_8 = CompositeDecoder.prototype.decodeSerializableElement$default_8;
  AbstractDecoder.prototype._get_serializersModule__14 = Decoder.prototype._get_serializersModule__14;
  AbstractDecoder.prototype.decodeSerializableValue_16 = Decoder.prototype.decodeSerializableValue_16;
  AbstractDecoder.prototype.decodeSequentially_8 = CompositeDecoder.prototype.decodeSequentially_8;
  AbstractDecoder.prototype.decodeElementIndex_8 = CompositeDecoder.prototype.decodeElementIndex_8;
  AbstractDecoder.prototype.decodeCollectionSize_8 = CompositeDecoder.prototype.decodeCollectionSize_8;
  AbstractEncoder.prototype._get_serializersModule__14 = Encoder.prototype._get_serializersModule__14;
  AbstractEncoder.prototype.encodeNotNullMark_1 = Encoder.prototype.encodeNotNullMark_1;
  AbstractEncoder.prototype.beginCollection_1 = Encoder.prototype.beginCollection_1;
  AbstractEncoder.prototype.encodeSerializableValue_1 = Encoder.prototype.encodeSerializableValue_1;
  ListLikeDescriptor.prototype._get_serialName__16 = SerialDescriptor.prototype._get_serialName__16;
  ListLikeDescriptor.prototype._get_isNullable__16 = SerialDescriptor.prototype._get_isNullable__16;
  ListLikeDescriptor.prototype._get_isInline__16 = SerialDescriptor.prototype._get_isInline__16;
  PrimitiveArrayDescriptor.prototype._get_isNullable__16 = SerialDescriptor.prototype._get_isNullable__16;
  PrimitiveArrayDescriptor.prototype._get_isInline__16 = SerialDescriptor.prototype._get_isInline__16;
  ArrayListClassDesc.prototype._get_isNullable__16 = SerialDescriptor.prototype._get_isNullable__16;
  ArrayListClassDesc.prototype._get_isInline__16 = SerialDescriptor.prototype._get_isInline__16;
  LinkedHashSetClassDesc.prototype._get_isNullable__16 = SerialDescriptor.prototype._get_isNullable__16;
  LinkedHashSetClassDesc.prototype._get_isInline__16 = SerialDescriptor.prototype._get_isInline__16;
  MapLikeDescriptor.prototype._get_isNullable__16 = SerialDescriptor.prototype._get_isNullable__16;
  MapLikeDescriptor.prototype._get_isInline__16 = SerialDescriptor.prototype._get_isInline__16;
  LinkedHashMapClassDesc.prototype._get_isNullable__16 = SerialDescriptor.prototype._get_isNullable__16;
  LinkedHashMapClassDesc.prototype._get_isInline__16 = SerialDescriptor.prototype._get_isInline__16;
  HashSetClassDesc.prototype._get_isNullable__16 = SerialDescriptor.prototype._get_isNullable__16;
  HashSetClassDesc.prototype._get_isInline__16 = SerialDescriptor.prototype._get_isInline__16;
  HashMapClassDesc.prototype._get_isNullable__16 = SerialDescriptor.prototype._get_isNullable__16;
  HashMapClassDesc.prototype._get_isInline__16 = SerialDescriptor.prototype._get_isInline__16;
  ArrayClassDesc.prototype._get_isNullable__16 = SerialDescriptor.prototype._get_isNullable__16;
  ArrayClassDesc.prototype._get_isInline__16 = SerialDescriptor.prototype._get_isInline__16;
  AbstractCollectionSerializer.prototype._get_descriptor__48 = KSerializer.prototype._get_descriptor__48;
  PluginGeneratedSerialDescriptor.prototype._get_isNullable__16 = SerialDescriptor.prototype._get_isNullable__16;
  PluginGeneratedSerialDescriptor.prototype._get_isInline__16 = SerialDescriptor.prototype._get_isInline__16;
  InlineClassDescriptor.prototype._get_isNullable__16 = SerialDescriptor.prototype._get_isNullable__16;
  _no_name_provided__60.prototype.typeParametersSerializers_2 = GeneratedSerializer.prototype.typeParametersSerializers_2;
  PrimitiveSerialDescriptor_0.prototype._get_isNullable__16 = SerialDescriptor.prototype._get_isNullable__16;
  PrimitiveSerialDescriptor_0.prototype._get_isInline__16 = SerialDescriptor.prototype._get_isInline__16;
  TaggedDecoder.prototype.decodeSerializableElement$default_8 = CompositeDecoder.prototype.decodeSerializableElement$default_8;
  TaggedDecoder.prototype.decodeSerializableValue_16 = Decoder.prototype.decodeSerializableValue_16;
  TaggedDecoder.prototype.decodeSequentially_8 = CompositeDecoder.prototype.decodeSequentially_8;
  TaggedDecoder.prototype.decodeElementIndex_8 = CompositeDecoder.prototype.decodeElementIndex_8;
  TaggedDecoder.prototype.decodeCollectionSize_8 = CompositeDecoder.prototype.decodeCollectionSize_8;
  NamedValueDecoder.prototype.decodeSerializableValue_16 = Decoder.prototype.decodeSerializableValue_16;
  NamedValueDecoder.prototype.decodeSerializableElement$default_8 = CompositeDecoder.prototype.decodeSerializableElement$default_8;
  NamedValueDecoder.prototype.decodeSequentially_8 = CompositeDecoder.prototype.decodeSequentially_8;
  NamedValueDecoder.prototype.decodeElementIndex_8 = CompositeDecoder.prototype.decodeElementIndex_8;
  NamedValueDecoder.prototype.decodeCollectionSize_8 = CompositeDecoder.prototype.decodeCollectionSize_8;
  KeyValueSerializer.prototype._get_descriptor__48 = KSerializer.prototype._get_descriptor__48;
  _no_name_provided__77.prototype._get_isNullable__16 = SerialDescriptor.prototype._get_isNullable__16;
  _no_name_provided__77.prototype._get_isInline__16 = SerialDescriptor.prototype._get_isInline__16;
  StreamingJsonDecoder.prototype.decodeSequentially_8 = CompositeDecoder.prototype.decodeSequentially_8;
  StreamingJsonDecoder.prototype.decodeCollectionSize_8 = CompositeDecoder.prototype.decodeCollectionSize_8;
  StreamingJsonDecoder.prototype.decodeSerializableElement$default_8 = CompositeDecoder.prototype.decodeSerializableElement$default_8;
  JsonDecoderForUnsignedTypes.prototype.decodeSerializableValue_16 = Decoder.prototype.decodeSerializableValue_16;
  JsonDecoderForUnsignedTypes.prototype.decodeSerializableElement$default_8 = CompositeDecoder.prototype.decodeSerializableElement$default_8;
  JsonDecoderForUnsignedTypes.prototype.decodeSequentially_8 = CompositeDecoder.prototype.decodeSequentially_8;
  JsonDecoderForUnsignedTypes.prototype.decodeCollectionSize_8 = CompositeDecoder.prototype.decodeCollectionSize_8;
  StreamingJsonEncoder.prototype.encodeNotNullMark_1 = Encoder.prototype.encodeNotNullMark_1;
  StreamingJsonEncoder.prototype.beginCollection_1 = Encoder.prototype.beginCollection_1;
  AbstractJsonTreeDecoder.prototype.decodeSerializableElement$default_8 = CompositeDecoder.prototype.decodeSerializableElement$default_8;
  AbstractJsonTreeDecoder.prototype.decodeSequentially_8 = CompositeDecoder.prototype.decodeSequentially_8;
  AbstractJsonTreeDecoder.prototype.decodeElementIndex_8 = CompositeDecoder.prototype.decodeElementIndex_8;
  AbstractJsonTreeDecoder.prototype.decodeCollectionSize_8 = CompositeDecoder.prototype.decodeCollectionSize_8;
  JsonTreeDecoder.prototype.decodeSerializableElement$default_8 = CompositeDecoder.prototype.decodeSerializableElement$default_8;
  JsonTreeDecoder.prototype.decodeSequentially_8 = CompositeDecoder.prototype.decodeSequentially_8;
  JsonTreeDecoder.prototype.decodeCollectionSize_8 = CompositeDecoder.prototype.decodeCollectionSize_8;
  JsonTreeListDecoder.prototype.decodeSerializableElement$default_8 = CompositeDecoder.prototype.decodeSerializableElement$default_8;
  JsonTreeListDecoder.prototype.decodeSequentially_8 = CompositeDecoder.prototype.decodeSequentially_8;
  JsonTreeListDecoder.prototype.decodeCollectionSize_8 = CompositeDecoder.prototype.decodeCollectionSize_8;
  JsonTreeMapDecoder.prototype.decodeSerializableElement$default_8 = CompositeDecoder.prototype.decodeSerializableElement$default_8;
  JsonTreeMapDecoder.prototype.decodeSequentially_8 = CompositeDecoder.prototype.decodeSequentially_8;
  JsonTreeMapDecoder.prototype.decodeCollectionSize_8 = CompositeDecoder.prototype.decodeCollectionSize_8;
  $serializer.prototype.typeParametersSerializers_2 = GeneratedSerializer.prototype.typeParametersSerializers_2;
  $serializer_0.prototype.typeParametersSerializers_2 = GeneratedSerializer.prototype.typeParametersSerializers_2;
  JobSupport.prototype.invokeOnCompletion$default_9 = Job.prototype.invokeOnCompletion$default_9;
  JobSupport.prototype.cancel$default_15 = Job.prototype.cancel$default_15;
  JobSupport.prototype.plus_28 = CoroutineContext.prototype.plus_28;
  JobSupport.prototype.get_70 = Element_0.prototype.get_70;
  JobSupport.prototype.fold_26 = Element_0.prototype.fold_26;
  JobSupport.prototype.minusKey_27 = Element_0.prototype.minusKey_27;
  AbstractCoroutine.prototype.invokeOnCompletion$default_9 = Job.prototype.invokeOnCompletion$default_9;
  AbstractCoroutine.prototype.cancel$default_15 = Job.prototype.cancel$default_15;
  AbstractCoroutine.prototype.plus_28 = CoroutineContext.prototype.plus_28;
  AbstractCoroutine.prototype.get_70 = Element_0.prototype.get_70;
  AbstractCoroutine.prototype.fold_26 = Element_0.prototype.fold_26;
  AbstractCoroutine.prototype.minusKey_27 = Element_0.prototype.minusKey_27;
  StandaloneCoroutine.prototype.invokeOnCompletion$default_9 = Job.prototype.invokeOnCompletion$default_9;
  StandaloneCoroutine.prototype.get_70 = Element_0.prototype.get_70;
  StandaloneCoroutine.prototype.fold_26 = Element_0.prototype.fold_26;
  StandaloneCoroutine.prototype.cancel$default_15 = Job.prototype.cancel$default_15;
  StandaloneCoroutine.prototype.minusKey_27 = Element_0.prototype.minusKey_27;
  StandaloneCoroutine.prototype.plus_28 = CoroutineContext.prototype.plus_28;
  LazyStandaloneCoroutine.prototype.invokeOnCompletion$default_9 = Job.prototype.invokeOnCompletion$default_9;
  LazyStandaloneCoroutine.prototype.get_70 = Element_0.prototype.get_70;
  LazyStandaloneCoroutine.prototype.fold_26 = Element_0.prototype.fold_26;
  LazyStandaloneCoroutine.prototype.cancel$default_15 = Job.prototype.cancel$default_15;
  LazyStandaloneCoroutine.prototype.minusKey_27 = Element_0.prototype.minusKey_27;
  LazyStandaloneCoroutine.prototype.plus_28 = CoroutineContext.prototype.plus_28;
  DeferredCoroutine.prototype.invokeOnCompletion$default_9 = Job.prototype.invokeOnCompletion$default_9;
  DeferredCoroutine.prototype.get_70 = Element_0.prototype.get_70;
  DeferredCoroutine.prototype.fold_26 = Element_0.prototype.fold_26;
  DeferredCoroutine.prototype.cancel$default_15 = Job.prototype.cancel$default_15;
  DeferredCoroutine.prototype.minusKey_27 = Element_0.prototype.minusKey_27;
  DeferredCoroutine.prototype.plus_28 = CoroutineContext.prototype.plus_28;
  LazyDeferredCoroutine.prototype.invokeOnCompletion$default_9 = Job.prototype.invokeOnCompletion$default_9;
  LazyDeferredCoroutine.prototype.get_70 = Element_0.prototype.get_70;
  LazyDeferredCoroutine.prototype.fold_26 = Element_0.prototype.fold_26;
  LazyDeferredCoroutine.prototype.cancel$default_15 = Job.prototype.cancel$default_15;
  LazyDeferredCoroutine.prototype.minusKey_27 = Element_0.prototype.minusKey_27;
  LazyDeferredCoroutine.prototype.plus_28 = CoroutineContext.prototype.plus_28;
  SchedulerTask.prototype.run_4 = Runnable.prototype.run_4;
  CancellableContinuationImpl.prototype.tryResume$default_1 = CancellableContinuation.prototype.tryResume$default_1;
  CompletableDeferredImpl.prototype.invokeOnCompletion$default_9 = Job.prototype.invokeOnCompletion$default_9;
  CompletableDeferredImpl.prototype.get_70 = Element_0.prototype.get_70;
  CompletableDeferredImpl.prototype.fold_26 = Element_0.prototype.fold_26;
  CompletableDeferredImpl.prototype.cancel$default_15 = Job.prototype.cancel$default_15;
  CompletableDeferredImpl.prototype.minusKey_27 = Element_0.prototype.minusKey_27;
  CompletableDeferredImpl.prototype.plus_28 = CoroutineContext.prototype.plus_28;
  CoroutineDispatcher.prototype.get_70 = ContinuationInterceptor.prototype.get_70;
  CoroutineDispatcher.prototype.fold_26 = Element_0.prototype.fold_26;
  CoroutineDispatcher.prototype.minusKey_27 = ContinuationInterceptor.prototype.minusKey_27;
  CoroutineDispatcher.prototype.plus_28 = CoroutineContext.prototype.plus_28;
  CoroutineName.prototype.get_70 = Element_0.prototype.get_70;
  CoroutineName.prototype.fold_26 = Element_0.prototype.fold_26;
  CoroutineName.prototype.minusKey_27 = Element_0.prototype.minusKey_27;
  CoroutineName.prototype.plus_28 = CoroutineContext.prototype.plus_28;
  EventLoop.prototype.plus_28 = CoroutineContext.prototype.plus_28;
  EventLoop.prototype.get_70 = ContinuationInterceptor.prototype.get_70;
  EventLoop.prototype.fold_26 = Element_0.prototype.fold_26;
  EventLoop.prototype.minusKey_27 = ContinuationInterceptor.prototype.minusKey_27;
  AwaitContinuation.prototype.tryResume$default_1 = CancellableContinuation.prototype.tryResume$default_1;
  JobImpl.prototype.invokeOnCompletion$default_9 = Job.prototype.invokeOnCompletion$default_9;
  JobImpl.prototype.cancel$default_15 = Job.prototype.cancel$default_15;
  JobImpl.prototype.plus_28 = CoroutineContext.prototype.plus_28;
  JobImpl.prototype.get_70 = Element_0.prototype.get_70;
  JobImpl.prototype.fold_26 = Element_0.prototype.fold_26;
  JobImpl.prototype.minusKey_27 = Element_0.prototype.minusKey_27;
  MainCoroutineDispatcher.prototype.plus_28 = CoroutineContext.prototype.plus_28;
  MainCoroutineDispatcher.prototype.get_70 = ContinuationInterceptor.prototype.get_70;
  MainCoroutineDispatcher.prototype.fold_26 = Element_0.prototype.fold_26;
  MainCoroutineDispatcher.prototype.minusKey_27 = ContinuationInterceptor.prototype.minusKey_27;
  SupervisorJobImpl.prototype.invokeOnCompletion$default_9 = Job.prototype.invokeOnCompletion$default_9;
  SupervisorJobImpl.prototype.get_70 = Element_0.prototype.get_70;
  SupervisorJobImpl.prototype.fold_26 = Element_0.prototype.fold_26;
  SupervisorJobImpl.prototype.cancel$default_15 = Job.prototype.cancel$default_15;
  SupervisorJobImpl.prototype.minusKey_27 = Element_0.prototype.minusKey_27;
  SupervisorJobImpl.prototype.plus_28 = CoroutineContext.prototype.plus_28;
  Unconfined.prototype.plus_28 = CoroutineContext.prototype.plus_28;
  Unconfined.prototype.get_70 = ContinuationInterceptor.prototype.get_70;
  Unconfined.prototype.fold_26 = Element_0.prototype.fold_26;
  Unconfined.prototype.minusKey_27 = ContinuationInterceptor.prototype.minusKey_27;
  Receive.prototype.tryResumeReceive_2 = ReceiveOrClosed.prototype.tryResumeReceive_2;
  Receive.prototype.completeResumeReceive_2 = ReceiveOrClosed.prototype.completeResumeReceive_2;
  AbstractSendChannel.prototype.close$default_5 = SendChannel.prototype.close$default_5;
  AbstractChannel.prototype.cancel$default_15 = ReceiveChannel.prototype.cancel$default_15;
  AbstractChannel.prototype.close$default_5 = SendChannel.prototype.close$default_5;
  ArrayChannel.prototype.cancel$default_15 = ReceiveChannel.prototype.cancel$default_15;
  ArrayChannel.prototype.close$default_5 = SendChannel.prototype.close$default_5;
  ConflatedChannel.prototype.cancel$default_15 = ReceiveChannel.prototype.cancel$default_15;
  ConflatedChannel.prototype.close$default_5 = SendChannel.prototype.close$default_5;
  LinkedListChannel.prototype.cancel$default_15 = ReceiveChannel.prototype.cancel$default_15;
  LinkedListChannel.prototype.close$default_5 = SendChannel.prototype.close$default_5;
  RendezvousChannel.prototype.cancel$default_15 = ReceiveChannel.prototype.cancel$default_15;
  RendezvousChannel.prototype.close$default_5 = SendChannel.prototype.close$default_5;
  JsMainDispatcher.prototype.get_70 = ContinuationInterceptor.prototype.get_70;
  JsMainDispatcher.prototype.fold_26 = Element_0.prototype.fold_26;
  JsMainDispatcher.prototype.minusKey_27 = ContinuationInterceptor.prototype.minusKey_27;
  JsMainDispatcher.prototype.plus_28 = CoroutineContext.prototype.plus_28;
  UnconfinedEventLoop.prototype.plus_28 = CoroutineContext.prototype.plus_28;
  UnconfinedEventLoop.prototype.get_70 = ContinuationInterceptor.prototype.get_70;
  UnconfinedEventLoop.prototype.fold_26 = Element_0.prototype.fold_26;
  UnconfinedEventLoop.prototype.minusKey_27 = ContinuationInterceptor.prototype.minusKey_27;
  SetTimeoutBasedDispatcher.prototype.plus_28 = CoroutineContext.prototype.plus_28;
  SetTimeoutBasedDispatcher.prototype.get_70 = ContinuationInterceptor.prototype.get_70;
  SetTimeoutBasedDispatcher.prototype.fold_26 = Element_0.prototype.fold_26;
  SetTimeoutBasedDispatcher.prototype.minusKey_27 = ContinuationInterceptor.prototype.minusKey_27;
  NodeDispatcher.prototype.plus_28 = CoroutineContext.prototype.plus_28;
  NodeDispatcher.prototype.get_70 = ContinuationInterceptor.prototype.get_70;
  NodeDispatcher.prototype.fold_26 = Element_0.prototype.fold_26;
  NodeDispatcher.prototype.minusKey_27 = ContinuationInterceptor.prototype.minusKey_27;
  SetTimeoutDispatcher.prototype.plus_28 = CoroutineContext.prototype.plus_28;
  SetTimeoutDispatcher.prototype.get_70 = ContinuationInterceptor.prototype.get_70;
  SetTimeoutDispatcher.prototype.fold_26 = Element_0.prototype.fold_26;
  SetTimeoutDispatcher.prototype.minusKey_27 = ContinuationInterceptor.prototype.minusKey_27;
  WindowDispatcher.prototype.plus_28 = CoroutineContext.prototype.plus_28;
  WindowDispatcher.prototype.get_70 = ContinuationInterceptor.prototype.get_70;
  WindowDispatcher.prototype.fold_26 = Element_0.prototype.fold_26;
  WindowDispatcher.prototype.minusKey_27 = ContinuationInterceptor.prototype.minusKey_27;
  CSSBuilder.prototype.buildRules_1 = RuleContainer.prototype.buildRules_1;
  CSSBuilder.prototype.rule_3 = RuleContainer.prototype.rule_3;
  CSSBuilder.prototype.rule$default_1 = RuleContainer.prototype.rule$default_1;
  KeyframesBuilder.prototype.buildRules_1 = RuleContainer.prototype.buildRules_1;
  KeyframesBuilder.prototype.rule_2 = RuleContainer.prototype.rule_2;
  KeyframesBuilder.prototype.rule_3 = RuleContainer.prototype.rule_3;
  KeyframesBuilder.prototype.rule$default_1 = RuleContainer.prototype.rule$default_1;
  ByteChannelSequentialBase.prototype.attachJob_1 = ByteChannel.prototype.attachJob_1;
  ChannelJob.prototype.invokeOnCompletion$default_9 = Job.prototype.invokeOnCompletion$default_9;
  ChannelJob.prototype.cancel$default_15 = Job.prototype.cancel$default_15;
  DefaultPool.prototype.close_39 = ObjectPool.prototype.close_39;
  DefaultBufferPool.prototype.close_39 = ObjectPool.prototype.close_39;
  NoPoolImpl.prototype.borrow_12 = ObjectPool.prototype.borrow_12;
  NoPoolImpl.prototype.close_39 = ObjectPool.prototype.close_39;
  EmptyBufferPoolImpl.prototype.close_39 = ObjectPool.prototype.close_39;
  _no_name_provided__118.prototype.close_39 = ObjectPool.prototype.close_39;
  _no_name_provided__119.prototype.close_39 = ObjectPool.prototype.close_39;
  _no_name_provided__120.prototype.close_39 = ObjectPool.prototype.close_39;
  _no_name_provided__121.prototype.close_39 = ObjectPool.prototype.close_39;
  _no_name_provided__126.prototype.close_39 = ObjectPool.prototype.close_39;
  _no_name_provided__127.prototype.close_39 = ObjectPool.prototype.close_39;
  _no_name_provided__1_2.prototype.get_70 = Element_0.prototype.get_70;
  _no_name_provided__1_2.prototype.fold_26 = Element_0.prototype.fold_26;
  _no_name_provided__1_2.prototype.minusKey_27 = Element_0.prototype.minusKey_27;
  _no_name_provided__1_2.prototype.plus_28 = CoroutineContext.prototype.plus_28;
  AttributesJs.prototype.get_65 = Attributes.prototype.get_65;
  EmptyHeaders.prototype.get_69 = StringValues.prototype.get_69;
  EmptyHeaders.prototype.contains_56 = StringValues.prototype.contains_56;
  EmptyHeaders.prototype.forEach_7 = StringValues.prototype.forEach_7;
  EmptyParameters.prototype.forEach_7 = StringValues.prototype.forEach_7;
  _no_name_provided__166.prototype.close_39 = ObjectPool.prototype.close_39;
  _no_name_provided__167.prototype.close_39 = ObjectPool.prototype.close_39;
  _no_name_provided__170.prototype.close_39 = ObjectPool.prototype.close_39;
  HttpResponse.prototype._get_headers__15 = HttpMessage.prototype._get_headers__15;
  HttpResponse.prototype._get_coroutineContext__22 = CoroutineScope.prototype._get_coroutineContext__22;
  HttpClientEngineBase.prototype._get_dispatcher__0 = HttpClientEngine.prototype._get_dispatcher__0;
  HttpClientEngineBase.prototype._get_config__1 = HttpClientEngine.prototype._get_config__1;
  HttpClientEngineBase.prototype._get_supportedCapabilities__1 = HttpClientEngine.prototype._get_supportedCapabilities__1;
  HttpClientEngineBase.prototype.execute_16 = HttpClientEngine.prototype.execute_16;
  HttpClientEngineBase.prototype.install_19 = HttpClientEngine.prototype.install_19;
  KtorCallContextElement.prototype.get_70 = Element_0.prototype.get_70;
  KtorCallContextElement.prototype.fold_26 = Element_0.prototype.fold_26;
  KtorCallContextElement.prototype.minusKey_27 = Element_0.prototype.minusKey_27;
  KtorCallContextElement.prototype.plus_28 = CoroutineContext.prototype.plus_28;
  JsClientEngine.prototype.install_19 = HttpClientEngine.prototype.install_19;
  _stableSortingIsSupported = null;
  functionClasses = functionClasses$init$();
  buf = new ArrayBuffer(8);
  bufFloat64 = bufFloat64$init$();
  bufInt32 = bufInt32$init$();
  lowIndex = lowIndex$init$();
  highIndex = 1 - lowIndex | 0;
  ZERO = fromInt(0);
  ONE = fromInt(1);
  NEG_ONE = fromInt(-1);
  MAX_VALUE = new Long(-1, 2147483647);
  MIN_VALUE = new Long(0, -2147483648);
  TWO_PWR_24_ = fromInt(16777216);
  propertyRefClassMetadataCache = propertyRefClassMetadataCache$init$();
  EMPTY_DESCRIPTOR_ARRAY = EMPTY_DESCRIPTOR_ARRAY$init$();
  EMPTY_SERIALIZER_ARRAY = EMPTY_SERIALIZER_ARRAY$init$();
  BUILTIN_SERIALIZERS = mapOf([to(PrimitiveClasses_getInstance()._get_stringClass_(), serializer_2(StringCompanionObject_getInstance())), to(getKClass_0(Char), serializer_3(Companion_getInstance_13())), to(PrimitiveClasses_getInstance()._get_charArrayClass_(), CharArraySerializer()), to(PrimitiveClasses_getInstance()._get_doubleClass_(), serializer_4(DoubleCompanionObject_getInstance())), to(PrimitiveClasses_getInstance()._get_doubleArrayClass_(), DoubleArraySerializer()), to(PrimitiveClasses_getInstance()._get_floatClass_(), serializer_5(FloatCompanionObject_getInstance())), to(PrimitiveClasses_getInstance()._get_floatArrayClass_(), FloatArraySerializer()), to(getKClass_0(Long), serializer_6(Companion_getInstance_15())), to(PrimitiveClasses_getInstance()._get_longArrayClass_(), LongArraySerializer()), to(PrimitiveClasses_getInstance()._get_intClass_(), serializer_7(IntCompanionObject_getInstance())), to(PrimitiveClasses_getInstance()._get_intArrayClass_(), IntArraySerializer()), to(PrimitiveClasses_getInstance()._get_shortClass_(), serializer_8(ShortCompanionObject_getInstance())), to(PrimitiveClasses_getInstance()._get_shortArrayClass_(), ShortArraySerializer()), to(PrimitiveClasses_getInstance()._get_byteClass_(), serializer_9(ByteCompanionObject_getInstance())), to(PrimitiveClasses_getInstance()._get_byteArrayClass_(), ByteArraySerializer()), to(PrimitiveClasses_getInstance()._get_booleanClass_(), serializer_10(BooleanCompanionObject_getInstance())), to(PrimitiveClasses_getInstance()._get_booleanArrayClass_(), BooleanArraySerializer()), to(getKClass_0(Unit), serializer_11(Unit_getInstance()))]);
  NULL = new Object();
  EmptySerializersModule = new SerialModuleImpl(emptyMap(), emptyMap(), emptyMap(), emptyMap());
  unsignedNumberDescriptors = setOf([serializer_12(Companion_getInstance_5())._get_descriptor__48(), serializer_13(Companion_getInstance_6())._get_descriptor__48(), serializer_14(Companion_getInstance_4())._get_descriptor__48(), serializer_15(Companion_getInstance_7())._get_descriptor__48()]);
  ESCAPE_CHARS = ESCAPE_CHARS$init$();
  RESUME_TOKEN = new Symbol('RESUME_TOKEN');
  COMPLETING_ALREADY = new Symbol('COMPLETING_ALREADY');
  COMPLETING_WAITING_CHILDREN = new Symbol('COMPLETING_WAITING_CHILDREN');
  COMPLETING_RETRY = new Symbol('COMPLETING_RETRY');
  TOO_LATE_TO_CANCEL = new Symbol('TOO_LATE_TO_CANCEL');
  SEALED_0 = new Symbol('SEALED');
  EMPTY_NEW = new Empty(false);
  EMPTY_ACTIVE = new Empty(true);
  EMPTY = new Symbol('EMPTY');
  OFFER_SUCCESS = new Symbol('OFFER_SUCCESS');
  OFFER_FAILED = new Symbol('OFFER_FAILED');
  POLL_FAILED = new Symbol('POLL_FAILED');
  ENQUEUE_FAILED = new Symbol('ENQUEUE_FAILED');
  HANDLER_INVOKED = new Symbol('ON_CLOSE_HANDLER_INVOKED');
  UNDEFINED = new Symbol('UNDEFINED');
  REUSABLE_CLAIMED = new Symbol('REUSABLE_CLAIMED');
  counter = 0;
  DEBUG = false;
  emptyMap_0 = emptyMap();
  attributeStringString = new StringAttribute();
  attributeBooleanTicker = new TickerAttribute();
  attributeInputTypeEnumInputTypeValues = new EnumAttribute(inputTypeValues);
  inputTypeValues = inputTypeValues$init$();
  events = listOf(['onCopy', 'onCut', 'onPaste', 'onCompositionEnd', 'onCompositionStart', 'onCompositionUpdate', 'onKeyDown', 'onKeyPress', 'onKeyUp', 'onFocus', 'onBlur', 'onChange', 'onInput', 'onSubmit', 'onClick', 'onContextMenu', 'onDoubleClick', 'onDrag', 'onDragEnd', 'onDragEnter', 'onDragExit', 'onDragLeave', 'onDragOver', 'onDragStart', 'onDrop', 'onMouseDown', 'onMouseEnter', 'onMouseLeave', 'onMouseMove', 'onMouseOut', 'onMouseOver', 'onMouseUp', 'onSelect', 'onTouchCancel', 'onTouchEnd', 'onTouchMove', 'onTouchStart', 'onScroll', 'onWheel', 'onAbort', 'onCanPlay', 'onCanPlayThrough', 'onDurationChange', 'onEmptied', 'onEncrypted', 'onEnded', 'onError', 'onLoadedData', 'onLoadedMetadata', 'onLoadStart', 'onPause', 'onPlay', 'onPlaying', 'onProgress', 'onRateChange', 'onSeeked', 'onSeeking', 'onStalled', 'onSuspend', 'onTimeUpdate', 'onVolumeChange', 'onWaiting', 'onLoad', 'onError', 'onAnimationStart', 'onAnimationEnd', 'onAnimationIteration', 'onTransitionEnd', 'accept', 'acceptCharset', 'accessKey', 'action', 'allowFullScreen', 'allowTransparency', 'alt', 'async', 'autoComplete', 'autoFocus', 'autoPlay', 'capture', 'cellPadding', 'cellSpacing', 'challenge', 'charSet', 'checked', 'cite', 'classID', 'className', 'colSpan', 'cols', 'content', 'contentEditable', 'contextMenu', 'controls', 'coords', 'crossOrigin', 'data', 'dateTime', 'default', 'defer', 'dir', 'disabled', 'download', 'draggable', 'encType', 'form', 'formAction', 'formEncType', 'formMethod', 'formNoValidate', 'formTarget', 'frameBorder', 'headers', 'height', 'hidden', 'high', 'href', 'hrefLang', 'htmlFor', 'httpEquiv', 'icon', 'id', 'inputMode', 'integrity', 'is', 'keyParams', 'keyType', 'kind', 'label', 'lang', 'list', 'loop', 'low', 'manifest', 'marginHeight', 'marginWidth', 'max', 'maxLength', 'media', 'mediaGroup', 'method', 'min', 'minLength', 'multiple', 'muted', 'name', 'noValidate', 'nonce', 'open', 'optimum', 'pattern', 'placeholder', 'poster', 'preload', 'profile', 'radioGroup', 'readOnly', 'rel', 'required', 'reversed', 'role', 'rowSpan', 'rows', 'sandbox', 'scope', 'scoped', 'scrolling', 'seamless', 'selected', 'shape', 'size', 'sizes', 'span', 'spellCheck', 'src', 'srcDoc', 'srcLang', 'srcSet', 'start', 'step', 'style', 'summary', 'tabIndex', 'target', 'title', 'type', 'useMap', 'value', 'width', 'wmode', 'wrap']);
  attrsMap = attrsMap$init$();
  key$delegate = StringAttr_getInstance();
  defaultValue$delegate = StringAttr_getInstance();
  defaultValue$delegate_0 = StringAttr_getInstance();
  value$delegate = StringAttr_getInstance();
  CAPITAL_LETTER = Regex_init_$Create$_0('[A-Z]');
  alignContent$delegate = CSSProperty_init_$Create$(null, 1, null);
  alignItems$delegate = CSSProperty_init_$Create$(null, 1, null);
  alignSelf$delegate = CSSProperty_init_$Create$(null, 1, null);
  animation$delegate = new CSSProperty(_no_name_provided_$factory_75());
  background$delegate = CSSProperty_init_$Create$(null, 1, null);
  backgroundColor$delegate = CSSProperty_init_$Create$(null, 1, null);
  backgroundPosition$delegate = CSSProperty_init_$Create$(null, 1, null);
  backgroundSize$delegate = CSSProperty_init_$Create$(null, 1, null);
  border$delegate = CSSProperty_init_$Create$(null, 1, null);
  borderRadius$delegate = CSSProperty_init_$Create$(null, 1, null);
  borderColor$delegate = CSSProperty_init_$Create$(null, 1, null);
  color$delegate = CSSProperty_init_$Create$(null, 1, null);
  content$delegate = CSSProperty_init_$Create$(null, 1, null);
  display$delegate = CSSProperty_init_$Create$(null, 1, null);
  flexDirection$delegate = CSSProperty_init_$Create$(null, 1, null);
  flexGrow$delegate = CSSProperty_init_$Create$(null, 1, null);
  flexWrap$delegate = CSSProperty_init_$Create$(null, 1, null);
  fontSize$delegate = CSSProperty_init_$Create$(null, 1, null);
  fontWeight$delegate = CSSProperty_init_$Create$(null, 1, null);
  gridColumn$delegate = CSSProperty_init_$Create$(null, 1, null);
  gridRow$delegate = CSSProperty_init_$Create$(null, 1, null);
  height$delegate = CSSProperty_init_$Create$(null, 1, null);
  justifyContent$delegate = CSSProperty_init_$Create$(null, 1, null);
  left$delegate = CSSProperty_init_$Create$(null, 1, null);
  margin$delegate = CSSProperty_init_$Create$(null, 1, null);
  maxWidth$delegate = CSSProperty_init_$Create$(null, 1, null);
  position$delegate = CSSProperty_init_$Create$(null, 1, null);
  textAlign$delegate = CSSProperty_init_$Create$(null, 1, null);
  top$delegate = CSSProperty_init_$Create$(null, 1, null);
  transform$delegate = new CSSProperty(_no_name_provided_$factory_76());
  transition$delegate = new CSSProperty(_no_name_provided_$factory_77());
  width$delegate = CSSProperty_init_$Create$(null, 1, null);
  DefaultChunkedBufferPool = DefaultBufferPool_init_$Create$(0, 0, null, 7, null);
  EmptyByteArray = new Int8Array(0);
  isLittleEndianPlatform = Companion_getInstance_40().nativeOrder() === ByteOrder_LITTLE_ENDIAN_getInstance();
  PACKET_MAX_COPY_SIZE = 200;
  IS_NODE = IS_NODE$init$();
  STREAM_TRUE = STREAM_TRUE$init$();
  FATAL_TRUE = FATAL_TRUE$init$();
  BASE64_INVERSE_ALPHABET = BASE64_INVERSE_ALPHABET$init$();
  digits = toCharArray('0123456789abcdef');
  _crypto = _crypto$init$();
  URL_ALPHABET = URL_ALPHABET$init$();
  URL_ALPHABET_CHARS = plus(plus_0((new Char(97)).rangeTo(new Char(122)), (new Char(65)).rangeTo(new Char(90))), (new Char(48)).rangeTo(new Char(57)));
  HEX_ALPHABET = plus(plus_0((new Char(97)).rangeTo(new Char(102)), (new Char(65)).rangeTo(new Char(70))), (new Char(48)).rangeTo(new Char(57)));
  URL_PROTOCOL_PART = URL_PROTOCOL_PART$init$();
  VALID_PATH_PART = listOf([new Char(58), new Char(64), new Char(33), new Char(36), new Char(38), new Char(39), new Char(40), new Char(41), new Char(42), new Char(43), new Char(44), new Char(59), new Char(61), new Char(45), new Char(46), new Char(95), new Char(126)]);
  OAUTH_SYMBOLS = OAUTH_SYMBOLS$init$();
  LETTERS_AND_NUMBERS = plus_2(plus_2(toSet_0((new Char(97)).rangeTo(new Char(122))), toSet_0((new Char(65)).rangeTo(new Char(90)))), toSet_0((new Char(48)).rangeTo(new Char(57))));
  TOKENS = plus_2(setOf([new Char(33), new Char(35), new Char(37), new Char(38), new Char(39), new Char(42), new Char(43), new Char(45), new Char(46), new Char(94), new Char(95), new Char(96), new Char(124), new Char(126)]), LETTERS_AND_NUMBERS);
  loweredPartNames = setOf(['max-age', 'expires', 'domain', 'path', 'secure', 'httponly', '$x-enc']);
  clientCookieHeaderPattern = clientCookieHeaderPattern$init$();
  cookieCharsShouldBeEscaped = setOf([new Char(59), new Char(44), new Char(34)]);
  HTTP_DATE_FORMATS = listOf(['***, dd MMM YYYY hh:mm:ss zzz', '****, dd-MMM-YYYY hh:mm:ss zzz', '*** MMM d hh:mm:ss YYYY', '***, dd-MMM-YYYY hh:mm:ss zzz', '***, dd-MMM-YYYY hh-mm-ss zzz', '***, dd MMM YYYY hh:mm:ss zzz', '*** dd-MMM-YYYY hh:mm:ss zzz', '*** dd MMM YYYY hh:mm:ss zzz', '*** dd-MMM-YYYY hh-mm-ss zzz', '***,dd-MMM-YYYY hh:mm:ss zzz', '*** MMM d YYYY hh:mm:ss zzz']);
  contentTypesByExtensions$delegate = lazy(_no_name_provided_$factory_118());
  extensionsByContentType$delegate = lazy(_no_name_provided_$factory_119());
  HeaderFieldValueSeparators = setOf([new Char(40), new Char(41), new Char(60), new Char(62), new Char(64), new Char(44), new Char(59), new Char(58), new Char(92), new Char(34), new Char(47), new Char(91), new Char(93), new Char(63), new Char(61), new Char(123), new Char(125), new Char(32), new Char(9), new Char(10), new Char(13)]);
  IPv4address = then(then_0(then(then_0(then(then_0(_get_digits_(), '.'), _get_digits_()), '.'), _get_digits_()), '.'), _get_digits_());
  IPv6address = then_0(then_1('[', atLeastOne(or(_get_hex_(), ':'))), ']');
  IP_PARSER = buildRegexParser(or_0(IPv4address, IPv6address));
  mimes$delegate = lazy(_no_name_provided_$factory_124());
  token68Pattern = token68Pattern$init$();
  authSchemePattern = authSchemePattern$init$();
  parameterPattern = parameterPattern$init$();
  escapeRegex = escapeRegex$init$();
  CachingProperty = new AttributeKey('Caching');
  ChunkSizeBufferPool = ChunkSizeBufferPool$init$();
  CrLf = CrLf$init$();
  LastChunkBytes = LastChunkBytes$init$();
  EMPTY_INT_ARRAY = new Int32Array(0);
  IntArrayPool = IntArrayPool$init$();
  versions = Companion_getInstance_57().build_13(listOf(['HTTP/1.0', 'HTTP/1.1']));
  CharArrayPool = CharArrayPool$init$();
  DefaultHttpMethods = DefaultHttpMethods$init$();
  HexTable = HexTable$init$();
  HexLetterTable = HexLetterTable$init$();
  CALL_COROUTINE = new CoroutineName('call-context');
  ENGINE_CAPABILITIES_KEY = new AttributeKey('EngineCapabilities');
  DEFAULT_CAPABILITIES = setOf_0(Feature_getInstance_4());
  KTOR_DEFAULT_USER_AGENT = 'Ktor client';
  ValidateMark = new AttributeKey('ValidateMark');
  ExpectSuccessAttributeKey = new AttributeKey('ExpectSuccessAttribyteKey');
  FEATURE_INSTALLED_LIST = new AttributeKey('ApplicationFeatureRegistry');
  ALLOWED_FOR_REDIRECT = setOf([Companion_getInstance_49()._Get, Companion_getInstance_49()._Head]);
  REQUEST_EXTENSIONS_KEY = new AttributeKey('Websocket extensions');
  RN_BYTES = RN_BYTES$init$();
  serializersStore = serializersStore$init$();
  initializer = SerializerInitializer_getInstance();
  endpoint = window.location.origin;
  apiContext = createContext();
  app = functionalComponent$default(null, _no_name_provided_$factory_213(), 1, null);
  scope = MainScope();
  locationSelector = functionalComponent$default(null, _no_name_provided_$factory_224(), 1, null);
  login = functionalComponent$default(null, _no_name_provided_$factory_232(), 1, null);
  logout = functionalComponent$default(null, _no_name_provided_$factory_241(), 1, null);
  patientArrivalForm = functionalComponent$default(null, _no_name_provided_$factory_244(), 1, null);
  patientArrivalFormInput = functionalComponent$default(null, _no_name_provided_$factory_260(), 1, null);
  secured = functionalComponent$default(null, _no_name_provided_$factory_274(), 1, null);
  spinner = functionalComponent$default(null, _no_name_provided_$factory_277(), 1, null);
  main();
  return _;
}));
